import * as pe from "react";
import k, { createContext as Qe, forwardRef as Xs, useRef as _e, useMemo as we, useEffect as De, createRef as Ri, useState as ke, useContext as Ue, useId as kt, useReducer as go, useLayoutEffect as g0, useCallback as ft, Fragment as rr, isValidElement as Sc, cloneElement as lc, createElement as Ho, Component as YS, useSyncExternalStore as ZS, useDebugValue as G_, memo as qS } from "react";
import * as Cc from "react-dom";
import JS, { createPortal as H_, flushSync as Ar, findDOMNode as XS } from "react-dom";
import K_ from "isomorphic-dompurify";
function qc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var c1 = { exports: {} }, Sl = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cy;
function QS() {
  if (Cy)
    return Sl;
  Cy = 1;
  var e = k, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, l, c) {
    var u, d = {}, p = null, h = null;
    c !== void 0 && (p = "" + c), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !o.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: p, ref: h, props: d, _owner: a.current };
  }
  return Sl.Fragment = n, Sl.jsx = i, Sl.jsxs = i, Sl;
}
var Cl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xy;
function eC() {
  return xy || (xy = 1, process.env.NODE_ENV !== "production" && function() {
    var e = k, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = Symbol.iterator, f = "@@iterator";
    function g(y) {
      if (y === null || typeof y != "object")
        return null;
      var P = m && y[m] || y[f];
      return typeof P == "function" ? P : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(y) {
      {
        for (var P = arguments.length, R = new Array(P > 1 ? P - 1 : 0), X = 1; X < P; X++)
          R[X - 1] = arguments[X];
        w("error", y, R);
      }
    }
    function w(y, P, R) {
      {
        var X = _.ReactDebugCurrentFrame, ce = X.getStackAddendum();
        ce !== "" && (P += "%s", R = R.concat([ce]));
        var ue = R.map(function(oe) {
          return String(oe);
        });
        ue.unshift("Warning: " + P), Function.prototype.apply.call(console[y], console, ue);
      }
    }
    var x = !1, b = !1, C = !1, E = !1, A = !1, O;
    O = Symbol.for("react.module.reference");
    function M(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === r || y === o || A || y === a || y === c || y === u || E || y === h || x || b || C || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === d || y.$$typeof === i || y.$$typeof === s || y.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === O || y.getModuleId !== void 0));
    }
    function I(y, P, R) {
      var X = y.displayName;
      if (X)
        return X;
      var ce = P.displayName || P.name || "";
      return ce !== "" ? R + "(" + ce + ")" : R;
    }
    function D(y) {
      return y.displayName || "Context";
    }
    function K(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case s:
            var P = y;
            return D(P) + ".Consumer";
          case i:
            var R = y;
            return D(R._context) + ".Provider";
          case l:
            return I(y, y.render, "ForwardRef");
          case d:
            var X = y.displayName || null;
            return X !== null ? X : K(y.type) || "Memo";
          case p: {
            var ce = y, ue = ce._payload, oe = ce._init;
            try {
              return K(oe(ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, V = 0, ee, U, H, W, L, T, B;
    function N() {
    }
    N.__reactDisabledLog = !0;
    function Y() {
      {
        if (V === 0) {
          ee = console.log, U = console.info, H = console.warn, W = console.error, L = console.group, T = console.groupCollapsed, B = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: N,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        V++;
      }
    }
    function Q() {
      {
        if (V--, V === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, y, {
              value: ee
            }),
            info: G({}, y, {
              value: U
            }),
            warn: G({}, y, {
              value: H
            }),
            error: G({}, y, {
              value: W
            }),
            group: G({}, y, {
              value: L
            }),
            groupCollapsed: G({}, y, {
              value: T
            }),
            groupEnd: G({}, y, {
              value: B
            })
          });
        }
        V < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var F = _.ReactCurrentDispatcher, re;
    function q(y, P, R) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch (ce) {
            var X = ce.stack.trim().match(/\n( *(at )?)/);
            re = X && X[1] || "";
          }
        return `
` + re + y;
      }
    }
    var he = !1, me;
    {
      var Le = typeof WeakMap == "function" ? WeakMap : Map;
      me = new Le();
    }
    function $(y, P) {
      if (!y || he)
        return "";
      {
        var R = me.get(y);
        if (R !== void 0)
          return R;
      }
      var X;
      he = !0;
      var ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ue;
      ue = F.current, F.current = null, Y();
      try {
        if (P) {
          var oe = function() {
            throw Error();
          };
          if (Object.defineProperty(oe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(oe, []);
            } catch (Be) {
              X = Be;
            }
            Reflect.construct(y, [], oe);
          } else {
            try {
              oe.call();
            } catch (Be) {
              X = Be;
            }
            y.call(oe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Be) {
            X = Be;
          }
          y();
        }
      } catch (Be) {
        if (Be && X && typeof Be.stack == "string") {
          for (var ne = Be.stack.split(`
`), Re = X.stack.split(`
`), Se = ne.length - 1, Ce = Re.length - 1; Se >= 1 && Ce >= 0 && ne[Se] !== Re[Ce]; )
            Ce--;
          for (; Se >= 1 && Ce >= 0; Se--, Ce--)
            if (ne[Se] !== Re[Ce]) {
              if (Se !== 1 || Ce !== 1)
                do
                  if (Se--, Ce--, Ce < 0 || ne[Se] !== Re[Ce]) {
                    var He = `
` + ne[Se].replace(" at new ", " at ");
                    return y.displayName && He.includes("<anonymous>") && (He = He.replace("<anonymous>", y.displayName)), typeof y == "function" && me.set(y, He), He;
                  }
                while (Se >= 1 && Ce >= 0);
              break;
            }
        }
      } finally {
        he = !1, F.current = ue, Q(), Error.prepareStackTrace = ce;
      }
      var Yt = y ? y.displayName || y.name : "", Nt = Yt ? q(Yt) : "";
      return typeof y == "function" && me.set(y, Nt), Nt;
    }
    function Te(y, P, R) {
      return $(y, !1);
    }
    function J(y) {
      var P = y.prototype;
      return !!(P && P.isReactComponent);
    }
    function te(y, P, R) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return $(y, J(y));
      if (typeof y == "string")
        return q(y);
      switch (y) {
        case c:
          return q("Suspense");
        case u:
          return q("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case l:
            return Te(y.render);
          case d:
            return te(y.type, P, R);
          case p: {
            var X = y, ce = X._payload, ue = X._init;
            try {
              return te(ue(ce), P, R);
            } catch {
            }
          }
        }
      return "";
    }
    var ve = Object.prototype.hasOwnProperty, Pe = {}, $e = _.ReactDebugCurrentFrame;
    function _t(y) {
      if (y) {
        var P = y._owner, R = te(y.type, y._source, P ? P.type : null);
        $e.setExtraStackFrame(R);
      } else
        $e.setExtraStackFrame(null);
    }
    function st(y, P, R, X, ce) {
      {
        var ue = Function.call.bind(ve);
        for (var oe in y)
          if (ue(y, oe)) {
            var ne = void 0;
            try {
              if (typeof y[oe] != "function") {
                var Re = Error((X || "React class") + ": " + R + " type `" + oe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[oe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Re.name = "Invariant Violation", Re;
              }
              ne = y[oe](P, oe, X, R, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Se) {
              ne = Se;
            }
            ne && !(ne instanceof Error) && (_t(ce), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", R, oe, typeof ne), _t(null)), ne instanceof Error && !(ne.message in Pe) && (Pe[ne.message] = !0, _t(ce), v("Failed %s type: %s", R, ne.message), _t(null));
          }
      }
    }
    var Mr = Array.isArray;
    function Vt(y) {
      return Mr(y);
    }
    function Xt(y) {
      {
        var P = typeof Symbol == "function" && Symbol.toStringTag, R = P && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return R;
      }
    }
    function je(y) {
      try {
        return lt(y), !1;
      } catch {
        return !0;
      }
    }
    function lt(y) {
      return "" + y;
    }
    function fr(y) {
      if (je(y))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Xt(y)), lt(y);
    }
    var Ot = _.ReactCurrentOwner, gr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, ge, Oe;
    Oe = {};
    function ct(y) {
      if (ve.call(y, "ref")) {
        var P = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function yr(y) {
      if (ve.call(y, "key")) {
        var P = Object.getOwnPropertyDescriptor(y, "key").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function Vr(y, P) {
      if (typeof y.ref == "string" && Ot.current && P && Ot.current.stateNode !== P) {
        var R = K(Ot.current.type);
        Oe[R] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', K(Ot.current.type), y.ref), Oe[R] = !0);
      }
    }
    function Xn(y, P) {
      {
        var R = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        R.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: R,
          configurable: !0
        });
      }
    }
    function ti(y, P) {
      {
        var R = function() {
          ge || (ge = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        R.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: R,
          configurable: !0
        });
      }
    }
    var ri = function(y, P, R, X, ce, ue, oe) {
      var ne = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: y,
        key: P,
        ref: R,
        props: oe,
        // Record the component responsible for creating this element.
        _owner: ue
      };
      return ne._store = {}, Object.defineProperty(ne._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ne, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: X
      }), Object.defineProperty(ne, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.freeze && (Object.freeze(ne.props), Object.freeze(ne)), ne;
    };
    function ni(y, P, R, X, ce) {
      {
        var ue, oe = {}, ne = null, Re = null;
        R !== void 0 && (fr(R), ne = "" + R), yr(P) && (fr(P.key), ne = "" + P.key), ct(P) && (Re = P.ref, Vr(P, ce));
        for (ue in P)
          ve.call(P, ue) && !gr.hasOwnProperty(ue) && (oe[ue] = P[ue]);
        if (y && y.defaultProps) {
          var Se = y.defaultProps;
          for (ue in Se)
            oe[ue] === void 0 && (oe[ue] = Se[ue]);
        }
        if (ne || Re) {
          var Ce = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          ne && Xn(oe, Ce), Re && ti(oe, Ce);
        }
        return ri(y, ne, Re, ce, X, Ot.current, oe);
      }
    }
    var Qr = _.ReactCurrentOwner, Qn = _.ReactDebugCurrentFrame;
    function Wt(y) {
      if (y) {
        var P = y._owner, R = te(y.type, y._source, P ? P.type : null);
        Qn.setExtraStackFrame(R);
      } else
        Qn.setExtraStackFrame(null);
    }
    var en;
    en = !1;
    function tn(y) {
      return typeof y == "object" && y !== null && y.$$typeof === t;
    }
    function ea() {
      {
        if (Qr.current) {
          var y = K(Qr.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function ai(y) {
      return "";
    }
    var ta = {};
    function oi(y) {
      {
        var P = ea();
        if (!P) {
          var R = typeof y == "string" ? y : y.displayName || y.name;
          R && (P = `

Check the top-level render call using <` + R + ">.");
        }
        return P;
      }
    }
    function ra(y, P) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var R = oi(P);
        if (ta[R])
          return;
        ta[R] = !0;
        var X = "";
        y && y._owner && y._owner !== Qr.current && (X = " It was passed a child from " + K(y._owner.type) + "."), Wt(y), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', R, X), Wt(null);
      }
    }
    function na(y, P) {
      {
        if (typeof y != "object")
          return;
        if (Vt(y))
          for (var R = 0; R < y.length; R++) {
            var X = y[R];
            tn(X) && ra(X, P);
          }
        else if (tn(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var ce = g(y);
          if (typeof ce == "function" && ce !== y.entries)
            for (var ue = ce.call(y), oe; !(oe = ue.next()).done; )
              tn(oe.value) && ra(oe.value, P);
        }
      }
    }
    function ii(y) {
      {
        var P = y.type;
        if (P == null || typeof P == "string")
          return;
        var R;
        if (typeof P == "function")
          R = P.propTypes;
        else if (typeof P == "object" && (P.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        P.$$typeof === d))
          R = P.propTypes;
        else
          return;
        if (R) {
          var X = K(P);
          st(R, y.props, "prop", X, y);
        } else if (P.PropTypes !== void 0 && !en) {
          en = !0;
          var ce = K(P);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ce || "Unknown");
        }
        typeof P.getDefaultProps == "function" && !P.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function si(y) {
      {
        for (var P = Object.keys(y.props), R = 0; R < P.length; R++) {
          var X = P[R];
          if (X !== "children" && X !== "key") {
            Wt(y), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", X), Wt(null);
            break;
          }
        }
        y.ref !== null && (Wt(y), v("Invalid attribute `ref` supplied to `React.Fragment`."), Wt(null));
      }
    }
    var aa = {};
    function oa(y, P, R, X, ce, ue) {
      {
        var oe = M(y);
        if (!oe) {
          var ne = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (ne += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Re = ai();
          Re ? ne += Re : ne += ea();
          var Se;
          y === null ? Se = "null" : Vt(y) ? Se = "array" : y !== void 0 && y.$$typeof === t ? (Se = "<" + (K(y.type) || "Unknown") + " />", ne = " Did you accidentally export a JSX literal instead of a component?") : Se = typeof y, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Se, ne);
        }
        var Ce = ni(y, P, R, ce, ue);
        if (Ce == null)
          return Ce;
        if (oe) {
          var He = P.children;
          if (He !== void 0)
            if (X)
              if (Vt(He)) {
                for (var Yt = 0; Yt < He.length; Yt++)
                  na(He[Yt], y);
                Object.freeze && Object.freeze(He);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              na(He, y);
        }
        if (ve.call(P, "key")) {
          var Nt = K(y), Be = Object.keys(P).filter(function(hi) {
            return hi !== "key";
          }), rn = Be.length > 0 ? "{key: someKey, " + Be.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!aa[Nt + rn]) {
            var pi = Be.length > 0 ? "{" + Be.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, rn, Nt, pi, Nt), aa[Nt + rn] = !0;
          }
        }
        return y === r ? si(Ce) : ii(Ce), Ce;
      }
    }
    function li(y, P, R) {
      return oa(y, P, R, !0);
    }
    function ci(y, P, R) {
      return oa(y, P, R, !1);
    }
    var ui = ci, di = li;
    Cl.Fragment = r, Cl.jsx = ui, Cl.jsxs = di;
  }()), Cl;
}
process.env.NODE_ENV === "production" ? c1.exports = QS() : c1.exports = eC();
var S = c1.exports, Is = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ep(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var u1 = { exports: {} }, xl = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ky;
function tC() {
  if (ky)
    return xl;
  ky = 1;
  var e = k, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, l, c) {
    var u, d = {}, p = null, h = null;
    c !== void 0 && (p = "" + c), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !o.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: p, ref: h, props: d, _owner: a.current };
  }
  return xl.Fragment = n, xl.jsx = i, xl.jsxs = i, xl;
}
var Mu = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ey;
function rC() {
  return Ey || (Ey = 1, process.env.NODE_ENV !== "production" && function() {
    var e = k, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = Symbol.iterator, f = "@@iterator";
    function g(y) {
      if (y === null || typeof y != "object")
        return null;
      var P = m && y[m] || y[f];
      return typeof P == "function" ? P : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(y) {
      {
        for (var P = arguments.length, R = new Array(P > 1 ? P - 1 : 0), X = 1; X < P; X++)
          R[X - 1] = arguments[X];
        w("error", y, R);
      }
    }
    function w(y, P, R) {
      {
        var X = _.ReactDebugCurrentFrame, ce = X.getStackAddendum();
        ce !== "" && (P += "%s", R = R.concat([ce]));
        var ue = R.map(function(oe) {
          return String(oe);
        });
        ue.unshift("Warning: " + P), Function.prototype.apply.call(console[y], console, ue);
      }
    }
    var x = !1, b = !1, C = !1, E = !1, A = !1, O;
    O = Symbol.for("react.module.reference");
    function M(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === r || y === o || A || y === a || y === c || y === u || E || y === h || x || b || C || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === d || y.$$typeof === i || y.$$typeof === s || y.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === O || y.getModuleId !== void 0));
    }
    function I(y, P, R) {
      var X = y.displayName;
      if (X)
        return X;
      var ce = P.displayName || P.name || "";
      return ce !== "" ? R + "(" + ce + ")" : R;
    }
    function D(y) {
      return y.displayName || "Context";
    }
    function K(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case s:
            var P = y;
            return D(P) + ".Consumer";
          case i:
            var R = y;
            return D(R._context) + ".Provider";
          case l:
            return I(y, y.render, "ForwardRef");
          case d:
            var X = y.displayName || null;
            return X !== null ? X : K(y.type) || "Memo";
          case p: {
            var ce = y, ue = ce._payload, oe = ce._init;
            try {
              return K(oe(ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, V = 0, ee, U, H, W, L, T, B;
    function N() {
    }
    N.__reactDisabledLog = !0;
    function Y() {
      {
        if (V === 0) {
          ee = console.log, U = console.info, H = console.warn, W = console.error, L = console.group, T = console.groupCollapsed, B = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: N,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        V++;
      }
    }
    function Q() {
      {
        if (V--, V === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, y, {
              value: ee
            }),
            info: G({}, y, {
              value: U
            }),
            warn: G({}, y, {
              value: H
            }),
            error: G({}, y, {
              value: W
            }),
            group: G({}, y, {
              value: L
            }),
            groupCollapsed: G({}, y, {
              value: T
            }),
            groupEnd: G({}, y, {
              value: B
            })
          });
        }
        V < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var F = _.ReactCurrentDispatcher, re;
    function q(y, P, R) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch (ce) {
            var X = ce.stack.trim().match(/\n( *(at )?)/);
            re = X && X[1] || "";
          }
        return `
` + re + y;
      }
    }
    var he = !1, me;
    {
      var Le = typeof WeakMap == "function" ? WeakMap : Map;
      me = new Le();
    }
    function $(y, P) {
      if (!y || he)
        return "";
      {
        var R = me.get(y);
        if (R !== void 0)
          return R;
      }
      var X;
      he = !0;
      var ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ue;
      ue = F.current, F.current = null, Y();
      try {
        if (P) {
          var oe = function() {
            throw Error();
          };
          if (Object.defineProperty(oe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(oe, []);
            } catch (Be) {
              X = Be;
            }
            Reflect.construct(y, [], oe);
          } else {
            try {
              oe.call();
            } catch (Be) {
              X = Be;
            }
            y.call(oe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Be) {
            X = Be;
          }
          y();
        }
      } catch (Be) {
        if (Be && X && typeof Be.stack == "string") {
          for (var ne = Be.stack.split(`
`), Re = X.stack.split(`
`), Se = ne.length - 1, Ce = Re.length - 1; Se >= 1 && Ce >= 0 && ne[Se] !== Re[Ce]; )
            Ce--;
          for (; Se >= 1 && Ce >= 0; Se--, Ce--)
            if (ne[Se] !== Re[Ce]) {
              if (Se !== 1 || Ce !== 1)
                do
                  if (Se--, Ce--, Ce < 0 || ne[Se] !== Re[Ce]) {
                    var He = `
` + ne[Se].replace(" at new ", " at ");
                    return y.displayName && He.includes("<anonymous>") && (He = He.replace("<anonymous>", y.displayName)), typeof y == "function" && me.set(y, He), He;
                  }
                while (Se >= 1 && Ce >= 0);
              break;
            }
        }
      } finally {
        he = !1, F.current = ue, Q(), Error.prepareStackTrace = ce;
      }
      var Yt = y ? y.displayName || y.name : "", Nt = Yt ? q(Yt) : "";
      return typeof y == "function" && me.set(y, Nt), Nt;
    }
    function Te(y, P, R) {
      return $(y, !1);
    }
    function J(y) {
      var P = y.prototype;
      return !!(P && P.isReactComponent);
    }
    function te(y, P, R) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return $(y, J(y));
      if (typeof y == "string")
        return q(y);
      switch (y) {
        case c:
          return q("Suspense");
        case u:
          return q("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case l:
            return Te(y.render);
          case d:
            return te(y.type, P, R);
          case p: {
            var X = y, ce = X._payload, ue = X._init;
            try {
              return te(ue(ce), P, R);
            } catch {
            }
          }
        }
      return "";
    }
    var ve = Object.prototype.hasOwnProperty, Pe = {}, $e = _.ReactDebugCurrentFrame;
    function _t(y) {
      if (y) {
        var P = y._owner, R = te(y.type, y._source, P ? P.type : null);
        $e.setExtraStackFrame(R);
      } else
        $e.setExtraStackFrame(null);
    }
    function st(y, P, R, X, ce) {
      {
        var ue = Function.call.bind(ve);
        for (var oe in y)
          if (ue(y, oe)) {
            var ne = void 0;
            try {
              if (typeof y[oe] != "function") {
                var Re = Error((X || "React class") + ": " + R + " type `" + oe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[oe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Re.name = "Invariant Violation", Re;
              }
              ne = y[oe](P, oe, X, R, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Se) {
              ne = Se;
            }
            ne && !(ne instanceof Error) && (_t(ce), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", R, oe, typeof ne), _t(null)), ne instanceof Error && !(ne.message in Pe) && (Pe[ne.message] = !0, _t(ce), v("Failed %s type: %s", R, ne.message), _t(null));
          }
      }
    }
    var Mr = Array.isArray;
    function Vt(y) {
      return Mr(y);
    }
    function Xt(y) {
      {
        var P = typeof Symbol == "function" && Symbol.toStringTag, R = P && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return R;
      }
    }
    function je(y) {
      try {
        return lt(y), !1;
      } catch {
        return !0;
      }
    }
    function lt(y) {
      return "" + y;
    }
    function fr(y) {
      if (je(y))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Xt(y)), lt(y);
    }
    var Ot = _.ReactCurrentOwner, gr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, ge, Oe;
    Oe = {};
    function ct(y) {
      if (ve.call(y, "ref")) {
        var P = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function yr(y) {
      if (ve.call(y, "key")) {
        var P = Object.getOwnPropertyDescriptor(y, "key").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function Vr(y, P) {
      if (typeof y.ref == "string" && Ot.current && P && Ot.current.stateNode !== P) {
        var R = K(Ot.current.type);
        Oe[R] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', K(Ot.current.type), y.ref), Oe[R] = !0);
      }
    }
    function Xn(y, P) {
      {
        var R = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        R.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: R,
          configurable: !0
        });
      }
    }
    function ti(y, P) {
      {
        var R = function() {
          ge || (ge = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        R.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: R,
          configurable: !0
        });
      }
    }
    var ri = function(y, P, R, X, ce, ue, oe) {
      var ne = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: y,
        key: P,
        ref: R,
        props: oe,
        // Record the component responsible for creating this element.
        _owner: ue
      };
      return ne._store = {}, Object.defineProperty(ne._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ne, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: X
      }), Object.defineProperty(ne, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.freeze && (Object.freeze(ne.props), Object.freeze(ne)), ne;
    };
    function ni(y, P, R, X, ce) {
      {
        var ue, oe = {}, ne = null, Re = null;
        R !== void 0 && (fr(R), ne = "" + R), yr(P) && (fr(P.key), ne = "" + P.key), ct(P) && (Re = P.ref, Vr(P, ce));
        for (ue in P)
          ve.call(P, ue) && !gr.hasOwnProperty(ue) && (oe[ue] = P[ue]);
        if (y && y.defaultProps) {
          var Se = y.defaultProps;
          for (ue in Se)
            oe[ue] === void 0 && (oe[ue] = Se[ue]);
        }
        if (ne || Re) {
          var Ce = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          ne && Xn(oe, Ce), Re && ti(oe, Ce);
        }
        return ri(y, ne, Re, ce, X, Ot.current, oe);
      }
    }
    var Qr = _.ReactCurrentOwner, Qn = _.ReactDebugCurrentFrame;
    function Wt(y) {
      if (y) {
        var P = y._owner, R = te(y.type, y._source, P ? P.type : null);
        Qn.setExtraStackFrame(R);
      } else
        Qn.setExtraStackFrame(null);
    }
    var en;
    en = !1;
    function tn(y) {
      return typeof y == "object" && y !== null && y.$$typeof === t;
    }
    function ea() {
      {
        if (Qr.current) {
          var y = K(Qr.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function ai(y) {
      return "";
    }
    var ta = {};
    function oi(y) {
      {
        var P = ea();
        if (!P) {
          var R = typeof y == "string" ? y : y.displayName || y.name;
          R && (P = `

Check the top-level render call using <` + R + ">.");
        }
        return P;
      }
    }
    function ra(y, P) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var R = oi(P);
        if (ta[R])
          return;
        ta[R] = !0;
        var X = "";
        y && y._owner && y._owner !== Qr.current && (X = " It was passed a child from " + K(y._owner.type) + "."), Wt(y), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', R, X), Wt(null);
      }
    }
    function na(y, P) {
      {
        if (typeof y != "object")
          return;
        if (Vt(y))
          for (var R = 0; R < y.length; R++) {
            var X = y[R];
            tn(X) && ra(X, P);
          }
        else if (tn(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var ce = g(y);
          if (typeof ce == "function" && ce !== y.entries)
            for (var ue = ce.call(y), oe; !(oe = ue.next()).done; )
              tn(oe.value) && ra(oe.value, P);
        }
      }
    }
    function ii(y) {
      {
        var P = y.type;
        if (P == null || typeof P == "string")
          return;
        var R;
        if (typeof P == "function")
          R = P.propTypes;
        else if (typeof P == "object" && (P.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        P.$$typeof === d))
          R = P.propTypes;
        else
          return;
        if (R) {
          var X = K(P);
          st(R, y.props, "prop", X, y);
        } else if (P.PropTypes !== void 0 && !en) {
          en = !0;
          var ce = K(P);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ce || "Unknown");
        }
        typeof P.getDefaultProps == "function" && !P.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function si(y) {
      {
        for (var P = Object.keys(y.props), R = 0; R < P.length; R++) {
          var X = P[R];
          if (X !== "children" && X !== "key") {
            Wt(y), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", X), Wt(null);
            break;
          }
        }
        y.ref !== null && (Wt(y), v("Invalid attribute `ref` supplied to `React.Fragment`."), Wt(null));
      }
    }
    var aa = {};
    function oa(y, P, R, X, ce, ue) {
      {
        var oe = M(y);
        if (!oe) {
          var ne = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (ne += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Re = ai();
          Re ? ne += Re : ne += ea();
          var Se;
          y === null ? Se = "null" : Vt(y) ? Se = "array" : y !== void 0 && y.$$typeof === t ? (Se = "<" + (K(y.type) || "Unknown") + " />", ne = " Did you accidentally export a JSX literal instead of a component?") : Se = typeof y, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Se, ne);
        }
        var Ce = ni(y, P, R, ce, ue);
        if (Ce == null)
          return Ce;
        if (oe) {
          var He = P.children;
          if (He !== void 0)
            if (X)
              if (Vt(He)) {
                for (var Yt = 0; Yt < He.length; Yt++)
                  na(He[Yt], y);
                Object.freeze && Object.freeze(He);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              na(He, y);
        }
        if (ve.call(P, "key")) {
          var Nt = K(y), Be = Object.keys(P).filter(function(hi) {
            return hi !== "key";
          }), rn = Be.length > 0 ? "{key: someKey, " + Be.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!aa[Nt + rn]) {
            var pi = Be.length > 0 ? "{" + Be.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, rn, Nt, pi, Nt), aa[Nt + rn] = !0;
          }
        }
        return y === r ? si(Ce) : ii(Ce), Ce;
      }
    }
    function li(y, P, R) {
      return oa(y, P, R, !0);
    }
    function ci(y, P, R) {
      return oa(y, P, R, !1);
    }
    var ui = ci, di = li;
    Mu.Fragment = r, Mu.jsx = ui, Mu.jsxs = di;
  }()), Mu;
}
process.env.NODE_ENV === "production" ? u1.exports = tC() : u1.exports = rC();
var Z = u1.exports;
const U_ = typeof document < "u" ? k.useLayoutEffect : () => {
};
var Hh;
const nC = (Hh = k.useInsertionEffect) !== null && Hh !== void 0 ? Hh : U_;
function aC(e) {
  const t = _e(null);
  return nC(() => {
    t.current = e;
  }, [
    e
  ]), ft((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
const qo = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, Pi = (e) => e && "window" in e && e.window === e ? e : qo(e).defaultView || window;
function $_(e, t) {
  return t && e ? e.contains(t) : !1;
}
const d1 = (e = document) => e.activeElement;
function V_(e) {
  return e.target;
}
function Pp(e) {
  var t;
  if (typeof window > "u" || window.navigator == null)
    return !1;
  let n = (t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands;
  return Array.isArray(n) && n.some((r) => e.test(r.brand)) || e.test(window.navigator.userAgent);
}
function y0(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function yo(e) {
  if (process.env.NODE_ENV === "test")
    return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const v0 = yo(function() {
  return y0(/^Mac/i);
}), oC = yo(function() {
  return y0(/^iPhone/i);
}), iC = yo(function() {
  return y0(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  v0() && navigator.maxTouchPoints > 1;
}), sC = yo(function() {
  return oC() || iC();
});
yo(function() {
  return v0() || sC();
});
yo(function() {
  return Pp(/AppleWebKit/i) && !lC();
});
const lC = yo(function() {
  return Pp(/Chrome/i);
}), cC = yo(function() {
  return Pp(/Android/i);
});
yo(function() {
  return Pp(/Firefox/i);
});
function W_() {
  let e = _e(/* @__PURE__ */ new Map()), t = ft((a, o, i, s) => {
    let l = s != null && s.once ? (...c) => {
      e.current.delete(i), i(...c);
    } : i;
    e.current.set(i, {
      type: o,
      eventTarget: a,
      fn: l,
      options: s
    }), a.addEventListener(o, l, s);
  }, []), n = ft((a, o, i, s) => {
    var l;
    let c = ((l = e.current.get(i)) === null || l === void 0 ? void 0 : l.fn) || i;
    a.removeEventListener(o, c, s), e.current.delete(i);
  }, []), r = ft(() => {
    e.current.forEach((a, o) => {
      n(a.eventTarget, a.type, o, a.options);
    });
  }, [
    n
  ]);
  return De(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function uC(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : cC() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function Y_(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function dC(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function Z_(e) {
  let t = _e({
    isFocused: !1,
    observer: null
  });
  U_(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = aC((r) => {
    e == null || e(r);
  });
  return ft((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let a = r.target, o = (i) => {
        if (t.current.isFocused = !1, a.disabled) {
          let s = Y_(i);
          n(s);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      a.addEventListener("focusout", o, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && a.disabled) {
          var i;
          (i = t.current.observer) === null || i === void 0 || i.disconnect();
          let s = a === document.activeElement ? null : document.activeElement;
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: s
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: s
          }));
        }
      }), t.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
let pC = !1, Jc = null, p1 = /* @__PURE__ */ new Set(), pc = /* @__PURE__ */ new Map(), Ui = !1, h1 = !1;
const hC = {
  Tab: !0,
  Escape: !0
};
function b0(e, t) {
  for (let n of p1)
    n(e, t);
}
function mC(e) {
  return !(e.metaKey || !v0() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Md(e) {
  Ui = !0, mC(e) && (Jc = "keyboard", b0("keyboard", e));
}
function Fn(e) {
  Jc = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (Ui = !0, b0("pointer", e));
}
function q_(e) {
  uC(e) && (Ui = !0, Jc = "virtual");
}
function J_(e) {
  e.target === window || e.target === document || pC || !e.isTrusted || (!Ui && !h1 && (Jc = "virtual", b0("virtual", e)), Ui = !1, h1 = !1);
}
function X_() {
  Ui = !1, h1 = !0;
}
function m1(e) {
  if (typeof window > "u" || typeof document > "u" || pc.get(Pi(e)))
    return;
  const t = Pi(e), n = qo(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    Ui = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", Md, !0), n.addEventListener("keyup", Md, !0), n.addEventListener("click", q_, !0), t.addEventListener("focus", J_, !0), t.addEventListener("blur", X_, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", Fn, !0), n.addEventListener("pointermove", Fn, !0), n.addEventListener("pointerup", Fn, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", Fn, !0), n.addEventListener("mousemove", Fn, !0), n.addEventListener("mouseup", Fn, !0)), t.addEventListener("beforeunload", () => {
    Q_(e);
  }, {
    once: !0
  }), pc.set(t, {
    focus: r
  });
}
const Q_ = (e, t) => {
  const n = Pi(e), r = qo(e);
  t && r.removeEventListener("DOMContentLoaded", t), pc.has(n) && (n.HTMLElement.prototype.focus = pc.get(n).focus, r.removeEventListener("keydown", Md, !0), r.removeEventListener("keyup", Md, !0), r.removeEventListener("click", q_, !0), n.removeEventListener("focus", J_, !0), n.removeEventListener("blur", X_, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", Fn, !0), r.removeEventListener("pointermove", Fn, !0), r.removeEventListener("pointerup", Fn, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", Fn, !0), r.removeEventListener("mousemove", Fn, !0), r.removeEventListener("mouseup", Fn, !0)), pc.delete(n));
};
function fC(e) {
  const t = qo(e);
  let n;
  return t.readyState !== "loading" ? m1(e) : (n = () => {
    m1(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => Q_(e, n);
}
typeof document < "u" && fC();
function e6() {
  return Jc !== "pointer";
}
const gC = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function yC(e, t, n) {
  let r = qo(n == null ? void 0 : n.target);
  const a = typeof window < "u" ? Pi(n == null ? void 0 : n.target).HTMLInputElement : HTMLInputElement, o = typeof window < "u" ? Pi(n == null ? void 0 : n.target).HTMLTextAreaElement : HTMLTextAreaElement, i = typeof window < "u" ? Pi(n == null ? void 0 : n.target).HTMLElement : HTMLElement, s = typeof window < "u" ? Pi(n == null ? void 0 : n.target).KeyboardEvent : KeyboardEvent;
  return e = e || r.activeElement instanceof a && !gC.has(r.activeElement.type) || r.activeElement instanceof o || r.activeElement instanceof i && r.activeElement.isContentEditable, !(e && t === "keyboard" && n instanceof s && !hC[n.key]);
}
function vC(e, t, n) {
  m1(), De(() => {
    let r = (a, o) => {
      yC(!!(n != null && n.isTextInput), a, o) && e(e6());
    };
    return p1.add(r), () => {
      p1.delete(r);
    };
  }, t);
}
function bC(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: a } = e;
  const o = ft((l) => {
    if (l.target === l.currentTarget)
      return r && r(l), a && a(!1), !0;
  }, [
    r,
    a
  ]), i = Z_(o), s = ft((l) => {
    const c = qo(l.target), u = c ? d1(c) : d1();
    l.target === l.currentTarget && u === V_(l.nativeEvent) && (n && n(l), a && a(!0), i(l));
  }, [
    a,
    n,
    i
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || a || r) ? s : void 0,
      onBlur: !t && (r || a) ? o : void 0
    }
  };
}
function _C(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: a } = e, o = _e({
    isFocusWithin: !1
  }), { addGlobalListener: i, removeAllGlobalListeners: s } = W_(), l = ft((d) => {
    d.currentTarget.contains(d.target) && o.current.isFocusWithin && !d.currentTarget.contains(d.relatedTarget) && (o.current.isFocusWithin = !1, s(), n && n(d), a && a(!1));
  }, [
    n,
    a,
    o,
    s
  ]), c = Z_(l), u = ft((d) => {
    if (!d.currentTarget.contains(d.target))
      return;
    const p = qo(d.target), h = d1(p);
    if (!o.current.isFocusWithin && h === V_(d.nativeEvent)) {
      r && r(d), a && a(!0), o.current.isFocusWithin = !0, c(d);
      let m = d.currentTarget;
      i(p, "focus", (f) => {
        if (o.current.isFocusWithin && !$_(m, f.target)) {
          let g = new p.defaultView.FocusEvent("blur", {
            relatedTarget: f.target
          });
          dC(g, m);
          let _ = Y_(g);
          l(_);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    a,
    c,
    i,
    l
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: u,
      onBlur: l
    }
  };
}
let Od = !1, Ou = 0;
function f1() {
  Od = !0, setTimeout(() => {
    Od = !1;
  }, 50);
}
function Py(e) {
  e.pointerType === "touch" && f1();
}
function wC() {
  if (!(typeof document > "u"))
    return Ou === 0 && (typeof PointerEvent < "u" ? document.addEventListener("pointerup", Py) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", f1)), Ou++, () => {
      Ou--, !(Ou > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", Py) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", f1));
    };
}
function Jr(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: a } = e, [o, i] = ke(!1), s = _e({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  De(wC, []);
  let { addGlobalListener: l, removeAllGlobalListeners: c } = W_(), { hoverProps: u, triggerHoverEnd: d } = we(() => {
    let p = (f, g) => {
      if (s.pointerType = g, a || g === "touch" || s.isHovered || !f.currentTarget.contains(f.target))
        return;
      s.isHovered = !0;
      let _ = f.currentTarget;
      s.target = _, l(qo(f.target), "pointerover", (v) => {
        s.isHovered && s.target && !$_(s.target, v.target) && h(v, v.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: _,
        pointerType: g
      }), n && n(!0), i(!0);
    }, h = (f, g) => {
      let _ = s.target;
      s.pointerType = "", s.target = null, !(g === "touch" || !s.isHovered || !_) && (s.isHovered = !1, c(), r && r({
        type: "hoverend",
        target: _,
        pointerType: g
      }), n && n(!1), i(!1));
    }, m = {};
    return typeof PointerEvent < "u" ? (m.onPointerEnter = (f) => {
      Od && f.pointerType === "mouse" || p(f, f.pointerType);
    }, m.onPointerLeave = (f) => {
      !a && f.currentTarget.contains(f.target) && h(f, f.pointerType);
    }) : process.env.NODE_ENV === "test" && (m.onTouchStart = () => {
      s.ignoreEmulatedMouseEvents = !0;
    }, m.onMouseEnter = (f) => {
      !s.ignoreEmulatedMouseEvents && !Od && p(f, "mouse"), s.ignoreEmulatedMouseEvents = !1;
    }, m.onMouseLeave = (f) => {
      !a && f.currentTarget.contains(f.target) && h(f, "mouse");
    }), {
      hoverProps: m,
      triggerHoverEnd: h
    };
  }, [
    t,
    n,
    r,
    a,
    s,
    l,
    c
  ]);
  return De(() => {
    a && d({
      currentTarget: s.target
    }, s.pointerType);
  }, [
    a
  ]), {
    hoverProps: u,
    isHovered: o
  };
}
function $r(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, a = _e({
    isFocused: !1,
    isFocusVisible: t || e6()
  }), [o, i] = ke(!1), [s, l] = ke(() => a.current.isFocused && a.current.isFocusVisible), c = ft(() => l(a.current.isFocused && a.current.isFocusVisible), []), u = ft((h) => {
    a.current.isFocused = h, i(h), c();
  }, [
    c
  ]);
  vC((h) => {
    a.current.isFocusVisible = h, c();
  }, [], {
    isTextInput: n
  });
  let { focusProps: d } = bC({
    isDisabled: r,
    onFocusChange: u
  }), { focusWithinProps: p } = _C({
    isDisabled: !r,
    onFocusWithinChange: u
  });
  return {
    isFocused: o,
    isFocusVisible: s,
    focusProps: r ? p : d
  };
}
var SC = Object.defineProperty, CC = (e, t, n) => t in e ? SC(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Kh = (e, t, n) => (CC(e, typeof t != "symbol" ? t + "" : t, n), n);
let xC = class {
  constructor() {
    Kh(this, "current", this.detect()), Kh(this, "handoffState", "pending"), Kh(this, "currentId", 0);
  }
  set(e) {
    this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, Di = new xC();
function Wn(e) {
  return Di.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
function Xc(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function Rn() {
  let e = [], t = { addEventListener(n, r, a, o) {
    return n.addEventListener(r, a, o), t.add(() => n.removeEventListener(r, a, o));
  }, requestAnimationFrame(...n) {
    let r = requestAnimationFrame(...n);
    return t.add(() => cancelAnimationFrame(r));
  }, nextFrame(...n) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...n));
  }, setTimeout(...n) {
    let r = setTimeout(...n);
    return t.add(() => clearTimeout(r));
  }, microTask(...n) {
    let r = { current: !0 };
    return Xc(() => {
      r.current && n[0]();
    }), t.add(() => {
      r.current = !1;
    });
  }, style(n, r, a) {
    let o = n.style.getPropertyValue(r);
    return Object.assign(n.style, { [r]: a }), this.add(() => {
      Object.assign(n.style, { [r]: o });
    });
  }, group(n) {
    let r = Rn();
    return n(r), this.add(() => r.dispose());
  }, add(n) {
    return e.includes(n) || e.push(n), () => {
      let r = e.indexOf(n);
      if (r >= 0)
        for (let a of e.splice(r, 1))
          a();
    };
  }, dispose() {
    for (let n of e.splice(0))
      n();
  } };
  return t;
}
function Yn() {
  let [e] = ke(Rn);
  return De(() => () => e.dispose(), [e]), e;
}
let Je = (e, t) => {
  Di.isServer ? De(e, t) : g0(e, t);
};
function Kr(e) {
  let t = _e(e);
  return Je(() => {
    t.current = e;
  }, [e]), t;
}
let ae = function(e) {
  let t = Kr(e);
  return k.useCallback((...n) => t.current(...n), [t]);
};
function kC(e) {
  let t = e.width / 2, n = e.height / 2;
  return { top: e.clientY - n, right: e.clientX + t, bottom: e.clientY + n, left: e.clientX - t };
}
function EC(e, t) {
  return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function _a({ disabled: e = !1 } = {}) {
  let t = _e(null), [n, r] = ke(!1), a = Yn(), o = ae(() => {
    t.current = null, r(!1), a.dispose();
  }), i = ae((s) => {
    if (a.dispose(), t.current === null) {
      t.current = s.currentTarget, r(!0);
      {
        let l = Wn(s.currentTarget);
        a.addEventListener(l, "pointerup", o, !1), a.addEventListener(l, "pointermove", (c) => {
          if (t.current) {
            let u = kC(c);
            r(EC(u, t.current.getBoundingClientRect()));
          }
        }, !1), a.addEventListener(l, "pointercancel", o, !1);
      }
    }
  });
  return { pressed: n, pressProps: e ? {} : { onPointerDown: i, onPointerUp: o, onClick: o } };
}
let t6 = Qe(void 0);
function wn() {
  return Ue(t6);
}
function r6({ value: e, children: t }) {
  return k.createElement(t6.Provider, { value: e }, t);
}
function g1(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
function ht(e, t, ...n) {
  if (e in t) {
    let a = t[e];
    return typeof a == "function" ? a(...n) : a;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((a) => `"${a}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, ht), r;
}
var Ir = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Ir || {}), jo = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(jo || {});
function ze() {
  let e = TC();
  return ft((t) => PC({ mergeRefs: e, ...t }), [e]);
}
function PC({ ourProps: e, theirProps: t, slot: n, defaultTag: r, features: a, visible: o = !0, name: i, mergeRefs: s }) {
  s = s ?? MC;
  let l = n6(t, e);
  if (o)
    return Au(l, n, r, i, s);
  let c = a ?? 0;
  if (c & 2) {
    let { static: u = !1, ...d } = l;
    if (u)
      return Au(d, n, r, i, s);
  }
  if (c & 1) {
    let { unmount: u = !0, ...d } = l;
    return ht(u ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return Au({ ...d, hidden: !0, style: { display: "none" } }, n, r, i, s);
    } });
  }
  return Au(l, n, r, i, s);
}
function Au(e, t = {}, n, r, a) {
  let { as: o = n, children: i, refName: s = "ref", ...l } = Uh(e, ["unmount", "static"]), c = e.ref !== void 0 ? { [s]: e.ref } : {}, u = typeof i == "function" ? i(t) : i;
  "className" in l && l.className && typeof l.className == "function" && (l.className = l.className(t)), l["aria-labelledby"] && l["aria-labelledby"] === l.id && (l["aria-labelledby"] = void 0);
  let d = {};
  if (t) {
    let p = !1, h = [];
    for (let [m, f] of Object.entries(t))
      typeof f == "boolean" && (p = !0), f === !0 && h.push(m.replace(/([A-Z])/g, (g) => `-${g.toLowerCase()}`));
    if (p) {
      d["data-headlessui-state"] = h.join(" ");
      for (let m of h)
        d[`data-${m}`] = "";
    }
  }
  if (o === rr && (Object.keys(Ro(l)).length > 0 || Object.keys(Ro(d)).length > 0))
    if (!Sc(u) || Array.isArray(u) && u.length > 1) {
      if (Object.keys(Ro(l)).length > 0)
        throw new Error(['Passing props on "Fragment"!', "", `The current component <${r} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(Ro(l)).concat(Object.keys(Ro(d))).map((p) => `  - ${p}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((p) => `  - ${p}`).join(`
`)].join(`
`));
    } else {
      let p = u.props, h = p == null ? void 0 : p.className, m = typeof h == "function" ? (..._) => g1(h(..._), l.className) : g1(h, l.className), f = m ? { className: m } : {}, g = n6(u.props, Ro(Uh(l, ["ref"])));
      for (let _ in d)
        _ in g && delete d[_];
      return lc(u, Object.assign({}, g, d, c, { ref: a(OC(u), c.ref) }, f));
    }
  return Ho(o, Object.assign({}, Uh(l, ["ref"]), o !== rr && c, o !== rr && d), u);
}
function TC() {
  let e = _e([]), t = ft((n) => {
    for (let r of e.current)
      r != null && (typeof r == "function" ? r(n) : r.current = n);
  }, []);
  return (...n) => {
    if (!n.every((r) => r == null))
      return e.current = n, t;
  };
}
function MC(...e) {
  return e.every((t) => t == null) ? void 0 : (t) => {
    for (let n of e)
      n != null && (typeof n == "function" ? n(t) : n.current = t);
  };
}
function n6(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, n = {};
  for (let r of e)
    for (let a in r)
      a.startsWith("on") && typeof r[a] == "function" ? (n[a] != null || (n[a] = []), n[a].push(r[a])) : t[a] = r[a];
  if (t.disabled || t["aria-disabled"])
    for (let r in n)
      /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(r) && (n[r] = [(a) => {
        var o;
        return (o = a == null ? void 0 : a.preventDefault) == null ? void 0 : o.call(a);
      }]);
  for (let r in n)
    Object.assign(t, { [r](a, ...o) {
      let i = n[r];
      for (let s of i) {
        if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented)
          return;
        s(a, ...o);
      }
    } });
  return t;
}
function mr(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, n = {};
  for (let r of e)
    for (let a in r)
      a.startsWith("on") && typeof r[a] == "function" ? (n[a] != null || (n[a] = []), n[a].push(r[a])) : t[a] = r[a];
  for (let r in n)
    Object.assign(t, { [r](...a) {
      let o = n[r];
      for (let i of o)
        i == null || i(...a);
    } });
  return t;
}
function Ie(e) {
  var t;
  return Object.assign(Xs(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function Ro(e) {
  let t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function Uh(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t)
    r in n && delete n[r];
  return n;
}
function OC(e) {
  return k.version.split(".")[0] >= "19" ? e.props.ref : e.ref;
}
let AC = "button";
function NC(e, t) {
  var n;
  let r = wn(), { disabled: a = r || !1, autoFocus: o = !1, ...i } = e, { isFocusVisible: s, focusProps: l } = $r({ autoFocus: o }), { isHovered: c, hoverProps: u } = Jr({ isDisabled: a }), { pressed: d, pressProps: p } = _a({ disabled: a }), h = mr({ ref: t, type: (n = i.type) != null ? n : "button", disabled: a || void 0, autoFocus: o }, l, u, p), m = we(() => ({ disabled: a, hover: c, focus: s, active: d, autofocus: o }), [a, c, s, d, o]);
  return ze()({ ourProps: h, theirProps: i, slot: m, defaultTag: AC, name: "Button" });
}
let LC = Ie(NC);
function Qc(e, t, n) {
  let [r, a] = ke(n), o = e !== void 0, i = _e(o), s = _e(!1), l = _e(!1);
  return o && !i.current && !s.current ? (s.current = !0, i.current = o, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !o && i.current && !l.current && (l.current = !0, i.current = o, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [o ? e : r, ae((c) => (o || a(c), t == null ? void 0 : t(c)))];
}
function eu(e) {
  let [t] = ke(e);
  return t;
}
function a6(e = {}, t = null, n = []) {
  for (let [r, a] of Object.entries(e))
    i6(n, o6(t, r), a);
  return n;
}
function o6(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function i6(e, t, n) {
  if (Array.isArray(n))
    for (let [r, a] of n.entries())
      i6(e, o6(t, r.toString()), a);
  else
    n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : a6(n, t, e);
}
function Tp(e) {
  var t, n;
  let r = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (r) {
    for (let a of r.elements)
      if (a !== e && (a.tagName === "INPUT" && a.type === "submit" || a.tagName === "BUTTON" && a.type === "submit" || a.nodeName === "INPUT" && a.type === "image")) {
        a.click();
        return;
      }
    (n = r.requestSubmit) == null || n.call(r);
  }
}
let RC = "span";
var ga = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(ga || {});
function DC(e, t) {
  var n;
  let { features: r = 1, ...a } = e, o = { ref: t, "aria-hidden": (r & 2) === 2 ? !0 : (n = a["aria-hidden"]) != null ? n : void 0, hidden: (r & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
  return ze()({ ourProps: o, theirProps: a, slot: {}, defaultTag: RC, name: "Hidden" });
}
let ya = Ie(DC), s6 = Qe(null);
function IC(e) {
  let [t, n] = ke(null);
  return k.createElement(s6.Provider, { value: { target: t } }, e.children, k.createElement(ya, { features: ga.Hidden, ref: n }));
}
function jC({ children: e }) {
  let t = Ue(s6);
  if (!t)
    return k.createElement(k.Fragment, null, e);
  let { target: n } = t;
  return n ? H_(k.createElement(k.Fragment, null, e), n) : null;
}
function tu({ data: e, form: t, disabled: n, onReset: r, overrides: a }) {
  let [o, i] = ke(null), s = Yn();
  return De(() => {
    if (r && o)
      return s.addEventListener(o, "reset", r);
  }, [o, t, r]), k.createElement(jC, null, k.createElement(BC, { setForm: i, formId: t }), a6(e).map(([l, c]) => k.createElement(ya, { features: ga.Hidden, ...Ro({ key: l, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: t, disabled: n, name: l, value: c, ...a }) })));
}
function BC({ setForm: e, formId: t }) {
  return De(() => {
    if (t) {
      let n = document.getElementById(t);
      n && e(n);
    }
  }, [e, t]), t ? null : k.createElement(ya, { features: ga.Hidden, as: "input", type: "hidden", hidden: !0, readOnly: !0, ref: (n) => {
    if (!n)
      return;
    let r = n.closest("form");
    r && e(r);
  } });
}
let l6 = Qe(void 0);
function vo() {
  return Ue(l6);
}
function FC({ id: e, children: t }) {
  return k.createElement(l6.Provider, { value: e }, t);
}
function Qa(e) {
  let t = e.parentElement, n = null;
  for (; t && !(t instanceof HTMLFieldSetElement); )
    t instanceof HTMLLegendElement && (n = t), t = t.parentElement;
  let r = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return r && zC(n) ? !1 : r;
}
function zC(e) {
  if (!e)
    return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement)
      return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
let c6 = Symbol();
function _0(e, t = !0) {
  return Object.assign(e, { [c6]: t });
}
function et(...e) {
  let t = _e(e);
  De(() => {
    t.current = e;
  }, [e]);
  let n = ae((r) => {
    for (let a of t.current)
      a != null && (typeof a == "function" ? a(r) : a.current = r);
  });
  return e.every((r) => r == null || (r == null ? void 0 : r[c6])) ? void 0 : n;
}
let Mp = Qe(null);
Mp.displayName = "DescriptionContext";
function u6() {
  let e = Ue(Mp);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, u6), t;
  }
  return e;
}
function Jo() {
  var e, t;
  return (t = (e = Ue(Mp)) == null ? void 0 : e.value) != null ? t : void 0;
}
function Qs() {
  let [e, t] = ke([]);
  return [e.length > 0 ? e.join(" ") : void 0, we(() => function(n) {
    let r = ae((o) => (t((i) => [...i, o]), () => t((i) => {
      let s = i.slice(), l = s.indexOf(o);
      return l !== -1 && s.splice(l, 1), s;
    }))), a = we(() => ({ register: r, slot: n.slot, name: n.name, props: n.props, value: n.value }), [r, n.slot, n.name, n.props, n.value]);
    return k.createElement(Mp.Provider, { value: a }, n.children);
  }, [t])];
}
let GC = "p";
function HC(e, t) {
  let n = kt(), r = wn(), { id: a = `headlessui-description-${n}`, ...o } = e, i = u6(), s = et(t);
  Je(() => i.register(a), [a, i.register]);
  let l = r || !1, c = we(() => ({ ...i.slot, disabled: l }), [i.slot, l]), u = { ref: s, ...i.props, id: a };
  return ze()({ ourProps: u, theirProps: o, slot: c, defaultTag: GC, name: i.name || "Description" });
}
let KC = Ie(HC), w0 = Object.assign(KC, {});
var xe = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(xe || {});
let Op = Qe(null);
Op.displayName = "LabelContext";
function S0() {
  let e = Ue(Op);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, S0), t;
  }
  return e;
}
function wa(e) {
  var t, n, r;
  let a = (n = (t = Ue(Op)) == null ? void 0 : t.value) != null ? n : void 0;
  return ((r = e == null ? void 0 : e.length) != null ? r : 0) > 0 ? [a, ...e].filter(Boolean).join(" ") : a;
}
function bo({ inherit: e = !1 } = {}) {
  let t = wa(), [n, r] = ke([]), a = e ? [t, ...n].filter(Boolean) : n;
  return [a.length > 0 ? a.join(" ") : void 0, we(() => function(o) {
    let i = ae((l) => (r((c) => [...c, l]), () => r((c) => {
      let u = c.slice(), d = u.indexOf(l);
      return d !== -1 && u.splice(d, 1), u;
    }))), s = we(() => ({ register: i, slot: o.slot, name: o.name, props: o.props, value: o.value }), [i, o.slot, o.name, o.props, o.value]);
    return k.createElement(Op.Provider, { value: s }, o.children);
  }, [r])];
}
let UC = "label";
function $C(e, t) {
  var n;
  let r = kt(), a = S0(), o = vo(), i = wn(), { id: s = `headlessui-label-${r}`, htmlFor: l = o ?? ((n = a.props) == null ? void 0 : n.htmlFor), passive: c = !1, ...u } = e, d = et(t);
  Je(() => a.register(s), [s, a.register]);
  let p = ae((g) => {
    let _ = g.currentTarget;
    if (_ instanceof HTMLLabelElement && g.preventDefault(), a.props && "onClick" in a.props && typeof a.props.onClick == "function" && a.props.onClick(g), _ instanceof HTMLLabelElement) {
      let v = document.getElementById(_.htmlFor);
      if (v) {
        let w = v.getAttribute("disabled");
        if (w === "true" || w === "")
          return;
        let x = v.getAttribute("aria-disabled");
        if (x === "true" || x === "")
          return;
        (v instanceof HTMLInputElement && (v.type === "radio" || v.type === "checkbox") || v.role === "radio" || v.role === "checkbox" || v.role === "switch") && v.click(), v.focus({ preventScroll: !0 });
      }
    }
  }), h = i || !1, m = we(() => ({ ...a.slot, disabled: h }), [a.slot, h]), f = { ref: d, ...a.props, id: s, htmlFor: l, onClick: p };
  return c && ("onClick" in f && (delete f.htmlFor, delete f.onClick), "onClick" in u && delete u.onClick), ze()({ ourProps: f, theirProps: u, slot: m, defaultTag: l ? UC : "div", name: a.name || "Label" });
}
let VC = Ie($C), ru = Object.assign(VC, {}), WC = "span";
function YC(e, t) {
  let n = kt(), r = vo(), a = wn(), { id: o = r || `headlessui-checkbox-${n}`, disabled: i = a || !1, autoFocus: s = !1, checked: l, defaultChecked: c, onChange: u, name: d, value: p, form: h, indeterminate: m = !1, ...f } = e, g = eu(c), [_, v] = Qc(l, u, g ?? !1), w = wa(), x = Jo(), b = Yn(), [C, E] = ke(!1), A = ae(() => {
    E(!0), v == null || v(!_), b.nextFrame(() => {
      E(!1);
    });
  }), O = ae((B) => {
    if (Qa(B.currentTarget))
      return B.preventDefault();
    B.preventDefault(), A();
  }), M = ae((B) => {
    B.key === xe.Space ? (B.preventDefault(), A()) : B.key === xe.Enter && Tp(B.currentTarget);
  }), I = ae((B) => B.preventDefault()), { isFocusVisible: D, focusProps: K } = $r({ autoFocus: s }), { isHovered: G, hoverProps: V } = Jr({ isDisabled: i }), { pressed: ee, pressProps: U } = _a({ disabled: i }), H = mr({ ref: t, id: o, role: "checkbox", "aria-checked": m ? "mixed" : _ ? "true" : "false", "aria-labelledby": w, "aria-describedby": x, "aria-disabled": i ? !0 : void 0, indeterminate: m ? "true" : void 0, tabIndex: i ? void 0 : 0, onKeyUp: i ? void 0 : M, onKeyPress: i ? void 0 : I, onClick: i ? void 0 : O }, K, V, U), W = we(() => ({ checked: _, disabled: i, hover: G, focus: D, active: ee, indeterminate: m, changing: C, autofocus: s }), [_, m, i, G, D, ee, C, s]), L = ft(() => {
    if (g !== void 0)
      return v == null ? void 0 : v(g);
  }, [v, g]), T = ze();
  return k.createElement(k.Fragment, null, d != null && k.createElement(tu, { disabled: i, data: { [d]: p || "on" }, overrides: { type: "checkbox", checked: _ }, form: h, onReset: L }), T({ ourProps: H, theirProps: f, slot: W, defaultTag: WC, name: "Checkbox" }));
}
Ie(YC);
let d6 = Qe(() => {
});
function ZC() {
  return Ue(d6);
}
function C0({ value: e, children: t }) {
  return k.createElement(d6.Provider, { value: e }, t);
}
function qC(e, t) {
  let n = ZC();
  return k.createElement(LC, { ref: t, ...mr({ onClick: n }, e) });
}
Ie(qC);
function is(e, t, n) {
  let r = n.initialDeps ?? [], a;
  return () => {
    var o, i, s, l;
    let c;
    n.key && (o = n.debug) != null && o.call(n) && (c = Date.now());
    const u = e();
    if (!(u.length !== r.length || u.some((p, h) => r[h] !== p)))
      return a;
    r = u;
    let d;
    if (n.key && (i = n.debug) != null && i.call(n) && (d = Date.now()), a = t(...u), n.key && (s = n.debug) != null && s.call(n)) {
      const p = Math.round((Date.now() - c) * 100) / 100, h = Math.round((Date.now() - d) * 100) / 100, m = h / 16, f = (g, _) => {
        for (g = String(g); g.length < _; )
          g = " " + g;
        return g;
      };
      console.info(
        `%c⏱ ${f(h, 5)} /${f(p, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * m, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (l = n == null ? void 0 : n.onChange) == null || l.call(n, a), a;
  };
}
function $h(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const JC = (e, t) => Math.abs(e - t) < 1, XC = (e, t, n) => {
  let r;
  return function(...a) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, a), n);
  };
}, QC = (e) => e, ex = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let a = t; a <= n; a++)
    r.push(a);
  return r;
}, tx = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const a = (i) => {
    const { width: s, height: l } = i;
    t({ width: Math.round(s), height: Math.round(l) });
  };
  if (a(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const o = new r.ResizeObserver((i) => {
    const s = i[0];
    if (s != null && s.borderBoxSize) {
      const l = s.borderBoxSize[0];
      if (l) {
        a({ width: l.inlineSize, height: l.blockSize });
        return;
      }
    }
    a(n.getBoundingClientRect());
  });
  return o.observe(n, { box: "border-box" }), () => {
    o.unobserve(n);
  };
}, Ty = {
  passive: !0
}, rx = typeof window > "u" ? !0 : "onscrollend" in window, nx = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let a = 0;
  const o = rx ? () => {
  } : XC(
    r,
    () => {
      t(a, !1);
    },
    e.options.isScrollingResetDelay
  ), i = (c) => () => {
    const { horizontal: u, isRtl: d } = e.options;
    a = u ? n.scrollLeft * (d && -1 || 1) : n.scrollTop, o(), t(a, c);
  }, s = i(!0), l = i(!1);
  return l(), n.addEventListener("scroll", s, Ty), n.addEventListener("scrollend", l, Ty), () => {
    n.removeEventListener("scroll", s), n.removeEventListener("scrollend", l);
  };
}, ax = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, ox = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var a, o;
  const i = e + t;
  (o = (a = r.scrollElement) == null ? void 0 : a.scrollTo) == null || o.call(a, {
    [r.options.horizontal ? "left" : "top"]: i,
    behavior: n
  });
};
let ix = class {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((a) => {
        a.forEach((o) => {
          this._measureElement(o.target, o);
        });
      }));
      return {
        disconnect: () => {
          var a;
          (a = r()) == null || a.disconnect(), n = null;
        },
        observe: (a) => {
          var o;
          return (o = r()) == null ? void 0 : o.observe(a, { box: "border-box" });
        },
        unobserve: (a) => {
          var o;
          return (o = r()) == null ? void 0 : o.unobserve(a);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, a]) => {
        typeof a > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: QC,
        rangeExtractor: ex,
        onChange: () => {
        },
        measureElement: ax,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...n
      };
    }, this.notify = (n) => {
      var r, a;
      (a = (r = this.options).onChange) == null || a.call(r, this, n);
    }, this.maybeNotify = is(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((a) => {
          this.observer.observe(a);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (a) => {
            this.scrollRect = a, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (a, o) => {
            this.scrollAdjustments = 0, this.scrollDirection = o ? this.getScrollOffset() < a ? "forward" : "backward" : null, this.scrollOffset = a, this.isScrolling = o, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
      for (let i = r - 1; i >= 0; i--) {
        const s = n[i];
        if (a.has(s.lane))
          continue;
        const l = o.get(
          s.lane
        );
        if (l == null || s.end > l.end ? o.set(s.lane, s) : s.end < l.end && a.set(s.lane, !0), a.size === this.options.lanes)
          break;
      }
      return o.size === this.options.lanes ? Array.from(o.values()).sort((i, s) => i.end === s.end ? i.index - s.index : i.end - s.end)[0] : void 0;
    }, this.getMeasurementOptions = is(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, a, o, i) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: a,
        getItemKey: o,
        enabled: i
      }),
      {
        key: !1
      }
    ), this.getMeasurements = is(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: a, getItemKey: o, enabled: i }, s) => {
        if (!i)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((u) => {
          this.itemSizeCache.set(u.key, u.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const c = this.measurementsCache.slice(0, l);
        for (let u = l; u < n; u++) {
          const d = o(u), p = this.options.lanes === 1 ? c[u - 1] : this.getFurthestMeasurement(c, u), h = p ? p.end + this.options.gap : r + a, m = s.get(d), f = typeof m == "number" ? m : this.options.estimateSize(u), g = h + f, _ = p ? p.lane : u % this.options.lanes;
          c[u] = {
            index: u,
            start: h,
            size: f,
            end: g,
            key: d,
            lane: _
          };
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = is(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (n, r, a) => this.range = n.length > 0 && r > 0 ? sx({
        measurements: n,
        outerSize: r,
        scrollOffset: a
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = is(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (n, r, a, o) => r === null ? [] : n({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: a,
        count: o
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, a = n.getAttribute(r);
      return a ? parseInt(a, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const a = this.indexFromElement(n), o = this.measurementsCache[a];
      if (!o)
        return;
      const i = o.key, s = this.elementsCache.get(i);
      s !== n && (s && this.observer.unobserve(s), this.observer.observe(n), this.elementsCache.set(i, n)), n.isConnected && this.resizeItem(a, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const a = this.measurementsCache[n];
      if (!a)
        return;
      const o = this.itemSizeCache.get(a.key) ?? a.size, i = r - o;
      i !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(a, i, this) : a.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", i), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += i,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(a.index), this.itemSizeCache = new Map(this.itemSizeCache.set(a.key, r)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((r, a) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(a));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = is(
      () => [this.getIndexes(), this.getMeasurements()],
      (n, r) => {
        const a = [];
        for (let o = 0, i = n.length; o < i; o++) {
          const s = n[o], l = r[s];
          a.push(l);
        }
        return a;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return $h(
          r[p6(
            0,
            r.length - 1,
            (a) => $h(r[a]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r) => {
      const a = this.getSize(), o = this.getScrollOffset();
      r === "auto" && (n <= o ? r = "start" : n >= o + a ? r = "end" : r = "start"), r === "start" ? n = n : r === "end" ? n = n - a : r === "center" && (n = n - a / 2);
      const i = this.options.horizontal ? "scrollWidth" : "scrollHeight", s = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[i] : this.scrollElement[i] : 0) - a;
      return Math.max(Math.min(s, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const a = this.measurementsCache[n];
      if (!a)
        return;
      const o = this.getSize(), i = this.getScrollOffset();
      if (r === "auto")
        if (a.end >= i + o - this.options.scrollPaddingEnd)
          r = "end";
        else if (a.start <= i + this.options.scrollPaddingStart)
          r = "start";
        else
          return [i, r];
      const s = r === "end" ? a.end + this.options.scrollPaddingEnd : a.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(s, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: a } = {}) => {
      this.cancelScrollToIndex(), a === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: a
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: a } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), a === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const o = this.getOffsetForIndex(n, r);
      if (!o)
        return;
      const [i, s] = o;
      this._scrollToOffset(i, { adjustments: void 0, behavior: a }), a !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [l] = $h(
            this.getOffsetForIndex(n, s)
          );
          JC(l, this.getScrollOffset()) || this.scrollToIndex(n, { align: s, behavior: a });
        } else
          this.scrollToIndex(n, { align: s, behavior: a });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let a;
      return r.length === 0 ? a = this.options.paddingStart : a = this.options.lanes === 1 ? ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((o) => o.end)
      ), Math.max(
        a - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: a
    }) => {
      this.options.scrollToFn(n, { behavior: a, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
};
const p6 = (e, t, n, r) => {
  for (; e <= t; ) {
    const a = (e + t) / 2 | 0, o = n(a);
    if (o < r)
      e = a + 1;
    else if (o > r)
      t = a - 1;
    else
      return a;
  }
  return e > 0 ? e - 1 : 0;
};
function sx({
  measurements: e,
  outerSize: t,
  scrollOffset: n
}) {
  const r = e.length - 1, a = p6(0, r, (i) => e[i].start, n);
  let o = a;
  for (; o < r && e[o].end < n + t; )
    o++;
  return { startIndex: a, endIndex: o };
}
const lx = typeof document < "u" ? pe.useLayoutEffect : pe.useEffect;
function cx(e) {
  const t = pe.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (a, o) => {
      var i;
      o ? Ar(t) : t(), (i = e.onChange) == null || i.call(e, a, o);
    }
  }, [r] = pe.useState(
    () => new ix(n)
  );
  return r.setOptions(n), pe.useEffect(() => r._didMount(), []), lx(() => r._willUpdate()), r;
}
function ux(e) {
  return cx({
    observeElementRect: tx,
    observeElementOffset: nx,
    scrollToFn: ox,
    ...e
  });
}
function dx(e, t) {
  return e !== null && t !== null && typeof e == "object" && typeof t == "object" && "id" in e && "id" in t ? e.id === t.id : e === t;
}
function x0(e = dx) {
  return ft((t, n) => {
    if (typeof e == "string") {
      let r = e;
      return (t == null ? void 0 : t[r]) === (n == null ? void 0 : n[r]);
    }
    return e(t, n);
  }, [e]);
}
function px(e) {
  if (e === null)
    return { width: 0, height: 0 };
  let { width: t, height: n } = e.getBoundingClientRect();
  return { width: t, height: n };
}
function xc(e, t = !1) {
  let [n, r] = go(() => ({}), {}), a = we(() => px(e), [e, n]);
  return Je(() => {
    if (!e)
      return;
    let o = new ResizeObserver(r);
    return o.observe(e), () => {
      o.disconnect();
    };
  }, [e]), t ? { width: `${a.width}px`, height: `${a.height}px` } : a;
}
let hx = class extends Map {
  constructor(t) {
    super(), this.factory = t;
  }
  get(t) {
    let n = super.get(t);
    return n === void 0 && (n = this.factory(t), this.set(t, n)), n;
  }
};
function h6(e, t) {
  let n = e(), r = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return n;
  }, subscribe(a) {
    return r.add(a), () => r.delete(a);
  }, dispatch(a, ...o) {
    let i = t[a].call(n, ...o);
    i && (n = i, r.forEach((s) => s()));
  } };
}
function m6(e) {
  return ZS(e.subscribe, e.getSnapshot, e.getSnapshot);
}
let mx = new hx(() => h6(() => [], { ADD(e) {
  return this.includes(e) ? this : [...this, e];
}, REMOVE(e) {
  let t = this.indexOf(e);
  if (t === -1)
    return this;
  let n = this.slice();
  return n.splice(t, 1), n;
} }));
function el(e, t) {
  let n = mx.get(t), r = kt(), a = m6(n);
  if (Je(() => {
    if (e)
      return n.dispatch("ADD", r), () => n.dispatch("REMOVE", r);
  }, [n, e]), !e)
    return !1;
  let o = a.indexOf(r), i = a.length;
  return o === -1 && (o = i, i += 1), o === i - 1;
}
let y1 = /* @__PURE__ */ new Map(), hc = /* @__PURE__ */ new Map();
function My(e) {
  var t;
  let n = (t = hc.get(e)) != null ? t : 0;
  return hc.set(e, n + 1), n !== 0 ? () => Oy(e) : (y1.set(e, { "aria-hidden": e.getAttribute("aria-hidden"), inert: e.inert }), e.setAttribute("aria-hidden", "true"), e.inert = !0, () => Oy(e));
}
function Oy(e) {
  var t;
  let n = (t = hc.get(e)) != null ? t : 1;
  if (n === 1 ? hc.delete(e) : hc.set(e, n - 1), n !== 1)
    return;
  let r = y1.get(e);
  r && (r["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", r["aria-hidden"]), e.inert = r.inert, y1.delete(e));
}
function Ap(e, { allowed: t, disallowed: n } = {}) {
  let r = el(e, "inert-others");
  Je(() => {
    var a, o;
    if (!r)
      return;
    let i = Rn();
    for (let l of (a = n == null ? void 0 : n()) != null ? a : [])
      l && i.add(My(l));
    let s = (o = t == null ? void 0 : t()) != null ? o : [];
    for (let l of s) {
      if (!l)
        continue;
      let c = Wn(l);
      if (!c)
        continue;
      let u = l.parentElement;
      for (; u && u !== c.body; ) {
        for (let d of u.children)
          s.some((p) => d.contains(p)) || i.add(My(d));
        u = u.parentElement;
      }
    }
    return i.dispose;
  }, [r, t, n]);
}
function nu(e, t, n) {
  let r = Kr((a) => {
    let o = a.getBoundingClientRect();
    o.x === 0 && o.y === 0 && o.width === 0 && o.height === 0 && n();
  });
  De(() => {
    if (!e)
      return;
    let a = t === null ? null : t instanceof HTMLElement ? t : t.current;
    if (!a)
      return;
    let o = Rn();
    if (typeof ResizeObserver < "u") {
      let i = new ResizeObserver(() => r.current(a));
      i.observe(a), o.add(() => i.disconnect());
    }
    if (typeof IntersectionObserver < "u") {
      let i = new IntersectionObserver(() => r.current(a));
      i.observe(a), o.add(() => i.disconnect());
    }
    return () => o.dispose();
  }, [t, r, e]);
}
let Ad = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(","), fx = ["[data-autofocus]"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Ct = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e[e.AutoFocus = 64] = "AutoFocus", e))(Ct || {}), zn = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(zn || {}), gx = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(gx || {});
function au(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Ad)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function yx(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(fx)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var ou = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(ou || {});
function iu(e, t = 0) {
  var n;
  return e === ((n = Wn(e)) == null ? void 0 : n.body) ? !1 : ht(t, { 0() {
    return e.matches(Ad);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(Ad))
        return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
function f6(e) {
  let t = Wn(e);
  Rn().nextFrame(() => {
    t && !iu(t.activeElement, 0) && Ga(e);
  });
}
var vx = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(vx || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Ga(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let bx = ["textarea", "input"].join(",");
function _x(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, bx)) != null ? n : !1;
}
function Ia(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let a = t(n), o = t(r);
    if (a === null || o === null)
      return 0;
    let i = a.compareDocumentPosition(o);
    return i & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : i & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function g6(e, t) {
  return br(au(), t, { relativeTo: e });
}
function br(e, t, { sorted: n = !0, relativeTo: r = null, skipElements: a = [] } = {}) {
  let o = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, i = Array.isArray(e) ? n ? Ia(e) : e : t & 64 ? yx(e) : au(e);
  a.length > 0 && i.length > 1 && (i = i.filter((h) => !a.some((m) => m != null && "current" in m ? (m == null ? void 0 : m.current) === h : m === h))), r = r ?? o.activeElement;
  let s = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), l = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, i.indexOf(r)) - 1;
    if (t & 4)
      return Math.max(0, i.indexOf(r)) + 1;
    if (t & 8)
      return i.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = t & 32 ? { preventScroll: !0 } : {}, u = 0, d = i.length, p;
  do {
    if (u >= d || u + d <= 0)
      return 0;
    let h = l + u;
    if (t & 16)
      h = (h + d) % d;
    else {
      if (h < 0)
        return 3;
      if (h >= d)
        return 1;
    }
    p = i[h], p == null || p.focus(c), u += s;
  } while (p !== o.activeElement);
  return t & 6 && _x(p) && p.select(), 2;
}
function y6() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function wx() {
  return /Android/gi.test(window.navigator.userAgent);
}
function v6() {
  return y6() || wx();
}
function kl(e, t, n, r) {
  let a = Kr(n);
  De(() => {
    if (!e)
      return;
    function o(i) {
      a.current(i);
    }
    return document.addEventListener(t, o, r), () => document.removeEventListener(t, o, r);
  }, [e, t, r]);
}
function b6(e, t, n, r) {
  let a = Kr(n);
  De(() => {
    if (!e)
      return;
    function o(i) {
      a.current(i);
    }
    return window.addEventListener(t, o, r), () => window.removeEventListener(t, o, r);
  }, [e, t, r]);
}
const Ay = 30;
function su(e, t, n) {
  let r = el(e, "outside-click"), a = Kr(n), o = ft(function(l, c) {
    if (l.defaultPrevented)
      return;
    let u = c(l);
    if (u === null || !u.getRootNode().contains(u) || !u.isConnected)
      return;
    let d = function p(h) {
      return typeof h == "function" ? p(h()) : Array.isArray(h) || h instanceof Set ? h : [h];
    }(t);
    for (let p of d)
      if (p !== null && (p.contains(u) || l.composed && l.composedPath().includes(p)))
        return;
    return !iu(u, ou.Loose) && u.tabIndex !== -1 && l.preventDefault(), a.current(l, u);
  }, [a, t]), i = _e(null);
  kl(r, "pointerdown", (l) => {
    var c, u;
    i.current = ((u = (c = l.composedPath) == null ? void 0 : c.call(l)) == null ? void 0 : u[0]) || l.target;
  }, !0), kl(r, "mousedown", (l) => {
    var c, u;
    i.current = ((u = (c = l.composedPath) == null ? void 0 : c.call(l)) == null ? void 0 : u[0]) || l.target;
  }, !0), kl(r, "click", (l) => {
    v6() || i.current && (o(l, () => i.current), i.current = null);
  }, !0);
  let s = _e({ x: 0, y: 0 });
  kl(r, "touchstart", (l) => {
    s.current.x = l.touches[0].clientX, s.current.y = l.touches[0].clientY;
  }, !0), kl(r, "touchend", (l) => {
    let c = { x: l.changedTouches[0].clientX, y: l.changedTouches[0].clientY };
    if (!(Math.abs(c.x - s.current.x) >= Ay || Math.abs(c.y - s.current.y) >= Ay))
      return o(l, () => l.target instanceof HTMLElement ? l.target : null);
  }, !0), b6(r, "blur", (l) => o(l, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Zn(...e) {
  return we(() => Wn(...e), [...e]);
}
function Np(e, t, n, r) {
  let a = Kr(n);
  De(() => {
    e = e ?? window;
    function o(i) {
      a.current(i);
    }
    return e.addEventListener(t, o, r), () => e.removeEventListener(t, o, r);
  }, [e, t, r]);
}
function _6(e) {
  let t = _e({ value: "", selectionStart: null, selectionEnd: null });
  return Np(e, "blur", (n) => {
    let r = n.target;
    r instanceof HTMLInputElement && (t.current = { value: r.value, selectionStart: r.selectionStart, selectionEnd: r.selectionEnd });
  }), ae(() => {
    if (document.activeElement !== e && e instanceof HTMLInputElement && e.isConnected) {
      if (e.focus({ preventScroll: !0 }), e.value !== t.current.value)
        e.setSelectionRange(e.value.length, e.value.length);
      else {
        let { selectionStart: n, selectionEnd: r } = t.current;
        n !== null && r !== null && e.setSelectionRange(n, r);
      }
      t.current = { value: "", selectionStart: null, selectionEnd: null };
    }
  });
}
function es(e, t) {
  return we(() => {
    var n;
    if (e.type)
      return e.type;
    let r = (n = e.as) != null ? n : "button";
    if (typeof r == "string" && r.toLowerCase() === "button" || (t == null ? void 0 : t.tagName) === "BUTTON" && !t.hasAttribute("type"))
      return "button";
  }, [e.type, e.as, t]);
}
function Sx() {
  let e;
  return { before({ doc: t }) {
    var n;
    let r = t.documentElement, a = (n = t.defaultView) != null ? n : window;
    e = Math.max(0, a.innerWidth - r.clientWidth);
  }, after({ doc: t, d: n }) {
    let r = t.documentElement, a = Math.max(0, r.clientWidth - r.offsetWidth), o = Math.max(0, e - a);
    n.style(r, "paddingRight", `${o}px`);
  } };
}
function Cx() {
  return y6() ? { before({ doc: e, d: t, meta: n }) {
    function r(a) {
      return n.containers.flatMap((o) => o()).some((o) => o.contains(a));
    }
    t.microTask(() => {
      var a;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let s = Rn();
        s.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => s.dispose()));
      }
      let o = (a = window.scrollY) != null ? a : window.pageYOffset, i = null;
      t.addEventListener(e, "click", (s) => {
        if (s.target instanceof HTMLElement)
          try {
            let l = s.target.closest("a");
            if (!l)
              return;
            let { hash: c } = new URL(l.href), u = e.querySelector(c);
            u && !r(u) && (i = u);
          } catch {
          }
      }, !0), t.addEventListener(e, "touchstart", (s) => {
        if (s.target instanceof HTMLElement)
          if (r(s.target)) {
            let l = s.target;
            for (; l.parentElement && r(l.parentElement); )
              l = l.parentElement;
            t.style(l, "overscrollBehavior", "contain");
          } else
            t.style(s.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (s) => {
        if (s.target instanceof HTMLElement) {
          if (s.target.tagName === "INPUT")
            return;
          if (r(s.target)) {
            let l = s.target;
            for (; l.parentElement && l.dataset.headlessuiPortal !== "" && !(l.scrollHeight > l.clientHeight || l.scrollWidth > l.clientWidth); )
              l = l.parentElement;
            l.dataset.headlessuiPortal === "" && s.preventDefault();
          } else
            s.preventDefault();
        }
      }, { passive: !1 }), t.add(() => {
        var s;
        let l = (s = window.scrollY) != null ? s : window.pageYOffset;
        o !== l && window.scrollTo(0, o), i && i.isConnected && (i.scrollIntoView({ block: "nearest" }), i = null);
      });
    });
  } } : {};
}
function xx() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function kx(e) {
  let t = {};
  for (let n of e)
    Object.assign(t, n(t));
  return t;
}
let Ti = h6(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var n;
  let r = (n = this.get(e)) != null ? n : { doc: e, count: 0, d: Rn(), meta: /* @__PURE__ */ new Set() };
  return r.count++, r.meta.add(t), this.set(e, r), this;
}, POP(e, t) {
  let n = this.get(e);
  return n && (n.count--, n.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: n }) {
  let r = { doc: e, d: t, meta: kx(n) }, a = [Cx(), Sx(), xx()];
  a.forEach(({ before: o }) => o == null ? void 0 : o(r)), a.forEach(({ after: o }) => o == null ? void 0 : o(r));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
Ti.subscribe(() => {
  let e = Ti.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [n] of e)
    t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let r = t.get(n.doc) === "hidden", a = n.count !== 0;
    (a && !r || !a && r) && Ti.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), n.count === 0 && Ti.dispatch("TEARDOWN", n);
  }
});
function Ex(e, t, n = () => ({ containers: [] })) {
  let r = m6(Ti), a = t ? r.get(t) : void 0, o = a ? a.count > 0 : !1;
  return Je(() => {
    if (!(!t || !e))
      return Ti.dispatch("PUSH", t, n), () => Ti.dispatch("POP", t, n);
  }, [e, t]), o;
}
function lu(e, t, n = () => [document.body]) {
  let r = el(e, "scroll-lock");
  Ex(r, t, (a) => {
    var o;
    return { containers: [...(o = a.containers) != null ? o : [], n] };
  });
}
function Ny(e) {
  return [e.screenX, e.screenY];
}
function k0() {
  let e = _e([-1, -1]);
  return { wasMoved(t) {
    let n = Ny(t);
    return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
  }, update(t) {
    e.current = Ny(t);
  } };
}
function Px(e = 0) {
  let [t, n] = ke(e), r = ft((l) => n(l), [t]), a = ft((l) => n((c) => c | l), [t]), o = ft((l) => (t & l) === l, [t]), i = ft((l) => n((c) => c & ~l), [n]), s = ft((l) => n((c) => c ^ l), [n]);
  return { flags: t, setFlag: r, addFlag: a, hasFlag: o, removeFlag: i, toggleFlag: s };
}
var Ly, Ry;
typeof process < "u" && typeof globalThis < "u" && typeof Element < "u" && ((Ly = process == null ? void 0 : process.env) == null ? void 0 : Ly.NODE_ENV) === "test" && typeof ((Ry = Element == null ? void 0 : Element.prototype) == null ? void 0 : Ry.getAnimations) > "u" && (Element.prototype.getAnimations = function() {
  return console.warn(["Headless UI has polyfilled `Element.prototype.getAnimations` for your tests.", "Please install a proper polyfill e.g. `jsdom-testing-mocks`, to silence these warnings.", "", "Example usage:", "```js", "import { mockAnimationsApi } from 'jsdom-testing-mocks'", "mockAnimationsApi()", "```"].join(`
`)), [];
});
var Tx = ((e) => (e[e.None = 0] = "None", e[e.Closed = 1] = "Closed", e[e.Enter = 2] = "Enter", e[e.Leave = 4] = "Leave", e))(Tx || {});
function ts(e) {
  let t = {};
  for (let n in e)
    e[n] === !0 && (t[`data-${n}`] = "");
  return t;
}
function rs(e, t, n, r) {
  let [a, o] = ke(n), { hasFlag: i, addFlag: s, removeFlag: l } = Px(e && a ? 3 : 0), c = _e(!1), u = _e(!1), d = Yn();
  return Je(() => {
    var p;
    if (e) {
      if (n && o(!0), !t) {
        n && s(3);
        return;
      }
      return (p = r == null ? void 0 : r.start) == null || p.call(r, n), Mx(t, { inFlight: c, prepare() {
        u.current ? u.current = !1 : u.current = c.current, c.current = !0, !u.current && (n ? (s(3), l(4)) : (s(4), l(2)));
      }, run() {
        u.current ? n ? (l(3), s(4)) : (l(4), s(3)) : n ? l(1) : s(1);
      }, done() {
        var h;
        u.current && typeof t.getAnimations == "function" && t.getAnimations().length > 0 || (c.current = !1, l(7), n || o(!1), (h = r == null ? void 0 : r.end) == null || h.call(r, n));
      } });
    }
  }, [e, n, t, d]), e ? [a, { closed: i(1), enter: i(2), leave: i(4), transition: i(2) || i(4) }] : [n, { closed: void 0, enter: void 0, leave: void 0, transition: void 0 }];
}
function Mx(e, { prepare: t, run: n, done: r, inFlight: a }) {
  let o = Rn();
  return Ax(e, { prepare: t, inFlight: a }), o.nextFrame(() => {
    n(), o.requestAnimationFrame(() => {
      o.add(Ox(e, r));
    });
  }), o.dispose;
}
function Ox(e, t) {
  var n, r;
  let a = Rn();
  if (!e)
    return a.dispose;
  let o = !1;
  a.add(() => {
    o = !0;
  });
  let i = (r = (n = e.getAnimations) == null ? void 0 : n.call(e).filter((s) => s instanceof CSSTransition)) != null ? r : [];
  return i.length === 0 ? (t(), a.dispose) : (Promise.allSettled(i.map((s) => s.finished)).then(() => {
    o || t();
  }), a.dispose);
}
function Ax(e, { inFlight: t, prepare: n }) {
  if (t != null && t.current) {
    n();
    return;
  }
  let r = e.style.transition;
  e.style.transition = "none", n(), e.offsetHeight, e.style.transition = r;
}
function w6(e, { container: t, accept: n, walk: r }) {
  let a = _e(n), o = _e(r);
  De(() => {
    a.current = n, o.current = r;
  }, [n, r]), Je(() => {
    if (!t || !e)
      return;
    let i = Wn(t);
    if (!i)
      return;
    let s = a.current, l = o.current, c = Object.assign((d) => s(d), { acceptNode: s }), u = i.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, c, !1);
    for (; u.nextNode(); )
      l(u.currentNode);
  }, [t, e, a, o]);
}
function kc(e, t) {
  let n = _e([]), r = ae(e);
  De(() => {
    let a = [...n.current];
    for (let [o, i] of t.entries())
      if (n.current[o] !== i) {
        let s = r(t, a);
        return n.current = t, s;
      }
  }, [r, ...t]);
}
function Lp() {
  return typeof window < "u";
}
function tl(e) {
  return S6(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Tn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function eo(e) {
  var t;
  return (t = (S6(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function S6(e) {
  return Lp() ? e instanceof Node || e instanceof Tn(e).Node : !1;
}
function Zr(e) {
  return Lp() ? e instanceof Element || e instanceof Tn(e).Element : !1;
}
function Za(e) {
  return Lp() ? e instanceof HTMLElement || e instanceof Tn(e).HTMLElement : !1;
}
function Dy(e) {
  return !Lp() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Tn(e).ShadowRoot;
}
const Nx = /* @__PURE__ */ new Set(["inline", "contents"]);
function cu(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = va(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Nx.has(a);
}
const Lx = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Rx(e) {
  return Lx.has(tl(e));
}
const Dx = [":popover-open", ":modal"];
function Rp(e) {
  return Dx.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Ix = ["transform", "translate", "scale", "rotate", "perspective"], jx = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Bx = ["paint", "layout", "strict", "content"];
function E0(e) {
  const t = P0(), n = Zr(e) ? va(e) : e;
  return Ix.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || jx.some((r) => (n.willChange || "").includes(r)) || Bx.some((r) => (n.contain || "").includes(r));
}
function Fx(e) {
  let t = Vo(e);
  for (; Za(t) && !js(t); ) {
    if (E0(t))
      return t;
    if (Rp(t))
      return null;
    t = Vo(t);
  }
  return null;
}
function P0() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const zx = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function js(e) {
  return zx.has(tl(e));
}
function va(e) {
  return Tn(e).getComputedStyle(e);
}
function Dp(e) {
  return Zr(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Vo(e) {
  if (tl(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Dy(e) && e.host || // Fallback.
    eo(e)
  );
  return Dy(t) ? t.host : t;
}
function C6(e) {
  const t = Vo(e);
  return js(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Za(t) && cu(t) ? t : C6(t);
}
function Ec(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = C6(e), o = a === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Tn(a);
  if (o) {
    const s = v1(i);
    return t.concat(i, i.visualViewport || [], cu(a) ? a : [], s && n ? Ec(s) : []);
  }
  return t.concat(a, Ec(a, [], n));
}
function v1(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Gx() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
const $i = Math.min, Wr = Math.max, Pc = Math.round, Nu = Math.floor, Ha = (e) => ({
  x: e,
  y: e
}), Hx = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Kx = {
  start: "end",
  end: "start"
};
function Iy(e, t, n) {
  return Wr(e, $i(t, n));
}
function rl(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Wo(e) {
  return e.split("-")[0];
}
function uu(e) {
  return e.split("-")[1];
}
function x6(e) {
  return e === "x" ? "y" : "x";
}
function k6(e) {
  return e === "y" ? "height" : "width";
}
const Ux = /* @__PURE__ */ new Set(["top", "bottom"]);
function po(e) {
  return Ux.has(Wo(e)) ? "y" : "x";
}
function E6(e) {
  return x6(po(e));
}
function $x(e, t, n) {
  n === void 0 && (n = !1);
  const r = uu(e), a = E6(e), o = k6(a);
  let i = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (i = Nd(i)), [i, Nd(i)];
}
function Vx(e) {
  const t = Nd(e);
  return [b1(e), t, b1(t)];
}
function b1(e) {
  return e.replace(/start|end/g, (t) => Kx[t]);
}
const jy = ["left", "right"], By = ["right", "left"], Wx = ["top", "bottom"], Yx = ["bottom", "top"];
function Zx(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? By : jy : t ? jy : By;
    case "left":
    case "right":
      return t ? Wx : Yx;
    default:
      return [];
  }
}
function qx(e, t, n, r) {
  const a = uu(e);
  let o = Zx(Wo(e), n === "start", r);
  return a && (o = o.map((i) => i + "-" + a), t && (o = o.concat(o.map(b1)))), o;
}
function Nd(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Hx[t]);
}
function Jx(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Xx(e) {
  return typeof e != "number" ? Jx(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ld(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: a
  } = e;
  return {
    width: r,
    height: a,
    top: n,
    left: t,
    right: t + r,
    bottom: n + a,
    x: t,
    y: n
  };
}
function Fy(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const o = po(t), i = E6(t), s = k6(i), l = Wo(t), c = o === "y", u = r.x + r.width / 2 - a.width / 2, d = r.y + r.height / 2 - a.height / 2, p = r[s] / 2 - a[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - a.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - a.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (uu(t)) {
    case "start":
      h[i] -= p * (n && c ? -1 : 1);
      break;
    case "end":
      h[i] += p * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const Qx = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: o = [],
    platform: i
  } = n, s = o.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: u,
    y: d
  } = Fy(c, r, l), p = r, h = {}, m = 0;
  for (let f = 0; f < s.length; f++) {
    const {
      name: g,
      fn: _
    } = s[f], {
      x: v,
      y: w,
      data: x,
      reset: b
    } = await _({
      x: u,
      y: d,
      initialPlacement: r,
      placement: p,
      strategy: a,
      middlewareData: h,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = v ?? u, d = w ?? d, h = {
      ...h,
      [g]: {
        ...h[g],
        ...x
      }
    }, b && m <= 50 && (m++, typeof b == "object" && (b.placement && (p = b.placement), b.rects && (c = b.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : b.rects), {
      x: u,
      y: d
    } = Fy(c, p, l)), f = -1);
  }
  return {
    x: u,
    y: d,
    placement: p,
    strategy: a,
    middlewareData: h
  };
};
async function Ip(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: o,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: h = 0
  } = rl(t, e), m = Xx(h), f = s[p ? d === "floating" ? "reference" : "floating" : d], g = Ld(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(f))) == null || n ? f : f.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), _ = d === "floating" ? {
    x: r,
    y: a,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, v = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), w = await (o.isElement == null ? void 0 : o.isElement(v)) ? await (o.getScale == null ? void 0 : o.getScale(v)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Ld(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: _,
    offsetParent: v,
    strategy: l
  }) : _);
  return {
    top: (g.top - x.top + m.top) / w.y,
    bottom: (x.bottom - g.bottom + m.bottom) / w.y,
    left: (g.left - x.left + m.left) / w.x,
    right: (x.right - g.right + m.right) / w.x
  };
}
const ek = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        middlewareData: o,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: f = !0,
        ...g
      } = rl(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const _ = Wo(a), v = po(s), w = Wo(s) === s, x = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), b = p || (w || !f ? [Nd(s)] : Vx(s)), C = m !== "none";
      !p && C && b.push(...qx(s, f, m, x));
      const E = [s, ...b], A = await Ip(t, g), O = [];
      let M = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (u && O.push(A[_]), d) {
        const G = $x(a, i, x);
        O.push(A[G[0]], A[G[1]]);
      }
      if (M = [...M, {
        placement: a,
        overflows: O
      }], !O.every((G) => G <= 0)) {
        var I, D;
        const G = (((I = o.flip) == null ? void 0 : I.index) || 0) + 1, V = E[G];
        if (V && (!(d === "alignment" && v !== po(V)) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        M.every((U) => U.overflows[0] > 0 && po(U.placement) === v)))
          return {
            data: {
              index: G,
              overflows: M
            },
            reset: {
              placement: V
            }
          };
        let ee = (D = M.filter((U) => U.overflows[0] <= 0).sort((U, H) => U.overflows[1] - H.overflows[1])[0]) == null ? void 0 : D.placement;
        if (!ee)
          switch (h) {
            case "bestFit": {
              var K;
              const U = (K = M.filter((H) => {
                if (C) {
                  const W = po(H.placement);
                  return W === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  W === "y";
                }
                return !0;
              }).map((H) => [H.placement, H.overflows.filter((W) => W > 0).reduce((W, L) => W + L, 0)]).sort((H, W) => H[1] - W[1])[0]) == null ? void 0 : K[0];
              U && (ee = U);
              break;
            }
            case "initialPlacement":
              ee = s;
              break;
          }
        if (a !== ee)
          return {
            reset: {
              placement: ee
            }
          };
      }
      return {};
    }
  };
}, tk = /* @__PURE__ */ new Set(["left", "top"]);
async function rk(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), i = Wo(n), s = uu(n), l = po(n) === "y", c = tk.has(i) ? -1 : 1, u = o && l ? -1 : 1, d = rl(t, e);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof m == "number" && (h = s === "end" ? m * -1 : m), l ? {
    x: h * u,
    y: p * c
  } : {
    x: p * c,
    y: h * u
  };
}
const nk = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: a,
        y: o,
        placement: i,
        middlewareData: s
      } = t, l = await rk(t, e);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: a + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, ak = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: o = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (g) => {
            let {
              x: _,
              y: v
            } = g;
            return {
              x: _,
              y: v
            };
          }
        },
        ...l
      } = rl(e, t), c = {
        x: n,
        y: r
      }, u = await Ip(t, l), d = po(Wo(a)), p = x6(d);
      let h = c[p], m = c[d];
      if (o) {
        const g = p === "y" ? "top" : "left", _ = p === "y" ? "bottom" : "right", v = h + u[g], w = h - u[_];
        h = Iy(v, h, w);
      }
      if (i) {
        const g = d === "y" ? "top" : "left", _ = d === "y" ? "bottom" : "right", v = m + u[g], w = m - u[_];
        m = Iy(v, m, w);
      }
      const f = s.fn({
        ...t,
        [p]: h,
        [d]: m
      });
      return {
        ...f,
        data: {
          x: f.x - n,
          y: f.y - r,
          enabled: {
            [p]: o,
            [d]: i
          }
        }
      };
    }
  };
}, ok = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        rects: o,
        platform: i,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = rl(e, t), u = await Ip(t, c), d = Wo(a), p = uu(a), h = po(a) === "y", {
        width: m,
        height: f
      } = o.floating;
      let g, _;
      d === "top" || d === "bottom" ? (g = d, _ = p === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (_ = d, g = p === "end" ? "top" : "bottom");
      const v = f - u.top - u.bottom, w = m - u.left - u.right, x = $i(f - u[g], v), b = $i(m - u[_], w), C = !t.middlewareData.shift;
      let E = x, A = b;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (A = w), (r = t.middlewareData.shift) != null && r.enabled.y && (E = v), C && !p) {
        const M = Wr(u.left, 0), I = Wr(u.right, 0), D = Wr(u.top, 0), K = Wr(u.bottom, 0);
        h ? A = m - 2 * (M !== 0 || I !== 0 ? M + I : Wr(u.left, u.right)) : E = f - 2 * (D !== 0 || K !== 0 ? D + K : Wr(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: A,
        availableHeight: E
      });
      const O = await i.getDimensions(s.floating);
      return m !== O.width || f !== O.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function P6(e) {
  const t = va(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = Za(e), o = a ? e.offsetWidth : n, i = a ? e.offsetHeight : r, s = Pc(n) !== o || Pc(r) !== i;
  return s && (n = o, r = i), {
    width: n,
    height: r,
    $: s
  };
}
function T0(e) {
  return Zr(e) ? e : e.contextElement;
}
function Ts(e) {
  const t = T0(e);
  if (!Za(t))
    return Ha(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: o
  } = P6(t);
  let i = (o ? Pc(n.width) : n.width) / r, s = (o ? Pc(n.height) : n.height) / a;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const ik = /* @__PURE__ */ Ha(0);
function T6(e) {
  const t = Tn(e);
  return !P0() || !t.visualViewport ? ik : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function sk(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Tn(e) ? !1 : t;
}
function Vi(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), o = T0(e);
  let i = Ha(1);
  t && (r ? Zr(r) && (i = Ts(r)) : i = Ts(e));
  const s = sk(o, n, r) ? T6(o) : Ha(0);
  let l = (a.left + s.x) / i.x, c = (a.top + s.y) / i.y, u = a.width / i.x, d = a.height / i.y;
  if (o) {
    const p = Tn(o), h = r && Zr(r) ? Tn(r) : r;
    let m = p, f = v1(m);
    for (; f && r && h !== m; ) {
      const g = Ts(f), _ = f.getBoundingClientRect(), v = va(f), w = _.left + (f.clientLeft + parseFloat(v.paddingLeft)) * g.x, x = _.top + (f.clientTop + parseFloat(v.paddingTop)) * g.y;
      l *= g.x, c *= g.y, u *= g.x, d *= g.y, l += w, c += x, m = Tn(f), f = v1(m);
    }
  }
  return Ld({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function M0(e, t) {
  const n = Dp(e).scrollLeft;
  return t ? t.left + n : Vi(eo(e)).left + n;
}
function M6(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), a = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    M0(e, r)
  )), o = r.top + t.scrollTop;
  return {
    x: a,
    y: o
  };
}
function lk(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: a
  } = e;
  const o = a === "fixed", i = eo(r), s = t ? Rp(t.floating) : !1;
  if (r === i || s && o)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Ha(1);
  const u = Ha(0), d = Za(r);
  if ((d || !d && !o) && ((tl(r) !== "body" || cu(i)) && (l = Dp(r)), Za(r))) {
    const h = Vi(r);
    c = Ts(r), u.x = h.x + r.clientLeft, u.y = h.y + r.clientTop;
  }
  const p = i && !d && !o ? M6(i, l, !0) : Ha(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + p.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + p.y
  };
}
function ck(e) {
  return Array.from(e.getClientRects());
}
function uk(e) {
  const t = eo(e), n = Dp(e), r = e.ownerDocument.body, a = Wr(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = Wr(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + M0(e);
  const s = -n.scrollTop;
  return va(r).direction === "rtl" && (i += Wr(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: o,
    x: i,
    y: s
  };
}
function dk(e, t) {
  const n = Tn(e), r = eo(e), a = n.visualViewport;
  let o = r.clientWidth, i = r.clientHeight, s = 0, l = 0;
  if (a) {
    o = a.width, i = a.height;
    const c = P0();
    (!c || c && t === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: s,
    y: l
  };
}
const pk = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function hk(e, t) {
  const n = Vi(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, o = Za(e) ? Ts(e) : Ha(1), i = e.clientWidth * o.x, s = e.clientHeight * o.y, l = a * o.x, c = r * o.y;
  return {
    width: i,
    height: s,
    x: l,
    y: c
  };
}
function zy(e, t, n) {
  let r;
  if (t === "viewport")
    r = dk(e, n);
  else if (t === "document")
    r = uk(eo(e));
  else if (Zr(t))
    r = hk(t, n);
  else {
    const a = T6(e);
    r = {
      x: t.x - a.x,
      y: t.y - a.y,
      width: t.width,
      height: t.height
    };
  }
  return Ld(r);
}
function O6(e, t) {
  const n = Vo(e);
  return n === t || !Zr(n) || js(n) ? !1 : va(n).position === "fixed" || O6(n, t);
}
function mk(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Ec(e, [], !1).filter((s) => Zr(s) && tl(s) !== "body"), a = null;
  const o = va(e).position === "fixed";
  let i = o ? Vo(e) : e;
  for (; Zr(i) && !js(i); ) {
    const s = va(i), l = E0(i);
    !l && s.position === "fixed" && (a = null), (o ? !l && !a : !l && s.position === "static" && a && pk.has(a.position) || cu(i) && !l && O6(e, i)) ? r = r.filter((c) => c !== i) : a = s, i = Vo(i);
  }
  return t.set(e, r), r;
}
function fk(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const o = [...n === "clippingAncestors" ? Rp(t) ? [] : mk(t, this._c) : [].concat(n), r], i = o[0], s = o.reduce((l, c) => {
    const u = zy(t, c, a);
    return l.top = Wr(u.top, l.top), l.right = $i(u.right, l.right), l.bottom = $i(u.bottom, l.bottom), l.left = Wr(u.left, l.left), l;
  }, zy(t, i, a));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function gk(e) {
  const {
    width: t,
    height: n
  } = P6(e);
  return {
    width: t,
    height: n
  };
}
function yk(e, t, n) {
  const r = Za(t), a = eo(t), o = n === "fixed", i = Vi(e, !0, o, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Ha(0);
  function c() {
    l.x = M0(a);
  }
  if (r || !r && !o)
    if ((tl(t) !== "body" || cu(a)) && (s = Dp(t)), r) {
      const h = Vi(t, !0, o, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else
      a && c();
  o && !r && a && c();
  const u = a && !r && !o ? M6(a, s) : Ha(0), d = i.left + s.scrollLeft - l.x - u.x, p = i.top + s.scrollTop - l.y - u.y;
  return {
    x: d,
    y: p,
    width: i.width,
    height: i.height
  };
}
function Vh(e) {
  return va(e).position === "static";
}
function Gy(e, t) {
  if (!Za(e) || va(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return eo(e) === n && (n = n.ownerDocument.body), n;
}
function A6(e, t) {
  const n = Tn(e);
  if (Rp(e))
    return n;
  if (!Za(e)) {
    let a = Vo(e);
    for (; a && !js(a); ) {
      if (Zr(a) && !Vh(a))
        return a;
      a = Vo(a);
    }
    return n;
  }
  let r = Gy(e, t);
  for (; r && Rx(r) && Vh(r); )
    r = Gy(r, t);
  return r && js(r) && Vh(r) && !E0(r) ? n : r || Fx(e) || n;
}
const vk = async function(e) {
  const t = this.getOffsetParent || A6, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: yk(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function bk(e) {
  return va(e).direction === "rtl";
}
const _k = {
  convertOffsetParentRelativeRectToViewportRelativeRect: lk,
  getDocumentElement: eo,
  getClippingRect: fk,
  getOffsetParent: A6,
  getElementRects: vk,
  getClientRects: ck,
  getDimensions: gk,
  getScale: Ts,
  isElement: Zr,
  isRTL: bk
};
function N6(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function wk(e, t) {
  let n = null, r;
  const a = eo(e);
  function o() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), o();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: d,
      width: p,
      height: h
    } = c;
    if (s || t(), !p || !h)
      return;
    const m = Nu(d), f = Nu(a.clientWidth - (u + p)), g = Nu(a.clientHeight - (d + h)), _ = Nu(u), v = {
      rootMargin: -m + "px " + -f + "px " + -g + "px " + -_ + "px",
      threshold: Wr(0, $i(1, l)) || 1
    };
    let w = !0;
    function x(b) {
      const C = b[0].intersectionRatio;
      if (C !== l) {
        if (!w)
          return i();
        C ? i(!1, C) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      C === 1 && !N6(c, e.getBoundingClientRect()) && i(), w = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ...v,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, v);
    }
    n.observe(e);
  }
  return i(!0), o;
}
function Sk(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: o = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = T0(e), u = a || o ? [...c ? Ec(c) : [], ...Ec(t)] : [];
  u.forEach((_) => {
    a && _.addEventListener("scroll", n, {
      passive: !0
    }), o && _.addEventListener("resize", n);
  });
  const d = c && s ? wk(c, n) : null;
  let p = -1, h = null;
  i && (h = new ResizeObserver((_) => {
    let [v] = _;
    v && v.target === c && h && (h.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var w;
      (w = h) == null || w.observe(t);
    })), n();
  }), c && !l && h.observe(c), h.observe(t));
  let m, f = l ? Vi(e) : null;
  l && g();
  function g() {
    const _ = Vi(e);
    f && !N6(f, _) && n(), f = _, m = requestAnimationFrame(g);
  }
  return n(), () => {
    var _;
    u.forEach((v) => {
      a && v.removeEventListener("scroll", n), o && v.removeEventListener("resize", n);
    }), d == null || d(), (_ = h) == null || _.disconnect(), h = null, l && cancelAnimationFrame(m);
  };
}
const Wh = Ip, Ck = nk, xk = ak, kk = ek, Ek = ok, Pk = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: _k,
    ...n
  }, o = {
    ...a.platform,
    _c: r
  };
  return Qx(e, t, {
    ...a,
    platform: o
  });
};
var Tk = typeof document < "u", Mk = function() {
}, nd = Tk ? g0 : Mk;
function Rd(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Rd(e[r], t[r]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = a[r];
      if (!(o === "_owner" && e.$$typeof) && !Rd(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function L6(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Hy(e, t) {
  const n = L6(e);
  return Math.round(t * n) / n;
}
function Yh(e) {
  const t = pe.useRef(e);
  return nd(() => {
    t.current = e;
  }), t;
}
function Ok(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: a,
    elements: {
      reference: o,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = pe.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, h] = pe.useState(r);
  Rd(p, r) || h(r);
  const [m, f] = pe.useState(null), [g, _] = pe.useState(null), v = pe.useCallback((H) => {
    H !== C.current && (C.current = H, f(H));
  }, []), w = pe.useCallback((H) => {
    H !== E.current && (E.current = H, _(H));
  }, []), x = o || m, b = i || g, C = pe.useRef(null), E = pe.useRef(null), A = pe.useRef(u), O = l != null, M = Yh(l), I = Yh(a), D = Yh(c), K = pe.useCallback(() => {
    if (!C.current || !E.current)
      return;
    const H = {
      placement: t,
      strategy: n,
      middleware: p
    };
    I.current && (H.platform = I.current), Pk(C.current, E.current, H).then((W) => {
      const L = {
        ...W,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: D.current !== !1
      };
      G.current && !Rd(A.current, L) && (A.current = L, Cc.flushSync(() => {
        d(L);
      }));
    });
  }, [p, t, n, I, D]);
  nd(() => {
    c === !1 && A.current.isPositioned && (A.current.isPositioned = !1, d((H) => ({
      ...H,
      isPositioned: !1
    })));
  }, [c]);
  const G = pe.useRef(!1);
  nd(() => (G.current = !0, () => {
    G.current = !1;
  }), []), nd(() => {
    if (x && (C.current = x), b && (E.current = b), x && b) {
      if (M.current)
        return M.current(x, b, K);
      K();
    }
  }, [x, b, K, M, O]);
  const V = pe.useMemo(() => ({
    reference: C,
    floating: E,
    setReference: v,
    setFloating: w
  }), [v, w]), ee = pe.useMemo(() => ({
    reference: x,
    floating: b
  }), [x, b]), U = pe.useMemo(() => {
    const H = {
      position: n,
      left: 0,
      top: 0
    };
    if (!ee.floating)
      return H;
    const W = Hy(ee.floating, u.x), L = Hy(ee.floating, u.y);
    return s ? {
      ...H,
      transform: "translate(" + W + "px, " + L + "px)",
      ...L6(ee.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: W,
      top: L
    };
  }, [n, s, ee.floating, u.x, u.y]);
  return pe.useMemo(() => ({
    ...u,
    update: K,
    refs: V,
    elements: ee,
    floatingStyles: U
  }), [u, K, V, ee, U]);
}
const R6 = (e, t) => ({
  ...Ck(e),
  options: [e, t]
}), Ak = (e, t) => ({
  ...xk(e),
  options: [e, t]
}), Nk = (e, t) => ({
  ...kk(e),
  options: [e, t]
}), Lk = (e, t) => ({
  ...Ek(e),
  options: [e, t]
}), D6 = {
  ...pe
}, Rk = D6.useInsertionEffect, Dk = Rk || ((e) => e());
function I6(e) {
  const t = pe.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Dk(() => {
    t.current = e;
  }), pe.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
      r[a] = arguments[a];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
var _1 = typeof document < "u" ? g0 : De;
let Ky = !1, Ik = 0;
const Uy = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + Ik++
);
function jk() {
  const [e, t] = pe.useState(() => Ky ? Uy() : void 0);
  return _1(() => {
    e == null && t(Uy());
  }, []), pe.useEffect(() => {
    Ky = !0;
  }, []), e;
}
const Bk = D6.useId, Fk = Bk || jk;
let Tc;
process.env.NODE_ENV !== "production" && (Tc = /* @__PURE__ */ new Set());
function zk() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const a = "Floating UI: " + n.join(" ");
  if (!((e = Tc) != null && e.has(a))) {
    var o;
    (o = Tc) == null || o.add(a), console.warn(a);
  }
}
function Gk() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const a = "Floating UI: " + n.join(" ");
  if (!((e = Tc) != null && e.has(a))) {
    var o;
    (o = Tc) == null || o.add(a), console.error(a);
  }
}
function Hk() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((a) => a(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((a) => a !== n)) || []);
    }
  };
}
const Kk = /* @__PURE__ */ pe.createContext(null), Uk = /* @__PURE__ */ pe.createContext(null), $k = () => {
  var e;
  return ((e = pe.useContext(Kk)) == null ? void 0 : e.id) || null;
}, Vk = () => pe.useContext(Uk), Wk = "data-floating-ui-focusable";
function Yk(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, a = Fk(), o = pe.useRef({}), [i] = pe.useState(() => Hk()), s = $k() != null;
  if (process.env.NODE_ENV !== "production") {
    const h = r.reference;
    h && !Zr(h) && Gk("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = pe.useState(r.reference), u = I6((h, m, f) => {
    o.current.openEvent = h ? m : void 0, i.emit("openchange", {
      open: h,
      event: m,
      reason: f,
      nested: s
    }), n == null || n(h, m, f);
  }), d = pe.useMemo(() => ({
    setPositionReference: c
  }), []), p = pe.useMemo(() => ({
    reference: l || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [l, r.reference, r.floating]);
  return pe.useMemo(() => ({
    dataRef: o,
    open: t,
    onOpenChange: u,
    elements: p,
    events: i,
    floatingId: a,
    refs: d
  }), [t, u, p, i, a, d]);
}
function Zk(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = Yk({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, a = r.elements, [o, i] = pe.useState(null), [s, l] = pe.useState(null), c = (a == null ? void 0 : a.domReference) || o, u = pe.useRef(null), d = Vk();
  _1(() => {
    c && (u.current = c);
  }, [c]);
  const p = Ok({
    ...e,
    elements: {
      ...a,
      ...s && {
        reference: s
      }
    }
  }), h = pe.useCallback((v) => {
    const w = Zr(v) ? {
      getBoundingClientRect: () => v.getBoundingClientRect(),
      contextElement: v
    } : v;
    l(w), p.refs.setReference(w);
  }, [p.refs]), m = pe.useCallback((v) => {
    (Zr(v) || v === null) && (u.current = v, i(v)), (Zr(p.refs.reference.current) || p.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    v !== null && !Zr(v)) && p.refs.setReference(v);
  }, [p.refs]), f = pe.useMemo(() => ({
    ...p.refs,
    setReference: m,
    setPositionReference: h,
    domReference: u
  }), [p.refs, m, h]), g = pe.useMemo(() => ({
    ...p.elements,
    domReference: c
  }), [p.elements, c]), _ = pe.useMemo(() => ({
    ...p,
    ...r,
    refs: f,
    elements: g,
    nodeId: t
  }), [p, f, g, t, r]);
  return _1(() => {
    r.dataRef.current.floatingContext = _;
    const v = d == null ? void 0 : d.nodesRef.current.find((w) => w.id === t);
    v && (v.context = _);
  }), pe.useMemo(() => ({
    ...p,
    context: _,
    refs: f,
    elements: g
  }), [p, f, g, _]);
}
const $y = "active", Vy = "selected";
function Zh(e, t, n) {
  const r = /* @__PURE__ */ new Map(), a = n === "item";
  let o = e;
  if (a && e) {
    const {
      [$y]: i,
      [Vy]: s,
      ...l
    } = e;
    o = l;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [Wk]: ""
    },
    ...o,
    ...t.map((i) => {
      const s = i ? i[n] : null;
      return typeof s == "function" ? e ? s(e) : null : s;
    }).concat(e).reduce((i, s) => (s && Object.entries(s).forEach((l) => {
      let [c, u] = l;
      if (!(a && [$y, Vy].includes(c)))
        if (c.indexOf("on") === 0) {
          if (r.has(c) || r.set(c, []), typeof u == "function") {
            var d;
            (d = r.get(c)) == null || d.push(u), i[c] = function() {
              for (var p, h = arguments.length, m = new Array(h), f = 0; f < h; f++)
                m[f] = arguments[f];
              return (p = r.get(c)) == null ? void 0 : p.map((g) => g(...m)).find((g) => g !== void 0);
            };
          }
        } else
          i[c] = u;
    }), i), {})
  };
}
function qk(e) {
  e === void 0 && (e = []);
  const t = e.map((s) => s == null ? void 0 : s.reference), n = e.map((s) => s == null ? void 0 : s.floating), r = e.map((s) => s == null ? void 0 : s.item), a = pe.useCallback(
    (s) => Zh(s, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), o = pe.useCallback(
    (s) => Zh(s, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), i = pe.useCallback(
    (s) => Zh(s, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return pe.useMemo(() => ({
    getReferenceProps: a,
    getFloatingProps: o,
    getItemProps: i
  }), [a, o, i]);
}
function Wy(e, t) {
  return {
    ...e,
    rects: {
      ...e.rects,
      floating: {
        ...e.rects.floating,
        height: t
      }
    }
  };
}
const Jk = (e) => ({
  name: "inner",
  options: e,
  async fn(t) {
    const {
      listRef: n,
      overflowRef: r,
      onFallbackChange: a,
      offset: o = 0,
      index: i = 0,
      minItemsVisible: s = 4,
      referenceOverflowThreshold: l = 0,
      scrollRef: c,
      ...u
    } = rl(e, t), {
      rects: d,
      elements: {
        floating: p
      }
    } = t, h = n.current[i], m = (c == null ? void 0 : c.current) || p, f = p.clientTop || m.clientTop, g = p.clientTop !== 0, _ = m.clientTop !== 0, v = p === m;
    if (process.env.NODE_ENV !== "production" && (t.placement.startsWith("bottom") || zk('`placement` side must be "bottom" when using the `inner`', "middleware.")), !h)
      return {};
    const w = {
      ...t,
      ...await R6(-h.offsetTop - p.clientTop - d.reference.height / 2 - h.offsetHeight / 2 - o).fn(t)
    }, x = await Wh(Wy(w, m.scrollHeight + f + p.clientTop), u), b = await Wh(w, {
      ...u,
      elementContext: "reference"
    }), C = Wr(0, x.top), E = w.y + C, A = (m.scrollHeight > m.clientHeight ? (O) => O : Pc)(Wr(0, m.scrollHeight + (g && v || _ ? f * 2 : 0) - C - Wr(0, x.bottom)));
    if (m.style.maxHeight = A + "px", m.scrollTop = C, a) {
      const O = m.offsetHeight < h.offsetHeight * $i(s, n.current.length) - 1 || b.top >= -l || b.bottom >= -l;
      Cc.flushSync(() => a(O));
    }
    return r && (r.current = await Wh(Wy({
      ...w,
      y: E
    }, m.offsetHeight + f + p.clientTop), u)), {
      y: E
    };
  }
});
function Xk(e, t) {
  const {
    open: n,
    elements: r
  } = e, {
    enabled: a = !0,
    overflowRef: o,
    scrollRef: i,
    onChange: s
  } = t, l = I6(s), c = pe.useRef(!1), u = pe.useRef(null), d = pe.useRef(null);
  pe.useEffect(() => {
    if (!a)
      return;
    function h(f) {
      if (f.ctrlKey || !m || o.current == null)
        return;
      const g = f.deltaY, _ = o.current.top >= -0.5, v = o.current.bottom >= -0.5, w = m.scrollHeight - m.clientHeight, x = g < 0 ? -1 : 1, b = g < 0 ? "max" : "min";
      m.scrollHeight <= m.clientHeight || (!_ && g > 0 || !v && g < 0 ? (f.preventDefault(), Cc.flushSync(() => {
        l((C) => C + Math[b](g, w * x));
      })) : /firefox/i.test(Gx()) && (m.scrollTop += g));
    }
    const m = (i == null ? void 0 : i.current) || r.floating;
    if (n && m)
      return m.addEventListener("wheel", h), requestAnimationFrame(() => {
        u.current = m.scrollTop, o.current != null && (d.current = {
          ...o.current
        });
      }), () => {
        u.current = null, d.current = null, m.removeEventListener("wheel", h);
      };
  }, [a, n, r.floating, o, i, l]);
  const p = pe.useMemo(() => ({
    onKeyDown() {
      c.current = !0;
    },
    onWheel() {
      c.current = !1;
    },
    onPointerMove() {
      c.current = !1;
    },
    onScroll() {
      const h = (i == null ? void 0 : i.current) || r.floating;
      if (!(!o.current || !h || !c.current)) {
        if (u.current !== null) {
          const m = h.scrollTop - u.current;
          (o.current.bottom < -0.5 && m < -1 || o.current.top < -0.5 && m > 1) && Cc.flushSync(() => l((f) => f + m));
        }
        requestAnimationFrame(() => {
          u.current = h.scrollTop;
        });
      }
    }
  }), [r.floating, l, o, i]);
  return pe.useMemo(() => a ? {
    floating: p
  } : {}, [a, p]);
}
let nl = Qe({ styles: void 0, setReference: () => {
}, setFloating: () => {
}, getReferenceProps: () => ({}), getFloatingProps: () => ({}), slot: {} });
nl.displayName = "FloatingContext";
let O0 = Qe(null);
O0.displayName = "PlacementContext";
function jp(e) {
  return we(() => e ? typeof e == "string" ? { to: e } : e : null, [e]);
}
function Bp() {
  return Ue(nl).setReference;
}
function j6() {
  return Ue(nl).getReferenceProps;
}
function Fp() {
  let { getFloatingProps: e, slot: t } = Ue(nl);
  return ft((...n) => Object.assign({}, e(...n), { "data-anchor": t.anchor }), [e, t]);
}
function zp(e = null) {
  e === !1 && (e = null), typeof e == "string" && (e = { to: e });
  let t = Ue(O0), n = we(() => e, [JSON.stringify(e, (a, o) => {
    var i;
    return (i = o == null ? void 0 : o.outerHTML) != null ? i : o;
  })]);
  Je(() => {
    t == null || t(n ?? null);
  }, [t, n]);
  let r = Ue(nl);
  return we(() => [r.setFloating, e ? r.styles : {}], [r.setFloating, e, r.styles]);
}
let Yy = 4;
function Gp({ children: e, enabled: t = !0 }) {
  let [n, r] = ke(null), [a, o] = ke(0), i = _e(null), [s, l] = ke(null);
  Qk(s);
  let c = t && n !== null && s !== null, { to: u = "bottom", gap: d = 0, offset: p = 0, padding: h = 0, inner: m } = eE(n, s), [f, g = "center"] = u.split(" ");
  Je(() => {
    c && o(0);
  }, [c]);
  let { refs: _, floatingStyles: v, context: w } = Zk({ open: c, placement: f === "selection" ? g === "center" ? "bottom" : `bottom-${g}` : g === "center" ? `${f}` : `${f}-${g}`, strategy: "absolute", transform: !1, middleware: [R6({ mainAxis: f === "selection" ? 0 : d, crossAxis: p }), Ak({ padding: h }), f !== "selection" && Nk({ padding: h }), f === "selection" && m ? Jk({ ...m, padding: h, overflowRef: i, offset: a, minItemsVisible: Yy, referenceOverflowThreshold: h, onFallbackChange(I) {
    var D, K;
    if (!I)
      return;
    let G = w.elements.floating;
    if (!G)
      return;
    let V = parseFloat(getComputedStyle(G).scrollPaddingBottom) || 0, ee = Math.min(Yy, G.childElementCount), U = 0, H = 0;
    for (let W of (K = (D = w.elements.floating) == null ? void 0 : D.childNodes) != null ? K : [])
      if (W instanceof HTMLElement) {
        let L = W.offsetTop, T = L + W.clientHeight + V, B = G.scrollTop, N = B + G.clientHeight;
        if (L >= B && T <= N)
          ee--;
        else {
          H = Math.max(0, Math.min(T, N) - Math.max(L, B)), U = W.clientHeight;
          break;
        }
      }
    ee >= 1 && o((W) => {
      let L = U * ee - H + V;
      return W >= L ? W : L;
    });
  } }) : null, Lk({ padding: h, apply({ availableWidth: I, availableHeight: D, elements: K }) {
    Object.assign(K.floating.style, { overflow: "auto", maxWidth: `${I}px`, maxHeight: `min(var(--anchor-max-height, 100vh), ${D}px)` });
  } })].filter(Boolean), whileElementsMounted: Sk }), [x = f, b = g] = w.placement.split("-");
  f === "selection" && (x = "selection");
  let C = we(() => ({ anchor: [x, b].filter(Boolean).join(" ") }), [x, b]), E = Xk(w, { overflowRef: i, onChange: o }), { getReferenceProps: A, getFloatingProps: O } = qk([E]), M = ae((I) => {
    l(I), _.setFloating(I);
  });
  return pe.createElement(O0.Provider, { value: r }, pe.createElement(nl.Provider, { value: { setFloating: M, setReference: _.setReference, styles: v, getReferenceProps: A, getFloatingProps: O, slot: C } }, e));
}
function Qk(e) {
  Je(() => {
    if (!e)
      return;
    let t = new MutationObserver(() => {
      let n = window.getComputedStyle(e).maxHeight, r = parseFloat(n);
      if (isNaN(r))
        return;
      let a = parseInt(n);
      isNaN(a) || r !== a && (e.style.maxHeight = `${Math.ceil(r)}px`);
    });
    return t.observe(e, { attributes: !0, attributeFilter: ["style"] }), () => {
      t.disconnect();
    };
  }, [e]);
}
function eE(e, t) {
  var n, r, a;
  let o = qh((n = e == null ? void 0 : e.gap) != null ? n : "var(--anchor-gap, 0)", t), i = qh((r = e == null ? void 0 : e.offset) != null ? r : "var(--anchor-offset, 0)", t), s = qh((a = e == null ? void 0 : e.padding) != null ? a : "var(--anchor-padding, 0)", t);
  return { ...e, gap: o, offset: i, padding: s };
}
function qh(e, t, n = void 0) {
  let r = Yn(), a = ae((l, c) => {
    if (l == null)
      return [n, null];
    if (typeof l == "number")
      return [l, null];
    if (typeof l == "string") {
      if (!c)
        return [n, null];
      let u = Zy(l, c);
      return [u, (d) => {
        let p = B6(l);
        {
          let h = p.map((m) => window.getComputedStyle(c).getPropertyValue(m));
          r.requestAnimationFrame(function m() {
            r.nextFrame(m);
            let f = !1;
            for (let [_, v] of p.entries()) {
              let w = window.getComputedStyle(c).getPropertyValue(v);
              if (h[_] !== w) {
                h[_] = w, f = !0;
                break;
              }
            }
            if (!f)
              return;
            let g = Zy(l, c);
            u !== g && (d(g), u = g);
          });
        }
        return r.dispose;
      }];
    }
    return [n, null];
  }), o = we(() => a(e, t)[0], [e, t]), [i = o, s] = ke();
  return Je(() => {
    let [l, c] = a(e, t);
    if (s(l), !!c)
      return c(s);
  }, [e, t]), i;
}
function B6(e) {
  let t = /var\((.*)\)/.exec(e);
  if (t) {
    let n = t[1].indexOf(",");
    if (n === -1)
      return [t[1]];
    let r = t[1].slice(0, n).trim(), a = t[1].slice(n + 1).trim();
    return a ? [r, ...B6(a)] : [r];
  }
  return [];
}
function Zy(e, t) {
  let n = document.createElement("div");
  t.appendChild(n), n.style.setProperty("margin-top", "0px", "important"), n.style.setProperty("margin-top", e, "important");
  let r = parseFloat(window.getComputedStyle(n).marginTop) || 0;
  return t.removeChild(n), r;
}
function tE({ children: e, freeze: t }) {
  let n = Dd(t, e);
  return k.createElement(k.Fragment, null, n);
}
function Dd(e, t) {
  let [n, r] = ke(t);
  return !e && n !== t && r(t), e ? n : t;
}
let Hp = Qe(null);
Hp.displayName = "OpenClosedContext";
var Pt = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(Pt || {});
function to() {
  return Ue(Hp);
}
function al({ value: e, children: t }) {
  return k.createElement(Hp.Provider, { value: e }, t);
}
function A0({ children: e }) {
  return k.createElement(Hp.Provider, { value: null }, e);
}
function rE(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let Aa = [];
rE(() => {
  function e(t) {
    if (!(t.target instanceof HTMLElement) || t.target === document.body || Aa[0] === t.target)
      return;
    let n = t.target;
    n = n.closest(Ad), Aa.unshift(n ?? t.target), Aa = Aa.filter((r) => r != null && r.isConnected), Aa.splice(10);
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function nE(e) {
  throw new Error("Unexpected object: " + e);
}
var Ge = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(Ge || {});
function Ko(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0)
    return null;
  let r = t.resolveActiveIndex(), a = r ?? -1;
  switch (e.focus) {
    case 0: {
      for (let o = 0; o < n.length; ++o)
        if (!t.resolveDisabled(n[o], o, n))
          return o;
      return r;
    }
    case 1: {
      a === -1 && (a = n.length);
      for (let o = a - 1; o >= 0; --o)
        if (!t.resolveDisabled(n[o], o, n))
          return o;
      return r;
    }
    case 2: {
      for (let o = a + 1; o < n.length; ++o)
        if (!t.resolveDisabled(n[o], o, n))
          return o;
      return r;
    }
    case 3: {
      for (let o = n.length - 1; o >= 0; --o)
        if (!t.resolveDisabled(n[o], o, n))
          return o;
      return r;
    }
    case 4: {
      for (let o = 0; o < n.length; ++o)
        if (t.resolveId(n[o], o, n) === e.id)
          return o;
      return r;
    }
    case 5:
      return null;
    default:
      nE(e);
  }
}
var N0 = ((e) => (e[e.Left = 0] = "Left", e[e.Right = 2] = "Right", e))(N0 || {});
function F6(e) {
  let t = ae(e), n = _e(!1);
  De(() => (n.current = !1, () => {
    n.current = !0, Xc(() => {
      n.current && t();
    });
  }), [t]);
}
function aE() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in pe ? ((t) => t.useSyncExternalStore)(pe)(() => () => {
  }, () => !1, () => !e) : !1;
}
function du() {
  let e = aE(), [t, n] = pe.useState(Di.isHandoffComplete);
  return t && Di.isHandoffComplete === !1 && n(!1), pe.useEffect(() => {
    t !== !0 && n(!0);
  }, [t]), pe.useEffect(() => Di.handoff(), []), e ? !1 : t;
}
let z6 = Qe(!1);
function oE() {
  return Ue(z6);
}
function qy(e) {
  return k.createElement(z6.Provider, { value: e.force }, e.children);
}
function iE(e) {
  let t = oE(), n = Ue(H6), r = Zn(e), [a, o] = ke(() => {
    var i;
    if (!t && n !== null)
      return (i = n.current) != null ? i : null;
    if (Di.isServer)
      return null;
    let s = r == null ? void 0 : r.getElementById("headlessui-portal-root");
    if (s)
      return s;
    if (r === null)
      return null;
    let l = r.createElement("div");
    return l.setAttribute("id", "headlessui-portal-root"), r.body.appendChild(l);
  });
  return De(() => {
    a !== null && (r != null && r.body.contains(a) || r == null || r.body.appendChild(a));
  }, [a, r]), De(() => {
    t || n !== null && o(n.current);
  }, [n, o, t]), a;
}
let G6 = rr, sE = Ie(function(e, t) {
  let n = e, r = _e(null), a = et(_0((d) => {
    r.current = d;
  }), t), o = Zn(r), i = iE(r), [s] = ke(() => {
    var d;
    return Di.isServer ? null : (d = o == null ? void 0 : o.createElement("div")) != null ? d : null;
  }), l = Ue(w1), c = du();
  Je(() => {
    !i || !s || i.contains(s) || (s.setAttribute("data-headlessui-portal", ""), i.appendChild(s));
  }, [i, s]), Je(() => {
    if (s && l)
      return l.register(s);
  }, [l, s]), F6(() => {
    var d;
    !i || !s || (s instanceof Node && i.contains(s) && i.removeChild(s), i.childNodes.length <= 0 && ((d = i.parentElement) == null || d.removeChild(i)));
  });
  let u = ze();
  return c ? !i || !s ? null : H_(u({ ourProps: { ref: a }, theirProps: n, slot: {}, defaultTag: G6, name: "Portal" }), s) : null;
});
function lE(e, t) {
  let n = et(t), { enabled: r = !0, ...a } = e, o = ze();
  return r ? k.createElement(sE, { ...a, ref: n }) : o({ ourProps: { ref: n }, theirProps: a, slot: {}, defaultTag: G6, name: "Portal" });
}
let cE = rr, H6 = Qe(null);
function uE(e, t) {
  let { target: n, ...r } = e, a = { ref: et(t) }, o = ze();
  return k.createElement(H6.Provider, { value: n }, o({ ourProps: a, theirProps: r, defaultTag: cE, name: "Popover.Group" }));
}
let w1 = Qe(null);
function K6() {
  let e = Ue(w1), t = _e([]), n = ae((o) => (t.current.push(o), e && e.register(o), () => r(o))), r = ae((o) => {
    let i = t.current.indexOf(o);
    i !== -1 && t.current.splice(i, 1), e && e.unregister(o);
  }), a = we(() => ({ register: n, unregister: r, portals: t }), [n, r, t]);
  return [t, we(() => function({ children: o }) {
    return k.createElement(w1.Provider, { value: a }, o);
  }, [a])];
}
let dE = Ie(lE), U6 = Ie(uE), pu = Object.assign(dE, { Group: U6 });
var pE = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(pE || {}), hE = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(hE || {}), mE = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(mE || {}), fE = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.SetTyping = 3] = "SetTyping", e[e.RegisterOption = 4] = "RegisterOption", e[e.UnregisterOption = 5] = "UnregisterOption", e[e.SetActivationTrigger = 6] = "SetActivationTrigger", e[e.UpdateVirtualConfiguration = 7] = "UpdateVirtualConfiguration", e[e.SetInputElement = 8] = "SetInputElement", e[e.SetButtonElement = 9] = "SetButtonElement", e[e.SetOptionsElement = 10] = "SetOptionsElement", e))(fE || {});
function Jh(e, t = (n) => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = t(e.options.slice()), a = r.length > 0 && r[0].dataRef.current.order !== null ? r.sort((i, s) => i.dataRef.current.order - s.dataRef.current.order) : Ia(r, (i) => i.dataRef.current.domRef.current), o = n ? a.indexOf(n) : null;
  return o === -1 && (o = null), { options: a, activeOptionIndex: o };
}
let gE = { 1(e) {
  var t;
  return (t = e.dataRef.current) != null && t.disabled || e.comboboxState === 1 ? e : { ...e, activeOptionIndex: null, comboboxState: 1, isTyping: !1, activationTrigger: 2, __demoMode: !1 };
}, 0(e) {
  var t, n;
  if ((t = e.dataRef.current) != null && t.disabled || e.comboboxState === 0)
    return e;
  if ((n = e.dataRef.current) != null && n.value) {
    let r = e.dataRef.current.calculateIndex(e.dataRef.current.value);
    if (r !== -1)
      return { ...e, activeOptionIndex: r, comboboxState: 0, __demoMode: !1 };
  }
  return { ...e, comboboxState: 0, __demoMode: !1 };
}, 3(e, t) {
  return e.isTyping === t.isTyping ? e : { ...e, isTyping: t.isTyping };
}, 2(e, t) {
  var n, r, a, o;
  if ((n = e.dataRef.current) != null && n.disabled || e.optionsElement && !((r = e.dataRef.current) != null && r.optionsPropsRef.current.static) && e.comboboxState === 1)
    return e;
  if (e.virtual) {
    let { options: c, disabled: u } = e.virtual, d = t.focus === Ge.Specific ? t.idx : Ko(t, { resolveItems: () => c, resolveActiveIndex: () => {
      var h, m;
      return (m = (h = e.activeOptionIndex) != null ? h : c.findIndex((f) => !u(f))) != null ? m : null;
    }, resolveDisabled: u, resolveId() {
      throw new Error("Function not implemented.");
    } }), p = (a = t.trigger) != null ? a : 2;
    return e.activeOptionIndex === d && e.activationTrigger === p ? e : { ...e, activeOptionIndex: d, activationTrigger: p, isTyping: !1, __demoMode: !1 };
  }
  let i = Jh(e);
  if (i.activeOptionIndex === null) {
    let c = i.options.findIndex((u) => !u.dataRef.current.disabled);
    c !== -1 && (i.activeOptionIndex = c);
  }
  let s = t.focus === Ge.Specific ? t.idx : Ko(t, { resolveItems: () => i.options, resolveActiveIndex: () => i.activeOptionIndex, resolveId: (c) => c.id, resolveDisabled: (c) => c.dataRef.current.disabled }), l = (o = t.trigger) != null ? o : 2;
  return e.activeOptionIndex === s && e.activationTrigger === l ? e : { ...e, ...i, isTyping: !1, activeOptionIndex: s, activationTrigger: l, __demoMode: !1 };
}, 4: (e, t) => {
  var n, r, a;
  if ((n = e.dataRef.current) != null && n.virtual)
    return { ...e, options: [...e.options, t.payload] };
  let o = t.payload, i = Jh(e, (l) => (l.push(o), l));
  e.activeOptionIndex === null && (r = e.dataRef.current) != null && r.isSelected(t.payload.dataRef.current.value) && (i.activeOptionIndex = i.options.indexOf(o));
  let s = { ...e, ...i, activationTrigger: 2 };
  return (a = e.dataRef.current) != null && a.__demoMode && e.dataRef.current.value === void 0 && (s.activeOptionIndex = 0), s;
}, 5: (e, t) => {
  var n;
  if ((n = e.dataRef.current) != null && n.virtual)
    return { ...e, options: e.options.filter((a) => a.id !== t.id) };
  let r = Jh(e, (a) => {
    let o = a.findIndex((i) => i.id === t.id);
    return o !== -1 && a.splice(o, 1), a;
  });
  return { ...e, ...r, activationTrigger: 2 };
}, 6: (e, t) => e.activationTrigger === t.trigger ? e : { ...e, activationTrigger: t.trigger }, 7: (e, t) => {
  var n, r;
  if (e.virtual === null)
    return { ...e, virtual: { options: t.options, disabled: (n = t.disabled) != null ? n : () => !1 } };
  if (e.virtual.options === t.options && e.virtual.disabled === t.disabled)
    return e;
  let a = e.activeOptionIndex;
  if (e.activeOptionIndex !== null) {
    let o = t.options.indexOf(e.virtual.options[e.activeOptionIndex]);
    o !== -1 ? a = o : a = null;
  }
  return { ...e, activeOptionIndex: a, virtual: { options: t.options, disabled: (r = t.disabled) != null ? r : () => !1 } };
}, 8: (e, t) => e.inputElement === t.element ? e : { ...e, inputElement: t.element }, 9: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 10: (e, t) => e.optionsElement === t.element ? e : { ...e, optionsElement: t.element } }, L0 = Qe(null);
L0.displayName = "ComboboxActionsContext";
function hu(e) {
  let t = Ue(L0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, hu), n;
  }
  return t;
}
let $6 = Qe(null);
function yE(e) {
  let t = ol("VirtualProvider"), { options: n } = t.virtual, [r, a] = we(() => {
    let c = t.optionsElement;
    if (!c)
      return [0, 0];
    let u = window.getComputedStyle(c);
    return [parseFloat(u.paddingBlockStart || u.paddingTop), parseFloat(u.paddingBlockEnd || u.paddingBottom)];
  }, [t.optionsElement]), o = ux({ enabled: n.length !== 0, scrollPaddingStart: r, scrollPaddingEnd: a, count: n.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return t.optionsElement;
  }, overscan: 12 }), [i, s] = ke(0);
  Je(() => {
    s((c) => c + 1);
  }, [n]);
  let l = o.getVirtualItems();
  return l.length === 0 ? null : k.createElement($6.Provider, { value: o }, k.createElement("div", { style: { position: "relative", width: "100%", height: `${o.getTotalSize()}px` }, ref: (c) => {
    c && t.activationTrigger !== 0 && t.activeOptionIndex !== null && n.length > t.activeOptionIndex && o.scrollToIndex(t.activeOptionIndex);
  } }, l.map((c) => {
    var u;
    return k.createElement(rr, { key: c.key }, k.cloneElement((u = e.children) == null ? void 0 : u.call(e, { ...e.slot, option: n[c.index] }), { key: `${i}-${c.key}`, "data-index": c.index, "aria-setsize": n.length, "aria-posinset": c.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${c.start}px)`, overflowAnchor: "none" } }));
  })));
}
let Mc = Qe(null);
Mc.displayName = "ComboboxDataContext";
function ol(e) {
  let t = Ue(Mc);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, ol), n;
  }
  return t;
}
function vE(e, t) {
  return ht(t.type, gE, e, t);
}
let bE = rr;
function _E(e, t) {
  var n, r;
  let a = wn(), { value: o, defaultValue: i, onChange: s, form: l, name: c, by: u, disabled: d = a || !1, onClose: p, __demoMode: h = !1, multiple: m = !1, immediate: f = !1, virtual: g = null, nullable: _, ...v } = e, w = eu(i), [x = m ? [] : void 0, b] = Qc(o, s, w), [C, E] = go(vE, { dataRef: Ri(), comboboxState: h ? 0 : 1, isTyping: !1, options: [], virtual: g ? { options: g.options, disabled: (n = g.disabled) != null ? n : () => !1 } : null, activeOptionIndex: null, activationTrigger: 2, inputElement: null, buttonElement: null, optionsElement: null, __demoMode: h }), A = _e(!1), O = _e({ static: !1, hold: !1 }), M = x0(u), I = ae((J) => g ? u === null ? g.options.indexOf(J) : g.options.findIndex((te) => M(te, J)) : C.options.findIndex((te) => M(te.dataRef.current.value, J))), D = ft((J) => ht(G.mode, { 1: () => x.some((te) => M(te, J)), 0: () => M(x, J) }), [x]), K = ae((J) => C.activeOptionIndex === I(J)), G = we(() => ({ ...C, immediate: f, optionsPropsRef: O, value: x, defaultValue: w, disabled: d, mode: m ? 1 : 0, virtual: g ? C.virtual : null, get activeOptionIndex() {
    if (A.current && C.activeOptionIndex === null && (g ? g.options.length > 0 : C.options.length > 0)) {
      if (g) {
        let te = g.options.findIndex((ve) => {
          var Pe, $e;
          return !(($e = (Pe = g.disabled) == null ? void 0 : Pe.call(g, ve)) != null && $e);
        });
        if (te !== -1)
          return te;
      }
      let J = C.options.findIndex((te) => !te.dataRef.current.disabled);
      if (J !== -1)
        return J;
    }
    return C.activeOptionIndex;
  }, calculateIndex: I, compare: M, isSelected: D, isActive: K }), [x, w, d, m, h, C, g]);
  Je(() => {
    var J;
    g && E({ type: 7, options: g.options, disabled: (J = g.disabled) != null ? J : null });
  }, [g, g == null ? void 0 : g.options, g == null ? void 0 : g.disabled]), Je(() => {
    C.dataRef.current = G;
  }, [G]);
  let V = G.comboboxState === 0;
  su(V, [G.buttonElement, G.inputElement, G.optionsElement], () => q.closeCombobox());
  let ee = we(() => {
    var J, te, ve;
    return { open: G.comboboxState === 0, disabled: d, activeIndex: G.activeOptionIndex, activeOption: G.activeOptionIndex === null ? null : G.virtual ? G.virtual.options[(J = G.activeOptionIndex) != null ? J : 0] : (ve = (te = G.options[G.activeOptionIndex]) == null ? void 0 : te.dataRef.current.value) != null ? ve : null, value: x };
  }, [G, d, x]), U = ae(() => {
    if (G.activeOptionIndex !== null) {
      if (q.setIsTyping(!1), G.virtual)
        N(G.virtual.options[G.activeOptionIndex]);
      else {
        let { dataRef: J } = G.options[G.activeOptionIndex];
        N(J.current.value);
      }
      q.goToOption(Ge.Specific, G.activeOptionIndex);
    }
  }), H = ae(() => {
    E({ type: 0 }), A.current = !0;
  }), W = ae(() => {
    E({ type: 1 }), A.current = !1, p == null || p();
  }), L = ae((J) => {
    E({ type: 3, isTyping: J });
  }), T = ae((J, te, ve) => (A.current = !1, J === Ge.Specific ? E({ type: 2, focus: Ge.Specific, idx: te, trigger: ve }) : E({ type: 2, focus: J, trigger: ve }))), B = ae((J, te) => (E({ type: 4, payload: { id: J, dataRef: te } }), () => {
    G.isActive(te.current.value) && (A.current = !0), E({ type: 5, id: J });
  })), N = ae((J) => ht(G.mode, { 0() {
    return b == null ? void 0 : b(J);
  }, 1() {
    let te = G.value.slice(), ve = te.findIndex((Pe) => M(Pe, J));
    return ve === -1 ? te.push(J) : te.splice(ve, 1), b == null ? void 0 : b(te);
  } })), Y = ae((J) => {
    E({ type: 6, trigger: J });
  }), Q = ae((J) => {
    E({ type: 8, element: J });
  }), F = ae((J) => {
    E({ type: 9, element: J });
  }), re = ae((J) => {
    E({ type: 10, element: J });
  }), q = we(() => ({ onChange: N, registerOption: B, goToOption: T, setIsTyping: L, closeCombobox: W, openCombobox: H, setActivationTrigger: Y, selectActiveOption: U, setInputElement: Q, setButtonElement: F, setOptionsElement: re }), []), [he, me] = bo(), Le = t === null ? {} : { ref: t }, $ = ft(() => {
    if (w !== void 0)
      return b == null ? void 0 : b(w);
  }, [b, w]), Te = ze();
  return k.createElement(me, { value: he, props: { htmlFor: (r = G.inputElement) == null ? void 0 : r.id }, slot: { open: G.comboboxState === 0, disabled: d } }, k.createElement(Gp, null, k.createElement(L0.Provider, { value: q }, k.createElement(Mc.Provider, { value: G }, k.createElement(al, { value: ht(G.comboboxState, { 0: Pt.Open, 1: Pt.Closed }) }, c != null && k.createElement(tu, { disabled: d, data: x != null ? { [c]: x } : {}, form: l, onReset: $ }), Te({ ourProps: Le, theirProps: v, slot: ee, defaultTag: bE, name: "Combobox" }))))));
}
let wE = "input";
function SE(e, t) {
  var n, r, a, o, i;
  let s = ol("Combobox.Input"), l = hu("Combobox.Input"), c = kt(), u = vo(), { id: d = u || `headlessui-combobox-input-${c}`, onChange: p, displayValue: h, disabled: m = s.disabled || !1, autoFocus: f = !1, type: g = "text", ..._ } = e, v = _e(null), w = et(v, t, Bp(), l.setInputElement), x = Zn(s.inputElement), b = Yn(), C = ae(() => {
    l.onChange(null), s.optionsElement && (s.optionsElement.scrollTop = 0), l.goToOption(Ge.Nothing);
  }), E = we(() => {
    var N;
    return typeof h == "function" && s.value !== void 0 ? (N = h(s.value)) != null ? N : "" : typeof s.value == "string" ? s.value : "";
  }, [s.value, h]);
  kc(([N, Y], [Q, F]) => {
    if (s.isTyping)
      return;
    let re = v.current;
    re && ((F === 0 && Y === 1 || N !== Q) && (re.value = N), requestAnimationFrame(() => {
      if (s.isTyping || !re || (x == null ? void 0 : x.activeElement) !== re)
        return;
      let { selectionStart: q, selectionEnd: he } = re;
      Math.abs((he ?? 0) - (q ?? 0)) === 0 && q === 0 && re.setSelectionRange(re.value.length, re.value.length);
    }));
  }, [E, s.comboboxState, x, s.isTyping]), kc(([N], [Y]) => {
    if (N === 0 && Y === 1) {
      if (s.isTyping)
        return;
      let Q = v.current;
      if (!Q)
        return;
      let F = Q.value, { selectionStart: re, selectionEnd: q, selectionDirection: he } = Q;
      Q.value = "", Q.value = F, he !== null ? Q.setSelectionRange(re, q, he) : Q.setSelectionRange(re, q);
    }
  }, [s.comboboxState]);
  let A = _e(!1), O = ae(() => {
    A.current = !0;
  }), M = ae(() => {
    b.nextFrame(() => {
      A.current = !1;
    });
  }), I = ae((N) => {
    switch (l.setIsTyping(!0), N.key) {
      case xe.Enter:
        if (s.comboboxState !== 0 || A.current)
          return;
        if (N.preventDefault(), N.stopPropagation(), s.activeOptionIndex === null) {
          l.closeCombobox();
          return;
        }
        l.selectActiveOption(), s.mode === 0 && l.closeCombobox();
        break;
      case xe.ArrowDown:
        return N.preventDefault(), N.stopPropagation(), ht(s.comboboxState, { 0: () => l.goToOption(Ge.Next), 1: () => l.openCombobox() });
      case xe.ArrowUp:
        return N.preventDefault(), N.stopPropagation(), ht(s.comboboxState, { 0: () => l.goToOption(Ge.Previous), 1: () => {
          Ar(() => l.openCombobox()), s.value || l.goToOption(Ge.Last);
        } });
      case xe.Home:
        if (N.shiftKey)
          break;
        return N.preventDefault(), N.stopPropagation(), l.goToOption(Ge.First);
      case xe.PageUp:
        return N.preventDefault(), N.stopPropagation(), l.goToOption(Ge.First);
      case xe.End:
        if (N.shiftKey)
          break;
        return N.preventDefault(), N.stopPropagation(), l.goToOption(Ge.Last);
      case xe.PageDown:
        return N.preventDefault(), N.stopPropagation(), l.goToOption(Ge.Last);
      case xe.Escape:
        return s.comboboxState !== 0 ? void 0 : (N.preventDefault(), s.optionsElement && !s.optionsPropsRef.current.static && N.stopPropagation(), s.mode === 0 && s.value === null && C(), l.closeCombobox());
      case xe.Tab:
        if (s.comboboxState !== 0)
          return;
        s.mode === 0 && s.activationTrigger !== 1 && l.selectActiveOption(), l.closeCombobox();
        break;
    }
  }), D = ae((N) => {
    p == null || p(N), s.mode === 0 && N.target.value === "" && C(), l.openCombobox();
  }), K = ae((N) => {
    var Y, Q, F;
    let re = (Y = N.relatedTarget) != null ? Y : Aa.find((q) => q !== N.currentTarget);
    if (!((Q = s.optionsElement) != null && Q.contains(re)) && !((F = s.buttonElement) != null && F.contains(re)) && s.comboboxState === 0)
      return N.preventDefault(), s.mode === 0 && s.value === null && C(), l.closeCombobox();
  }), G = ae((N) => {
    var Y, Q, F;
    let re = (Y = N.relatedTarget) != null ? Y : Aa.find((q) => q !== N.currentTarget);
    (Q = s.buttonElement) != null && Q.contains(re) || (F = s.optionsElement) != null && F.contains(re) || s.disabled || s.immediate && s.comboboxState !== 0 && b.microTask(() => {
      Ar(() => l.openCombobox()), l.setActivationTrigger(1);
    });
  }), V = wa(), ee = Jo(), { isFocused: U, focusProps: H } = $r({ autoFocus: f }), { isHovered: W, hoverProps: L } = Jr({ isDisabled: m }), T = we(() => ({ open: s.comboboxState === 0, disabled: m, hover: W, focus: U, autofocus: f }), [s, W, U, f, m]), B = mr({ ref: w, id: d, role: "combobox", type: g, "aria-controls": (n = s.optionsElement) == null ? void 0 : n.id, "aria-expanded": s.comboboxState === 0, "aria-activedescendant": s.activeOptionIndex === null ? void 0 : s.virtual ? (r = s.options.find((N) => !N.dataRef.current.disabled && s.compare(N.dataRef.current.value, s.virtual.options[s.activeOptionIndex]))) == null ? void 0 : r.id : (a = s.options[s.activeOptionIndex]) == null ? void 0 : a.id, "aria-labelledby": V, "aria-describedby": ee, "aria-autocomplete": "list", defaultValue: (i = (o = e.defaultValue) != null ? o : s.defaultValue !== void 0 ? h == null ? void 0 : h(s.defaultValue) : null) != null ? i : s.defaultValue, disabled: m || void 0, autoFocus: f, onCompositionStart: O, onCompositionEnd: M, onKeyDown: I, onChange: D, onFocus: G, onBlur: K }, H, L);
  return ze()({ ourProps: B, theirProps: _, slot: T, defaultTag: wE, name: "Combobox.Input" });
}
let CE = "button";
function xE(e, t) {
  var n;
  let r = ol("Combobox.Button"), a = hu("Combobox.Button"), o = et(t, a.setButtonElement), i = kt(), { id: s = `headlessui-combobox-button-${i}`, disabled: l = r.disabled || !1, autoFocus: c = !1, ...u } = e, d = _6(r.inputElement), p = ae((E) => {
    switch (E.key) {
      case xe.Space:
      case xe.Enter:
        E.preventDefault(), E.stopPropagation(), r.comboboxState === 1 && Ar(() => a.openCombobox()), d();
        return;
      case xe.ArrowDown:
        E.preventDefault(), E.stopPropagation(), r.comboboxState === 1 && (Ar(() => a.openCombobox()), r.value || a.goToOption(Ge.First)), d();
        return;
      case xe.ArrowUp:
        E.preventDefault(), E.stopPropagation(), r.comboboxState === 1 && (Ar(() => a.openCombobox()), r.value || a.goToOption(Ge.Last)), d();
        return;
      case xe.Escape:
        if (r.comboboxState !== 0)
          return;
        E.preventDefault(), r.optionsElement && !r.optionsPropsRef.current.static && E.stopPropagation(), Ar(() => a.closeCombobox()), d();
        return;
      default:
        return;
    }
  }), h = ae((E) => {
    E.preventDefault(), !Qa(E.currentTarget) && (E.button === N0.Left && (r.comboboxState === 0 ? a.closeCombobox() : a.openCombobox()), d());
  }), m = wa([s]), { isFocusVisible: f, focusProps: g } = $r({ autoFocus: c }), { isHovered: _, hoverProps: v } = Jr({ isDisabled: l }), { pressed: w, pressProps: x } = _a({ disabled: l }), b = we(() => ({ open: r.comboboxState === 0, active: w || r.comboboxState === 0, disabled: l, value: r.value, hover: _, focus: f }), [r, _, f, w, l]), C = mr({ ref: o, id: s, type: es(e, r.buttonElement), tabIndex: -1, "aria-haspopup": "listbox", "aria-controls": (n = r.optionsElement) == null ? void 0 : n.id, "aria-expanded": r.comboboxState === 0, "aria-labelledby": m, disabled: l || void 0, autoFocus: c, onMouseDown: h, onKeyDown: p }, g, v, x);
  return ze()({ ourProps: C, theirProps: u, slot: b, defaultTag: CE, name: "Combobox.Button" });
}
let kE = "div", EE = Ir.RenderStrategy | Ir.Static;
function PE(e, t) {
  var n, r, a;
  let o = kt(), { id: i = `headlessui-combobox-options-${o}`, hold: s = !1, anchor: l, portal: c = !1, modal: u = !0, transition: d = !1, ...p } = e, h = ol("Combobox.Options"), m = hu("Combobox.Options"), f = jp(l);
  f && (c = !0);
  let [g, _] = zp(f), [v, w] = ke(null), x = Fp(), b = et(t, f ? g : null, m.setOptionsElement, w), C = Zn(h.optionsElement), E = to(), [A, O] = rs(d, v, E !== null ? (E & Pt.Open) === Pt.Open : h.comboboxState === 0);
  nu(A, h.inputElement, m.closeCombobox);
  let M = h.__demoMode ? !1 : u && h.comboboxState === 0;
  lu(M, C);
  let I = h.__demoMode ? !1 : u && h.comboboxState === 0;
  Ap(I, { allowed: ft(() => [h.inputElement, h.buttonElement, h.optionsElement], [h.inputElement, h.buttonElement, h.optionsElement]) }), Je(() => {
    var B;
    h.optionsPropsRef.current.static = (B = e.static) != null ? B : !1;
  }, [h.optionsPropsRef, e.static]), Je(() => {
    h.optionsPropsRef.current.hold = s;
  }, [h.optionsPropsRef, s]), w6(h.comboboxState === 0, { container: h.optionsElement, accept(B) {
    return B.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : B.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(B) {
    B.setAttribute("role", "none");
  } });
  let D = wa([(n = h.buttonElement) == null ? void 0 : n.id]), K = we(() => ({ open: h.comboboxState === 0, option: void 0 }), [h.comboboxState]), G = ae(() => {
    m.setActivationTrigger(0);
  }), V = ae((B) => {
    B.preventDefault(), m.setActivationTrigger(0);
  }), ee = mr(f ? x() : {}, { "aria-labelledby": D, role: "listbox", "aria-multiselectable": h.mode === 1 ? !0 : void 0, id: i, ref: b, style: { ...p.style, ..._, "--input-width": xc(h.inputElement, !0).width, "--button-width": xc(h.buttonElement, !0).width }, onWheel: h.activationTrigger === 0 ? void 0 : G, onMouseDown: V, ...ts(O) }), U = A && h.comboboxState === 1, H = Dd(U, (r = h.virtual) == null ? void 0 : r.options), W = Dd(U, h.value), L = ae((B) => h.compare(W, B));
  if (h.virtual) {
    if (H === void 0)
      throw new Error("Missing `options` in virtual mode");
    Object.assign(p, { children: k.createElement(Mc.Provider, { value: H !== h.virtual.options ? { ...h, virtual: { ...h.virtual, options: H } } : h }, k.createElement(yE, { slot: K }, p.children)) });
  }
  let T = ze();
  return k.createElement(pu, { enabled: c ? e.static || A : !1 }, k.createElement(Mc.Provider, { value: h.mode === 1 ? h : { ...h, isSelected: L } }, T({ ourProps: ee, theirProps: { ...p, children: k.createElement(tE, { freeze: U }, typeof p.children == "function" ? (a = p.children) == null ? void 0 : a.call(p, K) : p.children) }, slot: K, defaultTag: kE, features: EE, visible: A, name: "Combobox.Options" })));
}
let TE = "div";
function ME(e, t) {
  var n, r, a, o;
  let i = ol("Combobox.Option"), s = hu("Combobox.Option"), l = kt(), { id: c = `headlessui-combobox-option-${l}`, value: u, disabled: d = (a = (r = (n = i.virtual) == null ? void 0 : n.disabled) == null ? void 0 : r.call(n, u)) != null ? a : !1, order: p = null, ...h } = e, m = _6(i.inputElement), f = i.virtual ? i.activeOptionIndex === i.calculateIndex(u) : i.activeOptionIndex === null ? !1 : ((o = i.options[i.activeOptionIndex]) == null ? void 0 : o.id) === c, g = i.isSelected(u), _ = _e(null), v = Kr({ disabled: d, value: u, domRef: _, order: p }), w = Ue($6), x = et(t, _, w ? w.measureElement : null), b = ae(() => {
    s.setIsTyping(!1), s.onChange(u);
  });
  Je(() => s.registerOption(c, v), [v, c]);
  let C = _e(!(i.virtual || i.__demoMode));
  Je(() => {
    if (!i.virtual && !i.__demoMode)
      return Rn().requestAnimationFrame(() => {
        C.current = !0;
      });
  }, [i.virtual, i.__demoMode]), Je(() => {
    if (C.current && i.comboboxState === 0 && f && i.activationTrigger !== 0)
      return Rn().requestAnimationFrame(() => {
        var V, ee;
        (ee = (V = _.current) == null ? void 0 : V.scrollIntoView) == null || ee.call(V, { block: "nearest" });
      });
  }, [_, f, i.comboboxState, i.activationTrigger, i.activeOptionIndex]);
  let E = ae((V) => {
    V.preventDefault(), V.button === N0.Left && (d || (b(), v6() || requestAnimationFrame(() => m()), i.mode === 0 && s.closeCombobox()));
  }), A = ae(() => {
    if (d)
      return s.goToOption(Ge.Nothing);
    let V = i.calculateIndex(u);
    s.goToOption(Ge.Specific, V);
  }), O = k0(), M = ae((V) => O.update(V)), I = ae((V) => {
    if (!O.wasMoved(V) || d || f)
      return;
    let ee = i.calculateIndex(u);
    s.goToOption(Ge.Specific, ee, 0);
  }), D = ae((V) => {
    O.wasMoved(V) && (d || f && (i.optionsPropsRef.current.hold || s.goToOption(Ge.Nothing)));
  }), K = we(() => ({ active: f, focus: f, selected: g, disabled: d }), [f, g, d]), G = { id: c, ref: x, role: "option", tabIndex: d === !0 ? void 0 : -1, "aria-disabled": d === !0 ? !0 : void 0, "aria-selected": g, disabled: void 0, onMouseDown: E, onFocus: A, onPointerEnter: M, onMouseEnter: M, onPointerMove: I, onMouseMove: I, onPointerLeave: D, onMouseLeave: D };
  return ze()({ ourProps: G, theirProps: h, slot: K, defaultTag: TE, name: "Combobox.Option" });
}
let OE = Ie(_E), R0 = Ie(xE), V6 = Ie(SE), AE = ru, W6 = Ie(PE), Y6 = Ie(ME), NE = Object.assign(OE, { Input: V6, Button: R0, Label: AE, Options: W6, Option: Y6 }), LE = rr;
function RE(e, t) {
  let { ...n } = e, r = !1, { isFocusVisible: a, focusProps: o } = $r(), { isHovered: i, hoverProps: s } = Jr({ isDisabled: r }), { pressed: l, pressProps: c } = _a({ disabled: r }), u = mr({ ref: t }, o, s, c), d = we(() => ({ hover: i, focus: a, active: l }), [i, a, l]);
  return ze()({ ourProps: u, theirProps: n, slot: d, defaultTag: LE, name: "DataInteractive" });
}
Ie(RE);
function DE(e, t = typeof document < "u" ? document.defaultView : null, n) {
  let r = el(e, "escape");
  Np(t, "keydown", (a) => {
    r && (a.defaultPrevented || a.key === xe.Escape && n(a));
  });
}
function IE() {
  var e;
  let [t] = ke(() => typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(pointer: coarse)") : null), [n, r] = ke((e = t == null ? void 0 : t.matches) != null ? e : !1);
  return Je(() => {
    if (!t)
      return;
    function a(o) {
      r(o.matches);
    }
    return t.addEventListener("change", a), () => t.removeEventListener("change", a);
  }, [t]), n;
}
function Z6({ defaultContainers: e = [], portals: t, mainTreeNode: n } = {}) {
  let r = Zn(n), a = ae(() => {
    var o, i;
    let s = [];
    for (let l of e)
      l !== null && (l instanceof HTMLElement ? s.push(l) : "current" in l && l.current instanceof HTMLElement && s.push(l.current));
    if (t != null && t.current)
      for (let l of t.current)
        s.push(l);
    for (let l of (o = r == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? o : [])
      l !== document.body && l !== document.head && l instanceof HTMLElement && l.id !== "headlessui-portal-root" && (n && (l.contains(n) || l.contains((i = n == null ? void 0 : n.getRootNode()) == null ? void 0 : i.host)) || s.some((c) => l.contains(c)) || s.push(l));
    return s;
  });
  return { resolveContainers: a, contains: ae((o) => a().some((i) => i.contains(o))) };
}
let q6 = Qe(null);
function Id({ children: e, node: t }) {
  let [n, r] = ke(null), a = D0(t ?? n);
  return k.createElement(q6.Provider, { value: a }, e, a === null && k.createElement(ya, { features: ga.Hidden, ref: (o) => {
    var i, s;
    if (o) {
      for (let l of (s = (i = Wn(o)) == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? s : [])
        if (l !== document.body && l !== document.head && l instanceof HTMLElement && l != null && l.contains(o)) {
          r(l);
          break;
        }
    }
  } }));
}
function D0(e = null) {
  var t;
  return (t = Ue(q6)) != null ? t : e;
}
function Kp() {
  let e = _e(!1);
  return Je(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
var Pn = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Pn || {});
function I0() {
  let e = _e(0);
  return b6(!0, "keydown", (t) => {
    t.key === "Tab" && (e.current = t.shiftKey ? 1 : 0);
  }, !0), e;
}
function J6(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let n of e.current)
    n.current instanceof HTMLElement && t.add(n.current);
  return t;
}
let jE = "div";
var ki = ((e) => (e[e.None = 0] = "None", e[e.InitialFocus = 1] = "InitialFocus", e[e.TabLock = 2] = "TabLock", e[e.FocusLock = 4] = "FocusLock", e[e.RestoreFocus = 8] = "RestoreFocus", e[e.AutoFocus = 16] = "AutoFocus", e))(ki || {});
function BE(e, t) {
  let n = _e(null), r = et(n, t), { initialFocus: a, initialFocusFallback: o, containers: i, features: s = 15, ...l } = e;
  du() || (s = 0);
  let c = Zn(n);
  HE(s, { ownerDocument: c });
  let u = KE(s, { ownerDocument: c, container: n, initialFocus: a, initialFocusFallback: o });
  UE(s, { ownerDocument: c, container: n, containers: i, previousActiveElement: u });
  let d = I0(), p = ae((v) => {
    let w = n.current;
    w && ((x) => x())(() => {
      ht(d.current, { [Pn.Forwards]: () => {
        br(w, Ct.First, { skipElements: [v.relatedTarget, o] });
      }, [Pn.Backwards]: () => {
        br(w, Ct.Last, { skipElements: [v.relatedTarget, o] });
      } });
    });
  }), h = el(!!(s & 2), "focus-trap#tab-lock"), m = Yn(), f = _e(!1), g = { ref: r, onKeyDown(v) {
    v.key == "Tab" && (f.current = !0, m.requestAnimationFrame(() => {
      f.current = !1;
    }));
  }, onBlur(v) {
    if (!(s & 4))
      return;
    let w = J6(i);
    n.current instanceof HTMLElement && w.add(n.current);
    let x = v.relatedTarget;
    x instanceof HTMLElement && x.dataset.headlessuiFocusGuard !== "true" && (X6(w, x) || (f.current ? br(n.current, ht(d.current, { [Pn.Forwards]: () => Ct.Next, [Pn.Backwards]: () => Ct.Previous }) | Ct.WrapAround, { relativeTo: v.target }) : v.target instanceof HTMLElement && Ga(v.target)));
  } }, _ = ze();
  return k.createElement(k.Fragment, null, h && k.createElement(ya, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: p, features: ga.Focusable }), _({ ourProps: g, theirProps: l, defaultTag: jE, name: "FocusTrap" }), h && k.createElement(ya, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: p, features: ga.Focusable }));
}
let FE = Ie(BE), zE = Object.assign(FE, { features: ki });
function GE(e = !0) {
  let t = _e(Aa.slice());
  return kc(([n], [r]) => {
    r === !0 && n === !1 && Xc(() => {
      t.current.splice(0);
    }), r === !1 && n === !0 && (t.current = Aa.slice());
  }, [e, Aa, t]), ae(() => {
    var n;
    return (n = t.current.find((r) => r != null && r.isConnected)) != null ? n : null;
  });
}
function HE(e, { ownerDocument: t }) {
  let n = !!(e & 8), r = GE(n);
  kc(() => {
    n || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && Ga(r());
  }, [n]), F6(() => {
    n && Ga(r());
  });
}
function KE(e, { ownerDocument: t, container: n, initialFocus: r, initialFocusFallback: a }) {
  let o = _e(null), i = el(!!(e & 1), "focus-trap#initial-focus"), s = Kp();
  return kc(() => {
    if (e === 0)
      return;
    if (!i) {
      a != null && a.current && Ga(a.current);
      return;
    }
    let l = n.current;
    l && Xc(() => {
      if (!s.current)
        return;
      let c = t == null ? void 0 : t.activeElement;
      if (r != null && r.current) {
        if ((r == null ? void 0 : r.current) === c) {
          o.current = c;
          return;
        }
      } else if (l.contains(c)) {
        o.current = c;
        return;
      }
      if (r != null && r.current)
        Ga(r.current);
      else {
        if (e & 16) {
          if (br(l, Ct.First | Ct.AutoFocus) !== zn.Error)
            return;
        } else if (br(l, Ct.First) !== zn.Error)
          return;
        if (a != null && a.current && (Ga(a.current), (t == null ? void 0 : t.activeElement) === a.current))
          return;
        console.warn("There are no focusable elements inside the <FocusTrap />");
      }
      o.current = t == null ? void 0 : t.activeElement;
    });
  }, [a, i, e]), o;
}
function UE(e, { ownerDocument: t, container: n, containers: r, previousActiveElement: a }) {
  let o = Kp(), i = !!(e & 4);
  Np(t == null ? void 0 : t.defaultView, "focus", (s) => {
    if (!i || !o.current)
      return;
    let l = J6(r);
    n.current instanceof HTMLElement && l.add(n.current);
    let c = a.current;
    if (!c)
      return;
    let u = s.target;
    u && u instanceof HTMLElement ? X6(l, u) ? (a.current = u, Ga(u)) : (s.preventDefault(), s.stopPropagation(), Ga(c)) : Ga(a.current);
  }, !0);
}
function X6(e, t) {
  for (let n of e)
    if (n.contains(t))
      return !0;
  return !1;
}
function Q6(e) {
  var t;
  return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || ((t = e.as) != null ? t : t5) !== rr || k.Children.count(e.children) === 1;
}
let Up = Qe(null);
Up.displayName = "TransitionContext";
var $E = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))($E || {});
function VE() {
  let e = Ue(Up);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function WE() {
  let e = Ue($p);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
let $p = Qe(null);
$p.displayName = "NestingContext";
function Vp(e) {
  return "children" in e ? Vp(e.children) : e.current.filter(({ el: t }) => t.current !== null).filter(({ state: t }) => t === "visible").length > 0;
}
function e5(e, t) {
  let n = Kr(e), r = _e([]), a = Kp(), o = Yn(), i = ae((h, m = jo.Hidden) => {
    let f = r.current.findIndex(({ el: g }) => g === h);
    f !== -1 && (ht(m, { [jo.Unmount]() {
      r.current.splice(f, 1);
    }, [jo.Hidden]() {
      r.current[f].state = "hidden";
    } }), o.microTask(() => {
      var g;
      !Vp(r) && a.current && ((g = n.current) == null || g.call(n));
    }));
  }), s = ae((h) => {
    let m = r.current.find(({ el: f }) => f === h);
    return m ? m.state !== "visible" && (m.state = "visible") : r.current.push({ el: h, state: "visible" }), () => i(h, jo.Unmount);
  }), l = _e([]), c = _e(Promise.resolve()), u = _e({ enter: [], leave: [] }), d = ae((h, m, f) => {
    l.current.splice(0), t && (t.chains.current[m] = t.chains.current[m].filter(([g]) => g !== h)), t == null || t.chains.current[m].push([h, new Promise((g) => {
      l.current.push(g);
    })]), t == null || t.chains.current[m].push([h, new Promise((g) => {
      Promise.all(u.current[m].map(([_, v]) => v)).then(() => g());
    })]), m === "enter" ? c.current = c.current.then(() => t == null ? void 0 : t.wait.current).then(() => f(m)) : f(m);
  }), p = ae((h, m, f) => {
    Promise.all(u.current[m].splice(0).map(([g, _]) => _)).then(() => {
      var g;
      (g = l.current.shift()) == null || g();
    }).then(() => f(m));
  });
  return we(() => ({ children: r, register: s, unregister: i, onStart: d, onStop: p, wait: c, chains: u }), [s, i, r, d, p, u, c]);
}
let t5 = rr, r5 = Ir.RenderStrategy;
function YE(e, t) {
  var n, r;
  let { transition: a = !0, beforeEnter: o, afterEnter: i, beforeLeave: s, afterLeave: l, enter: c, enterFrom: u, enterTo: d, entered: p, leave: h, leaveFrom: m, leaveTo: f, ...g } = e, [_, v] = ke(null), w = _e(null), x = Q6(e), b = et(...x ? [w, t, v] : t === null ? [] : [t]), C = (n = g.unmount) == null || n ? jo.Unmount : jo.Hidden, { show: E, appear: A, initial: O } = VE(), [M, I] = ke(E ? "visible" : "hidden"), D = WE(), { register: K, unregister: G } = D;
  Je(() => K(w), [K, w]), Je(() => {
    if (C === jo.Hidden && w.current) {
      if (E && M !== "visible") {
        I("visible");
        return;
      }
      return ht(M, { hidden: () => G(w), visible: () => K(w) });
    }
  }, [M, w, K, G, E, C]);
  let V = du();
  Je(() => {
    if (x && V && M === "visible" && w.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [w, M, V, x]);
  let ee = O && !A, U = A && E && O, H = _e(!1), W = e5(() => {
    H.current || (I("hidden"), G(w));
  }, D), L = ae((re) => {
    H.current = !0;
    let q = re ? "enter" : "leave";
    W.onStart(w, q, (he) => {
      he === "enter" ? o == null || o() : he === "leave" && (s == null || s());
    });
  }), T = ae((re) => {
    let q = re ? "enter" : "leave";
    H.current = !1, W.onStop(w, q, (he) => {
      he === "enter" ? i == null || i() : he === "leave" && (l == null || l());
    }), q === "leave" && !Vp(W) && (I("hidden"), G(w));
  });
  De(() => {
    x && a || (L(E), T(E));
  }, [E, x, a]);
  let B = !(!a || !x || !V || ee), [, N] = rs(B, _, E, { start: L, end: T }), Y = Ro({ ref: b, className: ((r = g1(g.className, U && c, U && u, N.enter && c, N.enter && N.closed && u, N.enter && !N.closed && d, N.leave && h, N.leave && !N.closed && m, N.leave && N.closed && f, !N.transition && E && p)) == null ? void 0 : r.trim()) || void 0, ...ts(N) }), Q = 0;
  M === "visible" && (Q |= Pt.Open), M === "hidden" && (Q |= Pt.Closed), N.enter && (Q |= Pt.Opening), N.leave && (Q |= Pt.Closing);
  let F = ze();
  return k.createElement($p.Provider, { value: W }, k.createElement(al, { value: Q }, F({ ourProps: Y, theirProps: g, defaultTag: t5, features: r5, visible: M === "visible", name: "Transition.Child" })));
}
function ZE(e, t) {
  let { show: n, appear: r = !1, unmount: a = !0, ...o } = e, i = _e(null), s = Q6(e), l = et(...s ? [i, t] : t === null ? [] : [t]);
  du();
  let c = to();
  if (n === void 0 && c !== null && (n = (c & Pt.Open) === Pt.Open), n === void 0)
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [u, d] = ke(n ? "visible" : "hidden"), p = e5(() => {
    n || d("hidden");
  }), [h, m] = ke(!0), f = _e([n]);
  Je(() => {
    h !== !1 && f.current[f.current.length - 1] !== n && (f.current.push(n), m(!1));
  }, [f, n]);
  let g = we(() => ({ show: n, appear: r, initial: h }), [n, r, h]);
  Je(() => {
    n ? d("visible") : !Vp(p) && i.current !== null && d("hidden");
  }, [n, p]);
  let _ = { unmount: a }, v = ae(() => {
    var b;
    h && m(!1), (b = e.beforeEnter) == null || b.call(e);
  }), w = ae(() => {
    var b;
    h && m(!1), (b = e.beforeLeave) == null || b.call(e);
  }), x = ze();
  return k.createElement($p.Provider, { value: p }, k.createElement(Up.Provider, { value: g }, x({ ourProps: { ..._, as: rr, children: k.createElement(n5, { ref: l, ..._, ...o, beforeEnter: v, beforeLeave: w }) }, theirProps: {}, defaultTag: rr, features: r5, visible: u === "visible", name: "Transition" })));
}
function qE(e, t) {
  let n = Ue(Up) !== null, r = to() !== null;
  return k.createElement(k.Fragment, null, !n && r ? k.createElement(S1, { ref: t, ...e }) : k.createElement(n5, { ref: t, ...e }));
}
let S1 = Ie(ZE), n5 = Ie(YE), j0 = Ie(qE), ad = Object.assign(S1, { Child: j0, Root: S1 });
var JE = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(JE || {}), XE = ((e) => (e[e.SetTitleId = 0] = "SetTitleId", e))(XE || {});
let QE = { 0(e, t) {
  return e.titleId === t.id ? e : { ...e, titleId: t.id };
} }, B0 = Qe(null);
B0.displayName = "DialogContext";
function Wp(e) {
  let t = Ue(B0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Wp), n;
  }
  return t;
}
function eP(e, t) {
  return ht(t.type, QE, e, t);
}
let Jy = Ie(function(e, t) {
  let n = kt(), { id: r = `headlessui-dialog-${n}`, open: a, onClose: o, initialFocus: i, role: s = "dialog", autoFocus: l = !0, __demoMode: c = !1, unmount: u = !1, ...d } = e, p = _e(!1);
  s = function() {
    return s === "dialog" || s === "alertdialog" ? s : (p.current || (p.current = !0, console.warn(`Invalid role [${s}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let h = to();
  a === void 0 && h !== null && (a = (h & Pt.Open) === Pt.Open);
  let m = _e(null), f = et(m, t), g = Zn(m), _ = a ? 0 : 1, [v, w] = go(eP, { titleId: null, descriptionId: null, panelRef: Ri() }), x = ae(() => o(!1)), b = ae((T) => w({ type: 0, id: T })), C = du() ? _ === 0 : !1, [E, A] = K6(), O = { get current() {
    var T;
    return (T = v.panelRef.current) != null ? T : m.current;
  } }, M = D0(), { resolveContainers: I } = Z6({ mainTreeNode: M, portals: E, defaultContainers: [O] }), D = h !== null ? (h & Pt.Closing) === Pt.Closing : !1;
  Ap(c || D ? !1 : C, { allowed: ae(() => {
    var T, B;
    return [(B = (T = m.current) == null ? void 0 : T.closest("[data-headlessui-portal]")) != null ? B : null];
  }), disallowed: ae(() => {
    var T;
    return [(T = M == null ? void 0 : M.closest("body > *:not(#headlessui-portal-root)")) != null ? T : null];
  }) }), su(C, I, (T) => {
    T.preventDefault(), x();
  }), DE(C, g == null ? void 0 : g.defaultView, (T) => {
    T.preventDefault(), T.stopPropagation(), document.activeElement && "blur" in document.activeElement && typeof document.activeElement.blur == "function" && document.activeElement.blur(), x();
  }), lu(c || D ? !1 : C, g, I), nu(C, m, x);
  let [K, G] = Qs(), V = we(() => [{ dialogState: _, close: x, setTitleId: b, unmount: u }, v], [_, v, x, b, u]), ee = we(() => ({ open: _ === 0 }), [_]), U = { ref: f, id: r, role: s, tabIndex: -1, "aria-modal": c ? void 0 : _ === 0 ? !0 : void 0, "aria-labelledby": v.titleId, "aria-describedby": K, unmount: u }, H = !IE(), W = ki.None;
  C && !c && (W |= ki.RestoreFocus, W |= ki.TabLock, l && (W |= ki.AutoFocus), H && (W |= ki.InitialFocus));
  let L = ze();
  return k.createElement(A0, null, k.createElement(qy, { force: !0 }, k.createElement(pu, null, k.createElement(B0.Provider, { value: V }, k.createElement(U6, { target: m }, k.createElement(qy, { force: !1 }, k.createElement(G, { slot: ee }, k.createElement(A, null, k.createElement(zE, { initialFocus: i, initialFocusFallback: m, containers: I, features: W }, k.createElement(C0, { value: x }, L({ ourProps: U, theirProps: d, slot: ee, defaultTag: tP, features: rP, visible: _ === 0, name: "Dialog" })))))))))));
}), tP = "div", rP = Ir.RenderStrategy | Ir.Static;
function nP(e, t) {
  let { transition: n = !1, open: r, ...a } = e, o = to(), i = e.hasOwnProperty("open") || o !== null, s = e.hasOwnProperty("onClose");
  if (!i && !s)
    throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!i)
    throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!s)
    throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (!o && typeof e.open != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${e.open}`);
  if (typeof e.onClose != "function")
    throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${e.onClose}`);
  return (r !== void 0 || n) && !a.static ? k.createElement(Id, null, k.createElement(ad, { show: r, transition: n, unmount: a.unmount }, k.createElement(Jy, { ref: t, ...a }))) : k.createElement(Id, null, k.createElement(Jy, { ref: t, open: r, ...a }));
}
let aP = "div";
function oP(e, t) {
  let n = kt(), { id: r = `headlessui-dialog-panel-${n}`, transition: a = !1, ...o } = e, [{ dialogState: i, unmount: s }, l] = Wp("Dialog.Panel"), c = et(t, l.panelRef), u = we(() => ({ open: i === 0 }), [i]), d = ae((g) => {
    g.stopPropagation();
  }), p = { ref: c, id: r, onClick: d }, h = a ? j0 : rr, m = a ? { unmount: s } : {}, f = ze();
  return k.createElement(h, { ...m }, f({ ourProps: p, theirProps: o, slot: u, defaultTag: aP, name: "Dialog.Panel" }));
}
let iP = "div";
function sP(e, t) {
  let { transition: n = !1, ...r } = e, [{ dialogState: a, unmount: o }] = Wp("Dialog.Backdrop"), i = we(() => ({ open: a === 0 }), [a]), s = { ref: t, "aria-hidden": !0 }, l = n ? j0 : rr, c = n ? { unmount: o } : {}, u = ze();
  return k.createElement(l, { ...c }, u({ ourProps: s, theirProps: r, slot: i, defaultTag: iP, name: "Dialog.Backdrop" }));
}
let lP = "h2";
function cP(e, t) {
  let n = kt(), { id: r = `headlessui-dialog-title-${n}`, ...a } = e, [{ dialogState: o, setTitleId: i }] = Wp("Dialog.Title"), s = et(t);
  De(() => (i(r), () => i(null)), [r, i]);
  let l = we(() => ({ open: o === 0 }), [o]), c = { ref: s, id: r };
  return ze()({ ourProps: c, theirProps: a, slot: l, defaultTag: lP, name: "Dialog.Title" });
}
let uP = Ie(nP), dP = Ie(oP);
Ie(sP);
let pP = Ie(cP), Xy = Object.assign(uP, { Panel: dP, Title: pP, Description: w0 });
var Qy;
let hP = (Qy = k.startTransition) != null ? Qy : function(e) {
  e();
};
var mP = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(mP || {}), fP = ((e) => (e[e.ToggleDisclosure = 0] = "ToggleDisclosure", e[e.CloseDisclosure = 1] = "CloseDisclosure", e[e.SetButtonId = 2] = "SetButtonId", e[e.SetPanelId = 3] = "SetPanelId", e[e.SetButtonElement = 4] = "SetButtonElement", e[e.SetPanelElement = 5] = "SetPanelElement", e))(fP || {});
let gP = { 0: (e) => ({ ...e, disclosureState: ht(e.disclosureState, { 0: 1, 1: 0 }) }), 1: (e) => e.disclosureState === 1 ? e : { ...e, disclosureState: 1 }, 2(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 3(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
}, 4(e, t) {
  return e.buttonElement === t.element ? e : { ...e, buttonElement: t.element };
}, 5(e, t) {
  return e.panelElement === t.element ? e : { ...e, panelElement: t.element };
} }, F0 = Qe(null);
F0.displayName = "DisclosureContext";
function z0(e) {
  let t = Ue(F0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, z0), n;
  }
  return t;
}
let G0 = Qe(null);
G0.displayName = "DisclosureAPIContext";
function a5(e) {
  let t = Ue(G0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, a5), n;
  }
  return t;
}
let H0 = Qe(null);
H0.displayName = "DisclosurePanelContext";
function yP() {
  return Ue(H0);
}
function vP(e, t) {
  return ht(t.type, gP, e, t);
}
let bP = rr;
function _P(e, t) {
  let { defaultOpen: n = !1, ...r } = e, a = _e(null), o = et(t, _0((f) => {
    a.current = f;
  }, e.as === void 0 || e.as === rr)), i = go(vP, { disclosureState: n ? 0 : 1, buttonElement: null, panelElement: null, buttonId: null, panelId: null }), [{ disclosureState: s, buttonId: l }, c] = i, u = ae((f) => {
    c({ type: 1 });
    let g = Wn(a);
    if (!g || !l)
      return;
    let _ = f ? f instanceof HTMLElement ? f : f.current instanceof HTMLElement ? f.current : g.getElementById(l) : g.getElementById(l);
    _ == null || _.focus();
  }), d = we(() => ({ close: u }), [u]), p = we(() => ({ open: s === 0, close: u }), [s, u]), h = { ref: o }, m = ze();
  return k.createElement(F0.Provider, { value: i }, k.createElement(G0.Provider, { value: d }, k.createElement(C0, { value: u }, k.createElement(al, { value: ht(s, { 0: Pt.Open, 1: Pt.Closed }) }, m({ ourProps: h, theirProps: r, slot: p, defaultTag: bP, name: "Disclosure" })))));
}
let wP = "button";
function SP(e, t) {
  let n = kt(), { id: r = `headlessui-disclosure-button-${n}`, disabled: a = !1, autoFocus: o = !1, ...i } = e, [s, l] = z0("Disclosure.Button"), c = yP(), u = c === null ? !1 : c === s.panelId, d = _e(null), p = et(d, t, ae((O) => {
    if (!u)
      return l({ type: 4, element: O });
  }));
  De(() => {
    if (!u)
      return l({ type: 2, buttonId: r }), () => {
        l({ type: 2, buttonId: null });
      };
  }, [r, l, u]);
  let h = ae((O) => {
    var M;
    if (u) {
      if (s.disclosureState === 1)
        return;
      switch (O.key) {
        case xe.Space:
        case xe.Enter:
          O.preventDefault(), O.stopPropagation(), l({ type: 0 }), (M = s.buttonElement) == null || M.focus();
          break;
      }
    } else
      switch (O.key) {
        case xe.Space:
        case xe.Enter:
          O.preventDefault(), O.stopPropagation(), l({ type: 0 });
          break;
      }
  }), m = ae((O) => {
    switch (O.key) {
      case xe.Space:
        O.preventDefault();
        break;
    }
  }), f = ae((O) => {
    var M;
    Qa(O.currentTarget) || a || (u ? (l({ type: 0 }), (M = s.buttonElement) == null || M.focus()) : l({ type: 0 }));
  }), { isFocusVisible: g, focusProps: _ } = $r({ autoFocus: o }), { isHovered: v, hoverProps: w } = Jr({ isDisabled: a }), { pressed: x, pressProps: b } = _a({ disabled: a }), C = we(() => ({ open: s.disclosureState === 0, hover: v, active: x, disabled: a, focus: g, autofocus: o }), [s, v, x, g, a, o]), E = es(e, s.buttonElement), A = mr(u ? { ref: p, type: E, disabled: a || void 0, autoFocus: o, onKeyDown: h, onClick: f } : { ref: p, id: r, type: E, "aria-expanded": s.disclosureState === 0, "aria-controls": s.panelElement ? s.panelId : void 0, disabled: a || void 0, autoFocus: o, onKeyDown: h, onKeyUp: m, onClick: f }, _, w, b);
  return ze()({ ourProps: A, theirProps: i, slot: C, defaultTag: wP, name: "Disclosure.Button" });
}
let CP = "div", xP = Ir.RenderStrategy | Ir.Static;
function kP(e, t) {
  let n = kt(), { id: r = `headlessui-disclosure-panel-${n}`, transition: a = !1, ...o } = e, [i, s] = z0("Disclosure.Panel"), { close: l } = a5("Disclosure.Panel"), [c, u] = ke(null), d = et(t, ae((v) => {
    hP(() => s({ type: 5, element: v }));
  }), u);
  De(() => (s({ type: 3, panelId: r }), () => {
    s({ type: 3, panelId: null });
  }), [r, s]);
  let p = to(), [h, m] = rs(a, c, p !== null ? (p & Pt.Open) === Pt.Open : i.disclosureState === 0), f = we(() => ({ open: i.disclosureState === 0, close: l }), [i.disclosureState, l]), g = { ref: d, id: r, ...ts(m) }, _ = ze();
  return k.createElement(A0, null, k.createElement(H0.Provider, { value: i.panelId }, _({ ourProps: g, theirProps: o, slot: f, defaultTag: CP, features: xP, visible: h, name: "Disclosure.Panel" })));
}
let EP = Ie(_P), PP = Ie(SP), TP = Ie(kP);
Object.assign(EP, { Button: PP, Panel: TP });
let MP = "div";
function OP(e, t) {
  let n = `headlessui-control-${kt()}`, [r, a] = bo(), [o, i] = Qs(), s = wn(), { disabled: l = s || !1, ...c } = e, u = we(() => ({ disabled: l }), [l]), d = { ref: t, disabled: l || void 0, "aria-disabled": l || void 0 }, p = ze();
  return k.createElement(r6, { value: l }, k.createElement(a, { value: r }, k.createElement(i, { value: o }, k.createElement(FC, { id: n }, p({ ourProps: d, theirProps: { ...c, children: k.createElement(IC, null, typeof c.children == "function" ? c.children(u) : c.children) }, slot: u, defaultTag: MP, name: "Field" })))));
}
let AP = Ie(OP);
function NP(e) {
  let t = typeof e == "string" ? e : void 0, [n, r] = ke(t);
  return [t ?? n, ft((a) => {
    t || a instanceof HTMLElement && r(a.tagName.toLowerCase());
  }, [t])];
}
let e2 = "fieldset";
function LP(e, t) {
  var n;
  let r = wn(), { disabled: a = r || !1, ...o } = e, [i, s] = NP((n = e.as) != null ? n : e2), l = et(t, s), [c, u] = bo(), d = we(() => ({ disabled: a }), [a]), p = i === "fieldset" ? { ref: l, "aria-labelledby": c, disabled: a || void 0 } : { ref: l, role: "group", "aria-labelledby": c, "aria-disabled": a || void 0 }, h = ze();
  return k.createElement(r6, { value: a }, k.createElement(u, null, h({ ourProps: p, theirProps: o, slot: d, defaultTag: e2, name: "Fieldset" })));
}
Ie(LP);
let RP = "input";
function DP(e, t) {
  let n = kt(), r = vo(), a = wn(), { id: o = r || `headlessui-input-${n}`, disabled: i = a || !1, autoFocus: s = !1, invalid: l = !1, ...c } = e, u = wa(), d = Jo(), { isFocused: p, focusProps: h } = $r({ autoFocus: s }), { isHovered: m, hoverProps: f } = Jr({ isDisabled: i }), g = mr({ ref: t, id: o, "aria-labelledby": u, "aria-describedby": d, "aria-invalid": l ? "" : void 0, disabled: i || void 0, autoFocus: s }, h, f), _ = we(() => ({ disabled: i, invalid: l, hover: m, focus: p, autofocus: s }), [i, l, m, p, s]);
  return ze()({ ourProps: g, theirProps: c, slot: _, defaultTag: RP, name: "Input" });
}
Ie(DP);
function IP(e, t) {
  return k.createElement(ru, { as: "div", ref: t, ...e });
}
Ie(IP);
function o5(e, t) {
  let n = _e({ left: 0, top: 0 });
  if (Je(() => {
    if (!t)
      return;
    let a = t.getBoundingClientRect();
    a && (n.current = a);
  }, [e, t]), t == null || !e || t === document.activeElement)
    return !1;
  let r = t.getBoundingClientRect();
  return r.top !== n.current.top || r.left !== n.current.left;
}
let t2 = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function r2(e) {
  var t, n;
  let r = (t = e.innerText) != null ? t : "", a = e.cloneNode(!0);
  if (!(a instanceof HTMLElement))
    return r;
  let o = !1;
  for (let s of a.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    s.remove(), o = !0;
  let i = o ? (n = a.innerText) != null ? n : "" : r;
  return t2.test(i) && (i = i.replace(t2, "")), i;
}
function jP(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string")
    return t.trim();
  let n = e.getAttribute("aria-labelledby");
  if (n) {
    let r = n.split(" ").map((a) => {
      let o = document.getElementById(a);
      if (o) {
        let i = o.getAttribute("aria-label");
        return typeof i == "string" ? i.trim() : r2(o).trim();
      }
      return null;
    }).filter(Boolean);
    if (r.length > 0)
      return r.join(", ");
  }
  return r2(e).trim();
}
function i5(e) {
  let t = _e(""), n = _e("");
  return ae(() => {
    let r = e.current;
    if (!r)
      return "";
    let a = r.innerText;
    if (t.current === a)
      return n.current;
    let o = jP(r).trim().toLowerCase();
    return t.current = a, n.current = o, o;
  });
}
var BP = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(BP || {}), FP = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(FP || {}), zP = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(zP || {}), GP = ((e) => (e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.GoToOption = 2] = "GoToOption", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterOption = 5] = "RegisterOption", e[e.UnregisterOption = 6] = "UnregisterOption", e[e.SetButtonElement = 7] = "SetButtonElement", e[e.SetOptionsElement = 8] = "SetOptionsElement", e))(GP || {});
function Xh(e, t = (n) => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = Ia(t(e.options.slice()), (o) => o.dataRef.current.domRef.current), a = n ? r.indexOf(n) : null;
  return a === -1 && (a = null), { options: r, activeOptionIndex: a };
}
let HP = { 1(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 ? e : { ...e, activeOptionIndex: null, listboxState: 1, __demoMode: !1 };
}, 0(e) {
  if (e.dataRef.current.disabled || e.listboxState === 0)
    return e;
  let t = e.activeOptionIndex, { isSelected: n } = e.dataRef.current, r = e.options.findIndex((a) => n(a.dataRef.current.value));
  return r !== -1 && (t = r), { ...e, listboxState: 0, activeOptionIndex: t, __demoMode: !1 };
}, 2(e, t) {
  var n, r, a, o, i;
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let s = { ...e, searchQuery: "", activationTrigger: (n = t.trigger) != null ? n : 1, __demoMode: !1 };
  if (t.focus === Ge.Nothing)
    return { ...s, activeOptionIndex: null };
  if (t.focus === Ge.Specific)
    return { ...s, activeOptionIndex: e.options.findIndex((u) => u.id === t.id) };
  if (t.focus === Ge.Previous) {
    let u = e.activeOptionIndex;
    if (u !== null) {
      let d = e.options[u].dataRef.current.domRef, p = Ko(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (p !== null) {
        let h = e.options[p].dataRef.current.domRef;
        if (((r = d.current) == null ? void 0 : r.previousElementSibling) === h.current || ((a = h.current) == null ? void 0 : a.previousElementSibling) === null)
          return { ...s, activeOptionIndex: p };
      }
    }
  } else if (t.focus === Ge.Next) {
    let u = e.activeOptionIndex;
    if (u !== null) {
      let d = e.options[u].dataRef.current.domRef, p = Ko(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (p !== null) {
        let h = e.options[p].dataRef.current.domRef;
        if (((o = d.current) == null ? void 0 : o.nextElementSibling) === h.current || ((i = h.current) == null ? void 0 : i.nextElementSibling) === null)
          return { ...s, activeOptionIndex: p };
      }
    }
  }
  let l = Xh(e), c = Ko(t, { resolveItems: () => l.options, resolveActiveIndex: () => l.activeOptionIndex, resolveId: (u) => u.id, resolveDisabled: (u) => u.dataRef.current.disabled });
  return { ...s, ...l, activeOptionIndex: c };
}, 3: (e, t) => {
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let n = e.searchQuery !== "" ? 0 : 1, r = e.searchQuery + t.value.toLowerCase(), a = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + n).concat(e.options.slice(0, e.activeOptionIndex + n)) : e.options).find((i) => {
    var s;
    return !i.dataRef.current.disabled && ((s = i.dataRef.current.textValue) == null ? void 0 : s.startsWith(r));
  }), o = a ? e.options.indexOf(a) : -1;
  return o === -1 || o === e.activeOptionIndex ? { ...e, searchQuery: r } : { ...e, searchQuery: r, activeOptionIndex: o, activationTrigger: 1 };
}, 4(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : { ...e, searchQuery: "" };
}, 5: (e, t) => {
  let n = { id: t.id, dataRef: t.dataRef }, r = Xh(e, (a) => [...a, n]);
  return e.activeOptionIndex === null && e.dataRef.current.isSelected(t.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(n)), { ...e, ...r };
}, 6: (e, t) => {
  let n = Xh(e, (r) => {
    let a = r.findIndex((o) => o.id === t.id);
    return a !== -1 && r.splice(a, 1), r;
  });
  return { ...e, ...n, activationTrigger: 1 };
}, 7: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 8: (e, t) => e.optionsElement === t.element ? e : { ...e, optionsElement: t.element } }, K0 = Qe(null);
K0.displayName = "ListboxActionsContext";
function Yp(e) {
  let t = Ue(K0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Yp), n;
  }
  return t;
}
let Zp = Qe(null);
Zp.displayName = "ListboxDataContext";
function mu(e) {
  let t = Ue(Zp);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, mu), n;
  }
  return t;
}
function KP(e, t) {
  return ht(t.type, HP, e, t);
}
let UP = rr;
function $P(e, t) {
  var n;
  let r = wn(), { value: a, defaultValue: o, form: i, name: s, onChange: l, by: c, invalid: u = !1, disabled: d = r || !1, horizontal: p = !1, multiple: h = !1, __demoMode: m = !1, ...f } = e;
  const g = p ? "horizontal" : "vertical";
  let _ = et(t), v = eu(o), [w = h ? [] : void 0, x] = Qc(a, l, v), [b, C] = go(KP, { dataRef: Ri(), listboxState: m ? 0 : 1, options: [], searchQuery: "", activeOptionIndex: null, activationTrigger: 1, optionsVisible: !1, buttonElement: null, optionsElement: null, __demoMode: m }), E = _e({ static: !1, hold: !1 }), A = _e(/* @__PURE__ */ new Map()), O = x0(c), M = ft(($) => ht(I.mode, { 1: () => w.some((Te) => O(Te, $)), 0: () => O(w, $) }), [w]), I = we(() => ({ ...b, value: w, disabled: d, invalid: u, mode: h ? 1 : 0, orientation: g, compare: O, isSelected: M, optionsPropsRef: E, listRef: A }), [w, d, u, h, b, A]);
  Je(() => {
    b.dataRef.current = I;
  }, [I]);
  let D = I.listboxState === 0;
  su(D, [I.buttonElement, I.optionsElement], ($, Te) => {
    var J;
    C({ type: 1 }), iu(Te, ou.Loose) || ($.preventDefault(), (J = I.buttonElement) == null || J.focus());
  });
  let K = we(() => ({ open: I.listboxState === 0, disabled: d, invalid: u, value: w }), [I, d, w, u]), G = ae(($) => {
    let Te = I.options.find((J) => J.id === $);
    Te && T(Te.dataRef.current.value);
  }), V = ae(() => {
    if (I.activeOptionIndex !== null) {
      let { dataRef: $, id: Te } = I.options[I.activeOptionIndex];
      T($.current.value), C({ type: 2, focus: Ge.Specific, id: Te });
    }
  }), ee = ae(() => C({ type: 0 })), U = ae(() => C({ type: 1 })), H = Yn(), W = ae(($, Te, J) => {
    H.dispose(), H.microTask(() => $ === Ge.Specific ? C({ type: 2, focus: Ge.Specific, id: Te, trigger: J }) : C({ type: 2, focus: $, trigger: J }));
  }), L = ae(($, Te) => (C({ type: 5, id: $, dataRef: Te }), () => C({ type: 6, id: $ }))), T = ae(($) => ht(I.mode, { 0() {
    return x == null ? void 0 : x($);
  }, 1() {
    let Te = I.value.slice(), J = Te.findIndex((te) => O(te, $));
    return J === -1 ? Te.push($) : Te.splice(J, 1), x == null ? void 0 : x(Te);
  } })), B = ae(($) => C({ type: 3, value: $ })), N = ae(() => C({ type: 4 })), Y = ae(($) => {
    C({ type: 7, element: $ });
  }), Q = ae(($) => {
    C({ type: 8, element: $ });
  }), F = we(() => ({ onChange: T, registerOption: L, goToOption: W, closeListbox: U, openListbox: ee, selectActiveOption: V, selectOption: G, search: B, clearSearch: N, setButtonElement: Y, setOptionsElement: Q }), []), [re, q] = bo({ inherit: !0 }), he = { ref: _ }, me = ft(() => {
    if (v !== void 0)
      return x == null ? void 0 : x(v);
  }, [x, v]), Le = ze();
  return k.createElement(q, { value: re, props: { htmlFor: (n = I.buttonElement) == null ? void 0 : n.id }, slot: { open: I.listboxState === 0, disabled: d } }, k.createElement(Gp, null, k.createElement(K0.Provider, { value: F }, k.createElement(Zp.Provider, { value: I }, k.createElement(al, { value: ht(I.listboxState, { 0: Pt.Open, 1: Pt.Closed }) }, s != null && w != null && k.createElement(tu, { disabled: d, data: { [s]: w }, form: i, onReset: me }), Le({ ourProps: he, theirProps: f, slot: K, defaultTag: UP, name: "Listbox" }))))));
}
let VP = "button";
function WP(e, t) {
  var n;
  let r = mu("Listbox.Button"), a = Yp("Listbox.Button"), o = kt(), i = vo(), { id: s = i || `headlessui-listbox-button-${o}`, disabled: l = r.disabled || !1, autoFocus: c = !1, ...u } = e, d = et(t, Bp(), a.setButtonElement), p = j6(), h = ae((I) => {
    switch (I.key) {
      case xe.Enter:
        Tp(I.currentTarget);
        break;
      case xe.Space:
      case xe.ArrowDown:
        I.preventDefault(), Ar(() => a.openListbox()), r.value || a.goToOption(Ge.First);
        break;
      case xe.ArrowUp:
        I.preventDefault(), Ar(() => a.openListbox()), r.value || a.goToOption(Ge.Last);
        break;
    }
  }), m = ae((I) => {
    switch (I.key) {
      case xe.Space:
        I.preventDefault();
        break;
    }
  }), f = ae((I) => {
    var D;
    if (Qa(I.currentTarget))
      return I.preventDefault();
    r.listboxState === 0 ? (Ar(() => a.closeListbox()), (D = r.buttonElement) == null || D.focus({ preventScroll: !0 })) : (I.preventDefault(), a.openListbox());
  }), g = ae((I) => I.preventDefault()), _ = wa([s]), v = Jo(), { isFocusVisible: w, focusProps: x } = $r({ autoFocus: c }), { isHovered: b, hoverProps: C } = Jr({ isDisabled: l }), { pressed: E, pressProps: A } = _a({ disabled: l }), O = we(() => ({ open: r.listboxState === 0, active: E || r.listboxState === 0, disabled: l, invalid: r.invalid, value: r.value, hover: b, focus: w, autofocus: c }), [r.listboxState, r.value, l, b, w, E, r.invalid, c]), M = mr(p(), { ref: d, id: s, type: es(e, r.buttonElement), "aria-haspopup": "listbox", "aria-controls": (n = r.optionsElement) == null ? void 0 : n.id, "aria-expanded": r.listboxState === 0, "aria-labelledby": _, "aria-describedby": v, disabled: l || void 0, autoFocus: c, onKeyDown: h, onKeyUp: m, onKeyPress: g, onClick: f }, x, C, A);
  return ze()({ ourProps: M, theirProps: u, slot: O, defaultTag: VP, name: "Listbox.Button" });
}
let s5 = Qe(!1), YP = "div", ZP = Ir.RenderStrategy | Ir.Static;
function qP(e, t) {
  var n, r;
  let a = kt(), { id: o = `headlessui-listbox-options-${a}`, anchor: i, portal: s = !1, modal: l = !0, transition: c = !1, ...u } = e, d = jp(i), [p, h] = ke(null);
  d && (s = !0);
  let m = mu("Listbox.Options"), f = Yp("Listbox.Options"), g = Zn(m.optionsElement), _ = to(), [v, w] = rs(c, p, _ !== null ? (_ & Pt.Open) === Pt.Open : m.listboxState === 0);
  nu(v, m.buttonElement, f.closeListbox);
  let x = m.__demoMode ? !1 : l && m.listboxState === 0;
  lu(x, g);
  let b = m.__demoMode ? !1 : l && m.listboxState === 0;
  Ap(b, { allowed: ft(() => [m.buttonElement, m.optionsElement], [m.buttonElement, m.optionsElement]) });
  let C = m.listboxState !== 0, E = o5(C, m.buttonElement) ? !1 : v, A = v && m.listboxState === 1, O = Dd(A, m.value), M = ae((N) => m.compare(O, N)), I = we(() => {
    var N;
    if (d == null || !((N = d == null ? void 0 : d.to) != null && N.includes("selection")))
      return null;
    let Y = m.options.findIndex((Q) => M(Q.dataRef.current.value));
    return Y === -1 && (Y = 0), Y;
  }, [d, m.options]), D = (() => {
    if (d == null)
      return;
    if (I === null)
      return { ...d, inner: void 0 };
    let N = Array.from(m.listRef.current.values());
    return { ...d, inner: { listRef: { current: N }, index: I } };
  })(), [K, G] = zp(D), V = Fp(), ee = et(t, d ? K : null, f.setOptionsElement, h), U = Yn();
  De(() => {
    var N;
    let Y = m.optionsElement;
    Y && m.listboxState === 0 && Y !== ((N = Wn(Y)) == null ? void 0 : N.activeElement) && (Y == null || Y.focus({ preventScroll: !0 }));
  }, [m.listboxState, m.optionsElement]);
  let H = ae((N) => {
    var Y, Q;
    switch (U.dispose(), N.key) {
      case xe.Space:
        if (m.searchQuery !== "")
          return N.preventDefault(), N.stopPropagation(), f.search(N.key);
      case xe.Enter:
        if (N.preventDefault(), N.stopPropagation(), m.activeOptionIndex !== null) {
          let { dataRef: F } = m.options[m.activeOptionIndex];
          f.onChange(F.current.value);
        }
        m.mode === 0 && (Ar(() => f.closeListbox()), (Y = m.buttonElement) == null || Y.focus({ preventScroll: !0 }));
        break;
      case ht(m.orientation, { vertical: xe.ArrowDown, horizontal: xe.ArrowRight }):
        return N.preventDefault(), N.stopPropagation(), f.goToOption(Ge.Next);
      case ht(m.orientation, { vertical: xe.ArrowUp, horizontal: xe.ArrowLeft }):
        return N.preventDefault(), N.stopPropagation(), f.goToOption(Ge.Previous);
      case xe.Home:
      case xe.PageUp:
        return N.preventDefault(), N.stopPropagation(), f.goToOption(Ge.First);
      case xe.End:
      case xe.PageDown:
        return N.preventDefault(), N.stopPropagation(), f.goToOption(Ge.Last);
      case xe.Escape:
        N.preventDefault(), N.stopPropagation(), Ar(() => f.closeListbox()), (Q = m.buttonElement) == null || Q.focus({ preventScroll: !0 });
        return;
      case xe.Tab:
        N.preventDefault(), N.stopPropagation(), Ar(() => f.closeListbox()), g6(m.buttonElement, N.shiftKey ? Ct.Previous : Ct.Next);
        break;
      default:
        N.key.length === 1 && (f.search(N.key), U.setTimeout(() => f.clearSearch(), 350));
        break;
    }
  }), W = (n = m.buttonElement) == null ? void 0 : n.id, L = we(() => ({ open: m.listboxState === 0 }), [m.listboxState]), T = mr(d ? V() : {}, { id: o, ref: ee, "aria-activedescendant": m.activeOptionIndex === null || (r = m.options[m.activeOptionIndex]) == null ? void 0 : r.id, "aria-multiselectable": m.mode === 1 ? !0 : void 0, "aria-labelledby": W, "aria-orientation": m.orientation, onKeyDown: H, role: "listbox", tabIndex: m.listboxState === 0 ? 0 : void 0, style: { ...u.style, ...G, "--button-width": xc(m.buttonElement, !0).width }, ...ts(w) }), B = ze();
  return k.createElement(pu, { enabled: s ? e.static || v : !1 }, k.createElement(Zp.Provider, { value: m.mode === 1 ? m : { ...m, isSelected: M } }, B({ ourProps: T, theirProps: u, slot: L, defaultTag: YP, features: ZP, visible: E, name: "Listbox.Options" })));
}
let JP = "div";
function XP(e, t) {
  let n = kt(), { id: r = `headlessui-listbox-option-${n}`, disabled: a = !1, value: o, ...i } = e, s = Ue(s5) === !0, l = mu("Listbox.Option"), c = Yp("Listbox.Option"), u = l.activeOptionIndex !== null ? l.options[l.activeOptionIndex].id === r : !1, d = l.isSelected(o), p = _e(null), h = i5(p), m = Kr({ disabled: a, value: o, domRef: p, get textValue() {
    return h();
  } }), f = et(t, p, (O) => {
    O ? l.listRef.current.set(r, O) : l.listRef.current.delete(r);
  });
  Je(() => {
    if (!l.__demoMode && l.listboxState === 0 && u && l.activationTrigger !== 0)
      return Rn().requestAnimationFrame(() => {
        var O, M;
        (M = (O = p.current) == null ? void 0 : O.scrollIntoView) == null || M.call(O, { block: "nearest" });
      });
  }, [p, u, l.__demoMode, l.listboxState, l.activationTrigger, l.activeOptionIndex]), Je(() => {
    if (!s)
      return c.registerOption(r, m);
  }, [m, r, s]);
  let g = ae((O) => {
    var M;
    if (a)
      return O.preventDefault();
    c.onChange(o), l.mode === 0 && (Ar(() => c.closeListbox()), (M = l.buttonElement) == null || M.focus({ preventScroll: !0 }));
  }), _ = ae(() => {
    if (a)
      return c.goToOption(Ge.Nothing);
    c.goToOption(Ge.Specific, r);
  }), v = k0(), w = ae((O) => {
    v.update(O), !a && (u || c.goToOption(Ge.Specific, r, 0));
  }), x = ae((O) => {
    v.wasMoved(O) && (a || u || c.goToOption(Ge.Specific, r, 0));
  }), b = ae((O) => {
    v.wasMoved(O) && (a || u && c.goToOption(Ge.Nothing));
  }), C = we(() => ({ active: u, focus: u, selected: d, disabled: a, selectedOption: d && s }), [u, d, a, s]), E = s ? {} : { id: r, ref: f, role: "option", tabIndex: a === !0 ? void 0 : -1, "aria-disabled": a === !0 ? !0 : void 0, "aria-selected": d, disabled: void 0, onClick: g, onFocus: _, onPointerEnter: w, onMouseEnter: w, onPointerMove: x, onMouseMove: x, onPointerLeave: b, onMouseLeave: b }, A = ze();
  return !d && s ? null : A({ ourProps: E, theirProps: i, slot: C, defaultTag: JP, name: "Listbox.Option" });
}
let QP = rr;
function eT(e, t) {
  let { options: n, placeholder: r, ...a } = e, o = { ref: et(t) }, i = mu("ListboxSelectedOption"), s = we(() => ({}), []), l = i.value === void 0 || i.value === null || i.mode === 1 && Array.isArray(i.value) && i.value.length === 0, c = ze();
  return k.createElement(s5.Provider, { value: !0 }, c({ ourProps: o, theirProps: { ...a, children: k.createElement(k.Fragment, null, r && l ? r : n) }, slot: s, defaultTag: QP, name: "ListboxSelectedOption" }));
}
let tT = Ie($P), l5 = Ie(WP), rT = ru, c5 = Ie(qP), nT = Ie(XP), aT = Ie(eT), oT = Object.assign(tT, { Button: l5, Label: rT, Options: c5, Option: nT, SelectedOption: aT });
var iT = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(iT || {}), sT = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(sT || {}), lT = ((e) => (e[e.OpenMenu = 0] = "OpenMenu", e[e.CloseMenu = 1] = "CloseMenu", e[e.GoToItem = 2] = "GoToItem", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterItem = 5] = "RegisterItem", e[e.UnregisterItem = 6] = "UnregisterItem", e[e.SetButtonElement = 7] = "SetButtonElement", e[e.SetItemsElement = 8] = "SetItemsElement", e))(lT || {});
function Qh(e, t = (n) => n) {
  let n = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, r = Ia(t(e.items.slice()), (o) => o.dataRef.current.domRef.current), a = n ? r.indexOf(n) : null;
  return a === -1 && (a = null), { items: r, activeItemIndex: a };
}
let cT = { 1(e) {
  return e.menuState === 1 ? e : { ...e, activeItemIndex: null, menuState: 1 };
}, 0(e) {
  return e.menuState === 0 ? e : { ...e, __demoMode: !1, menuState: 0 };
}, 2: (e, t) => {
  var n, r, a, o, i;
  if (e.menuState === 1)
    return e;
  let s = { ...e, searchQuery: "", activationTrigger: (n = t.trigger) != null ? n : 1, __demoMode: !1 };
  if (t.focus === Ge.Nothing)
    return { ...s, activeItemIndex: null };
  if (t.focus === Ge.Specific)
    return { ...s, activeItemIndex: e.items.findIndex((u) => u.id === t.id) };
  if (t.focus === Ge.Previous) {
    let u = e.activeItemIndex;
    if (u !== null) {
      let d = e.items[u].dataRef.current.domRef, p = Ko(t, { resolveItems: () => e.items, resolveActiveIndex: () => e.activeItemIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (p !== null) {
        let h = e.items[p].dataRef.current.domRef;
        if (((r = d.current) == null ? void 0 : r.previousElementSibling) === h.current || ((a = h.current) == null ? void 0 : a.previousElementSibling) === null)
          return { ...s, activeItemIndex: p };
      }
    }
  } else if (t.focus === Ge.Next) {
    let u = e.activeItemIndex;
    if (u !== null) {
      let d = e.items[u].dataRef.current.domRef, p = Ko(t, { resolveItems: () => e.items, resolveActiveIndex: () => e.activeItemIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (p !== null) {
        let h = e.items[p].dataRef.current.domRef;
        if (((o = d.current) == null ? void 0 : o.nextElementSibling) === h.current || ((i = h.current) == null ? void 0 : i.nextElementSibling) === null)
          return { ...s, activeItemIndex: p };
      }
    }
  }
  let l = Qh(e), c = Ko(t, { resolveItems: () => l.items, resolveActiveIndex: () => l.activeItemIndex, resolveId: (u) => u.id, resolveDisabled: (u) => u.dataRef.current.disabled });
  return { ...s, ...l, activeItemIndex: c };
}, 3: (e, t) => {
  let n = e.searchQuery !== "" ? 0 : 1, r = e.searchQuery + t.value.toLowerCase(), a = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + n).concat(e.items.slice(0, e.activeItemIndex + n)) : e.items).find((i) => {
    var s;
    return ((s = i.dataRef.current.textValue) == null ? void 0 : s.startsWith(r)) && !i.dataRef.current.disabled;
  }), o = a ? e.items.indexOf(a) : -1;
  return o === -1 || o === e.activeItemIndex ? { ...e, searchQuery: r } : { ...e, searchQuery: r, activeItemIndex: o, activationTrigger: 1 };
}, 4(e) {
  return e.searchQuery === "" ? e : { ...e, searchQuery: "", searchActiveItemIndex: null };
}, 5: (e, t) => {
  let n = Qh(e, (r) => [...r, { id: t.id, dataRef: t.dataRef }]);
  return { ...e, ...n };
}, 6: (e, t) => {
  let n = Qh(e, (r) => {
    let a = r.findIndex((o) => o.id === t.id);
    return a !== -1 && r.splice(a, 1), r;
  });
  return { ...e, ...n, activationTrigger: 1 };
}, 7: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 8: (e, t) => e.itemsElement === t.element ? e : { ...e, itemsElement: t.element } }, U0 = Qe(null);
U0.displayName = "MenuContext";
function qp(e) {
  let t = Ue(U0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, qp), n;
  }
  return t;
}
function uT(e, t) {
  return ht(t.type, cT, e, t);
}
let dT = rr;
function pT(e, t) {
  let { __demoMode: n = !1, ...r } = e, a = go(uT, { __demoMode: n, menuState: n ? 0 : 1, buttonElement: null, itemsElement: null, items: [], searchQuery: "", activeItemIndex: null, activationTrigger: 1 }), [{ menuState: o, itemsElement: i, buttonElement: s }, l] = a, c = et(t);
  su(o === 0, [s, i], (m, f) => {
    l({ type: 1 }), iu(f, ou.Loose) || (m.preventDefault(), s == null || s.focus());
  });
  let u = ae(() => {
    l({ type: 1 });
  }), d = we(() => ({ open: o === 0, close: u }), [o, u]), p = { ref: c }, h = ze();
  return k.createElement(Gp, null, k.createElement(U0.Provider, { value: a }, k.createElement(al, { value: ht(o, { 0: Pt.Open, 1: Pt.Closed }) }, h({ ourProps: p, theirProps: r, slot: d, defaultTag: dT, name: "Menu" }))));
}
let hT = "button";
function mT(e, t) {
  var n;
  let r = kt(), { id: a = `headlessui-menu-button-${r}`, disabled: o = !1, autoFocus: i = !1, ...s } = e, [l, c] = qp("Menu.Button"), u = j6(), d = et(t, Bp(), ae((E) => c({ type: 7, element: E }))), p = ae((E) => {
    switch (E.key) {
      case xe.Space:
      case xe.Enter:
      case xe.ArrowDown:
        E.preventDefault(), E.stopPropagation(), Ar(() => c({ type: 0 })), c({ type: 2, focus: Ge.First });
        break;
      case xe.ArrowUp:
        E.preventDefault(), E.stopPropagation(), Ar(() => c({ type: 0 })), c({ type: 2, focus: Ge.Last });
        break;
    }
  }), h = ae((E) => {
    switch (E.key) {
      case xe.Space:
        E.preventDefault();
        break;
    }
  }), m = ae((E) => {
    var A;
    if (Qa(E.currentTarget))
      return E.preventDefault();
    o || (l.menuState === 0 ? (Ar(() => c({ type: 1 })), (A = l.buttonElement) == null || A.focus({ preventScroll: !0 })) : (E.preventDefault(), c({ type: 0 })));
  }), { isFocusVisible: f, focusProps: g } = $r({ autoFocus: i }), { isHovered: _, hoverProps: v } = Jr({ isDisabled: o }), { pressed: w, pressProps: x } = _a({ disabled: o }), b = we(() => ({ open: l.menuState === 0, active: w || l.menuState === 0, disabled: o, hover: _, focus: f, autofocus: i }), [l, _, f, w, o, i]), C = mr(u(), { ref: d, id: a, type: es(e, l.buttonElement), "aria-haspopup": "menu", "aria-controls": (n = l.itemsElement) == null ? void 0 : n.id, "aria-expanded": l.menuState === 0, disabled: o || void 0, autoFocus: i, onKeyDown: p, onKeyUp: h, onClick: m }, g, v, x);
  return ze()({ ourProps: C, theirProps: s, slot: b, defaultTag: hT, name: "Menu.Button" });
}
let fT = "div", gT = Ir.RenderStrategy | Ir.Static;
function yT(e, t) {
  var n, r;
  let a = kt(), { id: o = `headlessui-menu-items-${a}`, anchor: i, portal: s = !1, modal: l = !0, transition: c = !1, ...u } = e, d = jp(i), [p, h] = qp("Menu.Items"), [m, f] = zp(d), g = Fp(), [_, v] = ke(null), w = et(t, d ? m : null, ae((H) => h({ type: 8, element: H })), v), x = Zn(p.itemsElement);
  d && (s = !0);
  let b = to(), [C, E] = rs(c, _, b !== null ? (b & Pt.Open) === Pt.Open : p.menuState === 0);
  nu(C, p.buttonElement, () => {
    h({ type: 1 });
  });
  let A = p.__demoMode ? !1 : l && p.menuState === 0;
  lu(A, x);
  let O = p.__demoMode ? !1 : l && p.menuState === 0;
  Ap(O, { allowed: ft(() => [p.buttonElement, p.itemsElement], [p.buttonElement, p.itemsElement]) });
  let M = p.menuState !== 0, I = o5(M, p.buttonElement) ? !1 : C;
  De(() => {
    let H = p.itemsElement;
    H && p.menuState === 0 && H !== (x == null ? void 0 : x.activeElement) && H.focus({ preventScroll: !0 });
  }, [p.menuState, p.itemsElement, x]), w6(p.menuState === 0, { container: p.itemsElement, accept(H) {
    return H.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : H.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(H) {
    H.setAttribute("role", "none");
  } });
  let D = Yn(), K = ae((H) => {
    var W, L, T;
    switch (D.dispose(), H.key) {
      case xe.Space:
        if (p.searchQuery !== "")
          return H.preventDefault(), H.stopPropagation(), h({ type: 3, value: H.key });
      case xe.Enter:
        if (H.preventDefault(), H.stopPropagation(), h({ type: 1 }), p.activeItemIndex !== null) {
          let { dataRef: B } = p.items[p.activeItemIndex];
          (L = (W = B.current) == null ? void 0 : W.domRef.current) == null || L.click();
        }
        f6(p.buttonElement);
        break;
      case xe.ArrowDown:
        return H.preventDefault(), H.stopPropagation(), h({ type: 2, focus: Ge.Next });
      case xe.ArrowUp:
        return H.preventDefault(), H.stopPropagation(), h({ type: 2, focus: Ge.Previous });
      case xe.Home:
      case xe.PageUp:
        return H.preventDefault(), H.stopPropagation(), h({ type: 2, focus: Ge.First });
      case xe.End:
      case xe.PageDown:
        return H.preventDefault(), H.stopPropagation(), h({ type: 2, focus: Ge.Last });
      case xe.Escape:
        H.preventDefault(), H.stopPropagation(), Ar(() => h({ type: 1 })), (T = p.buttonElement) == null || T.focus({ preventScroll: !0 });
        break;
      case xe.Tab:
        H.preventDefault(), H.stopPropagation(), Ar(() => h({ type: 1 })), g6(p.buttonElement, H.shiftKey ? Ct.Previous : Ct.Next);
        break;
      default:
        H.key.length === 1 && (h({ type: 3, value: H.key }), D.setTimeout(() => h({ type: 4 }), 350));
        break;
    }
  }), G = ae((H) => {
    switch (H.key) {
      case xe.Space:
        H.preventDefault();
        break;
    }
  }), V = we(() => ({ open: p.menuState === 0 }), [p.menuState]), ee = mr(d ? g() : {}, { "aria-activedescendant": p.activeItemIndex === null || (n = p.items[p.activeItemIndex]) == null ? void 0 : n.id, "aria-labelledby": (r = p.buttonElement) == null ? void 0 : r.id, id: o, onKeyDown: K, onKeyUp: G, role: "menu", tabIndex: p.menuState === 0 ? 0 : void 0, ref: w, style: { ...u.style, ...f, "--button-width": xc(p.buttonElement, !0).width }, ...ts(E) }), U = ze();
  return k.createElement(pu, { enabled: s ? e.static || C : !1 }, U({ ourProps: ee, theirProps: u, slot: V, defaultTag: fT, features: gT, visible: I, name: "Menu.Items" }));
}
let vT = rr;
function bT(e, t) {
  let n = kt(), { id: r = `headlessui-menu-item-${n}`, disabled: a = !1, ...o } = e, [i, s] = qp("Menu.Item"), l = i.activeItemIndex !== null ? i.items[i.activeItemIndex].id === r : !1, c = _e(null), u = et(t, c);
  Je(() => {
    if (!i.__demoMode && i.menuState === 0 && l && i.activationTrigger !== 0)
      return Rn().requestAnimationFrame(() => {
        var I, D;
        (D = (I = c.current) == null ? void 0 : I.scrollIntoView) == null || D.call(I, { block: "nearest" });
      });
  }, [i.__demoMode, c, l, i.menuState, i.activationTrigger, i.activeItemIndex]);
  let d = i5(c), p = _e({ disabled: a, domRef: c, get textValue() {
    return d();
  } });
  Je(() => {
    p.current.disabled = a;
  }, [p, a]), Je(() => (s({ type: 5, id: r, dataRef: p }), () => s({ type: 6, id: r })), [p, r]);
  let h = ae(() => {
    s({ type: 1 });
  }), m = ae((I) => {
    if (a)
      return I.preventDefault();
    s({ type: 1 }), f6(i.buttonElement);
  }), f = ae(() => {
    if (a)
      return s({ type: 2, focus: Ge.Nothing });
    s({ type: 2, focus: Ge.Specific, id: r });
  }), g = k0(), _ = ae((I) => {
    g.update(I), !a && (l || s({ type: 2, focus: Ge.Specific, id: r, trigger: 0 }));
  }), v = ae((I) => {
    g.wasMoved(I) && (a || l || s({ type: 2, focus: Ge.Specific, id: r, trigger: 0 }));
  }), w = ae((I) => {
    g.wasMoved(I) && (a || l && s({ type: 2, focus: Ge.Nothing }));
  }), [x, b] = bo(), [C, E] = Qs(), A = we(() => ({ active: l, focus: l, disabled: a, close: h }), [l, a, h]), O = { id: r, ref: u, role: "menuitem", tabIndex: a === !0 ? void 0 : -1, "aria-disabled": a === !0 ? !0 : void 0, "aria-labelledby": x, "aria-describedby": C, disabled: void 0, onClick: m, onFocus: f, onPointerEnter: _, onMouseEnter: _, onPointerMove: v, onMouseMove: v, onPointerLeave: w, onMouseLeave: w }, M = ze();
  return k.createElement(b, null, k.createElement(E, null, M({ ourProps: O, theirProps: o, slot: A, defaultTag: vT, name: "Menu.Item" })));
}
let _T = "div";
function wT(e, t) {
  let [n, r] = bo(), a = e, o = { ref: t, "aria-labelledby": n, role: "group" }, i = ze();
  return k.createElement(r, null, i({ ourProps: o, theirProps: a, slot: {}, defaultTag: _T, name: "Menu.Section" }));
}
let ST = "header";
function CT(e, t) {
  let n = kt(), { id: r = `headlessui-menu-heading-${n}`, ...a } = e, o = S0();
  Je(() => o.register(r), [r, o.register]);
  let i = { id: r, ref: t, role: "presentation", ...o.props };
  return ze()({ ourProps: i, theirProps: a, slot: {}, defaultTag: ST, name: "Menu.Heading" });
}
let xT = "div";
function kT(e, t) {
  let n = e, r = { ref: t, role: "separator" };
  return ze()({ ourProps: r, theirProps: n, slot: {}, defaultTag: xT, name: "Menu.Separator" });
}
let ET = Ie(pT), PT = Ie(mT), TT = Ie(yT), MT = Ie(bT), OT = Ie(wT), AT = Ie(CT), NT = Ie(kT);
Object.assign(ET, { Button: PT, Items: TT, Item: MT, Section: OT, Heading: AT, Separator: NT });
var LT = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(LT || {}), RT = ((e) => (e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))(RT || {});
let DT = { 0: (e) => ({ ...e, popoverState: ht(e.popoverState, { 0: 1, 1: 0 }), __demoMode: !1 }), 1(e) {
  return e.popoverState === 1 ? e : { ...e, popoverState: 1, __demoMode: !1 };
}, 2(e, t) {
  return e.button === t.button ? e : { ...e, button: t.button };
}, 3(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 4(e, t) {
  return e.panel === t.panel ? e : { ...e, panel: t.panel };
}, 5(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
} }, $0 = Qe(null);
$0.displayName = "PopoverContext";
function Jp(e) {
  let t = Ue($0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Jp), n;
  }
  return t;
}
let Xp = Qe(null);
Xp.displayName = "PopoverAPIContext";
function V0(e) {
  let t = Ue(Xp);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, V0), n;
  }
  return t;
}
let W0 = Qe(null);
W0.displayName = "PopoverGroupContext";
function u5() {
  return Ue(W0);
}
let Qp = Qe(null);
Qp.displayName = "PopoverPanelContext";
function IT() {
  return Ue(Qp);
}
function jT(e, t) {
  return ht(t.type, DT, e, t);
}
let BT = "div";
function FT(e, t) {
  var n;
  let { __demoMode: r = !1, ...a } = e, o = _e(null), i = et(t, _0((W) => {
    o.current = W;
  })), s = _e([]), l = go(jT, { __demoMode: r, popoverState: r ? 0 : 1, buttons: s, button: null, buttonId: null, panel: null, panelId: null, beforePanelSentinel: Ri(), afterPanelSentinel: Ri(), afterButtonSentinel: Ri() }), [{ popoverState: c, button: u, buttonId: d, panel: p, panelId: h, beforePanelSentinel: m, afterPanelSentinel: f, afterButtonSentinel: g }, _] = l, v = Zn((n = o.current) != null ? n : u), w = we(() => {
    if (!u || !p)
      return !1;
    for (let Q of document.querySelectorAll("body > *"))
      if (Number(Q == null ? void 0 : Q.contains(u)) ^ Number(Q == null ? void 0 : Q.contains(p)))
        return !0;
    let W = au(), L = W.indexOf(u), T = (L + W.length - 1) % W.length, B = (L + 1) % W.length, N = W[T], Y = W[B];
    return !p.contains(N) && !p.contains(Y);
  }, [u, p]), x = Kr(d), b = Kr(h), C = we(() => ({ buttonId: x, panelId: b, close: () => _({ type: 1 }) }), [x, b, _]), E = u5(), A = E == null ? void 0 : E.registerPopover, O = ae(() => {
    var W;
    return (W = E == null ? void 0 : E.isFocusWithinPopoverGroup()) != null ? W : (v == null ? void 0 : v.activeElement) && ((u == null ? void 0 : u.contains(v.activeElement)) || (p == null ? void 0 : p.contains(v.activeElement)));
  });
  De(() => A == null ? void 0 : A(C), [A, C]);
  let [M, I] = K6(), D = D0(u), K = Z6({ mainTreeNode: D, portals: M, defaultContainers: [u, p] });
  Np(v == null ? void 0 : v.defaultView, "focus", (W) => {
    var L, T, B, N, Y, Q;
    W.target !== window && W.target instanceof HTMLElement && c === 0 && (O() || u && p && (K.contains(W.target) || (T = (L = m.current) == null ? void 0 : L.contains) != null && T.call(L, W.target) || (N = (B = f.current) == null ? void 0 : B.contains) != null && N.call(B, W.target) || (Q = (Y = g.current) == null ? void 0 : Y.contains) != null && Q.call(Y, W.target) || _({ type: 1 })));
  }, !0), su(c === 0, K.resolveContainers, (W, L) => {
    _({ type: 1 }), iu(L, ou.Loose) || (W.preventDefault(), u == null || u.focus());
  });
  let G = ae((W) => {
    _({ type: 1 });
    let L = W ? W instanceof HTMLElement ? W : "current" in W && W.current instanceof HTMLElement ? W.current : u : u;
    L == null || L.focus();
  }), V = we(() => ({ close: G, isPortalled: w }), [G, w]), ee = we(() => ({ open: c === 0, close: G }), [c, G]), U = { ref: i }, H = ze();
  return k.createElement(Id, { node: D }, k.createElement(Gp, null, k.createElement(Qp.Provider, { value: null }, k.createElement($0.Provider, { value: l }, k.createElement(Xp.Provider, { value: V }, k.createElement(C0, { value: G }, k.createElement(al, { value: ht(c, { 0: Pt.Open, 1: Pt.Closed }) }, k.createElement(I, null, H({ ourProps: U, theirProps: a, slot: ee, defaultTag: BT, name: "Popover" })))))))));
}
let zT = "button";
function GT(e, t) {
  let n = kt(), { id: r = `headlessui-popover-button-${n}`, disabled: a = !1, autoFocus: o = !1, ...i } = e, [s, l] = Jp("Popover.Button"), { isPortalled: c } = V0("Popover.Button"), u = _e(null), d = `headlessui-focus-sentinel-${kt()}`, p = u5(), h = p == null ? void 0 : p.closeOthers, m = IT() !== null;
  De(() => {
    if (!m)
      return l({ type: 3, buttonId: r }), () => {
        l({ type: 3, buttonId: null });
      };
  }, [m, r, l]);
  let [f] = ke(() => Symbol()), g = et(u, t, Bp(), ae((L) => {
    if (!m) {
      if (L)
        s.buttons.current.push(f);
      else {
        let T = s.buttons.current.indexOf(f);
        T !== -1 && s.buttons.current.splice(T, 1);
      }
      s.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), L && l({ type: 2, button: L });
    }
  })), _ = et(u, t), v = Zn(u), w = ae((L) => {
    var T, B, N;
    if (m) {
      if (s.popoverState === 1)
        return;
      switch (L.key) {
        case xe.Space:
        case xe.Enter:
          L.preventDefault(), (B = (T = L.target).click) == null || B.call(T), l({ type: 1 }), (N = s.button) == null || N.focus();
          break;
      }
    } else
      switch (L.key) {
        case xe.Space:
        case xe.Enter:
          L.preventDefault(), L.stopPropagation(), s.popoverState === 1 && (h == null || h(s.buttonId)), l({ type: 0 });
          break;
        case xe.Escape:
          if (s.popoverState !== 0)
            return h == null ? void 0 : h(s.buttonId);
          if (!u.current || v != null && v.activeElement && !u.current.contains(v.activeElement))
            return;
          L.preventDefault(), L.stopPropagation(), l({ type: 1 });
          break;
      }
  }), x = ae((L) => {
    m || L.key === xe.Space && L.preventDefault();
  }), b = ae((L) => {
    var T, B;
    Qa(L.currentTarget) || a || (m ? (l({ type: 1 }), (T = s.button) == null || T.focus()) : (L.preventDefault(), L.stopPropagation(), s.popoverState === 1 && (h == null || h(s.buttonId)), l({ type: 0 }), (B = s.button) == null || B.focus()));
  }), C = ae((L) => {
    L.preventDefault(), L.stopPropagation();
  }), { isFocusVisible: E, focusProps: A } = $r({ autoFocus: o }), { isHovered: O, hoverProps: M } = Jr({ isDisabled: a }), { pressed: I, pressProps: D } = _a({ disabled: a }), K = s.popoverState === 0, G = we(() => ({ open: K, active: I || K, disabled: a, hover: O, focus: E, autofocus: o }), [K, O, E, I, a, o]), V = es(e, s.button), ee = mr(m ? { ref: _, type: V, onKeyDown: w, onClick: b, disabled: a || void 0, autoFocus: o } : { ref: g, id: s.buttonId, type: V, "aria-expanded": s.popoverState === 0, "aria-controls": s.panel ? s.panelId : void 0, disabled: a || void 0, autoFocus: o, onKeyDown: w, onKeyUp: x, onClick: b, onMouseDown: C }, A, M, D), U = I0(), H = ae(() => {
    let L = s.panel;
    if (!L)
      return;
    function T() {
      ht(U.current, { [Pn.Forwards]: () => br(L, Ct.First), [Pn.Backwards]: () => br(L, Ct.Last) }) === zn.Error && br(au().filter((B) => B.dataset.headlessuiFocusGuard !== "true"), ht(U.current, { [Pn.Forwards]: Ct.Next, [Pn.Backwards]: Ct.Previous }), { relativeTo: s.button });
    }
    T();
  }), W = ze();
  return k.createElement(k.Fragment, null, W({ ourProps: ee, theirProps: i, slot: G, defaultTag: zT, name: "Popover.Button" }), K && !m && c && k.createElement(ya, { id: d, ref: s.afterButtonSentinel, features: ga.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: H }));
}
let HT = "div", KT = Ir.RenderStrategy | Ir.Static;
function d5(e, t) {
  let n = kt(), { id: r = `headlessui-popover-backdrop-${n}`, transition: a = !1, ...o } = e, [{ popoverState: i }, s] = Jp("Popover.Backdrop"), [l, c] = ke(null), u = et(t, c), d = to(), [p, h] = rs(a, l, d !== null ? (d & Pt.Open) === Pt.Open : i === 0), m = ae((_) => {
    if (Qa(_.currentTarget))
      return _.preventDefault();
    s({ type: 1 });
  }), f = we(() => ({ open: i === 0 }), [i]), g = { ref: u, id: r, "aria-hidden": !0, onClick: m, ...ts(h) };
  return ze()({ ourProps: g, theirProps: o, slot: f, defaultTag: HT, features: KT, visible: p, name: "Popover.Backdrop" });
}
let UT = "div", $T = Ir.RenderStrategy | Ir.Static;
function VT(e, t) {
  let n = kt(), { id: r = `headlessui-popover-panel-${n}`, focus: a = !1, anchor: o, portal: i = !1, modal: s = !1, transition: l = !1, ...c } = e, [u, d] = Jp("Popover.Panel"), { close: p, isPortalled: h } = V0("Popover.Panel"), m = `headlessui-focus-sentinel-before-${n}`, f = `headlessui-focus-sentinel-after-${n}`, g = _e(null), _ = jp(o), [v, w] = zp(_), x = Fp();
  _ && (i = !0);
  let [b, C] = ke(null), E = et(g, t, _ ? v : null, ae((L) => d({ type: 4, panel: L })), C), A = Zn(g);
  Je(() => (d({ type: 5, panelId: r }), () => {
    d({ type: 5, panelId: null });
  }), [r, d]);
  let O = to(), [M, I] = rs(l, b, O !== null ? (O & Pt.Open) === Pt.Open : u.popoverState === 0);
  nu(M, u.button, () => {
    d({ type: 1 });
  });
  let D = u.__demoMode ? !1 : s && M;
  lu(D, A);
  let K = ae((L) => {
    var T;
    switch (L.key) {
      case xe.Escape:
        if (u.popoverState !== 0 || !g.current || A != null && A.activeElement && !g.current.contains(A.activeElement))
          return;
        L.preventDefault(), L.stopPropagation(), d({ type: 1 }), (T = u.button) == null || T.focus();
        break;
    }
  });
  De(() => {
    var L;
    e.static || u.popoverState === 1 && ((L = e.unmount) == null || L) && d({ type: 4, panel: null });
  }, [u.popoverState, e.unmount, e.static, d]), De(() => {
    if (u.__demoMode || !a || u.popoverState !== 0 || !g.current)
      return;
    let L = A == null ? void 0 : A.activeElement;
    g.current.contains(L) || br(g.current, Ct.First);
  }, [u.__demoMode, a, g.current, u.popoverState]);
  let G = we(() => ({ open: u.popoverState === 0, close: p }), [u.popoverState, p]), V = mr(_ ? x() : {}, { ref: E, id: r, onKeyDown: K, onBlur: a && u.popoverState === 0 ? (L) => {
    var T, B, N, Y, Q;
    let F = L.relatedTarget;
    F && g.current && ((T = g.current) != null && T.contains(F) || (d({ type: 1 }), ((N = (B = u.beforePanelSentinel.current) == null ? void 0 : B.contains) != null && N.call(B, F) || (Q = (Y = u.afterPanelSentinel.current) == null ? void 0 : Y.contains) != null && Q.call(Y, F)) && F.focus({ preventScroll: !0 })));
  } : void 0, tabIndex: -1, style: { ...c.style, ...w, "--button-width": xc(u.button, !0).width }, ...ts(I) }), ee = I0(), U = ae(() => {
    let L = g.current;
    if (!L)
      return;
    function T() {
      ht(ee.current, { [Pn.Forwards]: () => {
        var B;
        br(L, Ct.First) === zn.Error && ((B = u.afterPanelSentinel.current) == null || B.focus());
      }, [Pn.Backwards]: () => {
        var B;
        (B = u.button) == null || B.focus({ preventScroll: !0 });
      } });
    }
    T();
  }), H = ae(() => {
    let L = g.current;
    if (!L)
      return;
    function T() {
      ht(ee.current, { [Pn.Forwards]: () => {
        if (!u.button)
          return;
        let B = au(), N = B.indexOf(u.button), Y = B.slice(0, N + 1), Q = [...B.slice(N + 1), ...Y];
        for (let F of Q.slice())
          if (F.dataset.headlessuiFocusGuard === "true" || b != null && b.contains(F)) {
            let re = Q.indexOf(F);
            re !== -1 && Q.splice(re, 1);
          }
        br(Q, Ct.First, { sorted: !1 });
      }, [Pn.Backwards]: () => {
        var B;
        br(L, Ct.Previous) === zn.Error && ((B = u.button) == null || B.focus());
      } });
    }
    T();
  }), W = ze();
  return k.createElement(A0, null, k.createElement(Qp.Provider, { value: r }, k.createElement(Xp.Provider, { value: { close: p, isPortalled: h } }, k.createElement(pu, { enabled: i ? e.static || M : !1 }, M && h && k.createElement(ya, { id: m, ref: u.beforePanelSentinel, features: ga.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: U }), W({ ourProps: V, theirProps: c, slot: G, defaultTag: UT, features: $T, visible: M, name: "Popover.Panel" }), M && h && k.createElement(ya, { id: f, ref: u.afterPanelSentinel, features: ga.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: H })))));
}
let WT = "div";
function YT(e, t) {
  let n = _e(null), r = et(n, t), [a, o] = ke([]), i = ae((f) => {
    o((g) => {
      let _ = g.indexOf(f);
      if (_ !== -1) {
        let v = g.slice();
        return v.splice(_, 1), v;
      }
      return g;
    });
  }), s = ae((f) => (o((g) => [...g, f]), () => i(f))), l = ae(() => {
    var f;
    let g = Wn(n);
    if (!g)
      return !1;
    let _ = g.activeElement;
    return (f = n.current) != null && f.contains(_) ? !0 : a.some((v) => {
      var w, x;
      return ((w = g.getElementById(v.buttonId.current)) == null ? void 0 : w.contains(_)) || ((x = g.getElementById(v.panelId.current)) == null ? void 0 : x.contains(_));
    });
  }), c = ae((f) => {
    for (let g of a)
      g.buttonId.current !== f && g.close();
  }), u = we(() => ({ registerPopover: s, unregisterPopover: i, isFocusWithinPopoverGroup: l, closeOthers: c }), [s, i, l, c]), d = we(() => ({}), []), p = e, h = { ref: r }, m = ze();
  return k.createElement(Id, null, k.createElement(W0.Provider, { value: u }, m({ ourProps: h, theirProps: p, slot: d, defaultTag: WT, name: "Popover.Group" })));
}
let ZT = Ie(FT), qT = Ie(GT), JT = Ie(d5), XT = Ie(d5), QT = Ie(VT), eM = Ie(YT);
Object.assign(ZT, { Button: qT, Backdrop: XT, Overlay: JT, Panel: QT, Group: eM });
var tM = ((e) => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(tM || {});
let rM = { 0(e, t) {
  let n = [...e.options, { id: t.id, element: t.element, propsRef: t.propsRef }];
  return { ...e, options: Ia(n, (r) => r.element.current) };
}, 1(e, t) {
  let n = e.options.slice(), r = e.options.findIndex((a) => a.id === t.id);
  return r === -1 ? e : (n.splice(r, 1), { ...e, options: n });
} }, Y0 = Qe(null);
Y0.displayName = "RadioGroupDataContext";
function Z0(e) {
  let t = Ue(Y0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Z0), n;
  }
  return t;
}
let q0 = Qe(null);
q0.displayName = "RadioGroupActionsContext";
function J0(e) {
  let t = Ue(q0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, J0), n;
  }
  return t;
}
function nM(e, t) {
  return ht(t.type, rM, e, t);
}
let aM = "div";
function oM(e, t) {
  let n = kt(), r = wn(), { id: a = `headlessui-radiogroup-${n}`, value: o, form: i, name: s, onChange: l, by: c, disabled: u = r || !1, defaultValue: d, ...p } = e, h = x0(c), [m, f] = go(nM, { options: [] }), g = m.options, [_, v] = bo(), [w, x] = Qs(), b = _e(null), C = et(b, t), E = eu(d), [A, O] = Qc(o, l, E), M = we(() => g.find((T) => !T.propsRef.current.disabled), [g]), I = we(() => g.some((T) => h(T.propsRef.current.value, A)), [g, A]), D = ae((T) => {
    var B;
    if (u || h(T, A))
      return !1;
    let N = (B = g.find((Y) => h(Y.propsRef.current.value, T))) == null ? void 0 : B.propsRef.current;
    return N != null && N.disabled ? !1 : (O == null || O(T), !0);
  }), K = ae((T) => {
    let B = b.current;
    if (!B)
      return;
    let N = Wn(B), Y = g.filter((Q) => Q.propsRef.current.disabled === !1).map((Q) => Q.element.current);
    switch (T.key) {
      case xe.Enter:
        Tp(T.currentTarget);
        break;
      case xe.ArrowLeft:
      case xe.ArrowUp:
        if (T.preventDefault(), T.stopPropagation(), br(Y, Ct.Previous | Ct.WrapAround) === zn.Success) {
          let Q = g.find((F) => F.element.current === (N == null ? void 0 : N.activeElement));
          Q && D(Q.propsRef.current.value);
        }
        break;
      case xe.ArrowRight:
      case xe.ArrowDown:
        if (T.preventDefault(), T.stopPropagation(), br(Y, Ct.Next | Ct.WrapAround) === zn.Success) {
          let Q = g.find((F) => F.element.current === (N == null ? void 0 : N.activeElement));
          Q && D(Q.propsRef.current.value);
        }
        break;
      case xe.Space:
        {
          T.preventDefault(), T.stopPropagation();
          let Q = g.find((F) => F.element.current === (N == null ? void 0 : N.activeElement));
          Q && D(Q.propsRef.current.value);
        }
        break;
    }
  }), G = ae((T) => (f({ type: 0, ...T }), () => f({ type: 1, id: T.id }))), V = we(() => ({ value: A, firstOption: M, containsCheckedOption: I, disabled: u, compare: h, ...m }), [A, M, I, u, h, m]), ee = we(() => ({ registerOption: G, change: D }), [G, D]), U = { ref: C, id: a, role: "radiogroup", "aria-labelledby": _, "aria-describedby": w, onKeyDown: K }, H = we(() => ({ value: A }), [A]), W = ft(() => {
    if (E !== void 0)
      return D(E);
  }, [D, E]), L = ze();
  return k.createElement(x, { name: "RadioGroup.Description" }, k.createElement(v, { name: "RadioGroup.Label" }, k.createElement(q0.Provider, { value: ee }, k.createElement(Y0.Provider, { value: V }, s != null && k.createElement(tu, { disabled: u, data: { [s]: A || "on" }, overrides: { type: "radio", checked: A != null }, form: i, onReset: W }), L({ ourProps: U, theirProps: p, slot: H, defaultTag: aM, name: "RadioGroup" })))));
}
let iM = "div";
function sM(e, t) {
  var n;
  let r = Z0("RadioGroup.Option"), a = J0("RadioGroup.Option"), o = kt(), { id: i = `headlessui-radiogroup-option-${o}`, value: s, disabled: l = r.disabled || !1, autoFocus: c = !1, ...u } = e, d = _e(null), p = et(d, t), [h, m] = bo(), [f, g] = Qs(), _ = Kr({ value: s, disabled: l });
  Je(() => a.registerOption({ id: i, element: d, propsRef: _ }), [i, a, d, _]);
  let v = ae((D) => {
    var K;
    if (Qa(D.currentTarget))
      return D.preventDefault();
    a.change(s) && ((K = d.current) == null || K.focus());
  }), w = ((n = r.firstOption) == null ? void 0 : n.id) === i, { isFocusVisible: x, focusProps: b } = $r({ autoFocus: c }), { isHovered: C, hoverProps: E } = Jr({ isDisabled: l }), A = r.compare(r.value, s), O = mr({ ref: p, id: i, role: "radio", "aria-checked": A ? "true" : "false", "aria-labelledby": h, "aria-describedby": f, "aria-disabled": l ? !0 : void 0, tabIndex: l ? -1 : A || !r.containsCheckedOption && w ? 0 : -1, onClick: l ? void 0 : v, autoFocus: c }, b, E), M = we(() => ({ checked: A, disabled: l, active: x, hover: C, focus: x, autofocus: c }), [A, l, C, x, c]), I = ze();
  return k.createElement(g, { name: "RadioGroup.Description" }, k.createElement(m, { name: "RadioGroup.Label" }, I({ ourProps: O, theirProps: u, slot: M, defaultTag: iM, name: "RadioGroup.Option" })));
}
let lM = "span";
function cM(e, t) {
  var n;
  let r = Z0("Radio"), a = J0("Radio"), o = kt(), i = vo(), s = wn(), { id: l = i || `headlessui-radio-${o}`, value: c, disabled: u = r.disabled || s || !1, autoFocus: d = !1, ...p } = e, h = _e(null), m = et(h, t), f = wa(), g = Jo(), _ = Kr({ value: c, disabled: u });
  Je(() => a.registerOption({ id: l, element: h, propsRef: _ }), [l, a, h, _]);
  let v = ae((I) => {
    var D;
    if (Qa(I.currentTarget))
      return I.preventDefault();
    a.change(c) && ((D = h.current) == null || D.focus());
  }), { isFocusVisible: w, focusProps: x } = $r({ autoFocus: d }), { isHovered: b, hoverProps: C } = Jr({ isDisabled: u }), E = ((n = r.firstOption) == null ? void 0 : n.id) === l, A = r.compare(r.value, c), O = mr({ ref: m, id: l, role: "radio", "aria-checked": A ? "true" : "false", "aria-labelledby": f, "aria-describedby": g, "aria-disabled": u ? !0 : void 0, tabIndex: u ? -1 : A || !r.containsCheckedOption && E ? 0 : -1, autoFocus: d, onClick: u ? void 0 : v }, x, C), M = we(() => ({ checked: A, disabled: u, hover: b, focus: w, autofocus: d }), [A, u, b, w, d]);
  return ze()({ ourProps: O, theirProps: p, slot: M, defaultTag: lM, name: "Radio" });
}
let uM = Ie(oM), dM = Ie(sM), pM = Ie(cM), hM = ru, mM = w0;
Object.assign(uM, { Option: dM, Radio: pM, Label: hM, Description: mM });
let fM = "select";
function gM(e, t) {
  let n = kt(), r = vo(), a = wn(), { id: o = r || `headlessui-select-${n}`, disabled: i = a || !1, invalid: s = !1, autoFocus: l = !1, ...c } = e, u = wa(), d = Jo(), { isFocusVisible: p, focusProps: h } = $r({ autoFocus: l }), { isHovered: m, hoverProps: f } = Jr({ isDisabled: i }), { pressed: g, pressProps: _ } = _a({ disabled: i }), v = mr({ ref: t, id: o, "aria-labelledby": u, "aria-describedby": d, "aria-invalid": s ? "" : void 0, disabled: i || void 0, autoFocus: l }, h, f, _), w = we(() => ({ disabled: i, invalid: s, hover: m, focus: p, active: g, autofocus: l }), [i, s, m, p, g, l]);
  return ze()({ ourProps: v, theirProps: c, slot: w, defaultTag: fM, name: "Select" });
}
Ie(gM);
let X0 = Qe(null);
X0.displayName = "GroupContext";
let yM = rr;
function vM(e) {
  var t;
  let [n, r] = ke(null), [a, o] = bo(), [i, s] = Qs(), l = we(() => ({ switch: n, setSwitch: r }), [n, r]), c = {}, u = e, d = ze();
  return k.createElement(s, { name: "Switch.Description", value: i }, k.createElement(o, { name: "Switch.Label", value: a, props: { htmlFor: (t = l.switch) == null ? void 0 : t.id, onClick(p) {
    n && (p.currentTarget instanceof HTMLLabelElement && p.preventDefault(), n.click(), n.focus({ preventScroll: !0 }));
  } } }, k.createElement(X0.Provider, { value: l }, d({ ourProps: c, theirProps: u, slot: {}, defaultTag: yM, name: "Switch.Group" }))));
}
let bM = "button";
function _M(e, t) {
  var n;
  let r = kt(), a = vo(), o = wn(), { id: i = a || `headlessui-switch-${r}`, disabled: s = o || !1, checked: l, defaultChecked: c, onChange: u, name: d, value: p, form: h, autoFocus: m = !1, ...f } = e, g = Ue(X0), [_, v] = ke(null), w = _e(null), x = et(w, t, g === null ? null : g.setSwitch, v), b = eu(c), [C, E] = Qc(l, u, b ?? !1), A = Yn(), [O, M] = ke(!1), I = ae(() => {
    M(!0), E == null || E(!C), A.nextFrame(() => {
      M(!1);
    });
  }), D = ae((re) => {
    if (Qa(re.currentTarget))
      return re.preventDefault();
    re.preventDefault(), I();
  }), K = ae((re) => {
    re.key === xe.Space ? (re.preventDefault(), I()) : re.key === xe.Enter && Tp(re.currentTarget);
  }), G = ae((re) => re.preventDefault()), V = wa(), ee = Jo(), { isFocusVisible: U, focusProps: H } = $r({ autoFocus: m }), { isHovered: W, hoverProps: L } = Jr({ isDisabled: s }), { pressed: T, pressProps: B } = _a({ disabled: s }), N = we(() => ({ checked: C, disabled: s, hover: W, focus: U, active: T, autofocus: m, changing: O }), [C, W, U, T, s, O, m]), Y = mr({ id: i, ref: x, role: "switch", type: es(e, _), tabIndex: e.tabIndex === -1 ? 0 : (n = e.tabIndex) != null ? n : 0, "aria-checked": C, "aria-labelledby": V, "aria-describedby": ee, disabled: s || void 0, autoFocus: m, onClick: D, onKeyUp: K, onKeyPress: G }, H, L, B), Q = ft(() => {
    if (b !== void 0)
      return E == null ? void 0 : E(b);
  }, [E, b]), F = ze();
  return k.createElement(k.Fragment, null, d != null && k.createElement(tu, { disabled: s, data: { [d]: p || "on" }, overrides: { type: "checkbox", checked: C }, form: h, onReset: Q }), F({ ourProps: Y, theirProps: f, slot: N, defaultTag: bM, name: "Switch" }));
}
let wM = Ie(_M), SM = vM, CM = ru, xM = w0;
Object.assign(wM, { Group: SM, Label: CM, Description: xM });
function kM({ onFocus: e }) {
  let [t, n] = ke(!0), r = Kp();
  return t ? k.createElement(ya, { as: "button", type: "button", features: ga.Focusable, onFocus: (a) => {
    a.preventDefault();
    let o, i = 50;
    function s() {
      if (i-- <= 0) {
        o && cancelAnimationFrame(o);
        return;
      }
      if (e()) {
        if (cancelAnimationFrame(o), !r.current)
          return;
        n(!1);
        return;
      }
      o = requestAnimationFrame(s);
    }
    o = requestAnimationFrame(s);
  } }) : null;
}
const p5 = pe.createContext(null);
function EM() {
  return { groups: /* @__PURE__ */ new Map(), get(e, t) {
    var n;
    let r = this.groups.get(e);
    r || (r = /* @__PURE__ */ new Map(), this.groups.set(e, r));
    let a = (n = r.get(t)) != null ? n : 0;
    r.set(t, a + 1);
    let o = Array.from(r.keys()).indexOf(t);
    function i() {
      let s = r.get(t);
      s > 1 ? r.set(t, s - 1) : r.delete(t);
    }
    return [o, i];
  } };
}
function PM({ children: e }) {
  let t = pe.useRef(EM());
  return pe.createElement(p5.Provider, { value: t }, e);
}
function h5(e) {
  let t = pe.useContext(p5);
  if (!t)
    throw new Error("You must wrap your component in a <StableCollection>");
  let n = pe.useId(), [r, a] = t.current.get(e, n);
  return pe.useEffect(() => a, []), r;
}
var TM = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(TM || {}), MM = ((e) => (e[e.Less = -1] = "Less", e[e.Equal = 0] = "Equal", e[e.Greater = 1] = "Greater", e))(MM || {}), OM = ((e) => (e[e.SetSelectedIndex = 0] = "SetSelectedIndex", e[e.RegisterTab = 1] = "RegisterTab", e[e.UnregisterTab = 2] = "UnregisterTab", e[e.RegisterPanel = 3] = "RegisterPanel", e[e.UnregisterPanel = 4] = "UnregisterPanel", e))(OM || {});
let AM = { 0(e, t) {
  var n;
  let r = Ia(e.tabs, (u) => u.current), a = Ia(e.panels, (u) => u.current), o = r.filter((u) => {
    var d;
    return !((d = u.current) != null && d.hasAttribute("disabled"));
  }), i = { ...e, tabs: r, panels: a };
  if (t.index < 0 || t.index > r.length - 1) {
    let u = ht(Math.sign(t.index - e.selectedIndex), { [-1]: () => 1, 0: () => ht(Math.sign(t.index), { [-1]: () => 0, 0: () => 0, 1: () => 1 }), 1: () => 0 });
    if (o.length === 0)
      return i;
    let d = ht(u, { 0: () => r.indexOf(o[0]), 1: () => r.indexOf(o[o.length - 1]) });
    return { ...i, selectedIndex: d === -1 ? e.selectedIndex : d };
  }
  let s = r.slice(0, t.index), l = [...r.slice(t.index), ...s].find((u) => o.includes(u));
  if (!l)
    return i;
  let c = (n = r.indexOf(l)) != null ? n : e.selectedIndex;
  return c === -1 && (c = e.selectedIndex), { ...i, selectedIndex: c };
}, 1(e, t) {
  if (e.tabs.includes(t.tab))
    return e;
  let n = e.tabs[e.selectedIndex], r = Ia([...e.tabs, t.tab], (o) => o.current), a = e.selectedIndex;
  return e.info.current.isControlled || (a = r.indexOf(n), a === -1 && (a = e.selectedIndex)), { ...e, tabs: r, selectedIndex: a };
}, 2(e, t) {
  return { ...e, tabs: e.tabs.filter((n) => n !== t.tab) };
}, 3(e, t) {
  return e.panels.includes(t.panel) ? e : { ...e, panels: Ia([...e.panels, t.panel], (n) => n.current) };
}, 4(e, t) {
  return { ...e, panels: e.panels.filter((n) => n !== t.panel) };
} }, Q0 = Qe(null);
Q0.displayName = "TabsDataContext";
function Bs(e) {
  let t = Ue(Q0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Bs), n;
  }
  return t;
}
let eg = Qe(null);
eg.displayName = "TabsActionsContext";
function tg(e) {
  let t = Ue(eg);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, tg), n;
  }
  return t;
}
function NM(e, t) {
  return ht(t.type, AM, e, t);
}
let LM = "div";
function RM(e, t) {
  let { defaultIndex: n = 0, vertical: r = !1, manual: a = !1, onChange: o, selectedIndex: i = null, ...s } = e;
  const l = r ? "vertical" : "horizontal", c = a ? "manual" : "auto";
  let u = i !== null, d = Kr({ isControlled: u }), p = et(t), [h, m] = go(NM, { info: d, selectedIndex: i ?? n, tabs: [], panels: [] }), f = we(() => ({ selectedIndex: h.selectedIndex }), [h.selectedIndex]), g = Kr(o || (() => {
  })), _ = Kr(h.tabs), v = we(() => ({ orientation: l, activation: c, ...h }), [l, c, h]), w = ae((M) => (m({ type: 1, tab: M }), () => m({ type: 2, tab: M }))), x = ae((M) => (m({ type: 3, panel: M }), () => m({ type: 4, panel: M }))), b = ae((M) => {
    C.current !== M && g.current(M), u || m({ type: 0, index: M });
  }), C = Kr(u ? e.selectedIndex : h.selectedIndex), E = we(() => ({ registerTab: w, registerPanel: x, change: b }), []);
  Je(() => {
    m({ type: 0, index: i ?? n });
  }, [i]), Je(() => {
    if (C.current === void 0 || h.tabs.length <= 0)
      return;
    let M = Ia(h.tabs, (I) => I.current);
    M.some((I, D) => h.tabs[D] !== I) && b(M.indexOf(h.tabs[C.current]));
  });
  let A = { ref: p }, O = ze();
  return k.createElement(PM, null, k.createElement(eg.Provider, { value: E }, k.createElement(Q0.Provider, { value: v }, v.tabs.length <= 0 && k.createElement(kM, { onFocus: () => {
    var M, I;
    for (let D of _.current)
      if (((M = D.current) == null ? void 0 : M.tabIndex) === 0)
        return (I = D.current) == null || I.focus(), !0;
    return !1;
  } }), O({ ourProps: A, theirProps: s, slot: f, defaultTag: LM, name: "Tabs" }))));
}
let DM = "div";
function IM(e, t) {
  let { orientation: n, selectedIndex: r } = Bs("Tab.List"), a = et(t), o = we(() => ({ selectedIndex: r }), [r]), i = e, s = { ref: a, role: "tablist", "aria-orientation": n };
  return ze()({ ourProps: s, theirProps: i, slot: o, defaultTag: DM, name: "Tabs.List" });
}
let jM = "button";
function BM(e, t) {
  var n, r;
  let a = kt(), { id: o = `headlessui-tabs-tab-${a}`, disabled: i = !1, autoFocus: s = !1, ...l } = e, { orientation: c, activation: u, selectedIndex: d, tabs: p, panels: h } = Bs("Tab"), m = tg("Tab"), f = Bs("Tab"), [g, _] = ke(null), v = _e(null), w = et(v, t, _);
  Je(() => m.registerTab(v), [m, v]);
  let x = h5("tabs"), b = p.indexOf(v);
  b === -1 && (b = x);
  let C = b === d, E = ae((L) => {
    var T;
    let B = L();
    if (B === zn.Success && u === "auto") {
      let N = (T = Wn(v)) == null ? void 0 : T.activeElement, Y = f.tabs.findIndex((Q) => Q.current === N);
      Y !== -1 && m.change(Y);
    }
    return B;
  }), A = ae((L) => {
    let T = p.map((B) => B.current).filter(Boolean);
    if (L.key === xe.Space || L.key === xe.Enter) {
      L.preventDefault(), L.stopPropagation(), m.change(b);
      return;
    }
    switch (L.key) {
      case xe.Home:
      case xe.PageUp:
        return L.preventDefault(), L.stopPropagation(), E(() => br(T, Ct.First));
      case xe.End:
      case xe.PageDown:
        return L.preventDefault(), L.stopPropagation(), E(() => br(T, Ct.Last));
    }
    if (E(() => ht(c, { vertical() {
      return L.key === xe.ArrowUp ? br(T, Ct.Previous | Ct.WrapAround) : L.key === xe.ArrowDown ? br(T, Ct.Next | Ct.WrapAround) : zn.Error;
    }, horizontal() {
      return L.key === xe.ArrowLeft ? br(T, Ct.Previous | Ct.WrapAround) : L.key === xe.ArrowRight ? br(T, Ct.Next | Ct.WrapAround) : zn.Error;
    } })) === zn.Success)
      return L.preventDefault();
  }), O = _e(!1), M = ae(() => {
    var L;
    O.current || (O.current = !0, (L = v.current) == null || L.focus({ preventScroll: !0 }), m.change(b), Xc(() => {
      O.current = !1;
    }));
  }), I = ae((L) => {
    L.preventDefault();
  }), { isFocusVisible: D, focusProps: K } = $r({ autoFocus: s }), { isHovered: G, hoverProps: V } = Jr({ isDisabled: i }), { pressed: ee, pressProps: U } = _a({ disabled: i }), H = we(() => ({ selected: C, hover: G, active: ee, focus: D, autofocus: s, disabled: i }), [C, G, D, ee, s, i]), W = mr({ ref: w, onKeyDown: A, onMouseDown: I, onClick: M, id: o, role: "tab", type: es(e, g), "aria-controls": (r = (n = h[b]) == null ? void 0 : n.current) == null ? void 0 : r.id, "aria-selected": C, tabIndex: C ? 0 : -1, disabled: i || void 0, autoFocus: s }, K, V, U);
  return ze()({ ourProps: W, theirProps: l, slot: H, defaultTag: jM, name: "Tabs.Tab" });
}
let FM = "div";
function zM(e, t) {
  let { selectedIndex: n } = Bs("Tab.Panels"), r = et(t), a = we(() => ({ selectedIndex: n }), [n]), o = e, i = { ref: r };
  return ze()({ ourProps: i, theirProps: o, slot: a, defaultTag: FM, name: "Tabs.Panels" });
}
let GM = "div", HM = Ir.RenderStrategy | Ir.Static;
function KM(e, t) {
  var n, r, a, o;
  let i = kt(), { id: s = `headlessui-tabs-panel-${i}`, tabIndex: l = 0, ...c } = e, { selectedIndex: u, tabs: d, panels: p } = Bs("Tab.Panel"), h = tg("Tab.Panel"), m = _e(null), f = et(m, t);
  Je(() => h.registerPanel(m), [h, m]);
  let g = h5("panels"), _ = p.indexOf(m);
  _ === -1 && (_ = g);
  let v = _ === u, { isFocusVisible: w, focusProps: x } = $r(), b = we(() => ({ selected: v, focus: w }), [v, w]), C = mr({ ref: f, id: s, role: "tabpanel", "aria-labelledby": (r = (n = d[_]) == null ? void 0 : n.current) == null ? void 0 : r.id, tabIndex: v ? l : -1 }, x), E = ze();
  return !v && ((a = c.unmount) == null || a) && !((o = c.static) != null && o) ? k.createElement(ya, { "aria-hidden": "true", ...C }) : E({ ourProps: C, theirProps: c, slot: b, defaultTag: GM, features: HM, visible: v, name: "Tabs.Panel" });
}
let UM = Ie(BM), $M = Ie(RM), VM = Ie(IM), WM = Ie(zM), YM = Ie(KM);
Object.assign(UM, { Group: $M, List: VM, Panels: WM, Panel: YM });
let ZM = "textarea";
function qM(e, t) {
  let n = kt(), r = vo(), a = wn(), { id: o = r || `headlessui-textarea-${n}`, disabled: i = a || !1, autoFocus: s = !1, invalid: l = !1, ...c } = e, u = wa(), d = Jo(), { isFocused: p, focusProps: h } = $r({ autoFocus: s }), { isHovered: m, hoverProps: f } = Jr({ isDisabled: i }), g = mr({ ref: t, id: o, "aria-labelledby": u, "aria-describedby": d, "aria-invalid": l ? "" : void 0, disabled: i || void 0, autoFocus: s }, h, f), _ = we(() => ({ disabled: i, invalid: l, hover: m, focus: p, autofocus: s }), [i, l, m, p, s]);
  return ze()({ ourProps: g, theirProps: c, slot: _, defaultTag: ZM, name: "Textarea" });
}
Ie(qM);
const rg = "-", JM = (e) => {
  const t = QM(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      const o = a.split(rg);
      return o[0] === "" && o.length !== 1 && o.shift(), m5(o, t) || XM(a);
    },
    getConflictingClassGroupIds: (a, o) => {
      const i = n[a] || [];
      return o && r[a] ? [...i, ...r[a]] : i;
    }
  };
}, m5 = (e, t) => {
  var n;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], a = t.nextPart.get(r), o = a ? m5(e.slice(1), a) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(rg);
  return (n = t.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : n.classGroupId;
}, n2 = /^\[(.+)\]$/, XM = (e) => {
  if (n2.test(e)) {
    const t = n2.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, QM = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return tO(Object.entries(e.classGroups), n).forEach(([a, o]) => {
    C1(o, r, a, t);
  }), r;
}, C1 = (e, t, n, r) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const o = a === "" ? t : a2(t, a);
      o.classGroupId = n;
      return;
    }
    if (typeof a == "function") {
      if (eO(a)) {
        C1(a(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: n
      });
      return;
    }
    Object.entries(a).forEach(([o, i]) => {
      C1(i, a2(t, o), n, r);
    });
  });
}, a2 = (e, t) => {
  let n = e;
  return t.split(rg).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, eO = (e) => e.isThemeGetter, tO = (e, t) => t ? e.map(([n, r]) => {
  const a = r.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([i, s]) => [t + i, s])) : o);
  return [n, a];
}) : e, rO = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const a = (o, i) => {
    n.set(o, i), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let i = n.get(o);
      if (i !== void 0)
        return i;
      if ((i = r.get(o)) !== void 0)
        return a(o, i), i;
    },
    set(o, i) {
      n.has(o) ? n.set(o, i) : a(o, i);
    }
  };
}, f5 = "!", nO = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, a = t[0], o = t.length, i = (s) => {
    const l = [];
    let c = 0, u = 0, d;
    for (let g = 0; g < s.length; g++) {
      let _ = s[g];
      if (c === 0) {
        if (_ === a && (r || s.slice(g, g + o) === t)) {
          l.push(s.slice(u, g)), u = g + o;
          continue;
        }
        if (_ === "/") {
          d = g;
          continue;
        }
      }
      _ === "[" ? c++ : _ === "]" && c--;
    }
    const p = l.length === 0 ? s : s.substring(u), h = p.startsWith(f5), m = h ? p.substring(1) : p, f = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: f
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: i
  }) : i;
}, aO = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, oO = (e) => ({
  cache: rO(e.cacheSize),
  parseClassName: nO(e),
  ...JM(e)
}), iO = /\s+/, sO = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: a
  } = t, o = [], i = e.trim().split(iO);
  let s = "";
  for (let l = i.length - 1; l >= 0; l -= 1) {
    const c = i[l], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: p,
      maybePostfixModifierPosition: h
    } = n(c);
    let m = !!h, f = r(m ? p.substring(0, h) : p);
    if (!f) {
      if (!m) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (f = r(p), !f) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      m = !1;
    }
    const g = aO(u).join(":"), _ = d ? g + f5 : g, v = _ + f;
    if (o.includes(v))
      continue;
    o.push(v);
    const w = a(f, m);
    for (let x = 0; x < w.length; ++x) {
      const b = w[x];
      o.push(_ + b);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function jd() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = g5(t)) && (r && (r += " "), r += n);
  return r;
}
const g5 = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = g5(e[r])) && (n && (n += " "), n += t);
  return n;
};
function lO(e, ...t) {
  let n, r, a, o = i;
  function i(l) {
    const c = t.reduce((u, d) => d(u), e());
    return n = oO(c), r = n.cache.get, a = n.cache.set, o = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const u = sO(l, n);
    return a(l, u), u;
  }
  return function() {
    return o(jd.apply(null, arguments));
  };
}
const Qt = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, y5 = /^\[(?:([a-z-]+):)?(.+)\]$/i, cO = /^\d+\/\d+$/, uO = /* @__PURE__ */ new Set(["px", "full", "screen"]), dO = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, pO = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, hO = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, mO = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, fO = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ro = (e) => Ms(e) || uO.has(e) || cO.test(e), wo = (e) => il(e, "length", CO), Ms = (e) => !!e && !Number.isNaN(Number(e)), em = (e) => il(e, "number", Ms), El = (e) => !!e && Number.isInteger(Number(e)), gO = (e) => e.endsWith("%") && Ms(e.slice(0, -1)), at = (e) => y5.test(e), So = (e) => dO.test(e), yO = /* @__PURE__ */ new Set(["length", "size", "percentage"]), vO = (e) => il(e, yO, v5), bO = (e) => il(e, "position", v5), _O = /* @__PURE__ */ new Set(["image", "url"]), wO = (e) => il(e, _O, kO), SO = (e) => il(e, "", xO), Pl = () => !0, il = (e, t, n) => {
  const r = y5.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, CO = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  pO.test(e) && !hO.test(e)
), v5 = () => !1, xO = (e) => mO.test(e), kO = (e) => fO.test(e), EO = () => {
  const e = Qt("colors"), t = Qt("spacing"), n = Qt("blur"), r = Qt("brightness"), a = Qt("borderColor"), o = Qt("borderRadius"), i = Qt("borderSpacing"), s = Qt("borderWidth"), l = Qt("contrast"), c = Qt("grayscale"), u = Qt("hueRotate"), d = Qt("invert"), p = Qt("gap"), h = Qt("gradientColorStops"), m = Qt("gradientColorStopPositions"), f = Qt("inset"), g = Qt("margin"), _ = Qt("opacity"), v = Qt("padding"), w = Qt("saturate"), x = Qt("scale"), b = Qt("sepia"), C = Qt("skew"), E = Qt("space"), A = Qt("translate"), O = () => ["auto", "contain", "none"], M = () => ["auto", "hidden", "clip", "visible", "scroll"], I = () => ["auto", at, t], D = () => [at, t], K = () => ["", ro, wo], G = () => ["auto", Ms, at], V = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], ee = () => ["solid", "dashed", "dotted", "double", "none"], U = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], H = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], W = () => ["", "0", at], L = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], T = () => [Ms, at];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Pl],
      spacing: [ro, wo],
      blur: ["none", "", So, at],
      brightness: T(),
      borderColor: [e],
      borderRadius: ["none", "", "full", So, at],
      borderSpacing: D(),
      borderWidth: K(),
      contrast: T(),
      grayscale: W(),
      hueRotate: T(),
      invert: W(),
      gap: D(),
      gradientColorStops: [e],
      gradientColorStopPositions: [gO, wo],
      inset: I(),
      margin: I(),
      opacity: T(),
      padding: D(),
      saturate: T(),
      scale: T(),
      sepia: W(),
      skew: T(),
      space: D(),
      translate: D()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", at]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [So]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": L()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": L()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...V(), at]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: M()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": M()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": M()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: O()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": O()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": O()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [f]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [f]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [f]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [f]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [f]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [f]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [f]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [f]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [f]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", El, at]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: I()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", at]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: W()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: W()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", El, at]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Pl]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", El, at]
        }, at]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": G()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": G()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Pl]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [El, at]
        }, at]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": G()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": G()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", at]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", at]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...H()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...H(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...H(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [g]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [g]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [g]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [g]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [g]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [g]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [g]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [g]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [g]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [E]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [E]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", at, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [at, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [at, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [So]
        }, So]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [at, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [at, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [at, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [at, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", So, wo]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", em]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Pl]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", at]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Ms, em]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", ro, at]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", at]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", at]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [_]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [_]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...ee(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", ro, wo]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", ro, at]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: D()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", at]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", at]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [_]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...V(), bO]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", vO]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, wO]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [_]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...ee(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [_]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: ee()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...ee()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ro, at]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [ro, wo]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: K()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [_]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [ro, wo]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", So, SO]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Pl]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [_]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...U(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": U()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", So, at]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [b]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [_]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [b]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", at]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: T()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", at]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: T()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", at]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [El, at]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [A]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [A]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [C]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [C]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", at]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", at]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": D()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": D()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": D()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": D()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": D()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": D()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": D()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": D()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": D()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": D()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": D()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": D()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": D()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": D()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": D()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": D()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": D()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": D()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", at]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ro, wo, em]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Fe = /* @__PURE__ */ lO(EO);
function ng(e) {
  return /* @__PURE__ */ Z.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", width: "19", height: "16", ...e, children: /* @__PURE__ */ Z.jsx("path", { d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" }) });
}
var b5 = /* @__PURE__ */ ((e) => (e.small = "small", e.medium = "medium", e.big = "big", e))(b5 || {});
function _5({
  opened: e,
  onClose: t,
  children: n,
  title: r,
  size: a = "small",
  isFetching: o,
  afterLeave: i,
  afterEnter: s,
  className: l,
  contentClassName: c,
  isCentered: u,
  dialogClassName: d,
  backdropClassName: p,
  dialogContentClassName: h,
  dialogContentWrapperClassName: m,
  dialogContentWrapper1ClassName: f,
  titleClassName: g,
  closeIconWrapperClassName: _,
  closeIconClassName: v,
  ...w
}) {
  return /* @__PURE__ */ Z.jsx(ad.Root, { afterEnter: s, show: e, as: rr, children: /* @__PURE__ */ Z.jsxs(
    Xy,
    {
      className: Fe("relative z-10", d),
      onClose: o ? () => {
      } : t,
      children: [
        /* @__PURE__ */ Z.jsx(
          ad.Child,
          {
            as: rr,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /* @__PURE__ */ Z.jsx(
              "div",
              {
                className: Fe(
                  "fixed inset-0 bg-[#000000]/20 transition-opacity",
                  p
                )
              }
            )
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "div",
          {
            className: Fe("fixed inset-0 z-10 overflow-y-auto", m),
            children: /* @__PURE__ */ Z.jsx(
              "div",
              {
                id: "modal-background",
                className: Fe(
                  "flex min-h-full w-full items-end justify-center text-center sm:items-center sm:p-0 lg:p-4",
                  f
                ),
                children: /* @__PURE__ */ Z.jsx(
                  ad.Child,
                  {
                    as: rr,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    enterTo: "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    afterLeave: i,
                    children: /* @__PURE__ */ Z.jsxs(
                      Xy.Panel,
                      {
                        className: Fe(
                          "relative w-full",
                          a === "small" ? "max-w-2xl" : a === "medium" ? "max-w-4xl" : "max-w-7xl",
                          "bg-background-secondary transform rounded-lg text-left shadow-xl transition-all sm:my-8",
                          l
                        ),
                        ...w,
                        children: [
                          /* @__PURE__ */ Z.jsxs(
                            "div",
                            {
                              className: Fe(
                                "flex w-full items-start p-6 lg:p-10 lg:pb-0",
                                u ? "justify-center" : "justify-between",
                                h
                              ),
                              children: [
                                /* @__PURE__ */ Z.jsx("h3", { className: Fe(u ? "px-6 lg:px-10" : "", g), children: r }),
                                /* @__PURE__ */ Z.jsx(
                                  "button",
                                  {
                                    className: Fe(
                                      "focus-ring rounded-full",
                                      u && "absolute right-6 top-6 lg:right-10 lg:top-10",
                                      _
                                    ),
                                    disabled: o,
                                    onClick: t,
                                    children: /* @__PURE__ */ Z.jsx(
                                      ng,
                                      {
                                        className: Fe(
                                          "cursor-pointer",
                                          o && "fill-text-secondary pointer-events-none",
                                          v
                                        )
                                      }
                                    )
                                  }
                                )
                              ]
                            }
                          ),
                          /* @__PURE__ */ Z.jsx(
                            "div",
                            {
                              className: Fe(
                                "bg-background-secondary rounded-lg p-6 lg:p-10",
                                c
                              ),
                              children: n
                            }
                          )
                        ]
                      }
                    )
                  }
                )
              }
            )
          }
        )
      ]
    }
  ) });
}
const Bd = ({ small: e = !1, type: t = "light", className: n, style: r }) => /* @__PURE__ */ Z.jsxs("div", { role: "status", className: n, style: r, children: [
  /* @__PURE__ */ Z.jsxs(
    "svg",
    {
      "aria-hidden": "true",
      className: `${e ? "h-5 w-5" : "h-8 w-8"} animate-spin ${t === "light" ? "fill-brand-primary text-background-secondary" : "fill-background-secondary text-text-primary"}`,
      viewBox: "0 0 100 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ Z.jsx("span", { className: "sr-only", children: "Loading..." })
] }), PO = (e) => /* @__PURE__ */ Z.jsxs(
  "svg",
  {
    version: "1.1",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 210.2",
    ...e,
    children: [
      /* @__PURE__ */ Z.jsx(
        "path",
        {
          id: "XMLID_34_",
          d: `M93.6,27.1C87.6,34.2,78,39.8,68.4,39c-1.2-9.6,3.5-19.8,9-26.1c6-7.3,16.5-12.5,25-12.9
	C103.4,10,99.5,19.8,93.6,27.1 M102.3,40.9c-13.9-0.8-25.8,7.9-32.4,7.9c-6.7,0-16.8-7.5-27.8-7.3c-14.3,0.2-27.6,8.3-34.9,21.2
	c-15,25.8-3.9,64,10.6,85c7.1,10.4,15.6,21.8,26.8,21.4c10.6-0.4,14.8-6.9,27.6-6.9c12.9,0,16.6,6.9,27.8,6.7
	c11.6-0.2,18.9-10.4,26-20.8c8.1-11.8,11.4-23.3,11.6-23.9c-0.2-0.2-22.4-8.7-22.6-34.3c-0.2-21.4,17.5-31.6,18.3-32.2
	C123.3,42.9,107.7,41.3,102.3,40.9 M182.6,11.9v155.9h24.2v-53.3h33.5c30.6,0,52.1-21,52.1-51.4c0-30.4-21.1-51.2-51.3-51.2H182.6z
	 M206.8,32.3h27.9c21,0,33,11.2,33,30.9c0,19.7-12,31-33.1,31h-27.8V32.3z M336.6,169c15.2,0,29.3-7.7,35.7-19.9h0.5v18.7h22.4V90.2
	c0-22.5-18-37-45.7-37c-25.7,0-44.7,14.7-45.4,34.9h21.8c1.8-9.6,10.7-15.9,22.9-15.9c14.8,0,23.1,6.9,23.1,19.6v8.6l-30.2,1.8
	c-28.1,1.7-43.3,13.2-43.3,33.2C298.4,155.6,314.1,169,336.6,169z M343.1,150.5c-12.9,0-21.1-6.2-21.1-15.7c0-9.8,7.9-15.5,23-16.4
	l26.9-1.7v8.8C371.9,140.1,359.5,150.5,343.1,150.5z M425.1,210.2c23.6,0,34.7-9,44.4-36.3L512,54.7h-24.6l-28.5,92.1h-0.5
	l-28.5-92.1h-25.3l41,113.5l-2.2,6.9c-3.7,11.7-9.7,16.2-20.4,16.2c-1.9,0-5.6-0.2-7.1-0.4v18.7C417.3,210,423.3,210.2,425.1,210.2z
	`
        }
      ),
      /* @__PURE__ */ Z.jsx("g", {}),
      /* @__PURE__ */ Z.jsx("g", {}),
      /* @__PURE__ */ Z.jsx("g", {}),
      /* @__PURE__ */ Z.jsx("g", {}),
      /* @__PURE__ */ Z.jsx("g", {}),
      /* @__PURE__ */ Z.jsx("g", {})
    ]
  }
);
function ag(e) {
  return /* @__PURE__ */ Z.jsx(
    "svg",
    {
      width: "15",
      height: "9",
      viewBox: "0 0 15 9",
      fill: "none",
      stroke: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ Z.jsx(
        "path",
        {
          d: "M1.5 1.5L7.5 7.5L13.5 1.5",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function TO(e) {
  return /* @__PURE__ */ Z.jsxs(
    "svg",
    {
      width: "24",
      height: "10",
      viewBox: "0 0 24 10",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ Z.jsx("path", { d: "M4.75347 9.9973C8.35951 9.9973 10.1625 7.57135 11.9656 5.14539H0V9.9973H4.75347Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M19.1778 0.293716C15.5717 0.293716 13.7687 2.71967 11.9657 5.14562H23.9312V0.293716H19.1778Z" })
      ]
    }
  );
}
function MO(e) {
  return /* @__PURE__ */ Z.jsx(
    "svg",
    {
      width: "21",
      height: "15",
      viewBox: "0 0 21 15",
      fill: "rgb(var(--fill-primary))",
      stroke: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ Z.jsx(
        "path",
        {
          d: "M0.535394 0.862247C0.535394 0.75915 0.619218 0.675638 0.721353 0.675638H19.443C19.5455 0.675638 19.6292 0.759223 19.6292 0.862247V13.4278C19.6292 13.5308 19.5455 13.6144 19.443 13.6144H0.721353C0.619218 13.6144 0.535394 13.5309 0.535394 13.4278V0.862247ZM0.721353 14.2511H19.443C19.8964 14.2511 20.2646 13.8816 20.2646 13.4278V0.862247C20.2646 0.408374 19.8964 0.0389313 19.443 0.0389313H0.721353C0.26825 0.0389313 -0.1 0.408403 -0.1 0.862247V13.4278C-0.1 13.8816 0.26825 14.2511 0.721353 14.2511ZM17.3582 8.55702C17.3582 8.38228 17.2172 8.23931 17.0414 8.23931C16.866 8.23931 16.7251 8.38248 16.7251 8.55702V11.8459C16.7251 12.0206 16.8662 12.1633 17.0414 12.1633C17.217 12.1633 17.3582 12.0208 17.3582 11.8459V8.55702ZM16.1986 8.55702C16.1986 8.38218 16.0571 8.23931 15.8817 8.23931C15.7066 8.23931 15.5651 8.38228 15.5651 8.55702V11.8459C15.5651 12.0208 15.7067 12.1633 15.8817 12.1633C16.0569 12.1633 16.1986 12.0209 16.1986 11.8459V8.55702ZM15.0389 8.55702C15.0389 8.38199 14.8969 8.23931 14.7217 8.23931C14.5466 8.23931 14.4052 8.38228 14.4052 8.55702V11.8459C14.4052 12.0208 14.5468 12.1633 14.7217 12.1633C14.8967 12.1633 15.0389 12.0211 15.0389 11.8459V8.55702ZM13.879 8.55702C13.879 8.38199 13.7369 8.23931 13.5618 8.23931C13.3866 8.23931 13.2452 8.38228 13.2452 8.55702V11.8459C13.2452 12.0208 13.3868 12.1633 13.5618 12.1633C13.7367 12.1633 13.879 12.0211 13.879 11.8459V8.55702ZM12.719 8.55702C12.719 8.38209 12.5774 8.23931 12.4018 8.23931C12.2269 8.23931 12.0855 8.38238 12.0855 8.55702V11.8459C12.0855 12.0207 12.227 12.1633 12.4018 12.1633C12.5772 12.1633 12.719 12.021 12.719 11.8459V8.55702ZM11.5593 8.55702C11.5593 8.38199 11.4173 8.23931 11.2421 8.23931C11.0674 8.23931 10.9256 8.38218 10.9256 8.55702V11.8459C10.9256 12.0209 11.0676 12.1633 11.2421 12.1633C11.4171 12.1633 11.5593 12.0211 11.5593 11.8459V8.55702ZM10.3994 8.55702C10.3994 8.38209 10.2574 8.23931 10.0825 8.23931C9.90752 8.23931 9.76559 8.38209 9.76559 8.55702V11.8459C9.76559 12.021 9.90771 12.1633 10.0825 12.1633C10.2572 12.1633 10.3994 12.021 10.3994 11.8459V8.55702ZM9.2394 8.55702C9.2394 8.38209 9.09746 8.23931 8.92251 8.23931C8.74755 8.23931 8.60561 8.38209 8.60561 8.55702V11.8459C8.60561 12.021 8.74774 12.1633 8.92251 12.1633C9.09727 12.1633 9.2394 12.021 9.2394 11.8459V8.55702ZM8.07942 8.55702C8.07942 8.38218 7.93791 8.23931 7.76253 8.23931C7.58738 8.23931 7.44596 8.38228 7.44596 8.55702V11.8459C7.44596 12.0208 7.58757 12.1633 7.76253 12.1633C7.93772 12.1633 8.07942 12.0209 8.07942 11.8459V8.55702ZM6.91977 8.55702C6.91977 8.38218 6.77826 8.23931 6.60288 8.23931C6.42792 8.23931 6.28599 8.38209 6.28599 8.55702V11.8459C6.28599 12.021 6.42812 12.1633 6.60288 12.1633C6.77806 12.1633 6.91977 12.0209 6.91977 11.8459V8.55702ZM5.7598 8.55702C5.7598 8.38218 5.61828 8.23931 5.44291 8.23931C5.26795 8.23931 5.12602 8.38209 5.12602 8.55702V11.8459C5.12602 12.021 5.26814 12.1633 5.44291 12.1633C5.61809 12.1633 5.7598 12.0209 5.7598 11.8459V8.55702ZM4.59982 8.55702C4.59982 8.38218 4.45831 8.23931 4.28293 8.23931C4.10778 8.23931 3.96636 8.38228 3.96636 8.55702V11.8459C3.96636 12.0208 4.10797 12.1633 4.28293 12.1633C4.45812 12.1633 4.59982 12.0209 4.59982 11.8459V8.55702ZM3.43985 8.55702C3.43985 8.38218 3.29833 8.23931 3.12296 8.23931C2.94761 8.23931 2.80671 8.38248 2.80671 8.55702V11.8459C2.80671 12.0206 2.94781 12.1633 3.12296 12.1633C3.29814 12.1633 3.43985 12.0209 3.43985 11.8459V8.55702Z",
          strokeWidth: "0.2"
        }
      )
    }
  );
}
function OO(e) {
  return /* @__PURE__ */ Z.jsxs(
    "svg",
    {
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.9039 2.72621H18.3769V1.35165C18.3769 0.59564 17.7813 0 17.0253 0C16.2693 0 15.6736 0.59564 15.6736 1.35165V2.72621H12.3518V1.35165C12.3518 0.59564 11.7561 0 11.0001 0C10.2441 0 9.64848 0.59564 9.64848 1.35165V2.72621H6.32663V1.35165C6.32663 0.59564 5.73099 0 4.97498 0C4.21897 0 3.62333 0.59564 3.62333 1.35165V2.72621H3.09642C1.46986 2.72621 0.141113 4.05495 0.141113 5.68151V18.8086C0.141113 20.4351 1.46985 21.7639 3.09642 21.7639H18.9039C20.5304 21.7639 21.8592 20.4351 21.8592 18.8086V5.68151C21.8592 4.05495 20.5304 2.72621 18.9039 2.72621H18.9039ZM18.9039 19.7937H3.0964C2.54658 19.7937 2.1113 19.3584 2.1113 18.8086V8.79719H19.889V18.8086C19.889 19.3584 19.4537 19.7937 18.9039 19.7937Z"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.26582 10.767H4.53961C4.33343 10.767 4.15015 10.9502 4.15015 11.1564V12.8975C4.15015 13.1037 4.33343 13.287 4.53961 13.287H7.26582C7.472 13.287 7.65528 13.1037 7.65528 12.8975V11.1564C7.65528 10.9502 7.472 10.767 7.26582 10.767Z"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.3747 10.767H9.62554C9.41936 10.767 9.23608 10.9502 9.23608 11.1564V12.8975C9.23608 13.1037 9.41936 13.287 9.62554 13.287H12.3747C12.5809 13.287 12.7641 13.1037 12.7641 12.8975V11.1564C12.7641 10.9502 12.5809 10.767 12.3747 10.767Z"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4838 10.767H14.7347C14.5285 10.767 14.3452 10.9502 14.3452 11.1564V12.8975C14.3452 13.1037 14.5285 13.287 14.7347 13.287H17.4609C17.6671 13.287 17.8504 13.1037 17.8504 12.8975V11.1564C17.8733 10.9502 17.69 10.767 17.4838 10.767H17.4838Z"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.26582 15.281H4.53961C4.33343 15.281 4.15015 15.4643 4.15015 15.6705V17.4116C4.15015 17.6178 4.33343 17.801 4.53961 17.801H7.26582C7.472 17.801 7.65528 17.6178 7.65528 17.4116V15.6705C7.65528 15.4643 7.472 15.281 7.26582 15.281Z"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.3747 15.281H9.62554C9.41936 15.281 9.23608 15.4643 9.23608 15.6705V17.4116C9.23608 17.6178 9.41936 17.801 9.62554 17.801H12.3747C12.5809 17.801 12.7641 17.6178 12.7641 17.4116V15.6705C12.7641 15.4643 12.5809 15.281 12.3747 15.281Z"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4838 15.281H14.7347C14.5285 15.281 14.3452 15.4643 14.3452 15.6705V17.4116C14.3452 17.6178 14.5285 17.801 14.7347 17.801H17.4609C17.6671 17.801 17.8504 17.6178 17.8504 17.4116V15.6705C17.8733 15.4643 17.69 15.281 17.4838 15.281H17.4838Z"
          }
        )
      ]
    }
  );
}
function AO(e) {
  return /* @__PURE__ */ Z.jsxs(
    "svg",
    {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ Z.jsx("path", { d: "M22.3346 26.8581C22.5382 26.7636 22.7637 26.7709 22.9673 26.8727L24.4946 27.6363V24.8218H20.5601V27.68L22.3346 26.8581Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M37.2945 37.92C36.8218 37.6727 36.2909 37.6291 35.8109 37.8036L25.7164 41.4254C25.2218 41.7018 24.6473 41.8545 24.0436 41.8545H17.9564C17.5564 41.8545 17.2291 41.5273 17.2291 41.1273C17.2291 40.7273 17.5564 40.4 17.9564 40.4H24.0436C24.3855 40.4 24.72 40.3127 25.0036 40.1673C25.04 40.1454 25.0764 40.1236 25.1127 40.1018C25.5418 39.8327 25.8545 39.4109 25.9345 38.9236C26.0218 38.3854 25.8764 37.8691 25.5345 37.4691C25.1927 37.0691 24.6982 36.8436 24.1745 36.8436H19.6291C18.2982 36.8436 16.9673 36.3636 15.8836 35.4982C14.1091 34.08 10.4364 32.1891 5.58545 35.1491V43.9782C6.82909 43.9854 9.43272 44.2109 13.0545 45.6291C16.4509 46.96 20.0655 47.2654 23.5127 46.5163C27.0473 45.7454 32.3345 44.1818 37.3964 41.0763C37.7964 40.8291 38.0945 40.4145 38.2036 39.9345C38.3927 39.1345 38.0145 38.3054 37.2945 37.92Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M19.6293 35.3746H24.1748C25.1275 35.3746 26.022 35.7891 26.6402 36.5164C27.2584 37.2436 27.5202 38.2036 27.3675 39.1491C27.3602 39.2 27.3529 39.2436 27.3384 39.2946L32.3129 37.5127V26.0218C32.3129 25.36 31.7748 24.8291 31.1202 24.8291H25.942V28.8218C25.942 29.0764 25.8111 29.3091 25.6002 29.44C25.4839 29.5127 25.3529 29.5491 25.2148 29.5491C25.1057 29.5491 24.9893 29.52 24.8875 29.4691L22.6184 28.3346L20.1239 29.4836C19.8984 29.5855 19.6366 29.5709 19.4257 29.4327C19.2148 29.3018 19.0911 29.0691 19.0911 28.8218V24.8291H13.9129C13.2511 24.8291 12.7202 25.3673 12.7202 26.0218V32.3418C14.4657 32.7491 15.8548 33.6073 16.7857 34.3564C17.6293 35.0255 18.6111 35.3746 19.6293 35.3746Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M4.13102 32.7419L1.0183 32.6982L0.981934 45.8764L4.08739 45.9201L4.13102 45.8764V32.7419Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M25.782 10.9455C25.2147 10.611 24.5674 10.4219 23.8911 10.4219C21.8329 10.4219 20.1602 12.0946 20.1602 14.1528C20.1602 16.211 21.8329 17.8837 23.8911 17.8837C24.9529 17.8837 25.942 17.4255 26.6402 16.6619C26.0292 16.4873 25.4765 16.1382 25.0692 15.6437C24.0583 14.4219 24.182 12.5528 25.3456 11.3819L25.782 10.9455Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M32.3783 5.76718C32.4874 6.03627 32.4292 6.349 32.2183 6.55991L26.371 12.4072C25.731 13.0472 25.651 14.0581 26.1892 14.7126C26.4946 15.0835 26.9237 15.3017 27.3965 15.3235C27.8692 15.3526 28.3201 15.1708 28.6546 14.8363L33.5055 9.98536C33.7892 9.70173 34.2474 9.70173 34.531 9.98536C35.5201 10.9599 36.8292 11.4545 38.2183 11.469C39.5055 11.4472 40.7128 10.9526 41.6437 10.0726V1.09082H29.0401C27.8183 1.09082 26.6619 1.57082 25.7965 2.43627L22.9092 5.32355H31.7092C32.0001 5.31627 32.2692 5.49809 32.3783 5.76718Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M14.0222 15.6434C14.8456 15.6434 15.5131 14.9759 15.5131 14.1525C15.5131 13.3291 14.8456 12.6616 14.0222 12.6616C13.1988 12.6616 12.5312 13.3291 12.5312 14.1525C12.5312 14.9759 13.1988 15.6434 14.0222 15.6434Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M43.1055 1.09082H47.0255V9.64355H43.1055V1.09082Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M34.0584 11.4983L29.6875 15.8692C29.3384 16.2183 28.902 16.4655 28.4366 16.6183C27.5347 18.2765 25.7966 19.3383 23.8911 19.3383C21.0329 19.3383 18.7057 17.011 18.7057 14.1528C18.7057 11.2946 21.0329 8.96736 23.8911 8.96736C24.9457 8.96736 25.9711 9.29463 26.8293 9.891L29.9493 6.771H9.82565C9.55656 6.771 9.33838 6.98918 9.33838 7.25827V21.0328C9.33838 21.3019 9.55656 21.5201 9.82565 21.5201H37.9638C38.2329 21.5201 38.4511 21.3019 38.4511 21.0328V12.9019C38.3784 12.9019 38.3129 12.9165 38.2402 12.9165C36.7057 12.9165 35.2438 12.4437 34.0584 11.4983ZM14.022 17.0983C12.4002 17.0983 11.0766 15.7746 11.0766 14.1528C11.0766 12.531 12.4002 11.2074 14.022 11.2074C15.6438 11.2074 16.9675 12.531 16.9675 14.1528C16.9675 15.7746 15.6438 17.0983 14.022 17.0983Z" })
      ]
    }
  );
}
function NO(e) {
  return /* @__PURE__ */ Z.jsx(
    "svg",
    {
      width: "16",
      height: "13",
      viewBox: "0 0 16 13",
      fill: "none",
      stroke: "rgb(var(--background-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ Z.jsx(
        "path",
        {
          d: "M0.999756 7.84424L4.99976 11.8442L14.9998 1.84424",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function LO(e) {
  return /* @__PURE__ */ Z.jsx(
    "svg",
    {
      width: "19",
      height: "15",
      viewBox: "0 0 19 15",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ Z.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.0035 0.218132H1.88928C0.84752 0.218132 0 1.06565 0 2.10741V12.1836C0 13.2254 0.84752 14.0729 1.88928 14.0729H17.0035C18.0453 14.0729 18.8928 13.2254 18.8928 12.1836V2.10741C18.8928 1.06565 18.0453 0.218132 17.0035 0.218132ZM15.744 4.62646H3.14879C2.80074 4.62646 2.51903 4.34476 2.51903 3.9967C2.51903 3.64865 2.80074 3.36694 3.14879 3.36694H15.744C16.0921 3.36694 16.3738 3.64865 16.3738 3.9967C16.3738 4.34476 16.0921 4.62646 15.744 4.62646ZM6.92737 10.9241H3.1488V7.14551H6.92737V10.9241Z"
        }
      )
    }
  );
}
function RO(e) {
  return /* @__PURE__ */ Z.jsxs(
    "svg",
    {
      width: "22",
      height: "19",
      viewBox: "0 0 22 19",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ Z.jsx("path", { d: "M-0.000106812 4.07082C-0.000106812 2.90389 0.339278 1.90757 1.05149 1.19147L2.29012 2.43686C0.911525 3.81801 2.11547 8.11214 6.04069 12.0625C9.96591 16.0129 14.2392 17.2222 15.6165 15.8386L16.8552 17.084C14.5315 19.4203 9.23883 17.7627 4.80825 13.3067C1.73521 10.2156 -0.000106812 6.70857 -0.000106812 4.07082Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M7.81099 18.1573C6.65039 18.1573 5.65949 17.8161 4.94604 17.1L6.18467 15.8546C7.56079 17.2382 11.8316 16.0277 15.7605 12.0786C19.6894 8.1294 20.8909 3.83527 19.5148 2.45163L20.7534 1.20624C23.0783 3.5426 21.4285 8.86418 16.9967 13.319C13.9224 16.4138 10.4344 18.1573 7.81099 18.1573Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M17.4053 11.5363C16.6534 9.35934 15.1175 7.03294 13.08 4.98551C8.64939 0.529482 3.35672 -1.12939 1.03305 1.20822C0.868316 1.37511 1.01076 1.78733 1.35262 2.13106C1.69448 2.47479 2.10447 2.61677 2.26921 2.45113C3.64656 1.06749 7.91736 2.27802 11.8451 6.22842C13.703 8.09651 15.0878 10.1826 15.7554 12.1129C16.34 13.8054 16.2831 15.1704 15.6018 15.8553C15.4358 16.021 15.5795 16.4344 15.9201 16.7769C16.2608 17.1194 16.672 17.2639 16.838 17.097C18.0283 15.9002 18.2302 13.9225 17.4053 11.5363Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M20.751 1.20826C19.5582 0.00894456 17.5937 -0.194055 15.218 0.636625C13.0541 1.39134 10.7391 2.93687 8.70281 4.9843C4.27223 9.43909 2.62237 14.7607 4.94604 17.0983C5.11202 17.2639 5.522 17.1207 5.86387 16.7782C6.20573 16.4357 6.34817 16.0223 6.18219 15.8554C4.80236 14.4717 6.01002 10.1776 9.93896 6.22721C11.7969 4.35912 13.8716 2.96676 15.7915 2.29549C17.4748 1.70891 18.8323 1.76495 19.5148 2.44992C19.6795 2.61556 20.0908 2.47234 20.4314 2.12861C20.772 1.78488 20.9157 1.3739 20.751 1.20826Z" })
      ]
    }
  );
}
function DO(e) {
  return /* @__PURE__ */ Z.jsx(
    "svg",
    {
      width: "56",
      height: "59",
      viewBox: "0 0 56 59",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ Z.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28 58.165C43.464 58.165 56 45.181 56 29.165C56 27.12 55.817 25.101 55.464 23.137H27.512L47.768 45.165C26.4 63.072 0.073 17.275 13.577 8.73C15.863 7.283 19.133 7.127 23.385 8.263L24.03 8.443C24.248 8.506 24.468 8.573 24.69 8.643L25.365 8.861L25.708 8.978L26.404 9.226C26.757 9.354 27.114 9.491 27.477 9.634L28.211 9.93L28.959 10.246C29.211 10.354 29.466 10.466 29.722 10.581L30.5 10.935L31.293 11.309L32.1 11.702L32.923 12.115L33.339 12.328L34.183 12.77L35.043 13.23L35.916 13.711L36.805 14.211L37.255 14.468L38.165 14.997L39.09 15.545C39.246 15.638 39.402 15.731 39.558 15.826L40.985 16.699L41.955 17.305L42.939 17.931L43.938 18.576L44.952 19.24L45.98 19.924L47.023 20.627L48.616 21.718L49.154 22.091L38.543 1.11C36.197 0.207001 33.228 0.038 30.418 0.00699997L28.95 0H28C12.536 0 0 13.149 0 29.165C0 45.181 12.536 58.165 28 58.165Z"
        }
      )
    }
  );
}
function IO(e) {
  return /* @__PURE__ */ Z.jsxs(
    "svg",
    {
      width: "26",
      height: "22",
      viewBox: "0 0 26 22",
      fill: "rgb(var(--fill-primary))",
      stroke: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            d: "M7.62919 4.03262V19.4089H14.3212C20.3975 19.4089 23.0326 15.9768 23.0326 11.1231C23.0326 6.47761 20.3975 2.87352 14.3212 2.87352H8.78829C8.14535 2.87352 7.62919 3.39874 7.62919 4.03262Z",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            d: "M2.73866 21.7997H13.5509C17.3649 21.7997 20.3397 20.8565 22.3619 19.0428C24.3859 17.2276 25.4412 14.5533 25.4412 11.1229C25.4412 9.1476 25.0571 6.48868 23.3725 4.32192C21.6842 2.15039 18.704 0.491309 13.5509 0.491309H2.73866C1.72355 0.491309 0.9 1.31485 0.9 2.32997V19.961C0.9 20.9762 1.72355 21.7997 2.73866 21.7997ZM1.67955 2.32997C1.67955 1.74225 2.15095 1.27086 2.73866 1.27086H13.5509C15.6357 1.27086 18.4163 1.59408 20.6727 2.98558C22.9212 4.37219 24.6617 6.82698 24.6617 11.1229C24.6617 14.3254 23.6728 16.7946 21.7996 18.4647C19.9246 20.1364 17.1491 21.0202 13.5509 21.0202H2.73866C2.15095 21.0202 1.67955 20.5488 1.67955 19.961V2.32997Z",
            strokeWidth: "0.2"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            d: "M9.9854 9.04946C10.2208 9.04946 10.4382 9.08568 10.6464 9.15813C10.8547 9.23057 11.0268 9.34829 11.1807 9.49318C11.3256 9.64712 11.4433 9.83729 11.5339 10.0546C11.6154 10.281 11.6607 10.5436 11.6607 10.8515C11.6607 11.1232 11.6244 11.3677 11.5611 11.5941C11.4886 11.8204 11.389 12.0197 11.2532 12.1827C11.1173 12.3457 10.9453 12.4724 10.737 12.5721C10.5287 12.6626 10.2842 12.7169 10.0035 12.7169H8.41879V9.04041H9.9854V9.04946ZM9.93106 12.0468C10.0488 12.0468 10.1575 12.0287 10.2752 11.9925C10.3838 11.9563 10.4834 11.8929 10.5649 11.8023C10.6464 11.7118 10.7189 11.6031 10.7732 11.4582C10.8276 11.3133 10.8547 11.1503 10.8547 10.9421C10.8547 10.761 10.8366 10.5889 10.8004 10.444C10.7642 10.2991 10.7008 10.1633 10.6193 10.0637C10.5378 9.96407 10.4291 9.87351 10.2933 9.81918C10.1575 9.76485 9.99445 9.73768 9.79523 9.73768H9.21568V12.0559H9.93106V12.0468Z",
            fill: "rgb(var(--background-secondary))",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            d: "M14.9314 9.04946V9.72862H12.9935V10.5165H14.7775V11.1413H12.9935V12.0378H14.9767V12.7169H12.1876V9.04041H14.9314V9.04946Z",
            fill: "rgb(var(--background-secondary))",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            d: "M17.7008 9.04926L19.0773 12.7258H18.2351L17.9544 11.9108H16.5779L16.2882 12.7258H15.4732L16.8587 9.04926H17.7008ZM17.7461 11.3041L17.2843 9.95482H17.2752L16.7953 11.3041H17.7461Z",
            fill: "rgb(var(--background-secondary))",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            d: "M20.3893 9.04926V12.0466H22.1823V12.7258H19.5834V9.04926H20.3893Z",
            fill: "rgb(var(--background-secondary))",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            d: "M4.60354 12.5799C5.53877 12.5799 6.29693 11.8217 6.29693 10.8865C6.29693 9.95125 5.53877 9.1931 4.60354 9.1931C3.66832 9.1931 2.91016 9.95125 2.91016 10.8865C2.91016 11.8217 3.66832 12.5799 4.60354 12.5799Z",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            d: "M5.87874 19.4088C4.45703 19.4088 3.31603 18.2588 3.31603 16.8461V14.8449C3.31603 14.1385 3.88653 13.559 4.60192 13.559C5.30825 13.559 5.8878 14.1295 5.8878 14.8449V19.4088H5.87874Z",
            stroke: "none"
          }
        )
      ]
    }
  );
}
function jO(e) {
  return /* @__PURE__ */ Z.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "931.999",
      height: "931.999",
      viewBox: "0 0 931.999 931.999",
      fill: "rgb(var(--fill-primary))",
      stroke: "rgb(var(--fill-primary))",
      ...e,
      children: /* @__PURE__ */ Z.jsx(
        "path",
        {
          id: "Exclusion_3",
          "data-name": "Exclusion 3",
          d: "M466,931.5a472.963,472.963,0,0,1-47.595-2.4,466.666,466.666,0,0,1-46.22-7.054c-15-3.069-30.006-6.928-44.611-11.471-14.441-4.492-28.83-9.758-42.768-15.653-13.808-5.84-27.5-12.435-40.691-19.6-13.1-7.115-26.011-14.96-38.38-23.317A468.069,468.069,0,0,1,80,726.266c-8.357-12.369-16.2-25.282-23.317-38.38-7.167-13.193-13.762-26.883-19.6-40.691-5.9-13.938-11.162-28.327-15.653-42.768-4.543-14.605-8.4-29.614-11.471-44.611A466.67,466.67,0,0,1,2.9,513.595a472.483,472.483,0,0,1,0-95.189,466.668,466.668,0,0,1,7.054-46.22c3.069-15,6.928-30.006,11.471-44.611,4.492-14.441,9.758-28.83,15.653-42.768,5.84-13.808,12.435-27.5,19.6-40.691C63.8,231.017,71.644,218.1,80,205.735A468.069,468.069,0,0,1,205.735,80c12.369-8.357,25.282-16.2,38.38-23.317,13.193-7.167,26.883-13.762,40.691-19.6,13.938-5.9,28.327-11.162,42.768-15.653,14.605-4.543,29.614-8.4,44.611-11.471A466.668,466.668,0,0,1,418.406,2.9a472.483,472.483,0,0,1,95.189,0,466.67,466.67,0,0,1,46.22,7.054c15,3.069,30.006,6.928,44.611,11.471,14.441,4.492,28.83,9.758,42.768,15.653,13.808,5.84,27.5,12.435,40.691,19.6C700.983,63.8,713.9,71.644,726.266,80A468.069,468.069,0,0,1,852,205.735c8.357,12.369,16.2,25.282,23.317,38.38,7.167,13.193,13.762,26.883,19.6,40.691,5.9,13.938,11.162,28.327,15.653,42.768,4.543,14.605,8.4,29.614,11.471,44.611a466.666,466.666,0,0,1,7.054,46.22,472.43,472.43,0,0,1,0,95.189,466.667,466.667,0,0,1-7.054,46.22c-3.069,15-6.928,30.006-11.471,44.611-4.492,14.441-9.758,28.83-15.653,42.768-5.84,13.808-12.435,27.5-19.6,40.691-7.115,13.1-14.96,26.011-23.317,38.38A468.07,468.07,0,0,1,726.266,852c-12.369,8.357-25.282,16.2-38.38,23.317-13.193,7.167-26.883,13.762-40.691,19.6-13.938,5.9-28.327,11.162-42.768,15.653-14.605,4.543-29.614,8.4-44.611,11.471a466.667,466.667,0,0,1-46.22,7.054A472.963,472.963,0,0,1,466,931.5ZM591.545,364.758a80.927,80.927,0,0,1,15.924,1.594,83.7,83.7,0,0,1,15.106,4.568A85.8,85.8,0,0,1,648.74,387.7,83.147,83.147,0,0,1,659,399.281a78.754,78.754,0,0,1,7.845,13.276,72.539,72.539,0,0,1,6.849,30.37v218.92H766V442.927a167.974,167.974,0,0,0-11.76-62.213,180.051,180.051,0,0,0-33.721-53.795,170.406,170.406,0,0,0-112.982-56.757c-5.238-.42-10.266-.624-15.369-.624a174.2,174.2,0,0,0-69.106,14.241,173.135,173.135,0,0,0-57.581,40.436,175.252,175.252,0,0,0-57.425-40.359,171.956,171.956,0,0,0-68.64-14.319C243.794,269.539,166,347.321,166,442.927v218.92h92.308V442.927a71.8,71.8,0,0,1,5.875-28.312,78.778,78.778,0,0,1,6.832-12.631,83.117,83.117,0,0,1,8.974-11.238A84.939,84.939,0,0,1,303,373.58a81.077,81.077,0,0,1,13.354-5.362,76.388,76.388,0,0,1,14.133-2.838c2.655-.2,5.4-.416,7.891-.416a81.331,81.331,0,0,1,15.895,1.576,83.049,83.049,0,0,1,15.03,4.524,84.18,84.18,0,0,1,25.931,16.664,81.736,81.736,0,0,1,10.135,11.526A78.109,78.109,0,0,1,413.1,412.5a73.5,73.5,0,0,1,6.742,30.425v218.92h92.777V442.927a73.82,73.82,0,0,1,5.666-28.257,79.5,79.5,0,0,1,6.623-12.661,82.439,82.439,0,0,1,8.74-11.289A83.346,83.346,0,0,1,544.2,381.1a81.81,81.81,0,0,1,12.055-7.662,76.21,76.21,0,0,1,27.4-8.261C586.31,364.969,589.052,364.758,591.545,364.758Z",
          transform: "translate(-0.001 -0.001)",
          strokeWidth: "1"
        }
      )
    }
  );
}
function BO(e) {
  return /* @__PURE__ */ Z.jsxs(
    "svg",
    {
      width: "18",
      height: "21",
      viewBox: "0 0 18 21",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.67824 19.4354L9.29538 15.5267L9.3387 15.3101C9.37119 15.1261 9.46863 14.9528 9.6094 14.8229C9.75013 14.7038 9.94504 14.628 10.1291 14.628H10.6163C11.4284 14.628 12.1863 14.5414 12.8468 14.3682C13.5506 14.1841 14.1786 13.9026 14.7199 13.5236C15.283 13.123 15.7594 12.6033 16.1275 11.9753C16.5173 11.3148 16.8096 10.5244 16.9829 9.62575C17.1345 8.82452 17.167 8.10991 17.0695 7.50357C16.9612 6.85392 16.7122 6.31255 16.3333 5.86862C16.095 5.59794 15.8027 5.37056 15.4454 5.17567H15.4346V5.16485C15.5645 4.36362 15.5537 3.70314 15.4237 3.12928C15.2938 2.55543 15.0123 2.03572 14.59 1.54847C13.7022 0.54152 12.0889 0.0218048 9.8043 0.0218048H3.51355C3.30784 0.0218048 3.10211 0.0975972 2.9397 0.23835C2.7773 0.379114 2.66902 0.563184 2.63654 0.768897L0.00546765 17.3998C-0.016197 17.5514 0.0271323 17.703 0.124567 17.8221C0.222013 17.9412 0.373609 18.0062 0.525194 18.0062H4.43389V18.0278L4.1632 19.7278C4.14154 19.8577 4.18486 19.9984 4.27149 20.0959C4.35809 20.1933 4.48802 20.2583 4.61796 20.2583H7.89866C8.08273 20.2583 8.25597 20.1933 8.39673 20.0742C8.53748 19.9551 8.62411 19.7927 8.65659 19.6087L8.67825 19.4354"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.4549 5.16492C15.4333 5.28402 15.4116 5.40313 15.3899 5.53305C14.5562 9.79905 11.7194 11.2716 8.09223 11.2716H6.24074C5.79683 11.2716 5.42869 11.5964 5.35291 12.0295L4.14023 19.7278C4.09691 20.0093 4.31346 20.2692 4.60582 20.2692H7.88651C8.27631 20.2692 8.60113 19.9877 8.66609 19.6087L8.69858 19.4463L9.31576 15.5376L9.35907 15.3211C9.42403 14.9421 9.74884 14.6606 10.1386 14.6606H10.6259C13.7983 14.6606 16.2886 13.3721 17.0141 9.64748C17.3172 8.08833 17.1656 6.78904 16.3536 5.87953C16.1046 5.57636 15.8014 5.34899 15.4549 5.16493"
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.5792 4.81794C14.4492 4.78546 14.3193 4.75298 14.1894 4.7205C14.0595 4.68801 13.9187 4.66636 13.7779 4.6447C13.2799 4.56891 12.7385 4.5256 12.1538 4.5256H7.21651C7.0974 4.5256 6.9783 4.55809 6.88086 4.6014C6.65348 4.70967 6.48024 4.92622 6.44776 5.18607L5.3975 11.8341L5.36501 12.029C5.42997 11.5959 5.80894 11.2711 6.25286 11.2711H8.10436C11.7316 11.2711 14.5683 9.79856 15.402 5.53255C15.4237 5.40262 15.4454 5.28352 15.467 5.16442C15.2613 5.05614 15.0339 4.95869 14.7849 4.87208C14.7091 4.85043 14.6441 4.8396 14.5792 4.81794",
            fill: "#B3BCC7",
            className: "group-aria-checked:fill-brand-primary-hover group-aria-checked:easy-out group-aria-checked:transition-colors group-aria-checked:duration-75"
          }
        )
      ]
    }
  );
}
function FO(e) {
  return /* @__PURE__ */ Z.jsx(
    "svg",
    {
      width: "49",
      height: "47",
      viewBox: "0 0 50 50",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: /* @__PURE__ */ Z.jsx("path", { d: "M44.5947 49.5015H3.30047C1.91372 49.5015 0.732422 48.3202 0.732422 46.8821L0.732422 42.2082C0.732422 40.7701 1.91372 39.5888 3.30047 39.5888H44.5947C46.0328 39.5888 47.1628 40.7701 47.2141 42.2082V46.8307C47.2141 48.3202 46.0328 49.5015 44.5947 49.5015ZM44.5947 23.5642L3.30047 23.5642C2.63278 23.5642 1.96509 23.3074 1.50284 22.7937C0.989227 22.2801 0.732422 21.6638 0.732422 20.9448L0.732422 16.2709C0.732422 14.8328 1.91372 13.6515 3.30047 13.6515H44.5947C46.0328 13.6515 47.1628 14.7814 47.2141 16.2709V20.9448C47.1628 22.4342 46.0328 23.5642 44.5947 23.5642ZM26.567 10.6212H3.30047C2.63278 10.6212 1.96509 10.3644 1.50284 9.85078C1.04059 9.33717 0.732422 8.72084 0.732422 8.00178L0.732422 3.32793C0.732422 1.88982 1.91372 0.708518 3.30047 0.708518H26.5156C27.9537 0.708518 29.0837 1.88982 29.0837 3.27657V7.95042C29.135 9.49125 28.0051 10.6726 26.567 10.6212ZM47.2141 36.5585H3.30047C2.63278 36.5585 1.96509 36.3017 1.50284 35.7881C1.04059 35.2745 0.732422 34.6581 0.732422 33.9391L0.732422 29.2652C0.732422 27.8271 1.91372 26.6458 3.30047 26.6458L47.1628 26.6458C48.6009 26.6458 49.7308 27.8271 49.7308 29.2652V33.9391C49.7822 35.3772 48.6009 36.5071 47.2141 36.5585Z" })
    }
  );
}
function zO(e) {
  return /* @__PURE__ */ Z.jsx(
    "svg",
    {
      width: "20",
      height: "21",
      viewBox: "0 0 20 21",
      fill: "rgb(var(--rgb-color-green))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ Z.jsx("path", { d: "M9.93709 10.61C10.8847 10.5968 11.8073 10.3037 12.5888 9.76761C13.3703 9.23151 13.9758 8.47632 14.3293 7.597C14.6828 6.71768 14.7684 5.75348 14.5754 4.82564C14.3823 3.8978 13.9193 3.04773 13.2445 2.38233C12.5697 1.71692 11.7132 1.26588 10.7827 1.08592C9.85225 0.90596 8.88935 1.00511 8.01508 1.3709C7.14082 1.7367 6.39421 2.35281 5.86915 3.14176C5.34408 3.93072 5.06399 4.8573 5.06409 5.80501C5.06841 6.44052 5.1979 7.06895 5.44515 7.6544C5.69241 8.23986 6.05259 8.77086 6.50512 9.21707C6.95765 9.66329 7.49366 10.016 8.08253 10.255C8.6714 10.494 9.30159 10.6146 9.93709 10.61ZM9.93709 13.01C6.68409 13.013 0.190094 14.622 0.190094 17.818V20.218H19.6831V17.818C19.6831 14.622 13.1901 13.013 9.93709 13.013V13.01Z" })
    }
  );
}
function GO(e) {
  return /* @__PURE__ */ Z.jsxs(
    "svg",
    {
      version: "1.1",
      fill: "rgb(var(--fill-primary))",
      id: "Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: "20px",
      viewBox: "0 0 298 294",
      ...e,
      children: [
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            opacity: "1.000000",
            stroke: "none",
            d: `
M244.285446,208.610062
	C242.970535,209.638763 241.936996,211.008606 240.866455,211.038147
	C226.915070,211.423294 213.323441,212.234283 202.526245,199.743088
	C191.444809,186.923065 178.474030,175.756104 166.753845,163.461746
	C157.923599,154.198914 143.357864,154.168411 134.603729,163.190262
	C121.496552,176.698273 108.021919,189.849380 94.731537,203.180161
	C89.298790,208.629440 82.626717,210.348587 75.120163,211.342804
	C60.985691,213.214874 50.329533,208.886612 41.561268,197.525284
	C35.426071,189.575714 27.253853,183.221161 20.883156,175.425507
	C8.642242,160.446579 10.216591,137.694260 24.153507,123.132507
	C33.826618,113.025703 43.814171,103.215714 53.828175,93.444191
	C55.185833,92.119408 57.495472,91.183701 59.401691,91.115700
	C65.546120,90.896507 71.750221,90.741402 77.853561,91.346245
	C87.652054,92.317268 94.438049,98.733185 100.955849,105.375687
	C112.375610,117.013977 123.608986,128.844330 135.293442,140.210785
	C144.487930,149.155029 157.356705,148.646927 166.649048,139.429947
	C179.301895,126.879730 192.115875,114.471695 204.310608,101.486053
	C214.881454,90.229607 227.898621,89.801460 241.426010,92.080154
	C244.539246,92.604576 247.171005,96.638344 249.796814,99.283035
	C257.645477,107.188202 265.340271,115.245918 273.169800,123.170311
	C288.713440,138.902252 288.759369,163.937805 273.159729,179.690308
	C263.665131,189.277969 254.089081,198.784973 244.285446,208.610062
z`
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            opacity: "1.000000",
            stroke: "none",
            d: `
M99.133804,254.866470
	C89.211319,245.070602 79.538452,235.525192 69.900787,226.014526
	C77.181381,224.578506 84.190994,224.060730 90.499619,221.683029
	C95.720055,219.715469 100.687065,216.152695 104.766792,212.251404
	C117.882652,199.709244 130.526199,186.673599 143.371429,173.847855
	C148.933350,168.294357 151.991394,168.267914 157.623703,173.866959
	C170.023743,186.193771 182.537323,198.413330 194.675293,210.994354
	C202.944809,219.565735 212.734009,224.177948 224.546219,224.728470
	C225.302353,224.763702 226.052200,224.934326 228.588257,225.296951
	C219.519348,234.040939 211.361176,241.787537 203.339722,249.673203
	C194.672058,258.194153 186.151550,266.864594 177.532349,275.435120
	C161.107605,291.767181 136.428574,291.868164 119.855301,275.622467
	C112.958298,268.861816 106.203102,261.956482 99.133804,254.866470
z`
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "path",
          {
            opacity: "1.000000",
            stroke: "none",
            d: `
M93.157654,81.812546
	C85.493309,79.981094 78.150978,78.351784 70.817352,76.724403
	C70.913933,76.604439 71.581711,75.602051 72.415405,74.764885
	C88.518112,58.595020 104.543739,42.346703 120.786789,26.318796
	C135.627319,11.674816 158.966370,10.582329 174.536713,24.857964
	C190.414688,39.415646 205.186234,55.179058 220.474991,70.381584
	C222.722427,72.616348 225.151276,74.668686 227.593521,76.894150
	C220.952347,78.432266 214.797546,79.087257 209.311203,81.357597
	C204.392059,83.393204 199.630020,86.613060 195.805130,90.342636
	C182.501434,103.314796 169.612640,116.713509 156.616074,129.998932
	C152.699371,134.002716 149.133774,134.139923 145.126892,130.125793
	C132.536896,117.513069 120.106400,104.735985 107.298668,92.348724
	C103.197273,88.381973 98.113815,85.430618 93.157654,81.812546
z`
          }
        )
      ]
    }
  );
}
function HO(e) {
  return /* @__PURE__ */ Z.jsxs(
    "svg",
    {
      width: "19",
      height: "22",
      viewBox: "0 0 19 22",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ Z.jsx("path", { d: "M11.19 9.44064L7.94 21.8806H0L1.61 15.7606L11.19 9.44064Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M18.3994 0.41037L12.7594 21.8804H8.88938L12.6994 7.34037L6.85938 11.1904L7.89937 7.36037L18.3994 0.41037Z" })
      ]
    }
  );
}
function KO(e) {
  return /* @__PURE__ */ Z.jsxs(
    "svg",
    {
      width: "49",
      height: "47",
      viewBox: "0 0 49 47",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      fill: "rgb(var(--fill-primary))",
      children: [
        /* @__PURE__ */ Z.jsx("path", { d: "M26.5134 0.399902H13.6093L0.300049 23.4596L13.6093 46.5193L16.2422 41.9768L5.56587 23.4596L16.2422 4.97133H23.8805L26.5134 0.399902Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M17.4285 16.0526L20.0325 11.539L16.2423 4.97119L13.6094 9.48476L17.4285 16.0526Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M32.358 4.97119L34.9909 9.51369L16.2423 41.9766L13.6094 37.4341L32.358 4.97119Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M22.1155 46.5193L24.7195 41.9768H32.3578L43.0341 23.4596L32.3578 4.97133L34.9907 0.399902L48.2999 23.4596L34.9907 46.5193H22.1155Z" }),
        /* @__PURE__ */ Z.jsx("path", { d: "M31.1139 30.7798L28.481 35.3223L32.358 41.9769L34.9909 37.4633L31.1139 30.7798Z" })
      ]
    }
  );
}
const sl = ({
  description: e,
  descriptionClassName: t,
  error: n,
  errorClassName: r,
  className: a
}) => n || e ? /* @__PURE__ */ Z.jsxs("div", { className: a, children: [
  e ? /* @__PURE__ */ Z.jsx(
    "span",
    {
      className: Fe("[&>a]:text-brand-primary text-sm opacity-70", t),
      children: e
    }
  ) : null,
  n ? /* @__PURE__ */ Z.jsx(
    "p",
    {
      className: Fe("text-danger [&>a]:text-brand-primary text-sm", r),
      dangerouslySetInnerHTML: { __html: n }
    }
  ) : null
] }) : null;
function _o({
  wrapperAs: e = "div",
  wrapperProps: t = { className: "flex justify-between gap-2" },
  label: n,
  required: r,
  labelClassName: a,
  labelRightElement: o,
  requiredSignClassName: i
}) {
  return n || r || o ? /* @__PURE__ */ Z.jsxs(e, { ...t, children: [
    (n || r) && /* @__PURE__ */ Z.jsxs("span", { className: Fe("flex", a), children: [
      n,
      " ",
      r && /* @__PURE__ */ Z.jsx("i", { className: Fe("text-danger", i), children: "*" })
    ] }),
    o
  ] }) : null;
}
Xs(function(e, t) {
  return /* @__PURE__ */ Z.jsx(
    "button",
    {
      ref: t,
      ...e,
      onClick: (n) => {
        var r;
        n.preventDefault = () => {
        }, (r = e.onClick) == null || r.call(e, n);
      }
    }
  );
});
Xs(function(e, t) {
  return /* @__PURE__ */ Z.jsx(
    "div",
    {
      ref: t,
      ...e,
      onClick: (n) => {
        var r;
        n.preventDefault = () => {
        }, n.stopPropagation = () => {
        }, (r = e.onClick) == null || r.call(e, n);
      }
    }
  );
});
function w5() {
  return (w5 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function UO(e, t) {
  if (e == null)
    return {};
  var n, r, a = {}, o = Object.keys(e);
  for (r = 0; r < o.length; r++)
    t.indexOf(n = o[r]) >= 0 || (a[n] = e[n]);
  return a;
}
function o2(e) {
  var t = _e(e), n = _e(function(r) {
    t.current && t.current(r);
  });
  return t.current = e, n.current;
}
var Oc = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e < t ? t : e;
}, mc = function(e) {
  return "touches" in e;
}, x1 = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, i2 = function(e, t, n) {
  var r = e.getBoundingClientRect(), a = mc(t) ? function(o, i) {
    for (var s = 0; s < o.length; s++)
      if (o[s].identifier === i)
        return o[s];
    return o[0];
  }(t.touches, n) : t;
  return { left: Oc((a.pageX - (r.left + x1(e).pageXOffset)) / r.width), top: Oc((a.pageY - (r.top + x1(e).pageYOffset)) / r.height) };
}, s2 = function(e) {
  !mc(e) && e.preventDefault();
}, S5 = k.memo(function(e) {
  var t = e.onMove, n = e.onKey, r = UO(e, ["onMove", "onKey"]), a = _e(null), o = o2(t), i = o2(n), s = _e(null), l = _e(!1), c = we(function() {
    var h = function(g) {
      s2(g), (mc(g) ? g.touches.length > 0 : g.buttons > 0) && a.current ? o(i2(a.current, g, s.current)) : f(!1);
    }, m = function() {
      return f(!1);
    };
    function f(g) {
      var _ = l.current, v = x1(a.current), w = g ? v.addEventListener : v.removeEventListener;
      w(_ ? "touchmove" : "mousemove", h), w(_ ? "touchend" : "mouseup", m);
    }
    return [function(g) {
      var _ = g.nativeEvent, v = a.current;
      if (v && (s2(_), !function(x, b) {
        return b && !mc(x);
      }(_, l.current) && v)) {
        if (mc(_)) {
          l.current = !0;
          var w = _.changedTouches || [];
          w.length && (s.current = w[0].identifier);
        }
        v.focus(), o(i2(v, _, s.current)), f(!0);
      }
    }, function(g) {
      var _ = g.which || g.keyCode;
      _ < 37 || _ > 40 || (g.preventDefault(), i({ left: _ === 39 ? 0.05 : _ === 37 ? -0.05 : 0, top: _ === 40 ? 0.05 : _ === 38 ? -0.05 : 0 }));
    }, f];
  }, [i, o]), u = c[0], d = c[1], p = c[2];
  return De(function() {
    return p;
  }, [p]), k.createElement("div", w5({}, r, { onTouchStart: u, onMouseDown: u, className: "react-colorful__interactive", ref: a, onKeyDown: d, tabIndex: 0, role: "slider" }));
}), C5 = function(e) {
  return e.filter(Boolean).join(" ");
}, x5 = function(e) {
  var t = e.color, n = e.left, r = e.top, a = r === void 0 ? 0.5 : r, o = C5(["react-colorful__pointer", e.className]);
  return k.createElement("div", { className: o, style: { top: 100 * a + "%", left: 100 * n + "%" } }, k.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, Mi = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n;
}, $O = function(e) {
  var t = e.s, n = e.v, r = e.a, a = (200 - t) * n / 100;
  return { h: Mi(e.h), s: Mi(a > 0 && a < 200 ? t * n / 100 / (a <= 100 ? a : 200 - a) * 100 : 0), l: Mi(a / 2), a: Mi(r, 2) };
}, k1 = function(e) {
  var t = $O(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
};
k.memo(function(e) {
  var t = e.hue, n = e.onChange, r = C5(["react-colorful__hue", e.className]);
  return k.createElement("div", { className: r }, k.createElement(S5, { onMove: function(a) {
    n({ h: 360 * a.left });
  }, onKey: function(a) {
    n({ h: Oc(t + 360 * a.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": Mi(t), "aria-valuemax": "360", "aria-valuemin": "0" }, k.createElement(x5, { className: "react-colorful__hue-pointer", left: t / 360, color: k1({ h: t, s: 100, v: 100, a: 1 }) })));
});
k.memo(function(e) {
  var t = e.hsva, n = e.onChange, r = { backgroundColor: k1({ h: t.h, s: 100, v: 100, a: 1 }) };
  return k.createElement("div", { className: "react-colorful__saturation", style: r }, k.createElement(S5, { onMove: function(a) {
    n({ s: 100 * a.left, v: 100 - 100 * a.top });
  }, onKey: function(a) {
    n({ s: Oc(t.s + 100 * a.left, 0, 100), v: Oc(t.v - 100 * a.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + Mi(t.s) + "%, Brightness " + Mi(t.v) + "%" }, k.createElement(x5, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: k1(t) })));
});
const l2 = (e, t) => ({
  ...e ? {
    "data-test-id": `${t}`
  } : {}
});
function Kn(e) {
  "@babel/helpers - typeof";
  return Kn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kn(e);
}
function VO(e, t) {
  if (Kn(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Kn(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function k5(e) {
  var t = VO(e, "string");
  return Kn(t) == "symbol" ? t : t + "";
}
function Me(e, t, n) {
  return (t = k5(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function vt(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function c2(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, k5(r.key), r);
  }
}
function bt(e, t, n) {
  return t && c2(e.prototype, t), n && c2(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var WO = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, YO = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, ZO = function(e) {
  return YO[e];
}, qO = function(e) {
  return e.replace(WO, ZO);
};
function u2(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function d2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? u2(Object(n), !0).forEach(function(r) {
      Me(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u2(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var p2 = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: qO
};
Qe();
function JO() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  p2 = d2(d2({}, p2), e);
}
(function() {
  function e() {
    vt(this, e), this.usedNamespaces = {};
  }
  return bt(e, [{
    key: "addUsedNamespaces",
    value: function(t) {
      var n = this;
      t.forEach(function(r) {
        n.usedNamespaces[r] || (n.usedNamespaces[r] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
})();
var XO = {
  type: "3rdParty",
  init: function(e) {
    JO(e.options.react);
  }
};
function h2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function QO(e, t) {
  if (e) {
    if (typeof e == "string")
      return h2(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? h2(e, t) : void 0;
  }
}
const Ye = (e) => typeof e == "string", Tl = () => {
  let e, t;
  const n = new Promise((r, a) => {
    e = r, t = a;
  });
  return n.resolve = e, n.reject = t, n;
}, m2 = (e) => e == null ? "" : "" + e, eA = (e, t, n) => {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}, tA = /###/g, f2 = (e) => e && e.indexOf("###") > -1 ? e.replace(tA, ".") : e, g2 = (e) => !e || Ye(e), fc = (e, t, n) => {
  const r = Ye(t) ? t.split(".") : t;
  let a = 0;
  for (; a < r.length - 1; ) {
    if (g2(e))
      return {};
    const o = f2(r[a]);
    !e[o] && n && (e[o] = new n()), Object.prototype.hasOwnProperty.call(e, o) ? e = e[o] : e = {}, ++a;
  }
  return g2(e) ? {} : {
    obj: e,
    k: f2(r[a])
  };
}, y2 = (e, t, n) => {
  const {
    obj: r,
    k: a
  } = fc(e, t, Object);
  if (r !== void 0 || t.length === 1) {
    r[a] = n;
    return;
  }
  let o = t[t.length - 1], i = t.slice(0, t.length - 1), s = fc(e, i, Object);
  for (; s.obj === void 0 && i.length; )
    o = `${i[i.length - 1]}.${o}`, i = i.slice(0, i.length - 1), s = fc(e, i, Object), s && s.obj && typeof s.obj[`${s.k}.${o}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${o}`] = n;
}, rA = (e, t, n, r) => {
  const {
    obj: a,
    k: o
  } = fc(e, t, Object);
  a[o] = a[o] || [], a[o].push(n);
}, Fd = (e, t) => {
  const {
    obj: n,
    k: r
  } = fc(e, t);
  if (n)
    return n[r];
}, nA = (e, t, n) => {
  const r = Fd(e, n);
  return r !== void 0 ? r : Fd(t, n);
}, E5 = (e, t, n) => {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? Ye(e[r]) || e[r] instanceof String || Ye(t[r]) || t[r] instanceof String ? n && (e[r] = t[r]) : E5(e[r], t[r], n) : e[r] = t[r]);
  return e;
}, ss = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var aA = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const oA = (e) => Ye(e) ? e.replace(/[&<>"'\/]/g, (t) => aA[t]) : e;
class iA {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const r = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, r), this.regExpQueue.push(t), r;
  }
}
const sA = [" ", ",", "?", "!", ";"], lA = new iA(20), cA = (e, t, n) => {
  t = t || "", n = n || "";
  const r = sA.filter((i) => t.indexOf(i) < 0 && n.indexOf(i) < 0);
  if (r.length === 0)
    return !0;
  const a = lA.getRegExp(`(${r.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let o = !a.test(e);
  if (!o) {
    const i = e.indexOf(n);
    i > 0 && !a.test(e.substring(0, i)) && (o = !0);
  }
  return o;
}, E1 = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[t])
    return e[t];
  const r = t.split(n);
  let a = e;
  for (let o = 0; o < r.length; ) {
    if (!a || typeof a != "object")
      return;
    let i, s = "";
    for (let l = o; l < r.length; ++l)
      if (l !== o && (s += n), s += r[l], i = a[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < r.length - 1)
          continue;
        o += l - o + 1;
        break;
      }
    a = i;
  }
  return a;
}, zd = (e) => e && e.replace("_", "-"), uA = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
let dA = class P1 {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || uA, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, a) {
    return a && !this.debug ? null : (Ye(t[0]) && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new P1(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new P1(this.logger, t);
  }
};
var ja = new dA();
let eh = class {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const a = this.observers[r].get(n) || 0;
      this.observers[r].set(n, a + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((o) => {
      let [i, s] = o;
      for (let l = 0; l < s; l++)
        i(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o) => {
      let [i, s] = o;
      for (let l = 0; l < s; l++)
        i.apply(i, [t, ...r]);
    });
  }
};
class v2 extends eh {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, i = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, n], r && (Array.isArray(r) ? s.push(...r) : Ye(r) && o ? s.push(...r.split(o)) : s.push(r)));
    const l = Fd(this.data, s);
    return !l && !n && !r && t.indexOf(".") > -1 && (t = s[0], n = s[1], r = s.slice(2).join(".")), l || !i || !Ye(r) ? l : E1(this.data && this.data[t] && this.data[t][n], r, o);
  }
  addResource(t, n, r, a) {
    let o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const i = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator;
    let s = [t, n];
    r && (s = s.concat(i ? r.split(i) : r)), t.indexOf(".") > -1 && (s = t.split("."), a = n, n = s[1]), this.addNamespaces(n), y2(this.data, s, a), o.silent || this.emit("added", t, n, r, a);
  }
  addResources(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const o in r)
      (Ye(r[o]) || Array.isArray(r[o])) && this.addResource(t, n, o, r[o], {
        silent: !0
      });
    a.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, a, o) {
    let i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, s = [t, n];
    t.indexOf(".") > -1 && (s = t.split("."), a = r, r = n, n = s[1]), this.addNamespaces(n);
    let l = Fd(this.data, s) || {};
    i.skipCopy || (r = JSON.parse(JSON.stringify(r))), a ? E5(l, r, o) : l = {
      ...l,
      ...r
    }, y2(this.data, s, l), i.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, n)
    } : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((r) => n[r] && Object.keys(n[r]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var P5 = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, a) {
    return e.forEach((o) => {
      this.processors[o] && (t = this.processors[o].process(t, n, r, a));
    }), t;
  }
};
const b2 = {};
let _2 = class T5 extends eh {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), eA(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = ja.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let o = n.ns || this.options.defaultNS || [];
    const i = r && t.indexOf(r) > -1, s = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !cA(t, r, a);
    if (i && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: Ye(o) ? [o] : o
        };
      const c = t.split(r);
      (r !== a || r === a && this.options.ns.indexOf(c[0]) > -1) && (o = c.shift()), t = c.join(a);
    }
    return {
      key: t,
      namespaces: Ye(o) ? [o] : o
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null)
      return "";
    Array.isArray(t) || (t = [String(t)]);
    const a = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, o = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: i,
      namespaces: s
    } = this.extractFromKey(t[t.length - 1], n), l = s[s.length - 1], c = n.lng || this.language, u = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const x = n.nsSeparator || this.options.nsSeparator;
        return a ? {
          res: `${l}${x}${i}`,
          usedKey: i,
          exactUsedKey: i,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(n)
        } : `${l}${x}${i}`;
      }
      return a ? {
        res: i,
        usedKey: i,
        exactUsedKey: i,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(n)
      } : i;
    }
    const d = this.resolve(t, n);
    let p = d && d.res;
    const h = d && d.usedKey || i, m = d && d.exactUsedKey || i, f = Object.prototype.toString.apply(p), g = ["[object Number]", "[object Function]", "[object RegExp]"], _ = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, v = !this.i18nFormat || this.i18nFormat.handleAsObject, w = !Ye(p) && typeof p != "boolean" && typeof p != "number";
    if (v && p && w && g.indexOf(f) < 0 && !(Ye(_) && Array.isArray(p))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const x = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, p, {
          ...n,
          ns: s
        }) : `key '${i} (${this.language})' returned an object instead of string.`;
        return a ? (d.res = x, d.usedParams = this.getUsedParamsDetails(n), d) : x;
      }
      if (o) {
        const x = Array.isArray(p), b = x ? [] : {}, C = x ? m : h;
        for (const E in p)
          if (Object.prototype.hasOwnProperty.call(p, E)) {
            const A = `${C}${o}${E}`;
            b[E] = this.translate(A, {
              ...n,
              joinArrays: !1,
              ns: s
            }), b[E] === A && (b[E] = p[E]);
          }
        p = b;
      }
    } else if (v && Ye(_) && Array.isArray(p))
      p = p.join(_), p && (p = this.extendTranslation(p, t, n, r));
    else {
      let x = !1, b = !1;
      const C = n.count !== void 0 && !Ye(n.count), E = T5.hasDefaultValue(n), A = C ? this.pluralResolver.getSuffix(c, n.count, n) : "", O = n.ordinal && C ? this.pluralResolver.getSuffix(c, n.count, {
        ordinal: !1
      }) : "", M = C && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), I = M && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${A}`] || n[`defaultValue${O}`] || n.defaultValue;
      !this.isValidLookup(p) && E && (x = !0, p = I), this.isValidLookup(p) || (b = !0, p = i);
      const D = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && b ? void 0 : p, K = E && I !== p && this.options.updateMissing;
      if (b || x || K) {
        if (this.logger.log(K ? "updateKey" : "missingKey", c, l, i, K ? I : p), o) {
          const U = this.resolve(i, {
            ...n,
            keySeparator: !1
          });
          U && U.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let G = [];
        const V = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && V && V[0])
          for (let U = 0; U < V.length; U++)
            G.push(V[U]);
        else
          this.options.saveMissingTo === "all" ? G = this.languageUtils.toResolveHierarchy(n.lng || this.language) : G.push(n.lng || this.language);
        const ee = (U, H, W) => {
          const L = E && W !== p ? W : D;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(U, l, H, L, K, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(U, l, H, L, K, n), this.emit("missingKey", U, l, H, p);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && C ? G.forEach((U) => {
          const H = this.pluralResolver.getSuffixes(U, n);
          M && n[`defaultValue${this.options.pluralSeparator}zero`] && H.indexOf(`${this.options.pluralSeparator}zero`) < 0 && H.push(`${this.options.pluralSeparator}zero`), H.forEach((W) => {
            ee([U], i + W, n[`defaultValue${W}`] || I);
          });
        }) : ee(G, i, I));
      }
      p = this.extendTranslation(p, t, n, d, r), b && p === i && this.options.appendNamespaceToMissingKey && (p = `${l}:${i}`), (b || x) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? p = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${i}` : i, x ? p : void 0) : p = this.options.parseMissingKeyHandler(p));
    }
    return a ? (d.res = p, d.usedParams = this.getUsedParamsDetails(n), d) : p;
  }
  extendTranslation(t, n, r, a, o) {
    var i = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const c = Ye(t) && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const p = t.match(this.interpolator.nestingRegexp);
        u = p && p.length;
      }
      let d = r.replace && !Ye(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), t = this.interpolator.interpolate(t, d, r.lng || this.language || a.usedLng, r), c) {
        const p = t.match(this.interpolator.nestingRegexp), h = p && p.length;
        u < h && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && a && a.res && (r.lng = this.language || a.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var p = arguments.length, h = new Array(p), m = 0; m < p; m++)
          h[m] = arguments[m];
        return o && o[0] === h[0] && !r.context ? (i.logger.warn(`It seems you are nesting recursively key: ${h[0]} in key: ${n[0]}`), null) : i.translate(...h, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const s = r.postProcess || this.options.postProcess, l = Ye(s) ? [s] : s;
    return t != null && l && l.length && r.applyPostProcessor !== !1 && (t = P5.handle(l, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, a, o, i, s;
    return Ye(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(r))
        return;
      const c = this.extractFromKey(l, n), u = c.key;
      a = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const p = n.count !== void 0 && !Ye(n.count), h = p && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), m = n.context !== void 0 && (Ye(n.context) || typeof n.context == "number") && n.context !== "", f = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((g) => {
        this.isValidLookup(r) || (s = g, !b2[`${f[0]}-${g}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(s) && (b2[`${f[0]}-${g}`] = !0, this.logger.warn(`key "${a}" for languages "${f.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), f.forEach((_) => {
          if (this.isValidLookup(r))
            return;
          i = _;
          const v = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, u, _, g, n);
          else {
            let x;
            p && (x = this.pluralResolver.getSuffix(_, n.count, n));
            const b = `${this.options.pluralSeparator}zero`, C = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (p && (v.push(u + x), n.ordinal && x.indexOf(C) === 0 && v.push(u + x.replace(C, this.options.pluralSeparator)), h && v.push(u + b)), m) {
              const E = `${u}${this.options.contextSeparator}${n.context}`;
              v.push(E), p && (v.push(E + x), n.ordinal && x.indexOf(C) === 0 && v.push(E + x.replace(C, this.options.pluralSeparator)), h && v.push(E + b));
            }
          }
          let w;
          for (; w = v.pop(); )
            this.isValidLookup(r) || (o = w, r = this.getResource(_, g, w, n));
        }));
      });
    }), {
      res: r,
      usedKey: a,
      exactUsedKey: o,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, a) : this.resourceStore.getResource(t, n, r, a);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = t.replace && !Ye(t.replace);
    let a = r ? t.replace : t;
    if (r && typeof t.count < "u" && (a.count = t.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !r) {
      a = {
        ...a
      };
      for (const o of n)
        delete a[o];
    }
    return a;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
};
const tm = (e) => e.charAt(0).toUpperCase() + e.slice(1);
class w2 {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = ja.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = zd(t), !t || t.indexOf("-") < 0)
      return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = zd(t), !t || t.indexOf("-") < 0)
      return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (Ye(t) && t.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let a = Intl.getCanonicalLocales(t)[0];
          if (a && this.options.lowerCaseLng && (a = a.toLowerCase()), a)
            return a;
        } catch {
        }
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((a) => a.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = tm(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = tm(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = tm(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t)
      return null;
    let n;
    return t.forEach((r) => {
      if (n)
        return;
      const a = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (n = a);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n)
        return;
      const a = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(a))
        return n = a;
      n = this.options.supportedLngs.find((o) => {
        if (o === a || !(o.indexOf("-") < 0 && a.indexOf("-") < 0) && (o.indexOf("-") > 0 && a.indexOf("-") < 0 && o.substring(0, o.indexOf("-")) === a || o.indexOf(a) === 0 && a.length > 1))
          return o;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t)
      return [];
    if (typeof t == "function" && (t = t(n)), Ye(t) && (t = [t]), Array.isArray(t))
      return t;
    if (!n)
      return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), a = [], o = (i) => {
      i && (this.isSupportedCode(i) ? a.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return Ye(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && o(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && o(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && o(this.getLanguagePartFromCode(t))) : Ye(t) && o(this.formatLanguageCode(t)), r.forEach((i) => {
      a.indexOf(i) < 0 && o(this.formatLanguageCode(i));
    }), a;
  }
}
let pA = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], hA = {
  1: (e) => +(e > 1),
  2: (e) => +(e != 1),
  3: (e) => 0,
  4: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  5: (e) => e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
  6: (e) => e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
  7: (e) => e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  8: (e) => e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
  9: (e) => +(e >= 2),
  10: (e) => e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
  11: (e) => e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
  12: (e) => +(e % 10 != 1 || e % 100 == 11),
  13: (e) => +(e !== 0),
  14: (e) => e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
  15: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  16: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
  17: (e) => e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
  18: (e) => e == 0 ? 0 : e == 1 ? 1 : 2,
  19: (e) => e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
  20: (e) => e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
  21: (e) => e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
  22: (e) => e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const mA = ["v1", "v2", "v3"], fA = ["v4"], S2 = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, gA = () => {
  const e = {};
  return pA.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: hA[t.fc]
      };
    });
  }), e;
};
class yA {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = ja.create("pluralResolver"), (!this.options.compatibilityJSON || fA.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = gA(), this.pluralRulesCache = {};
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const r = zd(t === "dev" ? "en" : t), a = n.ordinal ? "ordinal" : "cardinal", o = JSON.stringify({
        cleanedCode: r,
        type: a
      });
      if (o in this.pluralRulesCache)
        return this.pluralRulesCache[o];
      let i;
      try {
        i = new Intl.PluralRules(r, {
          type: a
        });
      } catch {
        if (!t.match(/-|_/))
          return;
        const s = this.languageUtils.getLanguagePartFromCode(t);
        i = this.getRule(s, n);
      }
      return this.pluralRulesCache[o] = i, i;
    }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((a) => `${n}${a}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((a, o) => S2[a] - S2[o]).map((a) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : r.numbers.map((a) => this.getSuffix(t, a, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const a = this.getRule(t, r);
    return a ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(n)}` : this.getSuffixRetroCompatible(a, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let a = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (a === 2 ? a = "plural" : a === 1 && (a = ""));
    const o = () => this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
    return this.options.compatibilityJSON === "v1" ? a === 1 ? "" : typeof a == "number" ? `_plural_${a.toString()}` : o() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? o() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !mA.includes(this.options.compatibilityJSON);
  }
}
const C2 = function(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, o = nA(e, t, n);
  return !o && a && Ye(n) && (o = E1(e, n, r), o === void 0 && (o = E1(t, n, r))), o;
}, rm = (e) => e.replace(/\$/g, "$$$$");
class vA {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = ja.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: r,
      useRawValueToEscape: a,
      prefix: o,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: p,
      nestingPrefixEscaped: h,
      nestingSuffix: m,
      nestingSuffixEscaped: f,
      nestingOptionsSeparator: g,
      maxReplaces: _,
      alwaysFormat: v
    } = t.interpolation;
    this.escape = n !== void 0 ? n : oA, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = o ? ss(o) : i || "{{", this.suffix = s ? ss(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = p ? ss(p) : h || ss("$t("), this.nestingSuffix = m ? ss(m) : f || ss(")"), this.nestingOptionsSeparator = g || ",", this.maxReplaces = _ || 1e3, this.alwaysFormat = v !== void 0 ? v : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, r) => n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, r, a) {
    let o, i, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (p) => {
      if (p.indexOf(this.formatSeparator) < 0) {
        const g = C2(n, l, p, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(g, void 0, r, {
          ...a,
          ...n,
          interpolationkey: p
        }) : g;
      }
      const h = p.split(this.formatSeparator), m = h.shift().trim(), f = h.join(this.formatSeparator).trim();
      return this.format(C2(n, l, m, this.options.keySeparator, this.options.ignoreJSONStructure), f, r, {
        ...a,
        ...n,
        interpolationkey: m
      });
    };
    this.resetRegExp();
    const u = a && a.missingInterpolationHandler || this.options.missingInterpolationHandler, d = a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (p) => rm(p)
    }, {
      regex: this.regexp,
      safeValue: (p) => this.escapeValue ? rm(this.escape(p)) : rm(p)
    }].forEach((p) => {
      for (s = 0; o = p.regex.exec(t); ) {
        const h = o[1].trim();
        if (i = c(h), i === void 0)
          if (typeof u == "function") {
            const f = u(t, o, a);
            i = Ye(f) ? f : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, h))
            i = "";
          else if (d) {
            i = o[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${h} for interpolating ${t}`), i = "";
        else
          !Ye(i) && !this.useRawValueToEscape && (i = m2(i));
        const m = p.safeValue(i);
        if (t = t.replace(o[0], m), d ? (p.regex.lastIndex += i.length, p.regex.lastIndex -= o[0].length) : p.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, o, i;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0)
        return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let p = `{${d[1]}`;
      l = d[0], p = this.interpolate(p, i);
      const h = p.match(/'/g), m = p.match(/"/g);
      (h && h.length % 2 === 0 && !m || m.length % 2 !== 0) && (p = p.replace(/'/g, '"'));
      try {
        i = JSON.parse(p), c && (i = {
          ...c,
          ...i
        });
      } catch (f) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, f), `${l}${u}${p}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; a = this.nestingRegexp.exec(t); ) {
      let l = [];
      i = {
        ...r
      }, i = i.replace && !Ye(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      let c = !1;
      if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
        const u = a[1].split(this.formatSeparator).map((d) => d.trim());
        a[1] = u.shift(), l = u, c = !0;
      }
      if (o = n(s.call(this, a[1].trim(), i), i), o && a[0] === t && !Ye(o))
        return o;
      Ye(o) || (o = m2(o)), o || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${t}`), o = ""), c && (o = l.reduce((u, d) => this.format(u, d, r.lng, {
        ...r,
        interpolationkey: a[1].trim()
      }), o.trim())), t = t.replace(a[0], o), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const bA = (e) => {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const a = r[1].substring(0, r[1].length - 1);
    t === "currency" && a.indexOf(":") < 0 ? n.currency || (n.currency = a.trim()) : t === "relativetime" && a.indexOf(":") < 0 ? n.range || (n.range = a.trim()) : a.split(";").forEach((o) => {
      if (o) {
        const [i, ...s] = o.split(":"), l = s.join(":").trim().replace(/^'+|'+$/g, ""), c = i.trim();
        n[c] || (n[c] = l), l === "false" && (n[c] = !1), l === "true" && (n[c] = !0), isNaN(l) || (n[c] = parseInt(l, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}, ls = (e) => {
  const t = {};
  return (n, r, a) => {
    let o = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (o = {
      ...o,
      [a.interpolationkey]: void 0
    });
    const i = r + JSON.stringify(o);
    let s = t[i];
    return s || (s = e(zd(r), a), t[i] = s), s(n);
  };
};
class _A {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = ja.create("formatter"), this.options = t, this.formats = {
      number: ls((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r
        });
        return (o) => a.format(o);
      }),
      currency: ls((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (o) => a.format(o);
      }),
      datetime: ls((n, r) => {
        const a = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (o) => a.format(o);
      }),
      relativetime: ls((n, r) => {
        const a = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (o) => a.format(o, r.range || "day");
      }),
      list: ls((n, r) => {
        const a = new Intl.ListFormat(n, {
          ...r
        });
        return (o) => a.format(o);
      })
    }, this.init(t);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = n.interpolation.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = ls(n);
  }
  format(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = n.split(this.formatSeparator);
    if (o.length > 1 && o[0].indexOf("(") > 1 && o[0].indexOf(")") < 0 && o.find((i) => i.indexOf(")") > -1)) {
      const i = o.findIndex((s) => s.indexOf(")") > -1);
      o[0] = [o[0], ...o.splice(1, i)].join(this.formatSeparator);
    }
    return o.reduce((i, s) => {
      const {
        formatName: l,
        formatOptions: c
      } = bA(s);
      if (this.formats[l]) {
        let u = i;
        try {
          const d = a && a.formatParams && a.formatParams[a.interpolationkey] || {}, p = d.locale || d.lng || a.locale || a.lng || r;
          u = this.formats[l](i, p, {
            ...c,
            ...a,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return i;
    }, t);
  }
}
const wA = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class SA extends eh {
  constructor(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = a, this.logger = ja.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, a.backend, a);
  }
  queueLoad(t, n, r, a) {
    const o = {}, i = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      n.forEach((d) => {
        const p = `${c}|${d}`;
        !r.reload && this.store.hasResourceBundle(c, d) ? this.state[p] = 2 : this.state[p] < 0 || (this.state[p] === 1 ? i[p] === void 0 && (i[p] = !0) : (this.state[p] = 1, u = !1, i[p] === void 0 && (i[p] = !0), o[p] === void 0 && (o[p] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(o).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(o),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, n, r) {
    const a = t.split("|"), o = a[0], i = a[1];
    n && this.emit("failedLoading", o, i, n), !n && r && this.store.addResourceBundle(o, i, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2, n && r && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      rA(l.loaded, [o], i), wA(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, i = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length)
      return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: a,
        wait: o,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, a + 1, o * 2, i);
        }, o);
        return;
      }
      i(c, u);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, n);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, n, s);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    Ye(t) && (t = this.languageUtils.toResolveHierarchy(t)), Ye(n) && (n = [n]);
    const o = this.queueLoad(t, n, r, a);
    if (!o.toLoad.length)
      return o.pending.length || a(), null;
    o.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), a = r[0], o = r[1];
    this.read(a, o, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${n}loading namespace ${o} for language ${a} failed`, i), !i && s && this.logger.log(`${n}loaded namespace ${o} for language ${a}`, s), this.loaded(t, i, s);
    });
  }
  saveMissing(t, n, r, a, o) {
    let i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...i,
          isUpdate: o
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, n, r, a, l) : u = c(t, n, r, a), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, n, r, a, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, a);
    }
  }
}
const x2 = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), Ye(e[1]) && (t.defaultValue = e[1]), Ye(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const n = e[3] || e[2];
      Object.keys(n).forEach((r) => {
        t[r] = n[r];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), k2 = (e) => (Ye(e.ns) && (e.ns = [e.ns]), Ye(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), Ye(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e), Lu = () => {
}, CA = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((t) => {
    typeof e[t] == "function" && (e[t] = e[t].bind(e));
  });
};
let M5 = class T1 extends eh {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = k2(t), this.services = {}, this.logger = ja, this.modules = {
      external: []
    }, CA(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (Ye(n.ns) ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const a = x2();
    this.options = {
      ...a,
      ...this.options,
      ...k2(n)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    const o = (l) => l ? typeof l == "function" ? new l() : l : null;
    if (!this.options.isClone) {
      this.modules.logger ? ja.init(o(this.modules.logger), this.options) : ja.init(null, this.options);
      let l;
      this.modules.formatter ? l = this.modules.formatter : typeof Intl < "u" && (l = _A);
      const c = new w2(this.options);
      this.store = new v2(this.options.resources, this.options);
      const u = this.services;
      u.logger = ja, u.resourceStore = this.store, u.languageUtils = c, u.pluralResolver = new yA(c, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), l && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (u.formatter = o(l), u.formatter.init(u, this.options), this.options.interpolation.format = u.formatter.format.bind(u.formatter)), u.interpolator = new vA(this.options), u.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, u.backendConnector = new SA(o(this.modules.backend), u.resourceStore, u, this.options), u.backendConnector.on("*", function(d) {
        for (var p = arguments.length, h = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          h[m - 1] = arguments[m];
        t.emit(d, ...h);
      }), this.modules.languageDetector && (u.languageDetector = o(this.modules.languageDetector), u.languageDetector.init && u.languageDetector.init(u, this.options.detection, this.options)), this.modules.i18nFormat && (u.i18nFormat = o(this.modules.i18nFormat), u.i18nFormat.init && u.i18nFormat.init(this)), this.translator = new _2(this.services, this.options), this.translator.on("*", function(d) {
        for (var p = arguments.length, h = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          h[m - 1] = arguments[m];
        t.emit(d, ...h);
      }), this.modules.external.forEach((d) => {
        d.init && d.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = Lu), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const l = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      l.length > 0 && l[0] !== "dev" && (this.options.lng = l[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((l) => {
      this[l] = function() {
        return t.store[l](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((l) => {
      this[l] = function() {
        return t.store[l](...arguments), t;
      };
    });
    const i = Tl(), s = () => {
      const l = (c, u) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), i.resolve(u), r(c, u);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return l(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, l);
    };
    return this.options.resources || !this.options.initImmediate ? s() : setTimeout(s, 0), i;
  }
  loadResources(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Lu;
    const r = Ye(t) ? t : this.language;
    if (typeof t == "function" && (n = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (r && r.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return n();
      const a = [], o = (i) => {
        !i || i === "cimode" || this.services.languageUtils.toResolveHierarchy(i).forEach((s) => {
          s !== "cimode" && a.indexOf(s) < 0 && a.push(s);
        });
      };
      r ? o(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((i) => o(i)), this.options.preload && this.options.preload.forEach((i) => o(i)), this.services.backendConnector.load(a, this.options.ns, (i) => {
        !i && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(i);
      });
    } else
      n(null);
  }
  reloadResources(t, n, r) {
    const a = Tl();
    return typeof t == "function" && (r = t, t = void 0), typeof n == "function" && (r = n, n = void 0), t || (t = this.languages), n || (n = this.options.ns), r || (r = Lu), this.services.backendConnector.reload(t, n, (o) => {
      a.resolve(), r(o);
    }), a;
  }
  use(t) {
    if (!t)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && P5.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const a = Tl();
    this.emit("languageChanging", t);
    const o = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, i = (l, c) => {
      c ? (o(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, a.resolve(function() {
        return r.t(...arguments);
      }), n && n(l, function() {
        return r.t(...arguments);
      });
    }, s = (l) => {
      !t && !l && this.services.languageDetector && (l = []);
      const c = Ye(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || o(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        i(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(t), a;
  }
  getFixedT(t, n, r) {
    var a = this;
    const o = function(i, s) {
      let l;
      if (typeof s != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          u[d - 2] = arguments[d];
        l = a.options.overloadTranslationOptionHandler([i, s].concat(u));
      } else
        l = {
          ...s
        };
      l.lng = l.lng || o.lng, l.lngs = l.lngs || o.lngs, l.ns = l.ns || o.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || r || o.keyPrefix);
      const p = a.options.keySeparator || ".";
      let h;
      return l.keyPrefix && Array.isArray(i) ? h = i.map((m) => `${l.keyPrefix}${p}${m}`) : h = l.keyPrefix ? `${l.keyPrefix}${p}${i}` : i, a.t(h, l);
    };
    return Ye(t) ? o.lng = t : o.lngs = t, o.ns = n, o.keyPrefix = r, o;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, o = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const i = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, i);
      if (s !== void 0)
        return s;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(r, t) && (!a || i(o, t)));
  }
  loadNamespaces(t, n) {
    const r = Tl();
    return this.options.ns ? (Ye(t) && (t = [t]), t.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      r.resolve(), n && n(a);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = Tl();
    Ye(t) && (t = [t]);
    const a = this.options.preload || [], o = t.filter((i) => a.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return o.length ? (this.options.preload = a.concat(o), this.loadResources((i) => {
      r.resolve(), n && n(i);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t)
      return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new w2(x2());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new T1(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Lu;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const a = {
      ...this.options,
      ...t,
      isClone: !0
    }, o = new T1(a);
    return (t.debug !== void 0 || t.prefix !== void 0) && (o.logger = o.logger.clone(t)), ["store", "services", "language"].forEach((i) => {
      o[i] = this[i];
    }), o.services = {
      ...this.services
    }, o.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, r && (o.store = new v2(this.store.data, a), o.services.resourceStore = o.store), o.translator = new _2(o.services, a), o.translator.on("*", function(i) {
      for (var s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), c = 1; c < s; c++)
        l[c - 1] = arguments[c];
      o.emit(i, ...l);
    }), o.init(a, n), o.translator.options = a, o.translator.backendConnector.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, o;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
};
const Xe = M5.createInstance();
Xe.createInstance = M5.createInstance;
Xe.createInstance;
Xe.dir;
Xe.init;
Xe.loadResources;
Xe.reloadResources;
Xe.use;
Xe.changeLanguage;
Xe.getFixedT;
Xe.t;
Xe.exists;
Xe.setDefaultNamespace;
Xe.hasLoadedNamespace;
Xe.loadNamespaces;
Xe.loadLanguages;
var Mn = /* @__PURE__ */ ((e) => (e.FRENCH = "fr", e.ENGLISH = "en", e.SPANISH = "es", e.ITALIAN = "it", e.PORTUGUESE = "pt", e.DEUTSCH = "de", e.DUTCH = "nl", e.RUSSIAN = "ru", e.JAPANESE = "ja", e.ARABIC = "ar", e.TURKISH = "tr", e.CHINESE = "zh", e.SWEDISH = "sv", e.ROMANIAN = "ro", e.CZECH = "cs", e.HUNGARIAN = "hu", e.SLOVAK = "sk", e.DANISH = "da", e.INDONESIAN = "id", e.POLISH = "pl", e.GREEK = "el", e.SERBIAN = "sr", e.NORWEGIAN = "no", e.THAI = "th", e.SLOVENIAN = "sl", e.UKRAINIAN = "uk", e.ALBANIA = "sq", e.HINDI = "hi", e))(Mn || {});
const xA = {
  "required-field": "الحقل مطلوب",
  payment: {
    price_plan: "عرض",
    stripe_card: "بطاقات الائتمان (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "بطاقات الائتمان (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "بطاقات الائتمان (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "الدفع عند الاستلام",
    xendit_card: "بطاقات الائتمان (Xendit)",
    paystack_card: "بطاقات الإئتمان (Paystack)",
    paypal_connect: "ربط paypal",
    paypal_edit_organization_name: "تعديل اسم المنظمة",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "خطأ",
  "Payment-method": "طريقة دفع",
  price_plan: {
    trial_period: {
      week_0: "{{count}} أسبوع",
      week_1: "أسبوع {{count}}",
      week_2: "أسبوعين {{count}}",
      week_3: "{{count}} أسابيع",
      week_4: "{{count}} أسبوع",
      week_5: "{{count}} أسبوع",
      day_0: "{{count}} يوم",
      day_1: "يوم {{count}}",
      day_2: "يومين {{count}}",
      day_3: "{{count}} أيام",
      day_4: "{{count}} يوم",
      day_5: "{{count}} يوم",
      month_0: "{{count}} شهر",
      month_1: "شهر{{count}}",
      month_2: "شهربن {{count}}",
      month_3: "{{count}} أشهر",
      month_4: "{{count}} شهر",
      month_5: "{{count}} شهر",
      year_0: "{{count}} سنة",
      year_1: "سنة {{count}}",
      year_2: "سنتان {{count}}",
      year_3: "{{count}} سنوات",
      year_4: "{{count}} سنة",
      year_5: "{{count}} سنة"
    },
    interval: {
      month_0: "{{count}} شهر",
      month_1: "شهر {{count}}",
      month_2: "شهرين {{count}}",
      month_3: "{{count}} أشهر",
      month_4: "{{count}} شهر",
      month_5: "{{count}} شهر",
      day_0: "{{count}} يوم",
      day_1: "يوم {{count}}",
      day_2: "يومين {{count}}",
      day_3: "{{count}} أيام",
      day_4: "{{count}} يوم",
      day_5: "{{count}} يوم",
      week_0: "{{count}} أسبوع",
      week_1: "أسبوع {{count}}",
      week_2: "أسبوعين {{count}}",
      week_3: "{{count}} أسابيع",
      week_4: "{{count}} أسبوع",
      week_5: "{{count}} أسبوع",
      year_0: "{{count}} سنة",
      year_1: "سنة {{count}}",
      year_2: "سنتان{{count}}",
      year_3: "{{count}} سنوات",
      year_4: "{{count}} سنة",
      year_5: "{{count}} سنة"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "مجانا",
        trial_period_new: "{{ trialPeriodPrice }} لمدة {{ trialInterval }} ثم",
        unlimited_new: "<bold>{{amount}}</bold> لكل {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} مرات"
      }
    }
  },
  affiliate_badge: {
    made_with: "يعمل بواسطة"
  },
  form_select: {
    empty_list: "يبدو أن هذه القائمة فارغة",
    select: "حدد"
  },
  contact_slug: {
    email: "البريد الإلكتروني",
    first_name: "الاسم",
    last_name: "اسم العائلة",
    phone_number: "رقم الهاتف",
    country: "البلد",
    street_address: "عنوان الشارع",
    city: "المدينة",
    postal_code: "الرمز البريدي",
    company_name: "اسم الشركة",
    tax_number: "الرقم الضريبي",
    state_province: "الولاية/المقاطعة",
    street_number: "رقم الشارع",
    neighborhood: "الحي"
  },
  date_picker: {
    apply: "تطبيق",
    clear: "إزالة",
    time: "الوقت",
    all_time: "كل الوقت",
    last_3_months: "آخر 3 أشهر",
    last_pool_period: "فترة التقييم الأخيرة للمجموعة",
    last_month: "الشهر الفائت",
    this_month: "هذا الشهر",
    last_30_days: "آخر 30 يوم",
    title_dates: "تواريخ",
    from: "من",
    to: "إلى"
  },
  copy_clipboard: "تم النسخ في الحافظة",
  payment_inputs: {
    empty_card_number: "أدخل رقم البطاقة",
    invalid_card_number: "رقم البطاقة غير صالح",
    empty_expiry_date: "أدخل تاريخ الانتهاء",
    month_out_of_range: "يجب أن يكون شهر الانتهاء بين 01 و 12",
    year_out_of_range: "لا يمكن أن تكون سنة الانتهاء في الماضي",
    date_out_of_range: "لا يمكن أن يكون تاريخ الانتهاء في الماضي",
    invalid_expiry_date: "تاريخ الانتهاء غير صالح",
    invalid_cvc: "رمز التحقق غير صالح",
    empty_cvc: "أدخل رمز التحقق",
    card_number_placeholder: "رقم البطاقة",
    expiry_data_placeholder: "الشهر/السنة",
    cvc_placeholder: "رمز التحقق",
    card_holder_placeholder: "حامل البطاقة",
    empty_card_holder: "أدخل اسم حامل البطاقة"
  },
  copy_clipboard_error: "فشل في نسخ النص",
  input: {
    phone_number: "رقم الهاتف",
    phone_search: "بحث",
    search: "بحث"
  },
  "registered-over": "مسجل أكثر من",
  locale: {
    french: "فرنسية",
    german: "ألمانية",
    italian: "ايطالية",
    dutch: "هولندية",
    english: "إنجليزية",
    portuguese: "البرتغالية",
    russian: "الروسية",
    spanish: "الإسبانية",
    japanese: "اليابانية",
    arabic: "العربية",
    turkish: "التركية",
    chinese: "الصينية",
    swedish: "السويدية",
    romanian: "الرومانية",
    czech: "التشيكية",
    hungarian: "الهنغارية",
    slovak: "السلوفاكية",
    danish: "الدانماركية",
    indonesian: "الأندونيسية",
    polish: "البولندية",
    greek: "اليونانية",
    serbian: "الصربية",
    hindi: "الهندية",
    norwegian: "النرويجية",
    thai: "التايلندية",
    slovenian: "السلوفينية",
    ukrainian: "الأوكرانية",
    albania: "الألبانية"
  },
  product: "منتج",
  quantity: "الكمية",
  order_summary: "ملخص الطلب",
  vat: "ضريبة المبيعات",
  total: "المجموع",
  subtotal: "المجموع الفرعي",
  shipping: {
    shipping_method: "طريقة الشحن",
    not_available: "عذرًا! يبدو أننا لا نقدم الشحن إلى هذا الموقع بعد.",
    condition_label: {
      price: "للطلبات التي تتراوح أسعارها بين {{min}} {{currency}} و {{max}} {{currency}}",
      price_min: "للطلبات التي تتراوح أسعارها عند {{min}} {{currency}} أو أكثر",
      quantity: "للطلبات التي تحتوي على بين {{min}} إلى {{max}} عنصر",
      quantity_min: "للطلبات التي تحتوي على {{min}} عنصر أو أكثر",
      weight: "للطلبات التي يبلغ وزنها الإجمالي بين {{min}} غرام إلى {{max}} غرام",
      weight_min: "للطلبات التي يبلغ وزنها الإجمالي {{min}} غرام أو أكثر"
    }
  },
  shipping_fee: "رسوم الشحن",
  total_amount_with_tax_and_shipping: "المجموع (بما في ذلك الضريبة والشحن)",
  vat_percent: "ضريبة المبيعات ({{percent}}%)",
  including_tax: "يشمل {{percent}}٪ ضريبة القيمة المضافة ({{amount}})"
}, kA = {
  public_pages_purchase: xA
}, EA = {
  "required-field": "Pole je povinné",
  payment: {
    price_plan: "Plán",
    stripe_card: "Kreditní karty (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditní karty (místní)",
    dlocal_boleto: "Boleto (místní)",
    dlocal_pix: "Pix (místní)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditní karty (Mercado Pago)",
    mercadopago_pix: "PIX (Platební trh)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Dobírka",
    xendit_card: "Kreditní karty (Xendit)",
    paystack_card: "Kreditní karty (Paystack)",
    paypal_connect: "Připojte PayPal",
    paypal_edit_organization_name: "Upravit název organizace",
    paypal_rest: "PayPal",
    secure_and_pay: "Zabezpečte a zaplaťte",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Chyba",
  "Payment-method": "Způsob platby",
  price_plan: {
    trial_period: {
      week_0: "{{count}} týden",
      week_1: "{{count}} týdnů",
      week_2: "{{count}} týdnů",
      day_0: "{{count}} den",
      day_1: "{{count}} dny",
      day_2: "{{count}} dní",
      month_0: "{{count}} měsíc",
      month_1: "{{count}} měsíců",
      month_2: "{{count}} měsíců",
      year_0: "{{count}} rok",
      year_1: "{{count}} let",
      year_2: "{{count}} let"
    },
    interval: {
      month_0: "měsíc",
      month_1: "{{count}} měsíců",
      month_2: "{{count}} měsíců",
      day_0: "den",
      day_1: "{{count}} dnů",
      day_2: "{{count}} dnů",
      week_0: "týden",
      week_1: "{{count}} týdnů",
      week_2: "{{count}} týdnů",
      year_0: "rok",
      year_1: "{{count}} let",
      year_2: "{{count}} let"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Zdarma",
        trial_period_new: "{{ trialPeriodPrice }} pro {{ trialInterval }} pak",
        unlimited_new: "<bold>{{amount}}</bold> každý {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} krát"
      }
    }
  },
  affiliate_badge: {
    made_with: "Poháněno"
  },
  form_select: {
    empty_list: "Vypadá to, že tento seznam je prázdný",
    select: "Vybrat"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Jméno",
    last_name: "Příjmení",
    phone_number: "Telefonní číslo",
    country: "Země",
    street_address: "Ulice",
    city: "Město",
    postal_code: "PSČ",
    company_name: "Název společnosti",
    tax_number: "DIČ",
    state_province: "Stát/Provincie",
    street_number: "Číslo ulice",
    neighborhood: "Čtvrť"
  },
  date_picker: {
    apply: "Použít",
    clear: "Vymazat",
    time: "Čas",
    all_time: "Celý čas",
    last_3_months: "Poslední 3 měsíce",
    last_pool_period: "Poslední hodnotící období",
    last_month: "Minulý měsíc",
    this_month: "Tento měsíc",
    last_30_days: "Posledních 30 dní",
    title_dates: "Data",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Zkopírováno do schránky",
  payment_inputs: {
    empty_card_number: "Zadejte číslo karty",
    invalid_card_number: "Číslo karty je neplatné",
    empty_expiry_date: "Zadejte datum vypršení platnosti",
    month_out_of_range: "Měsíc vypršení platnosti musí být mezi 01 a 12",
    year_out_of_range: "Rok expirace nemůže být v minulosti",
    date_out_of_range: "Datum expirace nemůže být v minulosti",
    invalid_expiry_date: "Datum expirace je neplatné",
    invalid_cvc: "CVC je neplatné",
    empty_cvc: "Zadejte CVC",
    card_number_placeholder: "Číslo karty",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Držitel karty",
    empty_card_holder: "Zadejte jméno držitele karty"
  },
  copy_clipboard_error: "Kopírování textu se nezdařilo",
  input: {
    phone_number: "Telefonní číslo",
    phone_search: "Hledat",
    search: "Hledat"
  },
  "registered-over": "registrovaných přes",
  locale: {
    french: "Francouzština",
    german: "Němčina",
    italian: "Italština",
    dutch: "Holandský",
    english: "Angličtina",
    portuguese: "Portugalština",
    russian: "Ruština",
    spanish: "Španělština",
    japanese: "Japonština",
    arabic: "Arabština",
    turkish: "Turečtina",
    chinese: "Čínština",
    swedish: "Švédnština",
    romanian: "Rumunština",
    czech: "Čeština",
    hungarian: "Maďarský",
    slovak: "Slovenština",
    danish: "Dánština",
    indonesian: "Indonéština",
    polish: "Polština",
    greek: "Řečtina",
    serbian: "Srbština",
    hindi: "Hindi",
    norwegian: "Norština",
    thai: "Thajština",
    slovenian: "Slovinský",
    ukrainian: "Ukrajinština",
    albania: "Albánština"
  },
  product: "Produkt",
  quantity: "Množství",
  order_summary: "Shrnutí objednávky",
  vat: "Daň z prodeje",
  total: "Celkem",
  subtotal: "Mezisoučet",
  shipping: {
    shipping_method: "Způsob dopravy",
    not_available: "Omlouváme se! Vypadá to, že zatím nenabízíme dopravu na tuto adresu.",
    condition_label: {
      price: "Pro objednávky v cenovém rozmezí {{min}} {{currency}} až {{max}} {{currency}}",
      price_min: "Pro objednávky v ceně {{min}} {{currency}} nebo více",
      quantity: "Pro objednávky obsahující mezi {{min}} a {{max}} položkami",
      quantity_min: "Pro objednávky obsahující {{min}} nebo více položek",
      weight: "Pro objednávky s celkovou hmotností mezi {{min}}g a {{max}}g",
      weight_min: "Pro objednávky s celkovou hmotností {{min}}g nebo více"
    }
  },
  shipping_fee: "Poplatek za dopravu",
  total_amount_with_tax_and_shipping: "Celkem (včetně daně a dopravy)",
  vat_percent: "Daň z prodeje ({{percent}}%)",
  including_tax: "Včetně DPH {{percent}} % ({{amount}})"
}, PA = {
  public_pages_purchase: EA
}, TA = {
  "required-field": "Feltet er påkrævet",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kreditkort (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkort (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kontant ved levering",
    xendit_card: "Kreditkort (Xendit)",
    paystack_card: "Kreditkort (Paystack)",
    paypal_connect: "Tilslut PayPal",
    paypal_edit_organization_name: "Rediger organisationens navn",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fejl",
  "Payment-method": "Betalingsmetode",
  price_plan: {
    trial_period: {
      week: "{{count}} uge",
      week_plural: "{{count}} uger",
      day: "{{count}} dag",
      day_plural: "{{count}} dage",
      month: "{{count}} måned",
      month_plural: "{{count}} måneder",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "måned",
      month_plural: "{{count}} måneder",
      day: "dag",
      day_plural: "{{count}} dage",
      week: "uge",
      week_plural: "{{count}} uger",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} derefter",
        unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gange"
      }
    }
  },
  affiliate_badge: {
    made_with: "Støttet af"
  },
  form_select: {
    empty_list: "Det ser ud til, at denne liste er tom",
    select: "Vælge"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Fornavn",
    last_name: "Efternavn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gadeadresse",
    city: "By",
    postal_code: "Postnummer",
    company_name: "Firmanavn",
    tax_number: "Skattenummer",
    state_province: "stat/provins",
    street_number: "Gadenummer",
    neighborhood: "Kvarter"
  },
  date_picker: {
    apply: "Anvende",
    clear: "Slet",
    time: "Tid",
    all_time: "Hele tiden",
    last_3_months: "Sidste 3 måneder",
    last_pool_period: "Sidste puljeevalueringsperiode",
    last_month: "Sidste måned",
    this_month: "Denne måned",
    last_30_days: "Sidste 30 dage",
    title_dates: "Datoer",
    from: "Fra",
    to: "Til"
  },
  copy_clipboard: "Kopieret til udklipsholder",
  payment_inputs: {
    empty_card_number: "Indtast et kortnummer",
    invalid_card_number: "Kortnummeret er ugyldigt",
    empty_expiry_date: "Indtast en udløbsdato",
    month_out_of_range: "Udløbsmåned skal være mellem 01 og 12",
    year_out_of_range: "Udløbsåret må ikke ligge i fortiden",
    date_out_of_range: "Udløbsdatoen må ikke ligge i fortiden",
    invalid_expiry_date: "Udløbsdatoen er ugyldig",
    invalid_cvc: "CVC er ugyldig",
    empty_cvc: "Indtast en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortholder",
    empty_card_holder: "Indtast et kortholdernavn"
  },
  copy_clipboard_error: "Teksten kunne ikke kopieres",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Søge",
    search: "Søge"
  },
  "registered-over": "registreret over",
  locale: {
    french: "Fransk",
    german: "Tysk",
    italian: "Italiensk",
    dutch: "Hollandsk",
    english: "Engelsk",
    portuguese: "Portugisisk",
    russian: "Russisk",
    spanish: "Spansk",
    japanese: "Japansk",
    arabic: "Arabisk",
    turkish: "Tyrkisk",
    chinese: "Kinesisk",
    swedish: "Svensk",
    romanian: "Rumænsk",
    czech: "Tjekkisk",
    hungarian: "Ungarsk",
    slovak: "Slovakisk",
    danish: "Dansk",
    indonesian: "Indonesisk",
    polish: "Polsk",
    greek: "Græsk",
    serbian: "Serbisk",
    hindi: "Hindi",
    norwegian: "Norsk",
    thai: "Thai",
    slovenian: "Slovensk",
    ukrainian: "Ukrainsk",
    albania: "Albansk"
  },
  product: "Produkt",
  quantity: "Mængde",
  order_summary: "Ordreoversigt",
  vat: "Salgsskat",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Forsendelsesmetode",
    not_available: "Ups! Det ser ud til, at vi endnu ikke tilbyder forsendelse til denne placering.",
    condition_label: {
      price: "For ordrer prissat mellem {{min}} {{currency}} og {{max}} {{currency}}",
      price_min: "For ordrer prissat til {{min}} {{currency}} eller mere",
      quantity: "For ordrer indeholdende mellem {{min}} og {{max}} varer",
      quantity_min: "For ordrer indeholdende {{min}} eller flere varer",
      weight: "For ordrer med en samlet vægt mellem {{min}}g og {{max}}g",
      weight_min: "For ordrer med en samlet vægt på {{min}}g eller mere"
    }
  },
  shipping_fee: "Forsendelsesgebyr",
  total_amount_with_tax_and_shipping: "I alt (inkl. moms og forsendelse)",
  vat_percent: "Moms ({{percent}} %)",
  including_tax: "Inkluderer {{percent}} % moms ({{amount}})"
}, MA = {
  public_pages_purchase: TA
}, OA = {
  "required-field": "Das Feld ist erforderlich",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kreditkarten (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkarten (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkarten (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Lieferung per Nachnahme",
    xendit_card: "Kreditkarten (Xendit)",
    paystack_card: "Kreditkarten (Paystack)",
    paypal_connect: "PayPal verbinden",
    paypal_edit_organization_name: "Organisationsnamen bearbeiten",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fehler",
  "Payment-method": "Zahlungsmethode",
  price_plan: {
    trial_period: {
      week: "{{count}} Woche",
      week_plural: "{{count}} Wochen",
      day: "{{count}} Tag",
      day_plural: "{{count}} Tage",
      month: "{{count}} Monat",
      month_plural: "{{count}} Monate",
      year: "{{count}} Jahr",
      year_plural: "{{count}} Jahre"
    },
    interval: {
      month: "Monat",
      month_plural: "{{count}} Monate",
      day: "Tag",
      day_plural: "{{count}} Tage",
      week: "Woche",
      week_plural: "{{count}} Wochen",
      year: "Jahr",
      year_plural: "{{count}} Jahre"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Kostenlos",
        trial_period_new: "{{ trialPeriodPrice }} für {{ trialInterval }} dann",
        unlimited_new: "<bold>{{amount}}</bold> alle {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} mal"
      }
    }
  },
  affiliate_badge: {
    made_with: "Unterstützt von"
  },
  form_select: {
    empty_list: "Es sieht so aus, als wäre diese Liste leer",
    select: "Auswählen"
  },
  contact_slug: {
    email: "E-Mail",
    first_name: "Vorname",
    last_name: "Nachname",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Straßenadresse",
    city: "Stadt",
    postal_code: "Postleitzahl",
    company_name: "Firmenname",
    tax_number: "Steuernummer",
    state_province: "Bundesland/Provinz",
    street_number: "Hausnummer",
    neighborhood: "Nachbarschaft"
  },
  date_picker: {
    apply: "Anwenden",
    clear: "Löschen",
    time: "Zeit",
    all_time: "Alle Zeiten",
    last_3_months: "Letzte 3 Monate",
    last_pool_period: "Letzter Pool-Auswertungszeitraum",
    last_month: "Letzter Monat",
    this_month: "Dieser Monat",
    last_30_days: "Letzte 30 Tage",
    title_dates: "Termine",
    from: "Von",
    to: "Nach"
  },
  copy_clipboard: "In die Zwischenablage kopiert",
  payment_inputs: {
    empty_card_number: "Eine Kartennummer eingeben",
    invalid_card_number: "Kartennummer ist ungültig",
    empty_expiry_date: "Geben Sie ein Verfallsdatum ein",
    month_out_of_range: "Der Verfallsmonat muss zwischen 01 und 12 liegen",
    year_out_of_range: "Das Verfallsjahr darf nicht in der Vergangenheit liegen",
    date_out_of_range: "Das Verfallsdatum darf nicht in der Vergangenheit liegen",
    invalid_expiry_date: "Verfallsdatum ist ungültig",
    invalid_cvc: "CVC ist ungültig",
    empty_cvc: "Einen CVC eingeben",
    card_number_placeholder: "Kartennummer",
    expiry_data_placeholder: "MM/JJ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Karteninhaber",
    empty_card_holder: "Name des Karteninhabers eingeben"
  },
  copy_clipboard_error: "Text konnte nicht kopiert werden",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Suchen",
    search: "Suchen"
  },
  "registered-over": "registriert über",
  locale: {
    french: "Französisch",
    german: "Deutsch",
    italian: "Italienisch",
    dutch: "Niederländisch",
    english: "Englisch",
    portuguese: "Portugiesisch",
    russian: "Russisch",
    spanish: "Spanisch",
    japanese: "Japanisch",
    arabic: "Arabisch",
    turkish: "Türkisch",
    chinese: "Chinesisch",
    swedish: "Schwedisch",
    romanian: "Rumänisch",
    czech: "Tschechisch",
    hungarian: "Ungarisch",
    slovak: "Slowakisch",
    danish: "Dänisch",
    indonesian: "Indonesisch",
    polish: "Polnisch",
    greek: "Griechisch",
    serbian: "Serbisch",
    hindi: "Hindi",
    norwegian: "Norwegisch",
    thai: "Thailändisch",
    slovenian: "Slowenisch",
    ukrainian: "Ukrainisch",
    albania: "Albanisch"
  },
  product: "Produkt",
  quantity: "Menge",
  order_summary: "Bestellübersicht",
  vat: "Mehrwertsteuer",
  total: "Gesamt",
  subtotal: "Zwischensumme",
  shipping: {
    shipping_method: "Versandmethode",
    not_available: "Ups! Es scheint, dass wir noch keinen Versand an diesen Standort anbieten.",
    condition_label: {
      price: "Für Bestellungen im Wert von {{min}} {{currency}} bis {{max}} {{currency}}",
      price_min: "Für Bestellungen im Wert von {{min}} {{currency}} oder mehr",
      quantity: "Für Bestellungen mit {{min}} bis {{max}} Artikeln",
      quantity_min: "Für Bestellungen mit {{min}} oder mehr Artikeln",
      weight: "Für Bestellungen mit einem Gesamtgewicht zwischen {{min}}g und {{max}}g",
      weight_min: "Für Bestellungen mit einem Gesamtgewicht von {{min}}g oder mehr"
    }
  },
  shipping_fee: "Versandgebühr",
  total_amount_with_tax_and_shipping: "Gesamt (inklusive Steuern und Versand)",
  vat_percent: "Umsatzsteuer ({{percent}} %)",
  including_tax: "Enthält {{percent}} % MwSt. ({{amount}})"
}, AA = {
  public_pages_purchase: OA
}, NA = {
  "required-field": "Το πεδίο είναι υποχρεωτικό",
  payment: {
    price_plan: "Πλάνο",
    stripe_card: "Τραπεζικές κάρτες (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Τραπεζικές κάρτες (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Τραπεζικές κάρτες (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Με αντικαταβολή",
    xendit_card: "Τραπεζικές κάρτες (Xendit)",
    paystack_card: "Τραπεζικές κάρτες (Paystack)",
    paypal_connect: "Σύνδεση με PayPal",
    paypal_edit_organization_name: "Επεξεργασία ονόματος οργανισμού",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Σφάλμα",
  "Payment-method": "Τρόπος πληρωμής",
  price_plan: {
    trial_period: {
      week: "{{count}} εβδομάδα",
      week_plural: "{{count}} εβδομάδες",
      day: "{{count}} ημέρα",
      day_plural: "{{count}} ημέρες",
      month: "{{count}} μήνας",
      month_plural: "{{count}} μήνες",
      year: "{{count}} έτος",
      year_plural: "{{count}} έτη"
    },
    interval: {
      month: "μήνας",
      month_plural: "{{count}} μήνες",
      day: "ημέρα",
      day_plural: "{{count}} ημέρες",
      week: "εβδομάδα",
      week_plural: "{{count}} εβδομάδες",
      year: "έτος",
      year_plural: "{{count}} έτη"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Δωρεάν",
        trial_period_new: "{{ trialPeriodPrice }} για {{ trialInterval }} και έπειτα",
        unlimited_new: "<bold>{{amount}}</bold> κάθε {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} φορές"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Φαίνεται ότι αυτή η λίστα είναι κενή",
    select: "Επιλογή"
  },
  contact_slug: {
    email: "Email",
    first_name: "Όνομα",
    last_name: "Επώνυμο",
    phone_number: "Τηλέφωνο",
    country: "Χώρα",
    street_address: "Διεύθυνση",
    city: "Πόλη",
    postal_code: "Ταχυδρομικός κώδικας",
    company_name: "Επωνυμία εταιρίας",
    tax_number: "Α.Φ.Μ.",
    state_province: "Νομός",
    street_number: "Αριθμός οδού",
    neighborhood: "Γειτονιά"
  },
  date_picker: {
    apply: "Υποβολή",
    clear: "Επαναφορά",
    time: "Χρόνος",
    all_time: "Συνολικά",
    last_3_months: "Τελευταίοι 3 μήνες",
    last_pool_period: "Τελευταία περίοδος αξιολόγησης email",
    last_month: "Προηγούμενος μήνας",
    this_month: "Αυτό το μήνα",
    last_30_days: "Τελευταίες 30 ημέρες",
    title_dates: "Ημερομηνίες",
    from: "Από",
    to: "Προς"
  },
  copy_clipboard: "Επιτυχής αντιγραφή",
  payment_inputs: {
    empty_card_number: "Εισάγετε έναν αριθμό κάρτας",
    invalid_card_number: "Ο αριθμός κάρτας είναι μη έγκυρος",
    empty_expiry_date: "Εισάγετε μια ημερομηνία λήξης",
    month_out_of_range: "Ο μήνας λήξης πρέπει να είναι μεταξύ 01 και 12",
    year_out_of_range: "Η χρονολογία λήξης δεν μπορεί να είναι στο παρελθόν",
    date_out_of_range: "Η ημερομηνία λήξης δεν μπορεί να είναι στο παρελθόν",
    invalid_expiry_date: "Η ημερομηνία λήξης είναι μη έγκυρη",
    invalid_cvc: "Το CVC είναι μη έγκυρο",
    empty_cvc: "Εισάγετε το CVC",
    card_number_placeholder: "Αριθμός κάρτας",
    expiry_data_placeholder: "ΜΜ/ΕΕ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Κάτοχος κάρτας",
    empty_card_holder: "Εισάγετε το όνομα του κατόχου της κάρτας"
  },
  copy_clipboard_error: "Αποτυχία αντιγραφής κειμένου",
  input: {
    phone_number: "Τηλέφωνο",
    phone_search: "Αναζήτηση",
    search: "Αναζήτηση"
  },
  "registered-over": "εγγεγραμμένο πάνω από",
  locale: {
    french: "Γαλλικά",
    german: "Γερμανικά",
    italian: "Ιταλικά",
    dutch: "Ολλανδικά",
    english: "Αγγλικά",
    portuguese: "Πορτογαλικά",
    russian: "Ρωσικά",
    spanish: "Ισπανικά",
    japanese: "Ιαπωνικά",
    arabic: "Αραβικά",
    turkish: "Τούρκικα",
    chinese: "Κινέζικα",
    swedish: "Σουηδικά",
    romanian: "Ρουμανικά",
    czech: "Τσέχικα",
    hungarian: "Ουγγρικά",
    slovak: "Σλοβάκικα",
    danish: "Δανικά",
    indonesian: "Ινδονησιακά",
    polish: "Πολωνικά",
    greek: "Ελληνικά",
    serbian: "Σερβικά",
    hindi: "Ινδικά",
    norwegian: "Νορβηγικά",
    thai: "Ταϊλανδέζικα",
    slovenian: "Σλοβενικά",
    ukrainian: "Ουκρανικά",
    albania: "Αλβανικά"
  },
  product: "Προϊόν",
  quantity: "Ποσότητα",
  order_summary: "Σύνοψη Παραγγελίας",
  vat: "Φόρος πωλήσεων",
  total: "Σύνολο",
  subtotal: "Μερικό σύνολο",
  shipping: {
    shipping_method: "Τρόπος αποστολής",
    not_available: "Ωχ. Φαίνεται ότι δεν προσφέρουμε αποστολή σε αυτήν την τοποθεσία ακόμη",
    condition_label: {
      price: "Για παραγγελίες αξίας από {{min}} {{currency}} έως {{max}} {{currency}}",
      price_min: "Για παραγγελίες αξίας τουλάχιστον {{min}} {{currency}}",
      quantity: "Για παραγγελίες που περιέχουν από {{min}} έως {{max}} αντικείμενα",
      quantity_min: "Για παραγγελίες που περιέχουν τουλάχιστον {{min}} αντικείμενα",
      weight: "Για παραγγελίες με συνολικό βάρος από {{min}}g έως {{max}}g",
      weight_min: "Για παραγγελίες με συνολικό βάρος τουλάχιστον {{min}}g"
    }
  },
  shipping_fee: "Χρέωση αποστολής",
  total_amount_with_tax_and_shipping: "Σύνολο (συμπεριλαμβανομένων φόρων και αποστολής)",
  vat_percent: "ΦΠΑ ({{percent}}%)",
  including_tax: "Συμπεριλαμβάνει {{percent}}% ΦΠΑ ({{amount}})"
}, LA = {
  public_pages_purchase: NA
}, RA = {
  "required-field": "Field is required",
  payment: {
    price_plan: "Plan",
    stripe_card: "Credit cards (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Credit cards (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Credit cards (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Cash on delivery",
    xendit_card: "Credit cards (Xendit)",
    paystack_card: "Credit cards (Paystack)",
    paypal_connect: "Connect PayPal",
    paypal_edit_organization_name: "Edit organization name",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Error",
  "Payment-method": "Payment method",
  price_plan: {
    trial_period: {
      week: "{{count}} week",
      week_plural: "{{count}} weeks",
      day: "{{count}} day",
      day_plural: "{{count}} days",
      month: "{{count}} month",
      month_plural: "{{count}} months",
      year: "{{count}} year",
      year_plural: "{{count}} years"
    },
    interval: {
      month: "month",
      month_plural: "{{count}} months",
      day: "day",
      day_plural: "{{count}} days",
      week: "week",
      week_plural: "{{count}} weeks",
      year: "year",
      year_plural: "{{count}} years"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Free",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} then",
        unlimited_new: "<bold>{{amount}}</bold> every {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} times"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "It looks like this list is empty",
    select: "Select"
  },
  contact_slug: {
    email: "Email",
    first_name: "First name",
    last_name: "Last name",
    phone_number: "Phone number",
    country: "Country",
    street_address: "Street address",
    city: "City",
    postal_code: "Postal code",
    company_name: "Company name",
    tax_number: "Tax number",
    state_province: "State/Province",
    street_number: "Street number",
    neighborhood: "Neighborhood"
  },
  date_picker: {
    apply: "Apply",
    clear: "Clear",
    time: "Time",
    all_time: "All time",
    last_3_months: "Last 3 months",
    last_pool_period: "Last pool evaluation period",
    last_month: "Last month",
    this_month: "This month",
    last_30_days: "Last 30 days",
    title_dates: "Dates",
    from: "From",
    to: "To"
  },
  copy_clipboard: "Copied to clipboard",
  payment_inputs: {
    empty_card_number: "Enter a card number",
    invalid_card_number: "Card number is invalid",
    empty_expiry_date: "Enter an expiry date",
    month_out_of_range: "Expiry month must be between 01 and 12",
    year_out_of_range: "Expiry year cannot be in the past",
    date_out_of_range: "Expiry date cannot be in the past",
    invalid_expiry_date: "Expiry date is invalid",
    invalid_cvc: "CVC is invalid",
    empty_cvc: "Enter a CVC",
    card_number_placeholder: "Card number",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Card holder",
    empty_card_holder: "Enter a card holder name"
  },
  copy_clipboard_error: "Failed to copy text",
  input: {
    phone_number: "Phone number",
    phone_search: "Search",
    search: "Search"
  },
  "registered-over": "registered over",
  locale: {
    french: "French",
    german: "German",
    italian: "Italiano",
    dutch: "Dutch",
    english: "English",
    portuguese: "Portuguese",
    russian: "Russian",
    spanish: "Spanish",
    japanese: "Japanese",
    arabic: "Arabic",
    turkish: "Turkish",
    chinese: "Chinese",
    swedish: "Swedish",
    romanian: "Romanian",
    czech: "Czech",
    hungarian: "Hungarian",
    slovak: "Slovak",
    danish: "Danish",
    indonesian: "Indonesian",
    polish: "Polish",
    greek: "Greek",
    serbian: "Serbian",
    hindi: "Hindi",
    norwegian: "Norwegian",
    thai: "Thai",
    slovenian: "Slovenian",
    ukrainian: "Ukrainian",
    albania: "Albanian"
  },
  product: "Product",
  quantity: "Quantity",
  order_summary: "Order summary",
  vat: "Sales tax",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Shipping method",
    not_available: "Oops! It looks like we don't offer shipping to this location yet",
    condition_label: {
      price: "For orders priced between {{min}} {{currency}} to {{max}} {{currency}}",
      price_min: "For orders priced at {{min}} {{currency}} or more",
      quantity: "For orders containing between {{min}} to {{max}} items",
      quantity_min: "For orders containing {{min}} or more items",
      weight: "For orders with a total weight between {{min}}g to {{max}}g",
      weight_min: "For orders with a total weight of {{min}}g or more"
    }
  },
  shipping_fee: "Shipping fee",
  total_amount_with_tax_and_shipping: "Total (including tax and Shipping)",
  vat_percent: "Sales tax ({{percent}}%)",
  including_tax: "Includes {{percent}}% VAT ({{amount}})"
}, DA = {
  public_pages_purchase: RA
}, IA = {
  "required-field": "El campo es necesario",
  payment: {
    price_plan: "Plan",
    stripe_card: "Tarjetas de crédito (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Tarjetas de crédito (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Tarjetas de crédito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Pago contra entrega",
    xendit_card: "Tarjetas de crédito (Xendit)",
    paystack_card: "Tarjetas de crédito (Paystack)",
    paypal_connect: "Conectar PayPal",
    paypal_edit_organization_name: "Editar el nombre de la organización",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Error",
  "Payment-method": "Método de pago",
  price_plan: {
    trial_period: {
      week: "{{count}} semana",
      week_plural: "{{count}} semanas",
      day: "{{count}} día",
      day_plural: "{{count}} días",
      month: "{{count}} mes",
      month_plural: "{{count}} meses",
      year: "{{count}} año",
      year_plural: "{{count}} años"
    },
    interval: {
      month: "mes",
      month_plural: "{{count}} meses",
      day: "día",
      day_plural: "{{count}} días",
      week: "semana",
      week_plural: "{{count}} semanas",
      year: "año",
      year_plural: "{{count}} años"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} luego",
        unlimited_new: "<bold>{{amount}}</bold> cada {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} veces"
      }
    }
  },
  affiliate_badge: {
    made_with: "Desarrollado por"
  },
  form_select: {
    empty_list: "Parece que esta lista está vacía",
    select: "Seleccionar"
  },
  contact_slug: {
    email: "Correo",
    first_name: "Nombre",
    last_name: "Apellido",
    phone_number: "Número de teléfono",
    country: "País",
    street_address: "Dirección",
    city: "Ciudad",
    postal_code: "Código postal",
    company_name: "Nombre de la empresa",
    tax_number: "Número de IVA",
    state_province: "Estado/Provincia",
    street_number: "Dirección",
    neighborhood: "Barrio"
  },
  date_picker: {
    apply: "Aplicar",
    clear: "Borrar",
    time: "Hola",
    all_time: "Desde siempre",
    last_3_months: "Últimos 3 meses",
    last_pool_period: "Último periodo de evaluación de la pool",
    last_month: "Último mes",
    this_month: "Este mes",
    last_30_days: "Últimos 30 días",
    title_dates: "Fechas",
    from: "Desde",
    to: "Hasta"
  },
  copy_clipboard: "Copiado en el portapapeles",
  payment_inputs: {
    empty_card_number: "Ingresa un número de tarjeta",
    invalid_card_number: "El número de tarjeta no es válido",
    empty_expiry_date: "Ingresa la fecha de expiración",
    month_out_of_range: "El mes de expiración debe estar entre 01 y 12",
    year_out_of_range: "El año de expiración no puede estar situado en el pasado",
    date_out_of_range: "La fecha de expiración no puede estar situada en el pasado",
    invalid_expiry_date: "La fecha de expiracion no es válida",
    invalid_cvc: "El CVC no es válido",
    empty_cvc: "Ingresa un CVC",
    card_number_placeholder: "Número de tarjeta",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titular de la tarjeta",
    empty_card_holder: "Ingresa el nombre del titular de la tarjeta"
  },
  copy_clipboard_error: "Error el copiar el texto",
  input: {
    phone_number: "Teléfono",
    phone_search: "Buscar",
    search: "Buscar"
  },
  "registered-over": "registrado hace más de",
  locale: {
    french: "Francés",
    german: "Alemán",
    italian: "Italiano",
    dutch: "Holandés",
    english: "Inglés",
    portuguese: "Portugués",
    russian: "Ruso",
    spanish: "Español",
    japanese: "Japonés",
    arabic: "árabe",
    turkish: "Turco",
    chinese: "Chino",
    swedish: "Sueco",
    romanian: "Rumano",
    czech: "Checo",
    hungarian: "Húngaro",
    slovak: "Eslovaco",
    danish: "Danés",
    indonesian: "Indonesio",
    polish: "Polaco",
    greek: "Griego",
    serbian: "Serbio",
    hindi: "Hindi",
    norwegian: "Noruego",
    thai: "Tailandés",
    slovenian: "Esloveno",
    ukrainian: "Ucraniano",
    albania: "Albanés"
  },
  product: "Producto",
  quantity: "Cantidad",
  order_summary: "Resumen del pedido",
  vat: "IVA",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Método de envío",
    not_available: "¡Vaya! Parece que aún no ofrecemos envíos a esta ubicación",
    condition_label: {
      price: "Para pedidos con precio entre {{min}} {{currency}} y {{max}} {{currency}}",
      price_min: "Para pedidos que cuesten {{min}} {{currency}} o más",
      quantity: "Para pedidos de entre {{min}} y {{max}} artículos",
      quantity_min: "Para pedidos con {{min}} o más artículos",
      weight: "Para pedidos con un peso total entre {{min}}g y {{max}}g",
      weight_min: "Para pedidos con un peso total de {{min}}g o más"
    }
  },
  shipping_fee: "Tarifa de envío",
  total_amount_with_tax_and_shipping: "Total (incluyendo impuestos y envío)",
  vat_percent: "IVA ({{percent}}%)",
  including_tax: "Incluye el {{percent}}% de IVA ({{amount}})"
}, jA = {
  public_pages_purchase: IA
}, BA = {
  "required-field": "Le champ est obligatoire",
  payment: {
    price_plan: "Plan",
    stripe_card: "Cartes de crédit (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "BanContact (Stripe)",
    dlocal_card: "Cartes de crédit (Dlocal)",
    dlocal_boleto: "Billet (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Cartes de crédit (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Paiement à la livraison",
    xendit_card: "Cartes de crédit (Xendit)",
    paystack_card: "Cartes de crédit (Paystack)",
    paypal_connect: "Connectez-vous à PayPal",
    paypal_edit_organization_name: "Modifier le nom de l'organisation",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Erreur",
  "Payment-method": "Mode de paiement",
  price_plan: {
    trial_period: {
      week: "{{count}} semaine",
      week_plural: "{{count}} semaines",
      day: "{{count}} jour",
      day_plural: "{{count}} jours",
      month: "{{count}} mois",
      month_plural: "{{count}} mois",
      year: "{{count}} an",
      year_plural: "{{count}} ans"
    },
    interval: {
      month: "mois",
      month_plural: "{{count}} mois",
      day: "jour",
      day_plural: "{{count}} jours",
      week: "semaine",
      week_plural: "{{count}} semaines",
      year: "an",
      year_plural: "{{count}} ans"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuit",
        trial_period_new: "{{ trialPeriodPrice }} pendant {{ trialInterval }} puis",
        unlimited_new: "<bold>{{amount}}</bold> tous {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }}  - {{ count }} fois"
      }
    }
  },
  affiliate_badge: {
    made_with: "Développé par"
  },
  form_select: {
    empty_list: "Cette liste semble vide",
    select: "Sélectionner"
  },
  contact_slug: {
    email: "Email",
    first_name: "Prénom",
    last_name: "Nom",
    phone_number: "Numéro de téléphone",
    country: "Pays",
    street_address: "Adresse",
    city: "Ville",
    postal_code: "Code postal",
    company_name: "Nom de l'entreprise",
    tax_number: "Numéro d'identification fiscale",
    state_province: "Région",
    street_number: "Numéro de rue",
    neighborhood: "Quartier"
  },
  date_picker: {
    apply: "Appliquer",
    clear: "Effacer",
    time: "Horaire",
    all_time: "Depuis le début",
    last_3_months: "Les 3 derniers mois",
    last_pool_period: "Dernière période d'évaluation du pool",
    last_month: "Le mois dernier",
    this_month: "Ce mois",
    last_30_days: "Les 30 derniers jours",
    title_dates: "Dates",
    from: "De",
    to: "À"
  },
  copy_clipboard: "Copié dans le presse-papier",
  payment_inputs: {
    empty_card_number: "Entrez un numéro de carte",
    invalid_card_number: "Le numéro de carte est invalide",
    empty_expiry_date: "Entrez une date d'expiration",
    month_out_of_range: "Le mois d’expiration doit être entre 01 et 12",
    year_out_of_range: "L'année d'expiration ne peut pas être dans le passé",
    date_out_of_range: "La date d’expiration ne peut pas être dans le passé",
    invalid_expiry_date: "La date d’expiration est invalide",
    invalid_cvc: "Le code CVC est invalide",
    empty_cvc: "Saisissez le code CVC",
    card_number_placeholder: "Numéro de carte",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titulaire de la carte",
    empty_card_holder: "Saisir le nom du titulaire de la carte"
  },
  copy_clipboard_error: "Échec de la copie du texte",
  input: {
    phone_number: "Numéro de téléphone",
    phone_search: "Recherche",
    search: "Recherche"
  },
  "registered-over": "enregistré plus de",
  locale: {
    french: "Français",
    german: "Allemand",
    italian: "Italiano",
    dutch: "Néerlandais",
    english: "Anglais",
    portuguese: "Portugais",
    russian: "Russe",
    spanish: "Espagnol",
    japanese: "Japonais",
    arabic: "Аrabe",
    turkish: "Turc",
    chinese: "Chinois",
    swedish: "Suédois",
    romanian: "Roumain",
    czech: "Tchèque",
    hungarian: "Hongrois",
    slovak: "Slovaque",
    danish: "Danois",
    indonesian: "Indonésien",
    polish: "Polonais",
    greek: "Grec",
    serbian: "Serbe",
    hindi: "Indien",
    norwegian: "Norvégien",
    thai: "Thaïlandais",
    slovenian: "Slovène",
    ukrainian: "Ukrainien",
    albania: "Albanais"
  },
  product: "Produit",
  quantity: "Quantité",
  order_summary: "Résumé de la commande",
  vat: "TVA",
  total: "Total",
  subtotal: "Sous-total",
  shipping: {
    shipping_method: "Méthode d'expédition",
    not_available: "Oups ! Il semble qu'on ne livre pas encore à cet endroit",
    condition_label: {
      price: "Pour les commandes dont le prix est compris entre {{min}} {{currency}} et {{max}} {{currency}}",
      price_min: "Pour les commandes dont le prix est de {{min}} {{currency}} ou plus",
      quantity: "Pour les commandes contenant entre {{min}} et {{max}} articles",
      quantity_min: "Pour les commandes contenant {{min}} articles ou plus",
      weight: "Pour les commandes avec un poids total compris entre {{min}}g et {{max}}g",
      weight_min: "Pour les commandes avec un poids total de {{min}}g ou plus"
    }
  },
  shipping_fee: "Frais d'expédition",
  total_amount_with_tax_and_shipping: "Total (y compris la TVA et l'expédition)",
  vat_percent: "TVA ({{percent}}%)",
  including_tax: "Comprend {{percent}} % de TVA ({{amount}})"
}, FA = {
  public_pages_purchase: BA
}, zA = {
  "required-field": "यह फील्ड भरना अनिवार्य है",
  payment: {
    price_plan: "प्लान",
    stripe_card: "क्रेडिट कार्ड्स (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "बैनकॉन्टैक्ट (Stripe)",
    dlocal_card: "क्रेडिट कार्ड्स (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "क्रेडिट कार्ड्स (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "कैश-ऑन-डिलीवरी",
    xendit_card: "क्रेडिट कार्ड्स (Xendit)",
    paystack_card: "क्रेडिट कार्ड्स (Paystack)",
    paypal_connect: "Paypal से जुड़ें",
    paypal_edit_organization_name: "संगठन का नाम एडिट करें",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "एप्पल पे",
    xendit: {
      "3ds": "3D-सिक्योर"
    }
  },
  error: "एरर",
  "Payment-method": "पेमेंट मेथड",
  price_plan: {
    trial_period: {
      week: "{{count}} सप्ताह",
      week_plural: "{{count}} दिन",
      day: "{{count}} दिन",
      day_plural: "{{count}} दिन",
      month: "{{count}} महीना",
      month_plural: "{{count}} महीने",
      year: "{{count}} वर्ष",
      year_plural: "{{count}} वर्ष"
    },
    interval: {
      month: "महीना",
      month_plural: "{{count}} महीने",
      day: "दिन",
      day_plural: "{{count}} दिन",
      week: "सप्ताह",
      week_plural: "{{count}} सप्ताह",
      year: "वर्ष",
      year_plural: "{{count}} वर्ष"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "मुफ्त",
        trial_period_new: "{{ trialPeriodPrice }} के लिए {{ trialInterval }} फिर",
        unlimited_new: "{{amount}} हर {{interval}} पर",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} बार"
      }
    }
  },
  affiliate_badge: {
    made_with: "द्वारा संचालित"
  },
  form_select: {
    empty_list: "लगता है यह लिस्ट खाली है",
    select: "चूनें"
  },
  contact_slug: {
    email: "ईमेल",
    first_name: "प्रथम नाम",
    last_name: "अंतिम नाम",
    phone_number: "फ़ोन नंबर",
    country: "देश",
    street_address: "सड़क का पता",
    city: "शहर",
    postal_code: "पोस्टल कोड",
    company_name: "कंपनी का नाम",
    tax_number: "टैक्स नंबर",
    state_province: "राज्य/प्रान्त",
    street_number: "सड़क संख्या",
    neighborhood: "पड़ोस"
  },
  date_picker: {
    apply: "लागू करें",
    clear: "हटाएं",
    time: "समय",
    all_time: "सभी समय",
    last_3_months: "पिछले 3 महीने",
    last_pool_period: "पिछले पूल मूल्यांकन अवधि",
    last_month: "पिछले महीने",
    this_month: "इस महीने",
    last_30_days: "पिछले 30 दिन",
    title_dates: "दिनांक",
    from: "से",
    to: "तक"
  },
  copy_clipboard: "क्लिपबोर्ड पर कॉपी किया गया",
  payment_inputs: {
    empty_card_number: "कार्ड नंबर दर्ज करें",
    invalid_card_number: "कार्ड नंबर अमान्य है ",
    empty_expiry_date: "समाप्ति तिथि दर्ज करें",
    month_out_of_range: "समाप्ति माह 01 और 12 के बीच होना चाहिए ",
    year_out_of_range: "समाप्ति वर्ष अतीत में नहीं हो सकता",
    date_out_of_range: "समाप्ति तिथि अतीत में नहीं हो सकती",
    invalid_expiry_date: "समाप्ति तिथि अमान्य है",
    invalid_cvc: "CVC अमान्य है",
    empty_cvc: "CVC दर्ज करें  ",
    card_number_placeholder: "कार्ड नंबर",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "कार्ड धारक",
    empty_card_holder: "एक कार्ड धारक का नाम दर्ज करें"
  },
  copy_clipboard_error: "टेक्स्ट कॉपी करने में असफल",
  input: {
    phone_number: "फोन नंबर",
    phone_search: "खोजें",
    search: "खोजें"
  },
  "registered-over": "पंजीकृत किया गया",
  locale: {
    french: "फ्रेंच",
    german: "जर्मन",
    italian: "इटैलिनो",
    dutch: "डच",
    english: "अंग्रेज़ी",
    portuguese: "पुर्तगाली",
    russian: "रूसी",
    spanish: "स्पैनिश",
    japanese: "जापानी",
    arabic: "अरबी",
    turkish: "तुर्की",
    chinese: "चीनी",
    swedish: "स्वीडिश",
    romanian: "रोमानियाई",
    czech: "चेक",
    hungarian: "हंगेरीअन ",
    slovak: "स्लोवाक",
    danish: "डैनिश",
    indonesian: "इन्डोनेशियाई",
    polish: "पोलिश",
    greek: "यूनानी",
    serbian: "सर्बियाई",
    hindi: "हिंदी ",
    norwegian: "नार्वेजियन",
    thai: "थाई",
    slovenian: "स्लोवेनियाई",
    ukrainian: "यूक्रेनी",
    albania: "अल्बानियन"
  },
  product: "प्रोडक्ट",
  quantity: "क्वान्टिटी",
  order_summary: "ऑर्डर समरी",
  vat: "सेल्स टैक्स",
  total: "टोटल",
  subtotal: "सब टोटल ",
  shipping: {
    shipping_method: "शिपिंग मेथड",
    not_available: "अरे! ऐसा लगता है कि हम अभी इस स्थान पर शिपिंग की पेशकश नहीं करते है ",
    condition_label: {
      price: "{{min}} {{currency}} से {{max}} {{currency}} के बीच प्राइस वाले ऑर्डर्स के लिए",
      price_min: "{{min}} {{currency}} या अधिक प्राइस वाले ऑर्डर्स के लिए",
      quantity: "{{min}} से {{max}} आइटम वाले ऑर्डर्स के लिए",
      quantity_min: "{{min}} या अधिक आइटम वाले ऑर्डर्स के लिए",
      weight: "{{min}}g से {{max}}g के बीच कुल वजन वाले ऑर्डर्स के लिए",
      weight_min: "{{min}}g या अधिक कुल वजन वाले ऑर्डर्स के लिए"
    }
  },
  shipping_fee: "शिपिंग शुल्क",
  total_amount_with_tax_and_shipping: "कुल (कर और शिपिंग सहित)",
  vat_percent: "सेल्स टैक्स ({{percent}}%)",
  including_tax: "शामिल है {{percent}}% VAT ({{amount}})"
}, GA = {
  public_pages_purchase: zA
}, HA = {
  "required-field": "A mező kitöltése kötelező",
  payment: {
    price_plan: "Terv",
    stripe_card: "Hitelkártyák (Stripe)",
    stripe_ideal: "iDeal (csík)",
    stripe_bancotact: "Bancontact (csíkos)",
    dlocal_card: "Hitelkártyák (Dlocal)",
    dlocal_boleto: "Boleto (helyi)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Hitelkártyák (Mercado Pago)",
    mercadopago_pix: "PIX (fizetési piac)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Utánvétes fizetés",
    xendit_card: "Hitelkártyák (Xendit)",
    paystack_card: "Hitelkártyák (Paystack)",
    paypal_connect: "Csatlakoztassa a PayPal-t",
    paypal_edit_organization_name: "Szerkessze a szervezet nevét",
    paypal_rest: "PayPal",
    secure_and_pay: "Biztonságos és fizetés",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Hiba",
  "Payment-method": "Fizetési mód",
  price_plan: {
    trial_period: {
      week: "{{count}} hét",
      week_plural: "{{count}} hét",
      day: "{{count}} nap",
      day_plural: "{{count}} nap",
      month: "{{count}} hónap",
      month_plural: "{{count}} hónap",
      year: "{{count}} év",
      year_plural: "{{count}} év"
    },
    interval: {
      month: "hónap",
      month_plural: "{{count}} hónap",
      day: "nap",
      day_plural: "{{count}} nap",
      week: "hét",
      week_plural: "{{count}} hét",
      year: "év",
      year_plural: "{{count}} év"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Ingyenes",
        trial_period_new: "{{ trialPeriodPrice }} , akkor {{ trialInterval }}",
        unlimited_new: "<bold>{{amount}}</bold> minden {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} alkalommal"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Úgy tűnik, hogy ez a lista üres",
    select: "Kiválasztás"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Keresztnév",
    last_name: "Vezetéknév",
    phone_number: "Telefonszám",
    country: "Ország",
    street_address: "Utca cím",
    city: "Város",
    postal_code: "Irányítószám",
    company_name: "Cégnév",
    tax_number: "Adószám",
    state_province: "Állam/Mező",
    street_number: "Utca szám",
    neighborhood: "Környék"
  },
  date_picker: {
    apply: "Alkalmaz",
    clear: "Törlés",
    time: "Idő",
    all_time: "Minden idő",
    last_3_months: "Utolsó 3 hónap",
    last_pool_period: "Utolsó medenceértékelési időszak",
    last_month: "Utolsó hónap",
    this_month: "Ez a hónap",
    last_30_days: "Utolsó 30 nap",
    title_dates: "Dátumok",
    from: "Tól",
    to: "Ig"
  },
  copy_clipboard: "Másolva a vágólapra",
  payment_inputs: {
    empty_card_number: "Adjon meg egy kártyaszámot",
    invalid_card_number: "A kártyaszám érvénytelen",
    empty_expiry_date: "Adjon meg egy lejárati dátumot",
    month_out_of_range: "A lejárati hónapnak 01 és 12 között kell lennie",
    year_out_of_range: "A lejárati év nem lehet a múltban",
    date_out_of_range: "A lejárati dátum nem lehet a múltban",
    invalid_expiry_date: "A lejárati dátum érvénytelen",
    invalid_cvc: "A CVC érvénytelen",
    empty_cvc: "Adja meg a CVC-t",
    card_number_placeholder: "Kártyaszám",
    expiry_data_placeholder: "HH/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kártyabirtokos",
    empty_card_holder: "Adja meg a kártyabirtokos nevét"
  },
  copy_clipboard_error: "A szöveg másolása nem sikerült",
  input: {
    phone_number: "Telefonszám",
    phone_search: "Keresés",
    search: "Keresés"
  },
  "registered-over": "regisztrált több mint",
  locale: {
    french: "Francia",
    german: "Német",
    italian: "Olasz",
    dutch: "Holland",
    english: "Angol",
    portuguese: "Portugál",
    russian: "Orosz",
    spanish: "Spanyol",
    japanese: "Japán",
    arabic: "Arab",
    turkish: "Török",
    chinese: "Kínai",
    swedish: "Svéd",
    romanian: "Román",
    czech: "Cseh",
    hungarian: "Magyar",
    slovak: "Szlovák",
    danish: "Dán",
    indonesian: "Indonéz",
    polish: "Fényesít",
    greek: "Görög",
    serbian: "Szerb",
    hindi: "Dehogy",
    norwegian: "Norvég",
    thai: "Thai",
    slovenian: "Szlovén",
    ukrainian: "Ukrán",
    albania: "Albán"
  },
  product: "Termék",
  quantity: "Mennyiség",
  order_summary: "Rendelés összegzése",
  vat: "Áfa",
  total: "Összesen",
  subtotal: "Részösszeg",
  shipping: {
    shipping_method: "Szállítási mód",
    not_available: "Hoppá! Úgy tűnik, hogy még nem kínálunk szállítást erre a helyre.",
    condition_label: {
      price: "A {{min}} {{currency}} és {{max}} {{currency}} közötti árú rendelésekhez",
      price_min: "A {{min}} {{currency}} vagy annál drágább rendelésekhez",
      quantity: "A {{min}} és {{max}} közötti tételeket tartalmazó rendelésekhez",
      quantity_min: "A {{min}} vagy annál több tételt tartalmazó rendelésekhez",
      weight: "A {{min}}g és {{max}}g közötti összsúlyú rendelésekhez",
      weight_min: "A {{min}}g vagy annál nehezebb rendelésekhez"
    }
  },
  shipping_fee: "Szállítási díj",
  total_amount_with_tax_and_shipping: "Összesen (beleértve az adót és a szállítást)",
  vat_percent: "Áruforgalmi adó ({{percent}}%)",
  including_tax: "ÁFA {{percent}}%-ot tartalmaz ({{amount}})"
}, KA = {
  public_pages_purchase: HA
}, UA = {
  "required-field": "Bidang wajib diisi",
  payment: {
    price_plan: "Rencana",
    stripe_card: "Kartu kredit (Garis)",
    stripe_ideal: "iDeal (Garis)",
    stripe_bancotact: "Bancontact (Garis)",
    dlocal_card: "Kartu kredit (Dlokal)",
    dlocal_boleto: "Boleto (Dlokal)",
    dlocal_pix: "Pix (Dlokal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kartu kredit (Mercado Pago)",
    mercadopago_pix: "PIX (Pasar Pembayaran)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Pembayaran pisau cukur",
    flutterwave: "Gelombang bergetar",
    mollie: "Mollie",
    gocardless: "Tanpa kartu",
    cash_on_delivery: "Bayar di tempat",
    xendit_card: "Kartu kredit (Xendit)",
    paystack_card: "Kartu kredit (Paystack)",
    paypal_connect: "Hubungkan PayPal",
    paypal_edit_organization_name: "Edit nama organisasi",
    paypal_rest: "PayPal",
    secure_and_pay: "Amankan dan Bayar",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Kesalahan",
  "Payment-method": "Metode pembayaran",
  price_plan: {
    trial_period: {
      week: "{{count}} minggu",
      day: "{{count}} hari",
      month: "{{count}} bulan",
      year: "{{count}} tahun"
    },
    interval: {
      month: "bulan",
      day: "hari",
      week: "pekan",
      year: "tahun"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Bebas",
        trial_period_new: "{{ trialPeriodPrice }} untuk {{ trialInterval }} lalu",
        unlimited_new: "<bold>{{amount}}</bold> setiap {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kali"
      }
    }
  },
  affiliate_badge: {
    made_with: "Ditenagai oleh"
  },
  form_select: {
    empty_list: "Sepertinya daftar ini kosong",
    select: "Pilih"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nama depan",
    last_name: "Nama belakang",
    phone_number: "Nomor telepon",
    country: "Negara",
    street_address: "Alamat jalan",
    city: "Kota",
    postal_code: "Kode pos",
    company_name: "Nama perusahaan",
    tax_number: "Nomor pajak",
    state_province: "Negara Bagian/Provinsi",
    street_number: "Nomor jalan",
    neighborhood: "Lingkungan"
  },
  date_picker: {
    apply: "Terapkan",
    clear: "Bersihkan",
    time: "Waktu",
    all_time: "Semua waktu",
    last_3_months: "3 bulan terakhir",
    last_pool_period: "Periode evaluasi kolam terakhir",
    last_month: "Bulan lalu",
    this_month: "Bulan ini",
    last_30_days: "30 hari terakhir",
    title_dates: "Tanggal",
    from: "Dari",
    to: "Ke"
  },
  copy_clipboard: "Disalin ke clipboard",
  payment_inputs: {
    empty_card_number: "Masukkan nomor kartu",
    invalid_card_number: "Nomor kartu tidak valid",
    empty_expiry_date: "Masukkan tanggal kedaluwarsa",
    month_out_of_range: "Bulan kedaluwarsa harus antara 01 dan 12",
    year_out_of_range: "Tahun kedaluwarsa tidak boleh di masa lalu",
    date_out_of_range: "Tanggal kedaluwarsa tidak boleh di masa lalu",
    invalid_expiry_date: "Tanggal kedaluwarsa tidak valid",
    invalid_cvc: "CVC tidak valid",
    empty_cvc: "Masukkan CVC",
    card_number_placeholder: "Nomor kartu",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Pemegang kartu",
    empty_card_holder: "Masukkan nama pemegang kartu"
  },
  copy_clipboard_error: "Gagal menyalin teks",
  input: {
    phone_number: "Nomor telepon",
    phone_search: "Cari",
    search: "Cari"
  },
  "registered-over": "terdaftar lebih dari",
  locale: {
    french: "Perancis",
    german: "Jerman",
    italian: "Italia",
    dutch: "Belanda",
    english: "Bahasa inggris",
    portuguese: "Portugis",
    russian: "Rusia",
    spanish: "Orang Spanyol",
    japanese: "Jepang",
    arabic: "Arab",
    turkish: "Turki",
    chinese: "Cina",
    swedish: "Orang Swedia",
    romanian: "Rumania",
    czech: "Ceko",
    hungarian: "Hongaria",
    slovak: "Orang Slovakia",
    danish: "Orang Denmark",
    indonesian: "Bahasa Indonesia",
    polish: "Polandia",
    greek: "Orang yunani",
    serbian: "Orang Serbia",
    hindi: "Tidak",
    norwegian: "Norwegia",
    thai: "Thai",
    slovenian: "Slovenia",
    ukrainian: "Orang Ukraina",
    albania: "Bahasa Albania"
  },
  product: "Produk",
  quantity: "Kuantitas",
  order_summary: "Ringkasan Pesanan",
  vat: "Pajak penjualan",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Metode Pengiriman",
    not_available: "Ups! Sepertinya kami belum menawarkan pengiriman ke lokasi ini.",
    condition_label: {
      price: "Untuk pesanan yang harganya antara {{min}} {{currency}} hingga {{max}} {{currency}}",
      price_min: "Untuk pesanan yang harganya {{min}} {{currency}} atau lebih",
      quantity: "Untuk pesanan yang berisi antara {{min}} hingga {{max}} item",
      quantity_min: "Untuk pesanan yang berisi {{min}} item atau lebih",
      weight: "Untuk pesanan dengan total berat antara {{min}}g hingga {{max}}g",
      weight_min: "Untuk pesanan dengan total berat {{min}}g atau lebih"
    }
  },
  shipping_fee: "Biaya pengiriman",
  total_amount_with_tax_and_shipping: "Total (termasuk pajak dan pengiriman)",
  vat_percent: "Pajak penjualan ({{percent}}%)",
  including_tax: "Termasuk PPN {{percent}}% ({{amount}})"
}, $A = {
  public_pages_purchase: UA
}, VA = {
  "required-field": "Il campo è obbligatorio",
  payment: {
    price_plan: "Piano",
    stripe_card: "Carte di credito (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Carte di credito (Dlocal)",
    dlocal_boleto: "Biglietto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Carte di credito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Biglietto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Contanti alla consegna",
    xendit_card: "Carte di credito (Xendit)",
    paystack_card: "Carte di credito (Paystack)",
    paypal_connect: "Collegare PayPal",
    paypal_edit_organization_name: "Modifica il nome dell'organizzazione",
    paypal_rest: "PayPal",
    secure_and_pay: "Sicurezza e pagamento",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Errore",
  "Payment-method": "Metodo di pagamento",
  price_plan: {
    trial_period: {
      week: "{{count}} settimana",
      week_plural: "{{count}} settimane",
      day: "{{count}} giorno",
      day_plural: "{{count}} giorni",
      month: "{{count}} mese",
      month_plural: "{{count}} mesi",
      year: "{{count}} anni",
      year_plural: "{{count}} anni"
    },
    interval: {
      month: "mese",
      month_plural: "{{count}} mesi",
      day: "giorno",
      day_plural: "{{count}} giorni",
      week: "settimana",
      week_plural: "{{count}} settimane",
      year: "anno",
      year_plural: "{{count}} anni"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuito",
        trial_period_new: "{{ trialPeriodPrice }} per {{ trialInterval }} poi",
        unlimited_new: "<bold>{{amount}}</bold> ogni {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} tempi"
      }
    }
  },
  affiliate_badge: {
    made_with: "Realizzato da"
  },
  form_select: {
    empty_list: "Sembra che questo elenco sia vuoto",
    select: "Selezionare"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nome",
    last_name: "Cognome",
    phone_number: "Numero di telefono",
    country: "Paese",
    street_address: "Indirizzo",
    city: "Città",
    postal_code: "Codice postale",
    company_name: "Nome azienda",
    tax_number: "Partita IVA",
    state_province: "Stato/Provincia",
    street_number: "Numero civico",
    neighborhood: "Quartiere"
  },
  date_picker: {
    apply: "Applicare",
    clear: "Chiaro",
    time: "Tempo",
    all_time: "Per tutto il periodo",
    last_3_months: "Ultimi 3 mesi",
    last_pool_period: "Ultimo periodo di valutazione del pool",
    last_month: "Ultimo mese",
    this_month: "Questo mese",
    last_30_days: "Ultimi 30 giorni",
    title_dates: "Date",
    from: "Da",
    to: "A"
  },
  copy_clipboard: "Copiato negli appunti",
  payment_inputs: {
    empty_card_number: "Inserire un numero di carta",
    invalid_card_number: "Il numero della carta non è valido",
    empty_expiry_date: "Inserire una data di scadenza",
    month_out_of_range: "Il mese di scadenza deve essere compreso tra 01 e 12",
    year_out_of_range: "L'anno di scadenza non può essere passato",
    date_out_of_range: "La data di scadenza non può essere passata",
    invalid_expiry_date: "La data di scadenza non è valida",
    invalid_cvc: "Il CVC non è valido",
    empty_cvc: "Inserire una CVC",
    card_number_placeholder: "Numero della carta",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Portacarte",
    empty_card_holder: "Inserire il nome del titolare della carta"
  },
  copy_clipboard_error: "Impossibile copiare il testo",
  input: {
    phone_number: "Numero di telefono",
    phone_search: "Ricerca",
    search: "Ricerca"
  },
  "registered-over": "registrato oltre",
  locale: {
    french: "Francese",
    german: "Tedesco",
    italian: "Italiano",
    dutch: "Olandese",
    english: "Inglese",
    portuguese: "Portoghese",
    russian: "Russo",
    spanish: "Spagnolo",
    japanese: "Giapponese",
    arabic: "Аrabo",
    turkish: "Turco",
    chinese: "Cinese",
    swedish: "Svedese",
    romanian: "Rumeno",
    czech: "Ceco",
    hungarian: "Ungherese",
    slovak: "Slovacco",
    danish: "Danese",
    indonesian: "Indonesiano",
    polish: "Polacco",
    greek: "Greco",
    serbian: "Serbo",
    hindi: "Hindi",
    norwegian: "Norvegese",
    thai: "Tailandese",
    slovenian: "Sloveno",
    ukrainian: "Ucraino",
    albania: "Albanese"
  },
  product: "Prodotto",
  quantity: "Quantità",
  order_summary: "Riepilogo dell'ordine",
  vat: "Imposta sulle vendite",
  total: "Totale",
  subtotal: "Totale parziale",
  shipping: {
    shipping_method: "Metodo di spedizione",
    not_available: "Ops! Sembra che per ora non offriamo spedizioni in questa località.",
    condition_label: {
      price: "Per ordini con un prezzo compreso tra {{min}} {{currency}} e {{max}} {{currency}}",
      price_min: "Per ordini con un prezzo di {{min}} {{currency}} o più",
      quantity: "Per ordini contenenti tra {{min}} e {{max}} articoli",
      quantity_min: "Per ordini contenenti {{min}} articoli o più",
      weight: "Per ordini con un peso totale compreso tra {{min}}g e {{max}}g",
      weight_min: "Per ordini con un peso totale di {{min}}g o più"
    }
  },
  shipping_fee: "Spese di spedizione",
  total_amount_with_tax_and_shipping: "Totale (incluso l'imposta e la spedizione)",
  vat_percent: "Imposta sulle vendite ({{percent}}%)",
  including_tax: "Include {{percent}}% di IVA ({{amount}})"
}, WA = {
  public_pages_purchase: VA
}, YA = {
  "required-field": "フィールドは必須項目です",
  payment: {
    price_plan: "プラン",
    stripe_card: "クレジットカード（Stripe）",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact（Stripe）",
    dlocal_card: "クレジットカード（Dlocal）",
    dlocal_boleto: "Borelo（Dlocal）",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "Paypal",
    mercadopago_card: "クレジットカード (Mercado Pago)",
    mercadopago_pix: "PIX（Mercado Pago）",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay ",
    flutterwave: "Flutterwave ",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "着払い",
    xendit_card: "クレジットカード（Xendit）",
    paystack_card: "クレジットカード（Paystack）",
    paypal_connect: "PayPalに接続",
    paypal_edit_organization_name: "組織名を編集",
    paypal_rest: "ペイパル",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Appleペイ",
    xendit: {
      "3ds": "3Dセキュア"
    }
  },
  error: "エラー",
  "Payment-method": "支払い方法",
  price_plan: {
    trial_period: {
      week: `{{count}}週

{{count}}週`,
      day: `{{count}} 日

{{count}} 日`,
      month: `{{count}}ヶ月

{{count}}ヶ月`,
      year: `{{count}}年

{{count}}年`
    },
    interval: {
      month: `ヶ月

{{count}}ヶ月`,
      day: `日

{{count}} 日`,
      week: `週

{{count}}週`,
      year: `年

{{count}}年`
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "無料",
        trial_period_new: "{{ trialPeriodPrice }}を{{ trialInterval }}間ご利用いただけます。その後は",
        unlimited_new: "{{interval}}ごとに<bold>{{amount}}</bold>",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 回"
      }
    }
  },
  affiliate_badge: {
    made_with: "提供元"
  },
  form_select: {
    empty_list: "このリストが空のようです",
    select: "選択する"
  },
  contact_slug: {
    email: "Eメール",
    first_name: "名",
    last_name: "苗字",
    phone_number: "電話番号",
    country: "国",
    street_address: "住所",
    city: "市",
    postal_code: "郵便番号",
    company_name: "法人名",
    tax_number: "納税者番号",
    state_province: "州/都道府県",
    street_number: "番地",
    neighborhood: "近隣地域"
  },
  date_picker: {
    apply: "適用",
    clear: "消去",
    time: "時",
    all_time: "全期間",
    last_3_months: "過去3ヶ月",
    last_pool_period: "最後の評価期間",
    last_month: "先月",
    this_month: "今月",
    last_30_days: "過去30日",
    title_dates: "日",
    from: "から",
    to: "へ"
  },
  copy_clipboard: "クリップボードにコピーされました",
  payment_inputs: {
    empty_card_number: "カード番号を入力",
    invalid_card_number: "カード番号が無効です",
    empty_expiry_date: "有効期限を入力してください。",
    month_out_of_range: "有効期限の月は、1月から12月の間である必要があります。",
    year_out_of_range: "有効期限の年は過去にすることはできません。",
    date_out_of_range: "有効期限は過去の日付にすることはできません。",
    invalid_expiry_date: "有効期限が無効です",
    invalid_cvc: "CVCが無効です",
    empty_cvc: "CVCを入力",
    card_number_placeholder: "カード番号",
    expiry_data_placeholder: "月/年",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "カード所有者",
    empty_card_holder: "カード所有者の名前を入力してください"
  },
  copy_clipboard_error: "テキストのコピーに失敗しました",
  input: {
    phone_number: "電話番号",
    phone_search: "検索",
    search: "検索"
  },
  "registered-over": "登録された",
  locale: {
    french: "フランス語",
    german: "ドイツ語",
    italian: "イタリア語",
    dutch: "オランダ語",
    english: "英語",
    portuguese: "ポルトガル語",
    russian: "ロシア語",
    spanish: "スペイン語",
    japanese: "日本語",
    arabic: "アラブ",
    turkish: "トルコ語",
    chinese: "中国語",
    swedish: "スウェーデン語",
    romanian: "ルーマニア語",
    czech: "チェコ語",
    hungarian: "ハンガリー語",
    slovak: "スロバキア語",
    danish: "デンマーク語",
    indonesian: "インドネシア語",
    polish: "ポーランド語",
    greek: "ギリシャ語",
    serbian: "セルビア語",
    hindi: "ヒンズー語",
    norwegian: "ノルウェー語",
    thai: "タイ語",
    slovenian: "スロバニア語",
    ukrainian: "ウクライナ語",
    albania: "アルバニア語"
  },
  product: "商品",
  quantity: "数量",
  order_summary: "ご注文概要",
  vat: "消費税",
  total: "合計",
  subtotal: "小計",
  shipping: {
    shipping_method: "配送方法",
    not_available: "おっと！この地域への配送にはまだ対応していないようです。",
    condition_label: {
      price: "{{min}} {{currency}}から{{max}} {{currency}}までの注文の場合",
      price_min: "{{min}} {{currency}}以上の注文の場合",
      quantity: "{{min}}から{{max}}個の商品を含む注文の場合",
      quantity_min: "{{min}}個以上の商品を含む注文の場合",
      weight: "合計重量が {{min}}g から {{max}}g までの注文の場合",
      weight_min: "合計重量が {{min}}g 以上の注文の場合"
    }
  },
  shipping_fee: "送料",
  total_amount_with_tax_and_shipping: "合計（消費税・送料込み）",
  vat_percent: "消費税（{{percent}}%）",
  including_tax: "消費税 {{percent}}% を含む（{{amount}}）"
}, ZA = {
  public_pages_purchase: YA
}, qA = {
  "required-field": "Veld is vereist",
  payment: {
    price_plan: "Plan",
    stripe_card: "Creditcards (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Creditcards (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlokaal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Creditcards (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Contant bij levering",
    xendit_card: "Creditcards (Xendit)",
    paystack_card: "Creditcards (Paystack)",
    paypal_connect: "Verbind PayPal",
    paypal_edit_organization_name: "Organisatienaam bewerken",
    paypal_rest: "PayPal",
    secure_and_pay: "Beveiligd betalen",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fout",
  "Payment-method": "Betaalmethode",
  price_plan: {
    trial_period: {
      week: "{{count}} week",
      week_plural: "{{count}} weken",
      day: "{{count}} dag",
      day_plural: "{{count}} dagen",
      month: "{{count}} maand",
      month_plural: "{{count}} maanden",
      year: "{{count}} jaar",
      year_plural: "{{count}} jaren"
    },
    interval: {
      month: "maand",
      month_plural: "{{count}} maanden",
      day: "dag",
      day_plural: "{{count}} dagen",
      week: "week",
      week_plural: "{{count}} weken",
      year: "jaar",
      year_plural: "{{count}} jaren"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} voor {{ trialInterval }} dan",
        unlimited_new: "<bold>{{amount}}</bold> elke {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} keer"
      }
    }
  },
  affiliate_badge: {
    made_with: "Ondersteund door"
  },
  form_select: {
    empty_list: "Het lijkt erop dat deze lijst leeg is",
    select: "Selecteer"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Voornaam",
    last_name: "Achternaam",
    phone_number: "Telefoonnummer",
    country: "Land",
    street_address: "Straatadres",
    city: "Plaats",
    postal_code: "Postcode",
    company_name: "Bedrijfsnaam",
    tax_number: "BTW-nummer",
    state_province: "Staat/Provincie",
    street_number: "Huisnummer",
    neighborhood: "Buurt"
  },
  date_picker: {
    apply: "Toepassen",
    clear: "Wissen",
    time: "Tijd",
    all_time: "Alle tijden",
    last_3_months: "Laatste 3 maanden",
    last_pool_period: "Laatste pool-evaluatieperiode",
    last_month: "Afgelopen maand",
    this_month: "Deze maand",
    last_30_days: "Laatste 30 dagen",
    title_dates: "Datum",
    from: "Van",
    to: "Naar"
  },
  copy_clipboard: "Gekopieerd naar klembord",
  payment_inputs: {
    empty_card_number: "Voer een kaartnummer in",
    invalid_card_number: "Kaartnummer is ongeldig",
    empty_expiry_date: "Voer een vervaldatum in",
    month_out_of_range: "Vervalmaand moet tussen 01 en 12 liggen",
    year_out_of_range: "Vervaljaar mag niet in het verleden liggen",
    date_out_of_range: "Vervaldatum mag niet in het verleden liggen",
    invalid_expiry_date: "Vervaldatum is ongeldig",
    invalid_cvc: "CVC is ongeldig",
    empty_cvc: "Voer een CVC in",
    card_number_placeholder: "Kaartnummer",
    expiry_data_placeholder: "MM/JJ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kaarthouder",
    empty_card_holder: "Voer de naam van de kaarthouder in"
  },
  copy_clipboard_error: "Tekst kopiëren mislukt",
  input: {
    phone_number: "Telefoonnummer",
    phone_search: "Zoek",
    search: "Zoek"
  },
  "registered-over": "geregistreerd over",
  locale: {
    french: "Frans",
    german: "Duits",
    italian: "Italiaans",
    dutch: "Nederlands",
    english: "Engels",
    portuguese: "Portugees",
    russian: "Russisch",
    spanish: "Spaans",
    japanese: "Japans",
    arabic: "Arabisch",
    turkish: "Turks",
    chinese: "Chinees",
    swedish: "Zweeds",
    romanian: "Roemeens",
    czech: "Tsjechisch",
    hungarian: "Hongaars",
    slovak: "Slowaaks",
    danish: "Deens",
    indonesian: "Indonesisch",
    polish: "Pools",
    greek: "Grieks",
    serbian: "Servisch",
    hindi: "Hindi",
    norwegian: "Noors",
    thai: "Thais",
    slovenian: "Sloveens",
    ukrainian: "Oekraïens",
    albania: "Albanees"
  },
  product: "Product",
  quantity: "Aantal",
  order_summary: "Besteloverzicht",
  vat: "Verkoopbelasting",
  total: "Totaal",
  subtotal: "Subtotaal",
  shipping: {
    shipping_method: "Verzendmethode",
    not_available: "Oeps! Het lijkt erop dat we nog geen verzending naar deze locatie aanbieden",
    condition_label: {
      price: "Voor bestellingen geprijsd tussen {{min}} {{currency}} en {{max}} {{currency}}",
      price_min: "Voor bestellingen geprijsd vanaf {{min}} {{currency}} of meer",
      quantity: "Voor bestellingen die tussen de {{min}} en {{max}} artikelen bevatten",
      quantity_min: "Voor bestellingen met {{min}} of meer artikelen",
      weight: "Voor bestellingen met een totaalgewicht tussen {{min}}g en {{max}}g",
      weight_min: "Voor bestellingen met een totaalgewicht van {{min}}g of meer"
    }
  },
  shipping_fee: "Verzendkosten",
  total_amount_with_tax_and_shipping: "Totaal (inclusief BTW en Verzending)",
  vat_percent: "BTW ({{percent}}%)",
  including_tax: "Inclusief {{percent}}% BTW ({{amount}})"
}, JA = {
  public_pages_purchase: qA
}, XA = {
  "required-field": "Felt er obligatorisk",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredittkort (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kredittkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kredittkort (Mercado Pago)",
    mercadopago_pix: "PIX (betalingsmarked)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterbølge",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kontantbetaling ved levering",
    xendit_card: "Kredittkort (Xendit)",
    paystack_card: "Kredittkort (Paystack)",
    paypal_connect: "Koble til PayPal",
    paypal_edit_organization_name: "Rediger organisasjonsnavn",
    paypal_rest: "PayPal",
    secure_and_pay: "Sikker og betal",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Feil",
  "Payment-method": "Betalingsmåte",
  price_plan: {
    trial_period: {
      week: "{{count}} uke",
      week_plural: "{{count}} uker",
      day: "{{count}} dag",
      day_plural: "{{count}} dager",
      month: "{{count}} måned",
      month_plural: "{{count}} måneder",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "måned",
      month_plural: "{{count}} måneder",
      day: "dag",
      day_plural: "{{count}} dager",
      week: "uke",
      week_plural: "{{count}} uker",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} da",
        unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ganger"
      }
    }
  },
  affiliate_badge: {
    made_with: "Drevet av"
  },
  form_select: {
    empty_list: "Det ser ut som denne listen er tom",
    select: "Velg"
  },
  contact_slug: {
    email: "E-post",
    first_name: "Fornavn",
    last_name: "Etternavn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gateadresse",
    city: "By",
    postal_code: "Postnummer",
    company_name: "Firmanavn",
    tax_number: "Skattenummer",
    state_province: "Stat/Provins",
    street_number: "Gate nummer",
    neighborhood: "Nabolag"
  },
  date_picker: {
    apply: "Bruk",
    clear: "Fjern",
    time: "Tid",
    all_time: "All tid",
    last_3_months: "Siste 3 måneder",
    last_pool_period: "Siste evalueringsperiode for basseng",
    last_month: "Siste måned",
    this_month: "Denne måneden",
    last_30_days: "Siste 30 dager",
    title_dates: "Datoer",
    from: "Fra",
    to: "Til"
  },
  copy_clipboard: "Kopiert til utklippstavlen",
  payment_inputs: {
    empty_card_number: "Skriv inn et kortnummer",
    invalid_card_number: "Kortnummeret er ugyldig",
    empty_expiry_date: "Skriv inn en utløpsdato",
    month_out_of_range: "Utløpsmåned må være mellom 01 og 12",
    year_out_of_range: "Utløpsår kan ikke være i fortiden",
    date_out_of_range: "Utløpsdato kan ikke være i fortiden",
    invalid_expiry_date: "Utløpsdato er ugyldig",
    invalid_cvc: "CVC er ugyldig",
    empty_cvc: "Skriv inn en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortholder",
    empty_card_holder: "Skriv inn navnet til kortholderen"
  },
  copy_clipboard_error: "Kunne ikke kopiere tekst",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Søk",
    search: "Søk"
  },
  "registered-over": "registrert over",
  locale: {
    french: "Fransk",
    german: "Tysk",
    italian: "Italiensk",
    dutch: "Nederlandsk",
    english: "Engelsk",
    portuguese: "Portugisisk",
    russian: "Russisk",
    spanish: "Spansk",
    japanese: "Japansk",
    arabic: "Arabisk",
    turkish: "Tyrkisk",
    chinese: "Kinesisk",
    swedish: "Svensk",
    romanian: "Rumensk",
    czech: "Tsjekkisk",
    hungarian: "Ungarsk",
    slovak: "Slovakisk",
    danish: "Dansk",
    indonesian: "Indonesisk",
    polish: "Pusse",
    greek: "Gresk",
    serbian: "Serbisk",
    hindi: "Nei",
    norwegian: "Norsk",
    thai: "Thai",
    slovenian: "Slovensk",
    ukrainian: "Ukrainsk",
    albania: "Albansk"
  },
  product: "Produkt",
  quantity: "Mengde",
  order_summary: "Ordresammendrag",
  vat: "Moms",
  total: "Totalt",
  subtotal: "Delsum",
  shipping: {
    shipping_method: "Fraktmetode",
    not_available: "Oops! Det ser ut som vi ikke tilbyr frakt til dette stedet ennå.",
    condition_label: {
      price: "For bestillinger priset mellom {{min}} {{currency}} og {{max}} {{currency}}",
      price_min: "For bestillinger priset til {{min}} {{currency}} eller mer",
      quantity: "For bestillinger som inneholder mellom {{min}} til {{max}} varer",
      quantity_min: "For bestillinger som inneholder {{min}} eller flere varer",
      weight: "For bestillinger med en totalvekt mellom {{min}}g og {{max}}g",
      weight_min: "For bestillinger med en totalvekt på {{min}}g eller mer"
    }
  },
  shipping_fee: "Fraktgebyr",
  total_amount_with_tax_and_shipping: "Totalt (inkludert skatt og frakt)",
  vat_percent: "Merverdiavgift ({{percent}}%)",
  including_tax: "Inkludert {{percent}}% MVA ({{amount}})"
}, QA = {
  public_pages_purchase: XA
}, eN = {
  "required-field": "Pole jest wymagane",
  payment: {
    price_plan: "Plan",
    stripe_card: "Karty kredytowe (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Karty kredytowe (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Karty kredytowe (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Płatność gotówką przy odbiorze",
    xendit_card: "Karty kredytowe (Xendit)",
    paystack_card: "Karty kredytowe (Paystack)",
    paypal_connect: "Połącz PayPala",
    paypal_edit_organization_name: "Edytuj nazwę organizacji",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Błąd",
  "Payment-method": "Metoda płatności",
  price_plan: {
    trial_period: {
      week_0: "{{count}} tydzień",
      week_1: "{{count}} tygodni",
      week_2: "{{count}} tygodni",
      day_0: "{{count}} dzień",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      month_0: "{{count}} miesiąc",
      month_1: "{{count}} miesięcy",
      month_2: "{{count}} miesięcy",
      year_0: "{{count}} rok",
      year_1: "{{count}} lat",
      year_2: "{{count}} lat"
    },
    interval: {
      month_0: "miesiąc",
      month_1: "{{count}} miesięcy",
      month_2: "{{count}} miesięcy",
      day_0: "dzień",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      week_0: "tydzień",
      week_1: "{{count}} tygodni",
      week_2: "{{count}} tygodni",
      year_0: "rok",
      year_1: "{{count}} lat",
      year_2: "{{count}} lat"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Bezpłatny",
        trial_period_new: "{{ trialPeriodPrice }} dla {{ trialInterval }} potem",
        unlimited_new: "<bold>{{amount}}</bold> każdy {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} razy"
      }
    }
  },
  affiliate_badge: {
    made_with: "Zasilane przez"
  },
  form_select: {
    empty_list: "Wygląda na to, że ta lista jest pusta",
    select: "Wybierz"
  },
  contact_slug: {
    email: "Email",
    first_name: "Imię",
    last_name: "Nazwisko",
    phone_number: "Numer telefonu",
    country: "Kraj",
    street_address: "Adres",
    city: "Miasto",
    postal_code: "Kod pocztowy",
    company_name: "Nazwa firmy",
    tax_number: "Numer identyfikacji podatkowej",
    state_province: "Stan/Województwo",
    street_number: "Numer ulicy",
    neighborhood: "Osiedle"
  },
  date_picker: {
    apply: "Zastosuj",
    clear: "Wyczyść",
    time: "Czas",
    all_time: "Cały czas",
    last_3_months: "Ostatnie 3 miesiące",
    last_pool_period: "Ostatni okres oceny puli",
    last_month: "Ostatni miesiąc",
    this_month: "Ten miesiąc",
    last_30_days: "Ostatnie 30 dni",
    title_dates: "Daty",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Skopiowano do schowka",
  payment_inputs: {
    empty_card_number: "Wprowadź numer karty",
    invalid_card_number: "Numer karty jest nieprawidłowy",
    empty_expiry_date: "Wprowadź datę ważności",
    month_out_of_range: "Miesiąc ważności musi być między 01 a 12",
    year_out_of_range: "Rok ważności nie może być w przeszłości",
    date_out_of_range: "Data ważności nie może być w przeszłości",
    invalid_expiry_date: "Data ważności jest nieprawidłowa",
    invalid_cvc: "CVC jest nieprawidłowy",
    empty_cvc: "Wprowadź CVC",
    card_number_placeholder: "Numer karty",
    expiry_data_placeholder: "MM/RR",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Właściciel karty",
    empty_card_holder: "Wprowadź imię i nazwisko właściciela karty"
  },
  copy_clipboard_error: "Nie udało się skopiować tekstu",
  input: {
    phone_number: "Numer telefonu",
    phone_search: "Szukaj",
    search: "Szukaj"
  },
  "registered-over": "zarejestrowano ponad",
  locale: {
    french: "Francuski",
    german: "Niemiecki",
    italian: "Włoski",
    dutch: "Holenderski",
    english: "Angielski",
    portuguese: "Portugalski",
    russian: "Rosyjski",
    spanish: "Hiszpański",
    japanese: "Japoński",
    arabic: "Arabski",
    turkish: "Turecki",
    chinese: "Chiński",
    swedish: "Szwedzki",
    romanian: "Rumuński",
    czech: "Czeski",
    hungarian: "Węgierski",
    slovak: "Słowacki",
    danish: "Duński",
    indonesian: "Indonezyjski",
    polish: "Polski",
    greek: "Grecki",
    serbian: "Serbski",
    hindi: "Hinduski",
    norwegian: "Norweski",
    thai: "Tajski",
    slovenian: "Słoweński",
    ukrainian: "Ukraiński",
    albania: "Albański"
  },
  product: "Produkt",
  quantity: "Ilość",
  order_summary: "Podsumowanie zamówienia",
  vat: "Podatek od sprzedaży",
  total: "Razem",
  subtotal: "Suma częściowa",
  shipping: {
    shipping_method: "Metoda wysyłki",
    not_available: "Ups! Wygląda na to, że nie oferujemy jeszcze wysyłki do tej lokalizacji.",
    condition_label: {
      price: "Dla zamówień w cenie od {{min}} {{currency}} do {{max}} {{currency}}",
      price_min: "Dla zamówień w cenie {{min}} {{currency}} lub więcej",
      quantity: "Dla zamówień zawierających od {{min}} do {{max}} przedmiotów",
      quantity_min: "Dla zamówień zawierających {{min}} lub więcej przedmiotów",
      weight: "Dla zamówień o łącznej wadze od {{min}}g do {{max}}g",
      weight_min: "Dla zamówień o łącznej wadze {{min}}g lub więcej"
    }
  },
  shipping_fee: "Opłata za wysyłkę",
  total_amount_with_tax_and_shipping: "Razem (w tym podatek i wysyłka)",
  vat_percent: "Podatek od sprzedaży ({{percent}}%)",
  including_tax: "Zawiera {{percent}}% VAT ({{amount}})"
}, tN = {
  public_pages_purchase: eN
}, rN = {
  "required-field": "O campo é obrigatório",
  payment: {
    price_plan: "Plano",
    stripe_card: "Cartão de crédito (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Cartão de crédito (Dlocal)",
    dlocal_boleto: "Boleto bancário (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Cartão de crédito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Pagamento na entrega",
    xendit_card: "Cartão de crédito (Xendit)",
    paystack_card: "Cartão de crédito (Paystack)",
    paypal_connect: "Conectar PayPal",
    paypal_edit_organization_name: "Editar o nome da empresa",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Erro",
  "Payment-method": "Método de pagamento",
  price_plan: {
    trial_period: {
      week: "{{count}} semana",
      week_plural: "{{count}} semanas",
      day: "{{count}} dia",
      day_plural: "{{count}} dias",
      month: "{{count}} mês",
      month_plural: "{{count}} meses",
      year: "{{count}} ano",
      year_plural: "{{count}} anos"
    },
    interval: {
      month: "mês",
      month_plural: "{{count}} meses",
      day: "dia",
      day_plural: "{{count}} dias",
      week: "semana",
      week_plural: "{{count}} semanas",
      year: "ano",
      year_plural: "{{count}} anos"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuito",
        trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} depois",
        unlimited_new: "<bold>{{amount}}</bold> a cada {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} vezes"
      }
    }
  },
  affiliate_badge: {
    made_with: "Desenvolvido por"
  },
  form_select: {
    empty_list: "Parece que essa lista está vazia",
    select: "Selecionar"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nome",
    last_name: "Sobrenome",
    phone_number: "Número de telefone",
    country: "País",
    street_address: "Endereço",
    city: "Cidade",
    postal_code: "Código postal",
    company_name: "Nome da empresa",
    tax_number: "CNPJ/NIF",
    state_province: "Estado/Província",
    street_number: "Número",
    neighborhood: "Bairro"
  },
  date_picker: {
    apply: "Aplicar",
    clear: "Limpar",
    time: "Horário",
    all_time: "Desde o início",
    last_3_months: "Últimos 3 meses",
    last_pool_period: "Último período de avaliação do grupo",
    last_month: "Último mês",
    this_month: "Este mês",
    last_30_days: "Últimos 30 dias",
    title_dates: "Datas",
    from: "De",
    to: "Até"
  },
  copy_clipboard: "Copiado para a área de transferência",
  payment_inputs: {
    empty_card_number: "Insira um número de cartão",
    invalid_card_number: "O número do cartão é inválido",
    empty_expiry_date: "Insira uma data de validade",
    month_out_of_range: "O mês de validade deve estar entre 01 e 12",
    year_out_of_range: "O ano de validade não pode estar no passado",
    date_out_of_range: "A data de validade não pode estar no passado",
    invalid_expiry_date: "A data de validade é inválida",
    invalid_cvc: "O CVV é inválido",
    empty_cvc: "Insira o CVV",
    card_number_placeholder: "Número do cartão",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVV",
    card_holder_placeholder: "Titular do cartão",
    empty_card_holder: "Insira o nome do titular do cartão"
  },
  copy_clipboard_error: "Falha ao copiar o texto",
  input: {
    phone_number: "Número de telefone",
    phone_search: "Pesquisar",
    search: "Pesquisar"
  },
  "registered-over": "registrado há mais de",
  locale: {
    french: "Francês",
    german: "Alemão",
    italian: "Italiano",
    dutch: "Holandês",
    english: "Inglês",
    portuguese: "Português",
    russian: "Russo",
    spanish: "Espanhol",
    japanese: "Japonês",
    arabic: "Árabe",
    turkish: "Turco",
    chinese: "Chinês",
    swedish: "Sueco",
    romanian: "Romeno",
    czech: "Tcheco",
    hungarian: "Húngaro",
    slovak: "Eslovaco",
    danish: "Dinamarquês",
    indonesian: "Indonésio",
    polish: "Polonês",
    greek: "Grego",
    serbian: "Sérvio",
    hindi: "Hindi",
    norwegian: "Norueguês",
    thai: "Tailandês",
    slovenian: "Esloveno",
    ukrainian: "Ucraniano",
    albania: "Albanês"
  },
  product: "Produto",
  quantity: "Quantidade",
  order_summary: "Resumo do pedido",
  vat: "Imposto",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Método de envio",
    not_available: "Ops! Parece que ainda não oferecemos envio para este local",
    condition_label: {
      price: "Para pedidos com valor entre {{min}} {{currency}} e {{max}} {{currency}}",
      price_min: "Para pedidos com valor de {{min}} {{currency}} ou mais",
      quantity: "Para pedidos contendo entre {{min}} e {{max}} itens",
      quantity_min: "Para pedidos contendo {{min}} ou mais itens",
      weight: "Para pedidos com peso total entre {{min}}g e {{max}}g",
      weight_min: "Para pedidos com peso total de {{min}}g ou mais"
    }
  },
  shipping_fee: "Taxa de envio",
  total_amount_with_tax_and_shipping: "Total (incluindo imposto e envio)",
  vat_percent: "Imposto ({{percent}}%)",
  including_tax: "Inclui {{percent}}% de imposto (IVA) ({{amount}})"
}, nN = {
  public_pages_purchase: rN
}, aN = {
  "required-field": "Câmpul este obligatoriu",
  payment: {
    price_plan: "Plan",
    stripe_card: "Carduri de credit (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (stripe)",
    dlocal_card: "Carduri de credit (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Carduri de credit (Mercado Pago)",
    mercadopago_pix: "PIX (piață de plată)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Plata la livrare",
    xendit_card: "Carduri de credit (Xendit)",
    paystack_card: "Carduri de credit (Paystack)",
    paypal_connect: "Conectați PayPal",
    paypal_edit_organization_name: "Editați numele organizației",
    paypal_rest: "PayPal",
    secure_and_pay: "Securizat și plătiți",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Eroare",
  "Payment-method": "Modalitate de plată",
  price_plan: {
    trial_period: {
      week_0: "{{count}} săptămână",
      week_1: "{{count}} săptămâni",
      week_2: "{{count}} săptămâni",
      day_0: "{{count}} zi",
      day_1: "{{count}} zile",
      day_2: "{{count}} zile",
      month_0: "{{count}} lună",
      month_1: "{{count}} luni",
      month_2: "{{count}} luni",
      year_0: "{{count}} an",
      year_1: "{{count}} ani",
      year_2: "{{count}} ani"
    },
    interval: {
      month_0: "lună",
      month_1: "{{count}} luni",
      month_2: "{{count}} luni",
      day_0: "zi",
      day_1: "{{count}} zile",
      day_2: "{{count}} zile",
      week_0: "săptămână",
      week_1: "{{count}} săptămâni",
      week_2: "{{count}} săptămâni",
      year_0: "an",
      year_1: "{{count}} ani",
      year_2: "{{count}} ani"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuit",
        trial_period_new: "{{ trialPeriodPrice }} pentru {{ trialInterval }} atunci",
        unlimited_new: "<bold>{{amount}}</bold> la fiecare {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - de {{ count }} ori"
      }
    }
  },
  affiliate_badge: {
    made_with: "Realizat de"
  },
  form_select: {
    empty_list: "Se pare că această listă este goală",
    select: "Selectați"
  },
  contact_slug: {
    email: "Email",
    first_name: "Prenume",
    last_name: "Nume de familie",
    phone_number: "Număr de telefon",
    country: "Țară",
    street_address: "Adresă",
    city: "Oraș",
    postal_code: "Cod poștal",
    company_name: "Numele companiei",
    tax_number: "Număr de identificare fiscală",
    state_province: "Stat/Provincie",
    street_number: "Numărul străzii",
    neighborhood: "Cartier"
  },
  date_picker: {
    apply: "Aplică",
    clear: "Șterge",
    time: "Timp",
    all_time: "Tot timpul",
    last_3_months: "Ultimele 3 luni",
    last_pool_period: "Ultima perioadă de evaluare a grupului",
    last_month: "Luna trecută",
    this_month: "Luna aceasta",
    last_30_days: "Ultimele 30 de zile",
    title_dates: "Date",
    from: "De la",
    to: "Către"
  },
  copy_clipboard: "Copiat în clipboard",
  payment_inputs: {
    empty_card_number: "Introduceți un număr de card",
    invalid_card_number: "Numărul cardului este invalid",
    empty_expiry_date: "Introduceți o dată de expirare",
    month_out_of_range: "Luna de expirare trebuie să fie între 01 și 12",
    year_out_of_range: "Anul de expirare nu poate fi în trecut",
    date_out_of_range: "Data de expirare nu poate fi în trecut",
    invalid_expiry_date: "Data de expirare este invalidă",
    invalid_cvc: "CVC este invalid",
    empty_cvc: "Introduceți un CVC",
    card_number_placeholder: "Numărul cardului",
    expiry_data_placeholder: "LL/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titularul cardului",
    empty_card_holder: "Introduceți un nume al titularului cardului"
  },
  copy_clipboard_error: "Copierea textului a eșuat",
  input: {
    phone_number: "Număr de telefon",
    phone_search: "Căutare",
    search: "Caută"
  },
  "registered-over": "înregistrat peste",
  locale: {
    french: "Limba franceza",
    german: "Limba germana",
    italian: "Italiană",
    dutch: "Olandeză",
    english: "Engleză",
    portuguese: "Portugheză",
    russian: "Rusă",
    spanish: "Spaniolă",
    japanese: "Japonez",
    arabic: "Arabic",
    turkish: "Turc",
    chinese: "Chinez",
    swedish: "Suedez",
    romanian: "Română",
    czech: "Ceh",
    hungarian: "Maghiară",
    slovak: "Slovacă",
    danish: "Danez",
    indonesian: "Indoneziană",
    polish: "Lustrui",
    greek: "Greacă",
    serbian: "Sârb",
    hindi: "Nu",
    norwegian: "Norvegian",
    thai: "Thailandez",
    slovenian: "Slovenă",
    ukrainian: "Ucrainean",
    albania: "Albanez"
  },
  product: "Produs",
  quantity: "Cantitate",
  order_summary: "Rezumatul comenzii",
  vat: "Taxa pe vânzări",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Metoda de livrare",
    not_available: "Ups! Se pare că nu oferim livrare în această locație încă.",
    condition_label: {
      price: "Pentru comenzi cu prețuri între {{min}} {{currency}} și {{max}} {{currency}}",
      price_min: "Pentru comenzi cu prețuri de {{min}} {{currency}} sau mai mult",
      quantity: "Pentru comenzi care conțin între {{min}} și {{max}} articole",
      quantity_min: "Pentru comenzi care conțin {{min}} sau mai multe articole",
      weight: "Pentru comenzi cu o greutate totală între {{min}}g și {{max}}g",
      weight_min: "Pentru comenzi cu o greutate totală de {{min}}g sau mai mult"
    }
  },
  shipping_fee: "Taxa de livrare",
  total_amount_with_tax_and_shipping: "Total (inclusiv taxe și livrare)",
  vat_percent: "Taxa pe vânzări ({{percent}}%)",
  including_tax: "Incluzând TVA de {{percent}}% ({{amount}})"
}, oN = {
  public_pages_purchase: aN
}, iN = {
  "required-field": "Поле обязательно для заполнения",
  payment: {
    price_plan: "План",
    stripe_card: "Разрешить оплату кредитной картой",
    stripe_ideal: "Разрешить платежи через iDeal",
    stripe_bancotact: "Разрешить платежи через BanContact",
    dlocal_card: "Кредитные карты (Dlocal)",
    dlocal_boleto: "Заготовка (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "Разрешить платежи PayPal",
    mercadopago_card: "Кредитные карты",
    mercadopago_pix: "PIX (Платный рынок)",
    mercadopago_boleto: "Билет (Платный рынок)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Оплата наличными при доставке",
    xendit_card: "Кредитные карты (Xendit)",
    paystack_card: "Кредитные карты (Paystack)",
    paypal_connect: "Подключить PayPal",
    paypal_edit_organization_name: "Изменить название организации",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Ошибка",
  "Payment-method": "Способ оплаты",
  price_plan: {
    trial_period: {
      week_0: "{{count}} неделя",
      week_1: "{{count}} недели",
      week_2: "{{count}} недель",
      day_0: "день",
      day_1: "{{count}} дней",
      day_2: "{{count}} дни",
      month_0: "месяц",
      month_1: "{{count}} месяца",
      month_2: "{{count}} месяцев",
      year_0: "год",
      year_1: "{{count}} года",
      year_2: "{{count}} лет"
    },
    interval: {
      month_0: "месяц",
      month_1: "{{count}} месяцы",
      month_2: "{{count}} месяца",
      day_0: "день",
      day_1: "{{count}} дней",
      day_2: "{{count}} дни",
      week_0: "неделя",
      week_1: "{{count}} недели",
      week_2: "{{count}} неделями",
      year_0: "год",
      year_1: "{{count}} годы",
      year_2: "{{count}} лет"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Бесплатно",
        trial_period_new: "{{ trialPeriodPrice }} для {{ trialInterval }} затем",
        unlimited_new: "<bold>{{amount}}</bold> каждый {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} раз"
      }
    }
  },
  affiliate_badge: {
    made_with: "Создано с "
  },
  form_select: {
    empty_list: "Похоже, что этот список пуст.",
    select: "Выбрать"
  },
  contact_slug: {
    email: "Почта",
    first_name: "Имя",
    last_name: "Фамилия",
    phone_number: "Номер телефона",
    country: "Страна",
    street_address: "Адрес",
    city: "Город",
    postal_code: "Почтовый индекс",
    company_name: "Название компании",
    tax_number: "Налоговый номер",
    state_province: "Штат/Область",
    street_number: "Номер улицы",
    neighborhood: "Соседство"
  },
  date_picker: {
    apply: "Применить",
    clear: "Очистить",
    time: "Время",
    all_time: "Все время",
    last_3_months: "Последние 3 месяца",
    last_pool_period: "Последний период оценки пула",
    last_month: "Последний месяц",
    this_month: "В этом месяце",
    last_30_days: "Последние 30 дней",
    title_dates: "Даты",
    from: "От",
    to: "В"
  },
  copy_clipboard: "Номер карты недействителен",
  payment_inputs: {
    empty_card_number: "Введите номер карты",
    invalid_card_number: "Номер карты недействителен",
    empty_expiry_date: "Введите дату окончания срока действия",
    month_out_of_range: "Месяц окончания срока действия должен быть между 01 и 12",
    year_out_of_range: "Год окончания срока действия не может быть в прошлом",
    date_out_of_range: "Дата окончания срока действия не может быть в прошлом",
    invalid_expiry_date: "Срок годности недействителен",
    invalid_cvc: "CVC код неправильный",
    empty_cvc: "Введите CVC код",
    card_number_placeholder: "Номер карты",
    expiry_data_placeholder: "М/Г",
    cvc_placeholder: "CVC код",
    card_holder_placeholder: "Держатель карты",
    empty_card_holder: "Введите имя держателя карты"
  },
  copy_clipboard_error: "Не удалось скопировать текст",
  input: {
    phone_number: "Номер телефона",
    phone_search: "Поиск",
    search: "Поиск"
  },
  "registered-over": "зарегистрировано более чем",
  locale: {
    french: "Французский",
    german: "Немецкий",
    italian: "Итальянский",
    dutch: "Голландский",
    english: "Английский",
    portuguese: "Португальский",
    russian: "Русский",
    spanish: "Испанский",
    japanese: "Японский",
    arabic: "Арабский",
    turkish: "Турецкий",
    chinese: "Китайский",
    swedish: "Шведский",
    romanian: "Румынский",
    czech: "Чешский",
    hungarian: "Венгерский",
    slovak: "Словацкий",
    danish: "Датский",
    indonesian: "Индонезийский",
    polish: "Польский",
    greek: "Греческий",
    serbian: "Сербский",
    hindi: "Хинди",
    norwegian: "Норвежский",
    thai: "Тайский",
    slovenian: "Словенский",
    ukrainian: "Украинский",
    albania: "Албанский"
  },
  product: "Продукт",
  quantity: "Количество",
  order_summary: "Итог заказа",
  vat: "Налог с продаж",
  total: "Итого",
  subtotal: "Промежуточный итог",
  shipping: {
    shipping_method: "Способ доставки",
    not_available: "Упс! Похоже, что мы еще не предлагаем доставку в это место.",
    condition_label: {
      price: "Для заказов стоимостью от {{min}} {{currency}} до {{max}} {{currency}}",
      price_min: "Для заказов стоимостью {{min}} {{currency}} или более",
      quantity: "Для заказов, содержащих от {{min}} до {{max}} товаров",
      quantity_min: "Для заказов, содержащих {{min}} или более товаров",
      weight: "Для заказов с общим весом от {{min}}g до {{max}}g",
      weight_min: "Для заказов с общим весом {{min}}g или более"
    }
  },
  shipping_fee: "Стоимость доставки",
  total_amount_with_tax_and_shipping: "Итого (включая налог и доставку)",
  vat_percent: "Налог с продаж ({{percent}}%)",
  including_tax: "Включает {{percent}}% НДС ({{amount}})"
}, sN = {
  public_pages_purchase: iN
}, lN = {
  "required-field": "Pole je povinné",
  payment: {
    price_plan: "Plán",
    stripe_card: "Kreditné karty (Stripe)",
    stripe_ideal: "iDeal (pruh)",
    stripe_bancotact: "Bancontact (pruh)",
    dlocal_card: "Kreditné karty (miestne)",
    dlocal_boleto: "Boleto (miestne)",
    dlocal_pix: "Pix (miestne)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditné karty (Mercado Pago)",
    mercadopago_pix: "PIX (Platobný trh)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Platba na dobierku",
    xendit_card: "Kreditné karty (Xendit)",
    paystack_card: "Kreditné karty (Paystack)",
    paypal_connect: "Pripojte PayPal",
    paypal_edit_organization_name: "Upravte názov organizácie",
    paypal_rest: "PayPal",
    secure_and_pay: "Zabezpečiť a zaplatiť",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Chyba",
  "Payment-method": "Spôsob platby",
  price_plan: {
    trial_period: {
      week_0: "{{count}} týždeň",
      week_1: "{{count}} týždňov",
      week_2: "{{count}} týždňov",
      day_0: "{{count}} deň",
      day_1: "{{count}} dní",
      day_2: "{{count}} dní",
      month_0: "{{count}} mesiac",
      month_1: "{{count}} mesiacov",
      month_2: "{{count}} mesiacov",
      year_0: "{{count}} rok",
      year_1: "{{count}} rokov",
      year_2: "{{count}} rokov"
    },
    interval: {
      month_0: "mesiac",
      month_1: "{{count}} mesiacov",
      month_2: "{{count}} mesiacov",
      day_0: "deň",
      day_1: "{{count}} dní",
      day_2: "{{count}} dní",
      week_0: "týždeň",
      week_1: "{{count}} týždňov",
      week_2: "{{count}} týždňov",
      year_0: "rok",
      year_1: "{{count}} rokov",
      year_2: "{{count}} rokov"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Zadarmo",
        trial_period_new: "Potom {{ trialPeriodPrice }} za {{ trialInterval }}",
        unlimited_new: "<bold>{{amount}}</bold> každých {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krát"
      }
    }
  },
  affiliate_badge: {
    made_with: "Poháňané"
  },
  form_select: {
    empty_list: "Zdá sa, že tento zoznam je prázdny",
    select: "Vybrať"
  },
  contact_slug: {
    email: "Email",
    first_name: "Meno",
    last_name: "Priezvisko",
    phone_number: "Telefónne číslo",
    country: "Krajina",
    street_address: "Ulica",
    city: "Mesto",
    postal_code: "PSČ",
    company_name: "Názov spoločnosti",
    tax_number: "Daňové číslo",
    state_province: "Štát/Provincie",
    street_number: "Číslo ulice",
    neighborhood: "Štvrť"
  },
  date_picker: {
    apply: "Použiť",
    clear: "Vymazať",
    time: "Čas",
    all_time: "Celý čas",
    last_3_months: "Posledné 3 mesiace",
    last_pool_period: "Posledné hodnotenie bazéna",
    last_month: "Minulý mesiac",
    this_month: "Tento mesiac",
    last_30_days: "Posledných 30 dní",
    title_dates: "Dátumy",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Skopírované do schránky",
  payment_inputs: {
    empty_card_number: "Zadajte číslo karty",
    invalid_card_number: "Číslo karty je neplatné",
    empty_expiry_date: "Zadajte dátum expirácie",
    month_out_of_range: "Mesiac expirácie musí byť medzi 01 a 12",
    year_out_of_range: "Rok expirácie nemôže byť v minulosti",
    date_out_of_range: "Dátum expirácie nemôže byť v minulosti",
    invalid_expiry_date: "Dátum expirácie je neplatný",
    invalid_cvc: "CVC je neplatný",
    empty_cvc: "Zadajte CVC",
    card_number_placeholder: "Číslo karty",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Držiteľ karty",
    empty_card_holder: "Zadajte meno držiteľa karty"
  },
  copy_clipboard_error: "Nepodarilo sa skopírovať text",
  input: {
    phone_number: "Telefónne číslo",
    phone_search: "Hľadať",
    search: "Hľadať"
  },
  "registered-over": "registrované viac ako",
  locale: {
    french: "Francúzsky",
    german: "Nemecký",
    italian: "Taliansky",
    dutch: "Holandský",
    english: "Angličtina",
    portuguese: "Portugalčina",
    russian: "Ruský",
    spanish: "španielčina",
    japanese: "Japončina",
    arabic: "Arabčina",
    turkish: "Turecký",
    chinese: "čínsky",
    swedish: "švédsky",
    romanian: "Rumunský",
    czech: "český",
    hungarian: "Maďarský",
    slovak: "Slovenský",
    danish: "Dánčina",
    indonesian: "Indonézsky",
    polish: "Poľský",
    greek: "Grécky",
    serbian: "Srbský",
    hindi: "Nie",
    norwegian: "Nórsky",
    thai: "Thajčina",
    slovenian: "Slovensky",
    ukrainian: "Ukrajinčina",
    albania: "Albánsky"
  },
  product: "Produkt",
  quantity: "Množstvo",
  order_summary: "Zhrnutie objednávky",
  vat: "Daň z predaja",
  total: "Celkom",
  subtotal: "Medzisúčet",
  shipping: {
    shipping_method: "Spôsob dopravy",
    not_available: "Ups! Vyzerá to, že na túto lokalitu zatiaľ nenabízame dopravu.",
    condition_label: {
      price: "Pre objednávky v cene medzi {{min}} {{currency}} a {{max}} {{currency}}",
      price_min: "Pre objednávky v cene {{min}} {{currency}} alebo viac",
      quantity: "Pre objednávky obsahujúce medzi {{min}} a {{max}} položkami",
      quantity_min: "Pre objednávky obsahujúce {{min}} alebo viac položiek",
      weight: "Pre objednávky s celkovou hmotnosťou medzi {{min}}g a {{max}}g",
      weight_min: "Pre objednávky s celkovou hmotnosťou {{min}}g alebo viac"
    }
  },
  shipping_fee: "Poplatok za dopravu",
  total_amount_with_tax_and_shipping: "Celkom (vrátane dane a dopravy)",
  vat_percent: "Daň z predaja ({{percent}}%)",
  including_tax: "Vrátane DPH {{percent}}% ({{amount}})"
}, cN = {
  public_pages_purchase: lN
}, uN = {
  "required-field": "Polje je obvezno",
  payment: {
    price_plan: "Načrtujte",
    stripe_card: "Kreditne kartice (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditne kartice (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditne kartice (Mercado Pago)",
    mercadopago_pix: "PIX (plačilni trg)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Gotovino po povzetju",
    xendit_card: "Kreditne kartice (Xendit)",
    paystack_card: "Kreditne kartice (Paystack)",
    paypal_connect: "Povežite PayPal",
    paypal_edit_organization_name: "Uredi ime organizacije",
    paypal_rest: "PayPal",
    secure_and_pay: "Zavarujte in plačajte",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Napaka",
  "Payment-method": "Način plačila",
  price_plan: {
    trial_period: {
      week_0: "{{count}} teden",
      week_1: "{{count}} tednov",
      week_2: "{{count}} tednov",
      week_3: "{{count}} tednov",
      day_0: "{{count}} dan",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      day_3: "{{count}} dni",
      month_0: "{{count}} mesec",
      month_1: "{{count}} mesecev",
      month_2: "{{count}} mesecev",
      month_3: "{{count}} mesecev",
      year_0: "{{count}} leto",
      year_1: "{{count}} let",
      year_2: "{{count}} let",
      year_3: "{{count}} let"
    },
    interval: {
      month_0: "mesec",
      month_1: "{{count}} mesecev",
      month_2: "{{count}} mesecev",
      month_3: "{{count}} mesecev",
      day_0: "dan",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      day_3: "{{count}} dni",
      week_0: "teden",
      week_1: "{{count}} tednov",
      week_2: "{{count}} tednov",
      week_3: "{{count}} tednov",
      year_0: "leto",
      year_1: "{{count}} let",
      year_2: "{{count}} let",
      year_3: "{{count}} let"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Brezplačno",
        trial_period_new: "{{ trialPeriodPrice }} za {{ trialInterval }} potem",
        unlimited_new: "<bold>{{amount}}</bold> vsak {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krat"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Zdi se, da je ta seznam prazen",
    select: "Izberi"
  },
  contact_slug: {
    email: "E-pošta",
    first_name: "Ime",
    last_name: "Priimek",
    phone_number: "Telefonska številka",
    country: "Država",
    street_address: "Ulična naslov",
    city: "Mesto",
    postal_code: "Poštna številka",
    company_name: "Ime podjetja",
    tax_number: "Davčna številka",
    state_province: "Država/Provinca",
    street_number: "Številka ulice",
    neighborhood: "Soseska"
  },
  date_picker: {
    apply: "Uporabi",
    clear: "Počisti",
    time: "Čas",
    all_time: "Vse čase",
    last_3_months: "Zadnja 3 meseca",
    last_pool_period: "Zadnje obdobje ocenjevanja bazena",
    last_month: "Zadnji mesec",
    this_month: "Ta mesec",
    last_30_days: "Zadnjih 30 dni",
    title_dates: "Datumi",
    from: "Iz",
    to: "Do"
  },
  copy_clipboard: "Kopirano v odložišče",
  payment_inputs: {
    empty_card_number: "Vnesite številko kartice",
    invalid_card_number: "Številka kartice je neveljavna",
    empty_expiry_date: "Vnesite datum poteka",
    month_out_of_range: "Mesec poteka mora biti med 01 in 12",
    year_out_of_range: "Leto poteka ne more biti v preteklosti",
    date_out_of_range: "Datum poteka ne more biti v preteklosti",
    invalid_expiry_date: "Datum poteka je neveljaven",
    invalid_cvc: "CVC je neveljaven",
    empty_cvc: "Vnesite CVC",
    card_number_placeholder: "Številka kartice",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Imetnik kartice",
    empty_card_holder: "Vnesite ime imetnika kartice"
  },
  copy_clipboard_error: "Kopiranje besedila ni uspelo",
  input: {
    phone_number: "Telefonska številka",
    phone_search: "Iskanje",
    search: "Iskanje"
  },
  "registered-over": "registrirani več kot",
  locale: {
    french: "Francosko",
    german: "Nemški",
    italian: "Italijanski",
    dutch: "Nizozemščina",
    english: "Angleščina",
    portuguese: "Portugalščina",
    russian: "Ruski",
    spanish: "španski",
    japanese: "Japonska",
    arabic: "Arabsko",
    turkish: "Turško",
    chinese: "Kitajski",
    swedish: "švedščina",
    romanian: "Romunščina",
    czech: "češki",
    hungarian: "Madžarski",
    slovak: "Slovaški",
    danish: "Danščina",
    indonesian: "Indonezijski",
    polish: "Poljski",
    greek: "Grški",
    serbian: "Srbsko",
    hindi: "Ne",
    norwegian: "Norveški",
    thai: "Tajska",
    slovenian: "Slovenščina",
    ukrainian: "Ukrajinski",
    albania: "Albanski"
  },
  product: "Izdelek",
  quantity: "Količina",
  order_summary: "Povzetek naročila",
  vat: "Davek na prodajo",
  total: "Skupaj",
  subtotal: "Medseštevek",
  shipping: {
    shipping_method: "Način dostave",
    not_available: "Oups! Zdi se, da še ne ponujamo dostave na to lokacijo.",
    condition_label: {
      price: "Za naročila v vrednosti med {{min}} {{currency}} in {{max}} {{currency}}",
      price_min: "Za naročila v vrednosti {{min}} {{currency}} ali več",
      quantity: "Za naročila, ki vsebujejo med {{min}} in {{max}} artikli",
      quantity_min: "Za naročila, ki vsebujejo {{min}} ali več artiklov",
      weight: "Za naročila s skupno težo med {{min}}g in {{max}}g",
      weight_min: "Za naročila s skupno težo {{min}}g ali več"
    }
  },
  shipping_fee: "Strošek dostave",
  total_amount_with_tax_and_shipping: "Skupaj (vključno z davkom in dostavo)",
  vat_percent: "Davek na prodajo ({{percent}}%)",
  including_tax: "Vključeno {{percent}}% DDV ({{amount}})"
}, dN = {
  public_pages_purchase: uN
}, pN = {
  "required-field": "Fusha kërkohet",
  payment: {
    price_plan: "Planifikoni",
    stripe_card: "Kartat e kreditit (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (shirit)",
    dlocal_card: "Kartat e kreditit (Dlokale)",
    dlocal_boleto: "Boleto (lokale)",
    dlocal_pix: "Pix (vendor)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kartat e kreditit (Mercado Pago)",
    mercadopago_pix: "PIX (Tregu i Pagesave)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Pa kartë",
    cash_on_delivery: "Para ne dore gjate dorezimit",
    xendit_card: "Kartat e kreditit (Xendit)",
    paystack_card: "Kartat e kreditit (Paystack)",
    paypal_connect: "Lidhni PayPal",
    paypal_edit_organization_name: "Redakto emrin e organizatës",
    paypal_rest: "PayPal",
    secure_and_pay: "Siguro dhe Paguaj",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Gabim",
  "Payment-method": "Mënyra e pagesës",
  price_plan: {
    trial_period: {
      week: "{{count}} javë",
      week_plural: "{{count}} javë",
      day: "{{count}} ditë",
      day_plural: "{{count}} ditë",
      month: "{{count}} muaj",
      month_plural: "{{count}} muaj",
      year: "{{count}} vit",
      year_plural: "{{count}} vjet"
    },
    interval: {
      month: "muaj",
      month_plural: "{{count}} muaj",
      day: "ditë",
      day_plural: "{{count}} ditë",
      week: "javë",
      week_plural: "{{count}} javë",
      year: "vit",
      year_plural: "{{count}} vjet"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Falas",
        trial_period_new: "{{ trialPeriodPrice }} për {{ trialInterval }} pastaj",
        unlimited_new: "<bold>{{amount}}</bold> çdo {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} herë"
      }
    }
  },
  affiliate_badge: {
    made_with: "E fuqizuar nga"
  },
  form_select: {
    empty_list: "Duket se kjo listë është bosh",
    select: "Zgjidhni"
  },
  contact_slug: {
    email: "Email",
    first_name: "Emri i parë",
    last_name: "Mbiemri",
    phone_number: "Numri i telefonit",
    country: "Shteti",
    street_address: "Adresa e rrugës",
    city: "Qyteti",
    postal_code: "Kodi postar",
    company_name: "Emri i kompanisë",
    tax_number: "Numri i tatimit",
    state_province: "Shteti/Provinca",
    street_number: "Numri i rrugës",
    neighborhood: "Lagja"
  },
  date_picker: {
    apply: "Apliko",
    clear: "Pastro",
    time: "Koha",
    all_time: "Të gjitha kohët",
    last_3_months: "3 muajt e fundit",
    last_pool_period: "Periudha e fundit e vlerësimit të grupit",
    last_month: "Muaji i kaluar",
    this_month: "Ky muaj",
    last_30_days: "30 ditët e fundit",
    title_dates: "Datat",
    from: "Nga",
    to: "Në"
  },
  copy_clipboard: "Kopjuhet në clipboard",
  payment_inputs: {
    empty_card_number: "Shkruani një numër kartelash",
    invalid_card_number: "Numri i kartelës është i pavlefshëm",
    empty_expiry_date: "Shkruani një datë skadimi",
    month_out_of_range: "Muaji i skadimit duhet të jetë midis 01 dhe 12",
    year_out_of_range: "Viti i skadencës nuk mund të jetë në të kaluarën",
    date_out_of_range: "Data e skadencës nuk mund të jetë në të kaluarën",
    invalid_expiry_date: "Data e skadencës është e pavlefshme",
    invalid_cvc: "CVC është i pavlefshëm",
    empty_cvc: "Shkruani një CVC",
    card_number_placeholder: "Numri i kartës",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Emri i mbajtësit të kartës",
    empty_card_holder: "Shkruani emrin e mbajtësit të kartës"
  },
  copy_clipboard_error: "Dështoi të kopjohet teksti",
  input: {
    phone_number: "Numri i telefonit",
    phone_search: "Kërko",
    search: "Kërko"
  },
  "registered-over": "regjistruar mbi",
  locale: {
    french: "Frëngjisht",
    german: "Gjermane",
    italian: "Italisht",
    dutch: "Holandeze",
    english: "Anglisht",
    portuguese: "Portugeze",
    russian: "Rusisht",
    spanish: "Spanjisht",
    japanese: "Japoneze",
    arabic: "Arabisht",
    turkish: "Turk",
    chinese: "Kineze",
    swedish: "Suedeze",
    romanian: "Rumun",
    czech: "çeke",
    hungarian: "Hungareze",
    slovak: "Sllovake",
    danish: "Daneze",
    indonesian: "Indonezisht",
    polish: "Polonisht",
    greek: "Greke",
    serbian: "Serb",
    hindi: "Jo",
    norwegian: "Norvegjeze",
    thai: "Thai",
    slovenian: "Slloven",
    ukrainian: "Ukrainase",
    albania: "Shqiptare"
  },
  product: "Produkt",
  quantity: "Sasia",
  order_summary: "Përmbledhja e Porosisë",
  vat: "Tatimi mbi shitjet",
  total: "Totali",
  subtotal: "Nëntotali",
  shipping: {
    shipping_method: "Metoda e Dërgesës",
    not_available: "Ups! Duket se nuk ofrojmë dërgesa në këtë vend akoma.",
    condition_label: {
      price: "Për porositë me çmim midis {{min}} {{currency}} dhe {{max}} {{currency}}",
      price_min: "Për porositë me çmim {{min}} {{currency}} ose më shumë",
      quantity: "Për porositë që përmbajnë midis {{min}} dhe {{max}} artikuj",
      quantity_min: "Për porositë që përmbajnë {{min}} ose më shumë artikuj",
      weight: "Për porositë me një peshë totale midis {{min}}g dhe {{max}}g",
      weight_min: "Për porositë me një peshë totale prej {{min}}g ose më shumë"
    }
  },
  shipping_fee: "Tarifa e dërgesës",
  total_amount_with_tax_and_shipping: "Totali (duke përfshirë taksën dhe dërgesën)",
  vat_percent: "Tatimi mbi shitjet ({{percent}}%)",
  including_tax: "Duke përfshirë TVSH-në {{percent}}% ({{amount}})"
}, hN = {
  public_pages_purchase: pN
}, mN = {
  "required-field": "Поље је обавезно",
  payment: {
    price_plan: "План",
    stripe_card: "Кредитне картице (Стрипе)",
    stripe_ideal: "иДеал (Стрипе)",
    stripe_bancotact: "Банцонтацт (Стрипе)",
    dlocal_card: "Кредитне картице (Длоцал)",
    dlocal_boleto: "Болето (Длоцал)",
    dlocal_pix: "Пик (Длоцал)",
    paypal_soap: "ПаиПал",
    mercadopago_card: "Кредитне картице (Мерцадо Паго)",
    mercadopago_pix: "ПИКС (тржиште плаћања)",
    mercadopago_boleto: "Болето (Меркадо Паго)",
    razorpay: "Разорпаи",
    flutterwave: "Флуттерваве",
    mollie: "Моллие",
    gocardless: "Гоцардлесс",
    cash_on_delivery: "Плаћање поузећем",
    xendit_card: "Кредитне картице (Ксендит)",
    paystack_card: "Кредитне картице (Паистацк)",
    paypal_connect: "Повежите ПаиПал",
    paypal_edit_organization_name: "Измените назив организације",
    paypal_rest: "ПаиПал",
    secure_and_pay: "Осигурајте и платите",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Грешка",
  "Payment-method": "Начин плаћања",
  price_plan: {
    trial_period: {
      week_0: "{{count}} недеља",
      week_1: "{{count}} недеља",
      week_2: "{{count}} недеља",
      day_0: "{{count}} дан",
      day_1: "{{count}} дана",
      day_2: "{{count}} дана",
      month_0: "{{count}} месец",
      month_1: "{{count}} месеци",
      month_2: "{{count}} месеци",
      year_0: "{{count}} година",
      year_1: "{{count}} година",
      year_2: "{{count}} година"
    },
    interval: {
      month_0: "месец",
      month_1: "{{count}} месеци",
      month_2: "{{count}} месеци",
      day_0: "дан",
      day_1: "{{count}} дана",
      day_2: "{{count}} дана",
      week_0: "недељу дана",
      week_1: "{{count}} недеља",
      week_2: "{{count}} недеља",
      year_0: "године",
      year_1: "{{count}} година",
      year_2: "{{count}} година"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Бесплатно",
        trial_period_new: "{{ trialPeriodPrice }} за {{ trialInterval }} онда",
        unlimited_new: "<bold>{{amount}}</bold> сваких {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} пута"
      }
    }
  },
  affiliate_badge: {
    made_with: "Pokreće"
  },
  form_select: {
    empty_list: "Izgleda da je ova lista prazna",
    select: "Izaberi"
  },
  contact_slug: {
    email: "Email",
    first_name: "Ime",
    last_name: "Prezime",
    phone_number: "Broj telefona",
    country: "Zemlja",
    street_address: "Adresa",
    city: "Grad",
    postal_code: "Poštanski broj",
    company_name: "Naziv kompanije",
    tax_number: "Poreski broj",
    state_province: "Država/Provincija",
    street_number: "Broj ulice",
    neighborhood: "Kraj"
  },
  date_picker: {
    apply: "Primeni",
    clear: "Obriši",
    time: "Vreme",
    all_time: "Sve vreme",
    last_3_months: "Poslednja 3 meseca",
    last_pool_period: "Poslednji period evaluacije",
    last_month: "Prošli mesec",
    this_month: "Ovaj mesec",
    last_30_days: "Poslednjih 30 dana",
    title_dates: "Datumi",
    from: "Od",
    to: "Do"
  },
  copy_clipboard: "Kopirano u međuspremnik",
  payment_inputs: {
    empty_card_number: "Unesite broj kartice",
    invalid_card_number: "Broj kartice je nevažeći",
    empty_expiry_date: "Unesite datum isteka",
    month_out_of_range: "Mesec isteka mora biti između 01 i 12",
    year_out_of_range: "Godina isteka ne može biti u prošlosti",
    date_out_of_range: "Datum isteka ne može biti u prošlosti",
    invalid_expiry_date: "Datum isteka je nevažeći",
    invalid_cvc: "CVC je nevažeći",
    empty_cvc: "Unesite CVC",
    card_number_placeholder: "Broj kartice",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Ime vlasnika kartice",
    empty_card_holder: "Unesite ime vlasnika kartice"
  },
  copy_clipboard_error: "Kopiranje teksta nije uspelo",
  input: {
    phone_number: "Broj telefona",
    phone_search: "Pretraži",
    search: "Pretraži"
  },
  "registered-over": "registrovano više od",
  locale: {
    french: "Француски",
    german: "Немачки",
    italian: "Италијан",
    dutch: "холандски",
    english: "енглески језик",
    portuguese: "португалски",
    russian: "Руски",
    spanish: "Шпански",
    japanese: "јапански",
    arabic: "арапски",
    turkish: "турски",
    chinese: "кинески",
    swedish: "Шведски",
    romanian: "румунски",
    czech: "чешки",
    hungarian: "мађарски",
    slovak: "словачки",
    danish: "дански",
    indonesian: "индонезијски",
    polish: "Пољски",
    greek: "грчки",
    serbian: "Српски",
    hindi: "Јок",
    norwegian: "норвешки",
    thai: "тајландски",
    slovenian: "словеначки",
    ukrainian: "украјински",
    albania: "Албанац"
  },
  product: "Proizvod",
  quantity: "Količina",
  order_summary: "Pregled narudžbine",
  vat: "Porez na promet",
  total: "Ukupno",
  subtotal: "Međuzbir",
  shipping: {
    shipping_method: "Metod isporuke",
    not_available: "Ups! Izgleda da još ne nudimo isporuku na ovu lokaciju.",
    condition_label: {
      price: "Za narudžbine u cenovnom rasponu od {{min}} {{currency}} do {{max}} {{currency}}",
      price_min: "Za narudžbine od {{min}} {{currency}} ili više",
      quantity: "Za narudžbine koje sadrže između {{min}} i {{max}} stavki",
      quantity_min: "Za narudžbine koje sadrže {{min}} ili više stavki",
      weight: "Za narudžbine sa ukupnom težinom između {{min}}g i {{max}}g",
      weight_min: "Za narudžbine sa ukupnom težinom od {{min}}g ili više"
    }
  },
  shipping_fee: "Trošak isporuke",
  total_amount_with_tax_and_shipping: "Ukupno (uključujući porez i isporuku)",
  vat_percent: "Porez na promet ({{percent}}%)",
  including_tax: "Uključujući {{percent}}% PDV ({{amount}})"
}, fN = {
  public_pages_purchase: mN
}, gN = {
  "required-field": "Fält är obligatoriskt",
  payment: {
    price_plan: "Planen",
    stripe_card: "Kreditkort (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkort (Mercado Pago)",
    mercadopago_pix: "PIX (betalningsmarknad)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Fluttervåg",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Postförskott",
    xendit_card: "Kreditkort (Xendit)",
    paystack_card: "Kreditkort (Paystack)",
    paypal_connect: "Anslut PayPal",
    paypal_edit_organization_name: "Redigera organisationens namn",
    paypal_rest: "PayPal",
    secure_and_pay: "Säkra och betala",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fel",
  "Payment-method": "Betalningsmetod",
  price_plan: {
    trial_period: {
      week: "{{count}} vecka",
      week_plural: "{{count}} veckor",
      day: "{{count}} dag",
      day_plural: "{{count}} dagar",
      month: "{{count}} månad",
      month_plural: "{{count}} månader",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "månad",
      month_plural: "{{count}} månader",
      day: "dag",
      day_plural: "{{count}} dagar",
      week: "vecka",
      week_plural: "{{count}} veckor",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} för {{ trialInterval }} sedan",
        unlimited_new: "<bold>{{amount}}</bold> varje {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gånger"
      }
    }
  },
  affiliate_badge: {
    made_with: "Drivs av"
  },
  form_select: {
    empty_list: "Det verkar som att denna lista är tom",
    select: "Välj"
  },
  contact_slug: {
    email: "E-post",
    first_name: "Förnamn",
    last_name: "Efternamn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gatuadress",
    city: "Stad",
    postal_code: "Postnummer",
    company_name: "Företagsnamn",
    tax_number: "Skattenummer",
    state_province: "Stat/Provins",
    street_number: "Gatu nummer",
    neighborhood: "Grannskap"
  },
  date_picker: {
    apply: "Tillämpa",
    clear: "Rensa",
    time: "Tid",
    all_time: "All tid",
    last_3_months: "Senaste 3 månaderna",
    last_pool_period: "Senaste poolutvärderingsperioden",
    last_month: "Senaste månaden",
    this_month: "Denna månad",
    last_30_days: "Senaste 30 dagarna",
    title_dates: "Datum",
    from: "Från",
    to: "Till"
  },
  copy_clipboard: "Kopierad till urklipp",
  payment_inputs: {
    empty_card_number: "Ange ett kortnummer",
    invalid_card_number: "Kortnumret är ogiltigt",
    empty_expiry_date: "Ange ett utgångsdatum",
    month_out_of_range: "Utgångsmånad måste vara mellan 01 och 12",
    year_out_of_range: "Utgångsår kan inte vara i det förflutna",
    date_out_of_range: "Utgångsdatum kan inte vara i det förflutna",
    invalid_expiry_date: "Utgångsdatum är ogiltigt",
    invalid_cvc: "CVC är ogiltigt",
    empty_cvc: "Ange en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortinnehavare",
    empty_card_holder: "Ange ett namn på kortinnehavaren"
  },
  copy_clipboard_error: "Misslyckades med att kopiera text",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Sök",
    search: "Sök"
  },
  "registered-over": "registrerade över",
  locale: {
    french: "Franska",
    german: "Tysk",
    italian: "Italienska",
    dutch: "Holländska",
    english: "Engelsk",
    portuguese: "Portugisiska",
    russian: "Ryska",
    spanish: "Spanska",
    japanese: "Japanska",
    arabic: "Arabiska",
    turkish: "Turkiska",
    chinese: "Kinesiska",
    swedish: "Svenska",
    romanian: "Rumänska",
    czech: "Tjeckiska",
    hungarian: "Ungerska",
    slovak: "Slovakiska",
    danish: "Danska",
    indonesian: "Indonesiska",
    polish: "Putsa",
    greek: "Grekisk",
    serbian: "Serbiska",
    hindi: "Nej",
    norwegian: "Norska",
    thai: "Thai",
    slovenian: "Slovenska",
    ukrainian: "Ukrainska",
    albania: "Albanska"
  },
  product: "Produkt",
  quantity: "Antal",
  order_summary: "Orderöversikt",
  vat: "Moms",
  total: "Totalt",
  subtotal: "Delsumma",
  shipping: {
    shipping_method: "Fraktmetod",
    not_available: "Oj! Det verkar som om vi inte erbjuder frakt till denna plats än.",
    condition_label: {
      price: "För beställningar prissatta mellan {{min}} {{currency}} och {{max}} {{currency}}",
      price_min: "För beställningar prissatta till {{min}} {{currency}} eller mer",
      quantity: "För beställningar som innehåller mellan {{min}} till {{max}} artiklar",
      quantity_min: "För beställningar som innehåller {{min}} eller fler artiklar",
      weight: "För beställningar med en totalvikt mellan {{min}}g och {{max}}g",
      weight_min: "För beställningar med en totalvikt av {{min}}g eller mer"
    }
  },
  shipping_fee: "Fraktavgift",
  total_amount_with_tax_and_shipping: "Totalt (inklusive skatt och frakt)",
  vat_percent: "Moms ({{percent}}%)",
  including_tax: "Inklusive {{percent}}% moms ({{amount}})"
}, yN = {
  public_pages_purchase: gN
}, vN = {
  "required-field": "จำเป็นต้องกรอกข้อมูล",
  payment: {
    price_plan: "วางแผน",
    stripe_card: "บัตรเครดิต (ลายทาง)",
    stripe_ideal: "ไอดีล (ลายทาง)",
    stripe_bancotact: "แบนคอนแทค (ลายทาง)",
    dlocal_card: "บัตรเครดิต (ดีโลคอล)",
    dlocal_boleto: "โบเลโต (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "เพย์พาล",
    mercadopago_card: "บัตรเครดิต (เมอร์คาโดปาโก)",
    mercadopago_pix: "PIX (ตลาดการชำระเงิน)",
    mercadopago_boleto: "โบเลโต (Mercado Pago)",
    razorpay: "เรเซอร์เพย์",
    flutterwave: "กระพือปีก",
    mollie: "มอลลี่",
    gocardless: "ไร้บัตร",
    cash_on_delivery: "เงินสดในการจัดส่ง",
    xendit_card: "บัตรเครดิต (Xendit)",
    paystack_card: "บัตรเครดิต (เพย์สแต็ค)",
    paypal_connect: "เชื่อมต่อเพย์พาล",
    paypal_edit_organization_name: "แก้ไขชื่อองค์กร",
    paypal_rest: "เพย์พาล",
    secure_and_pay: "ปลอดภัยและชำระเงิน",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "ข้อผิดพลาด",
  "Payment-method": "วิธีการชำระเงิน",
  price_plan: {
    trial_period: {
      week: "{{count}} สัปดาห์",
      day: "{{count}} วัน",
      month: "{{count}} เดือน",
      year: "{{count}} ปี"
    },
    interval: {
      month: "เดือน",
      day: "วัน",
      week: "สัปดาห์",
      year: "ปี"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "ฟรี",
        trial_period_new: "{{ trialPeriodPrice }} สำหรับ {{ trialInterval }} จากนั้น",
        unlimited_new: "<bold>{{amount}}</bold> ทุกๆ {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ครั้ง"
      }
    }
  },
  affiliate_badge: {
    made_with: "ขับเคลื่อนโดย"
  },
  form_select: {
    empty_list: "ดูเหมือนว่ารายการนี้จะว่างเปล่า",
    select: "เลือก"
  },
  contact_slug: {
    email: "อีเมล",
    first_name: "ชื่อจริง",
    last_name: "นามสกุล",
    phone_number: "หมายเลขโทรศัพท์",
    country: "ประเทศ",
    street_address: "ที่อยู่ถนน",
    city: "เมือง",
    postal_code: "รหัสไปรษณีย์",
    company_name: "ชื่อบริษัท",
    tax_number: "หมายเลขภาษี",
    state_province: "รัฐ/จังหวัด",
    street_number: "หมายเลขถนน",
    neighborhood: "ย่าน"
  },
  date_picker: {
    apply: "สมัคร",
    clear: "ล้าง",
    time: "เวลา",
    all_time: "ทั้งหมด",
    last_3_months: "3 เดือนที่ผ่านมา",
    last_pool_period: "ช่วงเวลาประเมินผลล่าสุด",
    last_month: "เดือนที่แล้ว",
    this_month: "เดือนนี้",
    last_30_days: "30 วันที่ผ่านมา",
    title_dates: "วันที่",
    from: "จาก",
    to: "ถึง"
  },
  copy_clipboard: "คัดลอกไปยังคลิปบอร์ด",
  payment_inputs: {
    empty_card_number: "กรอกหมายเลขบัตร",
    invalid_card_number: "หมายเลขบัตรไม่ถูกต้อง",
    empty_expiry_date: "กรอกวันที่หมดอายุ",
    month_out_of_range: "เดือนหมดอายุต้องอยู่ระหว่าง 01 ถึง 12",
    year_out_of_range: "ปีหมดอายุไม่สามารถอยู่ในอดีตได้",
    date_out_of_range: "วันที่หมดอายุไม่สามารถอยู่ในอดีตได้",
    invalid_expiry_date: "วันที่หมดอายุไม่ถูกต้อง",
    invalid_cvc: "CVC ไม่ถูกต้อง",
    empty_cvc: "กรุณาใส่ CVC",
    card_number_placeholder: "หมายเลขบัตร",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "ชื่อผู้ถือบัตร",
    empty_card_holder: "กรุณาใส่ชื่อผู้ถือบัตร"
  },
  copy_clipboard_error: "ไม่สามารถคัดลอกข้อความได้",
  input: {
    phone_number: "หมายเลขโทรศัพท์",
    phone_search: "ค้นหา",
    search: "ค้นหา"
  },
  "registered-over": "ลงทะเบียนมากกว่า",
  locale: {
    french: "ภาษาฝรั่งเศส",
    german: "เยอรมัน",
    italian: "ภาษาอิตาลี",
    dutch: "ภาษาดัตช์",
    english: "ภาษาอังกฤษ",
    portuguese: "โปรตุเกส",
    russian: "ภาษารัสเซีย",
    spanish: "สเปน",
    japanese: "ญี่ปุ่น",
    arabic: "ภาษาอาหรับ",
    turkish: "ภาษาตุรกี",
    chinese: "ชาวจีน",
    swedish: "ภาษาสวีเดน",
    romanian: "โรมาเนีย",
    czech: "เช็ก",
    hungarian: "ภาษาฮังการี",
    slovak: "สโลวัก",
    danish: "ภาษาเดนมาร์ก",
    indonesian: "ชาวอินโดนีเซีย",
    polish: "ขัด",
    greek: "กรีก",
    serbian: "เซอร์เบีย",
    hindi: "ไม่",
    norwegian: "ภาษานอร์เวย์",
    thai: "แบบไทย",
    slovenian: "ภาษาสโลเวเนีย",
    ukrainian: "ภาษายูเครน",
    albania: "แอลเบเนีย"
  },
  product: "ผลิตภัณฑ์",
  quantity: "จำนวน",
  order_summary: "สรุปคำสั่งซื้อ",
  vat: "ภาษีขาย",
  total: "รวม",
  subtotal: "ยอดรวมย่อย",
  shipping: {
    shipping_method: "วิธีการจัดส่ง",
    not_available: "อุ๊บส์! ดูเหมือนว่าเรายังไม่สามารถจัดส่งไปยังสถานที่นี้ได้",
    condition_label: {
      price: "สำหรับคำสั่งซื้อที่มีราคาอยู่ระหว่าง {{min}} {{currency}} ถึง {{max}} {{currency}}",
      price_min: "สำหรับคำสั่งซื้อที่มีราคา {{min}} {{currency}} ขึ้นไป",
      quantity: "สำหรับคำสั่งซื้อที่มีจำนวนระหว่าง {{min}} ถึง {{max}} รายการ",
      quantity_min: "สำหรับคำสั่งซื้อที่มีจำนวน {{min}} รายการขึ้นไป",
      weight: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวมระหว่าง {{min}}g ถึง {{max}}g",
      weight_min: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวม {{min}}g ขึ้นไป"
    }
  },
  shipping_fee: "ค่าจัดส่ง",
  total_amount_with_tax_and_shipping: "รวม (รวมภาษีและค่าจัดส่ง)",
  vat_percent: "ภาษีขาย ({{percent}}%)",
  including_tax: "รวมภาษีมูลค่าเพิ่ม {{percent}}% ({{amount}})"
}, bN = {
  public_pages_purchase: vN
}, _N = {
  "required-field": "Alan gereklidir",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredi kartları (Şeritli)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "İletişimi yasakla (Stripe)",
    dlocal_card: "Kredi kartları (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kredi kartları (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Çarpıntı dalgası",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kapıda ödeme",
    xendit_card: "Kredi kartları (Xendit)",
    paystack_card: "Kredi kartları (Paystack)",
    paypal_connect: "PayPal'ı bağlayın",
    paypal_edit_organization_name: "Kuruluş adını düzenleyin",
    paypal_rest: "PayPal",
    secure_and_pay: "Güvenli ve Ödemeli",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Güvenlik"
    }
  },
  error: "Hata",
  "Payment-method": "Ödeme yöntemi",
  price_plan: {
    trial_period: {
      week: "{{count}} hafta",
      week_plural: "{{count}} hafta",
      day: "{{count}} gün",
      day_plural: "{{count}} gün",
      month: "{{count}} ay",
      month_plural: "{{count}} ay",
      year: "{{count}} yıl",
      year_plural: "{{count}} yıl"
    },
    interval: {
      month: "ay",
      month_plural: "{{count}} ay",
      day: "gün",
      day_plural: "{{count}} gün",
      week: "hafta",
      week_plural: "{{count}} hafta",
      year: "yıl",
      year_plural: "{{count}} yıl"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Ücretsiz",
        trial_period_new: "{{ trialInterval }} için {{ trialPeriodPrice }} sonra",
        unlimited_new: "<bold>{{amount}}</bold> her {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kez"
      }
    }
  },
  affiliate_badge: {
    made_with: "Tarafından desteklenmektedir"
  },
  form_select: {
    empty_list: "Bu liste boş gibi görünüyor",
    select: "Seçin"
  },
  contact_slug: {
    email: "E-posta",
    first_name: "İsim",
    last_name: "Soyisim",
    phone_number: "Telefon numarası",
    country: "Ülke",
    street_address: "Sokak adresi",
    city: "Şehir",
    postal_code: "Posta kodu",
    company_name: "Şirket adı",
    tax_number: "Vergi numarası",
    state_province: "Eyalet/İl",
    street_number: "Sokak numarası",
    neighborhood: "Mahalle"
  },
  date_picker: {
    apply: "Uygula",
    clear: "Temizle",
    time: "Zaman",
    all_time: "Tüm zamanlar",
    last_3_months: "Son 3 ay",
    last_pool_period: "Son havuz değerlendirme dönemi",
    last_month: "Geçen Ay",
    this_month: "Bu Ay",
    last_30_days: "Son 30 gün",
    title_dates: "Tarihler",
    from: "Tarihinden itibaren",
    to: "Tarihine kadar"
  },
  copy_clipboard: "Panoya kopyalandı",
  payment_inputs: {
    empty_card_number: "Bir kart numarası girin",
    invalid_card_number: "Kart numarası geçersiz",
    empty_expiry_date: "Bir son kullanma tarihi girin",
    month_out_of_range: "Son kullanma ayı 01 ile 12 arasında olmalıdır",
    year_out_of_range: "Son kullanma yılı geçmiş tarihte olamaz",
    date_out_of_range: "Son kullanma tarihi geçmiş tarih olamaz",
    invalid_expiry_date: "Son kullanma tarihi geçersiz",
    invalid_cvc: "CVC geçersiz",
    empty_cvc: "CVC girin",
    card_number_placeholder: "Kart numarası",
    expiry_data_placeholder: "AA/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kart sahibi",
    empty_card_holder: "Bir kart sahibi adı girin"
  },
  copy_clipboard_error: "Metin kopyalanamadı",
  input: {
    phone_number: "Telefon numarası",
    phone_search: "Ara",
    search: "Ara"
  },
  "registered-over": "kaydedilen",
  locale: {
    french: "Fransızca",
    german: "Almanca",
    italian: "İtalyan",
    dutch: "Flemenkçe",
    english: "İngilizce",
    portuguese: "Portekizce",
    russian: "Rusça",
    spanish: "İspanyol",
    japanese: "Japonca",
    arabic: "Arap",
    turkish: "Türkçe",
    chinese: "Çince",
    swedish: "İsveççe",
    romanian: "Romen",
    czech: "Çek",
    hungarian: "Macarca",
    slovak: "Slovak",
    danish: "Danimarka",
    indonesian: "Endonezya dili",
    polish: "Lehçe",
    greek: "Yunan",
    serbian: "Sırpça",
    hindi: "Hintçe",
    norwegian: "Norveççe",
    thai: "Tay dili",
    slovenian: "Slovence",
    ukrainian: "Ukrayna",
    albania: "Arnavut"
  },
  product: "Ürün",
  quantity: "Miktar",
  order_summary: "Sipariş Özeti",
  vat: "Satış vergisi",
  total: "Toplam",
  subtotal: "Ara Toplam",
  shipping: {
    shipping_method: "Gönderim Yöntemi",
    not_available: "Aman! Görünüşe göre bu konuma henüz gönderim yapmıyoruz.",
    condition_label: {
      price: "{{min}} {{currency}} ile {{max}} {{currency}} arasında fiyatlandırılan siparişler için",
      price_min: "{{min}} {{currency}} veya daha fazla fiyatlandırılan siparişler için",
      quantity: "{{min}} ile {{max}} ürün içeren siparişler için",
      quantity_min: "{{min}} veya daha fazla ürün içeren siparişler için",
      weight: "Toplam ağırlığı {{min}}g ile {{max}}g arasında olan siparişler için",
      weight_min: "Toplam ağırlığı {{min}}g veya daha fazla olan siparişler için"
    }
  },
  shipping_fee: "Gönderim ücreti",
  total_amount_with_tax_and_shipping: "Toplam (vergi ve gönderim dahil)",
  vat_percent: "Satış vergisi ({{percent}}%)",
  including_tax: "KDV dahil {{percent}}% ({{amount}})"
}, wN = {
  public_pages_purchase: _N
}, SN = {
  "required-field": "Поле обов'язкове",
  payment: {
    price_plan: "План",
    stripe_card: "Кредитні картки (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Кредитні картки (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Пікс (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Кредитні картки (Mercado Pago)",
    mercadopago_pix: "PIX (платіжний ринок)",
    mercadopago_boleto: "Болето (Меркадо Паго)",
    razorpay: "Razorpay",
    flutterwave: "Флаттервейв",
    mollie: "Моллі",
    gocardless: "Gocardless",
    cash_on_delivery: "Накладений платіж",
    xendit_card: "Кредитні картки (Xendit)",
    paystack_card: "Кредитні картки (Paystack)",
    paypal_connect: "Підключіть PayPal",
    paypal_edit_organization_name: "Редагувати назву організації",
    paypal_rest: "PayPal",
    secure_and_pay: "Захистіть і заплатите",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Помилка",
  "Payment-method": "Спосіб оплати",
  price_plan: {
    trial_period: {
      week_0: "{{count}} тиждень",
      week_1: "{{count}} тижнів",
      week_2: "{{count}} тижнів",
      day_0: "{{count}} день",
      day_1: "{{count}} днів",
      day_2: "{{count}} днів",
      month_0: "{{count}} місяць",
      month_1: "{{count}} місяців",
      month_2: "{{count}} місяців",
      year_0: "{{count}} рік",
      year_1: "{{count}} років",
      year_2: "{{count}} років"
    },
    interval: {
      month_0: "місяць",
      month_1: "{{count}} місяців",
      month_2: "{{count}} місяців",
      day_0: "день",
      day_1: "{{count}} днів",
      day_2: "{{count}} днів",
      week_0: "тиждень",
      week_1: "{{count}} тижнів",
      week_2: "{{count}} тижнів",
      year_0: "рік",
      year_1: "{{count}} років",
      year_2: "{{count}} років"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "безкоштовно",
        trial_period_new: "Тоді {{ trialPeriodPrice }} за {{ trialInterval }} ",
        unlimited_new: "<bold>{{amount}}</bold> кожні {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} разів"
      }
    }
  },
  affiliate_badge: {
    made_with: "Підтримується"
  },
  form_select: {
    empty_list: "Схоже, що цей список порожній",
    select: "Вибрати"
  },
  contact_slug: {
    email: "Електронна пошта",
    first_name: "Ім'я",
    last_name: "Прізвище",
    phone_number: "Номер телефону",
    country: "Країна",
    street_address: "Вулиця",
    city: "Місто",
    postal_code: "Поштовий індекс",
    company_name: "Назва компанії",
    tax_number: "Податковий номер",
    state_province: "Штат/Область",
    street_number: "Номер вулиці",
    neighborhood: "Район"
  },
  date_picker: {
    apply: "Застосувати",
    clear: "Очистити",
    time: "Час",
    all_time: "Весь час",
    last_3_months: "Останні 3 місяці",
    last_pool_period: "Останній період оцінки пулу",
    last_month: "Останній місяць",
    this_month: "Цей місяць",
    last_30_days: "Останні 30 днів",
    title_dates: "Дати",
    from: "З",
    to: "До"
  },
  copy_clipboard: "Скопійовано в буфер обміну",
  payment_inputs: {
    empty_card_number: "Введіть номер картки",
    invalid_card_number: "Номер картки недійсний",
    empty_expiry_date: "Введіть дату закінчення терміну дії",
    month_out_of_range: "Місяць закінчення терміну дії має бути між 01 і 12",
    year_out_of_range: "Рік закінчення не може бути в минулому",
    date_out_of_range: "Дата закінчення не може бути в минулому",
    invalid_expiry_date: "Дата закінчення недійсна",
    invalid_cvc: "CVC недійсний",
    empty_cvc: "Введіть CVC",
    card_number_placeholder: "Номер картки",
    expiry_data_placeholder: "ММ/РР",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Власник картки",
    empty_card_holder: "Введіть ім'я власника картки"
  },
  copy_clipboard_error: "Не вдалося скопіювати текст",
  input: {
    phone_number: "Номер телефону",
    phone_search: "Пошук",
    search: "Пошук"
  },
  "registered-over": "зареєстровано понад",
  locale: {
    french: "французька",
    german: "Німецький",
    italian: "італійська",
    dutch: "голландська",
    english: "англійська",
    portuguese: "португальська",
    russian: "російський",
    spanish: "Іспанська",
    japanese: "Японський",
    arabic: "арабська",
    turkish: "турецька",
    chinese: "китайський",
    swedish: "шведська",
    romanian: "румунська",
    czech: "чеська",
    hungarian: "угорська",
    slovak: "словацький",
    danish: "датська",
    indonesian: "індонезійська",
    polish: "польський",
    greek: "грецька",
    serbian: "сербська",
    hindi: "ні",
    norwegian: "норвезька",
    thai: "тайська",
    slovenian: "словенська",
    ukrainian: "Українська",
    albania: "албанець"
  },
  product: "Продукт",
  quantity: "Кількість",
  order_summary: "Підсумок замовлення",
  vat: "Податок на продаж",
  total: "Всього",
  subtotal: "Проміжний підсумок",
  shipping: {
    shipping_method: "Спосіб доставки",
    not_available: "Упс! Схоже, що ми ще не пропонуємо доставку в це місце.",
    condition_label: {
      price: "Для замовлень вартістю від {{min}} {{currency}} до {{max}} {{currency}}",
      price_min: "Для замовлень вартістю від {{min}} {{currency}} або більше",
      quantity: "Для замовлень, що містять від {{min}} до {{max}} товарів",
      quantity_min: "Для замовлень, що містять {{min}} або більше товарів",
      weight: "Для замовлень з загальною вагою від {{min}}g до {{max}}g",
      weight_min: "Для замовлень з загальною вагою {{min}}g або більше"
    }
  },
  shipping_fee: "Вартість доставки",
  total_amount_with_tax_and_shipping: "Всього (включаючи податок і доставку)",
  vat_percent: "Податок з продажу ({{percent}}%)",
  including_tax: "З урахуванням ПДВ {{percent}}% ({{amount}})"
}, CN = {
  public_pages_purchase: SN
}, xN = {
  "required-field": "字段为必填项",
  payment: {
    price_plan: "计划",
    stripe_card: "信用卡（Stripe）",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "信用卡（Dlocal）",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "信用卡（Mercado Pago）",
    mercadopago_pix: "PIX（Mercado Pago）",
    mercadopago_boleto: "Boleto（Mercado Pago）",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "货到付款",
    xendit_card: "信用卡 (Xendit)",
    paystack_card: "信用卡（Paystack）",
    paypal_connect: "连接 PayPal",
    paypal_edit_organization_name: "编辑组织名称",
    paypal_rest: "PayPal",
    secure_and_pay: "安全与支付",
    stripe_applepay: "苹果支付",
    xendit: {
      "3ds": "3D-安全"
    }
  },
  error: "错误",
  "Payment-method": "付款方式",
  price_plan: {
    trial_period: {
      week: `周

{{count}} 周`,
      day: `{{count}} 天

{{count}} 天`,
      month: `{{count}} 月

{{count}} 月`,
      year: `{{count}}年

{{count}}年`
    },
    interval: {
      month: `月

{{count}} 月`,
      day: `天

{{count}} 天`,
      week: `周

{{count}}周`,
      year: `年

{{count}}年`
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "免费",
        trial_period_new: "{{ trialInterval }} {{ trialPeriodPrice }} 然后",
        unlimited_new: "<bold>{{amount}}</bold>每个{{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 次"
      }
    }
  },
  affiliate_badge: {
    made_with: "技术支持"
  },
  form_select: {
    empty_list: "看起来这个列表是空的",
    select: "选择"
  },
  contact_slug: {
    email: "电子邮件",
    first_name: "名字",
    last_name: "姓氏",
    phone_number: "电话号码",
    country: "国家",
    street_address: "街道地址",
    city: "城市",
    postal_code: "邮政编码",
    company_name: "公司名称",
    tax_number: "税号",
    state_province: "州/省",
    street_number: "街道号码",
    neighborhood: "街道邻里"
  },
  date_picker: {
    apply: "应用",
    clear: "清除",
    time: "时间",
    all_time: "所有的时间",
    last_3_months: "过去3个月",
    last_pool_period: "最后一个池评估期",
    last_month: "次月",
    this_month: "这个月",
    last_30_days: "过去30天",
    title_dates: "日期",
    from: "从",
    to: "到"
  },
  copy_clipboard: "已复制到剪贴板",
  payment_inputs: {
    empty_card_number: "输入卡号",
    invalid_card_number: "卡号无效",
    empty_expiry_date: "输入到期日期",
    month_out_of_range: "到期月份必须在01到12之间",
    year_out_of_range: "到期年不能是过去的年份",
    date_out_of_range: "过期日期不能是过去时间",
    invalid_expiry_date: "过期日期无效",
    invalid_cvc: "CVC无效",
    empty_cvc: "输入CVC",
    card_number_placeholder: "卡号",
    expiry_data_placeholder: "月/年",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "持卡人",
    empty_card_holder: "输入持卡人姓名"
  },
  copy_clipboard_error: "复制文本失败",
  input: {
    phone_number: "电话号码",
    phone_search: "搜索",
    search: "搜索"
  },
  "registered-over": "注册超过",
  locale: {
    french: "法语",
    german: "德语",
    italian: "意大利语",
    dutch: "荷兰语",
    english: "英语",
    portuguese: "葡萄牙语",
    russian: "俄语",
    spanish: "西班牙语",
    japanese: "日语",
    arabic: "阿拉伯语",
    turkish: "土耳其语",
    chinese: "中國人",
    swedish: "瑞典语",
    romanian: "罗马尼亚语",
    czech: "捷克语",
    hungarian: "匈牙利语",
    slovak: "斯洛伐克语",
    danish: "丹麦语",
    indonesian: "印度尼西亚语",
    polish: "波兰语",
    greek: "希腊语",
    serbian: "塞尔维亚语",
    hindi: "印地语",
    norwegian: "挪威语",
    thai: "泰语",
    slovenian: "斯洛文尼亚语",
    ukrainian: "乌克兰语",
    albania: "阿尔巴尼亚语"
  },
  product: "产品",
  quantity: "数量",
  order_summary: "订单摘要",
  vat: "销售税",
  total: "总计",
  subtotal: "小计",
  shipping: {
    shipping_method: "运输方式",
    not_available: "哎呀！看起来我们还不提供该地点的运输服务。",
    condition_label: {
      price: "对于价格在 {{min}} {{currency}} 到 {{max}} {{currency}} 之间的订单",
      price_min: "对于价格在 {{min}} {{currency}} 或以上的订单",
      quantity: "对于包含 {{min}} 到 {{max}} 件商品的订单",
      quantity_min: "对于包含 {{min}} 件或更多商品的订单",
      weight: "对于总重量在 {{min}}g 到 {{max}}g 之间的订单",
      weight_min: "对于总重量在 {{min}}g 或以上的订单"
    }
  },
  shipping_fee: "运费",
  total_amount_with_tax_and_shipping: "总计（包括税费和运费）",
  vat_percent: "销售税 ({{percent}}%)",
  including_tax: "含{{percent}}%增值税（{{amount}}）"
}, kN = {
  public_pages_purchase: xN
}, O5 = ["common"], EN = O5[0], PN = Object.values(Mn), TN = {
  ar: { common: kA },
  cs: { common: PA },
  da: { common: MA },
  de: { common: AA },
  el: { common: LA },
  en: { common: DA },
  es: { common: jA },
  fr: { common: FA },
  hi: { common: GA },
  hu: { common: KA },
  id: { common: $A },
  it: { common: WA },
  ja: { common: ZA },
  nl: { common: JA },
  no: { common: QA },
  pl: { common: tN },
  pt: { common: nN },
  ro: { common: oN },
  ru: { common: sN },
  sk: { common: cN },
  sl: { common: dN },
  sq: { common: hN },
  sr: { common: fN },
  sv: { common: yN },
  th: { common: bN },
  tr: { common: wN },
  uk: { common: CN },
  zh: { common: kN }
}, MN = {
  supportedLngs: PN,
  load: "languageOnly",
  debug: !1,
  defaultNS: EN,
  react: { useSuspense: !1 },
  returnEmptyString: !1,
  ns: O5,
  compatibilityJSON: "v3",
  fallbackLng: Mn.ENGLISH,
  lng: Mn.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: TN
};
Xe.use(XO).init(MN);
const A5 = (e) => {
  switch (e) {
    case ye.stripe_card:
      return Xe.t("public_pages_purchase.payment.stripe_card");
    case ye.stripe_ideal:
      return Xe.t("public_pages_purchase.payment.stripe_ideal");
    case ye.stripe_bancontact:
      return Xe.t("public_pages_purchase.payment.stripe_bancotact");
    case ye.stripe_applepay:
      return Xe.t("public_pages_purchase.payment.stripe_applepay");
    case ye.dlocal_card:
      return Xe.t("public_pages_purchase.payment.dlocal_card");
    case ye.dlocal_boleto:
      return Xe.t("public_pages_purchase.payment.dlocal_boleto");
    case ye.dlocal_pix:
      return Xe.t("public_pages_purchase.payment.dlocal_pix");
    case ye.paypal_soap:
    case ye.paypal_rest:
      return Xe.t("public_pages_purchase.payment.paypal_soap");
    case ye.mercadopago_br_card:
      return Xe.t("public_pages_purchase.payment.mercadopago_card");
    case ye.mercadopago_br_pix:
      return Xe.t("public_pages_purchase.payment.mercadopago_pix");
    case ye.mercadopago_br_boleto:
      return Xe.t("public_pages_purchase.payment.mercadopago_boleto");
    case ye.mercadopago_co_card:
    case ye.mercadopago_ar_card:
    case ye.mercadopago_mx_card:
    case ye.mercadopago_cl_card:
      return Xe.t("public_pages_purchase.payment.mercadopago_card");
    case ye.razorpay:
      return Xe.t("public_pages_purchase.payment.razorpay");
    case ye.flutterwave:
      return Xe.t("public_pages_purchase.payment.flutterwave");
    case ye.mollie:
      return Xe.t("public_pages_purchase.payment.mollie");
    case ye.gocardless:
      return Xe.t("public_pages_purchase.payment.gocardless");
    case ye.cash_on_delivery:
      return Xe.t("public_pages_purchase.payment.cash_on_delivery");
    case ye.xendit_id_card:
    case ye.xendit_ph_card:
      return Xe.t("public_pages_purchase.payment.xendit_card");
    case ye.paystack_gh_card:
    case ye.paystack_ke_card:
    case ye.paystack_ng_card:
    case ye.paystack_za_card:
    case ye.paystack_eg_card:
    case ye.paystack_ci_card:
      return Xe.t("public_pages_purchase.payment.paystack_card");
    case ye.secure_and_pay:
      return Xe.t("public_pages_purchase.payment.secure_and_pay");
  }
}, ON = (e, t) => {
  switch (e) {
    case ye.stripe_card:
    case ye.dlocal_card:
    case ye.mercadopago_br_card:
    case ye.mercadopago_ar_card:
    case ye.mercadopago_co_card:
    case ye.mercadopago_mx_card:
    case ye.mercadopago_cl_card:
    case ye.secure_and_pay:
      return /* @__PURE__ */ Z.jsx(LO, { ...t });
    case ye.stripe_applepay:
      return /* @__PURE__ */ Z.jsx(PO, { ...t });
    case ye.stripe_ideal:
      return /* @__PURE__ */ Z.jsx(IO, { ...t });
    case ye.stripe_bancontact:
      return /* @__PURE__ */ Z.jsx(TO, { ...t });
    case ye.dlocal_boleto:
    case ye.mercadopago_br_boleto:
      return /* @__PURE__ */ Z.jsx(MO, { ...t });
    case ye.dlocal_pix:
    case ye.mercadopago_br_pix:
      return /* @__PURE__ */ Z.jsx(GO, { ...t });
    case ye.paypal_soap:
    case ye.paypal_rest:
      return /* @__PURE__ */ Z.jsx(BO, { ...t });
    case ye.razorpay:
      return /* @__PURE__ */ Z.jsx(HO, { ...t });
    case ye.flutterwave:
      return /* @__PURE__ */ Z.jsx(RO, { ...t });
    case ye.mollie:
      return /* @__PURE__ */ Z.jsx(jO, { ...t });
    case ye.gocardless:
      return /* @__PURE__ */ Z.jsx(DO, { ...t });
    case ye.cash_on_delivery:
      return /* @__PURE__ */ Z.jsx(AO, { ...t });
    case ye.xendit_id_card:
    case ye.xendit_ph_card:
      return /* @__PURE__ */ Z.jsx(KO, { ...t });
    case ye.paystack_gh_card:
    case ye.paystack_ke_card:
    case ye.paystack_ng_card:
    case ye.paystack_za_card:
    case ye.paystack_eg_card:
    case ye.paystack_ci_card:
      return /* @__PURE__ */ Z.jsx(FO, { ...t });
  }
};
var ye = /* @__PURE__ */ ((e) => (e.stripe_card = "stripe:card", e.stripe_ideal = "stripe:ideal", e.stripe_bancontact = "stripe:bancontact", e.stripe_applepay = "stripe:applepay", e.dlocal_card = "dlocal:card", e.dlocal_boleto = "dlocal:boleto", e.dlocal_pix = "dlocal:pix", e.paypal_soap = "paypal-soap", e.paypal_rest = "paypal-rest", e.mercadopago_br_card = "mercadopago-br:card", e.mercadopago_br_pix = "mercadopago-br:pix", e.mercadopago_br_boleto = "mercadopago-br:boleto", e.mercadopago_co_card = "mercadopago-co:card", e.mercadopago_ar_card = "mercadopago-ar:card", e.mercadopago_mx_card = "mercadopago-mx:card", e.mercadopago_cl_card = "mercadopago-cl:card", e.razorpay = "razorpay", e.flutterwave = "flutterwave", e.mollie = "mollie", e.gocardless = "gocardless", e.cash_on_delivery = "cash-on-delivery", e.xendit_id_card = "xendit-id:card", e.xendit_ph_card = "xendit-ph:card", e.paystack_gh_card = "paystack-gh:card", e.paystack_ke_card = "paystack-ke:card", e.paystack_ng_card = "paystack-ng:card", e.paystack_za_card = "paystack-za:card", e.paystack_eg_card = "paystack-eg:card", e.paystack_ci_card = "paystack-ci:card", e.secure_and_pay = "secure-and-pay", e))(ye || {});
function fu(e) {
  const t = Object.keys(Uo).find(
    (n) => Uo[n] === e
  );
  return t ? Mn[t] : Mn.ENGLISH;
}
var Uo = /* @__PURE__ */ ((e) => (e.ENGLISH = "en", e.FRENCH = "fr", e.SPANISH = "es", e.ITALIAN = "it", e.PORTUGUESE = "pt", e.DEUTSCH = "de", e.DUTCH = "nl", e.RUSSIAN = "ru", e.JAPANESE = "jp", e.ARABIC = "ar", e.TURKISH = "tr", e.CHINESE = "zh", e.SWEDISH = "sv", e.ROMANIAN = "ro", e.CZECH = "cs", e.HUNGARIAN = "hu", e.SLOVAK = "sk", e.DANISH = "dk", e.INDONESIAN = "id", e.POLISH = "pl", e.GREEK = "el", e.SERBIAN = "sr", e.NORWEGIAN = "no", e.THAI = "th", e.SLOVENIAN = "sl", e.UKRAINIAN = "ua", e.ALBANIA = "sq", e.HINDI = "hi", e))(Uo || {});
const AN = Qe(null), NN = ({
  children: e,
  locale: t
}) => (De(() => {
  if (!Xe.isInitialized)
    return;
  const n = fu(t);
  Xe.language !== n && Xe.changeLanguage(n);
}, [t]), /* @__PURE__ */ Z.jsx(AN.Provider, { value: { locale: t }, children: e }));
var og = /* @__PURE__ */ ((e) => (e.Afghanistan = "AF", e.AlandIslands = "AX", e.Albania = "AL", e.Algeria = "DZ", e.AmericanSamoa = "AS", e.Andorra = "AD", e.Angola = "AO", e.Anguilla = "AI", e.Antarctica = "AQ", e.AntiguaAndBarbuda = "AG", e.Argentina = "AR", e.Armenia = "AM", e.Aruba = "AW", e.Australia = "AU", e.Austria = "AT", e.Azerbaijan = "AZ", e.Bahamas = "BS", e.Bahrain = "BH", e.Bangladesh = "BD", e.Barbados = "BB", e.Belarus = "BY", e.Belgium = "BE", e.Belize = "BZ", e.Benin = "BJ", e.Bermuda = "BM", e.Bhutan = "BT", e.Bolivia = "BO", e.BonaireSintEustatiusSaba = "BQ", e.BosniaAndHerzegovina = "BA", e.Botswana = "BW", e.BouvetIsland = "BV", e.Brazil = "BR", e.BritishIndianOceanTerritory = "IO", e.BruneiDarussalam = "BN", e.Bulgaria = "BG", e.BurkinaFaso = "BF", e.Burundi = "BI", e.Cambodia = "KH", e.Cameroon = "CM", e.Canada = "CA", e.CapeVerde = "CV", e.CaymanIslands = "KY", e.CentralAfricanRepublic = "CF", e.Chad = "TD", e.Chile = "CL", e.China = "CN", e.ChristmasIsland = "CX", e.CocosKeelingIslands = "CC", e.Colombia = "CO", e.Comoros = "KM", e.Congo = "CG", e.CongoDemocraticRepublic = "CD", e.CookIslands = "CK", e.CostaRica = "CR", e.CoteDIvoire = "CI", e.Croatia = "HR", e.Cuba = "CU", e.Curaçao = "CW", e.Cyprus = "CY", e.CzechRepublic = "CZ", e.Denmark = "DK", e.Djibouti = "DJ", e.Dominica = "DM", e.DominicanRepublic = "DO", e.Ecuador = "EC", e.Egypt = "EG", e.ElSalvador = "SV", e.EquatorialGuinea = "GQ", e.Eritrea = "ER", e.Estonia = "EE", e.Ethiopia = "ET", e.FalklandIslands = "FK", e.FaroeIslands = "FO", e.Fiji = "FJ", e.Finland = "FI", e.France = "FR", e.FrenchGuiana = "GF", e.FrenchPolynesia = "PF", e.FrenchSouthernTerritories = "TF", e.Gabon = "GA", e.Gambia = "GM", e.Georgia = "GE", e.Germany = "DE", e.Ghana = "GH", e.Gibraltar = "GI", e.Greece = "GR", e.Greenland = "GL", e.Grenada = "GD", e.Guadeloupe = "GP", e.Guam = "GU", e.Guatemala = "GT", e.Guernsey = "GG", e.Guinea = "GN", e.GuineaBissau = "GW", e.Guyana = "GY", e.Haiti = "HT", e.HeardIslandMcdonaldIslands = "HM", e.HolySeeVaticanCityState = "VA", e.Honduras = "HN", e.HongKong = "HK", e.Hungary = "HU", e.Iceland = "IS", e.India = "IN", e.Indonesia = "ID", e.Iran = "IR", e.Iraq = "IQ", e.Ireland = "IE", e.IsleOfMan = "IM", e.Israel = "IL", e.Italy = "IT", e.Jamaica = "JM", e.Japan = "JP", e.Jersey = "JE", e.Jordan = "JO", e.Kazakhstan = "KZ", e.Kenya = "KE", e.Kiribati = "KI", e.Korea = "KR", e.KoreaDemocraticPeoplesRepublic = "KP", e.Kuwait = "KW", e.Kyrgyzstan = "KG", e.LaoPeoplesDemocraticRepublic = "LA", e.Latvia = "LV", e.Lebanon = "LB", e.Lesotho = "LS", e.Liberia = "LR", e.LibyanArabJamahiriya = "LY", e.Liechtenstein = "LI", e.Lithuania = "LT", e.Luxembourg = "LU", e.Macao = "MO", e.Macedonia = "MK", e.Madagascar = "MG", e.Malawi = "MW", e.Malaysia = "MY", e.Maldives = "MV", e.Mali = "ML", e.Malta = "MT", e.MarshallIslands = "MH", e.Martinique = "MQ", e.Mauritania = "MR", e.Mauritius = "MU", e.Mayotte = "YT", e.Mexico = "MX", e.Micronesia = "FM", e.Moldova = "MD", e.Monaco = "MC", e.Mongolia = "MN", e.Montenegro = "ME", e.Montserrat = "MS", e.Morocco = "MA", e.Mozambique = "MZ", e.Myanmar = "MM", e.Namibia = "NA", e.Nauru = "NR", e.Nepal = "NP", e.Netherlands = "NL", e.NewCaledonia = "NC", e.NewZealand = "NZ", e.Nicaragua = "NI", e.Niger = "NE", e.Nigeria = "NG", e.Niue = "NU", e.NorfolkIsland = "NF", e.NorthernMarianaIslands = "MP", e.Norway = "NO", e.Oman = "OM", e.Pakistan = "PK", e.Palau = "PW", e.PalestinianTerritory = "PS", e.Panama = "PA", e.PapuaNewGuinea = "PG", e.Paraguay = "PY", e.Peru = "PE", e.Philippines = "PH", e.Pitcairn = "PN", e.Poland = "PL", e.Portugal = "PT", e.PuertoRico = "PR", e.Qatar = "QA", e.Reunion = "RE", e.Romania = "RO", e.RussianFederation = "RU", e.Rwanda = "RW", e.SaintBarthelemy = "BL", e.SaintHelena = "SH", e.SaintKittsAndNevis = "KN", e.SaintLucia = "LC", e.SaintMartin = "MF", e.SaintPierreAndMiquelon = "PM", e.SaintVincentAndGrenadines = "VC", e.Samoa = "WS", e.SanMarino = "SM", e.SaoTomeAndPrincipe = "ST", e.SaudiArabia = "SA", e.Senegal = "SN", e.Serbia = "RS", e.Seychelles = "SC", e.SierraLeone = "SL", e.Singapore = "SG", e.SintMaarten = "SX", e.Slovakia = "SK", e.Slovenia = "SI", e.SolomonIslands = "SB", e.Somalia = "SO", e.SouthAfrica = "ZA", e.SouthGeorgiaAndSandwichIsl = "GS", e.SouthSudan = "SS", e.Spain = "ES", e.SriLanka = "LK", e.Sudan = "SD", e.Suriname = "SR", e.SvalbardAndJanMayen = "SJ", e.Swaziland = "SZ", e.Sweden = "SE", e.Switzerland = "CH", e.SyrianArabRepublic = "SY", e.Taiwan = "TW", e.Tajikistan = "TJ", e.Tanzania = "TZ", e.Thailand = "TH", e.TimorLeste = "TL", e.Togo = "TG", e.Tokelau = "TK", e.Tonga = "TO", e.TrinidadAndTobago = "TT", e.Tunisia = "TN", e.Turkey = "TR", e.Turkmenistan = "TM", e.TurksAndCaicosIslands = "TC", e.Tuvalu = "TV", e.Uganda = "UG", e.Ukraine = "UA", e.UnitedArabEmirates = "AE", e.UnitedKingdom = "GB", e.UnitedStates = "US", e.UnitedStatesOutlyingIslands = "UM", e.Uruguay = "UY", e.Uzbekistan = "UZ", e.Vanuatu = "VU", e.Venezuela = "VE", e.Vietnam = "VN", e.VirginIslandsBritish = "VG", e.VirginIslandsUS = "VI", e.WallisAndFutuna = "WF", e.WesternSahara = "EH", e.Yemen = "YE", e.Zambia = "ZM", e.Zimbabwe = "ZW", e))(og || {}), N5 = {};
const LN = [
  [
    "AF",
    "AFG",
    "004",
    "ISO 3166-2:AF"
  ],
  [
    "AL",
    "ALB",
    "008",
    "ISO 3166-2:AL"
  ],
  [
    "DZ",
    "DZA",
    "012",
    "ISO 3166-2:DZ"
  ],
  [
    "AS",
    "ASM",
    "016",
    "ISO 3166-2:AS"
  ],
  [
    "AD",
    "AND",
    "020",
    "ISO 3166-2:AD"
  ],
  [
    "AO",
    "AGO",
    "024",
    "ISO 3166-2:AO"
  ],
  [
    "AI",
    "AIA",
    "660",
    "ISO 3166-2:AI"
  ],
  [
    "AQ",
    "ATA",
    "010",
    "ISO 3166-2:AQ"
  ],
  [
    "AG",
    "ATG",
    "028",
    "ISO 3166-2:AG"
  ],
  [
    "AR",
    "ARG",
    "032",
    "ISO 3166-2:AR"
  ],
  [
    "AM",
    "ARM",
    "051",
    "ISO 3166-2:AM"
  ],
  [
    "AW",
    "ABW",
    "533",
    "ISO 3166-2:AW"
  ],
  [
    "AU",
    "AUS",
    "036",
    "ISO 3166-2:AU"
  ],
  [
    "AT",
    "AUT",
    "040",
    "ISO 3166-2:AT"
  ],
  [
    "AZ",
    "AZE",
    "031",
    "ISO 3166-2:AZ"
  ],
  [
    "BS",
    "BHS",
    "044",
    "ISO 3166-2:BS"
  ],
  [
    "BH",
    "BHR",
    "048",
    "ISO 3166-2:BH"
  ],
  [
    "BD",
    "BGD",
    "050",
    "ISO 3166-2:BD"
  ],
  [
    "BB",
    "BRB",
    "052",
    "ISO 3166-2:BB"
  ],
  [
    "BY",
    "BLR",
    "112",
    "ISO 3166-2:BY"
  ],
  [
    "BE",
    "BEL",
    "056",
    "ISO 3166-2:BE"
  ],
  [
    "BZ",
    "BLZ",
    "084",
    "ISO 3166-2:BZ"
  ],
  [
    "BJ",
    "BEN",
    "204",
    "ISO 3166-2:BJ"
  ],
  [
    "BM",
    "BMU",
    "060",
    "ISO 3166-2:BM"
  ],
  [
    "BT",
    "BTN",
    "064",
    "ISO 3166-2:BT"
  ],
  [
    "BO",
    "BOL",
    "068",
    "ISO 3166-2:BO"
  ],
  [
    "BA",
    "BIH",
    "070",
    "ISO 3166-2:BA"
  ],
  [
    "BW",
    "BWA",
    "072",
    "ISO 3166-2:BW"
  ],
  [
    "BV",
    "BVT",
    "074",
    "ISO 3166-2:BV"
  ],
  [
    "BR",
    "BRA",
    "076",
    "ISO 3166-2:BR"
  ],
  [
    "IO",
    "IOT",
    "086",
    "ISO 3166-2:IO"
  ],
  [
    "BN",
    "BRN",
    "096",
    "ISO 3166-2:BN"
  ],
  [
    "BG",
    "BGR",
    "100",
    "ISO 3166-2:BG"
  ],
  [
    "BF",
    "BFA",
    "854",
    "ISO 3166-2:BF"
  ],
  [
    "BI",
    "BDI",
    "108",
    "ISO 3166-2:BI"
  ],
  [
    "KH",
    "KHM",
    "116",
    "ISO 3166-2:KH"
  ],
  [
    "CM",
    "CMR",
    "120",
    "ISO 3166-2:CM"
  ],
  [
    "CA",
    "CAN",
    "124",
    "ISO 3166-2:CA"
  ],
  [
    "CV",
    "CPV",
    "132",
    "ISO 3166-2:CV"
  ],
  [
    "KY",
    "CYM",
    "136",
    "ISO 3166-2:KY"
  ],
  [
    "CF",
    "CAF",
    "140",
    "ISO 3166-2:CF"
  ],
  [
    "TD",
    "TCD",
    "148",
    "ISO 3166-2:TD"
  ],
  [
    "CL",
    "CHL",
    "152",
    "ISO 3166-2:CL"
  ],
  [
    "CN",
    "CHN",
    "156",
    "ISO 3166-2:CN"
  ],
  [
    "CX",
    "CXR",
    "162",
    "ISO 3166-2:CX"
  ],
  [
    "CC",
    "CCK",
    "166",
    "ISO 3166-2:CC"
  ],
  [
    "CO",
    "COL",
    "170",
    "ISO 3166-2:CO"
  ],
  [
    "KM",
    "COM",
    "174",
    "ISO 3166-2:KM"
  ],
  [
    "CG",
    "COG",
    "178",
    "ISO 3166-2:CG"
  ],
  [
    "CD",
    "COD",
    "180",
    "ISO 3166-2:CD"
  ],
  [
    "CK",
    "COK",
    "184",
    "ISO 3166-2:CK"
  ],
  [
    "CR",
    "CRI",
    "188",
    "ISO 3166-2:CR"
  ],
  [
    "CI",
    "CIV",
    "384",
    "ISO 3166-2:CI"
  ],
  [
    "HR",
    "HRV",
    "191",
    "ISO 3166-2:HR"
  ],
  [
    "CU",
    "CUB",
    "192",
    "ISO 3166-2:CU"
  ],
  [
    "CY",
    "CYP",
    "196",
    "ISO 3166-2:CY"
  ],
  [
    "CZ",
    "CZE",
    "203",
    "ISO 3166-2:CZ"
  ],
  [
    "DK",
    "DNK",
    "208",
    "ISO 3166-2:DK"
  ],
  [
    "DJ",
    "DJI",
    "262",
    "ISO 3166-2:DJ"
  ],
  [
    "DM",
    "DMA",
    "212",
    "ISO 3166-2:DM"
  ],
  [
    "DO",
    "DOM",
    "214",
    "ISO 3166-2:DO"
  ],
  [
    "EC",
    "ECU",
    "218",
    "ISO 3166-2:EC"
  ],
  [
    "EG",
    "EGY",
    "818",
    "ISO 3166-2:EG"
  ],
  [
    "SV",
    "SLV",
    "222",
    "ISO 3166-2:SV"
  ],
  [
    "GQ",
    "GNQ",
    "226",
    "ISO 3166-2:GQ"
  ],
  [
    "ER",
    "ERI",
    "232",
    "ISO 3166-2:ER"
  ],
  [
    "EE",
    "EST",
    "233",
    "ISO 3166-2:EE"
  ],
  [
    "ET",
    "ETH",
    "231",
    "ISO 3166-2:ET"
  ],
  [
    "FK",
    "FLK",
    "238",
    "ISO 3166-2:FK"
  ],
  [
    "FO",
    "FRO",
    "234",
    "ISO 3166-2:FO"
  ],
  [
    "FJ",
    "FJI",
    "242",
    "ISO 3166-2:FJ"
  ],
  [
    "FI",
    "FIN",
    "246",
    "ISO 3166-2:FI"
  ],
  [
    "FR",
    "FRA",
    "250",
    "ISO 3166-2:FR"
  ],
  [
    "GF",
    "GUF",
    "254",
    "ISO 3166-2:GF"
  ],
  [
    "PF",
    "PYF",
    "258",
    "ISO 3166-2:PF"
  ],
  [
    "TF",
    "ATF",
    "260",
    "ISO 3166-2:TF"
  ],
  [
    "GA",
    "GAB",
    "266",
    "ISO 3166-2:GA"
  ],
  [
    "GM",
    "GMB",
    "270",
    "ISO 3166-2:GM"
  ],
  [
    "GE",
    "GEO",
    "268",
    "ISO 3166-2:GE"
  ],
  [
    "DE",
    "DEU",
    "276",
    "ISO 3166-2:DE"
  ],
  [
    "GH",
    "GHA",
    "288",
    "ISO 3166-2:GH"
  ],
  [
    "GI",
    "GIB",
    "292",
    "ISO 3166-2:GI"
  ],
  [
    "GR",
    "GRC",
    "300",
    "ISO 3166-2:GR"
  ],
  [
    "GL",
    "GRL",
    "304",
    "ISO 3166-2:GL"
  ],
  [
    "GD",
    "GRD",
    "308",
    "ISO 3166-2:GD"
  ],
  [
    "GP",
    "GLP",
    "312",
    "ISO 3166-2:GP"
  ],
  [
    "GU",
    "GUM",
    "316",
    "ISO 3166-2:GU"
  ],
  [
    "GT",
    "GTM",
    "320",
    "ISO 3166-2:GT"
  ],
  [
    "GN",
    "GIN",
    "324",
    "ISO 3166-2:GN"
  ],
  [
    "GW",
    "GNB",
    "624",
    "ISO 3166-2:GW"
  ],
  [
    "GY",
    "GUY",
    "328",
    "ISO 3166-2:GY"
  ],
  [
    "HT",
    "HTI",
    "332",
    "ISO 3166-2:HT"
  ],
  [
    "HM",
    "HMD",
    "334",
    "ISO 3166-2:HM"
  ],
  [
    "VA",
    "VAT",
    "336",
    "ISO 3166-2:VA"
  ],
  [
    "HN",
    "HND",
    "340",
    "ISO 3166-2:HN"
  ],
  [
    "HK",
    "HKG",
    "344",
    "ISO 3166-2:HK"
  ],
  [
    "HU",
    "HUN",
    "348",
    "ISO 3166-2:HU"
  ],
  [
    "IS",
    "ISL",
    "352",
    "ISO 3166-2:IS"
  ],
  [
    "IN",
    "IND",
    "356",
    "ISO 3166-2:IN"
  ],
  [
    "ID",
    "IDN",
    "360",
    "ISO 3166-2:ID"
  ],
  [
    "IR",
    "IRN",
    "364",
    "ISO 3166-2:IR"
  ],
  [
    "IQ",
    "IRQ",
    "368",
    "ISO 3166-2:IQ"
  ],
  [
    "IE",
    "IRL",
    "372",
    "ISO 3166-2:IE"
  ],
  [
    "IL",
    "ISR",
    "376",
    "ISO 3166-2:IL"
  ],
  [
    "IT",
    "ITA",
    "380",
    "ISO 3166-2:IT"
  ],
  [
    "JM",
    "JAM",
    "388",
    "ISO 3166-2:JM"
  ],
  [
    "JP",
    "JPN",
    "392",
    "ISO 3166-2:JP"
  ],
  [
    "JO",
    "JOR",
    "400",
    "ISO 3166-2:JO"
  ],
  [
    "KZ",
    "KAZ",
    "398",
    "ISO 3166-2:KZ"
  ],
  [
    "KE",
    "KEN",
    "404",
    "ISO 3166-2:KE"
  ],
  [
    "KI",
    "KIR",
    "296",
    "ISO 3166-2:KI"
  ],
  [
    "KP",
    "PRK",
    "408",
    "ISO 3166-2:KP"
  ],
  [
    "KR",
    "KOR",
    "410",
    "ISO 3166-2:KR"
  ],
  [
    "KW",
    "KWT",
    "414",
    "ISO 3166-2:KW"
  ],
  [
    "KG",
    "KGZ",
    "417",
    "ISO 3166-2:KG"
  ],
  [
    "LA",
    "LAO",
    "418",
    "ISO 3166-2:LA"
  ],
  [
    "LV",
    "LVA",
    "428",
    "ISO 3166-2:LV"
  ],
  [
    "LB",
    "LBN",
    "422",
    "ISO 3166-2:LB"
  ],
  [
    "LS",
    "LSO",
    "426",
    "ISO 3166-2:LS"
  ],
  [
    "LR",
    "LBR",
    "430",
    "ISO 3166-2:LR"
  ],
  [
    "LY",
    "LBY",
    "434",
    "ISO 3166-2:LY"
  ],
  [
    "LI",
    "LIE",
    "438",
    "ISO 3166-2:LI"
  ],
  [
    "LT",
    "LTU",
    "440",
    "ISO 3166-2:LT"
  ],
  [
    "LU",
    "LUX",
    "442",
    "ISO 3166-2:LU"
  ],
  [
    "MO",
    "MAC",
    "446",
    "ISO 3166-2:MO"
  ],
  [
    "MG",
    "MDG",
    "450",
    "ISO 3166-2:MG"
  ],
  [
    "MW",
    "MWI",
    "454",
    "ISO 3166-2:MW"
  ],
  [
    "MY",
    "MYS",
    "458",
    "ISO 3166-2:MY"
  ],
  [
    "MV",
    "MDV",
    "462",
    "ISO 3166-2:MV"
  ],
  [
    "ML",
    "MLI",
    "466",
    "ISO 3166-2:ML"
  ],
  [
    "MT",
    "MLT",
    "470",
    "ISO 3166-2:MT"
  ],
  [
    "MH",
    "MHL",
    "584",
    "ISO 3166-2:MH"
  ],
  [
    "MQ",
    "MTQ",
    "474",
    "ISO 3166-2:MQ"
  ],
  [
    "MR",
    "MRT",
    "478",
    "ISO 3166-2:MR"
  ],
  [
    "MU",
    "MUS",
    "480",
    "ISO 3166-2:MU"
  ],
  [
    "YT",
    "MYT",
    "175",
    "ISO 3166-2:YT"
  ],
  [
    "MX",
    "MEX",
    "484",
    "ISO 3166-2:MX"
  ],
  [
    "FM",
    "FSM",
    "583",
    "ISO 3166-2:FM"
  ],
  [
    "MD",
    "MDA",
    "498",
    "ISO 3166-2:MD"
  ],
  [
    "MC",
    "MCO",
    "492",
    "ISO 3166-2:MC"
  ],
  [
    "MN",
    "MNG",
    "496",
    "ISO 3166-2:MN"
  ],
  [
    "MS",
    "MSR",
    "500",
    "ISO 3166-2:MS"
  ],
  [
    "MA",
    "MAR",
    "504",
    "ISO 3166-2:MA"
  ],
  [
    "MZ",
    "MOZ",
    "508",
    "ISO 3166-2:MZ"
  ],
  [
    "MM",
    "MMR",
    "104",
    "ISO 3166-2:MM"
  ],
  [
    "NA",
    "NAM",
    "516",
    "ISO 3166-2:NA"
  ],
  [
    "NR",
    "NRU",
    "520",
    "ISO 3166-2:NR"
  ],
  [
    "NP",
    "NPL",
    "524",
    "ISO 3166-2:NP"
  ],
  [
    "NL",
    "NLD",
    "528",
    "ISO 3166-2:NL"
  ],
  [
    "NC",
    "NCL",
    "540",
    "ISO 3166-2:NC"
  ],
  [
    "NZ",
    "NZL",
    "554",
    "ISO 3166-2:NZ"
  ],
  [
    "NI",
    "NIC",
    "558",
    "ISO 3166-2:NI"
  ],
  [
    "NE",
    "NER",
    "562",
    "ISO 3166-2:NE"
  ],
  [
    "NG",
    "NGA",
    "566",
    "ISO 3166-2:NG"
  ],
  [
    "NU",
    "NIU",
    "570",
    "ISO 3166-2:NU"
  ],
  [
    "NF",
    "NFK",
    "574",
    "ISO 3166-2:NF"
  ],
  [
    "MP",
    "MNP",
    "580",
    "ISO 3166-2:MP"
  ],
  [
    "MK",
    "MKD",
    "807",
    "ISO 3166-2:MK"
  ],
  [
    "NO",
    "NOR",
    "578",
    "ISO 3166-2:NO"
  ],
  [
    "OM",
    "OMN",
    "512",
    "ISO 3166-2:OM"
  ],
  [
    "PK",
    "PAK",
    "586",
    "ISO 3166-2:PK"
  ],
  [
    "PW",
    "PLW",
    "585",
    "ISO 3166-2:PW"
  ],
  [
    "PS",
    "PSE",
    "275",
    "ISO 3166-2:PS"
  ],
  [
    "PA",
    "PAN",
    "591",
    "ISO 3166-2:PA"
  ],
  [
    "PG",
    "PNG",
    "598",
    "ISO 3166-2:PG"
  ],
  [
    "PY",
    "PRY",
    "600",
    "ISO 3166-2:PY"
  ],
  [
    "PE",
    "PER",
    "604",
    "ISO 3166-2:PE"
  ],
  [
    "PH",
    "PHL",
    "608",
    "ISO 3166-2:PH"
  ],
  [
    "PN",
    "PCN",
    "612",
    "ISO 3166-2:PN"
  ],
  [
    "PL",
    "POL",
    "616",
    "ISO 3166-2:PL"
  ],
  [
    "PT",
    "PRT",
    "620",
    "ISO 3166-2:PT"
  ],
  [
    "PR",
    "PRI",
    "630",
    "ISO 3166-2:PR"
  ],
  [
    "QA",
    "QAT",
    "634",
    "ISO 3166-2:QA"
  ],
  [
    "RE",
    "REU",
    "638",
    "ISO 3166-2:RE"
  ],
  [
    "RO",
    "ROU",
    "642",
    "ISO 3166-2:RO"
  ],
  [
    "RU",
    "RUS",
    "643",
    "ISO 3166-2:RU"
  ],
  [
    "RW",
    "RWA",
    "646",
    "ISO 3166-2:RW"
  ],
  [
    "SH",
    "SHN",
    "654",
    "ISO 3166-2:SH"
  ],
  [
    "KN",
    "KNA",
    "659",
    "ISO 3166-2:KN"
  ],
  [
    "LC",
    "LCA",
    "662",
    "ISO 3166-2:LC"
  ],
  [
    "PM",
    "SPM",
    "666",
    "ISO 3166-2:PM"
  ],
  [
    "VC",
    "VCT",
    "670",
    "ISO 3166-2:VC"
  ],
  [
    "WS",
    "WSM",
    "882",
    "ISO 3166-2:WS"
  ],
  [
    "SM",
    "SMR",
    "674",
    "ISO 3166-2:SM"
  ],
  [
    "ST",
    "STP",
    "678",
    "ISO 3166-2:ST"
  ],
  [
    "SA",
    "SAU",
    "682",
    "ISO 3166-2:SA"
  ],
  [
    "SN",
    "SEN",
    "686",
    "ISO 3166-2:SN"
  ],
  [
    "SC",
    "SYC",
    "690",
    "ISO 3166-2:SC"
  ],
  [
    "SL",
    "SLE",
    "694",
    "ISO 3166-2:SL"
  ],
  [
    "SG",
    "SGP",
    "702",
    "ISO 3166-2:SG"
  ],
  [
    "SK",
    "SVK",
    "703",
    "ISO 3166-2:SK"
  ],
  [
    "SI",
    "SVN",
    "705",
    "ISO 3166-2:SI"
  ],
  [
    "SB",
    "SLB",
    "090",
    "ISO 3166-2:SB"
  ],
  [
    "SO",
    "SOM",
    "706",
    "ISO 3166-2:SO"
  ],
  [
    "ZA",
    "ZAF",
    "710",
    "ISO 3166-2:ZA"
  ],
  [
    "GS",
    "SGS",
    "239",
    "ISO 3166-2:GS"
  ],
  [
    "ES",
    "ESP",
    "724",
    "ISO 3166-2:ES"
  ],
  [
    "LK",
    "LKA",
    "144",
    "ISO 3166-2:LK"
  ],
  [
    "SD",
    "SDN",
    "729",
    "ISO 3166-2:SD"
  ],
  [
    "SR",
    "SUR",
    "740",
    "ISO 3166-2:SR"
  ],
  [
    "SJ",
    "SJM",
    "744",
    "ISO 3166-2:SJ"
  ],
  [
    "SZ",
    "SWZ",
    "748",
    "ISO 3166-2:SZ"
  ],
  [
    "SE",
    "SWE",
    "752",
    "ISO 3166-2:SE"
  ],
  [
    "CH",
    "CHE",
    "756",
    "ISO 3166-2:CH"
  ],
  [
    "SY",
    "SYR",
    "760",
    "ISO 3166-2:SY"
  ],
  [
    "TW",
    "TWN",
    "158",
    "ISO 3166-2:TW"
  ],
  [
    "TJ",
    "TJK",
    "762",
    "ISO 3166-2:TJ"
  ],
  [
    "TZ",
    "TZA",
    "834",
    "ISO 3166-2:TZ"
  ],
  [
    "TH",
    "THA",
    "764",
    "ISO 3166-2:TH"
  ],
  [
    "TL",
    "TLS",
    "626",
    "ISO 3166-2:TL"
  ],
  [
    "TG",
    "TGO",
    "768",
    "ISO 3166-2:TG"
  ],
  [
    "TK",
    "TKL",
    "772",
    "ISO 3166-2:TK"
  ],
  [
    "TO",
    "TON",
    "776",
    "ISO 3166-2:TO"
  ],
  [
    "TT",
    "TTO",
    "780",
    "ISO 3166-2:TT"
  ],
  [
    "TN",
    "TUN",
    "788",
    "ISO 3166-2:TN"
  ],
  [
    "TR",
    "TUR",
    "792",
    "ISO 3166-2:TR"
  ],
  [
    "TM",
    "TKM",
    "795",
    "ISO 3166-2:TM"
  ],
  [
    "TC",
    "TCA",
    "796",
    "ISO 3166-2:TC"
  ],
  [
    "TV",
    "TUV",
    "798",
    "ISO 3166-2:TV"
  ],
  [
    "UG",
    "UGA",
    "800",
    "ISO 3166-2:UG"
  ],
  [
    "UA",
    "UKR",
    "804",
    "ISO 3166-2:UA"
  ],
  [
    "AE",
    "ARE",
    "784",
    "ISO 3166-2:AE"
  ],
  [
    "GB",
    "GBR",
    "826",
    "ISO 3166-2:GB"
  ],
  [
    "US",
    "USA",
    "840",
    "ISO 3166-2:US"
  ],
  [
    "UM",
    "UMI",
    "581",
    "ISO 3166-2:UM"
  ],
  [
    "UY",
    "URY",
    "858",
    "ISO 3166-2:UY"
  ],
  [
    "UZ",
    "UZB",
    "860",
    "ISO 3166-2:UZ"
  ],
  [
    "VU",
    "VUT",
    "548",
    "ISO 3166-2:VU"
  ],
  [
    "VE",
    "VEN",
    "862",
    "ISO 3166-2:VE"
  ],
  [
    "VN",
    "VNM",
    "704",
    "ISO 3166-2:VN"
  ],
  [
    "VG",
    "VGB",
    "092",
    "ISO 3166-2:VG"
  ],
  [
    "VI",
    "VIR",
    "850",
    "ISO 3166-2:VI"
  ],
  [
    "WF",
    "WLF",
    "876",
    "ISO 3166-2:WF"
  ],
  [
    "EH",
    "ESH",
    "732",
    "ISO 3166-2:EH"
  ],
  [
    "YE",
    "YEM",
    "887",
    "ISO 3166-2:YE"
  ],
  [
    "ZM",
    "ZMB",
    "894",
    "ISO 3166-2:ZM"
  ],
  [
    "ZW",
    "ZWE",
    "716",
    "ISO 3166-2:ZW"
  ],
  [
    "AX",
    "ALA",
    "248",
    "ISO 3166-2:AX"
  ],
  [
    "BQ",
    "BES",
    "535",
    "ISO 3166-2:BQ"
  ],
  [
    "CW",
    "CUW",
    "531",
    "ISO 3166-2:CW"
  ],
  [
    "GG",
    "GGY",
    "831",
    "ISO 3166-2:GG"
  ],
  [
    "IM",
    "IMN",
    "833",
    "ISO 3166-2:IM"
  ],
  [
    "JE",
    "JEY",
    "832",
    "ISO 3166-2:JE"
  ],
  [
    "ME",
    "MNE",
    "499",
    "ISO 3166-2:ME"
  ],
  [
    "BL",
    "BLM",
    "652",
    "ISO 3166-2:BL"
  ],
  [
    "MF",
    "MAF",
    "663",
    "ISO 3166-2:MF"
  ],
  [
    "RS",
    "SRB",
    "688",
    "ISO 3166-2:RS"
  ],
  [
    "SX",
    "SXM",
    "534",
    "ISO 3166-2:SX"
  ],
  [
    "SS",
    "SSD",
    "728",
    "ISO 3166-2:SS"
  ],
  [
    "XK",
    "XKK",
    "983",
    "ISO 3166-2:XK"
  ]
], RN = [
  "br",
  "cy",
  "dv",
  "sw",
  "eu",
  "af",
  "am",
  "ha",
  "ku",
  "ml",
  "mt",
  "no",
  "ps",
  "sd",
  "so",
  "sq",
  "ta",
  "tg",
  "tt",
  "ug",
  "ur",
  "vi",
  "ar",
  "az",
  "be",
  "bg",
  "bn",
  "bs",
  "ca",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fa",
  "fi",
  "fr",
  "ga",
  "gl",
  "he",
  "hi",
  "hr",
  "hu",
  "hy",
  "id",
  "is",
  "it",
  "ja",
  "ka",
  "kk",
  "km",
  "ko",
  "ky",
  "lt",
  "lv",
  "mk",
  "mn",
  "mr",
  "ms",
  "nb",
  "nl",
  "nn",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sv",
  "th",
  "tk",
  "tr",
  "uk",
  "uz",
  "zh"
];
var th = {};
th.remove = DN;
var od = [
  {
    base: " ",
    chars: " "
  },
  {
    base: "0",
    chars: "߀"
  },
  {
    base: "A",
    chars: "ⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
  },
  {
    base: "AA",
    chars: "Ꜳ"
  },
  {
    base: "AE",
    chars: "ÆǼǢ"
  },
  {
    base: "AO",
    chars: "Ꜵ"
  },
  {
    base: "AU",
    chars: "Ꜷ"
  },
  {
    base: "AV",
    chars: "ꜸꜺ"
  },
  {
    base: "AY",
    chars: "Ꜽ"
  },
  {
    base: "B",
    chars: "ⒷＢḂḄḆɃƁ"
  },
  {
    base: "C",
    chars: "ⒸＣꜾḈĆCĈĊČÇƇȻ"
  },
  {
    base: "D",
    chars: "ⒹＤḊĎḌḐḒḎĐƊƉᴅꝹ"
  },
  {
    base: "Dh",
    chars: "Ð"
  },
  {
    base: "DZ",
    chars: "ǱǄ"
  },
  {
    base: "Dz",
    chars: "ǲǅ"
  },
  {
    base: "E",
    chars: "ɛⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎᴇ"
  },
  {
    base: "F",
    chars: "ꝼⒻＦḞƑꝻ"
  },
  {
    base: "G",
    chars: "ⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾɢ"
  },
  {
    base: "H",
    chars: "ⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
  },
  {
    base: "I",
    chars: "ⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
  },
  {
    base: "J",
    chars: "ⒿＪĴɈȷ"
  },
  {
    base: "K",
    chars: "ⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
  },
  {
    base: "L",
    chars: "ⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
  },
  {
    base: "LJ",
    chars: "Ǉ"
  },
  {
    base: "Lj",
    chars: "ǈ"
  },
  {
    base: "M",
    chars: "ⓂＭḾṀṂⱮƜϻ"
  },
  {
    base: "N",
    chars: "ꞤȠⓃＮǸŃÑṄŇṆŅṊṈƝꞐᴎ"
  },
  {
    base: "NJ",
    chars: "Ǌ"
  },
  {
    base: "Nj",
    chars: "ǋ"
  },
  {
    base: "O",
    chars: "ⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
  },
  {
    base: "OE",
    chars: "Œ"
  },
  {
    base: "OI",
    chars: "Ƣ"
  },
  {
    base: "OO",
    chars: "Ꝏ"
  },
  {
    base: "OU",
    chars: "Ȣ"
  },
  {
    base: "P",
    chars: "ⓅＰṔṖƤⱣꝐꝒꝔ"
  },
  {
    base: "Q",
    chars: "ⓆＱꝖꝘɊ"
  },
  {
    base: "R",
    chars: "ⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
  },
  {
    base: "S",
    chars: "ⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
  },
  {
    base: "T",
    chars: "ⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
  },
  {
    base: "Th",
    chars: "Þ"
  },
  {
    base: "TZ",
    chars: "Ꜩ"
  },
  {
    base: "U",
    chars: "ⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
  },
  {
    base: "V",
    chars: "ⓋＶṼṾƲꝞɅ"
  },
  {
    base: "VY",
    chars: "Ꝡ"
  },
  {
    base: "W",
    chars: "ⓌＷẀẂŴẆẄẈⱲ"
  },
  {
    base: "X",
    chars: "ⓍＸẊẌ"
  },
  {
    base: "Y",
    chars: "ⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
  },
  {
    base: "Z",
    chars: "ⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
  },
  {
    base: "a",
    chars: "ⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑ"
  },
  {
    base: "aa",
    chars: "ꜳ"
  },
  {
    base: "ae",
    chars: "æǽǣ"
  },
  {
    base: "ao",
    chars: "ꜵ"
  },
  {
    base: "au",
    chars: "ꜷ"
  },
  {
    base: "av",
    chars: "ꜹꜻ"
  },
  {
    base: "ay",
    chars: "ꜽ"
  },
  {
    base: "b",
    chars: "ⓑｂḃḅḇƀƃɓƂ"
  },
  {
    base: "c",
    chars: "ｃⓒćĉċčçḉƈȼꜿↄ"
  },
  {
    base: "d",
    chars: "ⓓｄḋďḍḑḓḏđƌɖɗƋᏧԁꞪ"
  },
  {
    base: "dh",
    chars: "ð"
  },
  {
    base: "dz",
    chars: "ǳǆ"
  },
  {
    base: "e",
    chars: "ⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇǝ"
  },
  {
    base: "f",
    chars: "ⓕｆḟƒ"
  },
  {
    base: "ff",
    chars: "ﬀ"
  },
  {
    base: "fi",
    chars: "ﬁ"
  },
  {
    base: "fl",
    chars: "ﬂ"
  },
  {
    base: "ffi",
    chars: "ﬃ"
  },
  {
    base: "ffl",
    chars: "ﬄ"
  },
  {
    base: "g",
    chars: "ⓖｇǵĝḡğġǧģǥɠꞡꝿᵹ"
  },
  {
    base: "h",
    chars: "ⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
  },
  {
    base: "hv",
    chars: "ƕ"
  },
  {
    base: "i",
    chars: "ⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
  },
  {
    base: "j",
    chars: "ⓙｊĵǰɉ"
  },
  {
    base: "k",
    chars: "ⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
  },
  {
    base: "l",
    chars: "ⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇɭ"
  },
  {
    base: "lj",
    chars: "ǉ"
  },
  {
    base: "m",
    chars: "ⓜｍḿṁṃɱɯ"
  },
  {
    base: "n",
    chars: "ⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥлԉ"
  },
  {
    base: "nj",
    chars: "ǌ"
  },
  {
    base: "o",
    chars: "ⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿꝋꝍɵɔᴑ"
  },
  {
    base: "oe",
    chars: "œ"
  },
  {
    base: "oi",
    chars: "ƣ"
  },
  {
    base: "oo",
    chars: "ꝏ"
  },
  {
    base: "ou",
    chars: "ȣ"
  },
  {
    base: "p",
    chars: "ⓟｐṕṗƥᵽꝑꝓꝕρ"
  },
  {
    base: "q",
    chars: "ⓠｑɋꝗꝙ"
  },
  {
    base: "r",
    chars: "ⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
  },
  {
    base: "s",
    chars: "ⓢｓśṥŝṡšṧṣṩșşȿꞩꞅẛʂ"
  },
  {
    base: "ss",
    chars: "ß"
  },
  {
    base: "t",
    chars: "ⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
  },
  {
    base: "th",
    chars: "þ"
  },
  {
    base: "tz",
    chars: "ꜩ"
  },
  {
    base: "u",
    chars: "ⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
  },
  {
    base: "v",
    chars: "ⓥｖṽṿʋꝟʌ"
  },
  {
    base: "vy",
    chars: "ꝡ"
  },
  {
    base: "w",
    chars: "ⓦｗẁẃŵẇẅẘẉⱳ"
  },
  {
    base: "x",
    chars: "ⓧｘẋẍ"
  },
  {
    base: "y",
    chars: "ⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
  },
  {
    base: "z",
    chars: "ⓩｚźẑżžẓẕƶȥɀⱬꝣ"
  }
], ig = {};
for (var Ru = 0; Ru < od.length; Ru += 1)
  for (var E2 = od[Ru].chars, nm = 0; nm < E2.length; nm += 1)
    ig[E2[nm]] = od[Ru].base;
function DN(e) {
  return e.replace(/[^\u0000-\u007e]/g, function(t) {
    return ig[t] || t;
  });
}
th.replacementList = od;
th.diacriticsMap = ig;
(function(e) {
  const t = LN, n = RN, r = th.remove, a = {}, o = {}, i = {}, s = {}, l = {};
  t.forEach(function(b) {
    const C = b;
    o[C[0]] = C[1], i[C[1]] = C[0], s[C[2]] = C[0], l[C[0]] = C[2];
  });
  function c(b) {
    return ("000" + (b || "")).slice(-3);
  }
  function u(b, C) {
    return Object.prototype.hasOwnProperty.call(b, C);
  }
  function d(b, C) {
    return Object.keys(b).reduce(function(E, A) {
      const O = b[A];
      return E[A] = C(O, A), E;
    }, {});
  }
  function p(b, C) {
    switch (b) {
      case "official":
        return Array.isArray(C) ? C[0] : C;
      case "all":
        return typeof C == "string" ? [C] : C;
      case "alias":
        return Array.isArray(C) ? C[1] || C[0] : C;
      default:
        throw new TypeError(
          "LocaleNameType must be one of these: all, official, alias!"
        );
    }
  }
  e.registerLocale = function(b) {
    if (!b.locale)
      throw new TypeError("Missing localeData.locale");
    if (!b.countries)
      throw new TypeError("Missing localeData.countries");
    a[b.locale] = b.countries;
  };
  function h(b) {
    return i[b];
  }
  e.alpha3ToAlpha2 = h;
  function m(b) {
    return o[b];
  }
  e.alpha2ToAlpha3 = m;
  function f(b) {
    return l[h(b)];
  }
  e.alpha3ToNumeric = f;
  function g(b) {
    return l[b];
  }
  e.alpha2ToNumeric = g;
  function _(b) {
    const C = c(b);
    return m(s[C]);
  }
  e.numericToAlpha3 = _;
  function v(b) {
    const C = c(b);
    return s[C];
  }
  e.numericToAlpha2 = v;
  function w(b) {
    if (typeof b == "string") {
      if (/^[0-9]*$/.test(b))
        return _(b);
      if (b.length === 2)
        return m(b.toUpperCase());
      if (b.length === 3)
        return b.toUpperCase();
    }
    if (typeof b == "number")
      return _(b);
  }
  e.toAlpha3 = w;
  function x(b) {
    if (typeof b == "string") {
      if (/^[0-9]*$/.test(b))
        return v(b);
      if (b.length === 2)
        return b.toUpperCase();
      if (b.length === 3)
        return h(b.toUpperCase());
    }
    if (typeof b == "number")
      return v(b);
  }
  e.toAlpha2 = x, e.getName = function(b, C, E = {}) {
    "select" in E || (E.select = "official");
    try {
      const A = a[C.toLowerCase()][x(b)];
      return p(E.select, A);
    } catch {
      return;
    }
  }, e.getNames = function(b, C = {}) {
    "select" in C || (C.select = "official");
    const E = a[b.toLowerCase()];
    return E === void 0 ? {} : d(E, function(A) {
      return p(C.select, A);
    });
  }, e.getAlpha2Code = function(b, C) {
    const E = (O) => O.toLowerCase(), A = (O, M) => E(O) === E(M);
    try {
      const O = a[C.toLowerCase()];
      for (const M in O)
        if (u(O, M)) {
          if (typeof O[M] == "string" && A(O[M], b))
            return M;
          if (Array.isArray(O[M])) {
            for (const I of O[M])
              if (A(I, b))
                return M;
          }
        }
      return;
    } catch {
      return;
    }
  }, e.getSimpleAlpha2Code = function(b, C) {
    const E = (O) => r(O.toLowerCase()), A = (O, M) => E(O) === E(M);
    try {
      const O = a[C.toLowerCase()];
      for (const M in O)
        if (u(O, M)) {
          if (typeof O[M] == "string" && A(O[M], b))
            return M;
          if (Array.isArray(O[M])) {
            for (const I of O[M])
              if (A(I, b))
                return M;
          }
        }
      return;
    } catch {
      return;
    }
  }, e.getAlpha2Codes = function() {
    return o;
  }, e.getAlpha3Code = function(b, C) {
    const E = e.getAlpha2Code(b, C);
    if (E)
      return e.toAlpha3(E);
  }, e.getSimpleAlpha3Code = function(b, C) {
    const E = e.getSimpleAlpha2Code(b, C);
    if (E)
      return e.toAlpha3(E);
  }, e.getAlpha3Codes = function() {
    return i;
  }, e.getNumericCodes = function() {
    return s;
  }, e.langs = function() {
    return Object.keys(a);
  }, e.getSupportedLanguages = function() {
    return n;
  }, e.isValid = function(b) {
    if (!b)
      return !1;
    const C = b.toString().toUpperCase();
    return u(i, C) || u(o, C) || u(s, C);
  };
})(N5);
const M1 = /* @__PURE__ */ Ep(N5), L5 = "ar", R5 = {
  AF: "أفغانستان",
  AL: "ألبانيا",
  DZ: "الجزائر",
  AS: "ساموا الأمريكية",
  AD: "أندورا",
  AO: "أنغولا",
  AI: "أنغويلا",
  AQ: "القارة القطبية الجنوبية",
  AG: "أنتيغوا وباربودا",
  AR: "الأرجنتين",
  AM: "أرمينيا",
  AW: "أروبا",
  AU: "أستراليا",
  AT: "النمسا",
  AZ: "أذربيجان",
  BS: "باهاماس",
  BH: "البحرين",
  BD: "بنغلاديش",
  BB: "باربادوس",
  BY: "روسيا البيضاء",
  BE: "بلجيكا",
  BZ: "بليز",
  BJ: "بنين",
  BM: "برمودا",
  BT: "بوتان",
  BO: "بوليفيا",
  BA: "البوسنة والهرسك",
  BW: "بوتسوانا",
  BV: "جزيرة بوفيه",
  BR: "البرازيل",
  IO: "إقليم المحيط الهندي البريطاني",
  BN: "بروناي",
  BG: "بلغاريا",
  BF: "بوركينا فاسو",
  BI: "بوروندي",
  KH: "كمبوديا",
  CM: "الكاميرون",
  CA: "كندا",
  CV: "الرأس الأخضر",
  KY: "جزر كايمان",
  CF: "جمهورية أفريقيا الوسطى",
  TD: "تشاد",
  CL: "تشيلي",
  CN: "الصين",
  CX: "جزيرة عيد الميلاد",
  CC: "جزر كوكوس",
  CO: "كولومبيا",
  KM: "جزر القمر",
  CG: "جمهورية الكونغو",
  CD: "جمهورية الكونغو الديمقراطية",
  CK: "جزر كوك",
  CR: "كوستاريكا",
  CI: "ساحل العاج",
  HR: "كرواتيا",
  CU: "كوبا",
  CY: "قبرص",
  CZ: "جمهورية التشيك",
  DK: "الدنمارك",
  DJ: "جيبوتي",
  DM: "دومينيكا",
  DO: "جمهورية الدومينيكان",
  EC: "الإكوادور",
  EG: "مصر",
  SV: "السلفادور",
  GQ: "غينيا الاستوائية",
  ER: "إريتريا",
  EE: "إستونيا",
  ET: "إثيوبيا",
  FK: "جزر فوكلاند",
  FO: "جزر فارو",
  FJ: "فيجي",
  FI: "فنلندا",
  FR: "فرنسا",
  GF: "غويانا الفرنسية",
  PF: "بولينزيا الفرنسية",
  TF: "أراض فرنسية جنوبية وأنتارتيكية",
  GA: "الغابون",
  GM: "غامبيا",
  GE: "جورجيا",
  DE: "ألمانيا",
  GH: "غانا",
  GI: "جبل طارق",
  GR: "اليونان",
  GL: "جرينلاند",
  GD: "غرينادا",
  GP: "غوادلوب",
  GU: "غوام",
  GT: "غواتيمالا",
  GN: "غينيا",
  GW: "غينيا بيساو",
  GY: "غيانا",
  HT: "هايتي",
  HM: "جزيرة هيرد وجزر ماكدونالد",
  VA: "الفاتيكان",
  HN: "هندوراس",
  HK: "هونغ كونغ",
  HU: "المجر",
  IS: "آيسلندا",
  IN: "الهند",
  ID: "إندونيسيا",
  IR: "إيران",
  IQ: "العراق",
  IE: "أيرلندا",
  IL: "إسرائيل",
  IT: "إيطاليا",
  JM: "جامايكا",
  JP: "اليابان",
  JO: "الأردن",
  KZ: "كازاخستان",
  KE: "كينيا",
  KI: "كيريباتي",
  KP: "كوريا الشمالية",
  KR: "كوريا الجنوبية",
  KW: "الكويت",
  KG: "قيرغيزستان",
  LA: "لاوس",
  LV: "لاتفيا",
  LB: "لبنان",
  LS: "ليسوتو",
  LR: "ليبيريا",
  LY: "ليبيا",
  LI: "ليختنشتاين",
  LT: "ليتوانيا",
  LU: "لوكسمبورغ",
  MO: "ماكاو",
  MK: "مقدونيا الشمالية",
  MG: "مدغشقر",
  MW: "مالاوي",
  MY: "ماليزيا",
  MV: "جزر المالديف",
  ML: "مالي",
  MT: "مالطا",
  MH: "جزر مارشال",
  MQ: "مارتينيك",
  MR: "موريتانيا",
  MU: "موريشيوس",
  YT: "مايوت",
  MX: "المكسيك",
  FM: "ولايات ميكرونيسيا المتحدة",
  MD: "مولدوفا",
  MC: "موناكو",
  MN: "منغوليا",
  MS: "مونتسرات",
  MA: "المغرب",
  MZ: "موزمبيق",
  MM: "بورما",
  NA: "ناميبيا",
  NR: "ناورو",
  NP: "نيبال",
  NL: "هولندا",
  NC: "كاليدونيا الجديدة",
  NZ: "نيوزيلندا",
  NI: "نيكاراغوا",
  NE: "النيجر",
  NG: "نيجيريا",
  NU: "نييوي",
  NF: "جزيرة نورفولك",
  MP: "جزر ماريانا الشمالية",
  NO: "النرويج",
  OM: "عمان",
  PK: "باكستان",
  PW: "بالاو",
  PS: "فلسطين",
  PA: "بنما",
  PG: "بابوا غينيا الجديدة",
  PY: "باراغواي",
  PE: "بيرو",
  PH: "الفلبين",
  PN: "جزر بيتكيرن",
  PL: "بولندا",
  PT: "البرتغال",
  PR: "بورتوريكو",
  QA: "قطر",
  RE: "لا ريونيون",
  RO: "رومانيا",
  RU: "روسيا",
  RW: "رواندا",
  SH: "سانت هيلينا وأسينشين وتريستان دا كونا",
  KN: "سانت كيتس ونيفيس",
  LC: "سانت لوسيا",
  PM: "سان بيير وميكلون",
  VC: "سانت فينسنت والغرينادين",
  WS: "ساموا",
  SM: "سان مارينو",
  ST: "ساو تومي وبرينسيب",
  SA: "السعودية",
  SN: "السنغال",
  SC: "سيشل",
  SL: "سيراليون",
  SG: "سنغافورة",
  SK: "سلوفاكيا",
  SI: "سلوفينيا",
  SB: "جزر سليمان",
  SO: "الصومال",
  ZA: "جنوب أفريقيا",
  GS: "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
  ES: "إسبانيا",
  LK: "سريلانكا",
  SD: "السودان",
  SR: "سورينام",
  SJ: "سفالبارد ويان ماين",
  SZ: "سوازيلاند",
  SE: "السويد",
  CH: "سويسرا",
  SY: "سوريا",
  TW: "تايوان",
  TJ: "طاجيكستان",
  TZ: "تانزانيا",
  TH: "تايلاند",
  TL: "تيمور الشرقية",
  TG: "توغو",
  TK: "توكيلاو",
  TO: "تونغا",
  TT: "ترينيداد وتوباغو",
  TN: "تونس",
  TR: "تركيا",
  TM: "تركمانستان",
  TC: "جزر توركس وكايكوس",
  TV: "توفالو",
  UG: "أوغندا",
  UA: "أوكرانيا",
  AE: "الإمارات العربية المتحدة",
  GB: "المملكة المتحدة",
  US: "الولايات المتحدة",
  UM: "جزر الولايات المتحدة",
  UY: "الأوروغواي",
  UZ: "أوزبكستان",
  VU: "فانواتو",
  VE: "فنزويلا",
  VN: "فيتنام",
  VG: "جزر العذراء البريطانية",
  VI: "جزر العذراء الأمريكية",
  WF: "والس وفوتونا",
  EH: "الصحراء الغربية",
  YE: "اليمن",
  ZM: "زامبيا",
  ZW: "زيمبابوي",
  AX: "جزر أولاند",
  BQ: "الجزر الكاريبية الهولندية",
  CW: "كوراساو",
  GG: "غيرنزي",
  IM: "جزيرة مان",
  JE: "جيرزي",
  ME: "الجبل الأسود",
  BL: "سان بارتيلمي",
  MF: "سانت مارتن (الجزء الفرنسي)",
  RS: "صربيا",
  SX: "سانت مارتن (الجزء الهولندي)",
  SS: "جنوب السودان",
  XK: "كوسوفو"
}, IN = {
  locale: L5,
  countries: R5
}, jN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: R5,
  default: IN,
  locale: L5
}, Symbol.toStringTag, { value: "Module" })), D5 = "cs", I5 = {
  AF: "Afghánistán",
  AX: "Ålandy",
  AL: "Albánie",
  DZ: "Alžírsko",
  AS: "Americká Samoa",
  VI: "Americké Panenské ostrovy",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktida",
  AG: "Antigua a Barbuda",
  AR: "Argentina",
  AM: "Arménie",
  AW: "Aruba",
  AU: "Austrálie",
  AZ: "Ázerbájdžán",
  BS: "Bahamy",
  BH: "Bahrajn",
  BD: "Bangladéš",
  BB: "Barbados",
  BE: "Belgie",
  BZ: "Belize",
  BY: "Bělorusko",
  BJ: "Benin",
  BM: "Bermudy",
  BT: "Bhútán",
  BO: "Bolívie",
  BQ: "Bonaire, Svatý Eustach a Saba",
  BA: "Bosna a Hercegovina",
  BW: "Botswana",
  BV: "Bouvetův ostrov",
  BR: "Brazílie",
  IO: "Britské indickooceánské území",
  VG: "Britské Panenské ostrovy",
  BN: "Brunej",
  BG: "Bulharsko",
  BF: "Burkina Faso",
  BI: "Burundi",
  CK: "Cookovy ostrovy",
  CW: "Curaçao",
  TD: "Čad",
  ME: "Černá Hora",
  CZ: "Česká republika",
  CN: "Čína",
  DK: "Dánsko",
  CD: "Demokratická republika Kongo",
  DM: "Dominika",
  DO: "Dominikánská republika",
  DJ: "Džibutsko",
  EG: "Egypt",
  EC: "Ekvádor",
  ER: "Eritrea",
  EE: "Estonsko",
  ET: "Etiopie",
  FO: "Faerské ostrovy",
  FK: "Falklandy (Malvíny)",
  FJ: "Fidži",
  PH: "Filipíny",
  FI: "Finsko",
  FR: "Francie",
  GF: "Francouzská Guyana",
  TF: "Francouzská jižní a antarktická území",
  PF: "Francouzská Polynésie",
  GA: "Gabon",
  GM: "Gambie",
  GH: "Ghana",
  GI: "Gibraltar",
  GD: "Grenada",
  GL: "Grónsko",
  GE: "Gruzie",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GG: "Guernsey",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heardův ostrov a McDonaldovy ostrovy",
  HN: "Honduras",
  HK: "Hongkong",
  CL: "Chile",
  HR: "Chorvatsko",
  IN: "Indie",
  ID: "Indonésie",
  IQ: "Irák",
  IR: "Írán",
  IE: "Irsko",
  IS: "Island",
  IT: "Itálie",
  IL: "Izrael",
  JM: "Jamajka",
  JP: "Japonsko",
  YE: "Jemen",
  JE: "Jersey",
  ZA: "Jihoafrická republika",
  GS: "Jižní Georgie a Jižní Sandwichovy ostrovy",
  KR: "Jižní Korea",
  SS: "Jižní Súdán",
  JO: "Jordánsko",
  KY: "Kajmanské ostrovy",
  KH: "Kambodža",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kapverdy",
  QA: "Katar",
  KZ: "Kazachstán",
  KE: "Keňa",
  KI: "Kiribati",
  CC: "Kokosové ostrovy",
  CO: "Kolumbie",
  KM: "Komory",
  CG: "Kongo",
  CR: "Kostarika",
  CU: "Kuba",
  KW: "Kuvajt",
  CY: "Kypr",
  KG: "Kyrgyzstán",
  LA: "Laos",
  LS: "Lesotho",
  LB: "Libanon",
  LR: "Libérie",
  LY: "Libye",
  LI: "Lichtenštejnsko",
  LT: "Litva",
  LV: "Lotyšsko",
  LU: "Lucembursko",
  MO: "Macao",
  MG: "Madagaskar",
  HU: "Maďarsko",
  MY: "Malajsie",
  MW: "Malawi",
  MV: "Maledivy",
  ML: "Mali",
  MT: "Malta",
  IM: "Ostrov Man",
  MA: "Maroko",
  MH: "Marshallovy ostrovy",
  MQ: "Martinik",
  MU: "Mauricius",
  MR: "Mauritánie",
  YT: "Mayotte",
  UM: "Menší odlehlé ostrovy USA",
  MX: "Mexiko",
  FM: "Mikronésie",
  MD: "Moldavsko",
  MC: "Monako",
  MN: "Mongolsko",
  MS: "Montserrat",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibie",
  NR: "Nauru",
  DE: "Německo",
  NP: "Nepál",
  NE: "Niger",
  NG: "Nigérie",
  NI: "Nikaragua",
  NU: "Niue",
  NL: "Nizozemsko",
  NF: "Norfolk",
  NO: "Norsko",
  NC: "Nová Kaledonie",
  NZ: "Nový Zéland",
  OM: "Omán",
  PK: "Pákistán",
  PW: "Palau",
  PS: "Palestinská autonomie",
  PA: "Panama",
  PG: "Papua-Nová Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PN: "Pitcairnovy ostrovy",
  CI: "Pobřeží slonoviny",
  PL: "Polsko",
  PR: "Portoriko",
  PT: "Portugalsko",
  AT: "Rakousko",
  RE: "Réunion",
  GQ: "Rovníková Guinea",
  RO: "Rumunsko",
  RU: "Rusko",
  RW: "Rwanda",
  GR: "Řecko",
  PM: "Saint-Pierre a Miquelon",
  SV: "Salvador",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saúdská Arábie",
  SN: "Senegal",
  KP: "Severní Korea",
  MK: "Severní Makedonie",
  MP: "Severní Mariany",
  SC: "Seychely",
  SL: "Sierra Leone",
  SG: "Singapur",
  SK: "Slovensko",
  SI: "Slovinsko",
  SO: "Somálsko",
  AE: "Spojené arabské emiráty",
  GB: "Spojené království",
  US: "Spojené státy americké",
  RS: "Srbsko",
  CF: "Středoafrická republika",
  SD: "Súdán",
  SR: "Surinam",
  SH: "Svatá Helena, Ascension a Tristan da Cunha",
  LC: "Svatá Lucie",
  BL: "Svatý Bartoloměj",
  KN: "Svatý Kryštof a Nevis",
  MF: "Svatý Martin (francouzská část)",
  SX: "Svatý Martin (nizozemská část)",
  ST: "Svatý Tomáš a Princův ostrov",
  VC: "Svatý Vincenc a Grenadiny",
  SZ: "Svazijsko",
  SY: "Sýrie",
  SB: "Šalamounovy ostrovy",
  ES: "Španělsko",
  SJ: "Špicberky a Jan Mayen",
  LK: "Šrí Lanka",
  SE: "Švédsko",
  CH: "Švýcarsko",
  TJ: "Tádžikistán",
  TZ: "Tanzanie",
  TH: "Thajsko",
  TW: "Tchaj-wan",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad a Tobago",
  TN: "Tunisko",
  TR: "Turecko",
  TM: "Turkmenistán",
  TC: "Turks a Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukrajina",
  UY: "Uruguay",
  UZ: "Uzbekistán",
  CX: "Vánoční ostrov",
  VU: "Vanuatu",
  VA: "Vatikán",
  VE: "Venezuela",
  VN: "Vietnam",
  TL: "Východní Timor",
  WF: "Wallis a Futuna",
  ZM: "Zambie",
  EH: "Západní Sahara",
  ZW: "Zimbabwe",
  XK: "Kosovo"
}, BN = {
  locale: D5,
  countries: I5
}, FN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: I5,
  default: BN,
  locale: D5
}, Symbol.toStringTag, { value: "Module" })), j5 = "da", B5 = {
  AF: "Afghanistan",
  AL: "Albanien",
  DZ: "Algeriet",
  AS: "Amerikansk Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua og Barbuda",
  AR: "Argentina",
  AM: "Armenien",
  AW: "Aruba",
  AU: "Australien",
  AT: "Østrig",
  AZ: "Aserbajdsjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Hviderusland",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnien-Hercegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brasilien",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodja",
  CM: "Cameroun",
  CA: "Canada",
  CV: "Kap Verde",
  KY: "Caymanøerne",
  CF: "Den Centralafrikanske Republik",
  TD: "Tchad",
  CL: "Chile",
  CN: "Kina",
  CX: "Juløen",
  CC: "Cocosøerne",
  CO: "Colombia",
  KM: "Comorerne",
  CG: "Congo",
  CD: "Demokratiske Republik Congo",
  CK: "Cookøerne",
  CR: "Costa Rica",
  CI: "Elfenbenskysten",
  HR: "Kroatien",
  CU: "Cuba",
  CY: "Cypern",
  CZ: "Tjekkiet",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominikanske Republik",
  EC: "Ecuador",
  EG: "Egypten",
  SV: "El Salvador",
  GQ: "Ækvatorialguinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Etiopien",
  FK: "Falklandsøerne",
  FO: "Færøerne",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrig",
  GF: "Fransk Guiana",
  PF: "Fransk Polynesien",
  TF: "Franske Sydterritorier",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgien",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grækenland",
  GL: "Grønland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard-øen og McDonald-øerne",
  VA: "Vatikanstaten",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Ungarn",
  IS: "Island",
  IN: "Indien",
  ID: "Indonesien",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irland",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Nordkorea",
  KR: "Sydkorea",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Nordmakedonien",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldiverne",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalløerne",
  MQ: "Martinique",
  MR: "Mauretanien",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Mikronesien",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongoliet",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Holland",
  NC: "Ny Kaledonien",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Nordmarianerne",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palæstina",
  PA: "Panama",
  PG: "Papua Ny Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinerne",
  PN: "Pitcairn",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Rumænien",
  RU: "Rusland",
  RW: "Rwanda",
  SH: "Sankt Helena",
  KN: "Saint Kitts og Nevis",
  LC: "Saint Lucia",
  PM: "Saint-Pierre og Miquelon",
  VC: "Saint Vincent og Grenadinerne",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé og Príncipe",
  SA: "Saudi-Arabien",
  SN: "Senegal",
  SC: "Seychellerne",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakiet",
  SI: "Slovenien",
  SB: "Salomonøerne",
  SO: "Somalia",
  ZA: "Sydafrika",
  GS: "South Georgia og South Sandwich Islands",
  ES: "Spanien",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Norge Svalbard og Jan Mayen",
  SZ: "Eswatini",
  SE: "Sverige",
  CH: "Schweiz",
  SY: "Syrien",
  TW: "Republikken Kina Taiwan",
  TJ: "Tadsjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Østtimor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad og Tobago",
  TN: "Tunesien",
  TR: "Tyrkiet",
  TM: "Turkmenistan",
  TC: "Turks- og Caicosøerne",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "Forenede Arabiske Emirater",
  GB: "Storbritannien",
  US: "USA",
  UM: "USA's ydre småøer",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Britiske Jomfruøer",
  VI: "Amerikanske Jomfruøer",
  WF: "Wallis og Futuna",
  EH: "Vestsahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Ålandsøerne",
  BQ: "Nederlandske Antiller",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isle of Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint-Barthélemy",
  MF: "Saint Martin (fransk side)",
  RS: "Serbien",
  SX: "Saint Martin (hollandsk side)",
  SS: "Sydsudan",
  XK: "Kosovo"
}, zN = {
  locale: j5,
  countries: B5
}, GN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: B5,
  default: zN,
  locale: j5
}, Symbol.toStringTag, { value: "Module" })), F5 = "de", z5 = {
  AF: "Afghanistan",
  EG: "Ägypten",
  AX: "Åland",
  AL: "Albanien",
  DZ: "Algerien",
  AS: "Amerikanisch-Samoa",
  VI: "Amerikanische Jungferninseln",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua und Barbuda",
  GQ: "Äquatorialguinea",
  AR: "Argentinien",
  AM: "Armenien",
  AW: "Aruba",
  AZ: "Aserbaidschan",
  ET: "Äthiopien",
  AU: "Australien",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesch",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivien",
  BQ: "Bonaire",
  BA: "Bosnien und Herzegowina",
  BW: "Botswana",
  BV: "Bouvetinsel",
  BR: "Brasilien",
  VG: "Britische Jungferninseln",
  IO: "Britisches Territorium im Indischen Ozean",
  BN: "Brunei Darussalam",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  CL: "Chile",
  CN: "China",
  CK: "Cookinseln",
  CR: "Costa Rica",
  CI: "Elfenbeinküste",
  CW: "Curaçao",
  DK: "Dänemark",
  DE: "Deutschland",
  DM: "Dominica",
  DO: "Dominikanische Republik",
  DJ: "Dschibuti",
  EC: "Ecuador",
  SV: "El Salvador",
  ER: "Eritrea",
  EE: "Estland",
  FK: "Falklandinseln",
  FO: "Färöer",
  FJ: "Fidschi",
  FI: "Finnland",
  FR: "Frankreich",
  GF: "Französisch-Guayana",
  PF: "Französisch-Polynesien",
  TF: "Französische Süd- und Antarktisgebiete",
  GA: "Gabun",
  GM: "Gambia",
  GE: "Georgien",
  GH: "Ghana",
  GI: "Gibraltar",
  GD: "Grenada",
  GR: "Griechenland",
  GL: "Grönland",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard und McDonaldinseln",
  HN: "Honduras",
  HK: [
    "Hongkong",
    "Hong Kong"
  ],
  IN: "Indien",
  ID: "Indonesien",
  IM: "Insel Man",
  IQ: "Irak",
  IR: "Iran",
  IE: "Irland",
  IS: "Island",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaika",
  JP: "Japan",
  YE: "Jemen",
  JE: "Jersey",
  JO: "Jordanien",
  KY: "Kaimaninseln",
  KH: "Kambodscha",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kap Verde",
  KZ: "Kasachstan",
  QA: "Katar",
  KE: "Kenia",
  KG: "Kirgisistan",
  KI: "Kiribati",
  CC: "Kokosinseln",
  CO: "Kolumbien",
  KM: "Komoren",
  CD: "Kongo",
  KP: "Nordkorea",
  KR: "Südkorea",
  HR: "Kroatien",
  CU: "Kuba",
  KW: "Kuwait",
  LA: "Laos",
  LS: "Lesotho",
  LV: "Lettland",
  LB: "Libanon",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Macao",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Malediven",
  ML: "Mali",
  MT: "Malta",
  MA: "Marokko",
  MH: "Marshallinseln",
  MQ: "Martinique",
  MR: "Mauretanien",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexiko",
  FM: "Mikronesien",
  MD: "Moldawien",
  MC: "Monaco",
  MN: "Mongolei",
  ME: "Montenegro",
  MS: "Montserrat",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NC: "Neukaledonien",
  NZ: "Neuseeland",
  NI: "Nicaragua",
  NL: "Niederlande",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  MK: "Nordmazedonien",
  MP: "Nördliche Marianen",
  NF: "Norfolkinsel",
  NO: "Norwegen",
  OM: "Oman",
  AT: "Österreich",
  TL: "Osttimor",
  PK: "Pakistan",
  PS: "Staat Palästina",
  PW: "Palau",
  PA: "Panama",
  PG: "Papua-Neuguinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippinen",
  PN: "Pitcairninseln",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  TW: "Taiwan",
  CG: "Republik Kongo",
  RE: "Réunion",
  RW: "Ruanda",
  RO: "Rumänien",
  RU: [
    "Russische Föderation",
    "Russland"
  ],
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin",
  SB: "Salomonen",
  ZM: "Sambia",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé und Príncipe",
  SA: "Saudi-Arabien",
  SE: "Schweden",
  CH: "Schweiz",
  SN: "Senegal",
  RS: "Serbien",
  SC: "Seychellen",
  SL: "Sierra Leone",
  ZW: "Simbabwe",
  SG: "Singapur",
  SX: "Sint Maarten",
  SK: "Slowakei",
  SI: "Slowenien",
  SO: "Somalia",
  ES: "Spanien",
  LK: "Sri Lanka",
  SH: "St. Helena",
  KN: "St. Kitts und Nevis",
  LC: "St. Lucia",
  PM: "Saint-Pierre und Miquelon",
  VC: "St. Vincent und die Grenadinen",
  ZA: "Südafrika",
  SD: "Sudan",
  GS: "Südgeorgien und die Südlichen Sandwichinseln",
  SS: "Südsudan",
  SR: "Suriname",
  SJ: "Svalbard und Jan Mayen",
  SZ: "Eswatini",
  SY: "Syrien, Arabische Republik",
  TJ: "Tadschikistan",
  TZ: [
    "Tansania, Vereinigte Republik",
    "Tansania"
  ],
  TH: "Thailand",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad und Tobago",
  TD: "Tschad",
  CZ: [
    "Tschechische Republik",
    "Tschechien"
  ],
  TN: "Tunesien",
  TR: "Türkei",
  TM: "Turkmenistan",
  TC: "Turks- und Caicosinseln",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  HU: "Ungarn",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VA: "Vatikanstadt",
  VE: "Venezuela",
  AE: "Vereinigte Arabische Emirate",
  US: [
    "Vereinigte Staaten von Amerika",
    "Vereinigte Staaten",
    "USA"
  ],
  GB: [
    "Vereinigtes Königreich",
    "Großbritannien"
  ],
  VN: "Vietnam",
  WF: "Wallis und Futuna",
  CX: "Weihnachtsinsel",
  EH: "Westsahara",
  CF: "Zentralafrikanische Republik",
  CY: "Zypern",
  XK: "Kosovo"
}, HN = {
  locale: F5,
  countries: z5
}, KN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: z5,
  default: HN,
  locale: F5
}, Symbol.toStringTag, { value: "Module" })), G5 = "el", H5 = {
  AF: "Αφγανιστάν",
  AL: "Αλβανία",
  DZ: "Αλγερία",
  AS: "Αμερικανική Σαμόα",
  AD: "Ανδόρρα",
  AO: "Ανγκόλα",
  AI: "Ανγκουίλα",
  AQ: "Ανταρκτική",
  AG: "Αντίγκουα και Μπαρμπούντα",
  AR: "Αργεντινή",
  AM: "Αρμενία",
  AW: "Αρούμπα",
  AU: "Αυστραλία",
  AT: "Αυστρία",
  AZ: "Αζερμπαϊτζάν",
  BS: "Μπαχάμες",
  BH: "Μπαχρέιν",
  BD: "Μπανγκλαντές",
  BB: "Μπαρμπάντος",
  BY: "Λευκορωσία",
  BE: "Βέλγιο",
  BZ: "Μπελίζ",
  BJ: "Μπενίν",
  BM: "Βερμούδες",
  BT: "Μπουτάν",
  BO: "Βολιβία",
  BA: "Βοσνία και Ερζεγοβίνη",
  BW: "Μποτσουάνα",
  BV: "Μπουβέ",
  BR: "Βραζιλία",
  IO: "Βρετανικό Έδαφος Ινδικού Ωκεανού",
  BN: "Σουλτανάτο του Μπρουνέι",
  BG: "Βουλγαρία",
  BF: "Μπουρκίνα Φάσο",
  BI: "Μπουρουντί",
  KH: "Καμπότζη",
  CM: "Καμερούν",
  CA: "Καναδάς",
  CV: [
    "Δημοκρατία του Πράσινου Ακρωτηρίου",
    "Πράσινο Ακρωτήριο"
  ],
  KY: "Κέιμαν Νήσοι",
  CF: "Κεντροαφρικανική Δημοκρατία",
  TD: "Τσάντ",
  CL: "Χιλή",
  CN: "Κίνα",
  CX: "Νήσος των Χριστουγέννων",
  CC: "Νησιά Κόκος",
  CO: "Κολομβία",
  KM: "Ένωση των Κομορών",
  CG: [
    "Δημοκρατία του Κονγκό",
    "Κονγκό"
  ],
  CD: "Λαϊκή Δημοκρατία του Κονγκό",
  CK: "Νήσοι Κουκ",
  CR: "Κόστα Ρίκα",
  CI: "Ακτή Ελεφαντοστού",
  HR: "Κροατία",
  CU: "Κούβα",
  CY: "Κύπρος",
  CZ: [
    "Τσεχική Δημοκρατία",
    "Τσεχία"
  ],
  DK: "Δανία",
  DJ: "Τζιμπουτί",
  DM: [
    "Κοινοπολιτεία της Δομινίκας",
    "Ντομίνικα"
  ],
  DO: "Δομινικανή Δημοκρατία",
  EC: "Εκουαδόρ",
  EG: "Αίγυπτος",
  SV: "Ελ Σαλβαδόρ",
  GQ: "Ισημερινή-Γουινέα",
  ER: [
    "Κράτος της Ερυθραίας",
    "Ερυθραία"
  ],
  EE: "Εσθονία",
  ET: "Αιθιοπία",
  FK: "Νήσοι Φώκλαντ (Μαλβίνας)",
  FO: "Νήσοι Φερόες",
  FJ: "Δημοκρατία των Φίτζι",
  FI: "Φινλανδία",
  FR: "Γαλλία",
  GF: "Γαλλική Γουιάνα",
  PF: "Γαλλική Πολυνησία",
  TF: "Γαλλικά Νότια και Ανταρκτικά Εδάφη",
  GA: "Γκαμπόν",
  GM: "Γκάμπια",
  GE: "Γεωργία",
  DE: "Γερμανία",
  GH: "Γκάνα",
  GI: "Γιβραλτάρ",
  GR: "Ελλάδα",
  GL: "Γροιλανδία",
  GD: "Γρενάδα",
  GP: "Γουαδελούπη",
  GU: "Γκουάμ",
  GT: "Γουατεμάλα",
  GN: "Γουινέα",
  GW: "Γουινέα-Μπισσάου",
  GY: "Γουιάνα",
  HT: "Αϊτη",
  HM: "Νήσοι Χερντ και Μακντόναλντ",
  VA: [
    "Κράτος της Πόλης του Βατικανού",
    "Βατικανό"
  ],
  HN: "Ονδούρα",
  HK: "Χονγκ Κόνγκ",
  HU: "Ουγγαρία",
  IS: "Ισλανδία",
  IN: "Ινδία",
  ID: "Ινδονησία",
  IR: [
    "Ισλαμική Δημοκρατία του Ιράν",
    "Ιράν"
  ],
  IQ: "Ιράκ",
  IE: "Ιρλανδία",
  IL: "Ισραήλ",
  IT: "Ιταλία",
  JM: "Τζαμάικα",
  JP: "Ιαπωνία",
  JO: "Ιορδανία",
  KZ: "Καζακστάν",
  KE: "Κένυα",
  KI: "Κιριμπάτι",
  KP: [
    "Λαοκρατική Δημοκρατία της Κορέας",
    "Βόρεια Κορέα"
  ],
  KR: [
    "Δημοκρατία της Κορέας",
    "Νότια Κορέα"
  ],
  KW: "Κουβέιτ",
  KG: "Κιργιζία",
  LA: [
    "Λαϊκή Δημοκρατία του Λάος",
    "Λάος"
  ],
  LV: "Λετονία",
  LB: "Λίβανο",
  LS: [
    "Βασίλειο του Λεσότο",
    "Λεσότο"
  ],
  LR: "Λιβερία",
  LY: [
    "Κράτος της Λιβύης",
    "Λιβύη"
  ],
  LI: [
    "Πριγκιπάτο του Λίχτενσταϊν",
    "Λίχτενσταϊν"
  ],
  LT: "Λιθουανία",
  LU: "Λουξεμβούργο",
  MO: "Μακάου",
  MK: [
    "Δημοκρατία της Βόρειας Μακεδονίας",
    "Βόρεια Μακεδονία"
  ],
  MG: "Μαδαγασκάρη",
  MW: "Μαλάουι",
  MY: "Μαλαισία",
  MV: "Μαλβίδες",
  ML: "Μαλί",
  MT: "Μάλτα",
  MH: "Νήσοι Μάρσαλ",
  MQ: "Μαρτινίκα",
  MR: "Μαυριτανία",
  MU: "Μαυρίκιος",
  YT: "Μαγιότ",
  MX: "Μεξικό",
  FM: [
    "Ομόσπονδες Πολιτείες της Μικρονησίας",
    "Μικρονησία"
  ],
  MD: [
    "Δημοκρατία της Μολδαβίας",
    "Μολδαβία"
  ],
  MC: [
    "Πριγκιπάτο του Μονακό",
    "Μονακό"
  ],
  MN: "Μογγολία",
  MS: "Μοντσερράτ",
  MA: "Μαρόκο",
  MZ: "Μοζαμβίκη",
  MM: "Μιανμάρ",
  NA: "Ναμίμπια",
  NR: "Ναουρού",
  NP: "Νεπάλ",
  NL: "Ολλανδία",
  NC: "Νέα Καληδονία",
  NZ: "Νέα Ζηλανδία",
  NI: "Νικαράγουα",
  NE: "Νίγηρας",
  NG: "Νιγηρία",
  NU: "Νιούε",
  NF: "Νησί Νόρφολκ",
  MP: "Βόρειες Μαριάνες Νήσοι",
  NO: "Νορβηγία",
  OM: "Ομάν",
  PK: "Πακιστάν",
  PW: "Παλάου",
  PS: [
    "Κράτος της Παλαιστίνης",
    "Παλαιστίνη"
  ],
  PA: "Παναμάς",
  PG: "Παπούα Νέα Γουινέα",
  PY: "Παραγουάη",
  PE: "Περού",
  PH: "Φιλιππίνες",
  PN: "Νήσοι Πίτκαιρν",
  PL: "Πολωνία",
  PT: "Πορτογαλία",
  PR: "Πουέρτο Ρίκο",
  QA: "Κατάρ",
  RE: "Ρεϋνιόν",
  RO: "Ρουμανία",
  RU: [
    "Ρωσική Ομοσπονδία",
    "Ρωσία"
  ],
  RW: "Ρουάντα",
  SH: "Νήσος Αγίας Ελένης",
  KN: "Ομοσπονδία Αγίου Χριστόφορου και Νέβις",
  LC: "Αγία Λουκία",
  PM: "Σαιν Πιερ και Μικελόν",
  VC: "Άγιος Βικέντιος και Γρεναδίνες",
  WS: "Σαμόα",
  SM: "Άγιος Μαρίνος",
  ST: "Σάο Τομέ και Πρίνσιπε",
  SA: "Σαουδική Αραβία",
  SN: "Σενεγάλη",
  SC: "Σεϋχέλλες",
  SL: "Σιέρα Λεόνε",
  SG: "Σιγκαπούρη",
  SK: "Σλοβακία",
  SI: "Σλοβενία",
  SB: "Νήσοι Σολομώντα",
  SO: "Σομαλία",
  ZA: "Νότια Αφρική",
  GS: "Νότιος Γεωργία και Νότιοι Σάντουιτς Νήσοι",
  ES: "Ισπανία",
  LK: "Σρι Λάνκα",
  SD: "Σουδάν",
  SR: "Σουρινάμ",
  SJ: "Σβάλμπαρντ και Γιαν Μαγιέν",
  SZ: "Σουαζιλάνδη",
  SE: "Σουηδία",
  CH: "Ελβετία",
  SY: [
    "Αραβική Δημοκρατία της Συρίας",
    "Συρία"
  ],
  TW: "Δημοκρατία της Κίνας",
  TJ: "Τατζικιστάν",
  TZ: [
    "Ενωμένη Δημοκρατία της Τανζανίας",
    "Τανζανία"
  ],
  TH: "Ταϊλάνδη",
  TL: "Ανατολικό Τιμόρ",
  TG: "Τογκό",
  TK: "Τοκελάου",
  TO: "Τόνγκα",
  TT: "Τρινιντάντ και Τομπάγκο",
  TN: "Τυνησία",
  TR: "Τουρκία",
  TM: "Τουρκμενιστάν",
  TC: "Τερκς και Κέικος",
  TV: "Τουβαλού",
  UG: "Ουγκάντα",
  UA: "Ουκρανια",
  AE: "Ηνωμένα Αραβικά Εμιράτα",
  GB: "Ηνωμένο Βασίλειο",
  US: [
    "Ηνωμένες Πολιτείες Αμερικής",
    "Αμερική",
    "ΗΠΑ"
  ],
  UM: "Απομακρυσμένες Νησίδες των Ηνωμένων Πολιτειών",
  UY: "Ουρουγουάη",
  UZ: "Ουζμπεκιστάν",
  VU: "Βανουάτου",
  VE: "Βενεζουέλα",
  VN: "Βιετνάμ",
  VG: "Βρετανικές Παρθένοι Νήσοι",
  VI: "Αμερικανικές Παρθένοι Νήσοι",
  WF: "Ουαλίς και Φουτουνά",
  EH: "Δυτική Σαχάρα",
  YE: "Υεμένη",
  ZM: "Ζάμπια",
  ZW: "Ζιμπάμπουε",
  AX: "Νήσοι Ώλαντ",
  BQ: "Μποναίρ, Άγιος Ευστάθιος και Σάμπα",
  CW: "Κουρασάο",
  GG: "Γκουέρνσεϊ",
  IM: "Νήσος του Μαν",
  JE: "Βαϊλάτο του Τζέρσεϊ",
  ME: "Μαυροβούνιο",
  BL: "Άγιος Βαρθολομαίος",
  MF: "Άγιος Μαρτίνος (Γαλλία)",
  RS: "Σερβία",
  SX: "Άγιος Μαρτίνος (Ολλανδία)",
  SS: "Νότιο Σουδάν",
  XK: "Κόσοβο"
}, UN = {
  locale: G5,
  countries: H5
}, $N = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: H5,
  default: UN,
  locale: G5
}, Symbol.toStringTag, { value: "Module" })), K5 = "en", U5 = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: [
    "People's Republic of China",
    "China"
  ],
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: [
    "Republic of the Congo",
    "Congo"
  ],
  CD: [
    "Democratic Republic of the Congo",
    "Congo"
  ],
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: [
    "Cote d'Ivoire",
    "Côte d'Ivoire",
    "Ivory Coast"
  ],
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: [
    "Czech Republic",
    "Czechia"
  ],
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: [
    "Republic of The Gambia",
    "The Gambia",
    "Gambia"
  ],
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: [
    "Islamic Republic of Iran",
    "Iran"
  ],
  IQ: "Iraq",
  IE: "Ireland",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "North Korea",
  KR: [
    "South Korea",
    "Korea, Republic of",
    "Republic of Korea"
  ],
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: [
    "Netherlands",
    "The Netherlands",
    "Netherlands (Kingdom of the)"
  ],
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MK: [
    "The Republic of North Macedonia",
    "North Macedonia"
  ],
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: [
    "State of Palestine",
    "Palestine"
  ],
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: [
    "Pitcairn",
    "Pitcairn Islands"
  ],
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: [
    "Russian Federation",
    "Russia"
  ],
  RW: "Rwanda",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Eswatini",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: [
    "Taiwan, Province of China",
    "Taiwan"
  ],
  TJ: "Tajikistan",
  TZ: [
    "United Republic of Tanzania",
    "Tanzania"
  ],
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: [
    "Türkiye",
    "Turkey"
  ],
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: [
    "United Arab Emirates",
    "UAE"
  ],
  GB: [
    "United Kingdom",
    "UK",
    "Great Britain"
  ],
  US: [
    "United States of America",
    "United States",
    "USA",
    "U.S.A.",
    "US",
    "U.S."
  ],
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: [
    "Åland Islands",
    "Aland Islands"
  ],
  BQ: "Bonaire, Sint Eustatius and Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isle of Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: "Saint Martin (French part)",
  RS: "Serbia",
  SX: "Sint Maarten (Dutch part)",
  SS: "South Sudan",
  XK: "Kosovo"
}, VN = {
  locale: K5,
  countries: U5
}, WN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: U5,
  default: VN,
  locale: K5
}, Symbol.toStringTag, { value: "Module" })), $5 = "es", V5 = {
  AF: "Afganistán",
  AL: "Albania",
  DZ: "Argelia",
  AS: "Samoa Americana",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguila",
  AQ: "Antártida",
  AG: "Antigua y Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaiyán",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Bielorrusia",
  BE: "Bélgica",
  BZ: "Belice",
  BJ: "Benin",
  BM: "Bermudas",
  BT: "Bután",
  BO: "Bolivia",
  BA: "Bosnia y Herzegovina",
  BW: "Botswana",
  BV: "Isla Bouvet",
  BR: "Brasil",
  IO: "Territorio Británico del Océano Índico",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Camboya",
  CM: "Camerún",
  CA: "Canadá",
  CV: "Cabo Verde",
  KY: "Islas Caimán",
  CF: "República Centroafricana",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Isla de Navidad",
  CC: "Islas Cocos (Keeling)",
  CO: "Colombia",
  KM: "Comoras",
  CG: "Congo",
  CD: "Congo (República Democrática del)",
  CK: "Islas Cook",
  CR: "Costa Rica",
  CI: "Costa de Marfil",
  HR: "Croacia",
  CU: "Cuba",
  CY: "Chipre",
  CZ: "República Checa",
  DK: "Dinamarca",
  DJ: "Yibuti",
  DM: "Dominica",
  DO: "República Dominicana",
  EC: "Ecuador",
  EG: "Egipto",
  SV: "El Salvador",
  GQ: "Guinea Ecuatorial",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Etiopía",
  FK: "Islas Malvinas",
  FO: "Islas Feroe",
  FJ: "Fiji",
  FI: "Finlandia",
  FR: "Francia",
  GF: "Guayana Francesa",
  PF: "Polinesia Francesa",
  TF: "Tierras Australes Francesas",
  GA: "Gabón",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Alemania",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grecia",
  GL: "Groenlandia",
  GD: "Granada",
  GP: "Guadalupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea Bissau",
  GY: "Guyana",
  HT: "Haití",
  HM: "Heard e Islas McDonald",
  VA: "Santa Sede",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungría",
  IS: "Islandia",
  IN: "India",
  ID: "Indonesia",
  IR: [
    "Irán",
    "República Islámica de Irán"
  ],
  IQ: "Iraq",
  IE: "Irlanda",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japón",
  JO: "Jordania",
  KZ: "Kazajistán",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "República Popular Democrática de Corea",
  KR: "República de Corea",
  KW: "Kuwait",
  KG: "Kirguistán",
  LA: "República Democrática Popular de Lao",
  LV: "Letonia",
  LB: "Líbano",
  LS: "Lesoto",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Lituania",
  LU: "Luxemburgo",
  MO: "Macao",
  MK: "Macedonia del Norte",
  MG: "Madagascar",
  MW: "Malaui",
  MY: "Malasia",
  MV: "Maldivas",
  ML: "Malí",
  MT: "Malta",
  MH: "Islas Marshall",
  MQ: "Martinica",
  MR: "Mauritania",
  MU: "Mauricio",
  YT: "Mayotte",
  MX: "México",
  FM: "Micronesia",
  MD: "Moldavia",
  MC: "Mónaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Marruecos",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Países Bajos",
  NC: "Nueva Caledonia",
  NZ: "Nueva Zelanda",
  NI: "Nicaragua",
  NE: "Níger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Isla Norfolk",
  MP: "Islas Marianas del Norte",
  NO: "Noruega",
  OM: "Omán",
  PK: "Pakistán",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panamá",
  PG: "Papua Nueva Guinea",
  PY: "Paraguay",
  PE: "Perú",
  PH: "Filipinas",
  PN: "Pitcairn",
  PL: "Polonia",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Catar",
  RE: "Reunión",
  RO: "Rumanía",
  RU: "Rusia",
  RW: "Ruanda",
  SH: "Santa Helena, Ascensión y Tristán de Acuña",
  KN: "Saint Kitts y Nevis",
  LC: "Santa Lucía",
  PM: "San Pedro y Miquelón",
  VC: "San Vicente y las Granadinas",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Santo Tomé y Príncipe",
  SA: "Arabia Saudita",
  SN: "Senegal",
  SC: "Seychelles",
  SL: "Sierra Leona",
  SG: "Singapur",
  SK: "Eslovaquia",
  SI: "Eslovenia",
  SB: "Islas Salomón",
  SO: "Somalia",
  ZA: "Sudáfrica",
  GS: "Georgia del Sur y las Islas Sandwich del Sur",
  ES: "España",
  LK: "Sri Lanka",
  SD: "Sudán",
  SR: "Suriname",
  SJ: "Svalbard y Jan Mayen",
  SZ: "Esuatini",
  SE: "Suecia",
  CH: "Suiza",
  SY: "República Árabe Siria",
  TW: "Taiwán",
  TJ: "Tayikistán",
  TZ: "Tanzania",
  TH: "Tailandia",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad y Tobago",
  TN: "Túnez",
  TR: "Turquía",
  TM: "Turkmenistán",
  TC: "Islas Turcas y Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ucrania",
  AE: "Emiratos Árabes Unidos",
  GB: "Reino Unido",
  US: "Estados Unidos",
  UM: "Islas Ultramarinas Menores de los Estados Unidos",
  UY: "Uruguay",
  UZ: "Uzbekistán",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Islas Vírgenes británicas",
  VI: "Islas Vírgenes de los Estados Unidos",
  WF: "Wallis y Futuna",
  EH: "Sahara Occidental",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabue",
  AX: "Islas Åland",
  BQ: "Bonaire, San Eustaquio y Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isla de Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: "Saint Martin (francesa)",
  RS: "Serbia",
  SX: "Sint Maarten (neerlandesa)",
  SS: "Sudán del Sur",
  XK: "Kosovo"
}, YN = {
  locale: $5,
  countries: V5
}, ZN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: V5,
  default: YN,
  locale: $5
}, Symbol.toStringTag, { value: "Module" })), W5 = "fr", Y5 = {
  AF: "Afghanistan",
  AL: "Albanie",
  DZ: "Algérie",
  AS: "Samoa américaines",
  AD: "Andorre",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctique",
  AG: "Antigua-et-Barbuda",
  AR: "Argentine",
  AM: "Arménie",
  AW: "Aruba",
  AU: "Australie",
  AT: "Autriche",
  AZ: "Azerbaïdjan",
  BS: "Bahamas",
  BH: "Bahreïn",
  BD: "Bangladesh",
  BB: "Barbade",
  BY: "Biélorussie",
  BE: "Belgique",
  BZ: "Belize",
  BJ: "Bénin",
  BM: "Bermudes",
  BT: "Bhoutan",
  BO: "Bolivie",
  BA: "Bosnie-Herzégovine",
  BW: "Botswana",
  BV: "Île Bouvet",
  BR: "Brésil",
  IO: "Océan Indien Britannique",
  BN: "Brunei Darussalam",
  BG: "Bulgarie",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodge",
  CM: "Cameroun",
  CA: "Canada",
  CV: "Cap-Vert",
  KY: "Îles Caïmans",
  CF: "République Centrafricaine",
  TD: "Tchad",
  CL: "Chili",
  CN: "Chine",
  CX: "Île Christmas",
  CC: "Îles Cocos",
  CO: "Colombie",
  KM: "Comores",
  CG: "République du Congo",
  CD: "République démocratique du Congo",
  CK: "Îles Cook",
  CR: "Costa Rica",
  CI: "Côte-d'Ivoire",
  HR: "Croatie",
  CU: "Cuba",
  CY: "Chypre",
  CZ: "République Tchèque",
  DK: "Danemark",
  DJ: "Djibouti",
  DM: "Dominique",
  DO: "République Dominicaine",
  EC: "Équateur",
  EG: "Égypte",
  SV: "El Salvador",
  GQ: "Guinée équatoriale",
  ER: "Érythrée",
  EE: "Estonie",
  ET: "Éthiopie",
  FK: "Îles Malouines",
  FO: "Îles Féroé",
  FJ: "Fidji",
  FI: "Finlande",
  FR: "France",
  GF: "Guyane française",
  PF: "Polynésie française",
  TF: "Terres australes françaises",
  GA: "Gabon",
  GM: "Gambie",
  GE: "Géorgie",
  DE: "Allemagne",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grèce",
  GL: "Groenland",
  GD: "Grenade",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinée",
  GW: "Guinée-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Îles Heard-et-MacDonald",
  VA: "Saint-Siège (Vatican)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hongrie",
  IS: "Islande",
  IN: "Inde",
  ID: "Indonésie",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlande",
  IL: "Israël",
  IT: "Italie",
  JM: "Jamaïque",
  JP: "Japon",
  JO: "Jordanie",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Corée du Nord",
  KR: "Corée du Sud",
  KW: "Koweït",
  KG: "Kirghizistan",
  LA: "Laos",
  LV: "Lettonie",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Libéria",
  LY: "Libye",
  LI: "Liechtenstein",
  LT: "Lituanie",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macédoine du Nord",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaisie",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malte",
  MH: "Îles Marshall",
  MQ: "Martinique",
  MR: "Mauritanie",
  MU: "Maurice",
  YT: "Mayotte",
  MX: "Mexique",
  FM: "Micronésie",
  MD: "Moldavie",
  MC: "Monaco",
  MN: "Mongolie",
  MS: "Montserrat",
  MA: "Maroc",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibie",
  NR: "Nauru",
  NP: "Népal",
  NL: "Pays-Bas",
  NC: "Nouvelle-Calédonie",
  NZ: "Nouvelle-Zélande",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigéria",
  NU: "Niué",
  NF: "Île Norfolk",
  MP: "Îles Mariannes du Nord",
  NO: "Norvège",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palaos",
  PS: "Palestine",
  PA: "Panama",
  PG: "Papouasie-Nouvelle-Guinée",
  PY: "Paraguay",
  PE: "Pérou",
  PH: "Philippines",
  PN: "Îles Pitcairn",
  PL: "Pologne",
  PT: "Portugal",
  PR: "Porto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roumanie",
  RU: "Russie",
  RW: "Rwanda",
  SH: "Sainte-Hélène",
  KN: "Saint-Christophe-et-Niévès",
  LC: "Sainte-Lucie",
  PM: "Saint-Pierre-et-Miquelon",
  VC: "Saint-Vincent-et-les-Grenadines",
  WS: "Samoa",
  SM: "Saint-Marin",
  ST: "São Tomé-et-Principe",
  SA: "Arabie Saoudite",
  SN: "Sénégal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapour",
  SK: "Slovaquie",
  SI: "Slovénie",
  SB: "Îles Salomon",
  SO: "Somalie",
  ZA: "Afrique du Sud",
  GS: "Géorgie du Sud-et-les Îles Sandwich du Sud",
  ES: "Espagne",
  LK: "Sri Lanka",
  SD: "Soudan",
  SR: "Suriname",
  SJ: "Svalbard et Île Jan Mayen",
  SZ: "Royaume d'Eswatini",
  SE: "Suède",
  CH: "Suisse",
  SY: "Syrie",
  TW: "Taïwan",
  TJ: "Tadjikistan",
  TZ: "République unie de Tanzanie",
  TH: "Thaïlande",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinité-et-Tobago",
  TN: "Tunisie",
  TR: "Turquie",
  TM: "Turkménistan",
  TC: "Îles Turques-et-Caïques",
  TV: "Tuvalu",
  UG: "Ouganda",
  UA: "Ukraine",
  AE: "Émirats Arabes Unis",
  GB: "Royaume-Uni",
  US: "États-Unis d'Amérique",
  UM: "Îles mineures éloignées des États-Unis",
  UY: "Uruguay",
  UZ: "Ouzbékistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Îles vierges britanniques",
  VI: "Îles vierges américaines",
  WF: "Wallis-et-Futuna",
  EH: "Sahara occidental",
  YE: "Yémen",
  ZM: "Zambie",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Bonaire, Saint-Eustache et Saba",
  CW: "Curaçao",
  GG: "Guernesey",
  IM: "Île de Man",
  JE: "Jersey",
  ME: "Monténégro",
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin (partie française)",
  RS: "Serbie",
  SX: "Saint-Martin (partie néerlandaise)",
  SS: "Soudan du Sud",
  XK: "Kosovo"
}, qN = {
  locale: W5,
  countries: Y5
}, JN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Y5,
  default: qN,
  locale: W5
}, Symbol.toStringTag, { value: "Module" })), Z5 = "hi", q5 = {
  AD: "अंडोरा",
  AE: "संयुक्त अरब अमीरात",
  AF: "अफगानिस्तान",
  AG: "एंटीगुआ और बारबूडा",
  AI: "अंग्विला",
  AL: "अल्बानिया",
  AM: "अर्मेनिया",
  AO: "अंगोला",
  AQ: "अंटार्टिका",
  AR: "अर्जेंटिना",
  AS: "अमेरिकान सामोआ",
  AT: "आस्ट्रिया",
  AU: "आस्ट्रेलिया",
  AW: "अरुबा",
  AX: "ऑलैण्ड द्वीपसमूह",
  AZ: "अजरबेजान",
  BA: "बोस्निया हर्जेगोविना",
  BB: "बार्बाडोस",
  BD: "बांग्लादेश",
  BE: "बेल्जियम",
  BF: "बुर्किना फासो",
  BG: "बल्गारिया",
  BH: "बहरीन",
  BI: "बुरुंडी",
  BJ: "बानिन",
  BL: "सेंट_बार्थेलेमी",
  BM: "बर्मूडा",
  BN: "ब्रुनेई",
  BO: "बोलिविया",
  BQ: "कैरिबियन नीदरलैंड",
  BR: "ब्राजील",
  BS: "बहामास",
  BT: "भूटान",
  BV: "बाउवेट",
  BW: "बोत्सवाना",
  BY: "बेलारुस",
  BZ: "बेलिजे",
  CA: "कनाडा",
  CC: "कोकोस (कीलिंग) द्वीप",
  CD: "कांगो लोकतान्त्रिक गणराज्य",
  CF: "सेंट्रल अफ्रीका गणतंत्र",
  CG: "कांगो",
  CH: "स्विट्जरलैंड",
  CI: "आइवरी कोस्ट",
  CK: "कुक द्वीप",
  CL: "चिली",
  CM: "कैमरून",
  CN: "चीन",
  CO: "कोलंबिया",
  CR: "कोस्टा रिका",
  CU: "क्यूबा",
  CV: "केप वर्दे",
  CW: "कुराकाओ",
  CX: "क्रिसमस द्वीप",
  CY: "साइप्रस",
  CZ: "चेक",
  DE: "जर्मनी",
  DJ: "जिबॉती",
  DK: "डैनमार्क",
  DM: "डोमिनिक",
  DO: "डोमिनिक गणतंत्र",
  DZ: "अल्जीरिया",
  EC: "इक्वाडोर",
  EE: "एस्तोनिया",
  EG: "मिस्र",
  EH: "पश्चिमी सहारा",
  ER: "एरिट्रेया",
  ES: "स्पेन",
  ET: "इथियोपिया",
  FI: "फिनलैंड",
  FJ: "फिजी",
  FK: "फाकलैंड द्वीप समूह (मालविनास)",
  FM: "माइक्रोनेशिया",
  FO: "फराओ द्वीप समूह",
  FR: "फ्रांस",
  GA: "गैबोन",
  GB: "ग्रेट ब्रिटेन",
  GD: "ग्रेनेडा",
  GE: "जॉर्जिया",
  GF: "फ्रेंच गुआना",
  GG: "ग्वेर्नसे",
  GH: "घाना",
  GI: "जिब्राल्टर",
  GL: "ग्रीनलैंड",
  GM: "गाम्बिया",
  GN: "गिनी",
  GP: "ग्वाडेलोप",
  GQ: "एक्वेटोरियल गिनी",
  GR: "यूनान",
  GS: "दक्षिण जॉर्जिया और दक्षिण सैंडविच द्वीप समूह",
  GT: "ग्वाटेमाला",
  GU: "ग्वाम",
  GW: "गिनी-बिसाउ",
  GY: "गुआना",
  HK: "हांग कांग",
  HM: "हर्ड एंड मैकडोनाल्ड द्वीपसमूह",
  HN: "होंडुरास",
  HR: "क्रोएशिया",
  HT: "हैती",
  HU: "हंगरी",
  ID: "इंडोनेशिया",
  IE: "आयरलैंड",
  IL: "इजराइल",
  IM: "आइसल ऑफ मैन",
  IN: "भारत",
  IO: "ब्रितानी हिंद महासागरीय क्षेत्र",
  IQ: "इराक",
  IR: "ईरान",
  IS: "आइसलैंड",
  IT: "इटली",
  JE: "जर्सी",
  JM: "जमैका",
  JO: "जॉर्डन",
  JP: "जापान",
  KE: "केन्या",
  KG: "किर्जिस्तान",
  KH: "कंबोडिया",
  KI: "किरिबिती",
  KM: "कोमोरोस",
  KN: "सेंट किट्स एंड नेविस",
  KP: "उत्तर कोरिया",
  KR: "दक्षिण कोरिया",
  KW: "कुवैत",
  KY: "केमैन आइसलैंड्स",
  KZ: "कज़ाखिस्तान",
  LA: "लाओस",
  LB: "लेबनान",
  LC: "सेंट लुसिया",
  LI: "लिक्टेनिस्टीन",
  LK: "श्री लंका",
  LR: "लाइबेरिया",
  LS: "लेसोथो",
  LT: "लिथुआनिया",
  LU: "लक्जमबर्ग",
  LV: "लात्विया",
  LY: "लीबिया",
  MA: "मोरक्को",
  MC: "मोनाको",
  MD: "मोलदोवा",
  ME: "मोंटेनेग्रो",
  MF: "सेंट मार्टिन की सामूहिकता",
  MG: "मैडागास्कर",
  MH: "मार्शल द्वीपसमूह",
  MK: "मकदूनिया",
  ML: "माली",
  MM: "म्यामांर (बर्मा)",
  MN: "मंगोलिया",
  MO: "मकाओ",
  MP: "उत्तर मैरिना द्वीपसमूह",
  MQ: "मार्टिनिक",
  MR: "मॉरितानिया",
  MS: "मोंटसेराट",
  MT: "माल्टा",
  MU: "मारीशस",
  MV: "मालदीव",
  MW: "मालावी",
  MX: "मेक्सिको",
  MY: "मलयेशिया",
  MZ: "मोजांबिक",
  NA: "नामीबिया",
  NC: "न्यू कैलेडोनिया",
  NE: "नाइजर",
  NF: "नोरफॉक द्वीप",
  NG: "नाइजीरिया",
  NI: "निकारागुआ",
  NL: "नीदरलैंड्स",
  NO: "नॉर्वे",
  NP: "नेपाल",
  NR: "नाउरू",
  NU: "नियू",
  NZ: "न्यूजीलैंड",
  OM: "ओमान",
  PA: "पनामा",
  PE: "पेरू",
  PF: "फ्रैंच गुआना",
  PG: "पापुआ न्यू गिनी",
  PH: "फिलीपींस",
  PK: "पाकिस्तान",
  PL: "पोलैंड",
  PM: "सेंट पिएरे एंड मिक्वेलॉन",
  PN: "पिटकैर्न द्वीपसमूह",
  PR: "पुएर्तो रिको",
  PS: "फिलिस्तीन राज्य",
  PT: "पुर्तगाल",
  PW: "पलाउ",
  PY: "पराग्वे",
  QA: "क़तार",
  RE: "रीयूनियन",
  RO: "रोमानिया",
  RS: "सर्बिया",
  RU: "रूस",
  RW: "रवांडा",
  SA: "सऊदी अरब",
  SB: "सोलोमन द्वीपसमूह",
  SC: "सेशेल्स",
  SD: "सूडान",
  SE: "स्वीडन",
  SG: "सिंगापुर",
  SH: "सेंट हेलेना",
  SI: "स्लोवानिया",
  SJ: "स्यालबार्ड (स्यालबार्ड एंड जन मावेम)",
  SK: "स्लोवाकिया",
  SL: "सियारा लिओन",
  SM: "सैन मारिनो",
  SN: "सेनेगल",
  SO: "सोमालिया",
  SR: "सूरीनाम",
  SS: "दक्षिण सूडान",
  ST: "साओ टॉम एंड प्रिंसिपी",
  SV: "सल्वाडोर",
  SX: "सिण्ट मार्टेन",
  SY: "सीरिया",
  SZ: "स्वाजीलैंड",
  TC: "तुर्क एंड कैकोस द्वीपसमूह",
  TD: "चाड",
  TF: "फ्रांसीसी दक्षिणी क्षेत्र",
  TG: "टोगो",
  TH: "थाईलैंड",
  TJ: "तज़ाकिस्तान",
  TK: "टोकेलू",
  TL: "पूर्वी तिमोर",
  TM: "तुर्कमेनिस्तान",
  TN: "ट्यूनीशिया",
  TO: "टोंगा",
  TR: "तुर्की",
  TT: "ट्रिनिडाड एंड टोबैगो",
  TV: "तुवालू",
  TW: "ताइवान",
  TZ: "तंजानिया",
  UA: "उक्रेन",
  UG: "उगांडा",
  UM: "यूएस माइनर आउटलाइंग द्वीपसमूह",
  US: "यूएसए (संयुक्त राज्य अमेरिका)",
  UY: "उरुग्वे",
  UZ: "उजबेकिस्तान",
  VA: "वेटिकन",
  VC: "सेंट विंसेंट एंड द ग्रेनेंडाइन्स",
  VE: "वेनेजुएला",
  VG: "ब्रितानी वर्जिन द्वीपसमूह",
  VI: "अमेरिकी वर्जिन द्वीपसमूह",
  VN: "विएतनाम",
  VU: "वनातू",
  WF: "वालीज एंड फुटुना",
  WS: "पश्चिमी सामोआ",
  XK: "कोसोवो",
  YE: "यमन",
  YT: "मायोते",
  ZA: "दक्षिण अफ्रीका",
  ZM: "जाम्बिया",
  ZW: "जिंबावे"
}, XN = {
  locale: Z5,
  countries: q5
}, QN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: q5,
  default: XN,
  locale: Z5
}, Symbol.toStringTag, { value: "Module" })), J5 = "hu", X5 = {
  AF: "Afganisztán",
  AL: "Albánia",
  DZ: "Algéria",
  AS: "Amerikai Szamoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktisz",
  AG: "Antigua és Barbuda",
  AR: "Argentína",
  AM: "Örményország",
  AW: "Aruba",
  AU: "Ausztrália",
  AT: "Ausztria",
  AZ: "Azerbajdzsán",
  BS: "Bahama-szigetek",
  BH: "Bahrein",
  BD: "Banglades",
  BB: "Barbados",
  BY: "Fehéroroszország",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhután",
  BO: "Bolívia",
  BA: "Bosznia-Hercegovina",
  BW: "Botswana",
  BV: "Bouvet-sziget",
  BR: "Brazília",
  IO: "Brit Indiai-óceáni Terület",
  BN: "Brunei",
  BG: "Bulgária",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodzsa",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Zöld-foki Köztársaság",
  KY: "Kajmán-szigetek",
  CF: "Közép-afrikai Köztársaság",
  TD: "Csád",
  CL: "Chile",
  CN: "Kína",
  CX: "Karácsony-sziget",
  CC: "Kókusz (Keeling)-szigetek",
  CO: "Kolumbia",
  KM: "Comore-szigetek",
  CG: "Kongói Köztársaság",
  CD: "Kongói Demokratikus Köztársaság",
  CK: "Cook-szigetek",
  CR: "Costa Rica",
  CI: "Elefántcsontpart",
  HR: "Horvátország",
  CU: "Kuba",
  CY: "Ciprus",
  CZ: "Csehország",
  DK: "Dánia",
  DJ: "Dzsibuti",
  DM: "Dominikai Közösség",
  DO: "Dominikai Köztársaság",
  EC: "Ecuador",
  EG: "Egyiptom",
  SV: "Salvador",
  GQ: "Egyenlítői-Guinea",
  ER: "Eritrea",
  EE: "Észtország",
  ET: "Etiópia",
  FK: "Falkland-szigetek",
  FO: "Feröer",
  FJ: "Fidzsi-szigetek",
  FI: "Finnország",
  FR: "Franciaország",
  GF: "Francia Guyana",
  PF: "Francia Polinézia",
  TF: "Francia déli területek",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Grúzia",
  DE: "Németország",
  GH: "Ghána",
  GI: "Gibraltár",
  GR: "Görögország",
  GL: "Grönland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Bissau-Guinea",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard-sziget és McDonald-szigetek",
  VA: "Vatikán",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Magyarország",
  IS: "Izland",
  IN: "India",
  ID: "Indonézia",
  IR: "Irán",
  IQ: "Irak",
  IE: "Írország",
  IL: "Izrael",
  IT: "Olaszország",
  JM: "Jamaica",
  JP: "Japán",
  JO: "Jordánia",
  KZ: "Kazahsztán",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Észak-Korea",
  KR: "Dél-Korea",
  KW: "Kuvait",
  KG: "Kirgizisztán",
  LA: "Laosz",
  LV: "Lettország",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Libéria",
  LY: "Líbia",
  LI: "Liechtenstein",
  LT: "Litvánia",
  LU: "Luxemburg",
  MO: "Makao",
  MK: "Észak-Macedónia",
  MG: "Madagaszkár",
  MW: "Malawi",
  MY: "Malajzia",
  MV: "Maldív-szigetek",
  ML: "Mali",
  MT: "Málta",
  MH: "Marshall-szigetek",
  MQ: "Martinique",
  MR: "Mauritánia",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexikó",
  FM: "Mikronéziai Szövetségi Államok",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongólia",
  MS: "Montserrat",
  MA: "Marokkó",
  MZ: "Mozambik",
  MM: "Mianmar",
  NA: "Namíbia",
  NR: "Nauru",
  NP: "Nepál",
  NL: "Hollandia",
  NC: "Új-Kaledónia",
  NZ: "Új-Zéland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigéria",
  NU: "Niue",
  NF: "Norfolk-sziget",
  MP: "Északi-Mariana-szigetek",
  NO: "Norvégia",
  OM: "Omán",
  PK: "Pakisztán",
  PW: "Palau",
  PS: "Palesztina",
  PA: "Panama",
  PG: "Pápua Új-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Fülöp-szigetek",
  PN: "Pitcairn-szigetek",
  PL: "Lengyelország",
  PT: "Portugália",
  PR: "Puerto Rico",
  QA: "Katar",
  RE: "Réunion",
  RO: "Románia",
  RU: "Oroszország",
  RW: "Ruanda",
  SH: "Saint Helena",
  KN: "Saint Kitts és Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent és a Grenadine-szigetek",
  WS: "Szamoa",
  SM: "San Marino",
  ST: "São Tomé és Príncipe",
  SA: "Szaudi-Arábia",
  SN: "Szenegál",
  SC: "Seychelle-szigetek",
  SL: "Sierra Leone",
  SG: "Szingapúr",
  SK: "Szlovákia",
  SI: "Szlovénia",
  SB: "Salamon-szigetek",
  SO: "Szomália",
  ZA: "Dél-Afrika",
  GS: "Déli-Georgia és Déli-Sandwich-szigetek",
  ES: "Spanyolország",
  LK: "Sri Lanka",
  SD: "Szudán",
  SR: "Suriname",
  SJ: "Spitzbergák és Jan Mayen",
  SZ: "Szváziföld",
  SE: "Svédország",
  CH: "Svájc",
  SY: "Szíria",
  TW: "Tajvan",
  TJ: "Tádzsikisztán",
  TZ: "Tanzánia",
  TH: "Thaiföld",
  TL: "Kelet-Timor",
  TG: "Togo",
  TK: "Tokelau-szigetek",
  TO: "Tonga",
  TT: "Trinidad és Tobago",
  TN: "Tunézia",
  TR: "Törökország",
  TM: "Türkmenisztán",
  TC: "Turks- és Caicos-szigetek",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukrajna",
  AE: "Egyesült Arab Emírségek",
  GB: "Egyesült Királyság",
  US: "Amerikai Egyesült Államok",
  UM: "Az Amerikai Egyesült Államok lakatlan külbirtokai",
  UY: "Uruguay",
  UZ: "Üzbegisztán",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Brit Virgin-szigetek",
  VI: "Amerikai Virgin-szigetek",
  WF: "Wallis és Futuna",
  EH: "Nyugat-Szahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Karibi Hollandia",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Man-sziget",
  JE: "Jersey",
  ME: "Montenegró",
  BL: "Saint Barthélemy",
  MF: "Szent Márton-sziget (francia rész)",
  RS: "Szerbia",
  SX: "Szent Márton-sziget (holland rész)",
  SS: "Dél-Szudán",
  XK: "Koszovó"
}, eL = {
  locale: J5,
  countries: X5
}, tL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: X5,
  default: eL,
  locale: J5
}, Symbol.toStringTag, { value: "Module" })), Q5 = "id", e4 = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "Samoa Amerika",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua dan Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahama",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarusia",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia dan Herzegovina",
  BW: "Botswana",
  BV: "Kepulauan Bouvet",
  BR: "Brasil",
  IO: "Teritori Samudra Hindia Britania",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kamboja",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Tanjung Verde",
  KY: "Kepulauan Cayman",
  CF: "Afrika Tengah",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Pulau Natal",
  CC: "Kepulauan Cocos (Keeling)",
  CO: "Kolombia",
  KM: "Komoro",
  CG: "Kongo",
  CD: "Republik Demokratik Kongo",
  CK: "Kepulauan Cook",
  CR: "Kosta Rika",
  CI: "Pantai Gading",
  HR: "Kroasia",
  CU: "Kuba",
  CY: "Siprus",
  CZ: "Republik Ceko",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominika",
  DO: "Republik Dominika",
  EC: "Ekuador",
  EG: "Mesir",
  SV: "El Salvador",
  GQ: "Guinea Khatulistiwa",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Kepulauan Falkland(Malvinas)",
  FO: "Kepulauan Faroe",
  FJ: "Fiji",
  FI: "Finlandia",
  FR: "Perancis",
  GF: "Guyana Perancis",
  PF: "Polinesia Perancis",
  TF: "Antartika Perancis",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Jerman",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Yunani",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatamala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Pulau Heard dan Kepulauan McDonald",
  VA: "Vatikan",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungaria",
  IS: "Islandia",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlandia",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaika",
  JP: "Jepang",
  JO: "Yordania",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea Utara",
  KR: "Korea Selatan",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxemburg",
  MO: "Makau",
  MK: "Makedonia Utara",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Kepulauan Marshall",
  MQ: "Martinik",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Meksiko",
  FM: "Federasi Mikronesia",
  MD: "Moldova",
  MC: "Monako",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Moroko",
  MZ: "Mozambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Belanda",
  NC: "Kaledonia Baru",
  NZ: "Selandia Baru",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Kepulauan Norfolk",
  MP: "Kepulauan Mariana Utara",
  NO: "Norwegia",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papua Nugini",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipina",
  PN: "Pitcairn",
  PL: "Polandia",
  PT: "Portugal",
  PR: "Puerto Riko",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Rumania",
  RU: "Rusia",
  RW: "Rwanda",
  SH: "Saint Helena",
  KN: "Saint Kitts dan Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre dan Miquelon",
  VC: "Saint Vincent dan the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome dan Principe",
  SA: "Arab Saudi",
  SN: "Senegal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapura",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Kepulauan Solomon",
  SO: "Somalia",
  ZA: "Afrika Selatan",
  GS: "Georgia Selatan dan Kepulauan Sandwich Selatan",
  ES: "Spanyol",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard dan Jan Mayen",
  SZ: "Eswatini",
  SE: "Sweden",
  CH: "Swiss",
  SY: "Suriah",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad dan Tobago",
  TN: "Tunisia",
  TR: "Turki",
  TM: "Turkmenistan",
  TC: "Turks dan Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Uni Emirat Arab",
  GB: "Britania Raya",
  US: "Amerika Serikat",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Sahara Barat",
  YE: "Yaman",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland Islands",
  BQ: "Bonaire, Sint Eustatius and Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isle of Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: "Saint Martin (French part)",
  RS: "Serbia",
  SX: "Sint Maarten (Dutch part)",
  SS: "Sudan Selatan",
  XK: "Kosovo"
}, rL = {
  locale: Q5,
  countries: e4
}, nL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: e4,
  default: rL,
  locale: Q5
}, Symbol.toStringTag, { value: "Module" })), t4 = "it", r4 = {
  AD: "Andorra",
  AE: "Emirati Arabi Uniti",
  AF: "Afghanistan",
  AG: "Antigua e Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antartide",
  AR: "Argentina",
  AS: "Samoa Americane",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Isole Åland",
  AZ: "Azerbaigian",
  BA: "Bosnia ed Erzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgio",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint-Barthélemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Isole BES",
  BR: "Brasile",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Isola Bouvet",
  BW: "Botswana",
  BY: "Bielorussia",
  BZ: "Belize",
  CA: "Canada",
  CC: "Isole Cocos e Keeling",
  CD: "Repubblica Democratica del Congo",
  CF: "Repubblica Centrafricana",
  CG: "Repubblica del Congo",
  CH: "Svizzera",
  CI: "Costa d'Avorio",
  CK: "Isole Cook",
  CL: "Cile",
  CM: "Camerun",
  CN: "Cina",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Capo Verde",
  CW: "Curaçao",
  CX: "Isola del Natale",
  CY: "Cipro",
  CZ: "Repubblica Ceca",
  DE: "Germania",
  DJ: "Gibuti",
  DK: "Danimarca",
  DM: "Dominica",
  DO: "Repubblica Dominicana",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egitto",
  EH: "Sahara Occidentale",
  ER: "Eritrea",
  ES: "Spagna",
  ET: "Etiopia",
  FI: "Finlandia",
  FJ: "Figi",
  FK: "Isole Falkland",
  FM: "Stati Federati di Micronesia",
  FO: "Isole Fær Øer",
  FR: "Francia",
  GA: "Gabon",
  GB: "Regno Unito",
  GD: "Grenada",
  GE: "Georgia",
  GF: "Guyana Francese",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibilterra",
  GL: "Groenlandia",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadalupa",
  GQ: "Guinea Equatoriale",
  GR: "Grecia",
  GS: "Georgia del Sud e isole Sandwich meridionali",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Isole Heard e McDonald",
  HN: "Honduras",
  HR: "Croazia",
  HT: "Haiti",
  HU: "Ungheria",
  ID: "Indonesia",
  IE: "Irlanda",
  IL: "Israele",
  IM: "Isola di Man",
  IN: "India",
  IO: "Territori Britannici dell'Oceano Indiano",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Islanda",
  IT: "Italia",
  JE: "Jersey",
  JM: "Giamaica",
  JO: "Giordania",
  JP: "Giappone",
  KE: "Kenya",
  KG: "Kirghizistan",
  KH: "Cambogia",
  KI: "Kiribati",
  KM: "Comore",
  KN: "Saint Kitts e Nevis",
  KP: "Corea del Nord",
  KR: "Corea del Sud",
  KW: "Kuwait",
  KY: "Isole Cayman",
  KZ: "Kazakistan",
  LA: "Laos",
  LB: "Libano",
  LC: "Santa Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lituania",
  LU: "Lussemburgo",
  LV: "Lettonia",
  LY: "Libia",
  MA: "Marocco",
  MC: "Monaco",
  MD: "Moldavia",
  ME: "Montenegro",
  MF: "Saint-Martin",
  MG: "Madagascar",
  MH: "Isole Marshall",
  MK: "Macedonia del Nord",
  ML: "Mali",
  MM: "Birmania  Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Isole Marianne Settentrionali",
  MQ: "Martinica",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldive",
  MW: "Malawi",
  MX: "Messico",
  MY: "Malesia",
  MZ: "Mozambico",
  NA: "Namibia",
  NC: "Nuova Caledonia",
  NE: "Niger",
  NF: "Isola Norfolk",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Paesi Bassi",
  NO: "Norvegia",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nuova Zelanda",
  OM: "Oman",
  PA: "Panamá",
  PE: "Perù",
  PF: "Polinesia Francese",
  PG: "Papua Nuova Guinea",
  PH: "Filippine",
  PK: "Pakistan",
  PL: "Polonia",
  PM: "Saint Pierre e Miquelon",
  PN: "Isole Pitcairn",
  PR: "Porto Rico",
  PS: "Stato di Palestina",
  PT: "Portogallo",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Ruanda",
  SA: "Arabia Saudita",
  SB: "Isole Salomone",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Svezia",
  SG: "Singapore",
  SH: "Sant'Elena, Isola di Ascensione e Tristan da Cunha",
  SI: "Slovenia",
  SJ: "Svalbard e Jan Mayen",
  SK: "Slovacchia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "Sudan del Sud",
  ST: "São Tomé e Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Siria",
  SZ: "Eswatini",
  TC: "Isole Turks e Caicos",
  TD: "Ciad",
  TF: "Territori Francesi del Sud",
  TG: "Togo",
  TH: "Thailandia",
  TJ: "Tagikistan",
  TK: "Tokelau",
  TL: "Timor Est",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turchia",
  TT: "Trinidad e Tobago",
  TV: "Tuvalu",
  TW: [
    "Repubblica di Cina",
    "Taiwan"
  ],
  TZ: "Tanzania",
  UA: "Ucraina",
  UG: "Uganda",
  UM: "Isole minori esterne degli Stati Uniti",
  US: "Stati Uniti d'America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Città del Vaticano",
  VC: "Saint Vincent e Grenadine",
  VE: "Venezuela",
  VG: "Isole Vergini Britanniche",
  VI: "Isole Vergini Americane",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis e Futuna",
  WS: "Samoa",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "Sudafrica",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  XK: "Kosovo"
}, aL = {
  locale: t4,
  countries: r4
}, oL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: r4,
  default: aL,
  locale: t4
}, Symbol.toStringTag, { value: "Module" })), n4 = "ja", a4 = {
  AF: "アフガニスタン",
  AL: "アルバニア",
  DZ: "アルジェリア",
  AS: "アメリカ領サモア",
  AD: "アンドラ",
  AO: "アンゴラ",
  AI: "アンギラ",
  AQ: "南極",
  AG: "アンティグア・バーブーダ",
  AR: "アルゼンチン",
  AM: "アルメニア",
  AW: "アルバ",
  AU: "オーストラリア",
  AT: "オーストリア",
  AZ: "アゼルバイジャン",
  BS: "バハマ",
  BH: "バーレーン",
  BD: "バングラデシュ",
  BB: "バルバドス",
  BY: "ベラルーシ",
  BE: "ベルギー",
  BZ: "ベリーズ",
  BJ: "ベナン",
  BM: "バミューダ",
  BT: "ブータン",
  BO: "ボリビア多民族国",
  BA: "ボスニア・ヘルツェゴビナ",
  BW: "ボツワナ",
  BV: "ブーベ島",
  BR: "ブラジル",
  IO: "イギリス領インド洋地域",
  BN: "ブルネイ・ダルサラーム",
  BG: "ブルガリア",
  BF: "ブルキナファソ",
  BI: "ブルンジ",
  KH: "カンボジア",
  CM: "カメルーン",
  CA: "カナダ",
  CV: "カーボベルデ",
  KY: "ケイマン諸島",
  CF: "中央アフリカ共和国",
  TD: "チャド",
  CL: "チリ",
  CN: "中華人民共和国",
  CX: "クリスマス島",
  CC: "ココス（キーリング）諸島",
  CO: "コロンビア",
  KM: "コモロ",
  CG: "コンゴ共和国",
  CD: "コンゴ民主共和国",
  CK: "クック諸島",
  CR: "コスタリカ",
  CI: "コートジボワール",
  HR: "クロアチア",
  CU: "キューバ",
  CY: "キプロス",
  CZ: "チェコ",
  DK: "デンマーク",
  DJ: "ジブチ",
  DM: "ドミニカ国",
  DO: "ドミニカ共和国",
  EC: "エクアドル",
  EG: "エジプト",
  SV: "エルサルバドル",
  GQ: "赤道ギニア",
  ER: "エリトリア",
  EE: "エストニア",
  ET: "エチオピア",
  FK: "フォークランド（マルビナス）諸島",
  FO: "フェロー諸島",
  FJ: "フィジー",
  FI: "フィンランド",
  FR: "フランス",
  GF: "フランス領ギアナ",
  PF: "フランス領ポリネシア",
  TF: "フランス領南方・南極地域",
  GA: "ガボン",
  GM: "ガンビア",
  GE: "ジョージア",
  DE: "ドイツ",
  GH: "ガーナ",
  GI: "ジブラルタル",
  GR: "ギリシャ",
  GL: "グリーンランド",
  GD: "グレナダ",
  GP: "グアドループ",
  GU: "グアム",
  GT: "グアテマラ",
  GN: "ギニア",
  GW: "ギニアビサウ",
  GY: "ガイアナ",
  HT: "ハイチ",
  HM: "ハード島とマクドナルド諸島",
  VA: "バチカン市国",
  HN: "ホンジュラス",
  HK: "香港",
  HU: "ハンガリー",
  IS: "アイスランド",
  IN: "インド",
  ID: "インドネシア",
  IR: "イラン・イスラム共和国",
  IQ: "イラク",
  IE: "アイルランド",
  IL: "イスラエル",
  IT: "イタリア",
  JM: "ジャマイカ",
  JP: "日本",
  JO: "ヨルダン",
  KZ: "カザフスタン",
  KE: "ケニア",
  KI: "キリバス",
  KP: "朝鮮民主主義人民共和国",
  KR: "大韓民国",
  KW: "クウェート",
  KG: "キルギス",
  LA: "ラオス人民民主共和国",
  LV: "ラトビア",
  LB: "レバノン",
  LS: "レソト",
  LR: "リベリア",
  LY: "リビア",
  LI: "リヒテンシュタイン",
  LT: "リトアニア",
  LU: "ルクセンブルク",
  MO: "マカオ",
  MG: "マダガスカル",
  MW: "マラウイ",
  MY: "マレーシア",
  MV: "モルディブ",
  ML: "マリ",
  MT: "マルタ",
  MH: "マーシャル諸島",
  MQ: "マルティニーク",
  MR: "モーリタニア",
  MU: "モーリシャス",
  YT: "マヨット",
  MX: "メキシコ",
  FM: "ミクロネシア連邦",
  MD: "モルドバ共和国",
  MC: "モナコ",
  MN: "モンゴル",
  MS: "モントセラト",
  MA: "モロッコ",
  MZ: "モザンビーク",
  MM: "ミャンマー",
  NA: "ナミビア",
  NR: "ナウル",
  NP: "ネパール",
  NL: "オランダ",
  NC: "ニューカレドニア",
  NZ: "ニュージーランド",
  NI: "ニカラグア",
  NE: "ニジェール",
  NG: "ナイジェリア",
  NU: "ニウエ",
  NF: "ノーフォーク島",
  MK: "北マケドニア",
  MP: "北マリアナ諸島",
  NO: "ノルウェー",
  OM: "オマーン",
  PK: "パキスタン",
  PW: "パラオ",
  PS: "パレスチナ",
  PA: "パナマ",
  PG: "パプアニューギニア",
  PY: "パラグアイ",
  PE: "ペルー",
  PH: "フィリピン",
  PN: "ピトケアン",
  PL: "ポーランド",
  PT: "ポルトガル",
  PR: "プエルトリコ",
  QA: "カタール",
  RE: "レユニオン",
  RO: "ルーマニア",
  RU: "ロシア連邦",
  RW: "ルワンダ",
  SH: "セントヘレナ・アセンションおよびトリスタンダクーニャ",
  KN: "セントクリストファー・ネイビス",
  LC: "セントルシア",
  PM: "サンピエール島・ミクロン島",
  VC: "セントビンセントおよびグレナディーン諸島",
  WS: "サモア",
  SM: "サンマリノ",
  ST: "サントメ・プリンシペ",
  SA: "サウジアラビア",
  SN: "セネガル",
  SC: "セーシェル",
  SL: "シエラレオネ",
  SG: "シンガポール",
  SK: "スロバキア",
  SI: "スロベニア",
  SB: "ソロモン諸島",
  SO: "ソマリア",
  ZA: "南アフリカ",
  GS: "サウスジョージア・サウスサンドウィッチ諸島",
  ES: "スペイン",
  LK: "スリランカ",
  SD: "スーダン",
  SR: "スリナム",
  SJ: "スヴァールバル諸島およびヤンマイエン島",
  SZ: "スワジランド",
  SE: "スウェーデン",
  CH: "スイス",
  SY: "シリア・アラブ共和国",
  TW: "台湾",
  TJ: "タジキスタン",
  TZ: "タンザニア",
  TH: "タイ",
  TL: "東ティモール",
  TG: "トーゴ",
  TK: "トケラウ",
  TO: "トンガ",
  TT: "トリニダード・トバゴ",
  TN: "チュニジア",
  TR: "トルコ",
  TM: "トルクメニスタン",
  TC: "タークス・カイコス諸島",
  TV: "ツバル",
  UG: "ウガンダ",
  UA: "ウクライナ",
  AE: "アラブ首長国連邦",
  GB: "イギリス",
  US: "アメリカ合衆国",
  UM: "合衆国領有小離島",
  UY: "ウルグアイ",
  UZ: "ウズベキスタン",
  VU: "バヌアツ",
  VE: "ベネズエラ・ボリバル共和国",
  VN: "ベトナム",
  VG: "イギリス領ヴァージン諸島",
  VI: "アメリカ領ヴァージン諸島",
  WF: "ウォリス・フツナ",
  EH: "西サハラ",
  YE: "イエメン",
  ZM: "ザンビア",
  ZW: "ジンバブエ",
  AX: "オーランド諸島",
  BQ: "ボネール、シント・ユースタティウスおよびサバ",
  CW: "キュラソー",
  GG: "ガーンジー",
  IM: "マン島",
  JE: "ジャージー",
  ME: "モンテネグロ",
  BL: "サン・バルテルミー",
  MF: "サン・マルタン（フランス領）",
  RS: "セルビア",
  SX: "シント・マールテン（オランダ領）",
  SS: "南スーダン",
  XK: "コソボ"
}, iL = {
  locale: n4,
  countries: a4
}, sL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: a4,
  default: iL,
  locale: n4
}, Symbol.toStringTag, { value: "Module" })), o4 = "nl", i4 = {
  AF: "Afghanistan",
  AL: "Albanië",
  DZ: "Algerije",
  AS: "Amerikaans-Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua en Barbuda",
  AR: "Argentinië",
  AM: "Armenië",
  AW: "Aruba",
  AU: "Australië",
  AT: "Oostenrijk",
  AZ: "Azerbeidzjan",
  BS: "Bahama's",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Wit-Rusland",
  BE: [
    "België",
    "Koninkrijk België"
  ],
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivië",
  BA: "Bosnië-Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Eiland",
  BR: "Brazilië",
  IO: "Brits Indische oceaan",
  BN: "Brunei Darussalam",
  BG: "Bulgarije",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodja",
  CM: "Kameroen",
  CA: "Canada",
  CV: "Kaapverdië",
  KY: "Kaaimaneilanden",
  CF: "Centraal-Afrikaanse Republiek",
  TD: "Tsjaad",
  CL: "Chili",
  CN: "China",
  CX: "Christmaseiland",
  CC: "Cocoseilanden",
  CO: "Colombia",
  KM: "Comoren",
  CG: "Congo, Volksrepubliek",
  CD: "Congo, Democratische Republiek",
  CK: "Cookeilanden",
  CR: "Costa Rica",
  CI: "Ivoorkust",
  HR: "Kroatië",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Tsjechië",
  DK: "Denemarken",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominicaanse Republiek",
  EC: "Ecuador",
  EG: "Egypte",
  SV: "El Salvador",
  GQ: "Equatoriaal-Guinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Ethiopië",
  FK: "Falklandeilanden",
  FO: "Faeröer",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrijk",
  GF: "Frans-Guyana",
  PF: "Frans-Polynesië",
  TF: "Franse Zuidelijke Gebieden",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgië",
  DE: "Duitsland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Griekenland",
  GL: "Groenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinee-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Heard en McDonaldeilanden",
  VA: "Heilige Stoel",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hongarije",
  IS: "IJsland",
  IN: "India",
  ID: "Indonesië",
  IR: "Iran",
  IQ: "Irak",
  IE: "Ierland",
  IL: "Israël",
  IT: "Italië",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordanië",
  KZ: "Kazachstan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Noord-Korea",
  KR: "Zuid-Korea",
  KW: "Koeweit",
  KG: "Kirgizstan",
  LA: "Laos",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libië",
  LI: "Liechtenstein",
  LT: "Litouwen",
  LU: "Luxemburg",
  MO: "Macao",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Maleisië",
  MV: [
    "Maldiven",
    "Malediven"
  ],
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalleilanden",
  MQ: "Martinique",
  MR: "Mauritanië",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesië, Federale Staten",
  MD: "Moldavië",
  MC: "Monaco",
  MN: "Mongolië",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibië",
  NR: "Nauru",
  NP: "Nepal",
  NL: [
    "Nederland",
    "Koninkrijk der Nederlanden"
  ],
  NC: "Nieuw-Caledonië",
  NZ: "Nieuw-Zeeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk",
  MP: "Noordelijke Marianen",
  MK: "Noord-Macedonië",
  NO: "Noorwegen",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papoea-Nieuw-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipijnen",
  PN: "Pitcairn",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roemenië",
  RU: "Rusland",
  RW: "Rwanda",
  SH: "Sint-Helena",
  KN: "Saint Kitts en Nevis",
  LC: "Saint Lucia",
  PM: "Saint-Pierre en Miquelon",
  VC: "Saint Vincent en de Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé en Principe",
  SA: "Saudi-Arabië",
  SN: "Senegal",
  SC: "Seychellen",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slowakije",
  SI: "Slovenië",
  SB: "Salomonseilanden",
  SO: "Somalië",
  ZA: "Zuid-Afrika",
  GS: "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
  ES: "Spanje",
  LK: "Sri Lanka",
  SD: "Soedan",
  SR: "Suriname",
  SJ: "Spitsbergen en Jan Mayen",
  SZ: "Ngwane, Koninkrijk Eswatini",
  SE: "Zweden",
  CH: "Zwitserland",
  SY: "Syrië",
  TW: "Taiwan",
  TJ: "Tadzjikistan",
  TZ: [
    "Tanzania",
    "Tanzania, Verenigde Republiek"
  ],
  TH: "Thailand",
  TL: "Timor Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad en Tobago",
  TN: "Tunesië",
  TR: "Turkije",
  TM: "Turkmenistan",
  TC: "Turks- en Caicoseilanden",
  TV: "Tuvalu",
  UG: "Oeganda",
  UA: "Oekraïne",
  AE: "Verenigde Arabische Emiraten",
  GB: [
    "Groot-Brittannië",
    "Verenigd Koninkrijk"
  ],
  US: [
    "Verenigde Staten van Amerika",
    "Verenigde Staten"
  ],
  UM: "Ver afgelegen eilandjes van de Verenigde Staten",
  UY: "Uruguay",
  UZ: "Oezbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Maagdeneilanden, Britse",
  VI: "Maagdeneilanden, Amerikaanse",
  WF: "Wallis en Futuna",
  EH: "Westelijke Sahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Bonaire, Sint Eustatius en Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Man Eiland",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: [
    "Sint-Maarten (Frans deel)",
    "Sint-Maarten (Franse Antillen)",
    "Collectiviteit van Sint-Maarten"
  ],
  RS: "Servië",
  SX: [
    "Sint Maarten",
    "Sint-Maarten",
    "Sint Maarten (Nederlands deel)",
    "Land Sint Maarten"
  ],
  SS: "Zuid-Soedan",
  XK: "Kosovo"
}, lL = {
  locale: o4,
  countries: i4
}, cL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: i4,
  default: lL,
  locale: o4
}, Symbol.toStringTag, { value: "Module" })), s4 = "no", l4 = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algerie",
  AS: "Amerikansk Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua og Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Østerrike",
  AZ: "Aserbajdsjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Hviterussland",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia-Hercegovina",
  BW: "Botswana",
  BV: "Bouvetøya",
  BR: "Brasil",
  IO: "Det britiske territoriet i Indiahavet",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodsja",
  CM: "Kamerun",
  CA: "Canada",
  CV: "Kapp Verde",
  KY: "Caymanøyene",
  CF: "Den sentralafrikanske republikk",
  TD: "Tsjad",
  CL: "Chile",
  CN: "Kina",
  CX: "Christmasøya",
  CC: "Kokosøyene",
  CO: "Colombia",
  KM: "Komorene",
  CG: "Kongo-Brazzaville",
  CD: "Kongo",
  CK: "Cookøyene",
  CR: "Costa Rica",
  CI: "Elfenbenskysten",
  HR: "Kroatia",
  CU: "Cuba",
  CY: "Kypros",
  CZ: "Tsjekkia",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Den dominikanske republikk",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Ekvatorial-Guinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Etiopia",
  FK: "Falklandsøyene",
  FO: "Færøyene",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrike",
  GF: "Fransk Guyana",
  PF: "Fransk Polynesia",
  TF: "De franske sørterritorier",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Hellas",
  GL: "Grønland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard- og McDonaldøyene",
  VA: "Vatikanstaten",
  HN: "Honduras",
  HK: "Hongkong SAR Kina",
  HU: "Ungarn",
  IS: "Island",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irland",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kasakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Nord-Korea",
  KR: "Sør-Korea",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Macao SAR Kina",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldivene",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalløyene",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Mikronesiaføderasjonen",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mosambik",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Nederland",
  NC: "Ny-Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolkøya",
  MK: "Nord-Makedonia",
  MP: "Nord-Marianene",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Det palestinske området",
  PA: "Panama",
  PG: "Papua Ny-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinene",
  PN: "Pitcairnøyene",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RU: "Russland",
  RW: "Rwanda",
  SH: "St. Helena",
  KN: "Saint Kitts og Nevis",
  LC: "St. Lucia",
  PM: "Saint-Pierre-et-Miquelon",
  VC: "St. Vincent og Grenadinene",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé og Príncipe",
  SA: "Saudi-Arabia",
  SN: "Senegal",
  SC: "Seychellene",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Salomonøyene",
  SO: "Somalia",
  ZA: "Sør-Afrika",
  GS: "Sør-Georgia og Sør-Sandwichøyene",
  ES: "Spania",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard og Jan Mayen",
  SZ: "Eswatini",
  SE: "Sverige",
  CH: "Sveits",
  SY: "Syria",
  TW: "Taiwan",
  TJ: "Tadsjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Øst-Timor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad og Tobago",
  TN: "Tunisia",
  TR: "Tyrkia",
  TM: "Turkmenistan",
  TC: "Turks- og Caicosøyene",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "De forente arabiske emirater",
  GB: "Storbritannia",
  US: "USA",
  UM: "USAs ytre øyer",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "De britiske jomfruøyene",
  VI: "De amerikanske jomfruøyene",
  WF: "Wallis og Futuna",
  EH: "Vest-Sahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Karibisk Nederland",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin",
  RS: "Serbia",
  SX: "Sint Maarten",
  SS: "Sør-Sudan",
  XK: "Kosovo"
}, uL = {
  locale: s4,
  countries: l4
}, dL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: l4,
  default: uL,
  locale: s4
}, Symbol.toStringTag, { value: "Module" })), c4 = "pl", u4 = {
  AF: "Afganistan",
  AL: "Albania",
  DZ: "Algieria",
  AS: "Samoa Amerykańskie",
  AD: "Andora",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktyka",
  AG: "Antigua i Barbuda",
  AR: "Argentyna",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbejdżan",
  BS: "Bahamy",
  BH: "Bahrajn",
  BD: "Bangladesz",
  BB: "Barbados",
  BY: "Białoruś",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermudy",
  BT: "Bhutan",
  BO: "Boliwia",
  BA: "Bośnia i Hercegowina",
  BW: "Botswana",
  BV: "Wyspa Bouveta",
  BR: "Brazylia",
  IO: "Brytyjskie Terytorium Oceanu Indyjskiego",
  BN: "Brunei",
  BG: "Bułgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodża",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Republika Zielonego Przylądka",
  KY: "Kajmany",
  CF: "Republika Środkowoafrykańska",
  TD: "Czad",
  CL: "Chile",
  CN: "Chiny",
  CX: "Wyspa Bożego Narodzenia",
  CC: "Wyspy Kokosowe",
  CO: "Kolumbia",
  KM: "Komory",
  CG: "Kongo",
  CD: "Demokratyczna Republika Konga",
  CK: "Wyspy Cooka",
  CR: "Kostaryka",
  CI: "Wybrzeże Kości Słoniowej",
  HR: "Chorwacja",
  CU: "Kuba",
  CY: "Cypr",
  CZ: "Czechy",
  DK: "Dania",
  DJ: "Dżibuti",
  DM: "Dominika",
  DO: "Dominikana",
  EC: "Ekwador",
  EG: "Egipt",
  SV: "Salwador",
  GQ: "Gwinea Równikowa",
  ER: "Erytrea",
  EE: "Estonia",
  ET: "Etiopia",
  FK: "Falklandy",
  FO: "Wyspy Owcze",
  FJ: "Fidżi",
  FI: "Finlandia",
  FR: "Francja",
  GF: "Gujana Francuska",
  PF: "Polinezja Francuska",
  TF: "Francuskie Terytoria Południowe i Antarktyczne",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Gruzja",
  DE: "Niemcy",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grecja",
  GL: "Grenlandia",
  GD: "Grenada",
  GP: "Gwadelupa",
  GU: "Guam",
  GT: "Gwatemala",
  GN: "Gwinea",
  GW: "Gwinea Bissau",
  GY: "Gujana",
  HT: "Haiti",
  HM: "Wyspy Heard i McDonalda",
  VA: "Watykan",
  HN: "Honduras",
  HK: "Hongkong",
  HU: "Węgry",
  IS: "Islandia",
  IN: "Indie",
  ID: "Indonezja",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlandia",
  IL: "Izrael",
  IT: "Włochy",
  JM: "Jamajka",
  JP: "Japonia",
  JO: "Jordania",
  KZ: "Kazachstan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Korea Północna",
  KR: "Korea Południowa",
  KW: "Kuwejt",
  KG: "Kirgistan",
  LA: "Laos",
  LV: "Łotwa",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Litwa",
  LU: "Luksemburg",
  MO: "Makau",
  MK: "Macedonia Północna",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malezja",
  MV: "Malediwy",
  ML: "Mali",
  MT: "Malta",
  MH: "Wyspy Marshalla",
  MQ: "Martynika",
  MR: "Mauretania",
  MU: "Mauritius",
  YT: "Majotta",
  MX: "Meksyk",
  FM: "Mikronezja",
  MD: "Mołdawia",
  MC: "Monako",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Maroko",
  MZ: "Mozambik",
  MM: "Mjanma",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Holandia",
  NC: "Nowa Kaledonia",
  NZ: "Nowa Zelandia",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk",
  MP: "Mariany Północne",
  NO: "Norwegia",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestyna",
  PA: "Panama",
  PG: "Papua-Nowa Gwinea",
  PY: "Paragwaj",
  PE: "Peru",
  PH: "Filipiny",
  PN: "Pitcairn",
  PL: "Polska",
  PT: "Portugalia",
  PR: "Portoryko",
  QA: "Katar",
  RE: "Reunion",
  RO: "Rumunia",
  RU: "Rosja",
  RW: "Rwanda",
  SH: "Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha",
  KN: "Saint Kitts i Nevis",
  LC: "Saint Lucia",
  PM: "Saint-Pierre i Miquelon",
  VC: "Saint Vincent i Grenadyny",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Wyspy Świętego Tomasza i Książęca",
  SA: "Arabia Saudyjska",
  SN: "Senegal",
  SC: "Seszele",
  SL: "Sierra Leone",
  SG: "Singapur",
  SK: "Słowacja",
  SI: "Słowenia",
  SB: "Wyspy Salomona",
  SO: "Somalia",
  ZA: "Południowa Afryka",
  GS: "Georgia Południowa i Sandwich Południowy",
  ES: "Hiszpania",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard i Jan Mayen",
  SZ: "Eswatini",
  SE: "Szwecja",
  CH: "Szwajcaria",
  SY: "Syria",
  TW: "Tajwan",
  TJ: "Tadżykistan",
  TZ: "Tanzania",
  TH: "Tajlandia",
  TL: "Timor Wschodni",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trynidad i Tobago",
  TN: "Tunezja",
  TR: "Turcja",
  TM: "Turkmenistan",
  TC: "Turks i Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Zjednoczone Emiraty Arabskie",
  GB: "Wielka Brytania",
  US: "Stany Zjednoczone",
  UM: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
  UY: "Urugwaj",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Wenezuela",
  VN: "Wietnam",
  VG: "Brytyjskie Wyspy Dziewicze",
  VI: "Wyspy Dziewicze Stanów Zjednoczonych",
  WF: "Wallis i Futuna",
  EH: "Sahara Zachodnia",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Wyspy Alandzkie",
  BQ: "Bonaire, Sint Eustatius i Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Wyspa Man",
  JE: "Jersey",
  ME: "Czarnogóra",
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin",
  RS: "Serbia",
  SX: "Sint Maarten",
  SS: "Sudan Południowy",
  XK: "Kosowo"
}, pL = {
  locale: c4,
  countries: u4
}, hL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: u4,
  default: pL,
  locale: c4
}, Symbol.toStringTag, { value: "Module" })), d4 = "pt", p4 = {
  AF: "Afeganistão",
  ZA: "África do Sul",
  AL: "Albânia",
  DE: "Alemanha",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguila",
  AQ: "Antártida",
  AG: "Antígua e Barbuda",
  SA: "Arábia Saudita",
  DZ: "Argélia",
  AR: "Argentina",
  AM: "Arménia",
  AW: "Aruba",
  AU: "Austrália",
  AT: "Áustria",
  AZ: "Azerbaijão",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BE: "Bélgica",
  BZ: "Belize",
  BJ: "Benim",
  BM: "Bermudas",
  BY: "Bielorrússia",
  BO: "Bolívia",
  BA: "Bósnia-Herzegovina",
  BW: "Botsuana",
  BR: "Brasil",
  BN: "Brunei",
  BG: "Bulgária",
  BF: "Burkina Faso",
  BI: "Burundi",
  BT: "Butão",
  CV: "Cabo Verde",
  KH: "Camboja",
  CA: "Canadá",
  QA: "Qatar",
  KZ: "Cazaquistão",
  TD: "Chade",
  CL: "Chile",
  CN: "China",
  CY: "Chipre",
  VA: "Santa Sé",
  SG: "Singapura",
  CO: "Colômbia",
  KM: "Comores",
  CG: "República Democrática do Congo",
  CD: "República Popular do Congo",
  KP: "Coreia do Norte",
  KR: "Coreia do Sul",
  CI: "Costa do Marfim",
  CR: "Costa Rica",
  HR: "Croácia",
  CU: "Cuba",
  CW: "Curaçao",
  DK: "Dinamarca",
  DJ: "Djibouti",
  DM: "Dominica",
  EG: "Egito",
  SV: "El Salvador",
  AE: "Emirados Árabes Unidos",
  EC: "Equador",
  ER: "Eritreia",
  SK: "Eslováquia",
  SI: "Eslovénia",
  ES: "Espanha",
  US: [
    "Estados Unidos",
    "Estados Unidos da América"
  ],
  EE: "Estónia",
  ET: "Etiópia",
  FJ: "Fiji",
  PH: "Filipinas",
  FI: "Finlândia",
  FR: "França",
  GA: "Gabão",
  GM: "Gâmbia",
  GH: "Gana",
  GE: "Geórgia",
  GS: "Geórgia do Sul e Ilhas Sandwich do Sul",
  GI: "Gibraltar",
  GD: "Granada",
  GR: "Grécia",
  GL: "Gronelândia",
  GP: "Guadalupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GY: "Guiana",
  GF: "Guiana Francesa",
  GN: "Guiné",
  GW: "Guiné-Bissau",
  GQ: "Guiné Equatorial",
  HT: "Haiti",
  NL: "Países Baixos",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungria",
  YE: "Iémen",
  BV: "Ilha Bouvet",
  CX: "Ilha de Natal",
  IM: "Ilha de Man",
  NF: "Ilha Norfolk",
  AX: "Ilhas Åland",
  KY: "Ilhas Caimão",
  CC: "Ilhas Cocos (Keeling)",
  CK: "Ilhas Cook",
  UM: "Ilhas Distantes dos EUA",
  HM: "Ilha Heard e Ilhas McDonald",
  FO: "Ilhas Faroé",
  FK: "Ilhas Malvinas",
  MP: "Ilhas Marianas do Norte",
  MH: "Ilhas Marshall",
  PN: "Ilhas Pitcairn",
  SB: "Ilhas Salomão",
  TC: "Ilhas Turcas e Caicos",
  VG: "Ilhas Virgens Britânicas",
  VI: "Ilhas Virgens Americanas",
  IN: "Índia",
  ID: "Indonésia",
  IR: "Irão",
  IQ: "Iraque",
  IE: "Irlanda",
  IS: "Islândia",
  IL: "Israel",
  IT: "Itália",
  JM: "Jamaica",
  JP: "Japão",
  JE: "Jersey",
  JO: "Jordânia",
  KW: "Koweit",
  LA: "Laos",
  LS: "Lesoto",
  LV: "Letónia",
  LB: "Líbano",
  LR: "Libéria",
  LY: "Líbia",
  LI: "Liechtenstein",
  LT: "Lituânia",
  LU: "Luxemburgo",
  MO: "Macau",
  MK: "Macedónia do Norte",
  MG: "Madagáscar",
  MY: "Malásia",
  MW: "Maláui",
  MV: "Maldivas",
  ML: "Mali",
  MT: "Malta",
  MA: "Marrocos",
  MQ: "Martinica",
  MU: "Maurícia",
  MR: "Mauritânia",
  YT: "Mayotte",
  MX: "México",
  MM: "Mianmar (Birmânia)",
  FM: "Micronésia",
  MZ: "Moçambique",
  MD: "Moldávia",
  MC: "Mónaco",
  MN: "Mongólia",
  ME: "Montenegro",
  MS: "Monserrate",
  NA: "Namíbia",
  NR: "Nauru",
  NP: "Nepal",
  NI: "Nicarágua",
  NE: "Níger",
  NG: "Nigéria",
  NU: "Niue",
  NO: "Noruega",
  NC: "Nova Caledónia",
  NZ: "Nova Zelândia",
  OM: "Omã",
  BQ: "Países Baixos Caribenhos",
  PW: "Palau",
  PA: "Panamá",
  PG: "Papua-Nova Guiné",
  PK: "Paquistão",
  PY: "Paraguai",
  PE: "Peru",
  PF: "Polinésia Francesa",
  PL: "Polónia",
  PR: "Porto Rico",
  PT: "Portugal",
  KE: "Quénia",
  KG: "Quirguistão",
  KI: "Quiribati",
  GB: "Reino Unido",
  CF: "República Centro-Africana",
  DO: "República Dominicana",
  CM: "Camarões",
  CZ: "Chéquia",
  RE: "Reunião",
  RO: "Roménia",
  RW: "Ruanda",
  RU: "Rússia",
  EH: "Saara Ocidental",
  PM: "Saint Pierre e Miquelon",
  WS: "Samoa",
  AS: "Samoa Americana",
  SM: "San Marino",
  SH: "Santa Helena",
  LC: "Santa Lúcia",
  BL: "São Bartolomeu",
  KN: "São Cristóvão e Neves",
  MF: "São Martinho",
  ST: "São Tomé e Príncipe",
  VC: "São Vicente e Granadinas",
  SN: "Senegal",
  SL: "Serra Leoa",
  RS: "Sérvia",
  SC: "Seychelles",
  SX: "São Martinho",
  SY: "Síria",
  SO: "Somália",
  LK: "Sri Lanka",
  SZ: "Essuatíni",
  SD: "Sudão",
  SS: "Sudão do Sul",
  SE: "Suécia",
  CH: "Suíça",
  SR: "Suriname",
  SJ: "Svalbard e Jan Mayen",
  TH: "Tailândia",
  TW: "Taiwan",
  TJ: "Tajiquistão",
  TZ: "Tanzânia",
  IO: "Território Britânico do Oceano Índico",
  TF: "Terras Austrais e Antárticas Francesas",
  PS: "Territórios palestinos",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trindade e Tobago",
  TN: "Tunísia",
  TM: "Turquemenistão",
  TR: "Turquia",
  TV: "Tuvalu",
  UA: "Ucrânia",
  UG: "Uganda",
  UY: "Uruguai",
  UZ: "Uzbequistão",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietname",
  WF: "Wallis e Futuna",
  ZM: "Zâmbia",
  ZW: "Zimbábue",
  XK: "Kosovo"
}, mL = {
  locale: d4,
  countries: p4
}, fL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: p4,
  default: mL,
  locale: d4
}, Symbol.toStringTag, { value: "Module" })), h4 = "ro", m4 = {
  AD: "Andorra",
  AE: "Emiratele Arabe Unite",
  AF: "Afganistan",
  AG: "Antigua și Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "Samoa Americană",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Insulele Åland",
  AZ: "Azerbaidjan",
  BA: "Bosnia și Herțegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgia",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Sfântul Bartolomeu",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Insulele Caraibe Olandeze",
  BR: "Brazilia",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Insula Bouvet",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Insulele Cocos (Keeling)",
  CD: "Congo - Kinshasa",
  CF: "Republica Centrafricană",
  CG: "Congo - Brazzaville",
  CH: "Elveția",
  CI: "Côte d’Ivoire",
  CK: "Insulele Cook",
  CL: "Chile",
  CM: "Camerun",
  CN: "China",
  CO: "Columbia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Capul Verde",
  CW: "Curaçao",
  CX: "Insula Christmas",
  CY: "Cipru",
  CZ: "Cehia",
  DE: "Germania",
  DJ: "Djibouti",
  DK: "Danemarca",
  DM: "Dominica",
  DO: "Republica Dominicană",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egipt",
  EH: "Sahara Occidentală",
  ER: "Eritreea",
  ES: "Spania",
  ET: "Etiopia",
  FI: "Finlanda",
  FJ: "Fiji",
  FK: "Insulele Falkland",
  FM: "Micronezia",
  FO: "Insulele Feroe",
  FR: "Franța",
  GA: "Gabon",
  GB: "Regatul Unit",
  GD: "Grenada",
  GE: "Georgia",
  GF: "Guyana Franceză",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Groenlanda",
  GM: "Gambia",
  GN: "Guineea",
  GP: "Guadelupa",
  GQ: "Guineea Ecuatorială",
  GR: "Grecia",
  GS: "Georgia de Sud și Insulele Sandwich de Sud",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guineea-Bissau",
  GY: "Guyana",
  HK: "R.A.S. Hong Kong a Chinei",
  HM: "Insula Heard și Insulele McDonald",
  HN: "Honduras",
  HR: "Croația",
  HT: "Haiti",
  HU: "Ungaria",
  ID: "Indonezia",
  IE: "Irlanda",
  IL: "Israel",
  IM: "Insula Man",
  IN: "India",
  IO: "Teritoriul Britanic din Oceanul Indian",
  IQ: "Irak",
  IR: "Iran",
  IS: "Islanda",
  IT: "Italia",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Iordania",
  JP: "Japonia",
  KE: "Kenya",
  KG: "Kârgâzstan",
  KH: "Cambodgia",
  KI: "Kiribati",
  KM: "Comore",
  KN: "Saint Kitts și Nevis",
  KP: "Coreea de Nord",
  KR: "Coreea de Sud",
  KW: "Kuweit",
  KY: "Insulele Cayman",
  KZ: "Kazahstan",
  LA: "Laos",
  LB: "Liban",
  LC: "Sfânta Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lituania",
  LU: "Luxemburg",
  LV: "Letonia",
  LY: "Libia",
  MA: "Maroc",
  MC: "Monaco",
  MD: "Republica Moldova",
  ME: "Muntenegru",
  MF: "Sfântul Martin",
  MG: "Madagascar",
  MH: "Insulele Marshall",
  MK: "Macedonia de Nord",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "R.A.S. Macao a Chinei",
  MP: "Insulele Mariane de Nord",
  MQ: "Martinica",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldive",
  MW: "Malawi",
  MX: "Mexic",
  MY: "Malaysia",
  MZ: "Mozambic",
  NA: "Namibia",
  NC: "Noua Caledonie",
  NE: "Niger",
  NF: "Insula Norfolk",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Țările de Jos",
  NO: "Norvegia",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Noua Zeelandă",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Polinezia Franceză",
  PG: "Papua-Noua Guinee",
  PH: "Filipine",
  PK: "Pakistan",
  PL: "Polonia",
  PM: "Saint-Pierre și Miquelon",
  PN: "Insulele Pitcairn",
  PR: "Puerto Rico",
  PS: "Teritoriile Palestiniene",
  PT: "Portugalia",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "România",
  RS: "Serbia",
  RU: "Rusia",
  RW: "Rwanda",
  SA: "Arabia Saudită",
  SB: "Insulele Solomon",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Suedia",
  SG: "Singapore",
  SH: "Sfânta Elena",
  SI: "Slovenia",
  SJ: "Svalbard și Jan Mayen",
  SK: "Slovacia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "Sudanul de Sud",
  ST: "Sao Tomé și Príncipe",
  SV: "El Salvador",
  SX: "Sint-Maarten",
  SY: "Siria",
  SZ: "Eswatini",
  TC: "Insulele Turks și Caicos",
  TD: "Ciad",
  TF: "Teritoriile Australe și Antarctice Franceze",
  TG: "Togo",
  TH: "Thailanda",
  TJ: "Tadjikistan",
  TK: "Tokelau",
  TL: "Timorul de Est",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turcia",
  TT: "Trinidad și Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ucraina",
  UG: "Uganda",
  UM: "Insulele Îndepărtate ale S.U.A.",
  US: "Statele Unite ale Americii",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Statul Cetății Vaticanului",
  VC: "Saint Vincent și Grenadinele",
  VE: "Venezuela",
  VG: "Insulele Virgine Britanice",
  VI: "Insulele Virgine Americane",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis și Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "Africa de Sud",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, gL = {
  locale: h4,
  countries: m4
}, yL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: m4,
  default: gL,
  locale: h4
}, Symbol.toStringTag, { value: "Module" })), f4 = "ru", g4 = {
  AU: "Австралия",
  AT: "Австрия",
  AZ: "Азербайджан",
  AX: "Аландские острова",
  AL: "Албания",
  DZ: "Алжир",
  VI: "Виргинские Острова (США)",
  AS: "Американское Самоа",
  AI: "Ангилья",
  AO: "Ангола",
  AD: "Андорра",
  AQ: "Антарктида",
  AG: "Антигуа и Барбуда",
  AR: "Аргентина",
  AM: "Армения",
  AW: "Аруба",
  AF: "Афганистан",
  BS: "Багамы",
  BD: "Бангладеш",
  BB: "Барбадос",
  BH: "Бахрейн",
  BZ: "Белиз",
  BY: "Беларусь",
  BE: "Бельгия",
  BJ: "Бенин",
  BM: "Бермуды",
  BG: "Болгария",
  BO: "Боливия",
  BQ: "Бонэйр, Синт-Эстатиус и Саба",
  BA: "Босния и Герцеговина",
  BW: "Ботсвана",
  BR: "Бразилия",
  IO: "Британская территория в Индийском океане",
  VG: "Виргинские Острова (Великобритания)",
  BN: "Бруней",
  BF: "Буркина-Фасо",
  BI: "Бурунди",
  BT: "Бутан",
  VU: "Вануату",
  VA: "Ватикан",
  GB: "Великобритания",
  HU: "Венгрия",
  VE: "Венесуэла",
  UM: "Внешние малые острова (США)",
  TL: "Восточный Тимор",
  VN: "Вьетнам",
  GA: "Габон",
  HT: "Гаити",
  GY: "Гайана",
  GM: "Гамбия",
  GH: "Гана",
  GP: "Гваделупа",
  GT: "Гватемала",
  GF: "Гвиана",
  GN: "Гвинея",
  GW: "Гвинея-Бисау",
  DE: "Германия",
  GG: "Гернси",
  GI: "Гибралтар",
  HN: "Гондурас",
  HK: "Гонконг",
  GD: "Гренада",
  GL: "Гренландия",
  GR: "Греция",
  GE: "Грузия",
  GU: "Гуам",
  DK: "Дания",
  JE: "Джерси",
  DJ: "Джибути",
  DM: "Доминика",
  DO: "Доминиканская Республика",
  CD: "Демократическая Республика Конго",
  EG: "Египет",
  ZM: "Замбия",
  EH: "САДР",
  ZW: "Зимбабве",
  IL: "Израиль",
  IN: "Индия",
  ID: "Индонезия",
  JO: "Иордания",
  IQ: "Ирак",
  IR: "Иран",
  IE: "Ирландия",
  IS: "Исландия",
  ES: "Испания",
  IT: "Италия",
  YE: "Йемен",
  CV: "Кабо-Верде",
  KZ: "Казахстан",
  KY: "Острова Кайман",
  KH: "Камбоджа",
  CM: "Камерун",
  CA: "Канада",
  QA: "Катар",
  KE: "Кения",
  CY: "Кипр",
  KG: "Киргизия",
  KI: "Кирибати",
  TW: [
    "Тайвань",
    "Китайская Республика"
  ],
  KP: "КНДР (Корейская Народно-Демократическая Республика)",
  CN: "КНР (Китайская Народная Республика)",
  CC: "Кокосовые острова",
  CO: "Колумбия",
  KM: "Коморы",
  CR: "Коста-Рика",
  CI: "Кот-д’Ивуар",
  CU: "Куба",
  KW: "Кувейт",
  CW: "Кюрасао",
  LA: "Лаос",
  LV: "Латвия",
  LS: "Лесото",
  LR: "Либерия",
  LB: "Ливан",
  LY: "Ливия",
  LT: "Литва",
  LI: "Лихтенштейн",
  LU: "Люксембург",
  MU: "Маврикий",
  MR: "Мавритания",
  MG: "Мадагаскар",
  YT: "Майотта",
  MO: "Макао",
  MW: "Малави",
  MY: "Малайзия",
  ML: "Мали",
  MV: "Мальдивы",
  MT: "Мальта",
  MA: "Марокко",
  MQ: "Мартиника",
  MH: "Маршалловы Острова",
  MX: "Мексика",
  FM: "Микронезия",
  MZ: "Мозамбик",
  MD: "Молдавия",
  MC: "Монако",
  MN: "Монголия",
  MS: "Монтсеррат",
  MM: "Мьянма",
  NA: "Намибия",
  NR: "Науру",
  NP: "Непал",
  NE: "Нигер",
  NG: "Нигерия",
  NL: "Нидерланды",
  NI: "Никарагуа",
  NU: "Ниуэ",
  NZ: "Новая Зеландия",
  NC: "Новая Каледония",
  NO: "Норвегия",
  AE: "ОАЭ",
  OM: "Оман",
  BV: "Остров Буве",
  IM: "Остров Мэн",
  CK: "Острова Кука",
  NF: "Остров Норфолк",
  CX: "Остров Рождества",
  PN: "Острова Питкэрн",
  SH: "Острова Святой Елены, Вознесения и Тристан-да-Кунья",
  PK: "Пакистан",
  PW: "Палау",
  PS: "Государство Палестина",
  PA: "Панама",
  PG: "Папуа — Новая Гвинея",
  PY: "Парагвай",
  PE: "Перу",
  PL: "Польша",
  PT: "Португалия",
  PR: "Пуэрто-Рико",
  CG: "Республика Конго",
  KR: "Республика Корея",
  RE: "Реюньон",
  RU: [
    "Российская Федерация",
    "Россия"
  ],
  RW: "Руанда",
  RO: "Румыния",
  SV: "Сальвадор",
  WS: "Самоа",
  SM: "Сан-Марино",
  ST: "Сан-Томе и Принсипи",
  SA: "Саудовская Аравия",
  SZ: "Эсватини",
  MK: "Северная Македония",
  MP: "Северные Марианские Острова",
  SC: "Сейшельские Острова",
  BL: "Сен-Бартелеми",
  MF: "Сен-Мартен",
  PM: "Сен-Пьер и Микелон",
  SN: "Сенегал",
  VC: "Сент-Винсент и Гренадины",
  KN: "Сент-Китс и Невис",
  LC: "Сент-Люсия",
  RS: "Сербия",
  SG: "Сингапур",
  SX: "Синт-Мартен",
  SY: "Сирия",
  SK: "Словакия",
  SI: "Словения",
  SB: "Соломоновы Острова",
  SO: "Сомали",
  SD: "Судан",
  SR: "Суринам",
  US: "США",
  SL: "Сьерра-Леоне",
  TJ: "Таджикистан",
  TH: "Таиланд",
  TZ: "Танзания",
  TC: "Теркс и Кайкос",
  TG: "Того",
  TK: "Токелау",
  TO: "Тонга",
  TT: "Тринидад и Тобаго",
  TV: "Тувалу",
  TN: "Тунис",
  TM: "Туркмения",
  TR: "Турция",
  UG: "Уганда",
  UZ: "Узбекистан",
  UA: "Украина",
  WF: "Уоллис и Футуна",
  UY: "Уругвай",
  FO: "Фареры",
  FJ: "Фиджи",
  PH: "Филиппины",
  FI: "Финляндия",
  FK: "Фолклендские острова",
  FR: "Франция",
  PF: "Французская Полинезия",
  TF: "Французские Южные и Антарктические Территории",
  HM: "Херд и Макдональд",
  HR: "Хорватия",
  CF: "ЦАР",
  TD: "Чад",
  ME: "Черногория",
  CZ: "Чехия",
  CL: "Чили",
  CH: "Швейцария",
  SE: "Швеция",
  SJ: "Шпицберген и Ян-Майен",
  LK: "Шри-Ланка",
  EC: "Эквадор",
  GQ: "Экваториальная Гвинея",
  ER: "Эритрея",
  EE: "Эстония",
  ET: "Эфиопия",
  ZA: "ЮАР",
  GS: "Южная Георгия и Южные Сандвичевы Острова",
  SS: "Южный Судан",
  JM: "Ямайка",
  JP: "Япония",
  XK: "Косово"
}, vL = {
  locale: f4,
  countries: g4
}, bL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: g4,
  default: vL,
  locale: f4
}, Symbol.toStringTag, { value: "Module" })), y4 = "sk", v4 = {
  AD: "Andorra",
  AE: "Spojené arabské emiráty",
  AF: "Afganistan",
  AG: "Antigua a Barbuda",
  AI: "Anguilla",
  AL: "Albánsko",
  AM: "Arménsko",
  AO: "Angola",
  AQ: "Antarktída",
  AR: "Argentína",
  AS: "Americká Samoa",
  AT: "Rakúsko",
  AU: "Austrália",
  AW: "Aruba",
  AX: "Alandy",
  AZ: "Azerbajdžan",
  BA: "Bosna a Hercegovina",
  BB: "Barbados",
  BD: "Bangladéš",
  BE: "Belgicko",
  BF: "Burkina Faso",
  BG: "Bulharsko",
  BH: "Bahrajn",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Svätý Bartolomej",
  BM: "Bermudy",
  BN: "Brunej",
  BO: "Bolívia",
  BQ: "Karibské Holandsko",
  BR: "Brazília",
  BS: "Bahamy",
  BT: "Bhután",
  BV: "Bouvetov ostrov",
  BW: "Botswana",
  BY: "Bielorusko",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Kokosové ostrovy",
  CD: "Konžská demokratická republika",
  CF: "Stredoafrická republika",
  CG: "Konžská republika",
  CH: "Švajčiarsko",
  CI: "Pobrežie Slonoviny",
  CK: "Cookove ostrovy",
  CL: "Čile",
  CM: "Kamerun",
  CN: "Čína",
  CO: "Kolumbia",
  CR: "Kostarika",
  CU: "Kuba",
  CV: "Kapverdy",
  CW: "Curaçao",
  CX: "Vianočný ostrov",
  CY: "Cyprus",
  CZ: "Česko",
  DE: "Nemecko",
  DJ: "Džibutsko",
  DK: "Dánsko",
  DM: "Dominika",
  DO: "Dominikánska republika",
  DZ: "Alžírsko",
  EC: "Ekvádor",
  EE: "Estónsko",
  EG: "Egypt",
  EH: "Západná Sahara",
  ER: "Eritrea",
  ES: "Španielsko",
  ET: "Etiópia",
  FI: "Fínsko",
  FJ: "Fidži",
  FK: "Falklandy",
  FM: "Mikronézia",
  FO: "Faerské ostrovy",
  FR: "Francúzsko",
  GA: "Gabon",
  GB: "Spojené kráľovstvo",
  GD: "Grenada",
  GE: "Gruzínsko",
  GF: "Francúzska Guayana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltár",
  GL: "Grónsko",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Rovníková Guinea",
  GR: "Grécko",
  GS: "Južná Georgia a Južné Sandwichove ostrovy",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guayana",
  HK: "Hongkong – OAO Číny",
  HM: "Heardov ostrov a Macdonaldove ostrovy",
  HN: "Honduras",
  HR: "Chorvátsko",
  HT: "Haiti",
  HU: "Maďarsko",
  ID: "Indonézia",
  IE: "Írsko",
  IL: "Izrael",
  IM: "Ostrov Man",
  IN: "India",
  IO: "Britské indickooceánske územie",
  IQ: "Irak",
  IR: "Irán",
  IS: "Island",
  IT: "Taliansko",
  JE: "Jersey",
  JM: "Jamajka",
  JO: "Jordánsko",
  JP: "Japonsko",
  KE: "Keňa",
  KG: "Kirgizsko",
  KH: "Kambodža",
  KI: "Kiribati",
  KM: "Komory",
  KN: "Svätý Krištof a Nevis",
  KP: "Severná Kórea",
  KR: "Južná Kórea",
  KW: "Kuvajt",
  KY: "Kajmanie ostrovy",
  KZ: "Kazachstan",
  LA: "Laos",
  LB: "Libanon",
  LC: "Svätá Lucia",
  LI: "Lichtenštajnsko",
  LK: "Srí Lanka",
  LR: "Libéria",
  LS: "Lesotho",
  LT: "Litva",
  LU: "Luxembursko",
  LV: "Lotyšsko",
  LY: "Líbya",
  MA: "Maroko",
  MC: "Monako",
  MD: "Moldavsko",
  ME: "Čierna Hora",
  MF: "Svätý Martin (fr.)",
  MG: "Madagaskar",
  MH: "Marshallove ostrovy",
  MK: "Severné Macedónsko",
  ML: "Mali",
  MM: "Mjanmarsko",
  MN: "Mongolsko",
  MO: "Macao – OAO Číny",
  MP: "Severné Mariány",
  MQ: "Martinik",
  MR: "Mauritánia",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Maurícius",
  MV: "Maldivy",
  MW: "Malawi",
  MX: "Mexiko",
  MY: "Malajzia",
  MZ: "Mozambik",
  NA: "Namíbia",
  NC: "Nová Kaledónia",
  NE: "Niger",
  NF: "Norfolk",
  NG: "Nigéria",
  NI: "Nikaragua",
  NL: "Holandsko",
  NO: "Nórsko",
  NP: "Nepál",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nový Zéland",
  OM: "Omán",
  PA: "Panama",
  PE: "Peru",
  PF: "Francúzska Polynézia",
  PG: "Papua Nová Guinea",
  PH: "Filipíny",
  PK: "Pakistan",
  PL: "Poľsko",
  PM: "Saint Pierre a Miquelon",
  PN: "Pitcairnove ostrovy",
  PR: "Portoriko",
  PS: "Palestínske územia",
  PT: "Portugalsko",
  PW: "Palau",
  PY: "Paraguaj",
  QA: "Katar",
  RE: "Réunion",
  RO: "Rumunsko",
  RS: "Srbsko",
  RU: "Rusko",
  RW: "Rwanda",
  SA: "Saudská Arábia",
  SB: "Šalamúnove ostrovy",
  SC: "Seychely",
  SD: "Sudán",
  SE: "Švédsko",
  SG: "Singapur",
  SH: "Svätá Helena",
  SI: "Slovinsko",
  SJ: "Svalbard a Jan Mayen",
  SK: "Slovensko",
  SL: "Sierra Leone",
  SM: "San Maríno",
  SN: "Senegal",
  SO: "Somálsko",
  SR: "Surinam",
  SS: "Južný Sudán",
  ST: "Svätý Tomáš a Princov ostrov",
  SV: "Salvádor",
  SX: "Svätý Martin (hol.)",
  SY: "Sýria",
  SZ: "Svazijsko",
  TC: "Turks a Caicos",
  TD: "Čad",
  TF: "Francúzske južné a antarktické územia",
  TG: "Togo",
  TH: "Thajsko",
  TJ: "Tadžikistan",
  TK: "Tokelau",
  TL: "Východný Timor",
  TM: "Turkménsko",
  TN: "Tunisko",
  TO: "Tonga",
  TR: "Turecko",
  TT: "Trinidad a Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzánia",
  UA: "Ukrajina",
  UG: "Uganda",
  UM: "Menšie odľahlé ostrovy USA",
  US: "Spojené štáty",
  UY: "Uruguaj",
  UZ: "Uzbekistan",
  VA: "Vatikán",
  VC: "Svätý Vincent a Grenadíny",
  VE: "Venezuela",
  VG: "Britské Panenské ostrovy",
  VI: "Americké Panenské ostrovy",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis a Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Jemen",
  YT: "Mayotte",
  ZA: "Južná Afrika",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, _L = {
  locale: y4,
  countries: v4
}, wL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: v4,
  default: _L,
  locale: y4
}, Symbol.toStringTag, { value: "Module" })), b4 = "sl", _4 = {
  AD: "Andora",
  AE: "Združeni arabski emirati",
  AF: "Afganistan",
  AG: "Antigva in Barbuda",
  AI: "Angvila",
  AL: "Albanija",
  AM: "Armenija",
  AO: "Angola",
  AQ: "Antarktika",
  AR: "Argentina",
  AS: "Ameriška Samoa",
  AT: "Avstrija",
  AU: "Avstralija",
  AW: "Aruba",
  AX: "Ålandski otoki",
  AZ: "Azerbajdžan",
  BA: "Bosna in Hercegovina",
  BB: "Barbados",
  BD: "Bangladeš",
  BE: "Belgija",
  BF: "Burkina Faso",
  BG: "Bolgarija",
  BH: "Bahrajn",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy",
  BM: "Bermudi",
  BN: "Brunej",
  BO: "Bolivija",
  BQ: "Nizozemski Karibi",
  BR: "Brazilija",
  BS: "Bahami",
  BT: "Butan",
  BV: "Bouvetov otok",
  BW: "Bocvana",
  BY: "Belorusija",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Kokosovi otoki",
  CD: "Demokratična republika Kongo",
  CF: "Centralnoafriška republika",
  CG: "Kongo - Brazzaville",
  CH: "Švica",
  CI: "Slonokoščena obala",
  CK: "Cookovi otoki",
  CL: "Čile",
  CM: "Kamerun",
  CN: "Kitajska",
  CO: "Kolumbija",
  CR: "Kostarika",
  CU: "Kuba",
  CV: "Zelenortski otoki",
  CW: "Curaçao",
  CX: "Božični otok",
  CY: "Ciper",
  CZ: "Češka",
  DE: "Nemčija",
  DJ: "Džibuti",
  DK: "Danska",
  DM: "Dominika",
  DO: "Dominikanska republika",
  DZ: "Alžirija",
  EC: "Ekvador",
  EE: "Estonija",
  EG: "Egipt",
  EH: "Zahodna Sahara",
  ER: "Eritreja",
  ES: "Španija",
  ET: "Etiopija",
  FI: "Finska",
  FJ: "Fidži",
  FK: "Falklandski otoki",
  FM: "Mikronezija",
  FO: "Ferski otoki",
  FR: "Francija",
  GA: "Gabon",
  GB: "Združeno kraljestvo",
  GD: "Grenada",
  GE: "Gruzija",
  GF: "Francoska Gvajana",
  GG: "Guernsey",
  GH: "Gana",
  GI: "Gibraltar",
  GL: "Grenlandija",
  GM: "Gambija",
  GN: "Gvineja",
  GP: "Gvadalupe",
  GQ: "Ekvatorialna Gvineja",
  GR: "Grčija",
  GS: "Južna Georgia in Južni Sandwichevi otoki",
  GT: "Gvatemala",
  GU: "Guam",
  GW: "Gvineja Bissau",
  GY: "Gvajana",
  HK: "Hongkong",
  HM: "Heardov otok in McDonaldovi otoki",
  HN: "Honduras",
  HR: "Hrvaška",
  HT: "Haiti",
  HU: "Madžarska",
  ID: "Indonezija",
  IE: "Irska",
  IL: "Izrael",
  IM: "Otok Man",
  IN: "Indija",
  IO: "Britansko ozemlje v Indijskem oceanu",
  IQ: "Irak",
  IR: "Iran",
  IS: "Islandija",
  IT: "Italija",
  JE: "Jersey",
  JM: "Jamajka",
  JO: "Jordanija",
  JP: "Japonska",
  KE: "Kenija",
  KG: "Kirgizistan",
  KH: "Kambodža",
  KI: "Kiribati",
  KM: "Komori",
  KN: "Saint Kitts in Nevis",
  KP: "Severna Koreja",
  KR: "Južna Koreja",
  KW: "Kuvajt",
  KY: "Kajmanski otoki",
  KZ: "Kazahstan",
  LA: "Laos",
  LB: "Libanon",
  LC: "Saint Lucia",
  LI: "Lihtenštajn",
  LK: "Šrilanka",
  LR: "Liberija",
  LS: "Lesoto",
  LT: "Litva",
  LU: "Luksemburg",
  LV: "Latvija",
  LY: "Libija",
  MA: "Maroko",
  MC: "Monako",
  MD: "Moldavija",
  ME: "Črna gora",
  MF: "Saint Martin",
  MG: "Madagaskar",
  MH: "Marshallovi otoki",
  MK: "Severna Makedonija",
  ML: "Mali",
  MM: "Mjanmar (Burma)",
  MN: "Mongolija",
  MO: "Macao",
  MP: "Severni Marianski otoki",
  MQ: "Martinik",
  MR: "Mavretanija",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldivi",
  MW: "Malavi",
  MX: "Mehika",
  MY: "Malezija",
  MZ: "Mozambik",
  NA: "Namibija",
  NC: "Nova Kaledonija",
  NE: "Niger",
  NF: "Norfolški otok",
  NG: "Nigerija",
  NI: "Nikaragva",
  NL: "Nizozemska",
  NO: "Norveška",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nova Zelandija",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Francoska Polinezija",
  PG: "Papua Nova Gvineja",
  PH: "Filipini",
  PK: "Pakistan",
  PL: "Poljska",
  PM: "Saint Pierre in Miquelon",
  PN: "Pitcairn",
  PR: "Portoriko",
  PS: "Palestinsko ozemlje",
  PT: "Portugalska",
  PW: "Palau",
  PY: "Paragvaj",
  QA: "Katar",
  RE: "Reunion",
  RO: "Romunija",
  RS: "Srbija",
  RU: "Rusija",
  RW: "Ruanda",
  SA: "Saudova Arabija",
  SB: "Salomonovi otoki",
  SC: "Sejšeli",
  SD: "Sudan",
  SE: "Švedska",
  SG: "Singapur",
  SH: "Sveta Helena",
  SI: "Slovenija",
  SJ: "Svalbard in Jan Mayen",
  SK: "Slovaška",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalija",
  SR: "Surinam",
  SS: "Južni Sudan",
  ST: "Sao Tome in Principe",
  SV: "Salvador",
  SX: "Sint Maarten",
  SY: "Sirija",
  SZ: "Svazi",
  TC: "Otoki Turks in Caicos",
  TD: "Čad",
  TF: "Francosko južno ozemlje",
  TG: "Togo",
  TH: "Tajska",
  TJ: "Tadžikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunizija",
  TO: "Tonga",
  TR: "Turčija",
  TT: "Trinidad in Tobago",
  TV: "Tuvalu",
  TW: "Tajvan",
  TZ: "Tanzanija",
  UA: "Ukrajina",
  UG: "Uganda",
  UM: "Stranski zunanji otoki Združenih držav",
  US: "Združene države Amerike",
  UY: "Urugvaj",
  UZ: "Uzbekistan",
  VA: "Vatikan",
  VC: "Saint Vincent in Grenadine",
  VE: "Venezuela",
  VG: "Britanski Deviški otoki",
  VI: "Ameriški Deviški otoki",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis in Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Jemen",
  YT: "Mayotte",
  ZA: "Južnoafriška republika",
  ZM: "Zambija",
  ZW: "Zimbabve"
}, SL = {
  locale: b4,
  countries: _4
}, CL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: _4,
  default: SL,
  locale: b4
}, Symbol.toStringTag, { value: "Module" })), w4 = "sq", S4 = {
  AF: "Afganistan",
  AL: "Shqipëri",
  DZ: "Algjeri",
  AS: "Samoa Amerikane",
  AD: "Andorrë",
  AO: "Angolë",
  AI: "Anguilë",
  AQ: "Antarktidë",
  AG: "Antigua & Barbuda",
  AR: "Argjentinë",
  AM: "Armeni",
  AW: "Arubë",
  AU: "Australi",
  AT: "Austri",
  AZ: "Azerbajxhan",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Bjellorusi",
  BE: "Belgjikë",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Butan",
  BO: "Bolivi",
  BA: "Bosnjë & Hercegovinë",
  BW: "Botsvanë",
  BV: "Ishulli Buve",
  BR: "Brazil",
  IO: "Territori Britanik i Oqeanit Indian",
  BN: "Brunej",
  BG: "Bullgari",
  BF: "Burkina Faso",
  BI: "Burund",
  KH: "Kamboxhia",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kepi i Gjelbër",
  KY: "Ishujt Kajman",
  CF: "Republika Afrikano-Qendrore",
  TD: "Çad",
  CL: "Kili",
  CN: "Kinë",
  CX: "Ishulli i Krishtlindjes",
  CC: "Ishujt Kokos (Kiling)",
  CO: "Kolumbi",
  KM: "Komore",
  CG: "Kongo-Brazavil",
  CD: "Kongo-Kinshasa",
  CK: "Ishulli Kuk",
  CR: "Kosta Rikë",
  CI: "Bregu i Fildishtë",
  HR: "Kroaci",
  CU: "Kubë",
  CY: "Qipro",
  CZ: "Republika Çeke",
  DK: "Danimarkë",
  DJ: "Xhibut",
  DM: "Dominikë",
  DO: "Republika Dominikane",
  EC: "Ekuador",
  EG: "Egjipt",
  SV: "El Salvador",
  GQ: "Guineja Ekuatoriale",
  ER: "Eritre",
  EE: "Estoni",
  ET: "Etiopi",
  FK: "Ishujt Folkland",
  FO: "Ishujt Faroe",
  FJ: "Fixhi",
  FI: "Finlandë",
  FR: "Francë",
  GF: "Guajana Frënge",
  PF: "Polinezia Frënge",
  TF: "Territoret Frënge Jugore",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Gjeorgji",
  DE: "Gjermani",
  GH: "Gana",
  GI: "Gjibraltar",
  GR: "Greqi",
  GL: "Groenlandë",
  GD: "Grenadë",
  GP: "Guadalup",
  GU: "Guam",
  GT: "Guatemalë",
  GN: "Guine",
  GW: "Guinea-Bisau",
  GY: "Guajanë",
  HT: "Haiti",
  HM: "Ishujt Hërd & Mekdonald",
  VA: "Vatikan",
  HN: "Honduras",
  HK: "RVA i Hong Kongut Kinë",
  HU: "Hungari",
  IS: "Islandë",
  IN: "Indi",
  ID: "Indonezi",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlandë",
  IL: "Izrael",
  IT: "Itali",
  JM: "Xhamajkë",
  JP: "Japoni",
  JO: "Jordani",
  KZ: "Kazakistan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Koreja e Veriut",
  KR: "Koreja e Jugut",
  KW: "Kuvajt",
  KG: "Kirgizstan",
  LA: "Laos",
  LV: "Letoni",
  LB: "Liban",
  LS: "Lesoto",
  LR: "Liberi",
  LY: "Libi",
  LI: "Lihtenshtein",
  LT: "Lituani",
  LU: "Luksemburg",
  MO: "RVA i Makaos Kinë",
  MG: "Madagaskar",
  MW: "Malavi",
  MY: "Malajzi",
  MV: "Maldive",
  ML: "Mali",
  MT: "Maltë",
  MH: "Ishujt Marshall",
  MQ: "Martinikë",
  MR: "Mauritani",
  MU: "Mauritius",
  YT: "Majote",
  MX: "Meksikë",
  FM: "Mikronezi",
  MD: "Moldavi",
  MC: "Monako",
  MN: "Mongoli",
  MS: "Montserat",
  MA: "Marok",
  MZ: "Mozambik",
  MM: "Mianmar (Burma)",
  NA: "Namibi",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Holandë",
  NC: "Kaledonia e Re",
  NZ: "Zelandë e Re",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeri",
  NU: "Niue",
  NF: "Ishujt Norfolk",
  MK: "Maqedoni",
  MP: "Ishujt Veriorë Mariana",
  NO: "Norvegji",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Territoret Palestineze",
  PA: "Panama",
  PG: "Papua Guineja e Re",
  PY: "Paraguai",
  PE: "Peru",
  PH: "Filipine",
  PN: "Ishujt Pitkern",
  PL: "Poloni",
  PT: "Portugali",
  PR: "Porto Riko",
  QA: "Katar",
  RE: "Reunion",
  RO: "Rumani",
  RU: "Rusi",
  RW: "Ruandë",
  SH: "Shën Helena",
  KN: "Shën Kits e Nevis",
  LC: "Shën Luçia",
  PM: "Shën Pier dhe Mikëlon",
  VC: "Shën Vinsent & Grenadinet",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome & Prinsipe",
  SA: "Arabi Saudite",
  SN: "Senegal",
  SC: "Sejshelle",
  SL: "Sierra Leone",
  SG: "Singapor",
  SK: "Sllovaki",
  SI: "Slloveni",
  SB: "Ishujt Solomon",
  SO: "Somali",
  ZA: "Afrikë e Jugut",
  GS: "Xhorxha Jugore dhe Ishujt Sanduiç të Jugut",
  ES: "Spanjë",
  LK: "Sri Lankë",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard & Zhan Majen",
  SZ: "Svaziland",
  SE: "Suedi",
  CH: "Zvicër",
  SY: "Siri",
  TW: "Tajvan",
  TJ: "Taxhikistan",
  TZ: "Tanzani",
  TH: "Tajlandë",
  TL: "Timori Lindor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad & Tobago",
  TN: "Tunizi",
  TR: "Turqi",
  TM: "Turkmenistan",
  TC: "Ishujt Turk & Kaikos",
  TV: "Tuvalu",
  UG: "Ugandë",
  UA: "Ukrainë",
  AE: "Emiratet e Bashkuara Arabe",
  GB: "Mbretëria e Bashkuar",
  US: "Shtetet e Bashkuara të Amerikës",
  UM: "Ishujt e Përtejmë SHBA-së",
  UY: "Uruguai",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuelë",
  VN: "Vietnam",
  VG: "Ishujt e Virgjër Britanikë",
  VI: "Ishujt e Virgjër Amerikanë",
  WF: "Uollis e Futuna",
  EH: "Sahara Perëndimore",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabve",
  AX: "Ishujt Aland",
  BQ: "Karaibet Holandeze",
  CW: "Kurasao",
  GG: "Gërnsi",
  IM: "Ishulli i Robit",
  JE: "Xhërsi",
  ME: "Mali i Zi",
  BL: "Shën Bartolomeo",
  MF: "Shën Martin",
  RS: "Serbi",
  SX: "Shën Martin",
  SS: "Sudan i Jugut",
  XK: "Kosovë"
}, xL = {
  locale: w4,
  countries: S4
}, kL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: S4,
  default: xL,
  locale: w4
}, Symbol.toStringTag, { value: "Module" })), C4 = "sr", x4 = {
  AD: "Андора",
  AE: "Уједињени Арапски Емирати",
  AF: "Авганистан",
  AG: "Антигва и Барбуда",
  AI: "Ангвила",
  AL: "Албанија",
  AM: "Јерменија",
  AO: "Ангола",
  AQ: "Антарктик",
  AR: "Аргентина",
  AS: "Америчка Самоа",
  AT: "Аустрија",
  AU: "Аустралија",
  AW: "Аруба",
  AX: "Оландска Острва",
  AZ: "Азербејџан",
  BA: "Босна и Херцеговина",
  BB: "Барбадос",
  BD: "Бангладеш",
  BE: "Белгија",
  BF: "Буркина Фасо",
  BG: "Бугарска",
  BH: "Бахреин",
  BI: "Бурунди",
  BJ: "Бенин",
  BL: "Сен Бартелеми",
  BM: "Бермуда",
  BN: "Брунеј",
  BO: "Боливија",
  BQ: "Карипска Холандија",
  BR: "Бразил",
  BS: "Бахами",
  BT: "Бутан",
  BV: "Острво Буве",
  BW: "Боцвана",
  BY: "Белорусија",
  BZ: "Белизе",
  CA: "Канада",
  CC: "Кокосова (Килингова) Острва",
  CD: "Конго - Киншаса",
  CF: "Централноафричка Република",
  CG: "Конго - Бразавил",
  CH: "Швајцарска",
  CI: "Обала Слоноваче",
  CK: "Кукова Острва",
  CL: "Чиле",
  CM: "Камерун",
  CN: "Кина",
  CO: "Колумбија",
  CR: "Костарика",
  CU: "Куба",
  CV: "Зеленортска Острва",
  CW: "Курасао",
  CX: "Божићно Острво",
  CY: "Кипар",
  CZ: "Чешка",
  DE: "Немачка",
  DJ: "Џибути",
  DK: "Данска",
  DM: "Доминика",
  DO: "Доминиканска Република",
  DZ: "Алжир",
  EC: "Еквадор",
  EE: "Естонија",
  EG: "Египат",
  EH: "Западна Сахара",
  ER: "Еритреја",
  ES: "Шпанија",
  ET: "Етиопија",
  FI: "Финска",
  FJ: "Фиџи",
  FK: "Фокландска Острва",
  FM: "Микронезија",
  FO: "Фарска Острва",
  FR: "Француска",
  GA: "Габон",
  GB: "Уједињено Краљевство",
  GD: "Гренада",
  GE: "Грузија",
  GF: "Француска Гвајана",
  GG: "Гернзи",
  GH: "Гана",
  GI: "Гибралтар",
  GL: "Гренланд",
  GM: "Гамбија",
  GN: "Гвинеја",
  GP: "Гваделуп",
  GQ: "Екваторијална Гвинеја",
  GR: "Грчка",
  GS: "Јужна Џорџија и Јужна Сендвичка Острва",
  GT: "Гватемала",
  GU: "Гуам",
  GW: "Гвинеја-Бисао",
  GY: "Гвајана",
  HK: "САР Хонгконг (Кина)",
  HM: "Острво Херд и Мекдоналдова острва",
  HN: "Хондурас",
  HR: "Хрватска",
  HT: "Хаити",
  HU: "Мађарска",
  ID: "Индонезија",
  IE: "Ирска",
  IL: "Израел",
  IM: "Острво Ман",
  IN: "Индија",
  IO: "Британска територија Индијског океана",
  IQ: "Ирак",
  IR: "Иран",
  IS: "Исланд",
  IT: "Италија",
  JE: "Џерзи",
  JM: "Јамајка",
  JO: "Јордан",
  JP: "Јапан",
  KE: "Кенија",
  KG: "Киргистан",
  KH: "Камбоџа",
  KI: "Кирибати",
  KM: "Коморска Острва",
  KN: "Сент Китс и Невис",
  KP: "Северна Кореја",
  KR: "Јужна Кореја",
  KW: "Кувајт",
  KY: "Кајманска Острва",
  KZ: "Казахстан",
  LA: "Лаос",
  LB: "Либан",
  LC: "Света Луција",
  LI: "Лихтенштајн",
  LK: "Шри Ланка",
  LR: "Либерија",
  LS: "Лесото",
  LT: "Литванија",
  LU: "Луксембург",
  LV: "Летонија",
  LY: "Либија",
  MA: "Мароко",
  MC: "Монако",
  MD: "Молдавија",
  ME: "Црна Гора",
  MF: "Свети Мартин (Француска)",
  MG: "Мадагаскар",
  MH: "Маршалска Острва",
  MK: "Северна Македонија",
  ML: "Мали",
  MM: "Мијанмар (Бурма)",
  MN: "Монголија",
  MO: "САР Макао (Кина)",
  MP: "Северна Маријанска Острва",
  MQ: "Мартиник",
  MR: "Мауританија",
  MS: "Монсерат",
  MT: "Малта",
  MU: "Маурицијус",
  MV: "Малдиви",
  MW: "Малави",
  MX: "Мексико",
  MY: "Малезија",
  MZ: "Мозамбик",
  NA: "Намибија",
  NC: "Нова Каледонија",
  NE: "Нигер",
  NF: "Острво Норфок",
  NG: "Нигерија",
  NI: "Никарагва",
  NL: "Холандија",
  NO: "Норвешка",
  NP: "Непал",
  NR: "Науру",
  NU: "Ниуе",
  NZ: "Нови Зеланд",
  OM: "Оман",
  PA: "Панама",
  PE: "Перу",
  PF: "Француска Полинезија",
  PG: "Папуа Нова Гвинеја",
  PH: "Филипини",
  PK: "Пакистан",
  PL: "Пољска",
  PM: "Сен Пјер и Микелон",
  PN: "Питкерн",
  PR: "Порторико",
  PS: "Палестинске територије",
  PT: "Португалија",
  PW: "Палау",
  PY: "Парагвај",
  QA: "Катар",
  RE: "Реинион",
  RO: "Румунија",
  RS: "Србија",
  RU: "Русија",
  RW: "Руанда",
  SA: "Саудијска Арабија",
  SB: "Соломонска Острва",
  SC: "Сејшели",
  SD: "Судан",
  SE: "Шведска",
  SG: "Сингапур",
  SH: "Света Јелена",
  SI: "Словенија",
  SJ: "Свалбард и Јан Мајен",
  SK: "Словачка",
  SL: "Сијера Леоне",
  SM: "Сан Марино",
  SN: "Сенегал",
  SO: "Сомалија",
  SR: "Суринам",
  SS: "Јужни Судан",
  ST: "Сао Томе и Принципе",
  SV: "Салвадор",
  SX: "Свети Мартин (Холандија)",
  SY: "Сирија",
  SZ: "Свазиленд",
  TC: "Острва Туркс и Каикос",
  TD: "Чад",
  TF: "Француске Јужне Територије",
  TG: "Того",
  TH: "Тајланд",
  TJ: "Таџикистан",
  TK: "Токелау",
  TL: "Источни Тимор",
  TM: "Туркменистан",
  TN: "Тунис",
  TO: "Тонга",
  TR: "Турска",
  TT: "Тринидад и Тобаго",
  TV: "Тувалу",
  TW: "Тајван",
  TZ: "Танзанија",
  UA: "Украјина",
  UG: "Уганда",
  UM: "Удаљена острва САД",
  US: "Сједињене Државе",
  UY: "Уругвај",
  UZ: "Узбекистан",
  VA: "Ватикан",
  VC: "Сент Винсент и Гренадини",
  VE: "Венецуела",
  VG: "Британска Девичанска Острва",
  VI: "Америчка Девичанска Острва",
  VN: "Вијетнам",
  VU: "Вануату",
  WF: "Валис и Футуна",
  WS: "Самоа",
  XK: "Косово",
  YE: "Јемен",
  YT: "Мајот",
  ZA: "Јужноафричка Република",
  ZM: "Замбија",
  ZW: "Зимбабве"
}, EL = {
  locale: C4,
  countries: x4
}, PL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: x4,
  default: EL,
  locale: C4
}, Symbol.toStringTag, { value: "Module" })), k4 = "sv", E4 = {
  AD: "Andorra",
  AE: "Förenade Arabemiraten",
  AF: "Afghanistan",
  AG: "Antigua och Barbuda",
  AI: "Anguilla",
  AL: "Albanien",
  AM: "Armenien",
  AO: "Angola",
  AQ: "Antarktis",
  AR: "Argentina",
  AS: "Amerikanska Samoa",
  AT: "Österrike",
  AU: "Australien",
  AW: "Aruba",
  AX: "Åland",
  AZ: "Azerbajdzjan",
  BA: "Bosnien och Hercegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgien",
  BF: "Burkina Faso",
  BG: "Bulgarien",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint-Barthélemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Bonaire, Saint Eustatius och Saba",
  BR: "Brasilien",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvetön",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Kokosöarna",
  CD: "Demokratiska republiken Kongo",
  CF: "Centralafrikanska republiken",
  CG: "Kongo-Brazzaville",
  CH: "Schweiz",
  CI: "Elfenbenskusten",
  CK: "Cooköarna",
  CL: "Chile",
  CM: "Kamerun",
  CN: "Kina",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Kuba",
  CV: "Kap Verde",
  CW: "Curacao",
  CX: "Julön",
  CY: "Cypern",
  CZ: "Tjeckien",
  DE: "Tyskland",
  DJ: "Djibouti",
  DK: "Danmark",
  DM: "Dominica",
  DO: "Dominikanska republiken",
  DZ: "Algeriet",
  EC: "Ecuador",
  EE: "Estland",
  EG: "Egypten",
  EH: "Västsahara",
  ER: "Eritrea",
  ES: "Spanien",
  ET: "Etiopien",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falklandsöarna",
  FM: "Mikronesiska federationen",
  FO: "Färöarna",
  FR: "Frankrike",
  GA: "Gabon",
  GB: "Storbritannien",
  GD: "Grenada",
  GE: "Georgien",
  GF: "Franska Guyana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Grönland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Ekvatorialguinea",
  GR: "Grekland",
  GS: "Sydgeorgien och Sydsandwichöarna",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea Bissau",
  GY: "Guyana",
  HK: "Hongkong",
  HM: "Heard- och McDonaldsöarna",
  HN: "Honduras",
  HR: "Kroatien",
  HT: "Haiti",
  HU: "Ungern",
  ID: "Indonesien",
  IE: "Irland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "Indien",
  IO: "Brittiska territoriet i Indiska Oceanen",
  IQ: "Irak",
  IR: "Iran",
  IS: "Island",
  IT: "Italien",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordanien",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kirgizistan",
  KH: "Kambodja",
  KI: "Kiribati",
  KM: "Komorerna",
  KN: "Saint Kitts och Nevis",
  KP: "Nordkorea",
  KR: "Sydkorea",
  KW: "Kuwait",
  KY: "Caymanöarna",
  KZ: "Kazakstan",
  LA: "Laos",
  LB: "Libanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Litauen",
  LU: "Luxemburg",
  LV: "Lettland",
  LY: "Libyen",
  MA: "Marocko",
  MC: "Monaco",
  MD: "Moldavien",
  ME: "Montenegro",
  MF: "Saint Martin (franska delen)",
  MG: "Madagaskar",
  MH: "Marshallöarna",
  MK: "Nordmakedonien",
  ML: "Mali",
  MM: "Burma",
  MN: "Mongoliet",
  MO: "Macau",
  MP: "Nordmarianerna",
  MQ: "Martinique",
  MR: "Mauretanien",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldiverna",
  MW: "Malawi",
  MX: "Mexiko",
  MY: "Malaysia",
  MZ: "Moçambique",
  NA: "Namibia",
  NC: "Nya Kaledonien",
  NE: "Niger",
  NF: "Norfolkön",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Nederländerna",
  NO: "Norge",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nya Zeeland",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Franska Polynesien",
  PG: "Papua Nya Guinea",
  PH: "Filippinerna",
  PK: "Pakistan",
  PL: "Polen",
  PM: "Saint-Pierre och Miquelon",
  PN: "Pitcairnöarna",
  PR: "Puerto Rico",
  PS: "Palestinska territoriet, ockuperade",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Rumänien",
  RS: "Serbien",
  RU: "Ryssland",
  RW: "Rwanda",
  SA: "Saudiarabien",
  SB: "Salomonöarna",
  SC: "Seychellerna",
  SD: "Sudan",
  SE: "Sverige",
  SG: "Singapore",
  SH: "Sankta Helena",
  SI: "Slovenien",
  SJ: "Svalbard och Jan Mayen",
  SK: "Slovakien",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Surinam",
  SS: "Sydsudan",
  ST: "São Tomé och Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten (nederländska delen)",
  SY: "Syrien",
  SZ: "Eswatini",
  TC: "Turks- och Caicosöarna",
  TD: "Tchad",
  TF: "Franska södra territorierna",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tadzjikistan",
  TK: "Tokelauöarna",
  TL: "Östtimor",
  TM: "Turkmenistan",
  TN: "Tunisien",
  TO: "Tonga",
  TR: "Turkiet",
  TT: "Trinidad och Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraina",
  UG: "Uganda",
  UM: "USA:s yttre öar",
  US: "USA",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Vatikanstaten",
  VC: "Saint Vincent och Grenadinerna",
  VE: "Venezuela",
  VG: "Brittiska Jungfruöarna",
  VI: "Amerikanska Jungfruöarna",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis- och Futunaöarna",
  WS: "Samoa",
  YE: "Jemen",
  YT: "Mayotte",
  ZA: "Sydafrika",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  XK: "Kosovo"
}, TL = {
  locale: k4,
  countries: E4
}, ML = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: E4,
  default: TL,
  locale: k4
}, Symbol.toStringTag, { value: "Module" })), P4 = "th", T4 = {
  BD: "บังกลาเทศ",
  BE: "เบลเยียม",
  BF: "บูร์กินาฟาโซ",
  BG: "บัลแกเรีย",
  BA: "บอสเนียและเฮอร์เซโกวีนา",
  BB: "บาร์เบโดส",
  WF: "วาลลิสและฟุตูนา",
  BL: "เซนต์บาร์เธเลมี",
  BM: "เบอร์มิวดา",
  BN: "บรูไน",
  BO: "โบลิเวีย",
  BH: "บาห์เรน",
  BI: "บุรุนดี",
  BJ: "เบนิน",
  BT: "ภูฏาน",
  JM: "จาเมกา",
  BV: "เกาะบูเวต",
  BW: "บอตสวานา",
  WS: "ซามัว",
  BR: "บราซิล",
  BS: "บาฮามาส",
  JE: "เจอร์ซีย์",
  BY: "เบลารุส",
  BZ: "เบลีซ",
  RU: "รัสเซีย",
  RW: "รวันดา",
  RS: "เซอร์เบีย",
  TL: "ติมอร์ตะวันออก",
  RE: "เรอูนียง",
  TM: "เติร์กเมนิสถาน",
  TJ: "ทาจิกิสถาน",
  RO: "โรมาเนีย",
  TK: "โตเกเลา",
  GW: "กินี-บิสเซา",
  GU: "กวม",
  GT: "กัวเตมาลา",
  GS: "เกาะเซาท์จอร์เจียและหมู่เกาะเซาท์แซนด์วิช",
  GR: "กรีซ",
  GQ: "อิเควทอเรียลกินี",
  GP: "กวาเดอลูป",
  JP: "ญี่ปุ่น",
  GY: "กายอานา",
  GG: "เกิร์นซีย์",
  GF: "เฟรนช์เกียนา",
  GE: "จอร์เจีย",
  GD: "เกรเนดา",
  GB: "สหราชอาณาจักร",
  GA: "กาบอง",
  SV: "เอลซัลวาดอร์",
  GN: "กินี",
  GM: "แกมเบีย",
  GL: "กรีนแลนด์",
  GI: "ยิบรอลตาร์",
  GH: "กานา",
  OM: "โอมาน",
  TN: "ตูนิเซีย",
  JO: "จอร์แดน",
  HR: "โครเอเชีย",
  HT: "เฮติ",
  HU: "ฮังการี",
  HK: "ฮ่องกง เขตปกครองพิเศษประเทศจีน",
  HN: "ฮอนดูรัส",
  HM: "เกาะเฮิร์ดและหมู่เกาะแมกดอนัลด์",
  VE: "เวเนซุเอลา",
  PR: "เปอร์โตริโก",
  PS: "ปาเลสไตน์",
  PW: "ปาเลา",
  PT: "โปรตุเกส",
  SJ: "สฟาลบาร์และยานไมเอน",
  PY: "ปารากวัย",
  IQ: "อิรัก",
  PA: "ปานามา",
  PF: "เฟรนช์โปลินีเซีย",
  PG: "ปาปัวนิวกินี",
  PE: "เปรู",
  PK: "ปากีสถาน",
  PH: "ฟิลิปปินส์",
  PN: "พิตแคร์น",
  PL: "โปแลนด์",
  PM: "แซงปีแยร์และมีเกอลง",
  ZM: "แซมเบีย",
  EH: "ซาฮาราตะวันตก",
  EE: "เอสโตเนีย",
  EG: "อียิปต์",
  ZA: "แอฟริกาใต้",
  EC: "เอกวาดอร์",
  IT: "อิตาลี",
  VN: "เวียดนาม",
  SB: "หมู่เกาะโซโลมอน",
  ET: "เอธิโอเปีย",
  SO: "โซมาเลีย",
  ZW: "ซิมบับเว",
  SA: "ซาอุดีอาระเบีย",
  ES: "สเปน",
  ER: "เอริเทรีย",
  ME: "มอนเตเนโกร",
  MD: "มอลโดวา",
  MG: "มาดากัสการ์",
  MF: "เซนต์มาติน",
  MA: "โมร็อกโก",
  MC: "โมนาโก",
  UZ: "อุซเบกิสถาน",
  MM: "เมียนม่าร์ [พม่า]",
  ML: "มาลี",
  MO: "มาเก๊า เขตปกครองพิเศษประเทศจีน",
  MN: "มองโกเลีย",
  MH: "หมู่เกาะมาร์แชลล์",
  MK: "มาซิโดเนีย",
  MU: "มอริเชียส",
  MT: "มอลตา",
  MW: "มาลาวี",
  MV: "มัลดีฟส์",
  MQ: "มาร์ตินีก",
  MP: "หมู่เกาะนอร์เทิร์นมาเรียนา",
  MS: "มอนต์เซอร์รัต",
  MR: "มอริเตเนีย",
  IM: "เกาะแมน",
  UG: "ยูกันดา",
  TZ: "แทนซาเนีย",
  MY: "มาเลเซีย",
  MX: "เม็กซิโก",
  IL: "อิสราเอล",
  FR: "ฝรั่งเศส",
  IO: "บริติชอินเดียนโอเชียนเทร์ริทอรี",
  SH: "เซนต์เฮเลนา",
  FI: "ฟินแลนด์",
  FJ: "ฟิจิ",
  FK: "หมู่เกาะฟอล์กแลนด์",
  FM: "ไมโครนีเซีย",
  FO: "หมู่เกาะแฟโร",
  NI: "นิการากัว",
  NL: "เนเธอร์แลนด์",
  NO: "นอร์เวย์",
  NA: "นามิเบีย",
  VU: "วานูอาตู",
  NC: "นิวแคลิโดเนีย",
  NE: "ไนเจอร์",
  NF: "เกาะนอร์ฟอล์ก",
  NG: "ไนจีเรีย",
  NZ: "นิวซีแลนด์",
  NP: "เนปาล",
  NR: "นาอูรู",
  NU: "นีอูเอ",
  CK: "หมู่เกาะคุก",
  CI: "ไอวอรี่โคสต์",
  CH: "สวิตเซอร์แลนด์",
  CO: "โคลอมเบีย",
  CN: "จีน",
  CM: "แคเมอรูน",
  CL: "ชิลี",
  CC: "หมู่เกาะโคโคส",
  CA: "แคนาดา",
  CG: "คองโก-บราซซาวิล",
  CF: "สาธารณรัฐแอฟริกากลาง",
  CD: "คองโก-กินชาซา",
  CZ: "สาธารณรัฐเช็ก",
  CY: "ไซปรัส",
  CX: "เกาะคริสต์มาส",
  CR: "คอสตาริกา",
  CV: "เคปเวิร์ด",
  CU: "คิวบา",
  SZ: "สวาซิแลนด์",
  SY: "ซีเรีย",
  KG: "คีร์กีซสถาน",
  KE: "เคนยา",
  SR: "ซูรินาเม",
  KI: "คิริบาส",
  KH: "กัมพูชา",
  KN: "เซนต์คิตส์และเนวิส",
  KM: "คอโมโรส",
  ST: "เซาตูเมและปรินซิปี",
  SK: "สโลวะเกีย",
  KR: "เกาหลีใต้",
  SI: "สโลวีเนีย",
  KP: "เกาหลีเหนือ",
  KW: "คูเวต",
  SN: "เซเนกัล",
  SM: "ซานมารีโน",
  SL: "เซียร์ราลีโอน",
  SC: "เซเชลส์",
  KZ: "คาซัคสถาน",
  KY: "หมู่เกาะเคย์แมน",
  SG: "สิงคโปร์",
  SE: "สวีเดน",
  SD: "ซูดาน",
  DO: "สาธารณรัฐโดมินิกัน",
  DM: "โดมินิกา",
  DJ: "จิบูตี",
  DK: "เดนมาร์ก",
  VG: "หมู่เกาะบริติชเวอร์จิน",
  DE: "เยอรมนี",
  YE: "เยเมน",
  DZ: "แอลจีเรีย",
  US: "สหรัฐอเมริกา",
  UY: "อุรุกวัย",
  YT: "มายอต",
  UM: "หมู่เกาะสหรัฐไมเนอร์เอาต์ไลอิง",
  LB: "เลบานอน",
  LC: "เซนต์ลูเซีย",
  LA: "ลาว",
  TV: "ตูวาลู",
  TW: "ไต้หวัน",
  TT: "ตรินิแดดและโตเบโก",
  TR: "ตุรกี",
  LK: "ศรีลังกา",
  LI: "ลิกเตนสไตน์",
  LV: "ลัตเวีย",
  TO: "ตองกา",
  LT: "ลิทัวเนีย",
  LU: "ลักเซมเบิร์ก",
  LR: "ไลบีเรีย",
  LS: "เลโซโท",
  TH: "ไทย",
  TF: "เฟรนช์เซาเทิร์นเทร์ริทอรีส์",
  TG: "โตโก",
  TD: "ชาด",
  TC: "หมู่เกาะเติกส์และหมู่เกาะเคคอส",
  LY: "ลิเบีย",
  VA: "วาติกัน",
  VC: "เซนต์วินเซนต์และเกรนาดีนส์",
  AE: "สหรัฐอาหรับเอมิเรตส์",
  AD: "อันดอร์รา",
  AG: "แอนติกาและบาร์บูดา",
  AF: "อัฟกานิสถาน",
  AI: "แองกวิลลา",
  VI: "หมู่เกาะยูเอสเวอร์จิน",
  IS: "ไอซ์แลนด์",
  IR: "อิหร่าน",
  AM: "อาร์เมเนีย",
  AL: "แอลเบเนีย",
  AO: "แองโกลา",
  AQ: "แอนตาร์กติกา",
  AS: "อเมริกันซามัว",
  AR: "อาร์เจนตินา",
  AU: "ออสเตรเลีย",
  AT: "ออสเตรีย",
  AW: "อารูบา",
  IN: "อินเดีย",
  AX: "หมู่เกาะโอลันด์",
  AZ: "อาเซอร์ไบจาน",
  IE: "ไอร์แลนด์",
  ID: "อินโดนีเซีย",
  UA: "ยูเครน",
  QA: "กาตาร์",
  MZ: "โมซัมบิก",
  BQ: "โบแนร์, ซินท์เอิสทาทิอุส, ซาบา",
  CW: "คูราเซา",
  SX: "Sint Maarten (ส่วนดัตช์)",
  SS: "ซูดานใต้",
  XK: "โคโซโว"
}, OL = {
  locale: P4,
  countries: T4
}, AL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: T4,
  default: OL,
  locale: P4
}, Symbol.toStringTag, { value: "Module" })), M4 = "tr", O4 = {
  AD: "Andorra",
  AE: "Birleşik Arap Emirlikleri",
  AF: "Afganistan",
  AG: "Antigua ve Barbuda",
  AI: "Anguilla",
  AL: "Arnavutluk",
  AM: "Ermenistan",
  AO: "Angola",
  AQ: "Antarktika",
  AR: "Arjantin",
  AS: "Amerikan Samoası",
  AT: "Avusturya",
  AU: "Avustralya",
  AW: "Aruba",
  AX: "Åland Adaları",
  AZ: "Azerbaycan",
  BA: "Bosna Hersek",
  BB: "Barbados",
  BD: "Bangladeş",
  BE: "Belçika",
  BF: "Burkina Faso",
  BG: "Bulgaristan",
  BH: "Bahreyn",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthelemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivya",
  BQ: "Karayip Hollanda",
  BR: "Brezilya",
  BS: "Bahamalar",
  BT: "Butan",
  BV: "Bouvet Adası",
  BW: "Botsvana",
  BY: "Beyaz Rusya",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Cocos (Keeling) Adaları",
  CD: "Kongo - Kinşasa",
  CF: "Orta Afrika Cumhuriyeti",
  CG: "Kongo - Brazavil",
  CH: "İsviçre",
  CI: "Fildişi Sahili",
  CK: "Cook Adaları",
  CL: "Şili",
  CM: "Kamerun",
  CN: "Çin",
  CO: "Kolombiya",
  CR: "Kosta Rika",
  CU: "Küba",
  CV: "Cape Verde",
  CW: "Curaçao",
  CX: "Christmas Adası",
  CY: "Güney Kıbrıs Rum Kesimi",
  CZ: "Çek Cumhuriyeti",
  DE: "Almanya",
  DJ: "Cibuti",
  DK: "Danimarka",
  DM: "Dominika",
  DO: "Dominik Cumhuriyeti",
  DZ: "Cezayir",
  EC: "Ekvador",
  EE: "Estonya",
  EG: "Mısır",
  EH: "Batı Sahara",
  ER: "Eritre",
  ES: "İspanya",
  ET: "Etiyopya",
  FI: "Finlandiya",
  FJ: "Fiji",
  FK: "Falkland Adaları",
  FM: "Mikronezya",
  FO: "Faroe Adaları",
  FR: "Fransa",
  GA: "Gabon",
  GB: "Birleşik Krallık",
  GD: "Grenada",
  GE: "Gürcistan",
  GF: "Fransız Guyanası",
  GG: "Guernsey",
  GH: "Gana",
  GI: "Cebelitarık",
  GL: "Grönland",
  GM: "Gambiya",
  GN: "Gine",
  GP: "Guadalupe",
  GQ: "Ekvator Ginesi",
  GR: "Yunanistan",
  GS: "Güney Georgia ve Güney Sandwich Adaları",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Gine-Bissau",
  GY: "Guyana",
  HK: "Çin Hong Kong ÖYB",
  HM: "Heard Adası ve McDonald Adaları",
  HN: "Honduras",
  HR: "Hırvatistan",
  HT: "Haiti",
  HU: "Macaristan",
  ID: "Endonezya",
  IE: "İrlanda",
  IL: "İsrail",
  IM: "Man Adası",
  IN: "Hindistan",
  IO: "Britanya Hint Okyanusu Toprakları",
  IQ: "Irak",
  IR: "İran",
  IS: "İzlanda",
  IT: "İtalya",
  JE: "Jersey",
  JM: "Jamaika",
  JO: "Ürdün",
  JP: "Japonya",
  KE: "Kenya",
  KG: "Kırgızistan",
  KH: "Kamboçya",
  KI: "Kiribati",
  KM: "Komorlar",
  KN: "Saint Kitts ve Nevis",
  KP: "Kuzey Kore",
  KR: "Güney Kore",
  KW: "Kuveyt",
  KY: "Cayman Adaları",
  KZ: "Kazakistan",
  LA: "Laos",
  LB: "Lübnan",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberya",
  LS: "Lesoto",
  LT: "Litvanya",
  LU: "Lüksemburg",
  LV: "Letonya",
  LY: "Libya",
  MA: "Fas",
  MC: "Monako",
  MD: "Moldova",
  ME: "Karadağ",
  MF: "Saint Martin",
  MG: "Madagaskar",
  MH: "Marshall Adaları",
  MK: "Kuzey Makedonya",
  ML: "Mali",
  MM: "Myanmar (Burma)",
  MN: "Moğolistan",
  MO: "Çin Makao ÖYB",
  MP: "Kuzey Mariana Adaları",
  MQ: "Martinik",
  MR: "Moritanya",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldivler",
  MW: "Malavi",
  MX: "Meksika",
  MY: "Malezya",
  MZ: "Mozambik",
  NA: "Namibya",
  NC: "Yeni Kaledonya",
  NE: "Nijer",
  NF: "Norfolk Adası",
  NG: "Nijerya",
  NI: "Nikaragua",
  NL: "Hollanda",
  NO: "Norveç",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Yeni Zelanda",
  OM: "Umman",
  PA: "Panama",
  PE: "Peru",
  PF: "Fransız Polinezyası",
  PG: "Papua Yeni Gine",
  PH: "Filipinler",
  PK: "Pakistan",
  PL: "Polonya",
  PM: "Saint Pierre ve Miquelon",
  PN: "Pitcairn Adaları",
  PR: "Porto Riko",
  PS: "Filistin Bölgeleri",
  PT: "Portekiz",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Katar",
  RE: "Réunion",
  RO: "Romanya",
  RS: "Sırbistan",
  RU: "Rusya",
  RW: "Ruanda",
  SA: "Suudi Arabistan",
  SB: "Solomon Adaları",
  SC: "Seyşeller",
  SD: "Sudan",
  SE: "İsveç",
  SG: "Singapur",
  SH: "Saint Helena",
  SI: "Slovenya",
  SJ: "Svalbard ve Jan Mayen Adaları",
  SK: "Slovakya",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somali",
  SR: "Surinam",
  SS: "Güney Sudan",
  ST: "São Tomé ve Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Suriye",
  SZ: "Svaziland",
  TC: "Turks ve Caicos Adaları",
  TD: "Çad",
  TF: "Fransız Güney Toprakları",
  TG: "Togo",
  TH: "Tayland",
  TJ: "Tacikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Türkmenistan",
  TN: "Tunus",
  TO: "Tonga",
  TR: "Türkiye",
  TT: "Trinidad ve Tobago",
  TV: "Tuvalu",
  TW: "Tayvan",
  TZ: "Tanzanya",
  UA: "Ukrayna",
  UG: "Uganda",
  UM: "ABD Uzak Adaları",
  US: [
    "ABD",
    "A.B.D.",
    "Amerika Birleşik Devletleri",
    "Birleşik Devletler",
    "Amerika"
  ],
  UY: "Uruguay",
  UZ: "Özbekistan",
  VA: "Vatikan",
  VC: "Saint Vincent ve Grenadinler",
  VE: "Venezuela",
  VG: "Britanya Virjin Adaları",
  VI: "ABD Virjin Adaları",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis ve Futuna Adaları",
  WS: "Samoa",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "Güney Afrika",
  ZM: "Zambiya",
  ZW: "Zimbabve",
  XK: "Kosova"
}, NL = {
  locale: M4,
  countries: O4
}, LL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: O4,
  default: NL,
  locale: M4
}, Symbol.toStringTag, { value: "Module" })), A4 = "uk", N4 = {
  AU: "Австралія",
  AT: "Австрія",
  AZ: "Азербайджан",
  AX: "Аландські Острови",
  AL: "Албанія",
  DZ: "Алжир",
  AS: "Американське Самоа",
  AI: "Ангілья",
  AO: "Ангола",
  AD: "Андорра",
  AQ: "Антарктика",
  AG: "Антигуа і Барбуда",
  MO: "Макао",
  AR: "Аргентина",
  AM: "Вірменія",
  AW: "Аруба",
  AF: "Афганістан",
  BS: "Багамські Острови",
  BD: "Бангладеш",
  BB: "Барбадос",
  BH: "Бахрейн",
  BZ: "Беліз",
  BE: "Бельгія",
  BJ: "Бенін",
  BM: "Бермудські Острови",
  BY: "Білорусь",
  BG: "Болгарія",
  BO: "Болівія",
  BA: "Боснія і Герцеговина",
  BW: "Ботсвана",
  BR: "Бразилія",
  IO: "Британська Територія в Індійському Океані",
  VG: "Британські Віргінські Острови",
  BN: "Бруней-Даруссалам",
  BF: "Буркіна-Фасо",
  BI: "Бурунді",
  BT: "Бутан",
  VU: "Вануату",
  VA: "Ватикан",
  GB: "Великобританія",
  VE: "Венесуела",
  VI: "Віргінські Острови (США)",
  WF: "Волліс і Футуна",
  VN: "В'єтнам",
  UM: "Зовнішні Віддалені Острови (США)",
  GA: "Габон",
  HT: "Гаїті",
  GY: "Гаяна",
  GM: "Гамбія",
  GH: "Гана",
  GP: "Гваделупа",
  GT: "Гватемала",
  GF: "Гвіана",
  GN: "Гвінея",
  GW: "Гвінея-Бісау",
  GG: "Гернсі",
  GI: "Гібралтар",
  HN: "Гондурас",
  HK: "Гонконг",
  GD: "Гренада",
  GR: "Греція",
  GE: "Грузія",
  GU: "Гуам",
  GL: "Гренландія",
  DK: "Данія",
  JE: "Джерсі",
  DJ: "Джибуті",
  DM: "Домініка",
  DO: "Домініканська Республіка",
  CD: "Демократична Республіка Конго",
  EC: "Еквадор",
  GQ: "Екваторіальна Гвінея",
  ER: "Еритрея",
  EE: "Естонія",
  ET: "Ефіопія",
  EG: "Єгипет",
  YE: "Ємен",
  ZM: "Замбія",
  ZW: "Зімбабве",
  IL: "Ізраїль",
  IN: "Індія",
  ID: "Індонезія",
  IQ: "Ірак",
  IR: "Іран",
  IE: "Ірландія",
  IS: "Ісландія",
  ES: "Іспанія",
  IT: "Італія",
  JO: "Йорданія",
  CV: "Кабо-Верде",
  KZ: "Казахстан",
  KY: "Кайманові Острови",
  KH: "Камбоджа",
  CM: "Камерун",
  CA: "Канада",
  BQ: "Карибські Нідерланди",
  QA: "Катар",
  KE: "Кенія",
  CY: "Кіпр",
  KI: "Кірибаті",
  KG: "Киргизстан",
  TW: "Тайвань, Провінція Китаю",
  KP: "Корейська Народно-Демократична Республіка",
  CN: "Китай",
  CC: "Кокосові Острови",
  CO: "Колумбія",
  KM: "Комори",
  XK: "Косово",
  CR: "Коста-Рика",
  CI: "Кот-Д'Івуар",
  CU: "Куба",
  KW: "Кувейт",
  CW: "Кюрасао",
  LA: "Лаос",
  LV: "Латвія",
  LS: "Лесото",
  LR: "Ліберія",
  LB: "Ліван",
  LY: "Лівія",
  LT: "Литва",
  LI: "Ліхтенштейн",
  LU: "Люксембург",
  MU: "Маврикій",
  MR: "Мавританія",
  MG: "Мадагаскар",
  YT: "Майотта",
  MW: "Малаві",
  MY: "Малайзія",
  ML: "Малі",
  MV: "Мальдіви",
  MT: "Мальта",
  MA: "Марокко",
  MQ: "Мартиніка",
  MH: "Маршаллові Острови",
  MX: "Мексика",
  FM: "Мікронезія",
  MZ: "Мозамбік",
  MD: "Молдова",
  MC: "Монако",
  MN: "Монголія",
  MS: "Монтсеррат",
  MM: "М'янма",
  NA: "Намібія",
  NR: "Науру",
  NP: "Непал",
  NE: "Нігер",
  NG: "Нігерія",
  NL: "Нідерланди",
  NI: "Нікарагуа",
  DE: "Німеччина",
  NU: "Ніуе",
  NZ: "Нова Зеландія",
  NC: "Нова Каледонія",
  NO: "Норвегія",
  AE: "Об'єднані Арабські Емірати",
  OM: "Оман",
  BV: "Острів Буве",
  HM: "Острів Герд і Острови Макдоналд",
  IM: "Острів Мен",
  NF: "Острів Норфолк",
  CX: "Острів Різдва",
  CK: "Острови Кука",
  SH: "Острів Святої Єлени",
  TC: "Острови Теркс і Кайкос",
  PK: "Пакистан",
  PW: "Палау",
  PS: "Палестина",
  PA: "Панама",
  PG: "Папуа-Нова Гвінея",
  ZA: "Південна Африка",
  PY: "Парагвай",
  PE: "Перу",
  GS: "Південна Джорджія та Південні Сандвічеві Острови",
  KR: "Республіка Корея",
  SS: "Південний Судан",
  MK: "Північна Македонія",
  MP: "Північні Маріанські Острови",
  PN: "Піткерн",
  PL: "Польща",
  PT: "Португалія",
  PR: "Пуерто-Рико",
  CG: "Конго",
  RE: "Реюньйон",
  RU: "Росія",
  RW: "Руанда",
  RO: "Румунія",
  EH: "Західна Сахара",
  SV: "Сальвадор",
  WS: "Самоа",
  SM: "Сан-Марино",
  ST: "Сан-Томе і Принсіпі",
  SA: "Саудівська Аравія",
  SZ: "Есватіні",
  SJ: "Острови Шпіцберген та Ян-Маєн",
  SC: "Сейшельські Острови",
  BL: "Сен-Бартелемі",
  MF: "Сен-Мартен",
  PM: "Сен-П'єр і Мікелон",
  SN: "Сенегал",
  VC: "Сент-Вінсент і Гренадіни",
  KN: "Сент-Кітс і Невіс",
  LC: "Сент-Люсія",
  RS: "Сербія",
  SG: "Сингапур",
  SX: "Сінт-Мартен",
  SY: "Сирія",
  SK: "Словаччина",
  SI: "Словенія",
  SB: "Соломонові Острови",
  SO: "Сомалі",
  SD: "Судан",
  SR: "Суринам",
  TL: "Тимор-Лешті",
  US: "США",
  SL: "Сьєрра-Леоне",
  TJ: "Таджикистан",
  TH: "Таїланд",
  TZ: "Танзанія",
  TG: "Того",
  TK: "Токелау",
  TO: "Тонга",
  TT: "Тринідад і Тобаго",
  TV: "Тувалу",
  TN: "Туніс",
  TM: "Туркменистан",
  TR: "Туреччина",
  UG: "Уганда",
  HU: "Угорщина",
  UZ: "Узбекистан",
  UA: "Україна",
  UY: "Уругвай",
  FO: "Фарерські Острови",
  FJ: "Фіджі",
  PH: "Філіппіни",
  FI: "Фінляндія",
  FK: "Фолклендські Острови",
  FR: "Франція",
  PF: "Французька Полінезія",
  TF: "Французькі Південні і Антарктичні Території",
  HR: "Хорватія",
  CF: "Центральноафриканська Республіка",
  TD: "Чад",
  ME: "Чорногорія",
  CZ: "Чехія",
  CL: "Чилі",
  CH: "Швейцарія",
  SE: "Швеція",
  LK: "Шри-Ланка",
  JM: "Ямайка",
  JP: "Японія"
}, RL = {
  locale: A4,
  countries: N4
}, DL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: N4,
  default: RL,
  locale: A4
}, Symbol.toStringTag, { value: "Module" })), L4 = "zh", R4 = {
  AD: "安道尔",
  AE: "阿联酋",
  AF: "阿富汗",
  AG: "安提瓜和巴布达",
  AI: "安圭拉",
  AL: "阿尔巴尼亚",
  AM: "亚美尼亚",
  AO: "安哥拉",
  AQ: "南极洲",
  AR: "阿根廷",
  AS: "美属萨摩亚",
  AT: "奥地利",
  AU: "澳大利亚",
  AW: "阿鲁巴",
  AX: "奥兰",
  AZ: "阿塞拜疆",
  BA: "波黑",
  BB: "巴巴多斯",
  BD: "孟加拉国",
  BE: "比利时",
  BF: "布基纳法索",
  BG: "保加利亚",
  BH: "巴林",
  BI: "布隆迪",
  BJ: "贝宁",
  BL: "圣巴泰勒米",
  BM: "百慕大",
  BN: "文莱",
  BO: "玻利维亚",
  BQ: "荷兰加勒比区",
  BR: "巴西",
  BS: "巴哈马",
  BT: "不丹",
  BV: "布韦岛",
  BW: "博茨瓦纳",
  BY: "白俄罗斯",
  BZ: "伯利兹",
  CA: "加拿大",
  CC: "科科斯（基林）群岛",
  CD: "刚果（金）",
  CF: "中非",
  CG: "刚果（布）",
  CH: "瑞士",
  CI: "科特迪瓦",
  CK: "库克群岛",
  CL: "智利",
  CM: "喀麦隆",
  CN: "中国",
  CO: "哥伦比亚",
  CR: "哥斯达黎加",
  CU: "古巴",
  CV: "佛得角",
  CW: "库拉索",
  CX: "圣诞岛",
  CY: "塞浦路斯",
  CZ: "捷克",
  DE: "德国",
  DJ: "吉布提",
  DK: "丹麦",
  DM: "多米尼克",
  DO: "多米尼加",
  DZ: "阿尔及利亚",
  EC: "厄瓜多尔",
  EE: "爱沙尼亚",
  EG: "埃及",
  EH: "阿拉伯撒哈拉民主共和国",
  ER: "厄立特里亚",
  ES: "西班牙",
  ET: "埃塞俄比亚",
  FI: "芬兰",
  FJ: "斐济",
  FK: "福克兰群岛",
  FM: "密克罗尼西亚联邦",
  FO: "法罗群岛",
  FR: "法国",
  GA: "加蓬",
  GB: "英国",
  GD: "格林纳达",
  GE: "格鲁吉亚",
  GF: "法属圭亚那",
  GG: "根西",
  GH: "加纳",
  GI: "直布罗陀",
  GL: "格陵兰",
  GM: "冈比亚",
  GN: "几内亚",
  GP: "瓜德罗普",
  GQ: "赤道几内亚",
  GR: "希腊",
  GS: "南乔治亚和南桑威奇群岛",
  GT: "危地马拉",
  GU: "关岛",
  GW: "几内亚比绍",
  GY: "圭亚那",
  HK: "香港",
  HM: "赫德岛和麦克唐纳群岛",
  HN: "洪都拉斯",
  HR: "克罗地亚",
  HT: "海地",
  HU: "匈牙利",
  ID: "印尼",
  IE: "爱尔兰",
  IL: "以色列",
  IM: "马恩岛",
  IN: "印度",
  IO: "英属印度洋领地",
  IQ: "伊拉克",
  IR: "伊朗",
  IS: "冰岛",
  IT: "意大利",
  JE: "泽西",
  JM: "牙买加",
  JO: "约旦",
  JP: "日本",
  KE: "肯尼亚",
  KG: "吉尔吉斯斯坦",
  KH: "柬埔寨",
  KI: "基里巴斯",
  KM: "科摩罗",
  KN: "圣基茨和尼维斯",
  KP: "朝鲜",
  KR: "韩国",
  KW: "科威特",
  KY: "开曼群岛",
  KZ: "哈萨克斯坦",
  LA: "老挝",
  LB: "黎巴嫩",
  LC: "圣卢西亚",
  LI: "列支敦士登",
  LK: "斯里兰卡",
  LR: "利比里亚",
  LS: "莱索托",
  LT: "立陶宛",
  LU: "卢森堡",
  LV: "拉脱维亚",
  LY: "利比亚",
  MA: "摩洛哥",
  MC: "摩纳哥",
  MD: "摩尔多瓦",
  ME: "黑山",
  MF: "法属圣马丁",
  MG: "马达加斯加",
  MH: "马绍尔群岛",
  MK: "北马其顿",
  ML: "马里",
  MM: "缅甸",
  MN: "蒙古",
  MO: "澳门",
  MP: "北马里亚纳群岛",
  MQ: "马提尼克",
  MR: "毛里塔尼亚",
  MS: "蒙特塞拉特",
  MT: "马耳他",
  MU: "毛里求斯",
  MV: "马尔代夫",
  MW: "马拉维",
  MX: "墨西哥",
  MY: "马来西亚",
  MZ: "莫桑比克",
  NA: "纳米比亚",
  NC: "新喀里多尼亚",
  NE: "尼日尔",
  NF: "诺福克岛",
  NG: "尼日利亚",
  NI: "尼加拉瓜",
  NL: "荷兰",
  NO: "挪威",
  NP: "尼泊尔",
  NR: "瑙鲁",
  NU: "纽埃",
  NZ: "新西兰",
  OM: "阿曼",
  PA: "巴拿马",
  PE: "秘鲁",
  PF: "法属波利尼西亚",
  PG: "巴布亚新几内亚",
  PH: "菲律宾",
  PK: "巴基斯坦",
  PL: "波兰",
  PM: "圣皮埃尔和密克隆",
  PN: "皮特凯恩群岛",
  PR: "波多黎各",
  PS: "巴勒斯坦",
  PT: "葡萄牙",
  PW: "帕劳",
  PY: "巴拉圭",
  QA: "卡塔尔",
  RE: "留尼汪",
  RO: "罗马尼亚",
  RS: "塞尔维亚",
  RU: "俄罗斯",
  RW: "卢旺达",
  SA: "沙特阿拉伯",
  SB: "所罗门群岛",
  SC: "塞舌尔",
  SD: "苏丹",
  SE: "瑞典",
  SG: "新加坡",
  SH: "圣赫勒拿、阿森松和特里斯坦-达库尼亚",
  SI: "斯洛文尼亚",
  SJ: "斯瓦尔巴和扬马延",
  SK: "斯洛伐克",
  SL: "塞拉利昂",
  SM: "圣马力诺",
  SN: "塞内加尔",
  SO: "索马里",
  SR: "苏里南",
  SS: "南苏丹",
  ST: "圣多美和普林西比",
  SV: "萨尔瓦多",
  SX: "荷属圣马丁",
  SY: "叙利亚",
  SZ: "斯威士兰",
  TC: "特克斯和凯科斯群岛",
  TD: "乍得",
  TF: "法属南部领地",
  TG: "多哥",
  TH: "泰国",
  TJ: "塔吉克斯坦",
  TK: "托克劳",
  TL: "东帝汶",
  TM: "土库曼斯坦",
  TN: "突尼斯",
  TO: "汤加",
  TR: "土耳其",
  TT: "特立尼达和多巴哥",
  TV: "图瓦卢",
  TW: "中国台湾省",
  TZ: "坦桑尼亚",
  UA: "乌克兰",
  UG: "乌干达",
  UM: "美国本土外小岛屿",
  US: "美国",
  UY: "乌拉圭",
  UZ: "乌兹别克斯坦",
  VA: "梵蒂冈",
  VC: "圣文森特和格林纳丁斯",
  VE: "委内瑞拉",
  VG: "英属维尔京群岛",
  VI: "美属维尔京群岛",
  VN: "越南",
  VU: "瓦努阿图",
  WF: "瓦利斯和富图纳",
  WS: "萨摩亚",
  XK: "科索沃",
  YE: "也门",
  YT: "马约特",
  ZA: "南非",
  ZM: "赞比亚",
  ZW: "津巴布韦"
}, IL = {
  locale: L4,
  countries: R4
}, jL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: R4,
  default: IL,
  locale: L4
}, Symbol.toStringTag, { value: "Module" })), BL = {
  ar: jN,
  cs: FN,
  da: GN,
  de: KN,
  el: $N,
  en: WN,
  es: ZN,
  fr: JN,
  hi: QN,
  hu: tL,
  id: nL,
  it: oL,
  ja: sL,
  nl: cL,
  no: dL,
  pl: hL,
  pt: fL,
  ro: yL,
  ru: bL,
  sk: wL,
  sl: CL,
  sq: kL,
  sr: PL,
  sv: ML,
  th: AL,
  tr: LL,
  uk: DL,
  zh: jL
};
Object.values(BL).forEach((e) => {
  M1.registerLocale(e.default);
});
const FL = (e, t) => {
  const n = fu(t);
  switch (e) {
    case og.Taiwan:
      return M1.getName(e, n, { select: "alias" });
    default:
      return M1.getName(e, n, { select: "official" });
  }
}, zL = (e = Uo.ENGLISH) => Object.values(og).map((t) => ({
  id: t,
  caption: FL(t, e) ?? ""
}));
var Kt = /* @__PURE__ */ ((e) => (e.Email = "email", e.FirstName = "first_name", e.Surname = "surname", e.Country = "country", e.City = "city", e.Neighborhood = "neighborhood", e.StreetAddress = "street_address", e.StreetNumber = "street_number", e.Postcode = "postcode", e.PhoneNumber = "phone_number", e.CompanyName = "company_name", e.TaxNumber = "tax_number", e.State = "state", e))(Kt || {});
const GL = {
  [Kt.Email]: "public_pages_purchase.contact_slug.email",
  [Kt.FirstName]: "public_pages_purchase.contact_slug.first_name",
  [Kt.Surname]: "public_pages_purchase.contact_slug.last_name",
  [Kt.PhoneNumber]: "public_pages_purchase.contact_slug.phone_number",
  [Kt.Country]: "public_pages_purchase.contact_slug.country",
  [Kt.Neighborhood]: "public_pages_purchase.contact_slug.neighborhood",
  [Kt.StreetAddress]: "public_pages_purchase.contact_slug.street_address",
  [Kt.StreetNumber]: "public_pages_purchase.contact_slug.street_number",
  [Kt.City]: "public_pages_purchase.contact_slug.city",
  [Kt.Postcode]: "public_pages_purchase.contact_slug.postal_code",
  [Kt.CompanyName]: "public_pages_purchase.contact_slug.company_name",
  [Kt.TaxNumber]: "public_pages_purchase.contact_slug.tax_number",
  [Kt.State]: "public_pages_purchase.contact_slug.state_province"
}, O1 = (e) => Xe.t(GL[e]), HL = (e) => {
  const { slug: t, fieldName: n } = e;
  return Object.values(Kt).includes(t) ? O1(t) : n;
};
var dr = /* @__PURE__ */ ((e) => (e.ARGENTINE_PESO = "ars", e.AUSTRALIAN_DOLLAR = "aud", e.BULGARIAN_LEV = "bgn", e.BRAZILIAN_REAL = "brl", e.CANADIAN_DOLLAR = "cad", e.CENTRAL_AFRICAN_FRANC = "xaf", e.CHILEAN_PESO = "clp", e.CHINESE_YUAN = "cny", e.COLOMBIAN_PESO = "cop", e.CZECH_CROWN = "czk", e.DANISH_KRONE = "dkk", e.EGYPTIAN_POUND = "egp", e.EURO = "eur", e.GHANAIAN_CEDI = "ghs", e.GUINEAN_FRANC = "gnf", e.HONG_KONG_DOLLAR = "hkd", e.HUNGARIAN_FORINT = "huf", e.ICELANDIC_KRONA = "isk", e.INDIAN_RUPEE = "inr", e.INDONESIAN_RUPIAH = "idr", e.ISRAELI_NEW_SHEKEL = "ils", e.JAPANESE_YEN = "jpy", e.KENYAN_SHILLING = "kes", e.MALAWIAN_KWACHA = "mwk", e.MALAYSIAN_RINGGIT = "myr", e.MEXICAN_PESO = "mxn", e.MOROCCAN_DIRHAM = "mad", e.NEW_ZEALAND_DOLLAR = "nzd", e.NIGERIAN_NAIRA = "ngn", e.NORWEGIAN_KRONE = "nok", e.PHILIPPINE_PESO = "php", e.POLISH_ZLOTY = "pln", e.POUND_STERLING = "gbp", e.ROMANIA_LEI = "ron", e.RUSSIAN_RUBLE = "rub", e.RWANDAN_FRANC = "rwf", e.SAO_TOME_AND_PRINCIPE_DOBRA = "std", e.SAUDI_RIYAL = "sar", e.SIERRA_LEONEAN_LEONE = "sll", e.SINGAPORE_DOLLAR = "sgd", e.SOUTH_AFRICAN_RAND = "zar", e.SRI_LANKAN_RUPEE = "lkr", e.SWEDISH_KRONA = "sek", e.SWISS_FRANC = "chf", e.TANZANIAN_SHILLING = "tzs", e.THAI_BAHT = "thb", e.TURKISH_LIRA = "try", e.UGANDAN_SHILLING = "ugx", e.US_DOLLAR = "usd", e.UNITED_ARAB_EMIRATES_DIRHAM = "aed", e.WEST_AFRICAN_CFA_FRANC_BCEAO = "xof", e.ZAMBIAN_KWACHA = "zmw", e.SERBIAN_DINAR = "rsd", e.UKRAINIAN_HRYVNIA = "uah", e.ALBANIAN_LEK = "all", e.VIETNAM_DONG = "vnd", e.PERUVIAN_SOL = "pen", e))(dr || {});
let KL = { data: "" }, UL = (e) => typeof window == "object" ? ((e ? e.querySelector("#_goober") : window._goober) || Object.assign((e || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : e || KL, $L = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, VL = /\/\*[^]*?\*\/|  +/g, P2 = /\n+/g, Io = (e, t) => {
  let n = "", r = "", a = "";
  for (let o in e) {
    let i = e[o];
    o[0] == "@" ? o[1] == "i" ? n = o + " " + i + ";" : r += o[1] == "f" ? Io(i, o) : o + "{" + Io(i, o[1] == "k" ? "" : t) + "}" : typeof i == "object" ? r += Io(i, t ? t.replace(/([^,])+/g, (s) => o.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (l) => /&/.test(l) ? l.replace(/&/g, s) : s ? s + " " + l : l)) : o) : i != null && (o = /^--/.test(o) ? o : o.replace(/[A-Z]/g, "-$&").toLowerCase(), a += Io.p ? Io.p(o, i) : o + ":" + i + ";");
  }
  return n + (t && a ? t + "{" + a + "}" : a) + r;
}, no = {}, D4 = (e) => {
  if (typeof e == "object") {
    let t = "";
    for (let n in e)
      t += n + D4(e[n]);
    return t;
  }
  return e;
}, WL = (e, t, n, r, a) => {
  let o = D4(e), i = no[o] || (no[o] = ((l) => {
    let c = 0, u = 11;
    for (; c < l.length; )
      u = 101 * u + l.charCodeAt(c++) >>> 0;
    return "go" + u;
  })(o));
  if (!no[i]) {
    let l = o !== e ? e : ((c) => {
      let u, d, p = [{}];
      for (; u = $L.exec(c.replace(VL, "")); )
        u[4] ? p.shift() : u[3] ? (d = u[3].replace(P2, " ").trim(), p.unshift(p[0][d] = p[0][d] || {})) : p[0][u[1]] = u[2].replace(P2, " ").trim();
      return p[0];
    })(e);
    no[i] = Io(a ? { ["@keyframes " + i]: l } : l, n ? "" : "." + i);
  }
  let s = n && no.g ? no.g : null;
  return n && (no.g = no[i]), ((l, c, u, d) => {
    d ? c.data = c.data.replace(d, l) : c.data.indexOf(l) === -1 && (c.data = u ? l + c.data : c.data + l);
  })(no[i], t, r, s), i;
}, YL = (e, t, n) => e.reduce((r, a, o) => {
  let i = t[o];
  if (i && i.call) {
    let s = i(n), l = s && s.props && s.props.className || /^go/.test(s) && s;
    i = l ? "." + l : s && typeof s == "object" ? s.props ? "" : Io(s, "") : s === !1 ? "" : s;
  }
  return r + a + (i ?? "");
}, "");
function rh(e) {
  let t = this || {}, n = e.call ? e(t.p) : e;
  return WL(n.unshift ? n.raw ? YL(n, [].slice.call(arguments, 1), t.p) : n.reduce((r, a) => Object.assign(r, a && a.call ? a(t.p) : a), {}) : n, UL(t.target), t.g, t.o, t.k);
}
let I4, A1, N1;
rh.bind({ g: 1 });
let mo = rh.bind({ k: 1 });
function ZL(e, t, n, r) {
  Io.p = t, I4 = e, A1 = n, N1 = r;
}
function Xo(e, t) {
  let n = this || {};
  return function() {
    let r = arguments;
    function a(o, i) {
      let s = Object.assign({}, o), l = s.className || a.className;
      n.p = Object.assign({ theme: A1 && A1() }, s), n.o = / *go\d+/.test(l), s.className = rh.apply(n, r) + (l ? " " + l : "");
      let c = e;
      return e[0] && (c = s.as || e, delete s.as), N1 && c[0] && N1(s), I4(c, s);
    }
    return a;
  };
}
var qL = (e) => typeof e == "function", L1 = (e, t) => qL(e) ? e(t) : e, JL = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (++e).toString();
})(), XL = /* @__PURE__ */ (() => {
  let e;
  return () => {
    if (e === void 0 && typeof window < "u") {
      let t = matchMedia("(prefers-reduced-motion: reduce)");
      e = !t || t.matches;
    }
    return e;
  };
})(), QL = 20, j4 = (e, t) => {
  switch (t.type) {
    case 0:
      return { ...e, toasts: [t.toast, ...e.toasts].slice(0, QL) };
    case 1:
      return { ...e, toasts: e.toasts.map((o) => o.id === t.toast.id ? { ...o, ...t.toast } : o) };
    case 2:
      let { toast: n } = t;
      return j4(e, { type: e.toasts.find((o) => o.id === n.id) ? 1 : 0, toast: n });
    case 3:
      let { toastId: r } = t;
      return { ...e, toasts: e.toasts.map((o) => o.id === r || r === void 0 ? { ...o, dismissed: !0, visible: !1 } : o) };
    case 4:
      return t.toastId === void 0 ? { ...e, toasts: [] } : { ...e, toasts: e.toasts.filter((o) => o.id !== t.toastId) };
    case 5:
      return { ...e, pausedAt: t.time };
    case 6:
      let a = t.time - (e.pausedAt || 0);
      return { ...e, pausedAt: void 0, toasts: e.toasts.map((o) => ({ ...o, pauseDuration: o.pauseDuration + a })) };
  }
}, eR = [], am = { toasts: [], pausedAt: void 0 }, sg = (e) => {
  am = j4(am, e), eR.forEach((t) => {
    t(am);
  });
}, tR = (e, t = "blank", n) => ({ createdAt: Date.now(), visible: !0, dismissed: !1, type: t, ariaProps: { role: "status", "aria-live": "polite" }, message: e, pauseDuration: 0, ...n, id: (n == null ? void 0 : n.id) || JL() }), gu = (e) => (t, n) => {
  let r = tR(t, e, n);
  return sg({ type: 2, toast: r }), r.id;
}, $t = (e, t) => gu("blank")(e, t);
$t.error = gu("error");
$t.success = gu("success");
$t.loading = gu("loading");
$t.custom = gu("custom");
$t.dismiss = (e) => {
  sg({ type: 3, toastId: e });
};
$t.remove = (e) => sg({ type: 4, toastId: e });
$t.promise = (e, t, n) => {
  let r = $t.loading(t.loading, { ...n, ...n == null ? void 0 : n.loading });
  return typeof e == "function" && (e = e()), e.then((a) => {
    let o = t.success ? L1(t.success, a) : void 0;
    return o ? $t.success(o, { id: r, ...n, ...n == null ? void 0 : n.success }) : $t.dismiss(r), a;
  }).catch((a) => {
    let o = t.error ? L1(t.error, a) : void 0;
    o ? $t.error(o, { id: r, ...n, ...n == null ? void 0 : n.error }) : $t.dismiss(r);
  }), e;
};
var rR = mo`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, nR = mo`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, aR = mo`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, oR = Xo("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${rR} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${nR} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e) => e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${aR} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`, iR = mo`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, sR = Xo("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e) => e.secondary || "#e0e0e0"};
  border-right-color: ${(e) => e.primary || "#616161"};
  animation: ${iR} 1s linear infinite;
`, lR = mo`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, cR = mo`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, uR = Xo("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${lR} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${cR} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e) => e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`, dR = Xo("div")`
  position: absolute;
`, pR = Xo("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, hR = mo`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, mR = Xo("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${hR} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, fR = ({ toast: e }) => {
  let { icon: t, type: n, iconTheme: r } = e;
  return t !== void 0 ? typeof t == "string" ? pe.createElement(mR, null, t) : t : n === "blank" ? null : pe.createElement(pR, null, pe.createElement(sR, { ...r }), n !== "loading" && pe.createElement(dR, null, n === "error" ? pe.createElement(oR, { ...r }) : pe.createElement(uR, { ...r })));
}, gR = (e) => `
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, yR = (e) => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, vR = "0%{opacity:0;} 100%{opacity:1;}", bR = "0%{opacity:1;} 100%{opacity:0;}", _R = Xo("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, wR = Xo("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, SR = (e, t) => {
  let n = e.includes("top") ? 1 : -1, [r, a] = XL() ? [vR, bR] : [gR(n), yR(n)];
  return { animation: t ? `${mo(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${mo(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)` };
};
pe.memo(({ toast: e, position: t, style: n, children: r }) => {
  let a = e.height ? SR(e.position || t || "top-center", e.visible) : { opacity: 0 }, o = pe.createElement(fR, { toast: e }), i = pe.createElement(wR, { ...e.ariaProps }, L1(e.message, e));
  return pe.createElement(_R, { className: e.className, style: { ...a, ...n, ...e.style } }, typeof r == "function" ? r({ icon: o, message: i }) : pe.createElement(pe.Fragment, null, o, i));
});
ZL(pe.createElement);
rh`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`;
var lg = {}, B4 = {}, cg = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.instanceOfHashable = e.guessType = e.guessObjectType = e.TYPE_MAP = void 0, e.TYPE_MAP = {
    Array: "array",
    Int8Array: "typedarray",
    Uint8Array: "typedarray",
    Uint8ClampedArray: "typedarray",
    Int16Array: "typedarray",
    Uint16Array: "typedarray",
    Int32Array: "typedarray",
    Uint32Array: "typedarray",
    Float32Array: "typedarray",
    Float64Array: "typedarray",
    BigUint64Array: "typedarray",
    BigInt64Array: "typedarray",
    Buffer: "typedarray",
    Map: "map",
    Set: "set",
    Date: "date",
    String: "string",
    Number: "number",
    BigInt: "bigint",
    Boolean: "boolean",
    Object: "object"
  };
  const t = (a) => {
    var o;
    if (a === null)
      return "null";
    if ((0, e.instanceOfHashable)(a))
      return "hashable";
    const i = ((o = a == null ? void 0 : a.constructor) == null ? void 0 : o.name) ?? "unknown";
    return e.TYPE_MAP[i] || "unknown";
  };
  e.guessObjectType = t;
  const n = (a) => {
    const o = typeof a;
    return o !== "object" ? o : (0, e.guessObjectType)(a);
  };
  e.guessType = n;
  const r = (a) => typeof a.toHashableString == "function";
  e.instanceOfHashable = r;
})(cg);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e._mapSort = e._map = e._objectSort = e._object = e._setCoerce = e._set = e._setSort = e._setSortCoerce = e._typedArray = e._typedArraySort = e._array = e._arraySort = e._date = e._dateCoerce = e._functionTrim = e._functionTrimCoerce = e._function = e._functionCoerce = e._null = e._nullCoerce = e._undefined = e._undefinedCoerce = e._symbol = e._symbolCoerce = e._boolean = e._booleanCoerce = e._bigInt = e._bigIntCoerce = e._number = e._numberCoerce = e._stringTrim = e._stringTrimCoerce = e._string = e._stringCoerce = e._hashable = e.PREFIX = void 0;
  const t = cg;
  e.PREFIX = {
    string: "<:s>",
    number: "<:n>",
    bigint: "<:bi>",
    boolean: "<:b>",
    symbol: "<:smbl>",
    undefined: "<:undf>",
    null: "<:null>",
    function: "<:func>",
    array: "",
    date: "<:date>",
    set: "<:set>",
    map: "<:map>"
  };
  function n(T) {
    return T.toHashableString();
  }
  e._hashable = n;
  function r(T) {
    return T;
  }
  e._stringCoerce = r;
  function a(T) {
    return e.PREFIX.string + ":" + T;
  }
  e._string = a;
  function o(T) {
    return T.replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._stringTrimCoerce = o;
  function i(T) {
    return e.PREFIX.string + ":" + T.replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._stringTrim = i;
  function s(T) {
    return T.toString();
  }
  e._numberCoerce = s;
  function l(T) {
    return `${e.PREFIX.number}:${T}`;
  }
  e._number = l;
  function c(T) {
    return T.toString();
  }
  e._bigIntCoerce = c;
  function u(T) {
    return `${e.PREFIX.bigint}:${T.toString()}`;
  }
  e._bigInt = u;
  function d(T) {
    return T ? "1" : "0";
  }
  e._booleanCoerce = d;
  function p(T) {
    return e.PREFIX.boolean + ":" + T.toString();
  }
  e._boolean = p;
  function h() {
    return e.PREFIX.symbol;
  }
  e._symbolCoerce = h;
  function m(T) {
    return e.PREFIX.symbol + ":" + T.toString();
  }
  e._symbol = m;
  function f() {
    return "";
  }
  e._undefinedCoerce = f;
  function g() {
    return e.PREFIX.undefined;
  }
  e._undefined = g;
  function _() {
    return "";
  }
  e._nullCoerce = _;
  function v() {
    return e.PREFIX.null;
  }
  e._null = v;
  function w(T) {
    return T.name + "=>" + T.toString();
  }
  e._functionCoerce = w;
  function x(T) {
    return e.PREFIX.function + ":" + T.name + "=>" + T.toString();
  }
  e._function = x;
  function b(T) {
    return T.name + "=>" + T.toString().replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._functionTrimCoerce = b;
  function C(T) {
    return e.PREFIX.function + ":" + T.name + "=>" + T.toString().replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._functionTrim = C;
  function E(T) {
    return T.toISOString();
  }
  e._dateCoerce = E;
  function A(T) {
    return e.PREFIX.date + ":" + T.toISOString();
  }
  e._date = A;
  function O(T) {
    const B = this;
    return "[" + T.map((N) => B[(0, t.guessType)(N)](N)).sort().toString() + "]";
  }
  e._arraySort = O;
  function M(T) {
    const B = this;
    return "[" + T.map((N) => B[(0, t.guessType)(N)](N)).toString() + "]";
  }
  e._array = M;
  function I(T) {
    const B = this;
    return "[" + Array.prototype.slice.call(T).map((N) => B[(0, t.guessType)(N)](N)).sort().toString() + "]";
  }
  e._typedArraySort = I;
  function D(T) {
    const B = this;
    return "[" + Array.prototype.slice.call(T).map((N) => B[(0, t.guessType)(N)](N)).toString() + "]";
  }
  e._typedArray = D;
  function K(T) {
    return O.call(this, Array.from(T));
  }
  e._setSortCoerce = K;
  function G(T) {
    return `${e.PREFIX.set}:${O.call(this, Array.from(T))}`;
  }
  e._setSort = G;
  function V(T) {
    return `${e.PREFIX.set}:${M.call(this, Array.from(T))}`;
  }
  e._set = V;
  function ee(T) {
    return M.call(this, Array.from(T));
  }
  e._setCoerce = ee;
  function U(T) {
    const B = this, N = Object.keys(T), Y = [];
    for (const Q of N) {
      const F = T[Q], re = (0, t.guessType)(F);
      Y.push(Q + ":" + B[re](F));
    }
    return "{" + Y.toString() + "}";
  }
  e._object = U;
  function H(T) {
    const B = this, N = Object.keys(T).sort(), Y = [];
    for (const Q of N) {
      const F = T[Q], re = (0, t.guessType)(F);
      Y.push(Q + ":" + B[re](F));
    }
    return "{" + Y.toString() + "}";
  }
  e._objectSort = H;
  function W(T) {
    const B = this, N = Array.from(T), Y = [];
    for (const Q of N) {
      const [F, re] = Q;
      Y.push([B[(0, t.guessType)(F)](F), B[(0, t.guessType)(re)](re)]);
    }
    return "[" + Y.join(";") + "]";
  }
  e._map = W;
  function L(T) {
    const B = this, N = Array.from(T), Y = [];
    for (const Q of N) {
      const [F, re] = Q;
      Y.push([B[(0, t.guessType)(F)](F), B[(0, t.guessType)(re)](re)]);
    }
    return "[" + Y.sort().join(";") + "]";
  }
  e._mapSort = L;
})(B4);
var CR = Is && Is.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var a = Object.getOwnPropertyDescriptor(t, n);
  (!a || ("get" in a ? !t.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, a);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), xR = Is && Is.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), kR = Is && Is.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && CR(t, e, n);
  return xR(t, e), t;
};
Object.defineProperty(lg, "__esModule", { value: !0 });
var R1 = lg.objectSorter = void 0;
const wt = kR(B4), ER = cg, PR = (e) => {
  const { sort: t, coerce: n, trim: r } = {
    sort: !0,
    coerce: !0,
    trim: !1,
    ...e
  }, a = {
    array: typeof t == "boolean" ? t : (t == null ? void 0 : t.array) ?? !1,
    typedArray: typeof t == "boolean" ? !1 : (t == null ? void 0 : t.typedArray) ?? !1,
    object: typeof t == "boolean" ? t : (t == null ? void 0 : t.object) ?? !1,
    set: typeof t == "boolean" ? t : (t == null ? void 0 : t.set) ?? !1,
    map: typeof t == "boolean" ? t : (t == null ? void 0 : t.map) ?? !1
  }, o = {
    boolean: typeof n == "boolean" ? n : (n == null ? void 0 : n.boolean) ?? !1,
    number: typeof n == "boolean" ? n : (n == null ? void 0 : n.number) ?? !1,
    bigint: typeof n == "boolean" ? n : (n == null ? void 0 : n.bigint) ?? !1,
    string: typeof n == "boolean" ? n : (n == null ? void 0 : n.string) ?? !1,
    undefined: typeof n == "boolean" ? n : (n == null ? void 0 : n.undefined) ?? !1,
    null: typeof n == "boolean" ? n : (n == null ? void 0 : n.null) ?? !1,
    symbol: typeof n == "boolean" ? n : (n == null ? void 0 : n.symbol) ?? !1,
    function: typeof n == "boolean" ? n : (n == null ? void 0 : n.function) ?? !1,
    date: typeof n == "boolean" ? n : (n == null ? void 0 : n.date) ?? !1,
    set: typeof n == "boolean" ? n : (n == null ? void 0 : n.set) ?? !1
  }, i = {
    string: typeof r == "boolean" ? r : (r == null ? void 0 : r.string) ?? !1,
    function: typeof r == "boolean" ? r : (r == null ? void 0 : r.function) ?? !1
  }, s = {
    // eslint-disable-next-line @typescript-eslint/ban-types
    unknown: function(c) {
      var u;
      const d = ((u = c.constructor) == null ? void 0 : u.name) ?? "unknonw";
      let p = "unknown";
      return typeof c.toString == "function" ? p = c.toString() : Object.keys(c).length > 0 && (p = JSON.stringify(c)), `<:${d}>:${p}`;
    }
  };
  s.hashable = wt._hashable.bind(s), i.string ? s.string = o.string ? wt._stringTrimCoerce.bind(s) : wt._stringTrim.bind(s) : s.string = o.string ? wt._stringCoerce.bind(s) : wt._string.bind(s), s.number = o.number ? wt._numberCoerce.bind(s) : wt._number.bind(s), s.bigint = o.bigint ? wt._bigIntCoerce.bind(s) : wt._bigInt.bind(s), s.boolean = o.boolean ? wt._booleanCoerce.bind(s) : wt._boolean.bind(s), s.symbol = o.symbol ? wt._symbolCoerce.bind(s) : wt._symbol.bind(s), s.undefined = o.undefined ? wt._undefinedCoerce.bind(s) : wt._undefined.bind(s), s.null = o.null ? wt._nullCoerce.bind(s) : wt._null.bind(s), i.function ? s.function = o.function ? wt._functionTrimCoerce.bind(s) : wt._functionTrim.bind(s) : s.function = o.function ? wt._functionCoerce.bind(s) : wt._function.bind(s), s.date = o.date ? wt._dateCoerce.bind(s) : wt._date.bind(s), s.array = a.array ? wt._arraySort.bind(s) : wt._array.bind(s), s.typedarray = a.typedArray ? wt._typedArraySort.bind(s) : wt._typedArray.bind(s), a.set ? s.set = o.set ? wt._setSortCoerce.bind(s) : wt._setSort.bind(s) : s.set = o.set ? wt._setCoerce.bind(s) : wt._set.bind(s), s.object = a.object ? wt._objectSort.bind(s) : wt._object.bind(s), s.map = a.map ? wt._mapSort.bind(s) : wt._map.bind(s);
  function l(c) {
    return s[(0, ER.guessType)(c)](c);
  }
  return l;
};
R1 = lg.objectSorter = PR;
const TR = $t.error, MR = $t.success, OR = $t.loading, AR = $t.custom, nh = (e) => {
  const t = {
    id: "mock-id",
    type: "blank",
    message: e,
    visible: !0,
    ariaProps: { role: "status", "aria-live": "polite" },
    pauseDuration: 0,
    createdAt: 0,
    dismissed: !1
  };
  let n;
  return typeof e == "string" ? n = e : typeof e == "function" ? n = JSON.stringify(R1()(e(t))) : typeof e == "object" && (n = JSON.stringify(R1()(e))), n;
};
$t.error = (e, t) => TR(e, {
  id: nh(e),
  ...t
});
$t.success = (e, t) => MR(e, {
  id: nh(e),
  ...t
});
$t.loading = (e, t) => OR(e, {
  id: nh(e),
  ...t
});
$t.custom = (e, t) => AR(e, {
  id: nh(e),
  ...t
});
const yt = (e) => Number(e), pr = (e) => e / 100, NR = "group group min-h-[42px] relative rounded-lg py-2.5 font-medium text-sm main-transition-colors focus-ring whitespace-nowrap [&>*]:font-medium [&>*]:font-inter font-inter cursor-pointer", LR = "flex items-center justify-center gap-2", F4 = (e) => "href" in e, RR = ({
  as: e = "a",
  href: t,
  isFetching: n,
  className: r,
  children: a,
  buttonTextClassName: o,
  ...i
}) => i["aria-disabled"] || n ? /* @__PURE__ */ Z.jsx("button", { className: r, disabled: !!i["aria-disabled"], children: /* @__PURE__ */ Z.jsx(D1, { buttonTextClassName: o, isFetching: n, children: a }) }) : /* @__PURE__ */ Z.jsx(e, { className: r, href: t, ...i, children: /* @__PURE__ */ Z.jsx(D1, { buttonTextClassName: o, isFetching: n, children: a }) }), D1 = ({
  children: e,
  isFetching: t,
  buttonTextClassName: n
}) => /* @__PURE__ */ Z.jsx(
  "div",
  {
    className: Fe(
      "flex items-center justify-center gap-2 truncate",
      t && "opacity-0",
      n
    ),
    children: e
  }
), z4 = ({
  width: e = "small",
  isFetching: t,
  backgroundColor: n,
  color: r,
  hoverColor: a,
  hoverBackgroundColor: o,
  borderColor: i,
  hoverBorderColor: s,
  loaderType: l,
  testAttributePostfix: c,
  className: u,
  buttonTextClassName: d,
  loaderClassName: p,
  as: h,
  ...m
}) => {
  const f = m, g = Fe(
    jd(
      NR,
      LR,
      n,
      r,
      a,
      o,
      e === "small" ? "px-4" : "px-10",
      i && `border ${i}`,
      s,
      t && "pointer-events-none select-none"
    ),
    u
  ), _ = Fe(
    jd("absolute", t ? "visible" : "invisible", "-translate-x-1/2 left-1/2"),
    p
  );
  if (F4(f)) {
    const { "aria-disabled": v, ...w } = f;
    return /* @__PURE__ */ Z.jsx(
      RR,
      {
        as: h,
        isFetching: t,
        "aria-disabled": v || t,
        className: Fe(g, v && "bg-text-secondary/50 pointer-events-none"),
        ...w,
        ...l2(!!c, `${c}`),
        children: /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
          /* @__PURE__ */ Z.jsx(Bd, { small: !0, type: l, className: _ }),
          f.children
        ] })
      }
    );
  } else {
    const { disabled: v, ...w } = f;
    return /* @__PURE__ */ Z.jsxs(
      "button",
      {
        disabled: t || v,
        className: Fe(g, v && "bg-text-secondary/50 pointer-events-none"),
        ...w,
        ...l2(!!c, `${c}`),
        children: [
          /* @__PURE__ */ Z.jsx(Bd, { small: !0, type: l, className: _ }),
          /* @__PURE__ */ Z.jsx(D1, { buttonTextClassName: d, isFetching: t, children: f.children })
        ]
      }
    );
  }
};
function DR({
  arrowButtonClassName: e,
  open: t,
  isDisabled: n,
  As: r = R0
}) {
  return /* @__PURE__ */ Z.jsx(
    r,
    {
      as: "div",
      className: Fe(
        "flex items-center",
        "focus-ring",
        "rounded-md",
        n && "cursor-not-allowed",
        e
      ),
      disabled: n,
      children: /* @__PURE__ */ Z.jsx(
        ag,
        {
          className: Fe("stroke-text-primary main-transition", t && "rotate-180"),
          "aria-hidden": "true"
        }
      )
    }
  );
}
function IR({ onClick: e, closeButtonClassName: t, isDisabled: n }) {
  return /* @__PURE__ */ Z.jsx(
    "button",
    {
      type: "button",
      className: Fe(
        "flex items-center",
        "focus-ring",
        "rounded-md",
        n && "cursor-not-allowed",
        t
      ),
      onClick: e,
      disabled: n,
      children: /* @__PURE__ */ Z.jsx(ng, { className: "fill-text-primary h-4 w-4" })
    }
  );
}
function jR({
  children: e,
  selectedData: t,
  virtual: n,
  disabled: r,
  onClose: a,
  onChange: o
}) {
  return /* @__PURE__ */ Z.jsx(
    NE,
    {
      immediate: !0,
      value: t,
      virtual: n,
      onChange: (i) => {
        i !== null && o(i == null ? void 0 : i.id);
      },
      disabled: r,
      onClose: a,
      children: ({ open: i }) => e(i)
    }
  );
}
const G4 = "text-[16px] sm:text-sm", ug = "px-4 py-2.5";
function BR({
  isDisabled: e,
  open: t,
  hasError: n,
  className: r,
  placeholder: a,
  selectedCaption: o,
  isPreFetching: i,
  onFocus: s,
  onChange: l,
  inputRef: c,
  dataTest: u
}) {
  return /* @__PURE__ */ Z.jsx(
    V6,
    {
      ref: c,
      className: Fe(
        "w-full truncate",
        G4,
        "flex items-center justify-between",
        ug,
        "rounded-lg pr-14",
        "text-text-primary placeholder:text-text-tertiary/70 cursor-default",
        "focus-visible:border-brand-primary border focus:outline-hidden",
        "main-transition-colors",
        e ? "bg-skeleton-primary/20" : "bg-background-secondary",
        t ? "border-brand-primary" : n ? "border-danger" : "border-text-secondary/30",
        i && ["animate-pulse", "text-transparent placeholder:text-transparent"],
        r
      ),
      onChange: (d) => l == null ? void 0 : l(d.target.value),
      onKeyDown: (d) => d.stopPropagation(),
      onFocus: s,
      displayValue: o ? () => o : void 0,
      placeholder: a ?? Xe.t("public_pages_purchase.form_select.select"),
      ...u
    }
  );
}
function FR({ loaderWrapperClassName: e, loaderClassName: t }) {
  return /* @__PURE__ */ Z.jsx(
    "div",
    {
      className: Fe(
        "flex h-full items-center justify-center",
        "scale-75",
        e
      ),
      children: /* @__PURE__ */ Z.jsx(Bd, { className: Fe(t) })
    }
  );
}
const zR = ({
  item: e,
  optionClassName: t,
  optionIconWrapperClassName: n,
  optionRef: r,
  as: a
}) => {
  const o = (e == null ? void 0 : e.customCaption) ?? (e == null ? void 0 : e.caption), i = ({ disabled: l, selected: c }) => Fe(
    "bg-background-secondary text-text-primary",
    ug,
    "border-b last:border-b-0 border-text-secondary/30",
    "group hover:bg-brand-primary hover:text-background-secondary",
    "data-[focus]:bg-brand-primary data-[focus]:text-background-secondary",
    "flex justify-between items-center gap-3 w-full break-all",
    c && "bg-brand-primary text-background-secondary",
    l && "bg-text-secondary hover:bg-text-secondary data-[focus]:bg-text-secondary text-background-secondary hover:text-background-secondary data-[focus]:text-background-secondary cursor-not-allowed",
    t,
    e == null ? void 0 : e.className
  ), s = ({ selected: l }) => /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
    o,
    /* @__PURE__ */ Z.jsxs("div", { className: Fe("flex items-center gap-3", n), children: [
      l && /* @__PURE__ */ Z.jsx(
        NO,
        {
          className: jd(
            "group-hover:stroke-background-secondary stroke-background-secondary h-4 w-4"
          ),
          "aria-hidden": "true"
        }
      ),
      e == null ? void 0 : e.additionalRender
    ] })
  ] });
  return /* @__PURE__ */ Z.jsx(
    a,
    {
      disabled: e == null ? void 0 : e.disabled,
      ref: r,
      value: e,
      className: i,
      "data-test-id": e == null ? void 0 : e.dataTestAttribute,
      children: s
    },
    e == null ? void 0 : e.id
  );
}, H4 = Xs(
  ({ children: e, style: t, optionsClassName: n, as: r }, a) => /* @__PURE__ */ Z.jsx(
    r,
    {
      anchor: { to: "bottom", gap: 4 },
      portal: !0,
      transition: !0,
      ref: a,
      style: t,
      className: Fe(
        "h-full w-[var(--input-width)] min-w-[200px]",
        "bg-background-secondary shadow-around-sm rounded-lg",
        "z-20",
        "transition duration-200 ease-out empty:invisible data-[closed]:opacity-0",
        "customScroll",
        G4,
        n
      ),
      children: e
    }
  )
);
H4.displayName = "ListOptionsWrapper";
const T2 = 240, GR = () => ({
  id: void 0,
  caption: Xe.t("public_pages_purchase.form_select.empty_list"),
  className: "bg-background-secondary hover:bg-background-secondary cursor-default text-text-tertiary/70 hover:text-text-tertiary/70",
  disabled: !0
}), HR = (e, t) => {
  let n = 0;
  return e && (e.querySelectorAll('[role="option"]').forEach((r) => {
    n += r.getBoundingClientRect().height;
  }), n = t ? Math.min(n, T2) || T2 : 42), n;
};
function KR({
  optionsClassName: e,
  data: t,
  loaderWrapperClassName: n,
  loaderClassName: r,
  asOptions: a,
  asOption: o,
  ...i
}) {
  const [s, l] = ke(null), c = HR(s, t);
  return /* @__PURE__ */ Z.jsx(
    H4,
    {
      as: a,
      ref: l,
      optionsClassName: e,
      style: { height: c },
      children: ({ option: u }) => t ? zR({ ...i, as: o, item: u }) : /* @__PURE__ */ Z.jsx(
        FR,
        {
          loaderWrapperClassName: n,
          loaderClassName: r
        }
      )
    }
  );
}
const UR = (e, t) => (t == null ? void 0 : t.find((n) => n.id === e)) ?? null, $R = (e) => {
  const [t, n] = ke(""), [r, a] = ke(e);
  return De(() => {
    const o = t === "" ? e : (e == null ? void 0 : e.filter(
      (i) => i.caption.toLowerCase().replace(/\s+/g, "").includes(t.toLowerCase().replace(/\s+/g, ""))
    )) ?? [];
    a(() => o);
  }, [e, t]), { filteredData: r, setFilteredData: a, query: t, setQuery: n };
}, VR = (e = []) => ({
  options: e.length > 0 ? e : [GR()],
  disabled: (t) => (t == null ? void 0 : t.disabled) ?? !1
});
function WR({
  label: e,
  data: t,
  staticData: n,
  onChange: r,
  labelClassName: a,
  value: o,
  isPreFetching: i,
  placeholder: s,
  error: l,
  required: c,
  description: u,
  className: d,
  containerClassName: p,
  closeButtonClassName: h,
  arrowButtonClassName: m,
  fieldClassName: f,
  disabled: g,
  withoutCloseIcon: _,
  onOpen: v,
  onClose: w,
  dataTest: x,
  wrapperProps: b,
  loaderClassName: C,
  loaderWrapperClassName: E,
  inputWrapperClassName: A,
  inputRef: O,
  statusIcon: M,
  statusIconClassName: I,
  ...D
}) {
  const [K, G] = ke(!1);
  De(() => {
    K && v && (v(), G(!1));
  }, [K]);
  const V = UR(o, t ?? n) ?? null, { filteredData: ee, setQuery: U } = $R(t), H = o !== void 0, W = g || i || H && !t && !n, L = H && !_ && !W;
  return /* @__PURE__ */ Z.jsxs("div", { className: Fe("relative flex flex-col gap-1", p), children: [
    /* @__PURE__ */ Z.jsx(
      jR,
      {
        selectedData: V,
        virtual: VR(ee),
        onChange: r,
        disabled: W,
        onClose: () => {
          U(""), w == null || w();
        },
        children: (T) => /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
          /* @__PURE__ */ Z.jsxs(AP, { className: Fe("relative flex flex-col gap-1", f), children: [
            /* @__PURE__ */ Z.jsx(
              _o,
              {
                wrapperAs: "label",
                wrapperProps: b,
                label: e,
                required: c,
                labelClassName: Fe("text-sm font-medium", a)
              }
            ),
            /* @__PURE__ */ Z.jsxs(R0, { as: "button", className: Fe("relative", A), children: [
              /* @__PURE__ */ Z.jsx(
                BR,
                {
                  dataTest: x,
                  inputRef: O,
                  isDisabled: W,
                  hasError: !!l,
                  open: T,
                  className: d,
                  placeholder: s,
                  selectedCaption: (V == null ? void 0 : V.caption) ?? "",
                  isPreFetching: i,
                  onFocus: () => G(!0),
                  onChange: (B) => {
                    G(!0), U(B);
                  }
                }
              ),
              M ? /* @__PURE__ */ Z.jsx(
                "div",
                {
                  className: Fe(
                    "absolute inset-y-0 right-3 flex h-[46px] items-center justify-center sm:h-[42px]",
                    I
                  ),
                  children: M
                }
              ) : /* @__PURE__ */ Z.jsx(
                DR,
                {
                  isDisabled: W,
                  arrowButtonClassName: Fe(
                    "absolute inset-y-0 right-4 h-[46px] sm:h-[42px]",
                    m
                  ),
                  open: T
                }
              )
            ] }),
            L && /* @__PURE__ */ Z.jsx(
              IR,
              {
                isDisabled: W,
                closeButtonClassName: Fe(
                  "absolute bottom-0 right-10 h-[46px] sm:h-[42px]",
                  h
                ),
                onClick: () => r(void 0)
              }
            )
          ] }),
          /* @__PURE__ */ Z.jsx(
            KR,
            {
              asOptions: W6,
              asOption: Y6,
              data: ee,
              ...D
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ Z.jsx(sl, { error: l, description: u })
  ] });
}
var K4 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = "", i = 0; i < arguments.length; i++) {
        var s = arguments[i];
        s && (o = a(o, r(s)));
      }
      return o;
    }
    function r(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var i = "";
      for (var s in o)
        t.call(o, s) && o[s] && (i = a(i, s));
      return i;
    }
    function a(o, i) {
      return i ? o ? o + " " + i : o + i : o;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(K4);
var YR = K4.exports;
const Ur = /* @__PURE__ */ Ep(YR);
function Ee(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ah(e) {
  return Ee(1, arguments), e instanceof Date || Kn(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Ne(e) {
  Ee(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Kn(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Ac(e) {
  if (Ee(1, arguments), !ah(e) && typeof e != "number")
    return !1;
  var t = Ne(e);
  return !isNaN(Number(t));
}
function dt(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function dg(e, t) {
  Ee(2, arguments);
  var n = Ne(e).getTime(), r = dt(t);
  return new Date(n + r);
}
function U4(e, t) {
  Ee(2, arguments);
  var n = dt(t);
  return dg(e, -n);
}
var ZR = 864e5;
function qR(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), a = n - r;
  return Math.floor(a / ZR) + 1;
}
function Fs(e) {
  Ee(1, arguments);
  var t = 1, n = Ne(e), r = n.getUTCDay(), a = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function $4(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = Fs(r), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var i = Fs(o);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function JR(e) {
  Ee(1, arguments);
  var t = $4(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Fs(n);
  return r;
}
var XR = 6048e5;
function V4(e) {
  Ee(1, arguments);
  var t = Ne(e), n = Fs(t).getTime() - JR(t).getTime();
  return Math.round(n / XR) + 1;
}
var QR = {};
function ns() {
  return QR;
}
function Wi(e, t) {
  var n, r, a, o, i, s, l, c;
  Ee(1, arguments);
  var u = ns(), d = dt((n = (r = (a = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = Ne(e), h = p.getUTCDay(), m = (h < d ? 7 : 0) + h - d;
  return p.setUTCDate(p.getUTCDate() - m), p.setUTCHours(0, 0, 0, 0), p;
}
function pg(e, t) {
  var n, r, a, o, i, s, l, c;
  Ee(1, arguments);
  var u = Ne(e), d = u.getUTCFullYear(), p = ns(), h = dt((n = (r = (a = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : p.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = p.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(d + 1, 0, h), m.setUTCHours(0, 0, 0, 0);
  var f = Wi(m, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(d, 0, h), g.setUTCHours(0, 0, 0, 0);
  var _ = Wi(g, t);
  return u.getTime() >= f.getTime() ? d + 1 : u.getTime() >= _.getTime() ? d : d - 1;
}
function eD(e, t) {
  var n, r, a, o, i, s, l, c;
  Ee(1, arguments);
  var u = ns(), d = dt((n = (r = (a = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), p = pg(e, t), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(p, 0, d), h.setUTCHours(0, 0, 0, 0);
  var m = Wi(h, t);
  return m;
}
var tD = 6048e5;
function W4(e, t) {
  Ee(1, arguments);
  var n = Ne(e), r = Wi(n, t).getTime() - eD(n, t).getTime();
  return Math.round(r / tD) + 1;
}
function Gt(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var Co = {
  // Year
  y: function(e, t) {
    var n = e.getUTCFullYear(), r = n > 0 ? n : 1 - n;
    return Gt(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M: function(e, t) {
    var n = e.getUTCMonth();
    return t === "M" ? String(n + 1) : Gt(n + 1, 2);
  },
  // Day of the month
  d: function(e, t) {
    return Gt(e.getUTCDate(), t.length);
  },
  // AM or PM
  a: function(e, t) {
    var n = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, t) {
    return Gt(e.getUTCHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H: function(e, t) {
    return Gt(e.getUTCHours(), t.length);
  },
  // Minute
  m: function(e, t) {
    return Gt(e.getUTCMinutes(), t.length);
  },
  // Second
  s: function(e, t) {
    return Gt(e.getUTCSeconds(), t.length);
  },
  // Fraction of second
  S: function(e, t) {
    var n = t.length, r = e.getUTCMilliseconds(), a = Math.floor(r * Math.pow(10, n - 3));
    return Gt(a, t.length);
  }
}, cs = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, rD = {
  // Era
  G: function(e, t, n) {
    var r = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(r, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(r, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      var r = e.getUTCFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, {
        unit: "year"
      });
    }
    return Co.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    var a = pg(e, r), o = a > 0 ? a : 1 - a;
    if (t === "YY") {
      var i = o % 100;
      return Gt(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : Gt(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    var n = $4(e);
    return Gt(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    var n = e.getUTCFullYear();
    return Gt(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    var r = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return Gt(r, 2);
      case "Qo":
        return n.ordinalNumber(r, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    var r = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return Gt(r, 2);
      case "qo":
        return n.ordinalNumber(r, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    var r = e.getUTCMonth();
    switch (t) {
      case "M":
      case "MM":
        return Co.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    var r = e.getUTCMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return Gt(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    var a = W4(e, r);
    return t === "wo" ? n.ordinalNumber(a, {
      unit: "week"
    }) : Gt(a, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    var r = V4(e);
    return t === "Io" ? n.ordinalNumber(r, {
      unit: "week"
    }) : Gt(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : Co.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    var r = qR(e);
    return t === "Do" ? n.ordinalNumber(r, {
      unit: "dayOfYear"
    }) : Gt(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    var r = e.getUTCDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    var a = e.getUTCDay(), o = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return Gt(o, 2);
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    var a = e.getUTCDay(), o = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return Gt(o, t.length);
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    var r = e.getUTCDay(), a = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return Gt(a, t.length);
      case "io":
        return n.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    var r = e.getUTCHours(), a = r / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    var r = e.getUTCHours(), a;
    switch (r === 12 ? a = cs.noon : r === 0 ? a = cs.midnight : a = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    var r = e.getUTCHours(), a;
    switch (r >= 17 ? a = cs.evening : r >= 12 ? a = cs.afternoon : r >= 4 ? a = cs.morning : a = cs.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      var r = e.getUTCHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, {
        unit: "hour"
      });
    }
    return Co.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : Co.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    var r = e.getUTCHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, {
      unit: "hour"
    }) : Gt(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    var r = e.getUTCHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, {
      unit: "hour"
    }) : Gt(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : Co.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : Co.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Co.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n, r) {
    var a = r._originalDate || e, o = a.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (t) {
      case "X":
        return O2(o);
      case "XXXX":
      case "XX":
        return Si(o);
      case "XXXXX":
      case "XXX":
      default:
        return Si(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n, r) {
    var a = r._originalDate || e, o = a.getTimezoneOffset();
    switch (t) {
      case "x":
        return O2(o);
      case "xxxx":
      case "xx":
        return Si(o);
      case "xxxxx":
      case "xxx":
      default:
        return Si(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n, r) {
    var a = r._originalDate || e, o = a.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + M2(o, ":");
      case "OOOO":
      default:
        return "GMT" + Si(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n, r) {
    var a = r._originalDate || e, o = a.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + M2(o, ":");
      case "zzzz":
      default:
        return "GMT" + Si(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n, r) {
    var a = r._originalDate || e, o = Math.floor(a.getTime() / 1e3);
    return Gt(o, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n, r) {
    var a = r._originalDate || e, o = a.getTime();
    return Gt(o, t.length);
  }
};
function M2(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.floor(r / 60), o = r % 60;
  if (o === 0)
    return n + String(a);
  var i = t;
  return n + String(a) + i + Gt(o, 2);
}
function O2(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + Gt(Math.abs(e) / 60, 2);
  }
  return Si(e, t);
}
function Si(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", a = Math.abs(e), o = Gt(Math.floor(a / 60), 2), i = Gt(a % 60, 2);
  return r + o + n + i;
}
var A2 = function(e, t) {
  switch (e) {
    case "P":
      return t.date({
        width: "short"
      });
    case "PP":
      return t.date({
        width: "medium"
      });
    case "PPP":
      return t.date({
        width: "long"
      });
    case "PPPP":
    default:
      return t.date({
        width: "full"
      });
  }
}, Y4 = function(e, t) {
  switch (e) {
    case "p":
      return t.time({
        width: "short"
      });
    case "pp":
      return t.time({
        width: "medium"
      });
    case "ppp":
      return t.time({
        width: "long"
      });
    case "pppp":
    default:
      return t.time({
        width: "full"
      });
  }
}, nD = function(e, t) {
  var n = e.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return A2(e, t);
  var o;
  switch (r) {
    case "P":
      o = t.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = t.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = t.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = t.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", A2(r, t)).replace("{{time}}", Y4(a, t));
}, I1 = {
  p: Y4,
  P: nD
};
function Gd(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var aD = ["D", "DD"], oD = ["YY", "YYYY"];
function Z4(e) {
  return aD.indexOf(e) !== -1;
}
function q4(e) {
  return oD.indexOf(e) !== -1;
}
function Hd(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var iD = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, sD = function(e, t, n) {
  var r, a = iD[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function om(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var lD = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, cD = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, uD = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, dD = {
  date: om({
    formats: lD,
    defaultWidth: "full"
  }),
  time: om({
    formats: cD,
    defaultWidth: "full"
  }),
  dateTime: om({
    formats: uD,
    defaultWidth: "full"
  })
}, pD = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, hD = function(e, t, n, r) {
  return pD[e];
};
function Ml(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", a;
    if (r === "formatting" && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth, i = n != null && n.width ? String(n.width) : o;
      a = e.formattingValues[i] || e.formattingValues[o];
    } else {
      var s = e.defaultWidth, l = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[l] || e.values[s];
    }
    var c = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[c];
  };
}
var mD = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, fD = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, gD = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, yD = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, vD = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, bD = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, _D = function(e, t) {
  var n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, wD = {
  ordinalNumber: _D,
  era: Ml({
    values: mD,
    defaultWidth: "wide"
  }),
  quarter: Ml({
    values: fD,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Ml({
    values: gD,
    defaultWidth: "wide"
  }),
  day: Ml({
    values: yD,
    defaultWidth: "wide"
  }),
  dayPeriod: Ml({
    values: vD,
    defaultWidth: "wide",
    formattingValues: bD,
    defaultFormattingWidth: "wide"
  })
};
function Ol(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(a);
    if (!o)
      return null;
    var i = o[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? CD(s, function(d) {
      return d.test(i);
    }) : SD(s, function(d) {
      return d.test(i);
    }), c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var u = t.slice(i.length);
    return {
      value: c,
      rest: u
    };
  };
}
function SD(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function CD(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function xD(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var a = r[0], o = t.match(e.parsePattern);
    if (!o)
      return null;
    var i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    var s = t.slice(a.length);
    return {
      value: i,
      rest: s
    };
  };
}
var kD = /^(\d+)(th|st|nd|rd)?/i, ED = /\d+/i, PD = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, TD = {
  any: [/^b/i, /^(a|c)/i]
}, MD = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, OD = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, AD = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, ND = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, LD = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, RD = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, DD = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ID = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, jD = {
  ordinalNumber: xD({
    matchPattern: kD,
    parsePattern: ED,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Ol({
    matchPatterns: PD,
    defaultMatchWidth: "wide",
    parsePatterns: TD,
    defaultParseWidth: "any"
  }),
  quarter: Ol({
    matchPatterns: MD,
    defaultMatchWidth: "wide",
    parsePatterns: OD,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Ol({
    matchPatterns: AD,
    defaultMatchWidth: "wide",
    parsePatterns: ND,
    defaultParseWidth: "any"
  }),
  day: Ol({
    matchPatterns: LD,
    defaultMatchWidth: "wide",
    parsePatterns: RD,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ol({
    matchPatterns: DD,
    defaultMatchWidth: "any",
    parsePatterns: ID,
    defaultParseWidth: "any"
  })
}, J4 = {
  code: "en-US",
  formatDistance: sD,
  formatLong: dD,
  formatRelative: hD,
  localize: wD,
  match: jD,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, BD = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, FD = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, zD = /^'([^]*?)'?$/, GD = /''/g, HD = /[a-zA-Z]/;
function N2(e, t, n) {
  var r, a, o, i, s, l, c, u, d, p, h, m, f, g, _, v, w, x;
  Ee(2, arguments);
  var b = String(t), C = ns(), E = (r = (a = n == null ? void 0 : n.locale) !== null && a !== void 0 ? a : C.locale) !== null && r !== void 0 ? r : J4, A = dt((o = (i = (s = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (c = n.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && s !== void 0 ? s : C.firstWeekContainsDate) !== null && i !== void 0 ? i : (d = C.locale) === null || d === void 0 || (p = d.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(A >= 1 && A <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var O = dt((h = (m = (f = (g = n == null ? void 0 : n.weekStartsOn) !== null && g !== void 0 ? g : n == null || (_ = n.locale) === null || _ === void 0 || (v = _.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && f !== void 0 ? f : C.weekStartsOn) !== null && m !== void 0 ? m : (w = C.locale) === null || w === void 0 || (x = w.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(O >= 0 && O <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!E.localize)
    throw new RangeError("locale must contain localize property");
  if (!E.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var M = Ne(e);
  if (!Ac(M))
    throw new RangeError("Invalid time value");
  var I = Gd(M), D = U4(M, I), K = {
    firstWeekContainsDate: A,
    weekStartsOn: O,
    locale: E,
    _originalDate: M
  }, G = b.match(FD).map(function(V) {
    var ee = V[0];
    if (ee === "p" || ee === "P") {
      var U = I1[ee];
      return U(V, E.formatLong);
    }
    return V;
  }).join("").match(BD).map(function(V) {
    if (V === "''")
      return "'";
    var ee = V[0];
    if (ee === "'")
      return KD(V);
    var U = rD[ee];
    if (U)
      return !(n != null && n.useAdditionalWeekYearTokens) && q4(V) && Hd(V, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && Z4(V) && Hd(V, t, String(e)), U(D, V, E.localize, K);
    if (ee.match(HD))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + ee + "`");
    return V;
  }).join("");
  return G;
}
function KD(e) {
  var t = e.match(zD);
  return t ? t[1].replace(GD, "'") : e;
}
var UD = 6e4;
function j1(e, t) {
  Ee(2, arguments);
  var n = dt(t);
  return dg(e, n * UD);
}
var $D = 36e5;
function VD(e, t) {
  Ee(2, arguments);
  var n = dt(t);
  return dg(e, n * $D);
}
function ll(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = dt(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Kd(e, t) {
  Ee(2, arguments);
  var n = dt(t), r = n * 7;
  return ll(e, r);
}
function ba(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = dt(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var a = n.getDate(), o = new Date(n.getTime());
  o.setMonth(n.getMonth() + r + 1, 0);
  var i = o.getDate();
  return a >= i ? o : (n.setFullYear(o.getFullYear(), o.getMonth(), a), n);
}
function X4(e, t) {
  Ee(2, arguments);
  var n = dt(t), r = n * 3;
  return ba(e, r);
}
function zs(e, t) {
  Ee(2, arguments);
  var n = dt(t);
  return ba(e, n * 12);
}
function WD(e, t) {
  Ee(2, arguments);
  var n = dt(t);
  return ll(e, -n);
}
function L2(e, t) {
  Ee(2, arguments);
  var n = dt(t);
  return Kd(e, -n);
}
function Gs(e, t) {
  Ee(2, arguments);
  var n = dt(t);
  return ba(e, -n);
}
function YD(e, t) {
  Ee(2, arguments);
  var n = dt(t);
  return X4(e, -n);
}
function Nc(e, t) {
  Ee(2, arguments);
  var n = dt(t);
  return zs(e, -n);
}
function R2(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getSeconds();
  return n;
}
function Ka(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getMinutes();
  return n;
}
function Ua(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getHours();
  return n;
}
function ZD(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getDay();
  return n;
}
function D2(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getDate();
  return n;
}
function Q4(e, t) {
  var n, r, a, o, i, s, l, c;
  Ee(1, arguments);
  var u = ns(), d = dt((n = (r = (a = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = Ne(e), h = p.getDay(), m = (h < d ? 7 : 0) + h - d;
  return p.setDate(p.getDate() - m), p.setHours(0, 0, 0, 0), p;
}
function Ud(e) {
  return Ee(1, arguments), Q4(e, {
    weekStartsOn: 1
  });
}
function qD(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var a = Ud(r), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  var i = Ud(o);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function JD(e) {
  Ee(1, arguments);
  var t = qD(e), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0);
  var r = Ud(n);
  return r;
}
var XD = 6048e5;
function QD(e) {
  Ee(1, arguments);
  var t = Ne(e), n = Ud(t).getTime() - JD(t).getTime();
  return Math.round(n / XD) + 1;
}
function Yr(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getMonth();
  return n;
}
function ws(e) {
  Ee(1, arguments);
  var t = Ne(e), n = Math.floor(t.getMonth() / 3) + 1;
  return n;
}
function pt(e) {
  return Ee(1, arguments), Ne(e).getFullYear();
}
function B1(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getTime();
  return n;
}
function eI(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = dt(t);
  return n.setSeconds(r), n;
}
function id(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = dt(t);
  return n.setMinutes(r), n;
}
function sd(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = dt(t);
  return n.setHours(r), n;
}
function tI(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getFullYear(), r = t.getMonth(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(n, r + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function on(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = dt(t), a = n.getFullYear(), o = n.getDate(), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(a, r, 15), i.setHours(0, 0, 0, 0);
  var s = tI(i);
  return n.setMonth(r, Math.min(o, s)), n;
}
function us(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = dt(t), a = Math.floor(n.getMonth() / 3) + 1, o = r - a;
  return on(n, n.getMonth() + o * 3);
}
function uo(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = dt(t);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(r), n);
}
function I2(e) {
  Ee(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (Kn(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return t.forEach(function(r) {
    var a = Ne(r);
    (n === void 0 || n > a || isNaN(a.getDate())) && (n = a);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function j2(e) {
  Ee(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (Kn(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return t.forEach(function(r) {
    var a = Ne(r);
    (n === void 0 || n < a || isNaN(Number(a))) && (n = a);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function $a(e) {
  Ee(1, arguments);
  var t = Ne(e);
  return t.setHours(0, 0, 0, 0), t;
}
var rI = 864e5;
function $d(e, t) {
  Ee(2, arguments);
  var n = $a(e), r = $a(t), a = n.getTime() - Gd(n), o = r.getTime() - Gd(r);
  return Math.round((a - o) / rI);
}
function Vd(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = Ne(t), a = n.getFullYear() - r.getFullYear(), o = n.getMonth() - r.getMonth();
  return a * 12 + o;
}
function Wd(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = Ne(t);
  return n.getFullYear() - r.getFullYear();
}
function e8(e) {
  Ee(1, arguments);
  var t = Ne(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function F1(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getMonth(), r = n - n % 3;
  return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
}
function t8(e) {
  Ee(1, arguments);
  var t = Ne(e), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function z1(e) {
  Ee(1, arguments);
  var t = Ne(e);
  return t.setHours(23, 59, 59, 999), t;
}
function nI(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function aI(e) {
  Ee(1, arguments);
  var t = Ne(e), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function oI(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = Ne(t);
  return n.getTime() === r.getTime();
}
function iI(e, t) {
  Ee(2, arguments);
  var n = $a(e), r = $a(t);
  return n.getTime() === r.getTime();
}
function sI(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = Ne(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function lI(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = Ne(t);
  return n.getFullYear() === r.getFullYear();
}
function cI(e, t) {
  Ee(2, arguments);
  var n = F1(e), r = F1(t);
  return n.getTime() === r.getTime();
}
function Yo(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = Ne(t);
  return n.getTime() > r.getTime();
}
function Bo(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = Ne(t);
  return n.getTime() < r.getTime();
}
function Lc(e, t) {
  Ee(2, arguments);
  var n = Ne(e).getTime(), r = Ne(t.start).getTime(), a = Ne(t.end).getTime();
  if (!(r <= a))
    throw new RangeError("Invalid interval");
  return n >= r && n <= a;
}
function B2(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = QO(e)) || t) {
      n && (e = n);
      var r = 0, a = function() {
      };
      return {
        s: a,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: a
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o, i = !0, s = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var l = n.next();
      return i = l.done, l;
    },
    e: function(l) {
      s = !0, o = l;
    },
    f: function() {
      try {
        i || n.return == null || n.return();
      } finally {
        if (s)
          throw o;
      }
    }
  };
}
function uI(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function Ae(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function G1(e, t) {
  return G1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, G1(e, t);
}
function Tt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && G1(e, t);
}
function Yd(e) {
  return Yd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Yd(e);
}
function r8() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (r8 = function() {
    return !!e;
  })();
}
function dI(e, t) {
  if (t && (Kn(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ae(e);
}
function Mt(e) {
  var t = r8();
  return function() {
    var n, r = Yd(e);
    if (t) {
      var a = Yd(this).constructor;
      n = Reflect.construct(r, arguments, a);
    } else
      n = r.apply(this, arguments);
    return dI(this, n);
  };
}
var pI = 10, n8 = /* @__PURE__ */ function() {
  function e() {
    vt(this, e), Me(this, "priority", void 0), Me(this, "subPriority", 0);
  }
  return bt(e, [{
    key: "validate",
    value: function(t, n) {
      return !0;
    }
  }]), e;
}(), hI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n(r, a, o, i, s) {
    var l;
    return vt(this, n), l = t.call(this), l.value = r, l.validateValue = a, l.setValue = o, l.priority = i, s && (l.subPriority = s), l;
  }
  return bt(n, [{
    key: "validate",
    value: function(r, a) {
      return this.validateValue(r, this.value, a);
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return this.setValue(r, a, this.value, o);
    }
  }]), n;
}(n8), mI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", pI), Me(Ae(r), "subPriority", -1), r;
  }
  return bt(n, [{
    key: "set",
    value: function(r, a) {
      if (a.timestampIsSet)
        return r;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(r.getUTCFullYear(), r.getUTCMonth(), r.getUTCDate()), o.setHours(r.getUTCHours(), r.getUTCMinutes(), r.getUTCSeconds(), r.getUTCMilliseconds()), o;
    }
  }]), n;
}(n8), Lt = /* @__PURE__ */ function() {
  function e() {
    vt(this, e), Me(this, "incompatibleTokens", void 0), Me(this, "priority", void 0), Me(this, "subPriority", void 0);
  }
  return bt(e, [{
    key: "run",
    value: function(t, n, r, a) {
      var o = this.parse(t, n, r, a);
      return o ? {
        setter: new hI(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(t, n, r) {
      return !0;
    }
  }]), e;
}(), fI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 140), Me(Ae(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "G":
        case "GG":
        case "GGG":
          return o.era(r, {
            width: "abbreviated"
          }) || o.era(r, {
            width: "narrow"
          });
        case "GGGGG":
          return o.era(r, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return o.era(r, {
            width: "wide"
          }) || o.era(r, {
            width: "abbreviated"
          }) || o.era(r, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return a.era = o, r.setUTCFullYear(o, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(Lt), hg = 6e4, mg = 36e5, gI = 1e3, _r = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Na = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function wr(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function cr(e, t) {
  var n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function La(e, t) {
  var n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, a = n[2] ? parseInt(n[2], 10) : 0, o = n[3] ? parseInt(n[3], 10) : 0, i = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (a * mg + o * hg + i * gI),
    rest: t.slice(n[0].length)
  };
}
function a8(e) {
  return cr(_r.anyDigitsSigned, e);
}
function hr(e, t) {
  switch (e) {
    case 1:
      return cr(_r.singleDigit, t);
    case 2:
      return cr(_r.twoDigits, t);
    case 3:
      return cr(_r.threeDigits, t);
    case 4:
      return cr(_r.fourDigits, t);
    default:
      return cr(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function o8(e, t) {
  switch (e) {
    case 1:
      return cr(_r.singleDigitSigned, t);
    case 2:
      return cr(_r.twoDigitsSigned, t);
    case 3:
      return cr(_r.threeDigitsSigned, t);
    case 4:
      return cr(_r.fourDigitsSigned, t);
    default:
      return cr(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function fg(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function i8(e, t) {
  var n = t > 0, r = n ? t : 1 - t, a;
  if (r <= 50)
    a = e || 100;
  else {
    var o = r + 50, i = Math.floor(o / 100) * 100, s = e >= o % 100;
    a = e + i - (s ? 100 : 0);
  }
  return n ? a : 1 - a;
}
function s8(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var yI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 130), Me(Ae(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      var i = function(s) {
        return {
          year: s,
          isTwoDigitYear: a === "yy"
        };
      };
      switch (a) {
        case "y":
          return wr(hr(4, r), i);
        case "yo":
          return wr(o.ordinalNumber(r, {
            unit: "year"
          }), i);
        default:
          return wr(hr(a.length, r), i);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      var i = r.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var s = i8(o.year, i);
        return r.setUTCFullYear(s, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
      }
      var l = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return r.setUTCFullYear(l, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(Lt), vI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 130), Me(Ae(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      var i = function(s) {
        return {
          year: s,
          isTwoDigitYear: a === "YY"
        };
      };
      switch (a) {
        case "Y":
          return wr(hr(4, r), i);
        case "Yo":
          return wr(o.ordinalNumber(r, {
            unit: "year"
          }), i);
        default:
          return wr(hr(a.length, r), i);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(r, a, o, i) {
      var s = pg(r, i);
      if (o.isTwoDigitYear) {
        var l = i8(o.year, s);
        return r.setUTCFullYear(l, 0, i.firstWeekContainsDate), r.setUTCHours(0, 0, 0, 0), Wi(r, i);
      }
      var c = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return r.setUTCFullYear(c, 0, i.firstWeekContainsDate), r.setUTCHours(0, 0, 0, 0), Wi(r, i);
    }
  }]), n;
}(Lt), bI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 130), Me(Ae(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a) {
      return o8(a === "R" ? 4 : a.length, r);
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      var i = /* @__PURE__ */ new Date(0);
      return i.setUTCFullYear(o, 0, 4), i.setUTCHours(0, 0, 0, 0), Fs(i);
    }
  }]), n;
}(Lt), _I = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 130), Me(Ae(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a) {
      return o8(a === "u" ? 4 : a.length, r);
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCFullYear(o, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(Lt), wI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 120), Me(Ae(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "Q":
        case "QQ":
          return hr(a.length, r);
        case "Qo":
          return o.ordinalNumber(r, {
            unit: "quarter"
          });
        case "QQQ":
          return o.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return o.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return o.quarter(r, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCMonth((o - 1) * 3, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(Lt), SI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 120), Me(Ae(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "q":
        case "qq":
          return hr(a.length, r);
        case "qo":
          return o.ordinalNumber(r, {
            unit: "quarter"
          });
        case "qqq":
          return o.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return o.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return o.quarter(r, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCMonth((o - 1) * 3, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(Lt), CI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), Me(Ae(r), "priority", 110), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      var i = function(s) {
        return s - 1;
      };
      switch (a) {
        case "M":
          return wr(cr(_r.month, r), i);
        case "MM":
          return wr(hr(2, r), i);
        case "Mo":
          return wr(o.ordinalNumber(r, {
            unit: "month"
          }), i);
        case "MMM":
          return o.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(r, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return o.month(r, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return o.month(r, {
            width: "wide",
            context: "formatting"
          }) || o.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCMonth(o, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(Lt), xI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 110), Me(Ae(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      var i = function(s) {
        return s - 1;
      };
      switch (a) {
        case "L":
          return wr(cr(_r.month, r), i);
        case "LL":
          return wr(hr(2, r), i);
        case "Lo":
          return wr(o.ordinalNumber(r, {
            unit: "month"
          }), i);
        case "LLL":
          return o.month(r, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(r, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return o.month(r, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return o.month(r, {
            width: "wide",
            context: "standalone"
          }) || o.month(r, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCMonth(o, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(Lt);
function kI(e, t, n) {
  Ee(2, arguments);
  var r = Ne(e), a = dt(t), o = W4(r, n) - a;
  return r.setUTCDate(r.getUTCDate() - o * 7), r;
}
var EI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 100), Me(Ae(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "w":
          return cr(_r.week, r);
        case "wo":
          return o.ordinalNumber(r, {
            unit: "week"
          });
        default:
          return hr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(r, a, o, i) {
      return Wi(kI(r, o, i), i);
    }
  }]), n;
}(Lt);
function PI(e, t) {
  Ee(2, arguments);
  var n = Ne(e), r = dt(t), a = V4(n) - r;
  return n.setUTCDate(n.getUTCDate() - a * 7), n;
}
var TI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 100), Me(Ae(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "I":
          return cr(_r.week, r);
        case "Io":
          return o.ordinalNumber(r, {
            unit: "week"
          });
        default:
          return hr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return Fs(PI(r, o));
    }
  }]), n;
}(Lt), MI = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], OI = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], AI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 90), Me(Ae(r), "subPriority", 1), Me(Ae(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "d":
          return cr(_r.date, r);
        case "do":
          return o.ordinalNumber(r, {
            unit: "date"
          });
        default:
          return hr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      var o = r.getUTCFullYear(), i = s8(o), s = r.getUTCMonth();
      return i ? a >= 1 && a <= OI[s] : a >= 1 && a <= MI[s];
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCDate(o), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(Lt), NI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 90), Me(Ae(r), "subpriority", 1), Me(Ae(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "D":
        case "DD":
          return cr(_r.dayOfYear, r);
        case "Do":
          return o.ordinalNumber(r, {
            unit: "date"
          });
        default:
          return hr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      var o = r.getUTCFullYear(), i = s8(o);
      return i ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCMonth(0, o), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(Lt);
function gg(e, t, n) {
  var r, a, o, i, s, l, c, u;
  Ee(2, arguments);
  var d = ns(), p = dt((r = (a = (o = (i = n == null ? void 0 : n.weekStartsOn) !== null && i !== void 0 ? i : n == null || (s = n.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && o !== void 0 ? o : d.weekStartsOn) !== null && a !== void 0 ? a : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = Ne(e), m = dt(t), f = h.getUTCDay(), g = m % 7, _ = (g + 7) % 7, v = (_ < p ? 7 : 0) + m - f;
  return h.setUTCDate(h.getUTCDate() + v), h;
}
var LI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 90), Me(Ae(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "E":
        case "EE":
        case "EEE":
          return o.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(r, {
            width: "short",
            context: "formatting"
          }) || o.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return o.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return o.day(r, {
            width: "short",
            context: "formatting"
          }) || o.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return o.day(r, {
            width: "wide",
            context: "formatting"
          }) || o.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(r, {
            width: "short",
            context: "formatting"
          }) || o.day(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(r, a, o, i) {
      return r = gg(r, o, i), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(Lt), RI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 90), Me(Ae(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o, i) {
      var s = function(l) {
        var c = Math.floor((l - 1) / 7) * 7;
        return (l + i.weekStartsOn + 6) % 7 + c;
      };
      switch (a) {
        case "e":
        case "ee":
          return wr(hr(a.length, r), s);
        case "eo":
          return wr(o.ordinalNumber(r, {
            unit: "day"
          }), s);
        case "eee":
          return o.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(r, {
            width: "short",
            context: "formatting"
          }) || o.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return o.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return o.day(r, {
            width: "short",
            context: "formatting"
          }) || o.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return o.day(r, {
            width: "wide",
            context: "formatting"
          }) || o.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(r, {
            width: "short",
            context: "formatting"
          }) || o.day(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(r, a, o, i) {
      return r = gg(r, o, i), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(Lt), DI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 90), Me(Ae(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o, i) {
      var s = function(l) {
        var c = Math.floor((l - 1) / 7) * 7;
        return (l + i.weekStartsOn + 6) % 7 + c;
      };
      switch (a) {
        case "c":
        case "cc":
          return wr(hr(a.length, r), s);
        case "co":
          return wr(o.ordinalNumber(r, {
            unit: "day"
          }), s);
        case "ccc":
          return o.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(r, {
            width: "short",
            context: "standalone"
          }) || o.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return o.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return o.day(r, {
            width: "short",
            context: "standalone"
          }) || o.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return o.day(r, {
            width: "wide",
            context: "standalone"
          }) || o.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(r, {
            width: "short",
            context: "standalone"
          }) || o.day(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(r, a, o, i) {
      return r = gg(r, o, i), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(Lt);
function II(e, t) {
  Ee(2, arguments);
  var n = dt(t);
  n % 7 === 0 && (n = n - 7);
  var r = 1, a = Ne(e), o = a.getUTCDay(), i = n % 7, s = (i + 7) % 7, l = (s < r ? 7 : 0) + n - o;
  return a.setUTCDate(a.getUTCDate() + l), a;
}
var jI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 90), Me(Ae(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      var i = function(s) {
        return s === 0 ? 7 : s;
      };
      switch (a) {
        case "i":
        case "ii":
          return hr(a.length, r);
        case "io":
          return o.ordinalNumber(r, {
            unit: "day"
          });
        case "iii":
          return wr(o.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(r, {
            width: "short",
            context: "formatting"
          }) || o.day(r, {
            width: "narrow",
            context: "formatting"
          }), i);
        case "iiiii":
          return wr(o.day(r, {
            width: "narrow",
            context: "formatting"
          }), i);
        case "iiiiii":
          return wr(o.day(r, {
            width: "short",
            context: "formatting"
          }) || o.day(r, {
            width: "narrow",
            context: "formatting"
          }), i);
        case "iiii":
        default:
          return wr(o.day(r, {
            width: "wide",
            context: "formatting"
          }) || o.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(r, {
            width: "short",
            context: "formatting"
          }) || o.day(r, {
            width: "narrow",
            context: "formatting"
          }), i);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 7;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r = II(r, o), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(Lt), BI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 80), Me(Ae(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCHours(fg(o), 0, 0, 0), r;
    }
  }]), n;
}(Lt), FI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 80), Me(Ae(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCHours(fg(o), 0, 0, 0), r;
    }
  }]), n;
}(Lt), zI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 80), Me(Ae(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCHours(fg(o), 0, 0, 0), r;
    }
  }]), n;
}(Lt), GI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 70), Me(Ae(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "h":
          return cr(_r.hour12h, r);
        case "ho":
          return o.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return hr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 12;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      var i = r.getUTCHours() >= 12;
      return i && o < 12 ? r.setUTCHours(o + 12, 0, 0, 0) : !i && o === 12 ? r.setUTCHours(0, 0, 0, 0) : r.setUTCHours(o, 0, 0, 0), r;
    }
  }]), n;
}(Lt), HI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 70), Me(Ae(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "H":
          return cr(_r.hour23h, r);
        case "Ho":
          return o.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return hr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 23;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCHours(o, 0, 0, 0), r;
    }
  }]), n;
}(Lt), KI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 70), Me(Ae(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "K":
          return cr(_r.hour11h, r);
        case "Ko":
          return o.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return hr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      var i = r.getUTCHours() >= 12;
      return i && o < 12 ? r.setUTCHours(o + 12, 0, 0, 0) : r.setUTCHours(o, 0, 0, 0), r;
    }
  }]), n;
}(Lt), UI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 70), Me(Ae(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "k":
          return cr(_r.hour24h, r);
        case "ko":
          return o.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return hr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 24;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      var i = o <= 24 ? o % 24 : o;
      return r.setUTCHours(i, 0, 0, 0), r;
    }
  }]), n;
}(Lt), $I = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 60), Me(Ae(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "m":
          return cr(_r.minute, r);
        case "mo":
          return o.ordinalNumber(r, {
            unit: "minute"
          });
        default:
          return hr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCMinutes(o, 0, 0), r;
    }
  }]), n;
}(Lt), VI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 50), Me(Ae(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, o) {
      switch (a) {
        case "s":
          return cr(_r.second, r);
        case "so":
          return o.ordinalNumber(r, {
            unit: "second"
          });
        default:
          return hr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCSeconds(o, 0), r;
    }
  }]), n;
}(Lt), WI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 30), Me(Ae(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a) {
      var o = function(i) {
        return Math.floor(i * Math.pow(10, -a.length + 3));
      };
      return wr(hr(a.length, r), o);
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return r.setUTCMilliseconds(o), r;
    }
  }]), n;
}(Lt), YI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 10), Me(Ae(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a) {
      switch (a) {
        case "X":
          return La(Na.basicOptionalMinutes, r);
        case "XX":
          return La(Na.basic, r);
        case "XXXX":
          return La(Na.basicOptionalSeconds, r);
        case "XXXXX":
          return La(Na.extendedOptionalSeconds, r);
        case "XXX":
        default:
          return La(Na.extended, r);
      }
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return a.timestampIsSet ? r : new Date(r.getTime() - o);
    }
  }]), n;
}(Lt), ZI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 10), Me(Ae(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a) {
      switch (a) {
        case "x":
          return La(Na.basicOptionalMinutes, r);
        case "xx":
          return La(Na.basic, r);
        case "xxxx":
          return La(Na.basicOptionalSeconds, r);
        case "xxxxx":
          return La(Na.extendedOptionalSeconds, r);
        case "xxx":
        default:
          return La(Na.extended, r);
      }
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return a.timestampIsSet ? r : new Date(r.getTime() - o);
    }
  }]), n;
}(Lt), qI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 40), Me(Ae(r), "incompatibleTokens", "*"), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r) {
      return a8(r);
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Lt), JI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Mt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), Me(Ae(r), "priority", 20), Me(Ae(r), "incompatibleTokens", "*"), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r) {
      return a8(r);
    }
  }, {
    key: "set",
    value: function(r, a, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Lt), XI = {
  G: new fI(),
  y: new yI(),
  Y: new vI(),
  R: new bI(),
  u: new _I(),
  Q: new wI(),
  q: new SI(),
  M: new CI(),
  L: new xI(),
  w: new EI(),
  I: new TI(),
  d: new AI(),
  D: new NI(),
  E: new LI(),
  e: new RI(),
  c: new DI(),
  i: new jI(),
  a: new BI(),
  b: new FI(),
  B: new zI(),
  h: new GI(),
  H: new HI(),
  K: new KI(),
  k: new UI(),
  m: new $I(),
  s: new VI(),
  S: new WI(),
  X: new YI(),
  x: new ZI(),
  t: new qI(),
  T: new JI()
}, QI = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ej = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, tj = /^'([^]*?)'?$/, rj = /''/g, nj = /\S/, aj = /[a-zA-Z]/;
function im(e, t, n, r) {
  var a, o, i, s, l, c, u, d, p, h, m, f, g, _, v, w, x, b;
  Ee(3, arguments);
  var C = String(e), E = String(t), A = ns(), O = (a = (o = r == null ? void 0 : r.locale) !== null && o !== void 0 ? o : A.locale) !== null && a !== void 0 ? a : J4;
  if (!O.match)
    throw new RangeError("locale must contain match property");
  var M = dt((i = (s = (l = (c = r == null ? void 0 : r.firstWeekContainsDate) !== null && c !== void 0 ? c : r == null || (u = r.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : A.firstWeekContainsDate) !== null && s !== void 0 ? s : (p = A.locale) === null || p === void 0 || (h = p.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(M >= 1 && M <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var I = dt((m = (f = (g = (_ = r == null ? void 0 : r.weekStartsOn) !== null && _ !== void 0 ? _ : r == null || (v = r.locale) === null || v === void 0 || (w = v.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && g !== void 0 ? g : A.weekStartsOn) !== null && f !== void 0 ? f : (x = A.locale) === null || x === void 0 || (b = x.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(I >= 0 && I <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (E === "")
    return C === "" ? Ne(n) : /* @__PURE__ */ new Date(NaN);
  var D = {
    firstWeekContainsDate: M,
    weekStartsOn: I,
    locale: O
  }, K = [new mI()], G = E.match(ej).map(function(q) {
    var he = q[0];
    if (he in I1) {
      var me = I1[he];
      return me(q, O.formatLong);
    }
    return q;
  }).join("").match(QI), V = [], ee = B2(G), U;
  try {
    var H = function() {
      var q = U.value;
      !(r != null && r.useAdditionalWeekYearTokens) && q4(q) && Hd(q, E, e), !(r != null && r.useAdditionalDayOfYearTokens) && Z4(q) && Hd(q, E, e);
      var he = q[0], me = XI[he];
      if (me) {
        var Le = me.incompatibleTokens;
        if (Array.isArray(Le)) {
          var $ = V.find(function(J) {
            return Le.includes(J.token) || J.token === he;
          });
          if ($)
            throw new RangeError("The format string mustn't contain `".concat($.fullToken, "` and `").concat(q, "` at the same time"));
        } else if (me.incompatibleTokens === "*" && V.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(q, "` and any other token at the same time"));
        V.push({
          token: he,
          fullToken: q
        });
        var Te = me.run(C, q, O.match, D);
        if (!Te)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        K.push(Te.setter), C = Te.rest;
      } else {
        if (he.match(aj))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + he + "`");
        if (q === "''" ? q = "'" : he === "'" && (q = oj(q)), C.indexOf(q) === 0)
          C = C.slice(q.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (ee.s(); !(U = ee.n()).done; ) {
      var W = H();
      if (Kn(W) === "object")
        return W.v;
    }
  } catch (q) {
    ee.e(q);
  } finally {
    ee.f();
  }
  if (C.length > 0 && nj.test(C))
    return /* @__PURE__ */ new Date(NaN);
  var L = K.map(function(q) {
    return q.priority;
  }).sort(function(q, he) {
    return he - q;
  }).filter(function(q, he, me) {
    return me.indexOf(q) === he;
  }).map(function(q) {
    return K.filter(function(he) {
      return he.priority === q;
    }).sort(function(he, me) {
      return me.subPriority - he.subPriority;
    });
  }).map(function(q) {
    return q[0];
  }), T = Ne(n);
  if (isNaN(T.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var B = U4(T, Gd(T)), N = {}, Y = B2(L), Q;
  try {
    for (Y.s(); !(Q = Y.n()).done; ) {
      var F = Q.value;
      if (!F.validate(B, D))
        return /* @__PURE__ */ new Date(NaN);
      var re = F.set(B, N, D);
      Array.isArray(re) ? (B = re[0], uI(N, re[1])) : B = re;
    }
  } catch (q) {
    Y.e(q);
  } finally {
    Y.f();
  }
  return B;
}
function oj(e) {
  return e.match(tj)[1].replace(rj, "'");
}
function ij(e, t) {
  var n;
  Ee(1, arguments);
  var r = dt((n = void 0) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = uj(e), o;
  if (a.date) {
    var i = dj(a.date, r);
    o = pj(i.restDateString, i.year);
  }
  if (!o || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var s = o.getTime(), l = 0, c;
  if (a.time && (l = hj(a.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (a.timezone) {
    if (c = mj(a.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var u = new Date(s + l), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()), d.setHours(u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds()), d;
  }
  return new Date(s + l + c);
}
var Du = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, sj = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, lj = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, cj = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function uj(e) {
  var t = {}, n = e.split(Du.dateTimeDelimiter), r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], Du.timeZoneDelimiter.test(t.date) && (t.date = e.split(Du.timeZoneDelimiter)[0], r = e.substr(t.date.length, e.length))), r) {
    var a = Du.timezone.exec(r);
    a ? (t.time = r.replace(a[1], ""), t.timezone = a[1]) : t.time = r;
  }
  return t;
}
function dj(e, t) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e.match(n);
  if (!r)
    return {
      year: NaN,
      restDateString: ""
    };
  var a = r[1] ? parseInt(r[1]) : null, o = r[2] ? parseInt(r[2]) : null;
  return {
    year: o === null ? a : o * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function pj(e, t) {
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = e.match(sj);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], a = Al(n[1]), o = Al(n[2]) - 1, i = Al(n[3]), s = Al(n[4]), l = Al(n[5]) - 1;
  if (r)
    return bj(t, s, l) ? fj(t, s, l) : /* @__PURE__ */ new Date(NaN);
  var c = /* @__PURE__ */ new Date(0);
  return !yj(t, o, i) || !vj(t, a) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, o, Math.max(a, i)), c);
}
function Al(e) {
  return e ? parseInt(e) : 1;
}
function hj(e) {
  var t = e.match(lj);
  if (!t)
    return NaN;
  var n = sm(t[1]), r = sm(t[2]), a = sm(t[3]);
  return _j(n, r, a) ? n * mg + r * hg + a * 1e3 : NaN;
}
function sm(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function mj(e) {
  if (e === "Z")
    return 0;
  var t = e.match(cj);
  if (!t)
    return 0;
  var n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), a = t[3] && parseInt(t[3]) || 0;
  return wj(r, a) ? n * (r * mg + a * hg) : NaN;
}
function fj(e, t, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var a = r.getUTCDay() || 7, o = (t - 1) * 7 + n + 1 - a;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
var gj = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function l8(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function yj(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (gj[t] || (l8(e) ? 29 : 28));
}
function vj(e, t) {
  return t >= 1 && t <= (l8(e) ? 366 : 365);
}
function bj(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function _j(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function wj(e, t) {
  return t >= 0 && t <= 59;
}
function Sj(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, H1(e, t);
}
function H1(e, t) {
  return H1 = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, H1(e, t);
}
function Cj(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function F2(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function xj(e, t, n) {
  return e === t ? !0 : e.correspondingElement ? e.correspondingElement.classList.contains(n) : e.classList.contains(n);
}
function kj(e, t, n) {
  if (e === t)
    return !0;
  for (; e.parentNode || e.host; ) {
    if (e.parentNode && xj(e, t, n))
      return !0;
    e = e.parentNode || e.host;
  }
  return e;
}
function Ej(e) {
  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
}
var Pj = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var e = !1, t = Object.defineProperty({}, "passive", {
      get: function() {
        e = !0;
      }
    }), n = function() {
    };
    return window.addEventListener("testPassiveEventSupport", n, t), window.removeEventListener("testPassiveEventSupport", n, t), e;
  }
};
function Tj(e) {
  return e === void 0 && (e = 0), function() {
    return ++e;
  };
}
var Mj = Tj(), K1, Iu = {}, lm = {}, Oj = ["touchstart", "touchmove"], Aj = "ignore-react-onclickoutside";
function z2(e, t) {
  var n = {}, r = Oj.indexOf(t) !== -1;
  return r && K1 && (n.passive = !e.props.preventDefault), n;
}
function oh(e, t) {
  var n, r, a = e.displayName || e.name || "Component";
  return r = n = /* @__PURE__ */ function(o) {
    Sj(i, o);
    function i(l) {
      var c;
      return c = o.call(this, l) || this, c.__outsideClickHandler = function(u) {
        if (typeof c.__clickOutsideHandlerProp == "function") {
          c.__clickOutsideHandlerProp(u);
          return;
        }
        var d = c.getInstance();
        if (typeof d.props.handleClickOutside == "function") {
          d.props.handleClickOutside(u);
          return;
        }
        if (typeof d.handleClickOutside == "function") {
          d.handleClickOutside(u);
          return;
        }
        throw new Error("WrappedComponent: " + a + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, c.__getComponentNode = function() {
        var u = c.getInstance();
        return typeof u.setClickOutsideRef == "function" ? u.setClickOutsideRef() : XS(u);
      }, c.enableOnClickOutside = function() {
        if (!(typeof document > "u" || lm[c._uid])) {
          typeof K1 > "u" && (K1 = Pj()), lm[c._uid] = !0;
          var u = c.props.eventTypes;
          u.forEach || (u = [u]), Iu[c._uid] = function(d) {
            if (c.componentNode !== null && !(c.initTimeStamp > d.timeStamp) && (c.props.preventDefault && d.preventDefault(), c.props.stopPropagation && d.stopPropagation(), !(c.props.excludeScrollbar && Ej(d)))) {
              var p = d.composed && d.composedPath && d.composedPath().shift() || d.target;
              kj(p, c.componentNode, c.props.outsideClickIgnoreClass) === document && c.__outsideClickHandler(d);
            }
          }, u.forEach(function(d) {
            document.addEventListener(d, Iu[c._uid], z2(F2(c), d));
          });
        }
      }, c.disableOnClickOutside = function() {
        delete lm[c._uid];
        var u = Iu[c._uid];
        if (u && typeof document < "u") {
          var d = c.props.eventTypes;
          d.forEach || (d = [d]), d.forEach(function(p) {
            return document.removeEventListener(p, u, z2(F2(c), p));
          }), delete Iu[c._uid];
        }
      }, c.getRef = function(u) {
        return c.instanceRef = u;
      }, c._uid = Mj(), c.initTimeStamp = performance.now(), c;
    }
    var s = i.prototype;
    return s.getInstance = function() {
      if (e.prototype && !e.prototype.isReactComponent)
        return this;
      var l = this.instanceRef;
      return l.getInstance ? l.getInstance() : l;
    }, s.componentDidMount = function() {
      typeof document > "u" || !document.createElement || (this.getInstance(), this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside());
    }, s.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, s.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, s.render = function() {
      var l = this.props;
      l.excludeScrollbar;
      var c = Cj(l, ["excludeScrollbar"]);
      return e.prototype && e.prototype.isReactComponent ? c.ref = this.getRef : c.wrappedRef = this.getRef, c.disableOnClickOutside = this.disableOnClickOutside, c.enableOnClickOutside = this.enableOnClickOutside, Ho(e, c);
    }, i;
  }(YS), n.displayName = "OnClickOutside(" + a + ")", n.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: !1,
    outsideClickIgnoreClass: Aj,
    preventDefault: !1,
    stopPropagation: !1
  }, n.getClass = function() {
    return e.getClass ? e.getClass() : e;
  }, r;
}
var c8 = pe.createContext(), u8 = pe.createContext();
function Nj(e) {
  var t = e.children, n = pe.useState(null), r = n[0], a = n[1], o = pe.useRef(!1);
  pe.useEffect(function() {
    return function() {
      o.current = !0;
    };
  }, []);
  var i = pe.useCallback(function(s) {
    o.current || a(s);
  }, []);
  return /* @__PURE__ */ pe.createElement(c8.Provider, {
    value: r
  }, /* @__PURE__ */ pe.createElement(u8.Provider, {
    value: i
  }, t));
}
var d8 = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, p8 = function(e) {
  if (typeof e == "function") {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      n[r - 1] = arguments[r];
    return e.apply(void 0, n);
  }
}, U1 = function(e, t) {
  if (typeof e == "function")
    return p8(e, t);
  e != null && (e.current = t);
}, G2 = function(e) {
  return e.reduce(function(t, n) {
    var r = n[0], a = n[1];
    return t[r] = a, t;
  }, {});
}, H2 = typeof window < "u" && window.document && window.document.createElement ? pe.useLayoutEffect : pe.useEffect, gn = "top", Un = "bottom", $n = "right", yn = "left", yg = "auto", yu = [gn, Un, $n, yn], Hs = "start", Rc = "end", Lj = "clippingParents", h8 = "viewport", Nl = "popper", Rj = "reference", K2 = /* @__PURE__ */ yu.reduce(function(e, t) {
  return e.concat([t + "-" + Hs, t + "-" + Rc]);
}, []), m8 = /* @__PURE__ */ [].concat(yu, [yg]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Hs, t + "-" + Rc]);
}, []), Dj = "beforeRead", Ij = "read", jj = "afterRead", Bj = "beforeMain", Fj = "main", zj = "afterMain", Gj = "beforeWrite", Hj = "write", Kj = "afterWrite", Uj = [Dj, Ij, jj, Bj, Fj, zj, Gj, Hj, Kj];
function qa(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Dn(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Yi(e) {
  var t = Dn(e).Element;
  return e instanceof t || e instanceof Element;
}
function Hn(e) {
  var t = Dn(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function vg(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Dn(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function $j(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, a = t.attributes[n] || {}, o = t.elements[n];
    !Hn(o) || !qa(o) || (Object.assign(o.style, r), Object.keys(a).forEach(function(i) {
      var s = a[i];
      s === !1 ? o.removeAttribute(i) : o.setAttribute(i, s === !0 ? "" : s);
    }));
  });
}
function Vj(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var a = t.elements[r], o = t.attributes[r] || {}, i = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = i.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Hn(a) || !qa(a) || (Object.assign(a.style, s), Object.keys(o).forEach(function(l) {
        a.removeAttribute(l);
      }));
    });
  };
}
const Wj = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: $j,
  effect: Vj,
  requires: ["computeStyles"]
};
function Va(e) {
  return e.split("-")[0];
}
var Ii = Math.max, Zd = Math.min, Ks = Math.round;
function $1() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function f8() {
  return !/^((?!chrome|android).)*safari/i.test($1());
}
function Us(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), a = 1, o = 1;
  t && Hn(e) && (a = e.offsetWidth > 0 && Ks(r.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && Ks(r.height) / e.offsetHeight || 1);
  var i = Yi(e) ? Dn(e) : window, s = i.visualViewport, l = !f8() && n, c = (r.left + (l && s ? s.offsetLeft : 0)) / a, u = (r.top + (l && s ? s.offsetTop : 0)) / o, d = r.width / a, p = r.height / o;
  return {
    width: d,
    height: p,
    top: u,
    right: c + d,
    bottom: u + p,
    left: c,
    x: c,
    y: u
  };
}
function bg(e) {
  var t = Us(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function g8(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && vg(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function fo(e) {
  return Dn(e).getComputedStyle(e);
}
function Yj(e) {
  return ["table", "td", "th"].indexOf(qa(e)) >= 0;
}
function Qo(e) {
  return ((Yi(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function ih(e) {
  return qa(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (vg(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Qo(e)
  );
}
function U2(e) {
  return !Hn(e) || // https://github.com/popperjs/popper-core/issues/837
  fo(e).position === "fixed" ? null : e.offsetParent;
}
function Zj(e) {
  var t = /firefox/i.test($1()), n = /Trident/i.test($1());
  if (n && Hn(e)) {
    var r = fo(e);
    if (r.position === "fixed")
      return null;
  }
  var a = ih(e);
  for (vg(a) && (a = a.host); Hn(a) && ["html", "body"].indexOf(qa(a)) < 0; ) {
    var o = fo(a);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function vu(e) {
  for (var t = Dn(e), n = U2(e); n && Yj(n) && fo(n).position === "static"; )
    n = U2(n);
  return n && (qa(n) === "html" || qa(n) === "body" && fo(n).position === "static") ? t : n || Zj(e) || t;
}
function _g(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function gc(e, t, n) {
  return Ii(e, Zd(t, n));
}
function qj(e, t, n) {
  var r = gc(e, t, n);
  return r > n ? n : r;
}
function y8() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function v8(e) {
  return Object.assign({}, y8(), e);
}
function b8(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var Jj = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, v8(typeof e != "number" ? e : b8(e, yu));
};
function Xj(e) {
  var t, n = e.state, r = e.name, a = e.options, o = n.elements.arrow, i = n.modifiersData.popperOffsets, s = Va(n.placement), l = _g(s), c = [yn, $n].indexOf(s) >= 0, u = c ? "height" : "width";
  if (!(!o || !i)) {
    var d = Jj(a.padding, n), p = bg(o), h = l === "y" ? gn : yn, m = l === "y" ? Un : $n, f = n.rects.reference[u] + n.rects.reference[l] - i[l] - n.rects.popper[u], g = i[l] - n.rects.reference[l], _ = vu(o), v = _ ? l === "y" ? _.clientHeight || 0 : _.clientWidth || 0 : 0, w = f / 2 - g / 2, x = d[h], b = v - p[u] - d[m], C = v / 2 - p[u] / 2 + w, E = gc(x, C, b), A = l;
    n.modifiersData[r] = (t = {}, t[A] = E, t.centerOffset = E - C, t);
  }
}
function Qj(e) {
  var t = e.state, n = e.options, r = n.element, a = r === void 0 ? "[data-popper-arrow]" : r;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || g8(t.elements.popper, a) && (t.elements.arrow = a));
}
const eB = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Xj,
  effect: Qj,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function $s(e) {
  return e.split("-")[1];
}
var tB = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function rB(e, t) {
  var n = e.x, r = e.y, a = t.devicePixelRatio || 1;
  return {
    x: Ks(n * a) / a || 0,
    y: Ks(r * a) / a || 0
  };
}
function $2(e) {
  var t, n = e.popper, r = e.popperRect, a = e.placement, o = e.variation, i = e.offsets, s = e.position, l = e.gpuAcceleration, c = e.adaptive, u = e.roundOffsets, d = e.isFixed, p = i.x, h = p === void 0 ? 0 : p, m = i.y, f = m === void 0 ? 0 : m, g = typeof u == "function" ? u({
    x: h,
    y: f
  }) : {
    x: h,
    y: f
  };
  h = g.x, f = g.y;
  var _ = i.hasOwnProperty("x"), v = i.hasOwnProperty("y"), w = yn, x = gn, b = window;
  if (c) {
    var C = vu(n), E = "clientHeight", A = "clientWidth";
    if (C === Dn(n) && (C = Qo(n), fo(C).position !== "static" && s === "absolute" && (E = "scrollHeight", A = "scrollWidth")), C = C, a === gn || (a === yn || a === $n) && o === Rc) {
      x = Un;
      var O = d && C === b && b.visualViewport ? b.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        C[E]
      );
      f -= O - r.height, f *= l ? 1 : -1;
    }
    if (a === yn || (a === gn || a === Un) && o === Rc) {
      w = $n;
      var M = d && C === b && b.visualViewport ? b.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        C[A]
      );
      h -= M - r.width, h *= l ? 1 : -1;
    }
  }
  var I = Object.assign({
    position: s
  }, c && tB), D = u === !0 ? rB({
    x: h,
    y: f
  }, Dn(n)) : {
    x: h,
    y: f
  };
  if (h = D.x, f = D.y, l) {
    var K;
    return Object.assign({}, I, (K = {}, K[x] = v ? "0" : "", K[w] = _ ? "0" : "", K.transform = (b.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + f + "px)" : "translate3d(" + h + "px, " + f + "px, 0)", K));
  }
  return Object.assign({}, I, (t = {}, t[x] = v ? f + "px" : "", t[w] = _ ? h + "px" : "", t.transform = "", t));
}
function nB(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, a = r === void 0 ? !0 : r, o = n.adaptive, i = o === void 0 ? !0 : o, s = n.roundOffsets, l = s === void 0 ? !0 : s, c = {
    placement: Va(t.placement),
    variation: $s(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, $2(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, $2(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const aB = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: nB,
  data: {}
};
var ju = {
  passive: !0
};
function oB(e) {
  var t = e.state, n = e.instance, r = e.options, a = r.scroll, o = a === void 0 ? !0 : a, i = r.resize, s = i === void 0 ? !0 : i, l = Dn(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, ju);
  }), s && l.addEventListener("resize", n.update, ju), function() {
    o && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, ju);
    }), s && l.removeEventListener("resize", n.update, ju);
  };
}
const iB = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: oB,
  data: {}
};
var sB = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ld(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return sB[t];
  });
}
var lB = {
  start: "end",
  end: "start"
};
function V2(e) {
  return e.replace(/start|end/g, function(t) {
    return lB[t];
  });
}
function wg(e) {
  var t = Dn(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Sg(e) {
  return Us(Qo(e)).left + wg(e).scrollLeft;
}
function cB(e, t) {
  var n = Dn(e), r = Qo(e), a = n.visualViewport, o = r.clientWidth, i = r.clientHeight, s = 0, l = 0;
  if (a) {
    o = a.width, i = a.height;
    var c = f8();
    (c || !c && t === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: s + Sg(e),
    y: l
  };
}
function uB(e) {
  var t, n = Qo(e), r = wg(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, o = Ii(n.scrollWidth, n.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), i = Ii(n.scrollHeight, n.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -r.scrollLeft + Sg(e), l = -r.scrollTop;
  return fo(a || n).direction === "rtl" && (s += Ii(n.clientWidth, a ? a.clientWidth : 0) - o), {
    width: o,
    height: i,
    x: s,
    y: l
  };
}
function Cg(e) {
  var t = fo(e), n = t.overflow, r = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + a + r);
}
function _8(e) {
  return ["html", "body", "#document"].indexOf(qa(e)) >= 0 ? e.ownerDocument.body : Hn(e) && Cg(e) ? e : _8(ih(e));
}
function yc(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = _8(e), a = r === ((n = e.ownerDocument) == null ? void 0 : n.body), o = Dn(r), i = a ? [o].concat(o.visualViewport || [], Cg(r) ? r : []) : r, s = t.concat(i);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(yc(ih(i)))
  );
}
function V1(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function dB(e, t) {
  var n = Us(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function W2(e, t, n) {
  return t === h8 ? V1(cB(e, n)) : Yi(t) ? dB(t, n) : V1(uB(Qo(e)));
}
function pB(e) {
  var t = yc(ih(e)), n = ["absolute", "fixed"].indexOf(fo(e).position) >= 0, r = n && Hn(e) ? vu(e) : e;
  return Yi(r) ? t.filter(function(a) {
    return Yi(a) && g8(a, r) && qa(a) !== "body";
  }) : [];
}
function hB(e, t, n, r) {
  var a = t === "clippingParents" ? pB(e) : [].concat(t), o = [].concat(a, [n]), i = o[0], s = o.reduce(function(l, c) {
    var u = W2(e, c, r);
    return l.top = Ii(u.top, l.top), l.right = Zd(u.right, l.right), l.bottom = Zd(u.bottom, l.bottom), l.left = Ii(u.left, l.left), l;
  }, W2(e, i, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function w8(e) {
  var t = e.reference, n = e.element, r = e.placement, a = r ? Va(r) : null, o = r ? $s(r) : null, i = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, l;
  switch (a) {
    case gn:
      l = {
        x: i,
        y: t.y - n.height
      };
      break;
    case Un:
      l = {
        x: i,
        y: t.y + t.height
      };
      break;
    case $n:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case yn:
      l = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = a ? _g(a) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (o) {
      case Hs:
        l[c] = l[c] - (t[u] / 2 - n[u] / 2);
        break;
      case Rc:
        l[c] = l[c] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function Dc(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = r === void 0 ? e.placement : r, o = n.strategy, i = o === void 0 ? e.strategy : o, s = n.boundary, l = s === void 0 ? Lj : s, c = n.rootBoundary, u = c === void 0 ? h8 : c, d = n.elementContext, p = d === void 0 ? Nl : d, h = n.altBoundary, m = h === void 0 ? !1 : h, f = n.padding, g = f === void 0 ? 0 : f, _ = v8(typeof g != "number" ? g : b8(g, yu)), v = p === Nl ? Rj : Nl, w = e.rects.popper, x = e.elements[m ? v : p], b = hB(Yi(x) ? x : x.contextElement || Qo(e.elements.popper), l, u, i), C = Us(e.elements.reference), E = w8({
    reference: C,
    element: w,
    strategy: "absolute",
    placement: a
  }), A = V1(Object.assign({}, w, E)), O = p === Nl ? A : C, M = {
    top: b.top - O.top + _.top,
    bottom: O.bottom - b.bottom + _.bottom,
    left: b.left - O.left + _.left,
    right: O.right - b.right + _.right
  }, I = e.modifiersData.offset;
  if (p === Nl && I) {
    var D = I[a];
    Object.keys(M).forEach(function(K) {
      var G = [$n, Un].indexOf(K) >= 0 ? 1 : -1, V = [gn, Un].indexOf(K) >= 0 ? "y" : "x";
      M[K] += D[V] * G;
    });
  }
  return M;
}
function mB(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = n.boundary, o = n.rootBoundary, i = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? m8 : l, u = $s(r), d = u ? s ? K2 : K2.filter(function(m) {
    return $s(m) === u;
  }) : yu, p = d.filter(function(m) {
    return c.indexOf(m) >= 0;
  });
  p.length === 0 && (p = d);
  var h = p.reduce(function(m, f) {
    return m[f] = Dc(e, {
      placement: f,
      boundary: a,
      rootBoundary: o,
      padding: i
    })[Va(f)], m;
  }, {});
  return Object.keys(h).sort(function(m, f) {
    return h[m] - h[f];
  });
}
function fB(e) {
  if (Va(e) === yg)
    return [];
  var t = ld(e);
  return [V2(e), t, V2(t)];
}
function gB(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var a = n.mainAxis, o = a === void 0 ? !0 : a, i = n.altAxis, s = i === void 0 ? !0 : i, l = n.fallbackPlacements, c = n.padding, u = n.boundary, d = n.rootBoundary, p = n.altBoundary, h = n.flipVariations, m = h === void 0 ? !0 : h, f = n.allowedAutoPlacements, g = t.options.placement, _ = Va(g), v = _ === g, w = l || (v || !m ? [ld(g)] : fB(g)), x = [g].concat(w).reduce(function(Y, Q) {
      return Y.concat(Va(Q) === yg ? mB(t, {
        placement: Q,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: m,
        allowedAutoPlacements: f
      }) : Q);
    }, []), b = t.rects.reference, C = t.rects.popper, E = /* @__PURE__ */ new Map(), A = !0, O = x[0], M = 0; M < x.length; M++) {
      var I = x[M], D = Va(I), K = $s(I) === Hs, G = [gn, Un].indexOf(D) >= 0, V = G ? "width" : "height", ee = Dc(t, {
        placement: I,
        boundary: u,
        rootBoundary: d,
        altBoundary: p,
        padding: c
      }), U = G ? K ? $n : yn : K ? Un : gn;
      b[V] > C[V] && (U = ld(U));
      var H = ld(U), W = [];
      if (o && W.push(ee[D] <= 0), s && W.push(ee[U] <= 0, ee[H] <= 0), W.every(function(Y) {
        return Y;
      })) {
        O = I, A = !1;
        break;
      }
      E.set(I, W);
    }
    if (A)
      for (var L = m ? 3 : 1, T = function(Y) {
        var Q = x.find(function(F) {
          var re = E.get(F);
          if (re)
            return re.slice(0, Y).every(function(q) {
              return q;
            });
        });
        if (Q)
          return O = Q, "break";
      }, B = L; B > 0; B--) {
        var N = T(B);
        if (N === "break")
          break;
      }
    t.placement !== O && (t.modifiersData[r]._skip = !0, t.placement = O, t.reset = !0);
  }
}
const yB = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: gB,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Y2(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Z2(e) {
  return [gn, $n, Un, yn].some(function(t) {
    return e[t] >= 0;
  });
}
function vB(e) {
  var t = e.state, n = e.name, r = t.rects.reference, a = t.rects.popper, o = t.modifiersData.preventOverflow, i = Dc(t, {
    elementContext: "reference"
  }), s = Dc(t, {
    altBoundary: !0
  }), l = Y2(i, r), c = Y2(s, a, o), u = Z2(l), d = Z2(c);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const bB = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: vB
};
function _B(e, t, n) {
  var r = Va(e), a = [yn, gn].indexOf(r) >= 0 ? -1 : 1, o = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, i = o[0], s = o[1];
  return i = i || 0, s = (s || 0) * a, [yn, $n].indexOf(r) >= 0 ? {
    x: s,
    y: i
  } : {
    x: i,
    y: s
  };
}
function wB(e) {
  var t = e.state, n = e.options, r = e.name, a = n.offset, o = a === void 0 ? [0, 0] : a, i = m8.reduce(function(u, d) {
    return u[d] = _B(d, t.rects, o), u;
  }, {}), s = i[t.placement], l = s.x, c = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += c), t.modifiersData[r] = i;
}
const SB = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: wB
};
function CB(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = w8({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const xB = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: CB,
  data: {}
};
function kB(e) {
  return e === "x" ? "y" : "x";
}
function EB(e) {
  var t = e.state, n = e.options, r = e.name, a = n.mainAxis, o = a === void 0 ? !0 : a, i = n.altAxis, s = i === void 0 ? !1 : i, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, d = n.padding, p = n.tether, h = p === void 0 ? !0 : p, m = n.tetherOffset, f = m === void 0 ? 0 : m, g = Dc(t, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), _ = Va(t.placement), v = $s(t.placement), w = !v, x = _g(_), b = kB(x), C = t.modifiersData.popperOffsets, E = t.rects.reference, A = t.rects.popper, O = typeof f == "function" ? f(Object.assign({}, t.rects, {
    placement: t.placement
  })) : f, M = typeof O == "number" ? {
    mainAxis: O,
    altAxis: O
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, O), I = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, D = {
    x: 0,
    y: 0
  };
  if (C) {
    if (o) {
      var K, G = x === "y" ? gn : yn, V = x === "y" ? Un : $n, ee = x === "y" ? "height" : "width", U = C[x], H = U + g[G], W = U - g[V], L = h ? -A[ee] / 2 : 0, T = v === Hs ? E[ee] : A[ee], B = v === Hs ? -A[ee] : -E[ee], N = t.elements.arrow, Y = h && N ? bg(N) : {
        width: 0,
        height: 0
      }, Q = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : y8(), F = Q[G], re = Q[V], q = gc(0, E[ee], Y[ee]), he = w ? E[ee] / 2 - L - q - F - M.mainAxis : T - q - F - M.mainAxis, me = w ? -E[ee] / 2 + L + q + re + M.mainAxis : B + q + re + M.mainAxis, Le = t.elements.arrow && vu(t.elements.arrow), $ = Le ? x === "y" ? Le.clientTop || 0 : Le.clientLeft || 0 : 0, Te = (K = I == null ? void 0 : I[x]) != null ? K : 0, J = U + he - Te - $, te = U + me - Te, ve = gc(h ? Zd(H, J) : H, U, h ? Ii(W, te) : W);
      C[x] = ve, D[x] = ve - U;
    }
    if (s) {
      var Pe, $e = x === "x" ? gn : yn, _t = x === "x" ? Un : $n, st = C[b], Mr = b === "y" ? "height" : "width", Vt = st + g[$e], Xt = st - g[_t], je = [gn, yn].indexOf(_) !== -1, lt = (Pe = I == null ? void 0 : I[b]) != null ? Pe : 0, fr = je ? Vt : st - E[Mr] - A[Mr] - lt + M.altAxis, Ot = je ? st + E[Mr] + A[Mr] - lt - M.altAxis : Xt, gr = h && je ? qj(fr, st, Ot) : gc(h ? fr : Vt, st, h ? Ot : Xt);
      C[b] = gr, D[b] = gr - st;
    }
    t.modifiersData[r] = D;
  }
}
const PB = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: EB,
  requiresIfExists: ["offset"]
};
function TB(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function MB(e) {
  return e === Dn(e) || !Hn(e) ? wg(e) : TB(e);
}
function OB(e) {
  var t = e.getBoundingClientRect(), n = Ks(t.width) / e.offsetWidth || 1, r = Ks(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function AB(e, t, n) {
  n === void 0 && (n = !1);
  var r = Hn(t), a = Hn(t) && OB(t), o = Qo(t), i = Us(e, a, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((qa(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Cg(o)) && (s = MB(t)), Hn(t) ? (l = Us(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : o && (l.x = Sg(o))), {
    x: i.left + s.scrollLeft - l.x,
    y: i.top + s.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function NB(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function a(o) {
    n.add(o.name);
    var i = [].concat(o.requires || [], o.requiresIfExists || []);
    i.forEach(function(s) {
      if (!n.has(s)) {
        var l = t.get(s);
        l && a(l);
      }
    }), r.push(o);
  }
  return e.forEach(function(o) {
    n.has(o.name) || a(o);
  }), r;
}
function LB(e) {
  var t = NB(e);
  return Uj.reduce(function(n, r) {
    return n.concat(t.filter(function(a) {
      return a.phase === r;
    }));
  }, []);
}
function RB(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function DB(e) {
  var t = e.reduce(function(n, r) {
    var a = n[r.name];
    return n[r.name] = a ? Object.assign({}, a, r, {
      options: Object.assign({}, a.options, r.options),
      data: Object.assign({}, a.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var q2 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function J2() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function IB(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, a = t.defaultOptions, o = a === void 0 ? q2 : a;
  return function(i, s, l) {
    l === void 0 && (l = o);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, q2, o),
      modifiersData: {},
      elements: {
        reference: i,
        popper: s
      },
      attributes: {},
      styles: {}
    }, u = [], d = !1, p = {
      state: c,
      setOptions: function(f) {
        var g = typeof f == "function" ? f(c.options) : f;
        m(), c.options = Object.assign({}, o, c.options, g), c.scrollParents = {
          reference: Yi(i) ? yc(i) : i.contextElement ? yc(i.contextElement) : [],
          popper: yc(s)
        };
        var _ = LB(DB([].concat(r, c.options.modifiers)));
        return c.orderedModifiers = _.filter(function(v) {
          return v.enabled;
        }), h(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!d) {
          var f = c.elements, g = f.reference, _ = f.popper;
          if (J2(g, _)) {
            c.rects = {
              reference: AB(g, vu(_), c.options.strategy === "fixed"),
              popper: bg(_)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(A) {
              return c.modifiersData[A.name] = Object.assign({}, A.data);
            });
            for (var v = 0; v < c.orderedModifiers.length; v++) {
              if (c.reset === !0) {
                c.reset = !1, v = -1;
                continue;
              }
              var w = c.orderedModifiers[v], x = w.fn, b = w.options, C = b === void 0 ? {} : b, E = w.name;
              typeof x == "function" && (c = x({
                state: c,
                options: C,
                name: E,
                instance: p
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: RB(function() {
        return new Promise(function(f) {
          p.forceUpdate(), f(c);
        });
      }),
      destroy: function() {
        m(), d = !0;
      }
    };
    if (!J2(i, s))
      return p;
    p.setOptions(l).then(function(f) {
      !d && l.onFirstUpdate && l.onFirstUpdate(f);
    });
    function h() {
      c.orderedModifiers.forEach(function(f) {
        var g = f.name, _ = f.options, v = _ === void 0 ? {} : _, w = f.effect;
        if (typeof w == "function") {
          var x = w({
            state: c,
            name: g,
            instance: p,
            options: v
          }), b = function() {
          };
          u.push(x || b);
        }
      });
    }
    function m() {
      u.forEach(function(f) {
        return f();
      }), u = [];
    }
    return p;
  };
}
var jB = [iB, xB, aB, Wj, SB, yB, PB, eB, bB], BB = /* @__PURE__ */ IB({
  defaultModifiers: jB
}), FB = typeof Element < "u", zB = typeof Map == "function", GB = typeof Set == "function", HB = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function cd(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, a;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!cd(e[r], t[r]))
          return !1;
      return !0;
    }
    var o;
    if (zB && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!cd(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (GB && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (HB && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, a[r]))
        return !1;
    if (FB && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((a[r] === "_owner" || a[r] === "__v" || a[r] === "__o") && e.$$typeof) && !cd(e[a[r]], t[a[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var KB = function(e, t) {
  try {
    return cd(e, t);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
};
const UB = /* @__PURE__ */ Ep(KB);
var $B = [], VB = function(e, t, n) {
  n === void 0 && (n = {});
  var r = pe.useRef(null), a = {
    onFirstUpdate: n.onFirstUpdate,
    placement: n.placement || "bottom",
    strategy: n.strategy || "absolute",
    modifiers: n.modifiers || $B
  }, o = pe.useState({
    styles: {
      popper: {
        position: a.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), i = o[0], s = o[1], l = pe.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(d) {
        var p = d.state, h = Object.keys(p.elements);
        Cc.flushSync(function() {
          s({
            styles: G2(h.map(function(m) {
              return [m, p.styles[m] || {}];
            })),
            attributes: G2(h.map(function(m) {
              return [m, p.attributes[m]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), c = pe.useMemo(function() {
    var d = {
      onFirstUpdate: a.onFirstUpdate,
      placement: a.placement,
      strategy: a.strategy,
      modifiers: [].concat(a.modifiers, [l, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return UB(r.current, d) ? r.current || d : (r.current = d, d);
  }, [a.onFirstUpdate, a.placement, a.strategy, a.modifiers, l]), u = pe.useRef();
  return H2(function() {
    u.current && u.current.setOptions(c);
  }, [c]), H2(function() {
    if (!(e == null || t == null)) {
      var d = n.createPopper || BB, p = d(e, t, c);
      return u.current = p, function() {
        p.destroy(), u.current = null;
      };
    }
  }, [e, t, n.createPopper]), {
    state: u.current ? u.current.state : null,
    styles: i.styles,
    attributes: i.attributes,
    update: u.current ? u.current.update : null,
    forceUpdate: u.current ? u.current.forceUpdate : null
  };
}, WB = function() {
}, YB = function() {
  return Promise.resolve(null);
}, ZB = [];
function qB(e) {
  var t = e.placement, n = t === void 0 ? "bottom" : t, r = e.strategy, a = r === void 0 ? "absolute" : r, o = e.modifiers, i = o === void 0 ? ZB : o, s = e.referenceElement, l = e.onFirstUpdate, c = e.innerRef, u = e.children, d = pe.useContext(c8), p = pe.useState(null), h = p[0], m = p[1], f = pe.useState(null), g = f[0], _ = f[1];
  pe.useEffect(function() {
    U1(c, h);
  }, [c, h]);
  var v = pe.useMemo(function() {
    return {
      placement: n,
      strategy: a,
      onFirstUpdate: l,
      modifiers: [].concat(i, [{
        name: "arrow",
        enabled: g != null,
        options: {
          element: g
        }
      }])
    };
  }, [n, a, l, i, g]), w = VB(s || d, h, v), x = w.state, b = w.styles, C = w.forceUpdate, E = w.update, A = pe.useMemo(function() {
    return {
      ref: m,
      style: b.popper,
      placement: x ? x.placement : n,
      hasPopperEscaped: x && x.modifiersData.hide ? x.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: x && x.modifiersData.hide ? x.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: b.arrow,
        ref: _
      },
      forceUpdate: C || WB,
      update: E || YB
    };
  }, [m, _, n, x, b, E, C]);
  return d8(u)(A);
}
var JB = process.env.NODE_ENV !== "production", S8 = function() {
};
if (JB) {
  var XB = function(e, t) {
    var n = arguments.length;
    t = new Array(n > 1 ? n - 1 : 0);
    for (var r = 1; r < n; r++)
      t[r - 1] = arguments[r];
    var a = 0, o = "Warning: " + e.replace(/%s/g, function() {
      return t[a++];
    });
    typeof console < "u" && console.error(o);
    try {
      throw new Error(o);
    } catch {
    }
  };
  S8 = function(e, t, n) {
    var r = arguments.length;
    n = new Array(r > 2 ? r - 2 : 0);
    for (var a = 2; a < r; a++)
      n[a - 2] = arguments[a];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || XB.apply(null, [t].concat(n));
  };
}
var QB = S8;
const eF = /* @__PURE__ */ Ep(QB);
function tF(e) {
  var t = e.children, n = e.innerRef, r = pe.useContext(u8), a = pe.useCallback(function(o) {
    U1(n, o), p8(r, o);
  }, [n, r]);
  return pe.useEffect(function() {
    return function() {
      return U1(n, null);
    };
  }, []), pe.useEffect(function() {
    eF(!!r, "`Reference` should not be used outside of a `Manager` component.");
  }, [r]), d8(t)({
    ref: a
  });
}
function rF(e, t) {
  if (Ee(2, arguments), Kn(t) !== "object" || t === null)
    throw new RangeError("values parameter must be an object");
  var n = Ne(e);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (t.year != null && n.setFullYear(t.year), t.month != null && (n = on(n, t.month)), t.date != null && n.setDate(dt(t.date)), t.hours != null && n.setHours(dt(t.hours)), t.minutes != null && n.setMinutes(dt(t.minutes)), t.seconds != null && n.setSeconds(dt(t.seconds)), t.milliseconds != null && n.setMilliseconds(dt(t.milliseconds)), n);
}
function X2(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function qd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? X2(Object(n), !0).forEach(function(r) {
      j(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : X2(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function W1(e) {
  return W1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, W1(e);
}
function jr(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Q2(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, C8(r.key), r);
  }
}
function Br(e, t, n) {
  return t && Q2(e.prototype, t), n && Q2(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function j(e, t, n) {
  return (t = C8(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Vs() {
  return Vs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vs.apply(this, arguments);
}
function Fr(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Y1(e, t);
}
function Jd(e) {
  return Jd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Jd(e);
}
function Y1(e, t) {
  return Y1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Y1(e, t);
}
function z(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zr(e) {
  var t = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }();
  return function() {
    var n, r = Jd(e);
    if (t) {
      var a = Jd(this).constructor;
      n = Reflect.construct(r, arguments, a);
    } else
      n = r.apply(this, arguments);
    return function(o, i) {
      if (i && (typeof i == "object" || typeof i == "function"))
        return i;
      if (i !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return z(o);
    }(this, n);
  };
}
function Ic(e) {
  return function(t) {
    if (Array.isArray(t))
      return cm(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
      return Array.from(t);
  }(e) || function(t, n) {
    if (t) {
      if (typeof t == "string")
        return cm(t, n);
      var r = Object.prototype.toString.call(t).slice(8, -1);
      if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
        return Array.from(t);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
        return cm(t, n);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function cm(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function C8(e) {
  var t = function(n, r) {
    if (typeof n != "object" || n === null)
      return n;
    var a = n[Symbol.toPrimitive];
    if (a !== void 0) {
      var o = a.call(n, r || "default");
      if (typeof o != "object")
        return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var ev = function(e, t) {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    default:
      return t.date({ width: "full" });
  }
}, tv = function(e, t) {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    default:
      return t.time({ width: "full" });
  }
}, nF = { p: tv, P: function(e, t) {
  var n, r = e.match(/(P+)(p+)?/) || [], a = r[1], o = r[2];
  if (!o)
    return ev(e, t);
  switch (a) {
    case "P":
      n = t.dateTime({ width: "short" });
      break;
    case "PP":
      n = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      n = t.dateTime({ width: "long" });
      break;
    default:
      n = t.dateTime({ width: "full" });
  }
  return n.replace("{{date}}", ev(a, t)).replace("{{time}}", tv(o, t));
} }, vc = 12, aF = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function Zt(e) {
  var t = e ? typeof e == "string" || e instanceof String ? ij(e) : Ne(e) : /* @__PURE__ */ new Date();
  return Do(t) ? t : null;
}
function Do(e, t) {
  return t = t || /* @__PURE__ */ new Date("1/1/1000"), Ac(e) && !Bo(e, t);
}
function ir(e, t, n) {
  if (n === "en")
    return N2(e, t, { awareOfUnicodeTokens: !0 });
  var r = Bi(n);
  return n && !r && console.warn('A locale object was not found for the provided string ["'.concat(n, '"].')), !r && ji() && Bi(ji()) && (r = Bi(ji())), N2(e, t, { locale: r || null, awareOfUnicodeTokens: !0 });
}
function Ta(e, t) {
  var n = t.dateFormat, r = t.locale;
  return e && ir(e, Array.isArray(n) ? n[0] : n, r) || "";
}
function rv(e, t) {
  var n = t.hour, r = n === void 0 ? 0 : n, a = t.minute, o = a === void 0 ? 0 : a, i = t.second;
  return sd(id(eI(e, i === void 0 ? 0 : i), o), r);
}
function Wa(e, t, n) {
  var r = Bi(t || ji());
  return Q4(e, { locale: r, weekStartsOn: n });
}
function $o(e) {
  return e8(e);
}
function cc(e) {
  return t8(e);
}
function nv(e) {
  return F1(e);
}
function av() {
  return $a(Zt());
}
function Fo(e, t) {
  return e && t ? lI(e, t) : !e && !t;
}
function da(e, t) {
  return e && t ? sI(e, t) : !e && !t;
}
function Xd(e, t) {
  return e && t ? cI(e, t) : !e && !t;
}
function Jt(e, t) {
  return e && t ? iI(e, t) : !e && !t;
}
function Oi(e, t) {
  return e && t ? oI(e, t) : !e && !t;
}
function ud(e, t, n) {
  var r, a = $a(t), o = z1(n);
  try {
    r = Lc(e, { start: a, end: o });
  } catch {
    r = !1;
  }
  return r;
}
function ji() {
  return (typeof window < "u" ? window : globalThis).__localeId__;
}
function Bi(e) {
  if (typeof e == "string") {
    var t = typeof window < "u" ? window : globalThis;
    return t.__localeData__ ? t.__localeData__[e] : null;
  }
  return e;
}
function xg(e, t) {
  return ir(on(Zt(), e), "LLLL", t);
}
function x8(e, t) {
  return ir(on(Zt(), e), "LLL", t);
}
function sh(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate, a = t.excludeDates, o = t.excludeDateIntervals, i = t.includeDates, s = t.includeDateIntervals, l = t.filterDate;
  return lh(e, { minDate: n, maxDate: r }) || a && a.some(function(c) {
    return Jt(e, c);
  }) || o && o.some(function(c) {
    var u = c.start, d = c.end;
    return Lc(e, { start: u, end: d });
  }) || i && !i.some(function(c) {
    return Jt(e, c);
  }) || s && !s.some(function(c) {
    var u = c.start, d = c.end;
    return Lc(e, { start: u, end: d });
  }) || l && !l(Zt(e)) || !1;
}
function kg(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.excludeDates, r = t.excludeDateIntervals;
  return r && r.length > 0 ? r.some(function(a) {
    var o = a.start, i = a.end;
    return Lc(e, { start: o, end: i });
  }) : n && n.some(function(a) {
    return Jt(e, a);
  }) || !1;
}
function k8(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate, a = t.excludeDates, o = t.includeDates, i = t.filterDate;
  return lh(e, { minDate: e8(n), maxDate: nI(r) }) || a && a.some(function(s) {
    return da(e, s);
  }) || o && !o.some(function(s) {
    return da(e, s);
  }) || i && !i(Zt(e)) || !1;
}
function um(e, t, n, r) {
  var a = pt(e), o = Yr(e), i = pt(t), s = Yr(t), l = pt(r);
  return a === i && a === l ? o <= n && n <= s : a < i ? l === a && o <= n || l === i && s >= n || l < i && l > a : void 0;
}
function oF(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate, a = t.excludeDates, o = t.includeDates, i = t.filterDate;
  return lh(e, { minDate: n, maxDate: r }) || a && a.some(function(s) {
    return Xd(e, s);
  }) || o && !o.some(function(s) {
    return Xd(e, s);
  }) || i && !i(Zt(e)) || !1;
}
function dm(e, t, n) {
  if (!Ac(t) || !Ac(n))
    return !1;
  var r = pt(t), a = pt(n);
  return r <= e && a >= e;
}
function E8(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate, a = t.excludeDates, o = t.includeDates, i = t.filterDate, s = new Date(e, 0, 1);
  return lh(s, { minDate: t8(n), maxDate: aI(r) }) || a && a.some(function(l) {
    return Fo(s, l);
  }) || o && !o.some(function(l) {
    return Fo(s, l);
  }) || i && !i(Zt(s)) || !1;
}
function pm(e, t, n, r) {
  var a = pt(e), o = ws(e), i = pt(t), s = ws(t), l = pt(r);
  return a === i && a === l ? o <= n && n <= s : a < i ? l === a && o <= n || l === i && s >= n || l < i && l > a : void 0;
}
function lh(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate;
  return n && $d(e, n) < 0 || r && $d(e, r) > 0;
}
function ov(e, t) {
  return t.some(function(n) {
    return Ua(n) === Ua(e) && Ka(n) === Ka(e);
  });
}
function iv(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.excludeTimes, r = t.includeTimes, a = t.filterTime;
  return n && ov(e, n) || r && !ov(e, r) || a && !a(e) || !1;
}
function sv(e, t) {
  var n = t.minTime, r = t.maxTime;
  if (!n || !r)
    throw new Error("Both minTime and maxTime props required");
  var a, o = Zt(), i = sd(id(o, Ka(e)), Ua(e)), s = sd(id(o, Ka(n)), Ua(n)), l = sd(id(o, Ka(r)), Ua(r));
  try {
    a = !Lc(i, { start: s, end: l });
  } catch {
    a = !1;
  }
  return a;
}
function lv(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.includeDates, a = Gs(e, 1);
  return n && Vd(n, a) > 0 || r && r.every(function(o) {
    return Vd(o, a) > 0;
  }) || !1;
}
function cv(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.maxDate, r = t.includeDates, a = ba(e, 1);
  return n && Vd(a, n) > 0 || r && r.every(function(o) {
    return Vd(a, o) > 0;
  }) || !1;
}
function uv(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.includeDates, a = Nc(e, 1);
  return n && Wd(n, a) > 0 || r && r.every(function(o) {
    return Wd(o, a) > 0;
  }) || !1;
}
function dv(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.maxDate, r = t.includeDates, a = zs(e, 1);
  return n && Wd(a, n) > 0 || r && r.every(function(o) {
    return Wd(a, o) > 0;
  }) || !1;
}
function P8(e) {
  var t = e.minDate, n = e.includeDates;
  if (n && t) {
    var r = n.filter(function(a) {
      return $d(a, t) >= 0;
    });
    return I2(r);
  }
  return n ? I2(n) : t;
}
function T8(e) {
  var t = e.maxDate, n = e.includeDates;
  if (n && t) {
    var r = n.filter(function(a) {
      return $d(a, t) <= 0;
    });
    return j2(r);
  }
  return n ? j2(n) : t;
}
function pv() {
  for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", n = /* @__PURE__ */ new Map(), r = 0, a = e.length; r < a; r++) {
    var o = e[r];
    if (ah(o)) {
      var i = ir(o, "MM.dd.yyyy"), s = n.get(i) || [];
      s.includes(t) || (s.push(t), n.set(i, s));
    } else if (W1(o) === "object") {
      var l = Object.keys(o), c = l[0], u = o[l[0]];
      if (typeof c == "string" && u.constructor === Array)
        for (var d = 0, p = u.length; d < p; d++) {
          var h = ir(u[d], "MM.dd.yyyy"), m = n.get(h) || [];
          m.includes(c) || (m.push(c), n.set(h, m));
        }
    }
  }
  return n;
}
function iF() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--holidays", n = /* @__PURE__ */ new Map();
  return e.forEach(function(r) {
    var a = r.date, o = r.holidayName;
    if (ah(a)) {
      var i = ir(a, "MM.dd.yyyy"), s = n.get(i) || {};
      if (!("className" in s) || s.className !== t || (l = s.holidayNames, c = [o], l.length !== c.length || !l.every(function(d, p) {
        return d === c[p];
      }))) {
        var l, c;
        s.className = t;
        var u = s.holidayNames;
        s.holidayNames = u ? [].concat(Ic(u), [o]) : [o], n.set(i, s);
      }
    }
  }), n;
}
function sF(e, t, n, r, a) {
  for (var o = a.length, i = [], s = 0; s < o; s++) {
    var l = j1(VD(e, Ua(a[s])), Ka(a[s])), c = j1(e, (n + 1) * r);
    Yo(l, t) && Bo(l, c) && i.push(a[s]);
  }
  return i;
}
function hv(e) {
  return e < 10 ? "0".concat(e) : "".concat(e);
}
function Ss(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : vc, n = Math.ceil(pt(e) / t) * t;
  return { startPeriod: n - (t - 1), endPeriod: n };
}
function mv(e) {
  var t = e.getSeconds(), n = e.getMilliseconds();
  return Ne(e.getTime() - 1e3 * t - n);
}
function lF(e, t, n, r) {
  for (var a = [], o = 0; o < 2 * t + 1; o++) {
    var i = e + t - o, s = !0;
    n && (s = pt(n) <= i), r && s && (s = pt(r) >= i), s && a.push(i);
  }
  return a;
}
var cF = oh(function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n(r) {
    var a;
    jr(this, n), j(z(a = t.call(this, r)), "renderOptions", function() {
      var l = a.props.year, c = a.state.yearsList.map(function(p) {
        return k.createElement("div", { className: l === p ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: p, onClick: a.onChange.bind(z(a), p), "aria-selected": l === p ? "true" : void 0 }, l === p ? k.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", p);
      }), u = a.props.minDate ? pt(a.props.minDate) : null, d = a.props.maxDate ? pt(a.props.maxDate) : null;
      return d && a.state.yearsList.find(function(p) {
        return p === d;
      }) || c.unshift(k.createElement("div", { className: "react-datepicker__year-option", key: "upcoming", onClick: a.incrementYears }, k.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), u && a.state.yearsList.find(function(p) {
        return p === u;
      }) || c.push(k.createElement("div", { className: "react-datepicker__year-option", key: "previous", onClick: a.decrementYears }, k.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), c;
    }), j(z(a), "onChange", function(l) {
      a.props.onChange(l);
    }), j(z(a), "handleClickOutside", function() {
      a.props.onCancel();
    }), j(z(a), "shiftYears", function(l) {
      var c = a.state.yearsList.map(function(u) {
        return u + l;
      });
      a.setState({ yearsList: c });
    }), j(z(a), "incrementYears", function() {
      return a.shiftYears(1);
    }), j(z(a), "decrementYears", function() {
      return a.shiftYears(-1);
    });
    var o = r.yearDropdownItemNumber, i = r.scrollableYearDropdown, s = o || (i ? 10 : 5);
    return a.state = { yearsList: lF(a.props.year, s, a.props.minDate, a.props.maxDate) }, a.dropdownRef = Ri(), a;
  }
  return Br(n, [{ key: "componentDidMount", value: function() {
    var r = this.dropdownRef.current;
    if (r) {
      var a = r.children ? Array.from(r.children) : null, o = a ? a.find(function(i) {
        return i.ariaSelected;
      }) : null;
      r.scrollTop = o ? o.offsetTop + (o.clientHeight - r.clientHeight) / 2 : (r.scrollHeight - r.clientHeight) / 2;
    }
  } }, { key: "render", value: function() {
    var r = Ur({ "react-datepicker__year-dropdown": !0, "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown });
    return k.createElement("div", { className: r, ref: this.dropdownRef }, this.renderOptions());
  } }]), n;
}()), uF = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n() {
    var r;
    jr(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return j(z(r = t.call.apply(t, [this].concat(o))), "state", { dropdownVisible: !1 }), j(z(r), "renderSelectOptions", function() {
      for (var s = r.props.minDate ? pt(r.props.minDate) : 1900, l = r.props.maxDate ? pt(r.props.maxDate) : 2100, c = [], u = s; u <= l; u++)
        c.push(k.createElement("option", { key: u, value: u }, u));
      return c;
    }), j(z(r), "onSelectChange", function(s) {
      r.onChange(s.target.value);
    }), j(z(r), "renderSelectMode", function() {
      return k.createElement("select", { value: r.props.year, className: "react-datepicker__year-select", onChange: r.onSelectChange }, r.renderSelectOptions());
    }), j(z(r), "renderReadView", function(s) {
      return k.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(l) {
        return r.toggleDropdown(l);
      } }, k.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), k.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, r.props.year));
    }), j(z(r), "renderDropdown", function() {
      return k.createElement(cF, { key: "dropdown", year: r.props.year, onChange: r.onChange, onCancel: r.toggleDropdown, minDate: r.props.minDate, maxDate: r.props.maxDate, scrollableYearDropdown: r.props.scrollableYearDropdown, yearDropdownItemNumber: r.props.yearDropdownItemNumber });
    }), j(z(r), "renderScrollMode", function() {
      var s = r.state.dropdownVisible, l = [r.renderReadView(!s)];
      return s && l.unshift(r.renderDropdown()), l;
    }), j(z(r), "onChange", function(s) {
      r.toggleDropdown(), s !== r.props.year && r.props.onChange(s);
    }), j(z(r), "toggleDropdown", function(s) {
      r.setState({ dropdownVisible: !r.state.dropdownVisible }, function() {
        r.props.adjustDateOnChange && r.handleYearChange(r.props.date, s);
      });
    }), j(z(r), "handleYearChange", function(s, l) {
      r.onSelect(s, l), r.setOpen();
    }), j(z(r), "onSelect", function(s, l) {
      r.props.onSelect && r.props.onSelect(s, l);
    }), j(z(r), "setOpen", function() {
      r.props.setOpen && r.props.setOpen(!0);
    }), r;
  }
  return Br(n, [{ key: "render", value: function() {
    var r;
    switch (this.props.dropdownMode) {
      case "scroll":
        r = this.renderScrollMode();
        break;
      case "select":
        r = this.renderSelectMode();
    }
    return k.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, r);
  } }]), n;
}(), dF = oh(function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n() {
    var r;
    jr(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return j(z(r = t.call.apply(t, [this].concat(o))), "isSelectedMonth", function(s) {
      return r.props.month === s;
    }), j(z(r), "renderOptions", function() {
      return r.props.monthNames.map(function(s, l) {
        return k.createElement("div", { className: r.isSelectedMonth(l) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: s, onClick: r.onChange.bind(z(r), l), "aria-selected": r.isSelectedMonth(l) ? "true" : void 0 }, r.isSelectedMonth(l) ? k.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", s);
      });
    }), j(z(r), "onChange", function(s) {
      return r.props.onChange(s);
    }), j(z(r), "handleClickOutside", function() {
      return r.props.onCancel();
    }), r;
  }
  return Br(n, [{ key: "render", value: function() {
    return k.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
  } }]), n;
}()), pF = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n() {
    var r;
    jr(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return j(z(r = t.call.apply(t, [this].concat(o))), "state", { dropdownVisible: !1 }), j(z(r), "renderSelectOptions", function(s) {
      return s.map(function(l, c) {
        return k.createElement("option", { key: c, value: c }, l);
      });
    }), j(z(r), "renderSelectMode", function(s) {
      return k.createElement("select", { value: r.props.month, className: "react-datepicker__month-select", onChange: function(l) {
        return r.onChange(l.target.value);
      } }, r.renderSelectOptions(s));
    }), j(z(r), "renderReadView", function(s, l) {
      return k.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: r.toggleDropdown }, k.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), k.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, l[r.props.month]));
    }), j(z(r), "renderDropdown", function(s) {
      return k.createElement(dF, { key: "dropdown", month: r.props.month, monthNames: s, onChange: r.onChange, onCancel: r.toggleDropdown });
    }), j(z(r), "renderScrollMode", function(s) {
      var l = r.state.dropdownVisible, c = [r.renderReadView(!l, s)];
      return l && c.unshift(r.renderDropdown(s)), c;
    }), j(z(r), "onChange", function(s) {
      r.toggleDropdown(), s !== r.props.month && r.props.onChange(s);
    }), j(z(r), "toggleDropdown", function() {
      return r.setState({ dropdownVisible: !r.state.dropdownVisible });
    }), r;
  }
  return Br(n, [{ key: "render", value: function() {
    var r, a = this, o = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(i) {
      return x8(i, a.props.locale);
    } : function(i) {
      return xg(i, a.props.locale);
    });
    switch (this.props.dropdownMode) {
      case "scroll":
        r = this.renderScrollMode(o);
        break;
      case "select":
        r = this.renderSelectMode(o);
    }
    return k.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, r);
  } }]), n;
}();
function hF(e, t) {
  for (var n = [], r = $o(e), a = $o(t); !Yo(r, a); )
    n.push(Zt(r)), r = ba(r, 1);
  return n;
}
var mF = oh(function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n(r) {
    var a;
    return jr(this, n), j(z(a = t.call(this, r)), "renderOptions", function() {
      return a.state.monthYearsList.map(function(o) {
        var i = B1(o), s = Fo(a.props.date, o) && da(a.props.date, o);
        return k.createElement("div", { className: s ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: i, onClick: a.onChange.bind(z(a), i), "aria-selected": s ? "true" : void 0 }, s ? k.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", ir(o, a.props.dateFormat, a.props.locale));
      });
    }), j(z(a), "onChange", function(o) {
      return a.props.onChange(o);
    }), j(z(a), "handleClickOutside", function() {
      a.props.onCancel();
    }), a.state = { monthYearsList: hF(a.props.minDate, a.props.maxDate) }, a;
  }
  return Br(n, [{ key: "render", value: function() {
    var r = Ur({ "react-datepicker__month-year-dropdown": !0, "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown });
    return k.createElement("div", { className: r }, this.renderOptions());
  } }]), n;
}()), fF = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n() {
    var r;
    jr(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return j(z(r = t.call.apply(t, [this].concat(o))), "state", { dropdownVisible: !1 }), j(z(r), "renderSelectOptions", function() {
      for (var s = $o(r.props.minDate), l = $o(r.props.maxDate), c = []; !Yo(s, l); ) {
        var u = B1(s);
        c.push(k.createElement("option", { key: u, value: u }, ir(s, r.props.dateFormat, r.props.locale))), s = ba(s, 1);
      }
      return c;
    }), j(z(r), "onSelectChange", function(s) {
      r.onChange(s.target.value);
    }), j(z(r), "renderSelectMode", function() {
      return k.createElement("select", { value: B1($o(r.props.date)), className: "react-datepicker__month-year-select", onChange: r.onSelectChange }, r.renderSelectOptions());
    }), j(z(r), "renderReadView", function(s) {
      var l = ir(r.props.date, r.props.dateFormat, r.props.locale);
      return k.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: function(c) {
        return r.toggleDropdown(c);
      } }, k.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), k.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, l));
    }), j(z(r), "renderDropdown", function() {
      return k.createElement(mF, { key: "dropdown", date: r.props.date, dateFormat: r.props.dateFormat, onChange: r.onChange, onCancel: r.toggleDropdown, minDate: r.props.minDate, maxDate: r.props.maxDate, scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown, locale: r.props.locale });
    }), j(z(r), "renderScrollMode", function() {
      var s = r.state.dropdownVisible, l = [r.renderReadView(!s)];
      return s && l.unshift(r.renderDropdown()), l;
    }), j(z(r), "onChange", function(s) {
      r.toggleDropdown();
      var l = Zt(parseInt(s));
      Fo(r.props.date, l) && da(r.props.date, l) || r.props.onChange(l);
    }), j(z(r), "toggleDropdown", function() {
      return r.setState({ dropdownVisible: !r.state.dropdownVisible });
    }), r;
  }
  return Br(n, [{ key: "render", value: function() {
    var r;
    switch (this.props.dropdownMode) {
      case "scroll":
        r = this.renderScrollMode();
        break;
      case "select":
        r = this.renderSelectMode();
    }
    return k.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, r);
  } }]), n;
}(), gF = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n() {
    var r;
    jr(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return j(z(r = t.call.apply(t, [this].concat(o))), "dayEl", k.createRef()), j(z(r), "handleClick", function(s) {
      !r.isDisabled() && r.props.onClick && r.props.onClick(s);
    }), j(z(r), "handleMouseEnter", function(s) {
      !r.isDisabled() && r.props.onMouseEnter && r.props.onMouseEnter(s);
    }), j(z(r), "handleOnKeyDown", function(s) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), r.props.handleOnKeyDown(s);
    }), j(z(r), "isSameDay", function(s) {
      return Jt(r.props.day, s);
    }), j(z(r), "isKeyboardSelected", function() {
      return !r.props.disabledKeyboardNavigation && !(r.isSameDay(r.props.selected) || r.isSameWeek(r.props.selected)) && (r.isSameDay(r.props.preSelection) || r.isSameWeek(r.props.preSelection));
    }), j(z(r), "isDisabled", function() {
      return sh(r.props.day, r.props);
    }), j(z(r), "isExcluded", function() {
      return kg(r.props.day, r.props);
    }), j(z(r), "isStartOfWeek", function() {
      return Jt(r.props.day, Wa(r.props.day, r.props.locale, r.props.calendarStartDay));
    }), j(z(r), "isSameWeek", function(s) {
      return r.props.showWeekPicker && Jt(s, Wa(r.props.day, r.props.locale, r.props.calendarStartDay));
    }), j(z(r), "getHighLightedClass", function() {
      var s = r.props, l = s.day, c = s.highlightDates;
      if (!c)
        return !1;
      var u = ir(l, "MM.dd.yyyy");
      return c.get(u);
    }), j(z(r), "getHolidaysClass", function() {
      var s = r.props, l = s.day, c = s.holidays;
      if (!c)
        return !1;
      var u = ir(l, "MM.dd.yyyy");
      return c.has(u) ? [c.get(u).className] : void 0;
    }), j(z(r), "isInRange", function() {
      var s = r.props, l = s.day, c = s.startDate, u = s.endDate;
      return !(!c || !u) && ud(l, c, u);
    }), j(z(r), "isInSelectingRange", function() {
      var s, l = r.props, c = l.day, u = l.selectsStart, d = l.selectsEnd, p = l.selectsRange, h = l.selectsDisabledDaysInRange, m = l.startDate, f = l.endDate, g = (s = r.props.selectingDate) !== null && s !== void 0 ? s : r.props.preSelection;
      return !(!(u || d || p) || !g || !h && r.isDisabled()) && (u && f && (Bo(g, f) || Oi(g, f)) ? ud(c, g, f) : (d && m && (Yo(g, m) || Oi(g, m)) || !(!p || !m || f || !Yo(g, m) && !Oi(g, m))) && ud(c, m, g));
    }), j(z(r), "isSelectingRangeStart", function() {
      var s;
      if (!r.isInSelectingRange())
        return !1;
      var l = r.props, c = l.day, u = l.startDate, d = l.selectsStart, p = (s = r.props.selectingDate) !== null && s !== void 0 ? s : r.props.preSelection;
      return Jt(c, d ? p : u);
    }), j(z(r), "isSelectingRangeEnd", function() {
      var s;
      if (!r.isInSelectingRange())
        return !1;
      var l = r.props, c = l.day, u = l.endDate, d = l.selectsEnd, p = l.selectsRange, h = (s = r.props.selectingDate) !== null && s !== void 0 ? s : r.props.preSelection;
      return Jt(c, d || p ? h : u);
    }), j(z(r), "isRangeStart", function() {
      var s = r.props, l = s.day, c = s.startDate, u = s.endDate;
      return !(!c || !u) && Jt(c, l);
    }), j(z(r), "isRangeEnd", function() {
      var s = r.props, l = s.day, c = s.startDate, u = s.endDate;
      return !(!c || !u) && Jt(u, l);
    }), j(z(r), "isWeekend", function() {
      var s = ZD(r.props.day);
      return s === 0 || s === 6;
    }), j(z(r), "isAfterMonth", function() {
      return r.props.month !== void 0 && (r.props.month + 1) % 12 === Yr(r.props.day);
    }), j(z(r), "isBeforeMonth", function() {
      return r.props.month !== void 0 && (Yr(r.props.day) + 1) % 12 === r.props.month;
    }), j(z(r), "isCurrentDay", function() {
      return r.isSameDay(Zt());
    }), j(z(r), "isSelected", function() {
      return r.isSameDay(r.props.selected) || r.isSameWeek(r.props.selected);
    }), j(z(r), "getClassNames", function(s) {
      var l, c = r.props.dayClassName ? r.props.dayClassName(s) : void 0;
      return Ur("react-datepicker__day", c, "react-datepicker__day--" + ir(r.props.day, "ddd", l), { "react-datepicker__day--disabled": r.isDisabled(), "react-datepicker__day--excluded": r.isExcluded(), "react-datepicker__day--selected": r.isSelected(), "react-datepicker__day--keyboard-selected": r.isKeyboardSelected(), "react-datepicker__day--range-start": r.isRangeStart(), "react-datepicker__day--range-end": r.isRangeEnd(), "react-datepicker__day--in-range": r.isInRange(), "react-datepicker__day--in-selecting-range": r.isInSelectingRange(), "react-datepicker__day--selecting-range-start": r.isSelectingRangeStart(), "react-datepicker__day--selecting-range-end": r.isSelectingRangeEnd(), "react-datepicker__day--today": r.isCurrentDay(), "react-datepicker__day--weekend": r.isWeekend(), "react-datepicker__day--outside-month": r.isAfterMonth() || r.isBeforeMonth() }, r.getHighLightedClass("react-datepicker__day--highlighted"), r.getHolidaysClass());
    }), j(z(r), "getAriaLabel", function() {
      var s = r.props, l = s.day, c = s.ariaLabelPrefixWhenEnabled, u = c === void 0 ? "Choose" : c, d = s.ariaLabelPrefixWhenDisabled, p = d === void 0 ? "Not available" : d, h = r.isDisabled() || r.isExcluded() ? p : u;
      return "".concat(h, " ").concat(ir(l, "PPPP", r.props.locale));
    }), j(z(r), "getTitle", function() {
      var s = r.props, l = s.day, c = s.holidays, u = c === void 0 ? /* @__PURE__ */ new Map() : c, d = ir(l, "MM.dd.yyyy");
      return u.has(d) && u.get(d).holidayNames.length > 0 ? u.get(d).holidayNames.join(", ") : "";
    }), j(z(r), "getTabIndex", function(s, l) {
      var c = s || r.props.selected, u = l || r.props.preSelection;
      return (!r.props.showWeekPicker || !r.props.showWeekNumber && r.isStartOfWeek()) && (r.isKeyboardSelected() || r.isSameDay(c) && Jt(u, c)) ? 0 : -1;
    }), j(z(r), "handleFocusDay", function() {
      var s, l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = !1;
      r.getTabIndex() === 0 && !l.isInputFocused && r.isSameDay(r.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (c = !0), r.props.inline && !r.props.shouldFocusDayInline && (c = !1), r.props.containerRef && r.props.containerRef.current && r.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (c = !0), r.props.monthShowsDuplicateDaysEnd && r.isAfterMonth() && (c = !1), r.props.monthShowsDuplicateDaysStart && r.isBeforeMonth() && (c = !1)), c && ((s = r.dayEl.current) === null || s === void 0 || s.focus({ preventScroll: !0 }));
    }), j(z(r), "renderDayContents", function() {
      return r.props.monthShowsDuplicateDaysEnd && r.isAfterMonth() || r.props.monthShowsDuplicateDaysStart && r.isBeforeMonth() ? null : r.props.renderDayContents ? r.props.renderDayContents(D2(r.props.day), r.props.day) : D2(r.props.day);
    }), j(z(r), "render", function() {
      return k.createElement("div", { ref: r.dayEl, className: r.getClassNames(r.props.day), onKeyDown: r.handleOnKeyDown, onClick: r.handleClick, onMouseEnter: r.handleMouseEnter, tabIndex: r.getTabIndex(), "aria-label": r.getAriaLabel(), role: "option", title: r.getTitle(), "aria-disabled": r.isDisabled(), "aria-current": r.isCurrentDay() ? "date" : void 0, "aria-selected": r.isSelected() || r.isInRange() }, r.renderDayContents(), r.getTitle() !== "" && k.createElement("span", { className: "holiday-overlay" }, r.getTitle()));
    }), r;
  }
  return Br(n, [{ key: "componentDidMount", value: function() {
    this.handleFocusDay();
  } }, { key: "componentDidUpdate", value: function(r) {
    this.handleFocusDay(r);
  } }]), n;
}(), yF = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n() {
    var r;
    jr(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return j(z(r = t.call.apply(t, [this].concat(o))), "weekNumberEl", k.createRef()), j(z(r), "handleClick", function(s) {
      r.props.onClick && r.props.onClick(s);
    }), j(z(r), "handleOnKeyDown", function(s) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), r.props.handleOnKeyDown(s);
    }), j(z(r), "isKeyboardSelected", function() {
      return !r.props.disabledKeyboardNavigation && !Jt(r.props.date, r.props.selected) && Jt(r.props.date, r.props.preSelection);
    }), j(z(r), "getTabIndex", function() {
      return r.props.showWeekPicker && r.props.showWeekNumber && (r.isKeyboardSelected() || Jt(r.props.date, r.props.selected) && Jt(r.props.preSelection, r.props.selected)) ? 0 : -1;
    }), j(z(r), "handleFocusWeekNumber", function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = !1;
      r.getTabIndex() === 0 && !s.isInputFocused && Jt(r.props.date, r.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (l = !0), r.props.inline && !r.props.shouldFocusDayInline && (l = !1), r.props.containerRef && r.props.containerRef.current && r.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (l = !0)), l && r.weekNumberEl.current && r.weekNumberEl.current.focus({ preventScroll: !0 });
    }), r;
  }
  return Br(n, [{ key: "componentDidMount", value: function() {
    this.handleFocusWeekNumber();
  } }, { key: "componentDidUpdate", value: function(r) {
    this.handleFocusWeekNumber(r);
  } }, { key: "render", value: function() {
    var r = this.props, a = r.weekNumber, o = r.ariaLabelPrefix, i = o === void 0 ? "week " : o, s = { "react-datepicker__week-number": !0, "react-datepicker__week-number--clickable": !!r.onClick, "react-datepicker__week-number--selected": Jt(this.props.date, this.props.selected), "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected() };
    return k.createElement("div", { ref: this.weekNumberEl, className: Ur(s), "aria-label": "".concat(i, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, a);
  } }], [{ key: "defaultProps", get: function() {
    return { ariaLabelPrefix: "week " };
  } }]), n;
}(), vF = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n() {
    var r;
    jr(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return j(z(r = t.call.apply(t, [this].concat(o))), "handleDayClick", function(s, l) {
      r.props.onDayClick && r.props.onDayClick(s, l);
    }), j(z(r), "handleDayMouseEnter", function(s) {
      r.props.onDayMouseEnter && r.props.onDayMouseEnter(s);
    }), j(z(r), "handleWeekClick", function(s, l, c) {
      if (typeof r.props.onWeekSelect == "function" && r.props.onWeekSelect(s, l, c), r.props.showWeekPicker) {
        var u = Wa(s, r.props.locale, r.props.calendarStartDay);
        r.handleDayClick(u, c);
      }
      r.props.shouldCloseOnSelect && r.props.setOpen(!1);
    }), j(z(r), "formatWeekNumber", function(s) {
      return r.props.formatWeekNumber ? r.props.formatWeekNumber(s) : function(l, c) {
        var u = ji() && Bi(ji());
        return QD(l, u ? { locale: u } : null);
      }(s);
    }), j(z(r), "renderDays", function() {
      var s = Wa(r.props.day, r.props.locale, r.props.calendarStartDay), l = [], c = r.formatWeekNumber(s);
      if (r.props.showWeekNumber) {
        var u = r.props.onWeekSelect || r.props.showWeekPicker ? r.handleWeekClick.bind(z(r), s, c) : void 0;
        l.push(k.createElement(yF, { key: "W", weekNumber: c, date: s, onClick: u, selected: r.props.selected, preSelection: r.props.preSelection, ariaLabelPrefix: r.props.ariaLabelPrefix, showWeekPicker: r.props.showWeekPicker, showWeekNumber: r.props.showWeekNumber, disabledKeyboardNavigation: r.props.disabledKeyboardNavigation, handleOnKeyDown: r.props.handleOnKeyDown, isInputFocused: r.props.isInputFocused, containerRef: r.props.containerRef }));
      }
      return l.concat([0, 1, 2, 3, 4, 5, 6].map(function(d) {
        var p = ll(s, d);
        return k.createElement(gF, { ariaLabelPrefixWhenEnabled: r.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: r.props.disabledDayAriaLabelPrefix, key: p.valueOf(), day: p, month: r.props.month, onClick: r.handleDayClick.bind(z(r), p), onMouseEnter: r.handleDayMouseEnter.bind(z(r), p), minDate: r.props.minDate, maxDate: r.props.maxDate, excludeDates: r.props.excludeDates, excludeDateIntervals: r.props.excludeDateIntervals, includeDates: r.props.includeDates, includeDateIntervals: r.props.includeDateIntervals, highlightDates: r.props.highlightDates, holidays: r.props.holidays, selectingDate: r.props.selectingDate, filterDate: r.props.filterDate, preSelection: r.props.preSelection, selected: r.props.selected, selectsStart: r.props.selectsStart, selectsEnd: r.props.selectsEnd, selectsRange: r.props.selectsRange, showWeekPicker: r.props.showWeekPicker, showWeekNumber: r.props.showWeekNumber, selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange, startDate: r.props.startDate, endDate: r.props.endDate, dayClassName: r.props.dayClassName, renderDayContents: r.props.renderDayContents, disabledKeyboardNavigation: r.props.disabledKeyboardNavigation, handleOnKeyDown: r.props.handleOnKeyDown, isInputFocused: r.props.isInputFocused, containerRef: r.props.containerRef, inline: r.props.inline, shouldFocusDayInline: r.props.shouldFocusDayInline, monthShowsDuplicateDaysEnd: r.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: r.props.monthShowsDuplicateDaysStart, locale: r.props.locale });
      }));
    }), j(z(r), "startOfWeek", function() {
      return Wa(r.props.day, r.props.locale, r.props.calendarStartDay);
    }), j(z(r), "isKeyboardSelected", function() {
      return !r.props.disabledKeyboardNavigation && !Jt(r.startOfWeek(), r.props.selected) && Jt(r.startOfWeek(), r.props.preSelection);
    }), r;
  }
  return Br(n, [{ key: "render", value: function() {
    var r = { "react-datepicker__week": !0, "react-datepicker__week--selected": Jt(this.startOfWeek(), this.props.selected), "react-datepicker__week--keyboard-selected": this.isKeyboardSelected() };
    return k.createElement("div", { className: Ur(r) }, this.renderDays());
  } }], [{ key: "defaultProps", get: function() {
    return { shouldCloseOnSelect: !0 };
  } }]), n;
}(), M8 = "two_columns", O8 = "three_columns", A8 = "four_columns", hm = j(j(j({}, M8, { grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]], verticalNavigationOffset: 2 }), O8, { grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]], verticalNavigationOffset: 3 }), A8, { grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]], verticalNavigationOffset: 4 });
function fv(e, t) {
  return e ? A8 : t ? M8 : O8;
}
var bF = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n() {
    var r;
    jr(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return j(z(r = t.call.apply(t, [this].concat(o))), "MONTH_REFS", Ic(Array(12)).map(function() {
      return k.createRef();
    })), j(z(r), "QUARTER_REFS", Ic(Array(4)).map(function() {
      return k.createRef();
    })), j(z(r), "isDisabled", function(s) {
      return sh(s, r.props);
    }), j(z(r), "isExcluded", function(s) {
      return kg(s, r.props);
    }), j(z(r), "handleDayClick", function(s, l) {
      r.props.onDayClick && r.props.onDayClick(s, l, r.props.orderInDisplay);
    }), j(z(r), "handleDayMouseEnter", function(s) {
      r.props.onDayMouseEnter && r.props.onDayMouseEnter(s);
    }), j(z(r), "handleMouseLeave", function() {
      r.props.onMouseLeave && r.props.onMouseLeave();
    }), j(z(r), "isRangeStartMonth", function(s) {
      var l = r.props, c = l.day, u = l.startDate, d = l.endDate;
      return !(!u || !d) && da(on(c, s), u);
    }), j(z(r), "isRangeStartQuarter", function(s) {
      var l = r.props, c = l.day, u = l.startDate, d = l.endDate;
      return !(!u || !d) && Xd(us(c, s), u);
    }), j(z(r), "isRangeEndMonth", function(s) {
      var l = r.props, c = l.day, u = l.startDate, d = l.endDate;
      return !(!u || !d) && da(on(c, s), d);
    }), j(z(r), "isRangeEndQuarter", function(s) {
      var l = r.props, c = l.day, u = l.startDate, d = l.endDate;
      return !(!u || !d) && Xd(us(c, s), d);
    }), j(z(r), "isInSelectingRangeMonth", function(s) {
      var l, c = r.props, u = c.day, d = c.selectsStart, p = c.selectsEnd, h = c.selectsRange, m = c.startDate, f = c.endDate, g = (l = r.props.selectingDate) !== null && l !== void 0 ? l : r.props.preSelection;
      return !(!(d || p || h) || !g) && (d && f ? um(g, f, s, u) : (p && m || !(!h || !m || f)) && um(m, g, s, u));
    }), j(z(r), "isSelectingMonthRangeStart", function(s) {
      var l;
      if (!r.isInSelectingRangeMonth(s))
        return !1;
      var c = r.props, u = c.day, d = c.startDate, p = c.selectsStart, h = on(u, s), m = (l = r.props.selectingDate) !== null && l !== void 0 ? l : r.props.preSelection;
      return da(h, p ? m : d);
    }), j(z(r), "isSelectingMonthRangeEnd", function(s) {
      var l;
      if (!r.isInSelectingRangeMonth(s))
        return !1;
      var c = r.props, u = c.day, d = c.endDate, p = c.selectsEnd, h = c.selectsRange, m = on(u, s), f = (l = r.props.selectingDate) !== null && l !== void 0 ? l : r.props.preSelection;
      return da(m, p || h ? f : d);
    }), j(z(r), "isInSelectingRangeQuarter", function(s) {
      var l, c = r.props, u = c.day, d = c.selectsStart, p = c.selectsEnd, h = c.selectsRange, m = c.startDate, f = c.endDate, g = (l = r.props.selectingDate) !== null && l !== void 0 ? l : r.props.preSelection;
      return !(!(d || p || h) || !g) && (d && f ? pm(g, f, s, u) : (p && m || !(!h || !m || f)) && pm(m, g, s, u));
    }), j(z(r), "isWeekInMonth", function(s) {
      var l = r.props.day, c = ll(s, 6);
      return da(s, l) || da(c, l);
    }), j(z(r), "isCurrentMonth", function(s, l) {
      return pt(s) === pt(Zt()) && l === Yr(Zt());
    }), j(z(r), "isCurrentQuarter", function(s, l) {
      return pt(s) === pt(Zt()) && l === ws(Zt());
    }), j(z(r), "isSelectedMonth", function(s, l, c) {
      return Yr(c) === l && pt(s) === pt(c);
    }), j(z(r), "isSelectedQuarter", function(s, l, c) {
      return ws(s) === l && pt(s) === pt(c);
    }), j(z(r), "renderWeeks", function() {
      for (var s = [], l = r.props.fixedHeight, c = 0, u = !1, d = Wa($o(r.props.day), r.props.locale, r.props.calendarStartDay); s.push(k.createElement(vF, { ariaLabelPrefix: r.props.weekAriaLabelPrefix, chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix, key: c, day: d, month: Yr(r.props.day), onDayClick: r.handleDayClick, onDayMouseEnter: r.handleDayMouseEnter, onWeekSelect: r.props.onWeekSelect, formatWeekNumber: r.props.formatWeekNumber, locale: r.props.locale, minDate: r.props.minDate, maxDate: r.props.maxDate, excludeDates: r.props.excludeDates, excludeDateIntervals: r.props.excludeDateIntervals, includeDates: r.props.includeDates, includeDateIntervals: r.props.includeDateIntervals, inline: r.props.inline, shouldFocusDayInline: r.props.shouldFocusDayInline, highlightDates: r.props.highlightDates, holidays: r.props.holidays, selectingDate: r.props.selectingDate, filterDate: r.props.filterDate, preSelection: r.props.preSelection, selected: r.props.selected, selectsStart: r.props.selectsStart, selectsEnd: r.props.selectsEnd, selectsRange: r.props.selectsRange, selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange, showWeekNumber: r.props.showWeekNumbers, showWeekPicker: r.props.showWeekPicker, startDate: r.props.startDate, endDate: r.props.endDate, dayClassName: r.props.dayClassName, setOpen: r.props.setOpen, shouldCloseOnSelect: r.props.shouldCloseOnSelect, disabledKeyboardNavigation: r.props.disabledKeyboardNavigation, renderDayContents: r.props.renderDayContents, handleOnKeyDown: r.props.handleOnKeyDown, isInputFocused: r.props.isInputFocused, containerRef: r.props.containerRef, calendarStartDay: r.props.calendarStartDay, monthShowsDuplicateDaysEnd: r.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: r.props.monthShowsDuplicateDaysStart })), !u; ) {
        c++, d = Kd(d, 1);
        var p = l && c >= 6, h = !l && !r.isWeekInMonth(d);
        if (p || h) {
          if (!r.props.peekNextMonth)
            break;
          u = !0;
        }
      }
      return s;
    }), j(z(r), "onMonthClick", function(s, l) {
      r.handleDayClick($o(on(r.props.day, l)), s);
    }), j(z(r), "onMonthMouseEnter", function(s) {
      r.handleDayMouseEnter($o(on(r.props.day, s)));
    }), j(z(r), "handleMonthNavigation", function(s, l) {
      r.isDisabled(l) || r.isExcluded(l) || (r.props.setPreSelection(l), r.MONTH_REFS[s].current && r.MONTH_REFS[s].current.focus());
    }), j(z(r), "onMonthKeyDown", function(s, l) {
      var c = r.props, u = c.selected, d = c.preSelection, p = c.disabledKeyboardNavigation, h = c.showTwoColumnMonthYearPicker, m = c.showFourColumnMonthYearPicker, f = c.setPreSelection, g = s.key;
      if (g !== "Tab" && s.preventDefault(), !p) {
        var _ = fv(m, h), v = hm[_].verticalNavigationOffset, w = hm[_].grid;
        switch (g) {
          case "Enter":
            r.onMonthClick(s, l), f(u);
            break;
          case "ArrowRight":
            r.handleMonthNavigation(l === 11 ? 0 : l + 1, ba(d, 1));
            break;
          case "ArrowLeft":
            r.handleMonthNavigation(l === 0 ? 11 : l - 1, Gs(d, 1));
            break;
          case "ArrowUp":
            r.handleMonthNavigation(w[0].includes(l) ? l + 12 - v : l - v, Gs(d, v));
            break;
          case "ArrowDown":
            r.handleMonthNavigation(w[w.length - 1].includes(l) ? l - 12 + v : l + v, ba(d, v));
        }
      }
    }), j(z(r), "onQuarterClick", function(s, l) {
      r.handleDayClick(nv(us(r.props.day, l)), s);
    }), j(z(r), "onQuarterMouseEnter", function(s) {
      r.handleDayMouseEnter(nv(us(r.props.day, s)));
    }), j(z(r), "handleQuarterNavigation", function(s, l) {
      r.isDisabled(l) || r.isExcluded(l) || (r.props.setPreSelection(l), r.QUARTER_REFS[s - 1].current && r.QUARTER_REFS[s - 1].current.focus());
    }), j(z(r), "onQuarterKeyDown", function(s, l) {
      var c = s.key;
      if (!r.props.disabledKeyboardNavigation)
        switch (c) {
          case "Enter":
            r.onQuarterClick(s, l), r.props.setPreSelection(r.props.selected);
            break;
          case "ArrowRight":
            r.handleQuarterNavigation(l === 4 ? 1 : l + 1, X4(r.props.preSelection, 1));
            break;
          case "ArrowLeft":
            r.handleQuarterNavigation(l === 1 ? 4 : l - 1, YD(r.props.preSelection, 1));
        }
    }), j(z(r), "getMonthClassNames", function(s) {
      var l = r.props, c = l.day, u = l.startDate, d = l.endDate, p = l.selected, h = l.minDate, m = l.maxDate, f = l.preSelection, g = l.monthClassName, _ = l.excludeDates, v = l.includeDates, w = g ? g(on(c, s)) : void 0, x = on(c, s);
      return Ur("react-datepicker__month-text", "react-datepicker__month-".concat(s), w, { "react-datepicker__month-text--disabled": (h || m || _ || v) && k8(x, r.props), "react-datepicker__month-text--selected": r.isSelectedMonth(c, s, p), "react-datepicker__month-text--keyboard-selected": !r.props.disabledKeyboardNavigation && Yr(f) === s, "react-datepicker__month-text--in-selecting-range": r.isInSelectingRangeMonth(s), "react-datepicker__month-text--in-range": um(u, d, s, c), "react-datepicker__month-text--range-start": r.isRangeStartMonth(s), "react-datepicker__month-text--range-end": r.isRangeEndMonth(s), "react-datepicker__month-text--selecting-range-start": r.isSelectingMonthRangeStart(s), "react-datepicker__month-text--selecting-range-end": r.isSelectingMonthRangeEnd(s), "react-datepicker__month-text--today": r.isCurrentMonth(c, s) });
    }), j(z(r), "getTabIndex", function(s) {
      var l = Yr(r.props.preSelection);
      return r.props.disabledKeyboardNavigation || s !== l ? "-1" : "0";
    }), j(z(r), "getQuarterTabIndex", function(s) {
      var l = ws(r.props.preSelection);
      return r.props.disabledKeyboardNavigation || s !== l ? "-1" : "0";
    }), j(z(r), "getAriaLabel", function(s) {
      var l = r.props, c = l.chooseDayAriaLabelPrefix, u = c === void 0 ? "Choose" : c, d = l.disabledDayAriaLabelPrefix, p = d === void 0 ? "Not available" : d, h = l.day, m = on(h, s), f = r.isDisabled(m) || r.isExcluded(m) ? p : u;
      return "".concat(f, " ").concat(ir(m, "MMMM yyyy"));
    }), j(z(r), "getQuarterClassNames", function(s) {
      var l = r.props, c = l.day, u = l.startDate, d = l.endDate, p = l.selected, h = l.minDate, m = l.maxDate, f = l.preSelection, g = l.disabledKeyboardNavigation;
      return Ur("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(s), { "react-datepicker__quarter-text--disabled": (h || m) && oF(us(c, s), r.props), "react-datepicker__quarter-text--selected": r.isSelectedQuarter(c, s, p), "react-datepicker__quarter-text--keyboard-selected": !g && ws(f) === s, "react-datepicker__quarter-text--in-selecting-range": r.isInSelectingRangeQuarter(s), "react-datepicker__quarter-text--in-range": pm(u, d, s, c), "react-datepicker__quarter-text--range-start": r.isRangeStartQuarter(s), "react-datepicker__quarter-text--range-end": r.isRangeEndQuarter(s) });
    }), j(z(r), "getMonthContent", function(s) {
      var l = r.props, c = l.showFullMonthYearPicker, u = l.renderMonthContent, d = l.locale, p = l.day, h = x8(s, d), m = xg(s, d);
      return u ? u(s, h, m, p) : c ? m : h;
    }), j(z(r), "getQuarterContent", function(s) {
      var l = r.props, c = l.renderQuarterContent, u = function(d, p) {
        return ir(us(Zt(), d), "QQQ", p);
      }(s, l.locale);
      return c ? c(s, u) : u;
    }), j(z(r), "renderMonths", function() {
      var s = r.props, l = s.showTwoColumnMonthYearPicker, c = s.showFourColumnMonthYearPicker, u = s.day, d = s.selected;
      return hm[fv(c, l)].grid.map(function(p, h) {
        return k.createElement("div", { className: "react-datepicker__month-wrapper", key: h }, p.map(function(m, f) {
          return k.createElement("div", { ref: r.MONTH_REFS[m], key: f, onClick: function(g) {
            r.onMonthClick(g, m);
          }, onKeyDown: function(g) {
            r.onMonthKeyDown(g, m);
          }, onMouseEnter: function() {
            return r.onMonthMouseEnter(m);
          }, tabIndex: r.getTabIndex(m), className: r.getMonthClassNames(m), role: "option", "aria-label": r.getAriaLabel(m), "aria-current": r.isCurrentMonth(u, m) ? "date" : void 0, "aria-selected": r.isSelectedMonth(u, m, d) }, r.getMonthContent(m));
        }));
      });
    }), j(z(r), "renderQuarters", function() {
      var s = r.props, l = s.day, c = s.selected;
      return k.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [1, 2, 3, 4].map(function(u, d) {
        return k.createElement("div", { key: d, ref: r.QUARTER_REFS[d], role: "option", onClick: function(p) {
          r.onQuarterClick(p, u);
        }, onKeyDown: function(p) {
          r.onQuarterKeyDown(p, u);
        }, onMouseEnter: function() {
          return r.onQuarterMouseEnter(u);
        }, className: r.getQuarterClassNames(u), "aria-selected": r.isSelectedQuarter(l, u, c), tabIndex: r.getQuarterTabIndex(u), "aria-current": r.isCurrentQuarter(l, u) ? "date" : void 0 }, r.getQuarterContent(u));
      }));
    }), j(z(r), "getClassNames", function() {
      var s = r.props, l = s.selectingDate, c = s.selectsStart, u = s.selectsEnd, d = s.showMonthYearPicker, p = s.showQuarterYearPicker, h = s.showWeekPicker;
      return Ur("react-datepicker__month", { "react-datepicker__month--selecting-range": l && (c || u) }, { "react-datepicker__monthPicker": d }, { "react-datepicker__quarterPicker": p }, { "react-datepicker__weekPicker": h });
    }), r;
  }
  return Br(n, [{ key: "render", value: function() {
    var r = this.props, a = r.showMonthYearPicker, o = r.showQuarterYearPicker, i = r.day, s = r.ariaLabelPrefix, l = s === void 0 ? "month " : s;
    return k.createElement("div", { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, "aria-label": "".concat(l, " ").concat(ir(i, "yyyy-MM")), role: "listbox" }, a ? this.renderMonths() : o ? this.renderQuarters() : this.renderWeeks());
  } }]), n;
}(), N8 = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n() {
    var r;
    jr(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return j(z(r = t.call.apply(t, [this].concat(o))), "state", { height: null }), j(z(r), "scrollToTheSelectedTime", function() {
      requestAnimationFrame(function() {
        r.list && (r.list.scrollTop = r.centerLi && n.calcCenterPosition(r.props.monthRef ? r.props.monthRef.clientHeight - r.header.clientHeight : r.list.clientHeight, r.centerLi));
      });
    }), j(z(r), "handleClick", function(s) {
      (r.props.minTime || r.props.maxTime) && sv(s, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && iv(s, r.props) || r.props.onChange(s);
    }), j(z(r), "isSelectedTime", function(s) {
      return r.props.selected && (l = r.props.selected, c = s, mv(l).getTime() === mv(c).getTime());
      var l, c;
    }), j(z(r), "isDisabledTime", function(s) {
      return (r.props.minTime || r.props.maxTime) && sv(s, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && iv(s, r.props);
    }), j(z(r), "liClasses", function(s) {
      var l = ["react-datepicker__time-list-item", r.props.timeClassName ? r.props.timeClassName(s) : void 0];
      return r.isSelectedTime(s) && l.push("react-datepicker__time-list-item--selected"), r.isDisabledTime(s) && l.push("react-datepicker__time-list-item--disabled"), r.props.injectTimes && (60 * Ua(s) + Ka(s)) % r.props.intervals != 0 && l.push("react-datepicker__time-list-item--injected"), l.join(" ");
    }), j(z(r), "handleOnKeyDown", function(s, l) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), s.key !== "ArrowUp" && s.key !== "ArrowLeft" || !s.target.previousSibling || (s.preventDefault(), s.target.previousSibling.focus()), s.key !== "ArrowDown" && s.key !== "ArrowRight" || !s.target.nextSibling || (s.preventDefault(), s.target.nextSibling.focus()), s.key === "Enter" && r.handleClick(l), r.props.handleOnKeyDown(s);
    }), j(z(r), "renderTimes", function() {
      for (var s = [], l = r.props.format ? r.props.format : "p", c = r.props.intervals, u = r.props.selected || r.props.openToDate || Zt(), d = $a(u), p = r.props.injectTimes && r.props.injectTimes.sort(function(w, x) {
        return w - x;
      }), h = 60 * function(w) {
        var x = new Date(w.getFullYear(), w.getMonth(), w.getDate()), b = new Date(w.getFullYear(), w.getMonth(), w.getDate(), 24);
        return Math.round((+b - +x) / 36e5);
      }(u), m = h / c, f = 0; f < m; f++) {
        var g = j1(d, f * c);
        if (s.push(g), p) {
          var _ = sF(d, g, f, c, p);
          s = s.concat(_);
        }
      }
      var v = s.reduce(function(w, x) {
        return x.getTime() <= u.getTime() ? x : w;
      }, s[0]);
      return s.map(function(w, x) {
        return k.createElement("li", { key: x, onClick: r.handleClick.bind(z(r), w), className: r.liClasses(w), ref: function(b) {
          w === v && (r.centerLi = b);
        }, onKeyDown: function(b) {
          r.handleOnKeyDown(b, w);
        }, tabIndex: w === v ? 0 : -1, role: "option", "aria-selected": r.isSelectedTime(w) ? "true" : void 0, "aria-disabled": r.isDisabledTime(w) ? "true" : void 0 }, ir(w, l, r.props.locale));
      });
    }), r;
  }
  return Br(n, [{ key: "componentDidMount", value: function() {
    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
  } }, { key: "render", value: function() {
    var r = this, a = this.state.height;
    return k.createElement("div", { className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "") }, k.createElement("div", { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(o) {
      r.header = o;
    } }, k.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)), k.createElement("div", { className: "react-datepicker__time" }, k.createElement("div", { className: "react-datepicker__time-box" }, k.createElement("ul", { className: "react-datepicker__time-list", ref: function(o) {
      r.list = o;
    }, style: a ? { height: a } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes()))));
  } }], [{ key: "defaultProps", get: function() {
    return { intervals: 30, onTimeChange: function() {
    }, todayButton: null, timeCaption: "Time" };
  } }]), n;
}();
j(N8, "calcCenterPosition", function(e, t) {
  return t.offsetTop - (e / 2 - t.clientHeight / 2);
});
var _F = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n(r) {
    var a;
    return jr(this, n), j(z(a = t.call(this, r)), "YEAR_REFS", Ic(Array(a.props.yearItemNumber)).map(function() {
      return k.createRef();
    })), j(z(a), "isDisabled", function(o) {
      return sh(o, a.props);
    }), j(z(a), "isExcluded", function(o) {
      return kg(o, a.props);
    }), j(z(a), "selectingDate", function() {
      var o;
      return (o = a.props.selectingDate) !== null && o !== void 0 ? o : a.props.preSelection;
    }), j(z(a), "updateFocusOnPaginate", function(o) {
      var i = (function() {
        this.YEAR_REFS[o].current.focus();
      }).bind(z(a));
      window.requestAnimationFrame(i);
    }), j(z(a), "handleYearClick", function(o, i) {
      a.props.onDayClick && a.props.onDayClick(o, i);
    }), j(z(a), "handleYearNavigation", function(o, i) {
      var s = a.props, l = s.date, c = s.yearItemNumber, u = Ss(l, c).startPeriod;
      a.isDisabled(i) || a.isExcluded(i) || (a.props.setPreSelection(i), o - u == -1 ? a.updateFocusOnPaginate(c - 1) : o - u === c ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[o - u].current.focus());
    }), j(z(a), "isSameDay", function(o, i) {
      return Jt(o, i);
    }), j(z(a), "isCurrentYear", function(o) {
      return o === pt(Zt());
    }), j(z(a), "isRangeStart", function(o) {
      return a.props.startDate && a.props.endDate && Fo(uo(Zt(), o), a.props.startDate);
    }), j(z(a), "isRangeEnd", function(o) {
      return a.props.startDate && a.props.endDate && Fo(uo(Zt(), o), a.props.endDate);
    }), j(z(a), "isInRange", function(o) {
      return dm(o, a.props.startDate, a.props.endDate);
    }), j(z(a), "isInSelectingRange", function(o) {
      var i = a.props, s = i.selectsStart, l = i.selectsEnd, c = i.selectsRange, u = i.startDate, d = i.endDate;
      return !(!(s || l || c) || !a.selectingDate()) && (s && d ? dm(o, a.selectingDate(), d) : (l && u || !(!c || !u || d)) && dm(o, u, a.selectingDate()));
    }), j(z(a), "isSelectingRangeStart", function(o) {
      if (!a.isInSelectingRange(o))
        return !1;
      var i = a.props, s = i.startDate, l = i.selectsStart, c = uo(Zt(), o);
      return Fo(c, l ? a.selectingDate() : s);
    }), j(z(a), "isSelectingRangeEnd", function(o) {
      if (!a.isInSelectingRange(o))
        return !1;
      var i = a.props, s = i.endDate, l = i.selectsEnd, c = i.selectsRange, u = uo(Zt(), o);
      return Fo(u, l || c ? a.selectingDate() : s);
    }), j(z(a), "isKeyboardSelected", function(o) {
      var i = cc(uo(a.props.date, o));
      return !a.props.disabledKeyboardNavigation && !a.props.inline && !Jt(i, cc(a.props.selected)) && Jt(i, cc(a.props.preSelection));
    }), j(z(a), "onYearClick", function(o, i) {
      var s = a.props.date;
      a.handleYearClick(cc(uo(s, i)), o);
    }), j(z(a), "onYearKeyDown", function(o, i) {
      var s = o.key;
      if (!a.props.disabledKeyboardNavigation)
        switch (s) {
          case "Enter":
            a.onYearClick(o, i), a.props.setPreSelection(a.props.selected);
            break;
          case "ArrowRight":
            a.handleYearNavigation(i + 1, zs(a.props.preSelection, 1));
            break;
          case "ArrowLeft":
            a.handleYearNavigation(i - 1, Nc(a.props.preSelection, 1));
        }
    }), j(z(a), "getYearClassNames", function(o) {
      var i = a.props, s = i.minDate, l = i.maxDate, c = i.selected, u = i.excludeDates, d = i.includeDates, p = i.filterDate;
      return Ur("react-datepicker__year-text", { "react-datepicker__year-text--selected": o === pt(c), "react-datepicker__year-text--disabled": (s || l || u || d || p) && E8(o, a.props), "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(o), "react-datepicker__year-text--range-start": a.isRangeStart(o), "react-datepicker__year-text--range-end": a.isRangeEnd(o), "react-datepicker__year-text--in-range": a.isInRange(o), "react-datepicker__year-text--in-selecting-range": a.isInSelectingRange(o), "react-datepicker__year-text--selecting-range-start": a.isSelectingRangeStart(o), "react-datepicker__year-text--selecting-range-end": a.isSelectingRangeEnd(o), "react-datepicker__year-text--today": a.isCurrentYear(o) });
    }), j(z(a), "getYearTabIndex", function(o) {
      return a.props.disabledKeyboardNavigation ? "-1" : o === pt(a.props.preSelection) ? "0" : "-1";
    }), j(z(a), "getYearContainerClassNames", function() {
      var o = a.props, i = o.selectingDate, s = o.selectsStart, l = o.selectsEnd, c = o.selectsRange;
      return Ur("react-datepicker__year", { "react-datepicker__year--selecting-range": i && (s || l || c) });
    }), j(z(a), "getYearContent", function(o) {
      return a.props.renderYearContent ? a.props.renderYearContent(o) : o;
    }), a;
  }
  return Br(n, [{ key: "render", value: function() {
    for (var r = this, a = [], o = this.props, i = o.date, s = o.yearItemNumber, l = o.onYearMouseEnter, c = o.onYearMouseLeave, u = Ss(i, s), d = u.startPeriod, p = u.endPeriod, h = function(f) {
      a.push(k.createElement("div", { ref: r.YEAR_REFS[f - d], onClick: function(g) {
        r.onYearClick(g, f);
      }, onKeyDown: function(g) {
        r.onYearKeyDown(g, f);
      }, tabIndex: r.getYearTabIndex(f), className: r.getYearClassNames(f), onMouseEnter: function(g) {
        return l(g, f);
      }, onMouseLeave: function(g) {
        return c(g, f);
      }, key: f, "aria-current": r.isCurrentYear(f) ? "date" : void 0 }, r.getYearContent(f)));
    }, m = d; m <= p; m++)
      h(m);
    return k.createElement("div", { className: this.getYearContainerClassNames() }, k.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.clearSelectingDate }, a));
  } }]), n;
}(), wF = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n(r) {
    var a;
    return jr(this, n), j(z(a = t.call(this, r)), "onTimeChange", function(o) {
      a.setState({ time: o });
      var i = a.props.date, s = i instanceof Date && !isNaN(i) ? i : /* @__PURE__ */ new Date();
      s.setHours(o.split(":")[0]), s.setMinutes(o.split(":")[1]), a.props.onChange(s);
    }), j(z(a), "renderTimeInput", function() {
      var o = a.state.time, i = a.props, s = i.date, l = i.timeString, c = i.customTimeInput;
      return c ? k.cloneElement(c, { date: s, value: o, onChange: a.onTimeChange }) : k.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: !0, value: o, onChange: function(u) {
        a.onTimeChange(u.target.value || l);
      } });
    }), a.state = { time: a.props.timeString }, a;
  }
  return Br(n, [{ key: "render", value: function() {
    return k.createElement("div", { className: "react-datepicker__input-time-container" }, k.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), k.createElement("div", { className: "react-datepicker-time__input-container" }, k.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
  } }], [{ key: "getDerivedStateFromProps", value: function(r, a) {
    return r.timeString !== a.time ? { time: r.timeString } : null;
  } }]), n;
}();
function SF(e) {
  var t = e.className, n = e.children, r = e.showPopperArrow, a = e.arrowProps, o = a === void 0 ? {} : a;
  return k.createElement("div", { className: t }, r && k.createElement("div", Vs({ className: "react-datepicker__triangle" }, o)), n);
}
var CF = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], xF = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n(r) {
    var a;
    return jr(this, n), j(z(a = t.call(this, r)), "handleClickOutside", function(o) {
      a.props.onClickOutside(o);
    }), j(z(a), "setClickOutsideRef", function() {
      return a.containerRef.current;
    }), j(z(a), "handleDropdownFocus", function(o) {
      (function() {
        var i = ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).className || "").split(/\s+/);
        return CF.some(function(s) {
          return i.indexOf(s) >= 0;
        });
      })(o.target) && a.props.onDropdownFocus();
    }), j(z(a), "getDateInView", function() {
      var o = a.props, i = o.preSelection, s = o.selected, l = o.openToDate, c = P8(a.props), u = T8(a.props), d = Zt(), p = l || s || i;
      return p || (c && Bo(d, c) ? c : u && Yo(d, u) ? u : d);
    }), j(z(a), "increaseMonth", function() {
      a.setState(function(o) {
        var i = o.date;
        return { date: ba(i, 1) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), j(z(a), "decreaseMonth", function() {
      a.setState(function(o) {
        var i = o.date;
        return { date: Gs(i, 1) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), j(z(a), "handleDayClick", function(o, i, s) {
      a.props.onSelect(o, i, s), a.props.setPreSelection && a.props.setPreSelection(o);
    }), j(z(a), "handleDayMouseEnter", function(o) {
      a.setState({ selectingDate: o }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(o);
    }), j(z(a), "handleMonthMouseLeave", function() {
      a.setState({ selectingDate: null }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
    }), j(z(a), "handleYearMouseEnter", function(o, i) {
      a.setState({ selectingDate: uo(Zt(), i) }), a.props.onYearMouseEnter && a.props.onYearMouseEnter(o, i);
    }), j(z(a), "handleYearMouseLeave", function(o, i) {
      a.props.onYearMouseLeave && a.props.onYearMouseLeave(o, i);
    }), j(z(a), "handleYearChange", function(o) {
      a.props.onYearChange && (a.props.onYearChange(o), a.setState({ isRenderAriaLiveMessage: !0 })), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(o), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(o);
    }), j(z(a), "handleMonthChange", function(o) {
      a.handleCustomMonthChange(o), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(o), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(o);
    }), j(z(a), "handleCustomMonthChange", function(o) {
      a.props.onMonthChange && (a.props.onMonthChange(o), a.setState({ isRenderAriaLiveMessage: !0 }));
    }), j(z(a), "handleMonthYearChange", function(o) {
      a.handleYearChange(o), a.handleMonthChange(o);
    }), j(z(a), "changeYear", function(o) {
      a.setState(function(i) {
        var s = i.date;
        return { date: uo(s, o) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), j(z(a), "changeMonth", function(o) {
      a.setState(function(i) {
        var s = i.date;
        return { date: on(s, o) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), j(z(a), "changeMonthYear", function(o) {
      a.setState(function(i) {
        var s = i.date;
        return { date: uo(on(s, Yr(o)), pt(o)) };
      }, function() {
        return a.handleMonthYearChange(a.state.date);
      });
    }), j(z(a), "header", function() {
      var o = Wa(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a.state.date, a.props.locale, a.props.calendarStartDay), i = [];
      return a.props.showWeekNumbers && i.push(k.createElement("div", { key: "W", className: "react-datepicker__day-name" }, a.props.weekLabel || "#")), i.concat([0, 1, 2, 3, 4, 5, 6].map(function(s) {
        var l = ll(o, s), c = a.formatWeekday(l, a.props.locale), u = a.props.weekDayClassName ? a.props.weekDayClassName(l) : void 0;
        return k.createElement("div", { key: s, className: Ur("react-datepicker__day-name", u) }, c);
      }));
    }), j(z(a), "formatWeekday", function(o, i) {
      return a.props.formatWeekDay ? function(s, l, c) {
        return l(ir(s, "EEEE", c));
      }(o, a.props.formatWeekDay, i) : a.props.useWeekdaysShort ? function(s, l) {
        return ir(s, "EEE", l);
      }(o, i) : function(s, l) {
        return ir(s, "EEEEEE", l);
      }(o, i);
    }), j(z(a), "decreaseYear", function() {
      a.setState(function(o) {
        var i = o.date;
        return { date: Nc(i, a.props.showYearPicker ? a.props.yearItemNumber : 1) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), j(z(a), "clearSelectingDate", function() {
      a.setState({ selectingDate: null });
    }), j(z(a), "renderPreviousButton", function() {
      if (!a.props.renderCustomHeader) {
        var o;
        switch (!0) {
          case a.props.showMonthYearPicker:
            o = uv(a.state.date, a.props);
            break;
          case a.props.showYearPicker:
            o = function(_) {
              var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = v.minDate, x = v.yearItemNumber, b = x === void 0 ? vc : x, C = Ss(cc(Nc(_, b)), b).endPeriod, E = w && pt(w);
              return E && E > C || !1;
            }(a.state.date, a.props);
            break;
          default:
            o = lv(a.state.date, a.props);
        }
        if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !o) && !a.props.showTimeSelectOnly) {
          var i = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], s = a.decreaseMonth;
          (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (s = a.decreaseYear), o && a.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--previous--disabled"), s = null);
          var l = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, c = a.props, u = c.previousMonthButtonLabel, d = c.previousYearButtonLabel, p = a.props, h = p.previousMonthAriaLabel, m = h === void 0 ? typeof u == "string" ? u : "Previous Month" : h, f = p.previousYearAriaLabel, g = f === void 0 ? typeof d == "string" ? d : "Previous Year" : f;
          return k.createElement("button", { type: "button", className: i.join(" "), onClick: s, onKeyDown: a.props.handleOnKeyDown, "aria-label": l ? g : m }, k.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ") }, l ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
        }
      }
    }), j(z(a), "increaseYear", function() {
      a.setState(function(o) {
        var i = o.date;
        return { date: zs(i, a.props.showYearPicker ? a.props.yearItemNumber : 1) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), j(z(a), "renderNextButton", function() {
      if (!a.props.renderCustomHeader) {
        var o;
        switch (!0) {
          case a.props.showMonthYearPicker:
            o = dv(a.state.date, a.props);
            break;
          case a.props.showYearPicker:
            o = function(_) {
              var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = v.maxDate, x = v.yearItemNumber, b = x === void 0 ? vc : x, C = Ss(zs(_, b), b).startPeriod, E = w && pt(w);
              return E && E < C || !1;
            }(a.state.date, a.props);
            break;
          default:
            o = cv(a.state.date, a.props);
        }
        if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !o) && !a.props.showTimeSelectOnly) {
          var i = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          a.props.showTimeSelect && i.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && i.push("react-datepicker__navigation--next--with-today-button");
          var s = a.increaseMonth;
          (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (s = a.increaseYear), o && a.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--next--disabled"), s = null);
          var l = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, c = a.props, u = c.nextMonthButtonLabel, d = c.nextYearButtonLabel, p = a.props, h = p.nextMonthAriaLabel, m = h === void 0 ? typeof u == "string" ? u : "Next Month" : h, f = p.nextYearAriaLabel, g = f === void 0 ? typeof d == "string" ? d : "Next Year" : f;
          return k.createElement("button", { type: "button", className: i.join(" "), onClick: s, onKeyDown: a.props.handleOnKeyDown, "aria-label": l ? g : m }, k.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ") }, l ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
        }
      }
    }), j(z(a), "renderCurrentMonth", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a.state.date, i = ["react-datepicker__current-month"];
      return a.props.showYearDropdown && i.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && i.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && i.push("react-datepicker__current-month--hasMonthYearDropdown"), k.createElement("div", { className: i.join(" ") }, ir(o, a.props.dateFormat, a.props.locale));
    }), j(z(a), "renderYearDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showYearDropdown && !o)
        return k.createElement(uF, { adjustDateOnChange: a.props.adjustDateOnChange, date: a.state.date, onSelect: a.props.onSelect, setOpen: a.props.setOpen, dropdownMode: a.props.dropdownMode, onChange: a.changeYear, minDate: a.props.minDate, maxDate: a.props.maxDate, year: pt(a.state.date), scrollableYearDropdown: a.props.scrollableYearDropdown, yearDropdownItemNumber: a.props.yearDropdownItemNumber });
    }), j(z(a), "renderMonthDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showMonthDropdown && !o)
        return k.createElement(pF, { dropdownMode: a.props.dropdownMode, locale: a.props.locale, onChange: a.changeMonth, month: Yr(a.state.date), useShortMonthInDropdown: a.props.useShortMonthInDropdown });
    }), j(z(a), "renderMonthYearDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showMonthYearDropdown && !o)
        return k.createElement(fF, { dropdownMode: a.props.dropdownMode, locale: a.props.locale, dateFormat: a.props.dateFormat, onChange: a.changeMonthYear, minDate: a.props.minDate, maxDate: a.props.maxDate, date: a.state.date, scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown });
    }), j(z(a), "handleTodayButtonClick", function(o) {
      a.props.onSelect(av(), o), a.props.setPreSelection && a.props.setPreSelection(av());
    }), j(z(a), "renderTodayButton", function() {
      if (a.props.todayButton && !a.props.showTimeSelectOnly)
        return k.createElement("div", { className: "react-datepicker__today-button", onClick: function(o) {
          return a.handleTodayButtonClick(o);
        } }, a.props.todayButton);
    }), j(z(a), "renderDefaultHeader", function(o) {
      var i = o.monthDate, s = o.i;
      return k.createElement("div", { className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") }, a.renderCurrentMonth(i), k.createElement("div", { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode), onFocus: a.handleDropdownFocus }, a.renderMonthDropdown(s !== 0), a.renderMonthYearDropdown(s !== 0), a.renderYearDropdown(s !== 0)), k.createElement("div", { className: "react-datepicker__day-names" }, a.header(i)));
    }), j(z(a), "renderCustomHeader", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = o.monthDate, s = o.i;
      if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly)
        return null;
      var l = lv(a.state.date, a.props), c = cv(a.state.date, a.props), u = uv(a.state.date, a.props), d = dv(a.state.date, a.props), p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
      return k.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: a.props.onDropdownFocus }, a.props.renderCustomHeader(qd(qd({}, a.state), {}, { customHeaderCount: s, monthDate: i, changeMonth: a.changeMonth, changeYear: a.changeYear, decreaseMonth: a.decreaseMonth, increaseMonth: a.increaseMonth, decreaseYear: a.decreaseYear, increaseYear: a.increaseYear, prevMonthButtonDisabled: l, nextMonthButtonDisabled: c, prevYearButtonDisabled: u, nextYearButtonDisabled: d })), p && k.createElement("div", { className: "react-datepicker__day-names" }, a.header(i)));
    }), j(z(a), "renderYearHeader", function() {
      var o = a.state.date, i = a.props, s = i.showYearPicker, l = Ss(o, i.yearItemNumber), c = l.startPeriod, u = l.endPeriod;
      return k.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(c, " - ").concat(u) : pt(o));
    }), j(z(a), "renderHeader", function(o) {
      switch (!0) {
        case a.props.renderCustomHeader !== void 0:
          return a.renderCustomHeader(o);
        case (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker):
          return a.renderYearHeader(o);
        default:
          return a.renderDefaultHeader(o);
      }
    }), j(z(a), "renderMonths", function() {
      var o;
      if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
        for (var i = [], s = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, l = Gs(a.state.date, s), c = (o = a.props.monthSelectedIn) !== null && o !== void 0 ? o : s, u = 0; u < a.props.monthsShown; ++u) {
          var d = ba(l, u - c + s), p = "month-".concat(u), h = u < a.props.monthsShown - 1, m = u > 0;
          i.push(k.createElement("div", { key: p, ref: function(f) {
            a.monthContainer = f;
          }, className: "react-datepicker__month-container" }, a.renderHeader({ monthDate: d, i: u }), k.createElement(bF, { chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: a.props.weekAriaLabelPrefix, ariaLabelPrefix: a.props.monthAriaLabelPrefix, onChange: a.changeMonthYear, day: d, dayClassName: a.props.dayClassName, calendarStartDay: a.props.calendarStartDay, monthClassName: a.props.monthClassName, onDayClick: a.handleDayClick, handleOnKeyDown: a.props.handleOnDayKeyDown, onDayMouseEnter: a.handleDayMouseEnter, onMouseLeave: a.handleMonthMouseLeave, onWeekSelect: a.props.onWeekSelect, orderInDisplay: u, formatWeekNumber: a.props.formatWeekNumber, locale: a.props.locale, minDate: a.props.minDate, maxDate: a.props.maxDate, excludeDates: a.props.excludeDates, excludeDateIntervals: a.props.excludeDateIntervals, highlightDates: a.props.highlightDates, holidays: a.props.holidays, selectingDate: a.state.selectingDate, includeDates: a.props.includeDates, includeDateIntervals: a.props.includeDateIntervals, inline: a.props.inline, shouldFocusDayInline: a.props.shouldFocusDayInline, fixedHeight: a.props.fixedHeight, filterDate: a.props.filterDate, preSelection: a.props.preSelection, setPreSelection: a.props.setPreSelection, selected: a.props.selected, selectsStart: a.props.selectsStart, selectsEnd: a.props.selectsEnd, selectsRange: a.props.selectsRange, selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange, showWeekNumbers: a.props.showWeekNumbers, startDate: a.props.startDate, endDate: a.props.endDate, peekNextMonth: a.props.peekNextMonth, setOpen: a.props.setOpen, shouldCloseOnSelect: a.props.shouldCloseOnSelect, renderDayContents: a.props.renderDayContents, renderMonthContent: a.props.renderMonthContent, renderQuarterContent: a.props.renderQuarterContent, renderYearContent: a.props.renderYearContent, disabledKeyboardNavigation: a.props.disabledKeyboardNavigation, showMonthYearPicker: a.props.showMonthYearPicker, showFullMonthYearPicker: a.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker, showYearPicker: a.props.showYearPicker, showQuarterYearPicker: a.props.showQuarterYearPicker, showWeekPicker: a.props.showWeekPicker, isInputFocused: a.props.isInputFocused, containerRef: a.containerRef, monthShowsDuplicateDaysEnd: h, monthShowsDuplicateDaysStart: m })));
        }
        return i;
      }
    }), j(z(a), "renderYears", function() {
      if (!a.props.showTimeSelectOnly)
        return a.props.showYearPicker ? k.createElement("div", { className: "react-datepicker__year--container" }, a.renderHeader(), k.createElement(_F, Vs({ onDayClick: a.handleDayClick, selectingDate: a.state.selectingDate, clearSelectingDate: a.clearSelectingDate, date: a.state.date }, a.props, { onYearMouseEnter: a.handleYearMouseEnter, onYearMouseLeave: a.handleYearMouseLeave }))) : void 0;
    }), j(z(a), "renderTimeSection", function() {
      if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly))
        return k.createElement(N8, { selected: a.props.selected, openToDate: a.props.openToDate, onChange: a.props.onTimeChange, timeClassName: a.props.timeClassName, format: a.props.timeFormat, includeTimes: a.props.includeTimes, intervals: a.props.timeIntervals, minTime: a.props.minTime, maxTime: a.props.maxTime, excludeTimes: a.props.excludeTimes, filterTime: a.props.filterTime, timeCaption: a.props.timeCaption, todayButton: a.props.todayButton, showMonthDropdown: a.props.showMonthDropdown, showMonthYearDropdown: a.props.showMonthYearDropdown, showYearDropdown: a.props.showYearDropdown, withPortal: a.props.withPortal, monthRef: a.state.monthContainer, injectTimes: a.props.injectTimes, locale: a.props.locale, handleOnKeyDown: a.props.handleOnKeyDown, showTimeSelectOnly: a.props.showTimeSelectOnly });
    }), j(z(a), "renderInputTimeSection", function() {
      var o = new Date(a.props.selected), i = Do(o) && a.props.selected ? "".concat(hv(o.getHours()), ":").concat(hv(o.getMinutes())) : "";
      if (a.props.showTimeInput)
        return k.createElement(wF, { date: o, timeString: i, timeInputLabel: a.props.timeInputLabel, onChange: a.props.onTimeChange, customTimeInput: a.props.customTimeInput });
    }), j(z(a), "renderAriaLiveRegion", function() {
      var o, i = Ss(a.state.date, a.props.yearItemNumber), s = i.startPeriod, l = i.endPeriod;
      return o = a.props.showYearPicker ? "".concat(s, " - ").concat(l) : a.props.showMonthYearPicker || a.props.showQuarterYearPicker ? pt(a.state.date) : "".concat(xg(Yr(a.state.date), a.props.locale), " ").concat(pt(a.state.date)), k.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, a.state.isRenderAriaLiveMessage && o);
    }), j(z(a), "renderChildren", function() {
      if (a.props.children)
        return k.createElement("div", { className: "react-datepicker__children-container" }, a.props.children);
    }), a.containerRef = k.createRef(), a.state = { date: a.getDateInView(), selectingDate: null, monthContainer: null, isRenderAriaLiveMessage: !1 }, a;
  }
  return Br(n, [{ key: "componentDidMount", value: function() {
    var r = this;
    this.props.showTimeSelect && (this.assignMonthContainer = void r.setState({ monthContainer: r.monthContainer }));
  } }, { key: "componentDidUpdate", value: function(r) {
    var a = this;
    if (!this.props.preSelection || Jt(this.props.preSelection, r.preSelection) && this.props.monthSelectedIn === r.monthSelectedIn)
      this.props.openToDate && !Jt(this.props.openToDate, r.openToDate) && this.setState({ date: this.props.openToDate });
    else {
      var o = !da(this.state.date, this.props.preSelection);
      this.setState({ date: this.props.preSelection }, function() {
        return o && a.handleCustomMonthChange(a.state.date);
      });
    }
  } }, { key: "render", value: function() {
    var r = this.props.container || SF;
    return k.createElement("div", { style: { display: "contents" }, ref: this.containerRef }, k.createElement(r, { className: Ur("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }), showPopperArrow: this.props.showPopperArrow, arrowProps: this.props.arrowProps }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
  } }], [{ key: "defaultProps", get: function() {
    return { onDropdownFocus: function() {
    }, monthsShown: 1, forceShowMonthNavigation: !1, timeCaption: "Time", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", customTimeInput: null, yearItemNumber: vc };
  } }]), n;
}(), kF = function(e) {
  var t = e.icon, n = e.className, r = n === void 0 ? "" : n, a = e.onClick, o = "react-datepicker__calendar-icon";
  return k.isValidElement(t) ? k.cloneElement(t, { className: "".concat(t.props.className || "", " ").concat(o, " ").concat(r), onClick: function(i) {
    typeof t.props.onClick == "function" && t.props.onClick(i), typeof a == "function" && a(i);
  } }) : typeof t == "string" ? k.createElement("i", { className: "".concat(o, " ").concat(t, " ").concat(r), "aria-hidden": "true", onClick: a }) : k.createElement("svg", { className: "".concat(o, " ").concat(r), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: a }, k.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" }));
}, L8 = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n(r) {
    var a;
    return jr(this, n), (a = t.call(this, r)).el = document.createElement("div"), a;
  }
  return Br(n, [{ key: "componentDidMount", value: function() {
    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
  } }, { key: "componentWillUnmount", value: function() {
    this.portalRoot.removeChild(this.el);
  } }, { key: "render", value: function() {
    return JS.createPortal(this.props.children, this.el);
  } }]), n;
}(), EF = function(e) {
  return !e.disabled && e.tabIndex !== -1;
}, R8 = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n(r) {
    var a;
    return jr(this, n), j(z(a = t.call(this, r)), "getTabChildren", function() {
      return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(EF);
    }), j(z(a), "handleFocusStart", function() {
      var o = a.getTabChildren();
      o && o.length > 1 && o[o.length - 1].focus();
    }), j(z(a), "handleFocusEnd", function() {
      var o = a.getTabChildren();
      o && o.length > 1 && o[0].focus();
    }), a.tabLoopRef = k.createRef(), a;
  }
  return Br(n, [{ key: "render", value: function() {
    return this.props.enableTabLoop ? k.createElement("div", { className: "react-datepicker__tab-loop", ref: this.tabLoopRef }, k.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: "0", onFocus: this.handleFocusStart }), this.props.children, k.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: "0", onFocus: this.handleFocusEnd })) : this.props.children;
  } }], [{ key: "defaultProps", get: function() {
    return { enableTabLoop: !0 };
  } }]), n;
}(), PF = function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n() {
    return jr(this, n), t.apply(this, arguments);
  }
  return Br(n, [{ key: "render", value: function() {
    var r, a = this.props, o = a.className, i = a.wrapperClassName, s = a.hidePopper, l = a.popperComponent, c = a.popperModifiers, u = a.popperPlacement, d = a.popperProps, p = a.targetComponent, h = a.enableTabLoop, m = a.popperOnKeyDown, f = a.portalId, g = a.portalHost;
    if (!s) {
      var _ = Ur("react-datepicker-popper", o);
      r = k.createElement(qB, Vs({ modifiers: c, placement: u }, d), function(w) {
        var x = w.ref, b = w.style, C = w.placement, E = w.arrowProps;
        return k.createElement(R8, { enableTabLoop: h }, k.createElement("div", { ref: x, style: b, className: _, "data-placement": C, onKeyDown: m }, k.cloneElement(l, { arrowProps: E })));
      });
    }
    this.props.popperContainer && (r = k.createElement(this.props.popperContainer, {}, r)), f && !s && (r = k.createElement(L8, { portalId: f, portalHost: g }, r));
    var v = Ur("react-datepicker-wrapper", i);
    return k.createElement(Nj, { className: "react-datepicker-manager" }, k.createElement(tF, null, function(w) {
      var x = w.ref;
      return k.createElement("div", { ref: x, className: v }, p);
    }), r);
  } }], [{ key: "defaultProps", get: function() {
    return { hidePopper: !0, popperModifiers: [], popperProps: {}, popperPlacement: "bottom-start" };
  } }]), n;
}(), gv = "react-datepicker-ignore-onclickoutside", TF = oh(xF), mm = "Date input not valid.";
(function(e) {
  Fr(n, k.Component);
  var t = zr(n);
  function n(r) {
    var a;
    return jr(this, n), j(z(a = t.call(this, r)), "getPreSelection", function() {
      return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : Zt();
    }), j(z(a), "modifyHolidays", function() {
      var o;
      return (o = a.props.holidays) === null || o === void 0 ? void 0 : o.reduce(function(i, s) {
        var l = new Date(s.date);
        return Ac(l) ? [].concat(Ic(i), [qd(qd({}, s), {}, { date: l })]) : i;
      }, []);
    }), j(z(a), "calcInitialState", function() {
      var o, i = a.getPreSelection(), s = P8(a.props), l = T8(a.props), c = s && Bo(i, $a(s)) ? s : l && Yo(i, z1(l)) ? l : i;
      return { open: a.props.startOpen || !1, preventFocus: !1, preSelection: (o = a.props.selectsRange ? a.props.startDate : a.props.selected) !== null && o !== void 0 ? o : c, highlightDates: pv(a.props.highlightDates), focused: !1, shouldFocusDayInline: !1, isRenderAriaLiveMessage: !1 };
    }), j(z(a), "clearPreventFocusTimeout", function() {
      a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
    }), j(z(a), "setFocus", function() {
      a.input && a.input.focus && a.input.focus({ preventScroll: !0 });
    }), j(z(a), "setBlur", function() {
      a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
    }), j(z(a), "setOpen", function(o) {
      var i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      a.setState({ open: o, preSelection: o && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection, lastPreSelectChange: fm }, function() {
        o || a.setState(function(s) {
          return { focused: !!i && s.focused };
        }, function() {
          !i && a.setBlur(), a.setState({ inputValue: null });
        });
      });
    }), j(z(a), "inputOk", function() {
      return ah(a.state.preSelection);
    }), j(z(a), "isCalendarOpen", function() {
      return a.props.open === void 0 ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
    }), j(z(a), "handleFocus", function(o) {
      a.state.preventFocus || (a.props.onFocus(o), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({ focused: !0 });
    }), j(z(a), "sendFocusBackToInput", function() {
      a.preventFocusTimeout && a.clearPreventFocusTimeout(), a.setState({ preventFocus: !0 }, function() {
        a.preventFocusTimeout = setTimeout(function() {
          a.setFocus(), a.setState({ preventFocus: !1 });
        });
      });
    }), j(z(a), "cancelFocusInput", function() {
      clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
    }), j(z(a), "deferFocusInput", function() {
      a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
        return a.setFocus();
      }, 1);
    }), j(z(a), "handleDropdownFocus", function() {
      a.cancelFocusInput();
    }), j(z(a), "handleBlur", function(o) {
      (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(o), a.setState({ focused: !1 });
    }), j(z(a), "handleCalendarClickOutside", function(o) {
      a.props.inline || a.setOpen(!1), a.props.onClickOutside(o), a.props.withPortal && o.preventDefault();
    }), j(z(a), "handleChange", function() {
      for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
        i[s] = arguments[s];
      var l = i[0];
      if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(z(a), i), typeof l.isDefaultPrevented == "function" && !l.isDefaultPrevented())) {
        a.setState({ inputValue: l.target.value, lastPreSelectChange: MF });
        var c, u, d, p, h, m, f, g, _ = (c = l.target.value, u = a.props.dateFormat, d = a.props.locale, p = a.props.strictParsing, h = a.props.minDate, m = null, f = Bi(d) || Bi(ji()), g = !0, Array.isArray(u) ? (u.forEach(function(v) {
          var w = im(c, v, /* @__PURE__ */ new Date(), { locale: f });
          p && (g = Do(w, h) && c === ir(w, v, d)), Do(w, h) && g && (m = w);
        }), m) : (m = im(c, u, /* @__PURE__ */ new Date(), { locale: f }), p ? g = Do(m) && c === ir(m, u, d) : Do(m) || (u = u.match(aF).map(function(v) {
          var w = v[0];
          return w === "p" || w === "P" ? f ? (0, nF[w])(v, f.formatLong) : w : v;
        }).join(""), c.length > 0 && (m = im(c, u.slice(0, c.length), /* @__PURE__ */ new Date())), Do(m) || (m = new Date(c))), Do(m) && g ? m : null));
        a.props.showTimeSelectOnly && a.props.selected && _ && !Jt(_, a.props.selected) && (_ = rF(a.props.selected, { hours: Ua(_), minutes: Ka(_), seconds: R2(_) })), !_ && l.target.value || (a.props.showWeekPicker && (_ = Wa(_, a.props.locale, a.props.calendarStartDay)), a.setSelected(_, l, !0));
      }
    }), j(z(a), "handleSelect", function(o, i, s) {
      if (a.props.shouldCloseOnSelect && !a.props.showTimeSelect && a.sendFocusBackToInput(), a.props.onChangeRaw && a.props.onChangeRaw(i), a.props.showWeekPicker && (o = Wa(o, a.props.locale, a.props.calendarStartDay)), a.setSelected(o, i, !1, s), a.props.showDateSelect && a.setState({ isRenderAriaLiveMessage: !0 }), !a.props.shouldCloseOnSelect || a.props.showTimeSelect)
        a.setPreSelection(o);
      else if (!a.props.inline) {
        a.props.selectsRange || a.setOpen(!1);
        var l = a.props, c = l.startDate, u = l.endDate;
        !c || u || Bo(o, c) || a.setOpen(!1);
      }
    }), j(z(a), "setSelected", function(o, i, s, l) {
      var c = o;
      if (a.props.showYearPicker) {
        if (c !== null && E8(pt(c), a.props))
          return;
      } else if (a.props.showMonthYearPicker) {
        if (c !== null && k8(c, a.props))
          return;
      } else if (c !== null && sh(c, a.props))
        return;
      var u = a.props, d = u.onChange, p = u.selectsRange, h = u.startDate, m = u.endDate;
      if (!Oi(a.props.selected, c) || a.props.allowSameDay || p)
        if (c !== null && (!a.props.selected || s && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (c = rv(c, { hour: Ua(a.props.selected), minute: Ka(a.props.selected), second: R2(a.props.selected) })), a.props.inline || a.setState({ preSelection: c }), a.props.focusSelectedMonth || a.setState({ monthSelectedIn: l })), p) {
          var f = h && !m, g = h && m;
          !h && !m ? d([c, null], i) : f && (Bo(c, h) ? d([c, null], i) : d([h, c], i)), g && d([c, null], i);
        } else
          d(c, i);
      s || (a.props.onSelect(c, i), a.setState({ inputValue: null }));
    }), j(z(a), "setPreSelection", function(o) {
      var i = a.props.minDate !== void 0, s = a.props.maxDate !== void 0, l = !0;
      if (o) {
        a.props.showWeekPicker && (o = Wa(o, a.props.locale, a.props.calendarStartDay));
        var c = $a(o);
        if (i && s)
          l = ud(o, a.props.minDate, a.props.maxDate);
        else if (i) {
          var u = $a(a.props.minDate);
          l = Yo(o, u) || Oi(c, u);
        } else if (s) {
          var d = z1(a.props.maxDate);
          l = Bo(o, d) || Oi(c, d);
        }
      }
      l && a.setState({ preSelection: o });
    }), j(z(a), "toggleCalendar", function() {
      a.setOpen(!a.state.open);
    }), j(z(a), "handleTimeChange", function(o) {
      var i = a.props.selected ? a.props.selected : a.getPreSelection(), s = a.props.selected ? o : rv(i, { hour: Ua(o), minute: Ka(o) });
      a.setState({ preSelection: s }), a.props.onChange(s), a.props.shouldCloseOnSelect && (a.sendFocusBackToInput(), a.setOpen(!1)), a.props.showTimeInput && a.setOpen(!0), (a.props.showTimeSelectOnly || a.props.showTimeSelect) && a.setState({ isRenderAriaLiveMessage: !0 }), a.setState({ inputValue: null });
    }), j(z(a), "onInputClick", function() {
      a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
    }), j(z(a), "onInputKeyDown", function(o) {
      a.props.onKeyDown(o);
      var i = o.key;
      if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
        if (a.state.open) {
          if (i === "ArrowDown" || i === "ArrowUp") {
            o.preventDefault();
            var s = a.props.showWeekPicker && a.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', l = a.calendar.componentNode && a.calendar.componentNode.querySelector(s);
            return void (l && l.focus({ preventScroll: !0 }));
          }
          var c = Zt(a.state.preSelection);
          i === "Enter" ? (o.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === fm ? (a.handleSelect(c, o), !a.props.shouldCloseOnSelect && a.setPreSelection(c)) : a.setOpen(!1)) : i === "Escape" ? (o.preventDefault(), a.sendFocusBackToInput(), a.setOpen(!1)) : i === "Tab" && a.setOpen(!1), a.inputOk() || a.props.onInputError({ code: 1, msg: mm });
        }
      } else
        i !== "ArrowDown" && i !== "ArrowUp" && i !== "Enter" || a.onInputClick();
    }), j(z(a), "onPortalKeyDown", function(o) {
      o.key === "Escape" && (o.preventDefault(), a.setState({ preventFocus: !0 }, function() {
        a.setOpen(!1), setTimeout(function() {
          a.setFocus(), a.setState({ preventFocus: !1 });
        });
      }));
    }), j(z(a), "onDayKeyDown", function(o) {
      a.props.onKeyDown(o);
      var i = o.key, s = Zt(a.state.preSelection);
      if (i === "Enter")
        o.preventDefault(), a.handleSelect(s, o), !a.props.shouldCloseOnSelect && a.setPreSelection(s);
      else if (i === "Escape")
        o.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({ code: 1, msg: mm });
      else if (!a.props.disabledKeyboardNavigation) {
        var l;
        switch (i) {
          case "ArrowLeft":
            l = a.props.showWeekPicker ? L2(s, 1) : WD(s, 1);
            break;
          case "ArrowRight":
            l = a.props.showWeekPicker ? Kd(s, 1) : ll(s, 1);
            break;
          case "ArrowUp":
            l = L2(s, 1);
            break;
          case "ArrowDown":
            l = Kd(s, 1);
            break;
          case "PageUp":
            l = Gs(s, 1);
            break;
          case "PageDown":
            l = ba(s, 1);
            break;
          case "Home":
            l = Nc(s, 1);
            break;
          case "End":
            l = zs(s, 1);
            break;
          default:
            l = null;
        }
        if (!l)
          return void (a.props.onInputError && a.props.onInputError({ code: 1, msg: mm }));
        if (o.preventDefault(), a.setState({ lastPreSelectChange: fm }), a.props.adjustDateOnChange && a.setSelected(l), a.setPreSelection(l), a.props.inline) {
          var c = Yr(s), u = Yr(l), d = pt(s), p = pt(l);
          c !== u || d !== p ? a.setState({ shouldFocusDayInline: !0 }) : a.setState({ shouldFocusDayInline: !1 });
        }
      }
    }), j(z(a), "onPopperKeyDown", function(o) {
      o.key === "Escape" && (o.preventDefault(), a.sendFocusBackToInput());
    }), j(z(a), "onClearClick", function(o) {
      o && o.preventDefault && o.preventDefault(), a.sendFocusBackToInput(), a.props.selectsRange ? a.props.onChange([null, null], o) : a.props.onChange(null, o), a.setState({ inputValue: null });
    }), j(z(a), "clear", function() {
      a.onClearClick();
    }), j(z(a), "onScroll", function(o) {
      typeof a.props.closeOnScroll == "boolean" && a.props.closeOnScroll ? o.target !== document && o.target !== document.documentElement && o.target !== document.body || a.setOpen(!1) : typeof a.props.closeOnScroll == "function" && a.props.closeOnScroll(o) && a.setOpen(!1);
    }), j(z(a), "renderCalendar", function() {
      return a.props.inline || a.isCalendarOpen() ? k.createElement(TF, { ref: function(o) {
        a.calendar = o;
      }, locale: a.props.locale, calendarStartDay: a.props.calendarStartDay, chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: a.props.weekAriaLabelPrefix, monthAriaLabelPrefix: a.props.monthAriaLabelPrefix, adjustDateOnChange: a.props.adjustDateOnChange, setOpen: a.setOpen, shouldCloseOnSelect: a.props.shouldCloseOnSelect, dateFormat: a.props.dateFormatCalendar, useWeekdaysShort: a.props.useWeekdaysShort, formatWeekDay: a.props.formatWeekDay, dropdownMode: a.props.dropdownMode, selected: a.props.selected, preSelection: a.state.preSelection, onSelect: a.handleSelect, onWeekSelect: a.props.onWeekSelect, openToDate: a.props.openToDate, minDate: a.props.minDate, maxDate: a.props.maxDate, selectsStart: a.props.selectsStart, selectsEnd: a.props.selectsEnd, selectsRange: a.props.selectsRange, startDate: a.props.startDate, endDate: a.props.endDate, excludeDates: a.props.excludeDates, excludeDateIntervals: a.props.excludeDateIntervals, filterDate: a.props.filterDate, onClickOutside: a.handleCalendarClickOutside, formatWeekNumber: a.props.formatWeekNumber, highlightDates: a.state.highlightDates, holidays: iF(a.modifyHolidays()), includeDates: a.props.includeDates, includeDateIntervals: a.props.includeDateIntervals, includeTimes: a.props.includeTimes, injectTimes: a.props.injectTimes, inline: a.props.inline, shouldFocusDayInline: a.state.shouldFocusDayInline, peekNextMonth: a.props.peekNextMonth, showMonthDropdown: a.props.showMonthDropdown, showPreviousMonths: a.props.showPreviousMonths, useShortMonthInDropdown: a.props.useShortMonthInDropdown, showMonthYearDropdown: a.props.showMonthYearDropdown, showWeekNumbers: a.props.showWeekNumbers, showYearDropdown: a.props.showYearDropdown, withPortal: a.props.withPortal, forceShowMonthNavigation: a.props.forceShowMonthNavigation, showDisabledMonthNavigation: a.props.showDisabledMonthNavigation, scrollableYearDropdown: a.props.scrollableYearDropdown, scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown, todayButton: a.props.todayButton, weekLabel: a.props.weekLabel, outsideClickIgnoreClass: gv, fixedHeight: a.props.fixedHeight, monthsShown: a.props.monthsShown, monthSelectedIn: a.state.monthSelectedIn, onDropdownFocus: a.handleDropdownFocus, onMonthChange: a.props.onMonthChange, onYearChange: a.props.onYearChange, dayClassName: a.props.dayClassName, weekDayClassName: a.props.weekDayClassName, monthClassName: a.props.monthClassName, timeClassName: a.props.timeClassName, showDateSelect: a.props.showDateSelect, showTimeSelect: a.props.showTimeSelect, showTimeSelectOnly: a.props.showTimeSelectOnly, onTimeChange: a.handleTimeChange, timeFormat: a.props.timeFormat, timeIntervals: a.props.timeIntervals, minTime: a.props.minTime, maxTime: a.props.maxTime, excludeTimes: a.props.excludeTimes, filterTime: a.props.filterTime, timeCaption: a.props.timeCaption, className: a.props.calendarClassName, container: a.props.calendarContainer, yearItemNumber: a.props.yearItemNumber, yearDropdownItemNumber: a.props.yearDropdownItemNumber, previousMonthAriaLabel: a.props.previousMonthAriaLabel, previousMonthButtonLabel: a.props.previousMonthButtonLabel, nextMonthAriaLabel: a.props.nextMonthAriaLabel, nextMonthButtonLabel: a.props.nextMonthButtonLabel, previousYearAriaLabel: a.props.previousYearAriaLabel, previousYearButtonLabel: a.props.previousYearButtonLabel, nextYearAriaLabel: a.props.nextYearAriaLabel, nextYearButtonLabel: a.props.nextYearButtonLabel, timeInputLabel: a.props.timeInputLabel, disabledKeyboardNavigation: a.props.disabledKeyboardNavigation, renderCustomHeader: a.props.renderCustomHeader, popperProps: a.props.popperProps, renderDayContents: a.props.renderDayContents, renderMonthContent: a.props.renderMonthContent, renderQuarterContent: a.props.renderQuarterContent, renderYearContent: a.props.renderYearContent, onDayMouseEnter: a.props.onDayMouseEnter, onMonthMouseLeave: a.props.onMonthMouseLeave, onYearMouseEnter: a.props.onYearMouseEnter, onYearMouseLeave: a.props.onYearMouseLeave, selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange, showTimeInput: a.props.showTimeInput, showMonthYearPicker: a.props.showMonthYearPicker, showFullMonthYearPicker: a.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker, showYearPicker: a.props.showYearPicker, showQuarterYearPicker: a.props.showQuarterYearPicker, showWeekPicker: a.props.showWeekPicker, showPopperArrow: a.props.showPopperArrow, excludeScrollbar: a.props.excludeScrollbar, handleOnKeyDown: a.props.onKeyDown, handleOnDayKeyDown: a.onDayKeyDown, isInputFocused: a.state.focused, customTimeInput: a.props.customTimeInput, setPreSelection: a.setPreSelection }, a.props.children) : null;
    }), j(z(a), "renderAriaLiveRegion", function() {
      var o, i = a.props, s = i.dateFormat, l = i.locale, c = a.props.showTimeInput || a.props.showTimeSelect ? "PPPPp" : "PPPP";
      return o = a.props.selectsRange ? "Selected start date: ".concat(Ta(a.props.startDate, { dateFormat: c, locale: l }), ". ").concat(a.props.endDate ? "End date: " + Ta(a.props.endDate, { dateFormat: c, locale: l }) : "") : a.props.showTimeSelectOnly ? "Selected time: ".concat(Ta(a.props.selected, { dateFormat: s, locale: l })) : a.props.showYearPicker ? "Selected year: ".concat(Ta(a.props.selected, { dateFormat: "yyyy", locale: l })) : a.props.showMonthYearPicker ? "Selected month: ".concat(Ta(a.props.selected, { dateFormat: "MMMM yyyy", locale: l })) : a.props.showQuarterYearPicker ? "Selected quarter: ".concat(Ta(a.props.selected, { dateFormat: "yyyy, QQQ", locale: l })) : "Selected date: ".concat(Ta(a.props.selected, { dateFormat: c, locale: l })), k.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, o);
    }), j(z(a), "renderDateInput", function() {
      var o, i = Ur(a.props.className, j({}, gv, a.state.open)), s = a.props.customInput || k.createElement("input", { type: "text" }), l = a.props.customInputRef || "ref", c = typeof a.props.value == "string" ? a.props.value : typeof a.state.inputValue == "string" ? a.state.inputValue : a.props.selectsRange ? function(u, d, p) {
        if (!u)
          return "";
        var h = Ta(u, p), m = d ? Ta(d, p) : "";
        return "".concat(h, " - ").concat(m);
      }(a.props.startDate, a.props.endDate, a.props) : Ta(a.props.selected, a.props);
      return k.cloneElement(s, (j(j(j(j(j(j(j(j(j(j(o = {}, l, function(u) {
        a.input = u;
      }), "value", c), "onBlur", a.handleBlur), "onChange", a.handleChange), "onClick", a.onInputClick), "onFocus", a.handleFocus), "onKeyDown", a.onInputKeyDown), "id", a.props.id), "name", a.props.name), "form", a.props.form), j(j(j(j(j(j(j(j(j(j(o, "autoFocus", a.props.autoFocus), "placeholder", a.props.placeholderText), "disabled", a.props.disabled), "autoComplete", a.props.autoComplete), "className", Ur(s.props.className, i)), "title", a.props.title), "readOnly", a.props.readOnly), "required", a.props.required), "tabIndex", a.props.tabIndex), "aria-describedby", a.props.ariaDescribedBy), j(j(j(o, "aria-invalid", a.props.ariaInvalid), "aria-labelledby", a.props.ariaLabelledBy), "aria-required", a.props.ariaRequired)));
    }), j(z(a), "renderClearButton", function() {
      var o = a.props, i = o.isClearable, s = o.disabled, l = o.selected, c = o.startDate, u = o.endDate, d = o.clearButtonTitle, p = o.clearButtonClassName, h = p === void 0 ? "" : p, m = o.ariaLabelClose, f = m === void 0 ? "Close" : m;
      return !i || l == null && c == null && u == null ? null : k.createElement("button", { type: "button", className: Ur("react-datepicker__close-icon", h, { "react-datepicker__close-icon--disabled": s }), disabled: s, "aria-label": f, onClick: a.onClearClick, title: d, tabIndex: -1 });
    }), a.state = a.calcInitialState(), a.preventFocusTimeout = null, a;
  }
  return Br(n, [{ key: "componentDidMount", value: function() {
    window.addEventListener("scroll", this.onScroll, !0);
  } }, { key: "componentDidUpdate", value: function(r, a) {
    var o, i;
    r.inline && (o = r.selected, i = this.props.selected, o && i ? Yr(o) !== Yr(i) || pt(o) !== pt(i) : o !== i) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && r.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), r.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: pv(this.props.highlightDates) }), a.focused || Oi(r.selected, this.props.selected) || this.setState({ inputValue: null }), a.open !== this.state.open && (a.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), a.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
  } }, { key: "componentWillUnmount", value: function() {
    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "renderInputContainer", value: function() {
    var r = this.props, a = r.showIcon, o = r.icon, i = r.calendarIconClassname, s = r.toggleCalendarOnIconClick, l = this.state.open;
    return k.createElement("div", { className: "react-datepicker__input-container".concat(a ? " react-datepicker__view-calendar-icon" : "") }, a && k.createElement(kF, Vs({ icon: o, className: "".concat(i, " ").concat(l && "react-datepicker-ignore-onclickoutside") }, s ? { onClick: this.toggleCalendar } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
  } }, { key: "render", value: function() {
    var r = this.renderCalendar();
    if (this.props.inline)
      return r;
    if (this.props.withPortal) {
      var a = this.state.open ? k.createElement(R8, { enableTabLoop: this.props.enableTabLoop }, k.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, r)) : null;
      return this.state.open && this.props.portalId && (a = k.createElement(L8, { portalId: this.props.portalId, portalHost: this.props.portalHost }, a)), k.createElement("div", null, this.renderInputContainer(), a);
    }
    return k.createElement(PF, { className: this.props.popperClassName, wrapperClassName: this.props.wrapperClassName, hidePopper: !this.isCalendarOpen(), portalId: this.props.portalId, portalHost: this.props.portalHost, popperModifiers: this.props.popperModifiers, targetComponent: this.renderInputContainer(), popperContainer: this.props.popperContainer, popperComponent: r, popperPlacement: this.props.popperPlacement, popperProps: this.props.popperProps, popperOnKeyDown: this.onPopperKeyDown, enableTabLoop: this.props.enableTabLoop });
  } }], [{ key: "defaultProps", get: function() {
    return { allowSameDay: !1, dateFormat: "MM/dd/yyyy", dateFormatCalendar: "LLLL yyyy", onChange: function() {
    }, disabled: !1, disabledKeyboardNavigation: !1, dropdownMode: "scroll", onFocus: function() {
    }, onBlur: function() {
    }, onKeyDown: function() {
    }, onInputClick: function() {
    }, onSelect: function() {
    }, onClickOutside: function() {
    }, onMonthChange: function() {
    }, onCalendarOpen: function() {
    }, onCalendarClose: function() {
    }, preventOpenOnFocus: !1, onYearChange: function() {
    }, onInputError: function() {
    }, monthsShown: 1, readOnly: !1, withPortal: !1, selectsDisabledDaysInRange: !1, shouldCloseOnSelect: !0, showTimeSelect: !1, showTimeInput: !1, showPreviousMonths: !1, showMonthYearPicker: !1, showFullMonthYearPicker: !1, showTwoColumnMonthYearPicker: !1, showFourColumnMonthYearPicker: !1, showYearPicker: !1, showQuarterYearPicker: !1, showWeekPicker: !1, strictParsing: !1, timeIntervals: 30, timeCaption: "Time", previousMonthAriaLabel: "Previous Month", previousMonthButtonLabel: "Previous Month", nextMonthAriaLabel: "Next Month", nextMonthButtonLabel: "Next Month", previousYearAriaLabel: "Previous Year", previousYearButtonLabel: "Previous Year", nextYearAriaLabel: "Next Year", nextYearButtonLabel: "Next Year", timeInputLabel: "Time", enableTabLoop: !0, yearItemNumber: vc, focusSelectedMonth: !1, showPopperArrow: !0, excludeScrollbar: !0, customTimeInput: null, calendarStartDay: void 0, toggleCalendarOnIconClick: !1 };
  } }]), n;
})();
var MF = "input", fm = "navigate";
const Cs = Xs(function({
  error: e,
  label: t,
  labelClassName: n,
  labelRightElement: r,
  htmlFor: a,
  nativeLabelProps: o,
  value: i,
  onChange: s,
  onFocus: l,
  maxLength: c,
  placeholder: u,
  isPreFetching: d,
  required: p,
  description: h,
  className: m,
  addonBefore: f,
  addonAfter: g,
  inputClassName: _,
  success: v,
  addonAfterClassName: w,
  addonBeforeClassName: x,
  statusIcon: b,
  statusIconClassName: C,
  labelContentWrapperClassName: E,
  errorAndDescriptionClassName: A,
  descriptionClassName: O,
  errorClassName: M,
  ...I
}, D) {
  const K = Fe(
    "break-words flex justify-center items-center py-2.5 px-2 sm:px-4  border border-y-text-secondary/50",
    d ? "bg-skeleton-primary/40 text-transparent border-0" : "text-text-tertiary bg-background-tertiary"
  ), G = Fe(ug, b && "pr-9");
  return /* @__PURE__ */ Z.jsxs(
    "label",
    {
      className: Fe("flex flex-col gap-1 text-sm font-medium", m),
      ...o,
      children: [
        /* @__PURE__ */ Z.jsx(
          _o,
          {
            label: t,
            labelClassName: n,
            labelRightElement: r,
            required: p
          }
        ),
        /* @__PURE__ */ Z.jsxs(
          "div",
          {
            className: Fe(
              "text-text-primary main-transition-colors relative flex w-full shrink-0 rounded-lg",
              d && "animate-pulse",
              E
            ),
            children: [
              f && /* @__PURE__ */ Z.jsx(
                "div",
                {
                  className: Fe(
                    "border-l-text-secondary/50 rounded-l-lg border-r-transparent",
                    K,
                    x
                  ),
                  children: f
                }
              ),
              /* @__PURE__ */ Z.jsx(
                "input",
                {
                  ref: D,
                  className: Fe(
                    "main-transition-colors focus:border-brand-primary placeholder:text-text-tertiary/70 bg-background-secondary min-w-0 basis-full rounded-lg focus:outline-hidden",
                    G,
                    _,
                    e ? "border-danger" : v ? "border-green" : "border-text-secondary/30",
                    d ? "bg-skeleton-primary/40 disabled:bg-skeleton-primary/40 border-0 text-transparent" : "disabled:bg-background-tertiary/40 border",
                    f && "rounded-l-none",
                    g && "rounded-r-none"
                  ),
                  type: I.type || "text",
                  value: i,
                  onChange: s,
                  onFocus: l,
                  maxLength: c,
                  placeholder: u,
                  spellCheck: !1,
                  disabled: I.disabled || d,
                  ...I
                }
              ),
              g && /* @__PURE__ */ Z.jsx(
                "div",
                {
                  className: Fe(
                    "border-r-text-secondary/50 rounded-r-lg border-l-transparent",
                    K,
                    w
                  ),
                  children: g
                }
              ),
              b && /* @__PURE__ */ Z.jsx(
                "div",
                {
                  className: Fe(
                    "absolute right-3 h-[21px] w-[21px] translate-y-1/2",
                    C
                  ),
                  children: b
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ Z.jsx(
          sl,
          {
            description: h,
            error: e,
            className: A,
            descriptionClassName: O,
            errorClassName: M
          }
        )
      ]
    }
  );
}), OF = "react-international-phone-", D8 = (...e) => e.filter((t) => !!t).join(" ").trim(), AF = (...e) => D8(...e).split(" ").map((t) => `${OF}${t}`).join(" "), mn = ({ addPrefix: e, rawClassNames: t }) => D8(AF(...e), ...t), Oa = (e) => e.replace(/\D/g, ""), yv = 35, NF = ({
  value: e,
  mask: t,
  maskSymbol: n,
  allowMoreDigitsThanMaskAllows: r,
  offset: a = 0,
  trimNonMaskCharsLeftover: o = !1
}) => {
  if (e.length < a)
    return e;
  const i = e.slice(0, a), s = e.slice(a);
  let l = i, c = 0;
  for (const d of t.split("")) {
    if (c >= s.length) {
      if (!o && d !== n) {
        l += d;
        continue;
      }
      break;
    }
    d === n ? (l += s[c], c += 1) : l += d;
  }
  let u = Oa(l);
  return r && u.length < e.length && (l += e.slice(u.length), u = Oa(l)), u.length >= yv && (l = l.slice(0, -(u.length - yv) || void 0)), l;
}, LF = (e, t) => {
  const n = e.style.display;
  n !== "block" && (e.style.display = "block");
  const r = e.getBoundingClientRect(), a = t.getBoundingClientRect(), o = a.top - r.top, i = r.bottom - a.bottom;
  o >= 0 && i >= 0 || (Math.abs(o) < Math.abs(i) ? e.scrollTop += o : e.scrollTop -= i), e.style.display = n;
}, pa = (e) => {
  const [t, n, r, a, o, i, s] = e;
  return {
    name: t,
    regions: n,
    iso2: r,
    dialCode: a,
    format: o,
    priority: i,
    areaCodes: s
  };
}, RF = (e) => `Field "${e}" is not supported`, xs = ({
  value: e,
  field: t,
  countries: n,
  defaultCountry: r
}) => {
  if (["regions", "priority"].includes(t))
    throw new Error(RF(t));
  const a = n.find((o) => {
    const i = pa(o);
    return e === i[t];
  }) || n.find((o) => {
    const i = pa(o);
    return r.toLocaleLowerCase() === i[t];
  });
  if (a)
    return pa(a);
}, vv = ({
  phone: e,
  countries: t,
  currentCountryIso2: n,
  defaultCountry: r
}) => {
  var a;
  const o = {
    country: void 0,
    fullDialCodeMatch: !1,
    areaCodeMatch: void 0
  };
  if (!e)
    return o;
  const i = Oa(e);
  if (!i)
    return o;
  let s = o;
  const l = ({
    country: c,
    fullDialCodeMatch: u,
    areaCodeMatch: d
  }) => {
    var p, h;
    const m = c.dialCode === ((p = s.country) == null ? void 0 : p.dialCode), f = (c.priority ?? 0) < (((h = s.country) == null ? void 0 : h.priority) ?? 0);
    (!m || f) && (s = { country: c, fullDialCodeMatch: u, areaCodeMatch: d });
  };
  for (const c of t) {
    const u = pa(c), { dialCode: d, areaCodes: p } = u;
    if (i.startsWith(d)) {
      const h = s.country ? Number(d) >= Number(s.country.dialCode) : !0;
      if (p) {
        const m = i.substring(d.length);
        for (const f of p)
          if (m.startsWith(f))
            return {
              country: u,
              fullDialCodeMatch: !0,
              areaCodeMatch: !0
            };
      }
      (h || d === i || !s.fullDialCodeMatch) && l({
        country: u,
        fullDialCodeMatch: !0,
        areaCodeMatch: p ? !p : void 0
      });
    }
    s.fullDialCodeMatch || i.length < d.length && d.startsWith(i) && (!s.country || Number(d) <= Number(s.country.dialCode)) && l({ country: u, fullDialCodeMatch: !1 });
  }
  if (n) {
    const c = xs({
      value: n,
      field: "iso2",
      countries: t,
      defaultCountry: r
    });
    s && c && // different countries with same dial code
    ((a = s.country) == null ? void 0 : a.dialCode) === c.dialCode && s.country !== c && // full dial code match (without area code)
    s.fullDialCodeMatch && !s.areaCodeMatch && (s = {
      country: c,
      areaCodeMatch: c != null && c.areaCodes ? !1 : void 0,
      fullDialCodeMatch: !0
    });
  }
  return s;
}, DF = ({
  phone: e,
  dialCode: t,
  prefix: n = "+",
  charAfterDialCode: r = " "
}) => {
  if (!e || !t)
    return e;
  let a = e;
  return a.startsWith(n) && (a = a.replace(n, "")), a.startsWith(t) ? (a = a.replace(t, ""), a.startsWith(r) && (a = a.replace(r, "")), a) : e;
}, bv = ({
  phone: e,
  dialCode: t,
  prefix: n = "+",
  charAfterDialCode: r = " "
}) => `${n}${t}${r}${DF({
  phone: e,
  dialCode: t,
  charAfterDialCode: r,
  prefix: n
})}`, IF = (e, t) => {
  const n = t.disableDialCodeAndPrefix ? !1 : t.forceDialCode, r = t.disableDialCodeAndPrefix ? !1 : t.insertDialCodeOnEmpty;
  let a = e;
  const o = (c) => t.trimNonDigitsEnd ? c.trim() : c;
  if (!a)
    return r && !a.length || n ? o(`${t.prefix}${t.dialCode}${t.charAfterDialCode}`) : o(a);
  if (a = Oa(a), a === t.dialCode && !t.disableDialCodeAndPrefix)
    return o(`${t.prefix}${t.dialCode}${t.charAfterDialCode}`);
  if (t.dialCode.startsWith(a) && !t.disableDialCodeAndPrefix)
    return o(n ? `${t.prefix}${t.dialCode}${t.charAfterDialCode}` : `${t.prefix}${a}`);
  if (!a.startsWith(t.dialCode) && !t.disableDialCodeAndPrefix) {
    if (n)
      return o(`${t.prefix}${t.dialCode}${t.charAfterDialCode}`);
    if (a.length < t.dialCode.length)
      return o(`${t.prefix}${a}`);
  }
  const i = () => {
    let c = t.dialCode.length;
    t.disableDialCodeAndPrefix && (c = 0);
    const u = a.slice(0, c), d = a.slice(c);
    return {
      phoneLeftSide: u,
      phoneRightSide: d
    };
  };
  let { phoneLeftSide: s, phoneRightSide: l } = i();
  return s = `${t.prefix}${s}${t.charAfterDialCode}`, l = NF({
    value: l,
    mask: t.mask,
    maskSymbol: t.maskChar,
    allowMoreDigitsThanMaskAllows: t.allowMoreDigitsThanMaskAllows,
    trimNonMaskCharsLeftover: t.trimNonDigitsEnd
  }), t.disableDialCodeAndPrefix && (s = ""), o(`${s}${l}`);
}, Ll = (e) => /\d/.test(e), jF = ({
  phoneBeforeInput: e,
  phoneAfterInput: t,
  phoneAfterFormatted: n,
  cursorPositionAfterInput: r,
  leftOffset: a = 0,
  deletion: o
}) => {
  if (r < a)
    return a;
  if (!e)
    return n.length;
  const i = o === "backward";
  if (r === 0 && t.length > 0 && n.length > 0) {
    if (i)
      return 0;
    for (let d = 0; d < n.length; d += 1)
      if (Ll(n[d]))
        return d;
    return n.length;
  }
  if (t.length < e.length && t.length === 1)
    return n.length;
  let s = null;
  for (let d = r - 1; d >= 0; d -= 1)
    if (Ll(t[d])) {
      s = d;
      break;
    }
  if (s === null)
    return r !== 0 ? r : n.length;
  let l = 0;
  for (let d = 0; d < s; d += 1)
    Ll(t[d]) && (l += 1);
  i && (l -= 1);
  let c = 0, u = 0;
  for (let d = 0; d < n.length && (c += 1, Ll(n[d]) && (u += 1), u !== l + 1); d += 1)
    ;
  for (; !Ll(n[c]) && c < n.length; )
    c += 1;
  return i && (c += 1), c;
}, Eg = [
  ["Afghanistan", ["asia"], "af", "93"],
  ["Albania", ["europe"], "al", "355"],
  ["Algeria", ["africa", "north-africa"], "dz", "213"],
  ["Andorra", ["europe"], "ad", "376"],
  ["Angola", ["africa"], "ao", "244"],
  ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"],
  [
    "Argentina",
    ["america", "south-america"],
    "ar",
    "54",
    "(..) ........",
    0,
    [
      "11",
      "221",
      "223",
      "261",
      "264",
      "2652",
      "280",
      "2905",
      "291",
      "2920",
      "2966",
      "299",
      "341",
      "342",
      "343",
      "351",
      "376",
      "379",
      "381",
      "3833",
      "385",
      "387",
      "388"
    ]
  ],
  ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"],
  ["Aruba", ["america", "carribean"], "aw", "297"],
  ["Australia", ["oceania"], "au", "61", ". .... ....", 0, ["2", "3", "4", "7", "8"]],
  ["Austria", ["europe", "eu-union"], "at", "43"],
  ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."],
  ["Bahamas", ["america", "carribean"], "bs", "1242"],
  ["Bahrain", ["middle-east"], "bh", "973"],
  ["Bangladesh", ["asia"], "bd", "880"],
  ["Barbados", ["america", "carribean"], "bb", "1246"],
  ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."],
  ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."],
  ["Belize", ["america", "central-america"], "bz", "501"],
  ["Benin", ["africa"], "bj", "229"],
  ["Bhutan", ["asia"], "bt", "975"],
  ["Bolivia", ["america", "south-america"], "bo", "591"],
  ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"],
  ["Botswana", ["africa"], "bw", "267"],
  ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."],
  ["British Indian Ocean Territory", ["asia"], "io", "246"],
  ["Brunei", ["asia"], "bn", "673"],
  ["Bulgaria", ["europe", "eu-union"], "bg", "359"],
  ["Burkina Faso", ["africa"], "bf", "226"],
  ["Burundi", ["africa"], "bi", "257"],
  ["Cambodia", ["asia"], "kh", "855"],
  ["Cameroon", ["africa"], "cm", "237"],
  [
    "Canada",
    ["america", "north-america"],
    "ca",
    "1",
    "(...) ...-....",
    1,
    [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ]
  ],
  ["Cape Verde", ["africa"], "cv", "238"],
  ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1],
  ["Central African Republic", ["africa"], "cf", "236"],
  ["Chad", ["africa"], "td", "235"],
  ["Chile", ["america", "south-america"], "cl", "56"],
  ["China", ["asia"], "cn", "86", "... .... ...."],
  ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."],
  ["Comoros", ["africa"], "km", "269"],
  ["Congo", ["africa"], "cd", "243"],
  ["Congo", ["africa"], "cg", "242"],
  ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."],
  ["Côte d'Ivoire", ["africa"], "ci", "225", ".. .. .. .. .."],
  ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"],
  ["Cuba", ["america", "carribean"], "cu", "53"],
  ["Curaçao", ["america", "carribean"], "cw", "599", "", 0],
  ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"],
  ["Czech Republic", ["europe", "eu-union"], "cz", "420", "... ... ..."],
  ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."],
  ["Djibouti", ["africa"], "dj", "253"],
  ["Dominica", ["america", "carribean"], "dm", "1767"],
  ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2],
  ["Ecuador", ["america", "south-america"], "ec", "593"],
  ["Egypt", ["africa", "north-africa"], "eg", "20"],
  ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."],
  ["Equatorial Guinea", ["africa"], "gq", "240"],
  ["Eritrea", ["africa"], "er", "291"],
  ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"],
  ["Ethiopia", ["africa"], "et", "251"],
  ["Fiji", ["oceania"], "fj", "679"],
  ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."],
  ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."],
  ["French Guiana", ["america", "south-america"], "gf", "594"],
  ["French Polynesia", ["oceania"], "pf", "689"],
  ["Gabon", ["africa"], "ga", "241"],
  ["Gambia", ["africa"], "gm", "220"],
  ["Georgia", ["asia", "ex-ussr"], "ge", "995"],
  ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"],
  ["Ghana", ["africa"], "gh", "233"],
  ["Gibraltar", ["europe"], "gi", "350"],
  ["Greece", ["europe", "eu-union"], "gr", "30"],
  ["Grenada", ["america", "carribean"], "gd", "1473"],
  ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0],
  ["Guam", ["oceania"], "gu", "1671"],
  ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."],
  ["Guinea", ["africa"], "gn", "224"],
  ["Guinea-Bissau", ["africa"], "gw", "245"],
  ["Guyana", ["america", "south-america"], "gy", "592"],
  ["Haiti", ["america", "carribean"], "ht", "509", "....-...."],
  ["Honduras", ["america", "central-america"], "hn", "504"],
  ["Hong Kong", ["asia"], "hk", "852", ".... ...."],
  ["Hungary", ["europe", "eu-union"], "hu", "36"],
  ["Iceland", ["europe"], "is", "354", "... ...."],
  ["India", ["asia"], "in", "91", ".....-....."],
  ["Indonesia", ["asia"], "id", "62"],
  ["Iran", ["middle-east"], "ir", "98", "... ... ...."],
  ["Iraq", ["middle-east"], "iq", "964"],
  ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."],
  ["Israel", ["middle-east"], "il", "972", "... ... ...."],
  ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0],
  ["Jamaica", ["america", "carribean"], "jm", "1876"],
  ["Japan", ["asia"], "jp", "81", ".. .... ...."],
  ["Jordan", ["middle-east"], "jo", "962"],
  [
    "Kazakhstan",
    ["asia", "ex-ussr"],
    "kz",
    "7",
    "... ...-..-..",
    0,
    [
      "310",
      "311",
      "312",
      "313",
      "315",
      "318",
      "321",
      "324",
      "325",
      "326",
      "327",
      "336",
      "7172",
      "73622"
    ]
  ],
  ["Kenya", ["africa"], "ke", "254"],
  ["Kiribati", ["oceania"], "ki", "686"],
  ["Kosovo", ["europe", "ex-yugos"], "xk", "383"],
  ["Kuwait", ["middle-east"], "kw", "965"],
  ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."],
  ["Laos", ["asia"], "la", "856"],
  ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371", ".. ... ..."],
  ["Lebanon", ["middle-east"], "lb", "961"],
  ["Lesotho", ["africa"], "ls", "266"],
  ["Liberia", ["africa"], "lr", "231"],
  ["Libya", ["africa", "north-africa"], "ly", "218"],
  ["Liechtenstein", ["europe"], "li", "423"],
  ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"],
  ["Luxembourg", ["europe", "eu-union"], "lu", "352"],
  ["Macau", ["asia"], "mo", "853"],
  ["Macedonia", ["europe", "ex-yugos"], "mk", "389"],
  ["Madagascar", ["africa"], "mg", "261"],
  ["Malawi", ["africa"], "mw", "265"],
  ["Malaysia", ["asia"], "my", "60", "..-....-...."],
  ["Maldives", ["asia"], "mv", "960"],
  ["Mali", ["africa"], "ml", "223"],
  ["Malta", ["europe", "eu-union"], "mt", "356"],
  ["Marshall Islands", ["oceania"], "mh", "692"],
  ["Martinique", ["america", "carribean"], "mq", "596"],
  ["Mauritania", ["africa"], "mr", "222"],
  ["Mauritius", ["africa"], "mu", "230"],
  [
    "Mexico",
    ["america", "central-america"],
    "mx",
    "52",
    "... ... ....",
    0,
    ["33", "55", "81", "229", "656", "664", "774", "998"]
  ],
  ["Micronesia", ["oceania"], "fm", "691"],
  ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."],
  ["Monaco", ["europe"], "mc", "377"],
  ["Mongolia", ["asia"], "mn", "976"],
  ["Montenegro", ["europe", "ex-yugos"], "me", "382"],
  ["Morocco", ["africa", "north-africa"], "ma", "212"],
  ["Mozambique", ["africa"], "mz", "258"],
  ["Myanmar", ["asia"], "mm", "95"],
  ["Namibia", ["africa"], "na", "264"],
  ["Nauru", ["africa"], "nr", "674"],
  ["Nepal", ["asia"], "np", "977"],
  ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"],
  ["New Caledonia", ["oceania"], "nc", "687"],
  ["New Zealand", ["oceania"], "nz", "64", "...-...-...."],
  ["Nicaragua", ["america", "central-america"], "ni", "505"],
  ["Niger", ["africa"], "ne", "227"],
  ["Nigeria", ["africa"], "ng", "234"],
  ["North Korea", ["asia"], "kp", "850"],
  ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."],
  ["Oman", ["middle-east"], "om", "968"],
  ["Pakistan", ["asia"], "pk", "92", "...-......."],
  ["Palau", ["oceania"], "pw", "680"],
  ["Palestine", ["middle-east"], "ps", "970"],
  ["Panama", ["america", "central-america"], "pa", "507"],
  ["Papua New Guinea", ["oceania"], "pg", "675"],
  ["Paraguay", ["america", "south-america"], "py", "595"],
  ["Peru", ["america", "south-america"], "pe", "51"],
  ["Philippines", ["asia"], "ph", "63", ".... ......."],
  ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."],
  ["Portugal", ["europe", "eu-union"], "pt", "351"],
  ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3],
  ["Qatar", ["middle-east"], "qa", "974"],
  ["Réunion", ["africa"], "re", "262"],
  ["Romania", ["europe", "eu-union"], "ro", "40"],
  ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 1],
  ["Rwanda", ["africa"], "rw", "250"],
  ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"],
  ["Saint Lucia", ["america", "carribean"], "lc", "1758"],
  ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"],
  ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"],
  ["Samoa", ["oceania"], "ws", "685"],
  ["San Marino", ["europe"], "sm", "378"],
  ["São Tomé and Príncipe", ["africa"], "st", "239"],
  ["Saudi Arabia", ["middle-east"], "sa", "966"],
  ["Senegal", ["africa"], "sn", "221"],
  ["Serbia", ["europe", "ex-yugos"], "rs", "381"],
  ["Seychelles", ["africa"], "sc", "248"],
  ["Sierra Leone", ["africa"], "sl", "232"],
  ["Singapore", ["asia"], "sg", "65", "....-...."],
  ["Slovakia", ["europe", "eu-union"], "sk", "421"],
  ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"],
  ["Solomon Islands", ["oceania"], "sb", "677"],
  ["Somalia", ["africa"], "so", "252"],
  ["South Africa", ["africa"], "za", "27"],
  ["South Korea", ["asia"], "kr", "82", "... .... ...."],
  ["South Sudan", ["africa", "north-africa"], "ss", "211"],
  ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."],
  ["Sri Lanka", ["asia"], "lk", "94"],
  ["Sudan", ["africa"], "sd", "249"],
  ["Suriname", ["america", "south-america"], "sr", "597"],
  ["Swaziland", ["africa"], "sz", "268"],
  ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."],
  ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."],
  ["Syria", ["middle-east"], "sy", "963"],
  ["Taiwan", ["asia"], "tw", "886"],
  ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"],
  ["Tanzania", ["africa"], "tz", "255"],
  ["Thailand", ["asia"], "th", "66"],
  ["Timor-Leste", ["asia"], "tl", "670"],
  ["Togo", ["africa"], "tg", "228"],
  ["Tonga", ["oceania"], "to", "676"],
  ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"],
  ["Tunisia", ["africa", "north-africa"], "tn", "216"],
  ["Turkey", ["europe"], "tr", "90", "... ... .. .."],
  ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"],
  ["Tuvalu", ["asia"], "tv", "688"],
  ["Uganda", ["africa"], "ug", "256"],
  ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."],
  ["United Arab Emirates", ["middle-east"], "ae", "971"],
  ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"],
  [
    "United States",
    ["america", "north-america"],
    "us",
    "1",
    "(...) ...-....",
    0,
    [
      "201",
      "202",
      "203",
      "205",
      "206",
      "207",
      "208",
      "209",
      "210",
      "212",
      "213",
      "214",
      "215",
      "216",
      "217",
      "218",
      "219",
      "224",
      "225",
      "228",
      "229",
      "231",
      "234",
      "239",
      "240",
      "248",
      "251",
      "252",
      "253",
      "254",
      "256",
      "260",
      "262",
      "267",
      "269",
      "270",
      "276",
      "281",
      "301",
      "302",
      "303",
      "304",
      "305",
      "307",
      "308",
      "309",
      "310",
      "312",
      "313",
      "314",
      "315",
      "316",
      "317",
      "318",
      "319",
      "320",
      "321",
      "323",
      "325",
      "330",
      "334",
      "336",
      "337",
      "339",
      "347",
      "351",
      "352",
      "360",
      "361",
      "386",
      "401",
      "402",
      "404",
      "405",
      "406",
      "407",
      "408",
      "409",
      "410",
      "412",
      "413",
      "414",
      "415",
      "417",
      "419",
      "423",
      "424",
      "425",
      "430",
      "432",
      "434",
      "435",
      "440",
      "443",
      "447",
      "469",
      "478",
      "479",
      "480",
      "484",
      "501",
      "502",
      "503",
      "504",
      "505",
      "507",
      "508",
      "509",
      "510",
      "512",
      "513",
      "515",
      "516",
      "517",
      "518",
      "520",
      "530",
      "540",
      "541",
      "551",
      "559",
      "561",
      "562",
      "563",
      "567",
      "570",
      "571",
      "573",
      "574",
      "575",
      "580",
      "585",
      "586",
      "601",
      "602",
      "603",
      "605",
      "606",
      "607",
      "608",
      "609",
      "610",
      "612",
      "614",
      "615",
      "616",
      "617",
      "618",
      "619",
      "620",
      "623",
      "626",
      "630",
      "631",
      "636",
      "641",
      "646",
      "650",
      "651",
      "660",
      "661",
      "662",
      "678",
      "681",
      "682",
      "689",
      "701",
      "702",
      "703",
      "704",
      "706",
      "707",
      "708",
      "712",
      "713",
      "714",
      "715",
      "716",
      "717",
      "718",
      "719",
      "720",
      "724",
      "727",
      "731",
      "732",
      "734",
      "740",
      "754",
      "757",
      "760",
      "762",
      "763",
      "765",
      "769",
      "770",
      "772",
      "773",
      "774",
      "775",
      "779",
      "781",
      "785",
      "786",
      "801",
      "802",
      "803",
      "804",
      "805",
      "806",
      "808",
      "810",
      "812",
      "813",
      "814",
      "815",
      "816",
      "817",
      "818",
      "828",
      "830",
      "831",
      "832",
      "843",
      "845",
      "847",
      "848",
      "850",
      "856",
      "857",
      "858",
      "859",
      "860",
      "862",
      "863",
      "864",
      "865",
      "870",
      "878",
      "901",
      "903",
      "904",
      "906",
      "907",
      "908",
      "909",
      "910",
      "912",
      "913",
      "914",
      "915",
      "916",
      "917",
      "918",
      "919",
      "920",
      "925",
      "928",
      "931",
      "936",
      "937",
      "940",
      "941",
      "947",
      "949",
      "951",
      "952",
      "954",
      "956",
      "970",
      "971",
      "972",
      "973",
      "978",
      "979",
      "980",
      "985",
      "989"
    ]
  ],
  ["Uruguay", ["america", "south-america"], "uy", "598"],
  ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."],
  ["Vanuatu", ["oceania"], "vu", "678"],
  ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1],
  ["Venezuela", ["america", "south-america"], "ve", "58"],
  ["Vietnam", ["asia"], "vn", "84"],
  ["Yemen", ["middle-east"], "ye", "967"],
  ["Zambia", ["africa"], "zm", "260"],
  ["Zimbabwe", ["africa"], "zw", "263"],
  ["Faroe Islands", ["europe"], "fo", "298"]
], Qd = "fr", BF = () => {
  const e = _e(), t = _e(Date.now());
  return {
    check: () => {
      const n = Date.now(), r = e.current ? n - t.current : void 0;
      return e.current = t.current, t.current = n, r;
    }
  };
}, FF = {
  size: 20,
  overrideLastItemDebounceMS: -1
  // overriding is disabled by default
};
function zF(e, t) {
  const { size: n, overrideLastItemDebounceMS: r, onChange: a } = {
    ...FF,
    ...t
  }, [o, i] = ke(e), [s, l] = ke([o]), [c, u] = ke(0), d = BF();
  return [o, (p, h) => {
    if (
      // compare entries if passed value is object
      typeof p == "object" && Object.entries(p).toString() === Object.entries(o).toString() || p === o
    )
      return;
    const m = r > 0, f = d.check(), g = m && f !== void 0 ? f > r : !0;
    if (
      // use value of config.overrideLastItem if passed
      (h == null ? void 0 : h.overrideLastItem) !== void 0 ? h.overrideLastItem : !g
    )
      l((_) => [..._.slice(0, c), p]);
    else {
      const _ = s.length >= n;
      l((v) => [...v.slice(_ ? 1 : 0, c + 1), p]), _ || u((v) => v + 1);
    }
    i(p), a == null || a(p);
  }, () => {
    if (c <= 0)
      return { success: !1 };
    const p = s[c - 1];
    return i(p), u((h) => h - 1), a == null || a(p), { success: !0, value: p };
  }, () => {
    if (c + 1 >= s.length)
      return { success: !1 };
    const p = s[c + 1];
    return i(p), u((h) => h + 1), a == null || a(p), { success: !0, value: p };
  }];
}
const GF = ".", dn = {
  defaultCountry: Qd,
  initialCountry: Qd,
  value: "",
  prefix: "+",
  defaultMask: "............",
  // 12 chars
  charAfterDialCode: " ",
  historySaveDebounceMS: 200,
  allowMoreDigitsThanMaskAllows: !0,
  disableCountryGuess: !1,
  disableDialCodePrefill: !1,
  forceDialCode: !1,
  disableDialCodeAndPrefix: !1,
  countries: Eg,
  dontShowDialCodePrefillOnFocus: !1
}, HF = ({
  defaultCountry: e = dn.defaultCountry,
  initialCountry: t = dn.initialCountry,
  value: n = dn.value,
  countries: r = dn.countries,
  prefix: a = dn.prefix,
  defaultMask: o = dn.defaultMask,
  allowMoreDigitsThanMaskAllows: i = dn.allowMoreDigitsThanMaskAllows,
  charAfterDialCode: s = dn.charAfterDialCode,
  historySaveDebounceMS: l = dn.historySaveDebounceMS,
  disableCountryGuess: c = dn.disableCountryGuess,
  disableDialCodePrefill: u = dn.disableDialCodePrefill,
  forceDialCode: d = dn.forceDialCode,
  disableDialCodeAndPrefix: p = dn.disableDialCodeAndPrefix,
  dontShowDialCodePrefillOnFocus: h = dn.dontShowDialCodePrefillOnFocus,
  onChange: m
}) => {
  const f = n || "", g = p ? !1 : !c, _ = _e(null), v = ({
    value: U,
    country: H,
    trimNonDigitsEnd: W,
    insertDialCodeOnEmpty: L,
    forceDisableCountryGuess: T
  }) => {
    const B = !T && g ? vv({
      phone: U,
      countries: r,
      currentCountryIso2: H.iso2,
      defaultCountry: e
    }) : void 0, N = (B == null ? void 0 : B.country) ?? H;
    return { phone: N ? IF(U, {
      prefix: a,
      mask: N.format || o,
      maskChar: GF,
      dialCode: N.dialCode,
      allowMoreDigitsThanMaskAllows: i,
      trimNonDigitsEnd: W,
      charAfterDialCode: s,
      forceDialCode: d,
      insertDialCodeOnEmpty: L,
      disableDialCodeAndPrefix: p
    }) : U, countryGuessResult: B, formatCountry: N };
  }, w = (U) => {
    typeof document < "u" && document.activeElement === _.current && Promise.resolve().then(() => {
      var H;
      (H = _.current) == null || H.setSelectionRange(U, U);
    });
  }, x = ft(
    ({ phone: U, country: H }) => m == null ? void 0 : m({
      phone: U,
      unformatedPhone: Oa(U),
      country: H,
      prefix: a
    }),
    [m, a]
  ), [{ phone: b, country: C }, E, A, O] = zF(
    () => {
      const U = vv({
        phone: f,
        countries: r,
        currentCountryIso2: t,
        defaultCountry: e
      }).country || xs({
        value: t,
        field: "iso2",
        countries: r,
        defaultCountry: e
      });
      U || console.error(
        `[react-international-phone]: can not find a country with "${e}" iso2 code`
      );
      const H = U || // set "us" if user provided not valid country
      pa(r.find((L) => pa(L).iso2 === Qd)), W = v({
        value: f,
        country: H,
        insertDialCodeOnEmpty: h ? !u : !1
      }).phone;
      return w(W.length), {
        phone: W,
        country: H.iso2
      };
    },
    {
      overrideLastItemDebounceMS: l,
      onChange: x
    }
  ), M = we(() => xs({
    value: C,
    field: "iso2",
    countries: r,
    defaultCountry: e
  }), [r, C, e]), I = ft(() => {
    var U;
    h || (U = _ == null ? void 0 : _.current) != null && U.value || x == null || x({
      phone: bv({
        phone: b,
        dialCode: M.dialCode,
        charAfterDialCode: s,
        prefix: a
      }),
      country: C
    });
  }, [
    s,
    C,
    M,
    x,
    b,
    a,
    h
  ]), D = (U, {
    deletion: H,
    cursorPosition: W,
    insertDialCodeOnEmpty: L,
    inserted: T
  } = {}) => {
    var B;
    let N = U, Y = W;
    d && !p && M && // dial code has been changed
    !Oa(U).startsWith(M.dialCode) && U && (T && U.startsWith(a) && // cursor position was set to 0 before the input
    U.length - (W ?? 0) === 0 ? N = U : (N = b, Y = 0));
    const { phone: Q, countryGuessResult: F } = v({
      value: N,
      country: M,
      trimNonDigitsEnd: H === "backward",
      // trim values if user deleting chars (delete mask's whitespace and brackets)
      insertDialCodeOnEmpty: L,
      forceDisableCountryGuess: d && !!H && Oa(N).length < M.dialCode.length
    });
    let re = M;
    g && F != null && F.country && F.country.name !== C && F.fullDialCodeMatch && (re = F.country);
    const q = jF({
      cursorPositionAfterInput: Y ?? 0,
      phoneBeforeInput: b,
      phoneAfterInput: U,
      phoneAfterFormatted: Q,
      leftOffset: d ? a.length + (((B = M == null ? void 0 : M.dialCode) == null ? void 0 : B.length) ?? 0) + s.length : 0,
      deletion: H
    });
    return E({
      phone: Q,
      country: re.iso2
    }), w(q), Q;
  };
  De(() => {
    const U = _.current;
    if (!U)
      return;
    const H = (W) => {
      if (!W.key)
        return;
      const L = W.ctrlKey, T = W.shiftKey, B = W.key.toLowerCase() === "z";
      !L || !B || (T ? O() : A());
    };
    return U.addEventListener("keydown", H), () => {
      U.removeEventListener("keydown", H);
    };
  }, [_, A, O]);
  const K = (U) => {
    U.preventDefault();
    const H = U.nativeEvent.inputType, W = () => {
      if ((H == null ? void 0 : H.toLocaleLowerCase().includes("delete")) ?? !1)
        return H != null && H.toLocaleLowerCase().includes("forward") ? "forward" : "backward";
    }, L = H == null ? void 0 : H.startsWith("insertFrom"), T = D(U.target.value, {
      deletion: W(),
      inserted: L,
      cursorPosition: U.target.selectionStart ?? 0
    });
    return p && M ? bv({
      phone: T,
      dialCode: M.dialCode,
      charAfterDialCode: s,
      prefix: a
    }) : T;
  }, G = (U) => {
    const H = xs({
      value: U,
      field: "iso2",
      countries: r,
      defaultCountry: e
    });
    if (!H)
      return;
    const W = p ? "" : `${a}${H.dialCode}${s}`;
    E({
      phone: W,
      country: H.iso2
    }), Promise.resolve().then(() => {
      var L;
      (L = _.current) == null || L.focus();
    });
  }, [V, ee] = ke(!1);
  return De(() => {
    if (!V) {
      ee(!0), f !== b && (x == null || x({ phone: b, country: C }));
      return;
    }
    Oa(f) !== Oa(b) && D(Oa(f));
  }, [f]), De(() => {
    if (!b && t) {
      const U = xs({
        value: t,
        field: "iso2",
        countries: r,
        defaultCountry: e
      });
      E({
        phone: b,
        country: (U == null ? void 0 : U.iso2) || e
      });
    }
  }, [t]), {
    phone: b,
    // Formatted phone string.
    country: C,
    // Current country iso code.
    setCountry: G,
    // Country setter.
    handlePhoneValueChange: K,
    // Change handler for input component
    onFocus: I,
    inputRef: _
    // Ref object for input component (handles caret position, focus and undo/redo).
  };
}, KF = (e, t) => {
  const n = parseInt(e, 16);
  return Number(n + t).toString(16);
}, UF = "abcdefghijklmnopqrstuvwxyz", $F = "1f1e6", _v = UF.split("").reduce((e, t, n) => ({
  ...e,
  // construct alphabet by incrementing A letter codepoint value
  [t]: KF($F, n)
}), {}), VF = (e) => [_v[e[0]], _v[e[1]]].join("-"), I8 = ({
  iso2: e,
  size: t = "24px",
  protocol: n = "https",
  disableLazyLoading: r,
  className: a,
  ...o
}) => {
  if (!e)
    return /* @__PURE__ */ Z.jsx("img", { width: t, height: t, ...o });
  const i = VF(e), s = `${n}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${i}.svg`;
  return /* @__PURE__ */ Z.jsx(
    "img",
    {
      className: mn({
        addPrefix: ["flag-emoji"],
        rawClassNames: [a]
      }),
      src: s,
      width: t,
      height: t,
      draggable: !1,
      "data-country": e,
      loading: r ? void 0 : "lazy",
      ...o
    }
  );
}, j8 = ({
  show: e,
  dialCodePrefix: t = "+",
  selectedCountry: n,
  countries: r = Eg,
  onSelect: a,
  onClose: o,
  searchInputPlaceholder: i,
  ...s
}) => {
  const l = _e(null), c = _e(null), u = _e(), [d, p] = ke(""), h = we(() => {
    if (d) {
      const C = d.toLowerCase();
      return r.filter(([E]) => E.toLowerCase().includes(C));
    } else
      return r;
  }, [r, d]), m = ft(
    (C) => h.findIndex((E) => pa(E).iso2 === C),
    [h]
  ), [f, g] = ke(m(n)), _ = () => {
    u.current !== n && g(m(n));
  }, v = ft(
    (C) => {
      g(m(C.iso2)), a == null || a(C);
    },
    [a, m]
  ), w = (C) => {
    const E = h.length - 1, A = (O) => C === "prev" ? O - 1 : C === "next" ? O + 1 : C === "last" ? E : 0;
    g((O) => {
      const M = A(O);
      return M < 0 ? 0 : M > E ? E : M;
    });
  }, x = (C) => {
    if (C.stopPropagation(), C.key === "Enter") {
      const E = pa(h[f]);
      v(E);
      return;
    }
    if (C.key === "Escape") {
      o == null || o();
      return;
    }
    if (C.key === "ArrowUp") {
      C.preventDefault(), w("prev");
      return;
    }
    if (C.key === "ArrowDown") {
      C.preventDefault(), w("next");
      return;
    }
    if (C.key === "PageUp") {
      C.preventDefault(), w("first");
      return;
    }
    if (C.key === "PageDown") {
      C.preventDefault(), w("last");
      return;
    }
    C.key === " " && C.preventDefault();
  }, b = ft(() => {
    if (!c.current || f === void 0 || !h[f])
      return;
    const C = pa(h[f]).iso2;
    if (C === u.current)
      return;
    const E = c.current.querySelector(`[data-country="${C}"]`);
    E && (LF(c.current, E), u.current = C);
  }, [f, h]);
  return De(() => {
    b();
  }, [f, b]), De(() => {
    l.current && (e ? Promise.resolve().then(() => {
      var C;
      return (C = l.current) == null ? void 0 : C.focus();
    }) : _());
  }, [e]), De(() => {
    _();
  }, [n]), /* @__PURE__ */ Z.jsxs(
    "div",
    {
      className: mn({
        addPrefix: ["country-selector-dropdown"],
        rawClassNames: [s.className]
      }),
      style: { display: e ? "block" : "none", ...s.style },
      tabIndex: -1,
      "aria-activedescendant": `${h[f] && pa(h[f]).iso2}-option`,
      onBlur: o,
      children: [
        /* @__PURE__ */ Z.jsx(
          "input",
          {
            ref: l,
            className: mn({
              addPrefix: ["country-selector-dropdown__search-input"],
              rawClassNames: [s.searchInputClassName]
            }),
            placeholder: i || "",
            style: s.searchInputStyle,
            type: "text",
            value: d,
            onChange: (C) => p(C.target.value),
            onKeyDown: x
          }
        ),
        d && /* @__PURE__ */ Z.jsx(
          ng,
          {
            onClick: () => p(""),
            className: mn({
              addPrefix: ["country-selector-dropdown__clear-search-input"],
              rawClassNames: [s.clearSearchInputClassName]
            }),
            style: s.clearSearchInputStyle
          }
        ),
        /* @__PURE__ */ Z.jsx(
          "ul",
          {
            ref: c,
            role: "listbox",
            className: mn({
              addPrefix: ["country-selector-dropdown__list"],
              rawClassNames: [s.listClassName]
            }),
            style: s.listStyle,
            children: h.map((C, E) => {
              const A = pa(C), O = A.iso2 === n, M = E === f;
              return /* @__PURE__ */ Z.jsxs(
                "li",
                {
                  "data-country": A.iso2,
                  "data-focused": M,
                  role: "option",
                  "aria-selected": O,
                  "aria-label": `${A.name} ${t}${A.dialCode}`,
                  id: `${A.iso2}-option`,
                  className: mn({
                    addPrefix: [
                      "country-selector-dropdown__list-item",
                      O && "country-selector-dropdown__list-item--selected",
                      M && "country-selector-dropdown__list-item--focused"
                    ],
                    rawClassNames: [s.listItemClassName]
                  }),
                  onClick: () => v(A),
                  style: s.listItemStyle,
                  children: [
                    /* @__PURE__ */ Z.jsx(
                      I8,
                      {
                        iso2: A.iso2,
                        className: mn({
                          addPrefix: ["country-selector-dropdown__list-item-flag-emoji"],
                          rawClassNames: [s.listItemFlagClassName]
                        }),
                        style: s.listItemFlagStyle
                      }
                    ),
                    /* @__PURE__ */ Z.jsx(
                      "span",
                      {
                        className: mn({
                          addPrefix: ["country-selector-dropdown__list-item-country-name"],
                          rawClassNames: [s.listItemCountryNameClassName]
                        }),
                        style: s.listItemCountryNameStyle,
                        children: A.name
                      }
                    ),
                    /* @__PURE__ */ Z.jsxs(
                      "span",
                      {
                        className: mn({
                          addPrefix: ["country-selector-dropdown__list-item-dial-code"],
                          rawClassNames: [s.listItemDialCodeClassName]
                        }),
                        style: s.listItemDialCodeStyle,
                        children: [
                          t,
                          A.dialCode
                        ]
                      }
                    )
                  ]
                },
                A.iso2
              );
            })
          }
        )
      ]
    }
  );
}, WF = ({
  selectedCountry: e,
  onSelect: t,
  disabled: n,
  hideDropdown: r,
  defaultCountry: a = Qd,
  countries: o = Eg,
  renderButtonWrapper: i,
  ...s
}) => {
  const [l, c] = ke(!1), u = we(() => {
    if (e)
      return xs({
        value: e,
        field: "iso2",
        countries: o,
        defaultCountry: a
      });
  }, [o, a, e]), d = _e(null), p = (m) => {
    m.key && ["ArrowUp", "ArrowDown"].includes(m.key) && (m.preventDefault(), c(!0));
  }, h = () => {
    const m = {
      title: u == null ? void 0 : u.name,
      onClick: () => c((g) => !g),
      // Need this to close dropdown on selector button click
      // https://stackoverflow.com/a/28963938
      onMouseDown: (g) => g.preventDefault(),
      onKeyDown: p,
      disabled: r || n,
      role: "combobox",
      "aria-label": "Country selector",
      "aria-haspopup": "listbox",
      "aria-expanded": l
    }, f = /* @__PURE__ */ Z.jsxs(
      "div",
      {
        className: mn({
          addPrefix: ["country-selector-button__button-content"],
          rawClassNames: [s.buttonContentWrapperClassName]
        }),
        style: s.buttonContentWrapperStyle,
        children: [
          /* @__PURE__ */ Z.jsx(
            I8,
            {
              iso2: e,
              className: mn({
                addPrefix: [
                  "country-selector-button__flag-emoji",
                  n && "country-selector-button__flag-emoji--disabled"
                ],
                rawClassNames: [s.flagClassName]
              }),
              style: {
                visibility: e ? "visible" : "hidden",
                ...s.flagStyle
              }
            }
          ),
          !r && /* @__PURE__ */ Z.jsx(
            "div",
            {
              className: mn({
                addPrefix: [
                  "country-selector-button__dropdown-arrow",
                  n && "country-selector-button__dropdown-arrow--disabled",
                  l && "country-selector-button__dropdown-arrow--active"
                ],
                rawClassNames: [s.dropdownArrowClassName]
              }),
              style: s.dropdownArrowStyle
            }
          )
        ]
      }
    );
    return i ? i({
      children: f,
      rootProps: m
    }) : /* @__PURE__ */ Z.jsx(
      "button",
      {
        ...m,
        type: "button",
        className: mn({
          addPrefix: [
            "country-selector-button",
            l && "country-selector-button--active",
            n && "country-selector-button--disabled",
            r && "country-selector-button--hide-dropdown"
          ],
          rawClassNames: [s.buttonClassName]
        }),
        "data-country": e,
        style: s.buttonStyle,
        children: f
      }
    );
  };
  return /* @__PURE__ */ Z.jsxs(
    "div",
    {
      className: mn({
        addPrefix: ["country-selector"],
        rawClassNames: [s.className]
      }),
      style: s.style,
      ref: d,
      children: [
        h(),
        /* @__PURE__ */ Z.jsx(
          j8,
          {
            show: l,
            countries: o,
            onSelect: (m) => {
              c(!1), t == null || t(m);
            },
            selectedCountry: e,
            onClose: () => {
              c(!1);
            },
            ...s.dropdownStyleProps
          }
        )
      ]
    }
  );
}, YF = ({
  label: e,
  labelClassName: t,
  required: n,
  value: r,
  onChange: a,
  error: o,
  wrapperClassName: i,
  inputClassName: s,
  listClassName: l,
  searchInputClassName: c,
  clearSearchInputClassName: u,
  listItemClassName: d,
  listItemCountryNameClassName: p,
  countrySelectorDropdownClassName: h,
  countrySelectorClassName: m,
  buttonClassName: f,
  listboxButtonClassName: g,
  listboxOptionsClassName: _,
  initialCountry: v,
  ...w
}) => {
  const x = _e(null), b = _e(null), C = _e(null), { country: E, setCountry: A, phone: O, handlePhoneValueChange: M, onFocus: I, inputRef: D } = HF({
    value: r,
    onChange: ({ unformatedPhone: K }) => a(K),
    initialCountry: v == null ? void 0 : v.toLowerCase()
  });
  return /* @__PURE__ */ Z.jsx("div", { className: i, children: /* @__PURE__ */ Z.jsx(oT, { children: ({ open: K }) => {
    var G;
    return /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
      /* @__PURE__ */ Z.jsxs("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ Z.jsx(
          _o,
          {
            label: e,
            required: n,
            labelClassName: Fe("text-sm font-medium", t)
          }
        ),
        /* @__PURE__ */ Z.jsxs(
          "div",
          {
            ref: b,
            className: "relative w-full cursor-default overflow-hidden rounded-lg text-left",
            children: [
              /* @__PURE__ */ Z.jsxs(
                l5,
                {
                  ref: C,
                  as: "div",
                  disabled: w.disabled,
                  className: Fe(
                    "z-1 absolute left-0 top-2 flex cursor-pointer items-center gap-1 pl-3",
                    g,
                    w.disabled && "cursor-not-allowed"
                  ),
                  children: [
                    /* @__PURE__ */ Z.jsx(
                      WF,
                      {
                        className: Fe("flex", m),
                        buttonStyle: { border: "none" },
                        buttonClassName: Fe(
                          w.disabled ? "cursor-not-allowed" : "cursor-pointer",
                          f
                        ),
                        hideDropdown: !0,
                        disabled: w.disabled,
                        selectedCountry: E,
                        defaultCountry: v == null ? void 0 : v.toLowerCase()
                      }
                    ),
                    /* @__PURE__ */ Z.jsx(
                      ag,
                      {
                        className: `transition-transform duration-300 ${K && "rotate-180"} `,
                        "aria-hidden": "true"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ Z.jsx(
                Cs,
                {
                  ref: D,
                  type: "tel",
                  placeholder: Xe.t("public_pages_purchase.input.phone_number"),
                  inputClassName: Fe(
                    "pl-16",
                    K && "border-brand-primary",
                    s
                  ),
                  value: O,
                  onChange: M,
                  onFocus: I,
                  error: o,
                  ...w
                }
              )
            ]
          }
        )
      ] }),
      /* @__PURE__ */ Z.jsx(
        c5,
        {
          className: Fe("focus-visible:outline-hidden", _),
          children: /* @__PURE__ */ Z.jsx(
            "div",
            {
              className: "bg-background-secondary absolute z-20 rounded-lg",
              ref: x,
              style: {
                width: `${(G = D.current) == null ? void 0 : G.clientWidth}px`
              },
              children: /* @__PURE__ */ Z.jsx("div", { children: /* @__PURE__ */ Z.jsx(
                j8,
                {
                  className: Fe(
                    "bg-background-secondary shadow-around-sm rounded-md text-sm",
                    h
                  ),
                  listClassName: Fe(
                    "max-h-60 w-full overflow-auto focus:outline-hidden customScroll rounded-md",
                    l
                  ),
                  searchInputClassName: Fe(
                    `w-full px-4 py-2.5 rounded-t-md border border-t-1 border-b-0 border-text-secondary/30 
                        shadow-around-sm focus:outline-hidden
                      `,
                    c
                  ),
                  clearSearchInputClassName: Fe(
                    "absolute top-0 right-2 w-[21px] h-[21px] translate-y-1/2 z-1 fill-text-primary cursor-pointer scale-75",
                    u
                  ),
                  listItemClassName: Fe(
                    `text-text-primary px-4 py-2.5 border border-t-0 last:rounded-b-md border-text-secondary/30 
                        group hover:bg-brand-primary hover:text-background-secondary flex justify-start gap-2 items-center 
                        data-[focused=true]:bg-brand-primary aria-[selected=true]:font-bold`,
                    d
                  ),
                  listItemCountryNameClassName: Fe(
                    "truncate",
                    p
                  ),
                  searchInputPlaceholder: Xe.t("public_pages_purchase.input.phone_search"),
                  show: K,
                  selectedCountry: E,
                  onSelect: (V) => {
                    var ee;
                    A(V.iso2), (ee = C.current) == null || ee.click();
                  }
                }
              ) })
            }
          )
        }
      )
    ] });
  } }) });
};
var dd = /* @__PURE__ */ ((e) => (e.Last30Days = "last_30_days", e.ThisMonth = "this_month", e.LastMonth = "last_month", e))(dd || {}), pd = /* @__PURE__ */ ((e) => (e.AllTime = "all_time", e.Last3Months = "last_3_months", e.EvaluationPeriod = "evaluation_period", e))(pd || {});
const ZF = Xs(
  ({
    onClick: e,
    error: t,
    label: n,
    labelClassName: r,
    required: a,
    wrapperButtonInputClassName: o,
    buttonInputClassName: i,
    description: s,
    children: l,
    value: c
  }, u) => /* @__PURE__ */ Z.jsxs("div", { className: Fe("flex flex-col gap-1", o), children: [
    /* @__PURE__ */ Z.jsx(_o, { label: n, labelClassName: r, required: a }),
    /* @__PURE__ */ Z.jsxs("button", { onClick: e, ref: u, type: "button", className: i, children: [
      l(c),
      /* @__PURE__ */ Z.jsx(
        OO,
        {
          className: Fe(
            "fill-fill-primary group-focus:fill-brand-primary main-transition-colors ml-3 hidden h-[20px] w-[20px] sm:block",
            c ? "hidden sm:block" : "block"
          )
        }
      )
    ] }),
    /* @__PURE__ */ Z.jsx(sl, { error: t, description: s })
  ] })
);
ZF.displayName = "ButtonInput";
dd.Last30Days + "", dd.ThisMonth + "", dd.LastMonth + "";
pd.AllTime + "", pd.Last3Months + "", pd.EvaluationPeriod + "";
const Ze = (e) => typeof e == "string", Rl = () => {
  let e, t;
  const n = new Promise((r, a) => {
    e = r, t = a;
  });
  return n.resolve = e, n.reject = t, n;
}, wv = (e) => e == null ? "" : "" + e, qF = (e, t, n) => {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}, JF = /###/g, Sv = (e) => e && e.indexOf("###") > -1 ? e.replace(JF, ".") : e, Cv = (e) => !e || Ze(e), bc = (e, t, n) => {
  const r = Ze(t) ? t.split(".") : t;
  let a = 0;
  for (; a < r.length - 1; ) {
    if (Cv(e))
      return {};
    const o = Sv(r[a]);
    !e[o] && n && (e[o] = new n()), Object.prototype.hasOwnProperty.call(e, o) ? e = e[o] : e = {}, ++a;
  }
  return Cv(e) ? {} : {
    obj: e,
    k: Sv(r[a])
  };
}, xv = (e, t, n) => {
  const {
    obj: r,
    k: a
  } = bc(e, t, Object);
  if (r !== void 0 || t.length === 1) {
    r[a] = n;
    return;
  }
  let o = t[t.length - 1], i = t.slice(0, t.length - 1), s = bc(e, i, Object);
  for (; s.obj === void 0 && i.length; )
    o = `${i[i.length - 1]}.${o}`, i = i.slice(0, i.length - 1), s = bc(e, i, Object), s && s.obj && typeof s.obj[`${s.k}.${o}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${o}`] = n;
}, XF = (e, t, n, r) => {
  const {
    obj: a,
    k: o
  } = bc(e, t, Object);
  a[o] = a[o] || [], a[o].push(n);
}, ep = (e, t) => {
  const {
    obj: n,
    k: r
  } = bc(e, t);
  if (n)
    return n[r];
}, QF = (e, t, n) => {
  const r = ep(e, n);
  return r !== void 0 ? r : ep(t, n);
}, B8 = (e, t, n) => {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? Ze(e[r]) || e[r] instanceof String || Ze(t[r]) || t[r] instanceof String ? n && (e[r] = t[r]) : B8(e[r], t[r], n) : e[r] = t[r]);
  return e;
}, ds = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var ez = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const tz = (e) => Ze(e) ? e.replace(/[&<>"'\/]/g, (t) => ez[t]) : e;
class rz {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const r = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, r), this.regExpQueue.push(t), r;
  }
}
const nz = [" ", ",", "?", "!", ";"], az = new rz(20), oz = (e, t, n) => {
  t = t || "", n = n || "";
  const r = nz.filter((i) => t.indexOf(i) < 0 && n.indexOf(i) < 0);
  if (r.length === 0)
    return !0;
  const a = az.getRegExp(`(${r.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let o = !a.test(e);
  if (!o) {
    const i = e.indexOf(n);
    i > 0 && !a.test(e.substring(0, i)) && (o = !0);
  }
  return o;
}, Z1 = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[t])
    return e[t];
  const r = t.split(n);
  let a = e;
  for (let o = 0; o < r.length; ) {
    if (!a || typeof a != "object")
      return;
    let i, s = "";
    for (let l = o; l < r.length; ++l)
      if (l !== o && (s += n), s += r[l], i = a[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < r.length - 1)
          continue;
        o += l - o + 1;
        break;
      }
    a = i;
  }
  return a;
}, tp = (e) => e && e.replace("_", "-"), iz = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class rp {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || iz, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, a) {
    return a && !this.debug ? null : (Ze(t[0]) && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new rp(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new rp(this.logger, t);
  }
}
var Ba = new rp();
class ch {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const a = this.observers[r].get(n) || 0;
      this.observers[r].set(n, a + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((i) => {
      let [s, l] = i;
      for (let c = 0; c < l; c++)
        s(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((i) => {
      let [s, l] = i;
      for (let c = 0; c < l; c++)
        s.apply(s, [t, ...r]);
    });
  }
}
class kv extends ch {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, i = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, n], r && (Array.isArray(r) ? s.push(...r) : Ze(r) && o ? s.push(...r.split(o)) : s.push(r)));
    const l = ep(this.data, s);
    return !l && !n && !r && t.indexOf(".") > -1 && (t = s[0], n = s[1], r = s.slice(2).join(".")), l || !i || !Ze(r) ? l : Z1(this.data && this.data[t] && this.data[t][n], r, o);
  }
  addResource(t, n, r, a) {
    let o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const i = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator;
    let s = [t, n];
    r && (s = s.concat(i ? r.split(i) : r)), t.indexOf(".") > -1 && (s = t.split("."), a = n, n = s[1]), this.addNamespaces(n), xv(this.data, s, a), o.silent || this.emit("added", t, n, r, a);
  }
  addResources(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const o in r)
      (Ze(r[o]) || Array.isArray(r[o])) && this.addResource(t, n, o, r[o], {
        silent: !0
      });
    a.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, a, o) {
    let i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, s = [t, n];
    t.indexOf(".") > -1 && (s = t.split("."), a = r, r = n, n = s[1]), this.addNamespaces(n);
    let l = ep(this.data, s) || {};
    i.skipCopy || (r = JSON.parse(JSON.stringify(r))), a ? B8(l, r, o) : l = {
      ...l,
      ...r
    }, xv(this.data, s, l), i.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, n)
    } : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((a) => n[a] && Object.keys(n[a]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var F8 = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, a) {
    return e.forEach((o) => {
      this.processors[o] && (t = this.processors[o].process(t, n, r, a));
    }), t;
  }
};
const Ev = {};
class np extends ch {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), qF(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Ba.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let o = n.ns || this.options.defaultNS || [];
    const i = r && t.indexOf(r) > -1, s = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !oz(t, r, a);
    if (i && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: Ze(o) ? [o] : o
        };
      const c = t.split(r);
      (r !== a || r === a && this.options.ns.indexOf(c[0]) > -1) && (o = c.shift()), t = c.join(a);
    }
    return {
      key: t,
      namespaces: Ze(o) ? [o] : o
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null)
      return "";
    Array.isArray(t) || (t = [String(t)]);
    const a = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, o = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: i,
      namespaces: s
    } = this.extractFromKey(t[t.length - 1], n), l = s[s.length - 1], c = n.lng || this.language, u = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const x = n.nsSeparator || this.options.nsSeparator;
        return a ? {
          res: `${l}${x}${i}`,
          usedKey: i,
          exactUsedKey: i,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(n)
        } : `${l}${x}${i}`;
      }
      return a ? {
        res: i,
        usedKey: i,
        exactUsedKey: i,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(n)
      } : i;
    }
    const d = this.resolve(t, n);
    let p = d && d.res;
    const h = d && d.usedKey || i, m = d && d.exactUsedKey || i, f = Object.prototype.toString.apply(p), g = ["[object Number]", "[object Function]", "[object RegExp]"], _ = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, v = !this.i18nFormat || this.i18nFormat.handleAsObject, w = !Ze(p) && typeof p != "boolean" && typeof p != "number";
    if (v && p && w && g.indexOf(f) < 0 && !(Ze(_) && Array.isArray(p))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const x = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, p, {
          ...n,
          ns: s
        }) : `key '${i} (${this.language})' returned an object instead of string.`;
        return a ? (d.res = x, d.usedParams = this.getUsedParamsDetails(n), d) : x;
      }
      if (o) {
        const x = Array.isArray(p), b = x ? [] : {}, C = x ? m : h;
        for (const E in p)
          if (Object.prototype.hasOwnProperty.call(p, E)) {
            const A = `${C}${o}${E}`;
            b[E] = this.translate(A, {
              ...n,
              joinArrays: !1,
              ns: s
            }), b[E] === A && (b[E] = p[E]);
          }
        p = b;
      }
    } else if (v && Ze(_) && Array.isArray(p))
      p = p.join(_), p && (p = this.extendTranslation(p, t, n, r));
    else {
      let x = !1, b = !1;
      const C = n.count !== void 0 && !Ze(n.count), E = np.hasDefaultValue(n), A = C ? this.pluralResolver.getSuffix(c, n.count, n) : "", O = n.ordinal && C ? this.pluralResolver.getSuffix(c, n.count, {
        ordinal: !1
      }) : "", M = C && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), I = M && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${A}`] || n[`defaultValue${O}`] || n.defaultValue;
      !this.isValidLookup(p) && E && (x = !0, p = I), this.isValidLookup(p) || (b = !0, p = i);
      const K = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && b ? void 0 : p, G = E && I !== p && this.options.updateMissing;
      if (b || x || G) {
        if (this.logger.log(G ? "updateKey" : "missingKey", c, l, i, G ? I : p), o) {
          const H = this.resolve(i, {
            ...n,
            keySeparator: !1
          });
          H && H.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let V = [];
        const ee = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && ee && ee[0])
          for (let H = 0; H < ee.length; H++)
            V.push(ee[H]);
        else
          this.options.saveMissingTo === "all" ? V = this.languageUtils.toResolveHierarchy(n.lng || this.language) : V.push(n.lng || this.language);
        const U = (H, W, L) => {
          const T = E && L !== p ? L : K;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(H, l, W, T, G, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(H, l, W, T, G, n), this.emit("missingKey", H, l, W, p);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && C ? V.forEach((H) => {
          const W = this.pluralResolver.getSuffixes(H, n);
          M && n[`defaultValue${this.options.pluralSeparator}zero`] && W.indexOf(`${this.options.pluralSeparator}zero`) < 0 && W.push(`${this.options.pluralSeparator}zero`), W.forEach((L) => {
            U([H], i + L, n[`defaultValue${L}`] || I);
          });
        }) : U(V, i, I));
      }
      p = this.extendTranslation(p, t, n, d, r), b && p === i && this.options.appendNamespaceToMissingKey && (p = `${l}:${i}`), (b || x) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? p = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${i}` : i, x ? p : void 0) : p = this.options.parseMissingKeyHandler(p));
    }
    return a ? (d.res = p, d.usedParams = this.getUsedParamsDetails(n), d) : p;
  }
  extendTranslation(t, n, r, a, o) {
    var i = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const c = Ze(t) && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const p = t.match(this.interpolator.nestingRegexp);
        u = p && p.length;
      }
      let d = r.replace && !Ze(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), t = this.interpolator.interpolate(t, d, r.lng || this.language || a.usedLng, r), c) {
        const p = t.match(this.interpolator.nestingRegexp), h = p && p.length;
        u < h && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && a && a.res && (r.lng = this.language || a.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var p = arguments.length, h = new Array(p), m = 0; m < p; m++)
          h[m] = arguments[m];
        return o && o[0] === h[0] && !r.context ? (i.logger.warn(`It seems you are nesting recursively key: ${h[0]} in key: ${n[0]}`), null) : i.translate(...h, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const s = r.postProcess || this.options.postProcess, l = Ze(s) ? [s] : s;
    return t != null && l && l.length && r.applyPostProcessor !== !1 && (t = F8.handle(l, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, a, o, i, s;
    return Ze(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(r))
        return;
      const c = this.extractFromKey(l, n), u = c.key;
      a = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const p = n.count !== void 0 && !Ze(n.count), h = p && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), m = n.context !== void 0 && (Ze(n.context) || typeof n.context == "number") && n.context !== "", f = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((g) => {
        this.isValidLookup(r) || (s = g, !Ev[`${f[0]}-${g}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(s) && (Ev[`${f[0]}-${g}`] = !0, this.logger.warn(`key "${a}" for languages "${f.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), f.forEach((_) => {
          if (this.isValidLookup(r))
            return;
          i = _;
          const v = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, u, _, g, n);
          else {
            let x;
            p && (x = this.pluralResolver.getSuffix(_, n.count, n));
            const b = `${this.options.pluralSeparator}zero`, C = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (p && (v.push(u + x), n.ordinal && x.indexOf(C) === 0 && v.push(u + x.replace(C, this.options.pluralSeparator)), h && v.push(u + b)), m) {
              const E = `${u}${this.options.contextSeparator}${n.context}`;
              v.push(E), p && (v.push(E + x), n.ordinal && x.indexOf(C) === 0 && v.push(E + x.replace(C, this.options.pluralSeparator)), h && v.push(E + b));
            }
          }
          let w;
          for (; w = v.pop(); )
            this.isValidLookup(r) || (o = w, r = this.getResource(_, g, w, n));
        }));
      });
    }), {
      res: r,
      usedKey: a,
      exactUsedKey: o,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, a) : this.resourceStore.getResource(t, n, r, a);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = t.replace && !Ze(t.replace);
    let a = r ? t.replace : t;
    if (r && typeof t.count < "u" && (a.count = t.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !r) {
      a = {
        ...a
      };
      for (const o of n)
        delete a[o];
    }
    return a;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
const gm = (e) => e.charAt(0).toUpperCase() + e.slice(1);
class Pv {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Ba.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = tp(t), !t || t.indexOf("-") < 0)
      return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = tp(t), !t || t.indexOf("-") < 0)
      return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (Ze(t) && t.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let a = Intl.getCanonicalLocales(t)[0];
          if (a && this.options.lowerCaseLng && (a = a.toLowerCase()), a)
            return a;
        } catch {
        }
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((a) => a.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = gm(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = gm(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = gm(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t)
      return null;
    let n;
    return t.forEach((r) => {
      if (n)
        return;
      const a = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (n = a);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n)
        return;
      const a = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(a))
        return n = a;
      n = this.options.supportedLngs.find((o) => {
        if (o === a)
          return o;
        if (!(o.indexOf("-") < 0 && a.indexOf("-") < 0) && (o.indexOf("-") > 0 && a.indexOf("-") < 0 && o.substring(0, o.indexOf("-")) === a || o.indexOf(a) === 0 && a.length > 1))
          return o;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t)
      return [];
    if (typeof t == "function" && (t = t(n)), Ze(t) && (t = [t]), Array.isArray(t))
      return t;
    if (!n)
      return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), a = [], o = (i) => {
      i && (this.isSupportedCode(i) ? a.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return Ze(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && o(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && o(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && o(this.getLanguagePartFromCode(t))) : Ze(t) && o(this.formatLanguageCode(t)), r.forEach((i) => {
      a.indexOf(i) < 0 && o(this.formatLanguageCode(i));
    }), a;
  }
}
let sz = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], lz = {
  1: (e) => +(e > 1),
  2: (e) => +(e != 1),
  3: (e) => 0,
  4: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  5: (e) => e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
  6: (e) => e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
  7: (e) => e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  8: (e) => e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
  9: (e) => +(e >= 2),
  10: (e) => e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
  11: (e) => e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
  12: (e) => +(e % 10 != 1 || e % 100 == 11),
  13: (e) => +(e !== 0),
  14: (e) => e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
  15: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  16: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
  17: (e) => e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
  18: (e) => e == 0 ? 0 : e == 1 ? 1 : 2,
  19: (e) => e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
  20: (e) => e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
  21: (e) => e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
  22: (e) => e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const cz = ["v1", "v2", "v3"], uz = ["v4"], Tv = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, dz = () => {
  const e = {};
  return sz.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: lz[t.fc]
      };
    });
  }), e;
};
class pz {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = Ba.create("pluralResolver"), (!this.options.compatibilityJSON || uz.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = dz(), this.pluralRulesCache = {};
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const r = tp(t === "dev" ? "en" : t), a = n.ordinal ? "ordinal" : "cardinal", o = JSON.stringify({
        cleanedCode: r,
        type: a
      });
      if (o in this.pluralRulesCache)
        return this.pluralRulesCache[o];
      let i;
      try {
        i = new Intl.PluralRules(r, {
          type: a
        });
      } catch {
        if (!t.match(/-|_/))
          return;
        const l = this.languageUtils.getLanguagePartFromCode(t);
        i = this.getRule(l, n);
      }
      return this.pluralRulesCache[o] = i, i;
    }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((a) => `${n}${a}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((a, o) => Tv[a] - Tv[o]).map((a) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : r.numbers.map((a) => this.getSuffix(t, a, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const a = this.getRule(t, r);
    return a ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(n)}` : this.getSuffixRetroCompatible(a, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let a = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (a === 2 ? a = "plural" : a === 1 && (a = ""));
    const o = () => this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
    return this.options.compatibilityJSON === "v1" ? a === 1 ? "" : typeof a == "number" ? `_plural_${a.toString()}` : o() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? o() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !cz.includes(this.options.compatibilityJSON);
  }
}
const Mv = function(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, o = QF(e, t, n);
  return !o && a && Ze(n) && (o = Z1(e, n, r), o === void 0 && (o = Z1(t, n, r))), o;
}, ym = (e) => e.replace(/\$/g, "$$$$");
class hz {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ba.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: r,
      useRawValueToEscape: a,
      prefix: o,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: p,
      nestingPrefixEscaped: h,
      nestingSuffix: m,
      nestingSuffixEscaped: f,
      nestingOptionsSeparator: g,
      maxReplaces: _,
      alwaysFormat: v
    } = t.interpolation;
    this.escape = n !== void 0 ? n : tz, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = o ? ds(o) : i || "{{", this.suffix = s ? ds(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = p ? ds(p) : h || ds("$t("), this.nestingSuffix = m ? ds(m) : f || ds(")"), this.nestingOptionsSeparator = g || ",", this.maxReplaces = _ || 1e3, this.alwaysFormat = v !== void 0 ? v : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, r) => n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, r, a) {
    let o, i, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (h) => {
      if (h.indexOf(this.formatSeparator) < 0) {
        const _ = Mv(n, l, h, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(_, void 0, r, {
          ...a,
          ...n,
          interpolationkey: h
        }) : _;
      }
      const m = h.split(this.formatSeparator), f = m.shift().trim(), g = m.join(this.formatSeparator).trim();
      return this.format(Mv(n, l, f, this.options.keySeparator, this.options.ignoreJSONStructure), g, r, {
        ...a,
        ...n,
        interpolationkey: f
      });
    };
    this.resetRegExp();
    const u = a && a.missingInterpolationHandler || this.options.missingInterpolationHandler, d = a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (h) => ym(h)
    }, {
      regex: this.regexp,
      safeValue: (h) => this.escapeValue ? ym(this.escape(h)) : ym(h)
    }].forEach((h) => {
      for (s = 0; o = h.regex.exec(t); ) {
        const m = o[1].trim();
        if (i = c(m), i === void 0)
          if (typeof u == "function") {
            const g = u(t, o, a);
            i = Ze(g) ? g : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, m))
            i = "";
          else if (d) {
            i = o[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${m} for interpolating ${t}`), i = "";
        else
          !Ze(i) && !this.useRawValueToEscape && (i = wv(i));
        const f = h.safeValue(i);
        if (t = t.replace(o[0], f), d ? (h.regex.lastIndex += i.length, h.regex.lastIndex -= o[0].length) : h.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, o, i;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0)
        return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let p = `{${d[1]}`;
      l = d[0], p = this.interpolate(p, i);
      const h = p.match(/'/g), m = p.match(/"/g);
      (h && h.length % 2 === 0 && !m || m.length % 2 !== 0) && (p = p.replace(/'/g, '"'));
      try {
        i = JSON.parse(p), c && (i = {
          ...c,
          ...i
        });
      } catch (f) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, f), `${l}${u}${p}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; a = this.nestingRegexp.exec(t); ) {
      let l = [];
      i = {
        ...r
      }, i = i.replace && !Ze(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      let c = !1;
      if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
        const u = a[1].split(this.formatSeparator).map((d) => d.trim());
        a[1] = u.shift(), l = u, c = !0;
      }
      if (o = n(s.call(this, a[1].trim(), i), i), o && a[0] === t && !Ze(o))
        return o;
      Ze(o) || (o = wv(o)), o || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${t}`), o = ""), c && (o = l.reduce((u, d) => this.format(u, d, r.lng, {
        ...r,
        interpolationkey: a[1].trim()
      }), o.trim())), t = t.replace(a[0], o), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const mz = (e) => {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const a = r[1].substring(0, r[1].length - 1);
    t === "currency" && a.indexOf(":") < 0 ? n.currency || (n.currency = a.trim()) : t === "relativetime" && a.indexOf(":") < 0 ? n.range || (n.range = a.trim()) : a.split(";").forEach((i) => {
      if (i) {
        const [s, ...l] = i.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = s.trim();
        n[u] || (n[u] = c), c === "false" && (n[u] = !1), c === "true" && (n[u] = !0), isNaN(c) || (n[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}, ps = (e) => {
  const t = {};
  return (n, r, a) => {
    let o = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (o = {
      ...o,
      [a.interpolationkey]: void 0
    });
    const i = r + JSON.stringify(o);
    let s = t[i];
    return s || (s = e(tp(r), a), t[i] = s), s(n);
  };
};
class fz {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ba.create("formatter"), this.options = t, this.formats = {
      number: ps((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r
        });
        return (o) => a.format(o);
      }),
      currency: ps((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (o) => a.format(o);
      }),
      datetime: ps((n, r) => {
        const a = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (o) => a.format(o);
      }),
      relativetime: ps((n, r) => {
        const a = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (o) => a.format(o, r.range || "day");
      }),
      list: ps((n, r) => {
        const a = new Intl.ListFormat(n, {
          ...r
        });
        return (o) => a.format(o);
      })
    }, this.init(t);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = n.interpolation.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = ps(n);
  }
  format(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = n.split(this.formatSeparator);
    if (o.length > 1 && o[0].indexOf("(") > 1 && o[0].indexOf(")") < 0 && o.find((s) => s.indexOf(")") > -1)) {
      const s = o.findIndex((l) => l.indexOf(")") > -1);
      o[0] = [o[0], ...o.splice(1, s)].join(this.formatSeparator);
    }
    return o.reduce((s, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = mz(l);
      if (this.formats[c]) {
        let d = s;
        try {
          const p = a && a.formatParams && a.formatParams[a.interpolationkey] || {}, h = p.locale || p.lng || a.locale || a.lng || r;
          d = this.formats[c](s, h, {
            ...u,
            ...a,
            ...p
          });
        } catch (p) {
          this.logger.warn(p);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return s;
    }, t);
  }
}
const gz = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class yz extends ch {
  constructor(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = a, this.logger = Ba.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, a.backend, a);
  }
  queueLoad(t, n, r, a) {
    const o = {}, i = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      n.forEach((d) => {
        const p = `${c}|${d}`;
        !r.reload && this.store.hasResourceBundle(c, d) ? this.state[p] = 2 : this.state[p] < 0 || (this.state[p] === 1 ? i[p] === void 0 && (i[p] = !0) : (this.state[p] = 1, u = !1, i[p] === void 0 && (i[p] = !0), o[p] === void 0 && (o[p] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(o).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(o),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, n, r) {
    const a = t.split("|"), o = a[0], i = a[1];
    n && this.emit("failedLoading", o, i, n), !n && r && this.store.addResourceBundle(o, i, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2, n && r && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      XF(l.loaded, [o], i), gz(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, i = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length)
      return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: a,
        wait: o,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, a + 1, o * 2, i);
        }, o);
        return;
      }
      i(c, u);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, n);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, n, s);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    Ze(t) && (t = this.languageUtils.toResolveHierarchy(t)), Ze(n) && (n = [n]);
    const o = this.queueLoad(t, n, r, a);
    if (!o.toLoad.length)
      return o.pending.length || a(), null;
    o.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), a = r[0], o = r[1];
    this.read(a, o, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${n}loading namespace ${o} for language ${a} failed`, i), !i && s && this.logger.log(`${n}loaded namespace ${o} for language ${a}`, s), this.loaded(t, i, s);
    });
  }
  saveMissing(t, n, r, a, o) {
    let i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...i,
          isUpdate: o
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, n, r, a, l) : u = c(t, n, r, a), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, n, r, a, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, a);
    }
  }
}
const Ov = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), Ze(e[1]) && (t.defaultValue = e[1]), Ze(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const n = e[3] || e[2];
      Object.keys(n).forEach((r) => {
        t[r] = n[r];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Av = (e) => (Ze(e.ns) && (e.ns = [e.ns]), Ze(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), Ze(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e), Bu = () => {
}, vz = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((n) => {
    typeof e[n] == "function" && (e[n] = e[n].bind(e));
  });
};
class jc extends ch {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Av(t), this.services = {}, this.logger = Ba, this.modules = {
      external: []
    }, vz(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (Ze(n.ns) ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const a = Ov();
    this.options = {
      ...a,
      ...this.options,
      ...Av(n)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    const o = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? Ba.init(o(this.modules.logger), this.options) : Ba.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = fz);
      const d = new Pv(this.options);
      this.store = new kv(this.options.resources, this.options);
      const p = this.services;
      p.logger = Ba, p.resourceStore = this.store, p.languageUtils = d, p.pluralResolver = new pz(d, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (p.formatter = o(u), p.formatter.init(p, this.options), this.options.interpolation.format = p.formatter.format.bind(p.formatter)), p.interpolator = new hz(this.options), p.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, p.backendConnector = new yz(o(this.modules.backend), p.resourceStore, p, this.options), p.backendConnector.on("*", function(h) {
        for (var m = arguments.length, f = new Array(m > 1 ? m - 1 : 0), g = 1; g < m; g++)
          f[g - 1] = arguments[g];
        t.emit(h, ...f);
      }), this.modules.languageDetector && (p.languageDetector = o(this.modules.languageDetector), p.languageDetector.init && p.languageDetector.init(p, this.options.detection, this.options)), this.modules.i18nFormat && (p.i18nFormat = o(this.modules.i18nFormat), p.i18nFormat.init && p.i18nFormat.init(this)), this.translator = new np(this.services, this.options), this.translator.on("*", function(h) {
        for (var m = arguments.length, f = new Array(m > 1 ? m - 1 : 0), g = 1; g < m; g++)
          f[g - 1] = arguments[g];
        t.emit(h, ...f);
      }), this.modules.external.forEach((h) => {
        h.init && h.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = Bu), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return t.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return t.store[u](...arguments), t;
      };
    });
    const l = Rl(), c = () => {
      const u = (d, p) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(p), r(d, p);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Bu;
    const a = Ze(t) ? t : this.language;
    if (typeof t == "function" && (r = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (a && a.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return r();
      const o = [], i = (s) => {
        if (!s || s === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(s).forEach((c) => {
          c !== "cimode" && o.indexOf(c) < 0 && o.push(c);
        });
      };
      a ? i(a) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => i(l)), this.options.preload && this.options.preload.forEach((s) => i(s)), this.services.backendConnector.load(o, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(s);
      });
    } else
      r(null);
  }
  reloadResources(t, n, r) {
    const a = Rl();
    return typeof t == "function" && (r = t, t = void 0), typeof n == "function" && (r = n, n = void 0), t || (t = this.languages), n || (n = this.options.ns), r || (r = Bu), this.services.backendConnector.reload(t, n, (o) => {
      a.resolve(), r(o);
    }), a;
  }
  use(t) {
    if (!t)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && F8.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const a = Rl();
    this.emit("languageChanging", t);
    const o = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, i = (l, c) => {
      c ? (o(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, a.resolve(function() {
        return r.t(...arguments);
      }), n && n(l, function() {
        return r.t(...arguments);
      });
    }, s = (l) => {
      !t && !l && this.services.languageDetector && (l = []);
      const c = Ze(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || o(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        i(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(t), a;
  }
  getFixedT(t, n, r) {
    var a = this;
    const o = function(i, s) {
      let l;
      if (typeof s != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          u[d - 2] = arguments[d];
        l = a.options.overloadTranslationOptionHandler([i, s].concat(u));
      } else
        l = {
          ...s
        };
      l.lng = l.lng || o.lng, l.lngs = l.lngs || o.lngs, l.ns = l.ns || o.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || r || o.keyPrefix);
      const p = a.options.keySeparator || ".";
      let h;
      return l.keyPrefix && Array.isArray(i) ? h = i.map((m) => `${l.keyPrefix}${p}${m}`) : h = l.keyPrefix ? `${l.keyPrefix}${p}${i}` : i, a.t(h, l);
    };
    return Ze(t) ? o.lng = t : o.lngs = t, o.ns = n, o.keyPrefix = r, o;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, o = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const i = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, i);
      if (s !== void 0)
        return s;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(r, t) && (!a || i(o, t)));
  }
  loadNamespaces(t, n) {
    const r = Rl();
    return this.options.ns ? (Ze(t) && (t = [t]), t.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      r.resolve(), n && n(a);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = Rl();
    Ze(t) && (t = [t]);
    const a = this.options.preload || [], o = t.filter((i) => a.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return o.length ? (this.options.preload = a.concat(o), this.loadResources((i) => {
      r.resolve(), n && n(i);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t)
      return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new Pv(Ov());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new jc(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Bu;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const a = {
      ...this.options,
      ...t,
      isClone: !0
    }, o = new jc(a);
    return (t.debug !== void 0 || t.prefix !== void 0) && (o.logger = o.logger.clone(t)), ["store", "services", "language"].forEach((s) => {
      o[s] = this[s];
    }), o.services = {
      ...this.services
    }, o.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, r && (o.store = new kv(this.store.data, a), o.services.resourceStore = o.store), o.translator = new np(o.services, a), o.translator.on("*", function(s) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      o.emit(s, ...c);
    }), o.init(a, n), o.translator.options = a, o.translator.backendConnector.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, o;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const xr = jc.createInstance();
xr.createInstance = jc.createInstance;
xr.createInstance;
xr.dir;
xr.init;
xr.loadResources;
xr.reloadResources;
xr.use;
xr.changeLanguage;
xr.getFixedT;
xr.t;
xr.exists;
xr.setDefaultNamespace;
xr.hasLoadedNamespace;
xr.loadNamespaces;
xr.loadLanguages;
function bz(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) !== -1)
        continue;
      n[r] = e[r];
    }
  return n;
}
function Pg(e, t) {
  if (e == null)
    return {};
  var n, r, a = bz(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (r = 0; r < o.length; r++)
      n = o[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (a[n] = e[n]);
  }
  return a;
}
function Gn(e) {
  "@babel/helpers - typeof";
  return Gn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gn(e);
}
function _z(e, t) {
  if (Gn(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Gn(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function z8(e) {
  var t = _z(e, "string");
  return Gn(t) == "symbol" ? t : t + "";
}
function Ve(e, t, n) {
  return (t = z8(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var wz = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
};
const Sz = /* @__PURE__ */ qc(wz);
var Cz = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function Nv(e) {
  var t = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, n = e.match(/<\/?([^\s]+?)[/\s>]/);
  if (n && (t.name = n[1], (Sz[n[1]] || e.charAt(e.length - 2) === "/") && (t.voidElement = !0), t.name.startsWith("!--"))) {
    var r = e.indexOf("-->");
    return { type: "comment", comment: r !== -1 ? e.slice(4, r) : "" };
  }
  for (var a = new RegExp(Cz), o = null; (o = a.exec(e)) !== null; )
    if (o[0].trim())
      if (o[1]) {
        var i = o[1].trim(), s = [i, ""];
        i.indexOf("=") > -1 && (s = i.split("=")), t.attrs[s[0]] = s[1], a.lastIndex--;
      } else
        o[2] && (t.attrs[o[2]] = o[3].trim().substring(1, o[3].length - 1));
  return t;
}
var xz = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, kz = /^\s*$/, Ez = /* @__PURE__ */ Object.create(null);
function G8(e, t) {
  switch (t.type) {
    case "text":
      return e + t.content;
    case "tag":
      return e += "<" + t.name + (t.attrs ? function(n) {
        var r = [];
        for (var a in n)
          r.push(a + '="' + n[a] + '"');
        return r.length ? " " + r.join(" ") : "";
      }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce(G8, "") + "</" + t.name + ">";
    case "comment":
      return e + "<!--" + t.comment + "-->";
  }
}
var Pz = { parse: function(e, t) {
  t || (t = {}), t.components || (t.components = Ez);
  var n, r = [], a = [], o = -1, i = !1;
  if (e.indexOf("<") !== 0) {
    var s = e.indexOf("<");
    r.push({ type: "text", content: s === -1 ? e : e.substring(0, s) });
  }
  return e.replace(xz, function(l, c) {
    if (i) {
      if (l !== "</" + n.name + ">")
        return;
      i = !1;
    }
    var u, d = l.charAt(1) !== "/", p = l.startsWith("<!--"), h = c + l.length, m = e.charAt(h);
    if (p) {
      var f = Nv(l);
      return o < 0 ? (r.push(f), r) : ((u = a[o]).children.push(f), r);
    }
    if (d && (o++, (n = Nv(l)).type === "tag" && t.components[n.name] && (n.type = "component", i = !0), n.voidElement || i || !m || m === "<" || n.children.push({ type: "text", content: e.slice(h, e.indexOf("<", h)) }), o === 0 && r.push(n), (u = a[o - 1]) && u.children.push(n), a[o] = n), (!d || n.voidElement) && (o > -1 && (n.voidElement || n.name === l.slice(2, -1)) && (o--, n = o === -1 ? r : a[o]), !i && m !== "<" && m)) {
      u = o === -1 ? r : a[o].children;
      var g = e.indexOf("<", h), _ = e.slice(h, g === -1 ? void 0 : g);
      kz.test(_) && (_ = " "), (g > -1 && o + u.length >= 0 || _ !== " ") && u.push({ type: "text", content: _ });
    }
  }), r;
}, stringify: function(e) {
  return e.reduce(function(t, n) {
    return t + G8("", n);
  }, "");
} };
function as(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Tz(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, z8(r.key), r);
  }
}
function os(e, t, n) {
  return t && Tz(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var Mz = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Oz = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Az = function(t) {
  return Oz[t];
}, Nz = function(t) {
  return t.replace(Mz, Az);
};
function Lv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Rv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Lv(Object(n), !0).forEach(function(r) {
      Ve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Lv(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var q1 = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Nz
}, H8, Tg = Qe();
function Lz() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  q1 = Rv(Rv({}, q1), e);
}
function K8() {
  return q1;
}
var Rz = function() {
  function e() {
    as(this, e), this.usedNamespaces = {};
  }
  return os(e, [{
    key: "addUsedNamespaces",
    value: function(n) {
      var r = this;
      n.forEach(function(a) {
        r.usedNamespaces[a] || (r.usedNamespaces[a] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
}();
function Dz(e) {
  H8 = e;
}
function U8() {
  return H8;
}
var Iz = {
  type: "3rdParty",
  init: function(t) {
    Lz(t.options.react), Dz(t);
  }
};
function hd() {
  if (console && console.warn) {
    for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    typeof n[0] == "string" && (n[0] = "react-i18next:: ".concat(n[0])), (e = console).warn.apply(e, n);
  }
}
var Dv = {};
function ap() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  typeof t[0] == "string" && Dv[t[0]] || (typeof t[0] == "string" && (Dv[t[0]] = /* @__PURE__ */ new Date()), hd.apply(void 0, t));
}
function Iv(e, t, n) {
  e.loadNamespaces(t, function() {
    if (e.isInitialized)
      n();
    else {
      var r = function a() {
        setTimeout(function() {
          e.off("initialized", a);
        }, 0), n();
      };
      e.on("initialized", r);
    }
  });
}
function jz(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = t.languages[0], a = t.options ? t.options.fallbackLng : !1, o = t.languages[t.languages.length - 1];
  if (r.toLowerCase() === "cimode")
    return !0;
  var i = function(l, c) {
    var u = t.services.backendConnector.state["".concat(l, "|").concat(c)];
    return u === -1 || u === 2;
  };
  return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !i(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(r, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || i(r, e) && (!a || i(o, e)));
}
function Bz(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!t.languages || !t.languages.length)
    return ap("i18n.languages were undefined or empty", t.languages), !0;
  var r = t.options.ignoreJSONStructure !== void 0;
  return r ? t.hasLoadedNamespace(e, {
    precheck: function(o, i) {
      if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !i(o.isLanguageChangingTo, e))
        return !1;
    }
  }) : jz(e, t, n);
}
var Fz = ["format"], zz = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];
function jv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Or(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jv(Object(n), !0).forEach(function(r) {
      Ve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jv(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function vm(e, t) {
  if (!e)
    return !1;
  var n = e.props ? e.props.children : e.children;
  return t ? n.length > 0 : !!n;
}
function bm(e) {
  return e ? e.props ? e.props.children : e.children : [];
}
function Gz(e) {
  return Object.prototype.toString.call(e) !== "[object Array]" ? !1 : e.every(function(t) {
    return Sc(t);
  });
}
function uc(e) {
  return Array.isArray(e) ? e : [e];
}
function Hz(e, t) {
  var n = Or({}, t);
  return n.props = Object.assign(e.props, t.props), n;
}
function $8(e, t) {
  if (!e)
    return "";
  var n = "", r = uc(e), a = t.transSupportBasicHtmlNodes && t.transKeepBasicHtmlNodesFor ? t.transKeepBasicHtmlNodesFor : [];
  return r.forEach(function(o, i) {
    if (typeof o == "string")
      n += "".concat(o);
    else if (Sc(o)) {
      var s = Object.keys(o.props).length, l = a.indexOf(o.type) > -1, c = o.props.children;
      if (!c && l && s === 0)
        n += "<".concat(o.type, "/>");
      else if (!c && (!l || s !== 0))
        n += "<".concat(i, "></").concat(i, ">");
      else if (o.props.i18nIsDynamicList)
        n += "<".concat(i, "></").concat(i, ">");
      else if (l && s === 1 && typeof c == "string")
        n += "<".concat(o.type, ">").concat(c, "</").concat(o.type, ">");
      else {
        var u = $8(c, t);
        n += "<".concat(i, ">").concat(u, "</").concat(i, ">");
      }
    } else if (o === null)
      hd("Trans: the passed in value is invalid - seems you passed in a null child.");
    else if (Gn(o) === "object") {
      var d = o.format, p = Pg(o, Fz), h = Object.keys(p);
      if (h.length === 1) {
        var m = d ? "".concat(h[0], ", ").concat(d) : h[0];
        n += "{{".concat(m, "}}");
      } else
        hd("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", o);
    } else
      hd("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", o);
  }), n;
}
function Kz(e, t, n, r, a, o) {
  if (t === "")
    return [];
  var i = r.transKeepBasicHtmlNodesFor || [], s = t && new RegExp(i.join("|")).test(t);
  if (!e && !s)
    return [t];
  var l = {};
  function c(g) {
    var _ = uc(g);
    _.forEach(function(v) {
      typeof v != "string" && (vm(v) ? c(bm(v)) : Gn(v) === "object" && !Sc(v) && Object.assign(l, v));
    });
  }
  c(e);
  var u = Pz.parse("<0>".concat(t, "</0>")), d = Or(Or({}, l), a);
  function p(g, _, v) {
    var w = bm(g), x = m(w, _.children, v);
    return Gz(w) && x.length === 0 ? w : x;
  }
  function h(g, _, v, w, x) {
    g.dummy && (g.children = _), v.push(lc(g, Or(Or({}, g.props), {}, {
      key: w
    }), x ? void 0 : _));
  }
  function m(g, _, v) {
    var w = uc(g), x = uc(_);
    return x.reduce(function(b, C, E) {
      var A = C.children && C.children[0] && C.children[0].content && n.services.interpolator.interpolate(C.children[0].content, d, n.language);
      if (C.type === "tag") {
        var O = w[parseInt(C.name, 10)];
        !O && v.length === 1 && v[0][C.name] && (O = v[0][C.name]), O || (O = {});
        var M = Object.keys(C.attrs).length !== 0 ? Hz({
          props: C.attrs
        }, O) : O, I = Sc(M), D = I && vm(C, !0) && !C.voidElement, K = s && Gn(M) === "object" && M.dummy && !I, G = Gn(e) === "object" && e !== null && Object.hasOwnProperty.call(e, C.name);
        if (typeof M == "string") {
          var V = n.services.interpolator.interpolate(M, d, n.language);
          b.push(V);
        } else if (vm(M) || D) {
          var ee = p(M, C, v);
          h(M, ee, b, E);
        } else if (K) {
          var U = m(w, C.children, v);
          b.push(lc(M, Or(Or({}, M.props), {}, {
            key: E
          }), U));
        } else if (Number.isNaN(parseFloat(C.name)))
          if (G) {
            var H = p(M, C, v);
            h(M, H, b, E, C.voidElement);
          } else if (r.transSupportBasicHtmlNodes && i.indexOf(C.name) > -1)
            if (C.voidElement)
              b.push(Ho(C.name, {
                key: "".concat(C.name, "-").concat(E)
              }));
            else {
              var W = m(w, C.children, v);
              b.push(Ho(C.name, {
                key: "".concat(C.name, "-").concat(E)
              }, W));
            }
          else if (C.voidElement)
            b.push("<".concat(C.name, " />"));
          else {
            var L = m(w, C.children, v);
            b.push("<".concat(C.name, ">").concat(L, "</").concat(C.name, ">"));
          }
        else if (Gn(M) === "object" && !I) {
          var T = C.children[0] ? A : null;
          T && b.push(T);
        } else
          C.children.length === 1 && A ? b.push(lc(M, Or(Or({}, M.props), {}, {
            key: E
          }), A)) : b.push(lc(M, Or(Or({}, M.props), {}, {
            key: E
          })));
      } else if (C.type === "text") {
        var B = r.transWrapTextNodes, N = o ? r.unescape(n.services.interpolator.interpolate(C.content, d, n.language)) : n.services.interpolator.interpolate(C.content, d, n.language);
        B ? b.push(Ho(B, {
          key: "".concat(C.name, "-").concat(E)
        }, N)) : b.push(N);
      }
      return b;
    }, []);
  }
  var f = m([{
    dummy: !0,
    children: e || []
  }], u, uc(e || []));
  return bm(f[0]);
}
function V8(e) {
  var t = e.children, n = e.count, r = e.parent, a = e.i18nKey, o = e.context, i = e.tOptions, s = i === void 0 ? {} : i, l = e.values, c = e.defaults, u = e.components, d = e.ns, p = e.i18n, h = e.t, m = e.shouldUnescape, f = Pg(e, zz), g = Ue(Tg) || {}, _ = g.i18n, v = g.defaultNS, w = p || _ || U8();
  if (!w)
    return ap("You will need to pass in an i18next instance by using i18nextReactModule"), t;
  var x = h || w.t.bind(w) || function(V) {
    return V;
  };
  o && (s.context = o);
  var b = Or(Or({}, K8()), w.options && w.options.react), C = d || x.ns || v || w.options && w.options.defaultNS;
  C = typeof C == "string" ? [C] : C || ["translation"];
  var E = c || $8(t, b) || b.transEmptyNodeValue || a, A = b.hashTransKey, O = a || (A ? A(E) : E), M = l ? s.interpolation : {
    interpolation: Or(Or({}, s.interpolation), {}, {
      prefix: "#$?",
      suffix: "?$#"
    })
  }, I = Or(Or(Or(Or({}, s), {}, {
    count: n
  }, l), M), {}, {
    defaultValue: E,
    ns: C
  }), D = O ? x(O, I) : E, K = Kz(u || t, D, w, b, I, m), G = r !== void 0 ? r : b.defaultTransParent;
  return G ? Ho(G, f, K) : K;
}
function Uz(e) {
  if (Array.isArray(e))
    return e;
}
function $z(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, a, o, i, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0)
        for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && n.return != null && (i = n.return(), Object(i) !== i))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function Bv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Vz(e, t) {
  if (e) {
    if (typeof e == "string")
      return Bv(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Bv(e, t) : void 0;
  }
}
function Wz() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yz(e, t) {
  return Uz(e) || $z(e, t) || Vz(e, t) || Wz();
}
function Fv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _m(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fv(Object(n), !0).forEach(function(r) {
      Ve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Fv(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Zz = function(t, n) {
  var r = _e();
  return De(function() {
    r.current = t;
  }, [t, n]), r.current;
};
function Gr(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.i18n, r = Ue(Tg) || {}, a = r.i18n, o = r.defaultNS, i = n || a || U8();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new Rz()), !i) {
    ap("You will need to pass in an i18next instance by using initReactI18next");
    var s = function(O) {
      return Array.isArray(O) ? O[O.length - 1] : O;
    }, l = [s, {}, !1];
    return l.t = s, l.i18n = {}, l.ready = !1, l;
  }
  i.options.react && i.options.react.wait !== void 0 && ap("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var c = _m(_m(_m({}, K8()), i.options.react), t), u = c.useSuspense, d = c.keyPrefix, p = o || i.options && i.options.defaultNS;
  p = typeof p == "string" ? [p] : p || ["translation"], i.reportNamespaces.addUsedNamespaces && i.reportNamespaces.addUsedNamespaces(p);
  var h = (i.isInitialized || i.initializedStoreOnce) && p.every(function(A) {
    return Bz(A, i, c);
  });
  function m() {
    return i.getFixedT(null, c.nsMode === "fallback" ? p : p[0], d);
  }
  var f = ke(m), g = Yz(f, 2), _ = g[0], v = g[1], w = p.join(), x = Zz(w), b = _e(!0);
  De(function() {
    var A = c.bindI18n, O = c.bindI18nStore;
    b.current = !0, !h && !u && Iv(i, p, function() {
      b.current && v(m);
    }), h && x && x !== w && b.current && v(m);
    function M() {
      b.current && v(m);
    }
    return A && i && i.on(A, M), O && i && i.store.on(O, M), function() {
      b.current = !1, A && i && A.split(" ").forEach(function(I) {
        return i.off(I, M);
      }), O && i && O.split(" ").forEach(function(I) {
        return i.store.off(I, M);
      });
    };
  }, [i, w]);
  var C = _e(!0);
  De(function() {
    b.current && !C.current && v(m), C.current = !1;
  }, [i, d]);
  var E = [_, i, h];
  if (E.t = _, E.i18n = i, E.ready = h, h || !h && !u)
    return E;
  throw new Promise(function(A) {
    Iv(i, p, function() {
      A();
    });
  });
}
function qz(e) {
  var t = e.i18n, n = e.defaultNS, r = e.children, a = we(function() {
    return {
      i18n: t,
      defaultNS: n
    };
  }, [t, n]);
  return Ho(Tg.Provider, {
    value: a
  }, r);
}
const Jz = {
  "required-field": "الحقل مطلوب",
  payment: {
    price_plan: "عرض",
    stripe_card: "بطاقات الائتمان (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "بطاقات الائتمان (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "بطاقات الائتمان (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "الدفع عند الاستلام",
    xendit_card: "بطاقات الائتمان (Xendit)",
    paystack_card: "بطاقات الإئتمان (Paystack)",
    paypal_connect: "ربط paypal",
    paypal_edit_organization_name: "تعديل اسم المنظمة",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "خطأ",
  "Payment-method": "طريقة دفع",
  price_plan: {
    trial_period: {
      week_0: "{{count}} أسبوع",
      week_1: "أسبوع {{count}}",
      week_2: "أسبوعين {{count}}",
      week_3: "{{count}} أسابيع",
      week_4: "{{count}} أسبوع",
      week_5: "{{count}} أسبوع",
      day_0: "{{count}} يوم",
      day_1: "يوم {{count}}",
      day_2: "يومين {{count}}",
      day_3: "{{count}} أيام",
      day_4: "{{count}} يوم",
      day_5: "{{count}} يوم",
      month_0: "{{count}} شهر",
      month_1: "شهر{{count}}",
      month_2: "شهربن {{count}}",
      month_3: "{{count}} أشهر",
      month_4: "{{count}} شهر",
      month_5: "{{count}} شهر",
      year_0: "{{count}} سنة",
      year_1: "سنة {{count}}",
      year_2: "سنتان {{count}}",
      year_3: "{{count}} سنوات",
      year_4: "{{count}} سنة",
      year_5: "{{count}} سنة"
    },
    interval: {
      month_0: "{{count}} شهر",
      month_1: "شهر {{count}}",
      month_2: "شهرين {{count}}",
      month_3: "{{count}} أشهر",
      month_4: "{{count}} شهر",
      month_5: "{{count}} شهر",
      day_0: "{{count}} يوم",
      day_1: "يوم {{count}}",
      day_2: "يومين {{count}}",
      day_3: "{{count}} أيام",
      day_4: "{{count}} يوم",
      day_5: "{{count}} يوم",
      week_0: "{{count}} أسبوع",
      week_1: "أسبوع {{count}}",
      week_2: "أسبوعين {{count}}",
      week_3: "{{count}} أسابيع",
      week_4: "{{count}} أسبوع",
      week_5: "{{count}} أسبوع",
      year_0: "{{count}} سنة",
      year_1: "سنة {{count}}",
      year_2: "سنتان{{count}}",
      year_3: "{{count}} سنوات",
      year_4: "{{count}} سنة",
      year_5: "{{count}} سنة"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "مجانا",
        trial_period_new: "{{ trialPeriodPrice }} لمدة {{ trialInterval }} ثم",
        unlimited_new: "<bold>{{amount}}</bold> لكل {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} مرات"
      }
    }
  },
  affiliate_badge: {
    made_with: "يعمل بواسطة"
  },
  form_select: {
    empty_list: "يبدو أن هذه القائمة فارغة",
    select: "حدد"
  },
  contact_slug: {
    email: "البريد الإلكتروني",
    first_name: "الاسم",
    last_name: "اسم العائلة",
    phone_number: "رقم الهاتف",
    country: "البلد",
    street_address: "عنوان الشارع",
    city: "المدينة",
    postal_code: "الرمز البريدي",
    company_name: "اسم الشركة",
    tax_number: "الرقم الضريبي",
    state_province: "الولاية/المقاطعة",
    street_number: "رقم الشارع",
    neighborhood: "الحي"
  },
  date_picker: {
    apply: "تطبيق",
    clear: "إزالة",
    time: "الوقت",
    all_time: "كل الوقت",
    last_3_months: "آخر 3 أشهر",
    last_pool_period: "فترة التقييم الأخيرة للمجموعة",
    last_month: "الشهر الفائت",
    this_month: "هذا الشهر",
    last_30_days: "آخر 30 يوم",
    title_dates: "تواريخ",
    from: "من",
    to: "إلى"
  },
  copy_clipboard: "تم النسخ في الحافظة",
  payment_inputs: {
    empty_card_number: "أدخل رقم البطاقة",
    invalid_card_number: "رقم البطاقة غير صالح",
    empty_expiry_date: "أدخل تاريخ الانتهاء",
    month_out_of_range: "يجب أن يكون شهر الانتهاء بين 01 و 12",
    year_out_of_range: "لا يمكن أن تكون سنة الانتهاء في الماضي",
    date_out_of_range: "لا يمكن أن يكون تاريخ الانتهاء في الماضي",
    invalid_expiry_date: "تاريخ الانتهاء غير صالح",
    invalid_cvc: "رمز التحقق غير صالح",
    empty_cvc: "أدخل رمز التحقق",
    card_number_placeholder: "رقم البطاقة",
    expiry_data_placeholder: "الشهر/السنة",
    cvc_placeholder: "رمز التحقق",
    card_holder_placeholder: "حامل البطاقة",
    empty_card_holder: "أدخل اسم حامل البطاقة"
  },
  copy_clipboard_error: "فشل في نسخ النص",
  input: {
    phone_number: "رقم الهاتف",
    phone_search: "بحث",
    search: "بحث"
  },
  "registered-over": "مسجل أكثر من",
  locale: {
    french: "فرنسية",
    german: "ألمانية",
    italian: "ايطالية",
    dutch: "هولندية",
    english: "إنجليزية",
    portuguese: "البرتغالية",
    russian: "الروسية",
    spanish: "الإسبانية",
    japanese: "اليابانية",
    arabic: "العربية",
    turkish: "التركية",
    chinese: "الصينية",
    swedish: "السويدية",
    romanian: "الرومانية",
    czech: "التشيكية",
    hungarian: "الهنغارية",
    slovak: "السلوفاكية",
    danish: "الدانماركية",
    indonesian: "الأندونيسية",
    polish: "البولندية",
    greek: "اليونانية",
    serbian: "الصربية",
    hindi: "الهندية",
    norwegian: "النرويجية",
    thai: "التايلندية",
    slovenian: "السلوفينية",
    ukrainian: "الأوكرانية",
    albania: "الألبانية"
  },
  product: "منتج",
  quantity: "الكمية",
  order_summary: "ملخص الطلب",
  vat: "ضريبة المبيعات",
  total: "المجموع",
  subtotal: "المجموع الفرعي",
  shipping: {
    shipping_method: "طريقة الشحن",
    not_available: "عذرًا! يبدو أننا لا نقدم الشحن إلى هذا الموقع بعد.",
    condition_label: {
      price: "للطلبات التي تتراوح أسعارها بين {{min}} {{currency}} و {{max}} {{currency}}",
      price_min: "للطلبات التي تتراوح أسعارها عند {{min}} {{currency}} أو أكثر",
      quantity: "للطلبات التي تحتوي على بين {{min}} إلى {{max}} عنصر",
      quantity_min: "للطلبات التي تحتوي على {{min}} عنصر أو أكثر",
      weight: "للطلبات التي يبلغ وزنها الإجمالي بين {{min}} غرام إلى {{max}} غرام",
      weight_min: "للطلبات التي يبلغ وزنها الإجمالي {{min}} غرام أو أكثر"
    }
  },
  shipping_fee: "رسوم الشحن",
  total_amount_with_tax_and_shipping: "المجموع (بما في ذلك الضريبة والشحن)",
  vat_percent: "ضريبة المبيعات ({{percent}}%)",
  including_tax: "شامل ضريبة القيمة المضافة {{percent}}% ({{amount}})"
}, Xz = {
  public_pages_purchase: Jz
}, Qz = {
  "required-field": "Pole je povinné",
  payment: {
    price_plan: "Plán",
    stripe_card: "Kreditní karty (Stripe)",
    stripe_ideal: "iDeal (proužek)",
    stripe_bancotact: "Bancontact (proužek)",
    dlocal_card: "Kreditní karty (místní)",
    dlocal_boleto: "Boleto (místní)",
    dlocal_pix: "Pix (místní)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditní karty (Mercado Pago)",
    mercadopago_pix: "PIX (Platební trh)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Dobírka",
    xendit_card: "Kreditní karty (Xendit)",
    paystack_card: "Kreditní karty (Paystack)",
    paypal_connect: "Připojte PayPal",
    paypal_edit_organization_name: "Upravit název organizace",
    paypal_rest: "PayPal",
    secure_and_pay: "Zabezpečte a zaplaťte",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Chyba",
  "Payment-method": "Způsob platby",
  price_plan: {
    trial_period: {
      week_0: "{{count}} týden",
      week_1: "{{count}} týdnů",
      week_2: "{{count}} týdnů",
      day_0: "{{count}} den",
      day_1: "{{count}} dny",
      day_2: "{{count}} dní",
      month_0: "{{count}} měsíc",
      month_1: "{{count}} měsíců",
      month_2: "{{count}} měsíců",
      year_0: "{{count}} rok",
      year_1: "{{count}} let",
      year_2: "{{count}} let"
    },
    interval: {
      month_0: "měsíc",
      month_1: "{{count}} měsíců",
      month_2: "{{count}} měsíců",
      day_0: "den",
      day_1: "{{count}} dnů",
      day_2: "{{count}} dnů",
      week_0: "týden",
      week_1: "{{count}} týdnů",
      week_2: "{{count}} týdnů",
      year_0: "rok",
      year_1: "{{count}} let",
      year_2: "{{count}} let"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Zdarma",
        trial_period_new: "{{ trialPeriodPrice }} pro {{ trialInterval }} pak",
        unlimited_new: "<bold>{{amount}}</bold> každý {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} krát"
      }
    }
  },
  affiliate_badge: {
    made_with: "Poháněno"
  },
  form_select: {
    empty_list: "Vypadá to, že tento seznam je prázdný",
    select: "Vybrat"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Jméno",
    last_name: "Příjmení",
    phone_number: "Telefonní číslo",
    country: "Země",
    street_address: "Ulice",
    city: "Město",
    postal_code: "PSČ",
    company_name: "Název společnosti",
    tax_number: "DIČ",
    state_province: "Stát/Provincie",
    street_number: "Číslo ulice",
    neighborhood: "Čtvrť"
  },
  date_picker: {
    apply: "Použít",
    clear: "Vymazat",
    time: "Čas",
    all_time: "Celý čas",
    last_3_months: "Poslední 3 měsíce",
    last_pool_period: "Poslední hodnotící období",
    last_month: "Minulý měsíc",
    this_month: "Tento měsíc",
    last_30_days: "Posledních 30 dní",
    title_dates: "Data",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Zkopírováno do schránky",
  payment_inputs: {
    empty_card_number: "Zadejte číslo karty",
    invalid_card_number: "Číslo karty je neplatné",
    empty_expiry_date: "Zadejte datum vypršení platnosti",
    month_out_of_range: "Měsíc vypršení platnosti musí být mezi 01 a 12",
    year_out_of_range: "Rok expirace nemůže být v minulosti",
    date_out_of_range: "Datum expirace nemůže být v minulosti",
    invalid_expiry_date: "Datum expirace je neplatné",
    invalid_cvc: "CVC je neplatné",
    empty_cvc: "Zadejte CVC",
    card_number_placeholder: "Číslo karty",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Držitel karty",
    empty_card_holder: "Zadejte jméno držitele karty"
  },
  copy_clipboard_error: "Kopírování textu se nezdařilo",
  input: {
    phone_number: "Telefonní číslo",
    phone_search: "Hledat",
    search: "Hledat"
  },
  "registered-over": "registrovaných přes",
  locale: {
    french: "Francouzština",
    german: "Němčina",
    italian: "Italština",
    dutch: "Holandský",
    english: "Angličtina",
    portuguese: "Portugalština",
    russian: "Ruština",
    spanish: "Španělština",
    japanese: "Japonština",
    arabic: "Arabština",
    turkish: "Turečtina",
    chinese: "Čínština",
    swedish: "Švédnština",
    romanian: "Rumunština",
    czech: "Čeština",
    hungarian: "Maďarský",
    slovak: "Slovenština",
    danish: "Dánština",
    indonesian: "Indonéština",
    polish: "Polština",
    greek: "Řečtina",
    serbian: "Srbština",
    hindi: "Hindi",
    norwegian: "Norština",
    thai: "Thajština",
    slovenian: "Slovinský",
    ukrainian: "Ukrajinština",
    albania: "Albánština"
  },
  product: "Produkt",
  quantity: "Množství",
  order_summary: "Shrnutí objednávky",
  vat: "Daň z prodeje",
  total: "Celkem",
  subtotal: "Mezisoučet",
  shipping: {
    shipping_method: "Způsob dopravy",
    not_available: "Omlouváme se! Vypadá to, že zatím nenabízíme dopravu na tuto adresu.",
    condition_label: {
      price: "Pro objednávky v cenovém rozmezí {{min}} {{currency}} až {{max}} {{currency}}",
      price_min: "Pro objednávky v ceně {{min}} {{currency}} nebo více",
      quantity: "Pro objednávky obsahující mezi {{min}} a {{max}} položkami",
      quantity_min: "Pro objednávky obsahující {{min}} nebo více položek",
      weight: "Pro objednávky s celkovou hmotností mezi {{min}}g a {{max}}g",
      weight_min: "Pro objednávky s celkovou hmotností {{min}}g nebo více"
    }
  },
  shipping_fee: "Poplatek za dopravu",
  total_amount_with_tax_and_shipping: "Celkem (včetně daně a dopravy)",
  vat_percent: "Daň z prodeje ({{percent}}%)",
  including_tax: "Včetně DPH {{percent}} % ({{amount}})"
}, eG = {
  public_pages_purchase: Qz
}, tG = {
  "required-field": "Feltet er påkrævet",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kreditkort (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkort (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kontant ved levering",
    xendit_card: "Kreditkort (Xendit)",
    paystack_card: "Kreditkort (Paystack)",
    paypal_connect: "Tilslut PayPal",
    paypal_edit_organization_name: "Rediger organisationens navn",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fejl",
  "Payment-method": "Betalingsmetode",
  price_plan: {
    trial_period: {
      week: "{{count}} uge",
      week_plural: "{{count}} uger",
      day: "{{count}} dag",
      day_plural: "{{count}} dage",
      month: "{{count}} måned",
      month_plural: "{{count}} måneder",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "måned",
      month_plural: "{{count}} måneder",
      day: "dag",
      day_plural: "{{count}} dage",
      week: "uge",
      week_plural: "{{count}} uger",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} derefter",
        unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gange"
      }
    }
  },
  affiliate_badge: {
    made_with: "Støttet af"
  },
  form_select: {
    empty_list: "Det ser ud til, at denne liste er tom",
    select: "Vælge"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Fornavn",
    last_name: "Efternavn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gadeadresse",
    city: "By",
    postal_code: "Postnummer",
    company_name: "Firmanavn",
    tax_number: "Skattenummer",
    state_province: "stat/provins",
    street_number: "Gadenummer",
    neighborhood: "Kvarter"
  },
  date_picker: {
    apply: "Anvende",
    clear: "Slet",
    time: "Tid",
    all_time: "Hele tiden",
    last_3_months: "Sidste 3 måneder",
    last_pool_period: "Sidste puljeevalueringsperiode",
    last_month: "Sidste måned",
    this_month: "Denne måned",
    last_30_days: "Sidste 30 dage",
    title_dates: "Datoer",
    from: "Fra",
    to: "Til"
  },
  copy_clipboard: "Kopieret til udklipsholder",
  payment_inputs: {
    empty_card_number: "Indtast et kortnummer",
    invalid_card_number: "Kortnummeret er ugyldigt",
    empty_expiry_date: "Indtast en udløbsdato",
    month_out_of_range: "Udløbsmåned skal være mellem 01 og 12",
    year_out_of_range: "Udløbsåret må ikke ligge i fortiden",
    date_out_of_range: "Udløbsdatoen må ikke ligge i fortiden",
    invalid_expiry_date: "Udløbsdatoen er ugyldig",
    invalid_cvc: "CVC er ugyldig",
    empty_cvc: "Indtast en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortholder",
    empty_card_holder: "Indtast et kortholdernavn"
  },
  copy_clipboard_error: "Teksten kunne ikke kopieres",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Søge",
    search: "Søge"
  },
  "registered-over": "registreret over",
  locale: {
    french: "Fransk",
    german: "Tysk",
    italian: "Italiensk",
    dutch: "Hollandsk",
    english: "Engelsk",
    portuguese: "Portugisisk",
    russian: "Russisk",
    spanish: "Spansk",
    japanese: "Japansk",
    arabic: "Arabisk",
    turkish: "Tyrkisk",
    chinese: "Kinesisk",
    swedish: "Svensk",
    romanian: "Rumænsk",
    czech: "Tjekkisk",
    hungarian: "Ungarsk",
    slovak: "Slovakisk",
    danish: "Dansk",
    indonesian: "Indonesisk",
    polish: "Polsk",
    greek: "Græsk",
    serbian: "Serbisk",
    hindi: "Hindi",
    norwegian: "Norsk",
    thai: "Thai",
    slovenian: "Slovensk",
    ukrainian: "Ukrainsk",
    albania: "Albansk"
  },
  product: "Produkt",
  quantity: "Mængde",
  order_summary: "Ordreoversigt",
  vat: "Salgsskat",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Forsendelsesmetode",
    not_available: "Ups! Det ser ud til, at vi endnu ikke tilbyder forsendelse til denne placering.",
    condition_label: {
      price: "For ordrer prissat mellem {{min}} {{currency}} og {{max}} {{currency}}",
      price_min: "For ordrer prissat til {{min}} {{currency}} eller mere",
      quantity: "For ordrer indeholdende mellem {{min}} og {{max}} varer",
      quantity_min: "For ordrer indeholdende {{min}} eller flere varer",
      weight: "For ordrer med en samlet vægt mellem {{min}}g og {{max}}g",
      weight_min: "For ordrer med en samlet vægt på {{min}}g eller mere"
    }
  },
  shipping_fee: "Forsendelsesgebyr",
  total_amount_with_tax_and_shipping: "I alt (inkl. moms og forsendelse)",
  vat_percent: "Moms ({{percent}} %)",
  including_tax: "Inklusive {{percent}}% moms ({{amount}})"
}, rG = {
  public_pages_purchase: tG
}, nG = {
  "required-field": "Das Feld ist erforderlich",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kreditkarten (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkarten (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkarten (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Lieferung per Nachnahme",
    xendit_card: "Kreditkarten (Xendit)",
    paystack_card: "Kreditkarten (Paystack)",
    paypal_connect: "PayPal verbinden",
    paypal_edit_organization_name: "Organisationsnamen bearbeiten",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fehler",
  "Payment-method": "Zahlungsmethode",
  price_plan: {
    trial_period: {
      week: "{{count}} Woche",
      week_plural: "{{count}} Wochen",
      day: "{{count}} Tag",
      day_plural: "{{count}} Tage",
      month: "{{count}} Monat",
      month_plural: "{{count}} Monate",
      year: "{{count}} Jahr",
      year_plural: "{{count}} Jahre"
    },
    interval: {
      month: "Monat",
      month_plural: "{{count}} Monate",
      day: "Tag",
      day_plural: "{{count}} Tage",
      week: "Woche",
      week_plural: "{{count}} Wochen",
      year: "Jahr",
      year_plural: "{{count}} Jahre"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Kostenlos",
        trial_period_new: "{{ trialPeriodPrice }} für {{ trialInterval }} dann",
        unlimited_new: "<bold>{{amount}}</bold> alle {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} mal"
      }
    }
  },
  affiliate_badge: {
    made_with: "Unterstützt von"
  },
  form_select: {
    empty_list: "Es sieht so aus, als wäre diese Liste leer",
    select: "Auswählen"
  },
  contact_slug: {
    email: "E-Mail",
    first_name: "Vorname",
    last_name: "Nachname",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Straßenadresse",
    city: "Stadt",
    postal_code: "Postleitzahl",
    company_name: "Firmenname",
    tax_number: "Steuernummer",
    state_province: "Bundesland/Provinz",
    street_number: "Hausnummer",
    neighborhood: "Nachbarschaft"
  },
  date_picker: {
    apply: "Anwenden",
    clear: "Löschen",
    time: "Zeit",
    all_time: "Alle Zeiten",
    last_3_months: "Letzte 3 Monate",
    last_pool_period: "Letzter Pool-Auswertungszeitraum",
    last_month: "Letzter Monat",
    this_month: "Dieser Monat",
    last_30_days: "Letzte 30 Tage",
    title_dates: "Termine",
    from: "Von",
    to: "Nach"
  },
  copy_clipboard: "In die Zwischenablage kopiert",
  payment_inputs: {
    empty_card_number: "Eine Kartennummer eingeben",
    invalid_card_number: "Kartennummer ist ungültig",
    empty_expiry_date: "Geben Sie ein Verfallsdatum ein",
    month_out_of_range: "Der Verfallsmonat muss zwischen 01 und 12 liegen",
    year_out_of_range: "Das Verfallsjahr darf nicht in der Vergangenheit liegen",
    date_out_of_range: "Das Verfallsdatum darf nicht in der Vergangenheit liegen",
    invalid_expiry_date: "Verfallsdatum ist ungültig",
    invalid_cvc: "CVC ist ungültig",
    empty_cvc: "Einen CVC eingeben",
    card_number_placeholder: "Kartennummer",
    expiry_data_placeholder: "MM/JJ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Karteninhaber",
    empty_card_holder: "Name des Karteninhabers eingeben"
  },
  copy_clipboard_error: "Text konnte nicht kopiert werden",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Suchen",
    search: "Suchen"
  },
  "registered-over": "registriert über",
  locale: {
    french: "Französisch",
    german: "Deutsch",
    italian: "Italienisch",
    dutch: "Niederländisch",
    english: "Englisch",
    portuguese: "Portugiesisch",
    russian: "Russisch",
    spanish: "Spanisch",
    japanese: "Japanisch",
    arabic: "Arabisch",
    turkish: "Türkisch",
    chinese: "Chinesisch",
    swedish: "Schwedisch",
    romanian: "Rumänisch",
    czech: "Tschechisch",
    hungarian: "Ungarisch",
    slovak: "Slowakisch",
    danish: "Dänisch",
    indonesian: "Indonesisch",
    polish: "Polnisch",
    greek: "Griechisch",
    serbian: "Serbisch",
    hindi: "Hindi",
    norwegian: "Norwegisch",
    thai: "Thailändisch",
    slovenian: "Slowenisch",
    ukrainian: "Ukrainisch",
    albania: "Albanisch"
  },
  product: "Produkt",
  quantity: "Menge",
  order_summary: "Bestellübersicht",
  vat: "Mehrwertsteuer",
  total: "Gesamt",
  subtotal: "Zwischensumme",
  shipping: {
    shipping_method: "Versandmethode",
    not_available: "Ups! Es scheint, dass wir noch keinen Versand an diesen Standort anbieten.",
    condition_label: {
      price: "Für Bestellungen im Wert von {{min}} {{currency}} bis {{max}} {{currency}}",
      price_min: "Für Bestellungen im Wert von {{min}} {{currency}} oder mehr",
      quantity: "Für Bestellungen mit {{min}} bis {{max}} Artikeln",
      quantity_min: "Für Bestellungen mit {{min}} oder mehr Artikeln",
      weight: "Für Bestellungen mit einem Gesamtgewicht zwischen {{min}}g und {{max}}g",
      weight_min: "Für Bestellungen mit einem Gesamtgewicht von {{min}}g oder mehr"
    }
  },
  shipping_fee: "Versandgebühr",
  total_amount_with_tax_and_shipping: "Gesamt (inklusive Steuern und Versand)",
  vat_percent: "Umsatzsteuer ({{percent}} %)",
  including_tax: "inklusive {{percent}}% MwSt. ({{amount}})"
}, aG = {
  public_pages_purchase: nG
}, oG = {
  "required-field": "Το πεδίο είναι υποχρεωτικό",
  payment: {
    price_plan: "Σχέδιο",
    stripe_card: "Πιστωτικές κάρτες (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Πιστωτικές κάρτες (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Πιστωτικές κάρτες (Mercado Pago)",
    mercadopago_pix: "PIX (Παραγορά πληρωμών)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Μόλι",
    gocardless: "Χωρίς Gocard",
    cash_on_delivery: "Με αντικαταβολή",
    xendit_card: "Πιστωτικές κάρτες (Xendit)",
    paystack_card: "Πιστωτικές κάρτες (Paystack)",
    paypal_connect: "Συνδέστε το PayPal",
    paypal_edit_organization_name: "Επεξεργασία ονόματος οργανισμού",
    paypal_rest: "PayPal",
    secure_and_pay: "Ασφαλίστε και πληρώστε",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Σφάλμα",
  "Payment-method": "Τρόπος πληρωμής",
  price_plan: {
    trial_period: {
      week: "{{count}} εβδομάδα",
      week_plural: "{{count}} εβδομάδες",
      day: "{{count}} ημέρα",
      day_plural: "{{count}} ημέρες",
      month: "{{count}} μήνας",
      month_plural: "{{count}} μήνες",
      year: "{{count}} έτος",
      year_plural: "{{count}} έτη"
    },
    interval: {
      month: "μήνας",
      month_plural: "{{count}} μήνες",
      day: "ημέρα",
      day_plural: "{{count}} ημέρες",
      week: "εβδομάδα",
      week_plural: "{{count}} εβδομάδες",
      year: "έτος",
      year_plural: "{{count}} έτη"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Δωρεάν",
        trial_period_new: "{{ trialPeriodPrice }} για {{ trialInterval }} στη συνέχεια",
        unlimited_new: "<bold>{{amount}}</bold> κάθε {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} φορές"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Φαίνεται ότι αυτή η λίστα είναι κενή",
    select: "Επιλέξτε"
  },
  contact_slug: {
    email: "Email",
    first_name: "Όνομα",
    last_name: "Επώνυμο",
    phone_number: "Αριθμός τηλεφώνου",
    country: "Χώρα",
    street_address: "Διεύθυνση",
    city: "Πόλη",
    postal_code: "Ταχυδρομικός κώδικας",
    company_name: "Όνομα εταιρείας",
    tax_number: "Αριθμός φορολογικού μητρώου",
    state_province: "Πολιτεία/Επαρχία",
    street_number: "Αριθμός δρόμου",
    neighborhood: "Γειτονιά"
  },
  date_picker: {
    apply: "Εφαρμογή",
    clear: "Καθαρισμός",
    time: "Χρόνος",
    all_time: "Όλος ο χρόνος",
    last_3_months: "Τελευταίοι 3 μήνες",
    last_pool_period: "Τελευταία περίοδος αξιολόγησης πισίνας",
    last_month: "Τελευταίος μήνας",
    this_month: "Αυτός ο μήνας",
    last_30_days: "Τελευταίες 30 ημέρες",
    title_dates: "Ημερομηνίες",
    from: "Από",
    to: "Προς"
  },
  copy_clipboard: "Αντιγράφηκε στο πρόχειρο",
  payment_inputs: {
    empty_card_number: "Εισάγετε έναν αριθμό κάρτας",
    invalid_card_number: "Ο αριθμός κάρτας είναι μη έγκυρος",
    empty_expiry_date: "Εισάγετε μια ημερομηνία λήξης",
    month_out_of_range: "Ο μήνας λήξης πρέπει να είναι μεταξύ 01 και 12",
    year_out_of_range: "Η ημερομηνία λήξης δεν μπορεί να είναι στο παρελθόν",
    date_out_of_range: "Η ημερομηνία λήξης δεν μπορεί να είναι στο παρελθόν",
    invalid_expiry_date: "Η ημερομηνία λήξης είναι μη έγκυρη",
    invalid_cvc: "Ο CVC είναι μη έγκυρος",
    empty_cvc: "Εισάγετε έναν CVC",
    card_number_placeholder: "Αριθμός κάρτας",
    expiry_data_placeholder: "ΜΜ/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Κάτοχος κάρτας",
    empty_card_holder: "Εισάγετε το όνομα του κατόχου της κάρτας"
  },
  copy_clipboard_error: "Αποτυχία αντιγραφής κειμένου",
  input: {
    phone_number: "Αριθμός τηλεφώνου",
    phone_search: "Αναζήτηση",
    search: "Αναζήτηση"
  },
  "registered-over": "καταχωρημένο πάνω από",
  locale: {
    french: "γαλλική γλώσσα",
    german: "Γερμανός",
    italian: "ιταλικός",
    dutch: "Ολλανδός",
    english: "Αγγλικά",
    portuguese: "Πορτογαλικά",
    russian: "Ρωσική",
    spanish: "Ισπανικά",
    japanese: "Ιαπωνικά",
    arabic: "αραβικός",
    turkish: "τούρκικος",
    chinese: "κινέζικα",
    swedish: "Σουηδικά",
    romanian: "ρουμανικός",
    czech: "Τσέχος",
    hungarian: "ουγγρικός",
    slovak: "Σλοβάκος",
    danish: "δανικός",
    indonesian: "Ινδονησιακά",
    polish: "Στίλβωση",
    greek: "Ελληνικά",
    serbian: "Σέρβος",
    hindi: "Όχι",
    norwegian: "Νορβηγός",
    thai: "Ταϊλανδός",
    slovenian: "Σλοβενική",
    ukrainian: "Ουκρανός",
    albania: "Αλβανός"
  },
  product: "Προϊόν",
  quantity: "Ποσότητα",
  order_summary: "Σύνοψη Παραγγελίας",
  vat: "Φόρος πωλήσεων",
  total: "Σύνολο",
  subtotal: "Μερικό σύνολο",
  shipping: {
    shipping_method: "Μέθοδος Αποστολής",
    not_available: "Ωχ! Φαίνεται ότι δεν προσφέρουμε αποστολή σε αυτή την τοποθεσία ακόμα.",
    condition_label: {
      price: "Για παραγγελίες που κοστίζουν μεταξύ {{min}} {{currency}} και {{max}} {{currency}}",
      price_min: "Για παραγγελίες που κοστίζουν τουλάχιστον {{min}} {{currency}}",
      quantity: "Για παραγγελίες που περιέχουν από {{min}} έως {{max}} αντικείμενα",
      quantity_min: "Για παραγγελίες που περιέχουν τουλάχιστον {{min}} αντικείμενα",
      weight: "Για παραγγελίες με συνολικό βάρος μεταξύ {{min}}g και {{max}}g",
      weight_min: "Για παραγγελίες με συνολικό βάρος τουλάχιστον {{min}}g"
    }
  },
  shipping_fee: "Χρέωση αποστολής",
  total_amount_with_tax_and_shipping: "Σύνολο (συμπεριλαμβανομένου του φόρου και της αποστολής)",
  vat_percent: "Φόρος πωλήσεων ({{percent}}%)",
  including_tax: "Συμπεριλαμβάνοντας {{percent}}% ΦΠΑ ({{amount}})"
}, iG = {
  public_pages_purchase: oG
}, sG = {
  "required-field": "Field is required",
  payment: {
    price_plan: "Plan",
    stripe_card: "Credit cards (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Credit cards (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Credit cards (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Cash on delivery",
    xendit_card: "Credit cards (Xendit)",
    paystack_card: "Credit cards (Paystack)",
    paypal_connect: "Connect PayPal",
    paypal_edit_organization_name: "Edit organization name",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Error",
  "Payment-method": "Payment method",
  price_plan: {
    trial_period: {
      week: "{{count}} week",
      week_plural: "{{count}} weeks",
      day: "{{count}} day",
      day_plural: "{{count}} days",
      month: "{{count}} month",
      month_plural: "{{count}} months",
      year: "{{count}} year",
      year_plural: "{{count}} years"
    },
    interval: {
      month: "month",
      month_plural: "{{count}} months",
      day: "day",
      day_plural: "{{count}} days",
      week: "week",
      week_plural: "{{count}} weeks",
      year: "year",
      year_plural: "{{count}} years"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Free",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} then",
        unlimited_new: "<bold>{{amount}}</bold> every {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} times"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "It looks like this list is empty",
    select: "Select"
  },
  contact_slug: {
    email: "Email",
    first_name: "First name",
    last_name: "Last name",
    phone_number: "Phone number",
    country: "Country",
    street_address: "Street address",
    city: "City",
    postal_code: "Postal code",
    company_name: "Company name",
    tax_number: "Tax number",
    state_province: "State/Province",
    street_number: "Street number",
    neighborhood: "Neighborhood"
  },
  date_picker: {
    apply: "Apply",
    clear: "Clear",
    time: "Time",
    all_time: "All time",
    last_3_months: "Last 3 months",
    last_pool_period: "Last pool evaluation period",
    last_month: "Last month",
    this_month: "This month",
    last_30_days: "Last 30 days",
    title_dates: "Dates",
    from: "From",
    to: "To"
  },
  copy_clipboard: "Copied to clipboard",
  payment_inputs: {
    empty_card_number: "Enter a card number",
    invalid_card_number: "Card number is invalid",
    empty_expiry_date: "Enter an expiry date",
    month_out_of_range: "Expiry month must be between 01 and 12",
    year_out_of_range: "Expiry year cannot be in the past",
    date_out_of_range: "Expiry date cannot be in the past",
    invalid_expiry_date: "Expiry date is invalid",
    invalid_cvc: "CVC is invalid",
    empty_cvc: "Enter a CVC",
    card_number_placeholder: "Card number",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Card holder",
    empty_card_holder: "Enter a card holder name"
  },
  copy_clipboard_error: "Failed to copy text",
  input: {
    phone_number: "Phone number",
    phone_search: "Search",
    search: "Search"
  },
  "registered-over": "registered over",
  locale: {
    french: "French",
    german: "German",
    italian: "Italiano",
    dutch: "Dutch",
    english: "English",
    portuguese: "Portuguese",
    russian: "Russian",
    spanish: "Spanish",
    japanese: "Japanese",
    arabic: "Arabic",
    turkish: "Turkish",
    chinese: "Chinese",
    swedish: "Swedish",
    romanian: "Romanian",
    czech: "Czech",
    hungarian: "Hungarian",
    slovak: "Slovak",
    danish: "Danish",
    indonesian: "Indonesian",
    polish: "Polish",
    greek: "Greek",
    serbian: "Serbian",
    hindi: "Hindi",
    norwegian: "Norwegian",
    thai: "Thai",
    slovenian: "Slovenian",
    ukrainian: "Ukrainian",
    albania: "Albanian"
  },
  product: "Product",
  quantity: "Quantity",
  order_summary: "Order summary",
  vat: "Sales tax",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Shipping method",
    not_available: "Oops! It looks like we don't offer shipping to this location yet",
    condition_label: {
      price: "For orders priced between {{min}} {{currency}} to {{max}} {{currency}}",
      price_min: "For orders priced at {{min}} {{currency}} or more",
      quantity: "For orders containing between {{min}} to {{max}} items",
      quantity_min: "For orders containing {{min}} or more items",
      weight: "For orders with a total weight between {{min}}g to {{max}}g",
      weight_min: "For orders with a total weight of {{min}}g or more"
    }
  },
  shipping_fee: "Shipping fee",
  total_amount_with_tax_and_shipping: "Total (including tax and Shipping)",
  vat_percent: "Sales tax ({{percent}}%)",
  including_tax: "Includes {{percent}}% VAT ({{amount}})"
}, lG = {
  public_pages_purchase: sG
}, cG = {
  "required-field": "El campo es necesario",
  payment: {
    price_plan: "Plan",
    stripe_card: "Tarjetas de crédito (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Tarjetas de crédito (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Tarjetas de crédito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Pago contra entrega",
    xendit_card: "Tarjetas de crédito (Xendit)",
    paystack_card: "Tarjetas de crédito (Paystack)",
    paypal_connect: "Conectar PayPal",
    paypal_edit_organization_name: "Editar el nombre de la organización",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Error",
  "Payment-method": "Método de pago",
  price_plan: {
    trial_period: {
      week: "{{count}} semana",
      week_plural: "{{count}} semanas",
      day: "{{count}} día",
      day_plural: "{{count}} días",
      month: "{{count}} mes",
      month_plural: "{{count}} meses",
      year: "{{count}} año",
      year_plural: "{{count}} años"
    },
    interval: {
      month: "mes",
      month_plural: "{{count}} meses",
      day: "día",
      day_plural: "{{count}} días",
      week: "semana",
      week_plural: "{{count}} semanas",
      year: "año",
      year_plural: "{{count}} años"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} luego",
        unlimited_new: "<bold>{{amount}}</bold> cada {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} veces"
      }
    }
  },
  affiliate_badge: {
    made_with: "Desarrollado por"
  },
  form_select: {
    empty_list: "Parece que esta lista está vacía",
    select: "Seleccionar"
  },
  contact_slug: {
    email: "Correo",
    first_name: "Nombre",
    last_name: "Apellido",
    phone_number: "Número de teléfono",
    country: "País",
    street_address: "Dirección",
    city: "Ciudad",
    postal_code: "Código postal",
    company_name: "Nombre de la empresa",
    tax_number: "Número de IVA",
    state_province: "Estado/Provincia",
    street_number: "Dirección",
    neighborhood: "Barrio"
  },
  date_picker: {
    apply: "Aplicar",
    clear: "Borrar",
    time: "Hola",
    all_time: "Desde siempre",
    last_3_months: "Últimos 3 meses",
    last_pool_period: "Último periodo de evaluación de la pool",
    last_month: "Último mes",
    this_month: "Este mes",
    last_30_days: "Últimos 30 días",
    title_dates: "Fechas",
    from: "Desde",
    to: "Hasta"
  },
  copy_clipboard: "Copiado en el portapapeles",
  payment_inputs: {
    empty_card_number: "Ingresa un número de tarjeta",
    invalid_card_number: "El número de tarjeta no es válido",
    empty_expiry_date: "Ingresa la fecha de expiración",
    month_out_of_range: "El mes de expiración debe estar entre 01 y 12",
    year_out_of_range: "El año de expiración no puede estar situado en el pasado",
    date_out_of_range: "La fecha de expiración no puede estar situada en el pasado",
    invalid_expiry_date: "La fecha de expiracion no es válida",
    invalid_cvc: "El CVC no es válido",
    empty_cvc: "Ingresa un CVC",
    card_number_placeholder: "Número de tarjeta",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titular de la tarjeta",
    empty_card_holder: "Ingresa el nombre del titular de la tarjeta"
  },
  copy_clipboard_error: "Error el copiar el texto",
  input: {
    phone_number: "Teléfono",
    phone_search: "Buscar",
    search: "Buscar"
  },
  "registered-over": "registrado hace más de",
  locale: {
    french: "Francés",
    german: "Alemán",
    italian: "Italiano",
    dutch: "Holandés",
    english: "Inglés",
    portuguese: "Portugués",
    russian: "Ruso",
    spanish: "Español",
    japanese: "Japonés",
    arabic: "árabe",
    turkish: "Turco",
    chinese: "Chino",
    swedish: "Sueco",
    romanian: "Rumano",
    czech: "Checo",
    hungarian: "Húngaro",
    slovak: "Eslovaco",
    danish: "Danés",
    indonesian: "Indonesio",
    polish: "Polaco",
    greek: "Griego",
    serbian: "Serbio",
    hindi: "Hindi",
    norwegian: "Noruego",
    thai: "Tailandés",
    slovenian: "Esloveno",
    ukrainian: "Ucraniano",
    albania: "Albanés"
  },
  product: "Producto",
  quantity: "Cantidad",
  order_summary: "Resumen del pedido",
  vat: "IVA",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Método de envío",
    not_available: "¡Vaya! Parece que aún no ofrecemos envíos a esta ubicación",
    condition_label: {
      price: "Para pedidos con precio entre {{min}} {{currency}} y {{max}} {{currency}}",
      price_min: "Para pedidos que cuesten {{min}} {{currency}} o más",
      quantity: "Para pedidos de entre {{min}} y {{max}} artículos",
      quantity_min: "Para pedidos con {{min}} o más artículos",
      weight: "Para pedidos con un peso total entre {{min}}g y {{max}}g",
      weight_min: "Para pedidos con un peso total de {{min}}g o más"
    }
  },
  shipping_fee: "Tarifa de envío",
  total_amount_with_tax_and_shipping: "Total (incluyendo impuestos y envío)",
  vat_percent: "IVA ({{percent}}%)",
  including_tax: "Incluyendo {{percent}}% de IVA ({{amount}})"
}, uG = {
  public_pages_purchase: cG
}, dG = {
  "required-field": "Le champ est obligatoire",
  payment: {
    price_plan: "Plan",
    stripe_card: "Cartes de crédit (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "BanContact (Stripe)",
    dlocal_card: "Cartes de crédit (Dlocal)",
    dlocal_boleto: "Billet (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Cartes de crédit (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Paiement à la livraison",
    xendit_card: "Cartes de crédit (Xendit)",
    paystack_card: "Cartes de crédit (Paystack)",
    paypal_connect: "Connectez-vous à PayPal",
    paypal_edit_organization_name: "Modifier le nom de l'organisation",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Erreur",
  "Payment-method": "Mode de paiement",
  price_plan: {
    trial_period: {
      week: "{{count}} semaine",
      week_plural: "{{count}} semaines",
      day: "{{count}} jour",
      day_plural: "{{count}} jours",
      month: "{{count}} mois",
      month_plural: "{{count}} mois",
      year: "{{count}} an",
      year_plural: "{{count}} ans"
    },
    interval: {
      month: "mois",
      month_plural: "{{count}} mois",
      day: "jour",
      day_plural: "{{count}} jours",
      week: "semaine",
      week_plural: "{{count}} semaines",
      year: "an",
      year_plural: "{{count}} ans"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuit",
        trial_period_new: "{{ trialPeriodPrice }} pendant {{ trialInterval }} puis",
        unlimited_new: "<bold>{{amount}}</bold> tous {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }}  - {{ count }} fois"
      }
    }
  },
  affiliate_badge: {
    made_with: "Développé par"
  },
  form_select: {
    empty_list: "Cette liste semble vide",
    select: "Sélectionner"
  },
  contact_slug: {
    email: "Email",
    first_name: "Prénom",
    last_name: "Nom",
    phone_number: "Numéro de téléphone",
    country: "Pays",
    street_address: "Adresse",
    city: "Ville",
    postal_code: "Code postal",
    company_name: "Nom de l'entreprise",
    tax_number: "Numéro d'identification fiscale",
    state_province: "Région",
    street_number: "Numéro de rue",
    neighborhood: "Quartier"
  },
  date_picker: {
    apply: "Appliquer",
    clear: "Effacer",
    time: "Horaire",
    all_time: "Depuis le début",
    last_3_months: "Les 3 derniers mois",
    last_pool_period: "Dernière période d'évaluation du pool",
    last_month: "Le mois dernier",
    this_month: "Ce mois",
    last_30_days: "Les 30 derniers jours",
    title_dates: "Dates",
    from: "De",
    to: "À"
  },
  copy_clipboard: "Copié dans le presse-papier",
  payment_inputs: {
    empty_card_number: "Entrez un numéro de carte",
    invalid_card_number: "Le numéro de carte est invalide",
    empty_expiry_date: "Entrez une date d'expiration",
    month_out_of_range: "Le mois d’expiration doit être entre 01 et 12",
    year_out_of_range: "L'année d'expiration ne peut pas être dans le passé",
    date_out_of_range: "La date d’expiration ne peut pas être dans le passé",
    invalid_expiry_date: "La date d’expiration est invalide",
    invalid_cvc: "Le code CVC est invalide",
    empty_cvc: "Saisissez le code CVC",
    card_number_placeholder: "Numéro de carte",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titulaire de la carte",
    empty_card_holder: "Saisir le nom du titulaire de la carte"
  },
  copy_clipboard_error: "Échec de la copie du texte",
  input: {
    phone_number: "Numéro de téléphone",
    phone_search: "Recherche",
    search: "Recherche"
  },
  "registered-over": "enregistré plus de",
  locale: {
    french: "Français",
    german: "Allemand",
    italian: "Italiano",
    dutch: "Néerlandais",
    english: "Anglais",
    portuguese: "Portugais",
    russian: "Russe",
    spanish: "Espagnol",
    japanese: "Japonais",
    arabic: "Аrabe",
    turkish: "Turc",
    chinese: "Chinois",
    swedish: "Suédois",
    romanian: "Roumain",
    czech: "Tchèque",
    hungarian: "Hongrois",
    slovak: "Slovaque",
    danish: "Danois",
    indonesian: "Indonésien",
    polish: "Polonais",
    greek: "Grec",
    serbian: "Serbe",
    hindi: "Indien",
    norwegian: "Norvégien",
    thai: "Thaïlandais",
    slovenian: "Slovène",
    ukrainian: "Ukrainien",
    albania: "Albanais"
  },
  product: "Produit",
  quantity: "Quantité",
  order_summary: "Résumé de la commande",
  vat: "TVA",
  total: "Total",
  subtotal: "Sous-total",
  shipping: {
    shipping_method: "Méthode d'expédition",
    not_available: "Oups ! Il semble qu'on ne livre pas encore à cet endroit",
    condition_label: {
      price: "Pour les commandes dont le prix est compris entre {{min}} {{currency}} et {{max}} {{currency}}",
      price_min: "Pour les commandes dont le prix est de {{min}} {{currency}} ou plus",
      quantity: "Pour les commandes contenant entre {{min}} et {{max}} articles",
      quantity_min: "Pour les commandes contenant {{min}} articles ou plus",
      weight: "Pour les commandes avec un poids total compris entre {{min}}g et {{max}}g",
      weight_min: "Pour les commandes avec un poids total de {{min}}g ou plus"
    }
  },
  shipping_fee: "Frais d'expédition",
  total_amount_with_tax_and_shipping: "Total (y compris la TVA et l'expédition)",
  vat_percent: "TVA ({{percent}}%)",
  including_tax: "TVA incluse à {{percent}} % ({{amount}})"
}, pG = {
  public_pages_purchase: dG
}, hG = {
  "required-field": "यह फील्ड भरना अनिवार्य है",
  payment: {
    price_plan: "प्लान",
    stripe_card: "क्रेडिट कार्ड्स (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "बैनकॉन्टैक्ट (Stripe)",
    dlocal_card: "क्रेडिट कार्ड्स (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "क्रेडिट कार्ड्स (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "कैश-ऑन-डिलीवरी",
    xendit_card: "क्रेडिट कार्ड्स (Xendit)",
    paystack_card: "क्रेडिट कार्ड्स (Paystack)",
    paypal_connect: "Paypal से जुड़ें",
    paypal_edit_organization_name: "संगठन का नाम एडिट करें",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "एप्पल पे",
    xendit: {
      "3ds": "3D-सिक्योर"
    }
  },
  error: "एरर",
  "Payment-method": "पेमेंट मेथड",
  price_plan: {
    trial_period: {
      week: "{{count}} सप्ताह",
      week_plural: "{{count}} दिन",
      day: "{{count}} दिन",
      day_plural: "{{count}} दिन",
      month: "{{count}} महीना",
      month_plural: "{{count}} महीने",
      year: "{{count}} वर्ष",
      year_plural: "{{count}} वर्ष"
    },
    interval: {
      month: "महीना",
      month_plural: "{{count}} महीने",
      day: "दिन",
      day_plural: "{{count}} दिन",
      week: "सप्ताह",
      week_plural: "{{count}} सप्ताह",
      year: "वर्ष",
      year_plural: "{{count}} वर्ष"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "मुफ्त",
        trial_period_new: "{{ trialPeriodPrice }} के लिए {{ trialInterval }} फिर",
        unlimited_new: "{{amount}} हर {{interval}} पर",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} बार"
      }
    }
  },
  affiliate_badge: {
    made_with: "द्वारा संचालित"
  },
  form_select: {
    empty_list: "लगता है यह लिस्ट खाली है",
    select: "चूनें"
  },
  contact_slug: {
    email: "ईमेल",
    first_name: "प्रथम नाम",
    last_name: "अंतिम नाम",
    phone_number: "फ़ोन नंबर",
    country: "देश",
    street_address: "सड़क का पता",
    city: "शहर",
    postal_code: "पोस्टल कोड",
    company_name: "कंपनी का नाम",
    tax_number: "टैक्स नंबर",
    state_province: "राज्य/प्रान्त",
    street_number: "सड़क संख्या",
    neighborhood: "पड़ोस"
  },
  date_picker: {
    apply: "लागू करें",
    clear: "हटाएं",
    time: "समय",
    all_time: "सभी समय",
    last_3_months: "पिछले 3 महीने",
    last_pool_period: "पिछले पूल मूल्यांकन अवधि",
    last_month: "पिछले महीने",
    this_month: "इस महीने",
    last_30_days: "पिछले 30 दिन",
    title_dates: "दिनांक",
    from: "से",
    to: "तक"
  },
  copy_clipboard: "क्लिपबोर्ड पर कॉपी किया गया",
  payment_inputs: {
    empty_card_number: "कार्ड नंबर दर्ज करें",
    invalid_card_number: "कार्ड नंबर अमान्य है ",
    empty_expiry_date: "समाप्ति तिथि दर्ज करें",
    month_out_of_range: "समाप्ति माह 01 और 12 के बीच होना चाहिए ",
    year_out_of_range: "समाप्ति वर्ष अतीत में नहीं हो सकता",
    date_out_of_range: "समाप्ति तिथि अतीत में नहीं हो सकती",
    invalid_expiry_date: "समाप्ति तिथि अमान्य है",
    invalid_cvc: "CVC अमान्य है",
    empty_cvc: "CVC दर्ज करें  ",
    card_number_placeholder: "कार्ड नंबर",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "कार्ड धारक",
    empty_card_holder: "एक कार्ड धारक का नाम दर्ज करें"
  },
  copy_clipboard_error: "टेक्स्ट कॉपी करने में असफल",
  input: {
    phone_number: "फोन नंबर",
    phone_search: "खोजें",
    search: "खोजें"
  },
  "registered-over": "पंजीकृत किया गया",
  locale: {
    french: "फ्रेंच",
    german: "जर्मन",
    italian: "इटैलिनो",
    dutch: "डच",
    english: "अंग्रेज़ी",
    portuguese: "पुर्तगाली",
    russian: "रूसी",
    spanish: "स्पैनिश",
    japanese: "जापानी",
    arabic: "अरबी",
    turkish: "तुर्की",
    chinese: "चीनी",
    swedish: "स्वीडिश",
    romanian: "रोमानियाई",
    czech: "चेक",
    hungarian: "हंगेरीअन ",
    slovak: "स्लोवाक",
    danish: "डैनिश",
    indonesian: "इन्डोनेशियाई",
    polish: "पोलिश",
    greek: "यूनानी",
    serbian: "सर्बियाई",
    hindi: "हिंदी ",
    norwegian: "नार्वेजियन",
    thai: "थाई",
    slovenian: "स्लोवेनियाई",
    ukrainian: "यूक्रेनी",
    albania: "अल्बानियन"
  },
  product: "प्रोडक्ट",
  quantity: "क्वान्टिटी",
  order_summary: "ऑर्डर समरी",
  vat: "सेल्स टैक्स",
  total: "टोटल",
  subtotal: "सब टोटल ",
  shipping: {
    shipping_method: "शिपिंग मेथड",
    not_available: "अरे! ऐसा लगता है कि हम अभी इस स्थान पर शिपिंग की पेशकश नहीं करते है ",
    condition_label: {
      price: "{{min}} {{currency}} से {{max}} {{currency}} के बीच प्राइस वाले ऑर्डर्स के लिए",
      price_min: "{{min}} {{currency}} या अधिक प्राइस वाले ऑर्डर्स के लिए",
      quantity: "{{min}} से {{max}} आइटम वाले ऑर्डर्स के लिए",
      quantity_min: "{{min}} या अधिक आइटम वाले ऑर्डर्स के लिए",
      weight: "{{min}}g से {{max}}g के बीच कुल वजन वाले ऑर्डर्स के लिए",
      weight_min: "{{min}}g या अधिक कुल वजन वाले ऑर्डर्स के लिए"
    }
  },
  shipping_fee: "शिपिंग शुल्क",
  total_amount_with_tax_and_shipping: "कुल (कर और शिपिंग सहित)",
  vat_percent: "सेल्स टैक्स ({{percent}}%)",
  including_tax: "जिसमें {{percent}}% कर ({{amount}}) शामिल है"
}, mG = {
  public_pages_purchase: hG
}, fG = {
  "required-field": "A mező kitöltése kötelező",
  payment: {
    price_plan: "Terv",
    stripe_card: "Hitelkártyák (Stripe)",
    stripe_ideal: "iDeal (csík)",
    stripe_bancotact: "Bancontact (csíkos)",
    dlocal_card: "Hitelkártyák (Dlocal)",
    dlocal_boleto: "Boleto (helyi)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Hitelkártyák (Mercado Pago)",
    mercadopago_pix: "PIX (fizetési piac)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Utánvétes fizetés",
    xendit_card: "Hitelkártyák (Xendit)",
    paystack_card: "Hitelkártyák (Paystack)",
    paypal_connect: "Csatlakoztassa a PayPal-t",
    paypal_edit_organization_name: "Szerkessze a szervezet nevét",
    paypal_rest: "PayPal",
    secure_and_pay: "Biztonságos és fizetés",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Hiba",
  "Payment-method": "Fizetési mód",
  price_plan: {
    trial_period: {
      week: "{{count}} hét",
      week_plural: "{{count}} hét",
      day: "{{count}} nap",
      day_plural: "{{count}} nap",
      month: "{{count}} hónap",
      month_plural: "{{count}} hónap",
      year: "{{count}} év",
      year_plural: "{{count}} év"
    },
    interval: {
      month: "hónap",
      month_plural: "{{count}} hónap",
      day: "nap",
      day_plural: "{{count}} nap",
      week: "hét",
      week_plural: "{{count}} hét",
      year: "év",
      year_plural: "{{count}} év"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Ingyenes",
        trial_period_new: "{{ trialPeriodPrice }} , akkor {{ trialInterval }}",
        unlimited_new: "<bold>{{amount}}</bold> minden {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} alkalommal"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Úgy tűnik, hogy ez a lista üres",
    select: "Kiválasztás"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Keresztnév",
    last_name: "Vezetéknév",
    phone_number: "Telefonszám",
    country: "Ország",
    street_address: "Utca cím",
    city: "Város",
    postal_code: "Irányítószám",
    company_name: "Cégnév",
    tax_number: "Adószám",
    state_province: "Állam/Mező",
    street_number: "Utca szám",
    neighborhood: "Környék"
  },
  date_picker: {
    apply: "Alkalmaz",
    clear: "Törlés",
    time: "Idő",
    all_time: "Minden idő",
    last_3_months: "Utolsó 3 hónap",
    last_pool_period: "Utolsó medenceértékelési időszak",
    last_month: "Utolsó hónap",
    this_month: "Ez a hónap",
    last_30_days: "Utolsó 30 nap",
    title_dates: "Dátumok",
    from: "Tól",
    to: "Ig"
  },
  copy_clipboard: "Másolva a vágólapra",
  payment_inputs: {
    empty_card_number: "Adjon meg egy kártyaszámot",
    invalid_card_number: "A kártyaszám érvénytelen",
    empty_expiry_date: "Adjon meg egy lejárati dátumot",
    month_out_of_range: "A lejárati hónapnak 01 és 12 között kell lennie",
    year_out_of_range: "A lejárati év nem lehet a múltban",
    date_out_of_range: "A lejárati dátum nem lehet a múltban",
    invalid_expiry_date: "A lejárati dátum érvénytelen",
    invalid_cvc: "A CVC érvénytelen",
    empty_cvc: "Adja meg a CVC-t",
    card_number_placeholder: "Kártyaszám",
    expiry_data_placeholder: "HH/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kártyabirtokos",
    empty_card_holder: "Adja meg a kártyabirtokos nevét"
  },
  copy_clipboard_error: "A szöveg másolása nem sikerült",
  input: {
    phone_number: "Telefonszám",
    phone_search: "Keresés",
    search: "Keresés"
  },
  "registered-over": "regisztrált több mint",
  locale: {
    french: "Francia",
    german: "Német",
    italian: "Olasz",
    dutch: "Holland",
    english: "Angol",
    portuguese: "Portugál",
    russian: "Orosz",
    spanish: "Spanyol",
    japanese: "Japán",
    arabic: "Arab",
    turkish: "Török",
    chinese: "Kínai",
    swedish: "Svéd",
    romanian: "Román",
    czech: "Cseh",
    hungarian: "Magyar",
    slovak: "Szlovák",
    danish: "Dán",
    indonesian: "Indonéz",
    polish: "Fényesít",
    greek: "Görög",
    serbian: "Szerb",
    hindi: "Dehogy",
    norwegian: "Norvég",
    thai: "Thai",
    slovenian: "Szlovén",
    ukrainian: "Ukrán",
    albania: "Albán"
  },
  product: "Termék",
  quantity: "Mennyiség",
  order_summary: "Rendelés összegzése",
  vat: "Áfa",
  total: "Összesen",
  subtotal: "Részösszeg",
  shipping: {
    shipping_method: "Szállítási mód",
    not_available: "Hoppá! Úgy tűnik, hogy még nem kínálunk szállítást erre a helyre.",
    condition_label: {
      price: "A {{min}} {{currency}} és {{max}} {{currency}} közötti árú rendelésekhez",
      price_min: "A {{min}} {{currency}} vagy annál drágább rendelésekhez",
      quantity: "A {{min}} és {{max}} közötti tételeket tartalmazó rendelésekhez",
      quantity_min: "A {{min}} vagy annál több tételt tartalmazó rendelésekhez",
      weight: "A {{min}}g és {{max}}g közötti összsúlyú rendelésekhez",
      weight_min: "A {{min}}g vagy annál nehezebb rendelésekhez"
    }
  },
  shipping_fee: "Szállítási díj",
  total_amount_with_tax_and_shipping: "Összesen (beleértve az adót és a szállítást)",
  vat_percent: "Áruforgalmi adó ({{percent}}%)",
  including_tax: "ÁFA {{percent}}%-ot tartalmaz ({{amount}})"
}, gG = {
  public_pages_purchase: fG
}, yG = {
  "required-field": "Bidang wajib diisi",
  payment: {
    price_plan: "Rencana",
    stripe_card: "Kartu kredit (Garis)",
    stripe_ideal: "iDeal (Garis)",
    stripe_bancotact: "Bancontact (Garis)",
    dlocal_card: "Kartu kredit (Dlokal)",
    dlocal_boleto: "Boleto (Dlokal)",
    dlocal_pix: "Pix (Dlokal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kartu kredit (Mercado Pago)",
    mercadopago_pix: "PIX (Pasar Pembayaran)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Pembayaran pisau cukur",
    flutterwave: "Gelombang bergetar",
    mollie: "Mollie",
    gocardless: "Tanpa kartu",
    cash_on_delivery: "Bayar di tempat",
    xendit_card: "Kartu kredit (Xendit)",
    paystack_card: "Kartu kredit (Paystack)",
    paypal_connect: "Hubungkan PayPal",
    paypal_edit_organization_name: "Edit nama organisasi",
    paypal_rest: "PayPal",
    secure_and_pay: "Amankan dan Bayar",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Kesalahan",
  "Payment-method": "Metode pembayaran",
  price_plan: {
    trial_period: {
      week: "{{count}} minggu",
      day: "{{count}} hari",
      month: "{{count}} bulan",
      year: "{{count}} tahun"
    },
    interval: {
      month: "bulan",
      day: "hari",
      week: "pekan",
      year: "tahun"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Bebas",
        trial_period_new: "{{ trialPeriodPrice }} untuk {{ trialInterval }} lalu",
        unlimited_new: "<bold>{{amount}}</bold> setiap {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kali"
      }
    }
  },
  affiliate_badge: {
    made_with: "Ditenagai oleh"
  },
  form_select: {
    empty_list: "Sepertinya daftar ini kosong",
    select: "Pilih"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nama depan",
    last_name: "Nama belakang",
    phone_number: "Nomor telepon",
    country: "Negara",
    street_address: "Alamat jalan",
    city: "Kota",
    postal_code: "Kode pos",
    company_name: "Nama perusahaan",
    tax_number: "Nomor pajak",
    state_province: "Negara Bagian/Provinsi",
    street_number: "Nomor jalan",
    neighborhood: "Lingkungan"
  },
  date_picker: {
    apply: "Terapkan",
    clear: "Bersihkan",
    time: "Waktu",
    all_time: "Semua waktu",
    last_3_months: "3 bulan terakhir",
    last_pool_period: "Periode evaluasi kolam terakhir",
    last_month: "Bulan lalu",
    this_month: "Bulan ini",
    last_30_days: "30 hari terakhir",
    title_dates: "Tanggal",
    from: "Dari",
    to: "Ke"
  },
  copy_clipboard: "Disalin ke clipboard",
  payment_inputs: {
    empty_card_number: "Masukkan nomor kartu",
    invalid_card_number: "Nomor kartu tidak valid",
    empty_expiry_date: "Masukkan tanggal kedaluwarsa",
    month_out_of_range: "Bulan kedaluwarsa harus antara 01 dan 12",
    year_out_of_range: "Tahun kedaluwarsa tidak boleh di masa lalu",
    date_out_of_range: "Tanggal kedaluwarsa tidak boleh di masa lalu",
    invalid_expiry_date: "Tanggal kedaluwarsa tidak valid",
    invalid_cvc: "CVC tidak valid",
    empty_cvc: "Masukkan CVC",
    card_number_placeholder: "Nomor kartu",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Pemegang kartu",
    empty_card_holder: "Masukkan nama pemegang kartu"
  },
  copy_clipboard_error: "Gagal menyalin teks",
  input: {
    phone_number: "Nomor telepon",
    phone_search: "Cari",
    search: "Cari"
  },
  "registered-over": "terdaftar lebih dari",
  locale: {
    french: "Perancis",
    german: "Jerman",
    italian: "Italia",
    dutch: "Belanda",
    english: "Bahasa inggris",
    portuguese: "Portugis",
    russian: "Rusia",
    spanish: "Orang Spanyol",
    japanese: "Jepang",
    arabic: "Arab",
    turkish: "Turki",
    chinese: "Cina",
    swedish: "Orang Swedia",
    romanian: "Rumania",
    czech: "Ceko",
    hungarian: "Hongaria",
    slovak: "Orang Slovakia",
    danish: "Orang Denmark",
    indonesian: "Bahasa Indonesia",
    polish: "Polandia",
    greek: "Orang yunani",
    serbian: "Orang Serbia",
    hindi: "Tidak",
    norwegian: "Norwegia",
    thai: "Thai",
    slovenian: "Slovenia",
    ukrainian: "Orang Ukraina",
    albania: "Bahasa Albania"
  },
  product: "Produk",
  quantity: "Kuantitas",
  order_summary: "Ringkasan Pesanan",
  vat: "Pajak penjualan",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Metode Pengiriman",
    not_available: "Ups! Sepertinya kami belum menawarkan pengiriman ke lokasi ini.",
    condition_label: {
      price: "Untuk pesanan yang harganya antara {{min}} {{currency}} hingga {{max}} {{currency}}",
      price_min: "Untuk pesanan yang harganya {{min}} {{currency}} atau lebih",
      quantity: "Untuk pesanan yang berisi antara {{min}} hingga {{max}} item",
      quantity_min: "Untuk pesanan yang berisi {{min}} item atau lebih",
      weight: "Untuk pesanan dengan total berat antara {{min}}g hingga {{max}}g",
      weight_min: "Untuk pesanan dengan total berat {{min}}g atau lebih"
    }
  },
  shipping_fee: "Biaya pengiriman",
  total_amount_with_tax_and_shipping: "Total (termasuk pajak dan pengiriman)",
  vat_percent: "Pajak penjualan ({{percent}}%)",
  including_tax: "Termasuk PPN {{percent}}% ({{amount}})"
}, vG = {
  public_pages_purchase: yG
}, bG = {
  "required-field": "Il campo è obbligatorio",
  payment: {
    price_plan: "Piano",
    stripe_card: "Carte di credito (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Carte di credito (Dlocal)",
    dlocal_boleto: "Biglietto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Carte di credito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Biglietto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Contanti alla consegna",
    xendit_card: "Carte di credito (Xendit)",
    paystack_card: "Carte di credito (Paystack)",
    paypal_connect: "Collegare PayPal",
    paypal_edit_organization_name: "Modifica il nome dell'organizzazione",
    paypal_rest: "PayPal",
    secure_and_pay: "Sicurezza e pagamento",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Errore",
  "Payment-method": "Metodo di pagamento",
  price_plan: {
    trial_period: {
      week: "{{count}} settimana",
      week_plural: "{{count}} settimane",
      day: "{{count}} giorno",
      day_plural: "{{count}} giorni",
      month: "{{count}} mese",
      month_plural: "{{count}} mesi",
      year: "{{count}} anni",
      year_plural: "{{count}} anni"
    },
    interval: {
      month: "mese",
      month_plural: "{{count}} mesi",
      day: "giorno",
      day_plural: "{{count}} giorni",
      week: "settimana",
      week_plural: "{{count}} settimane",
      year: "anno",
      year_plural: "{{count}} anni"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuito",
        trial_period_new: "{{ trialPeriodPrice }} per {{ trialInterval }} poi",
        unlimited_new: "<bold>{{amount}}</bold> ogni {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} tempi"
      }
    }
  },
  affiliate_badge: {
    made_with: "Realizzato da"
  },
  form_select: {
    empty_list: "Sembra che questo elenco sia vuoto",
    select: "Selezionare"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nome",
    last_name: "Cognome",
    phone_number: "Numero di telefono",
    country: "Paese",
    street_address: "Indirizzo",
    city: "Città",
    postal_code: "Codice postale",
    company_name: "Nome azienda",
    tax_number: "Partita IVA",
    state_province: "Stato/Provincia",
    street_number: "Numero civico",
    neighborhood: "Quartiere"
  },
  date_picker: {
    apply: "Applicare",
    clear: "Chiaro",
    time: "Tempo",
    all_time: "Per tutto il periodo",
    last_3_months: "Ultimi 3 mesi",
    last_pool_period: "Ultimo periodo di valutazione del pool",
    last_month: "Ultimo mese",
    this_month: "Questo mese",
    last_30_days: "Ultimi 30 giorni",
    title_dates: "Date",
    from: "Da",
    to: "A"
  },
  copy_clipboard: "Copiato negli appunti",
  payment_inputs: {
    empty_card_number: "Inserire un numero di carta",
    invalid_card_number: "Il numero della carta non è valido",
    empty_expiry_date: "Inserire una data di scadenza",
    month_out_of_range: "Il mese di scadenza deve essere compreso tra 01 e 12",
    year_out_of_range: "L'anno di scadenza non può essere passato",
    date_out_of_range: "La data di scadenza non può essere passata",
    invalid_expiry_date: "La data di scadenza non è valida",
    invalid_cvc: "Il CVC non è valido",
    empty_cvc: "Inserire una CVC",
    card_number_placeholder: "Numero della carta",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Portacarte",
    empty_card_holder: "Inserire il nome del titolare della carta"
  },
  copy_clipboard_error: "Impossibile copiare il testo",
  input: {
    phone_number: "Numero di telefono",
    phone_search: "Ricerca",
    search: "Ricerca"
  },
  "registered-over": "registrato oltre",
  locale: {
    french: "Francese",
    german: "Tedesco",
    italian: "Italiano",
    dutch: "Olandese",
    english: "Inglese",
    portuguese: "Portoghese",
    russian: "Russo",
    spanish: "Spagnolo",
    japanese: "Giapponese",
    arabic: "Аrabo",
    turkish: "Turco",
    chinese: "Cinese",
    swedish: "Svedese",
    romanian: "Rumeno",
    czech: "Ceco",
    hungarian: "Ungherese",
    slovak: "Slovacco",
    danish: "Danese",
    indonesian: "Indonesiano",
    polish: "Polacco",
    greek: "Greco",
    serbian: "Serbo",
    hindi: "Hindi",
    norwegian: "Norvegese",
    thai: "Tailandese",
    slovenian: "Sloveno",
    ukrainian: "Ucraino",
    albania: "Albanese"
  },
  product: "Prodotto",
  quantity: "Quantità",
  order_summary: "Riepilogo dell'ordine",
  vat: "Imposta sulle vendite",
  total: "Totale",
  subtotal: "Totale parziale",
  shipping: {
    shipping_method: "Metodo di spedizione",
    not_available: "Ops! Sembra che per ora non offriamo spedizioni in questa località.",
    condition_label: {
      price: "Per ordini con un prezzo compreso tra {{min}} {{currency}} e {{max}} {{currency}}",
      price_min: "Per ordini con un prezzo di {{min}} {{currency}} o più",
      quantity: "Per ordini contenenti tra {{min}} e {{max}} articoli",
      quantity_min: "Per ordini contenenti {{min}} articoli o più",
      weight: "Per ordini con un peso totale compreso tra {{min}}g e {{max}}g",
      weight_min: "Per ordini con un peso totale di {{min}}g o più"
    }
  },
  shipping_fee: "Spese di spedizione",
  total_amount_with_tax_and_shipping: "Totale (incluso l'imposta e la spedizione)",
  vat_percent: "Imposta sulle vendite ({{percent}}%)",
  including_tax: "Incluso IVA al {{percent}}% ({{amount}})"
}, _G = {
  public_pages_purchase: bG
}, wG = {
  "required-field": "フィールドは必須項目です",
  payment: {
    price_plan: "プラン",
    stripe_card: "クレジットカード（Stripe）",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact（Stripe）",
    dlocal_card: "クレジットカード（Dlocal）",
    dlocal_boleto: "Borelo（Dlocal）",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "Paypal",
    mercadopago_card: "クレジットカード (Mercado Pago)",
    mercadopago_pix: "PIX（Mercado Pago）",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay ",
    flutterwave: "Flutterwave ",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "着払い",
    xendit_card: "クレジットカード（Xendit）",
    paystack_card: "クレジットカード（Paystack）",
    paypal_connect: "PayPalに接続",
    paypal_edit_organization_name: "組織名を編集",
    paypal_rest: "ペイパル",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Appleペイ",
    xendit: {
      "3ds": "3Dセキュア"
    }
  },
  error: "エラー",
  "Payment-method": "支払い方法",
  price_plan: {
    trial_period: {
      week: `{{count}}週

{{count}}週`,
      day: `{{count}} 日

{{count}} 日`,
      month: `{{count}}ヶ月

{{count}}ヶ月`,
      year: `{{count}}年

{{count}}年`
    },
    interval: {
      month: `ヶ月

{{count}}ヶ月`,
      day: `日

{{count}} 日`,
      week: `週

{{count}}週`,
      year: `年

{{count}}年`
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "無料",
        trial_period_new: "{{ trialPeriodPrice }}を{{ trialInterval }}間ご利用いただけます。その後は",
        unlimited_new: "{{interval}}ごとに<bold>{{amount}}</bold>",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 回"
      }
    }
  },
  affiliate_badge: {
    made_with: "提供元"
  },
  form_select: {
    empty_list: "このリストが空のようです",
    select: "選択する"
  },
  contact_slug: {
    email: "Eメール",
    first_name: "名",
    last_name: "苗字",
    phone_number: "電話番号",
    country: "国",
    street_address: "住所",
    city: "市",
    postal_code: "郵便番号",
    company_name: "法人名",
    tax_number: "納税者番号",
    state_province: "州/都道府県",
    street_number: "番地",
    neighborhood: "近隣地域"
  },
  date_picker: {
    apply: "適用",
    clear: "消去",
    time: "時",
    all_time: "全期間",
    last_3_months: "過去3ヶ月",
    last_pool_period: "最後の評価期間",
    last_month: "先月",
    this_month: "今月",
    last_30_days: "過去30日",
    title_dates: "日",
    from: "から",
    to: "へ"
  },
  copy_clipboard: "クリップボードにコピーされました",
  payment_inputs: {
    empty_card_number: "カード番号を入力",
    invalid_card_number: "カード番号が無効です",
    empty_expiry_date: "有効期限を入力してください。",
    month_out_of_range: "有効期限の月は、1月から12月の間である必要があります。",
    year_out_of_range: "有効期限の年は過去にすることはできません。",
    date_out_of_range: "有効期限は過去の日付にすることはできません。",
    invalid_expiry_date: "有効期限が無効です",
    invalid_cvc: "CVCが無効です",
    empty_cvc: "CVCを入力",
    card_number_placeholder: "カード番号",
    expiry_data_placeholder: "月/年",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "カード所有者",
    empty_card_holder: "カード所有者の名前を入力してください"
  },
  copy_clipboard_error: "テキストのコピーに失敗しました",
  input: {
    phone_number: "電話番号",
    phone_search: "検索",
    search: "検索"
  },
  "registered-over": "登録された",
  locale: {
    french: "フランス語",
    german: "ドイツ語",
    italian: "イタリア語",
    dutch: "オランダ語",
    english: "英語",
    portuguese: "ポルトガル語",
    russian: "ロシア語",
    spanish: "スペイン語",
    japanese: "日本語",
    arabic: "アラブ",
    turkish: "トルコ語",
    chinese: "中国語",
    swedish: "スウェーデン語",
    romanian: "ルーマニア語",
    czech: "チェコ語",
    hungarian: "ハンガリー語",
    slovak: "スロバキア語",
    danish: "デンマーク語",
    indonesian: "インドネシア語",
    polish: "ポーランド語",
    greek: "ギリシャ語",
    serbian: "セルビア語",
    hindi: "ヒンズー語",
    norwegian: "ノルウェー語",
    thai: "タイ語",
    slovenian: "スロバニア語",
    ukrainian: "ウクライナ語",
    albania: "アルバニア語"
  },
  product: "商品",
  quantity: "数量",
  order_summary: "ご注文概要",
  vat: "消費税",
  total: "合計",
  subtotal: "小計",
  shipping: {
    shipping_method: "配送方法",
    not_available: "おっと！この地域への配送にはまだ対応していないようです。",
    condition_label: {
      price: "価格が{{min}}{{currency}}から{{max}}{{currency}}のご注文",
      price_min: "価格が{{min}}{{currency}}以上のご注文",
      quantity: "商品の個数が{{min}}個から{{max}}個までのご注文",
      quantity_min: "{{min}}個以上の商品を含むご注文",
      weight: "合計重量が{{min}}gから{{max}}gまでのご注文",
      weight_min: "合計重量が{{min}}g以上のご注文"
    }
  },
  shipping_fee: "配送料",
  total_amount_with_tax_and_shipping: "合計（税金と配送料を含む）",
  vat_percent: "消費税（{{percent}}％）",
  including_tax: "消費税（{{amount}}）を含む{{percent}}％"
}, SG = {
  public_pages_purchase: wG
}, CG = {
  "required-field": "Veld is vereist",
  payment: {
    price_plan: "Plan",
    stripe_card: "Creditcards (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Creditcards (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlokaal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Creditcards (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Contant bij levering",
    xendit_card: "Creditcards (Xendit)",
    paystack_card: "Creditcards (Paystack)",
    paypal_connect: "Verbind PayPal",
    paypal_edit_organization_name: "Organisatienaam bewerken",
    paypal_rest: "PayPal",
    secure_and_pay: "Beveiligd betalen",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fout",
  "Payment-method": "Betaalmethode",
  price_plan: {
    trial_period: {
      week: "{{count}} week",
      week_plural: "{{count}} weken",
      day: "{{count}} dag",
      day_plural: "{{count}} dagen",
      month: "{{count}} maand",
      month_plural: "{{count}} maanden",
      year: "{{count}} jaar",
      year_plural: "{{count}} jaren"
    },
    interval: {
      month: "maand",
      month_plural: "{{count}} maanden",
      day: "dag",
      day_plural: "{{count}} dagen",
      week: "week",
      week_plural: "{{count}} weken",
      year: "jaar",
      year_plural: "{{count}} jaren"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} voor {{ trialInterval }} dan",
        unlimited_new: "<bold>{{amount}}</bold> elke {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} keer"
      }
    }
  },
  affiliate_badge: {
    made_with: "Ondersteund door"
  },
  form_select: {
    empty_list: "Het lijkt erop dat deze lijst leeg is",
    select: "Selecteer"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Voornaam",
    last_name: "Achternaam",
    phone_number: "Telefoonnummer",
    country: "Land",
    street_address: "Straatadres",
    city: "Plaats",
    postal_code: "Postcode",
    company_name: "Bedrijfsnaam",
    tax_number: "BTW-nummer",
    state_province: "Staat/Provincie",
    street_number: "Huisnummer",
    neighborhood: "Buurt"
  },
  date_picker: {
    apply: "Toepassen",
    clear: "Wissen",
    time: "Tijd",
    all_time: "Alle tijden",
    last_3_months: "Laatste 3 maanden",
    last_pool_period: "Laatste pool-evaluatieperiode",
    last_month: "Afgelopen maand",
    this_month: "Deze maand",
    last_30_days: "Laatste 30 dagen",
    title_dates: "Datum",
    from: "Van",
    to: "Naar"
  },
  copy_clipboard: "Gekopieerd naar klembord",
  payment_inputs: {
    empty_card_number: "Voer een kaartnummer in",
    invalid_card_number: "Kaartnummer is ongeldig",
    empty_expiry_date: "Voer een vervaldatum in",
    month_out_of_range: "Vervalmaand moet tussen 01 en 12 liggen",
    year_out_of_range: "Vervaljaar mag niet in het verleden liggen",
    date_out_of_range: "Vervaldatum mag niet in het verleden liggen",
    invalid_expiry_date: "Vervaldatum is ongeldig",
    invalid_cvc: "CVC is ongeldig",
    empty_cvc: "Voer een CVC in",
    card_number_placeholder: "Kaartnummer",
    expiry_data_placeholder: "MM/JJ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kaarthouder",
    empty_card_holder: "Voer de naam van de kaarthouder in"
  },
  copy_clipboard_error: "Tekst kopiëren mislukt",
  input: {
    phone_number: "Telefoonnummer",
    phone_search: "Zoek",
    search: "Zoek"
  },
  "registered-over": "geregistreerd over",
  locale: {
    french: "Frans",
    german: "Duits",
    italian: "Italiaans",
    dutch: "Nederlands",
    english: "Engels",
    portuguese: "Portugees",
    russian: "Russisch",
    spanish: "Spaans",
    japanese: "Japans",
    arabic: "Arabisch",
    turkish: "Turks",
    chinese: "Chinees",
    swedish: "Zweeds",
    romanian: "Roemeens",
    czech: "Tsjechisch",
    hungarian: "Hongaars",
    slovak: "Slowaaks",
    danish: "Deens",
    indonesian: "Indonesisch",
    polish: "Pools",
    greek: "Grieks",
    serbian: "Servisch",
    hindi: "Hindi",
    norwegian: "Noors",
    thai: "Thais",
    slovenian: "Sloveens",
    ukrainian: "Oekraïens",
    albania: "Albanees"
  },
  product: "Product",
  quantity: "Aantal",
  order_summary: "Besteloverzicht",
  vat: "Verkoopbelasting",
  total: "Totaal",
  subtotal: "Subtotaal",
  shipping: {
    shipping_method: "Verzendmethode",
    not_available: "Oeps! Het lijkt erop dat we nog geen verzending naar deze locatie aanbieden",
    condition_label: {
      price: "Voor bestellingen geprijsd tussen {{min}} {{currency}} en {{max}} {{currency}}",
      price_min: "Voor bestellingen geprijsd vanaf {{min}} {{currency}} of meer",
      quantity: "Voor bestellingen die tussen de {{min}} en {{max}} artikelen bevatten",
      quantity_min: "Voor bestellingen met {{min}} of meer artikelen",
      weight: "Voor bestellingen met een totaalgewicht tussen {{min}}g en {{max}}g",
      weight_min: "Voor bestellingen met een totaalgewicht van {{min}}g of meer"
    }
  },
  shipping_fee: "Verzendkosten",
  total_amount_with_tax_and_shipping: "Totaal (inclusief BTW en Verzending)",
  vat_percent: "BTW ({{percent}}%)",
  including_tax: "Inclusief {{percent}}% BTW ({{amount}})"
}, xG = {
  public_pages_purchase: CG
}, kG = {
  "required-field": "Felt er obligatorisk",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredittkort (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kredittkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kredittkort (Mercado Pago)",
    mercadopago_pix: "PIX (betalingsmarked)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterbølge",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kontantbetaling ved levering",
    xendit_card: "Kredittkort (Xendit)",
    paystack_card: "Kredittkort (Paystack)",
    paypal_connect: "Koble til PayPal",
    paypal_edit_organization_name: "Rediger organisasjonsnavn",
    paypal_rest: "PayPal",
    secure_and_pay: "Sikker og betal",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Feil",
  "Payment-method": "Betalingsmåte",
  price_plan: {
    trial_period: {
      week: "{{count}} uke",
      week_plural: "{{count}} uker",
      day: "{{count}} dag",
      day_plural: "{{count}} dager",
      month: "{{count}} måned",
      month_plural: "{{count}} måneder",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "måned",
      month_plural: "{{count}} måneder",
      day: "dag",
      day_plural: "{{count}} dager",
      week: "uke",
      week_plural: "{{count}} uker",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} da",
        unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ganger"
      }
    }
  },
  affiliate_badge: {
    made_with: "Drevet av"
  },
  form_select: {
    empty_list: "Det ser ut som denne listen er tom",
    select: "Velg"
  },
  contact_slug: {
    email: "E-post",
    first_name: "Fornavn",
    last_name: "Etternavn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gateadresse",
    city: "By",
    postal_code: "Postnummer",
    company_name: "Firmanavn",
    tax_number: "Skattenummer",
    state_province: "Stat/Provins",
    street_number: "Gate nummer",
    neighborhood: "Nabolag"
  },
  date_picker: {
    apply: "Bruk",
    clear: "Fjern",
    time: "Tid",
    all_time: "All tid",
    last_3_months: "Siste 3 måneder",
    last_pool_period: "Siste evalueringsperiode for basseng",
    last_month: "Siste måned",
    this_month: "Denne måneden",
    last_30_days: "Siste 30 dager",
    title_dates: "Datoer",
    from: "Fra",
    to: "Til"
  },
  copy_clipboard: "Kopiert til utklippstavlen",
  payment_inputs: {
    empty_card_number: "Skriv inn et kortnummer",
    invalid_card_number: "Kortnummeret er ugyldig",
    empty_expiry_date: "Skriv inn en utløpsdato",
    month_out_of_range: "Utløpsmåned må være mellom 01 og 12",
    year_out_of_range: "Utløpsår kan ikke være i fortiden",
    date_out_of_range: "Utløpsdato kan ikke være i fortiden",
    invalid_expiry_date: "Utløpsdato er ugyldig",
    invalid_cvc: "CVC er ugyldig",
    empty_cvc: "Skriv inn en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortholder",
    empty_card_holder: "Skriv inn navnet til kortholderen"
  },
  copy_clipboard_error: "Kunne ikke kopiere tekst",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Søk",
    search: "Søk"
  },
  "registered-over": "registrert over",
  locale: {
    french: "Fransk",
    german: "Tysk",
    italian: "Italiensk",
    dutch: "Nederlandsk",
    english: "Engelsk",
    portuguese: "Portugisisk",
    russian: "Russisk",
    spanish: "Spansk",
    japanese: "Japansk",
    arabic: "Arabisk",
    turkish: "Tyrkisk",
    chinese: "Kinesisk",
    swedish: "Svensk",
    romanian: "Rumensk",
    czech: "Tsjekkisk",
    hungarian: "Ungarsk",
    slovak: "Slovakisk",
    danish: "Dansk",
    indonesian: "Indonesisk",
    polish: "Pusse",
    greek: "Gresk",
    serbian: "Serbisk",
    hindi: "Nei",
    norwegian: "Norsk",
    thai: "Thai",
    slovenian: "Slovensk",
    ukrainian: "Ukrainsk",
    albania: "Albansk"
  },
  product: "Produkt",
  quantity: "Mengde",
  order_summary: "Ordresammendrag",
  vat: "Moms",
  total: "Totalt",
  subtotal: "Delsum",
  shipping: {
    shipping_method: "Fraktmetode",
    not_available: "Oops! Det ser ut som vi ikke tilbyr frakt til dette stedet ennå.",
    condition_label: {
      price: "For bestillinger priset mellom {{min}} {{currency}} og {{max}} {{currency}}",
      price_min: "For bestillinger priset til {{min}} {{currency}} eller mer",
      quantity: "For bestillinger som inneholder mellom {{min}} til {{max}} varer",
      quantity_min: "For bestillinger som inneholder {{min}} eller flere varer",
      weight: "For bestillinger med en totalvekt mellom {{min}}g og {{max}}g",
      weight_min: "For bestillinger med en totalvekt på {{min}}g eller mer"
    }
  },
  shipping_fee: "Fraktgebyr",
  total_amount_with_tax_and_shipping: "Totalt (inkludert skatt og frakt)",
  vat_percent: "Merverdiavgift ({{percent}}%)",
  including_tax: "Inkludert {{percent}}% MVA ({{amount}})"
}, EG = {
  public_pages_purchase: kG
}, PG = {
  "required-field": "Pole jest wymagane",
  payment: {
    price_plan: "Plan",
    stripe_card: "Karty kredytowe (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Karty kredytowe (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Karty kredytowe (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Płatność gotówką przy odbiorze",
    xendit_card: "Karty kredytowe (Xendit)",
    paystack_card: "Karty kredytowe (Paystack)",
    paypal_connect: "Połącz PayPala",
    paypal_edit_organization_name: "Edytuj nazwę organizacji",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Błąd",
  "Payment-method": "Metoda płatności",
  price_plan: {
    trial_period: {
      week_0: "{{count}} tydzień",
      week_1: "{{count}} tygodni",
      week_2: "{{count}} tygodni",
      day_0: "{{count}} dzień",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      month_0: "{{count}} miesiąc",
      month_1: "{{count}} miesięcy",
      month_2: "{{count}} miesięcy",
      year_0: "{{count}} rok",
      year_1: "{{count}} lat",
      year_2: "{{count}} lat"
    },
    interval: {
      month_0: "miesiąc",
      month_1: "{{count}} miesięcy",
      month_2: "{{count}} miesięcy",
      day_0: "dzień",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      week_0: "tydzień",
      week_1: "{{count}} tygodni",
      week_2: "{{count}} tygodni",
      year_0: "rok",
      year_1: "{{count}} lat",
      year_2: "{{count}} lat"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Bezpłatny",
        trial_period_new: "{{ trialPeriodPrice }} dla {{ trialInterval }} potem",
        unlimited_new: "<bold>{{amount}}</bold> każdy {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} razy"
      }
    }
  },
  affiliate_badge: {
    made_with: "Zasilane przez"
  },
  form_select: {
    empty_list: "Wygląda na to, że ta lista jest pusta",
    select: "Wybierz"
  },
  contact_slug: {
    email: "Email",
    first_name: "Imię",
    last_name: "Nazwisko",
    phone_number: "Numer telefonu",
    country: "Kraj",
    street_address: "Adres",
    city: "Miasto",
    postal_code: "Kod pocztowy",
    company_name: "Nazwa firmy",
    tax_number: "Numer identyfikacji podatkowej",
    state_province: "Stan/Województwo",
    street_number: "Numer ulicy",
    neighborhood: "Osiedle"
  },
  date_picker: {
    apply: "Zastosuj",
    clear: "Wyczyść",
    time: "Czas",
    all_time: "Cały czas",
    last_3_months: "Ostatnie 3 miesiące",
    last_pool_period: "Ostatni okres oceny puli",
    last_month: "Ostatni miesiąc",
    this_month: "Ten miesiąc",
    last_30_days: "Ostatnie 30 dni",
    title_dates: "Daty",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Skopiowano do schowka",
  payment_inputs: {
    empty_card_number: "Wprowadź numer karty",
    invalid_card_number: "Numer karty jest nieprawidłowy",
    empty_expiry_date: "Wprowadź datę ważności",
    month_out_of_range: "Miesiąc ważności musi być między 01 a 12",
    year_out_of_range: "Rok ważności nie może być w przeszłości",
    date_out_of_range: "Data ważności nie może być w przeszłości",
    invalid_expiry_date: "Data ważności jest nieprawidłowa",
    invalid_cvc: "CVC jest nieprawidłowy",
    empty_cvc: "Wprowadź CVC",
    card_number_placeholder: "Numer karty",
    expiry_data_placeholder: "MM/RR",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Właściciel karty",
    empty_card_holder: "Wprowadź imię i nazwisko właściciela karty"
  },
  copy_clipboard_error: "Nie udało się skopiować tekstu",
  input: {
    phone_number: "Numer telefonu",
    phone_search: "Szukaj",
    search: "Szukaj"
  },
  "registered-over": "zarejestrowano ponad",
  locale: {
    french: "Francuski",
    german: "Niemiecki",
    italian: "Włoski",
    dutch: "Holenderski",
    english: "Angielski",
    portuguese: "Portugalski",
    russian: "Rosyjski",
    spanish: "Hiszpański",
    japanese: "Japoński",
    arabic: "Arabski",
    turkish: "Turecki",
    chinese: "Chiński",
    swedish: "Szwedzki",
    romanian: "Rumuński",
    czech: "Czeski",
    hungarian: "Węgierski",
    slovak: "Słowacki",
    danish: "Duński",
    indonesian: "Indonezyjski",
    polish: "Polski",
    greek: "Grecki",
    serbian: "Serbski",
    hindi: "Hinduski",
    norwegian: "Norweski",
    thai: "Tajski",
    slovenian: "Słoweński",
    ukrainian: "Ukraiński",
    albania: "Albański"
  },
  product: "Produkt",
  quantity: "Ilość",
  order_summary: "Podsumowanie zamówienia",
  vat: "Podatek od sprzedaży",
  total: "Razem",
  subtotal: "Suma częściowa",
  shipping: {
    shipping_method: "Metoda wysyłki",
    not_available: "Ups! Wygląda na to, że nie oferujemy jeszcze wysyłki do tej lokalizacji.",
    condition_label: {
      price: "Dla zamówień w cenie od {{min}} {{currency}} do {{max}} {{currency}}",
      price_min: "Dla zamówień w cenie {{min}} {{currency}} lub więcej",
      quantity: "Dla zamówień zawierających od {{min}} do {{max}} przedmiotów",
      quantity_min: "Dla zamówień zawierających {{min}} lub więcej przedmiotów",
      weight: "Dla zamówień o łącznej wadze od {{min}}g do {{max}}g",
      weight_min: "Dla zamówień o łącznej wadze {{min}}g lub więcej"
    }
  },
  shipping_fee: "Opłata za wysyłkę",
  total_amount_with_tax_and_shipping: "Razem (w tym podatek i wysyłka)",
  vat_percent: "Podatek od sprzedaży ({{percent}}%)",
  including_tax: "Zawiera {{percent}}% VAT ({{amount}})"
}, TG = {
  public_pages_purchase: PG
}, MG = {
  "required-field": "O campo é obrigatório",
  payment: {
    price_plan: "Plano",
    stripe_card: "Cartão de crédito (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Cartão de crédito (Dlocal)",
    dlocal_boleto: "Boleto bancário (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Cartão de crédito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Pagamento na entrega",
    xendit_card: "Cartão de crédito (Xendit)",
    paystack_card: "Cartão de crédito (Paystack)",
    paypal_connect: "Conectar PayPal",
    paypal_edit_organization_name: "Editar o nome da empresa",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Erro",
  "Payment-method": "Método de pagamento",
  price_plan: {
    trial_period: {
      week: "{{count}} semana",
      week_plural: "{{count}} semanas",
      day: "{{count}} dia",
      day_plural: "{{count}} dias",
      month: "{{count}} mês",
      month_plural: "{{count}} meses",
      year: "{{count}} ano",
      year_plural: "{{count}} anos"
    },
    interval: {
      month: "mês",
      month_plural: "{{count}} meses",
      day: "dia",
      day_plural: "{{count}} dias",
      week: "semana",
      week_plural: "{{count}} semanas",
      year: "ano",
      year_plural: "{{count}} anos"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuito",
        trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} depois",
        unlimited_new: "<bold>{{amount}}</bold> a cada {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} vezes"
      }
    }
  },
  affiliate_badge: {
    made_with: "Desenvolvido por"
  },
  form_select: {
    empty_list: "Parece que essa lista está vazia",
    select: "Selecionar"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nome",
    last_name: "Sobrenome",
    phone_number: "Número de telefone",
    country: "País",
    street_address: "Endereço",
    city: "Cidade",
    postal_code: "Código postal",
    company_name: "Nome da empresa",
    tax_number: "CNPJ/NIF",
    state_province: "Estado/Província",
    street_number: "Número",
    neighborhood: "Bairro"
  },
  date_picker: {
    apply: "Aplicar",
    clear: "Limpar",
    time: "Horário",
    all_time: "Desde o início",
    last_3_months: "Últimos 3 meses",
    last_pool_period: "Último período de avaliação do grupo",
    last_month: "Último mês",
    this_month: "Este mês",
    last_30_days: "Últimos 30 dias",
    title_dates: "Datas",
    from: "De",
    to: "Até"
  },
  copy_clipboard: "Copiado para a área de transferência",
  payment_inputs: {
    empty_card_number: "Insira um número de cartão",
    invalid_card_number: "O número do cartão é inválido",
    empty_expiry_date: "Insira uma data de validade",
    month_out_of_range: "O mês de validade deve estar entre 01 e 12",
    year_out_of_range: "O ano de validade não pode estar no passado",
    date_out_of_range: "A data de validade não pode estar no passado",
    invalid_expiry_date: "A data de validade é inválida",
    invalid_cvc: "O CVV é inválido",
    empty_cvc: "Insira o CVV",
    card_number_placeholder: "Número do cartão",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVV",
    card_holder_placeholder: "Titular do cartão",
    empty_card_holder: "Insira o nome do titular do cartão"
  },
  copy_clipboard_error: "Falha ao copiar o texto",
  input: {
    phone_number: "Número de telefone",
    phone_search: "Pesquisar",
    search: "Pesquisar"
  },
  "registered-over": "registrado há mais de",
  locale: {
    french: "Francês",
    german: "Alemão",
    italian: "Italiano",
    dutch: "Holandês",
    english: "Inglês",
    portuguese: "Português",
    russian: "Russo",
    spanish: "Espanhol",
    japanese: "Japonês",
    arabic: "Árabe",
    turkish: "Turco",
    chinese: "Chinês",
    swedish: "Sueco",
    romanian: "Romeno",
    czech: "Tcheco",
    hungarian: "Húngaro",
    slovak: "Eslovaco",
    danish: "Dinamarquês",
    indonesian: "Indonésio",
    polish: "Polonês",
    greek: "Grego",
    serbian: "Sérvio",
    hindi: "Hindi",
    norwegian: "Norueguês",
    thai: "Tailandês",
    slovenian: "Esloveno",
    ukrainian: "Ucraniano",
    albania: "Albanês"
  },
  product: "Produto",
  quantity: "Quantidade",
  order_summary: "Resumo do pedido",
  vat: "Imposto",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Método de envio",
    not_available: "Ops! Parece que ainda não oferecemos envio para este local",
    condition_label: {
      price: "Para pedidos com valor entre {{min}} {{currency}} e {{max}} {{currency}}",
      price_min: "Para pedidos com valor de {{min}} {{currency}} ou mais",
      quantity: "Para pedidos contendo entre {{min}} e {{max}} itens",
      quantity_min: "Para pedidos contendo {{min}} ou mais itens",
      weight: "Para pedidos com peso total entre {{min}}g e {{max}}g",
      weight_min: "Para pedidos com peso total de {{min}}g ou mais"
    }
  },
  shipping_fee: "Taxa de envio",
  total_amount_with_tax_and_shipping: "Total (incluindo imposto e envio)",
  vat_percent: "Imposto ({{percent}}%)",
  including_tax: "Incluindo {{percent}}% de IVA ({{amount}})"
}, OG = {
  public_pages_purchase: MG
}, AG = {
  "required-field": "Câmpul este obligatoriu",
  payment: {
    price_plan: "Plan",
    stripe_card: "Carduri de credit (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (stripe)",
    dlocal_card: "Carduri de credit (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Carduri de credit (Mercado Pago)",
    mercadopago_pix: "PIX (piață de plată)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Plata la livrare",
    xendit_card: "Carduri de credit (Xendit)",
    paystack_card: "Carduri de credit (Paystack)",
    paypal_connect: "Conectați PayPal",
    paypal_edit_organization_name: "Editați numele organizației",
    paypal_rest: "PayPal",
    secure_and_pay: "Securizat și plătiți",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Eroare",
  "Payment-method": "Modalitate de plată",
  price_plan: {
    trial_period: {
      week_0: "{{count}} săptămână",
      week_1: "{{count}} săptămâni",
      week_2: "{{count}} săptămâni",
      day_0: "{{count}} zi",
      day_1: "{{count}} zile",
      day_2: "{{count}} zile",
      month_0: "{{count}} lună",
      month_1: "{{count}} luni",
      month_2: "{{count}} luni",
      year_0: "{{count}} an",
      year_1: "{{count}} ani",
      year_2: "{{count}} ani"
    },
    interval: {
      month_0: "lună",
      month_1: "{{count}} luni",
      month_2: "{{count}} luni",
      day_0: "zi",
      day_1: "{{count}} zile",
      day_2: "{{count}} zile",
      week_0: "săptămână",
      week_1: "{{count}} săptămâni",
      week_2: "{{count}} săptămâni",
      year_0: "an",
      year_1: "{{count}} ani",
      year_2: "{{count}} ani"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuit",
        trial_period_new: "{{ trialPeriodPrice }} pentru {{ trialInterval }} atunci",
        unlimited_new: "<bold>{{amount}}</bold> la fiecare {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - de {{ count }} ori"
      }
    }
  },
  affiliate_badge: {
    made_with: "Realizat de"
  },
  form_select: {
    empty_list: "Se pare că această listă este goală",
    select: "Selectați"
  },
  contact_slug: {
    email: "Email",
    first_name: "Prenume",
    last_name: "Nume de familie",
    phone_number: "Număr de telefon",
    country: "Țară",
    street_address: "Adresă",
    city: "Oraș",
    postal_code: "Cod poștal",
    company_name: "Numele companiei",
    tax_number: "Număr de identificare fiscală",
    state_province: "Stat/Provincie",
    street_number: "Numărul străzii",
    neighborhood: "Cartier"
  },
  date_picker: {
    apply: "Aplică",
    clear: "Șterge",
    time: "Timp",
    all_time: "Tot timpul",
    last_3_months: "Ultimele 3 luni",
    last_pool_period: "Ultima perioadă de evaluare a grupului",
    last_month: "Luna trecută",
    this_month: "Luna aceasta",
    last_30_days: "Ultimele 30 de zile",
    title_dates: "Date",
    from: "De la",
    to: "Către"
  },
  copy_clipboard: "Copiat în clipboard",
  payment_inputs: {
    empty_card_number: "Introduceți un număr de card",
    invalid_card_number: "Numărul cardului este invalid",
    empty_expiry_date: "Introduceți o dată de expirare",
    month_out_of_range: "Luna de expirare trebuie să fie între 01 și 12",
    year_out_of_range: "Anul de expirare nu poate fi în trecut",
    date_out_of_range: "Data de expirare nu poate fi în trecut",
    invalid_expiry_date: "Data de expirare este invalidă",
    invalid_cvc: "CVC este invalid",
    empty_cvc: "Introduceți un CVC",
    card_number_placeholder: "Numărul cardului",
    expiry_data_placeholder: "LL/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titularul cardului",
    empty_card_holder: "Introduceți un nume al titularului cardului"
  },
  copy_clipboard_error: "Copierea textului a eșuat",
  input: {
    phone_number: "Număr de telefon",
    phone_search: "Căutare",
    search: "Caută"
  },
  "registered-over": "înregistrat peste",
  locale: {
    french: "Limba franceza",
    german: "Limba germana",
    italian: "Italiană",
    dutch: "Olandeză",
    english: "Engleză",
    portuguese: "Portugheză",
    russian: "Rusă",
    spanish: "Spaniolă",
    japanese: "Japonez",
    arabic: "Arabic",
    turkish: "Turc",
    chinese: "Chinez",
    swedish: "Suedez",
    romanian: "Română",
    czech: "Ceh",
    hungarian: "Maghiară",
    slovak: "Slovacă",
    danish: "Danez",
    indonesian: "Indoneziană",
    polish: "Lustrui",
    greek: "Greacă",
    serbian: "Sârb",
    hindi: "Nu",
    norwegian: "Norvegian",
    thai: "Thailandez",
    slovenian: "Slovenă",
    ukrainian: "Ucrainean",
    albania: "Albanez"
  },
  product: "Produs",
  quantity: "Cantitate",
  order_summary: "Rezumatul comenzii",
  vat: "Taxa pe vânzări",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Metoda de livrare",
    not_available: "Ups! Se pare că nu oferim livrare în această locație încă.",
    condition_label: {
      price: "Pentru comenzi cu prețuri între {{min}} {{currency}} și {{max}} {{currency}}",
      price_min: "Pentru comenzi cu prețuri de {{min}} {{currency}} sau mai mult",
      quantity: "Pentru comenzi care conțin între {{min}} și {{max}} articole",
      quantity_min: "Pentru comenzi care conțin {{min}} sau mai multe articole",
      weight: "Pentru comenzi cu o greutate totală între {{min}}g și {{max}}g",
      weight_min: "Pentru comenzi cu o greutate totală de {{min}}g sau mai mult"
    }
  },
  shipping_fee: "Taxa de livrare",
  total_amount_with_tax_and_shipping: "Total (inclusiv taxe și livrare)",
  vat_percent: "Taxa pe vânzări ({{percent}}%)",
  including_tax: "Incluzând TVA de {{percent}}% ({{amount}})"
}, NG = {
  public_pages_purchase: AG
}, LG = {
  "required-field": "Поле обязательно для заполнения",
  payment: {
    price_plan: "План",
    stripe_card: "Разрешить оплату кредитной картой",
    stripe_ideal: "Разрешить платежи через iDeal",
    stripe_bancotact: "Разрешить платежи через BanContact",
    dlocal_card: "Кредитные карты (Dlocal)",
    dlocal_boleto: "Заготовка (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "Разрешить платежи PayPal",
    mercadopago_card: "Кредитные карты",
    mercadopago_pix: "PIX (Платный рынок)",
    mercadopago_boleto: "Билет (Платный рынок)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Оплата наличными при доставке",
    xendit_card: "Кредитные карты (Xendit)",
    paystack_card: "Кредитные карты (Paystack)",
    paypal_connect: "Подключить PayPal",
    paypal_edit_organization_name: "Изменить название организации",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Ошибка",
  "Payment-method": "Способ оплаты",
  price_plan: {
    trial_period: {
      week_0: "{{count}} неделя",
      week_1: "{{count}} недели",
      week_2: "{{count}} недель",
      day_0: "день",
      day_1: "{{count}} дней",
      day_2: "{{count}} дни",
      month_0: "месяц",
      month_1: "{{count}} месяца",
      month_2: "{{count}} месяцев",
      year_0: "год",
      year_1: "{{count}} года",
      year_2: "{{count}} лет"
    },
    interval: {
      month_0: "месяц",
      month_1: "{{count}} месяцы",
      month_2: "{{count}} месяца",
      day_0: "день",
      day_1: "{{count}} дней",
      day_2: "{{count}} дни",
      week_0: "неделя",
      week_1: "{{count}} недели",
      week_2: "{{count}} неделями",
      year_0: "год",
      year_1: "{{count}} годы",
      year_2: "{{count}} лет"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Бесплатно",
        trial_period_new: "{{ trialPeriodPrice }} для {{ trialInterval }} затем",
        unlimited_new: "<bold>{{amount}}</bold> каждый {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} раз"
      }
    }
  },
  affiliate_badge: {
    made_with: "Создано с "
  },
  form_select: {
    empty_list: "Похоже, что этот список пуст.",
    select: "Выбрать"
  },
  contact_slug: {
    email: "Почта",
    first_name: "Имя",
    last_name: "Фамилия",
    phone_number: "Номер телефона",
    country: "Страна",
    street_address: "Адрес",
    city: "Город",
    postal_code: "Почтовый индекс",
    company_name: "Название компании",
    tax_number: "Налоговый номер",
    state_province: "Штат/Область",
    street_number: "Номер улицы",
    neighborhood: "Соседство"
  },
  date_picker: {
    apply: "Применить",
    clear: "Очистить",
    time: "Время",
    all_time: "Все время",
    last_3_months: "Последние 3 месяца",
    last_pool_period: "Последний период оценки пула",
    last_month: "Последний месяц",
    this_month: "В этом месяце",
    last_30_days: "Последние 30 дней",
    title_dates: "Даты",
    from: "От",
    to: "В"
  },
  copy_clipboard: "Номер карты недействителен",
  payment_inputs: {
    empty_card_number: "Введите номер карты",
    invalid_card_number: "Номер карты недействителен",
    empty_expiry_date: "Введите дату окончания срока действия",
    month_out_of_range: "Месяц окончания срока действия должен быть между 01 и 12",
    year_out_of_range: "Год окончания срока действия не может быть в прошлом",
    date_out_of_range: "Дата окончания срока действия не может быть в прошлом",
    invalid_expiry_date: "Срок годности недействителен",
    invalid_cvc: "CVC код неправильный",
    empty_cvc: "Введите CVC код",
    card_number_placeholder: "Номер карты",
    expiry_data_placeholder: "М/Г",
    cvc_placeholder: "CVC код",
    card_holder_placeholder: "Держатель карты",
    empty_card_holder: "Введите имя держателя карты"
  },
  copy_clipboard_error: "Не удалось скопировать текст",
  input: {
    phone_number: "Номер телефона",
    phone_search: "Поиск",
    search: "Поиск"
  },
  "registered-over": "зарегистрировано более чем",
  locale: {
    french: "Французский",
    german: "Немецкий",
    italian: "Итальянский",
    dutch: "Голландский",
    english: "Английский",
    portuguese: "Португальский",
    russian: "Русский",
    spanish: "Испанский",
    japanese: "Японский",
    arabic: "Арабский",
    turkish: "Турецкий",
    chinese: "Китайский",
    swedish: "Шведский",
    romanian: "Румынский",
    czech: "Чешский",
    hungarian: "Венгерский",
    slovak: "Словацкий",
    danish: "Датский",
    indonesian: "Индонезийский",
    polish: "Польский",
    greek: "Греческий",
    serbian: "Сербский",
    hindi: "Хинди",
    norwegian: "Норвежский",
    thai: "Тайский",
    slovenian: "Словенский",
    ukrainian: "Украинский",
    albania: "Албанский"
  },
  product: "Продукт",
  quantity: "Количество",
  order_summary: "Итог заказа",
  vat: "Налог с продаж",
  total: "Итого",
  subtotal: "Промежуточный итог",
  shipping: {
    shipping_method: "Способ доставки",
    not_available: "Упс! Похоже, что мы еще не предлагаем доставку в это место.",
    condition_label: {
      price: "Для заказов стоимостью от {{min}} {{currency}} до {{max}} {{currency}}",
      price_min: "Для заказов стоимостью {{min}} {{currency}} или более",
      quantity: "Для заказов, содержащих от {{min}} до {{max}} товаров",
      quantity_min: "Для заказов, содержащих {{min}} или более товаров",
      weight: "Для заказов с общим весом от {{min}}g до {{max}}g",
      weight_min: "Для заказов с общим весом {{min}}g или более"
    }
  },
  shipping_fee: "Стоимость доставки",
  total_amount_with_tax_and_shipping: "Итого (включая налог и доставку)",
  vat_percent: "Налог с продаж ({{percent}}%)",
  including_tax: "Включая {{percent}}% НДС ({{amount}})"
}, RG = {
  public_pages_purchase: LG
}, DG = {
  "required-field": "Pole je povinné",
  payment: {
    price_plan: "Plán",
    stripe_card: "Kreditné karty (Stripe)",
    stripe_ideal: "iDeal (pruh)",
    stripe_bancotact: "Bancontact (pruh)",
    dlocal_card: "Kreditné karty (miestne)",
    dlocal_boleto: "Boleto (miestne)",
    dlocal_pix: "Pix (miestne)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditné karty (Mercado Pago)",
    mercadopago_pix: "PIX (Platobný trh)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Platba na dobierku",
    xendit_card: "Kreditné karty (Xendit)",
    paystack_card: "Kreditné karty (Paystack)",
    paypal_connect: "Pripojte PayPal",
    paypal_edit_organization_name: "Upravte názov organizácie",
    paypal_rest: "PayPal",
    secure_and_pay: "Zabezpečiť a zaplatiť",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Chyba",
  "Payment-method": "Spôsob platby",
  price_plan: {
    trial_period: {
      week_0: "{{count}} týždeň",
      week_1: "{{count}} týždňov",
      week_2: "{{count}} týždňov",
      day_0: "{{count}} deň",
      day_1: "{{count}} dní",
      day_2: "{{count}} dní",
      month_0: "{{count}} mesiac",
      month_1: "{{count}} mesiacov",
      month_2: "{{count}} mesiacov",
      year_0: "{{count}} rok",
      year_1: "{{count}} rokov",
      year_2: "{{count}} rokov"
    },
    interval: {
      month_0: "mesiac",
      month_1: "{{count}} mesiacov",
      month_2: "{{count}} mesiacov",
      day_0: "deň",
      day_1: "{{count}} dní",
      day_2: "{{count}} dní",
      week_0: "týždeň",
      week_1: "{{count}} týždňov",
      week_2: "{{count}} týždňov",
      year_0: "rok",
      year_1: "{{count}} rokov",
      year_2: "{{count}} rokov"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Zadarmo",
        trial_period_new: "Potom {{ trialPeriodPrice }} za {{ trialInterval }}",
        unlimited_new: "<bold>{{amount}}</bold> každých {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krát"
      }
    }
  },
  affiliate_badge: {
    made_with: "Poháňané"
  },
  form_select: {
    empty_list: "Zdá sa, že tento zoznam je prázdny",
    select: "Vybrať"
  },
  contact_slug: {
    email: "Email",
    first_name: "Meno",
    last_name: "Priezvisko",
    phone_number: "Telefónne číslo",
    country: "Krajina",
    street_address: "Ulica",
    city: "Mesto",
    postal_code: "PSČ",
    company_name: "Názov spoločnosti",
    tax_number: "Daňové číslo",
    state_province: "Štát/Provincie",
    street_number: "Číslo ulice",
    neighborhood: "Štvrť"
  },
  date_picker: {
    apply: "Použiť",
    clear: "Vymazať",
    time: "Čas",
    all_time: "Celý čas",
    last_3_months: "Posledné 3 mesiace",
    last_pool_period: "Posledné hodnotenie bazéna",
    last_month: "Minulý mesiac",
    this_month: "Tento mesiac",
    last_30_days: "Posledných 30 dní",
    title_dates: "Dátumy",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Skopírované do schránky",
  payment_inputs: {
    empty_card_number: "Zadajte číslo karty",
    invalid_card_number: "Číslo karty je neplatné",
    empty_expiry_date: "Zadajte dátum expirácie",
    month_out_of_range: "Mesiac expirácie musí byť medzi 01 a 12",
    year_out_of_range: "Rok expirácie nemôže byť v minulosti",
    date_out_of_range: "Dátum expirácie nemôže byť v minulosti",
    invalid_expiry_date: "Dátum expirácie je neplatný",
    invalid_cvc: "CVC je neplatný",
    empty_cvc: "Zadajte CVC",
    card_number_placeholder: "Číslo karty",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Držiteľ karty",
    empty_card_holder: "Zadajte meno držiteľa karty"
  },
  copy_clipboard_error: "Nepodarilo sa skopírovať text",
  input: {
    phone_number: "Telefónne číslo",
    phone_search: "Hľadať",
    search: "Hľadať"
  },
  "registered-over": "registrované viac ako",
  locale: {
    french: "Francúzsky",
    german: "Nemecký",
    italian: "Taliansky",
    dutch: "Holandský",
    english: "Angličtina",
    portuguese: "Portugalčina",
    russian: "Ruský",
    spanish: "španielčina",
    japanese: "Japončina",
    arabic: "Arabčina",
    turkish: "Turecký",
    chinese: "čínsky",
    swedish: "švédsky",
    romanian: "Rumunský",
    czech: "český",
    hungarian: "Maďarský",
    slovak: "Slovenský",
    danish: "Dánčina",
    indonesian: "Indonézsky",
    polish: "Poľský",
    greek: "Grécky",
    serbian: "Srbský",
    hindi: "Nie",
    norwegian: "Nórsky",
    thai: "Thajčina",
    slovenian: "Slovensky",
    ukrainian: "Ukrajinčina",
    albania: "Albánsky"
  },
  product: "Produkt",
  quantity: "Množstvo",
  order_summary: "Zhrnutie objednávky",
  vat: "Daň z predaja",
  total: "Celkom",
  subtotal: "Medzisúčet",
  shipping: {
    shipping_method: "Spôsob dopravy",
    not_available: "Ups! Vyzerá to, že na túto lokalitu zatiaľ nenabízame dopravu.",
    condition_label: {
      price: "Pre objednávky v cene medzi {{min}} {{currency}} a {{max}} {{currency}}",
      price_min: "Pre objednávky v cene {{min}} {{currency}} alebo viac",
      quantity: "Pre objednávky obsahujúce medzi {{min}} a {{max}} položkami",
      quantity_min: "Pre objednávky obsahujúce {{min}} alebo viac položiek",
      weight: "Pre objednávky s celkovou hmotnosťou medzi {{min}}g a {{max}}g",
      weight_min: "Pre objednávky s celkovou hmotnosťou {{min}}g alebo viac"
    }
  },
  shipping_fee: "Poplatok za dopravu",
  total_amount_with_tax_and_shipping: "Celkom (vrátane dane a dopravy)",
  vat_percent: "Daň z predaja ({{percent}}%)",
  including_tax: "Vrátane DPH {{percent}}% ({{amount}})"
}, IG = {
  public_pages_purchase: DG
}, jG = {
  "required-field": "Polje je obvezno",
  payment: {
    price_plan: "Načrtujte",
    stripe_card: "Kreditne kartice (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditne kartice (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditne kartice (Mercado Pago)",
    mercadopago_pix: "PIX (plačilni trg)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Gotovino po povzetju",
    xendit_card: "Kreditne kartice (Xendit)",
    paystack_card: "Kreditne kartice (Paystack)",
    paypal_connect: "Povežite PayPal",
    paypal_edit_organization_name: "Uredi ime organizacije",
    paypal_rest: "PayPal",
    secure_and_pay: "Zavarujte in plačajte",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Napaka",
  "Payment-method": "Način plačila",
  price_plan: {
    trial_period: {
      week_0: "{{count}} teden",
      week_1: "{{count}} tednov",
      week_2: "{{count}} tednov",
      week_3: "{{count}} tednov",
      day_0: "{{count}} dan",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      day_3: "{{count}} dni",
      month_0: "{{count}} mesec",
      month_1: "{{count}} mesecev",
      month_2: "{{count}} mesecev",
      month_3: "{{count}} mesecev",
      year_0: "{{count}} leto",
      year_1: "{{count}} let",
      year_2: "{{count}} let",
      year_3: "{{count}} let"
    },
    interval: {
      month_0: "mesec",
      month_1: "{{count}} mesecev",
      month_2: "{{count}} mesecev",
      month_3: "{{count}} mesecev",
      day_0: "dan",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      day_3: "{{count}} dni",
      week_0: "teden",
      week_1: "{{count}} tednov",
      week_2: "{{count}} tednov",
      week_3: "{{count}} tednov",
      year_0: "leto",
      year_1: "{{count}} let",
      year_2: "{{count}} let",
      year_3: "{{count}} let"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Brezplačno",
        trial_period_new: "{{ trialPeriodPrice }} za {{ trialInterval }} potem",
        unlimited_new: "<bold>{{amount}}</bold> vsak {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krat"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Zdi se, da je ta seznam prazen",
    select: "Izberi"
  },
  contact_slug: {
    email: "E-pošta",
    first_name: "Ime",
    last_name: "Priimek",
    phone_number: "Telefonska številka",
    country: "Država",
    street_address: "Ulična naslov",
    city: "Mesto",
    postal_code: "Poštna številka",
    company_name: "Ime podjetja",
    tax_number: "Davčna številka",
    state_province: "Država/Provinca",
    street_number: "Številka ulice",
    neighborhood: "Soseska"
  },
  date_picker: {
    apply: "Uporabi",
    clear: "Počisti",
    time: "Čas",
    all_time: "Vse čase",
    last_3_months: "Zadnja 3 meseca",
    last_pool_period: "Zadnje obdobje ocenjevanja bazena",
    last_month: "Zadnji mesec",
    this_month: "Ta mesec",
    last_30_days: "Zadnjih 30 dni",
    title_dates: "Datumi",
    from: "Iz",
    to: "Do"
  },
  copy_clipboard: "Kopirano v odložišče",
  payment_inputs: {
    empty_card_number: "Vnesite številko kartice",
    invalid_card_number: "Številka kartice je neveljavna",
    empty_expiry_date: "Vnesite datum poteka",
    month_out_of_range: "Mesec poteka mora biti med 01 in 12",
    year_out_of_range: "Leto poteka ne more biti v preteklosti",
    date_out_of_range: "Datum poteka ne more biti v preteklosti",
    invalid_expiry_date: "Datum poteka je neveljaven",
    invalid_cvc: "CVC je neveljaven",
    empty_cvc: "Vnesite CVC",
    card_number_placeholder: "Številka kartice",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Imetnik kartice",
    empty_card_holder: "Vnesite ime imetnika kartice"
  },
  copy_clipboard_error: "Kopiranje besedila ni uspelo",
  input: {
    phone_number: "Telefonska številka",
    phone_search: "Iskanje",
    search: "Iskanje"
  },
  "registered-over": "registrirani več kot",
  locale: {
    french: "Francosko",
    german: "Nemški",
    italian: "Italijanski",
    dutch: "Nizozemščina",
    english: "Angleščina",
    portuguese: "Portugalščina",
    russian: "Ruski",
    spanish: "španski",
    japanese: "Japonska",
    arabic: "Arabsko",
    turkish: "Turško",
    chinese: "Kitajski",
    swedish: "švedščina",
    romanian: "Romunščina",
    czech: "češki",
    hungarian: "Madžarski",
    slovak: "Slovaški",
    danish: "Danščina",
    indonesian: "Indonezijski",
    polish: "Poljski",
    greek: "Grški",
    serbian: "Srbsko",
    hindi: "Ne",
    norwegian: "Norveški",
    thai: "Tajska",
    slovenian: "Slovenščina",
    ukrainian: "Ukrajinski",
    albania: "Albanski"
  },
  product: "Izdelek",
  quantity: "Količina",
  order_summary: "Povzetek naročila",
  vat: "Davek na prodajo",
  total: "Skupaj",
  subtotal: "Medseštevek",
  shipping: {
    shipping_method: "Način dostave",
    not_available: "Oups! Zdi se, da še ne ponujamo dostave na to lokacijo.",
    condition_label: {
      price: "Za naročila v vrednosti med {{min}} {{currency}} in {{max}} {{currency}}",
      price_min: "Za naročila v vrednosti {{min}} {{currency}} ali več",
      quantity: "Za naročila, ki vsebujejo med {{min}} in {{max}} artikli",
      quantity_min: "Za naročila, ki vsebujejo {{min}} ali več artiklov",
      weight: "Za naročila s skupno težo med {{min}}g in {{max}}g",
      weight_min: "Za naročila s skupno težo {{min}}g ali več"
    }
  },
  shipping_fee: "Strošek dostave",
  total_amount_with_tax_and_shipping: "Skupaj (vključno z davkom in dostavo)",
  vat_percent: "Davek na prodajo ({{percent}}%)",
  including_tax: "Vključeno {{percent}}% DDV ({{amount}})"
}, BG = {
  public_pages_purchase: jG
}, FG = {
  "required-field": "Fusha kërkohet",
  payment: {
    price_plan: "Planifikoni",
    stripe_card: "Kartat e kreditit (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (shirit)",
    dlocal_card: "Kartat e kreditit (Dlokale)",
    dlocal_boleto: "Boleto (lokale)",
    dlocal_pix: "Pix (vendor)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kartat e kreditit (Mercado Pago)",
    mercadopago_pix: "PIX (Tregu i Pagesave)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Pa kartë",
    cash_on_delivery: "Para ne dore gjate dorezimit",
    xendit_card: "Kartat e kreditit (Xendit)",
    paystack_card: "Kartat e kreditit (Paystack)",
    paypal_connect: "Lidhni PayPal",
    paypal_edit_organization_name: "Redakto emrin e organizatës",
    paypal_rest: "PayPal",
    secure_and_pay: "Siguro dhe Paguaj",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Gabim",
  "Payment-method": "Mënyra e pagesës",
  price_plan: {
    trial_period: {
      week: "{{count}} javë",
      week_plural: "{{count}} javë",
      day: "{{count}} ditë",
      day_plural: "{{count}} ditë",
      month: "{{count}} muaj",
      month_plural: "{{count}} muaj",
      year: "{{count}} vit",
      year_plural: "{{count}} vjet"
    },
    interval: {
      month: "muaj",
      month_plural: "{{count}} muaj",
      day: "ditë",
      day_plural: "{{count}} ditë",
      week: "javë",
      week_plural: "{{count}} javë",
      year: "vit",
      year_plural: "{{count}} vjet"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Falas",
        trial_period_new: "{{ trialPeriodPrice }} për {{ trialInterval }} pastaj",
        unlimited_new: "<bold>{{amount}}</bold> çdo {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} herë"
      }
    }
  },
  affiliate_badge: {
    made_with: "E fuqizuar nga"
  },
  form_select: {
    empty_list: "Duket se kjo listë është bosh",
    select: "Zgjidhni"
  },
  contact_slug: {
    email: "Email",
    first_name: "Emri i parë",
    last_name: "Mbiemri",
    phone_number: "Numri i telefonit",
    country: "Shteti",
    street_address: "Adresa e rrugës",
    city: "Qyteti",
    postal_code: "Kodi postar",
    company_name: "Emri i kompanisë",
    tax_number: "Numri i tatimit",
    state_province: "Shteti/Provinca",
    street_number: "Numri i rrugës",
    neighborhood: "Lagja"
  },
  date_picker: {
    apply: "Apliko",
    clear: "Pastro",
    time: "Koha",
    all_time: "Të gjitha kohët",
    last_3_months: "3 muajt e fundit",
    last_pool_period: "Periudha e fundit e vlerësimit të grupit",
    last_month: "Muaji i kaluar",
    this_month: "Ky muaj",
    last_30_days: "30 ditët e fundit",
    title_dates: "Datat",
    from: "Nga",
    to: "Në"
  },
  copy_clipboard: "Kopjuhet në clipboard",
  payment_inputs: {
    empty_card_number: "Shkruani një numër kartelash",
    invalid_card_number: "Numri i kartelës është i pavlefshëm",
    empty_expiry_date: "Shkruani një datë skadimi",
    month_out_of_range: "Muaji i skadimit duhet të jetë midis 01 dhe 12",
    year_out_of_range: "Viti i skadencës nuk mund të jetë në të kaluarën",
    date_out_of_range: "Data e skadencës nuk mund të jetë në të kaluarën",
    invalid_expiry_date: "Data e skadencës është e pavlefshme",
    invalid_cvc: "CVC është i pavlefshëm",
    empty_cvc: "Shkruani një CVC",
    card_number_placeholder: "Numri i kartës",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Emri i mbajtësit të kartës",
    empty_card_holder: "Shkruani emrin e mbajtësit të kartës"
  },
  copy_clipboard_error: "Dështoi të kopjohet teksti",
  input: {
    phone_number: "Numri i telefonit",
    phone_search: "Kërko",
    search: "Kërko"
  },
  "registered-over": "regjistruar mbi",
  locale: {
    french: "Frëngjisht",
    german: "Gjermane",
    italian: "Italisht",
    dutch: "Holandeze",
    english: "Anglisht",
    portuguese: "Portugeze",
    russian: "Rusisht",
    spanish: "Spanjisht",
    japanese: "Japoneze",
    arabic: "Arabisht",
    turkish: "Turk",
    chinese: "Kineze",
    swedish: "Suedeze",
    romanian: "Rumun",
    czech: "çeke",
    hungarian: "Hungareze",
    slovak: "Sllovake",
    danish: "Daneze",
    indonesian: "Indonezisht",
    polish: "Polonisht",
    greek: "Greke",
    serbian: "Serb",
    hindi: "Jo",
    norwegian: "Norvegjeze",
    thai: "Thai",
    slovenian: "Slloven",
    ukrainian: "Ukrainase",
    albania: "Shqiptare"
  },
  product: "Produkt",
  quantity: "Sasia",
  order_summary: "Përmbledhja e Porosisë",
  vat: "Tatimi mbi shitjet",
  total: "Totali",
  subtotal: "Nëntotali",
  shipping: {
    shipping_method: "Metoda e Dërgesës",
    not_available: "Ups! Duket se nuk ofrojmë dërgesa në këtë vend akoma.",
    condition_label: {
      price: "Për porositë me çmim midis {{min}} {{currency}} dhe {{max}} {{currency}}",
      price_min: "Për porositë me çmim {{min}} {{currency}} ose më shumë",
      quantity: "Për porositë që përmbajnë midis {{min}} dhe {{max}} artikuj",
      quantity_min: "Për porositë që përmbajnë {{min}} ose më shumë artikuj",
      weight: "Për porositë me një peshë totale midis {{min}}g dhe {{max}}g",
      weight_min: "Për porositë me një peshë totale prej {{min}}g ose më shumë"
    }
  },
  shipping_fee: "Tarifa e dërgesës",
  total_amount_with_tax_and_shipping: "Totali (duke përfshirë taksën dhe dërgesën)",
  vat_percent: "Tatimi mbi shitjet ({{percent}}%)",
  including_tax: "Duke përfshirë TVSH-në {{percent}}% ({{amount}})"
}, zG = {
  public_pages_purchase: FG
}, GG = {
  "required-field": "Поље је обавезно",
  payment: {
    price_plan: "План",
    stripe_card: "Кредитне картице (Стрипе)",
    stripe_ideal: "иДеал (Стрипе)",
    stripe_bancotact: "Банцонтацт (Стрипе)",
    dlocal_card: "Кредитне картице (Длоцал)",
    dlocal_boleto: "Болето (Длоцал)",
    dlocal_pix: "Пик (Длоцал)",
    paypal_soap: "ПаиПал",
    mercadopago_card: "Кредитне картице (Мерцадо Паго)",
    mercadopago_pix: "ПИКС (тржиште плаћања)",
    mercadopago_boleto: "Болето (Меркадо Паго)",
    razorpay: "Разорпаи",
    flutterwave: "Флуттерваве",
    mollie: "Моллие",
    gocardless: "Гоцардлесс",
    cash_on_delivery: "Плаћање поузећем",
    xendit_card: "Кредитне картице (Ксендит)",
    paystack_card: "Кредитне картице (Паистацк)",
    paypal_connect: "Повежите ПаиПал",
    paypal_edit_organization_name: "Измените назив организације",
    paypal_rest: "ПаиПал",
    secure_and_pay: "Осигурајте и платите",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Грешка",
  "Payment-method": "Начин плаћања",
  price_plan: {
    trial_period: {
      week_0: "{{count}} недеља",
      week_1: "{{count}} недеља",
      week_2: "{{count}} недеља",
      day_0: "{{count}} дан",
      day_1: "{{count}} дана",
      day_2: "{{count}} дана",
      month_0: "{{count}} месец",
      month_1: "{{count}} месеци",
      month_2: "{{count}} месеци",
      year_0: "{{count}} година",
      year_1: "{{count}} година",
      year_2: "{{count}} година"
    },
    interval: {
      month_0: "месец",
      month_1: "{{count}} месеци",
      month_2: "{{count}} месеци",
      day_0: "дан",
      day_1: "{{count}} дана",
      day_2: "{{count}} дана",
      week_0: "недељу дана",
      week_1: "{{count}} недеља",
      week_2: "{{count}} недеља",
      year_0: "године",
      year_1: "{{count}} година",
      year_2: "{{count}} година"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Бесплатно",
        trial_period_new: "{{ trialPeriodPrice }} за {{ trialInterval }} онда",
        unlimited_new: "<bold>{{amount}}</bold> сваких {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} пута"
      }
    }
  },
  affiliate_badge: {
    made_with: "Pokreće"
  },
  form_select: {
    empty_list: "Izgleda da je ova lista prazna",
    select: "Izaberi"
  },
  contact_slug: {
    email: "Email",
    first_name: "Ime",
    last_name: "Prezime",
    phone_number: "Broj telefona",
    country: "Zemlja",
    street_address: "Adresa",
    city: "Grad",
    postal_code: "Poštanski broj",
    company_name: "Naziv kompanije",
    tax_number: "Poreski broj",
    state_province: "Država/Provincija",
    street_number: "Broj ulice",
    neighborhood: "Kraj"
  },
  date_picker: {
    apply: "Primeni",
    clear: "Obriši",
    time: "Vreme",
    all_time: "Sve vreme",
    last_3_months: "Poslednja 3 meseca",
    last_pool_period: "Poslednji period evaluacije",
    last_month: "Prošli mesec",
    this_month: "Ovaj mesec",
    last_30_days: "Poslednjih 30 dana",
    title_dates: "Datumi",
    from: "Od",
    to: "Do"
  },
  copy_clipboard: "Kopirano u međuspremnik",
  payment_inputs: {
    empty_card_number: "Unesite broj kartice",
    invalid_card_number: "Broj kartice je nevažeći",
    empty_expiry_date: "Unesite datum isteka",
    month_out_of_range: "Mesec isteka mora biti između 01 i 12",
    year_out_of_range: "Godina isteka ne može biti u prošlosti",
    date_out_of_range: "Datum isteka ne može biti u prošlosti",
    invalid_expiry_date: "Datum isteka je nevažeći",
    invalid_cvc: "CVC je nevažeći",
    empty_cvc: "Unesite CVC",
    card_number_placeholder: "Broj kartice",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Ime vlasnika kartice",
    empty_card_holder: "Unesite ime vlasnika kartice"
  },
  copy_clipboard_error: "Kopiranje teksta nije uspelo",
  input: {
    phone_number: "Broj telefona",
    phone_search: "Pretraži",
    search: "Pretraži"
  },
  "registered-over": "registrovano više od",
  locale: {
    french: "Француски",
    german: "Немачки",
    italian: "Италијан",
    dutch: "холандски",
    english: "енглески језик",
    portuguese: "португалски",
    russian: "Руски",
    spanish: "Шпански",
    japanese: "јапански",
    arabic: "арапски",
    turkish: "турски",
    chinese: "кинески",
    swedish: "Шведски",
    romanian: "румунски",
    czech: "чешки",
    hungarian: "мађарски",
    slovak: "словачки",
    danish: "дански",
    indonesian: "индонезијски",
    polish: "Пољски",
    greek: "грчки",
    serbian: "Српски",
    hindi: "Јок",
    norwegian: "норвешки",
    thai: "тајландски",
    slovenian: "словеначки",
    ukrainian: "украјински",
    albania: "Албанац"
  },
  product: "Proizvod",
  quantity: "Količina",
  order_summary: "Pregled narudžbine",
  vat: "Porez na promet",
  total: "Ukupno",
  subtotal: "Međuzbir",
  shipping: {
    shipping_method: "Metod isporuke",
    not_available: "Ups! Izgleda da još ne nudimo isporuku na ovu lokaciju.",
    condition_label: {
      price: "Za narudžbine u cenovnom rasponu od {{min}} {{currency}} do {{max}} {{currency}}",
      price_min: "Za narudžbine od {{min}} {{currency}} ili više",
      quantity: "Za narudžbine koje sadrže između {{min}} i {{max}} stavki",
      quantity_min: "Za narudžbine koje sadrže {{min}} ili više stavki",
      weight: "Za narudžbine sa ukupnom težinom između {{min}}g i {{max}}g",
      weight_min: "Za narudžbine sa ukupnom težinom od {{min}}g ili više"
    }
  },
  shipping_fee: "Trošak isporuke",
  total_amount_with_tax_and_shipping: "Ukupno (uključujući porez i isporuku)",
  vat_percent: "Porez na promet ({{percent}}%)",
  including_tax: "Uključujući {{percent}}% PDV ({{amount}})"
}, HG = {
  public_pages_purchase: GG
}, KG = {
  "required-field": "Fält är obligatoriskt",
  payment: {
    price_plan: "Planen",
    stripe_card: "Kreditkort (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkort (Mercado Pago)",
    mercadopago_pix: "PIX (betalningsmarknad)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Fluttervåg",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Postförskott",
    xendit_card: "Kreditkort (Xendit)",
    paystack_card: "Kreditkort (Paystack)",
    paypal_connect: "Anslut PayPal",
    paypal_edit_organization_name: "Redigera organisationens namn",
    paypal_rest: "PayPal",
    secure_and_pay: "Säkra och betala",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fel",
  "Payment-method": "Betalningsmetod",
  price_plan: {
    trial_period: {
      week: "{{count}} vecka",
      week_plural: "{{count}} veckor",
      day: "{{count}} dag",
      day_plural: "{{count}} dagar",
      month: "{{count}} månad",
      month_plural: "{{count}} månader",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "månad",
      month_plural: "{{count}} månader",
      day: "dag",
      day_plural: "{{count}} dagar",
      week: "vecka",
      week_plural: "{{count}} veckor",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} för {{ trialInterval }} sedan",
        unlimited_new: "<bold>{{amount}}</bold> varje {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gånger"
      }
    }
  },
  affiliate_badge: {
    made_with: "Drivs av"
  },
  form_select: {
    empty_list: "Det verkar som att denna lista är tom",
    select: "Välj"
  },
  contact_slug: {
    email: "E-post",
    first_name: "Förnamn",
    last_name: "Efternamn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gatuadress",
    city: "Stad",
    postal_code: "Postnummer",
    company_name: "Företagsnamn",
    tax_number: "Skattenummer",
    state_province: "Stat/Provins",
    street_number: "Gatu nummer",
    neighborhood: "Grannskap"
  },
  date_picker: {
    apply: "Tillämpa",
    clear: "Rensa",
    time: "Tid",
    all_time: "All tid",
    last_3_months: "Senaste 3 månaderna",
    last_pool_period: "Senaste poolutvärderingsperioden",
    last_month: "Senaste månaden",
    this_month: "Denna månad",
    last_30_days: "Senaste 30 dagarna",
    title_dates: "Datum",
    from: "Från",
    to: "Till"
  },
  copy_clipboard: "Kopierad till urklipp",
  payment_inputs: {
    empty_card_number: "Ange ett kortnummer",
    invalid_card_number: "Kortnumret är ogiltigt",
    empty_expiry_date: "Ange ett utgångsdatum",
    month_out_of_range: "Utgångsmånad måste vara mellan 01 och 12",
    year_out_of_range: "Utgångsår kan inte vara i det förflutna",
    date_out_of_range: "Utgångsdatum kan inte vara i det förflutna",
    invalid_expiry_date: "Utgångsdatum är ogiltigt",
    invalid_cvc: "CVC är ogiltigt",
    empty_cvc: "Ange en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortinnehavare",
    empty_card_holder: "Ange ett namn på kortinnehavaren"
  },
  copy_clipboard_error: "Misslyckades med att kopiera text",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Sök",
    search: "Sök"
  },
  "registered-over": "registrerade över",
  locale: {
    french: "Franska",
    german: "Tysk",
    italian: "Italienska",
    dutch: "Holländska",
    english: "Engelsk",
    portuguese: "Portugisiska",
    russian: "Ryska",
    spanish: "Spanska",
    japanese: "Japanska",
    arabic: "Arabiska",
    turkish: "Turkiska",
    chinese: "Kinesiska",
    swedish: "Svenska",
    romanian: "Rumänska",
    czech: "Tjeckiska",
    hungarian: "Ungerska",
    slovak: "Slovakiska",
    danish: "Danska",
    indonesian: "Indonesiska",
    polish: "Putsa",
    greek: "Grekisk",
    serbian: "Serbiska",
    hindi: "Nej",
    norwegian: "Norska",
    thai: "Thai",
    slovenian: "Slovenska",
    ukrainian: "Ukrainska",
    albania: "Albanska"
  },
  product: "Produkt",
  quantity: "Antal",
  order_summary: "Orderöversikt",
  vat: "Moms",
  total: "Totalt",
  subtotal: "Delsumma",
  shipping: {
    shipping_method: "Fraktmetod",
    not_available: "Oj! Det verkar som om vi inte erbjuder frakt till denna plats än.",
    condition_label: {
      price: "För beställningar prissatta mellan {{min}} {{currency}} och {{max}} {{currency}}",
      price_min: "För beställningar prissatta till {{min}} {{currency}} eller mer",
      quantity: "För beställningar som innehåller mellan {{min}} till {{max}} artiklar",
      quantity_min: "För beställningar som innehåller {{min}} eller fler artiklar",
      weight: "För beställningar med en totalvikt mellan {{min}}g och {{max}}g",
      weight_min: "För beställningar med en totalvikt av {{min}}g eller mer"
    }
  },
  shipping_fee: "Fraktavgift",
  total_amount_with_tax_and_shipping: "Totalt (inklusive skatt och frakt)",
  vat_percent: "Moms ({{percent}}%)",
  including_tax: "Inklusive {{percent}}% moms ({{amount}})"
}, UG = {
  public_pages_purchase: KG
}, $G = {
  "required-field": "จำเป็นต้องกรอกข้อมูล",
  payment: {
    price_plan: "วางแผน",
    stripe_card: "บัตรเครดิต (ลายทาง)",
    stripe_ideal: "ไอดีล (ลายทาง)",
    stripe_bancotact: "แบนคอนแทค (ลายทาง)",
    dlocal_card: "บัตรเครดิต (ดีโลคอล)",
    dlocal_boleto: "โบเลโต (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "เพย์พาล",
    mercadopago_card: "บัตรเครดิต (เมอร์คาโดปาโก)",
    mercadopago_pix: "PIX (ตลาดการชำระเงิน)",
    mercadopago_boleto: "โบเลโต (Mercado Pago)",
    razorpay: "เรเซอร์เพย์",
    flutterwave: "กระพือปีก",
    mollie: "มอลลี่",
    gocardless: "ไร้บัตร",
    cash_on_delivery: "เงินสดในการจัดส่ง",
    xendit_card: "บัตรเครดิต (Xendit)",
    paystack_card: "บัตรเครดิต (เพย์สแต็ค)",
    paypal_connect: "เชื่อมต่อเพย์พาล",
    paypal_edit_organization_name: "แก้ไขชื่อองค์กร",
    paypal_rest: "เพย์พาล",
    secure_and_pay: "ปลอดภัยและชำระเงิน",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "ข้อผิดพลาด",
  "Payment-method": "วิธีการชำระเงิน",
  price_plan: {
    trial_period: {
      week: "{{count}} สัปดาห์",
      day: "{{count}} วัน",
      month: "{{count}} เดือน",
      year: "{{count}} ปี"
    },
    interval: {
      month: "เดือน",
      day: "วัน",
      week: "สัปดาห์",
      year: "ปี"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "ฟรี",
        trial_period_new: "{{ trialPeriodPrice }} สำหรับ {{ trialInterval }} จากนั้น",
        unlimited_new: "<bold>{{amount}}</bold> ทุกๆ {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ครั้ง"
      }
    }
  },
  affiliate_badge: {
    made_with: "ขับเคลื่อนโดย"
  },
  form_select: {
    empty_list: "ดูเหมือนว่ารายการนี้จะว่างเปล่า",
    select: "เลือก"
  },
  contact_slug: {
    email: "อีเมล",
    first_name: "ชื่อจริง",
    last_name: "นามสกุล",
    phone_number: "หมายเลขโทรศัพท์",
    country: "ประเทศ",
    street_address: "ที่อยู่ถนน",
    city: "เมือง",
    postal_code: "รหัสไปรษณีย์",
    company_name: "ชื่อบริษัท",
    tax_number: "หมายเลขภาษี",
    state_province: "รัฐ/จังหวัด",
    street_number: "หมายเลขถนน",
    neighborhood: "ย่าน"
  },
  date_picker: {
    apply: "สมัคร",
    clear: "ล้าง",
    time: "เวลา",
    all_time: "ทั้งหมด",
    last_3_months: "3 เดือนที่ผ่านมา",
    last_pool_period: "ช่วงเวลาประเมินผลล่าสุด",
    last_month: "เดือนที่แล้ว",
    this_month: "เดือนนี้",
    last_30_days: "30 วันที่ผ่านมา",
    title_dates: "วันที่",
    from: "จาก",
    to: "ถึง"
  },
  copy_clipboard: "คัดลอกไปยังคลิปบอร์ด",
  payment_inputs: {
    empty_card_number: "กรอกหมายเลขบัตร",
    invalid_card_number: "หมายเลขบัตรไม่ถูกต้อง",
    empty_expiry_date: "กรอกวันที่หมดอายุ",
    month_out_of_range: "เดือนหมดอายุต้องอยู่ระหว่าง 01 ถึง 12",
    year_out_of_range: "ปีหมดอายุไม่สามารถอยู่ในอดีตได้",
    date_out_of_range: "วันที่หมดอายุไม่สามารถอยู่ในอดีตได้",
    invalid_expiry_date: "วันที่หมดอายุไม่ถูกต้อง",
    invalid_cvc: "CVC ไม่ถูกต้อง",
    empty_cvc: "กรุณาใส่ CVC",
    card_number_placeholder: "หมายเลขบัตร",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "ชื่อผู้ถือบัตร",
    empty_card_holder: "กรุณาใส่ชื่อผู้ถือบัตร"
  },
  copy_clipboard_error: "ไม่สามารถคัดลอกข้อความได้",
  input: {
    phone_number: "หมายเลขโทรศัพท์",
    phone_search: "ค้นหา",
    search: "ค้นหา"
  },
  "registered-over": "ลงทะเบียนมากกว่า",
  locale: {
    french: "ภาษาฝรั่งเศส",
    german: "เยอรมัน",
    italian: "ภาษาอิตาลี",
    dutch: "ภาษาดัตช์",
    english: "ภาษาอังกฤษ",
    portuguese: "โปรตุเกส",
    russian: "ภาษารัสเซีย",
    spanish: "สเปน",
    japanese: "ญี่ปุ่น",
    arabic: "ภาษาอาหรับ",
    turkish: "ภาษาตุรกี",
    chinese: "ชาวจีน",
    swedish: "ภาษาสวีเดน",
    romanian: "โรมาเนีย",
    czech: "เช็ก",
    hungarian: "ภาษาฮังการี",
    slovak: "สโลวัก",
    danish: "ภาษาเดนมาร์ก",
    indonesian: "ชาวอินโดนีเซีย",
    polish: "ขัด",
    greek: "กรีก",
    serbian: "เซอร์เบีย",
    hindi: "ไม่",
    norwegian: "ภาษานอร์เวย์",
    thai: "แบบไทย",
    slovenian: "ภาษาสโลเวเนีย",
    ukrainian: "ภาษายูเครน",
    albania: "แอลเบเนีย"
  },
  product: "ผลิตภัณฑ์",
  quantity: "จำนวน",
  order_summary: "สรุปคำสั่งซื้อ",
  vat: "ภาษีขาย",
  total: "รวม",
  subtotal: "ยอดรวมย่อย",
  shipping: {
    shipping_method: "วิธีการจัดส่ง",
    not_available: "อุ๊บส์! ดูเหมือนว่าเรายังไม่สามารถจัดส่งไปยังสถานที่นี้ได้",
    condition_label: {
      price: "สำหรับคำสั่งซื้อที่มีราคาอยู่ระหว่าง {{min}} {{currency}} ถึง {{max}} {{currency}}",
      price_min: "สำหรับคำสั่งซื้อที่มีราคา {{min}} {{currency}} ขึ้นไป",
      quantity: "สำหรับคำสั่งซื้อที่มีจำนวนระหว่าง {{min}} ถึง {{max}} รายการ",
      quantity_min: "สำหรับคำสั่งซื้อที่มีจำนวน {{min}} รายการขึ้นไป",
      weight: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวมระหว่าง {{min}}g ถึง {{max}}g",
      weight_min: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวม {{min}}g ขึ้นไป"
    }
  },
  shipping_fee: "ค่าจัดส่ง",
  total_amount_with_tax_and_shipping: "รวม (รวมภาษีและค่าจัดส่ง)",
  vat_percent: "ภาษีขาย ({{percent}}%)",
  including_tax: "รวมภาษีมูลค่าเพิ่ม {{percent}}% ({{amount}})"
}, VG = {
  public_pages_purchase: $G
}, WG = {
  "required-field": "Alan gereklidir",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredi kartları (Şeritli)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "İletişimi yasakla (Stripe)",
    dlocal_card: "Kredi kartları (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kredi kartları (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Çarpıntı dalgası",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kapıda ödeme",
    xendit_card: "Kredi kartları (Xendit)",
    paystack_card: "Kredi kartları (Paystack)",
    paypal_connect: "PayPal'ı bağlayın",
    paypal_edit_organization_name: "Kuruluş adını düzenleyin",
    paypal_rest: "PayPal",
    secure_and_pay: "Güvenli ve Ödemeli",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Güvenlik"
    }
  },
  error: "Hata",
  "Payment-method": "Ödeme yöntemi",
  price_plan: {
    trial_period: {
      week: "{{count}} hafta",
      week_plural: "{{count}} hafta",
      day: "{{count}} gün",
      day_plural: "{{count}} gün",
      month: "{{count}} ay",
      month_plural: "{{count}} ay",
      year: "{{count}} yıl",
      year_plural: "{{count}} yıl"
    },
    interval: {
      month: "ay",
      month_plural: "{{count}} ay",
      day: "gün",
      day_plural: "{{count}} gün",
      week: "hafta",
      week_plural: "{{count}} hafta",
      year: "yıl",
      year_plural: "{{count}} yıl"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Ücretsiz",
        trial_period_new: "{{ trialInterval }} için {{ trialPeriodPrice }} sonra",
        unlimited_new: "<bold>{{amount}}</bold> her {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kez"
      }
    }
  },
  affiliate_badge: {
    made_with: "Tarafından desteklenmektedir"
  },
  form_select: {
    empty_list: "Bu liste boş gibi görünüyor",
    select: "Seçin"
  },
  contact_slug: {
    email: "E-posta",
    first_name: "İsim",
    last_name: "Soyisim",
    phone_number: "Telefon numarası",
    country: "Ülke",
    street_address: "Sokak adresi",
    city: "Şehir",
    postal_code: "Posta kodu",
    company_name: "Şirket adı",
    tax_number: "Vergi numarası",
    state_province: "Eyalet/İl",
    street_number: "Sokak numarası",
    neighborhood: "Mahalle"
  },
  date_picker: {
    apply: "Uygula",
    clear: "Temizle",
    time: "Zaman",
    all_time: "Tüm zamanlar",
    last_3_months: "Son 3 ay",
    last_pool_period: "Son havuz değerlendirme dönemi",
    last_month: "Geçen Ay",
    this_month: "Bu Ay",
    last_30_days: "Son 30 gün",
    title_dates: "Tarihler",
    from: "Tarihinden itibaren",
    to: "Tarihine kadar"
  },
  copy_clipboard: "Panoya kopyalandı",
  payment_inputs: {
    empty_card_number: "Bir kart numarası girin",
    invalid_card_number: "Kart numarası geçersiz",
    empty_expiry_date: "Bir son kullanma tarihi girin",
    month_out_of_range: "Son kullanma ayı 01 ile 12 arasında olmalıdır",
    year_out_of_range: "Son kullanma yılı geçmiş tarihte olamaz",
    date_out_of_range: "Son kullanma tarihi geçmiş tarih olamaz",
    invalid_expiry_date: "Son kullanma tarihi geçersiz",
    invalid_cvc: "CVC geçersiz",
    empty_cvc: "CVC girin",
    card_number_placeholder: "Kart numarası",
    expiry_data_placeholder: "AA/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kart sahibi",
    empty_card_holder: "Bir kart sahibi adı girin"
  },
  copy_clipboard_error: "Metin kopyalanamadı",
  input: {
    phone_number: "Telefon numarası",
    phone_search: "Ara",
    search: "Ara"
  },
  "registered-over": "kaydedilen",
  locale: {
    french: "Fransızca",
    german: "Almanca",
    italian: "İtalyan",
    dutch: "Flemenkçe",
    english: "İngilizce",
    portuguese: "Portekizce",
    russian: "Rusça",
    spanish: "İspanyol",
    japanese: "Japonca",
    arabic: "Arap",
    turkish: "Türkçe",
    chinese: "Çince",
    swedish: "İsveççe",
    romanian: "Romen",
    czech: "Çek",
    hungarian: "Macarca",
    slovak: "Slovak",
    danish: "Danimarka",
    indonesian: "Endonezya dili",
    polish: "Lehçe",
    greek: "Yunan",
    serbian: "Sırpça",
    hindi: "Hintçe",
    norwegian: "Norveççe",
    thai: "Tay dili",
    slovenian: "Slovence",
    ukrainian: "Ukrayna",
    albania: "Arnavut"
  },
  product: "Ürün",
  quantity: "Miktar",
  order_summary: "Sipariş Özeti",
  vat: "Satış vergisi",
  total: "Toplam",
  subtotal: "Ara Toplam",
  shipping: {
    shipping_method: "Gönderim Yöntemi",
    not_available: "Aman! Görünüşe göre bu konuma henüz gönderim yapmıyoruz.",
    condition_label: {
      price: "{{min}} {{currency}} ile {{max}} {{currency}} arasında fiyatlandırılan siparişler için",
      price_min: "{{min}} {{currency}} veya daha fazla fiyatlandırılan siparişler için",
      quantity: "{{min}} ile {{max}} ürün içeren siparişler için",
      quantity_min: "{{min}} veya daha fazla ürün içeren siparişler için",
      weight: "Toplam ağırlığı {{min}}g ile {{max}}g arasında olan siparişler için",
      weight_min: "Toplam ağırlığı {{min}}g veya daha fazla olan siparişler için"
    }
  },
  shipping_fee: "Gönderim ücreti",
  total_amount_with_tax_and_shipping: "Toplam (vergi ve gönderim dahil)",
  vat_percent: "Satış vergisi ({{percent}}%)",
  including_tax: "KDV dahil {{percent}}% ({{amount}})"
}, YG = {
  public_pages_purchase: WG
}, ZG = {
  "required-field": "Поле обов'язкове",
  payment: {
    price_plan: "План",
    stripe_card: "Кредитні картки (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Кредитні картки (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Пікс (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Кредитні картки (Mercado Pago)",
    mercadopago_pix: "PIX (платіжний ринок)",
    mercadopago_boleto: "Болето (Меркадо Паго)",
    razorpay: "Razorpay",
    flutterwave: "Флаттервейв",
    mollie: "Моллі",
    gocardless: "Gocardless",
    cash_on_delivery: "Накладений платіж",
    xendit_card: "Кредитні картки (Xendit)",
    paystack_card: "Кредитні картки (Paystack)",
    paypal_connect: "Підключіть PayPal",
    paypal_edit_organization_name: "Редагувати назву організації",
    paypal_rest: "PayPal",
    secure_and_pay: "Захистіть і заплатите",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Помилка",
  "Payment-method": "Спосіб оплати",
  price_plan: {
    trial_period: {
      week_0: "{{count}} тиждень",
      week_1: "{{count}} тижнів",
      week_2: "{{count}} тижнів",
      day_0: "{{count}} день",
      day_1: "{{count}} днів",
      day_2: "{{count}} днів",
      month_0: "{{count}} місяць",
      month_1: "{{count}} місяців",
      month_2: "{{count}} місяців",
      year_0: "{{count}} рік",
      year_1: "{{count}} років",
      year_2: "{{count}} років"
    },
    interval: {
      month_0: "місяць",
      month_1: "{{count}} місяців",
      month_2: "{{count}} місяців",
      day_0: "день",
      day_1: "{{count}} днів",
      day_2: "{{count}} днів",
      week_0: "тиждень",
      week_1: "{{count}} тижнів",
      week_2: "{{count}} тижнів",
      year_0: "рік",
      year_1: "{{count}} років",
      year_2: "{{count}} років"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "безкоштовно",
        trial_period_new: "Тоді {{ trialPeriodPrice }} за {{ trialInterval }} ",
        unlimited_new: "<bold>{{amount}}</bold> кожні {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} разів"
      }
    }
  },
  affiliate_badge: {
    made_with: "Підтримується"
  },
  form_select: {
    empty_list: "Схоже, що цей список порожній",
    select: "Вибрати"
  },
  contact_slug: {
    email: "Електронна пошта",
    first_name: "Ім'я",
    last_name: "Прізвище",
    phone_number: "Номер телефону",
    country: "Країна",
    street_address: "Вулиця",
    city: "Місто",
    postal_code: "Поштовий індекс",
    company_name: "Назва компанії",
    tax_number: "Податковий номер",
    state_province: "Штат/Область",
    street_number: "Номер вулиці",
    neighborhood: "Район"
  },
  date_picker: {
    apply: "Застосувати",
    clear: "Очистити",
    time: "Час",
    all_time: "Весь час",
    last_3_months: "Останні 3 місяці",
    last_pool_period: "Останній період оцінки пулу",
    last_month: "Останній місяць",
    this_month: "Цей місяць",
    last_30_days: "Останні 30 днів",
    title_dates: "Дати",
    from: "З",
    to: "До"
  },
  copy_clipboard: "Скопійовано в буфер обміну",
  payment_inputs: {
    empty_card_number: "Введіть номер картки",
    invalid_card_number: "Номер картки недійсний",
    empty_expiry_date: "Введіть дату закінчення терміну дії",
    month_out_of_range: "Місяць закінчення терміну дії має бути між 01 і 12",
    year_out_of_range: "Рік закінчення не може бути в минулому",
    date_out_of_range: "Дата закінчення не може бути в минулому",
    invalid_expiry_date: "Дата закінчення недійсна",
    invalid_cvc: "CVC недійсний",
    empty_cvc: "Введіть CVC",
    card_number_placeholder: "Номер картки",
    expiry_data_placeholder: "ММ/РР",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Власник картки",
    empty_card_holder: "Введіть ім'я власника картки"
  },
  copy_clipboard_error: "Не вдалося скопіювати текст",
  input: {
    phone_number: "Номер телефону",
    phone_search: "Пошук",
    search: "Пошук"
  },
  "registered-over": "зареєстровано понад",
  locale: {
    french: "французька",
    german: "Німецький",
    italian: "італійська",
    dutch: "голландська",
    english: "англійська",
    portuguese: "португальська",
    russian: "російський",
    spanish: "Іспанська",
    japanese: "Японський",
    arabic: "арабська",
    turkish: "турецька",
    chinese: "китайський",
    swedish: "шведська",
    romanian: "румунська",
    czech: "чеська",
    hungarian: "угорська",
    slovak: "словацький",
    danish: "датська",
    indonesian: "індонезійська",
    polish: "польський",
    greek: "грецька",
    serbian: "сербська",
    hindi: "ні",
    norwegian: "норвезька",
    thai: "тайська",
    slovenian: "словенська",
    ukrainian: "Українська",
    albania: "албанець"
  },
  product: "Продукт",
  quantity: "Кількість",
  order_summary: "Підсумок замовлення",
  vat: "Податок на продаж",
  total: "Всього",
  subtotal: "Проміжний підсумок",
  shipping: {
    shipping_method: "Спосіб доставки",
    not_available: "Упс! Схоже, що ми ще не пропонуємо доставку в це місце.",
    condition_label: {
      price: "Для замовлень вартістю від {{min}} {{currency}} до {{max}} {{currency}}",
      price_min: "Для замовлень вартістю від {{min}} {{currency}} або більше",
      quantity: "Для замовлень, що містять від {{min}} до {{max}} товарів",
      quantity_min: "Для замовлень, що містять {{min}} або більше товарів",
      weight: "Для замовлень з загальною вагою від {{min}}g до {{max}}g",
      weight_min: "Для замовлень з загальною вагою {{min}}g або більше"
    }
  },
  shipping_fee: "Вартість доставки",
  total_amount_with_tax_and_shipping: "Всього (включаючи податок і доставку)",
  vat_percent: "Податок з продажу ({{percent}}%)",
  including_tax: "З урахуванням ПДВ {{percent}}% ({{amount}})"
}, qG = {
  public_pages_purchase: ZG
}, JG = {
  "required-field": "字段为必填项",
  payment: {
    price_plan: "计划",
    stripe_card: "信用卡（Stripe）",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "信用卡（Dlocal）",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "信用卡（Mercado Pago）",
    mercadopago_pix: "PIX（Mercado Pago）",
    mercadopago_boleto: "Boleto（Mercado Pago）",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "货到付款",
    xendit_card: "信用卡 (Xendit)",
    paystack_card: "信用卡（Paystack）",
    paypal_connect: "连接 PayPal",
    paypal_edit_organization_name: "编辑组织名称",
    paypal_rest: "PayPal",
    secure_and_pay: "安全与支付",
    stripe_applepay: "苹果支付",
    xendit: {
      "3ds": "3D-安全"
    }
  },
  error: "错误",
  "Payment-method": "付款方式",
  price_plan: {
    trial_period: {
      week: `周

{{count}} 周`,
      day: `{{count}} 天

{{count}} 天`,
      month: `{{count}} 月

{{count}} 月`,
      year: `{{count}}年

{{count}}年`
    },
    interval: {
      month: `月

{{count}} 月`,
      day: `天

{{count}} 天`,
      week: `周

{{count}}周`,
      year: `年

{{count}}年`
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "免费",
        trial_period_new: "{{ trialInterval }} {{ trialPeriodPrice }} 然后",
        unlimited_new: "<bold>{{amount}}</bold>每个{{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 次"
      }
    }
  },
  affiliate_badge: {
    made_with: "技术支持"
  },
  form_select: {
    empty_list: "看起来这个列表是空的",
    select: "选择"
  },
  contact_slug: {
    email: "电子邮件",
    first_name: "名字",
    last_name: "姓氏",
    phone_number: "电话号码",
    country: "国家",
    street_address: "街道地址",
    city: "城市",
    postal_code: "邮政编码",
    company_name: "公司名称",
    tax_number: "税号",
    state_province: "州/省",
    street_number: "街道号码",
    neighborhood: "街道邻里"
  },
  date_picker: {
    apply: "应用",
    clear: "清除",
    time: "时间",
    all_time: "所有的时间",
    last_3_months: "过去3个月",
    last_pool_period: "最后一个池评估期",
    last_month: "次月",
    this_month: "这个月",
    last_30_days: "过去30天",
    title_dates: "日期",
    from: "从",
    to: "到"
  },
  copy_clipboard: "已复制到剪贴板",
  payment_inputs: {
    empty_card_number: "输入卡号",
    invalid_card_number: "卡号无效",
    empty_expiry_date: "输入到期日期",
    month_out_of_range: "到期月份必须在01到12之间",
    year_out_of_range: "到期年不能是过去的年份",
    date_out_of_range: "过期日期不能是过去时间",
    invalid_expiry_date: "过期日期无效",
    invalid_cvc: "CVC无效",
    empty_cvc: "输入CVC",
    card_number_placeholder: "卡号",
    expiry_data_placeholder: "月/年",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "持卡人",
    empty_card_holder: "输入持卡人姓名"
  },
  copy_clipboard_error: "复制文本失败",
  input: {
    phone_number: "电话号码",
    phone_search: "搜索",
    search: "搜索"
  },
  "registered-over": "注册超过",
  locale: {
    french: "法语",
    german: "德语",
    italian: "意大利语",
    dutch: "荷兰语",
    english: "英语",
    portuguese: "葡萄牙语",
    russian: "俄语",
    spanish: "西班牙语",
    japanese: "日语",
    arabic: "阿拉伯语",
    turkish: "土耳其语",
    chinese: "中國人",
    swedish: "瑞典语",
    romanian: "罗马尼亚语",
    czech: "捷克语",
    hungarian: "匈牙利语",
    slovak: "斯洛伐克语",
    danish: "丹麦语",
    indonesian: "印度尼西亚语",
    polish: "波兰语",
    greek: "希腊语",
    serbian: "塞尔维亚语",
    hindi: "印地语",
    norwegian: "挪威语",
    thai: "泰语",
    slovenian: "斯洛文尼亚语",
    ukrainian: "乌克兰语",
    albania: "阿尔巴尼亚语"
  },
  product: "产品",
  quantity: "数量",
  order_summary: "订单摘要",
  vat: "销售税",
  total: "总计",
  subtotal: "小计",
  shipping: {
    shipping_method: "运输方式",
    not_available: "哎呀！看起来我们还不提供该地点的运输服务。",
    condition_label: {
      price: "对于价格在 {{min}} {{currency}} 到 {{max}} {{currency}} 之间的订单",
      price_min: "对于价格在 {{min}} {{currency}} 或以上的订单",
      quantity: "对于包含 {{min}} 到 {{max}} 件商品的订单",
      quantity_min: "对于包含 {{min}} 件或更多商品的订单",
      weight: "对于总重量在 {{min}}g 到 {{max}}g 之间的订单",
      weight_min: "对于总重量在 {{min}}g 或以上的订单"
    }
  },
  shipping_fee: "运费",
  total_amount_with_tax_and_shipping: "总计（包括税费和运费）",
  vat_percent: "销售税 ({{percent}}%)",
  including_tax: "含增值税{{percent}}%（{{amount}}）"
}, XG = {
  public_pages_purchase: JG
}, zv = ["common"], QG = Object.values(Mn), W8 = {
  ar: { common: Xz },
  cs: { common: eG },
  da: { common: rG },
  de: { common: aG },
  el: { common: iG },
  en: { common: lG },
  es: { common: uG },
  fr: { common: pG },
  hi: { common: mG },
  hu: { common: gG },
  id: { common: vG },
  it: { common: _G },
  ja: { common: SG },
  nl: { common: xG },
  no: { common: EG },
  pl: { common: TG },
  pt: { common: OG },
  ro: { common: NG },
  ru: { common: RG },
  sk: { common: IG },
  sl: { common: BG },
  sq: { common: zG },
  sr: { common: HG },
  sv: { common: UG },
  th: { common: VG },
  tr: { common: YG },
  uk: { common: qG },
  zh: { common: XG }
}, Y8 = {
  supportedLngs: QG,
  load: "languageOnly",
  debug: !1,
  defaultNS: zv[0],
  react: { useSuspense: !1 },
  ns: zv,
  compatibilityJSON: "v3",
  fallbackLng: "en",
  interpolation: {
    escapeValue: !1
  }
};
xr.isInitialized || xr.use(Iz).init({ ...Y8, resources: W8 });
const eH = (e) => {
  const t = fu(e);
  return xr.cloneInstance({
    ...Y8,
    lng: t,
    resources: W8
  });
}, Ane = ({
  locale: e,
  children: t
}) => /* @__PURE__ */ S.jsx(qz, { i18n: eH(e), children: t }), tH = (e) => {
  const t = (n) => e((r) => ({ ...r, mercadoPago: { ...r.mercadoPago, ...n } }));
  return {
    initialized: !1,
    setInitialized: (n) => t({ initialized: n })
  };
}, Gv = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (c, u) => {
    const d = typeof c == "function" ? c(t) : c;
    if (!Object.is(d, t)) {
      const p = t;
      t = u ?? (typeof d != "object" || d === null) ? d : Object.assign({}, t, d), n.forEach((h) => h(t, p));
    }
  }, a = () => t, s = { setState: r, getState: a, getInitialState: () => l, subscribe: (c) => (n.add(c), () => n.delete(c)) }, l = t = e(r, a, s);
  return s;
}, rH = (e) => e ? Gv(e) : Gv, nH = (e) => e;
function aH(e, t = nH) {
  const n = k.useSyncExternalStore(
    e.subscribe,
    () => t(e.getState()),
    () => t(e.getInitialState())
  );
  return k.useDebugValue(n), n;
}
const Hv = (e) => {
  const t = rH(e), n = (r) => aH(t, r);
  return Object.assign(n, t), n;
}, oH = (e) => e ? Hv(e) : Hv;
var Kv = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const J1 = /* @__PURE__ */ new Map(), Fu = (e) => {
  const t = J1.get(e);
  return t ? Object.fromEntries(
    Object.entries(t.stores).map(([n, r]) => [n, r.getState()])
  ) : {};
}, iH = (e, t, n) => {
  if (e === void 0)
    return {
      type: "untracked",
      connection: t.connect(n)
    };
  const r = J1.get(n.name);
  if (r)
    return { type: "tracked", store: e, ...r };
  const a = {
    connection: t.connect(n),
    stores: {}
  };
  return J1.set(n.name, a), { type: "tracked", store: e, ...a };
}, sH = (e, t = {}) => (n, r, a) => {
  const { enabled: o, anonymousActionType: i, store: s, ...l } = t;
  let c;
  try {
    c = (o ?? (Kv ? "production" : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
  } catch {
  }
  if (!c)
    return e(n, r, a);
  const { connection: u, ...d } = iH(s, c, l);
  let p = !0;
  a.setState = (f, g, _) => {
    const v = n(f, g);
    if (!p)
      return v;
    const w = _ === void 0 ? { type: i || "anonymous" } : typeof _ == "string" ? { type: _ } : _;
    return s === void 0 ? (u == null || u.send(w, r()), v) : (u == null || u.send(
      {
        ...w,
        type: `${s}/${w.type}`
      },
      {
        ...Fu(l.name),
        [s]: a.getState()
      }
    ), v);
  };
  const h = (...f) => {
    const g = p;
    p = !1, n(...f), p = g;
  }, m = e(a.setState, r, a);
  if (d.type === "untracked" ? u == null || u.init(m) : (d.stores[d.store] = a, u == null || u.init(
    Object.fromEntries(
      Object.entries(d.stores).map(([f, g]) => [
        f,
        f === d.store ? m : g.getState()
      ])
    )
  )), a.dispatchFromDevtools && typeof a.dispatch == "function") {
    let f = !1;
    const g = a.dispatch;
    a.dispatch = (..._) => {
      (Kv ? "production" : void 0) !== "production" && _[0].type === "__setState" && !f && (console.warn(
        '[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.'
      ), f = !0), g(..._);
    };
  }
  return u.subscribe((f) => {
    var g;
    switch (f.type) {
      case "ACTION":
        if (typeof f.payload != "string") {
          console.error(
            "[zustand devtools middleware] Unsupported action format"
          );
          return;
        }
        return wm(
          f.payload,
          (_) => {
            if (_.type === "__setState") {
              if (s === void 0) {
                h(_.state);
                return;
              }
              Object.keys(_.state).length !== 1 && console.error(
                `
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `
              );
              const v = _.state[s];
              if (v == null)
                return;
              JSON.stringify(a.getState()) !== JSON.stringify(v) && h(v);
              return;
            }
            a.dispatchFromDevtools && typeof a.dispatch == "function" && a.dispatch(_);
          }
        );
      case "DISPATCH":
        switch (f.payload.type) {
          case "RESET":
            return h(m), s === void 0 ? u == null ? void 0 : u.init(a.getState()) : u == null ? void 0 : u.init(Fu(l.name));
          case "COMMIT":
            if (s === void 0) {
              u == null || u.init(a.getState());
              return;
            }
            return u == null ? void 0 : u.init(Fu(l.name));
          case "ROLLBACK":
            return wm(f.state, (_) => {
              if (s === void 0) {
                h(_), u == null || u.init(a.getState());
                return;
              }
              h(_[s]), u == null || u.init(Fu(l.name));
            });
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            return wm(f.state, (_) => {
              if (s === void 0) {
                h(_);
                return;
              }
              JSON.stringify(a.getState()) !== JSON.stringify(_[s]) && h(_[s]);
            });
          case "IMPORT_STATE": {
            const { nextLiftedState: _ } = f.payload, v = (g = _.computedStates.slice(-1)[0]) == null ? void 0 : g.state;
            if (!v)
              return;
            h(s === void 0 ? v : v[s]), u == null || u.send(
              null,
              // FIXME no-any
              _
            );
            return;
          }
          case "PAUSE_RECORDING":
            return p = !p;
        }
        return;
    }
  }), m;
}, lH = sH, wm = (e, t) => {
  let n;
  try {
    n = JSON.parse(e);
  } catch (r) {
    console.error(
      "[zustand devtools middleware] Could not parse the received json",
      r
    );
  }
  n !== void 0 && t(n);
}, cH = (e) => {
  const t = (n) => e((r) => ({ ...r, xendit: { ...r.xendit, ...n } }));
  return {
    cardHolderName: "",
    setCardHolderName: (n) => t({ cardHolderName: n }),
    cardNumber: "",
    setCardNumber: (n) => t({ cardNumber: n }),
    expiryMonth: "",
    setExpiryMonth: (n) => t({ expiryMonth: n }),
    expiryYear: "",
    setExpiryYear: (n) => t({ expiryYear: n }),
    cvc: "",
    setCvc: (n) => t({ cvc: n }),
    formInvalid: !0,
    setFormInvalid: (n) => t({ formInvalid: n })
  };
}, uH = (e, t, n, r) => {
  const a = {
    locale: Uo.ENGLISH
  };
  return {
    locale: (r == null ? void 0 : r.locale) ?? a.locale,
    setLocale: (o) => e({ locale: o })
  };
}, dH = (e, t, n, r) => {
  const a = {
    offerId: void 0,
    productId: void 0,
    paymentMethod: void 0,
    availablePaymentMethods: [],
    currency: void 0,
    pricePlan: void 0,
    finalAmount: void 0,
    contactFields: {}
  }, o = (i) => e((s) => ({ ...s, offer: { ...s.offer, ...i } }));
  return {
    offerId: (r == null ? void 0 : r.offerId) ?? a.offerId,
    setOfferId: (i) => o({ offerId: i }),
    productId: (r == null ? void 0 : r.productId) ?? a.productId,
    setProductId: (i) => o({ productId: i }),
    paymentMethod: (r == null ? void 0 : r.paymentMethod) ?? a.paymentMethod,
    setPaymentMethod: (i) => o({ paymentMethod: i }),
    availablePaymentMethods: (r == null ? void 0 : r.availablePaymentMethods) ?? a.availablePaymentMethods,
    setAvailablePaymentMethods: (i) => o({ availablePaymentMethods: i }),
    currency: (r == null ? void 0 : r.currency) ?? a.currency,
    setCurrency: (i) => o({ currency: i }),
    pricePlan: (r == null ? void 0 : r.pricePlan) ?? a.pricePlan,
    setPricePlan: (i) => o({ pricePlan: i }),
    finalAmount: (r == null ? void 0 : r.finalAmount) ?? a.finalAmount,
    setFinalAmount: (i) => o({ finalAmount: i }),
    contactFields: (r == null ? void 0 : r.contactFields) ?? a.contactFields,
    setContactFields: (i) => o({ contactFields: i })
  };
}, pH = (e, t, n, r) => {
  const a = {
    quantity: 1,
    selectedShipping: null,
    productVariant: null
  }, o = (i) => e((s) => ({
    ...s,
    physicalProduct: { ...s.physicalProduct, ...i }
  }));
  return {
    quantity: (r == null ? void 0 : r.quantity) ?? a.quantity,
    setQuantity: (i) => o({ quantity: i }),
    selectedShipping: (r == null ? void 0 : r.selectedShipping) ?? a.selectedShipping,
    setSelectedShipping: (i) => o({ selectedShipping: i }),
    productVariant: (r == null ? void 0 : r.productVariant) ?? a.productVariant,
    setProductVariant: (i) => o({ productVariant: i })
  };
}, hH = (e, t, n, r) => {
  const a = {
    stripeAccountId: void 0,
    mercadoPublicKey: null,
    xenditPublicKey: null
  }, o = (i) => e((s) => ({ ...s, publicKeys: { ...s.publicKeys, ...i } }));
  return {
    stripeAccountId: (r == null ? void 0 : r.stripeAccountId) ?? a.stripeAccountId,
    mercadoPublicKey: (r == null ? void 0 : r.mercadoPublicKey) ?? a.mercadoPublicKey,
    xenditPublicKey: (r == null ? void 0 : r.xenditPublicKey) ?? a.xenditPublicKey,
    setStripeAccountId: (i) => o({ stripeAccountId: i }),
    setMercadoPublicKey: (i) => o({ mercadoPublicKey: i }),
    setXenditPublicKey: (i) => o({ xenditPublicKey: i })
  };
}, mH = (e) => {
  const t = (n) => e((r) => ({ ...r, visitorInfo: { ...r.visitorInfo, ...n } }));
  return {
    visitorInfo: null,
    setVisitorInfo: (n) => t({ visitorInfo: n })
  };
}, Z8 = (e) => oH()(
  lH((t, n, r) => {
    const a = uH(t, n, r, e == null ? void 0 : e.base), o = dH(t, n, r, e == null ? void 0 : e.offer), i = mH(t), s = hH(t, n, r, e == null ? void 0 : e.publicKeys), l = pH(
      t,
      n,
      r,
      e == null ? void 0 : e.physicalProduct
    );
    return {
      ...a,
      offer: o,
      publicKeys: s,
      xendit: cH(t),
      physicalProduct: l,
      visitorInfo: i,
      mercadoPago: tH(t)
    };
  })
);
let Sm = null;
const fH = (e) => (Sm || (Sm = Z8(e)), Sm), q8 = Qe(null), gH = () => Ue(q8) ?? fH(), zt = () => gH()(), In = () => {
  const { offer: e } = zt();
  return e;
}, yH = () => {
  const { publicKeys: e } = zt();
  return e;
}, J8 = () => {
  const { xendit: e } = zt();
  return e;
}, X8 = () => {
  const { visitorInfo: e } = zt();
  return e;
}, bu = () => {
  const { physicalProduct: e } = zt();
  return e;
}, Q8 = () => {
  const { mercadoPago: e } = zt();
  return e;
};
function Nne({ children: e, initProps: t }) {
  const n = k.useMemo(() => Z8(t), [t]), r = typeof e == "function" ? e({ store: n }) : e;
  return k.createElement(q8.Provider, { value: n }, r);
}
let vH = class extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
};
class Mg extends Error {
  constructor(t) {
    super(t.detail), this.errors = t, this.violationsTitleToMessage();
  }
  // TODO: delete this method after BE decide what to use title or message
  violationsTitleToMessage() {
    var t;
    (t = this.errors.violations) == null || t.forEach((n) => {
      "title" in n && (n.message = n.title, delete n.title);
    });
  }
}
class e9 extends Error {
  constructor(t) {
    var n;
    super((n = t.errors.common) == null ? void 0 : n.join("")), this.errors = t.errors;
  }
  toErrorWithViolations({
    type: t,
    status: n,
    title: r,
    code: a
  }) {
    return new Mg({
      type: t,
      status: n,
      title: r,
      detail: this.message,
      violations: this.flattenObjectToViolations(this.errors.fields, a, "")
    });
  }
  flattenObjectToViolations(t, n, r = "") {
    const a = [];
    return typeof t == "string" ? (a.push({ propertyPath: r, message: t, code: n }), a) : (Array.isArray(t) ? t.length === 1 ? a.push({ propertyPath: r, message: t[0], code: n }) : t.forEach((o, i) => {
      const s = `${r}[${i}]`;
      a.push(...this.flattenObjectToViolations(o, n, s));
    }) : t !== null && typeof t == "object" && Object.entries(t).forEach(([o, i]) => {
      const s = r ? `${r}.${o}` : o;
      a.push(...this.flattenObjectToViolations(i, n, s));
    }), a);
  }
}
let Sa = class extends e9 {
  toErrorWithViolations() {
    return super.toErrorWithViolations({
      type: "",
      status: X1.code,
      title: "",
      code: X1.code
    });
  }
};
const t9 = class extends Mg {
};
t9.code = 422;
let X1 = t9;
class bH extends e9 {
}
let _H = class extends Error {
  constructor(t) {
    super(t), this.name = this.constructor.name;
  }
}, wH = class extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
};
const SH = [
  "Invalid JWT Token",
  "JWT Token not found",
  "Expired JWT Token"
];
class CH extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
let xH = class extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}, Uv = class extends Error {
  constructor(t) {
    super(t == null ? void 0 : t.error.message), this.name = this.constructor.name;
  }
  static isNotFoundResponse(t) {
    return !(!t || typeof t != "object" || !("error" in t) || !t.error || typeof t.error != "object" || !("code" in t.error) || !("message" in t.error));
  }
};
class kH extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
class EH extends Error {
  constructor(t) {
    super(t), this.location = t;
  }
}
class r9 extends Mg {
}
function n9(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: PH } = Object.prototype, { getPrototypeOf: Og } = Object, uh = /* @__PURE__ */ ((e) => (t) => {
  const n = PH.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ca = (e) => (e = e.toLowerCase(), (t) => uh(t) === e), dh = (e) => (t) => typeof t === e, { isArray: cl } = Array, Bc = dh("undefined");
function TH(e) {
  return e !== null && !Bc(e) && e.constructor !== null && !Bc(e.constructor) && On(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const a9 = Ca("ArrayBuffer");
function MH(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && a9(e.buffer), t;
}
const OH = dh("string"), On = dh("function"), o9 = dh("number"), ph = (e) => e !== null && typeof e == "object", AH = (e) => e === !0 || e === !1, md = (e) => {
  if (uh(e) !== "object")
    return !1;
  const t = Og(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, NH = Ca("Date"), LH = Ca("File"), RH = Ca("Blob"), DH = Ca("FileList"), IH = (e) => ph(e) && On(e.pipe), jH = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || On(e.append) && ((t = uh(e)) === "formdata" || // detect form-data instance
  t === "object" && On(e.toString) && e.toString() === "[object FormData]"));
}, BH = Ca("URLSearchParams"), [FH, zH, GH, HH] = ["ReadableStream", "Request", "Response", "Headers"].map(Ca), KH = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function _u(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, a;
  if (typeof e != "object" && (e = [e]), cl(e))
    for (r = 0, a = e.length; r < a; r++)
      t.call(null, e[r], r, e);
  else {
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
    let s;
    for (r = 0; r < i; r++)
      s = o[r], t.call(null, e[s], s, e);
  }
}
function i9(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, a;
  for (; r-- > 0; )
    if (a = n[r], t === a.toLowerCase())
      return a;
  return null;
}
const Ai = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, s9 = (e) => !Bc(e) && e !== Ai;
function Q1() {
  const { caseless: e } = s9(this) && this || {}, t = {}, n = (r, a) => {
    const o = e && i9(t, a) || a;
    md(t[o]) && md(r) ? t[o] = Q1(t[o], r) : md(r) ? t[o] = Q1({}, r) : cl(r) ? t[o] = r.slice() : t[o] = r;
  };
  for (let r = 0, a = arguments.length; r < a; r++)
    arguments[r] && _u(arguments[r], n);
  return t;
}
const UH = (e, t, n, { allOwnKeys: r } = {}) => (_u(t, (a, o) => {
  n && On(a) ? e[o] = n9(a, n) : e[o] = a;
}, { allOwnKeys: r }), e), $H = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), VH = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, WH = (e, t, n, r) => {
  let a, o, i;
  const s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      i = a[o], (!r || r(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = n !== !1 && Og(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, YH = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, ZH = (e) => {
  if (!e)
    return null;
  if (cl(e))
    return e;
  let t = e.length;
  if (!o9(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, qH = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Og(Uint8Array)), JH = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const a = r.value;
    t.call(e, a[0], a[1]);
  }
}, XH = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, QH = Ca("HTMLFormElement"), eK = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, n, r) {
    return n.toUpperCase() + r;
  }
), $v = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), tK = Ca("RegExp"), l9 = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  _u(n, (a, o) => {
    let i;
    (i = t(a, o, e)) !== !1 && (r[o] = i || a);
  }), Object.defineProperties(e, r);
}, rK = (e) => {
  l9(e, (t, n) => {
    if (On(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (On(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, nK = (e, t) => {
  const n = {}, r = (a) => {
    a.forEach((o) => {
      n[o] = !0;
    });
  };
  return cl(e) ? r(e) : r(String(e).split(t)), n;
}, aK = () => {
}, oK = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, Cm = "abcdefghijklmnopqrstuvwxyz", Vv = "0123456789", c9 = {
  DIGIT: Vv,
  ALPHA: Cm,
  ALPHA_DIGIT: Cm + Cm.toUpperCase() + Vv
}, iK = (e = 16, t = c9.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function sK(e) {
  return !!(e && On(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const lK = (e) => {
  const t = new Array(10), n = (r, a) => {
    if (ph(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[a] = r;
        const o = cl(r) ? [] : {};
        return _u(r, (i, s) => {
          const l = n(i, a + 1);
          !Bc(l) && (o[s] = l);
        }), t[a] = void 0, o;
      }
    }
    return r;
  };
  return n(e, 0);
}, cK = Ca("AsyncFunction"), uK = (e) => e && (ph(e) || On(e)) && On(e.then) && On(e.catch), u9 = ((e, t) => e ? setImmediate : t ? ((n, r) => (Ai.addEventListener("message", ({ source: a, data: o }) => {
  a === Ai && o === n && r.length && r.shift()();
}, !1), (a) => {
  r.push(a), Ai.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  On(Ai.postMessage)
), dK = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ai) : typeof process < "u" && process.nextTick || u9, ie = {
  isArray: cl,
  isArrayBuffer: a9,
  isBuffer: TH,
  isFormData: jH,
  isArrayBufferView: MH,
  isString: OH,
  isNumber: o9,
  isBoolean: AH,
  isObject: ph,
  isPlainObject: md,
  isReadableStream: FH,
  isRequest: zH,
  isResponse: GH,
  isHeaders: HH,
  isUndefined: Bc,
  isDate: NH,
  isFile: LH,
  isBlob: RH,
  isRegExp: tK,
  isFunction: On,
  isStream: IH,
  isURLSearchParams: BH,
  isTypedArray: qH,
  isFileList: DH,
  forEach: _u,
  merge: Q1,
  extend: UH,
  trim: KH,
  stripBOM: $H,
  inherits: VH,
  toFlatObject: WH,
  kindOf: uh,
  kindOfTest: Ca,
  endsWith: YH,
  toArray: ZH,
  forEachEntry: JH,
  matchAll: XH,
  isHTMLForm: QH,
  hasOwnProperty: $v,
  hasOwnProp: $v,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: l9,
  freezeMethods: rK,
  toObjectSet: nK,
  toCamelCase: eK,
  noop: aK,
  toFiniteNumber: oK,
  findKey: i9,
  global: Ai,
  isContextDefined: s9,
  ALPHABET: c9,
  generateString: iK,
  isSpecCompliantForm: sK,
  toJSONObject: lK,
  isAsyncFn: cK,
  isThenable: uK,
  setImmediate: u9,
  asap: dK
};
function tt(e, t, n, r, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), a && (this.response = a);
}
ie.inherits(tt, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ie.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const d9 = tt.prototype, p9 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  p9[e] = { value: e };
});
Object.defineProperties(tt, p9);
Object.defineProperty(d9, "isAxiosError", { value: !0 });
tt.from = (e, t, n, r, a, o) => {
  const i = Object.create(d9);
  return ie.toFlatObject(e, i, function(s) {
    return s !== Error.prototype;
  }, (s) => s !== "isAxiosError"), tt.call(i, e.message, t, n, r, a), i.cause = e, i.name = e.name, o && Object.assign(i, o), i;
};
const pK = null;
function ef(e) {
  return ie.isPlainObject(e) || ie.isArray(e);
}
function h9(e) {
  return ie.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Wv(e, t, n) {
  return e ? e.concat(t).map(function(r, a) {
    return r = h9(r), !n && a ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
function hK(e) {
  return ie.isArray(e) && !e.some(ef);
}
const mK = ie.toFlatObject(ie, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function hh(e, t, n) {
  if (!ie.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = ie.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, m) {
    return !ie.isUndefined(m[h]);
  });
  const r = n.metaTokens, a = n.visitor || c, o = n.dots, i = n.indexes, s = (n.Blob || typeof Blob < "u" && Blob) && ie.isSpecCompliantForm(t);
  if (!ie.isFunction(a))
    throw new TypeError("visitor must be a function");
  function l(h) {
    if (h === null)
      return "";
    if (ie.isDate(h))
      return h.toISOString();
    if (!s && ie.isBlob(h))
      throw new tt("Blob is not supported. Use a Buffer instead.");
    return ie.isArrayBuffer(h) || ie.isTypedArray(h) ? s && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function c(h, m, f) {
    let g = h;
    if (h && !f && typeof h == "object") {
      if (ie.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), h = JSON.stringify(h);
      else if (ie.isArray(h) && hK(h) || (ie.isFileList(h) || ie.endsWith(m, "[]")) && (g = ie.toArray(h)))
        return m = h9(m), g.forEach(function(_, v) {
          !(ie.isUndefined(_) || _ === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Wv([m], v, o) : i === null ? m : m + "[]",
            l(_)
          );
        }), !1;
    }
    return ef(h) ? !0 : (t.append(Wv(f, m, o), l(h)), !1);
  }
  const u = [], d = Object.assign(mK, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: ef
  });
  function p(h, m) {
    if (!ie.isUndefined(h)) {
      if (u.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      u.push(h), ie.forEach(h, function(f, g) {
        (!(ie.isUndefined(f) || f === null) && a.call(
          t,
          f,
          ie.isString(g) ? g.trim() : g,
          m,
          d
        )) === !0 && p(f, m ? m.concat(g) : [g]);
      }), u.pop();
    }
  }
  if (!ie.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), t;
}
function Yv(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Ag(e, t) {
  this._pairs = [], e && hh(e, this, t);
}
const m9 = Ag.prototype;
m9.append = function(e, t) {
  this._pairs.push([e, t]);
};
m9.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, Yv);
  } : Yv;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
function fK(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function f9(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || fK, a = n && n.serialize;
  let o;
  if (a ? o = a(t, n) : o = ie.isURLSearchParams(t) ? t.toString() : new Ag(t, n).toString(r), o) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class Zv {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    ie.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const g9 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, gK = typeof URLSearchParams < "u" ? URLSearchParams : Ag, yK = typeof FormData < "u" ? FormData : null, vK = typeof Blob < "u" ? Blob : null, bK = {
  isBrowser: !0,
  classes: {
    URLSearchParams: gK,
    FormData: yK,
    Blob: vK
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ng = typeof window < "u" && typeof document < "u", _K = ((e) => Ng && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), wK = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", SK = Ng && window.location.href || "http://localhost", CK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ng,
  hasStandardBrowserEnv: _K,
  hasStandardBrowserWebWorkerEnv: wK,
  origin: SK
}, Symbol.toStringTag, { value: "Module" })), ha = {
  ...CK,
  ...bK
};
function xK(e, t) {
  return hh(e, new ha.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, a, o) {
      return ha.isNode && ie.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function kK(e) {
  return ie.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function EK(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const a = n.length;
  let o;
  for (r = 0; r < a; r++)
    o = n[r], t[o] = e[o];
  return t;
}
function y9(e) {
  function t(n, r, a, o) {
    let i = n[o++];
    if (i === "__proto__")
      return !0;
    const s = Number.isFinite(+i), l = o >= n.length;
    return i = !i && ie.isArray(a) ? a.length : i, l ? (ie.hasOwnProp(a, i) ? a[i] = [a[i], r] : a[i] = r, !s) : ((!a[i] || !ie.isObject(a[i])) && (a[i] = []), t(n, r, a[i], o) && ie.isArray(a[i]) && (a[i] = EK(a[i])), !s);
  }
  if (ie.isFormData(e) && ie.isFunction(e.entries)) {
    const n = {};
    return ie.forEachEntry(e, (r, a) => {
      t(kK(r), a, n, 0);
    }), n;
  }
  return null;
}
function PK(e, t, n) {
  if (ie.isString(e))
    try {
      return (t || JSON.parse)(e), ie.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (0, JSON.stringify)(e);
}
const wu = {
  transitional: g9,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const n = t.getContentType() || "", r = n.indexOf("application/json") > -1, a = ie.isObject(e);
    if (a && ie.isHTMLForm(e) && (e = new FormData(e)), ie.isFormData(e))
      return r ? JSON.stringify(y9(e)) : e;
    if (ie.isArrayBuffer(e) || ie.isBuffer(e) || ie.isStream(e) || ie.isFile(e) || ie.isBlob(e) || ie.isReadableStream(e))
      return e;
    if (ie.isArrayBufferView(e))
      return e.buffer;
    if (ie.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let o;
    if (a) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return xK(e, this.formSerializer).toString();
      if ((o = ie.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const i = this.env && this.env.FormData;
        return hh(
          o ? { "files[]": e } : e,
          i && new i(),
          this.formSerializer
        );
      }
    }
    return a || r ? (t.setContentType("application/json", !1), PK(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || wu.transitional, n = t && t.forcedJSONParsing, r = this.responseType === "json";
    if (ie.isResponse(e) || ie.isReadableStream(e))
      return e;
    if (e && ie.isString(e) && (n && !this.responseType || r)) {
      const a = !(t && t.silentJSONParsing) && r;
      try {
        return JSON.parse(e);
      } catch (o) {
        if (a)
          throw o.name === "SyntaxError" ? tt.from(o, tt.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: ha.classes.FormData,
    Blob: ha.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ie.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  wu.headers[e] = {};
});
const TK = ie.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), MK = (e) => {
  const t = {};
  let n, r, a;
  return e && e.split(`
`).forEach(function(o) {
    a = o.indexOf(":"), n = o.substring(0, a).trim().toLowerCase(), r = o.substring(a + 1).trim(), !(!n || t[n] && TK[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, qv = Symbol("internals");
function Dl(e) {
  return e && String(e).trim().toLowerCase();
}
function fd(e) {
  return e === !1 || e == null ? e : ie.isArray(e) ? e.map(fd) : String(e);
}
function OK(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const AK = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function xm(e, t, n, r, a) {
  if (ie.isFunction(r))
    return r.call(this, t, n);
  if (a && (t = n), !!ie.isString(t)) {
    if (ie.isString(r))
      return t.indexOf(r) !== -1;
    if (ie.isRegExp(r))
      return r.test(t);
  }
}
function NK(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function LK(e, t) {
  const n = ie.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(a, o, i) {
        return this[r].call(this, t, a, o, i);
      },
      configurable: !0
    });
  });
}
let vn = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, n) {
    const r = this;
    function a(i, s, l) {
      const c = Dl(s);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const u = ie.findKey(r, c);
      (!u || r[u] === void 0 || l === !0 || l === void 0 && r[u] !== !1) && (r[u || s] = fd(i));
    }
    const o = (i, s) => ie.forEach(i, (l, c) => a(l, c, s));
    if (ie.isPlainObject(e) || e instanceof this.constructor)
      o(e, t);
    else if (ie.isString(e) && (e = e.trim()) && !AK(e))
      o(MK(e), t);
    else if (ie.isHeaders(e))
      for (const [i, s] of e.entries())
        a(s, i, n);
    else
      e != null && a(t, e, n);
    return this;
  }
  get(e, t) {
    if (e = Dl(e), e) {
      const n = ie.findKey(this, e);
      if (n) {
        const r = this[n];
        if (!t)
          return r;
        if (t === !0)
          return OK(r);
        if (ie.isFunction(t))
          return t.call(this, r, n);
        if (ie.isRegExp(t))
          return t.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = Dl(e), e) {
      const n = ie.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!t || xm(this, this[n], n, t)));
    }
    return !1;
  }
  delete(e, t) {
    const n = this;
    let r = !1;
    function a(o) {
      if (o = Dl(o), o) {
        const i = ie.findKey(n, o);
        i && (!t || xm(n, n[i], i, t)) && (delete n[i], r = !0);
      }
    }
    return ie.isArray(e) ? e.forEach(a) : a(e), r;
  }
  clear(e) {
    const t = Object.keys(this);
    let n = t.length, r = !1;
    for (; n--; ) {
      const a = t[n];
      (!e || xm(this, this[a], a, e, !0)) && (delete this[a], r = !0);
    }
    return r;
  }
  normalize(e) {
    const t = this, n = {};
    return ie.forEach(this, (r, a) => {
      const o = ie.findKey(n, a);
      if (o) {
        t[o] = fd(r), delete t[a];
        return;
      }
      const i = e ? NK(a) : String(a).trim();
      i !== a && delete t[a], t[i] = fd(r), n[i] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return ie.forEach(this, (n, r) => {
      n != null && n !== !1 && (t[r] = e && ie.isArray(n) ? n.join(", ") : n);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const n = new this(e);
    return t.forEach((r) => n.set(r)), n;
  }
  static accessor(e) {
    const t = (this[qv] = this[qv] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function r(a) {
      const o = Dl(a);
      t[o] || (LK(n, a), t[o] = !0);
    }
    return ie.isArray(e) ? e.forEach(r) : r(e), this;
  }
};
vn.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ie.reduceDescriptors(vn.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
ie.freezeMethods(vn);
function km(e, t) {
  const n = this || wu, r = t || n, a = vn.from(r.headers);
  let o = r.data;
  return ie.forEach(e, function(i) {
    o = i.call(n, o, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), o;
}
function v9(e) {
  return !!(e && e.__CANCEL__);
}
function ul(e, t, n) {
  tt.call(this, e ?? "canceled", tt.ERR_CANCELED, t, n), this.name = "CanceledError";
}
ie.inherits(ul, tt, {
  __CANCEL__: !0
});
function b9(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new tt(
    "Request failed with status code " + n.status,
    [tt.ERR_BAD_REQUEST, tt.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function RK(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function DK(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let a = 0, o = 0, i;
  return t = t !== void 0 ? t : 1e3, function(s) {
    const l = Date.now(), c = r[o];
    i || (i = l), n[a] = s, r[a] = l;
    let u = o, d = 0;
    for (; u !== a; )
      d += n[u++], u = u % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), l - i < t)
      return;
    const p = c && l - c;
    return p ? Math.round(d * 1e3 / p) : void 0;
  };
}
function IK(e, t) {
  let n = 0, r = 1e3 / t, a, o;
  const i = (s, l = Date.now()) => {
    n = l, a = null, o && (clearTimeout(o), o = null), e.apply(null, s);
  };
  return [(...s) => {
    const l = Date.now(), c = l - n;
    c >= r ? i(s, l) : (a = s, o || (o = setTimeout(() => {
      o = null, i(a);
    }, r - c)));
  }, () => a && i(a)];
}
const op = (e, t, n = 3) => {
  let r = 0;
  const a = DK(50, 250);
  return IK((o) => {
    const i = o.loaded, s = o.lengthComputable ? o.total : void 0, l = i - r, c = a(l), u = i <= s;
    r = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - i) / c : void 0,
      event: o,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, Jv = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, Xv = (e) => (...t) => ie.asap(() => e(...t)), jK = ha.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a");
    let n;
    function r(a) {
      let o = a;
      return e && (t.setAttribute("href", o), o = t.href), t.setAttribute("href", o), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return n = r(window.location.href), function(a) {
      const o = ie.isString(a) ? r(a) : a;
      return o.protocol === n.protocol && o.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), BK = ha.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, a, o) {
      const i = [e + "=" + encodeURIComponent(t)];
      ie.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), ie.isString(r) && i.push("path=" + r), ie.isString(a) && i.push("domain=" + a), o === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function FK(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function zK(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function _9(e, t) {
  return e && !FK(t) ? zK(e, t) : t;
}
const Qv = (e) => e instanceof vn ? { ...e } : e;
function Zi(e, t) {
  t = t || {};
  const n = {};
  function r(c, u, d) {
    return ie.isPlainObject(c) && ie.isPlainObject(u) ? ie.merge.call({ caseless: d }, c, u) : ie.isPlainObject(u) ? ie.merge({}, u) : ie.isArray(u) ? u.slice() : u;
  }
  function a(c, u, d) {
    if (ie.isUndefined(u)) {
      if (!ie.isUndefined(c))
        return r(void 0, c, d);
    } else
      return r(c, u, d);
  }
  function o(c, u) {
    if (!ie.isUndefined(u))
      return r(void 0, u);
  }
  function i(c, u) {
    if (ie.isUndefined(u)) {
      if (!ie.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return r(c, u);
    if (d in e)
      return r(void 0, c);
  }
  const l = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (c, u) => a(Qv(c), Qv(u), !0)
  };
  return ie.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const u = l[c] || a, d = u(e[c], t[c], c);
    ie.isUndefined(d) && u !== s || (n[c] = d);
  }), n;
}
const w9 = (e) => {
  const t = Zi({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: a, xsrfCookieName: o, headers: i, auth: s } = t;
  t.headers = i = vn.from(i), t.url = f9(_9(t.baseURL, t.url), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (ie.isFormData(n)) {
    if (ha.hasStandardBrowserEnv || ha.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((l = i.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      i.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (ha.hasStandardBrowserEnv && (r && ie.isFunction(r) && (r = r(t)), r || r !== !1 && jK(t.url))) {
    const c = a && o && BK.read(o);
    c && i.set(a, c);
  }
  return t;
}, GK = typeof XMLHttpRequest < "u", HK = GK && function(e) {
  return new Promise(function(t, n) {
    const r = w9(e);
    let a = r.data;
    const o = vn.from(r.headers).normalize();
    let { responseType: i, onUploadProgress: s, onDownloadProgress: l } = r, c, u, d, p, h;
    function m() {
      p && p(), h && h(), r.cancelToken && r.cancelToken.unsubscribe(c), r.signal && r.signal.removeEventListener("abort", c);
    }
    let f = new XMLHttpRequest();
    f.open(r.method.toUpperCase(), r.url, !0), f.timeout = r.timeout;
    function g() {
      if (!f)
        return;
      const v = vn.from(
        "getAllResponseHeaders" in f && f.getAllResponseHeaders()
      ), w = {
        data: !i || i === "text" || i === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: v,
        config: e,
        request: f
      };
      b9(function(x) {
        t(x), m();
      }, function(x) {
        n(x), m();
      }, w), f = null;
    }
    "onloadend" in f ? f.onloadend = g : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(g);
    }, f.onabort = function() {
      f && (n(new tt("Request aborted", tt.ECONNABORTED, e, f)), f = null);
    }, f.onerror = function() {
      n(new tt("Network Error", tt.ERR_NETWORK, e, f)), f = null;
    }, f.ontimeout = function() {
      let v = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const w = r.transitional || g9;
      r.timeoutErrorMessage && (v = r.timeoutErrorMessage), n(new tt(
        v,
        w.clarifyTimeoutError ? tt.ETIMEDOUT : tt.ECONNABORTED,
        e,
        f
      )), f = null;
    }, a === void 0 && o.setContentType(null), "setRequestHeader" in f && ie.forEach(o.toJSON(), function(v, w) {
      f.setRequestHeader(w, v);
    }), ie.isUndefined(r.withCredentials) || (f.withCredentials = !!r.withCredentials), i && i !== "json" && (f.responseType = r.responseType), l && ([d, h] = op(l, !0), f.addEventListener("progress", d)), s && f.upload && ([u, p] = op(s), f.upload.addEventListener("progress", u), f.upload.addEventListener("loadend", p)), (r.cancelToken || r.signal) && (c = (v) => {
      f && (n(!v || v.type ? new ul(null, e, f) : v), f.abort(), f = null);
    }, r.cancelToken && r.cancelToken.subscribe(c), r.signal && (r.signal.aborted ? c() : r.signal.addEventListener("abort", c)));
    const _ = RK(r.url);
    if (_ && ha.protocols.indexOf(_) === -1) {
      n(new tt("Unsupported protocol " + _ + ":", tt.ERR_BAD_REQUEST, e));
      return;
    }
    f.send(a || null);
  });
}, KK = (e, t) => {
  let n = new AbortController(), r;
  const a = function(l) {
    if (!r) {
      r = !0, i();
      const c = l instanceof Error ? l : this.reason;
      n.abort(c instanceof tt ? c : new ul(c instanceof Error ? c.message : c));
    }
  };
  let o = t && setTimeout(() => {
    a(new tt(`timeout ${t} of ms exceeded`, tt.ETIMEDOUT));
  }, t);
  const i = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((l) => {
      l && (l.removeEventListener ? l.removeEventListener("abort", a) : l.unsubscribe(a));
    }), e = null);
  };
  e.forEach((l) => l && l.addEventListener && l.addEventListener("abort", a));
  const { signal: s } = n;
  return s.unsubscribe = i, [s, () => {
    o && clearTimeout(o), o = null;
  }];
}, UK = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, a;
  for (; r < n; )
    a = r + t, yield e.slice(r, a), r = a;
}, $K = async function* (e, t, n) {
  for await (const r of e)
    yield* UK(ArrayBuffer.isView(r) ? r : await n(String(r)), t);
}, eb = (e, t, n, r, a) => {
  const o = $K(e, t, a);
  let i = 0, s, l = (c) => {
    s || (s = !0, r && r(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: d } = await o.next();
        if (u) {
          l(), c.close();
          return;
        }
        let p = d.byteLength;
        if (n) {
          let h = i += p;
          n(h);
        }
        c.enqueue(new Uint8Array(d));
      } catch (u) {
        throw l(u), u;
      }
    },
    cancel(c) {
      return l(c), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, mh = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", S9 = mh && typeof ReadableStream == "function", tf = mh && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), C9 = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, VK = S9 && C9(() => {
  let e = !1;
  const t = new Request(ha.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), tb = 64 * 1024, rf = S9 && C9(() => ie.isReadableStream(new Response("").body)), ip = {
  stream: rf && ((e) => e.body)
};
mh && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !ip[t] && (ip[t] = ie.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new tt(`Response type '${t}' is not supported`, tt.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const WK = async (e) => {
  if (e == null)
    return 0;
  if (ie.isBlob(e))
    return e.size;
  if (ie.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (ie.isArrayBufferView(e) || ie.isArrayBuffer(e))
    return e.byteLength;
  if (ie.isURLSearchParams(e) && (e = e + ""), ie.isString(e))
    return (await tf(e)).byteLength;
}, YK = async (e, t) => ie.toFiniteNumber(e.getContentLength()) ?? WK(t), ZK = mh && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: a,
    cancelToken: o,
    timeout: i,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: p
  } = w9(e);
  c = c ? (c + "").toLowerCase() : "text";
  let [h, m] = a || o || i ? KK([a, o], i) : [], f, g;
  const _ = () => {
    !f && setTimeout(() => {
      h && h.unsubscribe();
    }), f = !0;
  };
  let v;
  try {
    if (l && VK && n !== "get" && n !== "head" && (v = await YK(u, r)) !== 0) {
      let C = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), E;
      if (ie.isFormData(r) && (E = C.headers.get("content-type")) && u.setContentType(E), C.body) {
        const [A, O] = Jv(
          v,
          op(Xv(l))
        );
        r = eb(C.body, tb, A, O, tf);
      }
    }
    ie.isString(d) || (d = d ? "include" : "omit"), g = new Request(t, {
      ...p,
      signal: h,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: d
    });
    let w = await fetch(g);
    const x = rf && (c === "stream" || c === "response");
    if (rf && (s || x)) {
      const C = {};
      ["status", "statusText", "headers"].forEach((M) => {
        C[M] = w[M];
      });
      const E = ie.toFiniteNumber(w.headers.get("content-length")), [A, O] = s && Jv(
        E,
        op(Xv(s), !0)
      ) || [];
      w = new Response(
        eb(w.body, tb, A, () => {
          O && O(), x && _();
        }, tf),
        C
      );
    }
    c = c || "text";
    let b = await ip[ie.findKey(ip, c) || "text"](w, e);
    return !x && _(), m && m(), await new Promise((C, E) => {
      b9(C, E, {
        data: b,
        headers: vn.from(w.headers),
        status: w.status,
        statusText: w.statusText,
        config: e,
        request: g
      });
    });
  } catch (w) {
    throw _(), w && w.name === "TypeError" && /fetch/i.test(w.message) ? Object.assign(
      new tt("Network Error", tt.ERR_NETWORK, e, g),
      {
        cause: w.cause || w
      }
    ) : tt.from(w, w && w.code, e, g);
  }
}), nf = {
  http: pK,
  xhr: HK,
  fetch: ZK
};
ie.forEach(nf, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const rb = (e) => `- ${e}`, qK = (e) => ie.isFunction(e) || e === null || e === !1, x9 = {
  getAdapter: (e) => {
    e = ie.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const a = {};
    for (let o = 0; o < t; o++) {
      n = e[o];
      let i;
      if (r = n, !qK(n) && (r = nf[(i = String(n)).toLowerCase()], r === void 0))
        throw new tt(`Unknown adapter '${i}'`);
      if (r)
        break;
      a[i || "#" + o] = r;
    }
    if (!r) {
      const o = Object.entries(a).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? o.length > 1 ? `since :
` + o.map(rb).join(`
`) : " " + rb(o[0]) : "as no adapter specified";
      throw new tt(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: nf
};
function Em(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ul(null, e);
}
function nb(e) {
  return Em(e), e.headers = vn.from(e.headers), e.data = km.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), x9.getAdapter(e.adapter || wu.adapter)(e).then(function(t) {
    return Em(e), t.data = km.call(
      e,
      e.transformResponse,
      t
    ), t.headers = vn.from(t.headers), t;
  }, function(t) {
    return v9(t) || (Em(e), t && t.response && (t.response.data = km.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = vn.from(t.response.headers))), Promise.reject(t);
  });
}
const k9 = "1.7.4", Lg = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Lg[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ab = {};
Lg.transitional = function(e, t, n) {
  function r(a, o) {
    return "[Axios v" + k9 + "] Transitional option '" + a + "'" + o + (n ? ". " + n : "");
  }
  return (a, o, i) => {
    if (e === !1)
      throw new tt(
        r(o, " has been removed" + (t ? " in " + t : "")),
        tt.ERR_DEPRECATED
      );
    return t && !ab[o] && (ab[o] = !0, console.warn(
      r(
        o,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(a, o, i) : !0;
  };
};
function JK(e, t, n) {
  if (typeof e != "object")
    throw new tt("options must be an object", tt.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let a = r.length;
  for (; a-- > 0; ) {
    const o = r[a], i = t[o];
    if (i) {
      const s = e[o], l = s === void 0 || i(s, o, e);
      if (l !== !0)
        throw new tt("option " + o + " must be " + l, tt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new tt("Unknown option " + o, tt.ERR_BAD_OPTION);
  }
}
const af = {
  assertOptions: JK,
  validators: Lg
}, xo = af.validators;
let Fi = class {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new Zv(),
      response: new Zv()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (n) {
      if (n instanceof Error) {
        let r;
        Error.captureStackTrace ? Error.captureStackTrace(r = {}) : r = new Error();
        const a = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? a && !String(n.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + a) : n.stack = a;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = Zi(this.defaults, t);
    const { transitional: n, paramsSerializer: r, headers: a } = t;
    n !== void 0 && af.assertOptions(n, {
      silentJSONParsing: xo.transitional(xo.boolean),
      forcedJSONParsing: xo.transitional(xo.boolean),
      clarifyTimeoutError: xo.transitional(xo.boolean)
    }, !1), r != null && (ie.isFunction(r) ? t.paramsSerializer = {
      serialize: r
    } : af.assertOptions(r, {
      encode: xo.function,
      serialize: xo.function
    }, !0)), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let o = a && ie.merge(
      a.common,
      a[t.method]
    );
    a && ie.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete a[h];
      }
    ), t.headers = vn.concat(o, a);
    const i = [];
    let s = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(t) === !1 || (s = s && h.synchronous, i.unshift(h.fulfilled, h.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(h) {
      l.push(h.fulfilled, h.rejected);
    });
    let c, u = 0, d;
    if (!s) {
      const h = [nb.bind(this), void 0];
      for (h.unshift.apply(h, i), h.push.apply(h, l), d = h.length, c = Promise.resolve(t); u < d; )
        c = c.then(h[u++], h[u++]);
      return c;
    }
    d = i.length;
    let p = t;
    for (u = 0; u < d; ) {
      const h = i[u++], m = i[u++];
      try {
        p = h(p);
      } catch (f) {
        m.call(this, f);
        break;
      }
    }
    try {
      c = nb.call(this, p);
    } catch (h) {
      return Promise.reject(h);
    }
    for (u = 0, d = l.length; u < d; )
      c = c.then(l[u++], l[u++]);
    return c;
  }
  getUri(e) {
    e = Zi(this.defaults, e);
    const t = _9(e.baseURL, e.url);
    return f9(t, e.params, e.paramsSerializer);
  }
};
ie.forEach(["delete", "get", "head", "options"], function(e) {
  Fi.prototype[e] = function(t, n) {
    return this.request(Zi(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
ie.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(r, a, o) {
      return this.request(Zi(o || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: r,
        data: a
      }));
    };
  }
  Fi.prototype[e] = t(), Fi.prototype[e + "Form"] = t(!0);
});
let XK = class E9 {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    const r = this;
    this.promise.then((a) => {
      if (!r._listeners)
        return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](a);
      r._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const i = new Promise((s) => {
        r.subscribe(s), o = s;
      }).then(a);
      return i.cancel = function() {
        r.unsubscribe(o);
      }, i;
    }, t(function(a, o, i) {
      r.reason || (r.reason = new ul(a, o, i), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new E9(function(n) {
        t = n;
      }),
      cancel: t
    };
  }
};
function QK(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function eU(e) {
  return ie.isObject(e) && e.isAxiosError === !0;
}
const of = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(of).forEach(([e, t]) => {
  of[t] = e;
});
function P9(e) {
  const t = new Fi(e), n = n9(Fi.prototype.request, t);
  return ie.extend(n, Fi.prototype, t, { allOwnKeys: !0 }), ie.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(r) {
    return P9(Zi(e, r));
  }, n;
}
const Sr = P9(wu);
Sr.Axios = Fi;
Sr.CanceledError = ul;
Sr.CancelToken = XK;
Sr.isCancel = v9;
Sr.VERSION = k9;
Sr.toFormData = hh;
Sr.AxiosError = tt;
Sr.Cancel = Sr.CanceledError;
Sr.all = function(e) {
  return Promise.all(e);
};
Sr.spread = QK;
Sr.isAxiosError = eU;
Sr.mergeConfig = Zi;
Sr.AxiosHeaders = vn;
Sr.formToJSON = (e) => y9(ie.isHTMLForm(e) ? new FormData(e) : e);
Sr.getAdapter = x9.getAdapter;
Sr.HttpStatusCode = of;
Sr.default = Sr;
const {
  Axios: zne,
  AxiosError: tU,
  CanceledError: Gne,
  isCancel: rU,
  CancelToken: Hne,
  VERSION: Kne,
  all: Une,
  Cancel: $ne,
  isAxiosError: Vne,
  spread: Wne,
  toFormData: Yne,
  AxiosHeaders: Zne,
  HttpStatusCode: qne,
  formToJSON: Jne,
  getAdapter: Xne,
  mergeConfig: Qne
} = Sr, Os = Sr.create({
  withCredentials: !0,
  headers: { "X-Requested-With": "XMLHttpRequest" }
}), nU = (e) => Os.interceptors.response.use((t) => t, T9()), T9 = (e) => {
  let t = !1, n = [];
  const r = () => Os.post("/api/user/token/regenerate"), a = (s) => {
    n.push(s);
  }, o = () => {
    n.forEach((s) => s()), n = [];
  }, i = async (s) => {
    const l = s.config;
    if (!t) {
      t = !0;
      try {
        return await r(), t = !1, o(), await Os(l);
      } catch (c) {
        throw t = !1, n = [], c;
      }
    }
    return new Promise((c) => {
      a(() => {
        c(Os(l));
      });
    });
  };
  return async (s) => {
    if (rU(s))
      throw s;
    if (s = s, s.code === tU.ERR_NETWORK)
      throw new xH();
    const l = s.response;
    if (!l)
      throw s;
    switch (l.status) {
      case 400:
        throw "errors" in l.data ? new Sa(l.data) : new X1(l.data);
      case 401:
        if (SH.includes(l.data.message))
          return await i(s);
        if (l.data.location)
          throw new EH(l.data.location);
        break;
      case 403:
        throw new vH();
      case 404:
        throw new Uv(Uv.isNotFoundResponse(l.data) ? l.data : void 0);
      case 409:
        throw new bH(l.data);
      case 413:
        throw new kH();
      case 422:
        throw new r9(l.data);
      case 423:
        throw new CH();
      case 424:
        throw new _H(l.data.title);
      case 500:
      case 502:
        throw new wH();
    }
    throw s;
  };
};
var Il = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ob;
function aU() {
  if (ob)
    return Il;
  ob = 1;
  var e = k, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, l, c) {
    var u, d = {}, p = null, h = null;
    c !== void 0 && (p = "" + c), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !o.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: p, ref: h, props: d, _owner: a.current };
  }
  return Il.Fragment = n, Il.jsx = i, Il.jsxs = i, Il;
}
var zu = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ib;
function oU() {
  return ib || (ib = 1, process.env.NODE_ENV !== "production" && function() {
    var e = k, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = Symbol.iterator, f = "@@iterator";
    function g(y) {
      if (y === null || typeof y != "object")
        return null;
      var P = m && y[m] || y[f];
      return typeof P == "function" ? P : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(y) {
      {
        for (var P = arguments.length, R = new Array(P > 1 ? P - 1 : 0), X = 1; X < P; X++)
          R[X - 1] = arguments[X];
        w("error", y, R);
      }
    }
    function w(y, P, R) {
      {
        var X = _.ReactDebugCurrentFrame, ce = X.getStackAddendum();
        ce !== "" && (P += "%s", R = R.concat([ce]));
        var ue = R.map(function(oe) {
          return String(oe);
        });
        ue.unshift("Warning: " + P), Function.prototype.apply.call(console[y], console, ue);
      }
    }
    var x = !1, b = !1, C = !1, E = !1, A = !1, O;
    O = Symbol.for("react.module.reference");
    function M(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === r || y === o || A || y === a || y === c || y === u || E || y === h || x || b || C || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === d || y.$$typeof === i || y.$$typeof === s || y.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === O || y.getModuleId !== void 0));
    }
    function I(y, P, R) {
      var X = y.displayName;
      if (X)
        return X;
      var ce = P.displayName || P.name || "";
      return ce !== "" ? R + "(" + ce + ")" : R;
    }
    function D(y) {
      return y.displayName || "Context";
    }
    function K(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case s:
            var P = y;
            return D(P) + ".Consumer";
          case i:
            var R = y;
            return D(R._context) + ".Provider";
          case l:
            return I(y, y.render, "ForwardRef");
          case d:
            var X = y.displayName || null;
            return X !== null ? X : K(y.type) || "Memo";
          case p: {
            var ce = y, ue = ce._payload, oe = ce._init;
            try {
              return K(oe(ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, V = 0, ee, U, H, W, L, T, B;
    function N() {
    }
    N.__reactDisabledLog = !0;
    function Y() {
      {
        if (V === 0) {
          ee = console.log, U = console.info, H = console.warn, W = console.error, L = console.group, T = console.groupCollapsed, B = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: N,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        V++;
      }
    }
    function Q() {
      {
        if (V--, V === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, y, {
              value: ee
            }),
            info: G({}, y, {
              value: U
            }),
            warn: G({}, y, {
              value: H
            }),
            error: G({}, y, {
              value: W
            }),
            group: G({}, y, {
              value: L
            }),
            groupCollapsed: G({}, y, {
              value: T
            }),
            groupEnd: G({}, y, {
              value: B
            })
          });
        }
        V < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var F = _.ReactCurrentDispatcher, re;
    function q(y, P, R) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch (ce) {
            var X = ce.stack.trim().match(/\n( *(at )?)/);
            re = X && X[1] || "";
          }
        return `
` + re + y;
      }
    }
    var he = !1, me;
    {
      var Le = typeof WeakMap == "function" ? WeakMap : Map;
      me = new Le();
    }
    function $(y, P) {
      if (!y || he)
        return "";
      {
        var R = me.get(y);
        if (R !== void 0)
          return R;
      }
      var X;
      he = !0;
      var ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ue;
      ue = F.current, F.current = null, Y();
      try {
        if (P) {
          var oe = function() {
            throw Error();
          };
          if (Object.defineProperty(oe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(oe, []);
            } catch (Be) {
              X = Be;
            }
            Reflect.construct(y, [], oe);
          } else {
            try {
              oe.call();
            } catch (Be) {
              X = Be;
            }
            y.call(oe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Be) {
            X = Be;
          }
          y();
        }
      } catch (Be) {
        if (Be && X && typeof Be.stack == "string") {
          for (var ne = Be.stack.split(`
`), Re = X.stack.split(`
`), Se = ne.length - 1, Ce = Re.length - 1; Se >= 1 && Ce >= 0 && ne[Se] !== Re[Ce]; )
            Ce--;
          for (; Se >= 1 && Ce >= 0; Se--, Ce--)
            if (ne[Se] !== Re[Ce]) {
              if (Se !== 1 || Ce !== 1)
                do
                  if (Se--, Ce--, Ce < 0 || ne[Se] !== Re[Ce]) {
                    var He = `
` + ne[Se].replace(" at new ", " at ");
                    return y.displayName && He.includes("<anonymous>") && (He = He.replace("<anonymous>", y.displayName)), typeof y == "function" && me.set(y, He), He;
                  }
                while (Se >= 1 && Ce >= 0);
              break;
            }
        }
      } finally {
        he = !1, F.current = ue, Q(), Error.prepareStackTrace = ce;
      }
      var Yt = y ? y.displayName || y.name : "", Nt = Yt ? q(Yt) : "";
      return typeof y == "function" && me.set(y, Nt), Nt;
    }
    function Te(y, P, R) {
      return $(y, !1);
    }
    function J(y) {
      var P = y.prototype;
      return !!(P && P.isReactComponent);
    }
    function te(y, P, R) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return $(y, J(y));
      if (typeof y == "string")
        return q(y);
      switch (y) {
        case c:
          return q("Suspense");
        case u:
          return q("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case l:
            return Te(y.render);
          case d:
            return te(y.type, P, R);
          case p: {
            var X = y, ce = X._payload, ue = X._init;
            try {
              return te(ue(ce), P, R);
            } catch {
            }
          }
        }
      return "";
    }
    var ve = Object.prototype.hasOwnProperty, Pe = {}, $e = _.ReactDebugCurrentFrame;
    function _t(y) {
      if (y) {
        var P = y._owner, R = te(y.type, y._source, P ? P.type : null);
        $e.setExtraStackFrame(R);
      } else
        $e.setExtraStackFrame(null);
    }
    function st(y, P, R, X, ce) {
      {
        var ue = Function.call.bind(ve);
        for (var oe in y)
          if (ue(y, oe)) {
            var ne = void 0;
            try {
              if (typeof y[oe] != "function") {
                var Re = Error((X || "React class") + ": " + R + " type `" + oe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[oe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Re.name = "Invariant Violation", Re;
              }
              ne = y[oe](P, oe, X, R, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Se) {
              ne = Se;
            }
            ne && !(ne instanceof Error) && (_t(ce), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", R, oe, typeof ne), _t(null)), ne instanceof Error && !(ne.message in Pe) && (Pe[ne.message] = !0, _t(ce), v("Failed %s type: %s", R, ne.message), _t(null));
          }
      }
    }
    var Mr = Array.isArray;
    function Vt(y) {
      return Mr(y);
    }
    function Xt(y) {
      {
        var P = typeof Symbol == "function" && Symbol.toStringTag, R = P && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return R;
      }
    }
    function je(y) {
      try {
        return lt(y), !1;
      } catch {
        return !0;
      }
    }
    function lt(y) {
      return "" + y;
    }
    function fr(y) {
      if (je(y))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Xt(y)), lt(y);
    }
    var Ot = _.ReactCurrentOwner, gr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, ge, Oe;
    Oe = {};
    function ct(y) {
      if (ve.call(y, "ref")) {
        var P = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function yr(y) {
      if (ve.call(y, "key")) {
        var P = Object.getOwnPropertyDescriptor(y, "key").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function Vr(y, P) {
      if (typeof y.ref == "string" && Ot.current && P && Ot.current.stateNode !== P) {
        var R = K(Ot.current.type);
        Oe[R] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', K(Ot.current.type), y.ref), Oe[R] = !0);
      }
    }
    function Xn(y, P) {
      {
        var R = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        R.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: R,
          configurable: !0
        });
      }
    }
    function ti(y, P) {
      {
        var R = function() {
          ge || (ge = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        R.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: R,
          configurable: !0
        });
      }
    }
    var ri = function(y, P, R, X, ce, ue, oe) {
      var ne = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: y,
        key: P,
        ref: R,
        props: oe,
        // Record the component responsible for creating this element.
        _owner: ue
      };
      return ne._store = {}, Object.defineProperty(ne._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ne, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: X
      }), Object.defineProperty(ne, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.freeze && (Object.freeze(ne.props), Object.freeze(ne)), ne;
    };
    function ni(y, P, R, X, ce) {
      {
        var ue, oe = {}, ne = null, Re = null;
        R !== void 0 && (fr(R), ne = "" + R), yr(P) && (fr(P.key), ne = "" + P.key), ct(P) && (Re = P.ref, Vr(P, ce));
        for (ue in P)
          ve.call(P, ue) && !gr.hasOwnProperty(ue) && (oe[ue] = P[ue]);
        if (y && y.defaultProps) {
          var Se = y.defaultProps;
          for (ue in Se)
            oe[ue] === void 0 && (oe[ue] = Se[ue]);
        }
        if (ne || Re) {
          var Ce = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          ne && Xn(oe, Ce), Re && ti(oe, Ce);
        }
        return ri(y, ne, Re, ce, X, Ot.current, oe);
      }
    }
    var Qr = _.ReactCurrentOwner, Qn = _.ReactDebugCurrentFrame;
    function Wt(y) {
      if (y) {
        var P = y._owner, R = te(y.type, y._source, P ? P.type : null);
        Qn.setExtraStackFrame(R);
      } else
        Qn.setExtraStackFrame(null);
    }
    var en;
    en = !1;
    function tn(y) {
      return typeof y == "object" && y !== null && y.$$typeof === t;
    }
    function ea() {
      {
        if (Qr.current) {
          var y = K(Qr.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function ai(y) {
      return "";
    }
    var ta = {};
    function oi(y) {
      {
        var P = ea();
        if (!P) {
          var R = typeof y == "string" ? y : y.displayName || y.name;
          R && (P = `

Check the top-level render call using <` + R + ">.");
        }
        return P;
      }
    }
    function ra(y, P) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var R = oi(P);
        if (ta[R])
          return;
        ta[R] = !0;
        var X = "";
        y && y._owner && y._owner !== Qr.current && (X = " It was passed a child from " + K(y._owner.type) + "."), Wt(y), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', R, X), Wt(null);
      }
    }
    function na(y, P) {
      {
        if (typeof y != "object")
          return;
        if (Vt(y))
          for (var R = 0; R < y.length; R++) {
            var X = y[R];
            tn(X) && ra(X, P);
          }
        else if (tn(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var ce = g(y);
          if (typeof ce == "function" && ce !== y.entries)
            for (var ue = ce.call(y), oe; !(oe = ue.next()).done; )
              tn(oe.value) && ra(oe.value, P);
        }
      }
    }
    function ii(y) {
      {
        var P = y.type;
        if (P == null || typeof P == "string")
          return;
        var R;
        if (typeof P == "function")
          R = P.propTypes;
        else if (typeof P == "object" && (P.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        P.$$typeof === d))
          R = P.propTypes;
        else
          return;
        if (R) {
          var X = K(P);
          st(R, y.props, "prop", X, y);
        } else if (P.PropTypes !== void 0 && !en) {
          en = !0;
          var ce = K(P);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ce || "Unknown");
        }
        typeof P.getDefaultProps == "function" && !P.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function si(y) {
      {
        for (var P = Object.keys(y.props), R = 0; R < P.length; R++) {
          var X = P[R];
          if (X !== "children" && X !== "key") {
            Wt(y), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", X), Wt(null);
            break;
          }
        }
        y.ref !== null && (Wt(y), v("Invalid attribute `ref` supplied to `React.Fragment`."), Wt(null));
      }
    }
    var aa = {};
    function oa(y, P, R, X, ce, ue) {
      {
        var oe = M(y);
        if (!oe) {
          var ne = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (ne += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Re = ai();
          Re ? ne += Re : ne += ea();
          var Se;
          y === null ? Se = "null" : Vt(y) ? Se = "array" : y !== void 0 && y.$$typeof === t ? (Se = "<" + (K(y.type) || "Unknown") + " />", ne = " Did you accidentally export a JSX literal instead of a component?") : Se = typeof y, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Se, ne);
        }
        var Ce = ni(y, P, R, ce, ue);
        if (Ce == null)
          return Ce;
        if (oe) {
          var He = P.children;
          if (He !== void 0)
            if (X)
              if (Vt(He)) {
                for (var Yt = 0; Yt < He.length; Yt++)
                  na(He[Yt], y);
                Object.freeze && Object.freeze(He);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              na(He, y);
        }
        if (ve.call(P, "key")) {
          var Nt = K(y), Be = Object.keys(P).filter(function(hi) {
            return hi !== "key";
          }), rn = Be.length > 0 ? "{key: someKey, " + Be.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!aa[Nt + rn]) {
            var pi = Be.length > 0 ? "{" + Be.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, rn, Nt, pi, Nt), aa[Nt + rn] = !0;
          }
        }
        return y === r ? si(Ce) : ii(Ce), Ce;
      }
    }
    function li(y, P, R) {
      return oa(y, P, R, !0);
    }
    function ci(y, P, R) {
      return oa(y, P, R, !1);
    }
    var ui = ci, di = li;
    zu.Fragment = r, zu.jsx = ui, zu.jsxs = di;
  }()), zu;
}
process.env.NODE_ENV === "production" ? aU() : oU();
var sf = function(e, t) {
  return sf = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r)
      Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
  }, sf(e, t);
};
function fh(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  sf(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Ra = function() {
  return Ra = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Ra.apply(this, arguments);
};
function iU(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function Pm(e, t, n) {
  if (arguments.length === 2)
    for (var r = 0, a = t.length, o; r < a; r++)
      (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var sp = function() {
  return sp = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, sp.apply(this, arguments);
}, St;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(St || (St = {}));
var nr;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(nr || (nr = {}));
var Ws;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(Ws || (Ws = {}));
function sb(e) {
  return e.type === nr.literal;
}
function sU(e) {
  return e.type === nr.argument;
}
function M9(e) {
  return e.type === nr.number;
}
function O9(e) {
  return e.type === nr.date;
}
function A9(e) {
  return e.type === nr.time;
}
function N9(e) {
  return e.type === nr.select;
}
function L9(e) {
  return e.type === nr.plural;
}
function lU(e) {
  return e.type === nr.pound;
}
function R9(e) {
  return e.type === nr.tag;
}
function D9(e) {
  return !!(e && typeof e == "object" && e.type === Ws.number);
}
function lf(e) {
  return !!(e && typeof e == "object" && e.type === Ws.dateTime);
}
var I9 = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, cU = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function uU(e) {
  var t = {};
  return e.replace(cU, function(n) {
    var r = n.length;
    switch (n[0]) {
      case "G":
        t.era = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "y":
        t.year = r === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][r - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][r - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        t.weekday = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "e":
        if (r < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "c":
        if (r < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        t.minute = ["numeric", "2-digit"][r - 1];
        break;
      case "s":
        t.second = ["numeric", "2-digit"][r - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        t.timeZoneName = r < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var ur = function() {
  return ur = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, ur.apply(this, arguments);
}, dU = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function pU(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(dU).filter(function(p) {
    return p.length > 0;
  }), n = [], r = 0, a = t; r < a.length; r++) {
    var o = a[r], i = o.split("/");
    if (i.length === 0)
      throw new Error("Invalid number skeleton");
    for (var s = i[0], l = i.slice(1), c = 0, u = l; c < u.length; c++) {
      var d = u[c];
      if (d.length === 0)
        throw new Error("Invalid number skeleton");
    }
    n.push({ stem: s, options: l });
  }
  return n;
}
function hU(e) {
  return e.replace(/^(.*?)-/, "");
}
var lb = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, j9 = /^(@+)?(\+|#+)?[rs]?$/g, mU = /(\*)(0+)|(#+)(0+)|(0+)/g, B9 = /^(0+)$/;
function cb(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(j9, function(n, r, a) {
    return typeof a != "string" ? (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length) : a === "+" ? t.minimumSignificantDigits = r.length : r[0] === "#" ? t.maximumSignificantDigits = r.length : (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length + (typeof a == "string" ? a.length : 0)), "";
  }), t;
}
function F9(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function fU(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var n = e.slice(0, 2);
    if (n === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : n === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !B9.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function ub(e) {
  var t = {}, n = F9(e);
  return n || t;
}
function gU(e) {
  for (var t = {}, n = 0, r = e; n < r.length; n++) {
    var a = r[n];
    switch (a.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = a.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = hU(a.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = ur(ur(ur({}, t), { notation: "scientific" }), a.options.reduce(function(l, c) {
          return ur(ur({}, l), ub(c));
        }, {}));
        continue;
      case "engineering":
        t = ur(ur(ur({}, t), { notation: "engineering" }), a.options.reduce(function(l, c) {
          return ur(ur({}, l), ub(c));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(a.options[0]);
        continue;
      case "rounding-mode-floor":
        t.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        t.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        t.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        t.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        t.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        t.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        t.roundingMode = "halfExpand";
        continue;
      case "integer-width":
        if (a.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        a.options[0].replace(mU, function(l, c, u, d, p, h) {
          if (c)
            t.minimumIntegerDigits = u.length;
          else {
            if (d && p)
              throw new Error("We currently do not support maximum integer digits");
            if (h)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (B9.test(a.stem)) {
      t.minimumIntegerDigits = a.stem.length;
      continue;
    }
    if (lb.test(a.stem)) {
      if (a.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      a.stem.replace(lb, function(l, c, u, d, p, h) {
        return u === "*" ? t.minimumFractionDigits = c.length : d && d[0] === "#" ? t.maximumFractionDigits = d.length : p && h ? (t.minimumFractionDigits = p.length, t.maximumFractionDigits = p.length + h.length) : (t.minimumFractionDigits = c.length, t.maximumFractionDigits = c.length), "";
      });
      var o = a.options[0];
      o === "w" ? t = ur(ur({}, t), { trailingZeroDisplay: "stripIfInteger" }) : o && (t = ur(ur({}, t), cb(o)));
      continue;
    }
    if (j9.test(a.stem)) {
      t = ur(ur({}, t), cb(a.stem));
      continue;
    }
    var i = F9(a.stem);
    i && (t = ur(ur({}, t), i));
    var s = fU(a.stem);
    s && (t = ur(ur({}, t), s));
  }
  return t;
}
var Gu = {
  "001": [
    "H",
    "h"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CU: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BO": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-EC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-PE": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function yU(e, t) {
  for (var n = "", r = 0; r < e.length; r++) {
    var a = e.charAt(r);
    if (a === "j") {
      for (var o = 0; r + 1 < e.length && e.charAt(r + 1) === a; )
        o++, r++;
      var i = 1 + (o & 1), s = o < 2 ? 1 : 3 + (o >> 1), l = "a", c = vU(t);
      for ((c == "H" || c == "k") && (s = 0); s-- > 0; )
        n += l;
      for (; i-- > 0; )
        n = c + n;
    } else
      a === "J" ? n += "H" : n += a;
  }
  return n;
}
function vU(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var n = e.language, r;
  n !== "root" && (r = e.maximize().region);
  var a = Gu[r || ""] || Gu[n || ""] || Gu["".concat(n, "-001")] || Gu["001"];
  return a[0];
}
var Tm, bU = new RegExp("^".concat(I9.source, "*")), _U = new RegExp("".concat(I9.source, "*$"));
function xt(e, t) {
  return { start: e, end: t };
}
var wU = !!String.prototype.startsWith && "_a".startsWith("a", 1), SU = !!String.fromCodePoint, CU = !!Object.fromEntries, xU = !!String.prototype.codePointAt, kU = !!String.prototype.trimStart, EU = !!String.prototype.trimEnd, PU = !!Number.isSafeInteger, TU = PU ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, cf = !0;
try {
  var MU = G9("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  cf = ((Tm = MU.exec("a")) === null || Tm === void 0 ? void 0 : Tm[0]) === "a";
} catch {
  cf = !1;
}
var db = wU ? (
  // Native
  function(e, t, n) {
    return e.startsWith(t, n);
  }
) : (
  // For IE11
  function(e, t, n) {
    return e.slice(n, n + t.length) === t;
  }
), uf = SU ? String.fromCodePoint : (
  // IE11
  function() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    for (var n = "", r = e.length, a = 0, o; r > a; ) {
      if (o = e[a++], o > 1114111)
        throw RangeError(o + " is not a valid code point");
      n += o < 65536 ? String.fromCharCode(o) : String.fromCharCode(((o -= 65536) >> 10) + 55296, o % 1024 + 56320);
    }
    return n;
  }
), pb = (
  // native
  CU ? Object.fromEntries : (
    // Ponyfill
    function(e) {
      for (var t = {}, n = 0, r = e; n < r.length; n++) {
        var a = r[n], o = a[0], i = a[1];
        t[o] = i;
      }
      return t;
    }
  )
), z9 = xU ? (
  // Native
  function(e, t) {
    return e.codePointAt(t);
  }
) : (
  // IE 11
  function(e, t) {
    var n = e.length;
    if (!(t < 0 || t >= n)) {
      var r = e.charCodeAt(t), a;
      return r < 55296 || r > 56319 || t + 1 === n || (a = e.charCodeAt(t + 1)) < 56320 || a > 57343 ? r : (r - 55296 << 10) + (a - 56320) + 65536;
    }
  }
), OU = kU ? (
  // Native
  function(e) {
    return e.trimStart();
  }
) : (
  // Ponyfill
  function(e) {
    return e.replace(bU, "");
  }
), AU = EU ? (
  // Native
  function(e) {
    return e.trimEnd();
  }
) : (
  // Ponyfill
  function(e) {
    return e.replace(_U, "");
  }
);
function G9(e, t) {
  return new RegExp(e, t);
}
var df;
if (cf) {
  var hb = G9("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  df = function(e, t) {
    var n;
    hb.lastIndex = t;
    var r = hb.exec(e);
    return (n = r[1]) !== null && n !== void 0 ? n : "";
  };
} else
  df = function(e, t) {
    for (var n = []; ; ) {
      var r = z9(e, t);
      if (r === void 0 || H9(r) || DU(r))
        break;
      n.push(r), t += r >= 65536 ? 2 : 1;
    }
    return uf.apply(void 0, n);
  };
var NU = (
  /** @class */
  function() {
    function e(t, n) {
      n === void 0 && (n = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!n.ignoreTag, this.locale = n.locale, this.requiresOtherClause = !!n.requiresOtherClause, this.shouldParseSkeletons = !!n.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, n, r) {
      for (var a = []; !this.isEOF(); ) {
        var o = this.char();
        if (o === 123) {
          var i = this.parseArgument(t, r);
          if (i.err)
            return i;
          a.push(i.val);
        } else {
          if (o === 125 && t > 0)
            break;
          if (o === 35 && (n === "plural" || n === "selectordinal")) {
            var s = this.clonePosition();
            this.bump(), a.push({
              type: nr.pound,
              location: xt(s, this.clonePosition())
            });
          } else if (o === 60 && !this.ignoreTag && this.peek() === 47) {
            if (r)
              break;
            return this.error(St.UNMATCHED_CLOSING_TAG, xt(this.clonePosition(), this.clonePosition()));
          } else if (o === 60 && !this.ignoreTag && pf(this.peek() || 0)) {
            var i = this.parseTag(t, n);
            if (i.err)
              return i;
            a.push(i.val);
          } else {
            var i = this.parseLiteral(t, n);
            if (i.err)
              return i;
            a.push(i.val);
          }
        }
      }
      return { val: a, err: null };
    }, e.prototype.parseTag = function(t, n) {
      var r = this.clonePosition();
      this.bump();
      var a = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: nr.literal,
            value: "<".concat(a, "/>"),
            location: xt(r, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var o = this.parseMessage(t + 1, n, !0);
        if (o.err)
          return o;
        var i = o.val, s = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !pf(this.char()))
            return this.error(St.INVALID_TAG, xt(s, this.clonePosition()));
          var l = this.clonePosition(), c = this.parseTagName();
          return a !== c ? this.error(St.UNMATCHED_CLOSING_TAG, xt(l, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: nr.tag,
              value: a,
              children: i,
              location: xt(r, this.clonePosition())
            },
            err: null
          } : this.error(St.INVALID_TAG, xt(s, this.clonePosition())));
        } else
          return this.error(St.UNCLOSED_TAG, xt(r, this.clonePosition()));
      } else
        return this.error(St.INVALID_TAG, xt(r, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && RU(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, n) {
      for (var r = this.clonePosition(), a = ""; ; ) {
        var o = this.tryParseQuote(n);
        if (o) {
          a += o;
          continue;
        }
        var i = this.tryParseUnquoted(t, n);
        if (i) {
          a += i;
          continue;
        }
        var s = this.tryParseLeftAngleBracket();
        if (s) {
          a += s;
          continue;
        }
        break;
      }
      var l = xt(r, this.clonePosition());
      return {
        val: { type: nr.literal, value: a, location: l },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !LU(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var n = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var r = this.char();
        if (r === 39)
          if (this.peek() === 39)
            n.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          n.push(r);
        this.bump();
      }
      return uf.apply(void 0, n);
    }, e.prototype.tryParseUnquoted = function(t, n) {
      if (this.isEOF())
        return null;
      var r = this.char();
      return r === 60 || r === 123 || r === 35 && (n === "plural" || n === "selectordinal") || r === 125 && t > 0 ? null : (this.bump(), uf(r));
    }, e.prototype.parseArgument = function(t, n) {
      var r = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(St.EXPECT_ARGUMENT_CLOSING_BRACE, xt(r, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(St.EMPTY_ARGUMENT, xt(r, this.clonePosition()));
      var a = this.parseIdentifierIfPossible().value;
      if (!a)
        return this.error(St.MALFORMED_ARGUMENT, xt(r, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(St.EXPECT_ARGUMENT_CLOSING_BRACE, xt(r, this.clonePosition()));
      switch (this.char()) {
        case 125:
          return this.bump(), {
            val: {
              type: nr.argument,
              // value does not include the opening and closing braces.
              value: a,
              location: xt(r, this.clonePosition())
            },
            err: null
          };
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(St.EXPECT_ARGUMENT_CLOSING_BRACE, xt(r, this.clonePosition())) : this.parseArgumentOptions(t, n, a, r);
        default:
          return this.error(St.MALFORMED_ARGUMENT, xt(r, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), n = this.offset(), r = df(this.message, n), a = n + r.length;
      this.bumpTo(a);
      var o = this.clonePosition(), i = xt(t, o);
      return { value: r, location: i };
    }, e.prototype.parseArgumentOptions = function(t, n, r, a) {
      var o, i = this.clonePosition(), s = this.parseIdentifierIfPossible().value, l = this.clonePosition();
      switch (s) {
        case "":
          return this.error(St.EXPECT_ARGUMENT_TYPE, xt(i, l));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var c = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var u = this.clonePosition(), d = this.parseSimpleArgStyleIfPossible();
            if (d.err)
              return d;
            var p = AU(d.val);
            if (p.length === 0)
              return this.error(St.EXPECT_ARGUMENT_STYLE, xt(this.clonePosition(), this.clonePosition()));
            var h = xt(u, this.clonePosition());
            c = { style: p, styleLocation: h };
          }
          var m = this.tryParseArgumentClose(a);
          if (m.err)
            return m;
          var f = xt(a, this.clonePosition());
          if (c && db(c == null ? void 0 : c.style, "::", 0)) {
            var g = OU(c.style.slice(2));
            if (s === "number") {
              var d = this.parseNumberSkeletonFromString(g, c.styleLocation);
              return d.err ? d : {
                val: { type: nr.number, value: r, location: f, style: d.val },
                err: null
              };
            } else {
              if (g.length === 0)
                return this.error(St.EXPECT_DATE_TIME_SKELETON, f);
              var _ = g;
              this.locale && (_ = yU(g, this.locale));
              var p = {
                type: Ws.dateTime,
                pattern: _,
                location: c.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? uU(_) : {}
              }, v = s === "date" ? nr.date : nr.time;
              return {
                val: { type: v, value: r, location: f, style: p },
                err: null
              };
            }
          }
          return {
            val: {
              type: s === "number" ? nr.number : s === "date" ? nr.date : nr.time,
              value: r,
              location: f,
              style: (o = c == null ? void 0 : c.style) !== null && o !== void 0 ? o : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var w = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(St.EXPECT_SELECT_ARGUMENT_OPTIONS, xt(w, sp({}, w)));
          this.bumpSpace();
          var x = this.parseIdentifierIfPossible(), b = 0;
          if (s !== "select" && x.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(St.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, xt(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var d = this.tryParseDecimalInteger(St.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, St.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (d.err)
              return d;
            this.bumpSpace(), x = this.parseIdentifierIfPossible(), b = d.val;
          }
          var C = this.tryParsePluralOrSelectOptions(t, s, n, x);
          if (C.err)
            return C;
          var m = this.tryParseArgumentClose(a);
          if (m.err)
            return m;
          var E = xt(a, this.clonePosition());
          return s === "select" ? {
            val: {
              type: nr.select,
              value: r,
              options: pb(C.val),
              location: E
            },
            err: null
          } : {
            val: {
              type: nr.plural,
              value: r,
              options: pb(C.val),
              offset: b,
              pluralType: s === "plural" ? "cardinal" : "ordinal",
              location: E
            },
            err: null
          };
        }
        default:
          return this.error(St.INVALID_ARGUMENT_TYPE, xt(i, l));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(St.EXPECT_ARGUMENT_CLOSING_BRACE, xt(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, n = this.clonePosition(); !this.isEOF(); ) {
        var r = this.char();
        switch (r) {
          case 39: {
            this.bump();
            var a = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(St.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, xt(a, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(n.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(n.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, n) {
      var r = [];
      try {
        r = pU(t);
      } catch {
        return this.error(St.INVALID_NUMBER_SKELETON, n);
      }
      return {
        val: {
          type: Ws.number,
          tokens: r,
          location: n,
          parsedOptions: this.shouldParseSkeletons ? gU(r) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, n, r, a) {
      for (var o, i = !1, s = [], l = /* @__PURE__ */ new Set(), c = a.value, u = a.location; ; ) {
        if (c.length === 0) {
          var d = this.clonePosition();
          if (n !== "select" && this.bumpIf("=")) {
            var p = this.tryParseDecimalInteger(St.EXPECT_PLURAL_ARGUMENT_SELECTOR, St.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (p.err)
              return p;
            u = xt(d, this.clonePosition()), c = this.message.slice(d.offset, this.offset());
          } else
            break;
        }
        if (l.has(c))
          return this.error(n === "select" ? St.DUPLICATE_SELECT_ARGUMENT_SELECTOR : St.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, u);
        c === "other" && (i = !0), this.bumpSpace();
        var h = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(n === "select" ? St.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : St.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, xt(this.clonePosition(), this.clonePosition()));
        var m = this.parseMessage(t + 1, n, r);
        if (m.err)
          return m;
        var f = this.tryParseArgumentClose(h);
        if (f.err)
          return f;
        s.push([
          c,
          {
            value: m.val,
            location: xt(h, this.clonePosition())
          }
        ]), l.add(c), this.bumpSpace(), o = this.parseIdentifierIfPossible(), c = o.value, u = o.location;
      }
      return s.length === 0 ? this.error(n === "select" ? St.EXPECT_SELECT_ARGUMENT_SELECTOR : St.EXPECT_PLURAL_ARGUMENT_SELECTOR, xt(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !i ? this.error(St.MISSING_OTHER_CLAUSE, xt(this.clonePosition(), this.clonePosition())) : { val: s, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, n) {
      var r = 1, a = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (r = -1);
      for (var o = !1, i = 0; !this.isEOF(); ) {
        var s = this.char();
        if (s >= 48 && s <= 57)
          o = !0, i = i * 10 + (s - 48), this.bump();
        else
          break;
      }
      var l = xt(a, this.clonePosition());
      return o ? (i *= r, TU(i) ? { val: i, err: null } : this.error(n, l)) : this.error(t, l);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var n = z9(this.message, t);
      if (n === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return n;
    }, e.prototype.error = function(t, n) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: n
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (db(this.message, t, this.offset())) {
        for (var n = 0; n < t.length; n++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var n = this.offset(), r = this.message.indexOf(t, n);
      return r >= 0 ? (this.bumpTo(r), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var n = this.offset();
        if (n === t)
          break;
        if (n > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && H9(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), n = this.offset(), r = this.message.charCodeAt(n + (t >= 65536 ? 2 : 1));
      return r ?? null;
    }, e;
  }()
);
function pf(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function LU(e) {
  return pf(e) || e === 47;
}
function RU(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function H9(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function DU(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function hf(e) {
  e.forEach(function(t) {
    if (delete t.location, N9(t) || L9(t))
      for (var n in t.options)
        delete t.options[n].location, hf(t.options[n].value);
    else
      M9(t) && D9(t.style) || (O9(t) || A9(t)) && lf(t.style) ? delete t.style.location : R9(t) && hf(t.children);
  });
}
function IU(e, t) {
  t === void 0 && (t = {}), t = sp({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var n = new NU(e, t).parse();
  if (n.err) {
    var r = SyntaxError(St[n.err.kind]);
    throw r.location = n.err.location, r.originalMessage = n.err.message, r;
  }
  return t != null && t.captureLocation || hf(n.val), n.val;
}
function Mm(e, t) {
  var n = t && t.cache ? t.cache : HU, r = t && t.serializer ? t.serializer : GU, a = t && t.strategy ? t.strategy : BU;
  return a(e, {
    cache: n,
    serializer: r
  });
}
function jU(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function K9(e, t, n, r) {
  var a = jU(r) ? r : n(r), o = t.get(a);
  return typeof o > "u" && (o = e.call(this, r), t.set(a, o)), o;
}
function U9(e, t, n) {
  var r = Array.prototype.slice.call(arguments, 3), a = n(r), o = t.get(a);
  return typeof o > "u" && (o = e.apply(this, r), t.set(a, o)), o;
}
function Rg(e, t, n, r, a) {
  return n.bind(t, e, r, a);
}
function BU(e, t) {
  var n = e.length === 1 ? K9 : U9;
  return Rg(e, this, n, t.cache.create(), t.serializer);
}
function FU(e, t) {
  return Rg(e, this, U9, t.cache.create(), t.serializer);
}
function zU(e, t) {
  return Rg(e, this, K9, t.cache.create(), t.serializer);
}
var GU = function() {
  return JSON.stringify(arguments);
};
function Dg() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
Dg.prototype.get = function(e) {
  return this.cache[e];
};
Dg.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var HU = {
  create: function() {
    return new Dg();
  }
}, Om = {
  variadic: FU,
  monadic: zU
}, Ys;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(Ys || (Ys = {}));
var gh = (
  /** @class */
  function(e) {
    fh(t, e);
    function t(n, r, a) {
      var o = e.call(this, n) || this;
      return o.code = r, o.originalMessage = a, o;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  }(Error)
), mb = (
  /** @class */
  function(e) {
    fh(t, e);
    function t(n, r, a, o) {
      return e.call(this, 'Invalid values for "'.concat(n, '": "').concat(r, '". Options are "').concat(Object.keys(a).join('", "'), '"'), Ys.INVALID_VALUE, o) || this;
    }
    return t;
  }(gh)
), KU = (
  /** @class */
  function(e) {
    fh(t, e);
    function t(n, r, a) {
      return e.call(this, 'Value for "'.concat(n, '" must be of type ').concat(r), Ys.INVALID_VALUE, a) || this;
    }
    return t;
  }(gh)
), UU = (
  /** @class */
  function(e) {
    fh(t, e);
    function t(n, r) {
      return e.call(this, 'The intl string context variable "'.concat(n, '" was not provided to the string "').concat(r, '"'), Ys.MISSING_VALUE, r) || this;
    }
    return t;
  }(gh)
), an;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(an || (an = {}));
function $U(e) {
  return e.length < 2 ? e : e.reduce(function(t, n) {
    var r = t[t.length - 1];
    return !r || r.type !== an.literal || n.type !== an.literal ? t.push(n) : r.value += n.value, t;
  }, []);
}
function VU(e) {
  return typeof e == "function";
}
function gd(e, t, n, r, a, o, i) {
  if (e.length === 1 && sb(e[0]))
    return [
      {
        type: an.literal,
        value: e[0].value
      }
    ];
  for (var s = [], l = 0, c = e; l < c.length; l++) {
    var u = c[l];
    if (sb(u)) {
      s.push({
        type: an.literal,
        value: u.value
      });
      continue;
    }
    if (lU(u)) {
      typeof o == "number" && s.push({
        type: an.literal,
        value: n.getNumberFormat(t).format(o)
      });
      continue;
    }
    var d = u.value;
    if (!(a && d in a))
      throw new UU(d, i);
    var p = a[d];
    if (sU(u)) {
      (!p || typeof p == "string" || typeof p == "number") && (p = typeof p == "string" || typeof p == "number" ? String(p) : ""), s.push({
        type: typeof p == "string" ? an.literal : an.object,
        value: p
      });
      continue;
    }
    if (O9(u)) {
      var h = typeof u.style == "string" ? r.date[u.style] : lf(u.style) ? u.style.parsedOptions : void 0;
      s.push({
        type: an.literal,
        value: n.getDateTimeFormat(t, h).format(p)
      });
      continue;
    }
    if (A9(u)) {
      var h = typeof u.style == "string" ? r.time[u.style] : lf(u.style) ? u.style.parsedOptions : r.time.medium;
      s.push({
        type: an.literal,
        value: n.getDateTimeFormat(t, h).format(p)
      });
      continue;
    }
    if (M9(u)) {
      var h = typeof u.style == "string" ? r.number[u.style] : D9(u.style) ? u.style.parsedOptions : void 0;
      h && h.scale && (p = p * (h.scale || 1)), s.push({
        type: an.literal,
        value: n.getNumberFormat(t, h).format(p)
      });
      continue;
    }
    if (R9(u)) {
      var m = u.children, f = u.value, g = a[f];
      if (!VU(g))
        throw new KU(f, "function", i);
      var _ = gd(m, t, n, r, a, o), v = g(_.map(function(b) {
        return b.value;
      }));
      Array.isArray(v) || (v = [v]), s.push.apply(s, v.map(function(b) {
        return {
          type: typeof b == "string" ? an.literal : an.object,
          value: b
        };
      }));
    }
    if (N9(u)) {
      var w = u.options[p] || u.options.other;
      if (!w)
        throw new mb(u.value, p, Object.keys(u.options), i);
      s.push.apply(s, gd(w.value, t, n, r, a));
      continue;
    }
    if (L9(u)) {
      var w = u.options["=".concat(p)];
      if (!w) {
        if (!Intl.PluralRules)
          throw new gh(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, Ys.MISSING_INTL_API, i);
        var x = n.getPluralRules(t, { type: u.pluralType }).select(p - (u.offset || 0));
        w = u.options[x] || u.options.other;
      }
      if (!w)
        throw new mb(u.value, p, Object.keys(u.options), i);
      s.push.apply(s, gd(w.value, t, n, r, a, p - (u.offset || 0)));
      continue;
    }
  }
  return $U(s);
}
function WU(e, t) {
  return t ? Ra(Ra(Ra({}, e || {}), t || {}), Object.keys(e).reduce(function(n, r) {
    return n[r] = Ra(Ra({}, e[r]), t[r] || {}), n;
  }, {})) : e;
}
function YU(e, t) {
  return t ? Object.keys(e).reduce(function(n, r) {
    return n[r] = WU(e[r], t[r]), n;
  }, Ra({}, e)) : e;
}
function Am(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function ZU(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: Mm(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.NumberFormat).bind.apply(t, Pm([void 0], n, !1)))();
    }, {
      cache: Am(e.number),
      strategy: Om.variadic
    }),
    getDateTimeFormat: Mm(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, Pm([void 0], n, !1)))();
    }, {
      cache: Am(e.dateTime),
      strategy: Om.variadic
    }),
    getPluralRules: Mm(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.PluralRules).bind.apply(t, Pm([void 0], n, !1)))();
    }, {
      cache: Am(e.pluralRules),
      strategy: Om.variadic
    })
  };
}
/** @class */
(function() {
  function e(t, n, r, a) {
    var o = this;
    if (n === void 0 && (n = e.defaultLocale), this.formatterCache = {
      number: {},
      dateTime: {},
      pluralRules: {}
    }, this.format = function(l) {
      var c = o.formatToParts(l);
      if (c.length === 1)
        return c[0].value;
      var u = c.reduce(function(d, p) {
        return !d.length || p.type !== an.literal || typeof d[d.length - 1] != "string" ? d.push(p.value) : d[d.length - 1] += p.value, d;
      }, []);
      return u.length <= 1 ? u[0] || "" : u;
    }, this.formatToParts = function(l) {
      return gd(o.ast, o.locales, o.formatters, o.formats, l, void 0, o.message);
    }, this.resolvedOptions = function() {
      var l;
      return {
        locale: ((l = o.resolvedLocale) === null || l === void 0 ? void 0 : l.toString()) || Intl.NumberFormat.supportedLocalesOf(o.locales)[0]
      };
    }, this.getAst = function() {
      return o.ast;
    }, this.locales = n, this.resolvedLocale = e.resolveLocale(n), typeof t == "string") {
      if (this.message = t, !e.__parse)
        throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
      var i = a || {};
      i.formatters;
      var s = iU(i, ["formatters"]);
      this.ast = e.__parse(t, Ra(Ra({}, s), { locale: this.resolvedLocale }));
    } else
      this.ast = t;
    if (!Array.isArray(this.ast))
      throw new TypeError("A message must be provided as a String or AST.");
    this.formats = YU(e.formats, r), this.formatters = a && a.formatters || ZU(this.formatterCache);
  }
  return Object.defineProperty(e, "defaultLocale", {
    get: function() {
      return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
    },
    enumerable: !1,
    configurable: !0
  }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
    if (!(typeof Intl.Locale > "u")) {
      var n = Intl.NumberFormat.supportedLocalesOf(t);
      return n.length > 0 ? new Intl.Locale(n[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
    }
  }, e.__parse = IU, e.formats = {
    number: {
      integer: {
        maximumFractionDigits: 0
      },
      currency: {
        style: "currency"
      },
      percent: {
        style: "percent"
      }
    },
    date: {
      short: {
        month: "numeric",
        day: "numeric",
        year: "2-digit"
      },
      medium: {
        month: "short",
        day: "numeric",
        year: "numeric"
      },
      long: {
        month: "long",
        day: "numeric",
        year: "numeric"
      },
      full: {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric"
      }
    },
    time: {
      short: {
        hour: "numeric",
        minute: "numeric"
      },
      medium: {
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      },
      long: {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZoneName: "short"
      },
      full: {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZoneName: "short"
      }
    }
  }, e;
})();
const Hr = (e, t) => {
  De(() => {
    t(e);
  }, [e]);
};
var $9 = /* @__PURE__ */ ((e) => (e.Editor = "editor", e.Community = "community", e.BlockPreview = "block_preview", e.Membership = "membership", e.Marketplace = "marketplace", e.Settings = "settings", e.Email = "email", e.Ckeditor = "ckeditor", e.TextEditor = "text_editor", e.BlogPost = "blog_post", e.PageTemplate = "page_template", e.PageTemplatePreview = "page_template_preview", e.BlogTemplatePreview = "blog_template_preview", e.EmailTemplate = "email_template", e.WebsiteTemplate = "website_template", e.Product = "product", e.FunnelTemplatePreview = "funnel_template_preview", e.DigitalStore = "digital_store", e.DigitalProductResource = "digital_product_resource", e.CalendarHostAvatar = "calendar_host_avatar", e.FileManager = "file_manager", e.WhiteLabel = "white_label", e))($9 || {}), V9 = /* @__PURE__ */ ((e) => (e.Image = "image", e.ImageOther = "image_other", e.Video = "video", e.Audio = "audio", e.Font = "font", e.Document = "document", e))(V9 || {});
$9.WhiteLabel, V9.Image;
const W9 = Qe(null), eae = ({
  children: e,
  locale: t
}) => {
  const { setLocale: n } = zt();
  return Hr(t, (r) => {
    const a = fu(r);
    xr.language !== a && xr.changeLanguage(a), n(r);
  }), /* @__PURE__ */ S.jsx(NN, { locale: t, children: /* @__PURE__ */ S.jsx(W9.Provider, { value: { locale: t }, children: e }) });
}, qn = () => {
  const e = Ue(W9);
  if (!e)
    throw new Error("useLocaleContext must be used within a LocaleProvider");
  return e;
};
var mt = /* @__PURE__ */ ((e) => (e.default = "default", e.luminous = "luminous", e.night = "night", e.camilla = "camilla", e.creamy = "creamy", e.sepia = "sepia", e.urban = "urban", e.solarized = "solarized", e.cosmopolitan = "cosmopolitan", e.new_york = "new_york", e.cyberpunk = "cyberpunk", e))(mt || {}), Rr = /* @__PURE__ */ ((e) => (e.Arizonia = "arizonia", e.Inter = "inter", e.Kanit = "kanit", e.Lato = "lato", e.Lora = "lora", e.Merriweather = "merriweather", e.Montserrat = "montserrat", e.NotoSans = "notosans", e.Nunito = "nunito", e.OpenSans = "opensans", e.PlayfairDisplay = "playfairdisplay", e.Poppins = "poppins", e.Roboto = "roboto", e.SourceSansPro = "sourcesanspro", e.Ubuntu = "ubuntu", e))(Rr || {}), Ci = /* @__PURE__ */ ((e) => (e.primaryColor = "--THEME-primary", e.secondaryColor = "--THEME-secondary", e.tertiaryColor = "--THEME-tertiary", e.textColorPrimary = "--THEME-text-primary", e.textColorSecondary = "--THEME-text-secondary", e.borderColorTertiary = "--THEME-border-tertiary", e))(Ci || {}), mf = /* @__PURE__ */ ((e) => (e.primaryFont = "--THEME-font-primary", e.secondaryFont = "--THEME-font-secondary", e))(mf || {});
const ia = {
  primaryFont: Rr.Inter,
  secondaryFont: Rr.Inter
}, ff = {
  [mt.default]: {
    theme: mt.default,
    primaryColor: "#00A0FF",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F1F4F8",
    ...ia
  },
  [mt.luminous]: {
    theme: mt.luminous,
    primaryColor: "#6620FA",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F8F5FF",
    ...ia
  },
  [mt.night]: {
    theme: mt.night,
    primaryColor: "#FC3C67",
    secondaryColor: "#0A1733",
    tertiaryColor: "#142D63",
    ...ia
  },
  [mt.camilla]: {
    theme: mt.camilla,
    primaryColor: "#EEFF34",
    secondaryColor: "#121212",
    tertiaryColor: "#121212",
    ...ia
  },
  [mt.creamy]: {
    theme: mt.creamy,
    primaryColor: "#E40160",
    secondaryColor: "#FCF1E3",
    tertiaryColor: "#FFFAF4",
    ...ia
  },
  [mt.sepia]: {
    theme: mt.sepia,
    primaryColor: "#E7961B",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#FFF7EB",
    ...ia
  },
  [mt.solarized]: {
    theme: mt.solarized,
    primaryColor: "#00A0FF",
    secondaryColor: "#011420",
    tertiaryColor: "#011420",
    ...ia
  },
  [mt.new_york]: {
    theme: mt.new_york,
    primaryColor: "#FFC634",
    secondaryColor: "#01133A",
    tertiaryColor: "#01133A",
    ...ia
  },
  [mt.urban]: {
    theme: mt.urban,
    primaryColor: "#F57F29",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F9F9F9",
    ...ia
  },
  [mt.cyberpunk]: {
    theme: mt.cyberpunk,
    primaryColor: "#AE3ECA",
    secondaryColor: "#131114",
    tertiaryColor: "#1e1533",
    ...ia
  },
  [mt.cosmopolitan]: {
    theme: mt.cosmopolitan,
    primaryColor: "#D9335a",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F9F9F9",
    ...ia
  }
}, fb = "root-design-css", gb = "root-font-css", qU = (e) => {
  const {
    primaryColor: t,
    secondaryColor: n,
    tertiaryColor: r,
    textColorPrimary: a,
    textColorSecondary: o,
    borderColorTertiary: i
  } = yh(e);
  return `
  :root {
      /* Colors */
      /* Default primary color */
      ${Ci.primaryColor}: ${t}; /* Default primary color */

      /* Default secondary color */
      ${Ci.secondaryColor}: ${n}; /* Default secondary color */

      /* Default background color */
      ${Ci.tertiaryColor}: ${r}; /* Default background color */

      /* Default text primary color */
      ${Ci.textColorPrimary}: ${a}; /* Default text primary color */
      ${Ci.textColorSecondary}: ${o}; /* Default text secondary color */
      ${Ci.borderColorTertiary}: ${i}; /* Default border tertiry color */
      
      /* Fonts */
      ${mf.primaryFont}: ${e.primaryFont};
      ${mf.secondaryFont}: ${e.secondaryFont};
  }
  `;
}, JU = (e, t) => {
  const n = t ?? document, r = qU(e), a = n.createElement("style");
  a.id = fb;
  const o = n.getElementById(fb);
  o && o.remove(), a.append(r), n.head.append(a);
  const i = XU(e.primaryFont, e.secondaryFont), s = n.createElement("style");
  s.id = gb;
  const l = n.getElementById(gb);
  l && l.remove(), s.append(i), n.head.append(s);
}, Ig = "https://d1asgbu35ychbr.cloudfront.net", Y9 = "https://d3syewzhvzylbl.cloudfront.net/fonts/google-fonts", yb = {
  [Rr.Inter]: [400, 500, 600, 700],
  [Rr.Roboto]: [400, 500, 700],
  [Rr.Lato]: [400, 700],
  [Rr.Montserrat]: [400, 500, 600, 700],
  [Rr.OpenSans]: [400, 600, 700],
  [Rr.Poppins]: [400, 500, 600, 700],
  [Rr.Arizonia]: [400],
  [Rr.Kanit]: [400, 500, 600, 700],
  [Rr.Merriweather]: [400, 700],
  [Rr.NotoSans]: [400, 700],
  [Rr.Nunito]: [400, 600, 700],
  [Rr.PlayfairDisplay]: [400, 500, 600, 700],
  [Rr.SourceSansPro]: [400, 600, 700],
  [Rr.Ubuntu]: [400, 500, 700],
  [Rr.Lora]: [400, 500, 600, 700]
}, XU = (e, t) => {
  const n = [];
  return yb[e].forEach((r) => {
    n.push(vb({ fontFamily: e, fontWeight: r }));
  }), yb[t].forEach((r) => {
    n.push(vb({ fontFamily: t, fontWeight: r }));
  }), n.join(`
`);
}, vb = ({
  fontFamily: e,
  fontWeight: t
}) => `@font-face {
  font-family: '${e}';
  font-style: normal;
  font-weight: ${t};
  font-display: swap;
  src: url('${Y9}/${e}/${QU(
  t
)}.woff2') format('woff2');
  }
  `, QU = (e) => e === 400 ? "regular" : e, tae = ({
  fontFamily: e
}) => `@font-face {
  font-family: '${e}';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('${Y9}/${e}/preview/preview.woff2') format('woff2');
  }
  `;
function Nm(e) {
  return parseInt(e, 16) || 0;
}
function Lm(e) {
  return Nm(e) / 255 <= 0.03928 ? Nm(e) / 255 / 12.92 : Math.pow((Nm(e) / 255 + 0.055) / 1.055, 2.4);
}
function bb(e) {
  return 0.2126 * Lm(e.substr(1, 2)) + 0.7152 * Lm(e.substr(3, 2)) + 0.0722 * Lm(e.substr(-2));
}
function lp(e, t) {
  const n = bb(e), r = bb(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
const _b = "#ffffff", gf = "#000000", wb = "#ffffff33", Sb = "#00000033";
function yd(e) {
  const t = lp(e, _b), n = lp(e, gf);
  return t > n ? _b : gf;
}
const e$ = (e) => {
  const t = lp(e, wb), n = lp(e, Sb);
  return t > n ? wb : Sb;
}, Z9 = (e) => yd(e) === gf, yh = (e) => {
  const { primaryColor: t, secondaryColor: n, tertiaryColor: r } = e, a = yd(t), o = yd(n), i = yd(r), s = e$(r);
  return {
    primaryColor: t,
    secondaryColor: n,
    tertiaryColor: r,
    textColorPrimary: a,
    textColorSecondary: o,
    textColorTertiary: i,
    borderColorTertiary: s
  };
}, q9 = Qe(null), rae = ({
  children: e,
  design: t,
  customRoot: n
}) => {
  const [r, a] = ke(t);
  return De(() => {
    a(t);
  }, [t]), De(() => {
    JU(r, n);
  }, [r, n]), /* @__PURE__ */ S.jsx(q9.Provider, { value: { state: r, setState: a }, children: e });
}, Sn = () => {
  const e = Ue(q9), t = (e == null ? void 0 : e.state.theme) === mt.default, n = (e == null ? void 0 : e.state.primaryColor) === ff[mt.default].primaryColor && (e == null ? void 0 : e.state.theme) === mt.default;
  if (!e)
    throw new Error("useDesignContext must be used within a DesignProvider");
  return { ...e, isDefaultTheme: t, isDefaultSioColor: n };
}, J9 = "w-full h-full flex items-center flex-col gap-5", jg = ({ children: e }) => /* @__PURE__ */ S.jsx("div", { className: J9, children: e }), t$ = "flex w-full min-h-screen py-5 [&>*]:h-fit [&>*]:m-auto", nae = ({ children: e }) => /* @__PURE__ */ S.jsx("div", { className: t$, children: e });
var We = /* @__PURE__ */ ((e) => (e.link_thumbnail = "link_thumbnail", e.optin_thumbnail = "optin_thumbnail", e.profile = "profile", e.product_download_thumbnail = "product_download_thumbnail", e.product_download_cover = "product_download_cover", e.e_course_thumbnail = "e_course_thumbnail", e.e_course_cover = "e_course_cover", e.physical_product_thumbnail = "physical_product_thumbnail", e.physical_product_cover = "physical_product_cover", e))(We || {}), Fa = /* @__PURE__ */ ((e) => (e.link = "link", e.optin = "optin", e.header = "header", e.product = "product", e))(Fa || {}), r$ = /* @__PURE__ */ ((e) => (e.button = "button", e.callout = "callout", e.preview = "preview", e))(r$ || {});
function n$({ primaryColor: e, secondaryColor: t, ...n }) {
  return /* @__PURE__ */ S.jsxs(
    "svg",
    {
      width: "128",
      height: "128",
      viewBox: "0 0 128 128",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ S.jsxs("g", { clipPath: "url(#clip0_34300_1538)", children: [
          /* @__PURE__ */ S.jsx("path", { d: "M128 64.0015C128 80.9749 121.257 97.2532 109.255 109.255C97.2532 121.257 80.975 128 64.0015 128C47.0281 128 30.7498 121.257 18.7478 109.255C6.74573 97.2532 0.00305176 80.9749 0.00305176 64.0015C0.00305176 28.6553 28.6569 0.00299072 64.0015 0.00299072C99.3461 0.00299072 128 28.6538 128 64.0015Z" }),
          /* @__PURE__ */ S.jsx(
            "path",
            {
              d: "M64 67.4342C78.44 67.4342 90.146 55.7282 90.146 41.2882C90.146 26.8482 78.44 15.1422 64 15.1422C49.56 15.1422 37.854 26.8482 37.854 41.2882C37.854 55.7282 49.56 67.4342 64 67.4342Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ S.jsx(
            "path",
            {
              d: "M108.05 102.978C107.539 103.557 107.014 104.128 106.478 104.685C100.988 110.417 94.3938 114.979 87.0937 118.096C79.7936 121.212 71.9382 122.819 64.0007 122.819C56.0632 122.819 48.2078 121.212 40.9077 118.096C33.6076 114.979 27.0139 110.417 21.5236 104.685C20.9878 104.128 20.4626 103.557 19.9497 102.978C19.9497 92.1073 23.7345 79.2693 34.0171 72.528C38.6639 69.4812 44.7223 69.7017 49.2083 72.9873C52.6517 75.5059 57.0948 77.0692 63.9999 77.0692C70.905 77.0692 75.3497 75.5059 78.7931 72.9873C83.2791 69.7078 89.3375 69.4873 93.9843 72.528C104.267 79.2693 108.05 92.1073 108.05 102.978Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ S.jsx("defs", { children: /* @__PURE__ */ S.jsx("clipPath", { id: "clip0_34300_1538", children: /* @__PURE__ */ S.jsx("rect", { width: "128", height: "128", fill: "white" }) }) })
      ]
    }
  );
}
function a$({ primaryColor: e, secondaryColor: t, ...n }) {
  return /* @__PURE__ */ S.jsx("svg", { width: "50", height: "50", viewBox: "0 0 50 50", xmlns: "http://www.w3.org/2000/svg", ...n, children: /* @__PURE__ */ S.jsx("path", { d: "M24.9486 49.5817C20.0334 49.5817 15.1168 49.5844 10.2016 49.5817C5.13151 49.5778 1.10694 46.3184 0.160213 41.4345C0.0493842 40.8593 0.0106611 40.2631 0.00932579 39.6761C-2.12604e-05 29.8939 -0.00402697 20.113 0.00532007 10.3308C0.0106612 4.78766 4.4238 0.434324 10.0521 0.426445C20.016 0.413312 29.9813 0.413312 39.9452 0.426445C45.5748 0.433011 49.9853 4.78372 49.992 10.3282C50.0027 20.1104 50.0027 29.8913 49.992 39.6735C49.9853 45.2376 45.5655 49.5673 39.8945 49.5778C34.9125 49.5883 29.9306 49.5804 24.9472 49.5804L24.9486 49.5817ZM15.6416 34.2052V18.8641C15.8659 18.8641 16.0609 18.8641 16.2558 18.8641C18.2054 18.8641 20.1535 18.8641 22.1031 18.8641C22.2366 18.8641 22.3701 18.8681 22.5023 18.8615C23.1499 18.8313 23.4063 18.5791 23.4183 17.9527C23.425 17.5601 23.4223 17.1661 23.4183 16.7735C23.4117 16.0459 23.1606 15.7885 22.4329 15.7872C19.9346 15.7833 17.4349 15.778 14.9366 15.7885C13.4838 15.7951 12.5023 16.7787 12.501 18.2154C12.497 23.769 12.497 29.3226 12.501 34.8749C12.501 36.3103 13.4904 37.2886 14.9459 37.29C20.6102 37.2952 26.2745 37.2952 31.9388 37.29C33.3022 37.29 34.3277 36.3812 34.3584 35.0535C34.4051 33.0075 34.3798 30.9589 34.3677 28.9103C34.3651 28.3758 34.0633 28.1013 33.5185 28.079C33.1032 28.0619 32.6853 28.0711 32.2687 28.0751C31.5049 28.0816 31.2512 28.3246 31.2485 29.0836C31.2431 30.607 31.2472 32.1303 31.2472 33.6536C31.2472 33.8296 31.2472 34.0056 31.2472 34.2039H15.6403L15.6416 34.2052ZM31.0188 16.3769C29.2829 18.0814 27.6098 19.7243 25.9367 21.3684C23.6987 23.5681 21.4595 25.7677 19.2242 27.9713C18.5872 28.599 18.5886 29.2202 19.2135 29.8545C19.4458 30.0896 19.6835 30.3194 19.9199 30.5505C20.7464 31.3608 21.2912 31.3608 22.1204 30.5452C25.8539 26.8735 29.5887 23.203 33.3182 19.5273C33.4544 19.3933 33.5305 19.199 33.668 18.9784C34.3584 19.6744 34.9018 20.2286 35.4507 20.7749C35.8259 21.1478 36.2692 21.2752 36.7726 21.0625C37.268 20.8523 37.4977 20.4636 37.4977 19.9344C37.4963 17.9527 37.5017 15.9711 37.495 13.9881C37.4923 13.1752 37.017 12.7169 36.1824 12.7143C34.1835 12.7077 32.1845 12.7143 30.1856 12.7103C29.6301 12.7103 29.2148 12.9178 28.9932 13.43C28.7702 13.9487 28.9278 14.3847 29.3257 14.7616C29.8771 15.2829 30.4246 15.8096 31.0175 16.3756L31.0188 16.3769Z" }) });
}
function o$({ primaryColor: e, secondaryColor: t, ...n }) {
  return /* @__PURE__ */ S.jsx("svg", { width: "50", height: "47", viewBox: "0 0 50 47", xmlns: "http://www.w3.org/2000/svg", ...n, children: /* @__PURE__ */ S.jsx("path", { d: "M49.9985 16.8733V40.7569C49.9694 40.8466 49.933 40.9335 49.9141 41.0262C49.266 44.2437 46.8221 46.2651 43.5451 46.2651C31.1756 46.2695 18.8076 46.2709 6.43808 46.2651C2.72272 46.2637 0.000647304 43.5429 0.000647304 39.8533C-0.00080913 32.5394 0.000647304 25.2255 0.000647304 17.9115C0.000647304 15.2747 1.15997 13.3329 3.4888 12.0717C10.2263 8.42125 16.9652 4.77371 23.691 1.10444C24.5969 0.610663 25.4139 0.60342 26.3126 1.10154C28.7681 2.46267 31.2455 3.78761 33.7142 5.12703C37.9815 7.44095 42.2445 9.76067 46.5162 12.0645C48.1256 12.9318 49.2354 14.1916 49.7568 15.9466C49.8485 16.2536 49.9199 16.5649 50 16.8748L49.9985 16.8733ZM45.8244 18.734C45.8244 18.443 45.8142 18.1519 45.8259 17.8609C45.8666 16.8632 45.4093 16.1797 44.5369 15.7091C38.1577 12.2585 31.7815 8.79919 25.4096 5.33409C25.1256 5.17915 24.9042 5.14006 24.6158 5.32395C24.2211 5.57736 23.7929 5.77863 23.3793 6.00307C17.3744 9.26111 11.371 12.5206 5.36469 15.7743C4.57676 16.2014 4.16896 16.8386 4.17478 17.7349C4.17915 18.414 4.19809 19.0946 4.16605 19.7722C4.14857 20.1371 4.28984 20.3066 4.60298 20.4702C10.8147 23.6848 17.0278 26.8921 23.2162 30.1502C24.4644 30.8076 25.5625 30.796 26.8034 30.1429C32.6757 27.0514 38.5641 23.9889 44.4757 20.9741C45.4792 20.4629 46.1871 19.9692 45.8244 18.734Z" }) });
}
function i$({
  primaryColor: e,
  secondaryColor: t,
  ...n
}) {
  return /* @__PURE__ */ S.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "50", height: "50", viewBox: "0 0 50 50", ...n, children: /* @__PURE__ */ S.jsx("path", { d: "M8.4003 0.636108C19.4679 0.636108 30.5342 0.636108 41.6018 0.636108C41.709 0.666399 41.8148 0.70986 41.9246 0.726981C45.5946 1.31436 48.1101 3.31224 49.4361 6.72194C49.7053 7.41467 49.8152 8.16799 50 8.89366V41.5393C49.9692 41.646 49.925 41.75 49.9076 41.858C49.1749 46.5439 45.3777 49.7863 40.5557 49.7929C30.1927 49.8061 19.8296 49.8113 9.46648 49.7745C8.41101 49.7705 7.30867 49.6072 6.31214 49.274C2.41978 47.9728 0.0128507 44.5684 0.00615361 40.4897C-0.00456175 33.9956 0.00347216 27.5001 0.00347216 21.006C0.00347216 17.3106 -0.00590117 13.6151 0.00615361 9.92091C0.0195478 5.81189 2.48943 2.41405 6.42063 1.10628C7.06087 0.892922 7.73996 0.790197 8.40164 0.636108H8.4003ZM23.5357 26.5572C23.4822 26.5954 23.4286 26.6322 23.375 26.6704C23.2625 26.5163 23.1687 26.3425 23.0348 26.2095C21.4623 24.6568 19.8898 23.104 18.3053 21.5631C17.7736 21.0456 17.1119 20.9586 16.5212 21.2866C15.9519 21.6026 15.6345 22.2532 15.8381 22.8828C15.9412 23.2002 16.1663 23.507 16.41 23.748C18.8384 26.1555 21.2815 28.5498 23.7206 30.9454C24.6327 31.841 25.3667 31.8436 26.2708 30.9559C28.1808 29.0792 30.0909 27.2025 32.0009 25.3245C32.6103 24.7252 33.2251 24.13 33.8238 23.5202C34.235 23.1014 34.3221 22.5891 34.1346 22.0504C33.9511 21.5236 33.5452 21.2115 32.9907 21.118C32.4281 21.0219 31.9861 21.2629 31.5964 21.6474C30.0359 23.1896 28.4702 24.7252 26.9044 26.2622C26.7852 26.3794 26.6553 26.4874 26.4651 26.6586V26.0462C26.4651 21.28 26.4651 16.5138 26.4651 11.7476C26.4651 11.5711 26.4731 11.3946 26.4557 11.2208C26.3713 10.3397 25.577 9.76419 24.693 9.93672C23.963 10.079 23.5371 10.6637 23.5357 11.5421C23.5344 16.3729 23.5357 21.2023 23.5357 26.033C23.5357 26.2082 23.5357 26.382 23.5357 26.5572ZM25.0533 37.666C20.4819 37.666 15.9104 37.666 11.339 37.666C11.1274 37.666 10.9144 37.6647 10.7054 37.6871C9.89375 37.774 9.33655 38.4799 9.44103 39.2741C9.5522 40.1209 10.1536 40.5436 11.2573 40.545C20.4162 40.545 29.5752 40.545 38.7355 40.545C38.9458 40.545 39.1601 40.5384 39.3663 40.5028C40.1834 40.3659 40.6857 39.6599 40.5491 38.8553C40.4178 38.0848 39.8378 37.6673 38.8654 37.6673C34.2618 37.6647 29.6569 37.6673 25.0533 37.6673V37.666Z" }) });
}
const s$ = ({
  primaryColor: e,
  secondaryColor: t,
  ...n
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "398",
    height: "240",
    viewBox: "0 0 398 240",
    ...n,
    children: [
      /* @__PURE__ */ S.jsx("rect", { x: "0.5", width: "397", height: "240", rx: "47" }),
      /* @__PURE__ */ S.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M121.997 98.5457V101.851C122.145 102.825 122.296 103.798 122.448 104.771C122.809 107.093 123.17 109.416 123.487 111.745C125.072 123.386 126.634 135.037 128.185 146.682C128.373 148.085 128.563 149.489 128.752 150.892C129.513 156.524 130.274 162.158 130.925 167.806C131.791 175.334 138.051 181.27 145.654 181.454C148.495 181.522 151.339 181.509 154.182 181.497C155.301 181.492 156.421 181.487 157.54 181.487C164.734 181.487 171.929 181.486 179.123 181.486C203.116 181.483 227.11 181.481 251.105 181.506C256.414 181.511 260.776 179.674 264.079 175.494C265.962 173.114 266.865 170.356 267.249 167.367C268.597 156.803 269.984 146.243 271.375 135.683C271.767 132.711 272.148 129.736 272.528 126.761C273.557 118.725 274.585 110.687 275.846 102.687C276.787 96.7134 273.348 89.4454 267.4 86.7016C265.129 85.658 262.763 85.1243 260.275 85.1243C249.142 85.1243 238.01 85.1233 226.878 85.1222C197.193 85.1194 167.51 85.1166 137.824 85.1338C129.879 85.1385 124.041 89.9318 122.266 97.7098C122.225 97.8987 122.159 98.0834 122.093 98.2681C122.06 98.3605 122.027 98.4528 121.997 98.5457ZM159.9 135.161C159.86 135.354 159.819 135.547 159.777 135.739H159.775V138.826C159.788 138.854 159.803 138.881 159.819 138.908C159.854 138.97 159.889 139.032 159.897 139.098C160.694 146.032 166.865 151.814 174.696 151.676C179.548 151.591 184.402 151.608 189.257 151.626C191.748 151.635 194.239 151.643 196.73 151.639C197.242 151.639 197.566 151.785 197.889 152.195C200.401 155.391 202.931 158.575 205.48 161.742C205.929 162.298 206.429 162.841 206.999 163.265C209.967 165.48 213.843 164.863 216.305 161.795C216.473 161.586 216.641 161.377 216.809 161.168C218.993 158.447 221.177 155.725 223.306 152.962C223.992 152.076 224.661 151.391 225.882 151.599C226.012 151.622 226.15 151.59 226.289 151.558C226.357 151.542 226.425 151.526 226.492 151.517C233.278 150.589 238.453 145.071 238.924 138.261C239.388 131.535 235.069 125.364 228.533 123.51C227.666 123.264 226.768 123.125 225.861 122.984C225.437 122.918 225.012 122.852 224.587 122.774C224.356 117.688 222.215 113.55 217.813 110.785C213.386 108.003 208.705 107.888 203.946 109.925C199.169 102.446 190.654 99.8649 183.812 102.071C173.554 105.378 169.703 112.863 170.829 123.302C170.787 123.314 170.741 123.326 170.691 123.339C170.607 123.36 170.515 123.384 170.424 123.412C165.063 125.042 161.626 128.539 160.175 133.954C160.068 134.352 159.984 134.756 159.9 135.161ZM205.024 140.871H205.974L205.978 140.874V139.834V123.329C205.978 121.636 206.497 121.119 208.193 121.119C208.503 121.118 208.812 121.118 209.122 121.118C210.667 121.116 212.211 121.114 213.756 121.119C215.264 121.123 215.871 121.721 215.871 123.22C215.873 126.923 215.872 130.625 215.872 134.327C215.872 136.178 215.871 138.029 215.871 139.88V140.874H216.778C217.672 140.874 218.567 140.874 219.461 140.874C220.653 140.874 221.845 140.873 223.038 140.876C223.761 140.876 224.349 141.14 224.682 141.814C225.017 142.492 224.858 143.109 224.403 143.678C223.178 145.217 221.954 146.757 220.729 148.297C217.936 151.811 215.143 155.324 212.341 158.83C211.451 159.944 210.337 159.917 209.439 158.789C207.581 156.458 205.725 154.125 203.869 151.791C201.754 149.133 199.639 146.474 197.521 143.818C197.035 143.21 196.781 142.577 197.133 141.83C197.486 141.082 198.141 140.867 198.919 140.869C200.344 140.875 201.768 140.874 203.193 140.873C203.803 140.872 204.414 140.871 205.024 140.871Z",
          fill: t
        }
      ),
      /* @__PURE__ */ S.jsx(
        "path",
        {
          d: "M260.79 79.7267H137.383C137.289 79.5331 137.171 79.4056 137.175 79.2734C137.213 75.4245 137.104 71.5662 137.346 67.7268C137.686 62.3857 142.247 57.9276 147.589 57.7435C152.997 57.5593 158.415 57.6537 163.828 57.649C171.748 57.6396 179.669 57.6726 187.589 57.6254C188.971 57.6159 189.931 58.0551 190.807 59.1272C193.461 62.3857 196.229 65.5545 198.898 68.8083C199.593 69.6583 200.303 70.0078 201.429 70.0078C217.223 69.9653 233.012 69.9747 248.805 69.9842C254.299 69.9842 258.235 72.5485 260.099 77.2994C260.383 78.0266 260.53 78.8058 260.785 79.7267H260.79Z",
          fill: t
        }
      )
    ]
  }
);
function l$({ primaryColor: e, secondaryColor: t, ...n }) {
  return /* @__PURE__ */ S.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "59",
      height: "61",
      viewBox: "0 0 59 61",
      style: { maxHeight: 61 },
      ...n,
      children: [
        /* @__PURE__ */ S.jsx("path", { d: "M53.6899 23.3603C53.4756 22.7929 53.0763 22.4258 52.5326 22.1498C44.384 18.0012 36.2381 13.8498 28.1034 9.67457C27.3216 9.27386 26.6589 9.28647 25.8855 9.68297C17.8433 13.8078 9.78845 17.9115 1.73363 22.0125C1.00507 22.3838 0.325541 22.7747 0.32414 23.7148C0.322739 24.6535 0.99386 25.05 1.72382 25.4227C9.79405 29.5307 17.8629 33.6443 25.9219 37.7761C26.6575 38.1529 27.3006 38.1782 28.0473 37.7957C36.1834 33.6232 44.3293 29.469 52.478 25.3232C53.0342 25.0402 53.4616 24.6787 53.6899 24.0959V23.3603Z" }),
        /* @__PURE__ */ S.jsx("path", { d: "M1.53892 28.9366C1.53892 29.6666 1.53892 30.2761 1.53892 30.8855C1.53892 33.3654 1.54452 35.8454 1.53051 38.3239C1.52911 38.6279 1.46186 38.9474 1.35537 39.2346C0.971479 40.2812 0.52173 41.3054 0.163053 42.3618C-0.395978 44.0095 0.528738 45.7818 2.1666 46.3002C3.84089 46.8298 5.64268 45.9093 6.08683 44.207C6.23394 43.6466 6.14287 43.0091 6.08262 42.4136C6.049 42.0774 5.88647 41.7425 5.72955 41.4343C4.84967 39.7109 4.58487 37.8937 4.68995 35.9687C4.78102 34.3154 4.69976 32.6523 4.71657 30.9934C4.71937 30.674 4.63671 30.496 4.33688 30.3517C3.43038 29.9174 2.54069 29.4466 1.53751 28.9352L1.53892 28.9366Z" }),
        /* @__PURE__ */ S.jsx("path", { d: "M39.2665 35.6672C40.9767 33.9985 43.3452 32.9774 45.9084 32.9746C51.028 32.9676 55.2648 37.1624 55.2732 42.2259C55.2802 47.3889 51.0672 51.6314 45.9364 51.6202C42.6898 51.6128 40.0607 50.1878 38.4238 47.9398C35.3523 49.4673 32.049 50.159 28.6344 50.3508C24.277 50.596 20.0584 49.9613 16.0667 48.1665C14.95 47.6649 13.923 46.9363 12.9184 46.2218C12.1451 45.6712 11.8102 44.8739 11.8284 43.861C11.8656 41.7052 11.8588 39.5488 11.852 37.3921C11.8493 36.5436 11.8466 35.695 11.8466 34.8464V34.2089C11.9332 34.252 12.0127 34.2914 12.0873 34.3284C12.2675 34.4178 12.4185 34.4927 12.5682 34.569C13.8658 35.2312 15.1638 35.8927 16.4619 36.5544C19.1738 37.9366 21.886 39.319 24.5951 40.7071C26.2063 41.5324 27.7937 41.5366 29.4078 40.7043C31.7914 39.4761 34.1806 38.259 36.5699 37.0417C37.4688 36.5838 38.3678 36.1258 39.2665 35.6672ZM45.9645 45.4624C46.8836 44.86 47.7816 44.2197 48.6629 43.5626C49.5484 42.9013 49.5428 41.7902 48.6517 41.1261C47.9273 40.5866 47.1833 40.0705 46.4402 39.555C46.2937 39.4534 46.1472 39.3518 46.0009 39.25C45.5091 38.9068 44.9837 38.8493 44.4443 39.1394C43.9105 39.428 43.6555 39.8875 43.6527 40.4886C43.6508 40.8912 43.6514 41.2937 43.6521 41.6963C43.6524 41.8976 43.6527 42.0989 43.6527 42.3002C43.6527 42.5004 43.6513 42.7005 43.6499 42.9005C43.6469 43.3402 43.6439 43.7796 43.6555 44.2197C43.6877 45.4708 44.9206 46.1462 45.9645 45.4624Z" })
      ]
    }
  );
}
const c$ = ({
  primaryColor: e,
  secondaryColor: t,
  ...n
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "398",
    height: "240",
    viewBox: "0 0 398 240",
    ...n,
    children: [
      /* @__PURE__ */ S.jsx("rect", { x: "0.5", width: "397", height: "240", rx: "47", fill: e }),
      /* @__PURE__ */ S.jsxs("g", { children: [
        /* @__PURE__ */ S.jsx("path", { d: "M 108 120 L 203 157 L 292 120 L 203 84 L 108 120 Z", fill: t }),
        /* @__PURE__ */ S.jsx("ellipse", { cx: "35", cy: "40", rx: "7.327", ry: "7.352", fill: t }),
        /* @__PURE__ */ S.jsx("ellipse", { fill: t, cx: "65", cy: "40", rx: "7.706", ry: "7.706" }),
        /* @__PURE__ */ S.jsx("ellipse", { fill: t, cx: "95", cy: "40", rx: "7.449", ry: "7.449" }),
        /* @__PURE__ */ S.jsx("path", { fill: t, d: "M 126 155 L 126 130 L 119 127 L 119 153 L 126 155 Z" }),
        /* @__PURE__ */ S.jsx("rect", { fill: t, x: "0", y: "63", width: "398", height: "7" }),
        /* @__PURE__ */ S.jsx("path", { fill: t, d: "M 105 0 L 142 65 L 152 65 L 114 0 L 105 0 Z" }),
        /* @__PURE__ */ S.jsx(
          "path",
          {
            fill: t,
            d: "M 262 140 L 203 163 L 143 140 L 143 172 C 162 203 264 191 263 169 L 262 140 Z"
          }
        ),
        /* @__PURE__ */ S.jsx("ellipse", { fill: t, cx: "122", cy: "159", rx: "6.87", ry: "6.87" })
      ] })
    ]
  }
);
function u$({
  primaryColor: e,
  secondaryColor: t,
  ...n
}) {
  return /* @__PURE__ */ S.jsxs(
    "svg",
    {
      width: "60",
      height: "60",
      viewBox: "0 0 60 60",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ S.jsxs("g", { clipPath: "url(#clip0_111300_11839)", children: [
          /* @__PURE__ */ S.jsx("path", { d: "M26.4843 56.3672C29.3967 56.3672 31.7577 54.0062 31.7577 51.0938C31.7577 48.1813 29.3967 45.8203 26.4843 45.8203C23.5718 45.8203 21.2108 48.1813 21.2108 51.0938C21.2108 54.0062 23.5718 56.3672 26.4843 56.3672Z" }),
          /* @__PURE__ */ S.jsx("path", { d: "M44.1794 56.3672C47.0919 56.3672 49.4529 54.0062 49.4529 51.0938C49.4529 48.1813 47.0919 45.8203 44.1794 45.8203C41.267 45.8203 38.906 48.1813 38.906 51.0938C38.906 54.0062 41.267 56.3672 44.1794 56.3672Z" }),
          /* @__PURE__ */ S.jsx("path", { d: "M1.7578 7.14853H9.08819L17.5746 36.8569L16.909 38.1882C15.1564 41.6897 17.7006 45.8202 21.6262 45.8202H51.2106C52.1822 45.8202 52.9684 45.034 52.9684 44.0624C52.9684 43.0908 52.1822 42.3046 51.2106 42.3046H21.6262C20.3209 42.3046 19.4678 40.9301 20.0538 39.7606L20.5397 38.789H51.2106C51.9951 38.789 52.6852 38.2689 52.9015 37.5135L59.9327 12.9043C60.0838 12.3739 59.9774 11.8039 59.6461 11.3628C59.3131 10.9234 58.793 10.6641 58.242 10.6641H13.7487L12.1042 4.90827C11.8879 4.153 11.1979 3.63281 10.4133 3.63281H1.7578C0.786206 3.63281 0 4.41902 0 5.39061C0 6.36221 0.786206 7.14853 1.7578 7.14853Z" })
        ] }),
        /* @__PURE__ */ S.jsx("defs", { children: /* @__PURE__ */ S.jsx("clipPath", { id: "clip0_111300_11839", children: /* @__PURE__ */ S.jsx("rect", { width: "60", height: "60", fill: "white" }) }) })
      ]
    }
  );
}
const d$ = ({
  primaryColor: e,
  secondaryColor: t,
  ...n
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    width: "397",
    height: "215",
    viewBox: "0 0 397 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ S.jsx("rect", { width: "397", height: "215", rx: "47", fill: e }),
      /* @__PURE__ */ S.jsxs("g", { clipPath: "url(#clip0_125303_20216)", children: [
        /* @__PURE__ */ S.jsx(
          "path",
          {
            d: "M165.077 64.627L143.429 76.1167C143.058 76.311 142.708 76.5323 142.377 76.7744L197.734 105.641L220.915 94.1751L165.077 64.627Z",
            fill: "url(#paint0_linear_125303_20216)"
          }
        ),
        /* @__PURE__ */ S.jsx(
          "path",
          {
            d: "M258.989 83.1848L231.295 96.8826V112.315C231.295 114.255 229.721 115.829 227.78 115.829C225.839 115.829 224.266 114.255 224.266 112.315V100.359L201.207 111.765V167.615C201.279 167.582 201.352 167.551 201.423 167.515L254.435 140.654C257.251 139.246 259 136.417 259 133.267V83.4953C259 83.391 258.993 83.2881 258.989 83.1848Z",
            fill: "url(#paint1_linear_125303_20216)"
          }
        ),
        /* @__PURE__ */ S.jsx(
          "path",
          {
            d: "M254.435 76.1078L201.445 49.2585L201.423 49.2475C199.064 48.0728 196.26 48.0991 193.923 49.3178L172.58 60.6449L228.682 90.333L255.762 76.9392C255.351 76.626 254.91 76.345 254.435 76.1078Z",
            fill: "url(#paint2_linear_125303_20216)"
          }
        ),
        /* @__PURE__ */ S.jsx(
          "path",
          {
            d: "M139.017 82.9492C139.007 83.1102 139 83.2715 139 83.4342V133.328C139 136.413 140.697 139.215 143.429 140.646L193.9 167.433L193.923 167.445C194.007 167.489 194.093 167.527 194.178 167.568V111.713L139.017 82.9492Z",
            fill: "url(#paint3_linear_125303_20216)"
          }
        )
      ] }),
      /* @__PURE__ */ S.jsxs("defs", { children: [
        /* @__PURE__ */ S.jsxs(
          "linearGradient",
          {
            id: "paint0_linear_125303_20216",
            x1: "259",
            y1: "48",
            x2: "139",
            y2: "168",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ S.jsx("stop", { stopColor: t }),
              /* @__PURE__ */ S.jsx("stop", { offset: "1", stopColor: t, stopOpacity: "0.16" })
            ]
          }
        ),
        /* @__PURE__ */ S.jsxs(
          "linearGradient",
          {
            id: "paint1_linear_125303_20216",
            x1: "259",
            y1: "48",
            x2: "139",
            y2: "168",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ S.jsx("stop", { stopColor: t }),
              /* @__PURE__ */ S.jsx("stop", { offset: "1", stopColor: t, stopOpacity: "0.16" })
            ]
          }
        ),
        /* @__PURE__ */ S.jsxs(
          "linearGradient",
          {
            id: "paint2_linear_125303_20216",
            x1: "259",
            y1: "48",
            x2: "139",
            y2: "168",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ S.jsx("stop", { stopColor: t }),
              /* @__PURE__ */ S.jsx("stop", { offset: "1", stopColor: t, stopOpacity: "0.16" })
            ]
          }
        ),
        /* @__PURE__ */ S.jsxs(
          "linearGradient",
          {
            id: "paint3_linear_125303_20216",
            x1: "259",
            y1: "48",
            x2: "139",
            y2: "168",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ S.jsx("stop", { stopColor: t }),
              /* @__PURE__ */ S.jsx("stop", { offset: "1", stopColor: t, stopOpacity: "0.16" })
            ]
          }
        ),
        /* @__PURE__ */ S.jsx("clipPath", { id: "clip0_125303_20216", children: /* @__PURE__ */ S.jsx("rect", { width: "120", height: "120", fill: t, transform: "translate(139 48)" }) })
      ] })
    ]
  }
), p$ = (e, t) => {
  switch (e) {
    case We.profile:
      return /* @__PURE__ */ S.jsx(n$, { ...t });
    case We.link_thumbnail:
      return /* @__PURE__ */ S.jsx(a$, { ...t });
    case We.optin_thumbnail:
      return /* @__PURE__ */ S.jsx(o$, { ...t });
    case We.product_download_thumbnail:
      return /* @__PURE__ */ S.jsx(i$, { ...t });
    case We.product_download_cover:
      return /* @__PURE__ */ S.jsx(s$, { ...t });
    case We.e_course_thumbnail:
      return /* @__PURE__ */ S.jsx(l$, { ...t });
    case We.e_course_cover:
      return /* @__PURE__ */ S.jsx(c$, { ...t });
    case We.physical_product_thumbnail:
      return /* @__PURE__ */ S.jsx(u$, { ...t });
    case We.physical_product_cover:
      return /* @__PURE__ */ S.jsx(d$, { ...t });
  }
}, X9 = ({ children: e }) => /* @__PURE__ */ S.jsx("div", { className: "w-full max-w-xl", children: e }), Bg = "-", h$ = (e) => {
  const t = f$(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (i) => {
      const s = i.split(Bg);
      return s[0] === "" && s.length !== 1 && s.shift(), Q9(s, t) || m$(i);
    },
    getConflictingClassGroupIds: (i, s) => {
      const l = n[i] || [];
      return s && r[i] ? [...l, ...r[i]] : l;
    }
  };
}, Q9 = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), a = r ? Q9(e.slice(1), r) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const o = e.join(Bg);
  return (i = t.validators.find(({
    validator: s
  }) => s(o))) == null ? void 0 : i.classGroupId;
}, Cb = /^\[(.+)\]$/, m$ = (e) => {
  if (Cb.test(e)) {
    const t = Cb.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, f$ = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return y$(Object.entries(e.classGroups), n).forEach(([o, i]) => {
    yf(i, r, o, t);
  }), r;
}, yf = (e, t, n, r) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const o = a === "" ? t : xb(t, a);
      o.classGroupId = n;
      return;
    }
    if (typeof a == "function") {
      if (g$(a)) {
        yf(a(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: n
      });
      return;
    }
    Object.entries(a).forEach(([o, i]) => {
      yf(i, xb(t, o), n, r);
    });
  });
}, xb = (e, t) => {
  let n = e;
  return t.split(Bg).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, g$ = (e) => e.isThemeGetter, y$ = (e, t) => t ? e.map(([n, r]) => {
  const a = r.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([i, s]) => [t + i, s])) : o);
  return [n, a];
}) : e, v$ = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const a = (o, i) => {
    n.set(o, i), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let i = n.get(o);
      if (i !== void 0)
        return i;
      if ((i = r.get(o)) !== void 0)
        return a(o, i), i;
    },
    set(o, i) {
      n.has(o) ? n.set(o, i) : a(o, i);
    }
  };
}, e7 = "!", b$ = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, a = t[0], o = t.length, i = (s) => {
    const l = [];
    let c = 0, u = 0, d;
    for (let g = 0; g < s.length; g++) {
      let _ = s[g];
      if (c === 0) {
        if (_ === a && (r || s.slice(g, g + o) === t)) {
          l.push(s.slice(u, g)), u = g + o;
          continue;
        }
        if (_ === "/") {
          d = g;
          continue;
        }
      }
      _ === "[" ? c++ : _ === "]" && c--;
    }
    const p = l.length === 0 ? s : s.substring(u), h = p.startsWith(e7), m = h ? p.substring(1) : p, f = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: f
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: i
  }) : i;
}, _$ = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, w$ = (e) => ({
  cache: v$(e.cacheSize),
  parseClassName: b$(e),
  ...h$(e)
}), S$ = /\s+/, C$ = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: a
  } = t, o = [], i = e.trim().split(S$);
  let s = "";
  for (let l = i.length - 1; l >= 0; l -= 1) {
    const c = i[l], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: p,
      maybePostfixModifierPosition: h
    } = n(c);
    let m = !!h, f = r(m ? p.substring(0, h) : p);
    if (!f) {
      if (!m) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (f = r(p), !f) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      m = !1;
    }
    const g = _$(u).join(":"), _ = d ? g + e7 : g, v = _ + f;
    if (o.includes(v))
      continue;
    o.push(v);
    const w = a(f, m);
    for (let x = 0; x < w.length; ++x) {
      const b = w[x];
      o.push(_ + b);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function kr() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = t7(t)) && (r && (r += " "), r += n);
  return r;
}
const t7 = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = t7(e[r])) && (n && (n += " "), n += t);
  return n;
};
function x$(e, ...t) {
  let n, r, a, o = i;
  function i(l) {
    const c = t.reduce((u, d) => d(u), e());
    return n = w$(c), r = n.cache.get, a = n.cache.set, o = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const u = C$(l, n);
    return a(l, u), u;
  }
  return function() {
    return o(kr.apply(null, arguments));
  };
}
const er = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, r7 = /^\[(?:([a-z-]+):)?(.+)\]$/i, k$ = /^\d+\/\d+$/, E$ = /* @__PURE__ */ new Set(["px", "full", "screen"]), P$ = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, T$ = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, M$ = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, O$ = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, A$ = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ao = (e) => As(e) || E$.has(e) || k$.test(e), ko = (e) => dl(e, "length", F$), As = (e) => !!e && !Number.isNaN(Number(e)), Rm = (e) => dl(e, "number", As), jl = (e) => !!e && Number.isInteger(Number(e)), N$ = (e) => e.endsWith("%") && As(e.slice(0, -1)), ot = (e) => r7.test(e), Eo = (e) => P$.test(e), L$ = /* @__PURE__ */ new Set(["length", "size", "percentage"]), R$ = (e) => dl(e, L$, n7), D$ = (e) => dl(e, "position", n7), I$ = /* @__PURE__ */ new Set(["image", "url"]), j$ = (e) => dl(e, I$, G$), B$ = (e) => dl(e, "", z$), Bl = () => !0, dl = (e, t, n) => {
  const r = r7.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, F$ = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  T$.test(e) && !M$.test(e)
), n7 = () => !1, z$ = (e) => O$.test(e), G$ = (e) => A$.test(e), H$ = () => {
  const e = er("colors"), t = er("spacing"), n = er("blur"), r = er("brightness"), a = er("borderColor"), o = er("borderRadius"), i = er("borderSpacing"), s = er("borderWidth"), l = er("contrast"), c = er("grayscale"), u = er("hueRotate"), d = er("invert"), p = er("gap"), h = er("gradientColorStops"), m = er("gradientColorStopPositions"), f = er("inset"), g = er("margin"), _ = er("opacity"), v = er("padding"), w = er("saturate"), x = er("scale"), b = er("sepia"), C = er("skew"), E = er("space"), A = er("translate"), O = () => ["auto", "contain", "none"], M = () => ["auto", "hidden", "clip", "visible", "scroll"], I = () => ["auto", ot, t], D = () => [ot, t], K = () => ["", ao, ko], G = () => ["auto", As, ot], V = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], ee = () => ["solid", "dashed", "dotted", "double", "none"], U = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], H = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], W = () => ["", "0", ot], L = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], T = () => [As, ot];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Bl],
      spacing: [ao, ko],
      blur: ["none", "", Eo, ot],
      brightness: T(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Eo, ot],
      borderSpacing: D(),
      borderWidth: K(),
      contrast: T(),
      grayscale: W(),
      hueRotate: T(),
      invert: W(),
      gap: D(),
      gradientColorStops: [e],
      gradientColorStopPositions: [N$, ko],
      inset: I(),
      margin: I(),
      opacity: T(),
      padding: D(),
      saturate: T(),
      scale: T(),
      sepia: W(),
      skew: T(),
      space: D(),
      translate: D()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ot]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Eo]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": L()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": L()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...V(), ot]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: M()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": M()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": M()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: O()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": O()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": O()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [f]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [f]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [f]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [f]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [f]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [f]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [f]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [f]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [f]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", jl, ot]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: I()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ot]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: W()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: W()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", jl, ot]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Bl]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", jl, ot]
        }, ot]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": G()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": G()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Bl]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [jl, ot]
        }, ot]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": G()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": G()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ot]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ot]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...H()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...H(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...H(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [g]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [g]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [g]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [g]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [g]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [g]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [g]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [g]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [g]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [E]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [E]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", ot, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [ot, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [ot, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Eo]
        }, Eo]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ot, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [ot, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ot, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [ot, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Eo, ko]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Rm]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Bl]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ot]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", As, Rm]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", ao, ot]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ot]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ot]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [_]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [_]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...ee(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", ao, ko]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", ao, ot]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: D()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ot]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ot]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [_]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...V(), D$]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", R$]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, j$]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [_]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...ee(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [_]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: ee()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...ee()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ao, ot]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [ao, ko]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: K()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [_]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [ao, ko]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Eo, B$]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Bl]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [_]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...U(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": U()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Eo, ot]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [b]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [_]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [b]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ot]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: T()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ot]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: T()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ot]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [jl, ot]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [A]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [A]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [C]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [C]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ot]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ot]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": D()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": D()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": D()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": D()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": D()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": D()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": D()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": D()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": D()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": D()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": D()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": D()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": D()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": D()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": D()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": D()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": D()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": D()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ot]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ao, ko, Rm]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, At = /* @__PURE__ */ x$(H$), vh = ({ children: e }) => {
  const {
    state: { tertiaryColor: t }
  } = Sn();
  return /* @__PURE__ */ S.jsx(X9, { children: /* @__PURE__ */ S.jsx(
    "div",
    {
      className: kr(
        "bg-THEME-secondary mx-5 rounded-lg border p-5 sm:mx-0",
        Z9(t) ? "shadow-around-sm border-transparent" : "border-THEME-border-tertiary"
      ),
      children: e
    }
  ) });
}, Fg = ({ title: e, subTitle: t, thumbnail: n, imageType: r }) => {
  const { isDefaultTheme: a } = Sn();
  return /* @__PURE__ */ S.jsxs("div", { className: "flex gap-3", children: [
    /* @__PURE__ */ S.jsx(
      Cn,
      {
        className: "h-full shrink-0 rounded-xl",
        thumbnail: n,
        imageType: r,
        alt: e
      }
    ),
    /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ S.jsx("h3", { className: kr(a ? "text-text-primary" : "text-THEME-primary"), children: e }),
      /* @__PURE__ */ S.jsx("span", { className: "whitespace-pre-wrap font-medium", children: t })
    ] })
  ] });
}, Jn = (e) => {
  const { isDefaultSioColor: t } = Sn(), n = F4(e) ? e["aria-disabled"] : e.disabled;
  return /* @__PURE__ */ S.jsx(
    z4,
    {
      color: t ? "text-background-secondary" : "text-THEME-text-primary",
      hoverColor: t ? "hover:text-background-secondary" : "hover:text-THEME-text-primary",
      backgroundColor: t ? "bg-brand-primary" : "bg-THEME-primary",
      hoverBackgroundColor: t ? "hover:bg-brand-primary" : "hover:bg-THEME-primary",
      ...e,
      className: At(
        e.className,
        !t && "ring-THEME-primary",
        n && "bg-text-secondary/50"
      ),
      loaderClassName: t ? "text-background-secondary fill-brand-primary" : "text-THEME-text-primary fill-THEME-primary"
    }
  );
}, cn = ({ currency: e }) => /* @__PURE__ */ S.jsxs("div", { className: "text-xxs relative rounded-md px-2 py-1 font-bold uppercase", children: [
  /* @__PURE__ */ S.jsx("div", { className: "bg-THEME-primary absolute left-0 top-0 h-full w-full rounded-md opacity-30" }),
  e
] }), zg = ({ className: e, ...t }) => /* @__PURE__ */ S.jsx(
  "svg",
  {
    width: 20,
    height: 20,
    className: At("main-transition-colors fill-green absolute", e),
    ...t,
    children: /* @__PURE__ */ S.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
      }
    )
  }
), vf = ({
  options: e,
  selected: t,
  onChange: n,
  disabled: r,
  error: a,
  label: o,
  required: i,
  className: s,
  labelClassName: l,
  optionsWrapperClassName: c,
  optionWrapperClassName: u,
  selectedOptionWrapperClassName: d,
  optionClassName: p,
  selectedOptionClassName: h
}) => /* @__PURE__ */ S.jsxs("div", { className: At("flex flex-col gap-1", s), children: [
  /* @__PURE__ */ S.jsx(_o, { label: o, labelClassName: l, required: i }),
  /* @__PURE__ */ S.jsx("ul", { className: At("flex flex-col gap-5", c), children: e ? e.map((m) => /* @__PURE__ */ S.jsxs(
    "li",
    {
      className: At(
        u,
        m.id === t && d,
        "border-text-secondary/30 rounded-lg border"
      ),
      children: [
        /* @__PURE__ */ S.jsxs(
          "label",
          {
            className: At(
              "relative flex items-center gap-2",
              !r && "cursor-pointer",
              "p-4"
            ),
            children: [
              /* @__PURE__ */ S.jsx(
                "input",
                {
                  className: At(
                    "border-2 outline-hidden",
                    r ? "border-fill-primary/70" : "border-fill-primary",
                    "h-[20px] w-[20px] rounded-full",
                    m.id === t ? "bg-background-secondary" : "bg-transparent",
                    "main-transition-colors ring-brand-primary shrink-0 appearance-none ring-offset-1 focus-visible:ring-2"
                  ),
                  disabled: r,
                  checked: m.id === t,
                  value: m.caption,
                  onChange: () => n(m.id),
                  type: "radio"
                }
              ),
              /* @__PURE__ */ S.jsx(
                zg,
                {
                  className: kr(
                    m.id !== t && "fill-transparent",
                    r && "opacity-70"
                  )
                }
              ),
              /* @__PURE__ */ S.jsxs("div", { className: "flex w-full flex-wrap items-center justify-between gap-3", children: [
                /* @__PURE__ */ S.jsx(
                  "span",
                  {
                    className: At(
                      "main-transition-colors",
                      m.id === t ? "text-text-primary" : "text-text-primary/50",
                      r && "opacity-70",
                      p,
                      m.id === t ? h : void 0,
                      "text-left"
                    ),
                    children: m.caption
                  }
                ),
                m.additionalInfo
              ] })
            ]
          }
        ),
        m.content && m.id === t && /* @__PURE__ */ S.jsx("div", { className: "px-4 pb-4", children: m.content })
      ]
    },
    m.id
  )) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    /* @__PURE__ */ S.jsx(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "first-skeleton"
    ),
    /* @__PURE__ */ S.jsx(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "second-skeleton"
    )
  ] }) }),
  /* @__PURE__ */ S.jsx(sl, { error: a })
] }), K$ = ({
  thumbnail: e,
  url: t,
  buttonTitle: n,
  subTitle: r,
  title: a
}) => /* @__PURE__ */ S.jsx(vh, { children: /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col gap-3", children: [
  /* @__PURE__ */ S.jsx(
    Fg,
    {
      title: a,
      subTitle: r,
      imageType: We.link_thumbnail,
      thumbnail: e
    }
  ),
  /* @__PURE__ */ S.jsx(Jn, { href: t, children: n })
] }) }), Gg = ({
  value: e,
  error: t,
  field: n,
  onChange: r,
  contactFields: a
}) => {
  var l;
  const { locale: o } = qn(), { visitorInfo: i } = X8(), s = (l = a[Kt.Country]) != null && l.value ? a[Kt.Country].value : (i == null ? void 0 : i.country) ?? void 0;
  switch (n.slug) {
    case Kt.Country:
      return /* @__PURE__ */ S.jsx(
        WR,
        {
          label: O1(n.slug),
          className: "focus:!border-THEME-primary",
          required: n.required,
          data: zL(o),
          value: e,
          withoutCloseIcon: !0,
          onChange: (c) => r(c),
          error: t == null ? void 0 : t.join(", ")
        }
      );
    case Kt.PhoneNumber:
      return /* @__PURE__ */ S.jsx(
        YF,
        {
          label: O1(n.slug),
          inputClassName: "focus:!border-THEME-primary",
          required: n.required,
          value: e,
          onChange: r,
          initialCountry: s,
          error: t == null ? void 0 : t.join(", ")
        }
      );
    default:
      return /* @__PURE__ */ S.jsx(
        Cs,
        {
          label: HL(n),
          inputClassName: "focus:!border-THEME-primary",
          required: n.required,
          value: e,
          onChange: ({ target: { value: c } }) => r(c),
          error: t == null ? void 0 : t.join(", ")
        },
        n.slug
      );
  }
}, cp = (e) => e.reduce(
  (t, n) => ({ ...t, [n.slug]: { ...n, value: void 0 } }),
  {}
), U$ = async (e) => xh.post("/api/public/digital-store/opt-in", e), $$ = ({
  id: e,
  title: t,
  subTitle: n,
  thumbnail: r,
  fields: a,
  buttonTitle: o,
  thankYouPage: i
}) => {
  const [s, l] = ke(!1), [c, u] = ke({}), [d, p] = ke(
    cp(a)
  ), { visitorInfo: h } = X8();
  Hr(a, (f) => p(cp(f))), Hr(h, (f) => {
    if (!f)
      return;
    const g = Object.prototype.hasOwnProperty.call(d, Kt.Country) && !d[Kt.Country].value;
    f.country && g && p({
      ...d,
      [Kt.Country]: {
        ...d[Kt.Country],
        value: f.country
      }
    });
  });
  const m = async () => {
    var g;
    if (!e)
      return;
    const f = Object.values(d).map((_) => ({
      slug: _.slug,
      value: _.value ?? ""
    }));
    try {
      u({}), l(!0);
      const _ = Intl.DateTimeFormat().resolvedOptions().timeZone;
      await U$({
        itemOptIn: `/api/dashboard/digital-store/item-opt-ins/${e}`,
        values: f,
        timezone: _
      }), i.path && window.location.assign(i.path);
    } catch (_) {
      _ instanceof r9 && ((g = _.errors.violations) == null || g.forEach((v) => {
        var b;
        const w = /values\[(\d+)]/, x = v.propertyPath.match(w);
        if (x) {
          const C = parseInt(x[1]), E = (b = f.find((A, O) => O === C)) == null ? void 0 : b.slug;
          E && u((A) => ({ ...A, [E]: v.message }));
        }
      }));
    } finally {
      l(!1);
    }
  };
  return /* @__PURE__ */ S.jsx(vh, { children: /* @__PURE__ */ S.jsxs(
    "form",
    {
      onSubmit: (f) => {
        f.preventDefault(), m();
      },
      className: "flex flex-col gap-3",
      children: [
        /* @__PURE__ */ S.jsx(
          Fg,
          {
            title: t,
            subTitle: n,
            imageType: We.optin_thumbnail,
            thumbnail: r
          }
        ),
        Object.values(d).map((f) => {
          const g = (_) => p({
            ...d,
            [f.slug]: { ...f, value: _ }
          });
          return /* @__PURE__ */ S.jsx(
            Gg,
            {
              contactFields: d,
              field: f,
              value: d[f.slug].value,
              error: c[f.slug] ? [c[f.slug]] : [],
              onChange: g
            },
            f.slug
          );
        }),
        /* @__PURE__ */ S.jsx(Jn, { isFetching: s, type: "submit", children: o })
      ]
    }
  ) });
}, V$ = ({ text: e }) => {
  const { isDefaultTheme: t } = Sn();
  return /* @__PURE__ */ S.jsx(X9, { children: /* @__PURE__ */ S.jsx(
    "h2",
    {
      className: kr(
        "w-full px-5 py-2.5 text-2xl font-bold sm:px-0",
        t ? "text-text-primary" : "text-THEME-primary"
      ),
      children: e
    }
  ) });
};
var An = /* @__PURE__ */ ((e) => (e.download = "download", e.eCourse = "e-course", e.physicalProduct = "physical", e))(An || {});
const W$ = (e) => {
  switch (e) {
    case An.download:
      return We.product_download_thumbnail;
    case An.eCourse:
      return We.e_course_thumbnail;
    case An.physicalProduct:
      return We.physical_product_thumbnail;
  }
}, Hg = ({
  productType: e,
  thumbnail: t,
  buttonTitle: n,
  subTitle: r,
  title: a,
  checkoutPage: o
}) => {
  const i = () => {
    o.path && window.location.assign(o.path);
  };
  return /* @__PURE__ */ S.jsx(vh, { children: /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ S.jsx(
      Fg,
      {
        title: a,
        subTitle: r,
        imageType: W$(e),
        thumbnail: t
      }
    ),
    /* @__PURE__ */ S.jsx(Jn, { onClick: i, children: n })
  ] }) });
}, Y$ = Hg, Z$ = Hg, q$ = Hg, J$ = ({ ...e }) => {
  switch (e.productType) {
    case An.download:
      return /* @__PURE__ */ S.jsx(Y$, { ...e });
    case An.eCourse:
      return /* @__PURE__ */ S.jsx(Z$, { ...e });
    case An.physicalProduct:
      return /* @__PURE__ */ S.jsx(q$, { ...e });
  }
}, X$ = (e) => {
  switch (e.type) {
    case Fa.link:
      return /* @__PURE__ */ S.jsx(K$, { ...e });
    case Fa.optin:
      return /* @__PURE__ */ S.jsx($$, { ...e });
    case Fa.header:
      return /* @__PURE__ */ S.jsx(V$, { ...e });
    case Fa.product:
      return /* @__PURE__ */ S.jsx(J$, { ...e });
  }
}, Q$ = (e) => {
  switch (e) {
    case We.link_thumbnail:
    case We.optin_thumbnail:
    case We.product_download_thumbnail:
    case We.e_course_thumbnail:
    case We.physical_product_thumbnail:
      return 60;
    case We.profile:
      return 128;
    case We.product_download_cover:
    case We.e_course_cover:
    case We.physical_product_cover:
      return 300;
  }
}, eV = (e) => {
  switch (e) {
    case We.link_thumbnail:
    case We.optin_thumbnail:
    case We.product_download_thumbnail:
    case We.e_course_thumbnail:
    case We.physical_product_thumbnail:
      return 60;
    case We.profile:
      return 128;
    case We.product_download_cover:
    case We.e_course_cover:
    case We.physical_product_cover:
      return 180;
  }
}, qr = (e, t, n, r) => {
  let a = fu(n);
  switch (a) {
    case Mn.ARABIC:
      a = "ar-AE";
      break;
    case Mn.ALBANIA:
      a = Mn.ENGLISH;
      break;
  }
  return Intl.NumberFormat(a, {
    style: "currency",
    currency: t,
    currencyDisplay: "symbol",
    maximumFractionDigits: r ? 0 : void 0,
    minimumFractionDigits: r ? 0 : 2
    // we need 2 fractional digits for tests
  }).format(e);
};
function a7(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: tV } = Object.prototype, { getPrototypeOf: Kg } = Object, bh = /* @__PURE__ */ ((e) => (t) => {
  const n = tV.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), xa = (e) => (e = e.toLowerCase(), (t) => bh(t) === e), _h = (e) => (t) => typeof t === e, { isArray: pl } = Array, Fc = _h("undefined");
function rV(e) {
  return e !== null && !Fc(e) && e.constructor !== null && !Fc(e.constructor) && Nn(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const o7 = xa("ArrayBuffer");
function nV(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && o7(e.buffer), t;
}
const aV = _h("string"), Nn = _h("function"), i7 = _h("number"), wh = (e) => e !== null && typeof e == "object", oV = (e) => e === !0 || e === !1, vd = (e) => {
  if (bh(e) !== "object")
    return !1;
  const t = Kg(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, iV = xa("Date"), sV = xa("File"), lV = xa("Blob"), cV = xa("FileList"), uV = (e) => wh(e) && Nn(e.pipe), dV = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Nn(e.append) && ((t = bh(e)) === "formdata" || // detect form-data instance
  t === "object" && Nn(e.toString) && e.toString() === "[object FormData]"));
}, pV = xa("URLSearchParams"), [hV, mV, fV, gV] = ["ReadableStream", "Request", "Response", "Headers"].map(xa), yV = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Su(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, a;
  if (typeof e != "object" && (e = [e]), pl(e))
    for (r = 0, a = e.length; r < a; r++)
      t.call(null, e[r], r, e);
  else {
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
    let s;
    for (r = 0; r < i; r++)
      s = o[r], t.call(null, e[s], s, e);
  }
}
function s7(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, a;
  for (; r-- > 0; )
    if (a = n[r], t === a.toLowerCase())
      return a;
  return null;
}
const Ni = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, l7 = (e) => !Fc(e) && e !== Ni;
function bf() {
  const { caseless: e } = l7(this) && this || {}, t = {}, n = (r, a) => {
    const o = e && s7(t, a) || a;
    vd(t[o]) && vd(r) ? t[o] = bf(t[o], r) : vd(r) ? t[o] = bf({}, r) : pl(r) ? t[o] = r.slice() : t[o] = r;
  };
  for (let r = 0, a = arguments.length; r < a; r++)
    arguments[r] && Su(arguments[r], n);
  return t;
}
const vV = (e, t, n, { allOwnKeys: r } = {}) => (Su(t, (a, o) => {
  n && Nn(a) ? e[o] = a7(a, n) : e[o] = a;
}, { allOwnKeys: r }), e), bV = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), _V = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, wV = (e, t, n, r) => {
  let a, o, i;
  const s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      i = a[o], (!r || r(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = n !== !1 && Kg(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, SV = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, CV = (e) => {
  if (!e)
    return null;
  if (pl(e))
    return e;
  let t = e.length;
  if (!i7(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, xV = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Kg(Uint8Array)), kV = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let a;
  for (; (a = r.next()) && !a.done; ) {
    const o = a.value;
    t.call(e, o[0], o[1]);
  }
}, EV = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, PV = xa("HTMLFormElement"), TV = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, a) {
    return r.toUpperCase() + a;
  }
), kb = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), MV = xa("RegExp"), c7 = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Su(n, (a, o) => {
    let i;
    (i = t(a, o, e)) !== !1 && (r[o] = i || a);
  }), Object.defineProperties(e, r);
}, OV = (e) => {
  c7(e, (t, n) => {
    if (Nn(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Nn(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, AV = (e, t) => {
  const n = {}, r = (a) => {
    a.forEach((o) => {
      n[o] = !0;
    });
  };
  return pl(e) ? r(e) : r(String(e).split(t)), n;
}, NV = () => {
}, LV = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, Dm = "abcdefghijklmnopqrstuvwxyz", Eb = "0123456789", u7 = {
  DIGIT: Eb,
  ALPHA: Dm,
  ALPHA_DIGIT: Dm + Dm.toUpperCase() + Eb
}, RV = (e = 16, t = u7.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function DV(e) {
  return !!(e && Nn(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const IV = (e) => {
  const t = new Array(10), n = (r, a) => {
    if (wh(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[a] = r;
        const o = pl(r) ? [] : {};
        return Su(r, (i, s) => {
          const l = n(i, a + 1);
          !Fc(l) && (o[s] = l);
        }), t[a] = void 0, o;
      }
    }
    return r;
  };
  return n(e, 0);
}, jV = xa("AsyncFunction"), BV = (e) => e && (wh(e) || Nn(e)) && Nn(e.then) && Nn(e.catch), d7 = ((e, t) => e ? setImmediate : t ? ((n, r) => (Ni.addEventListener("message", ({ source: a, data: o }) => {
  a === Ni && o === n && r.length && r.shift()();
}, !1), (a) => {
  r.push(a), Ni.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Nn(Ni.postMessage)
), FV = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ni) : typeof process < "u" && process.nextTick || d7, se = {
  isArray: pl,
  isArrayBuffer: o7,
  isBuffer: rV,
  isFormData: dV,
  isArrayBufferView: nV,
  isString: aV,
  isNumber: i7,
  isBoolean: oV,
  isObject: wh,
  isPlainObject: vd,
  isReadableStream: hV,
  isRequest: mV,
  isResponse: fV,
  isHeaders: gV,
  isUndefined: Fc,
  isDate: iV,
  isFile: sV,
  isBlob: lV,
  isRegExp: MV,
  isFunction: Nn,
  isStream: uV,
  isURLSearchParams: pV,
  isTypedArray: xV,
  isFileList: cV,
  forEach: Su,
  merge: bf,
  extend: vV,
  trim: yV,
  stripBOM: bV,
  inherits: _V,
  toFlatObject: wV,
  kindOf: bh,
  kindOfTest: xa,
  endsWith: SV,
  toArray: CV,
  forEachEntry: kV,
  matchAll: EV,
  isHTMLForm: PV,
  hasOwnProperty: kb,
  hasOwnProp: kb,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: c7,
  freezeMethods: OV,
  toObjectSet: AV,
  toCamelCase: TV,
  noop: NV,
  toFiniteNumber: LV,
  findKey: s7,
  global: Ni,
  isContextDefined: l7,
  ALPHABET: u7,
  generateString: RV,
  isSpecCompliantForm: DV,
  toJSONObject: IV,
  isAsyncFn: jV,
  isThenable: BV,
  setImmediate: d7,
  asap: FV
};
function rt(e, t, n, r, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), a && (this.response = a);
}
se.inherits(rt, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: se.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const p7 = rt.prototype, h7 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  h7[e] = { value: e };
});
Object.defineProperties(rt, h7);
Object.defineProperty(p7, "isAxiosError", { value: !0 });
rt.from = (e, t, n, r, a, o) => {
  const i = Object.create(p7);
  return se.toFlatObject(e, i, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), rt.call(i, e.message, t, n, r, a), i.cause = e, i.name = e.name, o && Object.assign(i, o), i;
};
const zV = null;
function _f(e) {
  return se.isPlainObject(e) || se.isArray(e);
}
function m7(e) {
  return se.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Pb(e, t, n) {
  return e ? e.concat(t).map(function(a, o) {
    return a = m7(a), !n && o ? "[" + a + "]" : a;
  }).join(n ? "." : "") : t;
}
function GV(e) {
  return se.isArray(e) && !e.some(_f);
}
const HV = se.toFlatObject(se, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Sh(e, t, n) {
  if (!se.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = se.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(f, g) {
    return !se.isUndefined(g[f]);
  });
  const r = n.metaTokens, a = n.visitor || u, o = n.dots, i = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && se.isSpecCompliantForm(t);
  if (!se.isFunction(a))
    throw new TypeError("visitor must be a function");
  function c(m) {
    if (m === null)
      return "";
    if (se.isDate(m))
      return m.toISOString();
    if (!l && se.isBlob(m))
      throw new rt("Blob is not supported. Use a Buffer instead.");
    return se.isArrayBuffer(m) || se.isTypedArray(m) ? l && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function u(m, f, g) {
    let _ = m;
    if (m && !g && typeof m == "object") {
      if (se.endsWith(f, "{}"))
        f = r ? f : f.slice(0, -2), m = JSON.stringify(m);
      else if (se.isArray(m) && GV(m) || (se.isFileList(m) || se.endsWith(f, "[]")) && (_ = se.toArray(m)))
        return f = m7(f), _.forEach(function(w, x) {
          !(se.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Pb([f], x, o) : i === null ? f : f + "[]",
            c(w)
          );
        }), !1;
    }
    return _f(m) ? !0 : (t.append(Pb(g, f, o), c(m)), !1);
  }
  const d = [], p = Object.assign(HV, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: _f
  });
  function h(m, f) {
    if (!se.isUndefined(m)) {
      if (d.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + f.join("."));
      d.push(m), se.forEach(m, function(_, v) {
        (!(se.isUndefined(_) || _ === null) && a.call(
          t,
          _,
          se.isString(v) ? v.trim() : v,
          f,
          p
        )) === !0 && h(_, f ? f.concat(v) : [v]);
      }), d.pop();
    }
  }
  if (!se.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function Tb(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Ug(e, t) {
  this._pairs = [], e && Sh(e, this, t);
}
const f7 = Ug.prototype;
f7.append = function(t, n) {
  this._pairs.push([t, n]);
};
f7.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Tb);
  } : Tb;
  return this._pairs.map(function(a) {
    return n(a[0]) + "=" + n(a[1]);
  }, "").join("&");
};
function KV(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function g7(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || KV, a = n && n.serialize;
  let o;
  if (a ? o = a(t, n) : o = se.isURLSearchParams(t) ? t.toString() : new Ug(t, n).toString(r), o) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class Mb {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    se.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const y7 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, UV = typeof URLSearchParams < "u" ? URLSearchParams : Ug, $V = typeof FormData < "u" ? FormData : null, VV = typeof Blob < "u" ? Blob : null, WV = {
  isBrowser: !0,
  classes: {
    URLSearchParams: UV,
    FormData: $V,
    Blob: VV
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, $g = typeof window < "u" && typeof document < "u", YV = ((e) => $g && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), ZV = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", qV = $g && window.location.href || "http://localhost", JV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: $g,
  hasStandardBrowserEnv: YV,
  hasStandardBrowserWebWorkerEnv: ZV,
  origin: qV
}, Symbol.toStringTag, { value: "Module" })), ma = {
  ...JV,
  ...WV
};
function XV(e, t) {
  return Sh(e, new ma.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, a, o) {
      return ma.isNode && se.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function QV(e) {
  return se.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function eW(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const a = n.length;
  let o;
  for (r = 0; r < a; r++)
    o = n[r], t[o] = e[o];
  return t;
}
function v7(e) {
  function t(n, r, a, o) {
    let i = n[o++];
    if (i === "__proto__")
      return !0;
    const s = Number.isFinite(+i), l = o >= n.length;
    return i = !i && se.isArray(a) ? a.length : i, l ? (se.hasOwnProp(a, i) ? a[i] = [a[i], r] : a[i] = r, !s) : ((!a[i] || !se.isObject(a[i])) && (a[i] = []), t(n, r, a[i], o) && se.isArray(a[i]) && (a[i] = eW(a[i])), !s);
  }
  if (se.isFormData(e) && se.isFunction(e.entries)) {
    const n = {};
    return se.forEachEntry(e, (r, a) => {
      t(QV(r), a, n, 0);
    }), n;
  }
  return null;
}
function tW(e, t, n) {
  if (se.isString(e))
    try {
      return (t || JSON.parse)(e), se.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (0, JSON.stringify)(e);
}
const Cu = {
  transitional: y7,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", a = r.indexOf("application/json") > -1, o = se.isObject(t);
    if (o && se.isHTMLForm(t) && (t = new FormData(t)), se.isFormData(t))
      return a ? JSON.stringify(v7(t)) : t;
    if (se.isArrayBuffer(t) || se.isBuffer(t) || se.isStream(t) || se.isFile(t) || se.isBlob(t) || se.isReadableStream(t))
      return t;
    if (se.isArrayBufferView(t))
      return t.buffer;
    if (se.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (o) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return XV(t, this.formSerializer).toString();
      if ((s = se.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Sh(
          s ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return o || a ? (n.setContentType("application/json", !1), tW(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Cu.transitional, r = n && n.forcedJSONParsing, a = this.responseType === "json";
    if (se.isResponse(t) || se.isReadableStream(t))
      return t;
    if (t && se.isString(t) && (r && !this.responseType || a)) {
      const i = !(n && n.silentJSONParsing) && a;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (i)
          throw s.name === "SyntaxError" ? rt.from(s, rt.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: ma.classes.FormData,
    Blob: ma.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
se.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Cu.headers[e] = {};
});
const rW = se.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), nW = (e) => {
  const t = {};
  let n, r, a;
  return e && e.split(`
`).forEach(function(i) {
    a = i.indexOf(":"), n = i.substring(0, a).trim().toLowerCase(), r = i.substring(a + 1).trim(), !(!n || t[n] && rW[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, Ob = Symbol("internals");
function Fl(e) {
  return e && String(e).trim().toLowerCase();
}
function bd(e) {
  return e === !1 || e == null ? e : se.isArray(e) ? e.map(bd) : String(e);
}
function aW(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const oW = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Im(e, t, n, r, a) {
  if (se.isFunction(r))
    return r.call(this, t, n);
  if (a && (t = n), !!se.isString(t)) {
    if (se.isString(r))
      return t.indexOf(r) !== -1;
    if (se.isRegExp(r))
      return r.test(t);
  }
}
function iW(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function sW(e, t) {
  const n = se.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(a, o, i) {
        return this[r].call(this, t, a, o, i);
      },
      configurable: !0
    });
  });
}
class bn {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const a = this;
    function o(s, l, c) {
      const u = Fl(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = se.findKey(a, u);
      (!d || a[d] === void 0 || c === !0 || c === void 0 && a[d] !== !1) && (a[d || l] = bd(s));
    }
    const i = (s, l) => se.forEach(s, (c, u) => o(c, u, l));
    if (se.isPlainObject(t) || t instanceof this.constructor)
      i(t, n);
    else if (se.isString(t) && (t = t.trim()) && !oW(t))
      i(nW(t), n);
    else if (se.isHeaders(t))
      for (const [s, l] of t.entries())
        o(l, s, r);
    else
      t != null && o(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = Fl(t), t) {
      const r = se.findKey(this, t);
      if (r) {
        const a = this[r];
        if (!n)
          return a;
        if (n === !0)
          return aW(a);
        if (se.isFunction(n))
          return n.call(this, a, r);
        if (se.isRegExp(n))
          return n.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Fl(t), t) {
      const r = se.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Im(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let a = !1;
    function o(i) {
      if (i = Fl(i), i) {
        const s = se.findKey(r, i);
        s && (!n || Im(r, r[s], s, n)) && (delete r[s], a = !0);
      }
    }
    return se.isArray(t) ? t.forEach(o) : o(t), a;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, a = !1;
    for (; r--; ) {
      const o = n[r];
      (!t || Im(this, this[o], o, t, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(t) {
    const n = this, r = {};
    return se.forEach(this, (a, o) => {
      const i = se.findKey(r, o);
      if (i) {
        n[i] = bd(a), delete n[o];
        return;
      }
      const s = t ? iW(o) : String(o).trim();
      s !== o && delete n[o], n[s] = bd(a), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return se.forEach(this, (r, a) => {
      r != null && r !== !1 && (n[a] = t && se.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((a) => r.set(a)), r;
  }
  static accessor(t) {
    const r = (this[Ob] = this[Ob] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(i) {
      const s = Fl(i);
      r[s] || (sW(a, i), r[s] = !0);
    }
    return se.isArray(t) ? t.forEach(o) : o(t), this;
  }
}
bn.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
se.reduceDescriptors(bn.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
se.freezeMethods(bn);
function jm(e, t) {
  const n = this || Cu, r = t || n, a = bn.from(r.headers);
  let o = r.data;
  return se.forEach(e, function(s) {
    o = s.call(n, o, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), o;
}
function b7(e) {
  return !!(e && e.__CANCEL__);
}
function hl(e, t, n) {
  rt.call(this, e ?? "canceled", rt.ERR_CANCELED, t, n), this.name = "CanceledError";
}
se.inherits(hl, rt, {
  __CANCEL__: !0
});
function _7(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new rt(
    "Request failed with status code " + n.status,
    [rt.ERR_BAD_REQUEST, rt.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function lW(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function cW(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let a = 0, o = 0, i;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), u = r[o];
    i || (i = c), n[a] = l, r[a] = c;
    let d = o, p = 0;
    for (; d !== a; )
      p += n[d++], d = d % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), c - i < t)
      return;
    const h = u && c - u;
    return h ? Math.round(p * 1e3 / h) : void 0;
  };
}
function uW(e, t) {
  let n = 0, r = 1e3 / t, a, o;
  const i = (c, u = Date.now()) => {
    n = u, a = null, o && (clearTimeout(o), o = null), e.apply(null, c);
  };
  return [(...c) => {
    const u = Date.now(), d = u - n;
    d >= r ? i(c, u) : (a = c, o || (o = setTimeout(() => {
      o = null, i(a);
    }, r - d)));
  }, () => a && i(a)];
}
const up = (e, t, n = 3) => {
  let r = 0;
  const a = cW(50, 250);
  return uW((o) => {
    const i = o.loaded, s = o.lengthComputable ? o.total : void 0, l = i - r, c = a(l), u = i <= s;
    r = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - i) / c : void 0,
      event: o,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, Ab = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, Nb = (e) => (...t) => se.asap(() => e(...t)), dW = ma.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function a(o) {
      let i = o;
      return t && (n.setAttribute("href", i), i = n.href), n.setAttribute("href", i), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = a(window.location.href), function(i) {
      const s = se.isString(i) ? a(i) : i;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), pW = ma.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, a, o) {
      const i = [e + "=" + encodeURIComponent(t)];
      se.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), se.isString(r) && i.push("path=" + r), se.isString(a) && i.push("domain=" + a), o === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function hW(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function mW(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function w7(e, t) {
  return e && !hW(t) ? mW(e, t) : t;
}
const Lb = (e) => e instanceof bn ? { ...e } : e;
function qi(e, t) {
  t = t || {};
  const n = {};
  function r(c, u, d) {
    return se.isPlainObject(c) && se.isPlainObject(u) ? se.merge.call({ caseless: d }, c, u) : se.isPlainObject(u) ? se.merge({}, u) : se.isArray(u) ? u.slice() : u;
  }
  function a(c, u, d) {
    if (se.isUndefined(u)) {
      if (!se.isUndefined(c))
        return r(void 0, c, d);
    } else
      return r(c, u, d);
  }
  function o(c, u) {
    if (!se.isUndefined(u))
      return r(void 0, u);
  }
  function i(c, u) {
    if (se.isUndefined(u)) {
      if (!se.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return r(c, u);
    if (d in e)
      return r(void 0, c);
  }
  const l = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (c, u) => a(Lb(c), Lb(u), !0)
  };
  return se.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const d = l[u] || a, p = d(e[u], t[u], u);
    se.isUndefined(p) && d !== s || (n[u] = p);
  }), n;
}
const S7 = (e) => {
  const t = qi({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: a, xsrfCookieName: o, headers: i, auth: s } = t;
  t.headers = i = bn.from(i), t.url = g7(w7(t.baseURL, t.url), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (se.isFormData(n)) {
    if (ma.hasStandardBrowserEnv || ma.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((l = i.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      i.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (ma.hasStandardBrowserEnv && (r && se.isFunction(r) && (r = r(t)), r || r !== !1 && dW(t.url))) {
    const c = a && o && pW.read(o);
    c && i.set(a, c);
  }
  return t;
}, fW = typeof XMLHttpRequest < "u", gW = fW && function(e) {
  return new Promise(function(n, r) {
    const a = S7(e);
    let o = a.data;
    const i = bn.from(a.headers).normalize();
    let { responseType: s, onUploadProgress: l, onDownloadProgress: c } = a, u, d, p, h, m;
    function f() {
      h && h(), m && m(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let g = new XMLHttpRequest();
    g.open(a.method.toUpperCase(), a.url, !0), g.timeout = a.timeout;
    function _() {
      if (!g)
        return;
      const w = bn.from(
        "getAllResponseHeaders" in g && g.getAllResponseHeaders()
      ), b = {
        data: !s || s === "text" || s === "json" ? g.responseText : g.response,
        status: g.status,
        statusText: g.statusText,
        headers: w,
        config: e,
        request: g
      };
      _7(function(E) {
        n(E), f();
      }, function(E) {
        r(E), f();
      }, b), g = null;
    }
    "onloadend" in g ? g.onloadend = _ : g.onreadystatechange = function() {
      !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(_);
    }, g.onabort = function() {
      g && (r(new rt("Request aborted", rt.ECONNABORTED, e, g)), g = null);
    }, g.onerror = function() {
      r(new rt("Network Error", rt.ERR_NETWORK, e, g)), g = null;
    }, g.ontimeout = function() {
      let x = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const b = a.transitional || y7;
      a.timeoutErrorMessage && (x = a.timeoutErrorMessage), r(new rt(
        x,
        b.clarifyTimeoutError ? rt.ETIMEDOUT : rt.ECONNABORTED,
        e,
        g
      )), g = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in g && se.forEach(i.toJSON(), function(x, b) {
      g.setRequestHeader(b, x);
    }), se.isUndefined(a.withCredentials) || (g.withCredentials = !!a.withCredentials), s && s !== "json" && (g.responseType = a.responseType), c && ([p, m] = up(c, !0), g.addEventListener("progress", p)), l && g.upload && ([d, h] = up(l), g.upload.addEventListener("progress", d), g.upload.addEventListener("loadend", h)), (a.cancelToken || a.signal) && (u = (w) => {
      g && (r(!w || w.type ? new hl(null, e, g) : w), g.abort(), g = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const v = lW(a.url);
    if (v && ma.protocols.indexOf(v) === -1) {
      r(new rt("Unsupported protocol " + v + ":", rt.ERR_BAD_REQUEST, e));
      return;
    }
    g.send(o || null);
  });
}, yW = (e, t) => {
  let n = new AbortController(), r;
  const a = function(l) {
    if (!r) {
      r = !0, i();
      const c = l instanceof Error ? l : this.reason;
      n.abort(c instanceof rt ? c : new hl(c instanceof Error ? c.message : c));
    }
  };
  let o = t && setTimeout(() => {
    a(new rt(`timeout ${t} of ms exceeded`, rt.ETIMEDOUT));
  }, t);
  const i = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((l) => {
      l && (l.removeEventListener ? l.removeEventListener("abort", a) : l.unsubscribe(a));
    }), e = null);
  };
  e.forEach((l) => l && l.addEventListener && l.addEventListener("abort", a));
  const { signal: s } = n;
  return s.unsubscribe = i, [s, () => {
    o && clearTimeout(o), o = null;
  }];
}, vW = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, a;
  for (; r < n; )
    a = r + t, yield e.slice(r, a), r = a;
}, bW = async function* (e, t, n) {
  for await (const r of e)
    yield* vW(ArrayBuffer.isView(r) ? r : await n(String(r)), t);
}, Rb = (e, t, n, r, a) => {
  const o = bW(e, t, a);
  let i = 0, s, l = (c) => {
    s || (s = !0, r && r(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: d } = await o.next();
        if (u) {
          l(), c.close();
          return;
        }
        let p = d.byteLength;
        if (n) {
          let h = i += p;
          n(h);
        }
        c.enqueue(new Uint8Array(d));
      } catch (u) {
        throw l(u), u;
      }
    },
    cancel(c) {
      return l(c), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, Ch = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", C7 = Ch && typeof ReadableStream == "function", wf = Ch && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), x7 = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, _W = C7 && x7(() => {
  let e = !1;
  const t = new Request(ma.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Db = 64 * 1024, Sf = C7 && x7(() => se.isReadableStream(new Response("").body)), dp = {
  stream: Sf && ((e) => e.body)
};
Ch && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !dp[t] && (dp[t] = se.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new rt(`Response type '${t}' is not supported`, rt.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const wW = async (e) => {
  if (e == null)
    return 0;
  if (se.isBlob(e))
    return e.size;
  if (se.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (se.isArrayBufferView(e) || se.isArrayBuffer(e))
    return e.byteLength;
  if (se.isURLSearchParams(e) && (e = e + ""), se.isString(e))
    return (await wf(e)).byteLength;
}, SW = async (e, t) => {
  const n = se.toFiniteNumber(e.getContentLength());
  return n ?? wW(t);
}, CW = Ch && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: a,
    cancelToken: o,
    timeout: i,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: p
  } = S7(e);
  c = c ? (c + "").toLowerCase() : "text";
  let [h, m] = a || o || i ? yW([a, o], i) : [], f, g;
  const _ = () => {
    !f && setTimeout(() => {
      h && h.unsubscribe();
    }), f = !0;
  };
  let v;
  try {
    if (l && _W && n !== "get" && n !== "head" && (v = await SW(u, r)) !== 0) {
      let C = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), E;
      if (se.isFormData(r) && (E = C.headers.get("content-type")) && u.setContentType(E), C.body) {
        const [A, O] = Ab(
          v,
          up(Nb(l))
        );
        r = Rb(C.body, Db, A, O, wf);
      }
    }
    se.isString(d) || (d = d ? "include" : "omit"), g = new Request(t, {
      ...p,
      signal: h,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: d
    });
    let w = await fetch(g);
    const x = Sf && (c === "stream" || c === "response");
    if (Sf && (s || x)) {
      const C = {};
      ["status", "statusText", "headers"].forEach((M) => {
        C[M] = w[M];
      });
      const E = se.toFiniteNumber(w.headers.get("content-length")), [A, O] = s && Ab(
        E,
        up(Nb(s), !0)
      ) || [];
      w = new Response(
        Rb(w.body, Db, A, () => {
          O && O(), x && _();
        }, wf),
        C
      );
    }
    c = c || "text";
    let b = await dp[se.findKey(dp, c) || "text"](w, e);
    return !x && _(), m && m(), await new Promise((C, E) => {
      _7(C, E, {
        data: b,
        headers: bn.from(w.headers),
        status: w.status,
        statusText: w.statusText,
        config: e,
        request: g
      });
    });
  } catch (w) {
    throw _(), w && w.name === "TypeError" && /fetch/i.test(w.message) ? Object.assign(
      new rt("Network Error", rt.ERR_NETWORK, e, g),
      {
        cause: w.cause || w
      }
    ) : rt.from(w, w && w.code, e, g);
  }
}), Cf = {
  http: zV,
  xhr: gW,
  fetch: CW
};
se.forEach(Cf, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Ib = (e) => `- ${e}`, xW = (e) => se.isFunction(e) || e === null || e === !1, k7 = {
  getAdapter: (e) => {
    e = se.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const a = {};
    for (let o = 0; o < t; o++) {
      n = e[o];
      let i;
      if (r = n, !xW(n) && (r = Cf[(i = String(n)).toLowerCase()], r === void 0))
        throw new rt(`Unknown adapter '${i}'`);
      if (r)
        break;
      a[i || "#" + o] = r;
    }
    if (!r) {
      const o = Object.entries(a).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? o.length > 1 ? `since :
` + o.map(Ib).join(`
`) : " " + Ib(o[0]) : "as no adapter specified";
      throw new rt(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Cf
};
function Bm(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new hl(null, e);
}
function jb(e) {
  return Bm(e), e.headers = bn.from(e.headers), e.data = jm.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), k7.getAdapter(e.adapter || Cu.adapter)(e).then(function(r) {
    return Bm(e), r.data = jm.call(
      e,
      e.transformResponse,
      r
    ), r.headers = bn.from(r.headers), r;
  }, function(r) {
    return b7(r) || (Bm(e), r && r.response && (r.response.data = jm.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = bn.from(r.response.headers))), Promise.reject(r);
  });
}
const E7 = "1.7.4", Vg = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Vg[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Bb = {};
Vg.transitional = function(t, n, r) {
  function a(o, i) {
    return "[Axios v" + E7 + "] Transitional option '" + o + "'" + i + (r ? ". " + r : "");
  }
  return (o, i, s) => {
    if (t === !1)
      throw new rt(
        a(i, " has been removed" + (n ? " in " + n : "")),
        rt.ERR_DEPRECATED
      );
    return n && !Bb[i] && (Bb[i] = !0, console.warn(
      a(
        i,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(o, i, s) : !0;
  };
};
function kW(e, t, n) {
  if (typeof e != "object")
    throw new rt("options must be an object", rt.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let a = r.length;
  for (; a-- > 0; ) {
    const o = r[a], i = t[o];
    if (i) {
      const s = e[o], l = s === void 0 || i(s, o, e);
      if (l !== !0)
        throw new rt("option " + o + " must be " + l, rt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new rt("Unknown option " + o, rt.ERR_BAD_OPTION);
  }
}
const xf = {
  assertOptions: kW,
  validators: Vg
}, Po = xf.validators;
class zi {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Mb(),
      response: new Mb()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let a;
        Error.captureStackTrace ? Error.captureStackTrace(a = {}) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? o && !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + o) : r.stack = o;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = qi(this.defaults, n);
    const { transitional: r, paramsSerializer: a, headers: o } = n;
    r !== void 0 && xf.assertOptions(r, {
      silentJSONParsing: Po.transitional(Po.boolean),
      forcedJSONParsing: Po.transitional(Po.boolean),
      clarifyTimeoutError: Po.transitional(Po.boolean)
    }, !1), a != null && (se.isFunction(a) ? n.paramsSerializer = {
      serialize: a
    } : xf.assertOptions(a, {
      encode: Po.function,
      serialize: Po.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = o && se.merge(
      o.common,
      o[n.method]
    );
    o && se.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete o[m];
      }
    ), n.headers = bn.concat(i, o);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(f) {
      typeof f.runWhen == "function" && f.runWhen(n) === !1 || (l = l && f.synchronous, s.unshift(f.fulfilled, f.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(f) {
      c.push(f.fulfilled, f.rejected);
    });
    let u, d = 0, p;
    if (!l) {
      const m = [jb.bind(this), void 0];
      for (m.unshift.apply(m, s), m.push.apply(m, c), p = m.length, u = Promise.resolve(n); d < p; )
        u = u.then(m[d++], m[d++]);
      return u;
    }
    p = s.length;
    let h = n;
    for (d = 0; d < p; ) {
      const m = s[d++], f = s[d++];
      try {
        h = m(h);
      } catch (g) {
        f.call(this, g);
        break;
      }
    }
    try {
      u = jb.call(this, h);
    } catch (m) {
      return Promise.reject(m);
    }
    for (d = 0, p = c.length; d < p; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = qi(this.defaults, t);
    const n = w7(t.baseURL, t.url);
    return g7(n, t.params, t.paramsSerializer);
  }
}
se.forEach(["delete", "get", "head", "options"], function(t) {
  zi.prototype[t] = function(n, r) {
    return this.request(qi(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
se.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(o, i, s) {
      return this.request(qi(s || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: i
      }));
    };
  }
  zi.prototype[t] = n(), zi.prototype[t + "Form"] = n(!0);
});
class Wg {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const r = this;
    this.promise.then((a) => {
      if (!r._listeners)
        return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](a);
      r._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const i = new Promise((s) => {
        r.subscribe(s), o = s;
      }).then(a);
      return i.cancel = function() {
        r.unsubscribe(o);
      }, i;
    }, t(function(o, i, s) {
      r.reason || (r.reason = new hl(o, i, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Wg(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
}
function EW(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function PW(e) {
  return se.isObject(e) && e.isAxiosError === !0;
}
const kf = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(kf).forEach(([e, t]) => {
  kf[t] = e;
});
function P7(e) {
  const t = new zi(e), n = a7(zi.prototype.request, t);
  return se.extend(n, zi.prototype, t, { allOwnKeys: !0 }), se.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(a) {
    return P7(qi(e, a));
  }, n;
}
const Er = P7(Cu);
Er.Axios = zi;
Er.CanceledError = hl;
Er.CancelToken = Wg;
Er.isCancel = b7;
Er.VERSION = E7;
Er.toFormData = Sh;
Er.AxiosError = rt;
Er.Cancel = Er.CanceledError;
Er.all = function(t) {
  return Promise.all(t);
};
Er.spread = EW;
Er.isAxiosError = PW;
Er.mergeConfig = qi;
Er.AxiosHeaders = bn;
Er.formToJSON = (e) => v7(se.isHTMLForm(e) ? new FormData(e) : e);
Er.getAdapter = k7.getAdapter;
Er.HttpStatusCode = kf;
Er.default = Er;
const xh = Er.create(Os.defaults);
xh.interceptors.response.use((e) => e.data, T9());
const Cn = ({
  thumbnail: e,
  imageType: t,
  alt: n,
  className: r,
  width: a = Q$(t),
  height: o = eV(t),
  skipTheme: i
}) => {
  const { isDefaultTheme: s, state: l } = Sn(), { primaryColor: c, secondaryColor: u } = yh(l), d = !e, p = d ? "" : e.path, h = d && !s && !i, m = d ? p$(t, {
    width: a,
    height: o,
    fill: h ? c : "rgb(var(--text-primary))",
    className: r,
    primaryColor: h ? c : ff.default.primaryColor,
    secondaryColor: h ? u : ff.default.secondaryColor
  }) : null;
  return d ? m : /* @__PURE__ */ S.jsx("img", { className: r, alt: n, width: a, height: o, src: p });
}, ka = (e) => {
  switch (e.type) {
    case sr.instagram:
      return "https://www.instagram.com/" + e.url;
    case sr.twitter:
      return "https://twitter.com/" + e.url;
    case sr.tiktok:
      return "https://www.tiktok.com/@" + e.url;
    case sr.telegram:
      return "https://t.me/" + e.url;
    case sr.email:
      return "mailto:" + e.url;
    default:
      return e.url;
  }
}, TW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = zt();
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      style: {
        backgroundImage: `url(${Ig}/images/profile-background/luminous-profile-background.png)`
      },
      className: "bg-THEME-secondary shadow-around-sm flex w-full flex-col items-center justify-center gap-5 rounded-none p-10 sm:max-w-xl sm:rounded-lg",
      children: [
        /* @__PURE__ */ S.jsx(
          Cn,
          {
            width: 96,
            height: 96,
            imageType: We.profile,
            alt: e.sellerName,
            thumbnail: e.sellerPhoto,
            className: "border-THEME-primary rounded-full border-2 object-cover"
          }
        ),
        /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col items-center justify-center gap-3", children: [
          /* @__PURE__ */ S.jsx("h1", { lang: n, className: "text-THEME-primary break-all text-center text-2xl font-bold", children: e.sellerName }),
          /* @__PURE__ */ S.jsx("span", { lang: n, className: "hyphens-auto text-center text-[16px] font-normal ", children: e.bio })
        ] }),
        !!t.length && /* @__PURE__ */ S.jsx("div", { className: "flex flex-wrap items-center justify-center gap-1.5", children: t.map((r) => /* @__PURE__ */ S.jsx(
          "a",
          {
            href: ka(r),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-1",
            children: Ea(r.type, "fill-THEME-text-secondary")
          },
          r.type
        )) })
      ]
    }
  );
}, MW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = zt();
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: "bg-THEME-secondary shadow-around-sm flex w-full flex-col items-center justify-center gap-5 rounded-none px-5 py-10 sm:max-w-xl sm:rounded-lg",
      children: [
        /* @__PURE__ */ S.jsx(
          Cn,
          {
            imageType: We.profile,
            alt: e.sellerName,
            thumbnail: e.sellerPhoto,
            className: "border-THEME-primary rounded-full border-2 object-cover"
          }
        ),
        /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ S.jsx("h1", { lang: n, className: "text-text-primary break-all text-center text-2xl font-bold", children: e.sellerName }),
          /* @__PURE__ */ S.jsx("span", { lang: n, className: "hyphens-auto text-center text-lg font-medium", children: e.bio })
        ] }),
        !!t.length && /* @__PURE__ */ S.jsx("div", { className: "flex flex-wrap items-center justify-center gap-1.5", children: t.map((r) => /* @__PURE__ */ S.jsx(
          "a",
          {
            href: ka(r),
            target: "_blank",
            rel: "noreferrer",
            className: "border-text-secondary/30 rounded-md border p-1",
            children: Ea(r.type, "fill-THEME-primary")
          },
          r.type
        )) })
      ]
    }
  );
}, OW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = zt();
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      style: {
        backgroundImage: e.sellerPhoto ? `url(${e.sellerPhoto.path})` : "none"
      },
      className: "bg-THEME-secondary relative z-0 flex min-h-[500px] w-full flex-col items-center justify-end gap-5 overflow-hidden rounded-none bg-cover bg-center px-10 pb-10 pt-5 sm:max-w-xl sm:rounded-lg",
      children: [
        !e.sellerPhoto && /* @__PURE__ */ S.jsx(
          Cn,
          {
            width: 500,
            height: 500,
            alt: e.sellerName,
            imageType: We.profile,
            className: "-z-1 absolute top-0 w-full "
          }
        ),
        /* @__PURE__ */ S.jsxs("div", { className: "z-1 flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ S.jsx(
            "h1",
            {
              lang: n,
              className: "text-THEME-primary break-all text-center text-[40px] font-bold leading-[50px]",
              children: e.sellerName
            }
          ),
          /* @__PURE__ */ S.jsx(
            "span",
            {
              lang: n,
              className: "hyphens-auto text-center text-lg font-normal text-[#FAFAFA]",
              children: e.bio
            }
          )
        ] }),
        !!t.length && /* @__PURE__ */ S.jsx("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1.5", children: t.map((r) => /* @__PURE__ */ S.jsx(
          "a",
          {
            href: ka(r),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-1",
            children: Ea(r.type, "fill-THEME-text-secondary")
          },
          r.type
        )) }),
        /* @__PURE__ */ S.jsx(
          "div",
          {
            className: "from-THEME-secondary -z-1 absolute bottom-0 h-[300px] w-full bg-gradient-to-t to-transparent sm:rounded-b-lg"
          }
        )
      ]
    }
  );
}, AW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = zt();
  return /* @__PURE__ */ S.jsx("div", { className: "flex w-full max-w-xl flex-col gap-5 px-5 py-10 sm:px-0", children: /* @__PURE__ */ S.jsxs("div", { className: "flex flex-row gap-5", children: [
    /* @__PURE__ */ S.jsx("div", { className: "border-3 border-THEME-primary self-start rounded-full", children: /* @__PURE__ */ S.jsx(
      Cn,
      {
        width: 99,
        height: 99,
        imageType: We.profile,
        alt: e.sellerName,
        thumbnail: e.sellerPhoto,
        className: "rounded-full border-2 border-transparent object-cover"
      }
    ) }),
    /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col justify-between", children: [
      /* @__PURE__ */ S.jsx(
        "h1",
        {
          lang: n,
          className: "text-THEME-primary mb-1 break-all text-[22px] font-bold leading-7",
          children: e.sellerName
        }
      ),
      /* @__PURE__ */ S.jsx("span", { lang: n, className: "mb-2.5 hyphens-auto text-[14px] font-normal leading-4", children: e.bio }),
      !!t.length && /* @__PURE__ */ S.jsx("div", { className: "flex flex-wrap items-start gap-1.5", children: t.map((r) => /* @__PURE__ */ S.jsx(
        "a",
        {
          href: ka(r),
          target: "_blank",
          rel: "noreferrer",
          className: "rounded-full bg-[#F1F4F8] p-2",
          children: Ea(r.type, "fill-THEME-primary")
        },
        r.type
      )) })
    ] })
  ] }) });
}, NW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = zt();
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: "flex w-full flex-col items-center justify-center gap-5 px-5 py-10 sm:max-w-xl sm:px-0",
      children: [
        /* @__PURE__ */ S.jsx(
          Cn,
          {
            width: 200,
            height: 200,
            alt: e.sellerName,
            imageType: We.profile,
            thumbnail: e.sellerPhoto,
            className: "rounded-full object-cover"
          }
        ),
        /* @__PURE__ */ S.jsxs(
          "div",
          {
            className: "z-1 flex flex-col items-center justify-center gap-4 text-center font-normal",
            children: [
              /* @__PURE__ */ S.jsx("h1", { lang: n, className: "text-THEME-primary break-all text-[48px] leading-[62px]", children: e.sellerName }),
              /* @__PURE__ */ S.jsx("span", { lang: n, className: "hyphens-auto text-[18px] leading-[27px] text-[#242424]", children: e.bio }),
              !!t.length && /* @__PURE__ */ S.jsx("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1.5", children: t.map((r) => /* @__PURE__ */ S.jsx(
                "a",
                {
                  href: ka(r),
                  target: "_blank",
                  rel: "noreferrer",
                  className: "p-1",
                  children: Ea(r.type, "fill-[#242424] ")
                },
                r.type
              )) })
            ]
          }
        )
      ]
    }
  );
}, LW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = zt();
  return /* @__PURE__ */ S.jsx("div", { className: "flex w-full max-w-xl flex-col gap-5 px-5 py-10 sm:px-0", children: /* @__PURE__ */ S.jsxs("div", { className: "flex flex-row gap-5", children: [
    /* @__PURE__ */ S.jsx("div", { className: "border-3 border-THEME-primary self-start rounded-full", children: /* @__PURE__ */ S.jsx(
      Cn,
      {
        width: 99,
        height: 99,
        imageType: We.profile,
        alt: e.sellerName,
        thumbnail: e.sellerPhoto,
        className: "rounded-full border-2 border-transparent object-cover"
      }
    ) }),
    /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col justify-center", children: [
      /* @__PURE__ */ S.jsx(
        "h1",
        {
          lang: n,
          className: "text-THEME-primary mb-1 break-all text-[22px] font-bold leading-7",
          children: e.sellerName
        }
      ),
      /* @__PURE__ */ S.jsx("span", { lang: n, className: "mb-2.5 hyphens-auto text-[14px] font-normal leading-4", children: e.bio }),
      !!t.length && /* @__PURE__ */ S.jsx("div", { className: "flex flex-wrap items-start gap-1.5", children: t.map((r) => /* @__PURE__ */ S.jsx(
        "a",
        {
          href: ka(r),
          target: "_blank",
          rel: "noreferrer",
          className: "bg-THEME-secondary rounded-full p-2",
          children: Ea(r.type, "fill-THEME-primary")
        },
        r.type
      )) })
    ] })
  ] }) });
}, RW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = zt();
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      style: {
        backgroundImage: e.sellerPhoto ? `url(${e.sellerPhoto.path})` : "none"
      },
      className: "bg-THEME-secondary relative z-0 flex min-h-[500px] w-full flex-col items-center justify-end gap-4 overflow-hidden rounded-none bg-cover bg-center px-10 pb-8 pt-5 sm:max-w-xl sm:rounded-lg",
      children: [
        !e.sellerPhoto && /* @__PURE__ */ S.jsx(
          Cn,
          {
            width: 500,
            height: 500,
            alt: e.sellerName,
            imageType: We.profile,
            className: "-z-1 absolute top-0 w-full"
          }
        ),
        /* @__PURE__ */ S.jsxs("div", { className: "z-1 flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ S.jsx("h1", { lang: n, className: "break-all text-center text-[28px] font-bold leading-[36px]", children: e.sellerName }),
          /* @__PURE__ */ S.jsx(
            "span",
            {
              lang: n,
              className: "hyphens-auto text-center text-base font-normal text-[#F1F4F8]",
              children: e.bio
            }
          )
        ] }),
        !!t.length && /* @__PURE__ */ S.jsx("div", { className: "z-1 flex flex-wrap items-center justify-center gap-4", children: t.map((r) => /* @__PURE__ */ S.jsx(
          "a",
          {
            href: ka(r),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-0.5",
            children: Ea(r.type, "fill-THEME-primary")
          },
          r.type
        )) }),
        /* @__PURE__ */ S.jsx(
          "div",
          {
            className: "from-THEME-secondary -z-1 absolute bottom-0 h-[300px] w-full bg-gradient-to-t to-transparent sm:rounded-b-lg"
          }
        )
      ]
    }
  );
}, DW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = zt();
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      style: {
        backgroundImage: e.sellerPhoto ? `url(${e.sellerPhoto.path})` : "none"
      },
      className: "bg-THEME-secondary relative z-0 flex min-h-[520px] w-full flex-col items-center justify-end gap-4 overflow-hidden rounded-none bg-cover bg-center px-10 pb-12 pt-5 sm:max-w-xl sm:rounded-lg",
      children: [
        !e.sellerPhoto && /* @__PURE__ */ S.jsx(
          Cn,
          {
            width: 500,
            height: 520,
            alt: e.sellerName,
            imageType: We.profile,
            className: "-z-1 absolute top-0 w-full"
          }
        ),
        /* @__PURE__ */ S.jsxs("div", { className: "z-1 flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ S.jsx(
            "h1",
            {
              lang: n,
              className: "mb-2 break-all text-center text-[40px] font-bold leading-[50px]",
              children: e.sellerName
            }
          ),
          /* @__PURE__ */ S.jsx(
            "span",
            {
              lang: n,
              className: "mb-4 hyphens-auto text-center text-lg font-normal text-[#FAFAFA]",
              children: e.bio
            }
          )
        ] }),
        !!t.length && /* @__PURE__ */ S.jsx("div", { className: "z-1 flex flex-wrap items-center justify-center gap-6", children: t.map((r) => /* @__PURE__ */ S.jsx(
          "a",
          {
            href: ka(r),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-0.5",
            children: Ea(r.type, "fill-[#FAFAFA]")
          },
          r.type
        )) }),
        /* @__PURE__ */ S.jsx(
          "div",
          {
            className: "from-THEME-secondary -z-1 absolute bottom-0 h-full w-full bg-gradient-to-t to-transparent sm:rounded-b-lg"
          }
        )
      ]
    }
  );
}, IW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = zt();
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      style: {
        backgroundImage: `linear-gradient(to top, rgba(5, 0, 33, 1) 0%, rgba(6, 1, 36, 0.64) 100%), 
          url(${Ig}/images/profile-background/urban-profile-background.jpeg)`
      },
      className: "flex min-h-[500px] w-full flex-col items-center justify-center gap-20 bg-cover bg-center px-5 py-12 sm:max-w-xl sm:rounded-lg",
      children: [
        /* @__PURE__ */ S.jsx("div", { className: "border-3 border-THEME-secondary rounded-full", children: /* @__PURE__ */ S.jsx(
          Cn,
          {
            className: "rounded-full border-0 border-transparent",
            width: 149,
            height: 149,
            alt: e.sellerName,
            imageType: We.profile,
            thumbnail: e.sellerPhoto
          }
        ) }),
        /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col items-center", children: [
          /* @__PURE__ */ S.jsx(
            "h1",
            {
              lang: n,
              className: "text-THEME-primary mb-2 break-all text-center text-[40px] font-bold leading-[50.4px]",
              children: e.sellerName
            }
          ),
          /* @__PURE__ */ S.jsx(
            "span",
            {
              lang: n,
              className: "text-THEME-secondary mb-4 hyphens-auto text-center text-lg font-normal",
              children: e.bio
            }
          ),
          !!t.length && /* @__PURE__ */ S.jsx("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1.5", children: t.map((r) => /* @__PURE__ */ S.jsx(
            "a",
            {
              href: ka(r),
              target: "_blank",
              rel: "noreferrer",
              className: "rounded-md p-1",
              children: Ea(r.type, "fill-THEME-secondary")
            },
            r.type
          )) })
        ] })
      ]
    }
  );
}, jW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = zt();
  return /* @__PURE__ */ S.jsx(
    "div",
    {
      className: "mx-5 w-full overflow-hidden py-9 sm:max-w-xl ",
      style: { width: "calc(100% - 2.5rem)" },
      children: /* @__PURE__ */ S.jsxs("div", { className: "border-THEME-primary/50 relative flex rounded-b-lg border-2 border-t-0", children: [
        /* @__PURE__ */ S.jsx("div", { className: "border-THEME-primary absolute -left-[15%] top-[20%] -z-10 h-[60%] w-[130%] rounded-t-full border-[15px] border-b-0 blur-[20px] sm:-left-[15%] sm:top-[25%] sm:h-[65%] sm:w-[130%]" }),
        /* @__PURE__ */ S.jsx("div", { className: "from-THEME-primary/30 to -z-1 absolute -inset-x-[1px] -bottom-[0.5px] top-0 rounded-b-lg bg-gradient-to-t to-transparent opacity-70" }),
        /* @__PURE__ */ S.jsx("div", { className: "border-THEME-tertiary absolute inset-y-0 -left-[3px] bottom-[3px] z-0 border-l-4" }),
        /* @__PURE__ */ S.jsx(
          "div",
          {
            className: "z-1 absolute inset-y-0 -left-[2px] bottom-[3px] border-l-2 opacity-50 md:-left-[1.5px]",
            style: {
              borderImage: "linear-gradient(to bottom, transparent, var(--THEME-primary)) 2"
            }
          }
        ),
        /* @__PURE__ */ S.jsx("div", { className: "border-THEME-tertiary absolute inset-y-0 -right-[3px] bottom-[3px] z-0 border-l-4" }),
        /* @__PURE__ */ S.jsx(
          "div",
          {
            className: "z-1 absolute inset-y-0 -right-[1.5px] bottom-[3px] border-l-2 opacity-50",
            style: {
              borderImage: "linear-gradient(to bottom, transparent, var(--THEME-primary)) 2"
            }
          }
        ),
        /* @__PURE__ */ S.jsxs("div", { className: "flex w-full flex-col items-center justify-end gap-10 px-5 py-9", children: [
          /* @__PURE__ */ S.jsx("div", { className: "border-THEME-primary rounded-full border-[15px]", children: /* @__PURE__ */ S.jsx(
            Cn,
            {
              className: "rounded-full border-0 border-transparent",
              width: 149,
              height: 149,
              alt: e.sellerName,
              imageType: We.profile,
              thumbnail: e.sellerPhoto
            }
          ) }),
          /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col items-center", children: [
            /* @__PURE__ */ S.jsx(
              "h1",
              {
                lang: n,
                className: "text-THEME-text-primary break-all text-center text-[35px] font-bold leading-[45.57px]",
                children: e.sellerName
              }
            ),
            e.bio && /* @__PURE__ */ S.jsx(
              "span",
              {
                lang: n,
                className: "text-THEME-text-primary mb-4 mt-2 hyphens-auto text-center text-lg font-normal",
                children: e.bio
              }
            ),
            !!t.length && /* @__PURE__ */ S.jsx("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1", children: t.map((r) => /* @__PURE__ */ S.jsx(
              "a",
              {
                href: ka(r),
                target: "_blank",
                rel: "noreferrer",
                className: "rounded-md p-1",
                children: Ea(r.type, "fill-THEME-text-primary")
              },
              r.type
            )) })
          ] })
        ] })
      ] })
    }
  );
}, BW = ({ profile: e, socialLinks: t }) => {
  var r;
  const { locale: n } = zt();
  return /* @__PURE__ */ S.jsx(
    "div",
    {
      style: {
        backgroundImage: (r = e.sellerPhoto) != null && r.path ? `url(${e.sellerPhoto.path})` : void 0
      },
      className: " bg-center-left w-full overflow-hidden bg-contain bg-no-repeat sm:max-w-xl sm:rounded-lg sm:bg-[length:50%_120%]",
      children: /* @__PURE__ */ S.jsxs(
        "div",
        {
          className: `
          from-THEME-primary min-[460px]:from-78% flex min-h-[215px] bg-gradient-to-l from-70% to-[transparent] bg-[length:70%]
          bg-right bg-no-repeat 
          p-5 min-[460px]:bg-[length:78%] 
          min-[500px]:from-80% min-[500px]:bg-[length:80%] 
          sm:from-70% sm:bg-[length:73%]
        `,
          children: [
            !e.sellerPhoto && /* @__PURE__ */ S.jsx("div", { className: "border-3 border-THEME-primary my-auto rounded-full", children: /* @__PURE__ */ S.jsx(
              Cn,
              {
                className: "rounded-full border-0 border-transparent",
                width: 104,
                height: 104,
                alt: e.sellerName,
                imageType: We.profile,
                thumbnail: e.sellerPhoto
              }
            ) }),
            /* @__PURE__ */ S.jsxs("div", { className: "my-auto ml-auto flex w-[60%] flex-col", children: [
              /* @__PURE__ */ S.jsx(
                "h1",
                {
                  lang: n,
                  className: "text-THEME-text-primary mb-1 break-all text-left text-[22px] font-medium leading-[26.82px]",
                  children: e.sellerName
                }
              ),
              /* @__PURE__ */ S.jsx(
                "span",
                {
                  lang: n,
                  className: "text-THEME-text-primary mb-2.5 hyphens-auto text-left text-lg font-normal",
                  children: e.bio
                }
              ),
              !!t.length && /* @__PURE__ */ S.jsx("div", { className: "justify-left z-1 flex flex-wrap items-center gap-1.5", children: t.map((a) => /* @__PURE__ */ S.jsx(
                "a",
                {
                  href: ka(a),
                  target: "_blank",
                  rel: "noreferrer",
                  className: "bg-THEME-secondary rounded-full p-2",
                  children: Ea(a.type, "fill-THEME-primary")
                },
                a.type
              )) })
            ] })
          ]
        }
      )
    }
  );
};
var sr = /* @__PURE__ */ ((e) => (e.tiktok = "tiktok", e.youtube = "youtube", e.instagram = "instagram", e.twitter = "twitter", e.facebook = "facebook", e.spotify = "spotify", e.linkedin = "linkedin", e.pinterest = "pinterest", e.snapchat = "snapchat", e.twitch = "twitch", e.discord = "discord", e.telegram = "telegram", e.vimeo = "vimeo", e.etsy = "etsy", e.email = "email", e.website = "website", e.whatsapp = "whatsapp", e))(sr || {});
function FW(e) {
  return /* @__PURE__ */ S.jsx(
    "svg",
    {
      width: "27",
      height: "20",
      viewBox: "0 0 27 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ S.jsx("path", { d: "M22.2137 1.65786C20.5409 0.890326 18.7478 0.325064 16.8727 0.00143234C16.8388 -0.00512776 16.8049 0.0112724 16.7863 0.0418862C16.5556 0.451893 16.2998 0.987634 16.1215 1.40748C14.1043 1.10572 12.098 1.10572 10.1223 1.40748C9.94412 0.977794 9.67843 0.451893 9.44774 0.0418862C9.42915 0.0112724 9.39526 -0.00403441 9.36136 0.00143234C7.48736 0.323971 5.69427 0.889233 4.02035 1.65786C4.00613 1.66332 3.99301 1.67426 3.98536 1.68738C0.583945 6.76927 -0.348683 11.7265 0.108337 16.6225C0.110524 16.6466 0.123644 16.6696 0.142231 16.6838C2.38688 18.3325 4.56046 19.333 6.69468 19.9955C6.72857 20.0065 6.76465 19.9933 6.78652 19.9649C7.29165 19.2761 7.74102 18.549 8.12697 17.7848C8.14993 17.74 8.12806 17.6864 8.08105 17.6689C7.36709 17.3977 6.68812 17.0675 6.0343 16.6936C5.98291 16.663 5.97854 16.5897 6.02555 16.5537C6.16331 16.4509 6.30107 16.3437 6.43228 16.2355C6.45633 16.2158 6.48913 16.2114 6.51756 16.2246C10.8122 18.1849 15.4612 18.1849 19.7045 16.2246C19.7329 16.2114 19.7657 16.2147 19.7908 16.2355C19.922 16.3437 20.0598 16.452 20.1987 16.5548C20.2468 16.5897 20.2435 16.6641 20.191 16.6947C19.5372 17.0763 18.8582 17.3999 18.1432 17.6689C18.0961 17.6864 18.0765 17.741 18.0983 17.7859C18.4919 18.549 18.9424 19.2761 19.4377 19.9649C19.4585 19.9944 19.4956 20.0065 19.5295 19.9966C21.6736 19.333 23.8483 18.3325 26.0918 16.6849C26.1115 16.6707 26.1235 16.6488 26.1257 16.6247C26.6724 10.9645 25.2095 6.04766 22.2465 1.68957C22.241 1.67426 22.2279 1.66332 22.2137 1.65786ZM8.76877 13.6421C7.47533 13.6421 6.41041 12.4547 6.41041 10.9973C6.41041 9.53982 7.45456 8.35244 8.76877 8.35244C10.0928 8.35244 11.1479 9.54966 11.1271 10.9973C11.1271 12.4558 10.0819 13.6421 8.76877 13.6421ZM17.4882 13.6421C16.1959 13.6421 15.1299 12.4547 15.1299 10.9973C15.1299 9.53982 16.174 8.35244 17.4882 8.35244C18.8123 8.35244 19.8674 9.54966 19.8466 10.9973C19.8466 12.4558 18.8123 13.6421 17.4882 13.6421Z" })
    }
  );
}
function zW(e) {
  return /* @__PURE__ */ S.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", ...e, children: [
    /* @__PURE__ */ S.jsx("path", { d: "M23.2,3.71l-1.86,1.65-8.84,7.83c-.29,.26-.72,.26-1.01,0L2.66,5.36,.8,3.71c.46-.44,1.08-.71,1.76-.71H21.44c.68,0,1.3,.27,1.76,.71Z" }),
    /* @__PURE__ */ S.jsx("path", { d: "M24,5.56v12.88c0,1.41-1.15,2.56-2.56,2.56H2.56c-1.41,0-2.56-1.15-2.56-2.56V5.56l.15-.07L11.02,15.13c.56,.49,1.39,.49,1.95,0L23.85,5.49l.15,.07Z" })
  ] });
}
function GW(e) {
  return /* @__PURE__ */ S.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ S.jsx("path", { d: "M17.2792 13.3805H16.5578C16.4251 13.3805 16.3095 13.471 16.2776 13.5998L15.8153 15.4677C15.5602 16.4988 14.6348 17.2231 13.5727 17.2231H8.73963C8.16746 17.2231 7.70363 16.7592 7.70363 16.187V11.0263C7.70363 10.9303 7.78153 10.8524 7.87758 10.8524H11.1943C11.9565 10.8524 12.5744 11.4703 12.5744 12.2324V12.6976C12.5744 12.857 12.7036 12.9862 12.863 12.9862H13.4919C13.6513 12.9862 13.7805 12.857 13.7805 12.6976V6.89647C13.7805 6.73706 13.6513 6.60786 13.4919 6.60786H12.7703C12.6109 6.60786 12.4816 6.73706 12.4816 6.89647V7.69409C12.4816 8.45626 11.8637 9.07417 11.1016 9.07417H7.87758C7.78152 9.07417 7.70363 8.99627 7.70363 8.90018V3.88638C7.70363 3.26725 8.20553 2.76535 8.82469 2.76535H13.5408C14.493 2.76535 15.2649 3.53726 15.2649 4.48944V5.87852C15.2649 6.03794 15.3942 6.16714 15.5535 6.16714H16.2292C16.3791 6.16714 16.504 6.05243 16.5168 5.90308L16.8475 2.03151C16.8834 1.6111 16.5519 1.25 16.1299 1.25H2.37926C2.21985 1.25 2.09064 1.37921 2.09064 1.53862V2.58495C2.09064 2.74437 2.21985 2.87357 2.37926 2.87357H3.52867C4.20761 2.87357 4.75796 3.42396 4.75796 4.10286V16.0015C4.75796 16.6804 4.20761 17.2308 3.52867 17.2308H2.37926C2.21984 17.2308 2.09064 17.36 2.09064 17.5194V18.4613C2.09064 18.6208 2.21985 18.75 2.37926 18.75H16.3012C16.6518 18.75 16.9479 18.4897 16.9928 18.142L17.5655 13.7061C17.5878 13.5335 17.4533 13.3805 17.2792 13.3805Z" })
    }
  );
}
function HW(e) {
  return /* @__PURE__ */ S.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ S.jsx("path", { d: "M9.999 0C4.477 0 0 4.47698 0 9.99898C0 14.989 3.656 19.125 8.437 19.878V12.89H5.897V9.99898H8.437V7.79598C8.437 5.28798 9.93 3.90498 12.213 3.90498C13.307 3.90498 14.453 4.09998 14.453 4.09998V6.55898H13.189C11.949 6.55898 11.561 7.33098 11.561 8.12198V9.99698H14.332L13.889 12.888H11.561V19.876C16.342 19.127 19.998 14.99 19.998 9.99898C19.998 4.47698 15.521 0 9.999 0Z" })
    }
  );
}
function KW(e) {
  return /* @__PURE__ */ S.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Capa_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 24 24",
      width: "512",
      height: "512",
      fill: "rgb(var(--brand-primary))",
      ...e,
      children: /* @__PURE__ */ S.jsxs("g", { children: [
        /* @__PURE__ */ S.jsx("path", { d: "M12,2.162c3.204,0,3.584,0.012,4.849,0.07c1.308,0.06,2.655,0.358,3.608,1.311c0.962,0.962,1.251,2.296,1.311,3.608   c0.058,1.265,0.07,1.645,0.07,4.849c0,3.204-0.012,3.584-0.07,4.849c-0.059,1.301-0.364,2.661-1.311,3.608   c-0.962,0.962-2.295,1.251-3.608,1.311c-1.265,0.058-1.645,0.07-4.849,0.07s-3.584-0.012-4.849-0.07   c-1.291-0.059-2.669-0.371-3.608-1.311c-0.957-0.957-1.251-2.304-1.311-3.608c-0.058-1.265-0.07-1.645-0.07-4.849   c0-3.204,0.012-3.584,0.07-4.849c0.059-1.296,0.367-2.664,1.311-3.608c0.96-0.96,2.299-1.251,3.608-1.311   C8.416,2.174,8.796,2.162,12,2.162 M12,0C8.741,0,8.332,0.014,7.052,0.072C5.197,0.157,3.355,0.673,2.014,2.014   C0.668,3.36,0.157,5.198,0.072,7.052C0.014,8.332,0,8.741,0,12c0,3.259,0.014,3.668,0.072,4.948c0.085,1.853,0.603,3.7,1.942,5.038   c1.345,1.345,3.186,1.857,5.038,1.942C8.332,23.986,8.741,24,12,24c3.259,0,3.668-0.014,4.948-0.072   c1.854-0.085,3.698-0.602,5.038-1.942c1.347-1.347,1.857-3.184,1.942-5.038C23.986,15.668,24,15.259,24,12   c0-3.259-0.014-3.668-0.072-4.948c-0.085-1.855-0.602-3.698-1.942-5.038c-1.343-1.343-3.189-1.858-5.038-1.942   C15.668,0.014,15.259,0,12,0z" }),
        /* @__PURE__ */ S.jsx("path", { d: "M12,5.838c-3.403,0-6.162,2.759-6.162,6.162c0,3.403,2.759,6.162,6.162,6.162s6.162-2.759,6.162-6.162   C18.162,8.597,15.403,5.838,12,5.838z M12,16c-2.209,0-4-1.791-4-4s1.791-4,4-4s4,1.791,4,4S14.209,16,12,16z" }),
        /* @__PURE__ */ S.jsx("circle", { cx: "18.406", cy: "5.594", r: "1.44" })
      ] })
    }
  );
}
function Fb(e) {
  return /* @__PURE__ */ S.jsx(
    "svg",
    {
      width: "21",
      height: "22",
      viewBox: "0 0 21 22",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ S.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.4388 7.42975C9.94619 7.92232 9.14741 7.92232 8.65484 7.42975C8.16227 6.93718 8.16227 6.1384 8.65484 5.64583L12.223 2.0775C14.1937 0.106979 17.3883 0.106979 19.3589 2.0775C21.3294 4.04818 21.3294 7.24282 19.3589 9.21342L15.7909 12.7814C15.2983 13.274 14.4996 13.274 14.007 12.7814C13.5143 12.2888 13.5143 11.4901 14.007 10.9973L17.575 7.4295C18.5602 6.44416 18.5602 4.84668 17.575 3.8615C16.5897 2.87616 14.9922 2.87616 14.007 3.8615L10.4388 7.42975ZM10.4391 14.5653C10.9316 14.0727 11.7304 14.0727 12.223 14.5653C12.7157 15.058 12.7157 15.8566 12.223 16.3493L8.65483 19.9175C6.68431 21.888 3.48951 21.888 1.51891 19.9175C-0.451614 17.947 -0.451614 14.7522 1.51891 12.7816L5.0869 9.21359C5.57964 8.72102 6.37825 8.72102 6.87099 9.21359C7.36356 9.70632 7.36356 10.5051 6.87099 10.9977L3.30298 14.5657C2.31764 15.5508 2.31764 17.1483 3.30298 18.1337C4.28816 19.1189 5.88565 19.1189 6.87099 18.1337L10.4391 14.5653ZM14.0071 7.42934C14.4996 7.92191 14.4996 8.72069 14.0071 9.21326L8.65483 14.5651C8.16226 15.0578 7.36348 15.0578 6.87091 14.5651C6.37834 14.0725 6.37834 13.2737 6.87091 12.7812L12.2227 7.42934C12.7155 6.93661 13.5141 6.93661 14.0068 7.42934H14.0071Z"
        }
      )
    }
  );
}
function UW(e) {
  return /* @__PURE__ */ S.jsxs(
    "svg",
    {
      width: "21",
      height: "20",
      viewBox: "0 0 21 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ S.jsx("path", { d: "M4.66575 6.42578H0.641865C0.463278 6.42578 0.318573 6.57055 0.318573 6.74907V19.6761C0.318573 19.8547 0.463278 19.9994 0.641865 19.9994H4.66575C4.84434 19.9994 4.98904 19.8547 4.98904 19.6761V6.74907C4.98904 6.57055 4.84434 6.42578 4.66575 6.42578Z" }),
        /* @__PURE__ */ S.jsx("path", { d: "M2.65526 0C1.19114 0 0 1.18984 0 2.65235C0 4.11551 1.19114 5.3058 2.65526 5.3058C4.11822 5.3058 5.30839 4.11544 5.30839 2.65235C5.30845 1.18984 4.11822 0 2.65526 0Z" }),
        /* @__PURE__ */ S.jsx("path", { d: "M14.9008 6.10547C13.2847 6.10547 12.09 6.80022 11.3653 7.58964V6.75005C11.3653 6.57153 11.2206 6.42676 11.042 6.42676H7.18847C7.00988 6.42676 6.86517 6.57153 6.86517 6.75005V19.6771C6.86517 19.8557 7.00988 20.0004 7.18847 20.0004H11.2036C11.3821 20.0004 11.5268 19.8557 11.5268 19.6771V13.2812C11.5268 11.1259 12.1123 10.2863 13.6147 10.2863C15.2509 10.2863 15.3809 11.6323 15.3809 13.3921V19.6771C15.3809 19.8557 15.5256 20.0004 15.7042 20.0004H19.7208C19.8994 20.0004 20.0441 19.8557 20.0441 19.6771V12.5864C20.0441 9.38164 19.433 6.10547 14.9008 6.10547Z" })
      ]
    }
  );
}
function $W(e) {
  return /* @__PURE__ */ S.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ S.jsx("path", { d: "M10.2719 0C4.79037 0 1.87524 3.51266 1.87524 7.34283C1.87524 9.11916 2.86779 11.3343 4.45661 12.0368C4.69787 12.1455 4.82913 12.0993 4.88288 11.8755C4.93038 11.7055 5.13914 10.8867 5.2404 10.5005C5.27165 10.3767 5.2554 10.2692 5.15539 10.153C4.62787 9.54293 4.2091 8.43163 4.2091 7.38908C4.2091 4.71771 6.33294 2.12385 9.94686 2.12385C13.072 2.12385 15.2583 4.15394 15.2583 7.05782C15.2583 10.3392 13.522 12.6093 11.2657 12.6093C10.0169 12.6093 9.08682 11.6293 9.38183 10.4167C9.7381 8.9729 10.4369 7.42033 10.4369 6.37904C10.4369 5.44524 9.90936 4.67271 8.83181 4.67271C7.5605 4.67271 6.5292 5.93152 6.5292 7.62159C6.5292 8.69539 6.90922 9.42042 6.90922 9.42042C6.90922 9.42042 5.65166 14.5007 5.4179 15.4494C5.02289 17.0558 5.47166 19.6571 5.51041 19.8809C5.53416 20.0046 5.67291 20.0434 5.75042 19.9421C5.87417 19.7796 7.39424 17.6108 7.82051 16.0432C7.97552 15.4719 8.6118 13.1556 8.6118 13.1556C9.03057 13.9119 10.2394 14.5457 11.5269 14.5457C15.3571 14.5457 18.1247 11.1793 18.1247 7.00156C18.111 2.99638 14.6833 0 10.2719 0Z" })
    }
  );
}
function VW(e) {
  return /* @__PURE__ */ S.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ S.jsx("g", { clipPath: "url(#clip0_683_607)", children: /* @__PURE__ */ S.jsx("path", { d: "M9.99114 1.43967C12.6754 1.44057 14.9113 3.67528 14.9146 6.36602C14.9153 6.99625 14.9348 7.5766 14.9704 8.11121C14.9923 8.44105 15.2666 8.68549 15.5812 8.68549C15.6276 8.68549 15.6748 8.6802 15.7222 8.66909L16.563 8.47197C16.5988 8.46356 16.6347 8.45955 16.6702 8.45955C16.8838 8.45955 17.0804 8.60547 17.1284 8.82159C17.1962 9.12701 17.0251 9.43559 16.7291 9.53936L15.4527 10.0546C15.1305 10.1847 14.9574 10.5354 15.0481 10.8709C16.0722 14.6568 18.9324 14.2631 18.9324 14.7563C18.9324 15.3757 16.7765 15.4631 16.5817 15.658C16.387 15.8528 16.5733 16.7982 16.1381 16.9812C16.0561 17.0157 15.9395 17.0277 15.7974 17.0277C15.4696 17.0277 15.006 16.9638 14.5173 16.9638C14.0935 16.9638 13.6508 17.0119 13.2617 17.1917C12.2293 17.6686 11.2339 18.5594 10 18.5594C8.76613 18.5594 7.77078 17.6686 6.73837 17.1917C6.34912 17.0119 5.90658 16.9638 5.4827 16.9638C4.99412 16.9638 4.53044 17.0277 4.20268 17.0277C4.06061 17.0277 3.94394 17.0157 3.86195 16.9812C3.42675 16.7982 3.61307 15.8528 3.41829 15.658C3.22352 15.4631 1.0676 15.3756 1.0676 14.7563C1.0676 14.263 3.92788 14.6567 4.95193 10.8709C5.04267 10.5354 4.86959 10.1847 4.5473 10.0546L3.27088 9.53932C2.9749 9.43555 2.80378 9.12697 2.8716 8.82155C2.91955 8.60538 3.1162 8.45946 3.32977 8.4595C3.36521 8.4595 3.40117 8.46352 3.43695 8.47193L4.27784 8.66905C4.32524 8.68016 4.37243 8.68545 4.41876 8.68545C4.73332 8.68545 5.0077 8.44097 5.02965 8.11117C5.06522 7.57655 5.08469 6.9962 5.08546 6.36598C5.08871 3.67528 7.30684 1.44061 9.99114 1.43967ZM9.99148 0.37207H9.9911H9.99071C9.1895 0.372327 8.40899 0.533321 7.67098 0.850613C6.96256 1.15514 6.32499 1.58935 5.77599 2.14122C5.22771 2.69236 4.79623 3.33219 4.49354 4.04296C4.17881 4.78204 4.01876 5.56318 4.01777 6.3647C4.0173 6.75821 4.00915 7.14012 3.99343 7.50583L3.68058 7.43247C3.56579 7.40557 3.44776 7.3919 3.32985 7.39186C2.98937 7.39181 2.65351 7.5069 2.38413 7.7159C2.10309 7.93394 1.90601 8.24444 1.82927 8.59022C1.64663 9.41326 2.10108 10.2442 2.88863 10.5363L3.82543 10.9145C3.20511 12.8185 2.06128 13.1833 1.29103 13.4291C1.08665 13.4943 0.91011 13.5506 0.742027 13.634C0.072298 13.9665 0 14.5296 0 14.7563C0 15.1904 0.205492 15.5866 0.578683 15.8719C0.764489 16.0139 0.994664 16.1311 1.28232 16.2301C1.67439 16.3651 2.12889 16.4508 2.49828 16.5194C2.51613 16.6563 2.5423 16.8033 2.58642 16.9515C2.76958 17.5669 3.15609 17.8425 3.4481 17.9653C3.72516 18.0818 4.01145 18.0953 4.20268 18.0953C4.38973 18.0953 4.58745 18.0806 4.79678 18.0651C5.02136 18.0485 5.25359 18.0313 5.4827 18.0313C5.83774 18.0313 6.10203 18.0736 6.29066 18.1608C6.54966 18.2804 6.82433 18.4418 7.11515 18.6125C7.92473 19.088 8.84231 19.6269 10 19.6269C11.1577 19.6269 12.0753 19.088 12.8849 18.6125C13.1757 18.4417 13.4503 18.2804 13.7094 18.1608C13.898 18.0736 14.1623 18.0313 14.5173 18.0313C14.7465 18.0313 14.9787 18.0485 15.2032 18.0651C15.4126 18.0806 15.6103 18.0953 15.7973 18.0953C15.9885 18.0953 16.2748 18.0818 16.5519 17.9653C16.8439 17.8425 17.2304 17.5669 17.4136 16.9515C17.4577 16.8033 17.4839 16.6563 17.5017 16.5194C17.8711 16.4507 18.3257 16.3651 18.7177 16.2301C19.0054 16.1311 19.2355 16.0139 19.4213 15.8719C19.7945 15.5866 20 15.1904 20 14.7563C20 14.5296 19.9277 13.9665 19.2579 13.6341C19.0898 13.5507 18.9133 13.4944 18.7089 13.4292C17.9386 13.1834 16.7948 12.8185 16.1745 10.9145L17.1112 10.5364C17.8988 10.2442 18.3533 9.41326 18.1706 8.59022C18.0939 8.24444 17.8968 7.93394 17.6158 7.7159C17.3464 7.50694 17.0106 7.39186 16.6702 7.39186C16.5523 7.39186 16.4343 7.40552 16.3194 7.43243L16.0065 7.50579C15.9908 7.14012 15.9827 6.75821 15.9822 6.36465C15.9812 5.5625 15.8199 4.78059 15.5026 4.04052C15.1981 3.3301 14.7643 2.69043 14.2132 2.13925C13.6622 1.58811 13.0228 1.15437 12.313 0.8501C11.5735 0.533193 10.7925 0.372369 9.99148 0.37207Z" }) }),
        /* @__PURE__ */ S.jsx("defs", { children: /* @__PURE__ */ S.jsx("clipPath", { id: "clip0_683_607", children: /* @__PURE__ */ S.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
function WW(e) {
  return /* @__PURE__ */ S.jsx(
    "svg",
    {
      height: "512",
      viewBox: "0 0 176 176",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ S.jsx("g", { id: "Layer_2", "data-name": "Layer 2", children: /* @__PURE__ */ S.jsxs("g", { id: "_62.spotify", "data-name": "62.spotify", children: [
        /* @__PURE__ */ S.jsx("circle", { id: "background", cx: "88", cy: "88", r: "88" }),
        /* @__PURE__ */ S.jsxs("g", { id: "icon", fill: "#fff", children: [
          /* @__PURE__ */ S.jsx("path", { d: "m119.79 120.53a5.21 5.21 0 0 1 -7.12 1.87c-13.69-8-29.5-9.28-40.36-9a100.22 100.22 0 0 0 -20.93 2.76 5.21 5.21 0 0 1 -2.76-10 108.5 108.5 0 0 1 23.08-3.16 102.33 102.33 0 0 1 22.24 1.61 75.11 75.11 0 0 1 24 8.76 5.2 5.2 0 0 1 1.85 7.16z" }),
          /* @__PURE__ */ S.jsx("path", { d: "m129.47 100.42a6.16 6.16 0 0 1 -5.33 3.06 6.08 6.08 0 0 1 -3.11-.85c-16.21-9.47-34.93-11-47.8-10.6a118.31 118.31 0 0 0 -24.79 3.27 6.17 6.17 0 0 1 -3.27-11.89 127.88 127.88 0 0 1 27.34-3.7 119.43 119.43 0 0 1 26.35 1.91 88.81 88.81 0 0 1 28.4 10.38 6.17 6.17 0 0 1 2.21 8.42z" }),
          /* @__PURE__ */ S.jsx("path", { d: "m142 78.39a7.55 7.55 0 0 1 -10.35 2.71c-38.54-22.52-88.53-9.13-89-9a7.57 7.57 0 1 1 -4-14.59 157.1 157.1 0 0 1 33.45-4.51 148.15 148.15 0 0 1 32.31 2.34 109.15 109.15 0 0 1 34.84 12.66 7.57 7.57 0 0 1 2.75 10.39z" })
        ] })
      ] }) })
    }
  );
}
function YW(e) {
  return /* @__PURE__ */ S.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ S.jsx("g", { clipPath: "url(#clip0_683_665)", children: /* @__PURE__ */ S.jsx("path", { d: "M7.8475 12.6505L7.51667 17.3039C7.99 17.3039 8.195 17.1005 8.44083 16.8564L10.66 14.7355L15.2583 18.103C16.1017 18.573 16.6958 18.3255 16.9233 17.3272L19.9417 3.18385L19.9425 3.18302C20.21 1.93635 19.4917 1.44885 18.67 1.75469L0.928333 8.54719C-0.282501 9.01719 -0.264167 9.69219 0.722499 9.99802L5.25833 11.4089L15.7942 4.81635C16.29 4.48802 16.7408 4.66969 16.37 4.99802L7.8475 12.6505Z" }) }),
        /* @__PURE__ */ S.jsx("defs", { children: /* @__PURE__ */ S.jsx("clipPath", { id: "clip0_683_665", children: /* @__PURE__ */ S.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
function ZW(e) {
  return /* @__PURE__ */ S.jsx(
    "svg",
    {
      width: "18",
      height: "20",
      viewBox: "0 0 18 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ S.jsx("path", { d: "M16.3909 4.69C15.3941 4.4708 14.4923 3.9414 13.815 3.1779C13.1377 2.4144 12.7197 1.4559 12.6209 0.440001V0H9.17091V13.67C9.17161 14.2766 8.98151 14.868 8.62741 15.3604C8.27331 15.8529 7.77321 16.2215 7.19801 16.414C6.62281 16.6065 6.00161 16.6131 5.42241 16.4329C4.84321 16.2527 4.33541 15.8948 3.97091 15.41C3.64441 14.9808 3.44441 14.4689 3.39371 13.932C3.34291 13.3951 3.44341 12.8548 3.68371 12.372C3.92401 11.8892 4.29471 11.4834 4.75361 11.2003C5.21261 10.9172 5.74171 10.7681 6.28091 10.77C6.57921 10.7683 6.87591 10.8121 7.16091 10.9V7.4C6.82931 7.3589 6.49501 7.3422 6.16091 7.35C4.93021 7.3829 3.73581 7.7739 2.72401 8.4753C1.71221 9.1766 0.926813 10.1578 0.464113 11.2986C0.00141284 12.4395 -0.118588 13.6905 0.118812 14.8986C0.356312 16.1066 0.940813 17.2191 1.80091 18.1C2.68241 18.9962 3.81041 19.6101 5.04161 19.8638C6.27281 20.1175 7.55161 19.9994 8.71561 19.5246C9.87951 19.0498 10.8761 18.2397 11.5785 17.1973C12.281 16.1548 12.6578 14.9271 12.6609 13.67V6.67C14.0524 7.6639 15.7209 8.1956 17.4309 8.19V4.79C17.095 4.7914 16.7599 4.7579 16.4309 4.69H16.3909Z" })
    }
  );
}
function qW(e) {
  return /* @__PURE__ */ S.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ S.jsxs("g", { clipPath: "url(#clip0_683_603)", children: [
          /* @__PURE__ */ S.jsx("path", { d: "M0.8125 3.47917V17.3908H5.60333V20H8.21917L10.8308 17.39H14.7517L19.98 12.175V0H2.11833L0.8125 3.47917ZM3.86083 1.7375H18.2375V11.3033L15.1875 14.3467H10.395L7.78333 16.9525V14.3467H3.86083V1.7375Z" }),
          /* @__PURE__ */ S.jsx("path", { d: "M8.65417 5.21875H10.3958V10.4354H8.65417V5.21875Z" }),
          /* @__PURE__ */ S.jsx("path", { d: "M13.4442 5.21875H15.1867V10.4354H13.4442V5.21875Z" })
        ] }),
        /* @__PURE__ */ S.jsx("defs", { children: /* @__PURE__ */ S.jsx("clipPath", { id: "clip0_683_603", children: /* @__PURE__ */ S.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
function JW(e) {
  return /* @__PURE__ */ S.jsx(
    "svg",
    {
      width: "23",
      height: "20",
      viewBox: "0 0 23 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ S.jsx("path", { d: "M17.4231 0H20.8173L13.4038 8.47115L22.125 20H15.2981L9.94711 13.0096L3.83173 20H0.432692L8.36058 10.9375L0 0H7L11.8317 6.38942L17.4231 0ZM16.2308 17.9712H18.1106L5.97596 1.92308H3.95673L16.2308 17.9712Z" })
    }
  );
}
function XW(e) {
  return /* @__PURE__ */ S.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ S.jsx("g", { clipPath: "url(#clip0_683_643)", children: /* @__PURE__ */ S.jsx("path", { d: "M11.476 5.96933C13.7535 4.60186 14.9809 6.52932 13.8135 8.70802C12.6435 10.8955 11.5698 12.3217 11.0135 12.3217C10.4673 12.3217 10.0348 10.8542 9.3948 8.30678C8.73856 5.66809 8.73856 0.910692 5.99362 1.45068C3.39868 1.96317 0 6.02558 0 6.02558L0.807483 7.08931C0.807483 7.08931 2.48245 5.76809 3.03993 6.42557C3.60492 7.08931 5.74363 15.0591 6.45111 16.5329C7.0686 17.8241 8.78231 19.5278 10.6548 18.3128C12.5447 17.0903 18.7833 11.763 19.9008 5.45934C21.0158 -0.833021 12.381 0.484451 11.476 5.96933Z" }) }),
        /* @__PURE__ */ S.jsx("defs", { children: /* @__PURE__ */ S.jsx("clipPath", { id: "clip0_683_643", children: /* @__PURE__ */ S.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
function QW(e) {
  return /* @__PURE__ */ S.jsxs(
    "svg",
    {
      fill: "#00A0FF",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ S.jsx("defs", { children: /* @__PURE__ */ S.jsx("clipPath", { id: "clip1", children: /* @__PURE__ */ S.jsx("path", { d: "M 0 0 L 23.9375 0 L 23.9375 23.972656 L 0 23.972656 Z M 0 0 " }) }) }),
        /* @__PURE__ */ S.jsxs("g", { id: "surface1", children: [
          /* @__PURE__ */ S.jsx("path", { d: "M 17.453125 14.285156 L 17.445312 14.359375 C 15.253906 13.265625 15.023438 13.121094 14.738281 13.546875 C 14.542969 13.839844 13.972656 14.507812 13.796875 14.707031 C 13.625 14.898438 13.449219 14.914062 13.15625 14.78125 C 12.855469 14.628906 11.894531 14.316406 10.757812 13.296875 C 9.875 12.503906 9.28125 11.53125 9.105469 11.230469 C 8.8125 10.726562 9.421875 10.652344 9.980469 9.597656 C 10.078125 9.390625 10.027344 9.226562 9.953125 9.074219 C 9.878906 8.925781 9.285156 7.457031 9.035156 6.875 C 8.796875 6.289062 8.550781 6.363281 8.367188 6.363281 C 7.792969 6.3125 7.371094 6.320312 7 6.707031 C 5.390625 8.480469 5.796875 10.304688 7.175781 12.25 C 9.878906 15.796875 11.324219 16.449219 13.957031 17.355469 C 14.671875 17.582031 15.320312 17.550781 15.832031 17.476562 C 16.40625 17.386719 17.59375 16.753906 17.84375 16.050781 C 18.097656 15.347656 18.097656 14.765625 18.023438 14.628906 C 17.949219 14.496094 17.753906 14.417969 17.453125 14.285156 Z M 17.453125 14.285156 " }),
          /* @__PURE__ */ S.jsx("g", { clipPath: "url(#clip1)", clipRule: "nonzero", children: /* @__PURE__ */ S.jsx("path", { d: "M 20.457031 3.445312 C 12.792969 -3.976562 0.105469 1.40625 0.101562 11.875 C 0.101562 13.96875 0.648438 16.007812 1.691406 17.808594 L 0 23.960938 L 6.316406 22.3125 C 14.195312 26.578125 23.921875 20.914062 23.925781 11.878906 C 23.925781 8.710938 22.691406 5.726562 20.441406 3.484375 Z M 21.933594 11.847656 C 21.929688 19.46875 13.574219 24.226562 6.96875 20.339844 L 6.609375 20.125 L 2.871094 21.097656 L 3.875 17.457031 L 3.636719 17.085938 C -0.476562 10.53125 4.246094 1.964844 12.035156 1.964844 C 14.679688 1.964844 17.164062 2.996094 19.035156 4.867188 C 20.902344 6.722656 21.933594 9.210938 21.933594 11.847656 Z M 21.933594 11.847656 " }) })
        ] })
      ]
    }
  );
}
function eY(e) {
  return /* @__PURE__ */ S.jsx(
    "svg",
    {
      width: "21",
      height: "15",
      viewBox: "0 0 21 15",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ S.jsx("path", { d: "M19.607 2.20301C19.4931 1.78041 19.2705 1.39501 18.9614 1.08521C18.6523 0.775308 18.2674 0.551908 17.845 0.437008C16.279 0.00700787 10.014 7.59499e-06 10.014 7.59499e-06C10.014 7.59499e-06 3.74998 -0.00699213 2.18298 0.404008C1.76088 0.524208 1.37678 0.750808 1.06758 1.06211C0.758282 1.37351 0.534281 1.75911 0.416981 2.18201C0.00400126 3.74801 1.46519e-06 6.99601 1.46519e-06 6.99601C1.46519e-06 6.99601 -0.00399843 10.26 0.405982 11.81C0.635982 12.667 1.31098 13.344 2.16898 13.575C3.75098 14.005 9.99898 14.012 9.99898 14.012C9.99898 14.012 16.264 14.019 17.83 13.609C18.2525 13.4943 18.6378 13.2714 18.9477 12.9622C19.2576 12.653 19.4814 12.2682 19.597 11.846C20.011 10.281 20.014 7.03401 20.014 7.03401C20.014 7.03401 20.034 3.76901 19.607 2.20301ZM8.00998 10.005L8.01498 4.00501L13.222 7.01001L8.00998 10.005Z" })
    }
  );
}
const Lr = "w-[20px] h-[20px] shrink-0", Ea = (e, t) => {
  switch (e) {
    case sr.instagram:
      return /* @__PURE__ */ S.jsx(KW, { className: At(Lr, t) });
    case sr.pinterest:
      return /* @__PURE__ */ S.jsx($W, { className: At(Lr, t) });
    case sr.telegram:
      return /* @__PURE__ */ S.jsx(YW, { className: At(Lr, t) });
    case sr.vimeo:
      return /* @__PURE__ */ S.jsx(XW, { className: At(Lr, t) });
    case sr.twitter:
      return /* @__PURE__ */ S.jsx(JW, { className: At(Lr, t) });
    case sr.facebook:
      return /* @__PURE__ */ S.jsx(HW, { className: At(Lr, t) });
    case sr.spotify:
      return /* @__PURE__ */ S.jsx(WW, { className: At(Lr, t) });
    case sr.linkedin:
      return /* @__PURE__ */ S.jsx(UW, { className: At(Lr, t) });
    case sr.youtube:
      return /* @__PURE__ */ S.jsx(eY, { className: At(Lr, t) });
    case sr.tiktok:
      return /* @__PURE__ */ S.jsx(ZW, { className: At(Lr, t) });
    case sr.discord:
      return /* @__PURE__ */ S.jsx(FW, { className: At(Lr, t) });
    case sr.etsy:
      return /* @__PURE__ */ S.jsx(GW, { className: At(Lr, t) });
    case sr.snapchat:
      return /* @__PURE__ */ S.jsx(VW, { className: At(Lr, t) });
    case sr.website:
      return /* @__PURE__ */ S.jsx(Fb, { className: At(Lr, t) });
    case sr.twitch:
      return /* @__PURE__ */ S.jsx(qW, { className: At(Lr, t) });
    case sr.email:
      return /* @__PURE__ */ S.jsx(zW, { className: At(Lr, t) });
    case sr.whatsapp:
      return /* @__PURE__ */ S.jsx(QW, { className: At(Lr, t) });
    default:
      return /* @__PURE__ */ S.jsx(Fb, { className: At(Lr, t) });
  }
}, tY = (e) => {
  const {
    state: { theme: t }
  } = Sn();
  switch (t) {
    case mt.luminous:
      return /* @__PURE__ */ S.jsx(TW, { ...e });
    case mt.camilla:
      return /* @__PURE__ */ S.jsx(OW, { ...e });
    case mt.night:
      return /* @__PURE__ */ S.jsx(AW, { ...e });
    case mt.creamy:
      return /* @__PURE__ */ S.jsx(NW, { ...e });
    case mt.sepia:
      return /* @__PURE__ */ S.jsx(LW, { ...e });
    case mt.solarized:
      return /* @__PURE__ */ S.jsx(RW, { ...e });
    case mt.new_york:
      return /* @__PURE__ */ S.jsx(DW, { ...e });
    case mt.urban:
      return /* @__PURE__ */ S.jsx(IW, { ...e });
    case mt.cyberpunk:
      return /* @__PURE__ */ S.jsx(jW, { ...e });
    case mt.cosmopolitan:
      return /* @__PURE__ */ S.jsx(BW, { ...e });
    case mt.default:
    default:
      return /* @__PURE__ */ S.jsx(MW, { ...e });
  }
}, aae = {
  type: Fa.link,
  url: "",
  title: "Check it out!",
  subTitle: `Visit my Affiliate Link \r
and get a DISCOUNT!`,
  buttonTitle: "Click Me!",
  thumbnail: null
}, oae = {
  type: Fa.optin,
  title: "Subscribe to our newsletter",
  subTitle: `Get the latest news and updates \r
from our store!`,
  buttonTitle: "Subscribe",
  fields: [],
  thumbnail: null,
  thankYouPage: {
    title: "Thank you!",
    text: `Thank you for your subscription! \r
And have a good day!`
  }
}, iae = {
  type: Fa.product,
  productType: An.download,
  title: "Check it out!",
  subTitle: `Check it out! \r
and get a DISCOUNT!`,
  buttonTitle: "Click Me!",
  thumbnail: null,
  checkoutPage: {}
}, sae = {
  type: Fa.product,
  productType: An.eCourse,
  title: "My 12-week Program!",
  subTitle: "A 2-line course summary to close the sale. What will they learn?",
  buttonTitle: "GET MY COURSE",
  thumbnail: null,
  checkoutPage: {}
}, lae = {
  type: Fa.product,
  productType: An.physicalProduct,
  title: "My Physical Product!",
  subTitle: "My Physical Product subtitle",
  buttonTitle: "BUY NOW",
  thumbnail: null,
  checkoutPage: {}
}, kh = ({
  affiliateLink: e
}) => {
  const { t } = Gr(), n = () => /* @__PURE__ */ S.jsx(
    "div",
    {
      className: "fixed bottom-1 right-0 z-[3] h-[38px] w-[165px] bg-cover px-0 py-[3px]",
      style: { backgroundImage: `url(${Ig}/images/affiliate_badge_logo.png)` },
      children: /* @__PURE__ */ S.jsx("span", { className: "font-arial absolute left-[40px] top-0 text-[11px] text-[#ffffff]", children: t("public_pages_purchase.affiliate_badge.made_with") })
    }
  );
  return e ? /* @__PURE__ */ S.jsx("a", { href: e, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ S.jsx(n, {}) }) : /* @__PURE__ */ S.jsx(n, {});
}, cae = ({
  profile: e,
  socialLinks: t,
  items: n,
  affiliateLink: r,
  displayAffiliateLink: a
}) => /* @__PURE__ */ S.jsx(jg, { children: /* @__PURE__ */ S.jsxs("div", { className: At(J9, "relative mb-5 sm:mt-5"), children: [
  /* @__PURE__ */ S.jsx(tY, { profile: e, socialLinks: t }),
  n.map((o, i) => /* @__PURE__ */ S.jsx(rr, { children: X$(o) }, i)),
  a && /* @__PURE__ */ S.jsx(kh, { affiliateLink: r })
] }) }), uae = ({
  thankYouPage: { title: e, text: t },
  affiliateLink: n,
  displayAffiliateLink: r
}) => {
  const { isDefaultTheme: a } = Sn();
  return /* @__PURE__ */ S.jsx(vh, { children: /* @__PURE__ */ S.jsxs("div", { className: "relative flex flex-col justify-center gap-5", children: [
    /* @__PURE__ */ S.jsx(
      "h1",
      {
        className: kr(
          "self-center text-center text-4xl",
          a ? "text-text-primary" : "text-THEME-primary"
        ),
        children: e
      }
    ),
    /* @__PURE__ */ S.jsx("p", { className: "whitespace-pre-wrap text-center text-lg", children: t }),
    r && /* @__PURE__ */ S.jsx(kh, { affiliateLink: n })
  ] }) });
}, T7 = ({ children: e }) => {
  const {
    state: { tertiaryColor: t }
  } = Sn();
  return /* @__PURE__ */ S.jsx(
    "div",
    {
      className: kr(
        "bg-THEME-secondary relative w-full rounded-none border pb-5 sm:mb-5 sm:mt-5 sm:max-w-xl sm:rounded-lg sm:pb-0",
        Z9(t) ? "sm:shadow-around-sm border-transparent" : "sm:border-THEME-border-tertiary border-transparent"
      ),
      children: e
    }
  );
}, M7 = ({ paymentMethod: e }) => /* @__PURE__ */ S.jsx("div", { className: "[&>svg]:fill-THEME-primary/70", children: ON(e, { className: "w-5 h-5" }) }), rY = "pk_test_O3PjYFYA7hqkDM12lU32xgRT";
function _d(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _d = function(t) {
    return typeof t;
  } : _d = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _d(e);
}
var O7 = "https://js.stripe.com/v3", nY = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/, zb = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used", aY = function() {
  for (var t = document.querySelectorAll('script[src^="'.concat(O7, '"]')), n = 0; n < t.length; n++) {
    var r = t[n];
    if (nY.test(r.src))
      return r;
  }
  return null;
}, Gb = function(t) {
  var n = t && !t.advancedFraudSignals ? "?advancedFraudSignals=false" : "", r = document.createElement("script");
  r.src = "".concat(O7).concat(n);
  var a = document.head || document.body;
  if (!a)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return a.appendChild(r), r;
}, oY = function(t, n) {
  !t || !t._registerWrapper || t._registerWrapper({
    name: "stripe-js",
    version: "4.6.0",
    startTime: n
  });
}, zl = null, Hu = null, Ku = null, iY = function(t) {
  return function() {
    t(new Error("Failed to load Stripe.js"));
  };
}, sY = function(t, n) {
  return function() {
    window.Stripe ? t(window.Stripe) : n(new Error("Stripe.js not available"));
  };
}, lY = function(t) {
  return zl !== null ? zl : (zl = new Promise(function(n, r) {
    if (typeof window > "u" || typeof document > "u") {
      n(null);
      return;
    }
    if (window.Stripe && t && console.warn(zb), window.Stripe) {
      n(window.Stripe);
      return;
    }
    try {
      var a = aY();
      if (a && t)
        console.warn(zb);
      else if (!a)
        a = Gb(t);
      else if (a && Ku !== null && Hu !== null) {
        var o;
        a.removeEventListener("load", Ku), a.removeEventListener("error", Hu), (o = a.parentNode) === null || o === void 0 || o.removeChild(a), a = Gb(t);
      }
      Ku = sY(n, r), Hu = iY(r), a.addEventListener("load", Ku), a.addEventListener("error", Hu);
    } catch (i) {
      r(i);
      return;
    }
  }), zl.catch(function(n) {
    return zl = null, Promise.reject(n);
  }));
}, cY = function(t, n, r) {
  if (t === null)
    return null;
  var a = t.apply(void 0, n);
  return oY(a, r), a;
}, Hb = function(t) {
  var n = `invalid load parameters; expected object of shape

    {advancedFraudSignals: boolean}

but received

    `.concat(JSON.stringify(t), `
`);
  if (t === null || _d(t) !== "object")
    throw new Error(n);
  if (Object.keys(t).length === 1 && typeof t.advancedFraudSignals == "boolean")
    return t;
  throw new Error(n);
}, wd, Ef = !1, A7 = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  Ef = !0;
  var a = Date.now();
  return lY(wd).then(function(o) {
    return cY(o, n, a);
  });
};
A7.setLoadParameters = function(e) {
  if (Ef && wd) {
    var t = Hb(e), n = Object.keys(t), r = n.reduce(function(a, o) {
      var i;
      return a && e[o] === ((i = wd) === null || i === void 0 ? void 0 : i[o]);
    }, !0);
    if (r)
      return;
  }
  if (Ef)
    throw new Error("You cannot change load parameters after calling loadStripe");
  wd = Hb(e);
};
const N7 = Qe(void 0);
function uY() {
  const e = Ue(N7);
  if (!e)
    throw new Error("useStripeProvider must be used within a StripeContext.Provider");
  return e;
}
function dae({
  children: e,
  publishableKey: t,
  stripeAccountId: n,
  forceLoad: r
}) {
  const [a, o] = ke(null), { paymentMethod: i } = In(), s = we(
    () => i === ye.stripe_ideal || i === ye.stripe_card || i === ye.stripe_bancontact || r,
    [r, i]
  );
  return De(() => {
    s && n && o(
      A7(t || rY, {
        stripeAccount: n
      })
    );
  }, [t, s, n]), /* @__PURE__ */ S.jsx(
    N7.Provider,
    {
      value: {
        stripePromise: a
      },
      children: e
    }
  );
}
const un = {
  offer: [],
  customer: { fields: {} },
  page: [],
  digitalProduct: [],
  purchaseProductModel: [],
  pricePlan: [],
  thankYouPageUrl: [],
  failedReturnUrl: [],
  paymentMethod: [],
  common: []
}, ei = async (e, t) => xh.post("/api/purchase-service/buy-offer", e, {
  headers: {
    "accept-language": t
  }
});
function dY({
  isFetching: e,
  buttonTitle: t,
  setErrors: n,
  setIsFetching: r,
  preSubmit: a,
  handleBadRequest: o,
  hasErrors: i,
  buttonDisabled: s
}) {
  const { locale: l } = zt(), c = async (u) => {
    u.preventDefault();
    try {
      r(!0), n(un);
      const d = a();
      if (!d)
        throw new Error();
      const { redirect: p } = await ei(d, l);
      p && (window.location.href = p);
    } catch (d) {
      d instanceof Sa && o(d);
    } finally {
      r(!1);
    }
  };
  return /* @__PURE__ */ S.jsx(
    Jn,
    {
      disabled: s,
      className: kr("main-transition-colors", i && "bg-danger focus:bg-danger"),
      onClick: c,
      isFetching: e,
      type: "submit",
      children: t
    }
  );
}
const pY = (e, t) => ei(e, t), hY = ({ threeDsInfo: e, opened: t, onComplete: n }) => {
  const r = _e(null);
  return De(() => {
    if (!t)
      return;
    const a = (o) => {
      o.origin === "https://api.mercadopago.com" && o.data.status === "COMPLETE" && n();
    };
    return window.addEventListener("message", a), () => window.removeEventListener("message", a);
  }, [t, n]), De(() => {
    t && r.current && r.current.requestSubmit();
  }, [t]), /* @__PURE__ */ S.jsx(
    _5,
    {
      id: "three-ds-modal",
      size: b5.small,
      title: "",
      isFetching: !0,
      opened: t,
      onClose: () => {
      },
      closeIconClassName: "hidden",
      closeIconWrapperClassName: "hidden",
      contentClassName: "flex justify-center min-h-[500px]",
      children: /* @__PURE__ */ S.jsx("iframe", { name: "mercado-3ds-iframe", id: "mercado-3ds-iframe", title: "Mercado Pago 3DS iframe", children: /* @__PURE__ */ S.jsx(
        "form",
        {
          name: "mercado-3ds-form",
          target: "mercado-3ds-iframe",
          method: "post",
          action: e.external_resource_url,
          ref: r,
          children: /* @__PURE__ */ S.jsx("input", { type: "hidden", name: "creq", value: e.creq })
        }
      ) })
    }
  );
};
function mY({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: o,
  handleBadRequest: i
}) {
  const { locale: s } = zt(), [l, c] = ke(!1), [u, d] = ke(), [p, h] = ke(), m = (g) => {
    window.location.assign(g);
  }, f = async (g) => {
    g.preventDefault(), a(!0), r(un);
    try {
      const _ = o();
      if (!_)
        throw new Error("Request data is undefined");
      const v = await window.cardPaymentBrickController.getFormData(), w = await pY(
        {
          ..._,
          options: {
            token: v.token,
            mercadoPagoPaymentMethod: v.payment_method_id,
            installments: v.installments
          }
        },
        s
      );
      if (w.threeDsInfo) {
        h(w.threeDsInfo), d(w.redirect), c(!0);
        return;
      }
      m(w.redirect);
    } catch (_) {
      _ instanceof Sa && i(_);
    } finally {
      a(!1);
    }
  };
  return /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    /* @__PURE__ */ S.jsx(
      Jn,
      {
        disabled: n,
        type: "submit",
        onClick: f,
        isFetching: e,
        children: t
      }
    ),
    p && /* @__PURE__ */ S.jsx(
      hY,
      {
        opened: l,
        onComplete: () => {
          c(!1), u && m(u);
        },
        threeDsInfo: p
      }
    )
  ] });
}
async function fY(e) {
  const t = await Os.get(e, {
    maxRedirects: 0
    // Prevent axios from automatically following redirects
  });
  if (t.status === 200) {
    window.location.assign(t.data.options.paypalLink);
    return;
  }
  if (t.status >= 300 && t.status < 400) {
    const n = t.headers.location;
    if (n) {
      window.location.assign(n);
      return;
    }
  }
  throw new Error("No redirect URL found");
}
function gY({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: o,
  handleBadRequest: i,
  hasErrors: s
}) {
  const { locale: l } = zt(), c = async (u) => {
    u.preventDefault();
    try {
      a(!0), r(un);
      const d = o();
      if (!d)
        throw new Error();
      const { redirect: p } = await ei(d, l);
      await fY(p);
    } catch (d) {
      d instanceof Sa && i(d), console.error(d);
    } finally {
      a(!1);
    }
  };
  return /* @__PURE__ */ S.jsx(
    Jn,
    {
      disabled: n,
      className: kr("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: c,
      isFetching: e,
      type: "submit",
      children: t
    }
  );
}
function L7(e, t, n) {
  const r = document.createElement("script");
  r.onload = n, r.id = t, r.src = e, document.head.appendChild(r);
}
function yY(e, t) {
  return new Promise((n, r) => {
    const a = t || document, o = a.createElement("script");
    o.src = e, o.onload = (i) => n(i), o.onerror = (i) => r(i), a.head.appendChild(o);
  });
}
const vY = () => {
  const e = typeof window < "u" && !!window.paypal, [t, n] = ke(!e);
  return De(() => {
    e || L7(
      "https://www.paypalobjects.com/api/checkout.min.js",
      "paypal-js",
      () => n(!1)
    );
  }, [e]), {
    isScriptLoading: t
  };
};
function bY({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: o,
  handleBadRequest: i
}) {
  const { locale: s } = zt(), { isScriptLoading: l } = vY(), c = async (u) => {
    var d, p, h, m;
    u.preventDefault(), a(!0), r(un);
    try {
      const f = o();
      if (!f)
        throw new Error("Request data is undefined");
      (d = window.paypal) == null || d.checkout.initXO();
      const { redirect: g, approvalUrl: _ } = await ei(f, s);
      if (!_) {
        (p = window.paypal) == null || p.checkout.closeFlow(), g && window.location.assign(g);
        return;
      }
      (h = window.paypal) == null || h.checkout.startFlow(_);
    } catch (f) {
      f instanceof Sa && i(f), (m = window.paypal) == null || m.checkout.closeFlow();
    } finally {
      a(!1);
    }
  };
  return /* @__PURE__ */ S.jsx(
    Jn,
    {
      onClick: c,
      isFetching: e,
      disabled: l || n,
      type: "submit",
      children: t
    }
  );
}
const _Y = (e, t) => ei(e, t), wY = "https://checkout.razorpay.com/v1/checkout.js";
class SY {
  constructor(t) {
    this.options = t, typeof window < "u" && "Razorpay" in window && (this.razorpayInstance = new window.Razorpay(this.options));
  }
  on(t, n) {
    this.razorpayInstance.on(t, n);
  }
  open() {
    this.razorpayInstance.open();
  }
}
function CY() {
  const [e, t] = ke(!1), [n, r] = ke(!1), { currency: a, pricePlan: o, finalAmount: i } = In(), {
    state: { primaryColor: s }
  } = Sn(), l = function(c) {
    const u = {
      key: c.keyId,
      amount: i,
      currency: a == null ? void 0 : a.toUpperCase(),
      name: c.vendorName,
      description: o == null ? void 0 : o.name,
      prefill: {
        name: c.prefill.name,
        email: c.prefill.email,
        contact: c.prefill.phone
      },
      theme: {
        color: s
      },
      handler: async () => {
        window.location.assign(c.redirectUrl);
      }
    };
    if (c.rpOrderId)
      u.order_id = c.rpOrderId;
    else if (c.rpSubscriptionId)
      u.subscription_id = c.rpSubscriptionId;
    else
      throw Error("RP order id and subscription id is missing");
    return u;
  };
  return De(() => {
    const c = async () => {
      try {
        t(!0), await yY(wY, document), r(!0);
      } catch (u) {
        $t.error(u.message);
      } finally {
        t(!1);
      }
    };
    "Razorpay" in window ? r(!0) : c();
  }, []), { Razorpay: SY, generateOptions: l, isRazorpayReady: n, isRazorpayFetching: e };
}
function xY({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  handleBadRequest: o,
  preSubmit: i
}) {
  const { locale: s } = zt(), { generateOptions: l, isRazorpayReady: c, Razorpay: u, isRazorpayFetching: d } = CY(), p = async (h) => {
    h.preventDefault(), a(!0), r(un);
    try {
      const m = i();
      if (!m)
        throw new Error("Request data is undefined");
      const f = await _Y(m, s), g = l(f);
      if (c)
        new u(g).open();
      else
        throw new Error("form submitted before razorpay was ready");
    } catch (m) {
      m instanceof Sa && o(m);
    } finally {
      a(!1);
    }
  };
  return /* @__PURE__ */ S.jsx(
    Jn,
    {
      disabled: n,
      type: "submit",
      onClick: p,
      isFetching: e || d,
      children: t
    }
  );
}
var Pf = { exports: {} }, Uu = { exports: {} }, Rt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kb;
function kY() {
  if (Kb)
    return Rt;
  Kb = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function w(b) {
    if (typeof b == "object" && b !== null) {
      var C = b.$$typeof;
      switch (C) {
        case t:
          switch (b = b.type, b) {
            case l:
            case c:
            case r:
            case o:
            case a:
            case d:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case u:
                case m:
                case h:
                case i:
                  return b;
                default:
                  return C;
              }
          }
        case n:
          return C;
      }
    }
  }
  function x(b) {
    return w(b) === c;
  }
  return Rt.AsyncMode = l, Rt.ConcurrentMode = c, Rt.ContextConsumer = s, Rt.ContextProvider = i, Rt.Element = t, Rt.ForwardRef = u, Rt.Fragment = r, Rt.Lazy = m, Rt.Memo = h, Rt.Portal = n, Rt.Profiler = o, Rt.StrictMode = a, Rt.Suspense = d, Rt.isAsyncMode = function(b) {
    return x(b) || w(b) === l;
  }, Rt.isConcurrentMode = x, Rt.isContextConsumer = function(b) {
    return w(b) === s;
  }, Rt.isContextProvider = function(b) {
    return w(b) === i;
  }, Rt.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, Rt.isForwardRef = function(b) {
    return w(b) === u;
  }, Rt.isFragment = function(b) {
    return w(b) === r;
  }, Rt.isLazy = function(b) {
    return w(b) === m;
  }, Rt.isMemo = function(b) {
    return w(b) === h;
  }, Rt.isPortal = function(b) {
    return w(b) === n;
  }, Rt.isProfiler = function(b) {
    return w(b) === o;
  }, Rt.isStrictMode = function(b) {
    return w(b) === a;
  }, Rt.isSuspense = function(b) {
    return w(b) === d;
  }, Rt.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === r || b === c || b === o || b === a || b === d || b === p || typeof b == "object" && b !== null && (b.$$typeof === m || b.$$typeof === h || b.$$typeof === i || b.$$typeof === s || b.$$typeof === u || b.$$typeof === g || b.$$typeof === _ || b.$$typeof === v || b.$$typeof === f);
  }, Rt.typeOf = w, Rt;
}
var Dt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ub;
function EY() {
  return Ub || (Ub = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function w($) {
      return typeof $ == "string" || typeof $ == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      $ === r || $ === c || $ === o || $ === a || $ === d || $ === p || typeof $ == "object" && $ !== null && ($.$$typeof === m || $.$$typeof === h || $.$$typeof === i || $.$$typeof === s || $.$$typeof === u || $.$$typeof === g || $.$$typeof === _ || $.$$typeof === v || $.$$typeof === f);
    }
    function x($) {
      if (typeof $ == "object" && $ !== null) {
        var Te = $.$$typeof;
        switch (Te) {
          case t:
            var J = $.type;
            switch (J) {
              case l:
              case c:
              case r:
              case o:
              case a:
              case d:
                return J;
              default:
                var te = J && J.$$typeof;
                switch (te) {
                  case s:
                  case u:
                  case m:
                  case h:
                  case i:
                    return te;
                  default:
                    return Te;
                }
            }
          case n:
            return Te;
        }
      }
    }
    var b = l, C = c, E = s, A = i, O = t, M = u, I = r, D = m, K = h, G = n, V = o, ee = a, U = d, H = !1;
    function W($) {
      return H || (H = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), L($) || x($) === l;
    }
    function L($) {
      return x($) === c;
    }
    function T($) {
      return x($) === s;
    }
    function B($) {
      return x($) === i;
    }
    function N($) {
      return typeof $ == "object" && $ !== null && $.$$typeof === t;
    }
    function Y($) {
      return x($) === u;
    }
    function Q($) {
      return x($) === r;
    }
    function F($) {
      return x($) === m;
    }
    function re($) {
      return x($) === h;
    }
    function q($) {
      return x($) === n;
    }
    function he($) {
      return x($) === o;
    }
    function me($) {
      return x($) === a;
    }
    function Le($) {
      return x($) === d;
    }
    Dt.AsyncMode = b, Dt.ConcurrentMode = C, Dt.ContextConsumer = E, Dt.ContextProvider = A, Dt.Element = O, Dt.ForwardRef = M, Dt.Fragment = I, Dt.Lazy = D, Dt.Memo = K, Dt.Portal = G, Dt.Profiler = V, Dt.StrictMode = ee, Dt.Suspense = U, Dt.isAsyncMode = W, Dt.isConcurrentMode = L, Dt.isContextConsumer = T, Dt.isContextProvider = B, Dt.isElement = N, Dt.isForwardRef = Y, Dt.isFragment = Q, Dt.isLazy = F, Dt.isMemo = re, Dt.isPortal = q, Dt.isProfiler = he, Dt.isStrictMode = me, Dt.isSuspense = Le, Dt.isValidElementType = w, Dt.typeOf = x;
  }()), Dt;
}
var $b;
function R7() {
  return $b || ($b = 1, process.env.NODE_ENV === "production" ? Uu.exports = kY() : Uu.exports = EY()), Uu.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Fm, Vb;
function PY() {
  if (Vb)
    return Fm;
  Vb = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(i).map(function(u) {
        return i[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Fm = a() ? Object.assign : function(o, i) {
    for (var s, l = r(o), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (e) {
        c = e(s);
        for (var p = 0; p < c.length; p++)
          n.call(s, c[p]) && (l[c[p]] = s[c[p]]);
      }
    }
    return l;
  }, Fm;
}
var zm, Wb;
function Yg() {
  if (Wb)
    return zm;
  Wb = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return zm = e, zm;
}
var Gm, Yb;
function D7() {
  return Yb || (Yb = 1, Gm = Function.call.bind(Object.prototype.hasOwnProperty)), Gm;
}
var Hm, Zb;
function TY() {
  if (Zb)
    return Hm;
  Zb = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Yg(), n = {}, r = D7();
    e = function(o) {
      var i = "Warning: " + o;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function a(o, i, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in o)
        if (r(o, u)) {
          var d;
          try {
            if (typeof o[u] != "function") {
              var p = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            d = o[u](i, u, l, s, null, t);
          } catch (m) {
            d = m;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = c ? c() : "";
            e(
              "Failed " + s + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Hm = a, Hm;
}
var Km, qb;
function MY() {
  if (qb)
    return Km;
  qb = 1;
  var e = R7(), t = PY(), n = Yg(), r = D7(), a = TY(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Km = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(L) {
      var T = L && (c && L[c] || L[u]);
      if (typeof T == "function")
        return T;
    }
    var p = "<<anonymous>>", h = {
      array: _("array"),
      bigint: _("bigint"),
      bool: _("boolean"),
      func: _("function"),
      number: _("number"),
      object: _("object"),
      string: _("string"),
      symbol: _("symbol"),
      any: v(),
      arrayOf: w,
      element: x(),
      elementType: b(),
      instanceOf: C,
      node: M(),
      objectOf: A,
      oneOf: E,
      oneOfType: O,
      shape: D,
      exact: K
    };
    function m(L, T) {
      return L === T ? L !== 0 || 1 / L === 1 / T : L !== L && T !== T;
    }
    function f(L, T) {
      this.message = L, this.data = T && typeof T == "object" ? T : {}, this.stack = "";
    }
    f.prototype = Error.prototype;
    function g(L) {
      if (process.env.NODE_ENV !== "production")
        var T = {}, B = 0;
      function N(Q, F, re, q, he, me, Le) {
        if (q = q || p, me = me || re, Le !== n) {
          if (l) {
            var $ = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw $.name = "Invariant Violation", $;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Te = q + ":" + re;
            !T[Te] && // Avoid spamming the console because they are often not actionable except for lib authors
            B < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + me + "` prop on `" + q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), T[Te] = !0, B++);
          }
        }
        return F[re] == null ? Q ? F[re] === null ? new f("The " + he + " `" + me + "` is marked as required " + ("in `" + q + "`, but its value is `null`.")) : new f("The " + he + " `" + me + "` is marked as required in " + ("`" + q + "`, but its value is `undefined`.")) : null : L(F, re, q, he, me);
      }
      var Y = N.bind(null, !1);
      return Y.isRequired = N.bind(null, !0), Y;
    }
    function _(L) {
      function T(B, N, Y, Q, F, re) {
        var q = B[N], he = ee(q);
        if (he !== L) {
          var me = U(q);
          return new f(
            "Invalid " + Q + " `" + F + "` of type " + ("`" + me + "` supplied to `" + Y + "`, expected ") + ("`" + L + "`."),
            { expectedType: L }
          );
        }
        return null;
      }
      return g(T);
    }
    function v() {
      return g(i);
    }
    function w(L) {
      function T(B, N, Y, Q, F) {
        if (typeof L != "function")
          return new f("Property `" + F + "` of component `" + Y + "` has invalid PropType notation inside arrayOf.");
        var re = B[N];
        if (!Array.isArray(re)) {
          var q = ee(re);
          return new f("Invalid " + Q + " `" + F + "` of type " + ("`" + q + "` supplied to `" + Y + "`, expected an array."));
        }
        for (var he = 0; he < re.length; he++) {
          var me = L(re, he, Y, Q, F + "[" + he + "]", n);
          if (me instanceof Error)
            return me;
        }
        return null;
      }
      return g(T);
    }
    function x() {
      function L(T, B, N, Y, Q) {
        var F = T[B];
        if (!s(F)) {
          var re = ee(F);
          return new f("Invalid " + Y + " `" + Q + "` of type " + ("`" + re + "` supplied to `" + N + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(L);
    }
    function b() {
      function L(T, B, N, Y, Q) {
        var F = T[B];
        if (!e.isValidElementType(F)) {
          var re = ee(F);
          return new f("Invalid " + Y + " `" + Q + "` of type " + ("`" + re + "` supplied to `" + N + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(L);
    }
    function C(L) {
      function T(B, N, Y, Q, F) {
        if (!(B[N] instanceof L)) {
          var re = L.name || p, q = W(B[N]);
          return new f("Invalid " + Q + " `" + F + "` of type " + ("`" + q + "` supplied to `" + Y + "`, expected ") + ("instance of `" + re + "`."));
        }
        return null;
      }
      return g(T);
    }
    function E(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), i;
      function T(B, N, Y, Q, F) {
        for (var re = B[N], q = 0; q < L.length; q++)
          if (m(re, L[q]))
            return null;
        var he = JSON.stringify(L, function(Le, $) {
          var Te = U($);
          return Te === "symbol" ? String($) : $;
        });
        return new f("Invalid " + Q + " `" + F + "` of value `" + String(re) + "` " + ("supplied to `" + Y + "`, expected one of " + he + "."));
      }
      return g(T);
    }
    function A(L) {
      function T(B, N, Y, Q, F) {
        if (typeof L != "function")
          return new f("Property `" + F + "` of component `" + Y + "` has invalid PropType notation inside objectOf.");
        var re = B[N], q = ee(re);
        if (q !== "object")
          return new f("Invalid " + Q + " `" + F + "` of type " + ("`" + q + "` supplied to `" + Y + "`, expected an object."));
        for (var he in re)
          if (r(re, he)) {
            var me = L(re, he, Y, Q, F + "." + he, n);
            if (me instanceof Error)
              return me;
          }
        return null;
      }
      return g(T);
    }
    function O(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var T = 0; T < L.length; T++) {
        var B = L[T];
        if (typeof B != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + H(B) + " at index " + T + "."
          ), i;
      }
      function N(Y, Q, F, re, q) {
        for (var he = [], me = 0; me < L.length; me++) {
          var Le = L[me], $ = Le(Y, Q, F, re, q, n);
          if ($ == null)
            return null;
          $.data && r($.data, "expectedType") && he.push($.data.expectedType);
        }
        var Te = he.length > 0 ? ", expected one of type [" + he.join(", ") + "]" : "";
        return new f("Invalid " + re + " `" + q + "` supplied to " + ("`" + F + "`" + Te + "."));
      }
      return g(N);
    }
    function M() {
      function L(T, B, N, Y, Q) {
        return G(T[B]) ? null : new f("Invalid " + Y + " `" + Q + "` supplied to " + ("`" + N + "`, expected a ReactNode."));
      }
      return g(L);
    }
    function I(L, T, B, N, Y) {
      return new f(
        (L || "React class") + ": " + T + " type `" + B + "." + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Y + "`."
      );
    }
    function D(L) {
      function T(B, N, Y, Q, F) {
        var re = B[N], q = ee(re);
        if (q !== "object")
          return new f("Invalid " + Q + " `" + F + "` of type `" + q + "` " + ("supplied to `" + Y + "`, expected `object`."));
        for (var he in L) {
          var me = L[he];
          if (typeof me != "function")
            return I(Y, Q, F, he, U(me));
          var Le = me(re, he, Y, Q, F + "." + he, n);
          if (Le)
            return Le;
        }
        return null;
      }
      return g(T);
    }
    function K(L) {
      function T(B, N, Y, Q, F) {
        var re = B[N], q = ee(re);
        if (q !== "object")
          return new f("Invalid " + Q + " `" + F + "` of type `" + q + "` " + ("supplied to `" + Y + "`, expected `object`."));
        var he = t({}, B[N], L);
        for (var me in he) {
          var Le = L[me];
          if (r(L, me) && typeof Le != "function")
            return I(Y, Q, F, me, U(Le));
          if (!Le)
            return new f(
              "Invalid " + Q + " `" + F + "` key `" + me + "` supplied to `" + Y + "`.\nBad object: " + JSON.stringify(B[N], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(L), null, "  ")
            );
          var $ = Le(re, me, Y, Q, F + "." + me, n);
          if ($)
            return $;
        }
        return null;
      }
      return g(T);
    }
    function G(L) {
      switch (typeof L) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !L;
        case "object":
          if (Array.isArray(L))
            return L.every(G);
          if (L === null || s(L))
            return !0;
          var T = d(L);
          if (T) {
            var B = T.call(L), N;
            if (T !== L.entries) {
              for (; !(N = B.next()).done; )
                if (!G(N.value))
                  return !1;
            } else
              for (; !(N = B.next()).done; ) {
                var Y = N.value;
                if (Y && !G(Y[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function V(L, T) {
      return L === "symbol" ? !0 : T ? T["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && T instanceof Symbol : !1;
    }
    function ee(L) {
      var T = typeof L;
      return Array.isArray(L) ? "array" : L instanceof RegExp ? "object" : V(T, L) ? "symbol" : T;
    }
    function U(L) {
      if (typeof L > "u" || L === null)
        return "" + L;
      var T = ee(L);
      if (T === "object") {
        if (L instanceof Date)
          return "date";
        if (L instanceof RegExp)
          return "regexp";
      }
      return T;
    }
    function H(L) {
      var T = U(L);
      switch (T) {
        case "array":
        case "object":
          return "an " + T;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + T;
        default:
          return T;
      }
    }
    function W(L) {
      return !L.constructor || !L.constructor.name ? p : L.constructor.name;
    }
    return h.checkPropTypes = a, h.resetWarningCache = a.resetWarningCache, h.PropTypes = h, h;
  }, Km;
}
var Um, Jb;
function OY() {
  if (Jb)
    return Um;
  Jb = 1;
  var e = Yg();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Um = function() {
    function r(i, s, l, c, u, d) {
      if (d !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Um;
}
if (process.env.NODE_ENV !== "production") {
  var AY = R7(), NY = !0;
  Pf.exports = MY()(AY.isElement, NY);
} else
  Pf.exports = OY()();
var LY = Pf.exports;
const lr = /* @__PURE__ */ qc(LY);
function Xb(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Qb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xb(Object(n), !0).forEach(function(r) {
      I7(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xb(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Sd(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Sd = function(t) {
    return typeof t;
  } : Sd = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Sd(e);
}
function I7(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function j7(e, t) {
  return RY(e) || DY(e, t) || IY(e, t) || jY();
}
function RY(e) {
  if (Array.isArray(e))
    return e;
}
function DY(e, t) {
  var n = e && (typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"]);
  if (n != null) {
    var r = [], a = !0, o = !1, i, s;
    try {
      for (n = n.call(e); !(a = (i = n.next()).done) && (r.push(i.value), !(t && r.length === t)); a = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (o)
          throw s;
      }
    }
    return r;
  }
}
function IY(e, t) {
  if (e) {
    if (typeof e == "string")
      return e3(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return e3(e, t);
  }
}
function e3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function jY() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var xn = function(t, n, r) {
  var a = !!r, o = k.useRef(r);
  k.useEffect(function() {
    o.current = r;
  }, [r]), k.useEffect(function() {
    if (!a || !t)
      return function() {
      };
    var i = function() {
      o.current && o.current.apply(o, arguments);
    };
    return t.on(n, i), function() {
      t.off(n, i);
    };
  }, [a, n, t, o]);
}, Tf = function(t) {
  var n = k.useRef(t);
  return k.useEffect(function() {
    n.current = t;
  }, [t]), n.current;
}, Zs = function(t) {
  return t !== null && Sd(t) === "object";
}, BY = function(t) {
  return Zs(t) && typeof t.then == "function";
}, FY = function(t) {
  return Zs(t) && typeof t.elements == "function" && typeof t.createToken == "function" && typeof t.createPaymentMethod == "function" && typeof t.confirmCardPayment == "function";
}, t3 = "[object Object]", zY = function e(t, n) {
  if (!Zs(t) || !Zs(n))
    return t === n;
  var r = Array.isArray(t), a = Array.isArray(n);
  if (r !== a)
    return !1;
  var o = Object.prototype.toString.call(t) === t3, i = Object.prototype.toString.call(n) === t3;
  if (o !== i)
    return !1;
  if (!o && !r)
    return t === n;
  var s = Object.keys(t), l = Object.keys(n);
  if (s.length !== l.length)
    return !1;
  for (var c = {}, u = 0; u < s.length; u += 1)
    c[s[u]] = !0;
  for (var d = 0; d < l.length; d += 1)
    c[l[d]] = !0;
  var p = Object.keys(c);
  if (p.length !== s.length)
    return !1;
  var h = t, m = n, f = function(_) {
    return e(h[_], m[_]);
  };
  return p.every(f);
}, B7 = function(t, n, r) {
  return Zs(t) ? Object.keys(t).reduce(function(a, o) {
    var i = !Zs(n) || !zY(t[o], n[o]);
    return r.includes(o) ? (i && console.warn("Unsupported prop change: options.".concat(o, " is not a mutable property.")), a) : i ? Qb(Qb({}, a || {}), {}, I7({}, o, t[o])) : a;
  }, null) : null;
}, F7 = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.", r3 = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : F7;
  if (t === null || FY(t))
    return t;
  throw new Error(n);
}, GY = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : F7;
  if (BY(t))
    return {
      tag: "async",
      stripePromise: Promise.resolve(t).then(function(a) {
        return r3(a, n);
      })
    };
  var r = r3(t, n);
  return r === null ? {
    tag: "empty"
  } : {
    tag: "sync",
    stripe: r
  };
}, HY = function(t) {
  !t || !t._registerWrapper || !t.registerAppInfo || (t._registerWrapper({
    name: "react-stripe-js",
    version: "2.8.1"
  }), t.registerAppInfo({
    name: "react-stripe-js",
    version: "2.8.1",
    url: "https://stripe.com/docs/stripe-js/react"
  }));
}, Eh = /* @__PURE__ */ k.createContext(null);
Eh.displayName = "ElementsContext";
var z7 = function(t, n) {
  if (!t)
    throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(n, " in an <Elements> provider."));
  return t;
}, G7 = function(t) {
  var n = t.stripe, r = t.options, a = t.children, o = k.useMemo(function() {
    return GY(n);
  }, [n]), i = k.useState(function() {
    return {
      stripe: o.tag === "sync" ? o.stripe : null,
      elements: o.tag === "sync" ? o.stripe.elements(r) : null
    };
  }), s = j7(i, 2), l = s[0], c = s[1];
  k.useEffect(function() {
    var p = !0, h = function(f) {
      c(function(g) {
        return g.stripe ? g : {
          stripe: f,
          elements: f.elements(r)
        };
      });
    };
    return o.tag === "async" && !l.stripe ? o.stripePromise.then(function(m) {
      m && p && h(m);
    }) : o.tag === "sync" && !l.stripe && h(o.stripe), function() {
      p = !1;
    };
  }, [o, l, r]);
  var u = Tf(n);
  k.useEffect(function() {
    u !== null && u !== n && console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
  }, [u, n]);
  var d = Tf(r);
  return k.useEffect(function() {
    if (l.elements) {
      var p = B7(r, d, ["clientSecret", "fonts"]);
      p && l.elements.update(p);
    }
  }, [r, d, l.elements]), k.useEffect(function() {
    HY(l.stripe);
  }, [l.stripe]), /* @__PURE__ */ k.createElement(Eh.Provider, {
    value: l
  }, a);
};
G7.propTypes = {
  stripe: lr.any,
  options: lr.object
};
var KY = function(t) {
  var n = k.useContext(Eh);
  return z7(n, t);
}, Ph = function() {
  var t = KY("calls useElements()"), n = t.elements;
  return n;
};
lr.func.isRequired;
var H7 = /* @__PURE__ */ k.createContext(null);
H7.displayName = "CustomCheckoutSdkContext";
var UY = function(t, n) {
  if (!t)
    throw new Error("Could not find CustomCheckoutProvider context; You need to wrap the part of your app that ".concat(n, " in an <CustomCheckoutProvider> provider."));
  return t;
}, $Y = /* @__PURE__ */ k.createContext(null);
$Y.displayName = "CustomCheckoutContext";
lr.any, lr.shape({
  clientSecret: lr.string.isRequired,
  elementsOptions: lr.object
}).isRequired;
var Mf = function(t) {
  var n = k.useContext(H7), r = k.useContext(Eh);
  if (n && r)
    throw new Error("You cannot wrap the part of your app that ".concat(t, " in both <CustomCheckoutProvider> and <Elements> providers."));
  return n ? UY(n, t) : z7(r, t);
}, VY = function(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}, Pr = function(t, n) {
  var r = "".concat(VY(t), "Element"), a = function(l) {
    var c = l.id, u = l.className, d = l.options, p = d === void 0 ? {} : d, h = l.onBlur, m = l.onFocus, f = l.onReady, g = l.onChange, _ = l.onEscape, v = l.onClick, w = l.onLoadError, x = l.onLoaderStart, b = l.onNetworksChange, C = l.onConfirm, E = l.onCancel, A = l.onShippingAddressChange, O = l.onShippingRateChange, M = Mf("mounts <".concat(r, ">")), I = "elements" in M ? M.elements : null, D = "customCheckoutSdk" in M ? M.customCheckoutSdk : null, K = k.useState(null), G = j7(K, 2), V = G[0], ee = G[1], U = k.useRef(null), H = k.useRef(null);
    xn(V, "blur", h), xn(V, "focus", m), xn(V, "escape", _), xn(V, "click", v), xn(V, "loaderror", w), xn(V, "loaderstart", x), xn(V, "networkschange", b), xn(V, "confirm", C), xn(V, "cancel", E), xn(V, "shippingaddresschange", A), xn(V, "shippingratechange", O), xn(V, "change", g);
    var W;
    f && (t === "expressCheckout" ? W = f : W = function() {
      f(V);
    }), xn(V, "ready", W), k.useLayoutEffect(function() {
      if (U.current === null && H.current !== null && (I || D)) {
        var T = null;
        D ? T = D.createElement(t, p) : I && (T = I.create(t, p)), U.current = T, ee(T), T && T.mount(H.current);
      }
    }, [I, D, p]);
    var L = Tf(p);
    return k.useEffect(function() {
      if (U.current) {
        var T = B7(p, L, ["paymentRequest"]);
        T && "update" in U.current && U.current.update(T);
      }
    }, [p, L]), k.useLayoutEffect(function() {
      return function() {
        if (U.current && typeof U.current.destroy == "function")
          try {
            U.current.destroy(), U.current = null;
          } catch {
          }
      };
    }, []), /* @__PURE__ */ k.createElement("div", {
      id: c,
      className: u,
      ref: H
    });
  }, o = function(l) {
    Mf("mounts <".concat(r, ">"));
    var c = l.id, u = l.className;
    return /* @__PURE__ */ k.createElement("div", {
      id: c,
      className: u
    });
  }, i = n ? o : a;
  return i.propTypes = {
    id: lr.string,
    className: lr.string,
    onChange: lr.func,
    onBlur: lr.func,
    onFocus: lr.func,
    onReady: lr.func,
    onEscape: lr.func,
    onClick: lr.func,
    onLoadError: lr.func,
    onLoaderStart: lr.func,
    onNetworksChange: lr.func,
    onConfirm: lr.func,
    onCancel: lr.func,
    onShippingAddressChange: lr.func,
    onShippingRateChange: lr.func,
    options: lr.object
  }, i.displayName = r, i.__elementType = t, i;
}, Tr = typeof window > "u", WY = /* @__PURE__ */ k.createContext(null);
WY.displayName = "EmbeddedCheckoutProviderContext";
var ml = function() {
  var t = Mf("calls useStripe()"), n = t.stripe;
  return n;
};
Pr("auBankAccount", Tr);
Pr("card", Tr);
Pr("cardNumber", Tr);
Pr("cardExpiry", Tr);
Pr("cardCvc", Tr);
Pr("fpxBank", Tr);
Pr("iban", Tr);
Pr("idealBank", Tr);
Pr("p24Bank", Tr);
Pr("epsBank", Tr);
var K7 = Pr("payment", Tr), YY = Pr("expressCheckout", Tr);
Pr("currencySelector", Tr);
Pr("paymentRequestButton", Tr);
Pr("linkAuthentication", Tr);
Pr("address", Tr);
Pr("shippingAddress", Tr);
Pr("paymentMethodMessaging", Tr);
Pr("affirmMessage", Tr);
Pr("afterpayClearpayMessage", Tr);
const U7 = (e, t) => ei(e, t), $7 = (e, t) => ei(e, t), Th = () => xh.get("api/payment/confirm");
var Mh = /* @__PURE__ */ ((e) => (e.payment = "payment", e.setup = "setup", e))(Mh || {});
const ZY = (e, t) => t === Mh.setup ? e.confirmBancontactSetup : e.confirmBancontactPayment;
function qY({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: o,
  handleBadRequest: i,
  hasErrors: s
}) {
  const { locale: l } = zt(), c = ml(), u = Ph(), d = async (p) => {
    if (p.preventDefault(), !(!c || !u))
      try {
        a(!0), r(un);
        const h = o();
        if (!h)
          throw new Error("Request data is undefined");
        const { redirect: m, intentSecret: f, intentType: g } = await $7(h, l);
        if (!f)
          return window.location.href = m;
        const _ = ZY(c, g), { error: v } = await _(f, {
          payment_method: {
            billing_details: {
              name: h.customer.fields.first_name,
              email: h.customer.fields.email
            }
          },
          return_url: m
        });
        v ? r((w) => ({ ...w, common: [...w.common, v.message] })) : (await Th(), window.location.assign(m));
      } catch (h) {
        h instanceof Sa && i(h);
      } finally {
        a(!1);
      }
  };
  return /* @__PURE__ */ S.jsx(
    Jn,
    {
      disabled: n,
      className: kr("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: d,
      isFetching: e,
      type: "submit",
      children: t
    }
  );
}
const V7 = (e, t) => t === Mh.setup ? e.confirmCardSetup : e.confirmCardPayment;
function JY({
  setIsFetching: e,
  handleBadRequest: t,
  setErrors: n,
  preSubmit: r
}) {
  const a = ml(), o = Ph(), { locale: i } = zt(), s = async (l) => {
    if (!(!a || !o))
      try {
        const c = r();
        if (!c)
          throw new Error("Request data is undefined");
        const { error: u } = await o.submit();
        if (u) {
          l.paymentFailed();
          return;
        }
        const { error: d, paymentMethod: p } = await a.createPaymentMethod({
          elements: o
        });
        if (d || !p) {
          l.paymentFailed();
          return;
        }
        const { redirect: h, intentSecret: m, intentType: f } = await U7(
          {
            ...c,
            paymentMethod: ye.stripe_applepay,
            options: { stripePaymentMethodId: p.id }
          },
          i
        );
        if (!m)
          return window.location.href = h;
        const g = V7(a, f), { error: _ } = await g(m, {
          payment_method: p.id
        });
        _ ? n((v) => ({
          ...v,
          common: [...v.common, _.message]
        })) : (await Th(), window.location.assign(h));
      } catch (c) {
        l.paymentFailed({ reason: "fail" }), c instanceof Sa && t(c);
      } finally {
        e(!1);
      }
  };
  return /* @__PURE__ */ S.jsx(
    YY,
    {
      options: {
        paymentMethods: {
          applePay: "always",
          googlePay: "never",
          amazonPay: "never",
          link: "never",
          paypal: "never"
        }
      },
      onConfirm: s
    }
  );
}
function XY(e) {
  const t = ml(), { availablePaymentMethods: n } = In();
  if (!t)
    return null;
  const r = n.includes(ye.stripe_applepay);
  return /* @__PURE__ */ S.jsxs("div", { children: [
    r && /* @__PURE__ */ S.jsx(JY, { ...e }),
    /* @__PURE__ */ S.jsx(
      K7,
      {
        options: {
          fields: {
            billingDetails: {
              address: "never"
            }
          }
        }
      }
    )
  ] });
}
function QY({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: o,
  handleBadRequest: i,
  hasErrors: s
}) {
  const { locale: l } = zt(), c = ml(), u = Ph(), d = async (p) => {
    if (p.preventDefault(), !(!c || !u))
      try {
        const { error: h } = await u.submit();
        if (h)
          throw new Error("Stripe elements validation failed");
        const m = o();
        if (!m)
          throw new Error("Request data is undefined");
        a(!0), r(un);
        const { paymentMethod: f, error: g } = await c.createPaymentMethod({
          elements: u,
          params: {
            billing_details: {
              address: {
                country: null,
                line1: null,
                line2: null,
                city: null,
                state: null,
                postal_code: null
              }
            }
          }
        });
        if (g) {
          r((C) => ({
            ...C,
            common: [...C.common, g.message]
          }));
          return;
        }
        if (!f)
          throw Error("undefined payment method");
        const { redirect: _, intentSecret: v, intentType: w } = await U7(
          { ...m, options: { stripePaymentMethodId: f.id } },
          l
        );
        if (!v)
          return window.location.href = _;
        const x = V7(c, w), { error: b } = await x(v, {
          payment_method: f.id
        });
        b ? r((C) => ({ ...C, common: [...C.common, b.message] })) : (await Th(), window.location.assign(_));
      } catch (h) {
        h instanceof Sa && i(h);
      } finally {
        a(!1);
      }
  };
  return /* @__PURE__ */ S.jsx(
    Jn,
    {
      disabled: n,
      className: kr("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: d,
      isFetching: e,
      type: "submit",
      children: t
    }
  );
}
function eZ({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: o,
  handleBadRequest: i,
  hasErrors: s
}) {
  const { locale: l } = zt(), c = ml(), u = Ph(), d = async (p) => {
    if (p.preventDefault(), !(!c || !u))
      try {
        a(!0), r(un);
        const { error: h } = await u.submit();
        if (h)
          throw new Error("Stripe elements validation failed");
        const m = o();
        if (!m)
          throw new Error("Request data is undefined");
        const { redirect: f, intentSecret: g, intentType: _ } = await $7(m, l);
        if (!g)
          return window.location.href = f;
        const v = _ === Mh.setup ? c.confirmSetup : c.confirmPayment, { error: w } = await v({
          elements: u,
          clientSecret: g,
          confirmParams: {
            payment_method_data: {
              billing_details: {
                name: [m.customer.fields.first_name, m.customer.fields.last_name].filter(Boolean).join(" "),
                email: m.customer.fields.email
              }
            },
            return_url: f
          }
        });
        w ? r((x) => ({ ...x, common: [...x.common, w.message] })) : (await Th(), window.location.assign(f));
      } catch (h) {
        h instanceof Sa && i(h);
      } finally {
        a(!1);
      }
  };
  return /* @__PURE__ */ S.jsx(
    Jn,
    {
      disabled: n,
      className: kr("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: d,
      isFetching: e,
      type: "submit",
      children: t
    }
  );
}
function tZ() {
  return ml() ? /* @__PURE__ */ S.jsx("div", { children: /* @__PURE__ */ S.jsx(
    K7,
    {
      options: {
        fields: {
          billingDetails: {
            name: "never",
            email: "never"
          }
        }
      }
    }
  ) }) : null;
}
const rZ = (e) => {
  const [t, n] = e.split(" ");
  return { firstName: t, lastName: n };
}, nZ = (e, t) => ei(e, t), aZ = () => {
  const { t: e } = Gr(), t = typeof window < "u" && !!window.Xendit, [n, r] = ke(!t), { xenditPublicKey: a } = yH();
  return De(() => {
    t || L7("https://js.xendit.co/v1/xendit.min.js", "xendit-js", () => {
      window.Xendit && a ? window.Xendit.setPublishableKey(a) : $t.error(e("public_pages_purchase.error")), r(!1);
    });
  }, [t]), {
    isScriptLoading: n
  };
}, Gl = "xendit-3ds-frame", oZ = (e) => {
  const [t, n] = ke(!1), [r, a] = ke(!1), { t: o } = Gr();
  return { threeDsModal: /* @__PURE__ */ S.jsxs(
    _5,
    {
      opened: t,
      onClose: () => {
        n(!1), e();
      },
      title: o("public_pages_purchase.payment.xendit.3ds"),
      children: [
        r && /* @__PURE__ */ S.jsx(Bd, { className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }),
        /* @__PURE__ */ S.jsx(
          "iframe",
          {
            className: At("h-[650px] w-full", r && "invisible"),
            id: Gl,
            title: Gl,
            name: Gl
          }
        )
      ]
    }
  ), openLinkInIframe: (c) => {
    n(!0);
    const u = 10;
    let d = 0;
    a(!0);
    const p = setInterval(() => {
      d++, document.getElementById(Gl) ? (clearInterval(p), a(!1), window.open(c, Gl)) : d >= u && (clearInterval(p), $t.error(o("public_pages_purchase.error")), n(!1), a(!1), e());
    }, 500);
  }, closeThreeDsModal: () => {
    n(!1);
  } };
};
var _s = /* @__PURE__ */ ((e) => (e.verified = "VERIFIED", e.in_review = "IN_REVIEW", e.failed = "FAILED", e.approved = "APPROVED", e.card_enrolled = "CARD_ENROLLED", e.fraud = "FRAUD", e))(_s || {});
function iZ({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: o,
  handleBadRequest: i,
  hasErrors: s
}) {
  const { t: l } = Gr(), { locale: c } = zt(), { currency: u, finalAmount: d } = In(), { cardNumber: p, cardHolderName: h, cvc: m, expiryMonth: f, expiryYear: g, formInvalid: _ } = J8(), { isScriptLoading: v } = aZ(), { openLinkInIframe: w, threeDsModal: x, closeThreeDsModal: b } = oZ(
    () => a(!1)
  ), C = async (O, M) => {
    if (O) {
      $t.error(O.message), a(!1);
      return;
    } else if (M.status === _s.in_review)
      w(M.payer_authentication_url);
    else if (M.status === _s.verified) {
      setTimeout(() => {
        b();
      }, 1e3);
      try {
        const I = o();
        if (!I)
          throw new Error("Request data is undefined");
        const { redirect: D } = await nZ(
          {
            ...I,
            options: { token: M.credit_card_token_id }
          },
          c
        );
        if (D) {
          window.location.assign(D);
          return;
        } else
          $t.error(l("public_pages_purchase.error"));
      } catch (I) {
        I instanceof Sa && i(I);
      } finally {
        a(!1);
      }
    }
  }, E = async (O, M) => {
    if (O) {
      $t.error(O.message), a(!1);
      return;
    }
    if (!window.Xendit || !d) {
      $t.error(l("public_pages_purchase.error")), a(!1);
      return;
    }
    M.status === _s.verified ? window.Xendit.card.createAuthentication(
      {
        amount: d,
        token_id: M.id
      },
      C
    ) : M.status === _s.in_review ? w(M.payer_authentication_url) : M.status === _s.failed && ($t.error(l("public_pages_purchase.error")), a(!1));
  }, A = async (O) => {
    O.preventDefault();
    try {
      const M = o();
      if (!M || !d || !u)
        throw new Error("Request data is undefined");
      if (a(!0), r(un), window.Xendit) {
        const I = `20${g}`, { firstName: D, lastName: K } = rZ(h), G = M.customer.fields[Kt.Email] ?? "", V = M.customer.fields[Kt.PhoneNumber] ?? "", ee = V ? `+${V}` : "";
        window.Xendit.card.createToken(
          {
            amount: d,
            card_number: p,
            card_exp_month: f,
            card_exp_year: I,
            card_cvn: m,
            card_holder_first_name: D,
            card_holder_last_name: K,
            card_holder_email: G,
            card_holder_phone_number: ee,
            is_multiple_use: !0,
            should_authenticate: !0,
            currency: u
          },
          E
        );
      }
    } catch {
      a(!1);
    }
  };
  return /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    x,
    /* @__PURE__ */ S.jsx(
      Jn,
      {
        className: kr(
          "main-transition-colors",
          (s || _) && "bg-danger focus:bg-danger"
        ),
        onClick: A,
        isFetching: e,
        disabled: v || _ || n,
        type: "submit",
        children: t
      }
    )
  ] });
}
const sZ = (e, t) => {
  switch (e) {
    case ye.stripe_card:
      return /* @__PURE__ */ S.jsx(QY, { ...t });
    case ye.stripe_ideal:
      return /* @__PURE__ */ S.jsx(eZ, { ...t });
    case ye.stripe_bancontact:
      return /* @__PURE__ */ S.jsx(qY, { ...t });
    case ye.paypal_rest:
      return /* @__PURE__ */ S.jsx(gY, { ...t });
    case ye.paypal_soap:
      return /* @__PURE__ */ S.jsx(bY, { ...t });
    case ye.mercadopago_ar_card:
    case ye.mercadopago_br_card:
    case ye.mercadopago_cl_card:
    case ye.mercadopago_co_card:
    case ye.mercadopago_mx_card:
      return /* @__PURE__ */ S.jsx(mY, { ...t });
    case ye.razorpay:
      return /* @__PURE__ */ S.jsx(xY, { ...t });
    case ye.xendit_id_card:
    case ye.xendit_ph_card:
      return /* @__PURE__ */ S.jsx(iZ, { ...t });
    default:
      return /* @__PURE__ */ S.jsx(dY, { ...t });
  }
};
var Zg = {};
Object.defineProperty(Zg, "__esModule", { value: !0 });
var W7 = Zg.loadMercadoPago = void 0;
const Y7 = "https://sdk.mercadopago.com/js/v2", lZ = /^https:\/\/sdk\.mercadopago\.com\/js\/v2\/?(\?.*)?$/, n3 = "MercadoPago has already been initialized in your window, please remove the duplicate import", cZ = "MercadoPago.js not available", uZ = "Failed to load MercadoPago.js", dZ = () => {
  for (var e = document.querySelectorAll(`script[src^="${Y7}"`), t = 0; t < e.length; t++) {
    var n = e[t];
    if (lZ.test(n.src))
      return n;
  }
  return null;
}, pZ = () => {
  const e = document.createElement("script");
  e.src = Y7;
  const t = document.head || document.body;
  if (!t)
    throw new Error("Expected document.body or document.head not to be null. MercadoPago requires a <body> or a <head> element, please add on your project.");
  return t.appendChild(e), e;
};
let $u = null;
const hZ = () => ($u !== null || ($u = new Promise((e, t) => {
  if (typeof window > "u") {
    e(null);
    return;
  }
  if (window.MercadoPago) {
    console.warn(n3), e(window.MercadoPago);
    return;
  }
  try {
    let n = dZ();
    n ? console.warn(n3) : n || (n = pZ()), n.addEventListener("load", () => {
      window.MercadoPago ? e(window.MercadoPago) : t(new Error(cZ));
    }), n.addEventListener("error", () => {
      t(new Error(uZ));
    });
  } catch (n) {
    t(n);
    return;
  }
})), $u);
W7 = Zg.loadMercadoPago = hZ;
var mZ = function(e, t, n, r) {
  function a(o) {
    return o instanceof n ? o : new n(function(i) {
      i(o);
    });
  }
  return new (n || (n = Promise))(function(o, i) {
    function s(u) {
      try {
        c(r.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(r.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((r = r.apply(e, t || [])).next());
  });
};
class Da {
  static getInstance() {
    return mZ(this, void 0, void 0, function* () {
      if (this.publicKey)
        return this.loadedInstanceMercadoPago || (yield W7(), this.loadedInstanceMercadoPago = !0), this.instanceMercadoPago || (this.instanceMercadoPago = new window.MercadoPago(this.publicKey, this.options)), this.instanceMercadoPago;
      console.error("Expected the PUBLIC_KEY to render the MercadoPago SDK React");
    });
  }
}
Da.publicKey = null;
Da.options = {};
Da.instanceMercadoPago = void 0;
Da.loadedInstanceMercadoPago = !1;
function fZ(e, t) {
  return Object.keys(e).length === Object.keys(t).length && Object.keys(e).every((r) => Object.prototype.hasOwnProperty.call(t, r) && e[r] === t[r]);
}
const gZ = (e, t) => {
  const n = Object.assign(Object.assign({}, t), { frontEndStack: "react" }), r = !fZ(Da.options, n);
  (e !== Da.publicKey || r) && (Da.publicKey = e, Da.options = n, Da.instanceMercadoPago = void 0);
}, yZ = 200;
var vZ = function(e, t, n, r) {
  function a(o) {
    return o instanceof n ? o : new n(function(i) {
      i(o);
    });
  }
  return new (n || (n = Promise))(function(o, i) {
    function s(u) {
      try {
        c(r.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(r.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((r = r.apply(e, t || [])).next());
  });
};
const bZ = () => vZ(void 0, void 0, void 0, function* () {
}), _Z = () => {
}, wZ = (e) => {
  console.error(e);
}, SZ = (e) => {
  console.log(e);
};
var CZ = function(e, t, n, r) {
  function a(o) {
    return o instanceof n ? o : new n(function(i) {
      i(o);
    });
  }
  return new (n || (n = Promise))(function(o, i) {
    function s(u) {
      try {
        c(r.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(r.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((r = r.apply(e, t || [])).next());
  });
};
const xZ = ({ settings: e, name: t, containerId: n, controller: r }) => CZ(void 0, void 0, void 0, function* () {
  const a = yield Da.getInstance(), o = a == null ? void 0 : a.bricks();
  window[r] = yield o == null ? void 0 : o.create(t, n, e);
}), kZ = ({ onReady: e = _Z, onError: t = wZ, onSubmit: n = bZ, onBinChange: r = SZ, initialization: a, customization: o, locale: i, id: s = "cardPaymentBrick_container" }) => (De(() => {
  const l = {
    settings: {
      initialization: a,
      customization: o,
      callbacks: {
        onReady: e,
        onSubmit: n,
        onError: t,
        onBinChange: r
      },
      locale: i
    },
    name: "cardPayment",
    containerId: s,
    controller: "cardPaymentBrickController"
  }, c = setTimeout(() => {
    xZ(l);
  }, yZ);
  return () => {
    var u;
    clearTimeout(c), (u = window.cardPaymentBrickController) === null || u === void 0 || u.unmount();
  };
}, [a, o, r, e, t, n]), k.createElement("div", { id: s })), EZ = () => ({ update: (t) => {
  window.cardPaymentBrickController ? window.cardPaymentBrickController.update(t) : console.warn("[Checkout Bricks] Card Payment Brick is not initialized yet, please try again after a few seconds.");
} });
function PZ() {
  var m;
  const { state: e } = Sn(), { initialized: t } = Q8(), [n, r] = ke(!1), { primaryColor: a, secondaryColor: o, textColorPrimary: i, textColorTertiary: s, tertiaryColor: l } = yh(e), { finalAmount: c, contactFields: u } = In(), d = (m = u == null ? void 0 : u[Kt.Email]) == null ? void 0 : m.value, { update: p } = EZ();
  return De(() => {
    c && t && n && p({ amount: pr(c) });
  }, [c, t, n]), we(() => !c || !t ? null : /* @__PURE__ */ S.jsx(
    kZ,
    {
      initialization: { amount: pr(c), payer: { email: d } },
      customization: {
        visual: {
          hidePaymentButton: !0,
          style: {
            customVariables: {
              textPrimaryColor: s,
              inputBackgroundColor: l,
              formBackgroundColor: o,
              baseColor: a,
              baseColorFirstVariant: a,
              baseColorSecondVariant: o,
              outlinePrimaryColor: "var(--THEME-border-tertiary)",
              outlineSecondaryColor: "var(--THEME-border-tertiary)",
              buttonTextColor: i
            }
          }
        }
      },
      onSubmit: async (f) => {
      },
      onError: (f) => console.log("MP error", f),
      onReady: () => {
        r(!0);
      }
    }
  ), [t]);
}
var TZ = 3, MZ = 5, ca = /(\d{1,4})/g, qg = [{
  displayName: "Visa",
  type: "visa",
  format: ca,
  startPattern: /^4/,
  gaps: [4, 8, 12],
  lengths: [16, 18, 19],
  code: {
    name: "CVV",
    length: 3
  }
}, {
  displayName: "Mastercard",
  type: "mastercard",
  format: ca,
  startPattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: "CVC",
    length: 3
  }
}, {
  displayName: "American Express",
  type: "amex",
  format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
  startPattern: /^3[47]/,
  gaps: [4, 10],
  lengths: [15],
  code: {
    name: "CID",
    length: 4
  }
}, {
  displayName: "Diners Club",
  type: "dinersclub",
  format: ca,
  startPattern: /^(36|38|30[0-5])/,
  gaps: [4, 10],
  lengths: [14, 16, 19],
  code: {
    name: "CVV",
    length: 3
  }
}, {
  displayName: "Discover",
  type: "discover",
  format: ca,
  startPattern: /^(6011|65|64[4-9]|622)/,
  gaps: [4, 8, 12],
  lengths: [16, 19],
  code: {
    name: "CID",
    length: 3
  }
}, {
  displayName: "JCB",
  type: "jcb",
  format: ca,
  startPattern: /^35/,
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: "CVV",
    length: 3
  }
}, {
  displayName: "UnionPay",
  type: "unionpay",
  format: ca,
  startPattern: /^62/,
  gaps: [4, 8, 12],
  lengths: [14, 15, 16, 17, 18, 19],
  code: {
    name: "CVN",
    length: 3
  }
}, {
  displayName: "Maestro",
  type: "maestro",
  format: ca,
  startPattern: /^(5018|5020|5038|6304|6703|6708|6759|676[1-3])/,
  gaps: [4, 8, 12],
  lengths: [12, 13, 14, 15, 16, 17, 18, 19],
  code: {
    name: "CVC",
    length: 3
  }
}, {
  displayName: "Elo",
  type: "elo",
  format: ca,
  startPattern: /^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|4(0[5-9]|3[0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8])|9([2-6][0-9]|7[0-8])|541|700|720|901)|651652|655000|655021)/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: "CVE",
    length: 3
  }
}, {
  displayName: "Hipercard",
  type: "hipercard",
  format: ca,
  startPattern: /^(384100|384140|384160|606282|637095|637568|60(?!11))/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: "CVC",
    length: 3
  }
}, {
  displayName: "Troy",
  type: "troy",
  format: ca,
  startPattern: /^9792/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: "CVV",
    length: 3
  }
}], Oh = function(t) {
  return qg.filter(function(n) {
    return n.startPattern.test(t);
  })[0];
}, OZ = function(t) {
  return qg.filter(function(n) {
    return n.type === t;
  })[0];
}, AZ = /* @__PURE__ */ Object.freeze({
  DEFAULT_CVC_LENGTH: TZ,
  DEFAULT_ZIP_LENGTH: MZ,
  DEFAULT_CARD_FORMAT: ca,
  CARD_TYPES: qg,
  getCardTypeByValue: Oh,
  getCardTypeByType: OZ
}), NZ = /(0[1-9]|1[0-2])/, Z7 = "Enter a card number", q7 = "Enter an expiry date", J7 = "Enter a CVC", X7 = "Enter a ZIP code", Q7 = "Card number is invalid", ew = "Expiry date is invalid", Of = "CVC is invalid", tw = "Expiry month must be between 01 and 12", rw = "Expiry year cannot be in the past", nw = "Expiry date cannot be in the past", LZ = function(t) {
  var n = Oh(t);
  return n && t.length >= n.lengths[n.lengths.length - 1];
}, RZ = function(t) {
  return /^\d*$/.test(t.key);
}, aw = function(t) {
  return t.split("").reverse().map(function(n) {
    return parseInt(n, 10);
  }).map(function(n, r) {
    return r % 2 ? n * 2 : n;
  }).map(function(n) {
    return n > 9 ? n % 10 + 1 : n;
  }).reduce(function(n, r) {
    return n += r;
  }) % 10 === 0;
}, DZ = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = r.errorMessages, o = a === void 0 ? {} : a;
  if (!t)
    return o.emptyCardNumber || Z7;
  var i = t.replace(/\s/g, ""), s = Oh(i);
  if (s && s.lengths) {
    var l = s.lengths.includes(i.length);
    if (l) {
      var c = aw(i);
      if (c)
        return n ? n({
          cardNumber: i,
          cardType: s,
          errorMessages: o
        }) : void 0;
    }
  }
  return o.invalidCardNumber || Q7;
}, IZ = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = r.errorMessages, o = a === void 0 ? {} : a;
  if (!t)
    return o.emptyExpiryDate || q7;
  var i = t.replace(" / ", "").replace("/", "");
  if (i.length === 4) {
    var s = i.slice(0, 2), l = "20".concat(i.slice(2, 4));
    return NZ.test(s) ? parseInt(l) < (/* @__PURE__ */ new Date()).getFullYear() ? o.yearOutOfRange || rw : parseInt(l) === (/* @__PURE__ */ new Date()).getFullYear() && parseInt(s) < (/* @__PURE__ */ new Date()).getMonth() + 1 ? o.dateOutOfRange || nw : n ? n({
      expiryDate: {
        month: s,
        year: l
      },
      errorMessages: o
    }) : void 0 : o.monthOutOfRange || tw;
  }
  return o.invalidExpiryDate || ew;
}, jZ = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = r.cardType, o = r.errorMessages, i = o === void 0 ? {} : o;
  if (!t)
    return i.emptyCVC || J7;
  if (t.length < 3 || a && t.length !== a.code.length)
    return i.invalidCVC || Of;
  if (n)
    return n({
      cvc: t,
      cardType: a,
      errorMessages: i
    });
}, BZ = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.errorMessages, a = r === void 0 ? {} : r;
  if (!t)
    return a.emptyZIP || X7;
}, FZ = /* @__PURE__ */ Object.freeze({
  EMPTY_CARD_NUMBER: Z7,
  EMPTY_EXPIRY_DATE: q7,
  EMPTY_CVC: J7,
  EMPTY_ZIP: X7,
  INVALID_CARD_NUMBER: Q7,
  INVALID_EXPIRY_DATE: ew,
  INVALID_CVC: Of,
  MONTH_OUT_OF_RANGE: tw,
  YEAR_OUT_OF_RANGE: rw,
  DATE_OUT_OF_RANGE: nw,
  hasCardNumberReachedMaxLength: LZ,
  isNumeric: RZ,
  validateLuhn: aw,
  getCardNumberError: DZ,
  getExpiryDateError: IZ,
  getCVCError: jZ,
  getZIPError: BZ
});
function Lo(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function mi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      Lo(e, a, n[a]);
    });
  }
  return e;
}
function zZ(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Vu(e, t) {
  if (e == null)
    return {};
  var n = zZ(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      r = o[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function xu(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function xi(e, t) {
  return ow(e) || KZ(e, t) || iw();
}
function GZ(e) {
  return ow(e) || HZ(e) || iw();
}
function ow(e) {
  if (Array.isArray(e))
    return e;
}
function HZ(e) {
  if (Symbol.iterator in Object(e) || Object.prototype.toString.call(e) === "[object Arguments]")
    return Array.from(e);
}
function KZ(e, t) {
  var n = [], r = !0, a = !1, o = void 0;
  try {
    for (var i = e[Symbol.iterator](), s; !(r = (s = i.next()).done) && (n.push(s.value), !(t && n.length === t)); r = !0)
      ;
  } catch (l) {
    a = !0, o = l;
  } finally {
    try {
      !r && i.return != null && i.return();
    } finally {
      if (a)
        throw o;
    }
  }
  return n;
}
function iw() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var UZ = function(t) {
  var n = Oh(t);
  if (!n)
    return (t.match(/\d+/g) || []).join("");
  var r = n.format;
  if (r && r.global)
    return (t.match(r) || []).join(" ");
  if (r) {
    var a = r.exec(t.split(" ").join(""));
    if (a)
      return a.splice(1, 3).filter(function(o) {
        return o;
      }).join(" ");
  }
  return t;
}, $Z = function(t) {
  var n = t.nativeEvent && t.nativeEvent.data, r = t.target.value.split(" / ").join("/");
  if (!r)
    return null;
  var a = r;
  if (/^[2-9]$/.test(a) && (a = "0".concat(a)), r.length === 2 && +r > 12) {
    var o = r.split(""), i = GZ(o), s = i[0], l = i.slice(1);
    a = "0".concat(s, "/").concat(l.join(""));
  }
  if (/^1[/-]$/.test(a))
    return "01 / ";
  if (a = a.match(/(\d{1,2})/g) || [], a.length === 1) {
    if (!n && r.includes("/"))
      return a[0];
    if (/\d{2}/.test(a))
      return "".concat(a[0], " / ");
  }
  if (a.length > 2) {
    var c = a.join("").match(/^(\d{2}).*(\d{2})$/) || [], u = xi(c, 3), d = u[1], p = d === void 0 ? null : d, h = u[2], m = h === void 0 ? null : h;
    return [p, m].join(" / ");
  }
  return a.join(" / ");
}, VZ = /* @__PURE__ */ Object.freeze({
  formatCardNumber: UZ,
  formatExpiry: $Z
}), WZ = "Backspace", YZ = "Enter", ZZ = function() {
  return (window.getSelection() || {
    type: void 0
  }).type === "Range";
}, qt = {
  cardTypes: AZ,
  formatter: VZ,
  validator: FZ,
  BACKSPACE_KEY_CODE: WZ,
  ENTER_KEY_CODE: YZ,
  isHighlighted: ZZ
};
function qZ() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.autoFocus, n = t === void 0 ? !0 : t, r = e.errorMessages, a = e.onBlur, o = e.onChange, i = e.onError, s = e.onTouch, l = e.cardNumberValidator, c = e.cvcValidator, u = e.expiryValidator, d = k.useRef(), p = k.useRef(), h = k.useRef(), m = k.useRef(), f = k.useState({
    cardNumber: !1,
    expiryDate: !1,
    cvc: !1,
    zip: !1
  }), g = xi(f, 2), _ = g[0], v = g[1], w = k.useState(!1), x = xi(w, 2), b = x[0], C = x[1], E = k.useState({
    cardNumber: void 0,
    expiryDate: void 0,
    cvc: void 0,
    zip: void 0
  }), A = xi(E, 2), O = A[0], M = A[1], I = k.useState(), D = xi(I, 2), K = D[0], G = D[1], V = k.useState(), ee = xi(V, 2), U = ee[0], H = ee[1], W = k.useState(), L = xi(W, 2), T = L[0], B = L[1], N = k.useCallback(function(fe, ge) {
    M(function(Oe) {
      if (Oe[fe] === ge)
        return Oe;
      var ct = ge, yr = mi({}, Oe, Lo({}, fe, ge));
      return ge ? G(ge) : (ct = Object.values(yr).find(Boolean), G(ct)), i && i(ct, yr), yr;
    });
  }, []), Y = k.useCallback(function(fe, ge) {
    requestAnimationFrame(function() {
      document.activeElement.tagName !== "INPUT" ? C(!0) : ge === !1 && C(!1);
    }), v(function(Oe) {
      if (Oe[fe] === ge)
        return Oe;
      var ct = mi({}, Oe, Lo({}, fe, ge));
      return s && s(Lo({}, fe, ge), ct), ct;
    });
  }, []), Q = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      fe.onBlur && fe.onBlur(ge), a && a(ge), B(void 0), Y("cardNumber", !0);
    };
  }, [a, Y]), F = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      var Oe = ge.target.value || "", ct = Oe.replace(/\s/g, ""), yr = d.current.selectionStart, Vr = qt.cardTypes.getCardTypeByValue(ct);
      H(Vr), Y("cardNumber", !1), d.current.value = qt.formatter.formatCardNumber(ct), fe.onChange && fe.onChange(ge), o && o(ge), requestAnimationFrame(function() {
        document.activeElement === d.current && (d.current.value[yr - 1] === " " && (yr = yr + 1), d.current.setSelectionRange(yr, yr));
      });
      var Xn = qt.validator.getCardNumberError(ct, l, {
        errorMessages: r
      });
      !Xn && n && p.current && p.current.focus(), N("cardNumber", Xn), fe.onError && fe.onError(Xn);
    };
  }, [n, l, r, o, N, Y]), re = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      fe.onFocus && fe.onFocus(ge), B("cardNumber");
    };
  }, []), q = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      var Oe = ge.target.value || "", ct = Oe.replace(/\s/g, "");
      fe.onKeyPress && fe.onKeyPress(ge), ge.key !== qt.ENTER_KEY_CODE && (qt.validator.isNumeric(ge) || ge.preventDefault(), qt.validator.hasCardNumberReachedMaxLength(ct) && ge.preventDefault());
    };
  }, []), he = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ge = fe.refKey, Oe = Vu(fe, ["refKey"]);
    return mi(Lo({
      "aria-label": "Card number",
      autoComplete: "cc-number",
      id: "cardNumber",
      name: "cardNumber",
      placeholder: "Card number",
      type: "tel"
    }, ge || "ref", d), Oe, {
      onBlur: Q(Oe),
      onChange: F(Oe),
      onFocus: re(Oe),
      onKeyPress: q(Oe)
    });
  }, [Q, F, re, q]), me = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      fe.onBlur && fe.onBlur(ge), a && a(ge), B(void 0), Y("expiryDate", !0);
    };
  }, [a, Y]), Le = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      Y("expiryDate", !1), p.current.value = qt.formatter.formatExpiry(ge), fe.onChange && fe.onChange(ge), o && o(ge);
      var Oe = qt.validator.getExpiryDateError(p.current.value, u, {
        errorMessages: r
      });
      !Oe && n && h.current && h.current.focus(), N("expiryDate", Oe), fe.onError && fe.onError(Oe);
    };
  }, [n, r, u, o, N, Y]), $ = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      fe.onFocus && fe.onFocus(ge), B("expiryDate");
    };
  }, []), Te = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      fe.onKeyDown && fe.onKeyDown(ge), ge.key === qt.BACKSPACE_KEY_CODE && !ge.target.value && n && d.current && d.current.focus();
    };
  }, [n]), J = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      var Oe = ge.target.value || "", ct = Oe.replace(" / ", "");
      fe.onKeyPress && fe.onKeyPress(ge), ge.key !== qt.ENTER_KEY_CODE && (qt.validator.isNumeric(ge) || ge.preventDefault(), ct.length >= 4 && ge.preventDefault());
    };
  }, []), te = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ge = fe.refKey, Oe = Vu(fe, ["refKey"]);
    return mi(Lo({
      "aria-label": "Expiry date in format MM YY",
      autoComplete: "cc-exp",
      id: "expiryDate",
      name: "expiryDate",
      placeholder: "MM/YY",
      type: "tel"
    }, ge || "ref", p), Oe, {
      onBlur: me(Oe),
      onChange: Le(Oe),
      onFocus: $(Oe),
      onKeyDown: Te(Oe),
      onKeyPress: J(Oe)
    });
  }, [me, Le, $, Te, J]), ve = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      fe.onBlur && fe.onBlur(ge), a && a(ge), B(void 0), Y("cvc", !0);
    };
  }, [a, Y]), Pe = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Oe = ge.cardType;
    return function(ct) {
      var yr = ct.target.value;
      Y("cvc", !1), fe.onChange && fe.onChange(ct), o && o(ct);
      var Vr = qt.validator.getCVCError(yr, c, {
        cardType: Oe,
        errorMessages: r
      });
      !Vr && n && m.current && m.current.focus(), N("cvc", Vr), fe.onError && fe.onError(Vr);
    };
  }, [n, c, r, o, N, Y]), $e = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      fe.onFocus && fe.onFocus(ge), B("cvc");
    };
  }, []), _t = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      fe.onKeyDown && fe.onKeyDown(ge), ge.key === qt.BACKSPACE_KEY_CODE && !ge.target.value && n && p.current && p.current.focus();
    };
  }, [n]), st = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ge = arguments.length > 1 ? arguments[1] : void 0, Oe = ge.cardType;
    return function(ct) {
      var yr = ct.target.value || "", Vr = yr.replace(" / ", "");
      fe.onKeyPress && fe.onKeyPress(ct), ct.key !== qt.ENTER_KEY_CODE && (qt.validator.isNumeric(ct) || ct.preventDefault(), Oe && Vr.length >= Oe.code.length && ct.preventDefault(), Vr.length >= 4 && ct.preventDefault());
    };
  }, []), Mr = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ge = fe.refKey, Oe = Vu(fe, ["refKey"]);
    return mi(Lo({
      "aria-label": "CVC",
      autoComplete: "cc-csc",
      id: "cvc",
      name: "cvc",
      placeholder: U ? U.code.name : "CVC",
      type: "tel"
    }, ge || "ref", h), Oe, {
      onBlur: ve(Oe),
      onChange: Pe(Oe, {
        cardType: U
      }),
      onFocus: $e(Oe),
      onKeyDown: _t(Oe),
      onKeyPress: st(Oe, {
        cardType: U
      })
    });
  }, [U, ve, Pe, $e, _t, st]), Vt = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      fe.onBlur && fe.onBlur(ge), a && a(ge), B(void 0), Y("zip", !0);
    };
  }, [a, Y]), Xt = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      var Oe = ge.target.value;
      Y("zip", !1), fe.onChange && fe.onChange(ge), o && o(ge);
      var ct = qt.validator.getZIPError(Oe, {
        errorMessages: r
      });
      N("zip", ct), fe.onError && fe.onError(ct);
    };
  }, [r, o, N, Y]), je = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      fe.onFocus && fe.onFocus(ge), B("zip");
    };
  }, []), lt = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      fe.onKeyDown && fe.onKeyDown(ge), ge.key === qt.BACKSPACE_KEY_CODE && !ge.target.value && n && h.current && h.current.focus();
    };
  }, [n]), fr = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(ge) {
      fe.onKeyPress && fe.onKeyPress(ge), ge.key !== qt.ENTER_KEY_CODE && (qt.validator.isNumeric(ge) || ge.preventDefault());
    };
  }, []), Ot = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ge = fe.refKey, Oe = Vu(fe, ["refKey"]);
    return mi(Lo({
      autoComplete: "off",
      id: "zip",
      maxLength: "6",
      name: "zip",
      placeholder: "ZIP",
      type: "tel"
    }, ge || "ref", m), Oe, {
      onBlur: Vt(Oe),
      onChange: Xt(Oe),
      onFocus: je(Oe),
      onKeyDown: lt(Oe),
      onKeyPress: fr(Oe)
    });
  }, [Vt, Xt, je, lt, fr]), gr = k.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ge = fe.images || {};
    return mi({
      "aria-label": U ? U.displayName : "Placeholder card",
      children: ge[U ? U.type : "placeholder"] || ge.placeholder,
      width: "1.5em",
      height: "1em",
      viewBox: "0 0 24 16"
    }, fe);
  }, [U]);
  return k.useLayoutEffect(function() {
    if (m.current) {
      var fe = qt.validator.getZIPError(m.current.value, {
        errorMessages: r
      });
      N("zip", fe);
    }
    if (h.current) {
      var ge = qt.validator.getCVCError(h.current.value, c, {
        errorMessages: r
      });
      N("cvc", ge);
    }
    if (p.current) {
      var Oe = qt.validator.getExpiryDateError(p.current.value, u, {
        errorMessages: r
      });
      N("expiryDate", Oe);
    }
    if (d.current) {
      var ct = qt.validator.getCardNumberError(d.current.value, l, {
        errorMessages: r
      });
      N("cardNumber", ct);
    }
  }, [l, c, r, u, N]), k.useLayoutEffect(function() {
    d.current && (d.current.value = qt.formatter.formatCardNumber(d.current.value)), p.current && (p.current.value = qt.formatter.formatExpiry({
      target: p.current
    }));
  }, []), k.useLayoutEffect(function() {
    if (d.current) {
      var fe = qt.cardTypes.getCardTypeByValue(d.current.value);
      H(fe);
    }
  }, []), {
    getCardImageProps: gr,
    getCardNumberProps: he,
    getExpiryDateProps: te,
    getCVCProps: Mr,
    getZIPProps: Ot,
    wrapperProps: {
      error: K,
      focused: T,
      isTouched: b
    },
    meta: {
      cardType: U,
      erroredInputs: O,
      error: K,
      focused: T,
      isTouched: b,
      touchedInputs: _
    }
  };
}
var Af = { exports: {} }, It = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var a3;
function JZ() {
  if (a3)
    return It;
  a3 = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function f(g) {
    if (typeof g == "object" && g !== null) {
      var _ = g.$$typeof;
      switch (_) {
        case e:
          switch (g = g.type, g) {
            case n:
            case a:
            case r:
            case c:
            case u:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case s:
                case i:
                case l:
                case p:
                case d:
                case o:
                  return g;
                default:
                  return _;
              }
          }
        case t:
          return _;
      }
    }
  }
  return It.ContextConsumer = i, It.ContextProvider = o, It.Element = e, It.ForwardRef = l, It.Fragment = n, It.Lazy = p, It.Memo = d, It.Portal = t, It.Profiler = a, It.StrictMode = r, It.Suspense = c, It.SuspenseList = u, It.isAsyncMode = function() {
    return !1;
  }, It.isConcurrentMode = function() {
    return !1;
  }, It.isContextConsumer = function(g) {
    return f(g) === i;
  }, It.isContextProvider = function(g) {
    return f(g) === o;
  }, It.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, It.isForwardRef = function(g) {
    return f(g) === l;
  }, It.isFragment = function(g) {
    return f(g) === n;
  }, It.isLazy = function(g) {
    return f(g) === p;
  }, It.isMemo = function(g) {
    return f(g) === d;
  }, It.isPortal = function(g) {
    return f(g) === t;
  }, It.isProfiler = function(g) {
    return f(g) === a;
  }, It.isStrictMode = function(g) {
    return f(g) === r;
  }, It.isSuspense = function(g) {
    return f(g) === c;
  }, It.isSuspenseList = function(g) {
    return f(g) === u;
  }, It.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === a || g === r || g === c || g === u || g === h || typeof g == "object" && g !== null && (g.$$typeof === p || g.$$typeof === d || g.$$typeof === o || g.$$typeof === i || g.$$typeof === l || g.$$typeof === m || g.getModuleId !== void 0);
  }, It.typeOf = f, It;
}
var jt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var o3;
function XZ() {
  return o3 || (o3 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = !1, f = !1, g = !1, _ = !1, v = !1, w;
    w = Symbol.for("react.module.reference");
    function x(J) {
      return !!(typeof J == "string" || typeof J == "function" || J === n || J === a || v || J === r || J === c || J === u || _ || J === h || m || f || g || typeof J == "object" && J !== null && (J.$$typeof === p || J.$$typeof === d || J.$$typeof === o || J.$$typeof === i || J.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      J.$$typeof === w || J.getModuleId !== void 0));
    }
    function b(J) {
      if (typeof J == "object" && J !== null) {
        var te = J.$$typeof;
        switch (te) {
          case e:
            var ve = J.type;
            switch (ve) {
              case n:
              case a:
              case r:
              case c:
              case u:
                return ve;
              default:
                var Pe = ve && ve.$$typeof;
                switch (Pe) {
                  case s:
                  case i:
                  case l:
                  case p:
                  case d:
                  case o:
                    return Pe;
                  default:
                    return te;
                }
            }
          case t:
            return te;
        }
      }
    }
    var C = i, E = o, A = e, O = l, M = n, I = p, D = d, K = t, G = a, V = r, ee = c, U = u, H = !1, W = !1;
    function L(J) {
      return H || (H = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function T(J) {
      return W || (W = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function B(J) {
      return b(J) === i;
    }
    function N(J) {
      return b(J) === o;
    }
    function Y(J) {
      return typeof J == "object" && J !== null && J.$$typeof === e;
    }
    function Q(J) {
      return b(J) === l;
    }
    function F(J) {
      return b(J) === n;
    }
    function re(J) {
      return b(J) === p;
    }
    function q(J) {
      return b(J) === d;
    }
    function he(J) {
      return b(J) === t;
    }
    function me(J) {
      return b(J) === a;
    }
    function Le(J) {
      return b(J) === r;
    }
    function $(J) {
      return b(J) === c;
    }
    function Te(J) {
      return b(J) === u;
    }
    jt.ContextConsumer = C, jt.ContextProvider = E, jt.Element = A, jt.ForwardRef = O, jt.Fragment = M, jt.Lazy = I, jt.Memo = D, jt.Portal = K, jt.Profiler = G, jt.StrictMode = V, jt.Suspense = ee, jt.SuspenseList = U, jt.isAsyncMode = L, jt.isConcurrentMode = T, jt.isContextConsumer = B, jt.isContextProvider = N, jt.isElement = Y, jt.isForwardRef = Q, jt.isFragment = F, jt.isLazy = re, jt.isMemo = q, jt.isPortal = he, jt.isProfiler = me, jt.isStrictMode = Le, jt.isSuspense = $, jt.isSuspenseList = Te, jt.isValidElementType = x, jt.typeOf = b;
  }()), jt;
}
process.env.NODE_ENV === "production" ? Af.exports = JZ() : Af.exports = XZ();
var Jg = Af.exports;
function QZ(e) {
  function t(B, N, Y, Q, F) {
    for (var re = 0, q = 0, he = 0, me = 0, Le, $, Te = 0, J = 0, te, ve = te = Le = 0, Pe = 0, $e = 0, _t = 0, st = 0, Mr = Y.length, Vt = Mr - 1, Xt, je = "", lt = "", fr = "", Ot = "", gr; Pe < Mr; ) {
      if ($ = Y.charCodeAt(Pe), Pe === Vt && q + me + he + re !== 0 && (q !== 0 && ($ = q === 47 ? 10 : 47), me = he = re = 0, Mr++, Vt++), q + me + he + re === 0) {
        if (Pe === Vt && (0 < $e && (je = je.replace(p, "")), 0 < je.trim().length)) {
          switch ($) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              je += Y.charAt(Pe);
          }
          $ = 59;
        }
        switch ($) {
          case 123:
            for (je = je.trim(), Le = je.charCodeAt(0), te = 1, st = ++Pe; Pe < Mr; ) {
              switch ($ = Y.charCodeAt(Pe)) {
                case 123:
                  te++;
                  break;
                case 125:
                  te--;
                  break;
                case 47:
                  switch ($ = Y.charCodeAt(Pe + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (ve = Pe + 1; ve < Vt; ++ve)
                          switch (Y.charCodeAt(ve)) {
                            case 47:
                              if ($ === 42 && Y.charCodeAt(ve - 1) === 42 && Pe + 2 !== ve) {
                                Pe = ve + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if ($ === 47) {
                                Pe = ve + 1;
                                break e;
                              }
                          }
                        Pe = ve;
                      }
                  }
                  break;
                case 91:
                  $++;
                case 40:
                  $++;
                case 34:
                case 39:
                  for (; Pe++ < Vt && Y.charCodeAt(Pe) !== $; )
                    ;
              }
              if (te === 0)
                break;
              Pe++;
            }
            switch (te = Y.substring(st, Pe), Le === 0 && (Le = (je = je.replace(d, "").trim()).charCodeAt(0)), Le) {
              case 64:
                switch (0 < $e && (je = je.replace(p, "")), $ = je.charCodeAt(1), $) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    $e = N;
                    break;
                  default:
                    $e = ee;
                }
                if (te = t(N, $e, te, $, F + 1), st = te.length, 0 < H && ($e = n(ee, je, _t), gr = s(3, te, $e, N, K, D, st, $, F, Q), je = $e.join(""), gr !== void 0 && (st = (te = gr.trim()).length) === 0 && ($ = 0, te = "")), 0 < st)
                  switch ($) {
                    case 115:
                      je = je.replace(C, i);
                    case 100:
                    case 109:
                    case 45:
                      te = je + "{" + te + "}";
                      break;
                    case 107:
                      je = je.replace(v, "$1 $2"), te = je + "{" + te + "}", te = V === 1 || V === 2 && o("@" + te, 3) ? "@-webkit-" + te + "@" + te : "@" + te;
                      break;
                    default:
                      te = je + te, Q === 112 && (te = (lt += te, ""));
                  }
                else
                  te = "";
                break;
              default:
                te = t(N, n(N, je, _t), te, Q, F + 1);
            }
            fr += te, te = _t = $e = ve = Le = 0, je = "", $ = Y.charCodeAt(++Pe);
            break;
          case 125:
          case 59:
            if (je = (0 < $e ? je.replace(p, "") : je).trim(), 1 < (st = je.length))
              switch (ve === 0 && (Le = je.charCodeAt(0), Le === 45 || 96 < Le && 123 > Le) && (st = (je = je.replace(" ", ":")).length), 0 < H && (gr = s(1, je, N, B, K, D, lt.length, Q, F, Q)) !== void 0 && (st = (je = gr.trim()).length) === 0 && (je = "\0\0"), Le = je.charCodeAt(0), $ = je.charCodeAt(1), Le) {
                case 0:
                  break;
                case 64:
                  if ($ === 105 || $ === 99) {
                    Ot += je + Y.charAt(Pe);
                    break;
                  }
                default:
                  je.charCodeAt(st - 1) !== 58 && (lt += a(je, Le, $, je.charCodeAt(2)));
              }
            _t = $e = ve = Le = 0, je = "", $ = Y.charCodeAt(++Pe);
        }
      }
      switch ($) {
        case 13:
        case 10:
          q === 47 ? q = 0 : 1 + Le === 0 && Q !== 107 && 0 < je.length && ($e = 1, je += "\0"), 0 < H * L && s(0, je, N, B, K, D, lt.length, Q, F, Q), D = 1, K++;
          break;
        case 59:
        case 125:
          if (q + me + he + re === 0) {
            D++;
            break;
          }
        default:
          switch (D++, Xt = Y.charAt(Pe), $) {
            case 9:
            case 32:
              if (me + re + q === 0)
                switch (Te) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    Xt = "";
                    break;
                  default:
                    $ !== 32 && (Xt = " ");
                }
              break;
            case 0:
              Xt = "\\0";
              break;
            case 12:
              Xt = "\\f";
              break;
            case 11:
              Xt = "\\v";
              break;
            case 38:
              me + q + re === 0 && ($e = _t = 1, Xt = "\f" + Xt);
              break;
            case 108:
              if (me + q + re + G === 0 && 0 < ve)
                switch (Pe - ve) {
                  case 2:
                    Te === 112 && Y.charCodeAt(Pe - 3) === 58 && (G = Te);
                  case 8:
                    J === 111 && (G = J);
                }
              break;
            case 58:
              me + q + re === 0 && (ve = Pe);
              break;
            case 44:
              q + he + me + re === 0 && ($e = 1, Xt += "\r");
              break;
            case 34:
            case 39:
              q === 0 && (me = me === $ ? 0 : me === 0 ? $ : me);
              break;
            case 91:
              me + q + he === 0 && re++;
              break;
            case 93:
              me + q + he === 0 && re--;
              break;
            case 41:
              me + q + re === 0 && he--;
              break;
            case 40:
              if (me + q + re === 0) {
                if (Le === 0)
                  switch (2 * Te + 3 * J) {
                    case 533:
                      break;
                    default:
                      Le = 1;
                  }
                he++;
              }
              break;
            case 64:
              q + he + me + re + ve + te === 0 && (te = 1);
              break;
            case 42:
            case 47:
              if (!(0 < me + re + he))
                switch (q) {
                  case 0:
                    switch (2 * $ + 3 * Y.charCodeAt(Pe + 1)) {
                      case 235:
                        q = 47;
                        break;
                      case 220:
                        st = Pe, q = 42;
                    }
                    break;
                  case 42:
                    $ === 47 && Te === 42 && st + 2 !== Pe && (Y.charCodeAt(st + 2) === 33 && (lt += Y.substring(st, Pe + 1)), Xt = "", q = 0);
                }
          }
          q === 0 && (je += Xt);
      }
      J = Te, Te = $, Pe++;
    }
    if (st = lt.length, 0 < st) {
      if ($e = N, 0 < H && (gr = s(2, lt, $e, B, K, D, st, Q, F, Q), gr !== void 0 && (lt = gr).length === 0))
        return Ot + lt + fr;
      if (lt = $e.join(",") + "{" + lt + "}", V * G !== 0) {
        switch (V !== 2 || o(lt, 2) || (G = 0), G) {
          case 111:
            lt = lt.replace(x, ":-moz-$1") + lt;
            break;
          case 112:
            lt = lt.replace(w, "::-webkit-input-$1") + lt.replace(w, "::-moz-$1") + lt.replace(w, ":-ms-input-$1") + lt;
        }
        G = 0;
      }
    }
    return Ot + lt + fr;
  }
  function n(B, N, Y) {
    var Q = N.trim().split(g);
    N = Q;
    var F = Q.length, re = B.length;
    switch (re) {
      case 0:
      case 1:
        var q = 0;
        for (B = re === 0 ? "" : B[0] + " "; q < F; ++q)
          N[q] = r(B, N[q], Y).trim();
        break;
      default:
        var he = q = 0;
        for (N = []; q < F; ++q)
          for (var me = 0; me < re; ++me)
            N[he++] = r(B[me] + " ", Q[q], Y).trim();
    }
    return N;
  }
  function r(B, N, Y) {
    var Q = N.charCodeAt(0);
    switch (33 > Q && (Q = (N = N.trim()).charCodeAt(0)), Q) {
      case 38:
        return N.replace(_, "$1" + B.trim());
      case 58:
        return B.trim() + N.replace(_, "$1" + B.trim());
      default:
        if (0 < 1 * Y && 0 < N.indexOf("\f"))
          return N.replace(_, (B.charCodeAt(0) === 58 ? "" : "$1") + B.trim());
    }
    return B + N;
  }
  function a(B, N, Y, Q) {
    var F = B + ";", re = 2 * N + 3 * Y + 4 * Q;
    if (re === 944) {
      B = F.indexOf(":", 9) + 1;
      var q = F.substring(B, F.length - 1).trim();
      return q = F.substring(0, B).trim() + q + ";", V === 1 || V === 2 && o(q, 1) ? "-webkit-" + q + q : q;
    }
    if (V === 0 || V === 2 && !o(F, 1))
      return F;
    switch (re) {
      case 1015:
        return F.charCodeAt(10) === 97 ? "-webkit-" + F + F : F;
      case 951:
        return F.charCodeAt(3) === 116 ? "-webkit-" + F + F : F;
      case 963:
        return F.charCodeAt(5) === 110 ? "-webkit-" + F + F : F;
      case 1009:
        if (F.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + F + F;
      case 978:
        return "-webkit-" + F + "-moz-" + F + F;
      case 1019:
      case 983:
        return "-webkit-" + F + "-moz-" + F + "-ms-" + F + F;
      case 883:
        if (F.charCodeAt(8) === 45)
          return "-webkit-" + F + F;
        if (0 < F.indexOf("image-set(", 11))
          return F.replace(I, "$1-webkit-$2") + F;
        break;
      case 932:
        if (F.charCodeAt(4) === 45)
          switch (F.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + F.replace("-grow", "") + "-webkit-" + F + "-ms-" + F.replace("grow", "positive") + F;
            case 115:
              return "-webkit-" + F + "-ms-" + F.replace("shrink", "negative") + F;
            case 98:
              return "-webkit-" + F + "-ms-" + F.replace("basis", "preferred-size") + F;
          }
        return "-webkit-" + F + "-ms-" + F + F;
      case 964:
        return "-webkit-" + F + "-ms-flex-" + F + F;
      case 1023:
        if (F.charCodeAt(8) !== 99)
          break;
        return q = F.substring(F.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + q + "-webkit-" + F + "-ms-flex-pack" + q + F;
      case 1005:
        return m.test(F) ? F.replace(h, ":-webkit-") + F.replace(h, ":-moz-") + F : F;
      case 1e3:
        switch (q = F.substring(13).trim(), N = q.indexOf("-") + 1, q.charCodeAt(0) + q.charCodeAt(N)) {
          case 226:
            q = F.replace(b, "tb");
            break;
          case 232:
            q = F.replace(b, "tb-rl");
            break;
          case 220:
            q = F.replace(b, "lr");
            break;
          default:
            return F;
        }
        return "-webkit-" + F + "-ms-" + q + F;
      case 1017:
        if (F.indexOf("sticky", 9) === -1)
          break;
      case 975:
        switch (N = (F = B).length - 10, q = (F.charCodeAt(N) === 33 ? F.substring(0, N) : F).substring(B.indexOf(":", 7) + 1).trim(), re = q.charCodeAt(0) + (q.charCodeAt(7) | 0)) {
          case 203:
            if (111 > q.charCodeAt(8))
              break;
          case 115:
            F = F.replace(q, "-webkit-" + q) + ";" + F;
            break;
          case 207:
          case 102:
            F = F.replace(q, "-webkit-" + (102 < re ? "inline-" : "") + "box") + ";" + F.replace(q, "-webkit-" + q) + ";" + F.replace(q, "-ms-" + q + "box") + ";" + F;
        }
        return F + ";";
      case 938:
        if (F.charCodeAt(5) === 45)
          switch (F.charCodeAt(6)) {
            case 105:
              return q = F.replace("-items", ""), "-webkit-" + F + "-webkit-box-" + q + "-ms-flex-" + q + F;
            case 115:
              return "-webkit-" + F + "-ms-flex-item-" + F.replace(A, "") + F;
            default:
              return "-webkit-" + F + "-ms-flex-line-pack" + F.replace("align-content", "").replace(A, "") + F;
          }
        break;
      case 973:
      case 989:
        if (F.charCodeAt(3) !== 45 || F.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (M.test(B) === !0)
          return (q = B.substring(B.indexOf(":") + 1)).charCodeAt(0) === 115 ? a(B.replace("stretch", "fill-available"), N, Y, Q).replace(":fill-available", ":stretch") : F.replace(q, "-webkit-" + q) + F.replace(q, "-moz-" + q.replace("fill-", "")) + F;
        break;
      case 962:
        if (F = "-webkit-" + F + (F.charCodeAt(5) === 102 ? "-ms-" + F : "") + F, Y + Q === 211 && F.charCodeAt(13) === 105 && 0 < F.indexOf("transform", 10))
          return F.substring(0, F.indexOf(";", 27) + 1).replace(f, "$1-webkit-$2") + F;
    }
    return F;
  }
  function o(B, N) {
    var Y = B.indexOf(N === 1 ? ":" : "{"), Q = B.substring(0, N !== 3 ? Y : 10);
    return Y = B.substring(Y + 1, B.length - 1), W(N !== 2 ? Q : Q.replace(O, "$1"), Y, N);
  }
  function i(B, N) {
    var Y = a(N, N.charCodeAt(0), N.charCodeAt(1), N.charCodeAt(2));
    return Y !== N + ";" ? Y.replace(E, " or ($1)").substring(4) : "(" + N + ")";
  }
  function s(B, N, Y, Q, F, re, q, he, me, Le) {
    for (var $ = 0, Te = N, J; $ < H; ++$)
      switch (J = U[$].call(u, B, Te, Y, Q, F, re, q, he, me, Le)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          Te = J;
      }
    if (Te !== N)
      return Te;
  }
  function l(B) {
    switch (B) {
      case void 0:
      case null:
        H = U.length = 0;
        break;
      default:
        if (typeof B == "function")
          U[H++] = B;
        else if (typeof B == "object")
          for (var N = 0, Y = B.length; N < Y; ++N)
            l(B[N]);
        else
          L = !!B | 0;
    }
    return l;
  }
  function c(B) {
    return B = B.prefix, B !== void 0 && (W = null, B ? typeof B != "function" ? V = 1 : (V = 2, W = B) : V = 0), c;
  }
  function u(B, N) {
    var Y = B;
    if (33 > Y.charCodeAt(0) && (Y = Y.trim()), T = Y, Y = [T], 0 < H) {
      var Q = s(-1, N, Y, Y, K, D, 0, 0, 0, 0);
      Q !== void 0 && typeof Q == "string" && (N = Q);
    }
    var F = t(ee, Y, N, 0, 0);
    return 0 < H && (Q = s(-2, F, Y, Y, K, D, F.length, 0, 0, 0), Q !== void 0 && (F = Q)), T = "", G = 0, D = K = 1, F;
  }
  var d = /^\0+/g, p = /[\0\r\f]/g, h = /: */g, m = /zoo|gra/, f = /([,: ])(transform)/g, g = /,\r+?/g, _ = /([\t\r\n ])*\f?&/g, v = /@(k\w+)\s*(\S*)\s*/, w = /::(place)/g, x = /:(read-only)/g, b = /[svh]\w+-[tblr]{2}/, C = /\(\s*(.*)\s*\)/g, E = /([\s\S]*?);/g, A = /-self|flex-/g, O = /[^]*?(:[rp][el]a[\w-]+)[^]*/, M = /stretch|:\s*\w+\-(?:conte|avail)/, I = /([^-])(image-set\()/, D = 1, K = 1, G = 0, V = 1, ee = [], U = [], H = 0, W = null, L = 0, T = "";
  return u.use = l, u.set = c, e !== void 0 && c(e), u;
}
var eq = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function tq(e) {
  var t = {};
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var rq = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, i3 = tq(
  function(e) {
    return rq.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Nf = { exports: {} }, Bt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var s3;
function nq() {
  if (s3)
    return Bt;
  s3 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function w(b) {
    if (typeof b == "object" && b !== null) {
      var C = b.$$typeof;
      switch (C) {
        case t:
          switch (b = b.type, b) {
            case l:
            case c:
            case r:
            case o:
            case a:
            case d:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case u:
                case m:
                case h:
                case i:
                  return b;
                default:
                  return C;
              }
          }
        case n:
          return C;
      }
    }
  }
  function x(b) {
    return w(b) === c;
  }
  return Bt.AsyncMode = l, Bt.ConcurrentMode = c, Bt.ContextConsumer = s, Bt.ContextProvider = i, Bt.Element = t, Bt.ForwardRef = u, Bt.Fragment = r, Bt.Lazy = m, Bt.Memo = h, Bt.Portal = n, Bt.Profiler = o, Bt.StrictMode = a, Bt.Suspense = d, Bt.isAsyncMode = function(b) {
    return x(b) || w(b) === l;
  }, Bt.isConcurrentMode = x, Bt.isContextConsumer = function(b) {
    return w(b) === s;
  }, Bt.isContextProvider = function(b) {
    return w(b) === i;
  }, Bt.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, Bt.isForwardRef = function(b) {
    return w(b) === u;
  }, Bt.isFragment = function(b) {
    return w(b) === r;
  }, Bt.isLazy = function(b) {
    return w(b) === m;
  }, Bt.isMemo = function(b) {
    return w(b) === h;
  }, Bt.isPortal = function(b) {
    return w(b) === n;
  }, Bt.isProfiler = function(b) {
    return w(b) === o;
  }, Bt.isStrictMode = function(b) {
    return w(b) === a;
  }, Bt.isSuspense = function(b) {
    return w(b) === d;
  }, Bt.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === r || b === c || b === o || b === a || b === d || b === p || typeof b == "object" && b !== null && (b.$$typeof === m || b.$$typeof === h || b.$$typeof === i || b.$$typeof === s || b.$$typeof === u || b.$$typeof === g || b.$$typeof === _ || b.$$typeof === v || b.$$typeof === f);
  }, Bt.typeOf = w, Bt;
}
var Ft = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l3;
function aq() {
  return l3 || (l3 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function w($) {
      return typeof $ == "string" || typeof $ == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      $ === r || $ === c || $ === o || $ === a || $ === d || $ === p || typeof $ == "object" && $ !== null && ($.$$typeof === m || $.$$typeof === h || $.$$typeof === i || $.$$typeof === s || $.$$typeof === u || $.$$typeof === g || $.$$typeof === _ || $.$$typeof === v || $.$$typeof === f);
    }
    function x($) {
      if (typeof $ == "object" && $ !== null) {
        var Te = $.$$typeof;
        switch (Te) {
          case t:
            var J = $.type;
            switch (J) {
              case l:
              case c:
              case r:
              case o:
              case a:
              case d:
                return J;
              default:
                var te = J && J.$$typeof;
                switch (te) {
                  case s:
                  case u:
                  case m:
                  case h:
                  case i:
                    return te;
                  default:
                    return Te;
                }
            }
          case n:
            return Te;
        }
      }
    }
    var b = l, C = c, E = s, A = i, O = t, M = u, I = r, D = m, K = h, G = n, V = o, ee = a, U = d, H = !1;
    function W($) {
      return H || (H = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), L($) || x($) === l;
    }
    function L($) {
      return x($) === c;
    }
    function T($) {
      return x($) === s;
    }
    function B($) {
      return x($) === i;
    }
    function N($) {
      return typeof $ == "object" && $ !== null && $.$$typeof === t;
    }
    function Y($) {
      return x($) === u;
    }
    function Q($) {
      return x($) === r;
    }
    function F($) {
      return x($) === m;
    }
    function re($) {
      return x($) === h;
    }
    function q($) {
      return x($) === n;
    }
    function he($) {
      return x($) === o;
    }
    function me($) {
      return x($) === a;
    }
    function Le($) {
      return x($) === d;
    }
    Ft.AsyncMode = b, Ft.ConcurrentMode = C, Ft.ContextConsumer = E, Ft.ContextProvider = A, Ft.Element = O, Ft.ForwardRef = M, Ft.Fragment = I, Ft.Lazy = D, Ft.Memo = K, Ft.Portal = G, Ft.Profiler = V, Ft.StrictMode = ee, Ft.Suspense = U, Ft.isAsyncMode = W, Ft.isConcurrentMode = L, Ft.isContextConsumer = T, Ft.isContextProvider = B, Ft.isElement = N, Ft.isForwardRef = Y, Ft.isFragment = Q, Ft.isLazy = F, Ft.isMemo = re, Ft.isPortal = q, Ft.isProfiler = he, Ft.isStrictMode = me, Ft.isSuspense = Le, Ft.isValidElementType = w, Ft.typeOf = x;
  }()), Ft;
}
process.env.NODE_ENV === "production" ? Nf.exports = nq() : Nf.exports = aq();
var oq = Nf.exports, Xg = oq, iq = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, sq = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, lq = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, sw = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Qg = {};
Qg[Xg.ForwardRef] = lq;
Qg[Xg.Memo] = sw;
function c3(e) {
  return Xg.isMemo(e) ? sw : Qg[e.$$typeof] || iq;
}
var cq = Object.defineProperty, uq = Object.getOwnPropertyNames, u3 = Object.getOwnPropertySymbols, dq = Object.getOwnPropertyDescriptor, pq = Object.getPrototypeOf, d3 = Object.prototype;
function lw(e, t, n) {
  if (typeof t != "string") {
    if (d3) {
      var r = pq(t);
      r && r !== d3 && lw(e, r, n);
    }
    var a = uq(t);
    u3 && (a = a.concat(u3(t)));
    for (var o = c3(e), i = c3(t), s = 0; s < a.length; ++s) {
      var l = a[s];
      if (!sq[l] && !(n && n[l]) && !(i && i[l]) && !(o && o[l])) {
        var c = dq(t, l);
        try {
          cq(e, l, c);
        } catch {
        }
      }
    }
  }
  return e;
}
var hq = lw;
const mq = /* @__PURE__ */ qc(hq);
function Ja() {
  return Ja = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ja.apply(this, arguments);
}
function fq(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var p3 = function(e, t) {
  for (var n = [e[0]], r = 0, a = t.length; r < a; r += 1)
    n.push(t[r], e[r + 1]);
  return n;
}, ey = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !Jg.typeOf(e);
}, pp = Object.freeze([]), Ji = Object.freeze({});
function ku(e) {
  return typeof e == "function";
}
function ty(e) {
  return (process.env.NODE_ENV !== "production" ? typeof e == "string" && e : !1) || // $FlowFixMe
  e.displayName || // $FlowFixMe
  e.name || "Component";
}
function gq(e) {
  return typeof e == "function" && !(e.prototype && e.prototype.isReactComponent);
}
function ry(e) {
  return e && typeof e.styledComponentId == "string";
}
var fl = typeof process < "u" && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", cw = "active", uw = "data-styled-version", dw = "5.1.1", ny = `/*!sc*/
`, ay = typeof window < "u" && "HTMLElement" in window, yq = typeof SC_DISABLE_SPEEDY == "boolean" && SC_DISABLE_SPEEDY || typeof process < "u" && (process.env.REACT_APP_SC_DISABLE_SPEEDY || process.env.SC_DISABLE_SPEEDY) || process.env.NODE_ENV !== "production", vq = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, bq = {
  1: `Cannot create styled-component for component: %s.

`,
  2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`,
  3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`,
  4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`,
  5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`,
  6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`,
  7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
  8: `ThemeProvider: Please make your "theme" prop an object.

`,
  9: "Missing document `<head>`\n\n",
  10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`,
  11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`,
  12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
  13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`,
  14: `ThemeProvider: "theme" prop is required.

`,
  15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
  16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`,
  17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`
}, _q = process.env.NODE_ENV !== "production" ? bq : {};
function wq() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)
    t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
  return t.forEach(function(a) {
    e = e.replace(/%[a-z]/, a);
  }), e;
}
function gl(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + e + " for more information." + (n.length > 0 ? " Additional arguments: " + n.join(", ") : "")) : new Error(wq.apply(void 0, [_q[e]].concat(n)).trim());
}
var Sq = 1, Cq = function(t) {
  for (var n = t.childNodes, r = n.length; r >= 0; r--) {
    var a = n[r];
    if (a && a.nodeType === Sq && a.hasAttribute(fl))
      return a;
  }
}, pw = function(t) {
  var n = document.head, r = t || n, a = document.createElement("style"), o = Cq(r), i = o !== void 0 ? o.nextSibling : null;
  a.setAttribute(fl, cw), a.setAttribute(uw, dw);
  var s = vq();
  return s && a.setAttribute("nonce", s), r.insertBefore(a, i), a;
}, xq = function(t) {
  if (t.sheet)
    return t.sheet;
  for (var n = document, r = n.styleSheets, a = 0, o = r.length; a < o; a++) {
    var i = r[a];
    if (i.ownerNode === t)
      return i;
  }
  gl(17);
}, kq = function(t) {
  var n = t.isServer, r = t.useCSSOMInjection, a = t.target;
  return n ? new Tq(a) : r ? new Eq(a) : new Pq(a);
}, Eq = /* @__PURE__ */ function() {
  function e(n) {
    var r = this.element = pw(n);
    r.appendChild(document.createTextNode("")), this.sheet = xq(r), this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(r, a) {
    try {
      return this.sheet.insertRule(a, r), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.deleteRule = function(r) {
    this.sheet.deleteRule(r), this.length--;
  }, t.getRule = function(r) {
    var a = this.sheet.cssRules[r];
    return a !== void 0 && typeof a.cssText == "string" ? a.cssText : "";
  }, e;
}(), Pq = /* @__PURE__ */ function() {
  function e(n) {
    var r = this.element = pw(n);
    this.nodes = r.childNodes, this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(r, a) {
    if (r <= this.length && r >= 0) {
      var o = document.createTextNode(a), i = this.nodes[r];
      return this.element.insertBefore(o, i || null), this.length++, !0;
    } else
      return !1;
  }, t.deleteRule = function(r) {
    this.element.removeChild(this.nodes[r]), this.length--;
  }, t.getRule = function(r) {
    return r < this.length ? this.nodes[r].textContent : "";
  }, e;
}(), Tq = /* @__PURE__ */ function() {
  function e(n) {
    this.rules = [], this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(r, a) {
    return r <= this.length ? (this.rules.splice(r, 0, a), this.length++, !0) : !1;
  }, t.deleteRule = function(r) {
    this.rules.splice(r, 1), this.length--;
  }, t.getRule = function(r) {
    return r < this.length ? this.rules[r] : "";
  }, e;
}(), Mq = function(t) {
  return new Oq(t);
}, h3 = 512, Oq = /* @__PURE__ */ function() {
  function e(n) {
    this.groupSizes = new Uint32Array(h3), this.length = h3, this.tag = n;
  }
  var t = e.prototype;
  return t.indexOfGroup = function(r) {
    for (var a = 0, o = 0; o < r; o++)
      a += this.groupSizes[o];
    return a;
  }, t.insertRules = function(r, a) {
    if (r >= this.groupSizes.length) {
      for (var o = this.groupSizes, i = o.length, s = i; r >= s; )
        s <<= 1, s < 0 && gl(16, "" + r);
      this.groupSizes = new Uint32Array(s), this.groupSizes.set(o), this.length = s;
      for (var l = i; l < s; l++)
        this.groupSizes[l] = 0;
    }
    for (var c = this.indexOfGroup(r + 1), u = 0, d = a.length; u < d; u++)
      this.tag.insertRule(c, a[u]) && (this.groupSizes[r]++, c++);
  }, t.clearGroup = function(r) {
    if (r < this.length) {
      var a = this.groupSizes[r], o = this.indexOfGroup(r), i = o + a;
      this.groupSizes[r] = 0;
      for (var s = o; s < i; s++)
        this.tag.deleteRule(o);
    }
  }, t.getGroup = function(r) {
    var a = "";
    if (r >= this.length || this.groupSizes[r] === 0)
      return a;
    for (var o = this.groupSizes[r], i = this.indexOfGroup(r), s = i + o, l = i; l < s; l++)
      a += "" + this.tag.getRule(l) + ny;
    return a;
  }, e;
}(), Aq = 1 << 30, Cd = /* @__PURE__ */ new Map(), oy = /* @__PURE__ */ new Map(), Lf = 1, Wu = function(t) {
  if (Cd.has(t))
    return Cd.get(t);
  var n = Lf++;
  return process.env.NODE_ENV !== "production" && ((n | 0) < 0 || n > Aq) && gl(16, "" + n), Cd.set(t, n), oy.set(n, t), n;
}, Nq = function(t) {
  return oy.get(t);
}, Lq = function(t, n) {
  n >= Lf && (Lf = n + 1), Cd.set(t, n), oy.set(n, t);
}, Rq = "style[" + fl + "][" + uw + '="' + dw + '"]', Dq = new RegExp("^" + fl + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), Iq = function(t) {
  for (var n = t.getTag(), r = n.length, a = "", o = 0; o < r; o++) {
    var i = Nq(o);
    if (i !== void 0) {
      var s = t.names.get(i), l = n.getGroup(o);
      if (!(s === void 0 || l.length === 0)) {
        var c = fl + ".g" + o + '[id="' + i + '"]', u = "";
        s !== void 0 && s.forEach(function(d) {
          d.length > 0 && (u += d + ",");
        }), a += "" + l + c + '{content:"' + u + '"}' + ny;
      }
    }
  }
  return a;
}, jq = function(t, n, r) {
  for (var a = r.split(","), o, i = 0, s = a.length; i < s; i++)
    (o = a[i]) && t.registerName(n, o);
}, Bq = function(t, n) {
  for (var r = n.innerHTML.split(ny), a = [], o = 0, i = r.length; o < i; o++) {
    var s = r[o].trim();
    if (s) {
      var l = s.match(Dq);
      if (l) {
        var c = parseInt(l[1], 10) | 0, u = l[2];
        c !== 0 && (Lq(u, c), jq(t, u, l[3]), t.getTag().insertRules(c, a)), a.length = 0;
      } else
        a.push(s);
    }
  }
}, Fq = function(t) {
  for (var n = document.querySelectorAll(Rq), r = 0, a = n.length; r < a; r++) {
    var o = n[r];
    o && o.getAttribute(fl) !== cw && (Bq(t, o), o.parentNode && o.parentNode.removeChild(o));
  }
}, m3 = ay, f3 = {
  isServer: !ay,
  useCSSOMInjection: !yq
}, hw = /* @__PURE__ */ function() {
  e.registerId = function(r) {
    return Wu(r);
  };
  function e(n, r, a) {
    n === void 0 && (n = f3), r === void 0 && (r = {}), this.options = Ja({}, f3, {}, n), this.gs = r, this.names = new Map(a), !this.options.isServer && ay && m3 && (m3 = !1, Fq(this));
  }
  var t = e.prototype;
  return t.reconstructWithOptions = function(r) {
    return new e(Ja({}, this.options, {}, r), this.gs, this.names);
  }, t.allocateGSInstance = function(r) {
    return this.gs[r] = (this.gs[r] || 0) + 1;
  }, t.getTag = function() {
    return this.tag || (this.tag = Mq(kq(this.options)));
  }, t.hasNameForId = function(r, a) {
    return this.names.has(r) && this.names.get(r).has(a);
  }, t.registerName = function(r, a) {
    if (Wu(r), this.names.has(r))
      this.names.get(r).add(a);
    else {
      var o = /* @__PURE__ */ new Set();
      o.add(a), this.names.set(r, o);
    }
  }, t.insertRules = function(r, a, o) {
    this.registerName(r, a), this.getTag().insertRules(Wu(r), o);
  }, t.clearNames = function(r) {
    this.names.has(r) && this.names.get(r).clear();
  }, t.clearRules = function(r) {
    this.getTag().clearGroup(Wu(r)), this.clearNames(r);
  }, t.clearTag = function() {
    this.tag = void 0;
  }, t.toString = function() {
    return Iq(this);
  }, e;
}(), mw = 5381, ks = function(t, n) {
  for (var r = n.length; r; )
    t = t * 33 ^ n.charCodeAt(--r);
  return t;
}, fw = function(t) {
  return ks(mw, t);
};
function zq(e) {
  var t = "/*|*/", n = t + "}";
  function r(a) {
    if (a)
      try {
        e(a + "}");
      } catch {
      }
  }
  return function(o, i, s, l, c, u, d, p, h, m) {
    switch (o) {
      case 1:
        if (h === 0 && i.charCodeAt(0) === 64)
          return e(i + ";"), "";
        break;
      case 2:
        if (p === 0)
          return i + t;
        break;
      case 3:
        switch (p) {
          case 102:
          case 112:
            return e(s[0] + i), "";
          default:
            return i + (m === 0 ? t : "");
        }
      case -2:
        i.split(n).forEach(r);
    }
  };
}
var Gq = /^\s*\/\/.*$/gm;
function Hq(e) {
  var t = Ji, n = t.options, r = n === void 0 ? Ji : n, a = t.plugins, o = a === void 0 ? pp : a, i = new QZ(r), s = [], l = function(_) {
    if (_ === -2) {
      var v = s;
      return s = [], v;
    }
  }, c = zq(function(g) {
    s.push(g);
  }), u, d, p, h = function(_, v, w) {
    return (
      // the first self-ref is always untouched
      v > 0 && // there should be at least two self-refs to do a replacement (.b > .b)
      w.slice(0, v).indexOf(d) !== -1 && // no consecutive self refs (.b.b); that is a precedence boost and treated differently
      w.slice(v - d.length, v) !== d ? "." + u : _
    );
  }, m = function(_, v, w) {
    _ === 2 && w.length && w[0].lastIndexOf(d) > 0 && (w[0] = w[0].replace(p, h));
  };
  i.use([].concat(o, [m, c, l]));
  function f(g, _, v, w) {
    w === void 0 && (w = "&");
    var x = g.replace(Gq, ""), b = _ && v ? v + " " + _ + " { " + x + " }" : x;
    return u = w, d = _, p = new RegExp("\\" + d + "\\b", "g"), i(v || !_ ? "" : _, b);
  }
  return f.hash = o.length ? o.reduce(function(g, _) {
    return _.name || gl(15), ks(g, _.name);
  }, mw).toString() : "", f;
}
var gw = k.createContext();
gw.Consumer;
var yw = k.createContext();
yw.Consumer;
var Kq = new hw(), vw = Hq();
function Uq() {
  return Ue(gw) || Kq;
}
function $q() {
  return Ue(yw) || vw;
}
var Vq = /* @__PURE__ */ function() {
  function e(n, r) {
    var a = this;
    this.inject = function(o) {
      o.hasNameForId(a.id, a.name) || o.insertRules(a.id, a.name, vw.apply(void 0, a.stringifyArgs));
    }, this.toString = function() {
      return gl(12, String(a.name));
    }, this.name = n, this.id = "sc-keyframes-" + n, this.stringifyArgs = r;
  }
  var t = e.prototype;
  return t.getName = function() {
    return this.name;
  }, e;
}(), Wq = /([A-Z])/g, Yq = /^ms-/;
function g3(e) {
  return e.replace(Wq, "-$1").toLowerCase().replace(Yq, "-ms-");
}
function Zq(e, t) {
  return t == null || typeof t == "boolean" || t === "" ? "" : typeof t == "number" && t !== 0 && !(e in eq) ? t + "px" : String(t).trim();
}
var bw = function(t) {
  return t == null || t === !1 || t === "";
}, qq = function e(t, n) {
  var r = [], a = Object.keys(t);
  return a.forEach(function(o) {
    if (!bw(t[o])) {
      if (ey(t[o]))
        return r.push.apply(r, e(t[o], o)), r;
      if (ku(t[o]))
        return r.push(g3(o) + ":", t[o], ";"), r;
      r.push(g3(o) + ": " + Zq(o, t[o]) + ";");
    }
    return r;
  }), n ? [n + " {"].concat(r, ["}"]) : r;
};
function qs(e, t, n) {
  if (Array.isArray(e)) {
    for (var r = [], a = 0, o = e.length, i; a < o; a += 1)
      i = qs(e[a], t, n), i !== "" && (Array.isArray(i) ? r.push.apply(r, i) : r.push(i));
    return r;
  }
  if (bw(e))
    return "";
  if (ry(e))
    return "." + e.styledComponentId;
  if (ku(e))
    if (gq(e) && t) {
      var s = e(t);
      return process.env.NODE_ENV !== "production" && Jg.isElement(s) && console.warn(ty(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), qs(s, t, n);
    } else
      return e;
  return e instanceof Vq ? n ? (e.inject(n), e.getName()) : e : ey(e) ? qq(e) : e.toString();
}
function Rf(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return ku(e) || ey(e) ? qs(p3(pp, [e].concat(n))) : n.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : qs(p3(e, n));
}
function Df(e, t, n) {
  if (n === void 0 && (n = Ji), !Jg.isValidElementType(t))
    return gl(1, String(t));
  var r = function() {
    return e(t, n, Rf.apply(void 0, arguments));
  };
  return r.withConfig = function(a) {
    return Df(e, t, Ja({}, n, {}, a));
  }, r.attrs = function(a) {
    return Df(e, t, Ja({}, n, {
      attrs: Array.prototype.concat(n.attrs, a).filter(Boolean)
    }));
  }, r;
}
var If = function(t) {
  return typeof t == "function" || typeof t == "object" && t !== null && !Array.isArray(t);
}, Jq = function(t) {
  return t !== "__proto__" && t !== "constructor" && t !== "prototype";
};
function Xq(e, t, n) {
  var r = e[n];
  If(t) && If(r) ? _w(r, t) : e[n] = t;
}
function _w(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  for (var a = 0, o = n; a < o.length; a++) {
    var i = o[a];
    if (If(i))
      for (var s in i)
        Jq(s) && Xq(e, i[s], s);
  }
  return e;
}
var Qq = /(a)(d)/gi, Yu = 52, y3 = function(t) {
  return String.fromCharCode(t + (t > 25 ? 39 : 97));
};
function jf(e) {
  var t = "", n;
  for (n = Math.abs(e); n > Yu; n = n / Yu | 0)
    t = y3(n % Yu) + t;
  return (y3(n % Yu) + t).replace(Qq, "$1-$2");
}
function eJ(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (ku(n) && !ry(n))
      return !1;
  }
  return !0;
}
var tJ = /* @__PURE__ */ function() {
  function e(n, r) {
    this.rules = n, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && eJ(n), this.componentId = r, this.baseHash = fw(r), hw.registerId(r);
  }
  var t = e.prototype;
  return t.generateAndInjectStyles = function(r, a, o) {
    var i = this.componentId;
    if (this.isStatic && !o.hash) {
      if (this.staticRulesId && a.hasNameForId(i, this.staticRulesId))
        return this.staticRulesId;
      var s = qs(this.rules, r, a).join(""), l = jf(ks(this.baseHash, s.length) >>> 0);
      if (!a.hasNameForId(i, l)) {
        var c = o(s, "." + l, void 0, i);
        a.insertRules(i, l, c);
      }
      return this.staticRulesId = l, l;
    } else {
      for (var u = this.rules.length, d = ks(this.baseHash, o.hash), p = "", h = 0; h < u; h++) {
        var m = this.rules[h];
        if (typeof m == "string")
          p += m, process.env.NODE_ENV !== "production" && (d = ks(d, m + h));
        else {
          var f = qs(m, r, a), g = Array.isArray(f) ? f.join("") : f;
          d = ks(d, g + h), p += g;
        }
      }
      var _ = jf(d >>> 0);
      if (!a.hasNameForId(i, _)) {
        var v = o(p, "." + _, void 0, i);
        a.insertRules(i, _, v);
      }
      return _;
    }
  }, e;
}(), v3 = 200, rJ = function(e, t) {
  var n = {}, r = !1;
  return function(a) {
    if (!r && (n[a] = !0, Object.keys(n).length >= v3)) {
      var o = t ? ' with the id of "' + t + '"' : "";
      console.warn("Over " + v3 + " classes were generated for component " + e + o + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), r = !0, n = {};
    }
  };
}, nJ = /invalid hook call/i, $m = /* @__PURE__ */ new Set(), aJ = function(t, n) {
  if (process.env.NODE_ENV !== "production") {
    var r = n ? ' with the id of "' + n + '"' : "", a = "The component " + t + r + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`;
    try {
      _e(), $m.has(a) || (console.warn(a), $m.add(a));
    } catch (o) {
      nJ.test(o.message) && $m.delete(a);
    }
  }
}, oJ = function(e, t, n) {
  return n === void 0 && (n = Ji), e.theme !== n.theme && e.theme || t || n.theme;
}, iJ = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, sJ = /(^-|-$)/g;
function Bf(e) {
  return e.replace(iJ, "-").replace(sJ, "");
}
function hp(e) {
  return typeof e == "string" && (process.env.NODE_ENV !== "production" ? e.charAt(0) === e.charAt(0).toLowerCase() : !0);
}
function lJ(e) {
  return hp(e) ? "styled." + e : "Styled(" + ty(e) + ")";
}
var cJ = function(e) {
  return jf(fw(e) >>> 0);
};
function uJ(e, t) {
  return e && t ? e + " " + t : e || t;
}
var ww = k.createContext();
ww.Consumer;
var Vm = {};
function dJ(e, t) {
  var n = typeof e != "string" ? "sc" : Bf(e);
  Vm[n] = (Vm[n] || 0) + 1;
  var r = n + "-" + cJ(n + Vm[n]);
  return t ? t + "-" + r : r;
}
function pJ(e, t, n) {
  e === void 0 && (e = Ji);
  var r = Ja({}, t, {
    theme: e
  }), a = {};
  return n.forEach(function(o) {
    var i = o, s;
    ku(i) && (i = i(r));
    for (s in i)
      r[s] = a[s] = s === "className" ? uJ(a[s], i[s]) : i[s];
  }), [r, a];
}
function hJ(e, t, n, r) {
  var a = Uq(), o = $q(), i = e.isStatic && !t, s = i ? e.generateAndInjectStyles(Ji, a, o) : e.generateAndInjectStyles(n, a, o);
  return G_(s), process.env.NODE_ENV !== "production" && !i && r && r(s), s;
}
function mJ(e, t, n) {
  var r = e.attrs, a = e.componentStyle, o = e.defaultProps, i = e.foldedComponentIds, s = e.shouldForwardProp, l = e.styledComponentId, c = e.target;
  G_(l);
  var u = oJ(t, Ue(ww), o), d = pJ(u || Ji, t, r), p = d[0], h = d[1], m = hJ(a, r.length > 0, p, process.env.NODE_ENV !== "production" ? e.warnTooManyClasses : void 0), f = n, g = h.$as || t.$as || h.as || t.as || c, _ = hp(g), v = h !== t ? Ja({}, t, {}, h) : t, w = s || _ && i3, x = {};
  for (var b in v)
    b[0] === "$" || b === "as" || (b === "forwardedAs" ? x.as = v[b] : (!w || w(b, i3)) && (x[b] = v[b]));
  return t.style && h.style !== t.style && (x.style = Ja({}, t.style, {}, h.style)), x.className = Array.prototype.concat(i, l, m !== l ? m : null, t.className, h.className).filter(Boolean).join(" "), x.ref = f, Ho(g, x);
}
function Sw(e, t, n) {
  var r = ry(e), a = !hp(e), o = t.displayName, i = o === void 0 ? lJ(e) : o, s = t.componentId, l = s === void 0 ? dJ(t.displayName, t.parentComponentId) : s, c = t.attrs, u = c === void 0 ? pp : c, d = t.displayName && t.componentId ? Bf(t.displayName) + "-" + t.componentId : t.componentId || l, p = (
    // $FlowFixMe
    r && e.attrs ? Array.prototype.concat(e.attrs, u).filter(Boolean) : u
  ), h = t.shouldForwardProp;
  r && e.shouldForwardProp && (h ? h = function(v, w) {
    return (
      // $FlowFixMe
      e.shouldForwardProp(v, w) && t.shouldForwardProp(v, w)
    );
  } : h = e.shouldForwardProp);
  var m = new tJ(r ? (
    // fold the underlying StyledComponent rules up (implicit extend)
    // $FlowFixMe
    e.componentStyle.rules.concat(n)
  ) : n, d), f, g = function(v, w) {
    return mJ(f, v, w);
  };
  return g.displayName = i, f = k.forwardRef(g), f.attrs = p, f.componentStyle = m, f.displayName = i, f.shouldForwardProp = h, f.foldedComponentIds = r ? (
    // $FlowFixMe
    Array.prototype.concat(e.foldedComponentIds, e.styledComponentId)
  ) : pp, f.styledComponentId = d, f.target = r ? (
    // $FlowFixMe
    e.target
  ) : e, f.withComponent = function(v) {
    var w = t.componentId, x = fq(t, ["componentId"]), b = w && w + "-" + (hp(v) ? v : Bf(ty(v))), C = Ja({}, x, {
      attrs: p,
      componentId: b
    });
    return Sw(v, C, n);
  }, Object.defineProperty(f, "defaultProps", {
    get: function() {
      return this._foldedDefaultProps;
    },
    set: function(v) {
      this._foldedDefaultProps = r ? _w({}, e.defaultProps, v) : v;
    }
  }), process.env.NODE_ENV !== "production" && (aJ(i, d), f.warnTooManyClasses = rJ(i, d)), f.toString = function() {
    return "." + f.styledComponentId;
  }, a && mq(f, e, {
    // all SC-specific things should not be hoisted
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    self: !0,
    styledComponentId: !0,
    target: !0,
    withComponent: !0
  }), f;
}
var fJ = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], zc = function(t) {
  return Df(Sw, t);
};
fJ.forEach(function(e) {
  zc[e] = zc(e);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles not rendering properly, errors happening during rehydration process, missing theme prop, and makes your application bigger without a good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
function Cw() {
  var e = xu([`
  color: #c9444d;
  font-size: 0.75rem;
  margin-top: 0.25rem;

  & {
    `, `;
  }
`]);
  return Cw = function() {
    return e;
  }, e;
}
function xw() {
  var e = xu([`
        border-color: #444bc9;
        box-shadow: #444bc9 0px 0px 0px 1px;
        `, `;
      `]);
  return xw = function() {
    return e;
  }, e;
}
function kw() {
  var e = xu([`
        border-color: #c9444d;
        box-shadow: #c9444d 0px 0px 0px 1px;
        `, `;
      `]);
  return kw = function() {
    return e;
  }, e;
}
function Ew() {
  var e = xu([`
  align-items: center;
  background-color: white;
  border: 1px solid #bdbdbd;
  box-shadow: inset 0px 1px 2px #e5e5e5;
  border-radius: 0.2em;
  display: flex;
  height: 2.5em;
  padding: 0.4em 0.6em;

  & {
    `, `;
  }

  & {
    `, `;
  }

  & input {
    border: unset;
    margin: unset;
    padding: unset;
    outline: unset;
    font-size: inherit;

    & {
      `, `;
    }

    `, `;
  }

  & svg {
    margin-right: 0.6em;
    & {
      `, `;
    }
  }

  & input#cardNumber {
    width: 11em;
    & {
      `, `;
    }
  }

  & input#expiryDate {
    width: 4em;
    & {
      `, `;
    }
  }

  & input#cvc {
    width: 2.5em;
    & {
      `, `;
    }
  }

  & input#zip {
    width: 4em;
    & {
      `, `;
    }
  }

  `, `;
`]);
  return Ew = function() {
    return e;
  }, e;
}
function Pw() {
  var e = xu([`
  display: inline-flex;
  flex-direction: column;

  & {
    `, `;
  }

  `, `;
`]);
  return Pw = function() {
    return e;
  }, e;
}
zc.div(Pw(), function(e) {
  return e.hasErrored && e.styles.fieldWrapper ? e.styles.fieldWrapper.errored : void 0;
}, function(e) {
  return e.styles.fieldWrapper ? e.styles.fieldWrapper.base : void 0;
});
zc.div(Ew(), function(e) {
  return e.hasErrored && Rf(kw(), function(t) {
    return t.styles.inputWrapper && t.styles.inputWrapper.errored;
  });
}, function(e) {
  return e.focused && Rf(xw(), function(t) {
    return t.styles.inputWrapper && t.styles.inputWrapper.focused;
  });
}, function(e) {
  return e.hasErrored && e.styles.input ? e.styles.input.errored : void 0;
}, function(e) {
  return e.styles.input && e.styles.input.base;
}, function(e) {
  return e.styles.cardImage;
}, function(e) {
  return e.styles.input && e.styles.input.cardNumber;
}, function(e) {
  return e.styles.input && e.styles.input.expiryDate;
}, function(e) {
  return e.styles.input && e.styles.input.cvc;
}, function(e) {
  return e.styles.input && e.styles.input.zip;
}, function(e) {
  return e.styles.inputWrapper ? e.styles.inputWrapper.base : void 0;
});
zc.div(Cw(), function(e) {
  return e.styles.errorText ? e.styles.errorText.base : void 0;
});
var gJ = k.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, k.createElement("g", {
  id: "New-Icons",
  transform: "translate(-80.000000, -280.000000)",
  fillRule: "nonzero"
}, k.createElement("g", {
  id: "Card-Brands",
  transform: "translate(40.000000, 200.000000)"
}, k.createElement("g", {
  id: "Color",
  transform: "translate(0.000000, 80.000000)"
}, k.createElement("g", {
  id: "Visa",
  transform: "translate(40.000000, 0.000000)"
}, k.createElement("rect", {
  strokeOpacity: "0.2",
  stroke: "#000000",
  strokeWidth: "0.5",
  fill: "#FFFFFF",
  x: "0.25",
  y: "0.25",
  width: "23.5",
  height: "15.5",
  rx: "2"
}), k.createElement("path", {
  d: "M2.78773262,5.91443732 C2.26459089,5.62750595 1.6675389,5.39673777 1,5.23659312 L1.0280005,5.1118821 L3.76497922,5.1118821 C4.13596254,5.12488556 4.43699113,5.23650585 4.53494636,5.63071135 L5.12976697,8.46659052 L5.31198338,9.32072617 L6.97796639,5.1118821 L8.77678896,5.1118821 L6.10288111,11.2775284 L4.30396552,11.2775284 L2.78773262,5.91443732 L2.78773262,5.91443732 Z M10.0999752,11.2840738 L8.39882877,11.2840738 L9.46284763,5.1118821 L11.163901,5.1118821 L10.0999752,11.2840738 Z M16.2667821,5.26277458 L16.0354292,6.59558538 L15.881566,6.53004446 C15.5737466,6.40524617 15.1674138,6.28053516 14.6143808,6.29371316 C13.942741,6.29371316 13.6415263,6.56277129 13.6345494,6.82545859 C13.6345494,7.11441463 13.998928,7.3048411 14.5939153,7.58725177 C15.5740257,8.02718756 16.0286384,8.56556562 16.0218476,9.26818871 C16.0080799,10.5486366 14.8460128,11.376058 13.0610509,11.376058 C12.2978746,11.3694253 11.5627918,11.2180965 11.163808,11.0475679 L11.4018587,9.66204513 L11.6258627,9.76066195 C12.1788958,9.99070971 12.5428092,10.0889775 13.221984,10.0889775 C13.7117601,10.0889775 14.2368857,9.89837643 14.2435835,9.48488392 C14.2435835,9.21565125 14.0198586,9.01850486 13.3617074,8.7164581 C12.717789,8.42086943 11.8568435,7.92848346 11.8707973,7.04197926 C11.8780532,5.84042483 13.0610509,5 14.7409877,5 C15.3990458,5 15.9312413,5.13788902 16.2667821,5.26277458 Z M18.5277524,9.0974856 L19.941731,9.0974856 C19.8717762,8.78889347 19.549631,7.31147374 19.549631,7.31147374 L19.4307452,6.77964104 C19.3467437,7.00942698 19.1998574,7.38373457 19.2069273,7.37055657 C19.2069273,7.37055657 18.6678479,8.74290137 18.5277524,9.0974856 Z M20.6276036,5.1118821 L22,11.2839865 L20.4249023,11.2839865 C20.4249023,11.2839865 20.2707601,10.5748181 20.221922,10.3581228 L18.0377903,10.3581228 C17.9746264,10.5221933 17.6807607,11.2839865 17.6807607,11.2839865 L15.8957988,11.2839865 L18.4226343,5.62399144 C18.5977072,5.22341512 18.9059917,5.1118821 19.3117663,5.1118821 L20.6276036,5.1118821 L20.6276036,5.1118821 Z",
  id: "Shape",
  fill: "#171E6C"
})))))), yJ = k.createElement("g", {
  fill: "none"
}, k.createElement("path", {
  d: "m4.54588254.00006676h5.79377466c.8087588 0 1.3117793.72566459 1.1231113 1.61890981l-2.69741608 12.74856503c-.19036262.8901361-1.00010994 1.6164225-1.80943362 1.6164225h-5.79320976c-.80762905 0-1.31177937-.7262864-1.12311135-1.6164225l2.69854581-12.74856503c.18866803-.89324522.9979917-1.61890981 1.80773904-1.61890981",
  fill: "#dd2423"
}), k.createElement("path", {
  d: "m9.85756516.00006676h6.66269264c.8086174 0 .4439911.72566459.2537697 1.61890981l-2.6969924 12.74856503c-.1892329.8901361-.1302036 1.6164225-.9405158 1.6164225h-6.66269248c-.81031221 0-1.31177939-.7262864-1.12141672-1.6164225l2.69685116-12.74856503c.19149238-.89324522.99912144-1.61890981 1.8083039-1.61890981",
  fill: "#16315e"
}), k.createElement("path", {
  d: "m16.2559813.00006676h5.7937745c.8098886 0 1.3129092.72566459 1.1226878 1.61890981l-2.6969924 12.74856503c-.1903626.8901361-1.0006749 1.6164225-1.8104222 1.6164225h-5.7910915c-.8103122 0-1.3129091-.7262864-1.1231113-1.6164225l2.697416-12.74856503c.1886681-.89324522.9974268-1.61890981 1.8077391-1.61890981",
  fill: "#036862"
}), k.createElement("path", {
  d: "m6.05901135 4.08561434c-.59580116.00668457-.77175951 0-.8279645-.01461278-.02160646.11301588-.42365577 2.15460824-.42478553 2.15631824-.08656699.4130443-.14955043.7074763-.36349659.89759795-.12144798.1105286-.26323144.1638497-.42760986.1638497-.26421996 0-.41814822-.1444178-.44399122-.41832975l-.00494264-.09405035s.08049458-.55326485.08049458-.55637395c0 0 .42196112-1.86048711.49751306-2.10641713.00395412-.01399096.00508387-.02129736.00607239-.02798193-.82132725.00792821-.9669236 0-.97695012-.01461278-.00550753.02005371-.025843.13540142-.025843.13540142l-.43085788 2.09693437-.03699927.1778407-.07159782.5817131c0 .1725552.03078565.31339755.09207452.4324762.19629382.37760055.75622549.4341862 1.07297875.4341862.40812169 0 .79096525-.09544945 1.04967767-.26971465.44907509-.2921002.56656897-.74867195.67135315-1.15440985l.04857917-.20815445s.43467082-1.93230737.5085281-2.18367833c.00282441-.01399096.00395413-.02129736.00776704-.02798193zm1.47893982 1.55881086c-.10478422 0-.29627659.0279819-.46828081.12078865-.0624186.0352883-.12144796.07601755-.18372539.11659135l.056205-.22338905-.03078563-.03762015c-.36476761.08130305-.44639193.0921849-.78333945.14441785l-.02824374.0206755c-.03911752.3570805-.07385733.6255515-.21888878 1.32743145-.05521646.25867735-.11255121.519842-.17002718.7778975l.01553403.03280105c.34527946-.0200537.45006363-.0200537.75015309-.0146128l.02428961-.0290701c.03812903-.21499445.04307165-.2653619.12752039-.70079175.03968242-.20644445.1224365-.66006255.16324868-.8215804.07498704-.038242.14898558-.07586215.21959486-.07586215.16819135 0 .14771465.1615179.14121858.22587635-.00720213.1080413-.06849101.4609245-.13133325.76390655l-.04194194.19556255c-.02923223.14441785-.06128888.2847938-.09052111.427968l.01270966.02860375c.34033679-.0200537.44413246-.0200537.73476028-.0146128l.0341749-.0290701c.0525333-.3357831.06792611-.42563615.16113038-.9145426l.04688457-.22463265c.09108601-.43962715.13684082-.6625498.06792616-.8441214-.07286879-.2034908-.24769738-.2526146-.40826291-.2526146zm1.65214439.4602871c-.18090101.038242-.29627659.0637366-.41094606.08021485-.11368097.02005375-.22453757.038242-.39936616.06498025l-.01383941.0138355-.01270966.01103735c-.01821719.14332965-.0309269.26722735-.05507525.41288885-.02047669.150636-.05196844.3217921-.10323077.56772215-.03968243.18825615-.06015913.25385825-.08275412.32008215-.0220301.06622385-.04631967.1305823-.09094476.31572935l.01045019.0171001.00875554.01570095c.1633899-.00855005.27029237-.0146128.38016043-.01570095.10972684-.00435275.22340776 0 .39936611.00108815l.01539286-.0138355.01652257-.0152346c.02541932-.1669588.02923224-.21188535.04476626-.29334385.01539282-.0873658.04194194-.20830985.10704369-.53134565.03078568-.1517242.06510179-.30298205.09701718-.4578154.03318641-.1542115.06792612-.30609115.10097127-.45781535l-.00494263-.0183437zm.00385525-.620608c-.1643784-.10679765-.45288796-.07290845-.64706354.0746185-.19361063.14457325-.21564072.34977405-.05182718.4579708.16155403.10384405.45119334.0729085.64367421-.0758621.19318708-.14768235.21733543-.3510177.05521651-.4567272zm.99410809 2.473369c.3325698 0 .6734715-.1008904.9300657-.400297.1974235-.2428209.2879446-.60409865.3192952-.7528692.1021011-.4931037.0225949-.7233328-.0772466-.8635533-.1516687-.21375085-.4197016-.28230655-.697761-.28230655-.1672028 0-.5654392.01818825-.87654364.33391765-.22340786.22774175-.32663863.5367866-.38891601.83308405-.06284224.3018939-.13514621.84536505.31887154 1.0476122.14008884.0662239.34203141.08441215.47223481.08441215zm-.0259841-1.10948335c.0766817-.3734032.1672028-.6868008.3982364-.6868008.1810422 0 .1941755.23318275.1136809.6078296-.0144042.0831685-.0804945.3923688-.1698859.5240393-.0624186.09715945-.1362759.15607695-.2179003.15607695-.0242896 0-.1687562 0-.1710157-.23613635-.0011297-.11659135.0204767-.23567.0468846-.3650087zm2.1066988 1.06146325.0259841-.0290701c.0368581-.21499445.0429305-.2655174.1245549-.70079175.0408121-.20644445.1252608-.66006255.1649433-.82158045.0751282-.0383974.1478558-.07601755.2207245-.07601755.1670616 0 .1467262.1615179.140089.2258763-.0060725.1081968-.0673613.4609245-.1313334.76390655l-.0396824.1955626c-.030362.14457325-.0634071.2847938-.0926394.42812345l.0127097.02860375c.3414665-.02005375.441308-.02005375.7336305-.0146128l.0353047-.0290701c.0512623-.33593855.0651017-.42579165.1611304-.9145426l.0457548-.2247881c.0915096-.43962715.1378292-.66239435.0700444-.84396595-.0749871-.2034908-.2509454-.2526146-.4092515-.2526146-.1049254 0-.2974063.02782645-.468422.12078865-.0611476.0352883-.1224365.0758621-.1825956.11659135l.0523921-.22338905-.0281025-.0377756c-.3646263.0814585-.4479453.09234035-.7844692.1445733l-.025843.0206755c-.0408122.35708045-.0739986.62539605-.21903 1.32743145-.0552164.25867735-.1125512.51984195-.1698859.7778975l.0153928.03280105c.3458442-.02005375.4490751-.02005375.7485997-.0146128zm2.5088186.01453505c.0214652-.1153477.1489856-.7990394.1501153-.7990394 0 0 .1085971-.50165375.1152345-.519842 0 0 .0341748-.0522329.0683497-.07290845h.0502738c.4743532 0 1.0099953 0 1.4298381-.3399804.2856852-.2331827.4809905-.57751585.5681223-.99600105.022595-.1026004.0392588-.22463269.0392588-.34666496 0-.16027425-.0292322-.3188385-.1136809-.44273624-.2140874-.32972035-.6404262-.3357831-1.132573-.33827039-.0015534 0-.2426136.00248729-.2426136.00248729-.629976.00855003-.8826161.00606275-.9864117-.00792821-.0087556.05052291-.0252782.14037599-.0252782.14037599s-.2256673 1.15130077-.2256673 1.15316622c0 0-.5400198 2.4477966-.5654392 2.5631443.5500464-.00730635.7755725-.00730635.8704714.0041973zm.4181482-2.0451678s.2399304-1.14896892.2388007-1.14461618l.0077669-.05891749.0033893-.04492654.0958874.01088185s.4948299.046792.5064099.04803565c.1953052.0831685.2757998.29754113.2195948.57736036-.0512623.2557237-.2019425.4707182-.3955532.5745622-.1594358.0879876-.3547411.095294-.5559775.095294h-.1302035zm1.4938667.99045135c-.0634072.2975411-.136276.8410123.3154822 1.0347094.1440429.0674675.2731167.0875212.4043088.08021485.1385355-.00823915.2669031-.08472305.3858092-.1947853-.0107326.04523745-.0214652.0904749-.0321978.1358678l.0204766.0290701c.324944-.01507915.4257741-.01507915.7778319-.0121255l.0319154-.0267383c.0514036-.332674.0998416-.65570975.2334344-1.2921431.0651017-.30484755.1300622-.6067414.1968587-.9103453l-.0104501-.03342285c-.3634967.0741521-.4606551.09000855-.8103124.1445733l-.026549.0237846c-.0035305.0309356-.0072021.0606275-.0105914.09031945-.0543692-.0966931-.1331691-.17923975-.2547583-.2306954-.1554817-.0673121-.5206729.01943185-.8346018.33407305-.2205834.2246327-.3264973.53243385-.3866564.8276432zm.7634275.01818825c.0778115-.3667187.1672028-.67700715.3988014-.67700715.1464436 0 .2235489.14877055.2078737.40247335-.0124272.06327025-.025843.1299605-.0418008.20535625-.0231597.10897405-.0482967.21701535-.0727275.32521215-.0248545.07399665-.0538043.143796-.0855784.1902771-.0595943.09296215-.2013777.150636-.2830021.150636-.0231599 0-.1660731 0-.1710157-.23193905-.0011298-.11550315.0204767-.23442635.0474494-.36500865zm3.9866711-1.21085565-.0281024-.0352883c-.3596838.08021485-.4247856.09296215-.755237.142086l-.0242897.02673825c-.0011296.00435275-.0021182.01103735-.0038128.0171001l-.0011298-.00606275c-.2460027.6247742-.2388006.4899946-.4390485.98185465-.0011298-.02238555-.0011298-.0363765-.0022595-.06016115l-.0501327-1.0662668-.0314917-.0352883c-.3767711.08021485-.3856679.09296215-.7336305.142086l-.0271139.02673825c-.003813.01274735-.003813.0267383-.0060724.0419729l.0022594.00544095c.0434954.2446864.0330452.19012165.0766818.5762722.0203354.1894998.0474494.3800878.0677848.5672558.0343162.3132421.0535219.4674536.0954638.94547815-.2349878.4268798-.2906279.5883977-.51686.9630446l.0015534.0037309-.1592946.27733195c-.0182171.0292256-.0347397.0492793-.0578996.05782935-.0254193.0138355-.0584644.01632275-.1043605.01632275h-.0882616l-.131192.4803564.4500635.00855005c.26422-.00124365.4302931-.1372669.5196844-.32008215l.283002-.53383295h-.004519l.0297972-.03762015c.1903626-.4511308 1.6384179-3.1855867 1.6384179-3.1855867zm-4.7501128 6.3087581h-.1909276l.7066579-2.57293795h.2344228l.0744221-.265051.0072022.29474295c-.0087556.1821934.121448.3437113.4634794.31697305h.3955532l.1361347-.49543555h-.1488443c-.0855785 0-.1252609-.02378465-.1203182-.0747739l-.0072022-.299873h-.7325008v.00155455c-.2368235.00544095-.9440462.0250283-1.0872418.0670012-.1732752.0491238-.3558709.1936971-.3558709.1936971l.071739-.26536195h-.6851925l-.1427719.52652655-.7161194 2.61226815h-.1389591l-.136276.4918601h1.3647364l-.0457548.1640051h.6724828l.0446251-.1640051h.1886681zm-.5599316-2.0501423c-.1097268.03342285-.313929.1347796-.313929.1347796l.1816071-.65757525h.5443977l-.1313333.47911275s-.1681914.01088185-.2807425.0436829zm.0104502.9394154s-.1710158.0236292-.283567.0516111c-.1108566.0369984-.3187303.1535897-.3187303.1535897l.1875382-.6843135h.5472221zm-.3050322 1.1167897h-.5460922l.158306-.5775158h.5443976zm1.315112-1.5959024h.7871525l-.1131162.4032506h-.7976024l-.1197535.4408708h.6979023l-.5284398.8190931c-.0369994.0601612-.0701858.0814585-.1070437.0984031-.0369994.0206755-.0855785.0449265-.1417835.0449265h-.1936107l-.133028.4828437h.5064098c.2632315 0 .4187131-.131826.5335239-.3048476l.3623669-.5459584.0778115.5543531c.0165225.1038439.0843074.1646269.1302034.1882561.0506975.0279819.1030897.0760176.1770882.0831685.0793648.0037309.1366995.0066846.1748285.0066846h.2488272l.1494092-.5403621h-.0981469c-.0563463 0-.1533633-.0104155-.1698859-.0298474-.0165226-.0236292-.0165226-.0600057-.0254194-.1153477l-.0789412-.5555967h-.3232494l.1417836-.1857688h.796049l.1224365-.4408708h-.7370197l.1148107-.4032506h.7347603l.1362759-.497301h-2.1905826zm-6.6483163 1.7081877.1837253-.6728098h.7550958l.1379705-.5004101h-.7558018l.1153756-.4141325h.7385731l.1368408-.4845537h-1.84798632l-.13401641.4845537h.41984283l-.1119863.4141325h-.42097264l-.13952389.5089601h.41970155l-.24487301.8901361c-.03304514.117835.01553408.1627615.04631971.2174817.03149175.0533211.06340718.0886094.13514621.1086631.07399857.0181883.12469597.0290701.19361067.0290701h.8512656l.1516688-.554353-.3773361.0570521c-.0728688 0-.2746701-.0096382-.25264-.0837903zm.0866093-3.22084395-.1913512.38070965c-.0409534.08316845-.0778114.1347796-.1109978.1585642-.0292322.02005375-.0871318.0284483-.1710157.0284483h-.0998415l-.13345158.48704095h.33158128c.1594357 0 .2818722-.0643584.3403368-.09653765.0628422-.0369983.0793647-.0158564.1279439-.0674675l.1119864-.1067977h1.0354146l.1374057-.50709465h-.7579202l.1323219-.2768656zm1.5286064 3.23062205c-.0176524-.027982-.0049427-.0772612.0220301-.1798616l.283002-1.0311339h1.0067472c.1467262-.0023318.25264-.0041973.3215547-.0096382.0739985-.0085501.1544932-.0376202.2421899-.0898531.0905212-.0547202.1368408-.1123941.1759583-.178618.0436366-.0660684.113681-.2106417.1738401-.4335643l.3557296-1.3048905-1.044735.0066846s-.3216959.0522329-.4633381.10990675c-.1429132.06435845-.3471154.2440646-.3471154.2440646l.0943341-.3577023h-.645369l-.9035164 3.29860265c-.0320566.1280949-.0535218.2210571-.0584645.2768655-.0016946.0601612.0689147.1197005.1146695.164627.0540867.0449266.1340164.0376202.2106981.0449266.0806358.0066846.1953053.0108818.3536113.0108818h.4959597l.1522336-.5658567-.4439912.0461702c-.0474494 0-.0817655-.027982-.0960286-.0516111zm.4876277-1.9074346h1.0574447l-.06722.2319391c-.0094616.0054409-.0320566-.0115037-.1396652.0024873h-.9156612zm.2118279-.77789745h1.0663414l-.0766816.27935285s-.5025969-.0054409-.5830915.01088185c-.3541763.06746755-.5610614.27577745-.5610614.27577745zm.802065 1.78653705c-.0087555.0346665-.0225949.0558084-.0419418.0716648-.0214654.0152346-.0562051.0206755-.1080323.0206755h-.1506803l.0088968-.2824619h-.626728l-.0254193 1.380908c-.0009886.0996467.007767.1573206.0739985.2034908.0662315.0576738.2702923.0649802.5449624.0649802h.392729l.1417834-.5168883-.3418902.0206755-.1136809.0073064c-.0155341-.0073064-.030362-.013991-.0468846-.0321792-.0144043-.015701-.0386939-.0060627-.0347398-.1057095l.0026831-.3539713.3585541-.0163228c.1936107 0 .2763648-.0693331.346974-.1354015.0673612-.0632702.0893913-.1360232.1148107-.2344264l.0601592-.3133975h-.4927118z",
  fill: "#fefefe"
})), vJ = k.createElement("g", null, k.createElement("path", {
  transform: "scale(0.6)",
  d: "m33.6 24h-31.2c-1.325 0-2.4-1.075-2.4-2.4v-19.2c0-1.325 1.075-2.4 2.4-2.4h31.2c1.325 0 2.4 1.075 2.4 2.4v19.2c0 1.325-1.075 2.4-2.4 2.4zm-8.689-15.321c-.07-.002-.151-.004-.233-.004-.213 0-.424.01-.632.028l.027-.002c-.01.03.542 1.996 1.066 3.83l.064.224c1.114 3.896 1.114 3.896.937 4.274-.153.313-.392.565-.686.729l-.008.004-.231.116-.994.019c-.96.02-.998.024-1.12.111-.228.164-.315.425-.489 1.467-.09.55-.16.982-.16 1.006.148.031.318.049.492.049.084 0 .167-.004.249-.012l-.01.001c.214 0 .48 0 .812-.006.17.016.367.025.566.025.484 0 .956-.054 1.409-.157l-.043.008c1.072-.313 1.958-.975 2.55-1.852l.01-.016c.197-.286 5.257-9.732 5.257-9.814-.167-.024-.359-.038-.555-.038-.09 0-.178.003-.267.009l.012-.001h-.594l-1.4.011-.266.132c-.149.071-.277.163-.385.274-.067.08-.528 1.088-1.12 2.445-.344.887-.691 1.622-1.083 2.33l.049-.096c-.022-.046-.218-1.266-.378-2.282-.187-1.218-.366-2.27-.4-2.346-.065-.168-.191-.3-.349-.372l-.004-.002c-.151-.08-.223-.08-1.539-.095h-.553zm-3.77.131c-.043 0-.052.027-.062.071-.027.123-.418 2.354-.418 2.386.042.047.092.087.148.117l.003.001c.41.281.69.725.746 1.237l.001.008c.003.04.005.087.005.134 0 .787-.538 1.448-1.266 1.637l-.012.003c-.136.032-.19.067-.203.131-.035.168-.418 2.357-.418 2.39 0 .006.023.015.179.015.07 0 .16 0 .25-.007 1.958-.11 3.55-1.545 3.9-3.417l.004-.026c.026-.2.041-.431.041-.665 0-.321-.028-.636-.082-.942l.005.032c-.291-1.35-1.207-2.439-2.423-2.964l-.027-.01c-.108-.056-.232-.101-.364-.129l-.01-.002zm-16.966-.136c-.167 0-.603 0-.612.008s-.025.13-.058.32l-.137.758c-.104.588-.179 1.074-.167 1.082s.32.012.621.012h.596l-.012.091c0 .026-.037.211-.085.489l-.185 1.058c-.172.615-.271 1.322-.271 2.051 0 .156.005.31.013.464l-.001-.021c.182 1.082 1.114 1.766 2.624 1.925.198.021.466.031.701.031.038.003.081.004.125.004.138 0 .273-.016.403-.046l-.012.002c.022-.027.413-2.182.418-2.306 0-.052-.069-.068-.386-.088-.778-.043-1.126-.297-1.126-.823 0-.16.367-2.381.457-2.763.013-.059.032-.075.433-.075h.606c.053.003.116.004.179.004.174 0 .344-.012.512-.034l-.019.002c.025-.042.378-2 .378-2.099 0-.037-.198-.047-.847-.047h-.846l.107-.609c.195-1.063.149-1.32-.278-1.527-.214-.107-.231-.107-1.152-.123l-.953-.012-.024.111c-.012.064-.096.525-.183 1.03s-.171.96-.183 1.022l-.024.112zm6-.008-.025.111c-.04.186-1.415 8.014-1.415 8.053.294.026.637.042.983.042.135 0 .27-.002.404-.007l-.019.001h1.369l.04-.21c.025-.111.16-.871.302-1.686.14-.8.297-1.6.342-1.75.238-.867.892-1.541 1.727-1.805l.018-.005c.2-.061.43-.096.668-.096.056 0 .111.002.165.006h-.007c.499 0 .53-.005.545-.08.045-.195.452-2.57.445-2.593-.066-.021-.141-.034-.22-.034-.024 0-.048.001-.072.003h.003c-.006 0-.014 0-.021 0-.16 0-.317.013-.47.038l.017-.002c-.622.133-1.164.417-1.603.813l.003-.003c-.292.27-.546.576-.756.912l-.011.019c-.022.056-.054.104-.094.144.015-.157.037-.297.066-.435l-.004.024c.166-.885.076-1.192-.4-1.371-.269-.047-.578-.074-.894-.074-.058 0-.115.001-.173.003h.008zm9.704-.026h-.141c-.236 0-.467.022-.691.064l.023-.004c-1.274.263-2.314 1.086-2.869 2.195l-.011.024c-.272.488-.432 1.07-.432 1.689 0 .051.001.101.003.151v-.007c-.001.041-.002.09-.002.139 0 .262.024.518.069.767l-.004-.026c.249 1.142.939 2.09 1.879 2.674l.018.01c.276.177.595.325.933.427l.027.007c.025-.018.139-.633.247-1.233l.218-1.213-.103-.08c-.27-.187-.487-.434-.635-.721l-.005-.011c-.099-.162-.157-.359-.157-.569 0-.052.004-.103.01-.153l-.001.006c-.006-.044-.009-.095-.009-.147 0-.2.051-.387.14-.551l-.003.006c.228-.47.651-.815 1.161-.931l.011-.002c.08-.008.151-.031.151-.052 0-.054.4-2.314.422-2.394-.015-.056-.07-.064-.249-.064z"
})), bJ = k.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, k.createElement("g", null, k.createElement("rect", {
  id: "Rectangle",
  fill: "#D8D8D8",
  x: "0",
  y: "0",
  width: "24",
  height: "16",
  rx: "1"
}), k.createElement("rect", {
  id: "Rectangle",
  fill: "#A6A6A6",
  x: "0.923076923",
  y: "10.3529412",
  width: "4.61538462",
  height: "1.88235294",
  rx: "0.941176471"
}), k.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: "16.6153846",
  y: "3.76470588",
  width: "4.61538462",
  height: "2.82352941",
  rx: "1"
}), k.createElement("rect", {
  id: "Rectangle",
  fill: "#A6A6A6",
  x: "6.46153846",
  y: "10.3529412",
  width: "4.61538462",
  height: "1.88235294",
  rx: "0.941176471"
}), k.createElement("rect", {
  id: "Rectangle",
  fill: "#A6A6A6",
  x: "11.9230769",
  y: "10.3529412",
  width: "5.61538462",
  height: "1.88235294",
  rx: "0.941176471"
}), k.createElement("rect", {
  id: "Rectangle",
  fill: "#A6A6A6",
  x: "18.4615385",
  y: "10.3529412",
  width: "4.61538462",
  height: "1.88235294",
  rx: "0.941176471"
}))), _J = k.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, k.createElement("rect", {
  fill: "#252525",
  height: "16",
  rx: "2",
  width: "24"
}), k.createElement("circle", {
  cx: "9",
  cy: "8",
  fill: "#eb001b",
  r: "5"
}), k.createElement("circle", {
  cx: "15",
  cy: "8",
  fill: "#f79e1b",
  r: "5"
}), k.createElement("path", {
  d: "m12 3.99963381c1.2144467.91220633 2 2.36454836 2 4.00036619s-.7855533 3.0881599-2 4.0003662c-1.2144467-.9122063-2-2.36454837-2-4.0003662s.7855533-3.08815986 2-4.00036619z",
  fill: "#ff5f00"
})), wJ = k.createElement("g", {
  fill: "none"
}, k.createElement("path", {
  d: "m.20535714 16h4.51785715c1.0278125 0 2.25892857-1.1946667 2.25892857-2.1333333v-13.8666667h-4.51785715c-1.0278125 0-2.25892857 1.19466667-2.25892857 3.2z",
  fill: "#047ab1"
}), k.createElement("path", {
  d: "m2.76924107 10.816c-.86733559.0001606-1.73039558-.1147397-2.56388393-.3413333v-1.17333337c.64678874.37770431 1.38610045.59084099 2.14598215.61866667.8696875 0 1.35535714-.576 1.35535714-1.36533333v-3.22133334h2.14598214v3.22133334c0 1.25866666-.70026786 2.26133333-3.0834375 2.26133333z",
  fill: "#fff"
}), k.createElement("path", {
  d: "m8.11160714 16h4.51785716c1.0278125 0 2.2589286-1.1946667 2.2589286-2.1333333v-13.8666667h-4.5178572c-1.02781249 0-2.25892856 1.19466667-2.25892856 3.2z",
  fill: "#d42d06"
}), k.createElement("path", {
  d: "m8.11160714 6.08c.65508929-.59733333 1.78455357-.97066667 3.61428576-.88533333.9939285.04266666 2.0330357.32 2.0330357.32v1.184c-.5943231-.3394747-1.2623758-.54734656-1.9539732-.608-1.3892411-.11733334-2.23633933.61866666-2.23633933 1.90933333s.84709823 2.0266667 2.23633933 1.92c.6920185-.06606555 1.3596342-.27744592 1.9539732-.61866667v1.17333337s-1.0391072.288-2.0330357.3306666c-1.82973219.0853334-2.95919647-.288-3.61428576-.8853333z",
  fill: "#fff"
}), k.createElement("path", {
  d: "m16.0178571 16h4.5178572c1.0278125 0 2.2589286-1.1946667 2.2589286-2.1333333v-13.8666667h-4.5178572c-1.0278125 0-2.2589286 1.19466667-2.2589286 3.2z",
  fill: "#67b637"
}), k.createElement("path", {
  d: "m21.6651786 9.28c0 .8533333-.7002679 1.3866667-1.6377232 1.3866667h-4.0095983v-5.33333337h3.6481697l.2597768.01066667c.8245089.04266667 1.4344196.50133333 1.4344196 1.29066667 0 .61866666-.4179018 1.152-1.1746428 1.28v.032c.8358035.05333333 1.4795982.55466666 1.4795982 1.33333333zm-2.880134-3.104c-.0486104-.00686658-.0976798-.01043129-.1468303-.01066667h-1.3553572v1.344h1.5021875c.2823661-.064.5195536-.30933333.5195536-.672 0-.36266666-.2371875-.608-.5195536-.66133333zm.1694197 2.176c-.059755-.00886168-.1202559-.01243275-.1807143-.01066667h-1.4908929v1.46133334h1.4908929l.1807143-.02133334c.2823661-.064.5195536-.34133333.5195536-.71466666 0-.37333334-.2258929-.64-.5195536-.71466667z",
  fill: "#fff"
})), SJ = k.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, k.createElement("rect", {
  fill: "#016fd0",
  height: "16",
  rx: "2",
  width: "24"
}), k.createElement("path", {
  d: "m13.7640663 13.3938564v-5.70139231l10.1475359.00910497v1.57489503l-1.1728619 1.25339231 1.1728619 1.2648839v1.6083094h-1.8726188l-.9951823-1.0981657-.9881105 1.1023204z",
  fill: "#fffffe"
}), k.createElement("path", {
  d: "m14.4418122 12.7687956v-4.448884h3.7722872v1.02488398h-2.550895v.69569062h2.4900774v1.0078232h-2.4900774v.6833149h2.550895v1.0371713z",
  fill: "#016fd0"
}), k.createElement("path", {
  d: "m18.1952707 12.7687956 2.087337-2.2270055-2.0874254-2.2217901h1.6156464l1.2754917 1.41003315 1.2791161-1.41003315h1.5461657v.03500552l-2.0428729 2.18678458 2.0428729 2.1638895v.063116h-1.5617237l-1.2981216-1.4241768-1.2847735 1.4241768z",
  fill: "#016fd0"
}), k.createElement("path", {
  d: "m14.2373481 2.6319558h2.4460552l.8591381 1.95085083v-1.95085083h3.0198453l.5207514 1.46156906.5225194-1.46156906h2.3059447v5.70139227h-12.1865193z",
  fill: "#fffffe"
}), k.createElement("g", {
  fill: "#016fd0"
}, k.createElement("path", {
  d: "m14.7004641 3.25135912-1.9740111 4.44517127h1.3539006l.3724199-.89016575h2.0179447l.3721547.89016575h1.3875801l-1.96579-4.44517127zm.1696353 2.55743646.592-1.41507182.5915581 1.41507182z"
}), k.createElement("path", {
  d: "m18.2119779 7.69573481v-4.44508288l1.903116.00654144.9792707 2.73272928.9856354-2.73927072h1.8316022v4.44508288l-1.1786077.01043094v-3.05334807l-1.1125746 3.04291713h-1.0758011l-1.1356464-3.05334807v3.05334807z"
}))), CJ = k.createElement("g", {
  id: "319",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, k.createElement("g", {
  id: "New-Icons",
  transform: "translate(-320.000000, -280.000000)",
  fillRule: "nonzero"
}, k.createElement("g", {
  id: "Card-Brands",
  transform: "translate(40.000000, 200.000000)"
}, k.createElement("g", {
  id: "Color",
  transform: "translate(0.000000, 80.000000)"
}, k.createElement("g", {
  id: "Diners-Club",
  transform: "translate(280.000000, 0.000000)"
}, k.createElement("path", {
  d: "M21.9972414,15.749927 L21.999381,15.7499362 C22.9544683,15.7581106 23.73806,14.9772525 23.75,14.0041555 L23.7500083,2.00630219 C23.7461702,1.53568921 23.5588633,1.08617106 23.2297297,0.756801782 C22.9014319,0.428268884 22.4589161,0.246148853 21.9972414,0.250070854 L2.00063,0.250061791 C1.54108393,0.246148853 1.09856813,0.428268884 0.77027028,0.756801782 C0.441136651,1.08617106 0.253829819,1.53568921 0.25,2.00426336 L0.249991686,13.9936957 C0.253829819,14.4643086 0.441136651,14.9138268 0.77027028,15.2431961 C1.09856813,15.571729 1.54108393,15.753849 2.00275862,15.749927 L21.9972414,15.749927 Z M21.996203,16.249927 C21.9958359,16.249924 21.9954688,16.249921 21.9951018,16.2499178 L21.9972414,16.249927 L21.996203,16.249927 Z",
  id: "shape",
  strokeOpacity: "0.2",
  stroke: "#000000",
  strokeWidth: "0.5",
  fill: "#FFFFFF"
}), k.createElement("path", {
  d: "M10.0021142,2.05179033 L10.0021142,2.03579033 L14.0021142,2.03579033 L14.0021142,2.05179033 C17.1375481,2.28122918 19.5642283,4.89197286 19.5642283,8.03579033 C19.5642283,11.1796078 17.1375481,13.7903515 14.0021142,14.0197903 L14.0021142,14.0357903 L10.0021142,14.0357903 L10.0021142,14.0197903 C6.86668021,13.7903515 4.44,11.1796078 4.44,8.03579033 C4.44,4.89197286 6.86668021,2.28122918 10.0021142,2.05179033 Z",
  id: "shape",
  fill: "#0165AC"
}), k.createElement("path", {
  d: "M11.6021142,11.4277903 C13.0374002,10.9175027 13.9961556,9.55908923 13.9961556,8.03579033 C13.9961556,6.51249143 13.0374002,5.15407792 11.6021142,4.64379033 L11.6021142,11.4277903 L11.6021142,11.4277903 Z M9.20211417,4.64379033 C7.76682809,5.15407792 6.80807271,6.51249143 6.80807271,8.03579033 C6.80807271,9.55908923 7.76682809,10.9175027 9.20211417,11.4277903 L9.20211417,4.64379033 L9.20211417,4.64379033 Z M10.4021142,13.2357903 C7.53023347,13.2357903 5.20211417,10.907671 5.20211417,8.03579033 C5.20211417,5.16390963 7.53023347,2.83579033 10.4021142,2.83579033 C13.2739949,2.83579033 15.6021142,5.16390963 15.6021142,8.03579033 C15.6021142,10.907671 13.2739949,13.2357903 10.4021142,13.2357903 Z",
  id: "shape",
  fill: "#FFFFFF"
})))))), xJ = k.createElement("g", {
  id: "319",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, k.createElement("g", {
  id: "New-Icons",
  transform: "translate(-280.000000, -280.000000)",
  fillRule: "nonzero"
}, k.createElement("g", {
  id: "Card-Brands",
  transform: "translate(40.000000, 200.000000)"
}, k.createElement("g", {
  id: "Color",
  transform: "translate(0.000000, 80.000000)"
}, k.createElement("g", {
  id: "Discover",
  transform: "translate(240.000000, 0.000000)"
}, k.createElement("path", {
  d: "M21.9972414,15.749927 L21.999381,15.7499362 C22.9544683,15.7581106 23.73806,14.9772525 23.75,14.0041555 L23.7500083,2.00630219 C23.7461702,1.53568921 23.5588633,1.08617106 23.2297297,0.756801782 C22.9014319,0.428268884 22.4589161,0.246148853 21.9972414,0.250070854 L2.00063,0.250061791 C1.54108393,0.246148853 1.09856813,0.428268884 0.77027028,0.756801782 C0.441136651,1.08617106 0.253829819,1.53568921 0.25,2.00426336 L0.249991686,13.9936957 C0.253829819,14.4643086 0.441136651,14.9138268 0.77027028,15.2431961 C1.09856813,15.571729 1.54108393,15.753849 2.00275862,15.749927 L21.9972414,15.749927 Z M21.996203,16.249927 C21.9958359,16.249924 21.9954688,16.249921 21.9951018,16.2499178 L21.9972414,16.249927 L21.996203,16.249927 Z",
  id: "shape",
  strokeOpacity: "0.2",
  stroke: "#000000",
  strokeWidth: "0.5",
  fill: "#FFFFFF"
}), k.createElement("path", {
  d: "M12.6124138,15.9999283 L21.9972414,15.9999283 C22.5240217,16.0043364 23.0309756,15.7992919 23.4065697,15.4299059 C23.7821638,15.06052 23.9956285,14.5570537 24,14.0302731 L24,11.6716524 C20.4561668,13.7059622 16.6127929,15.1667795 12.6124138,15.9999283 L12.6124138,15.9999283 Z",
  id: "shape",
  fill: "#F27712"
}), k.createElement("path", {
  d: "M23.1724138,9.29647999 L22.32,9.29647999 L21.36,8.03027309 L21.2689655,8.03027309 L21.2689655,9.29647999 L20.5737931,9.29647999 L20.5737931,6.1516524 L21.6,6.1516524 C22.4027586,6.1516524 22.8662069,6.48268688 22.8662069,7.07854895 C22.8662069,7.56682481 22.5765517,7.88130757 22.0551724,7.98061792 L23.1724138,9.29647999 Z M22.1462069,7.10337654 C22.1462069,6.79716964 21.9144828,6.63992826 21.4841379,6.63992826 L21.2689655,6.63992826 L21.2689655,7.5916524 L21.4675862,7.5916524 C21.9144828,7.5916524 22.1462069,7.42613516 22.1462069,7.10337654 L22.1462069,7.10337654 Z M18.1406897,6.1516524 L20.1103448,6.1516524 L20.1103448,6.68130757 L18.8358621,6.68130757 L18.8358621,7.38475585 L20.0606897,7.38475585 L20.0606897,7.92268688 L18.8358621,7.92268688 L18.8358621,8.77510068 L20.1103448,8.77510068 L20.1103448,9.30475585 L18.1406897,9.30475585 L18.1406897,6.1516524 Z M15.9062069,9.37923861 L14.4,6.14337654 L15.1613793,6.14337654 L16.1131034,8.26199723 L17.0731034,6.14337654 L17.817931,6.14337654 L16.2951724,9.37923861 L15.9227586,9.37923861 L15.9062069,9.37923861 Z M9.60827586,9.37096274 C8.54896552,9.37096274 7.72137931,8.65096274 7.72137931,7.71579033 C7.72137931,6.8054455 8.56551724,6.06889378 9.62482759,6.06889378 C9.92275862,6.06889378 10.1710345,6.12682481 10.4772414,6.25923861 L10.4772414,6.98751447 C10.2453534,6.75969251 9.93335245,6.63192067 9.60827586,6.6316524 C8.9462069,6.6316524 8.44137931,7.1116524 8.44137931,7.71579033 C8.44137931,8.35303171 8.93793103,8.80820412 9.64137931,8.80820412 C9.95586207,8.80820412 10.1958621,8.70889378 10.4772414,8.46061792 L10.4772414,9.18889378 C10.1627586,9.32130757 9.89793103,9.37096274 9.60827586,9.37096274 L9.60827586,9.37096274 Z M7.5062069,8.33647999 C7.5062069,8.94889378 7.00137931,9.37096274 6.27310345,9.37096274 C5.74344828,9.37096274 5.36275862,9.18889378 5.04,8.77510068 L5.49517241,8.38613516 C5.65241379,8.66751447 5.91724138,8.80820412 6.24827586,8.80820412 C6.56275862,8.80820412 6.7862069,8.6178593 6.7862069,8.36958343 C6.7862069,8.22889378 6.72,8.12130757 6.57931034,8.03854895 C6.42504922,7.96369158 6.26441119,7.90275992 6.09931034,7.85647999 C5.44551724,7.64958343 5.22206897,7.42613516 5.22206897,6.98751447 C5.22206897,6.47441102 5.70206897,6.0854455 6.33103448,6.0854455 C6.72827586,6.0854455 7.08413793,6.20958343 7.38206897,6.44130757 L7.01793103,6.85510068 C6.87360928,6.69688076 6.66932728,6.60675635 6.45517241,6.60682481 C6.15724138,6.60682481 5.94206897,6.75579033 5.94206897,6.95441102 C5.94206897,7.11992826 6.0662069,7.21096274 6.48,7.3516524 C7.27448276,7.59992826 7.5062069,7.8316524 7.5062069,8.34475585 L7.5062069,8.33647999 Z M4.08827586,6.1516524 L4.78344828,6.1516524 L4.78344828,9.30475585 L4.08827586,9.30475585 L4.08827586,6.1516524 Z M1.8537931,9.30475585 L0.827586207,9.30475585 L0.827586207,6.1516524 L1.8537931,6.1516524 C2.97931034,6.1516524 3.75724138,6.79716964 3.75724138,7.72406619 C3.75724138,8.19579033 3.52551724,8.64268688 3.12,8.94061792 C2.77241379,9.18889378 2.38344828,9.30475585 1.84551724,9.30475585 L1.8537931,9.30475585 Z M2.66482759,6.9378593 C2.43310345,6.75579033 2.16827586,6.68958343 1.71310345,6.68958343 L1.52275862,6.68958343 L1.52275862,8.77510068 L1.71310345,8.77510068 C2.16,8.77510068 2.44137931,8.69234206 2.66482759,8.52682481 C2.90482759,8.32820412 3.04551724,8.03027309 3.04551724,7.72406619 C3.04551724,7.4178593 2.90482759,7.12820412 2.66482759,6.9378593 Z",
  id: "shape",
  fill: "#000000"
}), k.createElement("path", {
  d: "M12.4137931,6.06889378 C11.5034483,6.06889378 10.7586207,6.79716964 10.7586207,7.69923861 C10.7586207,8.65923861 11.4703448,9.37923861 12.4137931,9.37923861 C13.3406897,9.37923861 14.0689655,8.65096274 14.0689655,7.72406619 C14.0689655,6.79716964 13.3489655,6.06889378 12.4137931,6.06889378 Z",
  id: "shape",
  fill: "#F27712"
})))))), kJ = k.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, k.createElement("g", {
  id: "Group-2"
}, k.createElement("rect", {
  id: "Rectangle",
  fill: "#B3131B",
  x: "0",
  y: "0",
  width: "24",
  height: "16",
  rx: "2"
}), k.createElement("g", {
  id: "Hipercard_logo",
  transform: "translate(2.000000, 6.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, k.createElement("path", {
  d: "M4.45845797,4.72911206 L4.71934477,4.72911206 L4.72670967,4.71021617 C4.73076043,4.69982332 4.73407456,4.67539055 4.73407456,4.65592007 C4.73407456,4.63644958 4.74267391,4.56566228 4.75318417,4.49861521 C4.76369454,4.43156695 4.78836018,4.27726169 4.80799675,4.15571305 C4.82763331,4.0341644 4.85703646,3.85139347 4.87333717,3.74955542 C4.88963776,3.64771736 4.90953167,3.51735868 4.91754595,3.45986946 C4.92556023,3.40238023 4.93534271,3.3553436 4.93928464,3.3553436 C4.94322668,3.3553436 4.96009268,3.38074637 4.9767648,3.41179473 L5.0070776,3.46824705 L5.07434118,3.5349692 L5.14160488,3.60169134 L5.22440039,3.63432372 L5.30719578,3.66695609 L5.40587279,3.67955056 L5.5045498,3.69214384 L5.62980554,3.68457856 L5.75506139,3.67701327 L5.8906751,3.64246001 L6.02628894,3.60790675 L6.09908975,3.57519075 C6.13913019,3.55719677 6.21011098,3.51796553 6.25682484,3.48801021 L6.34175912,3.43354447 L6.42095111,3.35561954 C6.46450662,3.31276155 6.5259323,3.24403729 6.55745263,3.20290069 C6.58897283,3.16176409 6.61476215,3.12510239 6.61476215,3.12143264 C6.61476215,3.11776169 6.63024834,3.09228724 6.64917582,3.06482382 C6.66810343,3.0373592 6.70683989,2.96113177 6.73525696,2.8954298 C6.76367415,2.82972783 6.80808531,2.71146429 6.83394853,2.63262192 L6.88097263,2.48927217 L6.90527961,2.36510142 C6.91864839,2.29680721 6.93584673,2.18391928 6.94349809,2.11423935 L6.95740984,1.98754804 L6.9493753,1.88003572 L6.94134076,1.77252341 L6.91602234,1.66501109 L6.89070392,1.55749878 L6.84971924,1.47700311 L6.80873457,1.39650745 L6.72956721,1.31388424 L6.65039973,1.23125983 L6.55674682,1.18360201 L6.4630938,1.13594299 L6.35995932,1.11163207 L6.25682484,1.08732115 L6.15369036,1.07986696 L6.05055588,1.07241397 L5.93566831,1.0854122 L5.82078075,1.09840925 L5.7270093,1.12198192 L5.63323773,1.1455534 L5.55177641,1.18267501 C5.50697261,1.2030916 5.44177912,1.23776791 5.40690207,1.25973387 C5.3720249,1.28169983 5.33604735,1.30697239 5.32695174,1.31589472 C5.31785613,1.32481824 5.29608043,1.34134766 5.27856116,1.3526257 L5.24670802,1.37313308 L5.26898276,1.26820942 C5.28123392,1.21050159 5.29147275,1.15656744 5.2917358,1.14835469 L5.29221386,1.13342243 L5.06976516,1.13342243 L4.84731634,1.13342243 L4.80831003,1.37532513 C4.78685648,1.50837162 4.75298372,1.71398893 4.73303727,1.83225247 C4.7130907,1.95051602 4.68301183,2.12791134 4.66619545,2.22646429 C4.64937895,2.32501725 4.61938307,2.49972476 4.59953794,2.61470321 C4.5796928,2.72968165 4.54689191,2.91245259 4.52664697,3.02086084 C4.50640216,3.12926909 4.47674372,3.28784975 4.46073931,3.37326231 C4.44473502,3.45867488 4.41461296,3.61994335 4.39380151,3.7316367 C4.37299019,3.84333005 4.33954562,4.02072536 4.31948026,4.12584852 C4.29941502,4.23097167 4.26676167,4.39761576 4.24691738,4.49616871 C4.2270731,4.59472167 4.20785211,4.68745104 4.20420394,4.70223398 L4.19757093,4.72911206 L4.45845773,4.72911206 L4.45845797,4.72911206 Z M5.58158434,3.34795511 L5.48028286,3.35395071 L5.41406652,3.34244331 L5.34785018,3.33093472 L5.28059837,3.30070464 L5.21334656,3.27047457 L5.16636177,3.22630134 L5.11937709,3.18212931 L5.09225746,3.12240025 C5.07734166,3.08954926 5.0581828,3.0337432 5.04968233,2.99838718 L5.03422684,2.93410437 L5.04041916,2.8311458 L5.04661147,2.72818843 L5.07787505,2.56691995 C5.09507,2.47822229 5.12594421,2.31157821 5.14648436,2.19659976 C5.1670245,2.08162131 5.19812318,1.9131519 5.21559259,1.82222277 L5.24735509,1.6568975 L5.3169102,1.5999088 C5.35516545,1.56856538 5.41576424,1.52655673 5.45157423,1.50655705 L5.51668327,1.470194 L5.60161755,1.44430981 L5.68655183,1.41842563 L5.79575304,1.41211346 L5.90495426,1.40580129 L5.99387134,1.42445946 L6.08278843,1.44311762 L6.1455397,1.47157016 L6.20829096,1.50002269 L6.2609103,1.55210763 L6.31352963,1.60419138 L6.34191746,1.65934519 C6.3575308,1.68968039 6.37946059,1.74905705 6.39065044,1.79129506 L6.41099548,1.86808991 L6.40476348,2.09506035 L6.39853137,2.32203079 L6.36736983,2.45618705 C6.35023095,2.52997394 6.31760514,2.64286188 6.29486799,2.70704912 L6.25352781,2.82375493 L6.20290006,2.91822719 C6.17505485,2.9701879 6.1321162,3.04040419 6.10748089,3.07426459 C6.08284558,3.10812381 6.04357913,3.15198525 6.0202222,3.17173287 C5.99686528,3.19148049 5.95774892,3.22234369 5.93329695,3.24031617 L5.8888387,3.27299275 L5.7858622,3.30747553 L5.6828857,3.34195951 L5.58158434,3.34795511 Z M8.10111202,3.67635864 L8.23458018,3.67786023 L8.36804833,3.665875 C8.44145581,3.6592833 8.56157715,3.64555995 8.63498463,3.63537973 C8.70839211,3.62519831 8.83520336,3.60240928 8.91678734,3.58473665 L9.06512179,3.5526048 L9.07250973,3.498771 C9.07657311,3.4691621 9.093232,3.38101873 9.10952955,3.3028967 L9.1391613,3.16085621 L9.1326233,3.1544198 L9.12608543,3.1479822 L9.0807372,3.1695444 C9.05579576,3.181403 8.97811171,3.20969069 8.90810597,3.23240685 L8.78082285,3.27370711 L8.6472364,3.29918394 L8.51364995,3.32466077 L8.30131425,3.32506693 L8.08897856,3.32547309 L8.01617775,3.30258252 C7.9761373,3.28999283 7.91724557,3.26695772 7.88530737,3.25139472 L7.82723768,3.22309628 L7.7793106,3.18046765 L7.73138352,3.13783782 L7.69398963,3.07349051 L7.65659562,3.00914319 L7.63315109,2.92843011 L7.60970656,2.84771703 L7.60953911,2.69835615 L7.60937167,2.54899526 L7.63018579,2.41575047 L7.65099978,2.28250449 L7.83358895,2.27410658 L8.01617823,2.26570748 L8.69111697,2.26997453 L9.3660557,2.27424157 L9.38643459,2.18913124 C9.39764288,2.14232038 9.41477886,2.04555929 9.42451439,1.97410661 L9.44221542,1.84419231 L9.44258913,1.73490963 L9.44296284,1.62562694 L9.42374501,1.54404301 L9.40452717,1.46245909 L9.37275132,1.40843654 C9.35527451,1.37872491 9.32448062,1.33566504 9.3043205,1.31274938 C9.28416037,1.28983373 9.24816377,1.25752509 9.22432794,1.24095266 C9.20049222,1.22438023 9.15368992,1.19652977 9.12032288,1.17906499 L9.05965554,1.14730824 L8.95365525,1.12215633 L8.84765497,1.09700442 L8.71705262,1.08471099 L8.58645027,1.07241636 L8.46511559,1.08019547 L8.34378091,1.08797458 L8.19817929,1.11550012 L8.05257767,1.14302686 L7.96157665,1.17884877 C7.9115261,1.198551 7.83508525,1.23447922 7.7917081,1.2586898 C7.74833095,1.28290038 7.68827028,1.32231081 7.65823994,1.34626814 C7.62820961,1.37022427 7.57621515,1.4167998 7.54269681,1.44976786 C7.50917834,1.48273591 7.45959784,1.54196325 7.43251788,1.58138443 C7.40543792,1.62080561 7.36392374,1.69068862 7.34026433,1.73668 C7.31660479,1.78267138 7.28577559,1.84717876 7.27175488,1.88002975 C7.25773417,1.91288073 7.23225571,1.98007593 7.21513599,2.02935241 C7.1980164,2.07862889 7.17110667,2.17270216 7.15533656,2.23840413 C7.13956645,2.3041061 7.11795686,2.41225991 7.10731533,2.47874552 L7.08796742,2.59963476 L7.08814699,2.77739681 L7.08832657,2.95515887 L7.10676835,3.03280665 C7.11691132,3.07551293 7.13630473,3.14002032 7.14986473,3.1761564 C7.16342485,3.21229249 7.18849963,3.26604864 7.20558671,3.29561453 C7.22267367,3.32518042 7.2591652,3.37278329 7.28667905,3.40139948 C7.31419278,3.43001568 7.36400431,3.47343751 7.39737135,3.49789178 C7.43073838,3.52234606 7.49013972,3.55674044 7.52937438,3.57432587 L7.60070995,3.60629765 L7.70017273,3.62996947 C7.75487732,3.64298921 7.83743756,3.65841484 7.88363999,3.66425037 C7.92984242,3.6700847 8.02770503,3.67553319 8.10111251,3.67635864 L8.10111202,3.67635864 Z M8.32965888,1.99352094 C7.99374575,1.99352094 7.71890777,1.99115328 7.71890777,1.98826001 C7.71890777,1.98536673 7.73323995,1.94370571 7.75075703,1.89567996 C7.76827412,1.84765421 7.79903902,1.77617166 7.81912342,1.73682932 L7.85564031,1.66529779 L7.93590903,1.58670271 L8.01617775,1.50810762 L8.09504529,1.47097884 C8.13842244,1.45055747 8.19575308,1.42832273 8.22244671,1.42156738 C8.24914034,1.41481202 8.32558119,1.40585027 8.39231526,1.40165251 L8.51364995,1.39401794 L8.60682685,1.40580726 L8.70000364,1.41759659 L8.76771701,1.44811814 L8.8354305,1.4786385 L8.87257529,1.51806804 C8.89300502,1.53975447 8.9173507,1.5716916 8.92667697,1.58903811 L8.94363374,1.62057745 L8.95483159,1.69057752 L8.96602945,1.76057759 L8.95321966,1.87704927 L8.94040987,1.99352094 L8.32965888,1.99352094 Z M11.959629,3.67642315 L12.0931723,3.67788054 L12.2447655,3.66019237 C12.328143,3.6504637 12.4391291,3.63434164 12.4914025,3.62436569 C12.5436771,3.61438974 12.628308,3.59458597 12.6794712,3.58035851 C12.7306357,3.56612985 12.7769248,3.55074723 12.7823351,3.54617318 C12.7877455,3.54159912 12.8022037,3.48738425 12.8144634,3.42569488 C12.826723,3.3640055 12.8421665,3.28127956 12.8487817,3.24185837 C12.8553968,3.20243719 12.858816,3.16807267 12.8563809,3.16549477 C12.8539445,3.16291567 12.8449948,3.16624735 12.8364917,3.1728952 C12.8279885,3.17954304 12.7684545,3.20420995 12.7041944,3.22770736 L12.5873588,3.27043156 L12.420981,3.302168 L12.2546045,3.33390325 L12.1131465,3.32915121 L11.9716884,3.32439797 L11.8913406,3.29696441 L11.8109916,3.26953085 L11.7489046,3.21605781 L11.6868164,3.16258596 L11.6456318,3.08873695 L11.6044472,3.01488793 L11.5848322,2.91609248 L11.5652172,2.81729702 L11.5653386,2.68912203 L11.5654599,2.56094705 L11.5892961,2.40565148 L11.6131335,2.25035592 L11.6383541,2.16673523 C11.6522263,2.12074385 11.6679222,2.06698769 11.6732342,2.0472771 C11.678545,2.02756651 11.7007978,1.97112254 11.722683,1.92184607 C11.7445681,1.87256959 11.7836087,1.79641025 11.8094409,1.75260257 L11.8564059,1.67295267 L11.9140896,1.61410998 L11.9717721,1.5552673 L12.0328581,1.51796531 L12.0939452,1.48066331 L12.172393,1.45687442 C12.2155396,1.44379137 12.2917924,1.42680322 12.3418429,1.41912326 L12.4328439,1.40516219 L12.5663121,1.41175628 L12.6997802,1.41835037 L12.8575153,1.44943457 L13.0152504,1.48051877 L13.0794061,1.50407591 C13.1146915,1.51703353 13.145104,1.52763425 13.1469871,1.52763425 C13.1488715,1.52763425 13.1573345,1.48328542 13.1657928,1.42908129 C13.1742522,1.37487717 13.1893087,1.28569809 13.1992508,1.23090743 C13.209193,1.17611557 13.2149333,1.12892841 13.2120067,1.12604708 C13.2090789,1.12316575 13.1616662,1.11575337 13.1066446,1.109575 C13.0516217,1.10339663 12.9020779,1.09242679 12.7743246,1.08519718 L12.5420452,1.0720532 L12.3782433,1.08442906 L12.2144415,1.09680493 L12.0931068,1.12190786 L11.9717721,1.14701198 L11.8936314,1.17778201 C11.8506546,1.19470683 11.787705,1.2252463 11.7537446,1.24564856 C11.7197843,1.26605201 11.6765552,1.29349632 11.6576803,1.30663671 C11.6388043,1.3197771 11.5815404,1.37104495 11.5304257,1.42056632 L11.4374894,1.5106043 L11.3856128,1.58542809 C11.3570809,1.62658022 11.3077232,1.71239058 11.2759299,1.77611671 L11.2181236,1.89198153 L11.1738182,2.01741257 C11.1494494,2.08639964 11.1154271,2.19928757 11.098211,2.26827464 L11.0669102,2.39370567 L11.0555485,2.50719089 L11.0441879,2.62067611 L11.0443092,2.76999877 L11.0444306,2.91932143 L11.0558894,3.0061878 L11.0673483,3.09305536 L11.1036916,3.18241243 L11.1400338,3.27176949 L11.1820095,3.33637364 L11.2239841,3.4009766 L11.2907327,3.46565123 L11.3574813,3.53032586 L11.4280836,3.56706401 L11.4986858,3.60380216 L11.591451,3.6291691 C11.642471,3.64312061 11.7161818,3.65913278 11.7552528,3.6647509 C11.7943226,3.67037021 11.8863841,3.67562278 11.9598316,3.67642315 L11.959629,3.67642315 Z M13.9555105,3.67201037 L14.1193123,3.66738973 L14.2224468,3.64140161 L14.3255813,3.6154123 L14.3923154,3.5843508 C14.4290191,3.56726709 14.4890798,3.53354287 14.5257835,3.50940874 C14.5624872,3.48527462 14.6192998,3.43939314 14.6520322,3.40745004 C14.6847659,3.37550574 14.7333071,3.32100536 14.7599012,3.28633861 C14.7864953,3.25167066 14.8098571,3.22488337 14.8118155,3.22681143 C14.8137726,3.22873948 14.8076537,3.2839817 14.7982163,3.34957257 C14.7887801,3.41516345 14.7809516,3.50242641 14.7808217,3.54349015 L14.7805912,3.61815148 L15.003278,3.61815148 L15.2259647,3.61815148 L15.2327728,3.44792364 L15.2395797,3.27769581 L15.2713548,3.05669828 C15.2888318,2.93514963 15.3170592,2.75506651 15.3340824,2.65651355 C15.3511044,2.55796059 15.3806943,2.39131651 15.3998373,2.28619336 C15.4189803,2.1810702 15.4493055,2.01711392 15.4672278,1.92184607 L15.4998135,1.74863178 L15.5009055,1.59901287 L15.5019975,1.44939515 L15.4676343,1.38024561 L15.4332723,1.31109728 L15.3866749,1.26705665 L15.3400776,1.22301602 L15.2635748,1.18484915 L15.1870721,1.14668347 L15.0730551,1.12171553 L14.9590393,1.09674639 L14.8020602,1.08498574 L14.645081,1.07322389 L14.4428707,1.08554122 C14.3316553,1.09231569 14.1751408,1.10569261 14.0950599,1.11526718 L13.9494583,1.13267701 L13.8502272,1.13304733 L13.750996,1.13341765 L13.7365584,1.20210607 C13.7286171,1.2398847 13.7065499,1.32964076 13.687521,1.40156411 C13.6684909,1.47348627 13.6546854,1.53406946 13.6568415,1.53619223 C13.6589976,1.538315 13.7120682,1.52645639 13.7747764,1.50983976 C13.8374846,1.49322194 13.9706919,1.4658947 14.070793,1.44911203 L14.252795,1.41859765 L14.4165969,1.411951 L14.5803987,1.40530435 L14.6859089,1.42351335 L14.7914191,1.44172116 L14.8618442,1.47594352 L14.9322693,1.51016469 L14.971703,1.56803021 L15.0111368,1.62589572 L15.0105787,1.7171259 L15.0100205,1.80835607 L14.989117,1.90846915 L14.9682134,2.00858342 L14.5316331,2.01013398 L14.0950539,2.01168455 L13.9521677,2.05025639 C13.8735792,2.07147095 13.786558,2.09963679 13.7587857,2.11284647 C13.7310146,2.12605735 13.7032351,2.13686592 13.6970543,2.13686592 C13.6908735,2.13686592 13.6441232,2.16238934 13.5931651,2.19358344 L13.5005139,2.25030097 L13.4275457,2.32200093 C13.387413,2.36143645 13.3361406,2.42057897 13.3136063,2.45342996 C13.2910733,2.48628094 13.2544617,2.55490844 13.232249,2.60593498 L13.1918603,2.69871094 L13.173324,2.80304089 L13.1547877,2.90737084 L13.1547877,3.01681838 L13.1547877,3.12626711 L13.1724965,3.21739215 L13.1902065,3.3085184 L13.2230615,3.3679524 C13.2411331,3.40064092 13.2742951,3.44852332 13.2967566,3.47435973 L13.3375954,3.52133305 L13.4101681,3.56473577 L13.4827396,3.60813849 L13.5658078,3.63128231 C13.6114963,3.64401177 13.6810332,3.65942187 13.720336,3.66552618 L13.7917948,3.67662623 L13.9555966,3.67200559 L13.9555105,3.67201037 Z M14.1071788,3.33797677 L14.0101111,3.34295937 L13.9458219,3.32683969 C13.9104626,3.31797351 13.8568096,3.2982008 13.8265924,3.2829006 L13.771652,3.25508 L13.7416666,3.21999634 C13.7251748,3.20069908 13.6999809,3.16278307 13.6856804,3.13573655 L13.6596808,3.08656281 L13.6545823,2.97172771 L13.649485,2.85689381 L13.6700525,2.78723658 C13.6813657,2.74892516 13.7079052,2.68244671 13.7290308,2.6395051 L13.7674417,2.56143085 L13.840996,2.48951348 L13.9145503,2.4175973 L13.9926644,2.38056886 L14.0707784,2.34354042 L14.1678462,2.3208398 L14.2649139,2.29813917 L14.5682506,2.29813917 L14.8715874,2.29813917 L14.8907789,2.30595173 L14.9099692,2.31376429 L14.8938183,2.40749114 C14.8849342,2.4590409 14.8637479,2.55228633 14.8467356,2.61470321 C14.8297232,2.67712008 14.7996905,2.76887348 14.7799954,2.81860031 C14.7603004,2.86832714 14.7441859,2.91229012 14.7441859,2.91629675 C14.7441859,2.92030338 14.7242458,2.95653742 14.6998745,2.99681631 L14.6555643,3.07005131 L14.5828035,3.14102257 C14.5427861,3.18005671 14.5056371,3.21199384 14.5002523,3.21199384 C14.4948674,3.21199384 14.4703372,3.22543885 14.4457427,3.24187151 L14.4010235,3.27174799 L14.3026357,3.30237108 L14.2042466,3.33299417 L14.1071788,3.33797677 Z M18.0566228,3.67628099 L18.1718907,3.67771091 L18.281092,3.66026166 C18.3411526,3.65066439 18.4175935,3.63520412 18.4509605,3.6259067 C18.4843276,3.61660808 18.5443882,3.59247515 18.5844287,3.57227836 L18.6572295,3.53555693 L18.7198576,3.48128471 L18.7824857,3.4270125 L18.8484444,3.34040775 C18.8847223,3.29277621 18.9175725,3.24574076 18.9214467,3.23588547 L18.9284889,3.21796675 L18.922364,3.27769581 C18.9189945,3.3105468 18.9114402,3.36430295 18.9055761,3.39715394 C18.8997132,3.43000492 18.8913059,3.49316841 18.8868942,3.53751724 L18.8788715,3.61815148 L19.1168877,3.61815148 L19.3549039,3.61815148 L19.3549039,3.53751724 L19.3549039,3.456883 L19.391166,3.15226478 C19.411111,2.98472475 19.4406038,2.7616367 19.4567061,2.65651355 C19.4728085,2.5513904 19.4976627,2.40087316 19.5119389,2.32203079 C19.5262139,2.24318843 19.5514964,2.10073461 19.5681205,2.00546676 C19.5847433,1.9101989 19.6147725,1.74355481 19.6348497,1.63514656 C19.654927,1.52673831 19.68706,1.35471861 19.7062552,1.25288055 C19.7254515,1.1510425 19.7552865,0.992461836 19.7725549,0.900479078 C19.7898244,0.80849632 19.8207636,0.647227848 19.841308,0.542104696 C19.8618536,0.436981544 19.8918657,0.289152111 19.9080008,0.213594845 C19.9241371,0.13803758 19.9373165,0.0721862871 19.9372885,0.0672586394 L19.9372886,0.0582992798 L19.6776105,0.0582992798 L19.4179324,0.0582992798 L19.4102629,0.132960609 C19.4060453,0.174024341 19.386167,0.309758638 19.3660873,0.434592381 C19.3460089,0.559426124 19.3132764,0.758323906 19.2933496,0.876587452 C19.2734228,0.994850998 19.2542119,1.109532 19.2506592,1.13143345 L19.2442006,1.17125601 L19.2237071,1.16267653 C19.2124364,1.15795674 19.1513431,1.14127321 19.0879458,1.12560031 L18.9726778,1.09710477 L18.8149427,1.08501083 L18.6572076,1.07291569 L18.5237395,1.08516015 L18.3902713,1.09740461 L18.2689366,1.12760004 L18.147602,1.15779547 L18.032334,1.21314639 L17.9170661,1.26849731 L17.8321318,1.33040529 L17.7471975,1.39231447 L17.6738471,1.46974245 C17.6335045,1.51232808 17.5752238,1.58276537 17.5443344,1.62626963 L17.488171,1.70537002 L17.4222183,1.84048553 C17.3859453,1.91479923 17.3418026,2.01323153 17.3241241,2.05922291 C17.3064456,2.10521429 17.2752675,2.20716464 17.2548384,2.28577884 L17.2176966,2.42871287 L17.1993969,2.61428869 L17.1810984,2.7998633 L17.1948396,2.94918596 L17.2085795,3.09850862 L17.224825,3.15226478 C17.2337589,3.18183067 17.2525985,3.23450692 17.2666891,3.26932419 L17.2923089,3.33262744 L17.3390179,3.39487707 L17.3857281,3.45712789 L17.4390608,3.5001364 L17.4923947,3.54314491 L17.5651955,3.57873388 C17.6052359,3.59830709 17.6724044,3.62360354 17.714459,3.63494729 C17.7565136,3.64629103 17.8247643,3.65990926 17.8661273,3.66521081 C17.9074903,3.67051236 17.9932036,3.67549377 18.056601,3.67628099 L18.0566228,3.67628099 Z M18.2635057,3.33735678 L18.1718907,3.34214706 L18.1100549,3.33118916 C18.0760448,3.3251625 18.0216226,3.30900698 17.989117,3.29528841 L17.9300149,3.27034555 L17.8802835,3.23022554 L17.830552,3.19010433 L17.7935947,3.12041485 L17.7566361,3.05072537 L17.7397949,2.97307759 L17.7229524,2.8954298 L17.7243805,2.74013424 L17.7258074,2.58483867 L17.7453666,2.44746183 L17.7649257,2.31008498 L17.7953249,2.21451848 C17.8120436,2.1619569 17.8258042,2.11236625 17.8259049,2.10431836 C17.8260262,2.09627046 17.8425132,2.05326554 17.8625892,2.00875185 C17.8826665,1.96423817 17.9162082,1.89556528 17.9371288,1.8561441 C17.9580481,1.81672291 17.9971506,1.75526768 18.0240226,1.71957718 C18.0508934,1.68388667 18.0987648,1.63013051 18.1304016,1.60011905 C18.1620384,1.57010758 18.2123656,1.53074374 18.2422382,1.51264345 L18.2965536,1.47973512 L18.3919567,1.44723295 L18.4873609,1.41473079 L18.6875631,1.41461133 L18.8877654,1.41461133 L19.0030333,1.44609571 C19.0664307,1.46341117 19.1337447,1.48349327 19.1526184,1.49072169 L19.1869367,1.50386327 L19.1802341,1.53665453 C19.176548,1.55468912 19.1621274,1.63395198 19.1481884,1.71279434 C19.1342495,1.79163671 19.1067842,1.94215395 19.0871522,2.0472771 C19.0675203,2.15240025 19.0373589,2.31098092 19.0201245,2.39967858 C19.0028914,2.48837624 18.9779292,2.60126417 18.9646527,2.65054064 C18.9513763,2.69981712 18.9326471,2.76806952 18.9230301,2.80221304 C18.9134143,2.83635657 18.890516,2.89548834 18.872146,2.93361698 C18.8537759,2.97174563 18.8216307,3.02713239 18.8007126,3.05669828 C18.7797957,3.08626416 18.7444145,3.12722038 18.7220889,3.14771103 C18.6997633,3.16820288 18.6514661,3.2046173 18.6147623,3.22863316 L18.5480283,3.2722975 L18.4515745,3.30243201 L18.3551207,3.33256771 L18.2635057,3.33735798 L18.2635057,3.33735678 Z M0.406035224,3.61815148 L0.700846957,3.61815148 L0.721999232,3.48973399 C0.733631588,3.41910437 0.756352721,3.28337007 0.772489021,3.18810222 C0.78862532,3.09283436 0.818658081,2.91543904 0.839229163,2.7938904 C0.859799032,2.67234175 0.890636242,2.49225862 0.907755352,2.39370567 C0.924874463,2.29515271 0.952074059,2.14227379 0.968198225,2.05397392 C0.984323604,1.96567525 1.00057639,1.89041663 1.00431713,1.88673254 L1.01111794,1.88003572 L1.80383747,1.88003572 L2.596557,1.88003572 L2.60535861,1.88869883 L2.61416145,1.89736193 L2.60041544,1.96634661 C2.59285507,2.0042877 2.57049188,2.12134114 2.55072039,2.22646429 C2.53094769,2.33158744 2.49770806,2.50898276 2.47685426,2.62067611 C2.45600047,2.73236946 2.42584638,2.89095012 2.40984597,2.97307759 C2.39384435,3.05520505 2.36146377,3.22722475 2.33788965,3.3553436 C2.31431432,3.48346244 2.29507549,3.59500646 2.29513616,3.60321921 L2.2952575,3.61815148 L2.59128136,3.61815148 L2.88730644,3.61815148 L2.90040452,3.54349015 C2.90760938,3.50242641 2.91920048,3.4285117 2.92616388,3.37923522 C2.93312606,3.32995874 2.9499115,3.22513424 2.96346337,3.14629187 C2.97701646,3.06744951 3.00409472,2.91155665 3.02363688,2.7998633 C3.04317905,2.68816995 3.07588966,2.4973356 3.09632728,2.37578695 C3.11676368,2.25423831 3.14708242,2.07684299 3.16370127,1.98157513 C3.18032,1.88630727 3.2099327,1.7250388 3.22950738,1.62320075 C3.24908194,1.52136269 3.28168651,1.34934299 3.30196202,1.24093474 C3.32223741,1.13252649 3.3526127,0.96857021 3.36946269,0.876587452 C3.3863128,0.784604694 3.41703596,0.617960606 3.43773662,0.506267257 C3.45843729,0.394573908 3.48457667,0.264215227 3.49582403,0.216581299 L3.5162739,0.129974156 L3.21654665,0.129974156 L2.91681989,0.129974156 L2.90866742,0.186716767 C2.9041841,0.217925202 2.88970402,0.305278958 2.87649067,0.380836224 C2.86327611,0.456393489 2.83924092,0.590783883 2.82307672,0.679481542 C2.80691251,0.768179202 2.77737358,0.937511097 2.75743465,1.05577464 C2.73749451,1.17403819 2.7120846,1.33059045 2.7009667,1.40366896 L2.68075113,1.53653985 L2.24076366,1.54530688 L1.80077498,1.55407391 L1.43224272,1.54546337 C1.22954949,1.54072805 1.0625869,1.53591269 1.06121339,1.53476231 C1.05983988,1.53361551 1.06674383,1.4871905 1.07655495,1.43160066 C1.08636486,1.37601082 1.10492543,1.27945999 1.11780025,1.21704312 C1.13067507,1.15462624 1.15508154,1.03098708 1.17203685,0.942289422 C1.18899095,0.853591763 1.20819702,0.74339164 1.21471511,0.697400261 C1.22123321,0.651408882 1.23489429,0.574806358 1.24507305,0.52717243 C1.25525061,0.479538501 1.27456709,0.379202037 1.28799762,0.304203835 C1.30142816,0.229204439 1.31573716,0.159321434 1.3197958,0.148908269 L1.32717538,0.129974156 L1.02986779,0.129974156 L0.732560203,0.129974156 L0.713517938,0.234500018 C0.703043115,0.291989241 0.689078706,0.373967381 0.682484166,0.416673662 C0.675889626,0.459379942 0.653744833,0.596458144 0.633273245,0.721291887 C0.612802871,0.84612563 0.582582041,1.03158437 0.566118138,1.13342243 C0.549653021,1.23526048 0.519668795,1.42071922 0.499487197,1.54555297 C0.479305599,1.67038671 0.446005295,1.86390887 0.4254876,1.97560222 C0.404969905,2.08729557 0.375264748,2.24587624 0.359476679,2.3280037 C0.343687397,2.41013116 0.313600035,2.56602402 0.292613988,2.67443227 C0.271629155,2.78284052 0.241013987,2.93604557 0.224581631,3.01488793 C0.208148062,3.0937303 0.189981833,3.18511576 0.184209942,3.21796675 C0.178439265,3.25081773 0.159657869,3.34556595 0.142475664,3.42851887 C0.125292247,3.51147178 0.111233197,3.58807431 0.111233197,3.5987467 L0.111233197,3.61815148 L0.40604493,3.61815148 L0.406035224,3.61815148 Z M3.6696828,3.61815148 L3.93066933,3.61815148 L3.93803423,3.59925559 C3.94208498,3.58886273 3.94539912,3.56160239 3.94539912,3.53867598 C3.94539912,3.51574958 3.96181061,3.39658174 3.98186905,3.27385882 C4.00192749,3.1511347 4.03506982,2.95127648 4.0555186,2.82972783 C4.07596737,2.70817919 4.10616636,2.53078387 4.12262747,2.43551601 C4.13908859,2.34024816 4.16836313,2.18166749 4.18768216,2.08311454 C4.20700119,1.98456158 4.23665805,1.83135654 4.2535863,1.74265888 C4.27051468,1.65396122 4.3038043,1.48521228 4.32756345,1.3676607 C4.3513226,1.25010912 4.37372499,1.14921121 4.37734671,1.14344138 L4.38393166,1.13295176 L4.1200058,1.13617355 L3.85607993,1.13939533 L3.83409918,1.2946909 C3.82200988,1.38010346 3.79557869,1.54943535 3.77536324,1.670984 C3.75514791,1.79253264 3.72457012,1.97799139 3.70741291,2.08311454 C3.69025558,2.18823769 3.66033444,2.35756959 3.64092138,2.45940764 C3.62150844,2.56124569 3.59175924,2.71713855 3.57481193,2.80583621 C3.55786476,2.89453387 3.52745513,3.05042672 3.50723495,3.15226478 C3.48701476,3.25410283 3.45988239,3.38849323 3.44694071,3.4509101 C3.43399891,3.51332697 3.42009966,3.57649045 3.41605327,3.5912734 L3.40869626,3.61815148 L3.6696828,3.61815148 Z M9.77371379,3.61815148 L10.0327662,3.61815148 L10.0405474,3.5102342 C10.0448257,3.45088023 10.0594866,3.33127278 10.0731246,3.24443986 C10.0867638,3.15760695 10.1146878,2.98442611 10.1351788,2.85959237 C10.155671,2.73475862 10.1937543,2.52697555 10.2198085,2.39785326 C10.2458627,2.26872977 10.2753155,2.14038396 10.2852589,2.11263742 C10.295201,2.08489208 10.3033365,2.05482685 10.3033365,2.04582568 C10.3033365,2.03682332 10.3228132,1.98777501 10.346619,1.9368285 C10.3704237,1.885882 10.4147873,1.80786868 10.4452047,1.76346729 L10.5005078,1.6827351 L10.5745377,1.61525798 L10.6485665,1.54777966 L10.7398538,1.50485597 L10.8311424,1.46193228 L10.9706773,1.46264903 L11.1102122,1.46336577 L11.1788136,1.48354942 C11.216545,1.49465186 11.2506704,1.50373426 11.2546478,1.50373426 C11.2586263,1.50373426 11.2618805,1.49103467 11.2618805,1.47551228 C11.2618805,1.45999108 11.2755307,1.38130521 11.2922142,1.30065544 C11.3088977,1.22000687 11.3225479,1.15061842 11.3225479,1.14646009 C11.3225479,1.14230175 11.2829624,1.12704814 11.2345802,1.11256384 C11.186198,1.09807954 11.1193123,1.08290836 11.0859452,1.07885156 L11.0252779,1.07147502 L10.9464103,1.08520913 C10.9030332,1.09276246 10.8385341,1.10943762 10.8030789,1.12226504 C10.7676249,1.13509245 10.7090846,1.16418528 10.6729899,1.18691816 C10.6368953,1.20964985 10.5807489,1.25394851 10.5482203,1.28535763 C10.5156916,1.31676676 10.4609794,1.3800951 10.4266368,1.42608648 C10.392293,1.47207786 10.356378,1.5204584 10.3468229,1.53359879 L10.3294514,1.55749042 L10.339999,1.50970717 C10.3458012,1.48342638 10.3619594,1.39741653 10.375908,1.31857416 C10.3898566,1.2397318 10.4041729,1.16581708 10.4077208,1.15431924 L10.4141733,1.13341406 L10.1828196,1.13341406 L9.95146594,1.13341406 L9.95146594,1.16220945 C9.95146594,1.1780472 9.93781118,1.27346438 9.92112208,1.37424762 C9.90443298,1.47503205 9.87691282,1.64350027 9.85996613,1.74862342 C9.84301943,1.85374657 9.8129425,2.03651751 9.79312843,2.15478105 C9.77331448,2.2730446 9.74322906,2.44237649 9.72627205,2.53107415 C9.70931504,2.61977181 9.67920475,2.77566467 9.65936022,2.87750272 C9.63951569,2.97934078 9.60656725,3.14598486 9.58614129,3.24782292 C9.56571544,3.34966097 9.54127633,3.46992783 9.53183225,3.515083 C9.52238804,3.56023818 9.51466108,3.6018992 9.51466108,3.60766305 L9.51466108,3.61815148 L9.77371379,3.61814311 L9.77371379,3.61815148 Z M15.9231926,3.61815148 L16.1880687,3.61815148 L16.1880687,3.53834508 L16.1880687,3.4585375 L16.2185916,3.26060494 C16.2353807,3.15174036 16.2630766,2.97934914 16.2801399,2.87751109 C16.2972031,2.77567303 16.3184719,2.64665825 16.3274021,2.59081158 C16.3363336,2.53496491 16.3600011,2.41401355 16.3799983,2.32203079 C16.3999955,2.23004804 16.4249722,2.13059914 16.4355041,2.10103326 C16.4460347,2.07146737 16.4547308,2.04044768 16.4548278,2.03210114 C16.4549492,2.0237546 16.4775041,1.97007848 16.5050034,1.9128222 L16.555003,1.80871922 L16.6209641,1.72243342 L16.6869253,1.63614762 L16.7591146,1.58271997 C16.7988189,1.55333566 16.862664,1.51433975 16.9009912,1.49606385 L16.9706774,1.46283419 L17.1223457,1.46386153 L17.2740141,1.46488886 L17.3337192,1.48376564 L17.3934244,1.50264122 L17.4034867,1.49651779 L17.413549,1.49039556 L17.4140586,1.45227648 C17.4143376,1.43131157 17.4273241,1.35330183 17.4429192,1.27892123 L17.4712752,1.14368388 L17.4393799,1.13139044 C17.4218386,1.12462911 17.3801856,1.1106334 17.3468185,1.10028833 L17.2861512,1.08147964 L17.17695,1.0817544 L17.0677488,1.08202915 L16.9787546,1.11285532 L16.8897605,1.1436803 L16.8229391,1.18334995 L16.7561176,1.22301961 L16.669242,1.3126132 L16.5823676,1.4022068 L16.5356913,1.47170873 C16.5100193,1.50993414 16.4874171,1.53950002 16.4854648,1.5374107 C16.4835113,1.53532018 16.4974648,1.45566431 16.5164719,1.36039645 C16.535479,1.2651286 16.5512658,1.17508703 16.5515534,1.16030409 L16.5520751,1.1334272 L16.327606,1.1334272 L16.1031368,1.1334272 L16.1031368,1.14103908 C16.1031368,1.14522489 16.0919461,1.22182741 16.0782681,1.31126691 C16.0645912,1.40070521 16.0371283,1.57333176 16.0172416,1.6948804 C15.9973536,1.81642905 15.9647218,2.01263902 15.9447271,2.13090257 C15.9247312,2.24916611 15.894588,2.41849801 15.8777419,2.50719567 C15.8608958,2.59589333 15.8309746,2.75178618 15.8112517,2.85362424 C15.7915287,2.95546229 15.7591214,3.11941857 15.7392359,3.21797153 C15.7193504,3.31652448 15.6930086,3.44688316 15.6806992,3.50765749 L15.6583178,3.61815625 L15.9231951,3.61815625 L15.9231926,3.61815148 Z M4.18287366,0.70311036 L4.25654638,0.703373168 L4.31510626,0.683728279 L4.37366602,0.664083389 L4.42549425,0.612324572 L4.47732236,0.56056456 L4.50462182,0.491606161 L4.53192127,0.422646568 L4.5328968,0.32110716 L4.53387233,0.219567752 L4.5096054,0.179918405 L4.48533846,0.140270252 L4.4430896,0.114516275 L4.40084074,0.0887622969 L4.30962145,0.0887622969 L4.21840216,0.0887611023 L4.15629991,0.116134932 L4.09419767,0.143508762 L4.05814865,0.181538257 L4.0220995,0.219567752 L3.99378945,0.285269722 L3.96547928,0.350971692 L3.96012782,0.453313859 L3.95477635,0.555656026 L3.98113328,0.606521296 L4.00749008,0.657385372 L4.05834557,0.680117059 L4.10920094,0.702848746 L4.18287366,0.703111554 L4.18287366,0.70311036 Z",
  id: "path2997"
})))), EJ = {
  amex: SJ,
  dinersclub: CJ,
  discover: xJ,
  hipercard: kJ,
  jcb: wJ,
  unionpay: yJ,
  mastercard: _J,
  placeholder: bJ,
  visa: gJ,
  troy: vJ
};
function PJ() {
  const { t: e } = Gr(), [t, n] = ke(!1), {
    setCardNumber: r,
    setExpiryMonth: a,
    setExpiryYear: o,
    setCvc: i,
    setFormInvalid: s,
    cardHolderName: l,
    setCardHolderName: c
  } = J8(), { meta: u, getCardImageProps: d, getCardNumberProps: p, getExpiryDateProps: h, getCVCProps: m } = qZ({
    errorMessages: {
      dateOutOfRange: e("public_pages_purchase.payment_inputs.date_out_of_range"),
      emptyCVC: e("public_pages_purchase.payment_inputs.empty_cvc"),
      invalidCVC: e("public_pages_purchase.payment_inputs.invalid_cvc"),
      emptyCardNumber: e("public_pages_purchase.payment_inputs.empty_card_number"),
      invalidCardNumber: e("public_pages_purchase.payment_inputs.invalid_card_number"),
      emptyExpiryDate: e("public_pages_purchase.payment_inputs.empty_expiry_date"),
      invalidExpiryDate: e("public_pages_purchase.payment_inputs.invalid_expiry_date"),
      monthOutOfRange: e("public_pages_purchase.payment_inputs.month_out_of_range"),
      yearOutOfRange: e("public_pages_purchase.payment_inputs.year_out_of_range")
    }
  }), f = l === "", g = t && f;
  De(() => {
    const b = l.match(/^[a-zA-Z]+ [a-zA-Z]+$/);
    s(!!u.error || f || !b);
  }, [l, g, f, u.error, s]);
  const _ = (b) => {
    r(b.target.value.replace(/\s/g, ""));
  }, v = (b) => {
    const [C, E] = b.target.value.replace(/\s/g, "").split("/");
    C && E && C.length === 2 && E.length === 2 && (a(C), o(E));
  }, w = (b) => {
    i(b.target.value);
  }, {
    state: { primaryColor: x }
  } = Sn();
  return /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ S.jsxs("div", { className: "flex flex-wrap gap-3", children: [
      /* @__PURE__ */ S.jsx(
        Cs,
        {
          ...p({ onChange: _ }),
          addonBefore: /* @__PURE__ */ S.jsx("svg", { ...d({ images: EJ }) }),
          placeholder: e("public_pages_purchase.payment_inputs.card_number_placeholder"),
          inputClassName: "focus:!border-THEME-primary",
          error: u.touchedInputs.cardNumber ? u.erroredInputs.cardNumber : ""
        }
      ),
      /* @__PURE__ */ S.jsx(
        Cs,
        {
          ...h({ onChange: v }),
          placeholder: e("public_pages_purchase.payment_inputs.expiry_data_placeholder"),
          error: u.touchedInputs.expiryDate ? u.erroredInputs.expiryDate : "",
          inputClassName: "focus:!border-THEME-primary",
          className: "w-24"
        }
      )
    ] }),
    /* @__PURE__ */ S.jsxs("div", { className: "flex flex-wrap gap-3", children: [
      /* @__PURE__ */ S.jsx(
        Cs,
        {
          addonBefore: /* @__PURE__ */ S.jsx(zO, { height: 14, width: 21, fill: x }),
          type: "text",
          autoComplete: "cc-name",
          id: "cardName",
          name: "cardName",
          spellCheck: "false",
          "aria-label": e("public_pages_purchase.payment_inputs.card_holder_placeholder"),
          value: l,
          inputClassName: "focus:!border-THEME-primary",
          onChange: (b) => c(b.target.value),
          placeholder: e("public_pages_purchase.payment_inputs.card_holder_placeholder"),
          onBlur: () => n(!0),
          error: g ? e("public_pages_purchase.payment_inputs.empty_card_holder") : ""
        }
      ),
      /* @__PURE__ */ S.jsx(
        Cs,
        {
          ...m({ onChange: w }),
          placeholder: e("public_pages_purchase.payment_inputs.cvc_placeholder"),
          error: u.touchedInputs.cvc ? u.erroredInputs.cvc : "",
          inputClassName: "focus:!border-THEME-primary",
          className: "w-24"
        }
      )
    ] })
  ] });
}
const TJ = (e, t) => {
  switch (e) {
    case ye.stripe_card:
      return /* @__PURE__ */ S.jsx(XY, { ...t });
    case ye.stripe_ideal:
      return /* @__PURE__ */ S.jsx(tZ, {});
    case ye.mercadopago_ar_card:
    case ye.mercadopago_br_card:
    case ye.mercadopago_cl_card:
    case ye.mercadopago_co_card:
    case ye.mercadopago_mx_card:
      return /* @__PURE__ */ S.jsx(PZ, {});
    case ye.xendit_id_card:
    case ye.xendit_ph_card:
      return /* @__PURE__ */ S.jsx(PJ, {});
  }
};
function MJ(e) {
  switch (e) {
    case Uo.SPANISH:
      return "es-AR";
    case Uo.PORTUGUESE:
      return "pt-BR";
    case Uo.ENGLISH:
      return "en-US";
    default:
      return "en-US";
  }
}
function pae({
  children: e,
  publicKey: t,
  forceInitialization: n
}) {
  const { locale: r } = zt(), { paymentMethod: a } = In(), { setInitialized: o } = Q8();
  return De(() => {
    !t || !(a === ye.mercadopago_ar_card || a === ye.mercadopago_br_card || a === ye.mercadopago_br_pix || a === ye.mercadopago_br_boleto || a === ye.mercadopago_cl_card || a === ye.mercadopago_co_card || a === ye.mercadopago_mx_card || n) || (gZ(t, { locale: MJ(r) }), o(!0));
  }, [a, n, t, r]), e;
}
const OJ = [
  dr.CHILEAN_PESO,
  dr.GUINEAN_FRANC,
  dr.JAPANESE_YEN,
  dr.RWANDAN_FRANC,
  dr.UGANDAN_SHILLING,
  dr.CENTRAL_AFRICAN_FRANC,
  dr.WEST_AFRICAN_CFA_FRANC_BCEAO
];
function Wm({ children: e, paymentMethodType: t }) {
  const { stripePromise: n } = uY(), { locale: r } = zt(), { currency: a, finalAmount: o } = In(), { state: i } = Sn(), { primaryColor: s, textColorSecondary: l } = yh(i), c = o && o > 0 && t !== "ideal" ? "payment" : "setup", u = (() => {
    if (o && c === "payment" && a)
      return OJ.includes(a) ? pr(o) : o;
  })(), d = {
    mode: c,
    amount: u,
    payment_method_types: [t],
    currency: a,
    paymentMethodCreation: "manual",
    locale: r,
    appearance: {
      variables: {
        colorPrimary: s
      },
      rules: {
        ".Label": {
          color: l
        }
      }
    }
  };
  return /* @__PURE__ */ S.jsx(
    G7,
    {
      stripe: n,
      options: d,
      children: e
    },
    [d.mode, d.amount, d.payment_method_types].flat().filter(Boolean).join("-")
  );
}
const AJ = (e) => {
  switch (e) {
    case ye.stripe_bancontact:
      return ({ children: t }) => /* @__PURE__ */ S.jsx(Wm, { paymentMethodType: "bancontact", children: t });
    case ye.stripe_applepay:
    case ye.stripe_card:
      return ({ children: t }) => /* @__PURE__ */ S.jsx(Wm, { paymentMethodType: "card", children: t });
    case ye.stripe_ideal:
      return ({ children: t }) => /* @__PURE__ */ S.jsx(Wm, { paymentMethodType: "ideal", children: t });
    default:
      return k.Fragment;
  }
}, Tw = (e) => {
  const { paymentMethod: t } = In();
  return {
    PaymentProcessorProvider: we(
      () => AJ(t),
      [t]
    ),
    paymentProcessorDetails: TJ(t, e),
    paymentProcessorPaymentButton: sZ(t, e)
  };
}, iy = (e) => JSON.parse(JSON.stringify(e)), sy = (e) => Object.values(e).some(
  (t) => Array.isArray(t) ? t.length > 0 : sy(t)
), Mw = (e, t) => {
  var i;
  const { common: n, ...r } = iy(t), a = { ...r, ...((i = e.errors) == null ? void 0 : i.fields) || {} };
  return {
    common: e.errors.common ?? n,
    ...a
  };
};
/*! js-cookie v3.0.5 | MIT */
function Zu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      e[r] = n[r];
  }
  return e;
}
var NJ = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Ff(e, t) {
  function n(a, o, i) {
    if (!(typeof document > "u")) {
      i = Zu({}, t, i), typeof i.expires == "number" && (i.expires = new Date(Date.now() + i.expires * 864e5)), i.expires && (i.expires = i.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var l in i)
        i[l] && (s += "; " + l, i[l] !== !0 && (s += "=" + i[l].split(";")[0]));
      return document.cookie = a + "=" + e.write(o, a) + s;
    }
  }
  function r(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], i = {}, s = 0; s < o.length; s++) {
        var l = o[s].split("="), c = l.slice(1).join("=");
        try {
          var u = decodeURIComponent(l[0]);
          if (i[u] = e.read(c, u), a === u)
            break;
        } catch {
        }
      }
      return a ? i[a] : i;
    }
  }
  return Object.create(
    {
      set: n,
      get: r,
      remove: function(a, o) {
        n(
          a,
          "",
          Zu({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return Ff(this.converter, Zu({}, this.attributes, a));
      },
      withConverter: function(a) {
        return Ff(Zu({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var b3 = Ff(NJ, { path: "/" });
const Ow = ({
  pagePath: e,
  handlerError: t
}) => {
  const n = "error_message", r = b3.get(n);
  De(() => {
    r && (t(r), b3.remove(n, {
      path: e
    }));
  }, [r, e]);
}, Aw = (e) => {
  switch (e) {
    case An.download:
      return We.product_download_cover;
    case An.eCourse:
      return We.e_course_cover;
    case An.physicalProduct:
      return We.physical_product_cover;
  }
}, _3 = (e, t) => Object.keys(e).includes(t), Nw = (e, t) => {
  const n = [];
  return Object.values(Kt).forEach((r) => {
    const a = _3(t, r), o = _3(e, r);
    !a && o && n.push(...e[r]);
  }), n;
}, Lw = (e, t) => yt(e.price * (t ?? 0) / 100), LJ = (e, t) => {
  const n = Lw(e, t);
  return yt(n + e.price);
}, RJ = ({
  calculatePrice: e,
  productVariant: t,
  product: n,
  quantity: r
}) => e != null && e.netAmount ? e.netAmount : t != null && t.price ? yt((t == null ? void 0 : t.price) * r) : yt(n.price * r), DJ = ({ product: e, hasShipping: t, calculatePrice: n }) => {
  const { locale: r } = qn(), { quantity: a, productVariant: o } = bu(), { t: i } = Gr();
  return e && e.name && /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    /* @__PURE__ */ S.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ S.jsxs("div", { className: "flex gap-1 text-[16px]", children: [
        /* @__PURE__ */ S.jsx("span", { children: e.name }),
        /* @__PURE__ */ S.jsxs("span", { className: "font-bold", children: [
          "x",
          a
        ] })
      ] }),
      /* @__PURE__ */ S.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ S.jsx(cn, { currency: e.currency }),
        /* @__PURE__ */ S.jsx("span", { className: "text-[16px] font-bold", children: qr(
          pr(
            RJ({
              calculatePrice: n,
              productVariant: o,
              product: e,
              quantity: a
            })
          ),
          e.currency,
          r
        ) })
      ] })
    ] }),
    !!(n != null && n.tax) && /* @__PURE__ */ S.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ S.jsx("span", { className: "text-[16px]", children: i("public_pages_purchase.vat_percent", {
        percent: n.tax.rate
      }) }),
      /* @__PURE__ */ S.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ S.jsx(cn, { currency: e.currency }),
        /* @__PURE__ */ S.jsx("span", { className: "text-[16px] font-bold", children: qr(
          pr(n.tax.amount),
          e.currency,
          r
        ) })
      ] })
    ] }),
    !!(n != null && n.grossAmount) && /* @__PURE__ */ S.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ S.jsx("span", { className: "text-[16px]", children: i(t ? "public_pages_purchase.subtotal" : "public_pages_purchase.total") }),
      /* @__PURE__ */ S.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ S.jsx(cn, { currency: e.currency }),
        /* @__PURE__ */ S.jsx("span", { className: "text-[16px] font-bold", children: qr(
          pr(n.grossAmount),
          e.currency,
          r
        ) })
      ] })
    ] })
  ] });
}, IJ = ({
  product: e,
  selectedShipping: t,
  calculatePrice: n
}) => {
  var i;
  const { locale: r } = qn(), { t: a } = Gr(), o = Lw(t, (i = n == null ? void 0 : n.tax) == null ? void 0 : i.rate);
  return /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    /* @__PURE__ */ S.jsx("div", { className: "bg-text-secondary/30 h-[1px] w-full" }),
    /* @__PURE__ */ S.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ S.jsx("span", { className: "text-[16px]", children: a("public_pages_purchase.shipping_fee") }),
      /* @__PURE__ */ S.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ S.jsx(cn, { currency: t.currency }),
        /* @__PURE__ */ S.jsx("span", { className: "text-[16px] font-bold", children: qr(
          pr(t.price),
          e.currency,
          r
        ) })
      ] })
    ] }),
    o > 0 && /* @__PURE__ */ S.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ S.jsx("span", { className: "text-[16px]", children: a("public_pages_purchase.vat_percent", {
        percent: n == null ? void 0 : n.tax.rate
      }) }),
      /* @__PURE__ */ S.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ S.jsx(cn, { currency: t.currency }),
        /* @__PURE__ */ S.jsx("span", { className: "text-[16px] font-bold", children: qr(
          pr(o),
          t.currency,
          r
        ) })
      ] })
    ] })
  ] });
}, jJ = ({ product: e, calculatePrice: t, isLoading: n }) => {
  const { t: r } = Gr(), { locale: a } = qn(), { selectedShipping: o } = bu(), { finalAmount: i } = In(), s = !!o, l = s ? LJ(o, (t == null ? void 0 : t.tax.rate) ?? 0) : 0, c = yt(Math.ceil(i ?? 0) + l);
  return /* @__PURE__ */ S.jsxs("div", { className: kr("flex flex-col gap-1", n && "animate-pulse"), children: [
    /* @__PURE__ */ S.jsx(_o, { label: r("public_pages_purchase.order_summary") }),
    /* @__PURE__ */ S.jsxs("div", { className: "border-text-secondary/30 flex flex-col gap-5 rounded-lg border px-3.5 py-5", children: [
      /* @__PURE__ */ S.jsx(DJ, { product: e, hasShipping: s, calculatePrice: t }),
      s && /* @__PURE__ */ S.jsx(
        IJ,
        {
          product: e,
          selectedShipping: o,
          calculatePrice: t
        }
      ),
      c > 0 && /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
        /* @__PURE__ */ S.jsx("div", { className: "bg-text-secondary/30 h-[1px] w-full" }),
        /* @__PURE__ */ S.jsxs("div", { className: "flex w-full items-center justify-between", children: [
          /* @__PURE__ */ S.jsx("span", { className: "text-[16px] font-bold", children: r("public_pages_purchase.total_amount_with_tax_and_shipping") }),
          /* @__PURE__ */ S.jsxs("div", { className: "flex items-center gap-2.5", children: [
            /* @__PURE__ */ S.jsx(cn, { currency: e.currency }),
            /* @__PURE__ */ S.jsx("span", { className: "text-[16px] font-bold", children: qr(
              pr(c),
              e.currency,
              a
            ) })
          ] })
        ] })
      ] })
    ] })
  ] });
}, Rw = (e, t, n, r) => {
  const o = t.optionValueIds.map((i) => n.optionValues.map((l) => l.id).includes(i) ? r.id : i);
  return e.productVariants.find(
    (i) => JSON.stringify(i.optionValueIds) === JSON.stringify(o)
  );
}, BJ = (e, t, n, r) => !!Rw(e, t, n, r), FJ = ({ product: e, activeVariant: t, changeActiveVariant: n }) => {
  const r = (a, o) => {
    const i = Rw(e, t, a, o);
    i && n(i);
  };
  return /* @__PURE__ */ S.jsx("div", { className: "flex flex-col gap-2", children: e.options.map((a) => /* @__PURE__ */ S.jsxs("div", { children: [
    /* @__PURE__ */ S.jsx("span", { children: a.name }),
    /* @__PURE__ */ S.jsx("div", { className: "flex flex-wrap gap-2", children: a.optionValues.map((o) => {
      const i = t.optionValueIds.includes(o.id);
      return /* @__PURE__ */ S.jsx(
        z4,
        {
          type: "button",
          onClick: () => r(a, o),
          disabled: !BJ(e, t, a, o),
          color: i ? "text-THEME-primary" : "text-THEME-text-secondary",
          hoverColor: `hover:${i ? "text-THEME-primary" : "text-THEME-text-secondary"}`,
          backgroundColor: i ? "bg-THEME-tertiary" : "bg-THEME-secondary",
          hoverBackgroundColor: i ? "hover:bg-THEME-tertiary" : "hover:bg-THEME-secondary",
          borderColor: i ? "border-THEME-tertiary" : "border-THEME-border-tertiary",
          children: o.value
        },
        o.id
      );
    }) })
  ] }, a.id)) });
}, w3 = "w-8 h-full main-transition-colors hover:bg-THEME-tertiary text-THEME-text-secondary hover:text-THEME-text-secondary", zJ = ({
  quantity: e,
  onIncrease: t,
  onDecrease: n,
  disabledIncreaseButton: r,
  disabledDecreaseButton: a
}) => {
  const { t: o } = Gr();
  return /* @__PURE__ */ S.jsxs("div", { className: "flex justify-between", children: [
    /* @__PURE__ */ S.jsx("span", { children: o("public_pages_purchase.quantity") }),
    /* @__PURE__ */ S.jsxs(
      "div",
      {
        className: "border-THEME-border-tertiary flex h-8 items-center overflow-hidden rounded-md border text-[16px]",
        children: [
          /* @__PURE__ */ S.jsx(
            "button",
            {
              disabled: a,
              type: "button",
              onClick: n,
              className: w3,
              children: "-"
            }
          ),
          /* @__PURE__ */ S.jsx("span", { className: "inline-block min-w-8 text-center font-bold", children: e }),
          /* @__PURE__ */ S.jsx(
            "button",
            {
              disabled: r,
              type: "button",
              onClick: t,
              className: w3,
              children: "+"
            }
          )
        ]
      }
    )
  ] });
};
function Zo() {
  return Zo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zo.apply(null, arguments);
}
function S3(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function be(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? S3(Object(n), !0).forEach(function(r) {
      Ve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : S3(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function GJ(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Eu(e, t) {
  if (t && (Gn(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return GJ(e);
}
function yl() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (yl = function() {
    return !!e;
  })();
}
function Vn(e) {
  return Vn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Vn(e);
}
function zf(e, t) {
  return zf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, zf(e, t);
}
function vl(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && zf(e, t);
}
var HJ = {
  animating: !1,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: !1,
  edgeDragged: !1,
  initialized: !1,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: !1,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: !1,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: !1,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
function KJ(e, t, n) {
  var r = n || {}, a = r.noTrailing, o = a === void 0 ? !1 : a, i = r.noLeading, s = i === void 0 ? !1 : i, l = r.debounceMode, c = l === void 0 ? void 0 : l, u, d = !1, p = 0;
  function h() {
    u && clearTimeout(u);
  }
  function m(g) {
    var _ = g || {}, v = _.upcomingOnly, w = v === void 0 ? !1 : v;
    h(), d = !w;
  }
  function f() {
    for (var g = arguments.length, _ = new Array(g), v = 0; v < g; v++)
      _[v] = arguments[v];
    var w = this, x = Date.now() - p;
    if (d)
      return;
    function b() {
      p = Date.now(), t.apply(w, _);
    }
    function C() {
      u = void 0;
    }
    !s && c && !u && b(), h(), c === void 0 && x > e ? s ? (p = Date.now(), o || (u = setTimeout(c ? C : b, e))) : b() : o !== !0 && (u = setTimeout(c ? C : b, c === void 0 ? e - x : e));
  }
  return f.cancel = m, f;
}
function UJ(e, t, n) {
  var r = {}, a = r.atBegin, o = a === void 0 ? !1 : a;
  return KJ(e, t, {
    debounceMode: o !== !1
  });
}
var Dw = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = "", i = 0; i < arguments.length; i++) {
        var s = arguments[i];
        s && (o = a(o, r(s)));
      }
      return o;
    }
    function r(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var i = "";
      for (var s in o)
        t.call(o, s) && o[s] && (i = a(i, s));
      return i;
    }
    function a(o, i) {
      return i ? o ? o + " " + i : o + i : o;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(Dw);
var $J = Dw.exports;
const Gi = /* @__PURE__ */ qc($J);
var Gf = {
  accessibility: !0,
  adaptiveHeight: !1,
  afterChange: null,
  appendDots: function(t) {
    return /* @__PURE__ */ k.createElement("ul", {
      style: {
        display: "block"
      }
    }, t);
  },
  arrows: !0,
  autoplay: !1,
  autoplaySpeed: 3e3,
  beforeChange: null,
  centerMode: !1,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function(t) {
    return /* @__PURE__ */ k.createElement("button", null, t + 1);
  },
  dots: !1,
  dotsClass: "slick-dots",
  draggable: !0,
  easing: "linear",
  edgeFriction: 0.35,
  fade: !1,
  focusOnSelect: !1,
  infinite: !0,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: !1,
  pauseOnFocus: !1,
  pauseOnHover: !0,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: !1,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: !0,
  swipeEvent: null,
  swipeToSlide: !1,
  touchMove: !0,
  touchThreshold: 5,
  useCSS: !0,
  useTransform: !0,
  variableWidth: !1,
  vertical: !1,
  waitForAnimate: !0,
  asNavFor: null
};
function Hf(e, t, n) {
  return Math.max(t, Math.min(e, n));
}
var Ns = function(t) {
  var n = ["onTouchStart", "onTouchMove", "onWheel"];
  n.includes(t._reactName) || t.preventDefault();
}, mp = function(t) {
  for (var n = [], r = Iw(t), a = jw(t), o = r; o < a; o++)
    t.lazyLoadedList.indexOf(o) < 0 && n.push(o);
  return n;
}, Iw = function(t) {
  return t.currentSlide - VJ(t);
}, jw = function(t) {
  return t.currentSlide + WJ(t);
}, VJ = function(t) {
  return t.centerMode ? Math.floor(t.slidesToShow / 2) + (parseInt(t.centerPadding) > 0 ? 1 : 0) : 0;
}, WJ = function(t) {
  return t.centerMode ? Math.floor((t.slidesToShow - 1) / 2) + 1 + (parseInt(t.centerPadding) > 0 ? 1 : 0) : t.slidesToShow;
}, Kf = function(t) {
  return t && t.offsetWidth || 0;
}, ly = function(t) {
  return t && t.offsetHeight || 0;
}, Bw = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r, a, o, i;
  return r = t.startX - t.curX, a = t.startY - t.curY, o = Math.atan2(a, r), i = Math.round(o * 180 / Math.PI), i < 0 && (i = 360 - Math.abs(i)), i <= 45 && i >= 0 || i <= 360 && i >= 315 ? "left" : i >= 135 && i <= 225 ? "right" : n === !0 ? i >= 35 && i <= 135 ? "up" : "down" : "vertical";
}, Ah = function(t) {
  var n = !0;
  return t.infinite || (t.centerMode && t.currentSlide >= t.slideCount - 1 || t.slideCount <= t.slidesToShow || t.currentSlide >= t.slideCount - t.slidesToShow) && (n = !1), n;
}, Ym = function(t, n) {
  var r = {};
  return n.forEach(function(a) {
    return r[a] = t[a];
  }), r;
}, YJ = function(t) {
  var n = k.Children.count(t.children), r = t.listRef, a = Math.ceil(Kf(r)), o = t.trackRef && t.trackRef.node, i = Math.ceil(Kf(o)), s;
  if (t.vertical)
    s = a;
  else {
    var l = t.centerMode && parseInt(t.centerPadding) * 2;
    typeof t.centerPadding == "string" && t.centerPadding.slice(-1) === "%" && (l *= a / 100), s = Math.ceil((a - l) / t.slidesToShow);
  }
  var c = r && ly(r.querySelector('[data-index="0"]')), u = c * t.slidesToShow, d = t.currentSlide === void 0 ? t.initialSlide : t.currentSlide;
  t.rtl && t.currentSlide === void 0 && (d = n - 1 - t.initialSlide);
  var p = t.lazyLoadedList || [], h = mp(be(be({}, t), {}, {
    currentSlide: d,
    lazyLoadedList: p
  }));
  p = p.concat(h);
  var m = {
    slideCount: n,
    slideWidth: s,
    listWidth: a,
    trackWidth: i,
    currentSlide: d,
    slideHeight: c,
    listHeight: u,
    lazyLoadedList: p
  };
  return t.autoplaying === null && t.autoplay && (m.autoplaying = "playing"), m;
}, ZJ = function(t) {
  var n = t.waitForAnimate, r = t.animating, a = t.fade, o = t.infinite, i = t.index, s = t.slideCount, l = t.lazyLoad, c = t.currentSlide, u = t.centerMode, d = t.slidesToScroll, p = t.slidesToShow, h = t.useCSS, m = t.lazyLoadedList;
  if (n && r)
    return {};
  var f = i, g, _, v, w = {}, x = {}, b = o ? i : Hf(i, 0, s - 1);
  if (a) {
    if (!o && (i < 0 || i >= s))
      return {};
    i < 0 ? f = i + s : i >= s && (f = i - s), l && m.indexOf(f) < 0 && (m = m.concat(f)), w = {
      animating: !0,
      currentSlide: f,
      lazyLoadedList: m,
      targetSlide: f
    }, x = {
      animating: !1,
      targetSlide: f
    };
  } else
    g = f, f < 0 ? (g = f + s, o ? s % d !== 0 && (g = s - s % d) : g = 0) : !Ah(t) && f > c ? f = g = c : u && f >= s ? (f = o ? s : s - 1, g = o ? 0 : s - 1) : f >= s && (g = f - s, o ? s % d !== 0 && (g = 0) : g = s - p), !o && f + p >= s && (g = s - p), _ = Hc(be(be({}, t), {}, {
      slideIndex: f
    })), v = Hc(be(be({}, t), {}, {
      slideIndex: g
    })), o || (_ === v && (f = g), _ = v), l && (m = m.concat(mp(be(be({}, t), {}, {
      currentSlide: f
    })))), h ? (w = {
      animating: !0,
      currentSlide: g,
      trackStyle: Fw(be(be({}, t), {}, {
        left: _
      })),
      lazyLoadedList: m,
      targetSlide: b
    }, x = {
      animating: !1,
      currentSlide: g,
      trackStyle: Gc(be(be({}, t), {}, {
        left: v
      })),
      swipeLeft: null,
      targetSlide: b
    }) : w = {
      currentSlide: g,
      trackStyle: Gc(be(be({}, t), {}, {
        left: v
      })),
      lazyLoadedList: m,
      targetSlide: b
    };
  return {
    state: w,
    nextState: x
  };
}, qJ = function(t, n) {
  var r, a, o, i, s, l = t.slidesToScroll, c = t.slidesToShow, u = t.slideCount, d = t.currentSlide, p = t.targetSlide, h = t.lazyLoad, m = t.infinite;
  if (i = u % l !== 0, r = i ? 0 : (u - d) % l, n.message === "previous")
    o = r === 0 ? l : c - r, s = d - o, h && !m && (a = d - o, s = a === -1 ? u - 1 : a), m || (s = p - l);
  else if (n.message === "next")
    o = r === 0 ? l : r, s = d + o, h && !m && (s = (d + l) % u + r), m || (s = p + l);
  else if (n.message === "dots")
    s = n.index * n.slidesToScroll;
  else if (n.message === "children") {
    if (s = n.index, m) {
      var f = nX(be(be({}, t), {}, {
        targetSlide: s
      }));
      s > n.currentSlide && f === "left" ? s = s - u : s < n.currentSlide && f === "right" && (s = s + u);
    }
  } else
    n.message === "index" && (s = Number(n.index));
  return s;
}, JJ = function(t, n, r) {
  return t.target.tagName.match("TEXTAREA|INPUT|SELECT") || !n ? "" : t.keyCode === 37 ? r ? "next" : "previous" : t.keyCode === 39 ? r ? "previous" : "next" : "";
}, XJ = function(t, n, r) {
  return t.target.tagName === "IMG" && Ns(t), !n || !r && t.type.indexOf("mouse") !== -1 ? "" : {
    dragging: !0,
    touchObject: {
      startX: t.touches ? t.touches[0].pageX : t.clientX,
      startY: t.touches ? t.touches[0].pageY : t.clientY,
      curX: t.touches ? t.touches[0].pageX : t.clientX,
      curY: t.touches ? t.touches[0].pageY : t.clientY
    }
  };
}, QJ = function(t, n) {
  var r = n.scrolling, a = n.animating, o = n.vertical, i = n.swipeToSlide, s = n.verticalSwiping, l = n.rtl, c = n.currentSlide, u = n.edgeFriction, d = n.edgeDragged, p = n.onEdge, h = n.swiped, m = n.swiping, f = n.slideCount, g = n.slidesToScroll, _ = n.infinite, v = n.touchObject, w = n.swipeEvent, x = n.listHeight, b = n.listWidth;
  if (!r) {
    if (a)
      return Ns(t);
    o && i && s && Ns(t);
    var C, E = {}, A = Hc(n);
    v.curX = t.touches ? t.touches[0].pageX : t.clientX, v.curY = t.touches ? t.touches[0].pageY : t.clientY, v.swipeLength = Math.round(Math.sqrt(Math.pow(v.curX - v.startX, 2)));
    var O = Math.round(Math.sqrt(Math.pow(v.curY - v.startY, 2)));
    if (!s && !m && O > 10)
      return {
        scrolling: !0
      };
    s && (v.swipeLength = O);
    var M = (l ? -1 : 1) * (v.curX > v.startX ? 1 : -1);
    s && (M = v.curY > v.startY ? 1 : -1);
    var I = Math.ceil(f / g), D = Bw(n.touchObject, s), K = v.swipeLength;
    return _ || (c === 0 && (D === "right" || D === "down") || c + 1 >= I && (D === "left" || D === "up") || !Ah(n) && (D === "left" || D === "up")) && (K = v.swipeLength * u, d === !1 && p && (p(D), E.edgeDragged = !0)), !h && w && (w(D), E.swiped = !0), o ? C = A + K * (x / b) * M : l ? C = A - K * M : C = A + K * M, s && (C = A + K * M), E = be(be({}, E), {}, {
      touchObject: v,
      swipeLeft: C,
      trackStyle: Gc(be(be({}, n), {}, {
        left: C
      }))
    }), Math.abs(v.curX - v.startX) < Math.abs(v.curY - v.startY) * 0.8 || v.swipeLength > 10 && (E.swiping = !0, Ns(t)), E;
  }
}, eX = function(t, n) {
  var r = n.dragging, a = n.swipe, o = n.touchObject, i = n.listWidth, s = n.touchThreshold, l = n.verticalSwiping, c = n.listHeight, u = n.swipeToSlide, d = n.scrolling, p = n.onSwipe, h = n.targetSlide, m = n.currentSlide, f = n.infinite;
  if (!r)
    return a && Ns(t), {};
  var g = l ? c / s : i / s, _ = Bw(o, l), v = {
    dragging: !1,
    edgeDragged: !1,
    scrolling: !1,
    swiping: !1,
    swiped: !1,
    swipeLeft: null,
    touchObject: {}
  };
  if (d || !o.swipeLength)
    return v;
  if (o.swipeLength > g) {
    Ns(t), p && p(_);
    var w, x, b = f ? m : h;
    switch (_) {
      case "left":
      case "up":
        x = b + x3(n), w = u ? C3(n, x) : x, v.currentDirection = 0;
        break;
      case "right":
      case "down":
        x = b - x3(n), w = u ? C3(n, x) : x, v.currentDirection = 1;
        break;
      default:
        w = b;
    }
    v.triggerSlideHandler = w;
  } else {
    var C = Hc(n);
    v.trackStyle = Fw(be(be({}, n), {}, {
      left: C
    }));
  }
  return v;
}, tX = function(t) {
  for (var n = t.infinite ? t.slideCount * 2 : t.slideCount, r = t.infinite ? t.slidesToShow * -1 : 0, a = t.infinite ? t.slidesToShow * -1 : 0, o = []; r < n; )
    o.push(r), r = a + t.slidesToScroll, a += Math.min(t.slidesToScroll, t.slidesToShow);
  return o;
}, C3 = function(t, n) {
  var r = tX(t), a = 0;
  if (n > r[r.length - 1])
    n = r[r.length - 1];
  else
    for (var o in r) {
      if (n < r[o]) {
        n = a;
        break;
      }
      a = r[o];
    }
  return n;
}, x3 = function(t) {
  var n = t.centerMode ? t.slideWidth * Math.floor(t.slidesToShow / 2) : 0;
  if (t.swipeToSlide) {
    var r, a = t.listRef, o = a.querySelectorAll && a.querySelectorAll(".slick-slide") || [];
    if (Array.from(o).every(function(l) {
      if (t.vertical) {
        if (l.offsetTop + ly(l) / 2 > t.swipeLeft * -1)
          return r = l, !1;
      } else if (l.offsetLeft - n + Kf(l) / 2 > t.swipeLeft * -1)
        return r = l, !1;
      return !0;
    }), !r)
      return 0;
    var i = t.rtl === !0 ? t.slideCount - t.currentSlide : t.currentSlide, s = Math.abs(r.dataset.index - i) || 1;
    return s;
  } else
    return t.slidesToScroll;
}, cy = function(t, n) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    n.reduce(function(r, a) {
      return r && t.hasOwnProperty(a);
    }, !0) ? null : console.error("Keys Missing:", t)
  );
}, Gc = function(t) {
  cy(t, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var n, r;
  if (!t.vertical)
    n = rX(t) * t.slideWidth;
  else {
    var a = t.unslick ? t.slideCount : t.slideCount + 2 * t.slidesToShow;
    r = a * t.slideHeight;
  }
  var o = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (t.useTransform) {
    var i = t.vertical ? "translate3d(0px, " + t.left + "px, 0px)" : "translate3d(" + t.left + "px, 0px, 0px)", s = t.vertical ? "translate3d(0px, " + t.left + "px, 0px)" : "translate3d(" + t.left + "px, 0px, 0px)", l = t.vertical ? "translateY(" + t.left + "px)" : "translateX(" + t.left + "px)";
    o = be(be({}, o), {}, {
      WebkitTransform: i,
      transform: s,
      msTransform: l
    });
  } else
    t.vertical ? o.top = t.left : o.left = t.left;
  return t.fade && (o = {
    opacity: 1
  }), n && (o.width = n), r && (o.height = r), window && !window.addEventListener && window.attachEvent && (t.vertical ? o.marginTop = t.left + "px" : o.marginLeft = t.left + "px"), o;
}, Fw = function(t) {
  cy(t, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var n = Gc(t);
  return t.useTransform ? (n.WebkitTransition = "-webkit-transform " + t.speed + "ms " + t.cssEase, n.transition = "transform " + t.speed + "ms " + t.cssEase) : t.vertical ? n.transition = "top " + t.speed + "ms " + t.cssEase : n.transition = "left " + t.speed + "ms " + t.cssEase, n;
}, Hc = function(t) {
  if (t.unslick)
    return 0;
  cy(t, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var n = t.slideIndex, r = t.trackRef, a = t.infinite, o = t.centerMode, i = t.slideCount, s = t.slidesToShow, l = t.slidesToScroll, c = t.slideWidth, u = t.listWidth, d = t.variableWidth, p = t.slideHeight, h = t.fade, m = t.vertical, f = 0, g, _, v = 0;
  if (h || t.slideCount === 1)
    return 0;
  var w = 0;
  if (a ? (w = -ho(t), i % l !== 0 && n + l > i && (w = -(n > i ? s - (n - i) : i % l)), o && (w += parseInt(s / 2))) : (i % l !== 0 && n + l > i && (w = s - i % l), o && (w = parseInt(s / 2))), f = w * c, v = w * p, m ? g = n * p * -1 + v : g = n * c * -1 + f, d === !0) {
    var x, b = r && r.node;
    if (x = n + ho(t), _ = b && b.childNodes[x], g = _ ? _.offsetLeft * -1 : 0, o === !0) {
      x = a ? n + ho(t) : n, _ = b && b.children[x], g = 0;
      for (var C = 0; C < x; C++)
        g -= b && b.children[C] && b.children[C].offsetWidth;
      g -= parseInt(t.centerPadding), g += _ && (u - _.offsetWidth) / 2;
    }
  }
  return g;
}, ho = function(t) {
  return t.unslick || !t.infinite ? 0 : t.variableWidth ? t.slideCount : t.slidesToShow + (t.centerMode ? 1 : 0);
}, xd = function(t) {
  return t.unslick || !t.infinite ? 0 : t.slideCount;
}, rX = function(t) {
  return t.slideCount === 1 ? 1 : ho(t) + t.slideCount + xd(t);
}, nX = function(t) {
  return t.targetSlide > t.currentSlide ? t.targetSlide > t.currentSlide + aX(t) ? "left" : "right" : t.targetSlide < t.currentSlide - oX(t) ? "right" : "left";
}, aX = function(t) {
  var n = t.slidesToShow, r = t.centerMode, a = t.rtl, o = t.centerPadding;
  if (r) {
    var i = (n - 1) / 2 + 1;
    return parseInt(o) > 0 && (i += 1), a && n % 2 === 0 && (i += 1), i;
  }
  return a ? 0 : n - 1;
}, oX = function(t) {
  var n = t.slidesToShow, r = t.centerMode, a = t.rtl, o = t.centerPadding;
  if (r) {
    var i = (n - 1) / 2 + 1;
    return parseInt(o) > 0 && (i += 1), !a && n % 2 === 0 && (i += 1), i;
  }
  return a ? n - 1 : 0;
}, k3 = function() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}, iX = Object.keys(Gf);
function sX(e) {
  return iX.reduce(function(t, n) {
    return e.hasOwnProperty(n) && (t[n] = e[n]), t;
  }, {});
}
function lX(e, t, n) {
  return t = Vn(t), Eu(e, yl() ? Reflect.construct(t, n || [], Vn(e).constructor) : t.apply(e, n));
}
var Zm = function(t) {
  var n, r, a, o, i;
  t.rtl ? i = t.slideCount - 1 - t.index : i = t.index, a = i < 0 || i >= t.slideCount, t.centerMode ? (o = Math.floor(t.slidesToShow / 2), r = (i - t.currentSlide) % t.slideCount === 0, i > t.currentSlide - o - 1 && i <= t.currentSlide + o && (n = !0)) : n = t.currentSlide <= i && i < t.currentSlide + t.slidesToShow;
  var s;
  t.targetSlide < 0 ? s = t.targetSlide + t.slideCount : t.targetSlide >= t.slideCount ? s = t.targetSlide - t.slideCount : s = t.targetSlide;
  var l = i === s;
  return {
    "slick-slide": !0,
    "slick-active": n,
    "slick-center": r,
    "slick-cloned": a,
    "slick-current": l
    // dubious in case of RTL
  };
}, cX = function(t) {
  var n = {};
  return (t.variableWidth === void 0 || t.variableWidth === !1) && (n.width = t.slideWidth), t.fade && (n.position = "relative", t.vertical && t.slideHeight ? n.top = -t.index * parseInt(t.slideHeight) : n.left = -t.index * parseInt(t.slideWidth), n.opacity = t.currentSlide === t.index ? 1 : 0, n.zIndex = t.currentSlide === t.index ? 999 : 998, t.useCSS && (n.transition = "opacity " + t.speed + "ms " + t.cssEase + ", visibility " + t.speed + "ms " + t.cssEase)), n;
}, qm = function(t, n) {
  return t.key + "-" + n;
}, uX = function(t) {
  var n, r = [], a = [], o = [], i = k.Children.count(t.children), s = Iw(t), l = jw(t);
  return k.Children.forEach(t.children, function(c, u) {
    var d, p = {
      message: "children",
      index: u,
      slidesToScroll: t.slidesToScroll,
      currentSlide: t.currentSlide
    };
    !t.lazyLoad || t.lazyLoad && t.lazyLoadedList.indexOf(u) >= 0 ? d = c : d = /* @__PURE__ */ k.createElement("div", null);
    var h = cX(be(be({}, t), {}, {
      index: u
    })), m = d.props.className || "", f = Zm(be(be({}, t), {}, {
      index: u
    }));
    if (r.push(/* @__PURE__ */ k.cloneElement(d, {
      key: "original" + qm(d, u),
      "data-index": u,
      className: Gi(f, m),
      tabIndex: "-1",
      "aria-hidden": !f["slick-active"],
      style: be(be({
        outline: "none"
      }, d.props.style || {}), h),
      onClick: function(v) {
        d.props && d.props.onClick && d.props.onClick(v), t.focusOnSelect && t.focusOnSelect(p);
      }
    })), t.infinite && i > 1 && t.fade === !1 && !t.unslick) {
      var g = i - u;
      g <= ho(t) && (n = -g, n >= s && (d = c), f = Zm(be(be({}, t), {}, {
        index: n
      })), a.push(/* @__PURE__ */ k.cloneElement(d, {
        key: "precloned" + qm(d, n),
        "data-index": n,
        tabIndex: "-1",
        className: Gi(f, m),
        "aria-hidden": !f["slick-active"],
        style: be(be({}, d.props.style || {}), h),
        onClick: function(v) {
          d.props && d.props.onClick && d.props.onClick(v), t.focusOnSelect && t.focusOnSelect(p);
        }
      }))), n = i + u, n < l && (d = c), f = Zm(be(be({}, t), {}, {
        index: n
      })), o.push(/* @__PURE__ */ k.cloneElement(d, {
        key: "postcloned" + qm(d, n),
        "data-index": n,
        tabIndex: "-1",
        className: Gi(f, m),
        "aria-hidden": !f["slick-active"],
        style: be(be({}, d.props.style || {}), h),
        onClick: function(v) {
          d.props && d.props.onClick && d.props.onClick(v), t.focusOnSelect && t.focusOnSelect(p);
        }
      }));
    }
  }), t.rtl ? a.concat(r, o).reverse() : a.concat(r, o);
}, dX = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    as(this, t);
    for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++)
      a[o] = arguments[o];
    return n = lX(this, t, [].concat(a)), Ve(n, "node", null), Ve(n, "handleRef", function(i) {
      n.node = i;
    }), n;
  }
  return vl(t, e), os(t, [{
    key: "render",
    value: function() {
      var r = uX(this.props), a = this.props, o = a.onMouseEnter, i = a.onMouseOver, s = a.onMouseLeave, l = {
        onMouseEnter: o,
        onMouseOver: i,
        onMouseLeave: s
      };
      return /* @__PURE__ */ k.createElement("div", Zo({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, l), r);
    }
  }]);
}(k.PureComponent);
function pX(e, t, n) {
  return t = Vn(t), Eu(e, yl() ? Reflect.construct(t, n || [], Vn(e).constructor) : t.apply(e, n));
}
var hX = function(t) {
  var n;
  return t.infinite ? n = Math.ceil(t.slideCount / t.slidesToScroll) : n = Math.ceil((t.slideCount - t.slidesToShow) / t.slidesToScroll) + 1, n;
}, mX = /* @__PURE__ */ function(e) {
  function t() {
    return as(this, t), pX(this, t, arguments);
  }
  return vl(t, e), os(t, [{
    key: "clickHandler",
    value: function(r, a) {
      a.preventDefault(), this.props.clickHandler(r);
    }
  }, {
    key: "render",
    value: function() {
      for (var r = this.props, a = r.onMouseEnter, o = r.onMouseOver, i = r.onMouseLeave, s = r.infinite, l = r.slidesToScroll, c = r.slidesToShow, u = r.slideCount, d = r.currentSlide, p = hX({
        slideCount: u,
        slidesToScroll: l,
        slidesToShow: c,
        infinite: s
      }), h = {
        onMouseEnter: a,
        onMouseOver: o,
        onMouseLeave: i
      }, m = [], f = 0; f < p; f++) {
        var g = (f + 1) * l - 1, _ = s ? g : Hf(g, 0, u - 1), v = _ - (l - 1), w = s ? v : Hf(v, 0, u - 1), x = Gi({
          "slick-active": s ? d >= w && d <= _ : d === w
        }), b = {
          message: "dots",
          index: f,
          slidesToScroll: l,
          currentSlide: d
        }, C = this.clickHandler.bind(this, b);
        m = m.concat(/* @__PURE__ */ k.createElement("li", {
          key: f,
          className: x
        }, /* @__PURE__ */ k.cloneElement(this.props.customPaging(f), {
          onClick: C
        })));
      }
      return /* @__PURE__ */ k.cloneElement(this.props.appendDots(m), be({
        className: this.props.dotsClass
      }, h));
    }
  }]);
}(k.PureComponent);
function zw(e, t, n) {
  return t = Vn(t), Eu(e, yl() ? Reflect.construct(t, n || [], Vn(e).constructor) : t.apply(e, n));
}
var fX = /* @__PURE__ */ function(e) {
  function t() {
    return as(this, t), zw(this, t, arguments);
  }
  return vl(t, e), os(t, [{
    key: "clickHandler",
    value: function(r, a) {
      a && a.preventDefault(), this.props.clickHandler(r, a);
    }
  }, {
    key: "render",
    value: function() {
      var r = {
        "slick-arrow": !0,
        "slick-prev": !0
      }, a = this.clickHandler.bind(this, {
        message: "previous"
      });
      !this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow) && (r["slick-disabled"] = !0, a = null);
      var o = {
        key: "0",
        "data-role": "none",
        className: Gi(r),
        style: {
          display: "block"
        },
        onClick: a
      }, i = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, s;
      return this.props.prevArrow ? s = /* @__PURE__ */ k.cloneElement(this.props.prevArrow, be(be({}, o), i)) : s = /* @__PURE__ */ k.createElement("button", Zo({
        key: "0",
        type: "button"
      }, o), " ", "Previous"), s;
    }
  }]);
}(k.PureComponent), gX = /* @__PURE__ */ function(e) {
  function t() {
    return as(this, t), zw(this, t, arguments);
  }
  return vl(t, e), os(t, [{
    key: "clickHandler",
    value: function(r, a) {
      a && a.preventDefault(), this.props.clickHandler(r, a);
    }
  }, {
    key: "render",
    value: function() {
      var r = {
        "slick-arrow": !0,
        "slick-next": !0
      }, a = this.clickHandler.bind(this, {
        message: "next"
      });
      Ah(this.props) || (r["slick-disabled"] = !0, a = null);
      var o = {
        key: "1",
        "data-role": "none",
        className: Gi(r),
        style: {
          display: "block"
        },
        onClick: a
      }, i = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, s;
      return this.props.nextArrow ? s = /* @__PURE__ */ k.cloneElement(this.props.nextArrow, be(be({}, o), i)) : s = /* @__PURE__ */ k.createElement("button", Zo({
        key: "1",
        type: "button"
      }, o), " ", "Next"), s;
    }
  }]);
}(k.PureComponent), Gw = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, n) {
    var r = -1;
    return t.some(function(a, o) {
      return a[0] === n ? (r = o, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(n) {
        var r = e(this.__entries__, n), a = this.__entries__[r];
        return a && a[1];
      }, t.prototype.set = function(n, r) {
        var a = e(this.__entries__, n);
        ~a ? this.__entries__[a][1] = r : this.__entries__.push([n, r]);
      }, t.prototype.delete = function(n) {
        var r = this.__entries__, a = e(r, n);
        ~a && r.splice(a, 1);
      }, t.prototype.has = function(n) {
        return !!~e(this.__entries__, n);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var a = 0, o = this.__entries__; a < o.length; a++) {
          var i = o[a];
          n.call(r, i[1], i[0]);
        }
      }, t;
    }()
  );
}(), Uf = typeof window < "u" && typeof document < "u" && window.document === document, fp = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), yX = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(fp) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), vX = 2;
function bX(e, t) {
  var n = !1, r = !1, a = 0;
  function o() {
    n && (n = !1, e()), r && s();
  }
  function i() {
    yX(o);
  }
  function s() {
    var l = Date.now();
    if (n) {
      if (l - a < vX)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(i, t);
    a = l;
  }
  return s;
}
var _X = 20, wX = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], SX = typeof MutationObserver < "u", CX = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = bX(this.refresh.bind(this), _X);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var n = this.observers_, r = n.indexOf(t);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return t.forEach(function(n) {
        return n.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !Uf || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), SX ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !Uf || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var n = t.propertyName, r = n === void 0 ? "" : n, a = wX.some(function(o) {
        return !!~r.indexOf(o);
      });
      a && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), Hw = function(e, t) {
  for (var n = 0, r = Object.keys(t); n < r.length; n++) {
    var a = r[n];
    Object.defineProperty(e, a, {
      value: t[a],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, Js = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || fp;
}, Kw = Nh(0, 0, 0, 0);
function gp(e) {
  return parseFloat(e) || 0;
}
function E3(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.reduce(function(r, a) {
    var o = e["border-" + a + "-width"];
    return r + gp(o);
  }, 0);
}
function xX(e) {
  for (var t = ["top", "right", "bottom", "left"], n = {}, r = 0, a = t; r < a.length; r++) {
    var o = a[r], i = e["padding-" + o];
    n[o] = gp(i);
  }
  return n;
}
function kX(e) {
  var t = e.getBBox();
  return Nh(0, 0, t.width, t.height);
}
function EX(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!t && !n)
    return Kw;
  var r = Js(e).getComputedStyle(e), a = xX(r), o = a.left + a.right, i = a.top + a.bottom, s = gp(r.width), l = gp(r.height);
  if (r.boxSizing === "border-box" && (Math.round(s + o) !== t && (s -= E3(r, "left", "right") + o), Math.round(l + i) !== n && (l -= E3(r, "top", "bottom") + i)), !TX(e)) {
    var c = Math.round(s + o) - t, u = Math.round(l + i) - n;
    Math.abs(c) !== 1 && (s -= c), Math.abs(u) !== 1 && (l -= u);
  }
  return Nh(a.left, a.top, s, l);
}
var PX = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof Js(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof Js(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function TX(e) {
  return e === Js(e).document.documentElement;
}
function MX(e) {
  return Uf ? PX(e) ? kX(e) : EX(e) : Kw;
}
function OX(e) {
  var t = e.x, n = e.y, r = e.width, a = e.height, o = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, i = Object.create(o.prototype);
  return Hw(i, {
    x: t,
    y: n,
    width: r,
    height: a,
    top: n,
    right: t + r,
    bottom: a + n,
    left: t
  }), i;
}
function Nh(e, t, n, r) {
  return { x: e, y: t, width: n, height: r };
}
var AX = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Nh(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = MX(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), NX = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      var r = OX(n);
      Hw(this, { target: t, contentRect: r });
    }
    return e;
  }()
), LX = (
  /** @class */
  function() {
    function e(t, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new Gw(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = n, this.callbackCtx_ = r;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Js(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) || (n.set(t, new AX(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Js(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) && (n.delete(t), n.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && t.activeObservations_.push(n);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new NX(r.target, r.broadcastRect());
        });
        this.callback_.call(t, n, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), Uw = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new Gw(), $w = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = CX.getInstance(), r = new LX(t, n, this);
      Uw.set(this, r);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  $w.prototype[e] = function() {
    var t;
    return (t = Uw.get(this))[e].apply(t, arguments);
  };
});
var RX = function() {
  return typeof fp.ResizeObserver < "u" ? fp.ResizeObserver : $w;
}(), DX = ["animating"];
function IX(e, t, n) {
  return t = Vn(t), Eu(e, yl() ? Reflect.construct(t, n || [], Vn(e).constructor) : t.apply(e, n));
}
var jX = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    as(this, t), r = IX(this, t, [n]), Ve(r, "listRefHandler", function(o) {
      return r.list = o;
    }), Ve(r, "trackRefHandler", function(o) {
      return r.track = o;
    }), Ve(r, "adaptHeight", function() {
      if (r.props.adaptiveHeight && r.list) {
        var o = r.list.querySelector('[data-index="'.concat(r.state.currentSlide, '"]'));
        r.list.style.height = ly(o) + "px";
      }
    }), Ve(r, "componentDidMount", function() {
      if (r.props.onInit && r.props.onInit(), r.props.lazyLoad) {
        var o = mp(be(be({}, r.props), r.state));
        o.length > 0 && (r.setState(function(s) {
          return {
            lazyLoadedList: s.lazyLoadedList.concat(o)
          };
        }), r.props.onLazyLoad && r.props.onLazyLoad(o));
      }
      var i = be({
        listRef: r.list,
        trackRef: r.track
      }, r.props);
      r.updateState(i, !0, function() {
        r.adaptHeight(), r.props.autoplay && r.autoPlay("playing");
      }), r.props.lazyLoad === "progressive" && (r.lazyLoadTimer = setInterval(r.progressiveLazyLoad, 1e3)), r.ro = new RX(function() {
        r.state.animating ? (r.onWindowResized(!1), r.callbackTimers.push(setTimeout(function() {
          return r.onWindowResized();
        }, r.props.speed))) : r.onWindowResized();
      }), r.ro.observe(r.list), document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(s) {
        s.onfocus = r.props.pauseOnFocus ? r.onSlideFocus : null, s.onblur = r.props.pauseOnFocus ? r.onSlideBlur : null;
      }), window.addEventListener ? window.addEventListener("resize", r.onWindowResized) : window.attachEvent("onresize", r.onWindowResized);
    }), Ve(r, "componentWillUnmount", function() {
      r.animationEndCallback && clearTimeout(r.animationEndCallback), r.lazyLoadTimer && clearInterval(r.lazyLoadTimer), r.callbackTimers.length && (r.callbackTimers.forEach(function(o) {
        return clearTimeout(o);
      }), r.callbackTimers = []), window.addEventListener ? window.removeEventListener("resize", r.onWindowResized) : window.detachEvent("onresize", r.onWindowResized), r.autoplayTimer && clearInterval(r.autoplayTimer), r.ro.disconnect();
    }), Ve(r, "componentDidUpdate", function(o) {
      if (r.checkImagesLoad(), r.props.onReInit && r.props.onReInit(), r.props.lazyLoad) {
        var i = mp(be(be({}, r.props), r.state));
        i.length > 0 && (r.setState(function(c) {
          return {
            lazyLoadedList: c.lazyLoadedList.concat(i)
          };
        }), r.props.onLazyLoad && r.props.onLazyLoad(i));
      }
      r.adaptHeight();
      var s = be(be({
        listRef: r.list,
        trackRef: r.track
      }, r.props), r.state), l = r.didPropsChange(o);
      l && r.updateState(s, l, function() {
        r.state.currentSlide >= k.Children.count(r.props.children) && r.changeSlide({
          message: "index",
          index: k.Children.count(r.props.children) - r.props.slidesToShow,
          currentSlide: r.state.currentSlide
        }), (o.autoplay !== r.props.autoplay || o.autoplaySpeed !== r.props.autoplaySpeed) && (!o.autoplay && r.props.autoplay ? r.autoPlay("playing") : r.props.autoplay ? r.autoPlay("update") : r.pause("paused"));
      });
    }), Ve(r, "onWindowResized", function(o) {
      r.debouncedResize && r.debouncedResize.cancel(), r.debouncedResize = UJ(50, function() {
        return r.resizeWindow(o);
      }), r.debouncedResize();
    }), Ve(r, "resizeWindow", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, i = !!(r.track && r.track.node);
      if (i) {
        var s = be(be({
          listRef: r.list,
          trackRef: r.track
        }, r.props), r.state);
        r.updateState(s, o, function() {
          r.props.autoplay ? r.autoPlay("update") : r.pause("paused");
        }), r.setState({
          animating: !1
        }), clearTimeout(r.animationEndCallback), delete r.animationEndCallback;
      }
    }), Ve(r, "updateState", function(o, i, s) {
      var l = YJ(o);
      o = be(be(be({}, o), l), {}, {
        slideIndex: l.currentSlide
      });
      var c = Hc(o);
      o = be(be({}, o), {}, {
        left: c
      });
      var u = Gc(o);
      (i || k.Children.count(r.props.children) !== k.Children.count(o.children)) && (l.trackStyle = u), r.setState(l, s);
    }), Ve(r, "ssrInit", function() {
      if (r.props.variableWidth) {
        var o = 0, i = 0, s = [], l = ho(be(be(be({}, r.props), r.state), {}, {
          slideCount: r.props.children.length
        })), c = xd(be(be(be({}, r.props), r.state), {}, {
          slideCount: r.props.children.length
        }));
        r.props.children.forEach(function(C) {
          s.push(C.props.style.width), o += C.props.style.width;
        });
        for (var u = 0; u < l; u++)
          i += s[s.length - 1 - u], o += s[s.length - 1 - u];
        for (var d = 0; d < c; d++)
          o += s[d];
        for (var p = 0; p < r.state.currentSlide; p++)
          i += s[p];
        var h = {
          width: o + "px",
          left: -i + "px"
        };
        if (r.props.centerMode) {
          var m = "".concat(s[r.state.currentSlide], "px");
          h.left = "calc(".concat(h.left, " + (100% - ").concat(m, ") / 2 ) ");
        }
        return {
          trackStyle: h
        };
      }
      var f = k.Children.count(r.props.children), g = be(be(be({}, r.props), r.state), {}, {
        slideCount: f
      }), _ = ho(g) + xd(g) + f, v = 100 / r.props.slidesToShow * _, w = 100 / _, x = -w * (ho(g) + r.state.currentSlide) * v / 100;
      r.props.centerMode && (x += (100 - w * v / 100) / 2);
      var b = {
        width: v + "%",
        left: x + "%"
      };
      return {
        slideWidth: w + "%",
        trackStyle: b
      };
    }), Ve(r, "checkImagesLoad", function() {
      var o = r.list && r.list.querySelectorAll && r.list.querySelectorAll(".slick-slide img") || [], i = o.length, s = 0;
      Array.prototype.forEach.call(o, function(l) {
        var c = function() {
          return ++s && s >= i && r.onWindowResized();
        };
        if (!l.onclick)
          l.onclick = function() {
            return l.parentNode.focus();
          };
        else {
          var u = l.onclick;
          l.onclick = function(d) {
            u(d), l.parentNode.focus();
          };
        }
        l.onload || (r.props.lazyLoad ? l.onload = function() {
          r.adaptHeight(), r.callbackTimers.push(setTimeout(r.onWindowResized, r.props.speed));
        } : (l.onload = c, l.onerror = function() {
          c(), r.props.onLazyLoadError && r.props.onLazyLoadError();
        }));
      });
    }), Ve(r, "progressiveLazyLoad", function() {
      for (var o = [], i = be(be({}, r.props), r.state), s = r.state.currentSlide; s < r.state.slideCount + xd(i); s++)
        if (r.state.lazyLoadedList.indexOf(s) < 0) {
          o.push(s);
          break;
        }
      for (var l = r.state.currentSlide - 1; l >= -ho(i); l--)
        if (r.state.lazyLoadedList.indexOf(l) < 0) {
          o.push(l);
          break;
        }
      o.length > 0 ? (r.setState(function(c) {
        return {
          lazyLoadedList: c.lazyLoadedList.concat(o)
        };
      }), r.props.onLazyLoad && r.props.onLazyLoad(o)) : r.lazyLoadTimer && (clearInterval(r.lazyLoadTimer), delete r.lazyLoadTimer);
    }), Ve(r, "slideHandler", function(o) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, s = r.props, l = s.asNavFor, c = s.beforeChange, u = s.onLazyLoad, d = s.speed, p = s.afterChange, h = r.state.currentSlide, m = ZJ(be(be(be({
        index: o
      }, r.props), r.state), {}, {
        trackRef: r.track,
        useCSS: r.props.useCSS && !i
      })), f = m.state, g = m.nextState;
      if (f) {
        c && c(h, f.currentSlide);
        var _ = f.lazyLoadedList.filter(function(v) {
          return r.state.lazyLoadedList.indexOf(v) < 0;
        });
        u && _.length > 0 && u(_), !r.props.waitForAnimate && r.animationEndCallback && (clearTimeout(r.animationEndCallback), p && p(h), delete r.animationEndCallback), r.setState(f, function() {
          l && r.asNavForIndex !== o && (r.asNavForIndex = o, l.innerSlider.slideHandler(o)), g && (r.animationEndCallback = setTimeout(function() {
            var v = g.animating, w = Pg(g, DX);
            r.setState(w, function() {
              r.callbackTimers.push(setTimeout(function() {
                return r.setState({
                  animating: v
                });
              }, 10)), p && p(f.currentSlide), delete r.animationEndCallback;
            });
          }, d));
        });
      }
    }), Ve(r, "changeSlide", function(o) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, s = be(be({}, r.props), r.state), l = qJ(s, o);
      if (!(l !== 0 && !l) && (i === !0 ? r.slideHandler(l, i) : r.slideHandler(l), r.props.autoplay && r.autoPlay("update"), r.props.focusOnSelect)) {
        var c = r.list.querySelectorAll(".slick-current");
        c[0] && c[0].focus();
      }
    }), Ve(r, "clickHandler", function(o) {
      r.clickable === !1 && (o.stopPropagation(), o.preventDefault()), r.clickable = !0;
    }), Ve(r, "keyHandler", function(o) {
      var i = JJ(o, r.props.accessibility, r.props.rtl);
      i !== "" && r.changeSlide({
        message: i
      });
    }), Ve(r, "selectHandler", function(o) {
      r.changeSlide(o);
    }), Ve(r, "disableBodyScroll", function() {
      var o = function(s) {
        s = s || window.event, s.preventDefault && s.preventDefault(), s.returnValue = !1;
      };
      window.ontouchmove = o;
    }), Ve(r, "enableBodyScroll", function() {
      window.ontouchmove = null;
    }), Ve(r, "swipeStart", function(o) {
      r.props.verticalSwiping && r.disableBodyScroll();
      var i = XJ(o, r.props.swipe, r.props.draggable);
      i !== "" && r.setState(i);
    }), Ve(r, "swipeMove", function(o) {
      var i = QJ(o, be(be(be({}, r.props), r.state), {}, {
        trackRef: r.track,
        listRef: r.list,
        slideIndex: r.state.currentSlide
      }));
      i && (i.swiping && (r.clickable = !1), r.setState(i));
    }), Ve(r, "swipeEnd", function(o) {
      var i = eX(o, be(be(be({}, r.props), r.state), {}, {
        trackRef: r.track,
        listRef: r.list,
        slideIndex: r.state.currentSlide
      }));
      if (i) {
        var s = i.triggerSlideHandler;
        delete i.triggerSlideHandler, r.setState(i), s !== void 0 && (r.slideHandler(s), r.props.verticalSwiping && r.enableBodyScroll());
      }
    }), Ve(r, "touchEnd", function(o) {
      r.swipeEnd(o), r.clickable = !0;
    }), Ve(r, "slickPrev", function() {
      r.callbackTimers.push(setTimeout(function() {
        return r.changeSlide({
          message: "previous"
        });
      }, 0));
    }), Ve(r, "slickNext", function() {
      r.callbackTimers.push(setTimeout(function() {
        return r.changeSlide({
          message: "next"
        });
      }, 0));
    }), Ve(r, "slickGoTo", function(o) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (o = Number(o), isNaN(o))
        return "";
      r.callbackTimers.push(setTimeout(function() {
        return r.changeSlide({
          message: "index",
          index: o,
          currentSlide: r.state.currentSlide
        }, i);
      }, 0));
    }), Ve(r, "play", function() {
      var o;
      if (r.props.rtl)
        o = r.state.currentSlide - r.props.slidesToScroll;
      else if (Ah(be(be({}, r.props), r.state)))
        o = r.state.currentSlide + r.props.slidesToScroll;
      else
        return !1;
      r.slideHandler(o);
    }), Ve(r, "autoPlay", function(o) {
      r.autoplayTimer && clearInterval(r.autoplayTimer);
      var i = r.state.autoplaying;
      if (o === "update") {
        if (i === "hovered" || i === "focused" || i === "paused")
          return;
      } else if (o === "leave") {
        if (i === "paused" || i === "focused")
          return;
      } else if (o === "blur" && (i === "paused" || i === "hovered"))
        return;
      r.autoplayTimer = setInterval(r.play, r.props.autoplaySpeed + 50), r.setState({
        autoplaying: "playing"
      });
    }), Ve(r, "pause", function(o) {
      r.autoplayTimer && (clearInterval(r.autoplayTimer), r.autoplayTimer = null);
      var i = r.state.autoplaying;
      o === "paused" ? r.setState({
        autoplaying: "paused"
      }) : o === "focused" ? (i === "hovered" || i === "playing") && r.setState({
        autoplaying: "focused"
      }) : i === "playing" && r.setState({
        autoplaying: "hovered"
      });
    }), Ve(r, "onDotsOver", function() {
      return r.props.autoplay && r.pause("hovered");
    }), Ve(r, "onDotsLeave", function() {
      return r.props.autoplay && r.state.autoplaying === "hovered" && r.autoPlay("leave");
    }), Ve(r, "onTrackOver", function() {
      return r.props.autoplay && r.pause("hovered");
    }), Ve(r, "onTrackLeave", function() {
      return r.props.autoplay && r.state.autoplaying === "hovered" && r.autoPlay("leave");
    }), Ve(r, "onSlideFocus", function() {
      return r.props.autoplay && r.pause("focused");
    }), Ve(r, "onSlideBlur", function() {
      return r.props.autoplay && r.state.autoplaying === "focused" && r.autoPlay("blur");
    }), Ve(r, "render", function() {
      var o = Gi("slick-slider", r.props.className, {
        "slick-vertical": r.props.vertical,
        "slick-initialized": !0
      }), i = be(be({}, r.props), r.state), s = Ym(i, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]), l = r.props.pauseOnHover;
      s = be(be({}, s), {}, {
        onMouseEnter: l ? r.onTrackOver : null,
        onMouseLeave: l ? r.onTrackLeave : null,
        onMouseOver: l ? r.onTrackOver : null,
        focusOnSelect: r.props.focusOnSelect && r.clickable ? r.selectHandler : null
      });
      var c;
      if (r.props.dots === !0 && r.state.slideCount >= r.props.slidesToShow) {
        var u = Ym(i, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]), d = r.props.pauseOnDotsHover;
        u = be(be({}, u), {}, {
          clickHandler: r.changeSlide,
          onMouseEnter: d ? r.onDotsLeave : null,
          onMouseOver: d ? r.onDotsOver : null,
          onMouseLeave: d ? r.onDotsLeave : null
        }), c = /* @__PURE__ */ k.createElement(mX, u);
      }
      var p, h, m = Ym(i, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      m.clickHandler = r.changeSlide, r.props.arrows && (p = /* @__PURE__ */ k.createElement(fX, m), h = /* @__PURE__ */ k.createElement(gX, m));
      var f = null;
      r.props.vertical && (f = {
        height: r.state.listHeight
      });
      var g = null;
      r.props.vertical === !1 ? r.props.centerMode === !0 && (g = {
        padding: "0px " + r.props.centerPadding
      }) : r.props.centerMode === !0 && (g = {
        padding: r.props.centerPadding + " 0px"
      });
      var _ = be(be({}, f), g), v = r.props.touchMove, w = {
        className: "slick-list",
        style: _,
        onClick: r.clickHandler,
        onMouseDown: v ? r.swipeStart : null,
        onMouseMove: r.state.dragging && v ? r.swipeMove : null,
        onMouseUp: v ? r.swipeEnd : null,
        onMouseLeave: r.state.dragging && v ? r.swipeEnd : null,
        onTouchStart: v ? r.swipeStart : null,
        onTouchMove: r.state.dragging && v ? r.swipeMove : null,
        onTouchEnd: v ? r.touchEnd : null,
        onTouchCancel: r.state.dragging && v ? r.swipeEnd : null,
        onKeyDown: r.props.accessibility ? r.keyHandler : null
      }, x = {
        className: o,
        dir: "ltr",
        style: r.props.style
      };
      return r.props.unslick && (w = {
        className: "slick-list"
      }, x = {
        className: o,
        style: r.props.style
      }), /* @__PURE__ */ k.createElement("div", x, r.props.unslick ? "" : p, /* @__PURE__ */ k.createElement("div", Zo({
        ref: r.listRefHandler
      }, w), /* @__PURE__ */ k.createElement(dX, Zo({
        ref: r.trackRefHandler
      }, s), r.props.children)), r.props.unslick ? "" : h, r.props.unslick ? "" : c);
    }), r.list = null, r.track = null, r.state = be(be({}, HJ), {}, {
      currentSlide: r.props.initialSlide,
      targetSlide: r.props.initialSlide ? r.props.initialSlide : 0,
      slideCount: k.Children.count(r.props.children)
    }), r.callbackTimers = [], r.clickable = !0, r.debouncedResize = null;
    var a = r.ssrInit();
    return r.state = be(be({}, r.state), a), r;
  }
  return vl(t, e), os(t, [{
    key: "didPropsChange",
    value: function(r) {
      for (var a = !1, o = 0, i = Object.keys(this.props); o < i.length; o++) {
        var s = i[o];
        if (!r.hasOwnProperty(s)) {
          a = !0;
          break;
        }
        if (!(Gn(r[s]) === "object" || typeof r[s] == "function" || isNaN(r[s])) && r[s] !== this.props[s]) {
          a = !0;
          break;
        }
      }
      return a || k.Children.count(this.props.children) !== k.Children.count(r.children);
    }
  }]);
}(k.Component), BX = function(e) {
  return e.replace(/[A-Z]/g, function(t) {
    return "-" + t.toLowerCase();
  }).toLowerCase();
}, FX = BX, zX = FX, GX = function(e) {
  var t = /[height|width]$/;
  return t.test(e);
}, P3 = function(e) {
  var t = "", n = Object.keys(e);
  return n.forEach(function(r, a) {
    var o = e[r];
    r = zX(r), GX(r) && typeof o == "number" && (o = o + "px"), o === !0 ? t += r : o === !1 ? t += "not " + r : t += "(" + r + ": " + o + ")", a < n.length - 1 && (t += " and ");
  }), t;
}, HX = function(e) {
  var t = "";
  return typeof e == "string" ? e : e instanceof Array ? (e.forEach(function(n, r) {
    t += P3(n), r < e.length - 1 && (t += ", ");
  }), t) : P3(e);
}, KX = HX;
const Jm = /* @__PURE__ */ qc(KX);
function UX(e, t, n) {
  return t = Vn(t), Eu(e, yl() ? Reflect.construct(t, n || [], Vn(e).constructor) : t.apply(e, n));
}
var $X = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return as(this, t), r = UX(this, t, [n]), Ve(r, "innerSliderRefHandler", function(a) {
      return r.innerSlider = a;
    }), Ve(r, "slickPrev", function() {
      return r.innerSlider.slickPrev();
    }), Ve(r, "slickNext", function() {
      return r.innerSlider.slickNext();
    }), Ve(r, "slickGoTo", function(a) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      return r.innerSlider.slickGoTo(a, o);
    }), Ve(r, "slickPause", function() {
      return r.innerSlider.pause("paused");
    }), Ve(r, "slickPlay", function() {
      return r.innerSlider.autoPlay("play");
    }), r.state = {
      breakpoint: null
    }, r._responsiveMediaHandlers = [], r;
  }
  return vl(t, e), os(t, [{
    key: "media",
    value: function(r, a) {
      var o = window.matchMedia(r), i = function(l) {
        var c = l.matches;
        c && a();
      };
      o.addListener(i), i(o), this._responsiveMediaHandlers.push({
        mql: o,
        query: r,
        listener: i
      });
    }
    // handles responsive breakpoints
  }, {
    key: "componentDidMount",
    value: function() {
      var r = this;
      if (this.props.responsive) {
        var a = this.props.responsive.map(function(i) {
          return i.breakpoint;
        });
        a.sort(function(i, s) {
          return i - s;
        }), a.forEach(function(i, s) {
          var l;
          s === 0 ? l = Jm({
            minWidth: 0,
            maxWidth: i
          }) : l = Jm({
            minWidth: a[s - 1] + 1,
            maxWidth: i
          }), k3() && r.media(l, function() {
            r.setState({
              breakpoint: i
            });
          });
        });
        var o = Jm({
          minWidth: a.slice(-1)[0]
        });
        k3() && this.media(o, function() {
          r.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._responsiveMediaHandlers.forEach(function(r) {
        r.mql.removeListener(r.listener);
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this, a, o;
      this.state.breakpoint ? (o = this.props.responsive.filter(function(f) {
        return f.breakpoint === r.state.breakpoint;
      }), a = o[0].settings === "unslick" ? "unslick" : be(be(be({}, Gf), this.props), o[0].settings)) : a = be(be({}, Gf), this.props), a.centerMode && (a.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(a.slidesToScroll)), a.slidesToScroll = 1), a.fade && (a.slidesToShow > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(a.slidesToShow)), a.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(a.slidesToScroll)), a.slidesToShow = 1, a.slidesToScroll = 1);
      var i = k.Children.toArray(this.props.children);
      i = i.filter(function(f) {
        return typeof f == "string" ? !!f.trim() : !!f;
      }), a.variableWidth && (a.rows > 1 || a.slidesPerRow > 1) && (console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1"), a.variableWidth = !1);
      for (var s = [], l = null, c = 0; c < i.length; c += a.rows * a.slidesPerRow) {
        for (var u = [], d = c; d < c + a.rows * a.slidesPerRow; d += a.slidesPerRow) {
          for (var p = [], h = d; h < d + a.slidesPerRow && (a.variableWidth && i[h].props.style && (l = i[h].props.style.width), !(h >= i.length)); h += 1)
            p.push(/* @__PURE__ */ k.cloneElement(i[h], {
              key: 100 * c + 10 * d + h,
              tabIndex: -1,
              style: {
                width: "".concat(100 / a.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          u.push(/* @__PURE__ */ k.createElement("div", {
            key: 10 * c + d
          }, p));
        }
        a.variableWidth ? s.push(/* @__PURE__ */ k.createElement("div", {
          key: c,
          style: {
            width: l
          }
        }, u)) : s.push(/* @__PURE__ */ k.createElement("div", {
          key: c
        }, u));
      }
      if (a === "unslick") {
        var m = "regular slider " + (this.props.className || "");
        return /* @__PURE__ */ k.createElement("div", {
          className: m
        }, i);
      } else
        s.length <= a.slidesToShow && !a.infinite && (a.unslick = !0);
      return /* @__PURE__ */ k.createElement(jX, Zo({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, sX(a)), s);
    }
  }]);
}(k.Component), $f = /* @__PURE__ */ ((e) => (e[e.left = 0] = "left", e[e.right = 1] = "right", e))($f || {});
const T3 = ({ className: e, onClick: t, variant: n }) => {
  const { isDefaultSioColor: r } = Sn();
  return /* @__PURE__ */ S.jsx(
    "div",
    {
      className: kr(
        e,
        n === 0 ? "!left-2" : "!right-2",
        "!z-20 !h-[24px] !w-[24px] before:!content-none"
      ),
      onClick: t,
      children: /* @__PURE__ */ S.jsx(
        ag,
        {
          className: kr(
            "before:!display-none !flex !h-[24px] !w-[24px] justify-center",
            r ? "stroke-brand-primary" : "stroke-THEME-text-primary",
            n === 0 ? "rotate-90" : "-rotate-90"
          )
        }
      )
    }
  );
}, VX = ({ goToSlide: e, index: t, slidesCount: n }) => {
  const r = _e(null), [a, o] = ke(!1), { isDefaultSioColor: i } = Sn();
  let s = "";
  return a ? s = i ? "!bg-brand-primary" : "!bg-THEME-primary" : s = i ? "bg-THEME-tertiary" : "bg-THEME-secondary", De(() => {
    if (!r.current)
      return;
    const l = r.current.parentElement;
    if (!l)
      return;
    l.style.width = `${100 / n}%`, o(l.classList.contains("slick-active"));
    const c = new MutationObserver((u) => {
      u.forEach((d) => {
        d.attributeName === "class" && o(l.classList.contains("slick-active"));
      });
    });
    return c.observe(l, { attributes: !0 }), () => c.disconnect();
  }, []), /* @__PURE__ */ S.jsx(
    "div",
    {
      onClick: () => e(t),
      className: At("flex h-[4px] cursor-pointer rounded-[30px]", s),
      ref: r
    }
  );
}, Vw = k.forwardRef(
  ({ images: e, goToSlide: t }, n) => {
    if (!e || e.length === 0)
      return null;
    const r = e.length > 1;
    return /* @__PURE__ */ S.jsx(
      $X,
      {
        ref: n,
        swipe: r,
        arrows: r,
        infinite: r,
        swipeToSlide: r,
        dots: r,
        prevArrow: /* @__PURE__ */ S.jsx(T3, { variant: $f.left }),
        nextArrow: /* @__PURE__ */ S.jsx(T3, { variant: $f.right }),
        customPaging: (a) => /* @__PURE__ */ S.jsx(VX, { slidesCount: e.length, index: a, goToSlide: t }),
        dotsClass: "relative bottom-5 !flex flex-row justify-center items-center gap-[9px] w-[calc(100%-90px)] max-w-[120px] mx-auto",
        children: e.map(({ path: a, id: o }) => /* @__PURE__ */ S.jsx("div", { className: "!flex items-center justify-center", children: /* @__PURE__ */ S.jsx("img", { src: a }) }, o))
      }
    );
  }
);
Vw.displayName = "Slider";
const WX = ({ product: e }) => {
  const { currency: t, productVariants: n, images: r = [], name: a, stock: o, limitStock: i } = e, [s, l] = ke([]), { setPricePlan: c, setFinalAmount: u } = In(), { locale: d } = qn(), { quantity: p, setQuantity: h, productVariant: m, setProductVariant: f } = bu(), { t: g } = Gr(), _ = _e(null), v = (I) => {
    var D;
    (D = _ == null ? void 0 : _.current) == null || D.slickGoTo(I);
  }, w = (I, D) => {
    const K = f0(I, D);
    K && (c(K), u(K.amount));
  }, x = (I) => {
    var D;
    if (f(I), I.image) {
      const K = [I.image, ...s.slice(1)];
      l(K), (D = _.current) == null || D.slickGoTo(0);
    }
    w(e, I);
  };
  Hr(e, (I) => {
    if (!I)
      c(void 0), u(void 0);
    else {
      const D = [...r], K = m ?? n[0];
      f(K), K != null && K.image && D.unshift(K.image), l(D), w(I, K);
    }
  });
  const b = (m == null ? void 0 : m.stock) ?? o ?? 0, C = () => h(p + 1), E = () => h(p - 1), A = b > 0 && i ? b : void 0, O = !!A && p >= A, M = p <= 1;
  return /* @__PURE__ */ S.jsx("div", { className: "flex flex-col gap-3 sm:gap-5", children: /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ S.jsx(_o, { label: g("public_pages_purchase.product") }),
    /* @__PURE__ */ S.jsxs(
      "div",
      {
        className: "border-text-secondary/30 flex flex-col gap-3.5 rounded-lg border px-3.5 py-5",
        children: [
          m && /* @__PURE__ */ S.jsx(
            FJ,
            {
              product: e,
              activeVariant: m,
              changeActiveVariant: x
            }
          ),
          /* @__PURE__ */ S.jsx(
            zJ,
            {
              quantity: p,
              onIncrease: C,
              onDecrease: E,
              disabledIncreaseButton: O,
              disabledDecreaseButton: M
            }
          ),
          /* @__PURE__ */ S.jsx(Vw, { goToSlide: v, ref: _, images: s }),
          /* @__PURE__ */ S.jsxs("div", { className: "items flex justify-between", children: [
            /* @__PURE__ */ S.jsx("h2", { className: "text-[16px] font-normal", children: a }),
            /* @__PURE__ */ S.jsxs("div", { className: "flex items-center gap-2.5", children: [
              /* @__PURE__ */ S.jsx(cn, { currency: t }),
              /* @__PURE__ */ S.jsx("span", { className: "text-[16px] font-bold", children: qr(
                pr((m == null ? void 0 : m.price) ?? e.price),
                e.currency,
                d
              ) })
            ] })
          ] })
        ]
      }
    )
  ] }) });
}, YX = (e, t) => t ? e.some(
  (n) => n.rules.some((r) => r.id !== t.ruleId ? !1 : t.conditionId ? r.shippingConditions.some((a) => a.id === t.conditionId) : !0)
) : !1, ZX = ({ service: e, rule: t, onChange: n, isSelected: r }) => {
  const { locale: a } = qn(), o = qr(
    pr(t.price),
    t.currency,
    a
  );
  return /* @__PURE__ */ S.jsxs("label", { className: "relative flex cursor-pointer items-center gap-2", children: [
    /* @__PURE__ */ S.jsx(
      "input",
      {
        className: At(
          "border-fill-primary h-[20px] w-[20px] rounded-full border-2 outline-hidden",
          r ? "bg-background-secondary" : "bg-transparent",
          "main-transition-colors ring-brand-primary shrink-0 appearance-none ring-offset-1 focus-visible:ring-2"
        ),
        checked: r,
        value: t.id,
        onChange: () => {
          n({
            ruleId: t.id,
            currency: t.currency,
            price: t.price
          });
        },
        type: "radio"
      }
    ),
    /* @__PURE__ */ S.jsx(zg, { className: kr(!r && "fill-transparent") }),
    /* @__PURE__ */ S.jsx("div", { className: "flex w-full flex-wrap items-center justify-between gap-3", children: /* @__PURE__ */ S.jsxs(
      "div",
      {
        className: "main-transition-colors flex flex-col flex-wrap gap-2 text-left text-[16px]",
        children: [
          /* @__PURE__ */ S.jsxs("div", { className: "flex flex-wrap gap-1", children: [
            /* @__PURE__ */ S.jsx("span", { className: "flex shrink-0", children: e.name }),
            /* @__PURE__ */ S.jsx("span", { className: "flex shrink-0", children: t.name })
          ] }),
          t.description
        ]
      }
    ) }),
    /* @__PURE__ */ S.jsxs("div", { className: "ml-auto flex items-center gap-2.5", children: [
      /* @__PURE__ */ S.jsx(cn, { currency: t.currency }),
      /* @__PURE__ */ S.jsx("span", { className: "main-transition-colors text-[16px] font-bold", children: o })
    ] })
  ] });
};
var kn = /* @__PURE__ */ ((e) => (e.Inclusive = "inclusive", e.Exclusive = "exclusive", e))(kn || {}), En = /* @__PURE__ */ ((e) => (e.one_shot = "one_shot", e.subscription = "subscription", e.limited_subscription = "limited_subscription", e))(En || {}), Hi = /* @__PURE__ */ ((e) => (e.price = "price", e.quantity = "quantity", e.weight = "weight", e))(Hi || {});
const kd = (e, t, n, r = "narrowSymbol") => {
  try {
    return new Intl.NumberFormat(n, {
      style: "currency",
      currency: t,
      currencyDisplay: r
    }).format(e);
  } catch (a) {
    if (a instanceof RangeError && r !== "symbol")
      return kd(e, t, n, "symbol");
    throw a;
  }
}, qX = (e, t, n, r) => {
  switch (t.type) {
    case Hi.price:
      return e.max ? n("public_pages_purchase.shipping.condition_label.price", {
        min: kd(pr(e.min), t.currency, r),
        max: kd(pr(e.max), t.currency, r),
        currency: ""
      }) : n("public_pages_purchase.shipping.condition_label.price_min", {
        min: kd(pr(e.min), t.currency, r),
        currency: ""
      });
    case Hi.quantity:
      return e.max ? n("public_pages_purchase.shipping.condition_label.quantity", {
        min: e.min,
        max: e.max
      }) : n("public_pages_purchase.shipping.condition_label.quantity_min", {
        min: e.min
      });
    case Hi.weight:
      return e.max ? n("public_pages_purchase.shipping.condition_label.weight", {
        min: e.min,
        max: e.max
      }) : n("public_pages_purchase.shipping.condition_label.weight_min", {
        min: e.min
      });
    default:
      return "";
  }
}, JX = ({
  onChange: e,
  service: t,
  rule: n,
  condition: r,
  isSelected: a
}) => {
  const { t: o } = Gr(), { locale: i } = qn();
  return /* @__PURE__ */ S.jsxs("label", { className: At("relative flex cursor-pointer items-center gap-2"), children: [
    /* @__PURE__ */ S.jsx(
      "input",
      {
        className: At(
          "border-fill-primary h-[20px] w-[20px] rounded-full border-2 outline-hidden",
          a ? "bg-background-secondary" : "bg-transparent",
          "main-transition-colors ring-brand-primary shrink-0 appearance-none ring-offset-1 focus-visible:ring-2"
        ),
        checked: a,
        value: n.id,
        onChange: () => {
          e({
            ruleId: n.id,
            currency: n.currency,
            conditionId: r.id,
            price: r.price
          });
        },
        type: "radio"
      }
    ),
    /* @__PURE__ */ S.jsx(zg, { className: kr(!a && "fill-transparent") }),
    /* @__PURE__ */ S.jsx("div", { className: "flex w-full flex-wrap items-center justify-between gap-3", children: /* @__PURE__ */ S.jsxs(
      "div",
      {
        className: "main-transition-colors flex max-w-full flex-col flex-wrap gap-2 text-left text-[16px] md:max-w-[70%]",
        children: [
          /* @__PURE__ */ S.jsxs("div", { className: "flex flex-wrap gap-1", children: [
            /* @__PURE__ */ S.jsx("span", { className: "flex shrink-0", children: t.name }),
            /* @__PURE__ */ S.jsx("span", { className: "flex shrink-0", children: n.name })
          ] }),
          qX(r, n, o, i)
        ]
      }
    ) }),
    /* @__PURE__ */ S.jsxs("div", { className: "ml-auto flex items-center gap-2.5", children: [
      /* @__PURE__ */ S.jsx(cn, { currency: n.currency }),
      /* @__PURE__ */ S.jsx("span", { className: "main-transition-colors text-[16px] font-bold", children: qr(pr(r.price), n.currency, i) })
    ] })
  ] });
}, XX = ({ shipping: e, isLoading: t }) => {
  const { t: n } = Gr(), { setSelectedShipping: r, selectedShipping: a } = bu();
  Hr(a, (i) => {
    if (!(!e || !e.length) && !YX(e, i))
      if (e[0]) {
        const s = e[0].rules[0], l = s.shippingConditions[0];
        r(l ? {
          ruleId: s.id,
          currency: s.currency,
          conditionId: l.id,
          price: l.price
        } : {
          ruleId: s.id,
          currency: s.currency,
          price: s.price
        });
      } else
        r(null);
  });
  const o = (i) => {
    r(i);
  };
  return typeof e > "u" ? null : /* @__PURE__ */ S.jsxs("div", { className: kr("flex flex-col gap-1", t && "animate-pulse"), children: [
    /* @__PURE__ */ S.jsx(_o, { label: n("public_pages_purchase.shipping.shipping_method") }),
    /* @__PURE__ */ S.jsx("div", { className: "border-text-secondary/30 flex flex-col gap-4 rounded-lg border p-4", children: e.length ? e.map(
      (i, s) => i.rules.map(
        (l) => l.shippingConditions.length ? l.shippingConditions.map((c) => {
          const u = c.id === (a == null ? void 0 : a.conditionId) && l.id === (a == null ? void 0 : a.ruleId);
          return /* @__PURE__ */ S.jsx(
            JX,
            {
              isSelected: u,
              onChange: o,
              service: i,
              rule: l,
              condition: c
            },
            c.id
          );
        }) : /* @__PURE__ */ S.jsx(
          ZX,
          {
            isSelected: l.id === (a == null ? void 0 : a.ruleId),
            onChange: o,
            service: i,
            rule: l
          },
          l.id
        )
      )
    ) : n("public_pages_purchase.shipping.not_available") })
  ] });
};
var uy = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
}, de = (e, t, n) => (uy(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Ht = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, ut = (e, t, n, r) => (uy(e, t, "write to private field"), t.set(e, n), n), Vf = (e, t, n, r) => ({
  set _(a) {
    ut(e, t, a);
  },
  get _() {
    return de(e, t, r);
  }
}), sn = (e, t, n) => (uy(e, t, "access private method"), n), Wf = { exports: {} }, Hl = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var M3;
function QX() {
  if (M3)
    return Hl;
  M3 = 1;
  var e = k, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, l, c) {
    var u, d = {}, p = null, h = null;
    c !== void 0 && (p = "" + c), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !o.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: p, ref: h, props: d, _owner: a.current };
  }
  return Hl.Fragment = n, Hl.jsx = i, Hl.jsxs = i, Hl;
}
var qu = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var O3;
function eQ() {
  return O3 || (O3 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = k, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = Symbol.iterator, f = "@@iterator";
    function g(y) {
      if (y === null || typeof y != "object")
        return null;
      var P = m && y[m] || y[f];
      return typeof P == "function" ? P : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(y) {
      {
        for (var P = arguments.length, R = new Array(P > 1 ? P - 1 : 0), X = 1; X < P; X++)
          R[X - 1] = arguments[X];
        w("error", y, R);
      }
    }
    function w(y, P, R) {
      {
        var X = _.ReactDebugCurrentFrame, ce = X.getStackAddendum();
        ce !== "" && (P += "%s", R = R.concat([ce]));
        var ue = R.map(function(oe) {
          return String(oe);
        });
        ue.unshift("Warning: " + P), Function.prototype.apply.call(console[y], console, ue);
      }
    }
    var x = !1, b = !1, C = !1, E = !1, A = !1, O;
    O = Symbol.for("react.module.reference");
    function M(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === r || y === o || A || y === a || y === c || y === u || E || y === h || x || b || C || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === d || y.$$typeof === i || y.$$typeof === s || y.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === O || y.getModuleId !== void 0));
    }
    function I(y, P, R) {
      var X = y.displayName;
      if (X)
        return X;
      var ce = P.displayName || P.name || "";
      return ce !== "" ? R + "(" + ce + ")" : R;
    }
    function D(y) {
      return y.displayName || "Context";
    }
    function K(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case s:
            var P = y;
            return D(P) + ".Consumer";
          case i:
            var R = y;
            return D(R._context) + ".Provider";
          case l:
            return I(y, y.render, "ForwardRef");
          case d:
            var X = y.displayName || null;
            return X !== null ? X : K(y.type) || "Memo";
          case p: {
            var ce = y, ue = ce._payload, oe = ce._init;
            try {
              return K(oe(ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, V = 0, ee, U, H, W, L, T, B;
    function N() {
    }
    N.__reactDisabledLog = !0;
    function Y() {
      {
        if (V === 0) {
          ee = console.log, U = console.info, H = console.warn, W = console.error, L = console.group, T = console.groupCollapsed, B = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: N,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        V++;
      }
    }
    function Q() {
      {
        if (V--, V === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, y, {
              value: ee
            }),
            info: G({}, y, {
              value: U
            }),
            warn: G({}, y, {
              value: H
            }),
            error: G({}, y, {
              value: W
            }),
            group: G({}, y, {
              value: L
            }),
            groupCollapsed: G({}, y, {
              value: T
            }),
            groupEnd: G({}, y, {
              value: B
            })
          });
        }
        V < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var F = _.ReactCurrentDispatcher, re;
    function q(y, P, R) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch (ce) {
            var X = ce.stack.trim().match(/\n( *(at )?)/);
            re = X && X[1] || "";
          }
        return `
` + re + y;
      }
    }
    var he = !1, me;
    {
      var Le = typeof WeakMap == "function" ? WeakMap : Map;
      me = new Le();
    }
    function $(y, P) {
      if (!y || he)
        return "";
      {
        var R = me.get(y);
        if (R !== void 0)
          return R;
      }
      var X;
      he = !0;
      var ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ue;
      ue = F.current, F.current = null, Y();
      try {
        if (P) {
          var oe = function() {
            throw Error();
          };
          if (Object.defineProperty(oe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(oe, []);
            } catch (Be) {
              X = Be;
            }
            Reflect.construct(y, [], oe);
          } else {
            try {
              oe.call();
            } catch (Be) {
              X = Be;
            }
            y.call(oe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Be) {
            X = Be;
          }
          y();
        }
      } catch (Be) {
        if (Be && X && typeof Be.stack == "string") {
          for (var ne = Be.stack.split(`
`), Re = X.stack.split(`
`), Se = ne.length - 1, Ce = Re.length - 1; Se >= 1 && Ce >= 0 && ne[Se] !== Re[Ce]; )
            Ce--;
          for (; Se >= 1 && Ce >= 0; Se--, Ce--)
            if (ne[Se] !== Re[Ce]) {
              if (Se !== 1 || Ce !== 1)
                do
                  if (Se--, Ce--, Ce < 0 || ne[Se] !== Re[Ce]) {
                    var He = `
` + ne[Se].replace(" at new ", " at ");
                    return y.displayName && He.includes("<anonymous>") && (He = He.replace("<anonymous>", y.displayName)), typeof y == "function" && me.set(y, He), He;
                  }
                while (Se >= 1 && Ce >= 0);
              break;
            }
        }
      } finally {
        he = !1, F.current = ue, Q(), Error.prepareStackTrace = ce;
      }
      var Yt = y ? y.displayName || y.name : "", Nt = Yt ? q(Yt) : "";
      return typeof y == "function" && me.set(y, Nt), Nt;
    }
    function Te(y, P, R) {
      return $(y, !1);
    }
    function J(y) {
      var P = y.prototype;
      return !!(P && P.isReactComponent);
    }
    function te(y, P, R) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return $(y, J(y));
      if (typeof y == "string")
        return q(y);
      switch (y) {
        case c:
          return q("Suspense");
        case u:
          return q("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case l:
            return Te(y.render);
          case d:
            return te(y.type, P, R);
          case p: {
            var X = y, ce = X._payload, ue = X._init;
            try {
              return te(ue(ce), P, R);
            } catch {
            }
          }
        }
      return "";
    }
    var ve = Object.prototype.hasOwnProperty, Pe = {}, $e = _.ReactDebugCurrentFrame;
    function _t(y) {
      if (y) {
        var P = y._owner, R = te(y.type, y._source, P ? P.type : null);
        $e.setExtraStackFrame(R);
      } else
        $e.setExtraStackFrame(null);
    }
    function st(y, P, R, X, ce) {
      {
        var ue = Function.call.bind(ve);
        for (var oe in y)
          if (ue(y, oe)) {
            var ne = void 0;
            try {
              if (typeof y[oe] != "function") {
                var Re = Error((X || "React class") + ": " + R + " type `" + oe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[oe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Re.name = "Invariant Violation", Re;
              }
              ne = y[oe](P, oe, X, R, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Se) {
              ne = Se;
            }
            ne && !(ne instanceof Error) && (_t(ce), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", R, oe, typeof ne), _t(null)), ne instanceof Error && !(ne.message in Pe) && (Pe[ne.message] = !0, _t(ce), v("Failed %s type: %s", R, ne.message), _t(null));
          }
      }
    }
    var Mr = Array.isArray;
    function Vt(y) {
      return Mr(y);
    }
    function Xt(y) {
      {
        var P = typeof Symbol == "function" && Symbol.toStringTag, R = P && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return R;
      }
    }
    function je(y) {
      try {
        return lt(y), !1;
      } catch {
        return !0;
      }
    }
    function lt(y) {
      return "" + y;
    }
    function fr(y) {
      if (je(y))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Xt(y)), lt(y);
    }
    var Ot = _.ReactCurrentOwner, gr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, ge, Oe;
    Oe = {};
    function ct(y) {
      if (ve.call(y, "ref")) {
        var P = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function yr(y) {
      if (ve.call(y, "key")) {
        var P = Object.getOwnPropertyDescriptor(y, "key").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function Vr(y, P) {
      if (typeof y.ref == "string" && Ot.current && P && Ot.current.stateNode !== P) {
        var R = K(Ot.current.type);
        Oe[R] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', K(Ot.current.type), y.ref), Oe[R] = !0);
      }
    }
    function Xn(y, P) {
      {
        var R = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        R.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: R,
          configurable: !0
        });
      }
    }
    function ti(y, P) {
      {
        var R = function() {
          ge || (ge = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        R.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: R,
          configurable: !0
        });
      }
    }
    var ri = function(y, P, R, X, ce, ue, oe) {
      var ne = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: y,
        key: P,
        ref: R,
        props: oe,
        // Record the component responsible for creating this element.
        _owner: ue
      };
      return ne._store = {}, Object.defineProperty(ne._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ne, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: X
      }), Object.defineProperty(ne, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.freeze && (Object.freeze(ne.props), Object.freeze(ne)), ne;
    };
    function ni(y, P, R, X, ce) {
      {
        var ue, oe = {}, ne = null, Re = null;
        R !== void 0 && (fr(R), ne = "" + R), yr(P) && (fr(P.key), ne = "" + P.key), ct(P) && (Re = P.ref, Vr(P, ce));
        for (ue in P)
          ve.call(P, ue) && !gr.hasOwnProperty(ue) && (oe[ue] = P[ue]);
        if (y && y.defaultProps) {
          var Se = y.defaultProps;
          for (ue in Se)
            oe[ue] === void 0 && (oe[ue] = Se[ue]);
        }
        if (ne || Re) {
          var Ce = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          ne && Xn(oe, Ce), Re && ti(oe, Ce);
        }
        return ri(y, ne, Re, ce, X, Ot.current, oe);
      }
    }
    var Qr = _.ReactCurrentOwner, Qn = _.ReactDebugCurrentFrame;
    function Wt(y) {
      if (y) {
        var P = y._owner, R = te(y.type, y._source, P ? P.type : null);
        Qn.setExtraStackFrame(R);
      } else
        Qn.setExtraStackFrame(null);
    }
    var en;
    en = !1;
    function tn(y) {
      return typeof y == "object" && y !== null && y.$$typeof === t;
    }
    function ea() {
      {
        if (Qr.current) {
          var y = K(Qr.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function ai(y) {
      return "";
    }
    var ta = {};
    function oi(y) {
      {
        var P = ea();
        if (!P) {
          var R = typeof y == "string" ? y : y.displayName || y.name;
          R && (P = `

Check the top-level render call using <` + R + ">.");
        }
        return P;
      }
    }
    function ra(y, P) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var R = oi(P);
        if (ta[R])
          return;
        ta[R] = !0;
        var X = "";
        y && y._owner && y._owner !== Qr.current && (X = " It was passed a child from " + K(y._owner.type) + "."), Wt(y), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', R, X), Wt(null);
      }
    }
    function na(y, P) {
      {
        if (typeof y != "object")
          return;
        if (Vt(y))
          for (var R = 0; R < y.length; R++) {
            var X = y[R];
            tn(X) && ra(X, P);
          }
        else if (tn(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var ce = g(y);
          if (typeof ce == "function" && ce !== y.entries)
            for (var ue = ce.call(y), oe; !(oe = ue.next()).done; )
              tn(oe.value) && ra(oe.value, P);
        }
      }
    }
    function ii(y) {
      {
        var P = y.type;
        if (P == null || typeof P == "string")
          return;
        var R;
        if (typeof P == "function")
          R = P.propTypes;
        else if (typeof P == "object" && (P.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        P.$$typeof === d))
          R = P.propTypes;
        else
          return;
        if (R) {
          var X = K(P);
          st(R, y.props, "prop", X, y);
        } else if (P.PropTypes !== void 0 && !en) {
          en = !0;
          var ce = K(P);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ce || "Unknown");
        }
        typeof P.getDefaultProps == "function" && !P.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function si(y) {
      {
        for (var P = Object.keys(y.props), R = 0; R < P.length; R++) {
          var X = P[R];
          if (X !== "children" && X !== "key") {
            Wt(y), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", X), Wt(null);
            break;
          }
        }
        y.ref !== null && (Wt(y), v("Invalid attribute `ref` supplied to `React.Fragment`."), Wt(null));
      }
    }
    var aa = {};
    function oa(y, P, R, X, ce, ue) {
      {
        var oe = M(y);
        if (!oe) {
          var ne = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (ne += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Re = ai();
          Re ? ne += Re : ne += ea();
          var Se;
          y === null ? Se = "null" : Vt(y) ? Se = "array" : y !== void 0 && y.$$typeof === t ? (Se = "<" + (K(y.type) || "Unknown") + " />", ne = " Did you accidentally export a JSX literal instead of a component?") : Se = typeof y, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Se, ne);
        }
        var Ce = ni(y, P, R, ce, ue);
        if (Ce == null)
          return Ce;
        if (oe) {
          var He = P.children;
          if (He !== void 0)
            if (X)
              if (Vt(He)) {
                for (var Yt = 0; Yt < He.length; Yt++)
                  na(He[Yt], y);
                Object.freeze && Object.freeze(He);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              na(He, y);
        }
        if (ve.call(P, "key")) {
          var Nt = K(y), Be = Object.keys(P).filter(function(hi) {
            return hi !== "key";
          }), rn = Be.length > 0 ? "{key: someKey, " + Be.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!aa[Nt + rn]) {
            var pi = Be.length > 0 ? "{" + Be.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, rn, Nt, pi, Nt), aa[Nt + rn] = !0;
          }
        }
        return y === r ? si(Ce) : ii(Ce), Ce;
      }
    }
    function li(y, P, R) {
      return oa(y, P, R, !0);
    }
    function ci(y, P, R) {
      return oa(y, P, R, !1);
    }
    var ui = ci, di = li;
    qu.Fragment = r, qu.jsx = ui, qu.jsxs = di;
  }()), qu;
}
process.env.NODE_ENV === "production" ? Wf.exports = QX() : Wf.exports = eQ();
var Ke = Wf.exports, Et = /* @__PURE__ */ ((e) => (e.Editor = "editor", e.Community = "community", e.BlockPreview = "block_preview", e.Membership = "membership", e.Marketplace = "marketplace", e.Settings = "settings", e.Email = "email", e.Ckeditor = "ckeditor", e.TextEditor = "text_editor", e.BlogPost = "blog_post", e.PageTemplate = "page_template", e.PageTemplatePreview = "page_template_preview", e.BlogTemplatePreview = "blog_template_preview", e.EmailTemplate = "email_template", e.WebsiteTemplate = "website_template", e.Product = "product", e.FunnelTemplatePreview = "funnel_template_preview", e.DigitalStore = "digital_store", e.DigitalProductResource = "digital_product_resource", e.CalendarHostAvatar = "calendar_host_avatar", e.FileManager = "file_manager", e.WhiteLabel = "white_label", e))(Et || {}), Ut = /* @__PURE__ */ ((e) => (e.Image = "image", e.ImageOther = "image_other", e.Video = "video", e.Audio = "audio", e.Font = "font", e.Document = "document", e))(Ut || {});
Et.Editor + "", Et.Community + "", Et.BlockPreview + "", Et.Membership + "", Et.Marketplace + "", Et.Settings + "", Et.Email + "", Et.Ckeditor + "", Et.BlogPost + "", Et.PageTemplate + "", Et.PageTemplatePreview + "", Et.BlogTemplatePreview + "", Et.EmailTemplate + "", Et.Product + "", Et.FunnelTemplatePreview + "", Et.DigitalStore + "", Et.DigitalProductResource + "", Et.CalendarHostAvatar + "", Et.FileManager + "", Et.TextEditor + "", Et.WhiteLabel + "", Et.WebsiteTemplate + "";
Ut.Image + "", Ut.ImageOther + "", Ut.Video + "", Ut.Audio + "", Ut.Font + "", Ut.Document + "";
function tQ(e) {
  return /* @__PURE__ */ Ke.jsx(
    "svg",
    {
      id: "Layer_1",
      enableBackground: "new 0 0 28 28",
      height: "512",
      viewBox: "0 0 28 28",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ Ke.jsx("g", { id: "_x35_3", children: /* @__PURE__ */ Ke.jsx("path", { d: "m4.6 8.7c-.2.5-.3 1-.3 1.5v12.2c0 2 1.6 3.6 3.6 3.6h12.2c2 0 3.6-1.6 3.6-3.6v-16.8c0-2-1.6-3.6-3.6-3.6h-7.6c-.5 0-1 .1-1.5.3-.4.2-.7.4-1 .7l-4.6 4.6c-.3.3-.6.7-.8 1.1zm8.1 5.7c.3 0 .7.1 1 .2v-6c0-.4.2-.8.6-.9.4-.2.8-.1 1.1.2l2.7 2.7c.4.4.4 1 0 1.4s-1 .4-1.4 0l-1-1v6.3c0 1.7-1.4 3-3 3-1.7 0-3-1.3-3-3 0-1.6 1.3-2.9 3-2.9z" }) })
    }
  );
}
function A3(e) {
  return /* @__PURE__ */ Ke.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      id: "Capa_1",
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      ...e,
      children: [
        /* @__PURE__ */ Ke.jsx("path", { d: "m106 512h300c24.814 0 45-20.186 45-45v-317h-105c-24.814 0-45-20.186-45-45v-105h-195c-24.814 0-45 20.186-45 45v422c0 24.814 20.186 45 45 45zm60-301h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h120c8.291 0 15 6.709 15 15s-6.709 15-15 15h-120c-8.291 0-15-6.709-15-15s6.709-15 15-15z" }),
        /* @__PURE__ */ Ke.jsx("path", { d: "m346 120h96.211l-111.211-111.211v96.211c0 8.276 6.724 15 15 15z" })
      ]
    }
  );
}
function rQ(e) {
  return /* @__PURE__ */ Ke.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "512pt",
      viewBox: "0 -64 512 512",
      width: "512pt",
      ...e,
      children: [
        /* @__PURE__ */ Ke.jsx("path", { d: "m149.332031 106.667969c0 23.5625-19.101562 42.664062-42.664062 42.664062-23.566407 0-42.667969-19.101562-42.667969-42.664062 0-23.566407 19.101562-42.667969 42.667969-42.667969 23.5625 0 42.664062 19.101562 42.664062 42.667969zm0 0" }),
        /* @__PURE__ */ Ke.jsx("path", { d: "m448 0h-384c-35.285156 0-64 28.714844-64 64v256c0 1.195312.296875 2.324219.363281 3.519531-.300781 2.558594-.171875 5.140625.765625 7.574219 5.269532 29.996094 31.382813 52.90625 62.871094 52.90625h384c35.285156 0 64-28.714844 64-64v-256c0-35.285156-28.714844-64-64-64zm-384 42.667969h384c11.753906 0 21.332031 9.578125 21.332031 21.332031v169.367188l-112.210937-112.214844c-14.59375-14.59375-38.335938-14.59375-52.90625 0l-101.546875 101.546875-26.882813-26.878907c-14.589844-14.59375-38.335937-14.59375-52.90625 0l-80.210937 80.210938v-212.03125c0-11.753906 9.578125-21.332031 21.332031-21.332031zm0 0" })
      ]
    }
  );
}
function nQ(e) {
  return /* @__PURE__ */ Ke.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Capa_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 467.968 467.968",
      ...e,
      children: [
        /* @__PURE__ */ Ke.jsx("g", { children: /* @__PURE__ */ Ke.jsx("g", { children: /* @__PURE__ */ Ke.jsx("path", { d: "M264.704,96.512H51.2c-28.16,0-51.2,23.04-51.2,51.2v172.544c0,28.16,23.04,51.2,51.2,51.2h213.504    c28.16,0,51.2-23.04,51.2-51.2V147.712C315.904,119.04,292.864,96.512,264.704,96.512z" }) }) }),
        /* @__PURE__ */ Ke.jsx("g", { children: /* @__PURE__ */ Ke.jsx("g", { children: /* @__PURE__ */ Ke.jsx("path", { d: "M430.08,124.672c-3.072,0.512-6.144,2.048-8.704,3.584l-79.872,46.08V293.12l80.384,46.08    c14.848,8.704,33.28,3.584,41.984-11.264c2.56-4.608,4.096-9.728,4.096-15.36V154.368    C467.968,135.424,450.048,120.064,430.08,124.672z" }) }) }),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {}),
        /* @__PURE__ */ Ke.jsx("g", {})
      ]
    }
  );
}
function aQ(e) {
  switch (e) {
    case Ut.Audio:
      return /* @__PURE__ */ Ke.jsx(tQ, { className: "fill-text-secondary", width: 40, height: 40 });
    case Ut.Image:
    case Ut.ImageOther:
      return /* @__PURE__ */ Ke.jsx(rQ, { className: "fill-text-secondary", width: 40, height: 40 });
    case Ut.Video:
      return /* @__PURE__ */ Ke.jsx(nQ, { className: "fill-text-secondary", width: 40, height: 40 });
    case Ut.Font:
    case Ut.Document:
      return /* @__PURE__ */ Ke.jsx(A3, { className: "fill-text-secondary", width: 40, height: 40 });
    default:
      return /* @__PURE__ */ Ke.jsx(A3, { className: "fill-text-secondary", width: 40, height: 40 });
  }
}
const dy = "-", oQ = (e) => {
  const t = sQ(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      const o = a.split(dy);
      return o[0] === "" && o.length !== 1 && o.shift(), Ww(o, t) || iQ(a);
    },
    getConflictingClassGroupIds: (a, o) => {
      const i = n[a] || [];
      return o && r[a] ? [...i, ...r[a]] : i;
    }
  };
}, Ww = (e, t) => {
  var n;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], a = t.nextPart.get(r), o = a ? Ww(e.slice(1), a) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(dy);
  return (n = t.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : n.classGroupId;
}, N3 = /^\[(.+)\]$/, iQ = (e) => {
  if (N3.test(e)) {
    const t = N3.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, sQ = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return cQ(Object.entries(e.classGroups), n).forEach(([a, o]) => {
    Yf(o, r, a, t);
  }), r;
}, Yf = (e, t, n, r) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const o = a === "" ? t : L3(t, a);
      o.classGroupId = n;
      return;
    }
    if (typeof a == "function") {
      if (lQ(a)) {
        Yf(a(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: n
      });
      return;
    }
    Object.entries(a).forEach(([o, i]) => {
      Yf(i, L3(t, o), n, r);
    });
  });
}, L3 = (e, t) => {
  let n = e;
  return t.split(dy).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, lQ = (e) => e.isThemeGetter, cQ = (e, t) => t ? e.map(([n, r]) => {
  const a = r.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([i, s]) => [t + i, s])) : o);
  return [n, a];
}) : e, uQ = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const a = (o, i) => {
    n.set(o, i), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let i = n.get(o);
      if (i !== void 0)
        return i;
      if ((i = r.get(o)) !== void 0)
        return a(o, i), i;
    },
    set(o, i) {
      n.has(o) ? n.set(o, i) : a(o, i);
    }
  };
}, Yw = "!", dQ = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, a = t[0], o = t.length, i = (s) => {
    const l = [];
    let c = 0, u = 0, d;
    for (let g = 0; g < s.length; g++) {
      let _ = s[g];
      if (c === 0) {
        if (_ === a && (r || s.slice(g, g + o) === t)) {
          l.push(s.slice(u, g)), u = g + o;
          continue;
        }
        if (_ === "/") {
          d = g;
          continue;
        }
      }
      _ === "[" ? c++ : _ === "]" && c--;
    }
    const p = l.length === 0 ? s : s.substring(u), h = p.startsWith(Yw), m = h ? p.substring(1) : p, f = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: f
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: i
  }) : i;
}, pQ = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, hQ = (e) => ({
  cache: uQ(e.cacheSize),
  parseClassName: dQ(e),
  ...oQ(e)
}), mQ = /\s+/, fQ = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: a
  } = t, o = [], i = e.trim().split(mQ);
  let s = "";
  for (let l = i.length - 1; l >= 0; l -= 1) {
    const c = i[l], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: p,
      maybePostfixModifierPosition: h
    } = n(c);
    let m = !!h, f = r(m ? p.substring(0, h) : p);
    if (!f) {
      if (!m) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (f = r(p), !f) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      m = !1;
    }
    const g = pQ(u).join(":"), _ = d ? g + Yw : g, v = _ + f;
    if (o.includes(v))
      continue;
    o.push(v);
    const w = a(f, m);
    for (let x = 0; x < w.length; ++x) {
      const b = w[x];
      o.push(_ + b);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function gQ() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Zw(t)) && (r && (r += " "), r += n);
  return r;
}
const Zw = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Zw(e[r])) && (n && (n += " "), n += t);
  return n;
};
function yQ(e, ...t) {
  let n, r, a, o = i;
  function i(l) {
    const c = t.reduce((u, d) => d(u), e());
    return n = hQ(c), r = n.cache.get, a = n.cache.set, o = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const u = fQ(l, n);
    return a(l, u), u;
  }
  return function() {
    return o(gQ.apply(null, arguments));
  };
}
const tr = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, qw = /^\[(?:([a-z-]+):)?(.+)\]$/i, vQ = /^\d+\/\d+$/, bQ = /* @__PURE__ */ new Set(["px", "full", "screen"]), _Q = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, wQ = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, SQ = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, CQ = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, xQ = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, oo = (e) => Ls(e) || bQ.has(e) || vQ.test(e), To = (e) => bl(e, "length", NQ), Ls = (e) => !!e && !Number.isNaN(Number(e)), Xm = (e) => bl(e, "number", Ls), Kl = (e) => !!e && Number.isInteger(Number(e)), kQ = (e) => e.endsWith("%") && Ls(e.slice(0, -1)), it = (e) => qw.test(e), Mo = (e) => _Q.test(e), EQ = /* @__PURE__ */ new Set(["length", "size", "percentage"]), PQ = (e) => bl(e, EQ, Jw), TQ = (e) => bl(e, "position", Jw), MQ = /* @__PURE__ */ new Set(["image", "url"]), OQ = (e) => bl(e, MQ, RQ), AQ = (e) => bl(e, "", LQ), Ul = () => !0, bl = (e, t, n) => {
  const r = qw.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, NQ = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  wQ.test(e) && !SQ.test(e)
), Jw = () => !1, LQ = (e) => CQ.test(e), RQ = (e) => xQ.test(e), DQ = () => {
  const e = tr("colors"), t = tr("spacing"), n = tr("blur"), r = tr("brightness"), a = tr("borderColor"), o = tr("borderRadius"), i = tr("borderSpacing"), s = tr("borderWidth"), l = tr("contrast"), c = tr("grayscale"), u = tr("hueRotate"), d = tr("invert"), p = tr("gap"), h = tr("gradientColorStops"), m = tr("gradientColorStopPositions"), f = tr("inset"), g = tr("margin"), _ = tr("opacity"), v = tr("padding"), w = tr("saturate"), x = tr("scale"), b = tr("sepia"), C = tr("skew"), E = tr("space"), A = tr("translate"), O = () => ["auto", "contain", "none"], M = () => ["auto", "hidden", "clip", "visible", "scroll"], I = () => ["auto", it, t], D = () => [it, t], K = () => ["", oo, To], G = () => ["auto", Ls, it], V = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], ee = () => ["solid", "dashed", "dotted", "double", "none"], U = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], H = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], W = () => ["", "0", it], L = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], T = () => [Ls, it];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Ul],
      spacing: [oo, To],
      blur: ["none", "", Mo, it],
      brightness: T(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Mo, it],
      borderSpacing: D(),
      borderWidth: K(),
      contrast: T(),
      grayscale: W(),
      hueRotate: T(),
      invert: W(),
      gap: D(),
      gradientColorStops: [e],
      gradientColorStopPositions: [kQ, To],
      inset: I(),
      margin: I(),
      opacity: T(),
      padding: D(),
      saturate: T(),
      scale: T(),
      sepia: W(),
      skew: T(),
      space: D(),
      translate: D()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", it]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Mo]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": L()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": L()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...V(), it]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: M()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": M()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": M()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: O()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": O()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": O()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [f]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [f]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [f]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [f]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [f]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [f]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [f]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [f]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [f]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Kl, it]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: I()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", it]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: W()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: W()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Kl, it]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Ul]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Kl, it]
        }, it]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": G()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": G()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Ul]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Kl, it]
        }, it]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": G()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": G()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", it]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", it]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...H()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...H(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...H(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [g]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [g]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [g]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [g]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [g]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [g]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [g]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [g]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [g]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [E]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [E]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", it, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [it, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [it, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Mo]
        }, Mo]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [it, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [it, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [it, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [it, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Mo, To]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Xm]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Ul]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", it]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Ls, Xm]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", oo, it]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", it]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", it]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [_]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [_]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...ee(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", oo, To]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", oo, it]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: D()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", it]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", it]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [_]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...V(), TQ]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", PQ]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, OQ]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [_]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...ee(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [_]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: ee()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...ee()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [oo, it]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [oo, To]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: K()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [_]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [oo, To]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Mo, AQ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Ul]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [_]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...U(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": U()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Mo, it]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [b]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [_]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [b]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", it]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: T()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", it]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: T()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", it]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Kl, it]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [A]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [A]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [C]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [C]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", it]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", it]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": D()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": D()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": D()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": D()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": D()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": D()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": D()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": D()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": D()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": D()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": D()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": D()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": D()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": D()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": D()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": D()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": D()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": D()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", it]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [oo, To, Xm]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, dc = /* @__PURE__ */ yQ(DQ), $l = /* @__PURE__ */ new Set(), Vl = /* @__PURE__ */ new Set(), Ed = k.memo(
  ({
    src: e,
    fileType: t,
    alt: n,
    className: r,
    isThumbnail: a = !1,
    width: o,
    height: i,
    title: s
  }) => {
    const [l, c] = k.useState(Vl.has(e)), [u, d] = k.useState($l.has(e));
    return /* @__PURE__ */ Ke.jsxs(
      "div",
      {
        className: dc("flex items-center justify-center", r),
        style: {
          width: o,
          height: i,
          minHeight: i
        },
        title: s,
        children: [
          t !== Ut.Video && /* @__PURE__ */ Ke.jsx(
            "img",
            {
              src: e,
              alt: n,
              className: dc(
                "flex-2 w-full rounded-md object-cover",
                a && "h-full object-cover",
                !l && u ? "block" : "hidden"
              ),
              onLoad: () => {
                d(!0), $l.add(e), Vl.delete(e);
              },
              onError: () => {
                c(!0), $l.delete(e), Vl.add(e);
              }
            }
          ),
          t === Ut.Video && /* @__PURE__ */ Ke.jsx(
            "video",
            {
              src: e,
              className: dc(
                "flex-2 w-full rounded-md object-cover",
                a && "h-full object-cover",
                !l && u ? "block" : "hidden"
              ),
              onLoadedData: () => {
                d(!0), $l.add(e), Vl.delete(e);
              },
              onError: () => {
                c(!0), $l.delete(e), Vl.add(e);
              },
              controls: !a
            }
          ),
          /* @__PURE__ */ Ke.jsx(
            "div",
            {
              className: dc(
                "flex-2 flex items-center justify-center rounded-md",
                !a && "min-h-[300px]",
                !e || l ? "flex" : "hidden"
              ),
              children: aQ(t)
            }
          )
        ]
      }
    );
  }
);
Ed.displayName = "FilePreview";
const qe = (e) => typeof e == "string", Wl = () => {
  let e, t;
  const n = new Promise((r, a) => {
    e = r, t = a;
  });
  return n.resolve = e, n.reject = t, n;
}, R3 = (e) => e == null ? "" : "" + e, IQ = (e, t, n) => {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}, jQ = /###/g, D3 = (e) => e && e.indexOf("###") > -1 ? e.replace(jQ, ".") : e, I3 = (e) => !e || qe(e), _c = (e, t, n) => {
  const r = qe(t) ? t.split(".") : t;
  let a = 0;
  for (; a < r.length - 1; ) {
    if (I3(e))
      return {};
    const o = D3(r[a]);
    !e[o] && n && (e[o] = new n()), Object.prototype.hasOwnProperty.call(e, o) ? e = e[o] : e = {}, ++a;
  }
  return I3(e) ? {} : {
    obj: e,
    k: D3(r[a])
  };
}, j3 = (e, t, n) => {
  const {
    obj: r,
    k: a
  } = _c(e, t, Object);
  if (r !== void 0 || t.length === 1) {
    r[a] = n;
    return;
  }
  let o = t[t.length - 1], i = t.slice(0, t.length - 1), s = _c(e, i, Object);
  for (; s.obj === void 0 && i.length; )
    o = `${i[i.length - 1]}.${o}`, i = i.slice(0, i.length - 1), s = _c(e, i, Object), s && s.obj && typeof s.obj[`${s.k}.${o}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${o}`] = n;
}, BQ = (e, t, n, r) => {
  const {
    obj: a,
    k: o
  } = _c(e, t, Object);
  a[o] = a[o] || [], a[o].push(n);
}, yp = (e, t) => {
  const {
    obj: n,
    k: r
  } = _c(e, t);
  if (n)
    return n[r];
}, FQ = (e, t, n) => {
  const r = yp(e, n);
  return r !== void 0 ? r : yp(t, n);
}, Xw = (e, t, n) => {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? qe(e[r]) || e[r] instanceof String || qe(t[r]) || t[r] instanceof String ? n && (e[r] = t[r]) : Xw(e[r], t[r], n) : e[r] = t[r]);
  return e;
}, hs = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var zQ = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const GQ = (e) => qe(e) ? e.replace(/[&<>"'\/]/g, (t) => zQ[t]) : e;
class HQ {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const r = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, r), this.regExpQueue.push(t), r;
  }
}
const KQ = [" ", ",", "?", "!", ";"], UQ = new HQ(20), $Q = (e, t, n) => {
  t = t || "", n = n || "";
  const r = KQ.filter((i) => t.indexOf(i) < 0 && n.indexOf(i) < 0);
  if (r.length === 0)
    return !0;
  const a = UQ.getRegExp(`(${r.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let o = !a.test(e);
  if (!o) {
    const i = e.indexOf(n);
    i > 0 && !a.test(e.substring(0, i)) && (o = !0);
  }
  return o;
}, Zf = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[t])
    return e[t];
  const r = t.split(n);
  let a = e;
  for (let o = 0; o < r.length; ) {
    if (!a || typeof a != "object")
      return;
    let i, s = "";
    for (let l = o; l < r.length; ++l)
      if (l !== o && (s += n), s += r[l], i = a[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < r.length - 1)
          continue;
        o += l - o + 1;
        break;
      }
    a = i;
  }
  return a;
}, vp = (e) => e && e.replace("_", "-"), VQ = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class bp {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || VQ, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, a) {
    return a && !this.debug ? null : (qe(t[0]) && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new bp(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new bp(this.logger, t);
  }
}
var za = new bp();
class Lh {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const a = this.observers[r].get(n) || 0;
      this.observers[r].set(n, a + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((o) => {
      let [i, s] = o;
      for (let l = 0; l < s; l++)
        i(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o) => {
      let [i, s] = o;
      for (let l = 0; l < s; l++)
        i.apply(i, [t, ...r]);
    });
  }
}
class B3 extends Lh {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, i = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, n], r && (Array.isArray(r) ? s.push(...r) : qe(r) && o ? s.push(...r.split(o)) : s.push(r)));
    const l = yp(this.data, s);
    return !l && !n && !r && t.indexOf(".") > -1 && (t = s[0], n = s[1], r = s.slice(2).join(".")), l || !i || !qe(r) ? l : Zf(this.data && this.data[t] && this.data[t][n], r, o);
  }
  addResource(t, n, r, a) {
    let o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const i = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator;
    let s = [t, n];
    r && (s = s.concat(i ? r.split(i) : r)), t.indexOf(".") > -1 && (s = t.split("."), a = n, n = s[1]), this.addNamespaces(n), j3(this.data, s, a), o.silent || this.emit("added", t, n, r, a);
  }
  addResources(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const o in r)
      (qe(r[o]) || Array.isArray(r[o])) && this.addResource(t, n, o, r[o], {
        silent: !0
      });
    a.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, a, o) {
    let i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, s = [t, n];
    t.indexOf(".") > -1 && (s = t.split("."), a = r, r = n, n = s[1]), this.addNamespaces(n);
    let l = yp(this.data, s) || {};
    i.skipCopy || (r = JSON.parse(JSON.stringify(r))), a ? Xw(l, r, o) : l = {
      ...l,
      ...r
    }, j3(this.data, s, l), i.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, n)
    } : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((r) => n[r] && Object.keys(n[r]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Qw = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, a) {
    return e.forEach((o) => {
      this.processors[o] && (t = this.processors[o].process(t, n, r, a));
    }), t;
  }
};
const F3 = {};
class _p extends Lh {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), IQ(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = za.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let o = n.ns || this.options.defaultNS || [];
    const i = r && t.indexOf(r) > -1, s = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !$Q(t, r, a);
    if (i && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: qe(o) ? [o] : o
        };
      const c = t.split(r);
      (r !== a || r === a && this.options.ns.indexOf(c[0]) > -1) && (o = c.shift()), t = c.join(a);
    }
    return {
      key: t,
      namespaces: qe(o) ? [o] : o
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null)
      return "";
    Array.isArray(t) || (t = [String(t)]);
    const a = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, o = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: i,
      namespaces: s
    } = this.extractFromKey(t[t.length - 1], n), l = s[s.length - 1], c = n.lng || this.language, u = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const x = n.nsSeparator || this.options.nsSeparator;
        return a ? {
          res: `${l}${x}${i}`,
          usedKey: i,
          exactUsedKey: i,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(n)
        } : `${l}${x}${i}`;
      }
      return a ? {
        res: i,
        usedKey: i,
        exactUsedKey: i,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(n)
      } : i;
    }
    const d = this.resolve(t, n);
    let p = d && d.res;
    const h = d && d.usedKey || i, m = d && d.exactUsedKey || i, f = Object.prototype.toString.apply(p), g = ["[object Number]", "[object Function]", "[object RegExp]"], _ = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, v = !this.i18nFormat || this.i18nFormat.handleAsObject, w = !qe(p) && typeof p != "boolean" && typeof p != "number";
    if (v && p && w && g.indexOf(f) < 0 && !(qe(_) && Array.isArray(p))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const x = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, p, {
          ...n,
          ns: s
        }) : `key '${i} (${this.language})' returned an object instead of string.`;
        return a ? (d.res = x, d.usedParams = this.getUsedParamsDetails(n), d) : x;
      }
      if (o) {
        const x = Array.isArray(p), b = x ? [] : {}, C = x ? m : h;
        for (const E in p)
          if (Object.prototype.hasOwnProperty.call(p, E)) {
            const A = `${C}${o}${E}`;
            b[E] = this.translate(A, {
              ...n,
              joinArrays: !1,
              ns: s
            }), b[E] === A && (b[E] = p[E]);
          }
        p = b;
      }
    } else if (v && qe(_) && Array.isArray(p))
      p = p.join(_), p && (p = this.extendTranslation(p, t, n, r));
    else {
      let x = !1, b = !1;
      const C = n.count !== void 0 && !qe(n.count), E = _p.hasDefaultValue(n), A = C ? this.pluralResolver.getSuffix(c, n.count, n) : "", O = n.ordinal && C ? this.pluralResolver.getSuffix(c, n.count, {
        ordinal: !1
      }) : "", M = C && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), I = M && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${A}`] || n[`defaultValue${O}`] || n.defaultValue;
      !this.isValidLookup(p) && E && (x = !0, p = I), this.isValidLookup(p) || (b = !0, p = i);
      const D = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && b ? void 0 : p, K = E && I !== p && this.options.updateMissing;
      if (b || x || K) {
        if (this.logger.log(K ? "updateKey" : "missingKey", c, l, i, K ? I : p), o) {
          const U = this.resolve(i, {
            ...n,
            keySeparator: !1
          });
          U && U.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let G = [];
        const V = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && V && V[0])
          for (let U = 0; U < V.length; U++)
            G.push(V[U]);
        else
          this.options.saveMissingTo === "all" ? G = this.languageUtils.toResolveHierarchy(n.lng || this.language) : G.push(n.lng || this.language);
        const ee = (U, H, W) => {
          const L = E && W !== p ? W : D;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(U, l, H, L, K, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(U, l, H, L, K, n), this.emit("missingKey", U, l, H, p);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && C ? G.forEach((U) => {
          const H = this.pluralResolver.getSuffixes(U, n);
          M && n[`defaultValue${this.options.pluralSeparator}zero`] && H.indexOf(`${this.options.pluralSeparator}zero`) < 0 && H.push(`${this.options.pluralSeparator}zero`), H.forEach((W) => {
            ee([U], i + W, n[`defaultValue${W}`] || I);
          });
        }) : ee(G, i, I));
      }
      p = this.extendTranslation(p, t, n, d, r), b && p === i && this.options.appendNamespaceToMissingKey && (p = `${l}:${i}`), (b || x) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? p = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${i}` : i, x ? p : void 0) : p = this.options.parseMissingKeyHandler(p));
    }
    return a ? (d.res = p, d.usedParams = this.getUsedParamsDetails(n), d) : p;
  }
  extendTranslation(t, n, r, a, o) {
    var i = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const c = qe(t) && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const p = t.match(this.interpolator.nestingRegexp);
        u = p && p.length;
      }
      let d = r.replace && !qe(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), t = this.interpolator.interpolate(t, d, r.lng || this.language || a.usedLng, r), c) {
        const p = t.match(this.interpolator.nestingRegexp), h = p && p.length;
        u < h && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && a && a.res && (r.lng = this.language || a.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var p = arguments.length, h = new Array(p), m = 0; m < p; m++)
          h[m] = arguments[m];
        return o && o[0] === h[0] && !r.context ? (i.logger.warn(`It seems you are nesting recursively key: ${h[0]} in key: ${n[0]}`), null) : i.translate(...h, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const s = r.postProcess || this.options.postProcess, l = qe(s) ? [s] : s;
    return t != null && l && l.length && r.applyPostProcessor !== !1 && (t = Qw.handle(l, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, a, o, i, s;
    return qe(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(r))
        return;
      const c = this.extractFromKey(l, n), u = c.key;
      a = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const p = n.count !== void 0 && !qe(n.count), h = p && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), m = n.context !== void 0 && (qe(n.context) || typeof n.context == "number") && n.context !== "", f = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((g) => {
        this.isValidLookup(r) || (s = g, !F3[`${f[0]}-${g}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(s) && (F3[`${f[0]}-${g}`] = !0, this.logger.warn(`key "${a}" for languages "${f.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), f.forEach((_) => {
          if (this.isValidLookup(r))
            return;
          i = _;
          const v = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, u, _, g, n);
          else {
            let x;
            p && (x = this.pluralResolver.getSuffix(_, n.count, n));
            const b = `${this.options.pluralSeparator}zero`, C = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (p && (v.push(u + x), n.ordinal && x.indexOf(C) === 0 && v.push(u + x.replace(C, this.options.pluralSeparator)), h && v.push(u + b)), m) {
              const E = `${u}${this.options.contextSeparator}${n.context}`;
              v.push(E), p && (v.push(E + x), n.ordinal && x.indexOf(C) === 0 && v.push(E + x.replace(C, this.options.pluralSeparator)), h && v.push(E + b));
            }
          }
          let w;
          for (; w = v.pop(); )
            this.isValidLookup(r) || (o = w, r = this.getResource(_, g, w, n));
        }));
      });
    }), {
      res: r,
      usedKey: a,
      exactUsedKey: o,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, a) : this.resourceStore.getResource(t, n, r, a);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = t.replace && !qe(t.replace);
    let a = r ? t.replace : t;
    if (r && typeof t.count < "u" && (a.count = t.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !r) {
      a = {
        ...a
      };
      for (const o of n)
        delete a[o];
    }
    return a;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
const Qm = (e) => e.charAt(0).toUpperCase() + e.slice(1);
class z3 {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = za.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = vp(t), !t || t.indexOf("-") < 0)
      return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = vp(t), !t || t.indexOf("-") < 0)
      return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (qe(t) && t.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let a = Intl.getCanonicalLocales(t)[0];
          if (a && this.options.lowerCaseLng && (a = a.toLowerCase()), a)
            return a;
        } catch {
        }
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((a) => a.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Qm(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Qm(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = Qm(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t)
      return null;
    let n;
    return t.forEach((r) => {
      if (n)
        return;
      const a = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (n = a);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n)
        return;
      const a = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(a))
        return n = a;
      n = this.options.supportedLngs.find((o) => {
        if (o === a || !(o.indexOf("-") < 0 && a.indexOf("-") < 0) && (o.indexOf("-") > 0 && a.indexOf("-") < 0 && o.substring(0, o.indexOf("-")) === a || o.indexOf(a) === 0 && a.length > 1))
          return o;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t)
      return [];
    if (typeof t == "function" && (t = t(n)), qe(t) && (t = [t]), Array.isArray(t))
      return t;
    if (!n)
      return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), a = [], o = (i) => {
      i && (this.isSupportedCode(i) ? a.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return qe(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && o(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && o(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && o(this.getLanguagePartFromCode(t))) : qe(t) && o(this.formatLanguageCode(t)), r.forEach((i) => {
      a.indexOf(i) < 0 && o(this.formatLanguageCode(i));
    }), a;
  }
}
let WQ = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], YQ = {
  1: (e) => +(e > 1),
  2: (e) => +(e != 1),
  3: (e) => 0,
  4: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  5: (e) => e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
  6: (e) => e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
  7: (e) => e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  8: (e) => e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
  9: (e) => +(e >= 2),
  10: (e) => e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
  11: (e) => e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
  12: (e) => +(e % 10 != 1 || e % 100 == 11),
  13: (e) => +(e !== 0),
  14: (e) => e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
  15: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  16: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
  17: (e) => e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
  18: (e) => e == 0 ? 0 : e == 1 ? 1 : 2,
  19: (e) => e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
  20: (e) => e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
  21: (e) => e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
  22: (e) => e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const ZQ = ["v1", "v2", "v3"], qQ = ["v4"], G3 = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, JQ = () => {
  const e = {};
  return WQ.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: YQ[t.fc]
      };
    });
  }), e;
};
class XQ {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = za.create("pluralResolver"), (!this.options.compatibilityJSON || qQ.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = JQ(), this.pluralRulesCache = {};
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const r = vp(t === "dev" ? "en" : t), a = n.ordinal ? "ordinal" : "cardinal", o = JSON.stringify({
        cleanedCode: r,
        type: a
      });
      if (o in this.pluralRulesCache)
        return this.pluralRulesCache[o];
      let i;
      try {
        i = new Intl.PluralRules(r, {
          type: a
        });
      } catch {
        if (!t.match(/-|_/))
          return;
        const s = this.languageUtils.getLanguagePartFromCode(t);
        i = this.getRule(s, n);
      }
      return this.pluralRulesCache[o] = i, i;
    }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((a) => `${n}${a}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((a, o) => G3[a] - G3[o]).map((a) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : r.numbers.map((a) => this.getSuffix(t, a, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const a = this.getRule(t, r);
    return a ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(n)}` : this.getSuffixRetroCompatible(a, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let a = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (a === 2 ? a = "plural" : a === 1 && (a = ""));
    const o = () => this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
    return this.options.compatibilityJSON === "v1" ? a === 1 ? "" : typeof a == "number" ? `_plural_${a.toString()}` : o() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? o() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !ZQ.includes(this.options.compatibilityJSON);
  }
}
const H3 = function(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, o = FQ(e, t, n);
  return !o && a && qe(n) && (o = Zf(e, n, r), o === void 0 && (o = Zf(t, n, r))), o;
}, e1 = (e) => e.replace(/\$/g, "$$$$");
class QQ {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = za.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: r,
      useRawValueToEscape: a,
      prefix: o,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: p,
      nestingPrefixEscaped: h,
      nestingSuffix: m,
      nestingSuffixEscaped: f,
      nestingOptionsSeparator: g,
      maxReplaces: _,
      alwaysFormat: v
    } = t.interpolation;
    this.escape = n !== void 0 ? n : GQ, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = o ? hs(o) : i || "{{", this.suffix = s ? hs(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = p ? hs(p) : h || hs("$t("), this.nestingSuffix = m ? hs(m) : f || hs(")"), this.nestingOptionsSeparator = g || ",", this.maxReplaces = _ || 1e3, this.alwaysFormat = v !== void 0 ? v : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, r) => n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, r, a) {
    let o, i, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (p) => {
      if (p.indexOf(this.formatSeparator) < 0) {
        const g = H3(n, l, p, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(g, void 0, r, {
          ...a,
          ...n,
          interpolationkey: p
        }) : g;
      }
      const h = p.split(this.formatSeparator), m = h.shift().trim(), f = h.join(this.formatSeparator).trim();
      return this.format(H3(n, l, m, this.options.keySeparator, this.options.ignoreJSONStructure), f, r, {
        ...a,
        ...n,
        interpolationkey: m
      });
    };
    this.resetRegExp();
    const u = a && a.missingInterpolationHandler || this.options.missingInterpolationHandler, d = a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (p) => e1(p)
    }, {
      regex: this.regexp,
      safeValue: (p) => this.escapeValue ? e1(this.escape(p)) : e1(p)
    }].forEach((p) => {
      for (s = 0; o = p.regex.exec(t); ) {
        const h = o[1].trim();
        if (i = c(h), i === void 0)
          if (typeof u == "function") {
            const f = u(t, o, a);
            i = qe(f) ? f : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, h))
            i = "";
          else if (d) {
            i = o[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${h} for interpolating ${t}`), i = "";
        else
          !qe(i) && !this.useRawValueToEscape && (i = R3(i));
        const m = p.safeValue(i);
        if (t = t.replace(o[0], m), d ? (p.regex.lastIndex += i.length, p.regex.lastIndex -= o[0].length) : p.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, o, i;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0)
        return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let p = `{${d[1]}`;
      l = d[0], p = this.interpolate(p, i);
      const h = p.match(/'/g), m = p.match(/"/g);
      (h && h.length % 2 === 0 && !m || m.length % 2 !== 0) && (p = p.replace(/'/g, '"'));
      try {
        i = JSON.parse(p), c && (i = {
          ...c,
          ...i
        });
      } catch (f) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, f), `${l}${u}${p}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; a = this.nestingRegexp.exec(t); ) {
      let l = [];
      i = {
        ...r
      }, i = i.replace && !qe(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      let c = !1;
      if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
        const u = a[1].split(this.formatSeparator).map((d) => d.trim());
        a[1] = u.shift(), l = u, c = !0;
      }
      if (o = n(s.call(this, a[1].trim(), i), i), o && a[0] === t && !qe(o))
        return o;
      qe(o) || (o = R3(o)), o || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${t}`), o = ""), c && (o = l.reduce((u, d) => this.format(u, d, r.lng, {
        ...r,
        interpolationkey: a[1].trim()
      }), o.trim())), t = t.replace(a[0], o), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const eee = (e) => {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const a = r[1].substring(0, r[1].length - 1);
    t === "currency" && a.indexOf(":") < 0 ? n.currency || (n.currency = a.trim()) : t === "relativetime" && a.indexOf(":") < 0 ? n.range || (n.range = a.trim()) : a.split(";").forEach((o) => {
      if (o) {
        const [i, ...s] = o.split(":"), l = s.join(":").trim().replace(/^'+|'+$/g, ""), c = i.trim();
        n[c] || (n[c] = l), l === "false" && (n[c] = !1), l === "true" && (n[c] = !0), isNaN(l) || (n[c] = parseInt(l, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}, ms = (e) => {
  const t = {};
  return (n, r, a) => {
    let o = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (o = {
      ...o,
      [a.interpolationkey]: void 0
    });
    const i = r + JSON.stringify(o);
    let s = t[i];
    return s || (s = e(vp(r), a), t[i] = s), s(n);
  };
};
class tee {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = za.create("formatter"), this.options = t, this.formats = {
      number: ms((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r
        });
        return (o) => a.format(o);
      }),
      currency: ms((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (o) => a.format(o);
      }),
      datetime: ms((n, r) => {
        const a = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (o) => a.format(o);
      }),
      relativetime: ms((n, r) => {
        const a = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (o) => a.format(o, r.range || "day");
      }),
      list: ms((n, r) => {
        const a = new Intl.ListFormat(n, {
          ...r
        });
        return (o) => a.format(o);
      })
    }, this.init(t);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = n.interpolation.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = ms(n);
  }
  format(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = n.split(this.formatSeparator);
    if (o.length > 1 && o[0].indexOf("(") > 1 && o[0].indexOf(")") < 0 && o.find((i) => i.indexOf(")") > -1)) {
      const i = o.findIndex((s) => s.indexOf(")") > -1);
      o[0] = [o[0], ...o.splice(1, i)].join(this.formatSeparator);
    }
    return o.reduce((i, s) => {
      const {
        formatName: l,
        formatOptions: c
      } = eee(s);
      if (this.formats[l]) {
        let u = i;
        try {
          const d = a && a.formatParams && a.formatParams[a.interpolationkey] || {}, p = d.locale || d.lng || a.locale || a.lng || r;
          u = this.formats[l](i, p, {
            ...c,
            ...a,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return i;
    }, t);
  }
}
const ree = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class nee extends Lh {
  constructor(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = a, this.logger = za.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, a.backend, a);
  }
  queueLoad(t, n, r, a) {
    const o = {}, i = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      n.forEach((d) => {
        const p = `${c}|${d}`;
        !r.reload && this.store.hasResourceBundle(c, d) ? this.state[p] = 2 : this.state[p] < 0 || (this.state[p] === 1 ? i[p] === void 0 && (i[p] = !0) : (this.state[p] = 1, u = !1, i[p] === void 0 && (i[p] = !0), o[p] === void 0 && (o[p] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(o).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(o),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, n, r) {
    const a = t.split("|"), o = a[0], i = a[1];
    n && this.emit("failedLoading", o, i, n), !n && r && this.store.addResourceBundle(o, i, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2, n && r && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      BQ(l.loaded, [o], i), ree(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, i = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length)
      return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: a,
        wait: o,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, a + 1, o * 2, i);
        }, o);
        return;
      }
      i(c, u);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, n);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, n, s);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    qe(t) && (t = this.languageUtils.toResolveHierarchy(t)), qe(n) && (n = [n]);
    const o = this.queueLoad(t, n, r, a);
    if (!o.toLoad.length)
      return o.pending.length || a(), null;
    o.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), a = r[0], o = r[1];
    this.read(a, o, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${n}loading namespace ${o} for language ${a} failed`, i), !i && s && this.logger.log(`${n}loaded namespace ${o} for language ${a}`, s), this.loaded(t, i, s);
    });
  }
  saveMissing(t, n, r, a, o) {
    let i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...i,
          isUpdate: o
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, n, r, a, l) : u = c(t, n, r, a), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, n, r, a, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, a);
    }
  }
}
const K3 = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), qe(e[1]) && (t.defaultValue = e[1]), qe(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const n = e[3] || e[2];
      Object.keys(n).forEach((r) => {
        t[r] = n[r];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), U3 = (e) => (qe(e.ns) && (e.ns = [e.ns]), qe(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), qe(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e), Ju = () => {
}, aee = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((t) => {
    typeof e[t] == "function" && (e[t] = e[t].bind(e));
  });
};
class Kc extends Lh {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = U3(t), this.services = {}, this.logger = za, this.modules = {
      external: []
    }, aee(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (qe(n.ns) ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const a = K3();
    this.options = {
      ...a,
      ...this.options,
      ...U3(n)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    const o = (l) => l ? typeof l == "function" ? new l() : l : null;
    if (!this.options.isClone) {
      this.modules.logger ? za.init(o(this.modules.logger), this.options) : za.init(null, this.options);
      let l;
      this.modules.formatter ? l = this.modules.formatter : typeof Intl < "u" && (l = tee);
      const c = new z3(this.options);
      this.store = new B3(this.options.resources, this.options);
      const u = this.services;
      u.logger = za, u.resourceStore = this.store, u.languageUtils = c, u.pluralResolver = new XQ(c, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), l && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (u.formatter = o(l), u.formatter.init(u, this.options), this.options.interpolation.format = u.formatter.format.bind(u.formatter)), u.interpolator = new QQ(this.options), u.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, u.backendConnector = new nee(o(this.modules.backend), u.resourceStore, u, this.options), u.backendConnector.on("*", function(d) {
        for (var p = arguments.length, h = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          h[m - 1] = arguments[m];
        t.emit(d, ...h);
      }), this.modules.languageDetector && (u.languageDetector = o(this.modules.languageDetector), u.languageDetector.init && u.languageDetector.init(u, this.options.detection, this.options)), this.modules.i18nFormat && (u.i18nFormat = o(this.modules.i18nFormat), u.i18nFormat.init && u.i18nFormat.init(this)), this.translator = new _p(this.services, this.options), this.translator.on("*", function(d) {
        for (var p = arguments.length, h = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          h[m - 1] = arguments[m];
        t.emit(d, ...h);
      }), this.modules.external.forEach((d) => {
        d.init && d.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = Ju), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const l = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      l.length > 0 && l[0] !== "dev" && (this.options.lng = l[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((l) => {
      this[l] = function() {
        return t.store[l](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((l) => {
      this[l] = function() {
        return t.store[l](...arguments), t;
      };
    });
    const i = Wl(), s = () => {
      const l = (c, u) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), i.resolve(u), r(c, u);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return l(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, l);
    };
    return this.options.resources || !this.options.initImmediate ? s() : setTimeout(s, 0), i;
  }
  loadResources(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ju;
    const r = qe(t) ? t : this.language;
    if (typeof t == "function" && (n = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (r && r.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return n();
      const a = [], o = (i) => {
        !i || i === "cimode" || this.services.languageUtils.toResolveHierarchy(i).forEach((s) => {
          s !== "cimode" && a.indexOf(s) < 0 && a.push(s);
        });
      };
      r ? o(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((i) => o(i)), this.options.preload && this.options.preload.forEach((i) => o(i)), this.services.backendConnector.load(a, this.options.ns, (i) => {
        !i && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(i);
      });
    } else
      n(null);
  }
  reloadResources(t, n, r) {
    const a = Wl();
    return typeof t == "function" && (r = t, t = void 0), typeof n == "function" && (r = n, n = void 0), t || (t = this.languages), n || (n = this.options.ns), r || (r = Ju), this.services.backendConnector.reload(t, n, (o) => {
      a.resolve(), r(o);
    }), a;
  }
  use(t) {
    if (!t)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && Qw.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const a = Wl();
    this.emit("languageChanging", t);
    const o = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, i = (l, c) => {
      c ? (o(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, a.resolve(function() {
        return r.t(...arguments);
      }), n && n(l, function() {
        return r.t(...arguments);
      });
    }, s = (l) => {
      !t && !l && this.services.languageDetector && (l = []);
      const c = qe(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || o(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        i(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(t), a;
  }
  getFixedT(t, n, r) {
    var a = this;
    const o = function(i, s) {
      let l;
      if (typeof s != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          u[d - 2] = arguments[d];
        l = a.options.overloadTranslationOptionHandler([i, s].concat(u));
      } else
        l = {
          ...s
        };
      l.lng = l.lng || o.lng, l.lngs = l.lngs || o.lngs, l.ns = l.ns || o.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || r || o.keyPrefix);
      const p = a.options.keySeparator || ".";
      let h;
      return l.keyPrefix && Array.isArray(i) ? h = i.map((m) => `${l.keyPrefix}${p}${m}`) : h = l.keyPrefix ? `${l.keyPrefix}${p}${i}` : i, a.t(h, l);
    };
    return qe(t) ? o.lng = t : o.lngs = t, o.ns = n, o.keyPrefix = r, o;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, o = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const i = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, i);
      if (s !== void 0)
        return s;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(r, t) && (!a || i(o, t)));
  }
  loadNamespaces(t, n) {
    const r = Wl();
    return this.options.ns ? (qe(t) && (t = [t]), t.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      r.resolve(), n && n(a);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = Wl();
    qe(t) && (t = [t]);
    const a = this.options.preload || [], o = t.filter((i) => a.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return o.length ? (this.options.preload = a.concat(o), this.loadResources((i) => {
      r.resolve(), n && n(i);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t)
      return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new z3(K3());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new Kc(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ju;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const a = {
      ...this.options,
      ...t,
      isClone: !0
    }, o = new Kc(a);
    return (t.debug !== void 0 || t.prefix !== void 0) && (o.logger = o.logger.clone(t)), ["store", "services", "language"].forEach((i) => {
      o[i] = this[i];
    }), o.services = {
      ...this.services
    }, o.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, r && (o.store = new B3(this.store.data, a), o.services.resourceStore = o.store), o.translator = new _p(o.services, a), o.translator.on("*", function(i) {
      for (var s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), c = 1; c < s; c++)
        l[c - 1] = arguments[c];
      o.emit(i, ...l);
    }), o.init(a, n), o.translator.options = a, o.translator.backendConnector.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, o;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Xr = Kc.createInstance();
Xr.createInstance = Kc.createInstance;
Xr.createInstance;
Xr.dir;
Xr.init;
Xr.loadResources;
Xr.reloadResources;
Xr.use;
Xr.changeLanguage;
Xr.getFixedT;
Xr.t;
Xr.exists;
Xr.setDefaultNamespace;
Xr.hasLoadedNamespace;
Xr.loadNamespaces;
Xr.loadLanguages;
function Uc(e) {
  "@babel/helpers - typeof";
  return Uc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Uc(e);
}
function oee(e, t) {
  if (Uc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Uc(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function eS(e) {
  var t = oee(e, "string");
  return Uc(t) == "symbol" ? t : t + "";
}
function iee(e, t, n) {
  return (t = eS(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function see(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function lee(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, eS(r.key), r);
  }
}
function cee(e, t, n) {
  return t && lee(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var uee = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, dee = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, pee = function(e) {
  return dee[e];
}, hee = function(e) {
  return e.replace(uee, pee);
};
function $3(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function V3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $3(Object(n), !0).forEach(function(r) {
      iee(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $3(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var W3 = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: hee
};
Qe();
function mee() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  W3 = V3(V3({}, W3), e);
}
(function() {
  function e() {
    see(this, e), this.usedNamespaces = {};
  }
  return cee(e, [{
    key: "addUsedNamespaces",
    value: function(t) {
      var n = this;
      t.forEach(function(r) {
        n.usedNamespaces[r] || (n.usedNamespaces[r] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
})();
var fee = {
  type: "3rdParty",
  init: function(e) {
    mee(e.options.react);
  }
};
const gee = {
  title: "File Manager",
  file_upload: {
    file_not_supported: "File type not supported",
    drop_files_here: "Drag and drop your files here, or click to browse",
    upload_files: "Upload files",
    uploaded_successfully: "Successfully uploaded",
    crop_file: "Crop image ",
    crop_and_select_file: "Crop and select an image",
    upload_and_select_file: "Upload and select"
  },
  cancelled: "Cancelled",
  error: "Error",
  something_went_wrong: "Something went wrong",
  confirm_action: "Confirm action",
  confirm: "Confirm",
  cancel: "Cancel",
  file_details: "File details",
  download: "Download",
  rename: "Rename",
  delete: "Delete",
  name: "Name",
  size: "Size",
  file_source: {
    editor: "Editor",
    community: "Community",
    block_preview: "Block preview",
    membership: "Membership",
    marketplace: "Marketplace",
    settings: "Settings",
    email: "Email",
    ckeditor: "CKEditor",
    blog_post: "Blog post",
    page_template: "Page template",
    page_template_preview: "Page template preview",
    blog_template_preview: "Blog template preview",
    email_template: "Email template",
    product: "Product",
    funnel_template_preview: "Funnel template preview",
    digital_store: "Digital store",
    digital_product_resource: "Digital product resource",
    file_manager: "File manager",
    calendar_host_avatar: "Calendar",
    text_editor: "Text editor",
    website_template: "Website template",
    white_label: "White Label"
  },
  file_type: {
    image: "Image",
    image_other: "Other image",
    video: "Video",
    audio: "Audio",
    font: "Font",
    document: "Document"
  },
  select: "Select",
  file_selector: {
    files_selected: "file selected",
    search_file: "Search file",
    rename_file: "Rename file",
    file_name: "File name",
    enter_new_file_name: "Enter a new file name",
    failed_rename_file: "Failed to rename file",
    failed_delete_file: "Failed to delete file",
    failed_download_file: "Failed to download file",
    file_deletion_confirmation_text: 'Are you sure you want to delete "{{file}}"?',
    choose_file: "Choose a file"
  },
  search: "Search",
  upload: "Upload",
  file: "File",
  select_type: "Select file type",
  select_source: "Select source",
  type: "Type",
  created_at: "Created at",
  processing_size: "Processing",
  preview: "Preview",
  image_cropper: {
    aspect_ratio: {
      need_to_crop: "Crop image before selecting",
      need_to_crop_note: "The image has a different aspect ratio. Please crop it to match the required one"
    }
  },
  errors: {
    payload_to_large_error_message: "The file size is too big",
    conflict_error_message: "Sorry, but someone else has already changed this entity. Please reload the page and try again!",
    fields_toast_message: "Some fields contain invalid data, scroll down to resolve the issue",
    internal_error_message: "Something went wrong. Please try again"
  },
  file_renamed_successfully: "Renamed successfully",
  file_deleted_successfully: "Deleted successfully"
}, yee = {
  file_manager: gee
}, tS = ["common"], vee = tS[0], bee = Object.values(Mn), _ee = {
  en: { common: yee }
}, wee = {
  supportedLngs: bee,
  load: "languageOnly",
  debug: !1,
  defaultNS: vee,
  react: { useSuspense: !1 },
  ns: tS,
  fallbackLng: Mn.ENGLISH,
  lng: Mn.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: _ee,
  returnEmptyString: !1
};
Xr.use(fee).init(wee);
nU();
function See(e, t = 0.02) {
  const n = [
    { label: "(1:1)", value: 1 },
    { label: "(16:9)", value: 1.7777777777777777 },
    { label: "(21:9)", value: 2.3333333333333335 },
    { label: "(4:3)", value: 1.3333333333333333 },
    { label: "(1.43:1)", value: 1.43 },
    { label: "(32:9)", value: 3.5555555555555554 },
    { label: "(1.41:1)", value: 1.41 },
    { label: "(9:16)", value: 0.5625 },
    { label: "(19.5:9)", value: 2.1666666666666665 },
    { label: "(12:7)", value: 1.7142857142857142 }
  ].find((r) => Math.abs(e - r.value) < t);
  return n == null ? void 0 : n.label;
}
function Y3(e, t) {
  if (!t || isNaN(t))
    return e;
  const n = See(t);
  if (!n)
    return e;
  const r = n.replace(/[\s:]+/g, "_"), a = e.name.split(".").pop(), o = `${e.name.replace(/\.[^.]+$/, "")}_${r}.${a}`;
  return new File([e], o, {
    type: e.type,
    lastModified: e.lastModified
  });
}
function Z3(e, t) {
  const n = `${e.name.replace(/\.[^.]+$/, "")}.png`;
  return new File([t], n, {
    type: "image/png",
    lastModified: e.lastModified
  });
}
const Cee = k.memo(({ file: e, className: t }) => e.type.startsWith("image/") ? /* @__PURE__ */ Ke.jsx(
  Ed,
  {
    src: URL.createObjectURL(e),
    fileType: Ut.Image,
    alt: e.name,
    className: t,
    isThumbnail: !0,
    title: e.name
  }
) : e.type === "application/pdf" ? /* @__PURE__ */ Ke.jsx(
  "div",
  {
    className: dc(
      "pointer-events-none flex select-none items-center justify-center overflow-hidden rounded-md",
      t
    ),
    title: e.name,
    children: /* @__PURE__ */ Ke.jsx(
      "embed",
      {
        src: URL.createObjectURL(e),
        type: e.type,
        className: "h-full w-full",
        style: { border: "none" }
      }
    )
  }
) : e.type.startsWith("video/") ? /* @__PURE__ */ Ke.jsx(
  Ed,
  {
    src: URL.createObjectURL(e),
    fileType: Ut.Video,
    alt: e.name,
    className: t,
    isThumbnail: !0,
    title: e.name
  }
) : /* @__PURE__ */ Ke.jsx(
  Ed,
  {
    src: "",
    fileType: Ut.Document,
    className: t,
    isThumbnail: !0,
    title: e.name
  }
));
Cee.displayName = "FilePreviewFromOS";
var Rh = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, Dh = typeof window > "u" || "Deno" in globalThis;
function ua() {
}
function xee(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function kee(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function Eee(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function q3(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Pee(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function J3(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: a,
    predicate: o,
    queryKey: i,
    stale: s
  } = e;
  if (i) {
    if (r) {
      if (t.queryHash !== py(i, t.options))
        return !1;
    } else if (!Vc(t.queryKey, i))
      return !1;
  }
  if (n !== "all") {
    const l = t.isActive();
    if (n === "active" && !l || n === "inactive" && l)
      return !1;
  }
  return !(typeof s == "boolean" && t.isStale() !== s || a && a !== t.state.fetchStatus || o && !o(t));
}
function X3(e, t) {
  const { exact: n, status: r, predicate: a, mutationKey: o } = e;
  if (o) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if ($c(t.options.mutationKey) !== $c(o))
        return !1;
    } else if (!Vc(t.options.mutationKey, o))
      return !1;
  }
  return !(r && t.state.status !== r || a && !a(t));
}
function py(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || $c)(e);
}
function $c(e) {
  return JSON.stringify(
    e,
    (t, n) => Jf(n) ? Object.keys(n).sort().reduce((r, a) => (r[a] = n[a], r), {}) : n
  );
}
function Vc(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !Vc(e[n], t[n])) : !1;
}
function qf(e, t) {
  if (e === t)
    return e;
  const n = Q3(e) && Q3(t);
  if (n || Jf(e) && Jf(t)) {
    const r = n ? e : Object.keys(e), a = r.length, o = n ? t : Object.keys(t), i = o.length, s = n ? [] : {};
    let l = 0;
    for (let c = 0; c < i; c++) {
      const u = n ? c : o[c];
      (!n && r.includes(u) || n) && e[u] === void 0 && t[u] === void 0 ? (s[u] = void 0, l++) : (s[u] = qf(e[u], t[u]), s[u] === e[u] && e[u] !== void 0 && l++);
    }
    return a === i && l === a ? e : s;
  }
  return t;
}
function Q3(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function Jf(e) {
  if (!e_(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!e_(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function e_(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Tee(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function Mee(e, t, n) {
  if (typeof n.structuralSharing == "function")
    return n.structuralSharing(e, t);
  if (n.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return qf(e, t);
      } catch (r) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${n.queryHash}]: ${r}`
        );
      }
    return qf(e, t);
  }
  return t;
}
function Oee(e, t, n = 0) {
  const r = [...e, t];
  return n && r.length > n ? r.slice(1) : r;
}
function Aee(e, t, n = 0) {
  const r = [t, ...e];
  return n && r.length > n ? r.slice(0, -1) : r;
}
var wp = Symbol();
function rS(e, t) {
  return process.env.NODE_ENV !== "production" && e.queryFn === wp && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${e.queryHash}'`
  ), !e.queryFn && t != null && t.initialPromise ? () => t.initialPromise : !e.queryFn || e.queryFn === wp ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
var fs, fi, Yl, t_, Nee = (t_ = class extends Rh {
  constructor() {
    super(), Ht(this, fs, void 0), Ht(this, fi, void 0), Ht(this, Yl, void 0), ut(this, Yl, (e) => {
      if (!Dh && window.addEventListener) {
        const t = () => e();
        return window.addEventListener("visibilitychange", t, !1), () => {
          window.removeEventListener("visibilitychange", t);
        };
      }
    });
  }
  onSubscribe() {
    de(this, fi) || this.setEventListener(de(this, Yl));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = de(this, fi)) == null || e.call(this), ut(this, fi, void 0));
  }
  setEventListener(e) {
    var t;
    ut(this, Yl, e), (t = de(this, fi)) == null || t.call(this), ut(this, fi, e((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    }));
  }
  setFocused(e) {
    de(this, fs) !== e && (ut(this, fs, e), this.onFocus());
  }
  onFocus() {
    const e = this.isFocused();
    this.listeners.forEach((t) => {
      t(e);
    });
  }
  isFocused() {
    var e;
    return typeof de(this, fs) == "boolean" ? de(this, fs) : ((e = globalThis.document) == null ? void 0 : e.visibilityState) !== "hidden";
  }
}, fs = /* @__PURE__ */ new WeakMap(), fi = /* @__PURE__ */ new WeakMap(), Yl = /* @__PURE__ */ new WeakMap(), t_), nS = new Nee(), Zl, gi, ql, r_, Lee = (r_ = class extends Rh {
  constructor() {
    super(), Ht(this, Zl, !0), Ht(this, gi, void 0), Ht(this, ql, void 0), ut(this, ql, (e) => {
      if (!Dh && window.addEventListener) {
        const t = () => e(!0), n = () => e(!1);
        return window.addEventListener("online", t, !1), window.addEventListener("offline", n, !1), () => {
          window.removeEventListener("online", t), window.removeEventListener("offline", n);
        };
      }
    });
  }
  onSubscribe() {
    de(this, gi) || this.setEventListener(de(this, ql));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = de(this, gi)) == null || e.call(this), ut(this, gi, void 0));
  }
  setEventListener(e) {
    var t;
    ut(this, ql, e), (t = de(this, gi)) == null || t.call(this), ut(this, gi, e(this.setOnline.bind(this)));
  }
  setOnline(e) {
    de(this, Zl) !== e && (ut(this, Zl, e), this.listeners.forEach((t) => {
      t(e);
    }));
  }
  isOnline() {
    return de(this, Zl);
  }
}, Zl = /* @__PURE__ */ new WeakMap(), gi = /* @__PURE__ */ new WeakMap(), ql = /* @__PURE__ */ new WeakMap(), r_), Sp = new Lee();
function Ree() {
  let e, t;
  const n = new Promise((a, o) => {
    e = a, t = o;
  });
  n.status = "pending", n.catch(() => {
  });
  function r(a) {
    Object.assign(n, a), delete n.resolve, delete n.reject;
  }
  return n.resolve = (a) => {
    r({
      status: "fulfilled",
      value: a
    }), e(a);
  }, n.reject = (a) => {
    r({
      status: "rejected",
      reason: a
    }), t(a);
  }, n;
}
function Dee(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function aS(e) {
  return (e ?? "online") === "online" ? Sp.isOnline() : !0;
}
var oS = class extends Error {
  constructor(e) {
    super("CancelledError"), this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function t1(e) {
  return e instanceof oS;
}
function iS(e) {
  let t = !1, n = 0, r = !1, a;
  const o = Ree(), i = (f) => {
    var g;
    r || (p(new oS(f)), (g = e.abort) == null || g.call(e));
  }, s = () => {
    t = !0;
  }, l = () => {
    t = !1;
  }, c = () => nS.isFocused() && (e.networkMode === "always" || Sp.isOnline()) && e.canRun(), u = () => aS(e.networkMode) && e.canRun(), d = (f) => {
    var g;
    r || (r = !0, (g = e.onSuccess) == null || g.call(e, f), a == null || a(), o.resolve(f));
  }, p = (f) => {
    var g;
    r || (r = !0, (g = e.onError) == null || g.call(e, f), a == null || a(), o.reject(f));
  }, h = () => new Promise((f) => {
    var g;
    a = (_) => {
      (r || c()) && f(_);
    }, (g = e.onPause) == null || g.call(e);
  }).then(() => {
    var f;
    a = void 0, r || (f = e.onContinue) == null || f.call(e);
  }), m = () => {
    if (r)
      return;
    let f;
    const g = n === 0 ? e.initialPromise : void 0;
    try {
      f = g ?? e.fn();
    } catch (_) {
      f = Promise.reject(_);
    }
    Promise.resolve(f).then(d).catch((_) => {
      var v;
      if (r)
        return;
      const w = e.retry ?? (Dh ? 0 : 3), x = e.retryDelay ?? Dee, b = typeof x == "function" ? x(n, _) : x, C = w === !0 || typeof w == "number" && n < w || typeof w == "function" && w(n, _);
      if (t || !C) {
        p(_);
        return;
      }
      n++, (v = e.onFail) == null || v.call(e, n, _), Tee(b).then(() => c() ? void 0 : h()).then(() => {
        t ? p(_) : m();
      });
    });
  };
  return {
    promise: o,
    cancel: i,
    continue: () => (a == null || a(), o),
    cancelRetry: s,
    continueRetry: l,
    canStart: u,
    start: () => (u() ? m() : h().then(m), o)
  };
}
function Iee() {
  let e = [], t = 0, n = (s) => {
    s();
  }, r = (s) => {
    s();
  }, a = (s) => setTimeout(s, 0);
  const o = (s) => {
    t ? e.push(s) : a(() => {
      n(s);
    });
  }, i = () => {
    const s = e;
    e = [], s.length && a(() => {
      r(() => {
        s.forEach((l) => {
          n(l);
        });
      });
    });
  };
  return {
    batch: (s) => {
      let l;
      t++;
      try {
        l = s();
      } finally {
        t--, t || i();
      }
      return l;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (s) => (...l) => {
      o(() => {
        s(...l);
      });
    },
    schedule: o,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (s) => {
      n = s;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (s) => {
      r = s;
    },
    setScheduler: (s) => {
      a = s;
    }
  };
}
var ln = Iee(), gs, n_, sS = (n_ = class {
  constructor() {
    Ht(this, gs, void 0);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), kee(this.gcTime) && ut(this, gs, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (Dh ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    de(this, gs) && (clearTimeout(de(this, gs)), ut(this, gs, void 0));
  }
}, gs = /* @__PURE__ */ new WeakMap(), n_), Jl, Xl, sa, nn, Xu, ys, Ma, io, a_, jee = (a_ = class extends sS {
  constructor(e) {
    super(), Ht(this, Ma), Ht(this, Jl, void 0), Ht(this, Xl, void 0), Ht(this, sa, void 0), Ht(this, nn, void 0), Ht(this, Xu, void 0), Ht(this, ys, void 0), ut(this, ys, !1), ut(this, Xu, e.defaultOptions), this.setOptions(e.options), this.observers = [], ut(this, sa, e.cache), this.queryKey = e.queryKey, this.queryHash = e.queryHash, ut(this, Jl, Fee(this.options)), this.state = e.state ?? de(this, Jl), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var e;
    return (e = de(this, nn)) == null ? void 0 : e.promise;
  }
  setOptions(e) {
    this.options = { ...de(this, Xu), ...e }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && de(this, sa).remove(this);
  }
  setData(e, t) {
    const n = Mee(this.state.data, e, this.options);
    return sn(this, Ma, io).call(this, {
      data: n,
      type: "success",
      dataUpdatedAt: t == null ? void 0 : t.updatedAt,
      manual: t == null ? void 0 : t.manual
    }), n;
  }
  setState(e, t) {
    sn(this, Ma, io).call(this, { type: "setState", state: e, setStateOptions: t });
  }
  cancel(e) {
    var t, n;
    const r = (t = de(this, nn)) == null ? void 0 : t.promise;
    return (n = de(this, nn)) == null || n.cancel(e), r ? r.then(ua).catch(ua) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(de(this, Jl));
  }
  isActive() {
    return this.observers.some(
      (e) => Pee(e.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === wp || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (e) => e.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !Eee(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var e;
    const t = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    t == null || t.refetch({ cancelRefetch: !1 }), (e = de(this, nn)) == null || e.continue();
  }
  onOnline() {
    var e;
    const t = this.observers.find((n) => n.shouldFetchOnReconnect());
    t == null || t.refetch({ cancelRefetch: !1 }), (e = de(this, nn)) == null || e.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), de(this, sa).notify({ type: "observerAdded", query: this, observer: e }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((t) => t !== e), this.observers.length || (de(this, nn) && (de(this, ys) ? de(this, nn).cancel({ revert: !0 }) : de(this, nn).cancelRetry()), this.scheduleGc()), de(this, sa).notify({ type: "observerRemoved", query: this, observer: e }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || sn(this, Ma, io).call(this, { type: "invalidate" });
  }
  fetch(e, t) {
    var n, r, a;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && t != null && t.cancelRefetch)
        this.cancel({ silent: !0 });
      else if (de(this, nn))
        return de(this, nn).continueRetry(), de(this, nn).promise;
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const u = this.observers.find((d) => d.options.queryFn);
      u && this.setOptions(u.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const o = new AbortController(), i = (u) => {
      Object.defineProperty(u, "signal", {
        enumerable: !0,
        get: () => (ut(this, ys, !0), o.signal)
      });
    }, s = () => {
      const u = rS(this.options, t), d = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return i(d), ut(this, ys, !1), this.options.persister ? this.options.persister(
        u,
        d,
        this
      ) : u(d);
    }, l = {
      fetchOptions: t,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: s
    };
    i(l), (n = this.options.behavior) == null || n.onFetch(
      l,
      this
    ), ut(this, Xl, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((r = l.fetchOptions) == null ? void 0 : r.meta)) && sn(this, Ma, io).call(this, { type: "fetch", meta: (a = l.fetchOptions) == null ? void 0 : a.meta });
    const c = (u) => {
      var d, p, h, m;
      t1(u) && u.silent || sn(this, Ma, io).call(this, {
        type: "error",
        error: u
      }), t1(u) || ((p = (d = de(this, sa).config).onError) == null || p.call(
        d,
        u,
        this
      ), (m = (h = de(this, sa).config).onSettled) == null || m.call(
        h,
        this.state.data,
        u,
        this
      )), this.scheduleGc();
    };
    return ut(this, nn, iS({
      initialPromise: t == null ? void 0 : t.initialPromise,
      fn: l.fetchFn,
      abort: o.abort.bind(o),
      onSuccess: (u) => {
        var d, p, h, m;
        if (u === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), c(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(u);
        } catch (f) {
          c(f);
          return;
        }
        (p = (d = de(this, sa).config).onSuccess) == null || p.call(d, u, this), (m = (h = de(this, sa).config).onSettled) == null || m.call(
          h,
          u,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: c,
      onFail: (u, d) => {
        sn(this, Ma, io).call(this, { type: "failed", failureCount: u, error: d });
      },
      onPause: () => {
        sn(this, Ma, io).call(this, { type: "pause" });
      },
      onContinue: () => {
        sn(this, Ma, io).call(this, { type: "continue" });
      },
      retry: l.options.retry,
      retryDelay: l.options.retryDelay,
      networkMode: l.options.networkMode,
      canRun: () => !0
    })), de(this, nn).start();
  }
}, Jl = /* @__PURE__ */ new WeakMap(), Xl = /* @__PURE__ */ new WeakMap(), sa = /* @__PURE__ */ new WeakMap(), nn = /* @__PURE__ */ new WeakMap(), Xu = /* @__PURE__ */ new WeakMap(), ys = /* @__PURE__ */ new WeakMap(), Ma = /* @__PURE__ */ new WeakSet(), io = function(e) {
  const t = (n) => {
    switch (e.type) {
      case "failed":
        return {
          ...n,
          fetchFailureCount: e.failureCount,
          fetchFailureReason: e.error
        };
      case "pause":
        return {
          ...n,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...n,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...n,
          ...Bee(n.data, this.options),
          fetchMeta: e.meta ?? null
        };
      case "success":
        return {
          ...n,
          data: e.data,
          dataUpdateCount: n.dataUpdateCount + 1,
          dataUpdatedAt: e.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!e.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const r = e.error;
        return t1(r) && r.revert && de(this, Xl) ? { ...de(this, Xl), fetchStatus: "idle" } : {
          ...n,
          error: r,
          errorUpdateCount: n.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: n.fetchFailureCount + 1,
          fetchFailureReason: r,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...n,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...n,
          ...e.state
        };
    }
  };
  this.state = t(this.state), ln.batch(() => {
    this.observers.forEach((n) => {
      n.onQueryUpdate();
    }), de(this, sa).notify({ query: this, type: "updated", action: e });
  });
}, a_);
function Bee(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: aS(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function Fee(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var so, o_, zee = (o_ = class extends Rh {
  constructor(e = {}) {
    super(), Ht(this, so, void 0), this.config = e, ut(this, so, /* @__PURE__ */ new Map());
  }
  build(e, t, n) {
    const r = t.queryKey, a = t.queryHash ?? py(r, t);
    let o = this.get(a);
    return o || (o = new jee({
      cache: this,
      queryKey: r,
      queryHash: a,
      options: e.defaultQueryOptions(t),
      state: n,
      defaultOptions: e.getQueryDefaults(r)
    }), this.add(o)), o;
  }
  add(e) {
    de(this, so).has(e.queryHash) || (de(this, so).set(e.queryHash, e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const t = de(this, so).get(e.queryHash);
    t && (e.destroy(), t === e && de(this, so).delete(e.queryHash), this.notify({ type: "removed", query: e }));
  }
  clear() {
    ln.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return de(this, so).get(e);
  }
  getAll() {
    return [...de(this, so).values()];
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (n) => J3(t, n)
    );
  }
  findAll(e = {}) {
    const t = this.getAll();
    return Object.keys(e).length > 0 ? t.filter((n) => J3(e, n)) : t;
  }
  notify(e) {
    ln.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  onFocus() {
    ln.batch(() => {
      this.getAll().forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    ln.batch(() => {
      this.getAll().forEach((e) => {
        e.onOnline();
      });
    });
  }
}, so = /* @__PURE__ */ new WeakMap(), o_), lo, pn, vs, co, Oo, i_, Gee = (i_ = class extends sS {
  constructor(e) {
    super(), Ht(this, co), Ht(this, lo, void 0), Ht(this, pn, void 0), Ht(this, vs, void 0), this.mutationId = e.mutationId, ut(this, pn, e.mutationCache), ut(this, lo, []), this.state = e.state || Hee(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = e, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(e) {
    de(this, lo).includes(e) || (de(this, lo).push(e), this.clearGcTimeout(), de(this, pn).notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    ut(this, lo, de(this, lo).filter((t) => t !== e)), this.scheduleGc(), de(this, pn).notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    de(this, lo).length || (this.state.status === "pending" ? this.scheduleGc() : de(this, pn).remove(this));
  }
  continue() {
    var e;
    return ((e = de(this, vs)) == null ? void 0 : e.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(e) {
    var t, n, r, a, o, i, s, l, c, u, d, p, h, m, f, g, _, v, w, x;
    ut(this, vs, iS({
      fn: () => this.options.mutationFn ? this.options.mutationFn(e) : Promise.reject(new Error("No mutationFn found")),
      onFail: (E, A) => {
        sn(this, co, Oo).call(this, { type: "failed", failureCount: E, error: A });
      },
      onPause: () => {
        sn(this, co, Oo).call(this, { type: "pause" });
      },
      onContinue: () => {
        sn(this, co, Oo).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => de(this, pn).canRun(this)
    }));
    const b = this.state.status === "pending", C = !de(this, vs).canStart();
    try {
      if (!b) {
        sn(this, co, Oo).call(this, { type: "pending", variables: e, isPaused: C }), await ((n = (t = de(this, pn).config).onMutate) == null ? void 0 : n.call(
          t,
          e,
          this
        ));
        const A = await ((a = (r = this.options).onMutate) == null ? void 0 : a.call(r, e));
        A !== this.state.context && sn(this, co, Oo).call(this, {
          type: "pending",
          context: A,
          variables: e,
          isPaused: C
        });
      }
      const E = await de(this, vs).start();
      return await ((i = (o = de(this, pn).config).onSuccess) == null ? void 0 : i.call(
        o,
        E,
        e,
        this.state.context,
        this
      )), await ((l = (s = this.options).onSuccess) == null ? void 0 : l.call(s, E, e, this.state.context)), await ((u = (c = de(this, pn).config).onSettled) == null ? void 0 : u.call(
        c,
        E,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((p = (d = this.options).onSettled) == null ? void 0 : p.call(d, E, null, e, this.state.context)), sn(this, co, Oo).call(this, { type: "success", data: E }), E;
    } catch (E) {
      try {
        throw await ((m = (h = de(this, pn).config).onError) == null ? void 0 : m.call(
          h,
          E,
          e,
          this.state.context,
          this
        )), await ((g = (f = this.options).onError) == null ? void 0 : g.call(
          f,
          E,
          e,
          this.state.context
        )), await ((v = (_ = de(this, pn).config).onSettled) == null ? void 0 : v.call(
          _,
          void 0,
          E,
          this.state.variables,
          this.state.context,
          this
        )), await ((x = (w = this.options).onSettled) == null ? void 0 : x.call(
          w,
          void 0,
          E,
          e,
          this.state.context
        )), E;
      } finally {
        sn(this, co, Oo).call(this, { type: "error", error: E });
      }
    } finally {
      de(this, pn).runNext(this);
    }
  }
}, lo = /* @__PURE__ */ new WeakMap(), pn = /* @__PURE__ */ new WeakMap(), vs = /* @__PURE__ */ new WeakMap(), co = /* @__PURE__ */ new WeakSet(), Oo = function(e) {
  const t = (n) => {
    switch (e.type) {
      case "failed":
        return {
          ...n,
          failureCount: e.failureCount,
          failureReason: e.error
        };
      case "pause":
        return {
          ...n,
          isPaused: !0
        };
      case "continue":
        return {
          ...n,
          isPaused: !1
        };
      case "pending":
        return {
          ...n,
          context: e.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: e.isPaused,
          status: "pending",
          variables: e.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...n,
          data: e.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...n,
          data: void 0,
          error: e.error,
          failureCount: n.failureCount + 1,
          failureReason: e.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = t(this.state), ln.batch(() => {
    de(this, lo).forEach((n) => {
      n.onMutationUpdate(e);
    }), de(this, pn).notify({
      mutation: this,
      type: "updated",
      action: e
    });
  });
}, i_);
function Hee() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var jn, Qu, s_, Kee = (s_ = class extends Rh {
  constructor(e = {}) {
    super(), Ht(this, jn, void 0), Ht(this, Qu, void 0), this.config = e, ut(this, jn, /* @__PURE__ */ new Map()), ut(this, Qu, Date.now());
  }
  build(e, t, n) {
    const r = new Gee({
      mutationCache: this,
      mutationId: ++Vf(this, Qu)._,
      options: e.defaultMutationOptions(t),
      state: n
    });
    return this.add(r), r;
  }
  add(e) {
    const t = ed(e), n = de(this, jn).get(t) ?? [];
    n.push(e), de(this, jn).set(t, n), this.notify({ type: "added", mutation: e });
  }
  remove(e) {
    var t;
    const n = ed(e);
    if (de(this, jn).has(n)) {
      const r = (t = de(this, jn).get(n)) == null ? void 0 : t.filter((a) => a !== e);
      r && (r.length === 0 ? de(this, jn).delete(n) : de(this, jn).set(n, r));
    }
    this.notify({ type: "removed", mutation: e });
  }
  canRun(e) {
    var t;
    const n = (t = de(this, jn).get(ed(e))) == null ? void 0 : t.find((r) => r.state.status === "pending");
    return !n || n === e;
  }
  runNext(e) {
    var t;
    const n = (t = de(this, jn).get(ed(e))) == null ? void 0 : t.find((r) => r !== e && r.state.isPaused);
    return (n == null ? void 0 : n.continue()) ?? Promise.resolve();
  }
  clear() {
    ln.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return [...de(this, jn).values()].flat();
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (n) => X3(t, n)
    );
  }
  findAll(e = {}) {
    return this.getAll().filter((t) => X3(e, t));
  }
  notify(e) {
    ln.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  resumePausedMutations() {
    const e = this.getAll().filter((t) => t.state.isPaused);
    return ln.batch(
      () => Promise.all(
        e.map((t) => t.continue().catch(ua))
      )
    );
  }
}, jn = /* @__PURE__ */ new WeakMap(), Qu = /* @__PURE__ */ new WeakMap(), s_);
function ed(e) {
  var t;
  return ((t = e.options.scope) == null ? void 0 : t.id) ?? String(e.mutationId);
}
function l_(e) {
  return {
    onFetch: (t, n) => {
      var r, a, o, i, s;
      const l = t.options, c = (o = (a = (r = t.fetchOptions) == null ? void 0 : r.meta) == null ? void 0 : a.fetchMore) == null ? void 0 : o.direction, u = ((i = t.state.data) == null ? void 0 : i.pages) || [], d = ((s = t.state.data) == null ? void 0 : s.pageParams) || [];
      let p = { pages: [], pageParams: [] }, h = 0;
      const m = async () => {
        let f = !1;
        const g = (w) => {
          Object.defineProperty(w, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? f = !0 : t.signal.addEventListener("abort", () => {
              f = !0;
            }), t.signal)
          });
        }, _ = rS(t.options, t.fetchOptions), v = async (w, x, b) => {
          if (f)
            return Promise.reject();
          if (x == null && w.pages.length)
            return Promise.resolve(w);
          const C = {
            queryKey: t.queryKey,
            pageParam: x,
            direction: b ? "backward" : "forward",
            meta: t.options.meta
          };
          g(C);
          const E = await _(
            C
          ), { maxPages: A } = t.options, O = b ? Aee : Oee;
          return {
            pages: O(w.pages, E, A),
            pageParams: O(w.pageParams, x, A)
          };
        };
        if (c && u.length) {
          const w = c === "backward", x = w ? Uee : c_, b = {
            pages: u,
            pageParams: d
          }, C = x(l, b);
          p = await v(b, C, w);
        } else {
          const w = e ?? u.length;
          do {
            const x = h === 0 ? d[0] ?? l.initialPageParam : c_(l, p);
            if (h > 0 && x == null)
              break;
            p = await v(p, x), h++;
          } while (h < w);
        }
        return p;
      };
      t.options.persister ? t.fetchFn = () => {
        var f, g;
        return (g = (f = t.options).persister) == null ? void 0 : g.call(
          f,
          m,
          {
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          n
        );
      } : t.fetchFn = m;
    }
  };
}
function c_(e, { pages: t, pageParams: n }) {
  const r = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(
    t[r],
    t,
    n[r],
    n
  ) : void 0;
}
function Uee(e, { pages: t, pageParams: n }) {
  var r;
  return t.length > 0 ? (r = e.getPreviousPageParam) == null ? void 0 : r.call(e, t[0], t, n[0], n) : void 0;
}
var vr, yi, vi, Ql, ec, bi, tc, rc, u_, $ee = (u_ = class {
  constructor(e = {}) {
    Ht(this, vr, void 0), Ht(this, yi, void 0), Ht(this, vi, void 0), Ht(this, Ql, void 0), Ht(this, ec, void 0), Ht(this, bi, void 0), Ht(this, tc, void 0), Ht(this, rc, void 0), ut(this, vr, e.queryCache || new zee()), ut(this, yi, e.mutationCache || new Kee()), ut(this, vi, e.defaultOptions || {}), ut(this, Ql, /* @__PURE__ */ new Map()), ut(this, ec, /* @__PURE__ */ new Map()), ut(this, bi, 0);
  }
  mount() {
    Vf(this, bi)._++, de(this, bi) === 1 && (ut(this, tc, nS.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), de(this, vr).onFocus());
    })), ut(this, rc, Sp.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), de(this, vr).onOnline());
    })));
  }
  unmount() {
    var e, t;
    Vf(this, bi)._--, de(this, bi) === 0 && ((e = de(this, tc)) == null || e.call(this), ut(this, tc, void 0), (t = de(this, rc)) == null || t.call(this), ut(this, rc, void 0));
  }
  isFetching(e) {
    return de(this, vr).findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return de(this, yi).findAll({ ...e, status: "pending" }).length;
  }
  getQueryData(e) {
    var t;
    const n = this.defaultQueryOptions({ queryKey: e });
    return (t = de(this, vr).get(n.queryHash)) == null ? void 0 : t.state.data;
  }
  ensureQueryData(e) {
    const t = this.getQueryData(e.queryKey);
    if (t === void 0)
      return this.fetchQuery(e);
    {
      const n = this.defaultQueryOptions(e), r = de(this, vr).build(this, n);
      return e.revalidateIfStale && r.isStaleByTime(q3(n.staleTime, r)) && this.prefetchQuery(n), Promise.resolve(t);
    }
  }
  getQueriesData(e) {
    return de(this, vr).findAll(e).map(({ queryKey: t, state: n }) => {
      const r = n.data;
      return [t, r];
    });
  }
  setQueryData(e, t, n) {
    const r = this.defaultQueryOptions({ queryKey: e }), a = de(this, vr).get(
      r.queryHash
    ), o = a == null ? void 0 : a.state.data, i = xee(t, o);
    if (i !== void 0)
      return de(this, vr).build(this, r).setData(i, { ...n, manual: !0 });
  }
  setQueriesData(e, t, n) {
    return ln.batch(
      () => de(this, vr).findAll(e).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, t, n)
      ])
    );
  }
  getQueryState(e) {
    var t;
    const n = this.defaultQueryOptions({ queryKey: e });
    return (t = de(this, vr).get(n.queryHash)) == null ? void 0 : t.state;
  }
  removeQueries(e) {
    const t = de(this, vr);
    ln.batch(() => {
      t.findAll(e).forEach((n) => {
        t.remove(n);
      });
    });
  }
  resetQueries(e, t) {
    const n = de(this, vr), r = {
      type: "active",
      ...e
    };
    return ln.batch(() => (n.findAll(e).forEach((a) => {
      a.reset();
    }), this.refetchQueries(r, t)));
  }
  cancelQueries(e = {}, t = {}) {
    const n = { revert: !0, ...t }, r = ln.batch(
      () => de(this, vr).findAll(e).map((a) => a.cancel(n))
    );
    return Promise.all(r).then(ua).catch(ua);
  }
  invalidateQueries(e = {}, t = {}) {
    return ln.batch(() => {
      if (de(this, vr).findAll(e).forEach((r) => {
        r.invalidate();
      }), e.refetchType === "none")
        return Promise.resolve();
      const n = {
        ...e,
        type: e.refetchType ?? e.type ?? "active"
      };
      return this.refetchQueries(n, t);
    });
  }
  refetchQueries(e = {}, t) {
    const n = {
      ...t,
      cancelRefetch: (t == null ? void 0 : t.cancelRefetch) ?? !0
    }, r = ln.batch(
      () => de(this, vr).findAll(e).filter((a) => !a.isDisabled()).map((a) => {
        let o = a.fetch(void 0, n);
        return n.throwOnError || (o = o.catch(ua)), a.state.fetchStatus === "paused" ? Promise.resolve() : o;
      })
    );
    return Promise.all(r).then(ua);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    t.retry === void 0 && (t.retry = !1);
    const n = de(this, vr).build(this, t);
    return n.isStaleByTime(
      q3(t.staleTime, n)
    ) ? n.fetch(t) : Promise.resolve(n.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(ua).catch(ua);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = l_(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(ua).catch(ua);
  }
  ensureInfiniteQueryData(e) {
    return e.behavior = l_(e.pages), this.ensureQueryData(e);
  }
  resumePausedMutations() {
    return Sp.isOnline() ? de(this, yi).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return de(this, vr);
  }
  getMutationCache() {
    return de(this, yi);
  }
  getDefaultOptions() {
    return de(this, vi);
  }
  setDefaultOptions(e) {
    ut(this, vi, e);
  }
  setQueryDefaults(e, t) {
    de(this, Ql).set($c(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...de(this, Ql).values()];
    let n = {};
    return t.forEach((r) => {
      Vc(e, r.queryKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  setMutationDefaults(e, t) {
    de(this, ec).set($c(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...de(this, ec).values()];
    let n = {};
    return t.forEach((r) => {
      Vc(e, r.mutationKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  defaultQueryOptions(e) {
    if (e._defaulted)
      return e;
    const t = {
      ...de(this, vi).queries,
      ...this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = py(
      t.queryKey,
      t
    )), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.enabled !== !0 && t.queryFn === wp && (t.enabled = !1), t;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...de(this, vi).mutations,
      ...(e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    de(this, vr).clear(), de(this, yi).clear();
  }
}, vr = /* @__PURE__ */ new WeakMap(), yi = /* @__PURE__ */ new WeakMap(), vi = /* @__PURE__ */ new WeakMap(), Ql = /* @__PURE__ */ new WeakMap(), ec = /* @__PURE__ */ new WeakMap(), bi = /* @__PURE__ */ new WeakMap(), tc = /* @__PURE__ */ new WeakMap(), rc = /* @__PURE__ */ new WeakMap(), u_);
pe.createContext(
  void 0
);
var Vee = pe.createContext(!1);
Vee.Provider;
function Wee() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
pe.createContext(Wee());
new $ee({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchInterval: !1,
      refetchOnWindowFocus: !1,
      refetchOnMount: !1,
      refetchIntervalInBackground: !1
    }
  }
});
Qe(null);
function lS(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Yee } = Object.prototype, { getPrototypeOf: hy } = Object, Ih = /* @__PURE__ */ ((e) => (t) => {
  const n = Yee.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Pa = (e) => (e = e.toLowerCase(), (t) => Ih(t) === e), jh = (e) => (t) => typeof t === e, { isArray: _l } = Array, Wc = jh("undefined");
function Zee(e) {
  return e !== null && !Wc(e) && e.constructor !== null && !Wc(e.constructor) && Ln(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const cS = Pa("ArrayBuffer");
function qee(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && cS(e.buffer), t;
}
const Jee = jh("string"), Ln = jh("function"), uS = jh("number"), Bh = (e) => e !== null && typeof e == "object", Xee = (e) => e === !0 || e === !1, Pd = (e) => {
  if (Ih(e) !== "object")
    return !1;
  const t = hy(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Qee = Pa("Date"), ete = Pa("File"), tte = Pa("Blob"), rte = Pa("FileList"), nte = (e) => Bh(e) && Ln(e.pipe), ate = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Ln(e.append) && ((t = Ih(e)) === "formdata" || // detect form-data instance
  t === "object" && Ln(e.toString) && e.toString() === "[object FormData]"));
}, ote = Pa("URLSearchParams"), [ite, ste, lte, cte] = ["ReadableStream", "Request", "Response", "Headers"].map(Pa), ute = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Pu(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, a;
  if (typeof e != "object" && (e = [e]), _l(e))
    for (r = 0, a = e.length; r < a; r++)
      t.call(null, e[r], r, e);
  else {
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
    let s;
    for (r = 0; r < i; r++)
      s = o[r], t.call(null, e[s], s, e);
  }
}
function dS(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, a;
  for (; r-- > 0; )
    if (a = n[r], t === a.toLowerCase())
      return a;
  return null;
}
const Li = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, pS = (e) => !Wc(e) && e !== Li;
function Xf() {
  const { caseless: e } = pS(this) && this || {}, t = {}, n = (r, a) => {
    const o = e && dS(t, a) || a;
    Pd(t[o]) && Pd(r) ? t[o] = Xf(t[o], r) : Pd(r) ? t[o] = Xf({}, r) : _l(r) ? t[o] = r.slice() : t[o] = r;
  };
  for (let r = 0, a = arguments.length; r < a; r++)
    arguments[r] && Pu(arguments[r], n);
  return t;
}
const dte = (e, t, n, { allOwnKeys: r } = {}) => (Pu(t, (a, o) => {
  n && Ln(a) ? e[o] = lS(a, n) : e[o] = a;
}, { allOwnKeys: r }), e), pte = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), hte = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, mte = (e, t, n, r) => {
  let a, o, i;
  const s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      i = a[o], (!r || r(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = n !== !1 && hy(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, fte = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, gte = (e) => {
  if (!e)
    return null;
  if (_l(e))
    return e;
  let t = e.length;
  if (!uS(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, yte = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && hy(Uint8Array)), vte = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const a = r.value;
    t.call(e, a[0], a[1]);
  }
}, bte = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, _te = Pa("HTMLFormElement"), wte = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, n, r) {
    return n.toUpperCase() + r;
  }
), d_ = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Ste = Pa("RegExp"), hS = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Pu(n, (a, o) => {
    let i;
    (i = t(a, o, e)) !== !1 && (r[o] = i || a);
  }), Object.defineProperties(e, r);
}, Cte = (e) => {
  hS(e, (t, n) => {
    if (Ln(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Ln(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, xte = (e, t) => {
  const n = {}, r = (a) => {
    a.forEach((o) => {
      n[o] = !0;
    });
  };
  return _l(e) ? r(e) : r(String(e).split(t)), n;
}, kte = () => {
}, Ete = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, r1 = "abcdefghijklmnopqrstuvwxyz", p_ = "0123456789", mS = {
  DIGIT: p_,
  ALPHA: r1,
  ALPHA_DIGIT: r1 + r1.toUpperCase() + p_
}, Pte = (e = 16, t = mS.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function Tte(e) {
  return !!(e && Ln(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const Mte = (e) => {
  const t = new Array(10), n = (r, a) => {
    if (Bh(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[a] = r;
        const o = _l(r) ? [] : {};
        return Pu(r, (i, s) => {
          const l = n(i, a + 1);
          !Wc(l) && (o[s] = l);
        }), t[a] = void 0, o;
      }
    }
    return r;
  };
  return n(e, 0);
}, Ote = Pa("AsyncFunction"), Ate = (e) => e && (Bh(e) || Ln(e)) && Ln(e.then) && Ln(e.catch), fS = ((e, t) => e ? setImmediate : t ? ((n, r) => (Li.addEventListener("message", ({ source: a, data: o }) => {
  a === Li && o === n && r.length && r.shift()();
}, !1), (a) => {
  r.push(a), Li.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Ln(Li.postMessage)
), Nte = typeof queueMicrotask < "u" ? queueMicrotask.bind(Li) : typeof process < "u" && process.nextTick || fS, le = {
  isArray: _l,
  isArrayBuffer: cS,
  isBuffer: Zee,
  isFormData: ate,
  isArrayBufferView: qee,
  isString: Jee,
  isNumber: uS,
  isBoolean: Xee,
  isObject: Bh,
  isPlainObject: Pd,
  isReadableStream: ite,
  isRequest: ste,
  isResponse: lte,
  isHeaders: cte,
  isUndefined: Wc,
  isDate: Qee,
  isFile: ete,
  isBlob: tte,
  isRegExp: Ste,
  isFunction: Ln,
  isStream: nte,
  isURLSearchParams: ote,
  isTypedArray: yte,
  isFileList: rte,
  forEach: Pu,
  merge: Xf,
  extend: dte,
  trim: ute,
  stripBOM: pte,
  inherits: hte,
  toFlatObject: mte,
  kindOf: Ih,
  kindOfTest: Pa,
  endsWith: fte,
  toArray: gte,
  forEachEntry: vte,
  matchAll: bte,
  isHTMLForm: _te,
  hasOwnProperty: d_,
  hasOwnProp: d_,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: hS,
  freezeMethods: Cte,
  toObjectSet: xte,
  toCamelCase: wte,
  noop: kte,
  toFiniteNumber: Ete,
  findKey: dS,
  global: Li,
  isContextDefined: pS,
  ALPHABET: mS,
  generateString: Pte,
  isSpecCompliantForm: Tte,
  toJSONObject: Mte,
  isAsyncFn: Ote,
  isThenable: Ate,
  setImmediate: fS,
  asap: Nte
};
function nt(e, t, n, r, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), a && (this.response = a);
}
le.inherits(nt, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: le.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const gS = nt.prototype, yS = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  yS[e] = { value: e };
});
Object.defineProperties(nt, yS);
Object.defineProperty(gS, "isAxiosError", { value: !0 });
nt.from = (e, t, n, r, a, o) => {
  const i = Object.create(gS);
  return le.toFlatObject(e, i, function(s) {
    return s !== Error.prototype;
  }, (s) => s !== "isAxiosError"), nt.call(i, e.message, t, n, r, a), i.cause = e, i.name = e.name, o && Object.assign(i, o), i;
};
const Lte = null;
function Qf(e) {
  return le.isPlainObject(e) || le.isArray(e);
}
function vS(e) {
  return le.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function h_(e, t, n) {
  return e ? e.concat(t).map(function(r, a) {
    return r = vS(r), !n && a ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
function Rte(e) {
  return le.isArray(e) && !e.some(Qf);
}
const Dte = le.toFlatObject(le, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Fh(e, t, n) {
  if (!le.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = le.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, m) {
    return !le.isUndefined(m[h]);
  });
  const r = n.metaTokens, a = n.visitor || c, o = n.dots, i = n.indexes, s = (n.Blob || typeof Blob < "u" && Blob) && le.isSpecCompliantForm(t);
  if (!le.isFunction(a))
    throw new TypeError("visitor must be a function");
  function l(h) {
    if (h === null)
      return "";
    if (le.isDate(h))
      return h.toISOString();
    if (!s && le.isBlob(h))
      throw new nt("Blob is not supported. Use a Buffer instead.");
    return le.isArrayBuffer(h) || le.isTypedArray(h) ? s && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function c(h, m, f) {
    let g = h;
    if (h && !f && typeof h == "object") {
      if (le.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), h = JSON.stringify(h);
      else if (le.isArray(h) && Rte(h) || (le.isFileList(h) || le.endsWith(m, "[]")) && (g = le.toArray(h)))
        return m = vS(m), g.forEach(function(_, v) {
          !(le.isUndefined(_) || _ === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? h_([m], v, o) : i === null ? m : m + "[]",
            l(_)
          );
        }), !1;
    }
    return Qf(h) ? !0 : (t.append(h_(f, m, o), l(h)), !1);
  }
  const u = [], d = Object.assign(Dte, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: Qf
  });
  function p(h, m) {
    if (!le.isUndefined(h)) {
      if (u.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      u.push(h), le.forEach(h, function(f, g) {
        (!(le.isUndefined(f) || f === null) && a.call(
          t,
          f,
          le.isString(g) ? g.trim() : g,
          m,
          d
        )) === !0 && p(f, m ? m.concat(g) : [g]);
      }), u.pop();
    }
  }
  if (!le.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), t;
}
function m_(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function my(e, t) {
  this._pairs = [], e && Fh(e, this, t);
}
const bS = my.prototype;
bS.append = function(e, t) {
  this._pairs.push([e, t]);
};
bS.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, m_);
  } : m_;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
function Ite(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function _S(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || Ite, a = n && n.serialize;
  let o;
  if (a ? o = a(t, n) : o = le.isURLSearchParams(t) ? t.toString() : new my(t, n).toString(r), o) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class f_ {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    le.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const wS = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, jte = typeof URLSearchParams < "u" ? URLSearchParams : my, Bte = typeof FormData < "u" ? FormData : null, Fte = typeof Blob < "u" ? Blob : null, zte = {
  isBrowser: !0,
  classes: {
    URLSearchParams: jte,
    FormData: Bte,
    Blob: Fte
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, fy = typeof window < "u" && typeof document < "u", Gte = ((e) => fy && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), Hte = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Kte = fy && window.location.href || "http://localhost", Ute = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: fy,
  hasStandardBrowserEnv: Gte,
  hasStandardBrowserWebWorkerEnv: Hte,
  origin: Kte
}, Symbol.toStringTag, { value: "Module" })), fa = {
  ...Ute,
  ...zte
};
function $te(e, t) {
  return Fh(e, new fa.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, a, o) {
      return fa.isNode && le.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Vte(e) {
  return le.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Wte(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const a = n.length;
  let o;
  for (r = 0; r < a; r++)
    o = n[r], t[o] = e[o];
  return t;
}
function SS(e) {
  function t(n, r, a, o) {
    let i = n[o++];
    if (i === "__proto__")
      return !0;
    const s = Number.isFinite(+i), l = o >= n.length;
    return i = !i && le.isArray(a) ? a.length : i, l ? (le.hasOwnProp(a, i) ? a[i] = [a[i], r] : a[i] = r, !s) : ((!a[i] || !le.isObject(a[i])) && (a[i] = []), t(n, r, a[i], o) && le.isArray(a[i]) && (a[i] = Wte(a[i])), !s);
  }
  if (le.isFormData(e) && le.isFunction(e.entries)) {
    const n = {};
    return le.forEachEntry(e, (r, a) => {
      t(Vte(r), a, n, 0);
    }), n;
  }
  return null;
}
function Yte(e, t, n) {
  if (le.isString(e))
    try {
      return (t || JSON.parse)(e), le.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (0, JSON.stringify)(e);
}
const Tu = {
  transitional: wS,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const n = t.getContentType() || "", r = n.indexOf("application/json") > -1, a = le.isObject(e);
    if (a && le.isHTMLForm(e) && (e = new FormData(e)), le.isFormData(e))
      return r ? JSON.stringify(SS(e)) : e;
    if (le.isArrayBuffer(e) || le.isBuffer(e) || le.isStream(e) || le.isFile(e) || le.isBlob(e) || le.isReadableStream(e))
      return e;
    if (le.isArrayBufferView(e))
      return e.buffer;
    if (le.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let o;
    if (a) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return $te(e, this.formSerializer).toString();
      if ((o = le.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const i = this.env && this.env.FormData;
        return Fh(
          o ? { "files[]": e } : e,
          i && new i(),
          this.formSerializer
        );
      }
    }
    return a || r ? (t.setContentType("application/json", !1), Yte(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || Tu.transitional, n = t && t.forcedJSONParsing, r = this.responseType === "json";
    if (le.isResponse(e) || le.isReadableStream(e))
      return e;
    if (e && le.isString(e) && (n && !this.responseType || r)) {
      const a = !(t && t.silentJSONParsing) && r;
      try {
        return JSON.parse(e);
      } catch (o) {
        if (a)
          throw o.name === "SyntaxError" ? nt.from(o, nt.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: fa.classes.FormData,
    Blob: fa.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
le.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Tu.headers[e] = {};
});
const Zte = le.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), qte = (e) => {
  const t = {};
  let n, r, a;
  return e && e.split(`
`).forEach(function(o) {
    a = o.indexOf(":"), n = o.substring(0, a).trim().toLowerCase(), r = o.substring(a + 1).trim(), !(!n || t[n] && Zte[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, g_ = Symbol("internals");
function nc(e) {
  return e && String(e).trim().toLowerCase();
}
function Td(e) {
  return e === !1 || e == null ? e : le.isArray(e) ? e.map(Td) : String(e);
}
function Jte(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const Xte = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function n1(e, t, n, r, a) {
  if (le.isFunction(r))
    return r.call(this, t, n);
  if (a && (t = n), !!le.isString(t)) {
    if (le.isString(r))
      return t.indexOf(r) !== -1;
    if (le.isRegExp(r))
      return r.test(t);
  }
}
function Qte(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function ere(e, t) {
  const n = le.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(a, o, i) {
        return this[r].call(this, t, a, o, i);
      },
      configurable: !0
    });
  });
}
class _n {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const a = this;
    function o(s, l, c) {
      const u = nc(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = le.findKey(a, u);
      (!d || a[d] === void 0 || c === !0 || c === void 0 && a[d] !== !1) && (a[d || l] = Td(s));
    }
    const i = (s, l) => le.forEach(s, (c, u) => o(c, u, l));
    if (le.isPlainObject(t) || t instanceof this.constructor)
      i(t, n);
    else if (le.isString(t) && (t = t.trim()) && !Xte(t))
      i(qte(t), n);
    else if (le.isHeaders(t))
      for (const [s, l] of t.entries())
        o(l, s, r);
    else
      t != null && o(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = nc(t), t) {
      const r = le.findKey(this, t);
      if (r) {
        const a = this[r];
        if (!n)
          return a;
        if (n === !0)
          return Jte(a);
        if (le.isFunction(n))
          return n.call(this, a, r);
        if (le.isRegExp(n))
          return n.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = nc(t), t) {
      const r = le.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || n1(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let a = !1;
    function o(i) {
      if (i = nc(i), i) {
        const s = le.findKey(r, i);
        s && (!n || n1(r, r[s], s, n)) && (delete r[s], a = !0);
      }
    }
    return le.isArray(t) ? t.forEach(o) : o(t), a;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, a = !1;
    for (; r--; ) {
      const o = n[r];
      (!t || n1(this, this[o], o, t, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(t) {
    const n = this, r = {};
    return le.forEach(this, (a, o) => {
      const i = le.findKey(r, o);
      if (i) {
        n[i] = Td(a), delete n[o];
        return;
      }
      const s = t ? Qte(o) : String(o).trim();
      s !== o && delete n[o], n[s] = Td(a), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return le.forEach(this, (r, a) => {
      r != null && r !== !1 && (n[a] = t && le.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((a) => r.set(a)), r;
  }
  static accessor(t) {
    const n = (this[g_] = this[g_] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function a(o) {
      const i = nc(o);
      n[i] || (ere(r, o), n[i] = !0);
    }
    return le.isArray(t) ? t.forEach(a) : a(t), this;
  }
}
_n.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
le.reduceDescriptors(_n.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
le.freezeMethods(_n);
function a1(e, t) {
  const n = this || Tu, r = t || n, a = _n.from(r.headers);
  let o = r.data;
  return le.forEach(e, function(i) {
    o = i.call(n, o, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), o;
}
function CS(e) {
  return !!(e && e.__CANCEL__);
}
function wl(e, t, n) {
  nt.call(this, e ?? "canceled", nt.ERR_CANCELED, t, n), this.name = "CanceledError";
}
le.inherits(wl, nt, {
  __CANCEL__: !0
});
function xS(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new nt(
    "Request failed with status code " + n.status,
    [nt.ERR_BAD_REQUEST, nt.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function tre(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function rre(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let a = 0, o = 0, i;
  return t = t !== void 0 ? t : 1e3, function(s) {
    const l = Date.now(), c = r[o];
    i || (i = l), n[a] = s, r[a] = l;
    let u = o, d = 0;
    for (; u !== a; )
      d += n[u++], u = u % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), l - i < t)
      return;
    const p = c && l - c;
    return p ? Math.round(d * 1e3 / p) : void 0;
  };
}
function nre(e, t) {
  let n = 0, r = 1e3 / t, a, o;
  const i = (s, l = Date.now()) => {
    n = l, a = null, o && (clearTimeout(o), o = null), e.apply(null, s);
  };
  return [(...s) => {
    const l = Date.now(), c = l - n;
    c >= r ? i(s, l) : (a = s, o || (o = setTimeout(() => {
      o = null, i(a);
    }, r - c)));
  }, () => a && i(a)];
}
const Cp = (e, t, n = 3) => {
  let r = 0;
  const a = rre(50, 250);
  return nre((o) => {
    const i = o.loaded, s = o.lengthComputable ? o.total : void 0, l = i - r, c = a(l), u = i <= s;
    r = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - i) / c : void 0,
      event: o,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, y_ = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, v_ = (e) => (...t) => le.asap(() => e(...t)), are = fa.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a");
    let n;
    function r(a) {
      let o = a;
      return e && (t.setAttribute("href", o), o = t.href), t.setAttribute("href", o), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return n = r(window.location.href), function(a) {
      const o = le.isString(a) ? r(a) : a;
      return o.protocol === n.protocol && o.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), ore = fa.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, a, o) {
      const i = [e + "=" + encodeURIComponent(t)];
      le.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), le.isString(r) && i.push("path=" + r), le.isString(a) && i.push("domain=" + a), o === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function ire(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function sre(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function kS(e, t) {
  return e && !ire(t) ? sre(e, t) : t;
}
const b_ = (e) => e instanceof _n ? { ...e } : e;
function Xi(e, t) {
  t = t || {};
  const n = {};
  function r(c, u, d) {
    return le.isPlainObject(c) && le.isPlainObject(u) ? le.merge.call({ caseless: d }, c, u) : le.isPlainObject(u) ? le.merge({}, u) : le.isArray(u) ? u.slice() : u;
  }
  function a(c, u, d) {
    if (le.isUndefined(u)) {
      if (!le.isUndefined(c))
        return r(void 0, c, d);
    } else
      return r(c, u, d);
  }
  function o(c, u) {
    if (!le.isUndefined(u))
      return r(void 0, u);
  }
  function i(c, u) {
    if (le.isUndefined(u)) {
      if (!le.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return r(c, u);
    if (d in e)
      return r(void 0, c);
  }
  const l = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (c, u) => a(b_(c), b_(u), !0)
  };
  return le.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const u = l[c] || a, d = u(e[c], t[c], c);
    le.isUndefined(d) && u !== s || (n[c] = d);
  }), n;
}
const ES = (e) => {
  const t = Xi({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: a, xsrfCookieName: o, headers: i, auth: s } = t;
  t.headers = i = _n.from(i), t.url = _S(kS(t.baseURL, t.url), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (le.isFormData(n)) {
    if (fa.hasStandardBrowserEnv || fa.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((l = i.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      i.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (fa.hasStandardBrowserEnv && (r && le.isFunction(r) && (r = r(t)), r || r !== !1 && are(t.url))) {
    const c = a && o && ore.read(o);
    c && i.set(a, c);
  }
  return t;
}, lre = typeof XMLHttpRequest < "u", cre = lre && function(e) {
  return new Promise(function(t, n) {
    const r = ES(e);
    let a = r.data;
    const o = _n.from(r.headers).normalize();
    let { responseType: i, onUploadProgress: s, onDownloadProgress: l } = r, c, u, d, p, h;
    function m() {
      p && p(), h && h(), r.cancelToken && r.cancelToken.unsubscribe(c), r.signal && r.signal.removeEventListener("abort", c);
    }
    let f = new XMLHttpRequest();
    f.open(r.method.toUpperCase(), r.url, !0), f.timeout = r.timeout;
    function g() {
      if (!f)
        return;
      const v = _n.from(
        "getAllResponseHeaders" in f && f.getAllResponseHeaders()
      ), w = {
        data: !i || i === "text" || i === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: v,
        config: e,
        request: f
      };
      xS(function(x) {
        t(x), m();
      }, function(x) {
        n(x), m();
      }, w), f = null;
    }
    "onloadend" in f ? f.onloadend = g : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(g);
    }, f.onabort = function() {
      f && (n(new nt("Request aborted", nt.ECONNABORTED, e, f)), f = null);
    }, f.onerror = function() {
      n(new nt("Network Error", nt.ERR_NETWORK, e, f)), f = null;
    }, f.ontimeout = function() {
      let v = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const w = r.transitional || wS;
      r.timeoutErrorMessage && (v = r.timeoutErrorMessage), n(new nt(
        v,
        w.clarifyTimeoutError ? nt.ETIMEDOUT : nt.ECONNABORTED,
        e,
        f
      )), f = null;
    }, a === void 0 && o.setContentType(null), "setRequestHeader" in f && le.forEach(o.toJSON(), function(v, w) {
      f.setRequestHeader(w, v);
    }), le.isUndefined(r.withCredentials) || (f.withCredentials = !!r.withCredentials), i && i !== "json" && (f.responseType = r.responseType), l && ([d, h] = Cp(l, !0), f.addEventListener("progress", d)), s && f.upload && ([u, p] = Cp(s), f.upload.addEventListener("progress", u), f.upload.addEventListener("loadend", p)), (r.cancelToken || r.signal) && (c = (v) => {
      f && (n(!v || v.type ? new wl(null, e, f) : v), f.abort(), f = null);
    }, r.cancelToken && r.cancelToken.subscribe(c), r.signal && (r.signal.aborted ? c() : r.signal.addEventListener("abort", c)));
    const _ = tre(r.url);
    if (_ && fa.protocols.indexOf(_) === -1) {
      n(new nt("Unsupported protocol " + _ + ":", nt.ERR_BAD_REQUEST, e));
      return;
    }
    f.send(a || null);
  });
}, ure = (e, t) => {
  let n = new AbortController(), r;
  const a = function(l) {
    if (!r) {
      r = !0, i();
      const c = l instanceof Error ? l : this.reason;
      n.abort(c instanceof nt ? c : new wl(c instanceof Error ? c.message : c));
    }
  };
  let o = t && setTimeout(() => {
    a(new nt(`timeout ${t} of ms exceeded`, nt.ETIMEDOUT));
  }, t);
  const i = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((l) => {
      l && (l.removeEventListener ? l.removeEventListener("abort", a) : l.unsubscribe(a));
    }), e = null);
  };
  e.forEach((l) => l && l.addEventListener && l.addEventListener("abort", a));
  const { signal: s } = n;
  return s.unsubscribe = i, [s, () => {
    o && clearTimeout(o), o = null;
  }];
}, dre = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, a;
  for (; r < n; )
    a = r + t, yield e.slice(r, a), r = a;
}, pre = async function* (e, t, n) {
  for await (const r of e)
    yield* dre(ArrayBuffer.isView(r) ? r : await n(String(r)), t);
}, __ = (e, t, n, r, a) => {
  const o = pre(e, t, a);
  let i = 0, s, l = (c) => {
    s || (s = !0, r && r(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: d } = await o.next();
        if (u) {
          l(), c.close();
          return;
        }
        let p = d.byteLength;
        if (n) {
          let h = i += p;
          n(h);
        }
        c.enqueue(new Uint8Array(d));
      } catch (u) {
        throw l(u), u;
      }
    },
    cancel(c) {
      return l(c), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, zh = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", PS = zh && typeof ReadableStream == "function", e0 = zh && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), TS = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, hre = PS && TS(() => {
  let e = !1;
  const t = new Request(fa.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), w_ = 64 * 1024, t0 = PS && TS(() => le.isReadableStream(new Response("").body)), xp = {
  stream: t0 && ((e) => e.body)
};
zh && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !xp[t] && (xp[t] = le.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new nt(`Response type '${t}' is not supported`, nt.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const mre = async (e) => {
  if (e == null)
    return 0;
  if (le.isBlob(e))
    return e.size;
  if (le.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (le.isArrayBufferView(e) || le.isArrayBuffer(e))
    return e.byteLength;
  if (le.isURLSearchParams(e) && (e = e + ""), le.isString(e))
    return (await e0(e)).byteLength;
}, fre = async (e, t) => le.toFiniteNumber(e.getContentLength()) ?? mre(t), gre = zh && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: a,
    cancelToken: o,
    timeout: i,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: p
  } = ES(e);
  c = c ? (c + "").toLowerCase() : "text";
  let [h, m] = a || o || i ? ure([a, o], i) : [], f, g;
  const _ = () => {
    !f && setTimeout(() => {
      h && h.unsubscribe();
    }), f = !0;
  };
  let v;
  try {
    if (l && hre && n !== "get" && n !== "head" && (v = await fre(u, r)) !== 0) {
      let C = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), E;
      if (le.isFormData(r) && (E = C.headers.get("content-type")) && u.setContentType(E), C.body) {
        const [A, O] = y_(
          v,
          Cp(v_(l))
        );
        r = __(C.body, w_, A, O, e0);
      }
    }
    le.isString(d) || (d = d ? "include" : "omit"), g = new Request(t, {
      ...p,
      signal: h,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: d
    });
    let w = await fetch(g);
    const x = t0 && (c === "stream" || c === "response");
    if (t0 && (s || x)) {
      const C = {};
      ["status", "statusText", "headers"].forEach((M) => {
        C[M] = w[M];
      });
      const E = le.toFiniteNumber(w.headers.get("content-length")), [A, O] = s && y_(
        E,
        Cp(v_(s), !0)
      ) || [];
      w = new Response(
        __(w.body, w_, A, () => {
          O && O(), x && _();
        }, e0),
        C
      );
    }
    c = c || "text";
    let b = await xp[le.findKey(xp, c) || "text"](w, e);
    return !x && _(), m && m(), await new Promise((C, E) => {
      xS(C, E, {
        data: b,
        headers: _n.from(w.headers),
        status: w.status,
        statusText: w.statusText,
        config: e,
        request: g
      });
    });
  } catch (w) {
    throw _(), w && w.name === "TypeError" && /fetch/i.test(w.message) ? Object.assign(
      new nt("Network Error", nt.ERR_NETWORK, e, g),
      {
        cause: w.cause || w
      }
    ) : nt.from(w, w && w.code, e, g);
  }
}), r0 = {
  http: Lte,
  xhr: cre,
  fetch: gre
};
le.forEach(r0, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const S_ = (e) => `- ${e}`, yre = (e) => le.isFunction(e) || e === null || e === !1, MS = {
  getAdapter: (e) => {
    e = le.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const a = {};
    for (let o = 0; o < t; o++) {
      n = e[o];
      let i;
      if (r = n, !yre(n) && (r = r0[(i = String(n)).toLowerCase()], r === void 0))
        throw new nt(`Unknown adapter '${i}'`);
      if (r)
        break;
      a[i || "#" + o] = r;
    }
    if (!r) {
      const o = Object.entries(a).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? o.length > 1 ? `since :
` + o.map(S_).join(`
`) : " " + S_(o[0]) : "as no adapter specified";
      throw new nt(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: r0
};
function o1(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new wl(null, e);
}
function C_(e) {
  return o1(e), e.headers = _n.from(e.headers), e.data = a1.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), MS.getAdapter(e.adapter || Tu.adapter)(e).then(function(t) {
    return o1(e), t.data = a1.call(
      e,
      e.transformResponse,
      t
    ), t.headers = _n.from(t.headers), t;
  }, function(t) {
    return CS(t) || (o1(e), t && t.response && (t.response.data = a1.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = _n.from(t.response.headers))), Promise.reject(t);
  });
}
const OS = "1.7.4", gy = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  gy[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const x_ = {};
gy.transitional = function(e, t, n) {
  function r(a, o) {
    return "[Axios v" + OS + "] Transitional option '" + a + "'" + o + (n ? ". " + n : "");
  }
  return (a, o, i) => {
    if (e === !1)
      throw new nt(
        r(o, " has been removed" + (t ? " in " + t : "")),
        nt.ERR_DEPRECATED
      );
    return t && !x_[o] && (x_[o] = !0, console.warn(
      r(
        o,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(a, o, i) : !0;
  };
};
function vre(e, t, n) {
  if (typeof e != "object")
    throw new nt("options must be an object", nt.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let a = r.length;
  for (; a-- > 0; ) {
    const o = r[a], i = t[o];
    if (i) {
      const s = e[o], l = s === void 0 || i(s, o, e);
      if (l !== !0)
        throw new nt("option " + o + " must be " + l, nt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new nt("Unknown option " + o, nt.ERR_BAD_OPTION);
  }
}
const n0 = {
  assertOptions: vre,
  validators: gy
}, Ao = n0.validators;
class Ki {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new f_(),
      response: new f_()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let a;
        Error.captureStackTrace ? Error.captureStackTrace(a = {}) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? o && !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + o) : r.stack = o;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Xi(this.defaults, n);
    const { transitional: r, paramsSerializer: a, headers: o } = n;
    r !== void 0 && n0.assertOptions(r, {
      silentJSONParsing: Ao.transitional(Ao.boolean),
      forcedJSONParsing: Ao.transitional(Ao.boolean),
      clarifyTimeoutError: Ao.transitional(Ao.boolean)
    }, !1), a != null && (le.isFunction(a) ? n.paramsSerializer = {
      serialize: a
    } : n0.assertOptions(a, {
      encode: Ao.function,
      serialize: Ao.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = o && le.merge(
      o.common,
      o[n.method]
    );
    o && le.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete o[m];
      }
    ), n.headers = _n.concat(i, o);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(n) === !1 || (l = l && m.synchronous, s.unshift(m.fulfilled, m.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(m) {
      c.push(m.fulfilled, m.rejected);
    });
    let u, d = 0, p;
    if (!l) {
      const m = [C_.bind(this), void 0];
      for (m.unshift.apply(m, s), m.push.apply(m, c), p = m.length, u = Promise.resolve(n); d < p; )
        u = u.then(m[d++], m[d++]);
      return u;
    }
    p = s.length;
    let h = n;
    for (d = 0; d < p; ) {
      const m = s[d++], f = s[d++];
      try {
        h = m(h);
      } catch (g) {
        f.call(this, g);
        break;
      }
    }
    try {
      u = C_.call(this, h);
    } catch (m) {
      return Promise.reject(m);
    }
    for (d = 0, p = c.length; d < p; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = Xi(this.defaults, t);
    const n = kS(t.baseURL, t.url);
    return _S(n, t.params, t.paramsSerializer);
  }
}
le.forEach(["delete", "get", "head", "options"], function(e) {
  Ki.prototype[e] = function(t, n) {
    return this.request(Xi(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
le.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(r, a, o) {
      return this.request(Xi(o || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: r,
        data: a
      }));
    };
  }
  Ki.prototype[e] = t(), Ki.prototype[e + "Form"] = t(!0);
});
class yy {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    const r = this;
    this.promise.then((a) => {
      if (!r._listeners)
        return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](a);
      r._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const i = new Promise((s) => {
        r.subscribe(s), o = s;
      }).then(a);
      return i.cancel = function() {
        r.unsubscribe(o);
      }, i;
    }, t(function(a, o, i) {
      r.reason || (r.reason = new wl(a, o, i), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new yy(function(n) {
        t = n;
      }),
      cancel: t
    };
  }
}
function bre(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function _re(e) {
  return le.isObject(e) && e.isAxiosError === !0;
}
const a0 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(a0).forEach(([e, t]) => {
  a0[t] = e;
});
function AS(e) {
  const t = new Ki(e), n = lS(Ki.prototype.request, t);
  return le.extend(n, Ki.prototype, t, { allOwnKeys: !0 }), le.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(r) {
    return AS(Xi(e, r));
  }, n;
}
const Nr = AS(Tu);
Nr.Axios = Ki;
Nr.CanceledError = wl;
Nr.CancelToken = yy;
Nr.isCancel = CS;
Nr.VERSION = OS;
Nr.toFormData = Fh;
Nr.AxiosError = nt;
Nr.Cancel = Nr.CanceledError;
Nr.all = function(e) {
  return Promise.all(e);
};
Nr.spread = bre;
Nr.isAxiosError = _re;
Nr.mergeConfig = Xi;
Nr.AxiosHeaders = _n;
Nr.formToJSON = (e) => SS(le.isHTMLForm(e) ? new FormData(e) : e);
Nr.getAdapter = MS.getAdapter;
Nr.HttpStatusCode = a0;
Nr.default = Nr;
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function k_(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function NS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? k_(Object(n), !0).forEach(function(r) {
      xre(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : k_(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function wre(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function LS(e) {
  var t = wre(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function o0(e) {
  "@babel/helpers - typeof";
  return o0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, o0(e);
}
function Sre(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function E_(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, LS(r.key), r);
  }
}
function Cre(e, t, n) {
  return t && E_(e.prototype, t), n && E_(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function xre(e, t, n) {
  return t = LS(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function RS(e) {
  return kre(e) || Ere(e) || Pre(e) || Tre();
}
function kre(e) {
  if (Array.isArray(e))
    return i0(e);
}
function Ere(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Pre(e, t) {
  if (e) {
    if (typeof e == "string")
      return i0(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return i0(e, t);
  }
}
function i0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Tre() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Gh = typeof window < "u" && typeof window.document < "u", Xa = Gh ? window : {}, vy = Gh && Xa.document.documentElement ? "ontouchstart" in Xa.document.documentElement : !1, by = Gh ? "PointerEvent" in Xa : !1, ar = "cropper", _y = "all", DS = "crop", IS = "move", jS = "zoom", _i = "e", wi = "w", bs = "s", No = "n", ac = "ne", oc = "nw", ic = "se", sc = "sw", s0 = "".concat(ar, "-crop"), P_ = "".concat(ar, "-disabled"), fn = "".concat(ar, "-hidden"), T_ = "".concat(ar, "-hide"), Mre = "".concat(ar, "-invisible"), kp = "".concat(ar, "-modal"), l0 = "".concat(ar, "-move"), Yc = "".concat(ar, "Action"), td = "".concat(ar, "Preview"), wy = "crop", BS = "move", FS = "none", c0 = "crop", u0 = "cropend", d0 = "cropmove", p0 = "cropstart", M_ = "dblclick", Ore = vy ? "touchstart" : "mousedown", Are = vy ? "touchmove" : "mousemove", Nre = vy ? "touchend touchcancel" : "mouseup", O_ = by ? "pointerdown" : Ore, A_ = by ? "pointermove" : Are, N_ = by ? "pointerup pointercancel" : Nre, L_ = "ready", R_ = "resize", D_ = "wheel", h0 = "zoom", I_ = "image/jpeg", Lre = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, Rre = /^data:/, Dre = /^data:image\/jpeg;base64,/, Ire = /^img|canvas$/i, zS = 200, GS = 100, j_ = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: wy,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: zS,
  minContainerHeight: GS,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, jre = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', Bre = Number.isNaN || Xa.isNaN;
function gt(e) {
  return typeof e == "number" && !Bre(e);
}
var B_ = function(e) {
  return e > 0 && e < 1 / 0;
};
function i1(e) {
  return typeof e > "u";
}
function Qi(e) {
  return o0(e) === "object" && e !== null;
}
var Fre = Object.prototype.hasOwnProperty;
function Es(e) {
  if (!Qi(e))
    return !1;
  try {
    var t = e.constructor, n = t.prototype;
    return t && n && Fre.call(n, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function hn(e) {
  return typeof e == "function";
}
var zre = Array.prototype.slice;
function HS(e) {
  return Array.from ? Array.from(e) : zre.call(e);
}
function Cr(e, t) {
  return e && hn(t) && (Array.isArray(e) || gt(e.length) ? HS(e).forEach(function(n, r) {
    t.call(e, n, r, e);
  }) : Qi(e) && Object.keys(e).forEach(function(n) {
    t.call(e, e[n], n, e);
  })), e;
}
var or = Object.assign || function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return Qi(e) && n.length > 0 && n.forEach(function(a) {
    Qi(a) && Object.keys(a).forEach(function(o) {
      e[o] = a[o];
    });
  }), e;
}, Gre = /\.\d*(?:0|9){12}\d*$/;
function Rs(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return Gre.test(e) ? Math.round(e * t) / t : e;
}
var Hre = /^width|height|left|top|marginLeft|marginTop$/;
function zo(e, t) {
  var n = e.style;
  Cr(t, function(r, a) {
    Hre.test(a) && gt(r) && (r = "".concat(r, "px")), n[a] = r;
  });
}
function Kre(e, t) {
  return e.classList ? e.classList.contains(t) : e.className.indexOf(t) > -1;
}
function Dr(e, t) {
  if (t) {
    if (gt(e.length)) {
      Cr(e, function(r) {
        Dr(r, t);
      });
      return;
    }
    if (e.classList) {
      e.classList.add(t);
      return;
    }
    var n = e.className.trim();
    n ? n.indexOf(t) < 0 && (e.className = "".concat(n, " ").concat(t)) : e.className = t;
  }
}
function Ya(e, t) {
  if (t) {
    if (gt(e.length)) {
      Cr(e, function(n) {
        Ya(n, t);
      });
      return;
    }
    if (e.classList) {
      e.classList.remove(t);
      return;
    }
    e.className.indexOf(t) >= 0 && (e.className = e.className.replace(t, ""));
  }
}
function Ps(e, t, n) {
  if (t) {
    if (gt(e.length)) {
      Cr(e, function(r) {
        Ps(r, t, n);
      });
      return;
    }
    n ? Dr(e, t) : Ya(e, t);
  }
}
var Ure = /([a-z\d])([A-Z])/g;
function Sy(e) {
  return e.replace(Ure, "$1-$2").toLowerCase();
}
function m0(e, t) {
  return Qi(e[t]) ? e[t] : e.dataset ? e.dataset[t] : e.getAttribute("data-".concat(Sy(t)));
}
function Zc(e, t, n) {
  Qi(n) ? e[t] = n : e.dataset ? e.dataset[t] = n : e.setAttribute("data-".concat(Sy(t)), n);
}
function $re(e, t) {
  if (Qi(e[t]))
    try {
      delete e[t];
    } catch {
      e[t] = void 0;
    }
  else if (e.dataset)
    try {
      delete e.dataset[t];
    } catch {
      e.dataset[t] = void 0;
    }
  else
    e.removeAttribute("data-".concat(Sy(t)));
}
var KS = /\s\s*/, US = function() {
  var e = !1;
  if (Gh) {
    var t = !1, n = function() {
    }, r = Object.defineProperty({}, "once", {
      get: function() {
        return e = !0, t;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(a) {
        t = a;
      }
    });
    Xa.addEventListener("test", n, r), Xa.removeEventListener("test", n, r);
  }
  return e;
}();
function la(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = n;
  t.trim().split(KS).forEach(function(o) {
    if (!US) {
      var i = e.listeners;
      i && i[o] && i[o][n] && (a = i[o][n], delete i[o][n], Object.keys(i[o]).length === 0 && delete i[o], Object.keys(i).length === 0 && delete e.listeners);
    }
    e.removeEventListener(o, a, r);
  });
}
function Bn(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = n;
  t.trim().split(KS).forEach(function(o) {
    if (r.once && !US) {
      var i = e.listeners, s = i === void 0 ? {} : i;
      a = function() {
        delete s[o][n], e.removeEventListener(o, a, r);
        for (var l = arguments.length, c = new Array(l), u = 0; u < l; u++)
          c[u] = arguments[u];
        n.apply(e, c);
      }, s[o] || (s[o] = {}), s[o][n] && e.removeEventListener(o, s[o][n], r), s[o][n] = a, e.listeners = s;
    }
    e.addEventListener(o, a, r);
  });
}
function Ds(e, t, n) {
  var r;
  return hn(Event) && hn(CustomEvent) ? r = new CustomEvent(t, {
    detail: n,
    bubbles: !0,
    cancelable: !0
  }) : (r = document.createEvent("CustomEvent"), r.initCustomEvent(t, !0, !0, n)), e.dispatchEvent(r);
}
function $S(e) {
  var t = e.getBoundingClientRect();
  return {
    left: t.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: t.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var s1 = Xa.location, Vre = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function F_(e) {
  var t = e.match(Vre);
  return t !== null && (t[1] !== s1.protocol || t[2] !== s1.hostname || t[3] !== s1.port);
}
function z_(e) {
  var t = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return e + (e.indexOf("?") === -1 ? "?" : "&") + t;
}
function wc(e) {
  var t = e.rotate, n = e.scaleX, r = e.scaleY, a = e.translateX, o = e.translateY, i = [];
  gt(a) && a !== 0 && i.push("translateX(".concat(a, "px)")), gt(o) && o !== 0 && i.push("translateY(".concat(o, "px)")), gt(t) && t !== 0 && i.push("rotate(".concat(t, "deg)")), gt(n) && n !== 1 && i.push("scaleX(".concat(n, ")")), gt(r) && r !== 1 && i.push("scaleY(".concat(r, ")"));
  var s = i.length ? i.join(" ") : "none";
  return {
    WebkitTransform: s,
    msTransform: s,
    transform: s
  };
}
function Wre(e) {
  var t = NS({}, e), n = 0;
  return Cr(e, function(r, a) {
    delete t[a], Cr(t, function(o) {
      var i = Math.abs(r.startX - o.startX), s = Math.abs(r.startY - o.startY), l = Math.abs(r.endX - o.endX), c = Math.abs(r.endY - o.endY), u = Math.sqrt(i * i + s * s), d = Math.sqrt(l * l + c * c), p = (d - u) / u;
      Math.abs(p) > Math.abs(n) && (n = p);
    });
  }), n;
}
function rd(e, t) {
  var n = e.pageX, r = e.pageY, a = {
    endX: n,
    endY: r
  };
  return t ? a : NS({
    startX: n,
    startY: r
  }, a);
}
function Yre(e) {
  var t = 0, n = 0, r = 0;
  return Cr(e, function(a) {
    var o = a.startX, i = a.startY;
    t += o, n += i, r += 1;
  }), t /= r, n /= r, {
    pageX: t,
    pageY: n
  };
}
function Go(e) {
  var t = e.aspectRatio, n = e.height, r = e.width, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", o = B_(r), i = B_(n);
  if (o && i) {
    var s = n * t;
    a === "contain" && s > r || a === "cover" && s < r ? n = r / t : r = n * t;
  } else
    o ? n = r / t : i && (r = n * t);
  return {
    width: r,
    height: n
  };
}
function Zre(e) {
  var t = e.width, n = e.height, r = e.degree;
  if (r = Math.abs(r) % 180, r === 90)
    return {
      width: n,
      height: t
    };
  var a = r % 90 * Math.PI / 180, o = Math.sin(a), i = Math.cos(a), s = t * i + n * o, l = t * o + n * i;
  return r > 90 ? {
    width: l,
    height: s
  } : {
    width: s,
    height: l
  };
}
function qre(e, t, n, r) {
  var a = t.aspectRatio, o = t.naturalWidth, i = t.naturalHeight, s = t.rotate, l = s === void 0 ? 0 : s, c = t.scaleX, u = c === void 0 ? 1 : c, d = t.scaleY, p = d === void 0 ? 1 : d, h = n.aspectRatio, m = n.naturalWidth, f = n.naturalHeight, g = r.fillColor, _ = g === void 0 ? "transparent" : g, v = r.imageSmoothingEnabled, w = v === void 0 ? !0 : v, x = r.imageSmoothingQuality, b = x === void 0 ? "low" : x, C = r.maxWidth, E = C === void 0 ? 1 / 0 : C, A = r.maxHeight, O = A === void 0 ? 1 / 0 : A, M = r.minWidth, I = M === void 0 ? 0 : M, D = r.minHeight, K = D === void 0 ? 0 : D, G = document.createElement("canvas"), V = G.getContext("2d"), ee = Go({
    aspectRatio: h,
    width: E,
    height: O
  }), U = Go({
    aspectRatio: h,
    width: I,
    height: K
  }, "cover"), H = Math.min(ee.width, Math.max(U.width, m)), W = Math.min(ee.height, Math.max(U.height, f)), L = Go({
    aspectRatio: a,
    width: E,
    height: O
  }), T = Go({
    aspectRatio: a,
    width: I,
    height: K
  }, "cover"), B = Math.min(L.width, Math.max(T.width, o)), N = Math.min(L.height, Math.max(T.height, i)), Y = [-B / 2, -N / 2, B, N];
  return G.width = Rs(H), G.height = Rs(W), V.fillStyle = _, V.fillRect(0, 0, H, W), V.save(), V.translate(H / 2, W / 2), V.rotate(l * Math.PI / 180), V.scale(u, p), V.imageSmoothingEnabled = w, V.imageSmoothingQuality = b, V.drawImage.apply(V, [e].concat(RS(Y.map(function(Q) {
    return Math.floor(Rs(Q));
  })))), V.restore(), G;
}
var VS = String.fromCharCode;
function Jre(e, t, n) {
  var r = "";
  n += t;
  for (var a = t; a < n; a += 1)
    r += VS(e.getUint8(a));
  return r;
}
var Xre = /^data:.*,/;
function Qre(e) {
  var t = e.replace(Xre, ""), n = atob(t), r = new ArrayBuffer(n.length), a = new Uint8Array(r);
  return Cr(a, function(o, i) {
    a[i] = n.charCodeAt(i);
  }), r;
}
function ene(e, t) {
  for (var n = [], r = 8192, a = new Uint8Array(e); a.length > 0; )
    n.push(VS.apply(null, HS(a.subarray(0, r)))), a = a.subarray(r);
  return "data:".concat(t, ";base64,").concat(btoa(n.join("")));
}
function tne(e) {
  var t = new DataView(e), n;
  try {
    var r, a, o;
    if (t.getUint8(0) === 255 && t.getUint8(1) === 216)
      for (var i = t.byteLength, s = 2; s + 1 < i; ) {
        if (t.getUint8(s) === 255 && t.getUint8(s + 1) === 225) {
          a = s;
          break;
        }
        s += 1;
      }
    if (a) {
      var l = a + 4, c = a + 10;
      if (Jre(t, l, 4) === "Exif") {
        var u = t.getUint16(c);
        if (r = u === 18761, (r || u === 19789) && t.getUint16(c + 2, r) === 42) {
          var d = t.getUint32(c + 4, r);
          d >= 8 && (o = c + d);
        }
      }
    }
    if (o) {
      var p = t.getUint16(o, r), h, m;
      for (m = 0; m < p; m += 1)
        if (h = o + m * 12 + 2, t.getUint16(h, r) === 274) {
          h += 8, n = t.getUint16(h, r), t.setUint16(h, 1, r);
          break;
        }
    }
  } catch {
    n = 1;
  }
  return n;
}
function rne(e) {
  var t = 0, n = 1, r = 1;
  switch (e) {
    case 2:
      n = -1;
      break;
    case 3:
      t = -180;
      break;
    case 4:
      r = -1;
      break;
    case 5:
      t = 90, r = -1;
      break;
    case 6:
      t = 90;
      break;
    case 7:
      t = 90, n = -1;
      break;
    case 8:
      t = -90;
      break;
  }
  return {
    rotate: t,
    scaleX: n,
    scaleY: r
  };
}
var nne = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var e = this.element, t = this.options, n = this.container, r = this.cropper, a = Number(t.minContainerWidth), o = Number(t.minContainerHeight);
    Dr(r, fn), Ya(e, fn);
    var i = {
      width: Math.max(n.offsetWidth, a >= 0 ? a : zS),
      height: Math.max(n.offsetHeight, o >= 0 ? o : GS)
    };
    this.containerData = i, zo(r, {
      width: i.width,
      height: i.height
    }), Dr(e, fn), Ya(r, fn);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var e = this.containerData, t = this.imageData, n = this.options.viewMode, r = Math.abs(t.rotate) % 180 === 90, a = r ? t.naturalHeight : t.naturalWidth, o = r ? t.naturalWidth : t.naturalHeight, i = a / o, s = e.width, l = e.height;
    e.height * i > e.width ? n === 3 ? s = e.height * i : l = e.width / i : n === 3 ? l = e.width / i : s = e.height * i;
    var c = {
      aspectRatio: i,
      naturalWidth: a,
      naturalHeight: o,
      width: s,
      height: l
    };
    this.canvasData = c, this.limited = n === 1 || n === 2, this.limitCanvas(!0, !0), c.width = Math.min(Math.max(c.width, c.minWidth), c.maxWidth), c.height = Math.min(Math.max(c.height, c.minHeight), c.maxHeight), c.left = (e.width - c.width) / 2, c.top = (e.height - c.height) / 2, c.oldLeft = c.left, c.oldTop = c.top, this.initialCanvasData = or({}, c);
  },
  limitCanvas: function(e, t) {
    var n = this.options, r = this.containerData, a = this.canvasData, o = this.cropBoxData, i = n.viewMode, s = a.aspectRatio, l = this.cropped && o;
    if (e) {
      var c = Number(n.minCanvasWidth) || 0, u = Number(n.minCanvasHeight) || 0;
      i > 1 ? (c = Math.max(c, r.width), u = Math.max(u, r.height), i === 3 && (u * s > c ? c = u * s : u = c / s)) : i > 0 && (c ? c = Math.max(c, l ? o.width : 0) : u ? u = Math.max(u, l ? o.height : 0) : l && (c = o.width, u = o.height, u * s > c ? c = u * s : u = c / s));
      var d = Go({
        aspectRatio: s,
        width: c,
        height: u
      });
      c = d.width, u = d.height, a.minWidth = c, a.minHeight = u, a.maxWidth = 1 / 0, a.maxHeight = 1 / 0;
    }
    if (t)
      if (i > (l ? 0 : 1)) {
        var p = r.width - a.width, h = r.height - a.height;
        a.minLeft = Math.min(0, p), a.minTop = Math.min(0, h), a.maxLeft = Math.max(0, p), a.maxTop = Math.max(0, h), l && this.limited && (a.minLeft = Math.min(o.left, o.left + (o.width - a.width)), a.minTop = Math.min(o.top, o.top + (o.height - a.height)), a.maxLeft = o.left, a.maxTop = o.top, i === 2 && (a.width >= r.width && (a.minLeft = Math.min(0, p), a.maxLeft = Math.max(0, p)), a.height >= r.height && (a.minTop = Math.min(0, h), a.maxTop = Math.max(0, h))));
      } else
        a.minLeft = -a.width, a.minTop = -a.height, a.maxLeft = r.width, a.maxTop = r.height;
  },
  renderCanvas: function(e, t) {
    var n = this.canvasData, r = this.imageData;
    if (t) {
      var a = Zre({
        width: r.naturalWidth * Math.abs(r.scaleX || 1),
        height: r.naturalHeight * Math.abs(r.scaleY || 1),
        degree: r.rotate || 0
      }), o = a.width, i = a.height, s = n.width * (o / n.naturalWidth), l = n.height * (i / n.naturalHeight);
      n.left -= (s - n.width) / 2, n.top -= (l - n.height) / 2, n.width = s, n.height = l, n.aspectRatio = o / i, n.naturalWidth = o, n.naturalHeight = i, this.limitCanvas(!0, !1);
    }
    (n.width > n.maxWidth || n.width < n.minWidth) && (n.left = n.oldLeft), (n.height > n.maxHeight || n.height < n.minHeight) && (n.top = n.oldTop), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), this.limitCanvas(!1, !0), n.left = Math.min(Math.max(n.left, n.minLeft), n.maxLeft), n.top = Math.min(Math.max(n.top, n.minTop), n.maxTop), n.oldLeft = n.left, n.oldTop = n.top, zo(this.canvas, or({
      width: n.width,
      height: n.height
    }, wc({
      translateX: n.left,
      translateY: n.top
    }))), this.renderImage(e), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(e) {
    var t = this.canvasData, n = this.imageData, r = n.naturalWidth * (t.width / t.naturalWidth), a = n.naturalHeight * (t.height / t.naturalHeight);
    or(n, {
      width: r,
      height: a,
      left: (t.width - r) / 2,
      top: (t.height - a) / 2
    }), zo(this.image, or({
      width: n.width,
      height: n.height
    }, wc(or({
      translateX: n.left,
      translateY: n.top
    }, n)))), e && this.output();
  },
  initCropBox: function() {
    var e = this.options, t = this.canvasData, n = e.aspectRatio || e.initialAspectRatio, r = Number(e.autoCropArea) || 0.8, a = {
      width: t.width,
      height: t.height
    };
    n && (t.height * n > t.width ? a.height = a.width / n : a.width = a.height * n), this.cropBoxData = a, this.limitCropBox(!0, !0), a.width = Math.min(Math.max(a.width, a.minWidth), a.maxWidth), a.height = Math.min(Math.max(a.height, a.minHeight), a.maxHeight), a.width = Math.max(a.minWidth, a.width * r), a.height = Math.max(a.minHeight, a.height * r), a.left = t.left + (t.width - a.width) / 2, a.top = t.top + (t.height - a.height) / 2, a.oldLeft = a.left, a.oldTop = a.top, this.initialCropBoxData = or({}, a);
  },
  limitCropBox: function(e, t) {
    var n = this.options, r = this.containerData, a = this.canvasData, o = this.cropBoxData, i = this.limited, s = n.aspectRatio;
    if (e) {
      var l = Number(n.minCropBoxWidth) || 0, c = Number(n.minCropBoxHeight) || 0, u = i ? Math.min(r.width, a.width, a.width + a.left, r.width - a.left) : r.width, d = i ? Math.min(r.height, a.height, a.height + a.top, r.height - a.top) : r.height;
      l = Math.min(l, r.width), c = Math.min(c, r.height), s && (l && c ? c * s > l ? c = l / s : l = c * s : l ? c = l / s : c && (l = c * s), d * s > u ? d = u / s : u = d * s), o.minWidth = Math.min(l, u), o.minHeight = Math.min(c, d), o.maxWidth = u, o.maxHeight = d;
    }
    t && (i ? (o.minLeft = Math.max(0, a.left), o.minTop = Math.max(0, a.top), o.maxLeft = Math.min(r.width, a.left + a.width) - o.width, o.maxTop = Math.min(r.height, a.top + a.height) - o.height) : (o.minLeft = 0, o.minTop = 0, o.maxLeft = r.width - o.width, o.maxTop = r.height - o.height));
  },
  renderCropBox: function() {
    var e = this.options, t = this.containerData, n = this.cropBoxData;
    (n.width > n.maxWidth || n.width < n.minWidth) && (n.left = n.oldLeft), (n.height > n.maxHeight || n.height < n.minHeight) && (n.top = n.oldTop), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), this.limitCropBox(!1, !0), n.left = Math.min(Math.max(n.left, n.minLeft), n.maxLeft), n.top = Math.min(Math.max(n.top, n.minTop), n.maxTop), n.oldLeft = n.left, n.oldTop = n.top, e.movable && e.cropBoxMovable && Zc(this.face, Yc, n.width >= t.width && n.height >= t.height ? IS : _y), zo(this.cropBox, or({
      width: n.width,
      height: n.height
    }, wc({
      translateX: n.left,
      translateY: n.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), Ds(this.element, c0, this.getData());
  }
}, ane = {
  initPreview: function() {
    var e = this.element, t = this.crossOrigin, n = this.options.preview, r = t ? this.crossOriginUrl : this.url, a = e.alt || "The image to preview", o = document.createElement("img");
    if (t && (o.crossOrigin = t), o.src = r, o.alt = a, this.viewBox.appendChild(o), this.viewBoxImage = o, !!n) {
      var i = n;
      typeof n == "string" ? i = e.ownerDocument.querySelectorAll(n) : n.querySelector && (i = [n]), this.previews = i, Cr(i, function(s) {
        var l = document.createElement("img");
        Zc(s, td, {
          width: s.offsetWidth,
          height: s.offsetHeight,
          html: s.innerHTML
        }), t && (l.crossOrigin = t), l.src = r, l.alt = a, l.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', s.innerHTML = "", s.appendChild(l);
      });
    }
  },
  resetPreview: function() {
    Cr(this.previews, function(e) {
      var t = m0(e, td);
      zo(e, {
        width: t.width,
        height: t.height
      }), e.innerHTML = t.html, $re(e, td);
    });
  },
  preview: function() {
    var e = this.imageData, t = this.canvasData, n = this.cropBoxData, r = n.width, a = n.height, o = e.width, i = e.height, s = n.left - t.left - e.left, l = n.top - t.top - e.top;
    !this.cropped || this.disabled || (zo(this.viewBoxImage, or({
      width: o,
      height: i
    }, wc(or({
      translateX: -s,
      translateY: -l
    }, e)))), Cr(this.previews, function(c) {
      var u = m0(c, td), d = u.width, p = u.height, h = d, m = p, f = 1;
      r && (f = d / r, m = a * f), a && m > p && (f = p / a, h = r * f, m = p), zo(c, {
        width: h,
        height: m
      }), zo(c.getElementsByTagName("img")[0], or({
        width: o * f,
        height: i * f
      }, wc(or({
        translateX: -s * f,
        translateY: -l * f
      }, e))));
    }));
  }
}, one = {
  bind: function() {
    var e = this.element, t = this.options, n = this.cropper;
    hn(t.cropstart) && Bn(e, p0, t.cropstart), hn(t.cropmove) && Bn(e, d0, t.cropmove), hn(t.cropend) && Bn(e, u0, t.cropend), hn(t.crop) && Bn(e, c0, t.crop), hn(t.zoom) && Bn(e, h0, t.zoom), Bn(n, O_, this.onCropStart = this.cropStart.bind(this)), t.zoomable && t.zoomOnWheel && Bn(n, D_, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && Bn(n, M_, this.onDblclick = this.dblclick.bind(this)), Bn(e.ownerDocument, A_, this.onCropMove = this.cropMove.bind(this)), Bn(e.ownerDocument, N_, this.onCropEnd = this.cropEnd.bind(this)), t.responsive && Bn(window, R_, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var e = this.element, t = this.options, n = this.cropper;
    hn(t.cropstart) && la(e, p0, t.cropstart), hn(t.cropmove) && la(e, d0, t.cropmove), hn(t.cropend) && la(e, u0, t.cropend), hn(t.crop) && la(e, c0, t.crop), hn(t.zoom) && la(e, h0, t.zoom), la(n, O_, this.onCropStart), t.zoomable && t.zoomOnWheel && la(n, D_, this.onWheel, {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && la(n, M_, this.onDblclick), la(e.ownerDocument, A_, this.onCropMove), la(e.ownerDocument, N_, this.onCropEnd), t.responsive && la(window, R_, this.onResize);
  }
}, ine = {
  resize: function() {
    if (!this.disabled) {
      var e = this.options, t = this.container, n = this.containerData, r = t.offsetWidth / n.width, a = t.offsetHeight / n.height, o = Math.abs(r - 1) > Math.abs(a - 1) ? r : a;
      if (o !== 1) {
        var i, s;
        e.restore && (i = this.getCanvasData(), s = this.getCropBoxData()), this.render(), e.restore && (this.setCanvasData(Cr(i, function(l, c) {
          i[c] = l * o;
        })), this.setCropBoxData(Cr(s, function(l, c) {
          s[c] = l * o;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === FS || this.setDragMode(Kre(this.dragBox, s0) ? BS : wy);
  },
  wheel: function(e) {
    var t = this, n = Number(this.options.wheelZoomRatio) || 0.1, r = 1;
    this.disabled || (e.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      t.wheeling = !1;
    }, 50), e.deltaY ? r = e.deltaY > 0 ? 1 : -1 : e.wheelDelta ? r = -e.wheelDelta / 120 : e.detail && (r = e.detail > 0 ? 1 : -1), this.zoom(-r * n, e)));
  },
  cropStart: function(e) {
    var t = e.buttons, n = e.button;
    if (!(this.disabled || (e.type === "mousedown" || e.type === "pointerdown" && e.pointerType === "mouse") && // No primary button (Usually the left button)
    (gt(t) && t !== 1 || gt(n) && n !== 0 || e.ctrlKey))) {
      var r = this.options, a = this.pointers, o;
      e.changedTouches ? Cr(e.changedTouches, function(i) {
        a[i.identifier] = rd(i);
      }) : a[e.pointerId || 0] = rd(e), Object.keys(a).length > 1 && r.zoomable && r.zoomOnTouch ? o = jS : o = m0(e.target, Yc), Lre.test(o) && Ds(this.element, p0, {
        originalEvent: e,
        action: o
      }) !== !1 && (e.preventDefault(), this.action = o, this.cropping = !1, o === DS && (this.cropping = !0, Dr(this.dragBox, kp)));
    }
  },
  cropMove: function(e) {
    var t = this.action;
    if (!(this.disabled || !t)) {
      var n = this.pointers;
      e.preventDefault(), Ds(this.element, d0, {
        originalEvent: e,
        action: t
      }) !== !1 && (e.changedTouches ? Cr(e.changedTouches, function(r) {
        or(n[r.identifier] || {}, rd(r, !0));
      }) : or(n[e.pointerId || 0] || {}, rd(e, !0)), this.change(e));
    }
  },
  cropEnd: function(e) {
    if (!this.disabled) {
      var t = this.action, n = this.pointers;
      e.changedTouches ? Cr(e.changedTouches, function(r) {
        delete n[r.identifier];
      }) : delete n[e.pointerId || 0], t && (e.preventDefault(), Object.keys(n).length || (this.action = ""), this.cropping && (this.cropping = !1, Ps(this.dragBox, kp, this.cropped && this.options.modal)), Ds(this.element, u0, {
        originalEvent: e,
        action: t
      }));
    }
  }
}, sne = {
  change: function(e) {
    var t = this.options, n = this.canvasData, r = this.containerData, a = this.cropBoxData, o = this.pointers, i = this.action, s = t.aspectRatio, l = a.left, c = a.top, u = a.width, d = a.height, p = l + u, h = c + d, m = 0, f = 0, g = r.width, _ = r.height, v = !0, w;
    !s && e.shiftKey && (s = u && d ? u / d : 1), this.limited && (m = a.minLeft, f = a.minTop, g = m + Math.min(r.width, n.width, n.left + n.width), _ = f + Math.min(r.height, n.height, n.top + n.height));
    var x = o[Object.keys(o)[0]], b = {
      x: x.endX - x.startX,
      y: x.endY - x.startY
    }, C = function(E) {
      switch (E) {
        case _i:
          p + b.x > g && (b.x = g - p);
          break;
        case wi:
          l + b.x < m && (b.x = m - l);
          break;
        case No:
          c + b.y < f && (b.y = f - c);
          break;
        case bs:
          h + b.y > _ && (b.y = _ - h);
          break;
      }
    };
    switch (i) {
      case _y:
        l += b.x, c += b.y;
        break;
      case _i:
        if (b.x >= 0 && (p >= g || s && (c <= f || h >= _))) {
          v = !1;
          break;
        }
        C(_i), u += b.x, u < 0 && (i = wi, u = -u, l -= u), s && (d = u / s, c += (a.height - d) / 2);
        break;
      case No:
        if (b.y <= 0 && (c <= f || s && (l <= m || p >= g))) {
          v = !1;
          break;
        }
        C(No), d -= b.y, c += b.y, d < 0 && (i = bs, d = -d, c -= d), s && (u = d * s, l += (a.width - u) / 2);
        break;
      case wi:
        if (b.x <= 0 && (l <= m || s && (c <= f || h >= _))) {
          v = !1;
          break;
        }
        C(wi), u -= b.x, l += b.x, u < 0 && (i = _i, u = -u, l -= u), s && (d = u / s, c += (a.height - d) / 2);
        break;
      case bs:
        if (b.y >= 0 && (h >= _ || s && (l <= m || p >= g))) {
          v = !1;
          break;
        }
        C(bs), d += b.y, d < 0 && (i = No, d = -d, c -= d), s && (u = d * s, l += (a.width - u) / 2);
        break;
      case ac:
        if (s) {
          if (b.y <= 0 && (c <= f || p >= g)) {
            v = !1;
            break;
          }
          C(No), d -= b.y, c += b.y, u = d * s;
        } else
          C(No), C(_i), b.x >= 0 ? p < g ? u += b.x : b.y <= 0 && c <= f && (v = !1) : u += b.x, b.y <= 0 ? c > f && (d -= b.y, c += b.y) : (d -= b.y, c += b.y);
        u < 0 && d < 0 ? (i = sc, d = -d, u = -u, c -= d, l -= u) : u < 0 ? (i = oc, u = -u, l -= u) : d < 0 && (i = ic, d = -d, c -= d);
        break;
      case oc:
        if (s) {
          if (b.y <= 0 && (c <= f || l <= m)) {
            v = !1;
            break;
          }
          C(No), d -= b.y, c += b.y, u = d * s, l += a.width - u;
        } else
          C(No), C(wi), b.x <= 0 ? l > m ? (u -= b.x, l += b.x) : b.y <= 0 && c <= f && (v = !1) : (u -= b.x, l += b.x), b.y <= 0 ? c > f && (d -= b.y, c += b.y) : (d -= b.y, c += b.y);
        u < 0 && d < 0 ? (i = ic, d = -d, u = -u, c -= d, l -= u) : u < 0 ? (i = ac, u = -u, l -= u) : d < 0 && (i = sc, d = -d, c -= d);
        break;
      case sc:
        if (s) {
          if (b.x <= 0 && (l <= m || h >= _)) {
            v = !1;
            break;
          }
          C(wi), u -= b.x, l += b.x, d = u / s;
        } else
          C(bs), C(wi), b.x <= 0 ? l > m ? (u -= b.x, l += b.x) : b.y >= 0 && h >= _ && (v = !1) : (u -= b.x, l += b.x), b.y >= 0 ? h < _ && (d += b.y) : d += b.y;
        u < 0 && d < 0 ? (i = ac, d = -d, u = -u, c -= d, l -= u) : u < 0 ? (i = ic, u = -u, l -= u) : d < 0 && (i = oc, d = -d, c -= d);
        break;
      case ic:
        if (s) {
          if (b.x >= 0 && (p >= g || h >= _)) {
            v = !1;
            break;
          }
          C(_i), u += b.x, d = u / s;
        } else
          C(bs), C(_i), b.x >= 0 ? p < g ? u += b.x : b.y >= 0 && h >= _ && (v = !1) : u += b.x, b.y >= 0 ? h < _ && (d += b.y) : d += b.y;
        u < 0 && d < 0 ? (i = oc, d = -d, u = -u, c -= d, l -= u) : u < 0 ? (i = sc, u = -u, l -= u) : d < 0 && (i = ac, d = -d, c -= d);
        break;
      case IS:
        this.move(b.x, b.y), v = !1;
        break;
      case jS:
        this.zoom(Wre(o), e), v = !1;
        break;
      case DS:
        if (!b.x || !b.y) {
          v = !1;
          break;
        }
        w = $S(this.cropper), l = x.startX - w.left, c = x.startY - w.top, u = a.minWidth, d = a.minHeight, b.x > 0 ? i = b.y > 0 ? ic : ac : b.x < 0 && (l -= u, i = b.y > 0 ? sc : oc), b.y < 0 && (c -= d), this.cropped || (Ya(this.cropBox, fn), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    v && (a.width = u, a.height = d, a.left = l, a.top = c, this.action = i, this.renderCropBox()), Cr(o, function(E) {
      E.startX = E.endX, E.startY = E.endY;
    });
  }
}, lne = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && Dr(this.dragBox, kp), Ya(this.cropBox, fn), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = or({}, this.initialImageData), this.canvasData = or({}, this.initialCanvasData), this.cropBoxData = or({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (or(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), Ya(this.dragBox, kp), Dr(this.cropBox, fn)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && e && (this.isImg && (this.element.src = e), t ? (this.url = e, this.image.src = e, this.ready && (this.viewBoxImage.src = e, Cr(this.previews, function(n) {
      n.getElementsByTagName("img")[0].src = e;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(e))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, Ya(this.cropper, P_)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, Dr(this.cropper, P_)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var e = this.element;
    return e[ar] ? (e[ar] = void 0, this.isImg && this.replaced && (e.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.canvasData, r = n.left, a = n.top;
    return this.moveTo(i1(e) ? e : r + Number(e), i1(t) ? t : a + Number(t));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.canvasData, r = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.movable && (gt(e) && (n.left = e, r = !0), gt(t) && (n.top = t, r = !0), r && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(e, t) {
    var n = this.canvasData;
    return e = Number(e), e < 0 ? e = 1 / (1 - e) : e = 1 + e, this.zoomTo(n.width * e / n.naturalWidth, null, t);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(e, t, n) {
    var r = this.options, a = this.canvasData, o = a.width, i = a.height, s = a.naturalWidth, l = a.naturalHeight;
    if (e = Number(e), e >= 0 && this.ready && !this.disabled && r.zoomable) {
      var c = s * e, u = l * e;
      if (Ds(this.element, h0, {
        ratio: e,
        oldRatio: o / s,
        originalEvent: n
      }) === !1)
        return this;
      if (n) {
        var d = this.pointers, p = $S(this.cropper), h = d && Object.keys(d).length ? Yre(d) : {
          pageX: n.pageX,
          pageY: n.pageY
        };
        a.left -= (c - o) * ((h.pageX - p.left - a.left) / o), a.top -= (u - i) * ((h.pageY - p.top - a.top) / i);
      } else
        Es(t) && gt(t.x) && gt(t.y) ? (a.left -= (c - o) * ((t.x - a.left) / o), a.top -= (u - i) * ((t.y - a.top) / i)) : (a.left -= (c - o) / 2, a.top -= (u - i) / 2);
      a.width = c, a.height = u, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(e) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(e));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(e) {
    return e = Number(e), gt(e) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = e % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(e) {
    var t = this.imageData.scaleY;
    return this.scale(e, gt(t) ? t : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(e) {
    var t = this.imageData.scaleX;
    return this.scale(gt(t) ? t : 1, e);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.imageData, r = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.scalable && (gt(e) && (n.scaleX = e, r = !0), gt(t) && (n.scaleY = t, r = !0), r && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = this.options, n = this.imageData, r = this.canvasData, a = this.cropBoxData, o;
    if (this.ready && this.cropped) {
      o = {
        x: a.left - r.left,
        y: a.top - r.top,
        width: a.width,
        height: a.height
      };
      var i = n.width / n.naturalWidth;
      if (Cr(o, function(c, u) {
        o[u] = c / i;
      }), e) {
        var s = Math.round(o.y + o.height), l = Math.round(o.x + o.width);
        o.x = Math.round(o.x), o.y = Math.round(o.y), o.width = l - o.x, o.height = s - o.y;
      }
    } else
      o = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return t.rotatable && (o.rotate = n.rotate || 0), t.scalable && (o.scaleX = n.scaleX || 1, o.scaleY = n.scaleY || 1), o;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(e) {
    var t = this.options, n = this.imageData, r = this.canvasData, a = {};
    if (this.ready && !this.disabled && Es(e)) {
      var o = !1;
      t.rotatable && gt(e.rotate) && e.rotate !== n.rotate && (n.rotate = e.rotate, o = !0), t.scalable && (gt(e.scaleX) && e.scaleX !== n.scaleX && (n.scaleX = e.scaleX, o = !0), gt(e.scaleY) && e.scaleY !== n.scaleY && (n.scaleY = e.scaleY, o = !0)), o && this.renderCanvas(!0, !0);
      var i = n.width / n.naturalWidth;
      gt(e.x) && (a.left = e.x * i + r.left), gt(e.y) && (a.top = e.y * i + r.top), gt(e.width) && (a.width = e.width * i), gt(e.height) && (a.height = e.height * i), this.setCropBoxData(a);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? or({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? or({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var e = this.canvasData, t = {};
    return this.ready && Cr(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(n) {
      t[n] = e[n];
    }), t;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(e) {
    var t = this.canvasData, n = t.aspectRatio;
    return this.ready && !this.disabled && Es(e) && (gt(e.left) && (t.left = e.left), gt(e.top) && (t.top = e.top), gt(e.width) ? (t.width = e.width, t.height = e.width / n) : gt(e.height) && (t.height = e.height, t.width = e.height * n), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var e = this.cropBoxData, t;
    return this.ready && this.cropped && (t = {
      left: e.left,
      top: e.top,
      width: e.width,
      height: e.height
    }), t || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(e) {
    var t = this.cropBoxData, n = this.options.aspectRatio, r, a;
    return this.ready && this.cropped && !this.disabled && Es(e) && (gt(e.left) && (t.left = e.left), gt(e.top) && (t.top = e.top), gt(e.width) && e.width !== t.width && (r = !0, t.width = e.width), gt(e.height) && e.height !== t.height && (a = !0, t.height = e.height), n && (r ? t.height = t.width / n : a && (t.width = t.height * n)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var t = this.canvasData, n = qre(this.image, this.imageData, t, e);
    if (!this.cropped)
      return n;
    var r = this.getData(e.rounded), a = r.x, o = r.y, i = r.width, s = r.height, l = n.width / Math.floor(t.naturalWidth);
    l !== 1 && (a *= l, o *= l, i *= l, s *= l);
    var c = i / s, u = Go({
      aspectRatio: c,
      width: e.maxWidth || 1 / 0,
      height: e.maxHeight || 1 / 0
    }), d = Go({
      aspectRatio: c,
      width: e.minWidth || 0,
      height: e.minHeight || 0
    }, "cover"), p = Go({
      aspectRatio: c,
      width: e.width || (l !== 1 ? n.width : i),
      height: e.height || (l !== 1 ? n.height : s)
    }), h = p.width, m = p.height;
    h = Math.min(u.width, Math.max(d.width, h)), m = Math.min(u.height, Math.max(d.height, m));
    var f = document.createElement("canvas"), g = f.getContext("2d");
    f.width = Rs(h), f.height = Rs(m), g.fillStyle = e.fillColor || "transparent", g.fillRect(0, 0, h, m);
    var _ = e.imageSmoothingEnabled, v = _ === void 0 ? !0 : _, w = e.imageSmoothingQuality;
    g.imageSmoothingEnabled = v, w && (g.imageSmoothingQuality = w);
    var x = n.width, b = n.height, C = a, E = o, A, O, M, I, D, K;
    C <= -i || C > x ? (C = 0, A = 0, M = 0, D = 0) : C <= 0 ? (M = -C, C = 0, A = Math.min(x, i + C), D = A) : C <= x && (M = 0, A = Math.min(i, x - C), D = A), A <= 0 || E <= -s || E > b ? (E = 0, O = 0, I = 0, K = 0) : E <= 0 ? (I = -E, E = 0, O = Math.min(b, s + E), K = O) : E <= b && (I = 0, O = Math.min(s, b - E), K = O);
    var G = [C, E, A, O];
    if (D > 0 && K > 0) {
      var V = h / i;
      G.push(M * V, I * V, D * V, K * V);
    }
    return g.drawImage.apply(g, [n].concat(RS(G.map(function(ee) {
      return Math.floor(Rs(ee));
    })))), f;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(e) {
    var t = this.options;
    return !this.disabled && !i1(e) && (t.aspectRatio = Math.max(0, e) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(e) {
    var t = this.options, n = this.dragBox, r = this.face;
    if (this.ready && !this.disabled) {
      var a = e === wy, o = t.movable && e === BS;
      e = a || o ? e : FS, t.dragMode = e, Zc(n, Yc, e), Ps(n, s0, a), Ps(n, l0, o), t.cropBoxMovable || (Zc(r, Yc, e), Ps(r, s0, a), Ps(r, l0, o));
    }
    return this;
  }
}, cne = Xa.Cropper, WS = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Sre(this, e), !t || !Ire.test(t.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = t, this.options = or({}, j_, Es(n) && n), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return Cre(e, [{
    key: "init",
    value: function() {
      var t = this.element, n = t.tagName.toLowerCase(), r;
      if (!t[ar]) {
        if (t[ar] = this, n === "img") {
          if (this.isImg = !0, r = t.getAttribute("src") || "", this.originalUrl = r, !r)
            return;
          r = t.src;
        } else
          n === "canvas" && window.HTMLCanvasElement && (r = t.toDataURL());
        this.load(r);
      }
    }
  }, {
    key: "load",
    value: function(t) {
      var n = this;
      if (t) {
        this.url = t, this.imageData = {};
        var r = this.element, a = this.options;
        if (!a.rotatable && !a.scalable && (a.checkOrientation = !1), !a.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (Rre.test(t)) {
          Dre.test(t) ? this.read(Qre(t)) : this.clone();
          return;
        }
        var o = new XMLHttpRequest(), i = this.clone.bind(this);
        this.reloading = !0, this.xhr = o, o.onabort = i, o.onerror = i, o.ontimeout = i, o.onprogress = function() {
          o.getResponseHeader("content-type") !== I_ && o.abort();
        }, o.onload = function() {
          n.read(o.response);
        }, o.onloadend = function() {
          n.reloading = !1, n.xhr = null;
        }, a.checkCrossOrigin && F_(t) && r.crossOrigin && (t = z_(t)), o.open("GET", t, !0), o.responseType = "arraybuffer", o.withCredentials = r.crossOrigin === "use-credentials", o.send();
      }
    }
  }, {
    key: "read",
    value: function(t) {
      var n = this.options, r = this.imageData, a = tne(t), o = 0, i = 1, s = 1;
      if (a > 1) {
        this.url = ene(t, I_);
        var l = rne(a);
        o = l.rotate, i = l.scaleX, s = l.scaleY;
      }
      n.rotatable && (r.rotate = o), n.scalable && (r.scaleX = i, r.scaleY = s), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var t = this.element, n = this.url, r = t.crossOrigin, a = n;
      this.options.checkCrossOrigin && F_(n) && (r || (r = "anonymous"), a = z_(n)), this.crossOrigin = r, this.crossOriginUrl = a;
      var o = document.createElement("img");
      r && (o.crossOrigin = r), o.src = a || n, o.alt = t.alt || "The image to crop", this.image = o, o.onload = this.start.bind(this), o.onerror = this.stop.bind(this), Dr(o, T_), t.parentNode.insertBefore(o, t.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var t = this, n = this.image;
      n.onload = null, n.onerror = null, this.sizing = !0;
      var r = Xa.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(Xa.navigator.userAgent), a = function(s, l) {
        or(t.imageData, {
          naturalWidth: s,
          naturalHeight: l,
          aspectRatio: s / l
        }), t.initialImageData = or({}, t.imageData), t.sizing = !1, t.sized = !0, t.build();
      };
      if (n.naturalWidth && !r) {
        a(n.naturalWidth, n.naturalHeight);
        return;
      }
      var o = document.createElement("img"), i = document.body || document.documentElement;
      this.sizingImage = o, o.onload = function() {
        a(o.width, o.height), r || i.removeChild(o);
      }, o.src = n.src, r || (o.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", i.appendChild(o));
    }
  }, {
    key: "stop",
    value: function() {
      var t = this.image;
      t.onload = null, t.onerror = null, t.parentNode.removeChild(t), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var t = this.element, n = this.options, r = this.image, a = t.parentNode, o = document.createElement("div");
        o.innerHTML = jre;
        var i = o.querySelector(".".concat(ar, "-container")), s = i.querySelector(".".concat(ar, "-canvas")), l = i.querySelector(".".concat(ar, "-drag-box")), c = i.querySelector(".".concat(ar, "-crop-box")), u = c.querySelector(".".concat(ar, "-face"));
        this.container = a, this.cropper = i, this.canvas = s, this.dragBox = l, this.cropBox = c, this.viewBox = i.querySelector(".".concat(ar, "-view-box")), this.face = u, s.appendChild(r), Dr(t, fn), a.insertBefore(i, t.nextSibling), Ya(r, T_), this.initPreview(), this.bind(), n.initialAspectRatio = Math.max(0, n.initialAspectRatio) || NaN, n.aspectRatio = Math.max(0, n.aspectRatio) || NaN, n.viewMode = Math.max(0, Math.min(3, Math.round(n.viewMode))) || 0, Dr(c, fn), n.guides || Dr(c.getElementsByClassName("".concat(ar, "-dashed")), fn), n.center || Dr(c.getElementsByClassName("".concat(ar, "-center")), fn), n.background && Dr(i, "".concat(ar, "-bg")), n.highlight || Dr(u, Mre), n.cropBoxMovable && (Dr(u, l0), Zc(u, Yc, _y)), n.cropBoxResizable || (Dr(c.getElementsByClassName("".concat(ar, "-line")), fn), Dr(c.getElementsByClassName("".concat(ar, "-point")), fn)), this.render(), this.ready = !0, this.setDragMode(n.dragMode), n.autoCrop && this.crop(), this.setData(n.data), hn(n.ready) && Bn(t, L_, n.ready, {
          once: !0
        }), Ds(t, L_);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var t = this.cropper.parentNode;
        t && t.removeChild(this.cropper), Ya(this.element, fn);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = cne, e;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(t) {
      or(j_, Es(t) && t);
    }
  }]);
}();
or(WS.prototype, nne, ane, one, ine, sne, lne);
var Ei = function() {
  return Ei = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++)
      for (var a in t = arguments[n])
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }, Ei.apply(this, arguments);
};
function l1(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var a = 0;
    for (r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  }
  return n;
}
var une = ["aspectRatio", "autoCrop", "autoCropArea", "background", "center", "checkCrossOrigin", "checkOrientation", "cropBoxMovable", "cropBoxResizable", "data", "dragMode", "guides", "highlight", "initialAspectRatio", "minCanvasHeight", "minCanvasWidth", "minContainerHeight", "minContainerWidth", "minCropBoxHeight", "minCropBoxWidth", "modal", "movable", "preview", "responsive", "restore", "rotatable", "scalable", "toggleDragModeOnDblclick", "viewMode", "wheelZoomRatio", "zoomOnTouch", "zoomOnWheel", "zoomable", "cropstart", "cropmove", "cropend", "crop", "zoom", "ready"], dne = { opacity: 0, maxWidth: "100%" }, pne = k.forwardRef(function(e, t) {
  var n = l1(e, []), r = n.dragMode, a = r === void 0 ? "crop" : r, o = n.src, i = n.style, s = n.className, l = n.crossOrigin, c = n.scaleX, u = n.scaleY, d = n.enable, p = n.zoomTo, h = n.rotateTo, m = n.alt, f = m === void 0 ? "picture" : m, g = n.ready, _ = n.onInitialized, v = l1(n, ["dragMode", "src", "style", "className", "crossOrigin", "scaleX", "scaleY", "enable", "zoomTo", "rotateTo", "alt", "ready", "onInitialized"]), w = { scaleY: u, scaleX: c, enable: d, zoomTo: p, rotateTo: h }, x = function() {
    for (var C = [], E = 0; E < arguments.length; E++)
      C[E] = arguments[E];
    var A = _e(null);
    return k.useEffect(function() {
      C.forEach(function(O) {
        O && (typeof O == "function" ? O(A.current) : O.current = A.current);
      });
    }, [C]), A;
  }(t, _e(null));
  De(function() {
    var C;
    !((C = x.current) === null || C === void 0) && C.cropper && typeof p == "number" && x.current.cropper.zoomTo(p);
  }, [n.zoomTo]), De(function() {
    var C;
    !((C = x.current) === null || C === void 0) && C.cropper && o !== void 0 && x.current.cropper.reset().clear().replace(o);
  }, [o]), De(function() {
    if (x.current !== null) {
      var C = new WS(x.current, Ei(Ei({ dragMode: a }, v), { ready: function(E) {
        E.currentTarget !== null && function(A, O) {
          O === void 0 && (O = {});
          var M = O.enable, I = M === void 0 || M, D = O.scaleX, K = D === void 0 ? 1 : D, G = O.scaleY, V = G === void 0 ? 1 : G, ee = O.zoomTo, U = ee === void 0 ? 0 : ee, H = O.rotateTo;
          I ? A.enable() : A.disable(), A.scaleX(K), A.scaleY(V), H !== void 0 && A.rotateTo(H), U > 0 && A.zoomTo(U);
        }(E.currentTarget.cropper, w), g && g(E);
      } }));
      _ && _(C);
    }
    return function() {
      var E, A;
      (A = (E = x.current) === null || E === void 0 ? void 0 : E.cropper) === null || A === void 0 || A.destroy();
    };
  }, [x]);
  var b = function(C) {
    return une.reduce(function(E, A) {
      var O = E, M = A;
      return O[M], l1(O, [typeof M == "symbol" ? M : M + ""]);
    }, C);
  }(Ei(Ei({}, v), { crossOrigin: l, src: o, alt: f }));
  return k.createElement("div", { style: i, className: s }, k.createElement("img", Ei({}, b, { style: dne, ref: x })));
});
const hne = qS(
  ({ imageCropperRef: e, isRounded: t, imageFile: n, imageCropperProps: r }) => {
    const {
      viewMode: a = 1,
      autoCropArea: o = 1,
      aspectRatio: i = 1,
      checkOrientation: s = !1,
      // NOTE: it fixes this issue https://github.com/fengyuanchen/cropperjs/issues/671
      background: l = !0,
      dragMode: c = "move",
      toggleDragModeOnDblclick: u = !1,
      style: d = { height: 400, width: "100%" },
      ...p
    } = r || {}, h = _e(null), m = _e(null), f = _e(null), g = _e(null), _ = () => {
      m.current && (m.current.style.opacity = ""), f.current && (f.current.style.display = "block"), g.current && (g.current.style.zIndex = "", g.current.innerText = "");
    }, v = () => {
      f.current && g.current && (g.current.appendChild(f.current.cloneNode(!0)), g.current.style.zIndex = "1000", f.current.style.display = "none"), m.current && (m.current.style.opacity = "0");
    }, w = (x) => new Promise((b, C) => {
      var E;
      try {
        const A = (E = h.current) == null ? void 0 : E.cropper;
        if (!A)
          throw new Error();
        if (t) {
          const O = A == null ? void 0 : A.getCroppedCanvas();
          if (!O)
            throw new Error();
          const M = Math.min(O.width, O.height), I = document.createElement("canvas");
          I.width = M, I.height = M;
          const D = I.getContext("2d");
          if (!D)
            throw new Error();
          D.beginPath(), D.arc(M / 2, M / 2, M / 2, 0, Math.PI * 2), D.closePath(), D.clip(), D.drawImage(O, 0, 0, M, M), I.toBlob((K) => {
            if (!n || !K)
              return C(new Error());
            const G = Y3(
              Z3(n, K),
              i
            );
            b(G);
          });
        } else
          A.getCroppedCanvas(x).toBlob((O) => {
            if (!n || !O)
              return C(new Error());
            const M = Y3(
              Z3(n, O),
              i
            );
            b(M);
          });
      } catch (A) {
        C(A);
      }
    });
    return e && (e.current = {
      hidePreview: _,
      showPreview: v,
      getCroppedFile: w
    }), /* @__PURE__ */ Ke.jsx("div", { children: /* @__PURE__ */ Ke.jsxs("div", { className: "relative w-full overflow-hidden", children: [
      /* @__PURE__ */ Ke.jsx(
        "div",
        {
          ref: g,
          className: "absolute inset-0 flex items-center justify-center"
        }
      ),
      /* @__PURE__ */ Ke.jsx(
        "div",
        {
          ref: f,
          style: {
            position: "absolute",
            overflow: "hidden",
            width: d.width,
            height: d.height,
            borderRadius: t ? "50%" : 0
          }
        }
      ),
      /* @__PURE__ */ Ke.jsx("div", { ref: m, children: /* @__PURE__ */ Ke.jsx(
        pne,
        {
          className: t ? "sio-cropper-rounded" : "",
          ref: h,
          src: n && URL.createObjectURL(n),
          preview: f || void 0,
          style: d,
          viewMode: a,
          background: l,
          autoCropArea: o,
          aspectRatio: i,
          checkOrientation: s,
          dragMode: c,
          toggleDragModeOnDblclick: u,
          ...p
        }
      ) })
    ] }) });
  }
);
hne.displayName = "ImageCropper";
const mne = {
  id: 123,
  type: En.one_shot,
  currency: dr.EURO,
  name: "Default Price plan",
  amount: yt(1),
  taxBehavior: kn.Inclusive,
  innerName: "Default Price plan",
  statementDescriptor: "Default Price plan",
  removedAt: null
}, fne = {
  id: 112651,
  name: "T-shirt",
  tax: 20,
  createdAt: "2025-01-01T00:00:00.000Z",
  updatedAt: "2025-01-01T00:00:00.000Z",
  taxBehavior: kn.Inclusive,
  options: [
    {
      id: "01JTG214EFTGZQ486S90TTNZ9P",
      name: "Color",
      optionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        }
      ]
    },
    {
      id: "01JTG226Z40D4GP8P4X9MA49XS",
      name: "Size",
      optionValues: [
        {
          id: "01JTG226Z41H5Q9QPCG1VS57V8",
          value: "S"
        },
        {
          id: "01JTG22ANKHJZFR5G74R9K8P5T",
          value: "M"
        },
        {
          id: "01JTG22C024FRBMX3055G1AD45",
          value: "L"
        },
        {
          id: "01JTG22DJ2PM2CT42C3AXTGZTM",
          value: "XL"
        }
      ]
    }
  ],
  productVariants: [
    {
      id: "01JTG21EHKEMWGEBH704F0V5EX",
      sku: "WHI-737",
      optionValueIds: ["01JTG214EG046HQWF9R8Q77YHH", "01JTG226Z41H5Q9QPCG1VS57V8"],
      productOptionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG226Z41H5Q9QPCG1VS57V8",
          value: "S"
        }
      ],
      image: {
        id: 31121503,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
        name: "White T-shirt",
        filename: "white-t-shirt.webp",
        source: Et.Product,
        size: 1024,
        type: Ut.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(799),
      stock: null,
      pricePlan: {
        id: 123,
        type: En.one_shot,
        currency: dr.EURO,
        name: "Default Price plan",
        amount: yt(1),
        taxBehavior: kn.Inclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG21HT1GC9S77WEJMY8H2KF",
      sku: "BLA-213",
      optionValueIds: ["01JTG21FZB99TBWGW6ZD7RTXVF", "01JTG226Z41H5Q9QPCG1VS57V8"],
      productOptionValues: [
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        },
        {
          id: "01JTG226Z41H5Q9QPCG1VS57V8",
          value: "S"
        }
      ],
      image: {
        id: 31121528,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
        name: "Black T-shirt",
        filename: "black-t-shirt.jpg",
        source: Et.Product,
        size: 1024,
        type: Ut.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(699),
      stock: null,
      pricePlan: {
        id: 124,
        type: En.one_shot,
        currency: dr.EURO,
        name: "Default Price plan",
        amount: yt(699),
        taxBehavior: kn.Inclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22C0H1PTYQGZ8Z576M09H",
      sku: "BLA-649",
      optionValueIds: ["01JTG21FZB99TBWGW6ZD7RTXVF", "01JTG22ANKHJZFR5G74R9K8P5T"],
      productOptionValues: [
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        },
        {
          id: "01JTG22ANKHJZFR5G74R9K8P5T",
          value: "M"
        }
      ],
      image: {
        id: 31121528,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
        name: "Black T-shirt",
        filename: "black-t-shirt.jpg",
        source: Et.Product,
        size: 1024,
        type: Ut.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(799),
      stock: null,
      pricePlan: {
        id: 125,
        type: En.one_shot,
        currency: dr.EURO,
        name: "Default Price plan",
        amount: yt(799),
        taxBehavior: kn.Exclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22C0HMC23MHK814V8CPA4",
      sku: "WHI-332",
      optionValueIds: ["01JTG214EG046HQWF9R8Q77YHH", "01JTG22ANKHJZFR5G74R9K8P5T"],
      productOptionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG22ANKHJZFR5G74R9K8P5T",
          value: "M"
        }
      ],
      image: {
        id: 31121503,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
        name: "White T-shirt",
        filename: "white-t-shirt.webp",
        source: Et.Product,
        size: 1024,
        type: Ut.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(799),
      stock: null,
      pricePlan: {
        id: 126,
        type: En.one_shot,
        currency: dr.EURO,
        name: "Default Price plan",
        amount: yt(799),
        taxBehavior: kn.Exclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22DJH1CNT3RHRGC9TT0AQ",
      sku: "BLA-298",
      optionValueIds: ["01JTG21FZB99TBWGW6ZD7RTXVF", "01JTG22C024FRBMX3055G1AD45"],
      productOptionValues: [
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        },
        {
          id: "01JTG22C024FRBMX3055G1AD45",
          value: "L"
        }
      ],
      image: {
        id: 31121528,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
        name: "Black T-shirt",
        filename: "black-t-shirt.jpg",
        source: Et.Product,
        size: 1024,
        type: Ut.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(899),
      stock: null,
      pricePlan: {
        id: 127,
        type: En.one_shot,
        currency: dr.EURO,
        name: "Default Price plan",
        amount: yt(899),
        taxBehavior: kn.Exclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22DJHAM47QZGNW8B8A9AR",
      sku: "WHI-220",
      optionValueIds: ["01JTG214EG046HQWF9R8Q77YHH", "01JTG22C024FRBMX3055G1AD45"],
      productOptionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG22C024FRBMX3055G1AD45",
          value: "L"
        }
      ],
      image: {
        id: 31121503,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
        name: "White T-shirt",
        filename: "white-t-shirt.webp",
        source: Et.Product,
        size: 1024,
        type: Ut.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(899),
      stock: null,
      pricePlan: {
        id: 128,
        type: En.one_shot,
        currency: dr.EURO,
        name: "Default Price plan",
        amount: yt(899),
        taxBehavior: kn.Exclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22ERSQSJ084P417PRG46W",
      sku: "BLA-217",
      optionValueIds: ["01JTG21FZB99TBWGW6ZD7RTXVF", "01JTG22DJ2PM2CT42C3AXTGZTM"],
      productOptionValues: [
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        },
        {
          id: "01JTG22DJ2PM2CT42C3AXTGZTM",
          value: "XL"
        }
      ],
      image: {
        id: 31121528,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
        name: "Black T-shirt",
        filename: "black-t-shirt.jpg",
        source: Et.Product,
        size: 1024,
        type: Ut.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(899),
      stock: null,
      pricePlan: {
        id: 129,
        type: En.one_shot,
        currency: dr.EURO,
        name: "Default Price plan",
        amount: yt(899),
        taxBehavior: kn.Inclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22ERSSH236MH8ZMQWRQRA",
      sku: "WHI-855",
      optionValueIds: ["01JTG214EG046HQWF9R8Q77YHH", "01JTG22DJ2PM2CT42C3AXTGZTM"],
      productOptionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG22DJ2PM2CT42C3AXTGZTM",
          value: "XL"
        }
      ],
      image: {
        id: 31121503,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
        name: "White T-shirt",
        filename: "white-t-shirt.webp",
        source: Et.Product,
        size: 1024,
        type: Ut.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(999),
      stock: null,
      pricePlan: {
        id: 130,
        type: En.one_shot,
        currency: dr.EURO,
        name: "Default Price plan",
        amount: yt(999),
        taxBehavior: kn.Inclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    }
  ],
  sku: "T-S-887",
  images: [
    {
      id: 31121503,
      path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
      thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
      name: "White T-shirt",
      filename: "white-t-shirt.webp",
      source: Et.Product,
      size: 1024,
      type: Ut.Image,
      createdAt: "2025-01-01T00:00:00.000Z"
    },
    {
      id: 31121528,
      path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
      thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
      name: "Black T-shirt",
      filename: "black-t-shirt.jpg",
      source: Et.Product,
      size: 1024,
      type: Ut.Image,
      createdAt: "2025-01-01T00:00:00.000Z"
    }
  ],
  currency: dr.EURO,
  price: yt(799),
  description: "T-shirt description",
  limitStock: !1,
  stock: null,
  weight: 250,
  shippingFeesDisabled: !1,
  pricePlan: mne
}, gne = [
  {
    rules: [
      {
        id: 5056,
        name: "Rule",
        description: "Desc",
        price: yt(1e3),
        shippingConditions: [
          {
            id: 7180,
            min: 1,
            max: 100,
            price: yt(500)
          }
        ],
        currency: dr.EURO,
        type: Hi.quantity
      }
    ],
    id: 1739821,
    name: "Custom"
  },
  {
    rules: [
      {
        id: 5075,
        name: "Fixed Rate",
        description: "Fixed price rate delivery",
        price: yt(599),
        shippingConditions: [],
        currency: dr.EURO,
        type: Hi.quantity
      }
    ],
    id: 1739887,
    name: "Fixed Delivery"
  },
  {
    rules: [
      {
        id: 5074,
        name: "Multizone",
        description: "Multizone Description",
        price: yt(1100),
        shippingConditions: [
          {
            id: 7191,
            min: 1,
            max: 1e4,
            price: yt(999)
          }
        ],
        currency: dr.EURO,
        type: Hi.quantity
      }
    ],
    id: 1739886,
    name: "New Custom"
  }
], yne = {
  pricePlan: 1,
  quantity: 1,
  originalAmount: yt(999),
  netAmount: yt(999),
  discountedNetAmount: yt(999),
  tax: {
    amount: yt(200),
    rate: 20
  },
  grossAmount: yt(1199),
  discount: {
    amount: yt(0),
    percent: 0
  },
  shippingFee: {
    amount: yt(599),
    tax: {
      amount: yt(119.8),
      rate: 20
    }
  },
  currencyCode: dr.EURO
}, hae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  calculatePrice: yne,
  physicalProduct: fne,
  shippingRules: gne
}, Symbol.toStringTag, { value: "Module" })), f0 = (e, t) => t != null && t.pricePlan ? t.pricePlan : e != null && e.pricePlan ? e.pricePlan : null, mae = (e) => {
  var J;
  const { title: t, description: n, buttonTitle: r, fields: a, cover: o, offerId: i, id: s } = e.checkoutPage, {
    currency: l,
    paymentMethods: c,
    thankYouPage: u,
    affiliateLink: d,
    displayAffiliateLink: p,
    productType: h,
    physicalProduct: m,
    shippingRules: f,
    calculatePrice: g,
    isLoadingShippingRules: _ = !1,
    isLoadingCalculatePrice: v = !1,
    skipDisabledButton: w = !1
  } = e, { t: x } = Gr(), [b, C] = ke(!1), [E, A] = ke(un), { productVariant: O, quantity: M, selectedShipping: I } = bu();
  Ow({
    handlerError: (te) => A((ve) => ({ ...ve, common: [te] })),
    pagePath: e.checkoutPage.path
  });
  const {
    availablePaymentMethods: D,
    setAvailablePaymentMethods: K,
    setPaymentMethod: G,
    paymentMethod: V,
    setCurrency: ee,
    setPricePlan: U,
    setOfferId: H,
    setProductId: W,
    finalAmount: L,
    setFinalAmount: T,
    contactFields: B,
    setContactFields: N
  } = In();
  Hr(m == null ? void 0 : m.id, (te) => te && W(te)), Hr(i, (te) => te && H(te)), Hr(c, (te) => te && K(te)), Hr(l, (te) => te && ee(te)), Hr(a, (te) => te && N(cp(te))), Hr(m, (te) => {
    if (!te)
      U(void 0), T(void 0);
    else {
      const ve = f0(te, O);
      ve && (U(ve), T(ve.amount));
    }
  });
  const Y = () => {
    let te = !1;
    const ve = iy(un);
    return Object.values(B).forEach(({ slug: Pe, value: $e, required: _t }) => {
      _t && ($e == null || $e === "") && (ve.customer.fields[Pe] = [x("public_pages_purchase.required-field")], te = !0);
    }), V || (ve.paymentMethod = [x("public_pages_purchase.required-field")], te = !0), { errors: ve, isFailed: te };
  }, Q = !!L && !!V && !!i && !!m && !!s, F = () => {
    if (!Q)
      return;
    const te = f0(m, O);
    if (!te)
      return;
    const ve = Object.values(B).reduce((_t, st) => (_t[st.slug] = st.value ?? "", _t), {}), Pe = `${window.location.origin}${(u == null ? void 0 : u.path) ?? ""}`, $e = window.location.href;
    return {
      page: s,
      customer: {
        fields: ve
      },
      offer: i,
      digitalProduct: null,
      pricePlan: te.id,
      purchaseProductModel: {
        product: m.id,
        productVariant: (O == null ? void 0 : O.id) ?? null,
        quantity: M,
        shippingRule: (I == null ? void 0 : I.ruleId) ?? null,
        shippingCondition: (I == null ? void 0 : I.conditionId) ?? null
      },
      thankYouPageUrl: Pe,
      failedReturnUrl: $e,
      paymentMethod: V
    };
  }, re = () => {
    const { errors: te, isFailed: ve } = Y();
    if (ve) {
      A((Pe) => ({ ...Pe, ...te }));
      return;
    }
    return F();
  }, q = (te) => {
    const ve = Mw(te, un), Pe = Nw(ve.customer.fields, B);
    A({
      ...ve,
      common: ve.common.concat(Pe)
    });
  }, { paymentProcessorPaymentButton: he, paymentProcessorDetails: me, PaymentProcessorProvider: Le } = Tw({
    isFetching: b,
    setIsFetching: C,
    handleBadRequest: q,
    buttonTitle: r,
    buttonDisabled: !Q && !w,
    preSubmit: re,
    setErrors: A,
    hasErrors: sy(E)
  }), $ = Object.values(D).filter((te) => te !== ye.stripe_applepay).map((te) => ({
    id: te,
    caption: x(A5(te)),
    content: me,
    additionalInfo: /* @__PURE__ */ S.jsx(M7, { paymentMethod: te })
  })), Te = (te, ve) => {
    N({
      ...B,
      [te.slug]: { ...te, value: ve }
    });
  };
  return /* @__PURE__ */ S.jsx(jg, { children: /* @__PURE__ */ S.jsxs(T7, { children: [
    /* @__PURE__ */ S.jsxs("form", { className: "flex flex-col gap-5 px-5 pt-5 sm:gap-10 sm:pb-5 ", children: [
      /* @__PURE__ */ S.jsx(
        Cn,
        {
          className: "h-full w-full shrink-0 rounded-lg",
          thumbnail: o,
          imageType: Aw(h),
          alt: t
        }
      ),
      /* @__PURE__ */ S.jsx("h2", { className: "text-xl font-bold sm:text-3xl", children: t }),
      /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col gap-3 sm:gap-5", children: [
        /* @__PURE__ */ S.jsx(
          "div",
          {
            className: "ckeditor-default text-sm sm:text-base sm:leading-5",
            dangerouslySetInnerHTML: {
              __html: K_.sanitize(n)
            }
          }
        ),
        m && /* @__PURE__ */ S.jsx(WX, { product: m }),
        B[Kt.Country] && /* @__PURE__ */ S.jsx(XX, { shipping: f, isLoading: _ }),
        m && /* @__PURE__ */ S.jsx(
          jJ,
          {
            product: m,
            calculatePrice: g,
            isLoading: v
          }
        ),
        Object.values(B).map((te) => /* @__PURE__ */ S.jsx(
          Gg,
          {
            contactFields: B,
            field: te,
            value: B[te.slug].value,
            error: E.customer.fields[te.slug],
            onChange: (ve) => Te(te, ve)
          },
          te.slug
        )),
        /* @__PURE__ */ S.jsxs(Le, { children: [
          D.length > 0 && /* @__PURE__ */ S.jsx(
            vf,
            {
              label: x("public_pages_purchase.Payment-method"),
              labelClassName: "mb-2",
              optionClassName: "text-THEME-text-secondary",
              selectedOptionClassName: "text-THEME-text-secondary",
              optionsWrapperClassName: "gap-3",
              options: $,
              selected: V,
              onChange: (te) => G(te),
              required: !0,
              error: (J = E.paymentMethod) == null ? void 0 : J.join(", ")
            }
          ),
          E.common && /* @__PURE__ */ S.jsx(
            sl,
            {
              error: E.common.join(", "),
              errorClassName: "flex justify-center"
            }
          ),
          he
        ] })
      ] })
    ] }),
    p && /* @__PURE__ */ S.jsx(kh, { affiliateLink: d })
  ] }) });
}, vne = ({ children: e }) => /* @__PURE__ */ S.jsx("span", { className: "font-medium", children: e }), bne = ({ type: e, amount: t, currency: n, recurringOptions: r }) => {
  if (e === En.one_shot)
    return /* @__PURE__ */ S.jsx(_ne, { amount: t, currency: n });
  if (e === En.subscription)
    return /* @__PURE__ */ S.jsx(
      wne,
      {
        amount: t,
        currency: n,
        recurringOptions: r
      }
    );
  if (e === En.limited_subscription)
    return /* @__PURE__ */ S.jsx(
      Sne,
      {
        amount: t,
        currency: n,
        recurringOptions: r
      }
    );
}, _ne = ({
  amount: e,
  currency: t
}) => {
  const { locale: n } = qn(), r = qr(
    pr(e),
    t,
    n
  );
  return /* @__PURE__ */ S.jsxs("div", { className: "flex items-center", children: [
    /* @__PURE__ */ S.jsx(cn, { currency: t }),
    /* @__PURE__ */ S.jsx("div", { className: " ml-1 text-xs font-medium", children: r })
  ] });
}, wne = ({
  amount: e,
  currency: t,
  recurringOptions: n
}) => {
  const { locale: r } = qn(), { t: a } = Gr(), o = qr(
    pr(e),
    t,
    r
  ), i = n.trialPeriod ? `${a("public_pages_purchase.components.offer_price.price_plans.trial_period_new", {
    trialPeriodPrice: a(
      "public_pages_purchase.components.offer_price.price_plans.trial_period_price"
    ),
    trialInterval: a(
      `public_pages_purchase.price_plan.trial_period.${n.trialInterval}`,
      {
        count: n.trialPeriod
      }
    )
  })} ` : void 0, s = /* @__PURE__ */ S.jsx(
    V8,
    {
      i18nKey: "public_pages_purchase.components.offer_price.price_plans.unlimited_new",
      values: {
        amount: o,
        interval: a(`public_pages_purchase.price_plan.interval.${n.interval}`, {
          count: n.intervalCount
        })
      },
      components: {
        bold: /* @__PURE__ */ S.jsx(vne, {})
      }
    }
  );
  return /* @__PURE__ */ S.jsxs("div", { className: "flex items-center", children: [
    /* @__PURE__ */ S.jsx(cn, { currency: t }),
    /* @__PURE__ */ S.jsxs("div", { className: "ml-3", children: [
      i && /* @__PURE__ */ S.jsx("div", { className: "text-xs font-medium", children: i }),
      /* @__PURE__ */ S.jsx("div", { className: "text-xs", children: s })
    ] })
  ] });
}, Sne = ({
  amount: e,
  currency: t,
  recurringOptions: n
}) => {
  const { locale: r } = qn(), { t: a } = Gr(), o = qr(
    pr(e),
    t,
    r
  ), i = n.trialPeriod ? `${a("public_pages_purchase.components.offer_price.price_plans.trial_period_new", {
    trialPeriodPrice: a(
      "public_pages_purchase.components.offer_price.price_plans.trial_period_price"
    ),
    trialInterval: a(
      `public_pages_purchase.price_plan.trial_period.${n.trialInterval}`,
      {
        count: n.trialPeriod
      }
    )
  })} ` : void 0, s = /* @__PURE__ */ S.jsx(
    V8,
    {
      i18nKey: "public_pages_purchase.components.offer_price.price_plans.limited_with_limit_of_payments",
      values: {
        amount: o,
        count: n.limitOfPayments,
        interval: a(`public_pages_purchase.price_plan.interval.${n.interval}`, {
          count: n.intervalCount
        })
      }
    }
  );
  return /* @__PURE__ */ S.jsxs("div", { className: "flex items-center", children: [
    /* @__PURE__ */ S.jsx(cn, { currency: t }),
    /* @__PURE__ */ S.jsxs("div", { className: "ml-3", children: [
      i && /* @__PURE__ */ S.jsx("div", { className: "text-xs font-medium", children: i }),
      /* @__PURE__ */ S.jsx("div", { className: "text-xs font-medium", children: s })
    ] })
  ] });
}, Cne = ({ calculatePrice: e, pricePlan: t }) => {
  const { locale: n } = qn(), { t: r } = Gr();
  return /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    !!(e != null && e.netAmount) && /* @__PURE__ */ S.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ S.jsx("span", { className: "text-[16px]", children: r("public_pages_purchase.subtotal") }),
      /* @__PURE__ */ S.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ S.jsx(cn, { currency: t.currency }),
        /* @__PURE__ */ S.jsx("span", { className: "text-[16px] font-bold", children: qr(
          pr(e.netAmount),
          t.currency,
          n
        ) })
      ] })
    ] }),
    !!(e != null && e.tax) && /* @__PURE__ */ S.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ S.jsx("span", { className: "text-[16px]", children: r("public_pages_purchase.vat_percent", {
        percent: e.tax.rate
      }) }),
      /* @__PURE__ */ S.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ S.jsx(cn, { currency: t.currency }),
        /* @__PURE__ */ S.jsx("span", { className: "text-[16px] font-bold", children: qr(
          pr(e.tax.amount),
          t.currency,
          n
        ) })
      ] })
    ] })
  ] });
}, xne = ({
  calculatePrice: e,
  isLoading: t,
  pricePlan: n
}) => {
  const { t: r } = Gr(), { locale: a } = qn(), { finalAmount: o } = In();
  return /* @__PURE__ */ S.jsxs("div", { className: kr("flex flex-col gap-1", t && "animate-pulse"), children: [
    /* @__PURE__ */ S.jsx(_o, { label: r("public_pages_purchase.order_summary") }),
    /* @__PURE__ */ S.jsxs("div", { className: "border-text-secondary/30 flex flex-col gap-5 rounded-lg border px-3.5 py-5", children: [
      (n == null ? void 0 : n.taxBehavior) === kn.Exclusive && e && /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
        /* @__PURE__ */ S.jsx(Cne, { calculatePrice: e, pricePlan: n }),
        /* @__PURE__ */ S.jsx("div", { className: "bg-text-secondary/30 h-[1px] w-full" })
      ] }),
      o && o > 0 && /* @__PURE__ */ S.jsxs("div", { className: "flex w-full items-center justify-between", children: [
        /* @__PURE__ */ S.jsx("span", { className: "text-[16px] font-bold", children: r("public_pages_purchase.total") }),
        /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col items-center gap-1.5", children: [
          /* @__PURE__ */ S.jsxs("div", { className: "flex items-center gap-2.5", children: [
            /* @__PURE__ */ S.jsx(cn, { currency: n.currency }),
            /* @__PURE__ */ S.jsx("span", { className: "text-[16px] font-bold", children: qr(
              pr(o),
              n.currency,
              a
            ) })
          ] }),
          (n == null ? void 0 : n.taxBehavior) === kn.Inclusive && e && /* @__PURE__ */ S.jsx("span", { className: "text-text-tertiary text-xs", children: r("public_pages_purchase.including_tax", {
            percent: e.tax.rate,
            amount: qr(
              pr(e.tax.amount),
              n.currency,
              a
            )
          }) })
        ] })
      ] })
    ] })
  ] });
}, fae = (e) => {
  var Le, $, Te;
  const { title: t, description: n, buttonTitle: r, fields: a, cover: o, offerId: i, digitalProductId: s, id: l } = e.checkoutPage, {
    currency: c,
    paymentMethods: u,
    pricePlans: d,
    thankYouPage: p,
    affiliateLink: h,
    displayAffiliateLink: m,
    productType: f,
    calculatePrice: g,
    isLoadingCalculatePrice: _,
    skipDisabledButton: v = !1
  } = e, { t: w } = Gr(), [x, b] = ke(!1), [C, E] = ke(un);
  Ow({
    handlerError: (J) => E((te) => ({ ...te, common: [J] })),
    pagePath: e.checkoutPage.path
  });
  const {
    setAvailablePaymentMethods: A,
    setPaymentMethod: O,
    paymentMethod: M,
    availablePaymentMethods: I,
    setCurrency: D,
    setPricePlan: K,
    pricePlan: G,
    setOfferId: V,
    setProductId: ee,
    finalAmount: U,
    setFinalAmount: H,
    contactFields: W,
    setContactFields: L
  } = In();
  Hr(s, (J) => J && ee(J)), Hr(i, (J) => J && V(J)), Hr(u, (J) => J && A(J)), Hr(c, (J) => J && D(J)), Hr(a, (J) => J && L(cp(J))), Hr(d, (J) => {
    if (J) {
      if (J.length === 0)
        K(void 0), H(void 0);
      else if (!G) {
        const te = J[0];
        K(te), H(te.amount);
      }
    }
  });
  const T = () => {
    let J = !1;
    const te = iy(un);
    return Object.values(W).forEach(({ slug: ve, value: Pe, required: $e }) => {
      $e && (Pe == null || Pe === "") && (te.customer.fields[ve] = [w("public_pages_purchase.required-field")], J = !0);
    }), M || (te.paymentMethod = [w("public_pages_purchase.required-field")], J = !0), G || (te.pricePlan = [w("public_pages_purchase.required-field")], J = !0), { errors: te, isFailed: J };
  }, B = !!U && !!M && !!i && !!s && !!G && !!l, N = () => {
    if (!B)
      return;
    const J = Object.values(W).reduce((Pe, $e) => (Pe[$e.slug] = $e.value ?? "", Pe), {}), te = `${window.location.origin}${(p == null ? void 0 : p.path) ?? ""}`, ve = window.location.href;
    return {
      page: l,
      customer: {
        fields: J
      },
      offer: i,
      digitalProduct: s,
      purchaseProductModel: null,
      pricePlan: G.id,
      thankYouPageUrl: te,
      failedReturnUrl: ve,
      paymentMethod: M
    };
  }, Y = () => {
    const { errors: J, isFailed: te } = T();
    if (te) {
      E((ve) => ({ ...ve, ...J }));
      return;
    }
    return N();
  }, Q = (J) => {
    const te = Mw(J, un), ve = Nw(te.customer.fields, W);
    E({
      ...te,
      common: te.common.concat(ve)
    });
  }, { paymentProcessorPaymentButton: F, paymentProcessorDetails: re, PaymentProcessorProvider: q } = Tw({
    isFetching: x,
    setIsFetching: b,
    handleBadRequest: Q,
    buttonTitle: r,
    buttonDisabled: !B && !v,
    preSubmit: Y,
    setErrors: E,
    hasErrors: sy(C)
  }), he = Object.values(I).filter((J) => J !== ye.stripe_applepay).filter((J) => J !== ye.cash_on_delivery).map((J) => ({
    id: J,
    caption: w(A5(J)),
    content: re,
    additionalInfo: /* @__PURE__ */ S.jsx(M7, { paymentMethod: J })
  })), me = d == null ? void 0 : d.map((J) => ({
    id: String(J.id),
    caption: J.name,
    additionalInfo: /* @__PURE__ */ S.jsx(bne, { ...J })
  }));
  return /* @__PURE__ */ S.jsx(jg, { children: /* @__PURE__ */ S.jsxs(T7, { children: [
    /* @__PURE__ */ S.jsx(q, { children: /* @__PURE__ */ S.jsxs("form", { className: "flex flex-col gap-5 px-5 pt-5 sm:gap-10 sm:pb-5", children: [
      /* @__PURE__ */ S.jsx(
        Cn,
        {
          className: "h-full w-full shrink-0 rounded-lg",
          thumbnail: o,
          imageType: Aw(f),
          alt: t
        }
      ),
      /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col gap-5 sm:gap-10", children: [
        /* @__PURE__ */ S.jsx("div", { className: "flex flex-col gap-3 sm:gap-5", children: /* @__PURE__ */ S.jsx("h2", { className: "text-xl font-bold sm:text-3xl", children: t }) }),
        /* @__PURE__ */ S.jsxs("div", { className: "flex flex-col gap-3 sm:gap-5", children: [
          /* @__PURE__ */ S.jsx(
            "div",
            {
              className: "ckeditor-default text-sm sm:text-base sm:leading-5",
              dangerouslySetInnerHTML: {
                __html: K_.sanitize(n)
              }
            }
          ),
          Object.values(W).map((J) => {
            const te = (ve) => L({
              ...W,
              [J.slug]: { ...J, value: ve }
            });
            return /* @__PURE__ */ S.jsx(
              Gg,
              {
                contactFields: W,
                field: J,
                value: W[J.slug].value,
                error: C.customer.fields[J.slug],
                onChange: te
              },
              J.slug
            );
          }),
          d && (d == null ? void 0 : d.length) > 0 && /* @__PURE__ */ S.jsx(
            vf,
            {
              label: w("public_pages_purchase.payment.price_plan"),
              labelClassName: "mb-2",
              optionClassName: "text-THEME-text-secondary",
              selectedOptionClassName: "text-THEME-text-secondary",
              optionsWrapperClassName: "gap-3",
              options: me,
              selected: String(G == null ? void 0 : G.id),
              onChange: (J) => {
                const te = Number(J), ve = d.find((Pe) => Pe.id === te);
                ve && (K(ve), H(ve.amount));
              },
              required: !0,
              error: (Le = C.pricePlan) == null ? void 0 : Le.join(", ")
            }
          ),
          G && /* @__PURE__ */ S.jsx(
            xne,
            {
              calculatePrice: g,
              isLoading: _ ?? !1,
              pricePlan: G
            }
          ),
          I && (I == null ? void 0 : I.length) > 0 && /* @__PURE__ */ S.jsx(
            vf,
            {
              label: w("public_pages_purchase.Payment-method"),
              labelClassName: "mb-2",
              optionClassName: "text-THEME-text-secondary",
              selectedOptionClassName: "text-THEME-text-secondary",
              optionsWrapperClassName: "gap-3",
              options: he,
              selected: M,
              onChange: (J) => O(J),
              required: !0,
              error: ($ = C.paymentMethod) == null ? void 0 : $.join(", ")
            }
          ),
          C.common && /* @__PURE__ */ S.jsx(
            sl,
            {
              error: (Te = C.common) == null ? void 0 : Te.join(", "),
              errorClassName: "flex justify-center"
            }
          )
        ] }),
        F
      ] })
    ] }) }),
    m && /* @__PURE__ */ S.jsx(kh, { affiliateLink: h })
  ] }) });
};
export {
  t$ as CENTERED_LAYOUT_BASE_CLASSNAME,
  vh as CardWrapper,
  nae as CenteredLayout,
  cn as CurrencyBadge,
  q9 as DesignContext,
  rae as DesignProvider,
  fae as DigitalCheckout,
  Ane as DigitalStoreI18Provider,
  mf as FontRootNamesEnum,
  cae as Home,
  J9 as LAYOUT_BASE_CLASSNAME,
  jg as Layout,
  W9 as LocaleContext,
  eae as LocaleProvider,
  pae as MercadoPagoProvider,
  mae as PhysicalCheckout,
  An as ProductTypeEnum,
  tY as Profile,
  fb as ROOT_DESIGN_ID,
  gb as ROOT_FONT_ID,
  vf as RadioGroupAccordion,
  Ig as S3_BUCKET_URL,
  Y9 as S3_FONTS_BUCKET_URL,
  sr as SocialLinksEnum,
  Rr as StoreFontEnum,
  Cn as StoreImage,
  We as StoreImageEnum,
  Fa as StoreItemEnum,
  r$ as StoreItemStyleEnum,
  Nne as StoreProvider,
  mt as StoreThemeEnum,
  dae as StripeProvider,
  zg as SuccessIcon,
  uae as ThankYou,
  Jn as ThemeButton,
  Ci as ThemeRootNamesEnum,
  JU as applyDesign,
  Z8 as createStore,
  ff as defaultDesignValues,
  sae as defaultECourseValues,
  ia as defaultFontValues,
  aae as defaultLinkValues,
  oae as defaultOptinValues,
  lae as defaultPhysicalProductValues,
  iae as defaultProductDownloadValues,
  qr as getAmountWithCurrencySymbol,
  yh as getColors,
  X$ as getCommonItem,
  cp as getDefaultFieldValues,
  XU as getFontCss,
  eH as getI18nInstance,
  f0 as getPhysicalProductPricePlan,
  qU as getRootDesignCss,
  vb as getSingleFontCssString,
  tae as getSingleFontPreviewCssString,
  Ea as getSocialLinkIcon,
  eV as getStoreImageHeight,
  Q$ as getStoreImageWidth,
  xh as httpClient,
  hae as mocks,
  Sn as useDesignContext,
  qn as useLocaleContext,
  Q8 as useMercadoPagoStore,
  In as useOfferStore,
  Tw as usePaymentProcessors,
  bu as usePhysicalProductStore,
  yH as usePublicKeysStore,
  zt as useStore,
  X8 as useVisitorInfoStore,
  J8 as useXenditStore
};
